import './assets/index.css';var dY = Object.defineProperty;
var fY = (t, r, e) => r in t ? dY(t, r, { enumerable: !0, configurable: !0, writable: !0, value: e }) : t[r] = e;
var Ve = (t, r, e) => fY(t, typeof r != "symbol" ? r + "" : r, e);
import * as $ from "react";
import te, { useState as We, PureComponent as hY, useLayoutEffect as ag, useEffect as Ue, createElement as wc, cloneElement as v7, Component as In, createRef as Ul, useRef as Vt, useCallback as ns, createContext as Uc, useContext as zn, useId as ui, useInsertionEffect as pY, useMemo as Oc, forwardRef as uo, Fragment as g7, useImperativeHandle as MP } from "react";
import * as vY from "react-dom";
import RP from "react-dom";
var xp = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Yy(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function gY(t) {
  if (t.__esModule) return t;
  var r = t.default;
  if (typeof r == "function") {
    var e = function n() {
      return this instanceof n ? Reflect.construct(r, arguments, this.constructor) : r.apply(this, arguments);
    };
    e.prototype = r.prototype;
  } else e = {};
  return Object.defineProperty(e, "__esModule", { value: !0 }), Object.keys(t).forEach(function(n) {
    var i = Object.getOwnPropertyDescriptor(t, n);
    Object.defineProperty(e, n, i.get ? i : {
      enumerable: !0,
      get: function() {
        return t[n];
      }
    });
  }), e;
}
var Jg = { exports: {} }, Lh = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var N8;
function mY() {
  if (N8) return Lh;
  N8 = 1;
  var t = te, r = Symbol.for("react.element"), e = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, i = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(s, l, u) {
    var c, d = {}, f = null, h = null;
    u !== void 0 && (f = "" + u), l.key !== void 0 && (f = "" + l.key), l.ref !== void 0 && (h = l.ref);
    for (c in l) n.call(l, c) && !a.hasOwnProperty(c) && (d[c] = l[c]);
    if (s && s.defaultProps) for (c in l = s.defaultProps, l) d[c] === void 0 && (d[c] = l[c]);
    return { $$typeof: r, type: s, key: f, ref: h, props: d, _owner: i.current };
  }
  return Lh.Fragment = e, Lh.jsx = o, Lh.jsxs = o, Lh;
}
var Eh = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var O8;
function yY() {
  return O8 || (O8 = 1, process.env.NODE_ENV !== "production" && function() {
    var t = te, r = Symbol.for("react.element"), e = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), p = Symbol.iterator, v = "@@iterator";
    function g(X) {
      if (X === null || typeof X != "object")
        return null;
      var fe = p && X[p] || X[v];
      return typeof fe == "function" ? fe : null;
    }
    var m = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(X) {
      {
        for (var fe = arguments.length, Se = new Array(fe > 1 ? fe - 1 : 0), at = 1; at < fe; at++)
          Se[at - 1] = arguments[at];
        b("error", X, Se);
      }
    }
    function b(X, fe, Se) {
      {
        var at = m.ReactDebugCurrentFrame, Ft = at.getStackAddendum();
        Ft !== "" && (fe += "%s", Se = Se.concat([Ft]));
        var $t = Se.map(function(Rt) {
          return String(Rt);
        });
        $t.unshift("Warning: " + fe), Function.prototype.apply.call(console[X], console, $t);
      }
    }
    var C = !1, w = !1, _ = !1, x = !1, I = !1, D;
    D = Symbol.for("react.module.reference");
    function T(X) {
      return !!(typeof X == "string" || typeof X == "function" || X === n || X === a || I || X === i || X === u || X === c || x || X === h || C || w || _ || typeof X == "object" && X !== null && (X.$$typeof === f || X.$$typeof === d || X.$$typeof === o || X.$$typeof === s || X.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      X.$$typeof === D || X.getModuleId !== void 0));
    }
    function A(X, fe, Se) {
      var at = X.displayName;
      if (at)
        return at;
      var Ft = fe.displayName || fe.name || "";
      return Ft !== "" ? Se + "(" + Ft + ")" : Se;
    }
    function M(X) {
      return X.displayName || "Context";
    }
    function R(X) {
      if (X == null)
        return null;
      if (typeof X.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof X == "function")
        return X.displayName || X.name || null;
      if (typeof X == "string")
        return X;
      switch (X) {
        case n:
          return "Fragment";
        case e:
          return "Portal";
        case a:
          return "Profiler";
        case i:
          return "StrictMode";
        case u:
          return "Suspense";
        case c:
          return "SuspenseList";
      }
      if (typeof X == "object")
        switch (X.$$typeof) {
          case s:
            var fe = X;
            return M(fe) + ".Consumer";
          case o:
            var Se = X;
            return M(Se._context) + ".Provider";
          case l:
            return A(X, X.render, "ForwardRef");
          case d:
            var at = X.displayName || null;
            return at !== null ? at : R(X.type) || "Memo";
          case f: {
            var Ft = X, $t = Ft._payload, Rt = Ft._init;
            try {
              return R(Rt($t));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var E = Object.assign, k = 0, P, N, O, W, V, B, Z;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function z() {
      {
        if (k === 0) {
          P = console.log, N = console.info, O = console.warn, W = console.error, V = console.group, B = console.groupCollapsed, Z = console.groupEnd;
          var X = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: X,
            log: X,
            warn: X,
            error: X,
            group: X,
            groupCollapsed: X,
            groupEnd: X
          });
        }
        k++;
      }
    }
    function U() {
      {
        if (k--, k === 0) {
          var X = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: E({}, X, {
              value: P
            }),
            info: E({}, X, {
              value: N
            }),
            warn: E({}, X, {
              value: O
            }),
            error: E({}, X, {
              value: W
            }),
            group: E({}, X, {
              value: V
            }),
            groupCollapsed: E({}, X, {
              value: B
            }),
            groupEnd: E({}, X, {
              value: Z
            })
          });
        }
        k < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var J = m.ReactCurrentDispatcher, K;
    function j(X, fe, Se) {
      {
        if (K === void 0)
          try {
            throw Error();
          } catch (Ft) {
            var at = Ft.stack.trim().match(/\n( *(at )?)/);
            K = at && at[1] || "";
          }
        return `
` + K + X;
      }
    }
    var oe = !1, ie;
    {
      var le = typeof WeakMap == "function" ? WeakMap : Map;
      ie = new le();
    }
    function re(X, fe) {
      if (!X || oe)
        return "";
      {
        var Se = ie.get(X);
        if (Se !== void 0)
          return Se;
      }
      var at;
      oe = !0;
      var Ft = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var $t;
      $t = J.current, J.current = null, z();
      try {
        if (fe) {
          var Rt = function() {
            throw Error();
          };
          if (Object.defineProperty(Rt.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Rt, []);
            } catch (yn) {
              at = yn;
            }
            Reflect.construct(X, [], Rt);
          } else {
            try {
              Rt.call();
            } catch (yn) {
              at = yn;
            }
            X.call(Rt.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (yn) {
            at = yn;
          }
          X();
        }
      } catch (yn) {
        if (yn && at && typeof yn.stack == "string") {
          for (var bt = yn.stack.split(`
`), Ct = at.stack.split(`
`), Zt = bt.length - 1, Ar = Ct.length - 1; Zt >= 1 && Ar >= 0 && bt[Zt] !== Ct[Ar]; )
            Ar--;
          for (; Zt >= 1 && Ar >= 0; Zt--, Ar--)
            if (bt[Zt] !== Ct[Ar]) {
              if (Zt !== 1 || Ar !== 1)
                do
                  if (Zt--, Ar--, Ar < 0 || bt[Zt] !== Ct[Ar]) {
                    var Ur = `
` + bt[Zt].replace(" at new ", " at ");
                    return X.displayName && Ur.includes("<anonymous>") && (Ur = Ur.replace("<anonymous>", X.displayName)), typeof X == "function" && ie.set(X, Ur), Ur;
                  }
                while (Zt >= 1 && Ar >= 0);
              break;
            }
        }
      } finally {
        oe = !1, J.current = $t, U(), Error.prepareStackTrace = Ft;
      }
      var vo = X ? X.displayName || X.name : "", Ut = vo ? j(vo) : "";
      return typeof X == "function" && ie.set(X, Ut), Ut;
    }
    function Re(X, fe, Se) {
      return re(X, !1);
    }
    function ve(X) {
      var fe = X.prototype;
      return !!(fe && fe.isReactComponent);
    }
    function Oe(X, fe, Se) {
      if (X == null)
        return "";
      if (typeof X == "function")
        return re(X, ve(X));
      if (typeof X == "string")
        return j(X);
      switch (X) {
        case u:
          return j("Suspense");
        case c:
          return j("SuspenseList");
      }
      if (typeof X == "object")
        switch (X.$$typeof) {
          case l:
            return Re(X.render);
          case d:
            return Oe(X.type, fe, Se);
          case f: {
            var at = X, Ft = at._payload, $t = at._init;
            try {
              return Oe($t(Ft), fe, Se);
            } catch {
            }
          }
        }
      return "";
    }
    var qe = Object.prototype.hasOwnProperty, dt = {}, At = m.ReactDebugCurrentFrame;
    function Be(X) {
      if (X) {
        var fe = X._owner, Se = Oe(X.type, X._source, fe ? fe.type : null);
        At.setExtraStackFrame(Se);
      } else
        At.setExtraStackFrame(null);
    }
    function Nt(X, fe, Se, at, Ft) {
      {
        var $t = Function.call.bind(qe);
        for (var Rt in X)
          if ($t(X, Rt)) {
            var bt = void 0;
            try {
              if (typeof X[Rt] != "function") {
                var Ct = Error((at || "React class") + ": " + Se + " type `" + Rt + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof X[Rt] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Ct.name = "Invariant Violation", Ct;
              }
              bt = X[Rt](fe, Rt, at, Se, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Zt) {
              bt = Zt;
            }
            bt && !(bt instanceof Error) && (Be(Ft), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", at || "React class", Se, Rt, typeof bt), Be(null)), bt instanceof Error && !(bt.message in dt) && (dt[bt.message] = !0, Be(Ft), y("Failed %s type: %s", Se, bt.message), Be(null));
          }
      }
    }
    var wt = Array.isArray;
    function Dt(X) {
      return wt(X);
    }
    function Ot(X) {
      {
        var fe = typeof Symbol == "function" && Symbol.toStringTag, Se = fe && X[Symbol.toStringTag] || X.constructor.name || "Object";
        return Se;
      }
    }
    function or(X) {
      try {
        return $r(X), !1;
      } catch {
        return !0;
      }
    }
    function $r(X) {
      return "" + X;
    }
    function kr(X) {
      if (or(X))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ot(X)), $r(X);
    }
    var Gr = m.ReactCurrentOwner, Dn = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, dn, Pn, Tn;
    Tn = {};
    function Gi(X) {
      if (qe.call(X, "ref")) {
        var fe = Object.getOwnPropertyDescriptor(X, "ref").get;
        if (fe && fe.isReactWarning)
          return !1;
      }
      return X.ref !== void 0;
    }
    function de(X) {
      if (qe.call(X, "key")) {
        var fe = Object.getOwnPropertyDescriptor(X, "key").get;
        if (fe && fe.isReactWarning)
          return !1;
      }
      return X.key !== void 0;
    }
    function Kt(X, fe) {
      if (typeof X.ref == "string" && Gr.current && fe && Gr.current.stateNode !== fe) {
        var Se = R(Gr.current.type);
        Tn[Se] || (y('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', R(Gr.current.type), X.ref), Tn[Se] = !0);
      }
    }
    function fn(X, fe) {
      {
        var Se = function() {
          dn || (dn = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", fe));
        };
        Se.isReactWarning = !0, Object.defineProperty(X, "key", {
          get: Se,
          configurable: !0
        });
      }
    }
    function Ii(X, fe) {
      {
        var Se = function() {
          Pn || (Pn = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", fe));
        };
        Se.isReactWarning = !0, Object.defineProperty(X, "ref", {
          get: Se,
          configurable: !0
        });
      }
    }
    var di = function(X, fe, Se, at, Ft, $t, Rt) {
      var bt = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: X,
        key: fe,
        ref: Se,
        props: Rt,
        // Record the component responsible for creating this element.
        _owner: $t
      };
      return bt._store = {}, Object.defineProperty(bt._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(bt, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: at
      }), Object.defineProperty(bt, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ft
      }), Object.freeze && (Object.freeze(bt.props), Object.freeze(bt)), bt;
    };
    function Ai(X, fe, Se, at, Ft) {
      {
        var $t, Rt = {}, bt = null, Ct = null;
        Se !== void 0 && (kr(Se), bt = "" + Se), de(fe) && (kr(fe.key), bt = "" + fe.key), Gi(fe) && (Ct = fe.ref, Kt(fe, Ft));
        for ($t in fe)
          qe.call(fe, $t) && !Dn.hasOwnProperty($t) && (Rt[$t] = fe[$t]);
        if (X && X.defaultProps) {
          var Zt = X.defaultProps;
          for ($t in Zt)
            Rt[$t] === void 0 && (Rt[$t] = Zt[$t]);
        }
        if (bt || Ct) {
          var Ar = typeof X == "function" ? X.displayName || X.name || "Unknown" : X;
          bt && fn(Rt, Ar), Ct && Ii(Rt, Ar);
        }
        return di(X, bt, Ct, Ft, at, Gr.current, Rt);
      }
    }
    var Br = m.ReactCurrentOwner, Nn = m.ReactDebugCurrentFrame;
    function Tr(X) {
      if (X) {
        var fe = X._owner, Se = Oe(X.type, X._source, fe ? fe.type : null);
        Nn.setExtraStackFrame(Se);
      } else
        Nn.setExtraStackFrame(null);
    }
    var On;
    On = !1;
    function Bi(X) {
      return typeof X == "object" && X !== null && X.$$typeof === r;
    }
    function Sr() {
      {
        if (Br.current) {
          var X = R(Br.current.type);
          if (X)
            return `

Check the render method of \`` + X + "`.";
        }
        return "";
      }
    }
    function Mn(X) {
      return "";
    }
    var Ke = {};
    function St(X) {
      {
        var fe = Sr();
        if (!fe) {
          var Se = typeof X == "string" ? X : X.displayName || X.name;
          Se && (fe = `

Check the top-level render call using <` + Se + ">.");
        }
        return fe;
      }
    }
    function Ir(X, fe) {
      {
        if (!X._store || X._store.validated || X.key != null)
          return;
        X._store.validated = !0;
        var Se = St(fe);
        if (Ke[Se])
          return;
        Ke[Se] = !0;
        var at = "";
        X && X._owner && X._owner !== Br.current && (at = " It was passed a child from " + R(X._owner.type) + "."), Tr(X), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Se, at), Tr(null);
      }
    }
    function mn(X, fe) {
      {
        if (typeof X != "object")
          return;
        if (Dt(X))
          for (var Se = 0; Se < X.length; Se++) {
            var at = X[Se];
            Bi(at) && Ir(at, fe);
          }
        else if (Bi(X))
          X._store && (X._store.validated = !0);
        else if (X) {
          var Ft = g(X);
          if (typeof Ft == "function" && Ft !== X.entries)
            for (var $t = Ft.call(X), Rt; !(Rt = $t.next()).done; )
              Bi(Rt.value) && Ir(Rt.value, fe);
        }
      }
    }
    function Ie(X) {
      {
        var fe = X.type;
        if (fe == null || typeof fe == "string")
          return;
        var Se;
        if (typeof fe == "function")
          Se = fe.propTypes;
        else if (typeof fe == "object" && (fe.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        fe.$$typeof === d))
          Se = fe.propTypes;
        else
          return;
        if (Se) {
          var at = R(fe);
          Nt(Se, X.props, "prop", at, X);
        } else if (fe.PropTypes !== void 0 && !On) {
          On = !0;
          var Ft = R(fe);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Ft || "Unknown");
        }
        typeof fe.getDefaultProps == "function" && !fe.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Xe(X) {
      {
        for (var fe = Object.keys(X.props), Se = 0; Se < fe.length; Se++) {
          var at = fe[Se];
          if (at !== "children" && at !== "key") {
            Tr(X), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", at), Tr(null);
            break;
          }
        }
        X.ref !== null && (Tr(X), y("Invalid attribute `ref` supplied to `React.Fragment`."), Tr(null));
      }
    }
    var it = {};
    function hr(X, fe, Se, at, Ft, $t) {
      {
        var Rt = T(X);
        if (!Rt) {
          var bt = "";
          (X === void 0 || typeof X == "object" && X !== null && Object.keys(X).length === 0) && (bt += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Ct = Mn();
          Ct ? bt += Ct : bt += Sr();
          var Zt;
          X === null ? Zt = "null" : Dt(X) ? Zt = "array" : X !== void 0 && X.$$typeof === r ? (Zt = "<" + (R(X.type) || "Unknown") + " />", bt = " Did you accidentally export a JSX literal instead of a component?") : Zt = typeof X, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Zt, bt);
        }
        var Ar = Ai(X, fe, Se, Ft, $t);
        if (Ar == null)
          return Ar;
        if (Rt) {
          var Ur = fe.children;
          if (Ur !== void 0)
            if (at)
              if (Dt(Ur)) {
                for (var vo = 0; vo < Ur.length; vo++)
                  mn(Ur[vo], X);
                Object.freeze && Object.freeze(Ur);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              mn(Ur, X);
        }
        if (qe.call(fe, "key")) {
          var Ut = R(X), yn = Object.keys(fe).filter(function(Ug) {
            return Ug !== "key";
          }), ud = yn.length > 0 ? "{key: someKey, " + yn.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!it[Ut + ud]) {
            var $g = yn.length > 0 ? "{" + yn.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, ud, Ut, $g, Ut), it[Ut + ud] = !0;
          }
        }
        return X === n ? Xe(Ar) : Ie(Ar), Ar;
      }
    }
    function hn(X, fe, Se) {
      return hr(X, fe, Se, !0);
    }
    function $n(X, fe, Se) {
      return hr(X, fe, Se, !1);
    }
    var Di = $n, Fr = hn;
    Eh.Fragment = n, Eh.jsx = Di, Eh.jsxs = Fr;
  }()), Eh;
}
var V8;
function bY() {
  return V8 || (V8 = 1, process.env.NODE_ENV === "production" ? Jg.exports = mY() : Jg.exports = yY()), Jg.exports;
}
var S = bY();
const CY = (t) => /* @__PURE__ */ $.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ $.createElement("g", { id: "icon-chevron-up" }, /* @__PURE__ */ $.createElement("path", { id: "ô", d: "M6.29476 13.345L11.1419 8.38646C11.4105 8.1179 11.679 8 12 8C12.3275 8 12.6026 8.12445 12.8581 8.38646L17.7052 13.345C17.9017 13.5415 18 13.7773 18 14.0655C18 14.6485 17.5349 15.1201 16.9585 15.1201C16.6769 15.1201 16.4017 15.0087 16.1921 14.786L12.0066 10.4694L7.81441 14.786C7.59825 15.0022 7.32969 15.1201 7.04148 15.1201C6.46507 15.1201 6 14.6485 6 14.0655C6 13.7838 6.09825 13.5415 6.29476 13.345Z", fill: "#395278" }))), Mxe = (t) => {
  const {
    children: r,
    header: e,
    defaultOpen: n = !1,
    className: i = "",
    buttons: a
  } = t, [o, s] = We(n);
  return /* @__PURE__ */ S.jsxs(
    "div",
    {
      className: `theme-accordion ${o ? "theme-accordion-open" : ""} ${i}`,
      children: [
        /* @__PURE__ */ S.jsxs("div", { className: "theme-accordion-heading", onClick: () => s(!o), children: [
          /* @__PURE__ */ S.jsx("span", { className: "theme-accordion-title", children: e }),
          /* @__PURE__ */ S.jsxs("div", { className: "theme-accordion-heading-menu", children: [
            a && /* @__PURE__ */ S.jsx("div", { className: "theme-accordion-heading-buttons", children: a.map((l) => l) }),
            /* @__PURE__ */ S.jsx(CY, { className: "theme-accordion-arrow" })
          ] })
        ] }),
        o && /* @__PURE__ */ S.jsx("div", { className: "theme-accordion-body", children: /* @__PURE__ */ S.jsx("div", { children: r }) })
      ]
    }
  );
}, wY = (t) => /* @__PURE__ */ $.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ $.createElement("path", { d: "M3.4497 12.5461C3.11316 12.2154 3.12476 11.6294 3.43809 11.316L6.75703 7.9971L3.43809 4.68977C3.12476 4.37064 3.11316 3.7904 3.4497 3.45387C3.78623 3.11153 4.37227 3.12314 4.68559 3.44226L7.99873 6.7554L11.3119 3.44226C11.6368 3.11733 12.2054 3.11733 12.542 3.45387C12.8843 3.7904 12.8843 4.35903 12.5536 4.68977L9.24623 7.9971L12.5536 11.3102C12.8843 11.641 12.8785 12.2038 12.542 12.5461C12.2112 12.8827 11.6368 12.8827 11.3119 12.5577L7.99873 9.2446L4.68559 12.5577C4.37227 12.8769 3.79203 12.8827 3.4497 12.5461Z", fill: "#EB4553" })), _Y = (t) => /* @__PURE__ */ $.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ $.createElement("path", { d: "M3.4497 12.5461C3.11316 12.2154 3.12476 11.6294 3.43809 11.316L6.75703 7.9971L3.43809 4.68977C3.12476 4.37064 3.11316 3.7904 3.4497 3.45387C3.78623 3.11153 4.37227 3.12314 4.68559 3.44226L7.99873 6.7554L11.3119 3.44226C11.6368 3.11733 12.2054 3.11733 12.542 3.45387C12.8843 3.7904 12.8843 4.35903 12.5536 4.68977L9.24623 7.9971L12.5536 11.3102C12.8843 11.641 12.8785 12.2038 12.542 12.5461C12.2112 12.8827 11.6368 12.8827 11.3119 12.5577L7.99873 9.2446L4.68559 12.5577C4.37227 12.8769 3.79203 12.8827 3.4497 12.5461Z", fill: "#42AD47" })), xY = (t) => /* @__PURE__ */ $.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ $.createElement("path", { d: "M3.4497 12.5461C3.11316 12.2154 3.12476 11.6294 3.43809 11.316L6.75703 7.9971L3.43809 4.68977C3.12476 4.37064 3.11316 3.79041 3.4497 3.45387C3.78623 3.11153 4.37227 3.12314 4.68559 3.44227L7.99873 6.7554L11.3119 3.44227C11.6368 3.11734 12.2054 3.11734 12.542 3.45387C12.8843 3.79041 12.8843 4.35904 12.5536 4.68977L9.24623 7.9971L12.5536 11.3102C12.8843 11.641 12.8785 12.2038 12.542 12.5461C12.2112 12.8827 11.6368 12.8827 11.3119 12.5577L7.99873 9.2446L4.68559 12.5577C4.37227 12.8769 3.79203 12.8827 3.4497 12.5461Z", fill: "#FF9600" })), SY = (t) => /* @__PURE__ */ $.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ $.createElement("path", { d: "M3.4497 12.5461C3.11316 12.2154 3.12476 11.6294 3.43809 11.316L6.75703 7.9971L3.43809 4.68977C3.12476 4.37064 3.11316 3.7904 3.4497 3.45387C3.78623 3.11153 4.37227 3.12314 4.68559 3.44226L7.99873 6.7554L11.3119 3.44226C11.6368 3.11733 12.2054 3.11733 12.542 3.45387C12.8843 3.7904 12.8843 4.35903 12.5536 4.68977L9.24623 7.9971L12.5536 11.3102C12.8843 11.641 12.8785 12.2038 12.542 12.5461C12.2112 12.8827 11.6368 12.8827 11.3119 12.5577L7.99873 9.2446L4.68559 12.5577C4.37227 12.8769 3.79203 12.8827 3.4497 12.5461Z", fill: "#395278" })), LP = (t) => {
  const {
    variant: r = "default",
    className: e = "",
    withClose: n = !1,
    onClose: i
  } = t;
  return /* @__PURE__ */ S.jsxs("div", { className: `theme-alert theme-alert-variant-${r} ${e}`, children: [
    n && /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
      r === "error" && /* @__PURE__ */ S.jsx(
        wY,
        {
          className: "theme-alert-close-icon",
          onClick: () => i && i()
        }
      ),
      r === "success" && /* @__PURE__ */ S.jsx(
        _Y,
        {
          className: "theme-alert-close-icon",
          onClick: () => i && i()
        }
      ),
      r === "warning" && /* @__PURE__ */ S.jsx(
        xY,
        {
          className: "theme-alert-close-icon",
          onClick: () => i && i()
        }
      ),
      r === "default" && /* @__PURE__ */ S.jsx(
        SY,
        {
          className: "theme-alert-close-icon",
          onClick: () => i && i()
        }
      )
    ] }),
    t.children
  ] });
}, Rxe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), IY = (t) => /* @__PURE__ */ $.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ $.createElement("path", { d: "M15.1135 12C15.1135 12.321 15.0022 12.5895 14.7271 12.8515L9.77511 17.7052C9.5786 17.9017 9.33624 18 9.04803 18C8.47162 18 8 17.5349 8 16.9585C8 16.6638 8.1179 16.4017 8.33406 16.1856L12.6507 11.9934L8.33406 7.80786C8.1179 7.59825 8 7.32969 8 7.04148C8 6.47162 8.47162 6 9.04803 6C9.33624 6 9.5786 6.09825 9.77511 6.29476L14.7271 11.1485C14.9956 11.4039 15.1135 11.6725 15.1135 12Z", fill: "#395278" })), Lxe = (t) => {
  const { items: r, className: e = "" } = t;
  return /* @__PURE__ */ S.jsx("ul", { className: `theme-breadcrumb ${e}`, children: r.map((n, i) => /* @__PURE__ */ S.jsxs(
    "li",
    {
      className: `${n.isActive ? "theme-breadcrumb-active" : ""}`,
      children: [
        n.content,
        i !== r.length - 1 && /* @__PURE__ */ S.jsx(IY, { className: "theme-breadcrumb-arrow" })
      ]
    },
    `breadcrumb-item-${i}`
  )) });
}, AY = (t) => /* @__PURE__ */ $.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", width: "40px", height: "40px", viewBox: "0 0 40 40", enableBackground: "new 0 0 40 40", xmlSpace: "preserve", ...t }, /* @__PURE__ */ $.createElement("path", { opacity: 0.2, fill: "#fff", d: "M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946           s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634           c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z" }), /* @__PURE__ */ $.createElement("path", { fill: "#fff", d: "M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0           C22.32,8.481,24.301,9.057,26.013,10.047z" }, /* @__PURE__ */ $.createElement("animateTransform", { attributeType: "xml", attributeName: "transform", type: "rotate", from: "0 20 20", to: "360 20 20", dur: "0.5s", repeatCount: "indefinite" }))), DY = (t) => {
  const {
    variant: r = "block",
    theme: e = "purple",
    label: n = "",
    iconOnly: i = !1,
    icon: a = null,
    iconPosition: o = "left",
    disabled: s = !1,
    loading: l = !1,
    type: u = "button",
    size: c = "md",
    fullWidth: d = !1,
    className: f = "",
    onClick: h = null
  } = t;
  return /* @__PURE__ */ S.jsxs(
    "button",
    {
      type: u,
      className: `theme-btn theme-btn-size-${c} ${d && "theme-btn-fullwidth"} theme-btn-${r} theme-btn-color-${e} ${f}`,
      disabled: s || l,
      onClick: (p) => {
        h !== null && h(p);
      },
      children: [
        l && /* @__PURE__ */ S.jsx("div", { role: "status", className: "theme-btn-loading", children: /* @__PURE__ */ S.jsx(AY, {}) }),
        a !== null && o === "left" && a,
        !i && !l && n,
        a !== null && o === "right" && a
      ]
    }
  );
}, TY = (t) => {
  const {
    className: r = "",
    heading: e = "",
    children: n,
    onClick: i,
    onDragOver: a,
    onDragLeave: o,
    onDrop: s,
    variant: l = "normal"
  } = t;
  return /* @__PURE__ */ S.jsxs(
    "div",
    {
      className: `theme-card ${r} theme-card-variant-${l}`,
      onDragOver: a,
      onDragLeave: o,
      onDrop: s,
      children: [
        e !== "" && /* @__PURE__ */ S.jsx("div", { className: "theme-card-heading", children: /* @__PURE__ */ S.jsx("span", { children: e }) }),
        /* @__PURE__ */ S.jsx("div", { className: "theme-card-body", onClick: () => i && i(), children: n })
      ]
    }
  );
};
var hC = function(t, r) {
  return hC = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, n) {
    e.__proto__ = n;
  } || function(e, n) {
    for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
  }, hC(t, r);
};
function EP(t, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
  hC(t, r);
  function e() {
    this.constructor = t;
  }
  t.prototype = r === null ? Object.create(r) : (e.prototype = r.prototype, new e());
}
var pC = function() {
  return pC = Object.assign || function(r) {
    for (var e, n = 1, i = arguments.length; n < i; n++) {
      e = arguments[n];
      for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && (r[a] = e[a]);
    }
    return r;
  }, pC.apply(this, arguments);
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var vC = function(t, r) {
  return vC = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, n) {
    e.__proto__ = n;
  } || function(e, n) {
    for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
  }, vC(t, r);
};
function ee(t, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
  vC(t, r);
  function e() {
    this.constructor = t;
  }
  t.prototype = r === null ? Object.create(r) : (e.prototype = r.prototype, new e());
}
var MY = /* @__PURE__ */ function() {
  function t() {
    this.firefox = !1, this.ie = !1, this.edge = !1, this.newEdge = !1, this.weChat = !1;
  }
  return t;
}(), RY = /* @__PURE__ */ function() {
  function t() {
    this.browser = new MY(), this.node = !1, this.wxa = !1, this.worker = !1, this.svgSupported = !1, this.touchEventsSupported = !1, this.pointerEventsSupported = !1, this.domSupported = !1, this.transformSupported = !1, this.transform3dSupported = !1, this.hasGlobalWindow = typeof window < "u";
  }
  return t;
}(), vt = new RY();
typeof wx == "object" && typeof wx.getSystemInfoSync == "function" ? (vt.wxa = !0, vt.touchEventsSupported = !0) : typeof document > "u" && typeof self < "u" ? vt.worker = !0 : typeof navigator > "u" || navigator.userAgent.indexOf("Node.js") === 0 ? (vt.node = !0, vt.svgSupported = !0) : LY(navigator.userAgent, vt);
function LY(t, r) {
  var e = r.browser, n = t.match(/Firefox\/([\d.]+)/), i = t.match(/MSIE\s([\d.]+)/) || t.match(/Trident\/.+?rv:(([\d.]+))/), a = t.match(/Edge?\/([\d.]+)/), o = /micromessenger/i.test(t);
  n && (e.firefox = !0, e.version = n[1]), i && (e.ie = !0, e.version = i[1]), a && (e.edge = !0, e.version = a[1], e.newEdge = +a[1].split(".")[0] > 18), o && (e.weChat = !0), r.svgSupported = typeof SVGRect < "u", r.touchEventsSupported = "ontouchstart" in window && !e.ie && !e.edge, r.pointerEventsSupported = "onpointerdown" in window && (e.edge || e.ie && +e.version >= 11), r.domSupported = typeof document < "u";
  var s = document.documentElement.style;
  r.transform3dSupported = (e.ie && "transition" in s || e.edge || "WebKitCSSMatrix" in window && "m11" in new WebKitCSSMatrix() || "MozPerspective" in s) && !("OTransition" in s), r.transformSupported = r.transform3dSupported || e.ie && +e.version >= 9;
}
var m7 = 12, kP = "sans-serif", Jl = m7 + "px " + kP, EY = 20, kY = 100, PY = "007LLmW'55;N0500LLLLLLLLLL00NNNLzWW\\\\WQb\\0FWLg\\bWb\\WQ\\WrWWQ000CL5LLFLL0LL**F*gLLLL5F0LF\\FFF5.5N";
function NY(t) {
  var r = {};
  if (typeof JSON > "u")
    return r;
  for (var e = 0; e < t.length; e++) {
    var n = String.fromCharCode(e + 32), i = (t.charCodeAt(e) - EY) / kY;
    r[n] = i;
  }
  return r;
}
var OY = NY(PY), Qa = {
  createCanvas: function() {
    return typeof document < "u" && document.createElement("canvas");
  },
  measureText: /* @__PURE__ */ function() {
    var t, r;
    return function(e, n) {
      if (!t) {
        var i = Qa.createCanvas();
        t = i && i.getContext("2d");
      }
      if (t)
        return r !== n && (r = t.font = n || Jl), t.measureText(e);
      e = e || "", n = n || Jl;
      var a = /((?:\d+)?\.?\d*)px/.exec(n), o = a && +a[1] || m7, s = 0;
      if (n.indexOf("mono") >= 0)
        s = o * e.length;
      else
        for (var l = 0; l < e.length; l++) {
          var u = OY[e[l]];
          s += u == null ? o : u * o;
        }
      return { width: s };
    };
  }(),
  loadImage: function(t, r, e) {
    var n = new Image();
    return n.onload = r, n.onerror = e, n.src = t, n;
  }
};
function PP(t) {
  for (var r in Qa)
    t[r] && (Qa[r] = t[r]);
}
var NP = Ma([
  "Function",
  "RegExp",
  "Date",
  "Error",
  "CanvasGradient",
  "CanvasPattern",
  "Image",
  "Canvas"
], function(t, r) {
  return t["[object " + r + "]"] = !0, t;
}, {}), OP = Ma([
  "Int8",
  "Uint8",
  "Uint8Clamped",
  "Int16",
  "Uint16",
  "Int32",
  "Uint32",
  "Float32",
  "Float64"
], function(t, r) {
  return t["[object " + r + "Array]"] = !0, t;
}, {}), Kf = Object.prototype.toString, Xy = Array.prototype, VY = Xy.forEach, GY = Xy.filter, y7 = Xy.slice, BY = Xy.map, G8 = (function() {
}).constructor, Kg = G8 ? G8.prototype : null, b7 = "__proto__", FY = 2311;
function C7() {
  return FY++;
}
function Da() {
  for (var t = [], r = 0; r < arguments.length; r++)
    t[r] = arguments[r];
  typeof console < "u" && console.error.apply(console, t);
}
function Ge(t) {
  if (t == null || typeof t != "object")
    return t;
  var r = t, e = Kf.call(t);
  if (e === "[object Array]") {
    if (!cf(t)) {
      r = [];
      for (var n = 0, i = t.length; n < i; n++)
        r[n] = Ge(t[n]);
    }
  } else if (OP[e]) {
    if (!cf(t)) {
      var a = t.constructor;
      if (a.from)
        r = a.from(t);
      else {
        r = new a(t.length);
        for (var n = 0, i = t.length; n < i; n++)
          r[n] = t[n];
      }
    }
  } else if (!NP[e] && !cf(t) && !Kl(t)) {
    r = {};
    for (var o in t)
      t.hasOwnProperty(o) && o !== b7 && (r[o] = Ge(t[o]));
  }
  return r;
}
function Qe(t, r, e) {
  if (!Me(r) || !Me(t))
    return e ? Ge(r) : t;
  for (var n in r)
    if (r.hasOwnProperty(n) && n !== b7) {
      var i = t[n], a = r[n];
      Me(a) && Me(i) && !ue(a) && !ue(i) && !Kl(a) && !Kl(i) && !gC(a) && !gC(i) && !cf(a) && !cf(i) ? Qe(i, a, e) : (e || !(n in t)) && (t[n] = Ge(r[n]));
    }
  return t;
}
function $y(t, r) {
  for (var e = t[0], n = 1, i = t.length; n < i; n++)
    e = Qe(e, t[n], r);
  return e;
}
function ae(t, r) {
  if (Object.assign)
    Object.assign(t, r);
  else
    for (var e in r)
      r.hasOwnProperty(e) && e !== b7 && (t[e] = r[e]);
  return t;
}
function Ee(t, r, e) {
  for (var n = yt(r), i = 0; i < n.length; i++) {
    var a = n[i];
    (e ? r[a] != null : t[a] == null) && (t[a] = r[a]);
  }
  return t;
}
var HY = Qa.createCanvas;
function nt(t, r) {
  if (t) {
    if (t.indexOf)
      return t.indexOf(r);
    for (var e = 0, n = t.length; e < n; e++)
      if (t[e] === r)
        return e;
  }
  return -1;
}
function w7(t, r) {
  var e = t.prototype;
  function n() {
  }
  n.prototype = r.prototype, t.prototype = new n();
  for (var i in e)
    e.hasOwnProperty(i) && (t.prototype[i] = e[i]);
  t.prototype.constructor = t, t.superClass = r;
}
function Xr(t, r, e) {
  if (t = "prototype" in t ? t.prototype : t, r = "prototype" in r ? r.prototype : r, Object.getOwnPropertyNames)
    for (var n = Object.getOwnPropertyNames(r), i = 0; i < n.length; i++) {
      var a = n[i];
      a !== "constructor" && (e ? r[a] != null : t[a] == null) && (t[a] = r[a]);
    }
  else
    Ee(t, r, e);
}
function Zn(t) {
  return !t || typeof t == "string" ? !1 : typeof t.length == "number";
}
function L(t, r, e) {
  if (t && r)
    if (t.forEach && t.forEach === VY)
      t.forEach(r, e);
    else if (t.length === +t.length)
      for (var n = 0, i = t.length; n < i; n++)
        r.call(e, t[n], n, t);
    else
      for (var a in t)
        t.hasOwnProperty(a) && r.call(e, t[a], a, t);
}
function ce(t, r, e) {
  if (!t)
    return [];
  if (!r)
    return Uy(t);
  if (t.map && t.map === BY)
    return t.map(r, e);
  for (var n = [], i = 0, a = t.length; i < a; i++)
    n.push(r.call(e, t[i], i, t));
  return n;
}
function Ma(t, r, e, n) {
  if (t && r) {
    for (var i = 0, a = t.length; i < a; i++)
      e = r.call(n, e, t[i], i, t);
    return e;
  }
}
function Wt(t, r, e) {
  if (!t)
    return [];
  if (!r)
    return Uy(t);
  if (t.filter && t.filter === GY)
    return t.filter(r, e);
  for (var n = [], i = 0, a = t.length; i < a; i++)
    r.call(e, t[i], i, t) && n.push(t[i]);
  return n;
}
function VP(t, r, e) {
  if (t && r) {
    for (var n = 0, i = t.length; n < i; n++)
      if (r.call(e, t[n], n, t))
        return t[n];
  }
}
function yt(t) {
  if (!t)
    return [];
  if (Object.keys)
    return Object.keys(t);
  var r = [];
  for (var e in t)
    t.hasOwnProperty(e) && r.push(e);
  return r;
}
function zY(t, r) {
  for (var e = [], n = 2; n < arguments.length; n++)
    e[n - 2] = arguments[n];
  return function() {
    return t.apply(r, e.concat(y7.call(arguments)));
  };
}
var ye = Kg && Ae(Kg.bind) ? Kg.call.bind(Kg.bind) : zY;
function Ye(t) {
  for (var r = [], e = 1; e < arguments.length; e++)
    r[e - 1] = arguments[e];
  return function() {
    return t.apply(this, r.concat(y7.call(arguments)));
  };
}
function ue(t) {
  return Array.isArray ? Array.isArray(t) : Kf.call(t) === "[object Array]";
}
function Ae(t) {
  return typeof t == "function";
}
function pe(t) {
  return typeof t == "string";
}
function dv(t) {
  return Kf.call(t) === "[object String]";
}
function Mt(t) {
  return typeof t == "number";
}
function Me(t) {
  var r = typeof t;
  return r === "function" || !!t && r === "object";
}
function gC(t) {
  return !!NP[Kf.call(t)];
}
function ai(t) {
  return !!OP[Kf.call(t)];
}
function Kl(t) {
  return typeof t == "object" && typeof t.nodeType == "number" && typeof t.ownerDocument == "object";
}
function og(t) {
  return t.colorStops != null;
}
function GP(t) {
  return t.image != null;
}
function _7(t) {
  return Kf.call(t) === "[object RegExp]";
}
function ql(t) {
  return t !== t;
}
function Qr() {
  for (var t = [], r = 0; r < arguments.length; r++)
    t[r] = arguments[r];
  for (var e = 0, n = t.length; e < n; e++)
    if (t[e] != null)
      return t[e];
}
function je(t, r) {
  return t ?? r;
}
function Ki(t, r, e) {
  return t ?? r ?? e;
}
function Uy(t) {
  for (var r = [], e = 1; e < arguments.length; e++)
    r[e - 1] = arguments[e];
  return y7.apply(t, r);
}
function Jy(t) {
  if (typeof t == "number")
    return [t, t, t, t];
  var r = t.length;
  return r === 2 ? [t[0], t[1], t[0], t[1]] : r === 3 ? [t[0], t[1], t[2], t[1]] : t;
}
function ke(t, r) {
  if (!t)
    throw new Error(r);
}
function Aa(t) {
  return t == null ? null : typeof t.trim == "function" ? t.trim() : t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
}
var BP = "__ec_primitive__";
function fv(t) {
  t[BP] = !0;
}
function cf(t) {
  return t[BP];
}
var WY = function() {
  function t() {
    this.data = {};
  }
  return t.prototype.delete = function(r) {
    var e = this.has(r);
    return e && delete this.data[r], e;
  }, t.prototype.has = function(r) {
    return this.data.hasOwnProperty(r);
  }, t.prototype.get = function(r) {
    return this.data[r];
  }, t.prototype.set = function(r, e) {
    return this.data[r] = e, this;
  }, t.prototype.keys = function() {
    return yt(this.data);
  }, t.prototype.forEach = function(r) {
    var e = this.data;
    for (var n in e)
      e.hasOwnProperty(n) && r(e[n], n);
  }, t;
}(), FP = typeof Map == "function";
function ZY() {
  return FP ? /* @__PURE__ */ new Map() : new WY();
}
var HP = function() {
  function t(r) {
    var e = ue(r);
    this.data = ZY();
    var n = this;
    r instanceof t ? r.each(i) : r && L(r, i);
    function i(a, o) {
      e ? n.set(a, o) : n.set(o, a);
    }
  }
  return t.prototype.hasKey = function(r) {
    return this.data.has(r);
  }, t.prototype.get = function(r) {
    return this.data.get(r);
  }, t.prototype.set = function(r, e) {
    return this.data.set(r, e), e;
  }, t.prototype.each = function(r, e) {
    this.data.forEach(function(n, i) {
      r.call(e, n, i);
    });
  }, t.prototype.keys = function() {
    var r = this.data.keys();
    return FP ? Array.from(r) : r;
  }, t.prototype.removeKey = function(r) {
    this.data.delete(r);
  }, t;
}();
function xe(t) {
  return new HP(t);
}
function hv(t, r) {
  for (var e = new t.constructor(t.length + r.length), n = 0; n < t.length; n++)
    e[n] = t[n];
  for (var i = t.length, n = 0; n < r.length; n++)
    e[n + i] = r[n];
  return e;
}
function sg(t, r) {
  var e;
  if (Object.create)
    e = Object.create(t);
  else {
    var n = function() {
    };
    n.prototype = t, e = new n();
  }
  return r && ae(e, r), e;
}
function x7(t) {
  var r = t.style;
  r.webkitUserSelect = "none", r.userSelect = "none", r.webkitTapHighlightColor = "rgba(0,0,0,0)", r["-webkit-touch-callout"] = "none";
}
function be(t, r) {
  return t.hasOwnProperty(r);
}
function Yr() {
}
var zp = 180 / Math.PI;
const jY = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  HashMap: HP,
  RADIAN_TO_DEGREE: zp,
  assert: ke,
  bind: ye,
  clone: Ge,
  concatArray: hv,
  createCanvas: HY,
  createHashMap: xe,
  createObject: sg,
  curry: Ye,
  defaults: Ee,
  disableUserSelect: x7,
  each: L,
  eqNaN: ql,
  extend: ae,
  filter: Wt,
  find: VP,
  guid: C7,
  hasOwn: be,
  indexOf: nt,
  inherits: w7,
  isArray: ue,
  isArrayLike: Zn,
  isBuiltInObject: gC,
  isDom: Kl,
  isFunction: Ae,
  isGradientObject: og,
  isImagePatternObject: GP,
  isNumber: Mt,
  isObject: Me,
  isPrimitive: cf,
  isRegExp: _7,
  isString: pe,
  isStringSafe: dv,
  isTypedArray: ai,
  keys: yt,
  logError: Da,
  map: ce,
  merge: Qe,
  mergeAll: $y,
  mixin: Xr,
  noop: Yr,
  normalizeCssArray: Jy,
  reduce: Ma,
  retrieve: Qr,
  retrieve2: je,
  retrieve3: Ki,
  setAsPrimitive: fv,
  slice: Uy,
  trim: Aa
}, Symbol.toStringTag, { value: "Module" }));
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var mC = function(t, r) {
  return mC = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, n) {
    e.__proto__ = n;
  } || function(e, n) {
    for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
  }, mC(t, r);
};
function _r(t, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
  mC(t, r);
  function e() {
    this.constructor = t;
  }
  t.prototype = r === null ? Object.create(r) : (e.prototype = r.prototype, new e());
}
function fu(t, r) {
  return t == null && (t = 0), r == null && (r = 0), [t, r];
}
function Qn(t, r) {
  return t[0] = r[0], t[1] = r[1], t;
}
function Ho(t) {
  return [t[0], t[1]];
}
function zP(t, r, e) {
  return t[0] = r, t[1] = e, t;
}
function yC(t, r, e) {
  return t[0] = r[0] + e[0], t[1] = r[1] + e[1], t;
}
function sm(t, r, e, n) {
  return t[0] = r[0] + e[0] * n, t[1] = r[1] + e[1] * n, t;
}
function Il(t, r, e) {
  return t[0] = r[0] - e[0], t[1] = r[1] - e[1], t;
}
function pv(t) {
  return Math.sqrt(S7(t));
}
var YY = pv;
function S7(t) {
  return t[0] * t[0] + t[1] * t[1];
}
var XY = S7;
function $Y(t, r, e) {
  return t[0] = r[0] * e[0], t[1] = r[1] * e[1], t;
}
function UY(t, r, e) {
  return t[0] = r[0] / e[0], t[1] = r[1] / e[1], t;
}
function JY(t, r) {
  return t[0] * r[0] + t[1] * r[1];
}
function Wp(t, r, e) {
  return t[0] = r[0] * e, t[1] = r[1] * e, t;
}
function Jc(t, r) {
  var e = pv(r);
  return e === 0 ? (t[0] = 0, t[1] = 0) : (t[0] = r[0] / e, t[1] = r[1] / e), t;
}
function lm(t, r) {
  return Math.sqrt((t[0] - r[0]) * (t[0] - r[0]) + (t[1] - r[1]) * (t[1] - r[1]));
}
var Ts = lm;
function WP(t, r) {
  return (t[0] - r[0]) * (t[0] - r[0]) + (t[1] - r[1]) * (t[1] - r[1]);
}
var Gl = WP;
function KY(t, r) {
  return t[0] = -r[0], t[1] = -r[1], t;
}
function Zp(t, r, e, n) {
  return t[0] = r[0] + n * (e[0] - r[0]), t[1] = r[1] + n * (e[1] - r[1]), t;
}
function En(t, r, e) {
  var n = r[0], i = r[1];
  return t[0] = e[0] * n + e[2] * i + e[4], t[1] = e[1] * n + e[3] * i + e[5], t;
}
function Ms(t, r, e) {
  return t[0] = Math.min(r[0], e[0]), t[1] = Math.min(r[1], e[1]), t;
}
function Rs(t, r, e) {
  return t[0] = Math.max(r[0], e[0]), t[1] = Math.max(r[1], e[1]), t;
}
const qY = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  add: yC,
  applyTransform: En,
  clone: Ho,
  copy: Qn,
  create: fu,
  dist: Ts,
  distSquare: Gl,
  distance: lm,
  distanceSquare: WP,
  div: UY,
  dot: JY,
  len: pv,
  lenSquare: S7,
  length: YY,
  lengthSquare: XY,
  lerp: Zp,
  max: Rs,
  min: Ms,
  mul: $Y,
  negate: KY,
  normalize: Jc,
  scale: Wp,
  scaleAndAdd: sm,
  set: zP,
  sub: Il
}, Symbol.toStringTag, { value: "Module" }));
var fd = /* @__PURE__ */ function() {
  function t(r, e) {
    this.target = r, this.topTarget = e && e.topTarget;
  }
  return t;
}(), QY = function() {
  function t(r) {
    this.handler = r, r.on("mousedown", this._dragStart, this), r.on("mousemove", this._drag, this), r.on("mouseup", this._dragEnd, this);
  }
  return t.prototype._dragStart = function(r) {
    for (var e = r.target; e && !e.draggable; )
      e = e.parent || e.__hostTarget;
    e && (this._draggingTarget = e, e.dragging = !0, this._x = r.offsetX, this._y = r.offsetY, this.handler.dispatchToElement(new fd(e, r), "dragstart", r.event));
  }, t.prototype._drag = function(r) {
    var e = this._draggingTarget;
    if (e) {
      var n = r.offsetX, i = r.offsetY, a = n - this._x, o = i - this._y;
      this._x = n, this._y = i, e.drift(a, o, r), this.handler.dispatchToElement(new fd(e, r), "drag", r.event);
      var s = this.handler.findHover(n, i, e).target, l = this._dropTarget;
      this._dropTarget = s, e !== s && (l && s !== l && this.handler.dispatchToElement(new fd(l, r), "dragleave", r.event), s && s !== l && this.handler.dispatchToElement(new fd(s, r), "dragenter", r.event));
    }
  }, t.prototype._dragEnd = function(r) {
    var e = this._draggingTarget;
    e && (e.dragging = !1), this.handler.dispatchToElement(new fd(e, r), "dragend", r.event), this._dropTarget && this.handler.dispatchToElement(new fd(this._dropTarget, r), "drop", r.event), this._draggingTarget = null, this._dropTarget = null;
  }, t;
}(), ka = function() {
  function t(r) {
    r && (this._$eventProcessor = r);
  }
  return t.prototype.on = function(r, e, n, i) {
    this._$handlers || (this._$handlers = {});
    var a = this._$handlers;
    if (typeof e == "function" && (i = n, n = e, e = null), !n || !r)
      return this;
    var o = this._$eventProcessor;
    e != null && o && o.normalizeQuery && (e = o.normalizeQuery(e)), a[r] || (a[r] = []);
    for (var s = 0; s < a[r].length; s++)
      if (a[r][s].h === n)
        return this;
    var l = {
      h: n,
      query: e,
      ctx: i || this,
      callAtLast: n.zrEventfulCallAtLast
    }, u = a[r].length - 1, c = a[r][u];
    return c && c.callAtLast ? a[r].splice(u, 0, l) : a[r].push(l), this;
  }, t.prototype.isSilent = function(r) {
    var e = this._$handlers;
    return !e || !e[r] || !e[r].length;
  }, t.prototype.off = function(r, e) {
    var n = this._$handlers;
    if (!n)
      return this;
    if (!r)
      return this._$handlers = {}, this;
    if (e) {
      if (n[r]) {
        for (var i = [], a = 0, o = n[r].length; a < o; a++)
          n[r][a].h !== e && i.push(n[r][a]);
        n[r] = i;
      }
      n[r] && n[r].length === 0 && delete n[r];
    } else
      delete n[r];
    return this;
  }, t.prototype.trigger = function(r) {
    for (var e = [], n = 1; n < arguments.length; n++)
      e[n - 1] = arguments[n];
    if (!this._$handlers)
      return this;
    var i = this._$handlers[r], a = this._$eventProcessor;
    if (i)
      for (var o = e.length, s = i.length, l = 0; l < s; l++) {
        var u = i[l];
        if (!(a && a.filter && u.query != null && !a.filter(r, u.query)))
          switch (o) {
            case 0:
              u.h.call(u.ctx);
              break;
            case 1:
              u.h.call(u.ctx, e[0]);
              break;
            case 2:
              u.h.call(u.ctx, e[0], e[1]);
              break;
            default:
              u.h.apply(u.ctx, e);
              break;
          }
      }
    return a && a.afterTrigger && a.afterTrigger(r), this;
  }, t.prototype.triggerWithContext = function(r) {
    for (var e = [], n = 1; n < arguments.length; n++)
      e[n - 1] = arguments[n];
    if (!this._$handlers)
      return this;
    var i = this._$handlers[r], a = this._$eventProcessor;
    if (i)
      for (var o = e.length, s = e[o - 1], l = i.length, u = 0; u < l; u++) {
        var c = i[u];
        if (!(a && a.filter && c.query != null && !a.filter(r, c.query)))
          switch (o) {
            case 0:
              c.h.call(s);
              break;
            case 1:
              c.h.call(s, e[0]);
              break;
            case 2:
              c.h.call(s, e[0], e[1]);
              break;
            default:
              c.h.apply(s, e.slice(1, o - 1));
              break;
          }
      }
    return a && a.afterTrigger && a.afterTrigger(r), this;
  }, t;
}(), eX = Math.log(2);
function bC(t, r, e, n, i, a) {
  var o = n + "-" + i, s = t.length;
  if (a.hasOwnProperty(o))
    return a[o];
  if (r === 1) {
    var l = Math.round(Math.log((1 << s) - 1 & ~i) / eX);
    return t[e][l];
  }
  for (var u = n | 1 << e, c = e + 1; n & 1 << c; )
    c++;
  for (var d = 0, f = 0, h = 0; f < s; f++) {
    var p = 1 << f;
    p & i || (d += (h % 2 ? -1 : 1) * t[e][f] * bC(t, r - 1, c, u, i | p, a), h++);
  }
  return a[o] = d, d;
}
function B8(t, r) {
  var e = [
    [t[0], t[1], 1, 0, 0, 0, -r[0] * t[0], -r[0] * t[1]],
    [0, 0, 0, t[0], t[1], 1, -r[1] * t[0], -r[1] * t[1]],
    [t[2], t[3], 1, 0, 0, 0, -r[2] * t[2], -r[2] * t[3]],
    [0, 0, 0, t[2], t[3], 1, -r[3] * t[2], -r[3] * t[3]],
    [t[4], t[5], 1, 0, 0, 0, -r[4] * t[4], -r[4] * t[5]],
    [0, 0, 0, t[4], t[5], 1, -r[5] * t[4], -r[5] * t[5]],
    [t[6], t[7], 1, 0, 0, 0, -r[6] * t[6], -r[6] * t[7]],
    [0, 0, 0, t[6], t[7], 1, -r[7] * t[6], -r[7] * t[7]]
  ], n = {}, i = bC(e, 8, 0, 0, 0, n);
  if (i !== 0) {
    for (var a = [], o = 0; o < 8; o++)
      for (var s = 0; s < 8; s++)
        a[s] == null && (a[s] = 0), a[s] += ((o + s) % 2 ? -1 : 1) * bC(e, 7, o === 0 ? 1 : 0, 1 << o, 1 << s, n) / i * r[o];
    return function(l, u, c) {
      var d = u * a[6] + c * a[7] + 1;
      l[0] = (u * a[0] + c * a[1] + a[2]) / d, l[1] = (u * a[3] + c * a[4] + a[5]) / d;
    };
  }
}
var F8 = "___zrEVENTSAVED", S5 = [];
function tX(t, r, e, n, i) {
  return CC(S5, r, n, i, !0) && CC(t, e, S5[0], S5[1]);
}
function CC(t, r, e, n, i) {
  if (r.getBoundingClientRect && vt.domSupported && !ZP(r)) {
    var a = r[F8] || (r[F8] = {}), o = rX(r, a), s = nX(o, a, i);
    if (s)
      return s(t, e, n), !0;
  }
  return !1;
}
function rX(t, r) {
  var e = r.markers;
  if (e)
    return e;
  e = r.markers = [];
  for (var n = ["left", "right"], i = ["top", "bottom"], a = 0; a < 4; a++) {
    var o = document.createElement("div"), s = o.style, l = a % 2, u = (a >> 1) % 2;
    s.cssText = [
      "position: absolute",
      "visibility: hidden",
      "padding: 0",
      "margin: 0",
      "border-width: 0",
      "user-select: none",
      "width:0",
      "height:0",
      n[l] + ":0",
      i[u] + ":0",
      n[1 - l] + ":auto",
      i[1 - u] + ":auto",
      ""
    ].join("!important;"), t.appendChild(o), e.push(o);
  }
  return e;
}
function nX(t, r, e) {
  for (var n = e ? "invTrans" : "trans", i = r[n], a = r.srcCoords, o = [], s = [], l = !0, u = 0; u < 4; u++) {
    var c = t[u].getBoundingClientRect(), d = 2 * u, f = c.left, h = c.top;
    o.push(f, h), l = l && a && f === a[d] && h === a[d + 1], s.push(t[u].offsetLeft, t[u].offsetTop);
  }
  return l && i ? i : (r.srcCoords = o, r[n] = e ? B8(s, o) : B8(o, s));
}
function ZP(t) {
  return t.nodeName.toUpperCase() === "CANVAS";
}
var iX = /([&<>"'])/g, aX = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
};
function bi(t) {
  return t == null ? "" : (t + "").replace(iX, function(r, e) {
    return aX[e];
  });
}
var oX = /^(?:mouse|pointer|contextmenu|drag|drop)|click/, I5 = [], sX = vt.browser.firefox && +vt.browser.version.split(".")[0] < 39;
function wC(t, r, e, n) {
  return e = e || {}, n ? H8(t, r, e) : sX && r.layerX != null && r.layerX !== r.offsetX ? (e.zrX = r.layerX, e.zrY = r.layerY) : r.offsetX != null ? (e.zrX = r.offsetX, e.zrY = r.offsetY) : H8(t, r, e), e;
}
function H8(t, r, e) {
  if (vt.domSupported && t.getBoundingClientRect) {
    var n = r.clientX, i = r.clientY;
    if (ZP(t)) {
      var a = t.getBoundingClientRect();
      e.zrX = n - a.left, e.zrY = i - a.top;
      return;
    } else if (CC(I5, t, n, i)) {
      e.zrX = I5[0], e.zrY = I5[1];
      return;
    }
  }
  e.zrX = e.zrY = 0;
}
function I7(t) {
  return t || window.event;
}
function ga(t, r, e) {
  if (r = I7(r), r.zrX != null)
    return r;
  var n = r.type, i = n && n.indexOf("touch") >= 0;
  if (i) {
    var o = n !== "touchend" ? r.targetTouches[0] : r.changedTouches[0];
    o && wC(t, o, r, e);
  } else {
    wC(t, r, r, e);
    var a = lX(r);
    r.zrDelta = a ? a / 120 : -(r.detail || 0) / 3;
  }
  var s = r.button;
  return r.which == null && s !== void 0 && oX.test(r.type) && (r.which = s & 1 ? 1 : s & 2 ? 3 : s & 4 ? 2 : 0), r;
}
function lX(t) {
  var r = t.wheelDelta;
  if (r)
    return r;
  var e = t.deltaX, n = t.deltaY;
  if (e == null || n == null)
    return r;
  var i = Math.abs(n !== 0 ? n : e), a = n > 0 ? -1 : n < 0 ? 1 : e > 0 ? -1 : 1;
  return 3 * i * a;
}
function _C(t, r, e, n) {
  t.addEventListener(r, e, n);
}
function uX(t, r, e, n) {
  t.removeEventListener(r, e, n);
}
var Ys = function(t) {
  t.preventDefault(), t.stopPropagation(), t.cancelBubble = !0;
};
function z8(t) {
  return t.which === 2 || t.which === 3;
}
var cX = function() {
  function t() {
    this._track = [];
  }
  return t.prototype.recognize = function(r, e, n) {
    return this._doTrack(r, e, n), this._recognize(r);
  }, t.prototype.clear = function() {
    return this._track.length = 0, this;
  }, t.prototype._doTrack = function(r, e, n) {
    var i = r.touches;
    if (i) {
      for (var a = {
        points: [],
        touches: [],
        target: e,
        event: r
      }, o = 0, s = i.length; o < s; o++) {
        var l = i[o], u = wC(n, l, {});
        a.points.push([u.zrX, u.zrY]), a.touches.push(l);
      }
      this._track.push(a);
    }
  }, t.prototype._recognize = function(r) {
    for (var e in A5)
      if (A5.hasOwnProperty(e)) {
        var n = A5[e](this._track, r);
        if (n)
          return n;
      }
  }, t;
}();
function W8(t) {
  var r = t[1][0] - t[0][0], e = t[1][1] - t[0][1];
  return Math.sqrt(r * r + e * e);
}
function dX(t) {
  return [
    (t[0][0] + t[1][0]) / 2,
    (t[0][1] + t[1][1]) / 2
  ];
}
var A5 = {
  pinch: function(t, r) {
    var e = t.length;
    if (e) {
      var n = (t[e - 1] || {}).points, i = (t[e - 2] || {}).points || n;
      if (i && i.length > 1 && n && n.length > 1) {
        var a = W8(n) / W8(i);
        !isFinite(a) && (a = 1), r.pinchScale = a;
        var o = dX(n);
        return r.pinchX = o[0], r.pinchY = o[1], {
          type: "pinch",
          target: t[0].target,
          event: r
        };
      }
    }
  }
};
function Oi() {
  return [1, 0, 0, 1, 0, 0];
}
function lg(t) {
  return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 1, t[4] = 0, t[5] = 0, t;
}
function Ky(t, r) {
  return t[0] = r[0], t[1] = r[1], t[2] = r[2], t[3] = r[3], t[4] = r[4], t[5] = r[5], t;
}
function zo(t, r, e) {
  var n = r[0] * e[0] + r[2] * e[1], i = r[1] * e[0] + r[3] * e[1], a = r[0] * e[2] + r[2] * e[3], o = r[1] * e[2] + r[3] * e[3], s = r[0] * e[4] + r[2] * e[5] + r[4], l = r[1] * e[4] + r[3] * e[5] + r[5];
  return t[0] = n, t[1] = i, t[2] = a, t[3] = o, t[4] = s, t[5] = l, t;
}
function eo(t, r, e) {
  return t[0] = r[0], t[1] = r[1], t[2] = r[2], t[3] = r[3], t[4] = r[4] + e[0], t[5] = r[5] + e[1], t;
}
function hu(t, r, e, n) {
  n === void 0 && (n = [0, 0]);
  var i = r[0], a = r[2], o = r[4], s = r[1], l = r[3], u = r[5], c = Math.sin(e), d = Math.cos(e);
  return t[0] = i * d + s * c, t[1] = -i * c + s * d, t[2] = a * d + l * c, t[3] = -a * c + d * l, t[4] = d * (o - n[0]) + c * (u - n[1]) + n[0], t[5] = d * (u - n[1]) - c * (o - n[0]) + n[1], t;
}
function qy(t, r, e) {
  var n = e[0], i = e[1];
  return t[0] = r[0] * n, t[1] = r[1] * i, t[2] = r[2] * n, t[3] = r[3] * i, t[4] = r[4] * n, t[5] = r[5] * i, t;
}
function Kc(t, r) {
  var e = r[0], n = r[2], i = r[4], a = r[1], o = r[3], s = r[5], l = e * o - a * n;
  return l ? (l = 1 / l, t[0] = o * l, t[1] = -a * l, t[2] = -n * l, t[3] = e * l, t[4] = (n * s - o * i) * l, t[5] = (a * i - e * s) * l, t) : null;
}
function jP(t) {
  var r = Oi();
  return Ky(r, t), r;
}
const fX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  clone: jP,
  copy: Ky,
  create: Oi,
  identity: lg,
  invert: Kc,
  mul: zo,
  rotate: hu,
  scale: qy,
  translate: eo
}, Symbol.toStringTag, { value: "Module" }));
var tt = function() {
  function t(r, e) {
    this.x = r || 0, this.y = e || 0;
  }
  return t.prototype.copy = function(r) {
    return this.x = r.x, this.y = r.y, this;
  }, t.prototype.clone = function() {
    return new t(this.x, this.y);
  }, t.prototype.set = function(r, e) {
    return this.x = r, this.y = e, this;
  }, t.prototype.equal = function(r) {
    return r.x === this.x && r.y === this.y;
  }, t.prototype.add = function(r) {
    return this.x += r.x, this.y += r.y, this;
  }, t.prototype.scale = function(r) {
    this.x *= r, this.y *= r;
  }, t.prototype.scaleAndAdd = function(r, e) {
    this.x += r.x * e, this.y += r.y * e;
  }, t.prototype.sub = function(r) {
    return this.x -= r.x, this.y -= r.y, this;
  }, t.prototype.dot = function(r) {
    return this.x * r.x + this.y * r.y;
  }, t.prototype.len = function() {
    return Math.sqrt(this.x * this.x + this.y * this.y);
  }, t.prototype.lenSquare = function() {
    return this.x * this.x + this.y * this.y;
  }, t.prototype.normalize = function() {
    var r = this.len();
    return this.x /= r, this.y /= r, this;
  }, t.prototype.distance = function(r) {
    var e = this.x - r.x, n = this.y - r.y;
    return Math.sqrt(e * e + n * n);
  }, t.prototype.distanceSquare = function(r) {
    var e = this.x - r.x, n = this.y - r.y;
    return e * e + n * n;
  }, t.prototype.negate = function() {
    return this.x = -this.x, this.y = -this.y, this;
  }, t.prototype.transform = function(r) {
    if (r) {
      var e = this.x, n = this.y;
      return this.x = r[0] * e + r[2] * n + r[4], this.y = r[1] * e + r[3] * n + r[5], this;
    }
  }, t.prototype.toArray = function(r) {
    return r[0] = this.x, r[1] = this.y, r;
  }, t.prototype.fromArray = function(r) {
    this.x = r[0], this.y = r[1];
  }, t.set = function(r, e, n) {
    r.x = e, r.y = n;
  }, t.copy = function(r, e) {
    r.x = e.x, r.y = e.y;
  }, t.len = function(r) {
    return Math.sqrt(r.x * r.x + r.y * r.y);
  }, t.lenSquare = function(r) {
    return r.x * r.x + r.y * r.y;
  }, t.dot = function(r, e) {
    return r.x * e.x + r.y * e.y;
  }, t.add = function(r, e, n) {
    r.x = e.x + n.x, r.y = e.y + n.y;
  }, t.sub = function(r, e, n) {
    r.x = e.x - n.x, r.y = e.y - n.y;
  }, t.scale = function(r, e, n) {
    r.x = e.x * n, r.y = e.y * n;
  }, t.scaleAndAdd = function(r, e, n, i) {
    r.x = e.x + n.x * i, r.y = e.y + n.y * i;
  }, t.lerp = function(r, e, n, i) {
    var a = 1 - i;
    r.x = a * e.x + i * n.x, r.y = a * e.y + i * n.y;
  }, t;
}(), qg = Math.min, Qg = Math.max, _u = new tt(), xu = new tt(), Su = new tt(), Iu = new tt(), kh = new tt(), Ph = new tt(), rt = function() {
  function t(r, e, n, i) {
    n < 0 && (r = r + n, n = -n), i < 0 && (e = e + i, i = -i), this.x = r, this.y = e, this.width = n, this.height = i;
  }
  return t.prototype.union = function(r) {
    var e = qg(r.x, this.x), n = qg(r.y, this.y);
    isFinite(this.x) && isFinite(this.width) ? this.width = Qg(r.x + r.width, this.x + this.width) - e : this.width = r.width, isFinite(this.y) && isFinite(this.height) ? this.height = Qg(r.y + r.height, this.y + this.height) - n : this.height = r.height, this.x = e, this.y = n;
  }, t.prototype.applyTransform = function(r) {
    t.applyTransform(this, this, r);
  }, t.prototype.calculateTransform = function(r) {
    var e = this, n = r.width / e.width, i = r.height / e.height, a = Oi();
    return eo(a, a, [-e.x, -e.y]), qy(a, a, [n, i]), eo(a, a, [r.x, r.y]), a;
  }, t.prototype.intersect = function(r, e) {
    if (!r)
      return !1;
    r instanceof t || (r = t.create(r));
    var n = this, i = n.x, a = n.x + n.width, o = n.y, s = n.y + n.height, l = r.x, u = r.x + r.width, c = r.y, d = r.y + r.height, f = !(a < l || u < i || s < c || d < o);
    if (e) {
      var h = 1 / 0, p = 0, v = Math.abs(a - l), g = Math.abs(u - i), m = Math.abs(s - c), y = Math.abs(d - o), b = Math.min(v, g), C = Math.min(m, y);
      a < l || u < i ? b > p && (p = b, v < g ? tt.set(Ph, -v, 0) : tt.set(Ph, g, 0)) : b < h && (h = b, v < g ? tt.set(kh, v, 0) : tt.set(kh, -g, 0)), s < c || d < o ? C > p && (p = C, m < y ? tt.set(Ph, 0, -m) : tt.set(Ph, 0, y)) : b < h && (h = b, m < y ? tt.set(kh, 0, m) : tt.set(kh, 0, -y));
    }
    return e && tt.copy(e, f ? kh : Ph), f;
  }, t.prototype.contain = function(r, e) {
    var n = this;
    return r >= n.x && r <= n.x + n.width && e >= n.y && e <= n.y + n.height;
  }, t.prototype.clone = function() {
    return new t(this.x, this.y, this.width, this.height);
  }, t.prototype.copy = function(r) {
    t.copy(this, r);
  }, t.prototype.plain = function() {
    return {
      x: this.x,
      y: this.y,
      width: this.width,
      height: this.height
    };
  }, t.prototype.isFinite = function() {
    return isFinite(this.x) && isFinite(this.y) && isFinite(this.width) && isFinite(this.height);
  }, t.prototype.isZero = function() {
    return this.width === 0 || this.height === 0;
  }, t.create = function(r) {
    return new t(r.x, r.y, r.width, r.height);
  }, t.copy = function(r, e) {
    r.x = e.x, r.y = e.y, r.width = e.width, r.height = e.height;
  }, t.applyTransform = function(r, e, n) {
    if (!n) {
      r !== e && t.copy(r, e);
      return;
    }
    if (n[1] < 1e-5 && n[1] > -1e-5 && n[2] < 1e-5 && n[2] > -1e-5) {
      var i = n[0], a = n[3], o = n[4], s = n[5];
      r.x = e.x * i + o, r.y = e.y * a + s, r.width = e.width * i, r.height = e.height * a, r.width < 0 && (r.x += r.width, r.width = -r.width), r.height < 0 && (r.y += r.height, r.height = -r.height);
      return;
    }
    _u.x = Su.x = e.x, _u.y = Iu.y = e.y, xu.x = Iu.x = e.x + e.width, xu.y = Su.y = e.y + e.height, _u.transform(n), Iu.transform(n), xu.transform(n), Su.transform(n), r.x = qg(_u.x, xu.x, Su.x, Iu.x), r.y = qg(_u.y, xu.y, Su.y, Iu.y);
    var l = Qg(_u.x, xu.x, Su.x, Iu.x), u = Qg(_u.y, xu.y, Su.y, Iu.y);
    r.width = l - r.x, r.height = u - r.y;
  }, t;
}(), YP = "silent";
function hX(t, r, e) {
  return {
    type: t,
    event: e,
    target: r.target,
    topTarget: r.topTarget,
    cancelBubble: !1,
    offsetX: e.zrX,
    offsetY: e.zrY,
    gestureEvent: e.gestureEvent,
    pinchX: e.pinchX,
    pinchY: e.pinchY,
    pinchScale: e.pinchScale,
    wheelDelta: e.zrDelta,
    zrByTouch: e.zrByTouch,
    which: e.which,
    stop: pX
  };
}
function pX() {
  Ys(this.event);
}
var vX = function(t) {
  _r(r, t);
  function r() {
    var e = t !== null && t.apply(this, arguments) || this;
    return e.handler = null, e;
  }
  return r.prototype.dispose = function() {
  }, r.prototype.setCursor = function() {
  }, r;
}(ka), Nh = /* @__PURE__ */ function() {
  function t(r, e) {
    this.x = r, this.y = e;
  }
  return t;
}(), gX = [
  "click",
  "dblclick",
  "mousewheel",
  "mouseout",
  "mouseup",
  "mousedown",
  "mousemove",
  "contextmenu"
], D5 = new rt(0, 0, 0, 0), XP = function(t) {
  _r(r, t);
  function r(e, n, i, a, o) {
    var s = t.call(this) || this;
    return s._hovered = new Nh(0, 0), s.storage = e, s.painter = n, s.painterRoot = a, s._pointerSize = o, i = i || new vX(), s.proxy = null, s.setHandlerProxy(i), s._draggingMgr = new QY(s), s;
  }
  return r.prototype.setHandlerProxy = function(e) {
    this.proxy && this.proxy.dispose(), e && (L(gX, function(n) {
      e.on && e.on(n, this[n], this);
    }, this), e.handler = this), this.proxy = e;
  }, r.prototype.mousemove = function(e) {
    var n = e.zrX, i = e.zrY, a = $P(this, n, i), o = this._hovered, s = o.target;
    s && !s.__zr && (o = this.findHover(o.x, o.y), s = o.target);
    var l = this._hovered = a ? new Nh(n, i) : this.findHover(n, i), u = l.target, c = this.proxy;
    c.setCursor && c.setCursor(u ? u.cursor : "default"), s && u !== s && this.dispatchToElement(o, "mouseout", e), this.dispatchToElement(l, "mousemove", e), u && u !== s && this.dispatchToElement(l, "mouseover", e);
  }, r.prototype.mouseout = function(e) {
    var n = e.zrEventControl;
    n !== "only_globalout" && this.dispatchToElement(this._hovered, "mouseout", e), n !== "no_globalout" && this.trigger("globalout", { type: "globalout", event: e });
  }, r.prototype.resize = function() {
    this._hovered = new Nh(0, 0);
  }, r.prototype.dispatch = function(e, n) {
    var i = this[e];
    i && i.call(this, n);
  }, r.prototype.dispose = function() {
    this.proxy.dispose(), this.storage = null, this.proxy = null, this.painter = null;
  }, r.prototype.setCursorStyle = function(e) {
    var n = this.proxy;
    n.setCursor && n.setCursor(e);
  }, r.prototype.dispatchToElement = function(e, n, i) {
    e = e || {};
    var a = e.target;
    if (!(a && a.silent)) {
      for (var o = "on" + n, s = hX(n, e, i); a && (a[o] && (s.cancelBubble = !!a[o].call(a, s)), a.trigger(n, s), a = a.__hostTarget ? a.__hostTarget : a.parent, !s.cancelBubble); )
        ;
      s.cancelBubble || (this.trigger(n, s), this.painter && this.painter.eachOtherLayer && this.painter.eachOtherLayer(function(l) {
        typeof l[o] == "function" && l[o].call(l, s), l.trigger && l.trigger(n, s);
      }));
    }
  }, r.prototype.findHover = function(e, n, i) {
    var a = this.storage.getDisplayList(), o = new Nh(e, n);
    if (Z8(a, o, e, n, i), this._pointerSize && !o.target) {
      for (var s = [], l = this._pointerSize, u = l / 2, c = new rt(e - u, n - u, l, l), d = a.length - 1; d >= 0; d--) {
        var f = a[d];
        f !== i && !f.ignore && !f.ignoreCoarsePointer && (!f.parent || !f.parent.ignoreCoarsePointer) && (D5.copy(f.getBoundingRect()), f.transform && D5.applyTransform(f.transform), D5.intersect(c) && s.push(f));
      }
      if (s.length)
        for (var h = 4, p = Math.PI / 12, v = Math.PI * 2, g = 0; g < u; g += h)
          for (var m = 0; m < v; m += p) {
            var y = e + g * Math.cos(m), b = n + g * Math.sin(m);
            if (Z8(s, o, y, b, i), o.target)
              return o;
          }
    }
    return o;
  }, r.prototype.processGesture = function(e, n) {
    this._gestureMgr || (this._gestureMgr = new cX());
    var i = this._gestureMgr;
    n === "start" && i.clear();
    var a = i.recognize(e, this.findHover(e.zrX, e.zrY, null).target, this.proxy.dom);
    if (n === "end" && i.clear(), a) {
      var o = a.type;
      e.gestureEvent = o;
      var s = new Nh();
      s.target = a.target, this.dispatchToElement(s, o, a.event);
    }
  }, r;
}(ka);
L(["click", "mousedown", "mouseup", "mousewheel", "dblclick", "contextmenu"], function(t) {
  XP.prototype[t] = function(r) {
    var e = r.zrX, n = r.zrY, i = $P(this, e, n), a, o;
    if ((t !== "mouseup" || !i) && (a = this.findHover(e, n), o = a.target), t === "mousedown")
      this._downEl = o, this._downPoint = [r.zrX, r.zrY], this._upEl = o;
    else if (t === "mouseup")
      this._upEl = o;
    else if (t === "click") {
      if (this._downEl !== this._upEl || !this._downPoint || Ts(this._downPoint, [r.zrX, r.zrY]) > 4)
        return;
      this._downPoint = null;
    }
    this.dispatchToElement(a, t, r);
  };
});
function mX(t, r, e) {
  if (t[t.rectHover ? "rectContain" : "contain"](r, e)) {
    for (var n = t, i = void 0, a = !1; n; ) {
      if (n.ignoreClip && (a = !0), !a) {
        var o = n.getClipPath();
        if (o && !o.contain(r, e))
          return !1;
      }
      n.silent && (i = !0);
      var s = n.__hostTarget;
      n = s || n.parent;
    }
    return i ? YP : !0;
  }
  return !1;
}
function Z8(t, r, e, n, i) {
  for (var a = t.length - 1; a >= 0; a--) {
    var o = t[a], s = void 0;
    if (o !== i && !o.ignore && (s = mX(o, e, n)) && (!r.topTarget && (r.topTarget = o), s !== YP)) {
      r.target = o;
      break;
    }
  }
}
function $P(t, r, e) {
  var n = t.painter;
  return r < 0 || r > n.getWidth() || e < 0 || e > n.getHeight();
}
var UP = 32, Oh = 7;
function yX(t) {
  for (var r = 0; t >= UP; )
    r |= t & 1, t >>= 1;
  return t + r;
}
function j8(t, r, e, n) {
  var i = r + 1;
  if (i === e)
    return 1;
  if (n(t[i++], t[r]) < 0) {
    for (; i < e && n(t[i], t[i - 1]) < 0; )
      i++;
    bX(t, r, i);
  } else
    for (; i < e && n(t[i], t[i - 1]) >= 0; )
      i++;
  return i - r;
}
function bX(t, r, e) {
  for (e--; r < e; ) {
    var n = t[r];
    t[r++] = t[e], t[e--] = n;
  }
}
function Y8(t, r, e, n, i) {
  for (n === r && n++; n < e; n++) {
    for (var a = t[n], o = r, s = n, l; o < s; )
      l = o + s >>> 1, i(a, t[l]) < 0 ? s = l : o = l + 1;
    var u = n - o;
    switch (u) {
      case 3:
        t[o + 3] = t[o + 2];
      case 2:
        t[o + 2] = t[o + 1];
      case 1:
        t[o + 1] = t[o];
        break;
      default:
        for (; u > 0; )
          t[o + u] = t[o + u - 1], u--;
    }
    t[o] = a;
  }
}
function T5(t, r, e, n, i, a) {
  var o = 0, s = 0, l = 1;
  if (a(t, r[e + i]) > 0) {
    for (s = n - i; l < s && a(t, r[e + i + l]) > 0; )
      o = l, l = (l << 1) + 1, l <= 0 && (l = s);
    l > s && (l = s), o += i, l += i;
  } else {
    for (s = i + 1; l < s && a(t, r[e + i - l]) <= 0; )
      o = l, l = (l << 1) + 1, l <= 0 && (l = s);
    l > s && (l = s);
    var u = o;
    o = i - l, l = i - u;
  }
  for (o++; o < l; ) {
    var c = o + (l - o >>> 1);
    a(t, r[e + c]) > 0 ? o = c + 1 : l = c;
  }
  return l;
}
function M5(t, r, e, n, i, a) {
  var o = 0, s = 0, l = 1;
  if (a(t, r[e + i]) < 0) {
    for (s = i + 1; l < s && a(t, r[e + i - l]) < 0; )
      o = l, l = (l << 1) + 1, l <= 0 && (l = s);
    l > s && (l = s);
    var u = o;
    o = i - l, l = i - u;
  } else {
    for (s = n - i; l < s && a(t, r[e + i + l]) >= 0; )
      o = l, l = (l << 1) + 1, l <= 0 && (l = s);
    l > s && (l = s), o += i, l += i;
  }
  for (o++; o < l; ) {
    var c = o + (l - o >>> 1);
    a(t, r[e + c]) < 0 ? l = c : o = c + 1;
  }
  return l;
}
function CX(t, r) {
  var e = Oh, n, i, a = 0, o = [];
  n = [], i = [];
  function s(h, p) {
    n[a] = h, i[a] = p, a += 1;
  }
  function l() {
    for (; a > 1; ) {
      var h = a - 2;
      if (h >= 1 && i[h - 1] <= i[h] + i[h + 1] || h >= 2 && i[h - 2] <= i[h] + i[h - 1])
        i[h - 1] < i[h + 1] && h--;
      else if (i[h] > i[h + 1])
        break;
      c(h);
    }
  }
  function u() {
    for (; a > 1; ) {
      var h = a - 2;
      h > 0 && i[h - 1] < i[h + 1] && h--, c(h);
    }
  }
  function c(h) {
    var p = n[h], v = i[h], g = n[h + 1], m = i[h + 1];
    i[h] = v + m, h === a - 3 && (n[h + 1] = n[h + 2], i[h + 1] = i[h + 2]), a--;
    var y = M5(t[g], t, p, v, 0, r);
    p += y, v -= y, v !== 0 && (m = T5(t[p + v - 1], t, g, m, m - 1, r), m !== 0 && (v <= m ? d(p, v, g, m) : f(p, v, g, m)));
  }
  function d(h, p, v, g) {
    var m = 0;
    for (m = 0; m < p; m++)
      o[m] = t[h + m];
    var y = 0, b = v, C = h;
    if (t[C++] = t[b++], --g === 0) {
      for (m = 0; m < p; m++)
        t[C + m] = o[y + m];
      return;
    }
    if (p === 1) {
      for (m = 0; m < g; m++)
        t[C + m] = t[b + m];
      t[C + g] = o[y];
      return;
    }
    for (var w = e, _, x, I; ; ) {
      _ = 0, x = 0, I = !1;
      do
        if (r(t[b], o[y]) < 0) {
          if (t[C++] = t[b++], x++, _ = 0, --g === 0) {
            I = !0;
            break;
          }
        } else if (t[C++] = o[y++], _++, x = 0, --p === 1) {
          I = !0;
          break;
        }
      while ((_ | x) < w);
      if (I)
        break;
      do {
        if (_ = M5(t[b], o, y, p, 0, r), _ !== 0) {
          for (m = 0; m < _; m++)
            t[C + m] = o[y + m];
          if (C += _, y += _, p -= _, p <= 1) {
            I = !0;
            break;
          }
        }
        if (t[C++] = t[b++], --g === 0) {
          I = !0;
          break;
        }
        if (x = T5(o[y], t, b, g, 0, r), x !== 0) {
          for (m = 0; m < x; m++)
            t[C + m] = t[b + m];
          if (C += x, b += x, g -= x, g === 0) {
            I = !0;
            break;
          }
        }
        if (t[C++] = o[y++], --p === 1) {
          I = !0;
          break;
        }
        w--;
      } while (_ >= Oh || x >= Oh);
      if (I)
        break;
      w < 0 && (w = 0), w += 2;
    }
    if (e = w, e < 1 && (e = 1), p === 1) {
      for (m = 0; m < g; m++)
        t[C + m] = t[b + m];
      t[C + g] = o[y];
    } else {
      if (p === 0)
        throw new Error();
      for (m = 0; m < p; m++)
        t[C + m] = o[y + m];
    }
  }
  function f(h, p, v, g) {
    var m = 0;
    for (m = 0; m < g; m++)
      o[m] = t[v + m];
    var y = h + p - 1, b = g - 1, C = v + g - 1, w = 0, _ = 0;
    if (t[C--] = t[y--], --p === 0) {
      for (w = C - (g - 1), m = 0; m < g; m++)
        t[w + m] = o[m];
      return;
    }
    if (g === 1) {
      for (C -= p, y -= p, _ = C + 1, w = y + 1, m = p - 1; m >= 0; m--)
        t[_ + m] = t[w + m];
      t[C] = o[b];
      return;
    }
    for (var x = e; ; ) {
      var I = 0, D = 0, T = !1;
      do
        if (r(o[b], t[y]) < 0) {
          if (t[C--] = t[y--], I++, D = 0, --p === 0) {
            T = !0;
            break;
          }
        } else if (t[C--] = o[b--], D++, I = 0, --g === 1) {
          T = !0;
          break;
        }
      while ((I | D) < x);
      if (T)
        break;
      do {
        if (I = p - M5(o[b], t, h, p, p - 1, r), I !== 0) {
          for (C -= I, y -= I, p -= I, _ = C + 1, w = y + 1, m = I - 1; m >= 0; m--)
            t[_ + m] = t[w + m];
          if (p === 0) {
            T = !0;
            break;
          }
        }
        if (t[C--] = o[b--], --g === 1) {
          T = !0;
          break;
        }
        if (D = g - T5(t[y], o, 0, g, g - 1, r), D !== 0) {
          for (C -= D, b -= D, g -= D, _ = C + 1, w = b + 1, m = 0; m < D; m++)
            t[_ + m] = o[w + m];
          if (g <= 1) {
            T = !0;
            break;
          }
        }
        if (t[C--] = t[y--], --p === 0) {
          T = !0;
          break;
        }
        x--;
      } while (I >= Oh || D >= Oh);
      if (T)
        break;
      x < 0 && (x = 0), x += 2;
    }
    if (e = x, e < 1 && (e = 1), g === 1) {
      for (C -= p, y -= p, _ = C + 1, w = y + 1, m = p - 1; m >= 0; m--)
        t[_ + m] = t[w + m];
      t[C] = o[b];
    } else {
      if (g === 0)
        throw new Error();
      for (w = C - (g - 1), m = 0; m < g; m++)
        t[w + m] = o[m];
    }
  }
  return {
    mergeRuns: l,
    forceMergeRuns: u,
    pushRun: s
  };
}
function x0(t, r, e, n) {
  e || (e = 0), n || (n = t.length);
  var i = n - e;
  if (!(i < 2)) {
    var a = 0;
    if (i < UP) {
      a = j8(t, e, n, r), Y8(t, e, n, e + a, r);
      return;
    }
    var o = CX(t, r), s = yX(i);
    do {
      if (a = j8(t, e, n, r), a < s) {
        var l = i;
        l > s && (l = s), Y8(t, e, e + l, e + a, r), a = l;
      }
      o.pushRun(e, a), o.mergeRuns(), i -= a, e += a;
    } while (i !== 0);
    o.forceMergeRuns();
  }
}
var ji = 1, Sp = 2, zd = 4, X8 = !1;
function R5() {
  X8 || (X8 = !0, console.warn("z / z2 / zlevel of displayable is invalid, which may cause unexpected errors"));
}
function $8(t, r) {
  return t.zlevel === r.zlevel ? t.z === r.z ? t.z2 - r.z2 : t.z - r.z : t.zlevel - r.zlevel;
}
var wX = function() {
  function t() {
    this._roots = [], this._displayList = [], this._displayListLen = 0, this.displayableSortFunc = $8;
  }
  return t.prototype.traverse = function(r, e) {
    for (var n = 0; n < this._roots.length; n++)
      this._roots[n].traverse(r, e);
  }, t.prototype.getDisplayList = function(r, e) {
    e = e || !1;
    var n = this._displayList;
    return (r || !n.length) && this.updateDisplayList(e), n;
  }, t.prototype.updateDisplayList = function(r) {
    this._displayListLen = 0;
    for (var e = this._roots, n = this._displayList, i = 0, a = e.length; i < a; i++)
      this._updateAndAddDisplayable(e[i], null, r);
    n.length = this._displayListLen, x0(n, $8);
  }, t.prototype._updateAndAddDisplayable = function(r, e, n) {
    if (!(r.ignore && !n)) {
      r.beforeUpdate(), r.update(), r.afterUpdate();
      var i = r.getClipPath();
      if (r.ignoreClip)
        e = null;
      else if (i) {
        e ? e = e.slice() : e = [];
        for (var a = i, o = r; a; )
          a.parent = o, a.updateTransform(), e.push(a), o = a, a = a.getClipPath();
      }
      if (r.childrenRef) {
        for (var s = r.childrenRef(), l = 0; l < s.length; l++) {
          var u = s[l];
          r.__dirty && (u.__dirty |= ji), this._updateAndAddDisplayable(u, e, n);
        }
        r.__dirty = 0;
      } else {
        var c = r;
        e && e.length ? c.__clipPaths = e : c.__clipPaths && c.__clipPaths.length > 0 && (c.__clipPaths = []), isNaN(c.z) && (R5(), c.z = 0), isNaN(c.z2) && (R5(), c.z2 = 0), isNaN(c.zlevel) && (R5(), c.zlevel = 0), this._displayList[this._displayListLen++] = c;
      }
      var d = r.getDecalElement && r.getDecalElement();
      d && this._updateAndAddDisplayable(d, e, n);
      var f = r.getTextGuideLine();
      f && this._updateAndAddDisplayable(f, e, n);
      var h = r.getTextContent();
      h && this._updateAndAddDisplayable(h, e, n);
    }
  }, t.prototype.addRoot = function(r) {
    r.__zr && r.__zr.storage === this || this._roots.push(r);
  }, t.prototype.delRoot = function(r) {
    if (r instanceof Array) {
      for (var e = 0, n = r.length; e < n; e++)
        this.delRoot(r[e]);
      return;
    }
    var i = nt(this._roots, r);
    i >= 0 && this._roots.splice(i, 1);
  }, t.prototype.delAllRoots = function() {
    this._roots = [], this._displayList = [], this._displayListLen = 0;
  }, t.prototype.getRoots = function() {
    return this._roots;
  }, t.prototype.dispose = function() {
    this._displayList = null, this._roots = null;
  }, t;
}(), um;
um = vt.hasGlobalWindow && (window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.msRequestAnimationFrame && window.msRequestAnimationFrame.bind(window) || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame) || function(t) {
  return setTimeout(t, 16);
};
var jp = {
  linear: function(t) {
    return t;
  },
  quadraticIn: function(t) {
    return t * t;
  },
  quadraticOut: function(t) {
    return t * (2 - t);
  },
  quadraticInOut: function(t) {
    return (t *= 2) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1);
  },
  cubicIn: function(t) {
    return t * t * t;
  },
  cubicOut: function(t) {
    return --t * t * t + 1;
  },
  cubicInOut: function(t) {
    return (t *= 2) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2);
  },
  quarticIn: function(t) {
    return t * t * t * t;
  },
  quarticOut: function(t) {
    return 1 - --t * t * t * t;
  },
  quarticInOut: function(t) {
    return (t *= 2) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2);
  },
  quinticIn: function(t) {
    return t * t * t * t * t;
  },
  quinticOut: function(t) {
    return --t * t * t * t * t + 1;
  },
  quinticInOut: function(t) {
    return (t *= 2) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2);
  },
  sinusoidalIn: function(t) {
    return 1 - Math.cos(t * Math.PI / 2);
  },
  sinusoidalOut: function(t) {
    return Math.sin(t * Math.PI / 2);
  },
  sinusoidalInOut: function(t) {
    return 0.5 * (1 - Math.cos(Math.PI * t));
  },
  exponentialIn: function(t) {
    return t === 0 ? 0 : Math.pow(1024, t - 1);
  },
  exponentialOut: function(t) {
    return t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
  },
  exponentialInOut: function(t) {
    return t === 0 ? 0 : t === 1 ? 1 : (t *= 2) < 1 ? 0.5 * Math.pow(1024, t - 1) : 0.5 * (-Math.pow(2, -10 * (t - 1)) + 2);
  },
  circularIn: function(t) {
    return 1 - Math.sqrt(1 - t * t);
  },
  circularOut: function(t) {
    return Math.sqrt(1 - --t * t);
  },
  circularInOut: function(t) {
    return (t *= 2) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
  },
  elasticIn: function(t) {
    var r, e = 0.1, n = 0.4;
    return t === 0 ? 0 : t === 1 ? 1 : (!e || e < 1 ? (e = 1, r = n / 4) : r = n * Math.asin(1 / e) / (2 * Math.PI), -(e * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - r) * (2 * Math.PI) / n)));
  },
  elasticOut: function(t) {
    var r, e = 0.1, n = 0.4;
    return t === 0 ? 0 : t === 1 ? 1 : (!e || e < 1 ? (e = 1, r = n / 4) : r = n * Math.asin(1 / e) / (2 * Math.PI), e * Math.pow(2, -10 * t) * Math.sin((t - r) * (2 * Math.PI) / n) + 1);
  },
  elasticInOut: function(t) {
    var r, e = 0.1, n = 0.4;
    return t === 0 ? 0 : t === 1 ? 1 : (!e || e < 1 ? (e = 1, r = n / 4) : r = n * Math.asin(1 / e) / (2 * Math.PI), (t *= 2) < 1 ? -0.5 * (e * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - r) * (2 * Math.PI) / n)) : e * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - r) * (2 * Math.PI) / n) * 0.5 + 1);
  },
  backIn: function(t) {
    var r = 1.70158;
    return t * t * ((r + 1) * t - r);
  },
  backOut: function(t) {
    var r = 1.70158;
    return --t * t * ((r + 1) * t + r) + 1;
  },
  backInOut: function(t) {
    var r = 2.5949095;
    return (t *= 2) < 1 ? 0.5 * (t * t * ((r + 1) * t - r)) : 0.5 * ((t -= 2) * t * ((r + 1) * t + r) + 2);
  },
  bounceIn: function(t) {
    return 1 - jp.bounceOut(1 - t);
  },
  bounceOut: function(t) {
    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + 0.75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + 0.9375 : 7.5625 * (t -= 2.625 / 2.75) * t + 0.984375;
  },
  bounceInOut: function(t) {
    return t < 0.5 ? jp.bounceIn(t * 2) * 0.5 : jp.bounceOut(t * 2 - 1) * 0.5 + 0.5;
  }
}, e1 = Math.pow, Bl = Math.sqrt, cm = 1e-8, JP = 1e-4, U8 = Bl(3), t1 = 1 / 3, Ro = fu(), wa = fu(), df = fu();
function Al(t) {
  return t > -cm && t < cm;
}
function KP(t) {
  return t > cm || t < -cm;
}
function bn(t, r, e, n, i) {
  var a = 1 - i;
  return a * a * (a * t + 3 * i * r) + i * i * (i * n + 3 * a * e);
}
function J8(t, r, e, n, i) {
  var a = 1 - i;
  return 3 * (((r - t) * a + 2 * (e - r) * i) * a + (n - e) * i * i);
}
function dm(t, r, e, n, i, a) {
  var o = n + 3 * (r - e) - t, s = 3 * (e - r * 2 + t), l = 3 * (r - t), u = t - i, c = s * s - 3 * o * l, d = s * l - 9 * o * u, f = l * l - 3 * s * u, h = 0;
  if (Al(c) && Al(d))
    if (Al(s))
      a[0] = 0;
    else {
      var p = -l / s;
      p >= 0 && p <= 1 && (a[h++] = p);
    }
  else {
    var v = d * d - 4 * c * f;
    if (Al(v)) {
      var g = d / c, p = -s / o + g, m = -g / 2;
      p >= 0 && p <= 1 && (a[h++] = p), m >= 0 && m <= 1 && (a[h++] = m);
    } else if (v > 0) {
      var y = Bl(v), b = c * s + 1.5 * o * (-d + y), C = c * s + 1.5 * o * (-d - y);
      b < 0 ? b = -e1(-b, t1) : b = e1(b, t1), C < 0 ? C = -e1(-C, t1) : C = e1(C, t1);
      var p = (-s - (b + C)) / (3 * o);
      p >= 0 && p <= 1 && (a[h++] = p);
    } else {
      var w = (2 * c * s - 3 * o * d) / (2 * Bl(c * c * c)), _ = Math.acos(w) / 3, x = Bl(c), I = Math.cos(_), p = (-s - 2 * x * I) / (3 * o), m = (-s + x * (I + U8 * Math.sin(_))) / (3 * o), D = (-s + x * (I - U8 * Math.sin(_))) / (3 * o);
      p >= 0 && p <= 1 && (a[h++] = p), m >= 0 && m <= 1 && (a[h++] = m), D >= 0 && D <= 1 && (a[h++] = D);
    }
  }
  return h;
}
function qP(t, r, e, n, i) {
  var a = 6 * e - 12 * r + 6 * t, o = 9 * r + 3 * n - 3 * t - 9 * e, s = 3 * r - 3 * t, l = 0;
  if (Al(o)) {
    if (KP(a)) {
      var u = -s / a;
      u >= 0 && u <= 1 && (i[l++] = u);
    }
  } else {
    var c = a * a - 4 * o * s;
    if (Al(c))
      i[0] = -a / (2 * o);
    else if (c > 0) {
      var d = Bl(c), u = (-a + d) / (2 * o), f = (-a - d) / (2 * o);
      u >= 0 && u <= 1 && (i[l++] = u), f >= 0 && f <= 1 && (i[l++] = f);
    }
  }
  return l;
}
function Ql(t, r, e, n, i, a) {
  var o = (r - t) * i + t, s = (e - r) * i + r, l = (n - e) * i + e, u = (s - o) * i + o, c = (l - s) * i + s, d = (c - u) * i + u;
  a[0] = t, a[1] = o, a[2] = u, a[3] = d, a[4] = d, a[5] = c, a[6] = l, a[7] = n;
}
function QP(t, r, e, n, i, a, o, s, l, u, c) {
  var d, f = 5e-3, h = 1 / 0, p, v, g, m;
  Ro[0] = l, Ro[1] = u;
  for (var y = 0; y < 1; y += 0.05)
    wa[0] = bn(t, e, i, o, y), wa[1] = bn(r, n, a, s, y), g = Gl(Ro, wa), g < h && (d = y, h = g);
  h = 1 / 0;
  for (var b = 0; b < 32 && !(f < JP); b++)
    p = d - f, v = d + f, wa[0] = bn(t, e, i, o, p), wa[1] = bn(r, n, a, s, p), g = Gl(wa, Ro), p >= 0 && g < h ? (d = p, h = g) : (df[0] = bn(t, e, i, o, v), df[1] = bn(r, n, a, s, v), m = Gl(df, Ro), v <= 1 && m < h ? (d = v, h = m) : f *= 0.5);
  return c && (c[0] = bn(t, e, i, o, d), c[1] = bn(r, n, a, s, d)), Bl(h);
}
function _X(t, r, e, n, i, a, o, s, l) {
  for (var u = t, c = r, d = 0, f = 1 / l, h = 1; h <= l; h++) {
    var p = h * f, v = bn(t, e, i, o, p), g = bn(r, n, a, s, p), m = v - u, y = g - c;
    d += Math.sqrt(m * m + y * y), u = v, c = g;
  }
  return d;
}
function Rn(t, r, e, n) {
  var i = 1 - n;
  return i * (i * t + 2 * n * r) + n * n * e;
}
function xC(t, r, e, n) {
  return 2 * ((1 - n) * (r - t) + n * (e - r));
}
function xX(t, r, e, n, i) {
  var a = t - 2 * r + e, o = 2 * (r - t), s = t - n, l = 0;
  if (Al(a)) {
    if (KP(o)) {
      var u = -s / o;
      u >= 0 && u <= 1 && (i[l++] = u);
    }
  } else {
    var c = o * o - 4 * a * s;
    if (Al(c)) {
      var u = -o / (2 * a);
      u >= 0 && u <= 1 && (i[l++] = u);
    } else if (c > 0) {
      var d = Bl(c), u = (-o + d) / (2 * a), f = (-o - d) / (2 * a);
      u >= 0 && u <= 1 && (i[l++] = u), f >= 0 && f <= 1 && (i[l++] = f);
    }
  }
  return l;
}
function eN(t, r, e) {
  var n = t + e - 2 * r;
  return n === 0 ? 0.5 : (t - r) / n;
}
function vv(t, r, e, n, i) {
  var a = (r - t) * n + t, o = (e - r) * n + r, s = (o - a) * n + a;
  i[0] = t, i[1] = a, i[2] = s, i[3] = s, i[4] = o, i[5] = e;
}
function tN(t, r, e, n, i, a, o, s, l) {
  var u, c = 5e-3, d = 1 / 0;
  Ro[0] = o, Ro[1] = s;
  for (var f = 0; f < 1; f += 0.05) {
    wa[0] = Rn(t, e, i, f), wa[1] = Rn(r, n, a, f);
    var h = Gl(Ro, wa);
    h < d && (u = f, d = h);
  }
  d = 1 / 0;
  for (var p = 0; p < 32 && !(c < JP); p++) {
    var v = u - c, g = u + c;
    wa[0] = Rn(t, e, i, v), wa[1] = Rn(r, n, a, v);
    var h = Gl(wa, Ro);
    if (v >= 0 && h < d)
      u = v, d = h;
    else {
      df[0] = Rn(t, e, i, g), df[1] = Rn(r, n, a, g);
      var m = Gl(df, Ro);
      g <= 1 && m < d ? (u = g, d = m) : c *= 0.5;
    }
  }
  return l && (l[0] = Rn(t, e, i, u), l[1] = Rn(r, n, a, u)), Bl(d);
}
function SX(t, r, e, n, i, a, o) {
  for (var s = t, l = r, u = 0, c = 1 / o, d = 1; d <= o; d++) {
    var f = d * c, h = Rn(t, e, i, f), p = Rn(r, n, a, f), v = h - s, g = p - l;
    u += Math.sqrt(v * v + g * g), s = h, l = p;
  }
  return u;
}
var IX = /cubic-bezier\(([0-9,\.e ]+)\)/;
function A7(t) {
  var r = t && IX.exec(t);
  if (r) {
    var e = r[1].split(","), n = +Aa(e[0]), i = +Aa(e[1]), a = +Aa(e[2]), o = +Aa(e[3]);
    if (isNaN(n + i + a + o))
      return;
    var s = [];
    return function(l) {
      return l <= 0 ? 0 : l >= 1 ? 1 : dm(0, n, a, 1, l, s) && bn(0, i, o, 1, s[0]);
    };
  }
}
var AX = function() {
  function t(r) {
    this._inited = !1, this._startTime = 0, this._pausedTime = 0, this._paused = !1, this._life = r.life || 1e3, this._delay = r.delay || 0, this.loop = r.loop || !1, this.onframe = r.onframe || Yr, this.ondestroy = r.ondestroy || Yr, this.onrestart = r.onrestart || Yr, r.easing && this.setEasing(r.easing);
  }
  return t.prototype.step = function(r, e) {
    if (this._inited || (this._startTime = r + this._delay, this._inited = !0), this._paused) {
      this._pausedTime += e;
      return;
    }
    var n = this._life, i = r - this._startTime - this._pausedTime, a = i / n;
    a < 0 && (a = 0), a = Math.min(a, 1);
    var o = this.easingFunc, s = o ? o(a) : a;
    if (this.onframe(s), a === 1)
      if (this.loop) {
        var l = i % n;
        this._startTime = r - l, this._pausedTime = 0, this.onrestart();
      } else
        return !0;
    return !1;
  }, t.prototype.pause = function() {
    this._paused = !0;
  }, t.prototype.resume = function() {
    this._paused = !1;
  }, t.prototype.setEasing = function(r) {
    this.easing = r, this.easingFunc = Ae(r) ? r : jp[r] || A7(r);
  }, t;
}(), rN = /* @__PURE__ */ function() {
  function t(r) {
    this.value = r;
  }
  return t;
}(), DX = function() {
  function t() {
    this._len = 0;
  }
  return t.prototype.insert = function(r) {
    var e = new rN(r);
    return this.insertEntry(e), e;
  }, t.prototype.insertEntry = function(r) {
    this.head ? (this.tail.next = r, r.prev = this.tail, r.next = null, this.tail = r) : this.head = this.tail = r, this._len++;
  }, t.prototype.remove = function(r) {
    var e = r.prev, n = r.next;
    e ? e.next = n : this.head = n, n ? n.prev = e : this.tail = e, r.next = r.prev = null, this._len--;
  }, t.prototype.len = function() {
    return this._len;
  }, t.prototype.clear = function() {
    this.head = this.tail = null, this._len = 0;
  }, t;
}(), ug = function() {
  function t(r) {
    this._list = new DX(), this._maxSize = 10, this._map = {}, this._maxSize = r;
  }
  return t.prototype.put = function(r, e) {
    var n = this._list, i = this._map, a = null;
    if (i[r] == null) {
      var o = n.len(), s = this._lastRemovedEntry;
      if (o >= this._maxSize && o > 0) {
        var l = n.head;
        n.remove(l), delete i[l.key], a = l.value, this._lastRemovedEntry = l;
      }
      s ? s.value = e : s = new rN(e), s.key = r, n.insertEntry(s), i[r] = s;
    }
    return a;
  }, t.prototype.get = function(r) {
    var e = this._map[r], n = this._list;
    if (e != null)
      return e !== n.tail && (n.remove(e), n.insertEntry(e)), e.value;
  }, t.prototype.clear = function() {
    this._list.clear(), this._map = {};
  }, t.prototype.len = function() {
    return this._list.len();
  }, t;
}(), K8 = {
  transparent: [0, 0, 0, 0],
  aliceblue: [240, 248, 255, 1],
  antiquewhite: [250, 235, 215, 1],
  aqua: [0, 255, 255, 1],
  aquamarine: [127, 255, 212, 1],
  azure: [240, 255, 255, 1],
  beige: [245, 245, 220, 1],
  bisque: [255, 228, 196, 1],
  black: [0, 0, 0, 1],
  blanchedalmond: [255, 235, 205, 1],
  blue: [0, 0, 255, 1],
  blueviolet: [138, 43, 226, 1],
  brown: [165, 42, 42, 1],
  burlywood: [222, 184, 135, 1],
  cadetblue: [95, 158, 160, 1],
  chartreuse: [127, 255, 0, 1],
  chocolate: [210, 105, 30, 1],
  coral: [255, 127, 80, 1],
  cornflowerblue: [100, 149, 237, 1],
  cornsilk: [255, 248, 220, 1],
  crimson: [220, 20, 60, 1],
  cyan: [0, 255, 255, 1],
  darkblue: [0, 0, 139, 1],
  darkcyan: [0, 139, 139, 1],
  darkgoldenrod: [184, 134, 11, 1],
  darkgray: [169, 169, 169, 1],
  darkgreen: [0, 100, 0, 1],
  darkgrey: [169, 169, 169, 1],
  darkkhaki: [189, 183, 107, 1],
  darkmagenta: [139, 0, 139, 1],
  darkolivegreen: [85, 107, 47, 1],
  darkorange: [255, 140, 0, 1],
  darkorchid: [153, 50, 204, 1],
  darkred: [139, 0, 0, 1],
  darksalmon: [233, 150, 122, 1],
  darkseagreen: [143, 188, 143, 1],
  darkslateblue: [72, 61, 139, 1],
  darkslategray: [47, 79, 79, 1],
  darkslategrey: [47, 79, 79, 1],
  darkturquoise: [0, 206, 209, 1],
  darkviolet: [148, 0, 211, 1],
  deeppink: [255, 20, 147, 1],
  deepskyblue: [0, 191, 255, 1],
  dimgray: [105, 105, 105, 1],
  dimgrey: [105, 105, 105, 1],
  dodgerblue: [30, 144, 255, 1],
  firebrick: [178, 34, 34, 1],
  floralwhite: [255, 250, 240, 1],
  forestgreen: [34, 139, 34, 1],
  fuchsia: [255, 0, 255, 1],
  gainsboro: [220, 220, 220, 1],
  ghostwhite: [248, 248, 255, 1],
  gold: [255, 215, 0, 1],
  goldenrod: [218, 165, 32, 1],
  gray: [128, 128, 128, 1],
  green: [0, 128, 0, 1],
  greenyellow: [173, 255, 47, 1],
  grey: [128, 128, 128, 1],
  honeydew: [240, 255, 240, 1],
  hotpink: [255, 105, 180, 1],
  indianred: [205, 92, 92, 1],
  indigo: [75, 0, 130, 1],
  ivory: [255, 255, 240, 1],
  khaki: [240, 230, 140, 1],
  lavender: [230, 230, 250, 1],
  lavenderblush: [255, 240, 245, 1],
  lawngreen: [124, 252, 0, 1],
  lemonchiffon: [255, 250, 205, 1],
  lightblue: [173, 216, 230, 1],
  lightcoral: [240, 128, 128, 1],
  lightcyan: [224, 255, 255, 1],
  lightgoldenrodyellow: [250, 250, 210, 1],
  lightgray: [211, 211, 211, 1],
  lightgreen: [144, 238, 144, 1],
  lightgrey: [211, 211, 211, 1],
  lightpink: [255, 182, 193, 1],
  lightsalmon: [255, 160, 122, 1],
  lightseagreen: [32, 178, 170, 1],
  lightskyblue: [135, 206, 250, 1],
  lightslategray: [119, 136, 153, 1],
  lightslategrey: [119, 136, 153, 1],
  lightsteelblue: [176, 196, 222, 1],
  lightyellow: [255, 255, 224, 1],
  lime: [0, 255, 0, 1],
  limegreen: [50, 205, 50, 1],
  linen: [250, 240, 230, 1],
  magenta: [255, 0, 255, 1],
  maroon: [128, 0, 0, 1],
  mediumaquamarine: [102, 205, 170, 1],
  mediumblue: [0, 0, 205, 1],
  mediumorchid: [186, 85, 211, 1],
  mediumpurple: [147, 112, 219, 1],
  mediumseagreen: [60, 179, 113, 1],
  mediumslateblue: [123, 104, 238, 1],
  mediumspringgreen: [0, 250, 154, 1],
  mediumturquoise: [72, 209, 204, 1],
  mediumvioletred: [199, 21, 133, 1],
  midnightblue: [25, 25, 112, 1],
  mintcream: [245, 255, 250, 1],
  mistyrose: [255, 228, 225, 1],
  moccasin: [255, 228, 181, 1],
  navajowhite: [255, 222, 173, 1],
  navy: [0, 0, 128, 1],
  oldlace: [253, 245, 230, 1],
  olive: [128, 128, 0, 1],
  olivedrab: [107, 142, 35, 1],
  orange: [255, 165, 0, 1],
  orangered: [255, 69, 0, 1],
  orchid: [218, 112, 214, 1],
  palegoldenrod: [238, 232, 170, 1],
  palegreen: [152, 251, 152, 1],
  paleturquoise: [175, 238, 238, 1],
  palevioletred: [219, 112, 147, 1],
  papayawhip: [255, 239, 213, 1],
  peachpuff: [255, 218, 185, 1],
  peru: [205, 133, 63, 1],
  pink: [255, 192, 203, 1],
  plum: [221, 160, 221, 1],
  powderblue: [176, 224, 230, 1],
  purple: [128, 0, 128, 1],
  red: [255, 0, 0, 1],
  rosybrown: [188, 143, 143, 1],
  royalblue: [65, 105, 225, 1],
  saddlebrown: [139, 69, 19, 1],
  salmon: [250, 128, 114, 1],
  sandybrown: [244, 164, 96, 1],
  seagreen: [46, 139, 87, 1],
  seashell: [255, 245, 238, 1],
  sienna: [160, 82, 45, 1],
  silver: [192, 192, 192, 1],
  skyblue: [135, 206, 235, 1],
  slateblue: [106, 90, 205, 1],
  slategray: [112, 128, 144, 1],
  slategrey: [112, 128, 144, 1],
  snow: [255, 250, 250, 1],
  springgreen: [0, 255, 127, 1],
  steelblue: [70, 130, 180, 1],
  tan: [210, 180, 140, 1],
  teal: [0, 128, 128, 1],
  thistle: [216, 191, 216, 1],
  tomato: [255, 99, 71, 1],
  turquoise: [64, 224, 208, 1],
  violet: [238, 130, 238, 1],
  wheat: [245, 222, 179, 1],
  white: [255, 255, 255, 1],
  whitesmoke: [245, 245, 245, 1],
  yellow: [255, 255, 0, 1],
  yellowgreen: [154, 205, 50, 1]
};
function Ua(t) {
  return t = Math.round(t), t < 0 ? 0 : t > 255 ? 255 : t;
}
function TX(t) {
  return t = Math.round(t), t < 0 ? 0 : t > 360 ? 360 : t;
}
function gv(t) {
  return t < 0 ? 0 : t > 1 ? 1 : t;
}
function L5(t) {
  var r = t;
  return r.length && r.charAt(r.length - 1) === "%" ? Ua(parseFloat(r) / 100 * 255) : Ua(parseInt(r, 10));
}
function _c(t) {
  var r = t;
  return r.length && r.charAt(r.length - 1) === "%" ? gv(parseFloat(r) / 100) : gv(parseFloat(r));
}
function E5(t, r, e) {
  return e < 0 ? e += 1 : e > 1 && (e -= 1), e * 6 < 1 ? t + (r - t) * e * 6 : e * 2 < 1 ? r : e * 3 < 2 ? t + (r - t) * (2 / 3 - e) * 6 : t;
}
function Dl(t, r, e) {
  return t + (r - t) * e;
}
function pa(t, r, e, n, i) {
  return t[0] = r, t[1] = e, t[2] = n, t[3] = i, t;
}
function SC(t, r) {
  return t[0] = r[0], t[1] = r[1], t[2] = r[2], t[3] = r[3], t;
}
var nN = new ug(20), r1 = null;
function hd(t, r) {
  r1 && SC(r1, r), r1 = nN.put(t, r1 || r.slice());
}
function Ci(t, r) {
  if (t) {
    r = r || [];
    var e = nN.get(t);
    if (e)
      return SC(r, e);
    t = t + "";
    var n = t.replace(/ /g, "").toLowerCase();
    if (n in K8)
      return SC(r, K8[n]), hd(t, r), r;
    var i = n.length;
    if (n.charAt(0) === "#") {
      if (i === 4 || i === 5) {
        var a = parseInt(n.slice(1, 4), 16);
        if (!(a >= 0 && a <= 4095)) {
          pa(r, 0, 0, 0, 1);
          return;
        }
        return pa(r, (a & 3840) >> 4 | (a & 3840) >> 8, a & 240 | (a & 240) >> 4, a & 15 | (a & 15) << 4, i === 5 ? parseInt(n.slice(4), 16) / 15 : 1), hd(t, r), r;
      } else if (i === 7 || i === 9) {
        var a = parseInt(n.slice(1, 7), 16);
        if (!(a >= 0 && a <= 16777215)) {
          pa(r, 0, 0, 0, 1);
          return;
        }
        return pa(r, (a & 16711680) >> 16, (a & 65280) >> 8, a & 255, i === 9 ? parseInt(n.slice(7), 16) / 255 : 1), hd(t, r), r;
      }
      return;
    }
    var o = n.indexOf("("), s = n.indexOf(")");
    if (o !== -1 && s + 1 === i) {
      var l = n.substr(0, o), u = n.substr(o + 1, s - (o + 1)).split(","), c = 1;
      switch (l) {
        case "rgba":
          if (u.length !== 4)
            return u.length === 3 ? pa(r, +u[0], +u[1], +u[2], 1) : pa(r, 0, 0, 0, 1);
          c = _c(u.pop());
        case "rgb":
          if (u.length >= 3)
            return pa(r, L5(u[0]), L5(u[1]), L5(u[2]), u.length === 3 ? c : _c(u[3])), hd(t, r), r;
          pa(r, 0, 0, 0, 1);
          return;
        case "hsla":
          if (u.length !== 4) {
            pa(r, 0, 0, 0, 1);
            return;
          }
          return u[3] = _c(u[3]), IC(u, r), hd(t, r), r;
        case "hsl":
          if (u.length !== 3) {
            pa(r, 0, 0, 0, 1);
            return;
          }
          return IC(u, r), hd(t, r), r;
        default:
          return;
      }
    }
    pa(r, 0, 0, 0, 1);
  }
}
function IC(t, r) {
  var e = (parseFloat(t[0]) % 360 + 360) % 360 / 360, n = _c(t[1]), i = _c(t[2]), a = i <= 0.5 ? i * (n + 1) : i + n - i * n, o = i * 2 - a;
  return r = r || [], pa(r, Ua(E5(o, a, e + 1 / 3) * 255), Ua(E5(o, a, e) * 255), Ua(E5(o, a, e - 1 / 3) * 255), 1), t.length === 4 && (r[3] = t[3]), r;
}
function MX(t) {
  if (t) {
    var r = t[0] / 255, e = t[1] / 255, n = t[2] / 255, i = Math.min(r, e, n), a = Math.max(r, e, n), o = a - i, s = (a + i) / 2, l, u;
    if (o === 0)
      l = 0, u = 0;
    else {
      s < 0.5 ? u = o / (a + i) : u = o / (2 - a - i);
      var c = ((a - r) / 6 + o / 2) / o, d = ((a - e) / 6 + o / 2) / o, f = ((a - n) / 6 + o / 2) / o;
      r === a ? l = f - d : e === a ? l = 1 / 3 + c - f : n === a && (l = 2 / 3 + d - c), l < 0 && (l += 1), l > 1 && (l -= 1);
    }
    var h = [l * 360, u, s];
    return t[3] != null && h.push(t[3]), h;
  }
}
function fm(t, r) {
  var e = Ci(t);
  if (e) {
    for (var n = 0; n < 3; n++)
      r < 0 ? e[n] = e[n] * (1 - r) | 0 : e[n] = (255 - e[n]) * r + e[n] | 0, e[n] > 255 ? e[n] = 255 : e[n] < 0 && (e[n] = 0);
    return Ja(e, e.length === 4 ? "rgba" : "rgb");
  }
}
function RX(t) {
  var r = Ci(t);
  if (r)
    return ((1 << 24) + (r[0] << 16) + (r[1] << 8) + +r[2]).toString(16).slice(1);
}
function Yp(t, r, e) {
  if (!(!(r && r.length) || !(t >= 0 && t <= 1))) {
    e = e || [];
    var n = t * (r.length - 1), i = Math.floor(n), a = Math.ceil(n), o = r[i], s = r[a], l = n - i;
    return e[0] = Ua(Dl(o[0], s[0], l)), e[1] = Ua(Dl(o[1], s[1], l)), e[2] = Ua(Dl(o[2], s[2], l)), e[3] = gv(Dl(o[3], s[3], l)), e;
  }
}
var LX = Yp;
function D7(t, r, e) {
  if (!(!(r && r.length) || !(t >= 0 && t <= 1))) {
    var n = t * (r.length - 1), i = Math.floor(n), a = Math.ceil(n), o = Ci(r[i]), s = Ci(r[a]), l = n - i, u = Ja([
      Ua(Dl(o[0], s[0], l)),
      Ua(Dl(o[1], s[1], l)),
      Ua(Dl(o[2], s[2], l)),
      gv(Dl(o[3], s[3], l))
    ], "rgba");
    return e ? {
      color: u,
      leftIndex: i,
      rightIndex: a,
      value: n
    } : u;
  }
}
var EX = D7;
function ff(t, r, e, n) {
  var i = Ci(t);
  if (t)
    return i = MX(i), r != null && (i[0] = TX(r)), e != null && (i[1] = _c(e)), n != null && (i[2] = _c(n)), Ja(IC(i), "rgba");
}
function mv(t, r) {
  var e = Ci(t);
  if (e && r != null)
    return e[3] = gv(r), Ja(e, "rgba");
}
function Ja(t, r) {
  if (!(!t || !t.length)) {
    var e = t[0] + "," + t[1] + "," + t[2];
    return (r === "rgba" || r === "hsva" || r === "hsla") && (e += "," + t[3]), r + "(" + e + ")";
  }
}
function yv(t, r) {
  var e = Ci(t);
  return e ? (0.299 * e[0] + 0.587 * e[1] + 0.114 * e[2]) * e[3] / 255 + (1 - e[3]) * r : 0;
}
function kX() {
  return Ja([
    Math.round(Math.random() * 255),
    Math.round(Math.random() * 255),
    Math.round(Math.random() * 255)
  ], "rgb");
}
var q8 = new ug(100);
function hm(t) {
  if (pe(t)) {
    var r = q8.get(t);
    return r || (r = fm(t, -0.1), q8.put(t, r)), r;
  } else if (og(t)) {
    var e = ae({}, t);
    return e.colorStops = ce(t.colorStops, function(n) {
      return {
        offset: n.offset,
        color: fm(n.color, -0.1)
      };
    }), e;
  }
  return t;
}
const PX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fastLerp: Yp,
  fastMapToColor: LX,
  lerp: D7,
  lift: fm,
  liftColor: hm,
  lum: yv,
  mapToColor: EX,
  modifyAlpha: mv,
  modifyHSL: ff,
  parse: Ci,
  random: kX,
  stringify: Ja,
  toHex: RX
}, Symbol.toStringTag, { value: "Module" }));
var pm = Math.round;
function bv(t) {
  var r;
  if (!t || t === "transparent")
    t = "none";
  else if (typeof t == "string" && t.indexOf("rgba") > -1) {
    var e = Ci(t);
    e && (t = "rgb(" + e[0] + "," + e[1] + "," + e[2] + ")", r = e[3]);
  }
  return {
    color: t,
    opacity: r ?? 1
  };
}
var Q8 = 1e-4;
function Tl(t) {
  return t < Q8 && t > -Q8;
}
function n1(t) {
  return pm(t * 1e3) / 1e3;
}
function AC(t) {
  return pm(t * 1e4) / 1e4;
}
function NX(t) {
  return "matrix(" + n1(t[0]) + "," + n1(t[1]) + "," + n1(t[2]) + "," + n1(t[3]) + "," + AC(t[4]) + "," + AC(t[5]) + ")";
}
var OX = {
  left: "start",
  right: "end",
  center: "middle",
  middle: "middle"
};
function VX(t, r, e) {
  return e === "top" ? t += r / 2 : e === "bottom" && (t -= r / 2), t;
}
function GX(t) {
  return t && (t.shadowBlur || t.shadowOffsetX || t.shadowOffsetY);
}
function BX(t) {
  var r = t.style, e = t.getGlobalScale();
  return [
    r.shadowColor,
    (r.shadowBlur || 0).toFixed(2),
    (r.shadowOffsetX || 0).toFixed(2),
    (r.shadowOffsetY || 0).toFixed(2),
    e[0],
    e[1]
  ].join(",");
}
function iN(t) {
  return t && !!t.image;
}
function FX(t) {
  return t && !!t.svgElement;
}
function T7(t) {
  return iN(t) || FX(t);
}
function aN(t) {
  return t.type === "linear";
}
function oN(t) {
  return t.type === "radial";
}
function sN(t) {
  return t && (t.type === "linear" || t.type === "radial");
}
function Qy(t) {
  return "url(#" + t + ")";
}
function lN(t) {
  var r = t.getGlobalScale(), e = Math.max(r[0], r[1]);
  return Math.max(Math.ceil(Math.log(e) / Math.log(10)), 1);
}
function uN(t) {
  var r = t.x || 0, e = t.y || 0, n = (t.rotation || 0) * zp, i = je(t.scaleX, 1), a = je(t.scaleY, 1), o = t.skewX || 0, s = t.skewY || 0, l = [];
  return (r || e) && l.push("translate(" + r + "px," + e + "px)"), n && l.push("rotate(" + n + ")"), (i !== 1 || a !== 1) && l.push("scale(" + i + "," + a + ")"), (o || s) && l.push("skew(" + pm(o * zp) + "deg, " + pm(s * zp) + "deg)"), l.join(" ");
}
var HX = function() {
  return vt.hasGlobalWindow && Ae(window.btoa) ? function(t) {
    return window.btoa(unescape(encodeURIComponent(t)));
  } : typeof Buffer < "u" ? function(t) {
    return Buffer.from(t).toString("base64");
  } : function(t) {
    return process.env.NODE_ENV !== "production" && Da("Base64 isn't natively supported in the current environment."), null;
  };
}(), DC = Array.prototype.slice;
function ws(t, r, e) {
  return (r - t) * e + t;
}
function k5(t, r, e, n) {
  for (var i = r.length, a = 0; a < i; a++)
    t[a] = ws(r[a], e[a], n);
  return t;
}
function zX(t, r, e, n) {
  for (var i = r.length, a = i && r[0].length, o = 0; o < i; o++) {
    t[o] || (t[o] = []);
    for (var s = 0; s < a; s++)
      t[o][s] = ws(r[o][s], e[o][s], n);
  }
  return t;
}
function i1(t, r, e, n) {
  for (var i = r.length, a = 0; a < i; a++)
    t[a] = r[a] + e[a] * n;
  return t;
}
function eS(t, r, e, n) {
  for (var i = r.length, a = i && r[0].length, o = 0; o < i; o++) {
    t[o] || (t[o] = []);
    for (var s = 0; s < a; s++)
      t[o][s] = r[o][s] + e[o][s] * n;
  }
  return t;
}
function WX(t, r) {
  for (var e = t.length, n = r.length, i = e > n ? r : t, a = Math.min(e, n), o = i[a - 1] || { color: [0, 0, 0, 0], offset: 0 }, s = a; s < Math.max(e, n); s++)
    i.push({
      offset: o.offset,
      color: o.color.slice()
    });
}
function ZX(t, r, e) {
  var n = t, i = r;
  if (!(!n.push || !i.push)) {
    var a = n.length, o = i.length;
    if (a !== o) {
      var s = a > o;
      if (s)
        n.length = o;
      else
        for (var l = a; l < o; l++)
          n.push(e === 1 ? i[l] : DC.call(i[l]));
    }
    for (var u = n[0] && n[0].length, l = 0; l < n.length; l++)
      if (e === 1)
        isNaN(n[l]) && (n[l] = i[l]);
      else
        for (var c = 0; c < u; c++)
          isNaN(n[l][c]) && (n[l][c] = i[l][c]);
  }
}
function Xp(t) {
  if (Zn(t)) {
    var r = t.length;
    if (Zn(t[0])) {
      for (var e = [], n = 0; n < r; n++)
        e.push(DC.call(t[n]));
      return e;
    }
    return DC.call(t);
  }
  return t;
}
function S0(t) {
  return t[0] = Math.floor(t[0]) || 0, t[1] = Math.floor(t[1]) || 0, t[2] = Math.floor(t[2]) || 0, t[3] = t[3] == null ? 1 : t[3], "rgba(" + t.join(",") + ")";
}
function jX(t) {
  return Zn(t && t[0]) ? 2 : 1;
}
var a1 = 0, I0 = 1, cN = 2, Ip = 3, TC = 4, MC = 5, tS = 6;
function rS(t) {
  return t === TC || t === MC;
}
function o1(t) {
  return t === I0 || t === cN;
}
var Vh = [0, 0, 0, 0], YX = function() {
  function t(r) {
    this.keyframes = [], this.discrete = !1, this._invalid = !1, this._needsSort = !1, this._lastFr = 0, this._lastFrP = 0, this.propName = r;
  }
  return t.prototype.isFinished = function() {
    return this._finished;
  }, t.prototype.setFinished = function() {
    this._finished = !0, this._additiveTrack && this._additiveTrack.setFinished();
  }, t.prototype.needsAnimate = function() {
    return this.keyframes.length >= 1;
  }, t.prototype.getAdditiveTrack = function() {
    return this._additiveTrack;
  }, t.prototype.addKeyframe = function(r, e, n) {
    this._needsSort = !0;
    var i = this.keyframes, a = i.length, o = !1, s = tS, l = e;
    if (Zn(e)) {
      var u = jX(e);
      s = u, (u === 1 && !Mt(e[0]) || u === 2 && !Mt(e[0][0])) && (o = !0);
    } else if (Mt(e) && !ql(e))
      s = a1;
    else if (pe(e))
      if (!isNaN(+e))
        s = a1;
      else {
        var c = Ci(e);
        c && (l = c, s = Ip);
      }
    else if (og(e)) {
      var d = ae({}, l);
      d.colorStops = ce(e.colorStops, function(h) {
        return {
          offset: h.offset,
          color: Ci(h.color)
        };
      }), aN(e) ? s = TC : oN(e) && (s = MC), l = d;
    }
    a === 0 ? this.valType = s : (s !== this.valType || s === tS) && (o = !0), this.discrete = this.discrete || o;
    var f = {
      time: r,
      value: l,
      rawValue: e,
      percent: 0
    };
    return n && (f.easing = n, f.easingFunc = Ae(n) ? n : jp[n] || A7(n)), i.push(f), f;
  }, t.prototype.prepare = function(r, e) {
    var n = this.keyframes;
    this._needsSort && n.sort(function(v, g) {
      return v.time - g.time;
    });
    for (var i = this.valType, a = n.length, o = n[a - 1], s = this.discrete, l = o1(i), u = rS(i), c = 0; c < a; c++) {
      var d = n[c], f = d.value, h = o.value;
      d.percent = d.time / r, s || (l && c !== a - 1 ? ZX(f, h, i) : u && WX(f.colorStops, h.colorStops));
    }
    if (!s && i !== MC && e && this.needsAnimate() && e.needsAnimate() && i === e.valType && !e._finished) {
      this._additiveTrack = e;
      for (var p = n[0].value, c = 0; c < a; c++)
        i === a1 ? n[c].additiveValue = n[c].value - p : i === Ip ? n[c].additiveValue = i1([], n[c].value, p, -1) : o1(i) && (n[c].additiveValue = i === I0 ? i1([], n[c].value, p, -1) : eS([], n[c].value, p, -1));
    }
  }, t.prototype.step = function(r, e) {
    if (!this._finished) {
      this._additiveTrack && this._additiveTrack._finished && (this._additiveTrack = null);
      var n = this._additiveTrack != null, i = n ? "additiveValue" : "value", a = this.valType, o = this.keyframes, s = o.length, l = this.propName, u = a === Ip, c, d = this._lastFr, f = Math.min, h, p;
      if (s === 1)
        h = p = o[0];
      else {
        if (e < 0)
          c = 0;
        else if (e < this._lastFrP) {
          var v = f(d + 1, s - 1);
          for (c = v; c >= 0 && !(o[c].percent <= e); c--)
            ;
          c = f(c, s - 2);
        } else {
          for (c = d; c < s && !(o[c].percent > e); c++)
            ;
          c = f(c - 1, s - 2);
        }
        p = o[c + 1], h = o[c];
      }
      if (h && p) {
        this._lastFr = c, this._lastFrP = e;
        var g = p.percent - h.percent, m = g === 0 ? 1 : f((e - h.percent) / g, 1);
        p.easingFunc && (m = p.easingFunc(m));
        var y = n ? this._additiveValue : u ? Vh : r[l];
        if ((o1(a) || u) && !y && (y = this._additiveValue = []), this.discrete)
          r[l] = m < 1 ? h.rawValue : p.rawValue;
        else if (o1(a))
          a === I0 ? k5(y, h[i], p[i], m) : zX(y, h[i], p[i], m);
        else if (rS(a)) {
          var b = h[i], C = p[i], w = a === TC;
          r[l] = {
            type: w ? "linear" : "radial",
            x: ws(b.x, C.x, m),
            y: ws(b.y, C.y, m),
            colorStops: ce(b.colorStops, function(x, I) {
              var D = C.colorStops[I];
              return {
                offset: ws(x.offset, D.offset, m),
                color: S0(k5([], x.color, D.color, m))
              };
            }),
            global: C.global
          }, w ? (r[l].x2 = ws(b.x2, C.x2, m), r[l].y2 = ws(b.y2, C.y2, m)) : r[l].r = ws(b.r, C.r, m);
        } else if (u)
          k5(y, h[i], p[i], m), n || (r[l] = S0(y));
        else {
          var _ = ws(h[i], p[i], m);
          n ? this._additiveValue = _ : r[l] = _;
        }
        n && this._addToTarget(r);
      }
    }
  }, t.prototype._addToTarget = function(r) {
    var e = this.valType, n = this.propName, i = this._additiveValue;
    e === a1 ? r[n] = r[n] + i : e === Ip ? (Ci(r[n], Vh), i1(Vh, Vh, i, 1), r[n] = S0(Vh)) : e === I0 ? i1(r[n], r[n], i, 1) : e === cN && eS(r[n], r[n], i, 1);
  }, t;
}(), M7 = function() {
  function t(r, e, n, i) {
    if (this._tracks = {}, this._trackKeys = [], this._maxTime = 0, this._started = 0, this._clip = null, this._target = r, this._loop = e, e && i) {
      Da("Can' use additive animation on looped animation.");
      return;
    }
    this._additiveAnimators = i, this._allowDiscrete = n;
  }
  return t.prototype.getMaxTime = function() {
    return this._maxTime;
  }, t.prototype.getDelay = function() {
    return this._delay;
  }, t.prototype.getLoop = function() {
    return this._loop;
  }, t.prototype.getTarget = function() {
    return this._target;
  }, t.prototype.changeTarget = function(r) {
    this._target = r;
  }, t.prototype.when = function(r, e, n) {
    return this.whenWithKeys(r, e, yt(e), n);
  }, t.prototype.whenWithKeys = function(r, e, n, i) {
    for (var a = this._tracks, o = 0; o < n.length; o++) {
      var s = n[o], l = a[s];
      if (!l) {
        l = a[s] = new YX(s);
        var u = void 0, c = this._getAdditiveTrack(s);
        if (c) {
          var d = c.keyframes, f = d[d.length - 1];
          u = f && f.value, c.valType === Ip && u && (u = S0(u));
        } else
          u = this._target[s];
        if (u == null)
          continue;
        r > 0 && l.addKeyframe(0, Xp(u), i), this._trackKeys.push(s);
      }
      l.addKeyframe(r, Xp(e[s]), i);
    }
    return this._maxTime = Math.max(this._maxTime, r), this;
  }, t.prototype.pause = function() {
    this._clip.pause(), this._paused = !0;
  }, t.prototype.resume = function() {
    this._clip.resume(), this._paused = !1;
  }, t.prototype.isPaused = function() {
    return !!this._paused;
  }, t.prototype.duration = function(r) {
    return this._maxTime = r, this._force = !0, this;
  }, t.prototype._doneCallback = function() {
    this._setTracksFinished(), this._clip = null;
    var r = this._doneCbs;
    if (r)
      for (var e = r.length, n = 0; n < e; n++)
        r[n].call(this);
  }, t.prototype._abortedCallback = function() {
    this._setTracksFinished();
    var r = this.animation, e = this._abortedCbs;
    if (r && r.removeClip(this._clip), this._clip = null, e)
      for (var n = 0; n < e.length; n++)
        e[n].call(this);
  }, t.prototype._setTracksFinished = function() {
    for (var r = this._tracks, e = this._trackKeys, n = 0; n < e.length; n++)
      r[e[n]].setFinished();
  }, t.prototype._getAdditiveTrack = function(r) {
    var e, n = this._additiveAnimators;
    if (n)
      for (var i = 0; i < n.length; i++) {
        var a = n[i].getTrack(r);
        a && (e = a);
      }
    return e;
  }, t.prototype.start = function(r) {
    if (!(this._started > 0)) {
      this._started = 1;
      for (var e = this, n = [], i = this._maxTime || 0, a = 0; a < this._trackKeys.length; a++) {
        var o = this._trackKeys[a], s = this._tracks[o], l = this._getAdditiveTrack(o), u = s.keyframes, c = u.length;
        if (s.prepare(i, l), s.needsAnimate())
          if (!this._allowDiscrete && s.discrete) {
            var d = u[c - 1];
            d && (e._target[s.propName] = d.rawValue), s.setFinished();
          } else
            n.push(s);
      }
      if (n.length || this._force) {
        var f = new AX({
          life: i,
          loop: this._loop,
          delay: this._delay || 0,
          onframe: function(h) {
            e._started = 2;
            var p = e._additiveAnimators;
            if (p) {
              for (var v = !1, g = 0; g < p.length; g++)
                if (p[g]._clip) {
                  v = !0;
                  break;
                }
              v || (e._additiveAnimators = null);
            }
            for (var g = 0; g < n.length; g++)
              n[g].step(e._target, h);
            var m = e._onframeCbs;
            if (m)
              for (var g = 0; g < m.length; g++)
                m[g](e._target, h);
          },
          ondestroy: function() {
            e._doneCallback();
          }
        });
        this._clip = f, this.animation && this.animation.addClip(f), r && f.setEasing(r);
      } else
        this._doneCallback();
      return this;
    }
  }, t.prototype.stop = function(r) {
    if (this._clip) {
      var e = this._clip;
      r && e.onframe(1), this._abortedCallback();
    }
  }, t.prototype.delay = function(r) {
    return this._delay = r, this;
  }, t.prototype.during = function(r) {
    return r && (this._onframeCbs || (this._onframeCbs = []), this._onframeCbs.push(r)), this;
  }, t.prototype.done = function(r) {
    return r && (this._doneCbs || (this._doneCbs = []), this._doneCbs.push(r)), this;
  }, t.prototype.aborted = function(r) {
    return r && (this._abortedCbs || (this._abortedCbs = []), this._abortedCbs.push(r)), this;
  }, t.prototype.getClip = function() {
    return this._clip;
  }, t.prototype.getTrack = function(r) {
    return this._tracks[r];
  }, t.prototype.getTracks = function() {
    var r = this;
    return ce(this._trackKeys, function(e) {
      return r._tracks[e];
    });
  }, t.prototype.stopTracks = function(r, e) {
    if (!r.length || !this._clip)
      return !0;
    for (var n = this._tracks, i = this._trackKeys, a = 0; a < r.length; a++) {
      var o = n[r[a]];
      o && !o.isFinished() && (e ? o.step(this._target, 1) : this._started === 1 && o.step(this._target, 0), o.setFinished());
    }
    for (var s = !0, a = 0; a < i.length; a++)
      if (!n[i[a]].isFinished()) {
        s = !1;
        break;
      }
    return s && this._abortedCallback(), s;
  }, t.prototype.saveTo = function(r, e, n) {
    if (r) {
      e = e || this._trackKeys;
      for (var i = 0; i < e.length; i++) {
        var a = e[i], o = this._tracks[a];
        if (!(!o || o.isFinished())) {
          var s = o.keyframes, l = s[n ? 0 : s.length - 1];
          l && (r[a] = Xp(l.rawValue));
        }
      }
    }
  }, t.prototype.__changeFinalValue = function(r, e) {
    e = e || yt(r);
    for (var n = 0; n < e.length; n++) {
      var i = e[n], a = this._tracks[i];
      if (a) {
        var o = a.keyframes;
        if (o.length > 1) {
          var s = o.pop();
          a.addKeyframe(s.time, r[i]), a.prepare(this._maxTime, a.getAdditiveTrack());
        }
      }
    }
  }, t;
}();
function Ud() {
  return (/* @__PURE__ */ new Date()).getTime();
}
var XX = function(t) {
  _r(r, t);
  function r(e) {
    var n = t.call(this) || this;
    return n._running = !1, n._time = 0, n._pausedTime = 0, n._pauseStart = 0, n._paused = !1, e = e || {}, n.stage = e.stage || {}, n;
  }
  return r.prototype.addClip = function(e) {
    e.animation && this.removeClip(e), this._head ? (this._tail.next = e, e.prev = this._tail, e.next = null, this._tail = e) : this._head = this._tail = e, e.animation = this;
  }, r.prototype.addAnimator = function(e) {
    e.animation = this;
    var n = e.getClip();
    n && this.addClip(n);
  }, r.prototype.removeClip = function(e) {
    if (e.animation) {
      var n = e.prev, i = e.next;
      n ? n.next = i : this._head = i, i ? i.prev = n : this._tail = n, e.next = e.prev = e.animation = null;
    }
  }, r.prototype.removeAnimator = function(e) {
    var n = e.getClip();
    n && this.removeClip(n), e.animation = null;
  }, r.prototype.update = function(e) {
    for (var n = Ud() - this._pausedTime, i = n - this._time, a = this._head; a; ) {
      var o = a.next, s = a.step(n, i);
      s && (a.ondestroy(), this.removeClip(a)), a = o;
    }
    this._time = n, e || (this.trigger("frame", i), this.stage.update && this.stage.update());
  }, r.prototype._startLoop = function() {
    var e = this;
    this._running = !0;
    function n() {
      e._running && (um(n), !e._paused && e.update());
    }
    um(n);
  }, r.prototype.start = function() {
    this._running || (this._time = Ud(), this._pausedTime = 0, this._startLoop());
  }, r.prototype.stop = function() {
    this._running = !1;
  }, r.prototype.pause = function() {
    this._paused || (this._pauseStart = Ud(), this._paused = !0);
  }, r.prototype.resume = function() {
    this._paused && (this._pausedTime += Ud() - this._pauseStart, this._paused = !1);
  }, r.prototype.clear = function() {
    for (var e = this._head; e; ) {
      var n = e.next;
      e.prev = e.next = e.animation = null, e = n;
    }
    this._head = this._tail = null;
  }, r.prototype.isFinished = function() {
    return this._head == null;
  }, r.prototype.animate = function(e, n) {
    n = n || {}, this.start();
    var i = new M7(e, n.loop);
    return this.addAnimator(i), i;
  }, r;
}(ka), $X = 300, P5 = vt.domSupported, N5 = function() {
  var t = [
    "click",
    "dblclick",
    "mousewheel",
    "wheel",
    "mouseout",
    "mouseup",
    "mousedown",
    "mousemove",
    "contextmenu"
  ], r = [
    "touchstart",
    "touchend",
    "touchmove"
  ], e = {
    pointerdown: 1,
    pointerup: 1,
    pointermove: 1,
    pointerout: 1
  }, n = ce(t, function(i) {
    var a = i.replace("mouse", "pointer");
    return e.hasOwnProperty(a) ? a : i;
  });
  return {
    mouse: t,
    touch: r,
    pointer: n
  };
}(), nS = {
  mouse: ["mousemove", "mouseup"],
  pointer: ["pointermove", "pointerup"]
}, iS = !1;
function RC(t) {
  var r = t.pointerType;
  return r === "pen" || r === "touch";
}
function UX(t) {
  t.touching = !0, t.touchTimer != null && (clearTimeout(t.touchTimer), t.touchTimer = null), t.touchTimer = setTimeout(function() {
    t.touching = !1, t.touchTimer = null;
  }, 700);
}
function O5(t) {
  t && (t.zrByTouch = !0);
}
function JX(t, r) {
  return ga(t.dom, new KX(t, r), !0);
}
function dN(t, r) {
  for (var e = r, n = !1; e && e.nodeType !== 9 && !(n = e.domBelongToZr || e !== r && e === t.painterRoot); )
    e = e.parentNode;
  return n;
}
var KX = /* @__PURE__ */ function() {
  function t(r, e) {
    this.stopPropagation = Yr, this.stopImmediatePropagation = Yr, this.preventDefault = Yr, this.type = e.type, this.target = this.currentTarget = r.dom, this.pointerType = e.pointerType, this.clientX = e.clientX, this.clientY = e.clientY;
  }
  return t;
}(), za = {
  mousedown: function(t) {
    t = ga(this.dom, t), this.__mayPointerCapture = [t.zrX, t.zrY], this.trigger("mousedown", t);
  },
  mousemove: function(t) {
    t = ga(this.dom, t);
    var r = this.__mayPointerCapture;
    r && (t.zrX !== r[0] || t.zrY !== r[1]) && this.__togglePointerCapture(!0), this.trigger("mousemove", t);
  },
  mouseup: function(t) {
    t = ga(this.dom, t), this.__togglePointerCapture(!1), this.trigger("mouseup", t);
  },
  mouseout: function(t) {
    t = ga(this.dom, t);
    var r = t.toElement || t.relatedTarget;
    dN(this, r) || (this.__pointerCapturing && (t.zrEventControl = "no_globalout"), this.trigger("mouseout", t));
  },
  wheel: function(t) {
    iS = !0, t = ga(this.dom, t), this.trigger("mousewheel", t);
  },
  mousewheel: function(t) {
    iS || (t = ga(this.dom, t), this.trigger("mousewheel", t));
  },
  touchstart: function(t) {
    t = ga(this.dom, t), O5(t), this.__lastTouchMoment = /* @__PURE__ */ new Date(), this.handler.processGesture(t, "start"), za.mousemove.call(this, t), za.mousedown.call(this, t);
  },
  touchmove: function(t) {
    t = ga(this.dom, t), O5(t), this.handler.processGesture(t, "change"), za.mousemove.call(this, t);
  },
  touchend: function(t) {
    t = ga(this.dom, t), O5(t), this.handler.processGesture(t, "end"), za.mouseup.call(this, t), +/* @__PURE__ */ new Date() - +this.__lastTouchMoment < $X && za.click.call(this, t);
  },
  pointerdown: function(t) {
    za.mousedown.call(this, t);
  },
  pointermove: function(t) {
    RC(t) || za.mousemove.call(this, t);
  },
  pointerup: function(t) {
    za.mouseup.call(this, t);
  },
  pointerout: function(t) {
    RC(t) || za.mouseout.call(this, t);
  }
};
L(["click", "dblclick", "contextmenu"], function(t) {
  za[t] = function(r) {
    r = ga(this.dom, r), this.trigger(t, r);
  };
});
var LC = {
  pointermove: function(t) {
    RC(t) || LC.mousemove.call(this, t);
  },
  pointerup: function(t) {
    LC.mouseup.call(this, t);
  },
  mousemove: function(t) {
    this.trigger("mousemove", t);
  },
  mouseup: function(t) {
    var r = this.__pointerCapturing;
    this.__togglePointerCapture(!1), this.trigger("mouseup", t), r && (t.zrEventControl = "only_globalout", this.trigger("mouseout", t));
  }
};
function qX(t, r) {
  var e = r.domHandlers;
  vt.pointerEventsSupported ? L(N5.pointer, function(n) {
    A0(r, n, function(i) {
      e[n].call(t, i);
    });
  }) : (vt.touchEventsSupported && L(N5.touch, function(n) {
    A0(r, n, function(i) {
      e[n].call(t, i), UX(r);
    });
  }), L(N5.mouse, function(n) {
    A0(r, n, function(i) {
      i = I7(i), r.touching || e[n].call(t, i);
    });
  }));
}
function QX(t, r) {
  vt.pointerEventsSupported ? L(nS.pointer, e) : vt.touchEventsSupported || L(nS.mouse, e);
  function e(n) {
    function i(a) {
      a = I7(a), dN(t, a.target) || (a = JX(t, a), r.domHandlers[n].call(t, a));
    }
    A0(r, n, i, { capture: !0 });
  }
}
function A0(t, r, e, n) {
  t.mounted[r] = e, t.listenerOpts[r] = n, _C(t.domTarget, r, e, n);
}
function V5(t) {
  var r = t.mounted;
  for (var e in r)
    r.hasOwnProperty(e) && uX(t.domTarget, e, r[e], t.listenerOpts[e]);
  t.mounted = {};
}
var aS = /* @__PURE__ */ function() {
  function t(r, e) {
    this.mounted = {}, this.listenerOpts = {}, this.touching = !1, this.domTarget = r, this.domHandlers = e;
  }
  return t;
}(), e$ = function(t) {
  _r(r, t);
  function r(e, n) {
    var i = t.call(this) || this;
    return i.__pointerCapturing = !1, i.dom = e, i.painterRoot = n, i._localHandlerScope = new aS(e, za), P5 && (i._globalHandlerScope = new aS(document, LC)), qX(i, i._localHandlerScope), i;
  }
  return r.prototype.dispose = function() {
    V5(this._localHandlerScope), P5 && V5(this._globalHandlerScope);
  }, r.prototype.setCursor = function(e) {
    this.dom.style && (this.dom.style.cursor = e || "default");
  }, r.prototype.__togglePointerCapture = function(e) {
    if (this.__mayPointerCapture = null, P5 && +this.__pointerCapturing ^ +e) {
      this.__pointerCapturing = e;
      var n = this._globalHandlerScope;
      e ? QX(this, n) : V5(n);
    }
  }, r;
}(ka), fN = 1;
vt.hasGlobalWindow && (fN = Math.max(window.devicePixelRatio || window.screen && window.screen.deviceXDPI / window.screen.logicalXDPI || 1, 1));
var vm = fN, EC = 0.4, kC = "#333", PC = "#ccc", t$ = "#eee", oS = lg, sS = 5e-5;
function Au(t) {
  return t > sS || t < -sS;
}
var Du = [], pd = [], G5 = Oi(), B5 = Math.abs, Ls = function() {
  function t() {
  }
  return t.prototype.getLocalTransform = function(r) {
    return t.getLocalTransform(this, r);
  }, t.prototype.setPosition = function(r) {
    this.x = r[0], this.y = r[1];
  }, t.prototype.setScale = function(r) {
    this.scaleX = r[0], this.scaleY = r[1];
  }, t.prototype.setSkew = function(r) {
    this.skewX = r[0], this.skewY = r[1];
  }, t.prototype.setOrigin = function(r) {
    this.originX = r[0], this.originY = r[1];
  }, t.prototype.needLocalTransform = function() {
    return Au(this.rotation) || Au(this.x) || Au(this.y) || Au(this.scaleX - 1) || Au(this.scaleY - 1) || Au(this.skewX) || Au(this.skewY);
  }, t.prototype.updateTransform = function() {
    var r = this.parent && this.parent.transform, e = this.needLocalTransform(), n = this.transform;
    if (!(e || r)) {
      n && (oS(n), this.invTransform = null);
      return;
    }
    n = n || Oi(), e ? this.getLocalTransform(n) : oS(n), r && (e ? zo(n, r, n) : Ky(n, r)), this.transform = n, this._resolveGlobalScaleRatio(n);
  }, t.prototype._resolveGlobalScaleRatio = function(r) {
    var e = this.globalScaleRatio;
    if (e != null && e !== 1) {
      this.getGlobalScale(Du);
      var n = Du[0] < 0 ? -1 : 1, i = Du[1] < 0 ? -1 : 1, a = ((Du[0] - n) * e + n) / Du[0] || 0, o = ((Du[1] - i) * e + i) / Du[1] || 0;
      r[0] *= a, r[1] *= a, r[2] *= o, r[3] *= o;
    }
    this.invTransform = this.invTransform || Oi(), Kc(this.invTransform, r);
  }, t.prototype.getComputedTransform = function() {
    for (var r = this, e = []; r; )
      e.push(r), r = r.parent;
    for (; r = e.pop(); )
      r.updateTransform();
    return this.transform;
  }, t.prototype.setLocalTransform = function(r) {
    if (r) {
      var e = r[0] * r[0] + r[1] * r[1], n = r[2] * r[2] + r[3] * r[3], i = Math.atan2(r[1], r[0]), a = Math.PI / 2 + i - Math.atan2(r[3], r[2]);
      n = Math.sqrt(n) * Math.cos(a), e = Math.sqrt(e), this.skewX = a, this.skewY = 0, this.rotation = -i, this.x = +r[4], this.y = +r[5], this.scaleX = e, this.scaleY = n, this.originX = 0, this.originY = 0;
    }
  }, t.prototype.decomposeTransform = function() {
    if (this.transform) {
      var r = this.parent, e = this.transform;
      r && r.transform && (r.invTransform = r.invTransform || Oi(), zo(pd, r.invTransform, e), e = pd);
      var n = this.originX, i = this.originY;
      (n || i) && (G5[4] = n, G5[5] = i, zo(pd, e, G5), pd[4] -= n, pd[5] -= i, e = pd), this.setLocalTransform(e);
    }
  }, t.prototype.getGlobalScale = function(r) {
    var e = this.transform;
    return r = r || [], e ? (r[0] = Math.sqrt(e[0] * e[0] + e[1] * e[1]), r[1] = Math.sqrt(e[2] * e[2] + e[3] * e[3]), e[0] < 0 && (r[0] = -r[0]), e[3] < 0 && (r[1] = -r[1]), r) : (r[0] = 1, r[1] = 1, r);
  }, t.prototype.transformCoordToLocal = function(r, e) {
    var n = [r, e], i = this.invTransform;
    return i && En(n, n, i), n;
  }, t.prototype.transformCoordToGlobal = function(r, e) {
    var n = [r, e], i = this.transform;
    return i && En(n, n, i), n;
  }, t.prototype.getLineScale = function() {
    var r = this.transform;
    return r && B5(r[0] - 1) > 1e-10 && B5(r[3] - 1) > 1e-10 ? Math.sqrt(B5(r[0] * r[3] - r[2] * r[1])) : 1;
  }, t.prototype.copyTransform = function(r) {
    hN(this, r);
  }, t.getLocalTransform = function(r, e) {
    e = e || [];
    var n = r.originX || 0, i = r.originY || 0, a = r.scaleX, o = r.scaleY, s = r.anchorX, l = r.anchorY, u = r.rotation || 0, c = r.x, d = r.y, f = r.skewX ? Math.tan(r.skewX) : 0, h = r.skewY ? Math.tan(-r.skewY) : 0;
    if (n || i || s || l) {
      var p = n + s, v = i + l;
      e[4] = -p * a - f * v * o, e[5] = -v * o - h * p * a;
    } else
      e[4] = e[5] = 0;
    return e[0] = a, e[3] = o, e[1] = h * a, e[2] = f * o, u && hu(e, e, u), e[4] += n + c, e[5] += i + d, e;
  }, t.initDefaultProps = function() {
    var r = t.prototype;
    r.scaleX = r.scaleY = r.globalScaleRatio = 1, r.x = r.y = r.originX = r.originY = r.skewX = r.skewY = r.rotation = r.anchorX = r.anchorY = 0;
  }(), t;
}(), Ko = [
  "x",
  "y",
  "originX",
  "originY",
  "anchorX",
  "anchorY",
  "rotation",
  "scaleX",
  "scaleY",
  "skewX",
  "skewY"
];
function hN(t, r) {
  for (var e = 0; e < Ko.length; e++) {
    var n = Ko[e];
    t[n] = r[n];
  }
}
var lS = {};
function qi(t, r) {
  r = r || Jl;
  var e = lS[r];
  e || (e = lS[r] = new ug(500));
  var n = e.get(t);
  return n == null && (n = Qa.measureText(t, r).width, e.put(t, n)), n;
}
function uS(t, r, e, n) {
  var i = qi(t, r), a = e2(r), o = Ap(0, i, e), s = Wd(0, a, n), l = new rt(o, s, i, a);
  return l;
}
function cg(t, r, e, n) {
  var i = ((t || "") + "").split(`
`), a = i.length;
  if (a === 1)
    return uS(i[0], r, e, n);
  for (var o = new rt(0, 0, 0, 0), s = 0; s < i.length; s++) {
    var l = uS(i[s], r, e, n);
    s === 0 ? o.copy(l) : o.union(l);
  }
  return o;
}
function Ap(t, r, e) {
  return e === "right" ? t -= r : e === "center" && (t -= r / 2), t;
}
function Wd(t, r, e) {
  return e === "middle" ? t -= r / 2 : e === "bottom" && (t -= r), t;
}
function e2(t) {
  return qi("国", t);
}
function to(t, r) {
  return typeof t == "string" ? t.lastIndexOf("%") >= 0 ? parseFloat(t) / 100 * r : parseFloat(t) : t;
}
function gm(t, r, e) {
  var n = r.position || "inside", i = r.distance != null ? r.distance : 5, a = e.height, o = e.width, s = a / 2, l = e.x, u = e.y, c = "left", d = "top";
  if (n instanceof Array)
    l += to(n[0], e.width), u += to(n[1], e.height), c = null, d = null;
  else
    switch (n) {
      case "left":
        l -= i, u += s, c = "right", d = "middle";
        break;
      case "right":
        l += i + o, u += s, d = "middle";
        break;
      case "top":
        l += o / 2, u -= i, c = "center", d = "bottom";
        break;
      case "bottom":
        l += o / 2, u += a + i, c = "center";
        break;
      case "inside":
        l += o / 2, u += s, c = "center", d = "middle";
        break;
      case "insideLeft":
        l += i, u += s, d = "middle";
        break;
      case "insideRight":
        l += o - i, u += s, c = "right", d = "middle";
        break;
      case "insideTop":
        l += o / 2, u += i, c = "center";
        break;
      case "insideBottom":
        l += o / 2, u += a - i, c = "center", d = "bottom";
        break;
      case "insideTopLeft":
        l += i, u += i;
        break;
      case "insideTopRight":
        l += o - i, u += i, c = "right";
        break;
      case "insideBottomLeft":
        l += i, u += a - i, d = "bottom";
        break;
      case "insideBottomRight":
        l += o - i, u += a - i, c = "right", d = "bottom";
        break;
    }
  return t = t || {}, t.x = l, t.y = u, t.align = c, t.verticalAlign = d, t;
}
var F5 = "__zr_normal__", H5 = Ko.concat(["ignore"]), r$ = Ma(Ko, function(t, r) {
  return t[r] = !0, t;
}, { ignore: !1 }), vd = {}, n$ = new rt(0, 0, 0, 0), t2 = function() {
  function t(r) {
    this.id = C7(), this.animators = [], this.currentStates = [], this.states = {}, this._init(r);
  }
  return t.prototype._init = function(r) {
    this.attr(r);
  }, t.prototype.drift = function(r, e, n) {
    switch (this.draggable) {
      case "horizontal":
        e = 0;
        break;
      case "vertical":
        r = 0;
        break;
    }
    var i = this.transform;
    i || (i = this.transform = [1, 0, 0, 1, 0, 0]), i[4] += r, i[5] += e, this.decomposeTransform(), this.markRedraw();
  }, t.prototype.beforeUpdate = function() {
  }, t.prototype.afterUpdate = function() {
  }, t.prototype.update = function() {
    this.updateTransform(), this.__dirty && this.updateInnerText();
  }, t.prototype.updateInnerText = function(r) {
    var e = this._textContent;
    if (e && (!e.ignore || r)) {
      this.textConfig || (this.textConfig = {});
      var n = this.textConfig, i = n.local, a = e.innerTransformable, o = void 0, s = void 0, l = !1;
      a.parent = i ? this : null;
      var u = !1;
      if (a.copyTransform(e), n.position != null) {
        var c = n$;
        n.layoutRect ? c.copy(n.layoutRect) : c.copy(this.getBoundingRect()), i || c.applyTransform(this.transform), this.calculateTextPosition ? this.calculateTextPosition(vd, n, c) : gm(vd, n, c), a.x = vd.x, a.y = vd.y, o = vd.align, s = vd.verticalAlign;
        var d = n.origin;
        if (d && n.rotation != null) {
          var f = void 0, h = void 0;
          d === "center" ? (f = c.width * 0.5, h = c.height * 0.5) : (f = to(d[0], c.width), h = to(d[1], c.height)), u = !0, a.originX = -a.x + f + (i ? 0 : c.x), a.originY = -a.y + h + (i ? 0 : c.y);
        }
      }
      n.rotation != null && (a.rotation = n.rotation);
      var p = n.offset;
      p && (a.x += p[0], a.y += p[1], u || (a.originX = -p[0], a.originY = -p[1]));
      var v = n.inside == null ? typeof n.position == "string" && n.position.indexOf("inside") >= 0 : n.inside, g = this._innerTextDefaultStyle || (this._innerTextDefaultStyle = {}), m = void 0, y = void 0, b = void 0;
      v && this.canBeInsideText() ? (m = n.insideFill, y = n.insideStroke, (m == null || m === "auto") && (m = this.getInsideTextFill()), (y == null || y === "auto") && (y = this.getInsideTextStroke(m), b = !0)) : (m = n.outsideFill, y = n.outsideStroke, (m == null || m === "auto") && (m = this.getOutsideFill()), (y == null || y === "auto") && (y = this.getOutsideStroke(m), b = !0)), m = m || "#000", (m !== g.fill || y !== g.stroke || b !== g.autoStroke || o !== g.align || s !== g.verticalAlign) && (l = !0, g.fill = m, g.stroke = y, g.autoStroke = b, g.align = o, g.verticalAlign = s, e.setDefaultTextStyle(g)), e.__dirty |= ji, l && e.dirtyStyle(!0);
    }
  }, t.prototype.canBeInsideText = function() {
    return !0;
  }, t.prototype.getInsideTextFill = function() {
    return "#fff";
  }, t.prototype.getInsideTextStroke = function(r) {
    return "#000";
  }, t.prototype.getOutsideFill = function() {
    return this.__zr && this.__zr.isDarkMode() ? PC : kC;
  }, t.prototype.getOutsideStroke = function(r) {
    var e = this.__zr && this.__zr.getBackgroundColor(), n = typeof e == "string" && Ci(e);
    n || (n = [255, 255, 255, 1]);
    for (var i = n[3], a = this.__zr.isDarkMode(), o = 0; o < 3; o++)
      n[o] = n[o] * i + (a ? 0 : 255) * (1 - i);
    return n[3] = 1, Ja(n, "rgba");
  }, t.prototype.traverse = function(r, e) {
  }, t.prototype.attrKV = function(r, e) {
    r === "textConfig" ? this.setTextConfig(e) : r === "textContent" ? this.setTextContent(e) : r === "clipPath" ? this.setClipPath(e) : r === "extra" ? (this.extra = this.extra || {}, ae(this.extra, e)) : this[r] = e;
  }, t.prototype.hide = function() {
    this.ignore = !0, this.markRedraw();
  }, t.prototype.show = function() {
    this.ignore = !1, this.markRedraw();
  }, t.prototype.attr = function(r, e) {
    if (typeof r == "string")
      this.attrKV(r, e);
    else if (Me(r))
      for (var n = r, i = yt(n), a = 0; a < i.length; a++) {
        var o = i[a];
        this.attrKV(o, r[o]);
      }
    return this.markRedraw(), this;
  }, t.prototype.saveCurrentToNormalState = function(r) {
    this._innerSaveToNormal(r);
    for (var e = this._normalState, n = 0; n < this.animators.length; n++) {
      var i = this.animators[n], a = i.__fromStateTransition;
      if (!(i.getLoop() || a && a !== F5)) {
        var o = i.targetName, s = o ? e[o] : e;
        i.saveTo(s);
      }
    }
  }, t.prototype._innerSaveToNormal = function(r) {
    var e = this._normalState;
    e || (e = this._normalState = {}), r.textConfig && !e.textConfig && (e.textConfig = this.textConfig), this._savePrimaryToNormal(r, e, H5);
  }, t.prototype._savePrimaryToNormal = function(r, e, n) {
    for (var i = 0; i < n.length; i++) {
      var a = n[i];
      r[a] != null && !(a in e) && (e[a] = this[a]);
    }
  }, t.prototype.hasState = function() {
    return this.currentStates.length > 0;
  }, t.prototype.getState = function(r) {
    return this.states[r];
  }, t.prototype.ensureState = function(r) {
    var e = this.states;
    return e[r] || (e[r] = {}), e[r];
  }, t.prototype.clearStates = function(r) {
    this.useState(F5, !1, r);
  }, t.prototype.useState = function(r, e, n, i) {
    var a = r === F5, o = this.hasState();
    if (!(!o && a)) {
      var s = this.currentStates, l = this.stateTransition;
      if (!(nt(s, r) >= 0 && (e || s.length === 1))) {
        var u;
        if (this.stateProxy && !a && (u = this.stateProxy(r)), u || (u = this.states && this.states[r]), !u && !a) {
          Da("State " + r + " not exists.");
          return;
        }
        a || this.saveCurrentToNormalState(u);
        var c = !!(u && u.hoverLayer || i);
        c && this._toggleHoverLayerFlag(!0), this._applyStateObj(r, u, this._normalState, e, !n && !this.__inHover && l && l.duration > 0, l);
        var d = this._textContent, f = this._textGuide;
        return d && d.useState(r, e, n, c), f && f.useState(r, e, n, c), a ? (this.currentStates = [], this._normalState = {}) : e ? this.currentStates.push(r) : this.currentStates = [r], this._updateAnimationTargets(), this.markRedraw(), !c && this.__inHover && (this._toggleHoverLayerFlag(!1), this.__dirty &= ~ji), u;
      }
    }
  }, t.prototype.useStates = function(r, e, n) {
    if (!r.length)
      this.clearStates();
    else {
      var i = [], a = this.currentStates, o = r.length, s = o === a.length;
      if (s) {
        for (var l = 0; l < o; l++)
          if (r[l] !== a[l]) {
            s = !1;
            break;
          }
      }
      if (s)
        return;
      for (var l = 0; l < o; l++) {
        var u = r[l], c = void 0;
        this.stateProxy && (c = this.stateProxy(u, r)), c || (c = this.states[u]), c && i.push(c);
      }
      var d = i[o - 1], f = !!(d && d.hoverLayer || n);
      f && this._toggleHoverLayerFlag(!0);
      var h = this._mergeStates(i), p = this.stateTransition;
      this.saveCurrentToNormalState(h), this._applyStateObj(r.join(","), h, this._normalState, !1, !e && !this.__inHover && p && p.duration > 0, p);
      var v = this._textContent, g = this._textGuide;
      v && v.useStates(r, e, f), g && g.useStates(r, e, f), this._updateAnimationTargets(), this.currentStates = r.slice(), this.markRedraw(), !f && this.__inHover && (this._toggleHoverLayerFlag(!1), this.__dirty &= ~ji);
    }
  }, t.prototype.isSilent = function() {
    for (var r = this.silent, e = this.parent; !r && e; ) {
      if (e.silent) {
        r = !0;
        break;
      }
      e = e.parent;
    }
    return r;
  }, t.prototype._updateAnimationTargets = function() {
    for (var r = 0; r < this.animators.length; r++) {
      var e = this.animators[r];
      e.targetName && e.changeTarget(this[e.targetName]);
    }
  }, t.prototype.removeState = function(r) {
    var e = nt(this.currentStates, r);
    if (e >= 0) {
      var n = this.currentStates.slice();
      n.splice(e, 1), this.useStates(n);
    }
  }, t.prototype.replaceState = function(r, e, n) {
    var i = this.currentStates.slice(), a = nt(i, r), o = nt(i, e) >= 0;
    a >= 0 ? o ? i.splice(a, 1) : i[a] = e : n && !o && i.push(e), this.useStates(i);
  }, t.prototype.toggleState = function(r, e) {
    e ? this.useState(r, !0) : this.removeState(r);
  }, t.prototype._mergeStates = function(r) {
    for (var e = {}, n, i = 0; i < r.length; i++) {
      var a = r[i];
      ae(e, a), a.textConfig && (n = n || {}, ae(n, a.textConfig));
    }
    return n && (e.textConfig = n), e;
  }, t.prototype._applyStateObj = function(r, e, n, i, a, o) {
    var s = !(e && i);
    e && e.textConfig ? (this.textConfig = ae({}, i ? this.textConfig : n.textConfig), ae(this.textConfig, e.textConfig)) : s && n.textConfig && (this.textConfig = n.textConfig);
    for (var l = {}, u = !1, c = 0; c < H5.length; c++) {
      var d = H5[c], f = a && r$[d];
      e && e[d] != null ? f ? (u = !0, l[d] = e[d]) : this[d] = e[d] : s && n[d] != null && (f ? (u = !0, l[d] = n[d]) : this[d] = n[d]);
    }
    if (!a)
      for (var c = 0; c < this.animators.length; c++) {
        var h = this.animators[c], p = h.targetName;
        h.getLoop() || h.__changeFinalValue(p ? (e || n)[p] : e || n);
      }
    u && this._transitionState(r, l, o);
  }, t.prototype._attachComponent = function(r) {
    if (r.__zr && !r.__hostTarget) {
      if (process.env.NODE_ENV !== "production")
        throw new Error("Text element has been added to zrender.");
      return;
    }
    if (r === this) {
      if (process.env.NODE_ENV !== "production")
        throw new Error("Recursive component attachment.");
      return;
    }
    var e = this.__zr;
    e && r.addSelfToZr(e), r.__zr = e, r.__hostTarget = this;
  }, t.prototype._detachComponent = function(r) {
    r.__zr && r.removeSelfFromZr(r.__zr), r.__zr = null, r.__hostTarget = null;
  }, t.prototype.getClipPath = function() {
    return this._clipPath;
  }, t.prototype.setClipPath = function(r) {
    this._clipPath && this._clipPath !== r && this.removeClipPath(), this._attachComponent(r), this._clipPath = r, this.markRedraw();
  }, t.prototype.removeClipPath = function() {
    var r = this._clipPath;
    r && (this._detachComponent(r), this._clipPath = null, this.markRedraw());
  }, t.prototype.getTextContent = function() {
    return this._textContent;
  }, t.prototype.setTextContent = function(r) {
    var e = this._textContent;
    if (e !== r) {
      if (e && e !== r && this.removeTextContent(), process.env.NODE_ENV !== "production" && r.__zr && !r.__hostTarget)
        throw new Error("Text element has been added to zrender.");
      r.innerTransformable = new Ls(), this._attachComponent(r), this._textContent = r, this.markRedraw();
    }
  }, t.prototype.setTextConfig = function(r) {
    this.textConfig || (this.textConfig = {}), ae(this.textConfig, r), this.markRedraw();
  }, t.prototype.removeTextConfig = function() {
    this.textConfig = null, this.markRedraw();
  }, t.prototype.removeTextContent = function() {
    var r = this._textContent;
    r && (r.innerTransformable = null, this._detachComponent(r), this._textContent = null, this._innerTextDefaultStyle = null, this.markRedraw());
  }, t.prototype.getTextGuideLine = function() {
    return this._textGuide;
  }, t.prototype.setTextGuideLine = function(r) {
    this._textGuide && this._textGuide !== r && this.removeTextGuideLine(), this._attachComponent(r), this._textGuide = r, this.markRedraw();
  }, t.prototype.removeTextGuideLine = function() {
    var r = this._textGuide;
    r && (this._detachComponent(r), this._textGuide = null, this.markRedraw());
  }, t.prototype.markRedraw = function() {
    this.__dirty |= ji;
    var r = this.__zr;
    r && (this.__inHover ? r.refreshHover() : r.refresh()), this.__hostTarget && this.__hostTarget.markRedraw();
  }, t.prototype.dirty = function() {
    this.markRedraw();
  }, t.prototype._toggleHoverLayerFlag = function(r) {
    this.__inHover = r;
    var e = this._textContent, n = this._textGuide;
    e && (e.__inHover = r), n && (n.__inHover = r);
  }, t.prototype.addSelfToZr = function(r) {
    if (this.__zr !== r) {
      this.__zr = r;
      var e = this.animators;
      if (e)
        for (var n = 0; n < e.length; n++)
          r.animation.addAnimator(e[n]);
      this._clipPath && this._clipPath.addSelfToZr(r), this._textContent && this._textContent.addSelfToZr(r), this._textGuide && this._textGuide.addSelfToZr(r);
    }
  }, t.prototype.removeSelfFromZr = function(r) {
    if (this.__zr) {
      this.__zr = null;
      var e = this.animators;
      if (e)
        for (var n = 0; n < e.length; n++)
          r.animation.removeAnimator(e[n]);
      this._clipPath && this._clipPath.removeSelfFromZr(r), this._textContent && this._textContent.removeSelfFromZr(r), this._textGuide && this._textGuide.removeSelfFromZr(r);
    }
  }, t.prototype.animate = function(r, e, n) {
    var i = r ? this[r] : this;
    if (process.env.NODE_ENV !== "production" && !i) {
      Da('Property "' + r + '" is not existed in element ' + this.id);
      return;
    }
    var a = new M7(i, e, n);
    return r && (a.targetName = r), this.addAnimator(a, r), a;
  }, t.prototype.addAnimator = function(r, e) {
    var n = this.__zr, i = this;
    r.during(function() {
      i.updateDuringAnimation(e);
    }).done(function() {
      var a = i.animators, o = nt(a, r);
      o >= 0 && a.splice(o, 1);
    }), this.animators.push(r), n && n.animation.addAnimator(r), n && n.wakeUp();
  }, t.prototype.updateDuringAnimation = function(r) {
    this.markRedraw();
  }, t.prototype.stopAnimation = function(r, e) {
    for (var n = this.animators, i = n.length, a = [], o = 0; o < i; o++) {
      var s = n[o];
      !r || r === s.scope ? s.stop(e) : a.push(s);
    }
    return this.animators = a, this;
  }, t.prototype.animateTo = function(r, e, n) {
    z5(this, r, e, n);
  }, t.prototype.animateFrom = function(r, e, n) {
    z5(this, r, e, n, !0);
  }, t.prototype._transitionState = function(r, e, n, i) {
    for (var a = z5(this, e, n, i), o = 0; o < a.length; o++)
      a[o].__fromStateTransition = r;
  }, t.prototype.getBoundingRect = function() {
    return null;
  }, t.prototype.getPaintRect = function() {
    return null;
  }, t.initDefaultProps = function() {
    var r = t.prototype;
    r.type = "element", r.name = "", r.ignore = r.silent = r.isGroup = r.draggable = r.dragging = r.ignoreClip = r.__inHover = !1, r.__dirty = ji;
    var e = {};
    function n(a, o, s) {
      e[a + o + s] || (console.warn("DEPRECATED: '" + a + "' has been deprecated. use '" + o + "', '" + s + "' instead"), e[a + o + s] = !0);
    }
    function i(a, o, s, l) {
      Object.defineProperty(r, a, {
        get: function() {
          if (process.env.NODE_ENV !== "production" && n(a, s, l), !this[o]) {
            var c = this[o] = [];
            u(this, c);
          }
          return this[o];
        },
        set: function(c) {
          process.env.NODE_ENV !== "production" && n(a, s, l), this[s] = c[0], this[l] = c[1], this[o] = c, u(this, c);
        }
      });
      function u(c, d) {
        Object.defineProperty(d, 0, {
          get: function() {
            return c[s];
          },
          set: function(f) {
            c[s] = f;
          }
        }), Object.defineProperty(d, 1, {
          get: function() {
            return c[l];
          },
          set: function(f) {
            c[l] = f;
          }
        });
      }
    }
    Object.defineProperty && (i("position", "_legacyPos", "x", "y"), i("scale", "_legacyScale", "scaleX", "scaleY"), i("origin", "_legacyOrigin", "originX", "originY"));
  }(), t;
}();
Xr(t2, ka);
Xr(t2, Ls);
function z5(t, r, e, n, i) {
  e = e || {};
  var a = [];
  pN(t, "", t, r, e, n, a, i);
  var o = a.length, s = !1, l = e.done, u = e.aborted, c = function() {
    s = !0, o--, o <= 0 && (s ? l && l() : u && u());
  }, d = function() {
    o--, o <= 0 && (s ? l && l() : u && u());
  };
  o || l && l(), a.length > 0 && e.during && a[0].during(function(p, v) {
    e.during(v);
  });
  for (var f = 0; f < a.length; f++) {
    var h = a[f];
    c && h.done(c), d && h.aborted(d), e.force && h.duration(e.duration), h.start(e.easing);
  }
  return a;
}
function W5(t, r, e) {
  for (var n = 0; n < e; n++)
    t[n] = r[n];
}
function i$(t) {
  return Zn(t[0]);
}
function a$(t, r, e) {
  if (Zn(r[e]))
    if (Zn(t[e]) || (t[e] = []), ai(r[e])) {
      var n = r[e].length;
      t[e].length !== n && (t[e] = new r[e].constructor(n), W5(t[e], r[e], n));
    } else {
      var i = r[e], a = t[e], o = i.length;
      if (i$(i))
        for (var s = i[0].length, l = 0; l < o; l++)
          a[l] ? W5(a[l], i[l], s) : a[l] = Array.prototype.slice.call(i[l]);
      else
        W5(a, i, o);
      a.length = i.length;
    }
  else
    t[e] = r[e];
}
function o$(t, r) {
  return t === r || Zn(t) && Zn(r) && s$(t, r);
}
function s$(t, r) {
  var e = t.length;
  if (e !== r.length)
    return !1;
  for (var n = 0; n < e; n++)
    if (t[n] !== r[n])
      return !1;
  return !0;
}
function pN(t, r, e, n, i, a, o, s) {
  for (var l = yt(n), u = i.duration, c = i.delay, d = i.additive, f = i.setToFinal, h = !Me(a), p = t.animators, v = [], g = 0; g < l.length; g++) {
    var m = l[g], y = n[m];
    if (y != null && e[m] != null && (h || a[m]))
      if (Me(y) && !Zn(y) && !og(y)) {
        if (r) {
          s || (e[m] = y, t.updateDuringAnimation(r));
          continue;
        }
        pN(t, m, e[m], y, i, a && a[m], o, s);
      } else
        v.push(m);
    else s || (e[m] = y, t.updateDuringAnimation(r), v.push(m));
  }
  var b = v.length;
  if (!d && b)
    for (var C = 0; C < p.length; C++) {
      var w = p[C];
      if (w.targetName === r) {
        var _ = w.stopTracks(v);
        if (_) {
          var x = nt(p, w);
          p.splice(x, 1);
        }
      }
    }
  if (i.force || (v = Wt(v, function(A) {
    return !o$(n[A], e[A]);
  }), b = v.length), b > 0 || i.force && !o.length) {
    var I = void 0, D = void 0, T = void 0;
    if (s) {
      D = {}, f && (I = {});
      for (var C = 0; C < b; C++) {
        var m = v[C];
        D[m] = e[m], f ? I[m] = n[m] : e[m] = n[m];
      }
    } else if (f) {
      T = {};
      for (var C = 0; C < b; C++) {
        var m = v[C];
        T[m] = Xp(e[m]), a$(e, n, m);
      }
    }
    var w = new M7(e, !1, !1, d ? Wt(p, function(M) {
      return M.targetName === r;
    }) : null);
    w.targetName = r, i.scope && (w.scope = i.scope), f && I && w.whenWithKeys(0, I, v), T && w.whenWithKeys(0, T, v), w.whenWithKeys(u ?? 500, s ? D : n, v).delay(c || 0), t.addAnimator(w, r), o.push(w);
  }
}
var ze = function(t) {
  _r(r, t);
  function r(e) {
    var n = t.call(this) || this;
    return n.isGroup = !0, n._children = [], n.attr(e), n;
  }
  return r.prototype.childrenRef = function() {
    return this._children;
  }, r.prototype.children = function() {
    return this._children.slice();
  }, r.prototype.childAt = function(e) {
    return this._children[e];
  }, r.prototype.childOfName = function(e) {
    for (var n = this._children, i = 0; i < n.length; i++)
      if (n[i].name === e)
        return n[i];
  }, r.prototype.childCount = function() {
    return this._children.length;
  }, r.prototype.add = function(e) {
    if (e && (e !== this && e.parent !== this && (this._children.push(e), this._doAdd(e)), process.env.NODE_ENV !== "production" && e.__hostTarget))
      throw "This elemenet has been used as an attachment";
    return this;
  }, r.prototype.addBefore = function(e, n) {
    if (e && e !== this && e.parent !== this && n && n.parent === this) {
      var i = this._children, a = i.indexOf(n);
      a >= 0 && (i.splice(a, 0, e), this._doAdd(e));
    }
    return this;
  }, r.prototype.replace = function(e, n) {
    var i = nt(this._children, e);
    return i >= 0 && this.replaceAt(n, i), this;
  }, r.prototype.replaceAt = function(e, n) {
    var i = this._children, a = i[n];
    if (e && e !== this && e.parent !== this && e !== a) {
      i[n] = e, a.parent = null;
      var o = this.__zr;
      o && a.removeSelfFromZr(o), this._doAdd(e);
    }
    return this;
  }, r.prototype._doAdd = function(e) {
    e.parent && e.parent.remove(e), e.parent = this;
    var n = this.__zr;
    n && n !== e.__zr && e.addSelfToZr(n), n && n.refresh();
  }, r.prototype.remove = function(e) {
    var n = this.__zr, i = this._children, a = nt(i, e);
    return a < 0 ? this : (i.splice(a, 1), e.parent = null, n && e.removeSelfFromZr(n), n && n.refresh(), this);
  }, r.prototype.removeAll = function() {
    for (var e = this._children, n = this.__zr, i = 0; i < e.length; i++) {
      var a = e[i];
      n && a.removeSelfFromZr(n), a.parent = null;
    }
    return e.length = 0, this;
  }, r.prototype.eachChild = function(e, n) {
    for (var i = this._children, a = 0; a < i.length; a++) {
      var o = i[a];
      e.call(n, o, a);
    }
    return this;
  }, r.prototype.traverse = function(e, n) {
    for (var i = 0; i < this._children.length; i++) {
      var a = this._children[i], o = e.call(n, a);
      a.isGroup && !o && a.traverse(e, n);
    }
    return this;
  }, r.prototype.addSelfToZr = function(e) {
    t.prototype.addSelfToZr.call(this, e);
    for (var n = 0; n < this._children.length; n++) {
      var i = this._children[n];
      i.addSelfToZr(e);
    }
  }, r.prototype.removeSelfFromZr = function(e) {
    t.prototype.removeSelfFromZr.call(this, e);
    for (var n = 0; n < this._children.length; n++) {
      var i = this._children[n];
      i.removeSelfFromZr(e);
    }
  }, r.prototype.getBoundingRect = function(e) {
    for (var n = new rt(0, 0, 0, 0), i = e || this._children, a = [], o = null, s = 0; s < i.length; s++) {
      var l = i[s];
      if (!(l.ignore || l.invisible)) {
        var u = l.getBoundingRect(), c = l.getLocalTransform(a);
        c ? (rt.applyTransform(n, u, c), o = o || n.clone(), o.union(n)) : (o = o || u.clone(), o.union(u));
      }
    }
    return o || n;
  }, r;
}(t2);
ze.prototype.type = "group";
/*!
* ZRender, a high performance 2d drawing library.
*
* Copyright (c) 2013, Baidu Inc.
* All rights reserved.
*
* LICENSE
* https://github.com/ecomfe/zrender/blob/master/LICENSE.txt
*/
var Dp = {}, uc = {};
function l$(t) {
  delete uc[t];
}
function u$(t) {
  if (!t)
    return !1;
  if (typeof t == "string")
    return yv(t, 1) < EC;
  if (t.colorStops) {
    for (var r = t.colorStops, e = 0, n = r.length, i = 0; i < n; i++)
      e += yv(r[i].color, 1);
    return e /= n, e < EC;
  }
  return !1;
}
var c$ = function() {
  function t(r, e, n) {
    var i = this;
    this._sleepAfterStill = 10, this._stillFrameAccum = 0, this._needsRefresh = !0, this._needsRefreshHover = !0, this._darkMode = !1, n = n || {}, this.dom = e, this.id = r;
    var a = new wX(), o = n.renderer || "canvas";
    if (Dp[o] || (o = yt(Dp)[0]), process.env.NODE_ENV !== "production" && !Dp[o])
      throw new Error("Renderer '" + o + "' is not imported. Please import it first.");
    n.useDirtyRect = n.useDirtyRect == null ? !1 : n.useDirtyRect;
    var s = new Dp[o](e, a, n, r), l = n.ssr || s.ssrOnly;
    this.storage = a, this.painter = s;
    var u = !vt.node && !vt.worker && !l ? new e$(s.getViewportRoot(), s.root) : null, c = n.useCoarsePointer, d = c == null || c === "auto" ? vt.touchEventsSupported : !!c, f = 44, h;
    d && (h = je(n.pointerSize, f)), this.handler = new XP(a, s, u, s.root, h), this.animation = new XX({
      stage: {
        update: l ? null : function() {
          return i._flush(!0);
        }
      }
    }), l || this.animation.start();
  }
  return t.prototype.add = function(r) {
    this._disposed || !r || (this.storage.addRoot(r), r.addSelfToZr(this), this.refresh());
  }, t.prototype.remove = function(r) {
    this._disposed || !r || (this.storage.delRoot(r), r.removeSelfFromZr(this), this.refresh());
  }, t.prototype.configLayer = function(r, e) {
    this._disposed || (this.painter.configLayer && this.painter.configLayer(r, e), this.refresh());
  }, t.prototype.setBackgroundColor = function(r) {
    this._disposed || (this.painter.setBackgroundColor && this.painter.setBackgroundColor(r), this.refresh(), this._backgroundColor = r, this._darkMode = u$(r));
  }, t.prototype.getBackgroundColor = function() {
    return this._backgroundColor;
  }, t.prototype.setDarkMode = function(r) {
    this._darkMode = r;
  }, t.prototype.isDarkMode = function() {
    return this._darkMode;
  }, t.prototype.refreshImmediately = function(r) {
    this._disposed || (r || this.animation.update(!0), this._needsRefresh = !1, this.painter.refresh(), this._needsRefresh = !1);
  }, t.prototype.refresh = function() {
    this._disposed || (this._needsRefresh = !0, this.animation.start());
  }, t.prototype.flush = function() {
    this._disposed || this._flush(!1);
  }, t.prototype._flush = function(r) {
    var e, n = Ud();
    this._needsRefresh && (e = !0, this.refreshImmediately(r)), this._needsRefreshHover && (e = !0, this.refreshHoverImmediately());
    var i = Ud();
    e ? (this._stillFrameAccum = 0, this.trigger("rendered", {
      elapsedTime: i - n
    })) : this._sleepAfterStill > 0 && (this._stillFrameAccum++, this._stillFrameAccum > this._sleepAfterStill && this.animation.stop());
  }, t.prototype.setSleepAfterStill = function(r) {
    this._sleepAfterStill = r;
  }, t.prototype.wakeUp = function() {
    this._disposed || (this.animation.start(), this._stillFrameAccum = 0);
  }, t.prototype.refreshHover = function() {
    this._needsRefreshHover = !0;
  }, t.prototype.refreshHoverImmediately = function() {
    this._disposed || (this._needsRefreshHover = !1, this.painter.refreshHover && this.painter.getType() === "canvas" && this.painter.refreshHover());
  }, t.prototype.resize = function(r) {
    this._disposed || (r = r || {}, this.painter.resize(r.width, r.height), this.handler.resize());
  }, t.prototype.clearAnimation = function() {
    this._disposed || this.animation.clear();
  }, t.prototype.getWidth = function() {
    if (!this._disposed)
      return this.painter.getWidth();
  }, t.prototype.getHeight = function() {
    if (!this._disposed)
      return this.painter.getHeight();
  }, t.prototype.setCursorStyle = function(r) {
    this._disposed || this.handler.setCursorStyle(r);
  }, t.prototype.findHover = function(r, e) {
    if (!this._disposed)
      return this.handler.findHover(r, e);
  }, t.prototype.on = function(r, e, n) {
    return this._disposed || this.handler.on(r, e, n), this;
  }, t.prototype.off = function(r, e) {
    this._disposed || this.handler.off(r, e);
  }, t.prototype.trigger = function(r, e) {
    this._disposed || this.handler.trigger(r, e);
  }, t.prototype.clear = function() {
    if (!this._disposed) {
      for (var r = this.storage.getRoots(), e = 0; e < r.length; e++)
        r[e] instanceof ze && r[e].removeSelfFromZr(this);
      this.storage.delAllRoots(), this.painter.clear();
    }
  }, t.prototype.dispose = function() {
    this._disposed || (this.animation.stop(), this.clear(), this.storage.dispose(), this.painter.dispose(), this.handler.dispose(), this.animation = this.storage = this.painter = this.handler = null, this._disposed = !0, l$(this.id));
  }, t;
}();
function NC(t, r) {
  var e = new c$(C7(), t, r);
  return uc[e.id] = e, e;
}
function d$(t) {
  t.dispose();
}
function f$() {
  for (var t in uc)
    uc.hasOwnProperty(t) && uc[t].dispose();
  uc = {};
}
function h$(t) {
  return uc[t];
}
function vN(t, r) {
  Dp[t] = r;
}
var OC;
function gN(t) {
  if (typeof OC == "function")
    return OC(t);
}
function mN(t) {
  OC = t;
}
var p$ = "5.6.0";
const v$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  dispose: d$,
  disposeAll: f$,
  getElementSSRData: gN,
  getInstance: h$,
  init: NC,
  registerPainter: vN,
  registerSSRDataGetter: mN,
  version: p$
}, Symbol.toStringTag, { value: "Module" }));
var cS = 1e-4, yN = 20;
function g$(t) {
  return t.replace(/^\s+|\s+$/g, "");
}
function zt(t, r, e, n) {
  var i = r[0], a = r[1], o = e[0], s = e[1], l = a - i, u = s - o;
  if (l === 0)
    return u === 0 ? o : (o + s) / 2;
  if (n)
    if (l > 0) {
      if (t <= i)
        return o;
      if (t >= a)
        return s;
    } else {
      if (t >= i)
        return o;
      if (t <= a)
        return s;
    }
  else {
    if (t === i)
      return o;
    if (t === a)
      return s;
  }
  return (t - i) / l * u + o;
}
function he(t, r) {
  switch (t) {
    case "center":
    case "middle":
      t = "50%";
      break;
    case "left":
    case "top":
      t = "0%";
      break;
    case "right":
    case "bottom":
      t = "100%";
      break;
  }
  return pe(t) ? g$(t).match(/%$/) ? parseFloat(t) / 100 * r : parseFloat(t) : t == null ? NaN : +t;
}
function Or(t, r, e) {
  return r == null && (r = 10), r = Math.min(Math.max(0, r), yN), t = (+t).toFixed(r), e ? t : +t;
}
function Ui(t) {
  return t.sort(function(r, e) {
    return r - e;
  }), t;
}
function Ya(t) {
  if (t = +t, isNaN(t))
    return 0;
  if (t > 1e-14) {
    for (var r = 1, e = 0; e < 15; e++, r *= 10)
      if (Math.round(t * r) / r === t)
        return e;
  }
  return mm(t);
}
function mm(t) {
  var r = t.toString().toLowerCase(), e = r.indexOf("e"), n = e > 0 ? +r.slice(e + 1) : 0, i = e > 0 ? e : r.length, a = r.indexOf("."), o = a < 0 ? 0 : i - 1 - a;
  return Math.max(0, o - n);
}
function R7(t, r) {
  var e = Math.log, n = Math.LN10, i = Math.floor(e(t[1] - t[0]) / n), a = Math.round(e(Math.abs(r[1] - r[0])) / n), o = Math.min(Math.max(-i + a, 0), 20);
  return isFinite(o) ? o : 20;
}
function m$(t, r, e) {
  if (!t[r])
    return 0;
  var n = bN(t, e);
  return n[r] || 0;
}
function bN(t, r) {
  var e = Ma(t, function(h, p) {
    return h + (isNaN(p) ? 0 : p);
  }, 0);
  if (e === 0)
    return [];
  for (var n = Math.pow(10, r), i = ce(t, function(h) {
    return (isNaN(h) ? 0 : h) / e * n * 100;
  }), a = n * 100, o = ce(i, function(h) {
    return Math.floor(h);
  }), s = Ma(o, function(h, p) {
    return h + p;
  }, 0), l = ce(i, function(h, p) {
    return h - o[p];
  }); s < a; ) {
    for (var u = Number.NEGATIVE_INFINITY, c = null, d = 0, f = l.length; d < f; ++d)
      l[d] > u && (u = l[d], c = d);
    ++o[c], l[c] = 0, ++s;
  }
  return ce(o, function(h) {
    return h / n;
  });
}
function y$(t, r) {
  var e = Math.max(Ya(t), Ya(r)), n = t + r;
  return e > yN ? n : Or(n, e);
}
var VC = 9007199254740991;
function L7(t) {
  var r = Math.PI * 2;
  return (t % r + r) % r;
}
function Af(t) {
  return t > -cS && t < cS;
}
var b$ = /^(?:(\d{4})(?:[-\/](\d{1,2})(?:[-\/](\d{1,2})(?:[T ](\d{1,2})(?::(\d{1,2})(?::(\d{1,2})(?:[.,](\d+))?)?)?(Z|[\+\-]\d\d:?\d\d)?)?)?)?)?$/;
function ra(t) {
  if (t instanceof Date)
    return t;
  if (pe(t)) {
    var r = b$.exec(t);
    if (!r)
      return /* @__PURE__ */ new Date(NaN);
    if (r[8]) {
      var e = +r[4] || 0;
      return r[8].toUpperCase() !== "Z" && (e -= +r[8].slice(0, 3)), new Date(Date.UTC(+r[1], +(r[2] || 1) - 1, +r[3] || 1, e, +(r[5] || 0), +r[6] || 0, r[7] ? +r[7].substring(0, 3) : 0));
    } else
      return new Date(+r[1], +(r[2] || 1) - 1, +r[3] || 1, +r[4] || 0, +(r[5] || 0), +r[6] || 0, r[7] ? +r[7].substring(0, 3) : 0);
  } else if (t == null)
    return /* @__PURE__ */ new Date(NaN);
  return new Date(Math.round(t));
}
function CN(t) {
  return Math.pow(10, dg(t));
}
function dg(t) {
  if (t === 0)
    return 0;
  var r = Math.floor(Math.log(t) / Math.LN10);
  return t / Math.pow(10, r) >= 10 && r++, r;
}
function E7(t, r) {
  var e = dg(t), n = Math.pow(10, e), i = t / n, a;
  return r ? i < 1.5 ? a = 1 : i < 2.5 ? a = 2 : i < 4 ? a = 3 : i < 7 ? a = 5 : a = 10 : i < 1 ? a = 1 : i < 2 ? a = 2 : i < 3 ? a = 3 : i < 5 ? a = 5 : a = 10, t = a * n, e >= -20 ? +t.toFixed(e < 0 ? -e : 0) : t;
}
function D0(t, r) {
  var e = (t.length - 1) * r + 1, n = Math.floor(e), i = +t[n - 1], a = e - n;
  return a ? i + a * (t[n] - i) : i;
}
function GC(t) {
  t.sort(function(l, u) {
    return s(l, u, 0) ? -1 : 1;
  });
  for (var r = -1 / 0, e = 1, n = 0; n < t.length; ) {
    for (var i = t[n].interval, a = t[n].close, o = 0; o < 2; o++)
      i[o] <= r && (i[o] = r, a[o] = o ? 1 : 1 - e), r = i[o], e = a[o];
    i[0] === i[1] && a[0] * a[1] !== 1 ? t.splice(n, 1) : n++;
  }
  return t;
  function s(l, u, c) {
    return l.interval[c] < u.interval[c] || l.interval[c] === u.interval[c] && (l.close[c] - u.close[c] === (c ? -1 : 1) || !c && s(l, u, 1));
  }
}
function qo(t) {
  var r = parseFloat(t);
  return r == t && (r !== 0 || !pe(t) || t.indexOf("x") <= 0) ? r : NaN;
}
function r2(t) {
  return !isNaN(qo(t));
}
function wN() {
  return Math.round(Math.random() * 9);
}
function _N(t, r) {
  return r === 0 ? t : _N(r, t % r);
}
function dS(t, r) {
  return t == null ? r : r == null ? t : t * r / _N(t, r);
}
var C$ = "[ECharts] ", fS = {}, w$ = typeof console < "u" && console.warn && console.log;
function n2(t, r, e) {
  if (w$) {
    if (e) {
      if (fS[r])
        return;
      fS[r] = !0;
    }
    console[t](C$ + r);
  }
}
function _$(t, r) {
  n2("log", t, r);
}
function Mr(t, r) {
  n2("warn", t, r);
}
function jn(t, r) {
  n2("error", t, r);
}
function Ra(t) {
  process.env.NODE_ENV !== "production" && n2("warn", "DEPRECATED: " + t, !0);
}
function qr(t, r, e) {
  process.env.NODE_ENV !== "production" && Ra((e ? "[" + e + "]" : "") + (t + " is deprecated, use " + r + " instead."));
}
function _i() {
  for (var t = [], r = 0; r < arguments.length; r++)
    t[r] = arguments[r];
  var e = "";
  if (process.env.NODE_ENV !== "production") {
    var n = function(i) {
      return i === void 0 ? "undefined" : i === 1 / 0 ? "Infinity" : i === -1 / 0 ? "-Infinity" : ql(i) ? "NaN" : i instanceof Date ? "Date(" + i.toISOString() + ")" : Ae(i) ? "function () { ... }" : _7(i) ? i + "" : null;
    };
    e = ce(t, function(i) {
      if (pe(i))
        return i;
      var a = n(i);
      if (a != null)
        return a;
      if (typeof JSON < "u" && JSON.stringify)
        try {
          return JSON.stringify(i, function(o, s) {
            var l = n(s);
            return l ?? s;
          });
        } catch {
          return "?";
        }
      else
        return "?";
    }).join(" ");
  }
  return e;
}
function Gt(t) {
  throw new Error(t);
}
function hS(t, r, e) {
  return (r - t) * e + t;
}
var xN = "series\0", SN = "\0_ec_\0";
function Qt(t) {
  return t instanceof Array ? t : t == null ? [] : [t];
}
function Vc(t, r, e) {
  if (t) {
    t[r] = t[r] || {}, t.emphasis = t.emphasis || {}, t.emphasis[r] = t.emphasis[r] || {};
    for (var n = 0, i = e.length; n < i; n++) {
      var a = e[n];
      !t.emphasis[r].hasOwnProperty(a) && t[r].hasOwnProperty(a) && (t.emphasis[r][a] = t[r][a]);
    }
  }
}
var pS = ["fontStyle", "fontWeight", "fontSize", "fontFamily", "rich", "tag", "color", "textBorderColor", "textBorderWidth", "width", "height", "lineHeight", "align", "verticalAlign", "baseline", "shadowColor", "shadowBlur", "shadowOffsetX", "shadowOffsetY", "textShadowColor", "textShadowBlur", "textShadowOffsetX", "textShadowOffsetY", "backgroundColor", "borderColor", "borderWidth", "borderRadius", "padding"];
function qf(t) {
  return Me(t) && !ue(t) && !(t instanceof Date) ? t.value : t;
}
function x$(t) {
  return Me(t) && !(t instanceof Array);
}
function IN(t, r, e) {
  var n = e === "normalMerge", i = e === "replaceMerge", a = e === "replaceAll";
  t = t || [], r = (r || []).slice();
  var o = xe();
  L(r, function(l, u) {
    if (!Me(l)) {
      r[u] = null;
      return;
    }
    process.env.NODE_ENV !== "production" && (l.id != null && !gS(l.id) && vS(l.id), l.name != null && !gS(l.name) && vS(l.name));
  });
  var s = S$(t, o, e);
  return (n || i) && I$(s, t, o, r), n && A$(s, r), n || i ? D$(s, r, i) : a && T$(s, r), M$(s), s;
}
function S$(t, r, e) {
  var n = [];
  if (e === "replaceAll")
    return n;
  for (var i = 0; i < t.length; i++) {
    var a = t[i];
    a && a.id != null && r.set(a.id, i), n.push({
      existing: e === "replaceMerge" || Df(a) ? null : a,
      newOption: null,
      keyInfo: null,
      brandNew: null
    });
  }
  return n;
}
function I$(t, r, e, n) {
  L(n, function(i, a) {
    if (!(!i || i.id == null)) {
      var o = $p(i.id), s = e.get(o);
      if (s != null) {
        var l = t[s];
        ke(!l.newOption, 'Duplicated option on id "' + o + '".'), l.newOption = i, l.existing = r[s], n[a] = null;
      }
    }
  });
}
function A$(t, r) {
  L(r, function(e, n) {
    if (!(!e || e.name == null))
      for (var i = 0; i < t.length; i++) {
        var a = t[i].existing;
        if (!t[i].newOption && a && (a.id == null || e.id == null) && !Df(e) && !Df(a) && AN("name", a, e)) {
          t[i].newOption = e, r[n] = null;
          return;
        }
      }
  });
}
function D$(t, r, e) {
  L(r, function(n) {
    if (n) {
      for (
        var i, a = 0;
        // Be `!resultItem` only when `nextIdx >= result.length`.
        (i = t[a]) && (i.newOption || Df(i.existing) || // In mode "replaceMerge", here no not-mapped-non-internal-existing.
        i.existing && n.id != null && !AN("id", n, i.existing));
      )
        a++;
      i ? (i.newOption = n, i.brandNew = e) : t.push({
        newOption: n,
        brandNew: e,
        existing: null,
        keyInfo: null
      }), a++;
    }
  });
}
function T$(t, r) {
  L(r, function(e) {
    t.push({
      newOption: e,
      brandNew: !0,
      existing: null,
      keyInfo: null
    });
  });
}
function M$(t) {
  var r = xe();
  L(t, function(e) {
    var n = e.existing;
    n && r.set(n.id, e);
  }), L(t, function(e) {
    var n = e.newOption;
    ke(!n || n.id == null || !r.get(n.id) || r.get(n.id) === e, "id duplicates: " + (n && n.id)), n && n.id != null && r.set(n.id, e), !e.keyInfo && (e.keyInfo = {});
  }), L(t, function(e, n) {
    var i = e.existing, a = e.newOption, o = e.keyInfo;
    if (Me(a)) {
      if (o.name = a.name != null ? $p(a.name) : i ? i.name : xN + n, i)
        o.id = $p(i.id);
      else if (a.id != null)
        o.id = $p(a.id);
      else {
        var s = 0;
        do
          o.id = "\0" + o.name + "\0" + s++;
        while (r.get(o.id));
      }
      r.set(o.id, e);
    }
  });
}
function AN(t, r, e) {
  var n = vn(r[t], null), i = vn(e[t], null);
  return n != null && i != null && n === i;
}
function $p(t) {
  if (process.env.NODE_ENV !== "production" && t == null)
    throw new Error();
  return vn(t, "");
}
function vn(t, r) {
  return t == null ? r : pe(t) ? t : Mt(t) || dv(t) ? t + "" : r;
}
function vS(t) {
  process.env.NODE_ENV !== "production" && Mr("`" + t + "` is invalid id or name. Must be a string or number.");
}
function gS(t) {
  return dv(t) || r2(t);
}
function k7(t) {
  var r = t.name;
  return !!(r && r.indexOf(xN));
}
function Df(t) {
  return t && t.id != null && $p(t.id).indexOf(SN) === 0;
}
function R$(t) {
  return SN + t;
}
function L$(t, r, e) {
  L(t, function(n) {
    var i = n.newOption;
    Me(i) && (n.keyInfo.mainType = r, n.keyInfo.subType = E$(r, i, n.existing, e));
  });
}
function E$(t, r, e, n) {
  var i = r.type ? r.type : e ? e.subType : n.determineSubType(t, r);
  return i;
}
function k$(t, r) {
  var e = {}, n = {};
  return i(t || [], e), i(r || [], n, e), [a(e), a(n)];
  function i(o, s, l) {
    for (var u = 0, c = o.length; u < c; u++) {
      var d = vn(o[u].seriesId, null);
      if (d == null)
        return;
      for (var f = Qt(o[u].dataIndex), h = l && l[d], p = 0, v = f.length; p < v; p++) {
        var g = f[p];
        h && h[g] ? h[g] = null : (s[d] || (s[d] = {}))[g] = 1;
      }
    }
  }
  function a(o, s) {
    var l = [];
    for (var u in o)
      if (o.hasOwnProperty(u) && o[u] != null)
        if (s)
          l.push(+u);
        else {
          var c = a(o[u], !0);
          c.length && l.push({
            seriesId: u,
            dataIndex: c
          });
        }
    return l;
  }
}
function Gc(t, r) {
  if (r.dataIndexInside != null)
    return r.dataIndexInside;
  if (r.dataIndex != null)
    return ue(r.dataIndex) ? ce(r.dataIndex, function(e) {
      return t.indexOfRawIndex(e);
    }) : t.indexOfRawIndex(r.dataIndex);
  if (r.name != null)
    return ue(r.name) ? ce(r.name, function(e) {
      return t.indexOfName(e);
    }) : t.indexOfName(r.name);
}
function It() {
  var t = "__ec_inner_" + P$++;
  return function(r) {
    return r[t] || (r[t] = {});
  };
}
var P$ = wN();
function Up(t, r, e) {
  var n = P7(r, e), i = n.mainTypeSpecified, a = n.queryOptionMap, o = n.others, s = o, l = e ? e.defaultMainType : null;
  return !i && l && a.set(l, {}), a.each(function(u, c) {
    var d = fg(t, c, u, {
      useDefault: l === c,
      enableAll: e && e.enableAll != null ? e.enableAll : !0,
      enableNone: e && e.enableNone != null ? e.enableNone : !0
    });
    s[c + "Models"] = d.models, s[c + "Model"] = d.models[0];
  }), s;
}
function P7(t, r) {
  var e;
  if (pe(t)) {
    var n = {};
    n[t + "Index"] = 0, e = n;
  } else
    e = t;
  var i = xe(), a = {}, o = !1;
  return L(e, function(s, l) {
    if (l === "dataIndex" || l === "dataIndexInside") {
      a[l] = s;
      return;
    }
    var u = l.match(/^(\w+)(Index|Id|Name)$/) || [], c = u[1], d = (u[2] || "").toLowerCase();
    if (!(!c || !d || r && r.includeMainTypes && nt(r.includeMainTypes, c) < 0)) {
      o = o || !!c;
      var f = i.get(c) || i.set(c, {});
      f[d] = s;
    }
  }), {
    mainTypeSpecified: o,
    queryOptionMap: i,
    others: a
  };
}
var on = {
  useDefault: !0,
  enableAll: !1,
  enableNone: !1
}, N$ = {
  useDefault: !1,
  enableAll: !0,
  enableNone: !0
};
function fg(t, r, e, n) {
  n = n || on;
  var i = e.index, a = e.id, o = e.name, s = {
    models: null,
    specified: i != null || a != null || o != null
  };
  if (!s.specified) {
    var l = void 0;
    return s.models = n.useDefault && (l = t.getComponent(r)) ? [l] : [], s;
  }
  return i === "none" || i === !1 ? (ke(n.enableNone, '`"none"` or `false` is not a valid value on index option.'), s.models = [], s) : (i === "all" && (ke(n.enableAll, '`"all"` is not a valid value on index option.'), i = a = o = null), s.models = t.queryComponents({
    mainType: r,
    index: i,
    id: a,
    name: o
  }), s);
}
function DN(t, r, e) {
  t.setAttribute ? t.setAttribute(r, e) : t[r] = e;
}
function O$(t, r) {
  return t.getAttribute ? t.getAttribute(r) : t[r];
}
function V$(t) {
  return t === "auto" ? vt.domSupported ? "html" : "richText" : t || "html";
}
function BC(t, r) {
  var e = xe(), n = [];
  return L(t, function(i) {
    var a = r(i);
    (e.get(a) || (n.push(a), e.set(a, []))).push(i);
  }), {
    keys: n,
    buckets: e
  };
}
function TN(t, r, e, n, i) {
  var a = r == null || r === "auto";
  if (n == null)
    return n;
  if (Mt(n)) {
    var o = hS(e || 0, n, i);
    return Or(o, a ? Math.max(Ya(e || 0), Ya(n)) : r);
  } else {
    if (pe(n))
      return i < 1 ? e : n;
    for (var s = [], l = e, u = n, c = Math.max(l ? l.length : 0, u.length), d = 0; d < c; ++d) {
      var f = t.getDimensionInfo(d);
      if (f && f.type === "ordinal")
        s[d] = (i < 1 && l ? l : u)[d];
      else {
        var h = l && l[d] ? l[d] : 0, p = u[d], o = hS(h, p, i);
        s[d] = Or(o, a ? Math.max(Ya(h), Ya(p)) : r);
      }
    }
    return s;
  }
}
var G$ = ".", Tu = "___EC__COMPONENT__CONTAINER___", MN = "___EC__EXTENDED_CLASS___";
function No(t) {
  var r = {
    main: "",
    sub: ""
  };
  if (t) {
    var e = t.split(G$);
    r.main = e[0] || "", r.sub = e[1] || "";
  }
  return r;
}
function B$(t) {
  ke(/^[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)?$/.test(t), 'componentType "' + t + '" illegal');
}
function F$(t) {
  return !!(t && t[MN]);
}
function N7(t, r) {
  t.$constructor = t, t.extend = function(e) {
    process.env.NODE_ENV !== "production" && L(r, function(a) {
      e[a] || console.warn("Method `" + a + "` should be implemented" + (e.type ? " in " + e.type : "") + ".");
    });
    var n = this, i;
    return H$(n) ? i = /** @class */
    function(a) {
      ee(o, a);
      function o() {
        return a.apply(this, arguments) || this;
      }
      return o;
    }(n) : (i = function() {
      (e.$constructor || n).apply(this, arguments);
    }, w7(i, this)), ae(i.prototype, e), i[MN] = !0, i.extend = this.extend, i.superCall = Z$, i.superApply = j$, i.superClass = n, i;
  };
}
function H$(t) {
  return Ae(t) && /^class\s/.test(Function.prototype.toString.call(t));
}
function RN(t, r) {
  t.extend = r.extend;
}
var z$ = Math.round(Math.random() * 10);
function W$(t) {
  var r = ["__\0is_clz", z$++].join("_");
  t.prototype[r] = !0, process.env.NODE_ENV !== "production" && ke(!t.isInstance, 'The method "is" can not be defined.'), t.isInstance = function(e) {
    return !!(e && e[r]);
  };
}
function Z$(t, r) {
  for (var e = [], n = 2; n < arguments.length; n++)
    e[n - 2] = arguments[n];
  return this.superClass.prototype[r].apply(t, e);
}
function j$(t, r, e) {
  return this.superClass.prototype[r].apply(t, e);
}
function i2(t) {
  var r = {};
  t.registerClass = function(n) {
    var i = n.type || n.prototype.type;
    if (i) {
      B$(i), n.prototype.type = i;
      var a = No(i);
      if (!a.sub)
        process.env.NODE_ENV !== "production" && r[a.main] && console.warn(a.main + " exists."), r[a.main] = n;
      else if (a.sub !== Tu) {
        var o = e(a);
        o[a.sub] = n;
      }
    }
    return n;
  }, t.getClass = function(n, i, a) {
    var o = r[n];
    if (o && o[Tu] && (o = i ? o[i] : null), a && !o)
      throw new Error(i ? "Component " + n + "." + (i || "") + " is used but not imported." : n + ".type should be specified.");
    return o;
  }, t.getClassesByMainType = function(n) {
    var i = No(n), a = [], o = r[i.main];
    return o && o[Tu] ? L(o, function(s, l) {
      l !== Tu && a.push(s);
    }) : a.push(o), a;
  }, t.hasClass = function(n) {
    var i = No(n);
    return !!r[i.main];
  }, t.getAllClassMainTypes = function() {
    var n = [];
    return L(r, function(i, a) {
      n.push(a);
    }), n;
  }, t.hasSubTypes = function(n) {
    var i = No(n), a = r[i.main];
    return a && a[Tu];
  };
  function e(n) {
    var i = r[n.main];
    return (!i || !i[Tu]) && (i = r[n.main] = {}, i[Tu] = !0), i;
  }
}
function Bc(t, r) {
  for (var e = 0; e < t.length; e++)
    t[e][1] || (t[e][1] = t[e][0]);
  return r = r || !1, function(n, i, a) {
    for (var o = {}, s = 0; s < t.length; s++) {
      var l = t[s][1];
      if (!(i && nt(i, l) >= 0 || a && nt(a, l) < 0)) {
        var u = n.getShallow(l, r);
        u != null && (o[t[s][0]] = u);
      }
    }
    return o;
  };
}
var Y$ = [
  ["fill", "color"],
  ["shadowBlur"],
  ["shadowOffsetX"],
  ["shadowOffsetY"],
  ["opacity"],
  ["shadowColor"]
  // Option decal is in `DecalObject` but style.decal is in `PatternObject`.
  // So do not transfer decal directly.
], X$ = Bc(Y$), $$ = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.getAreaStyle = function(r, e) {
      return X$(this, r, e);
    }, t;
  }()
), FC = new ug(50);
function U$(t) {
  if (typeof t == "string") {
    var r = FC.get(t);
    return r && r.image;
  } else
    return t;
}
function O7(t, r, e, n, i) {
  if (t)
    if (typeof t == "string") {
      if (r && r.__zrImageSrc === t || !e)
        return r;
      var a = FC.get(t), o = { hostEl: e, cb: n, cbPayload: i };
      return a ? (r = a.image, !a2(r) && a.pending.push(o)) : (r = Qa.loadImage(t, mS, mS), r.__zrImageSrc = t, FC.put(t, r.__cachedImgObj = {
        image: r,
        pending: [o]
      })), r;
    } else
      return t;
  else return r;
}
function mS() {
  var t = this.__cachedImgObj;
  this.onload = this.onerror = this.__cachedImgObj = null;
  for (var r = 0; r < t.pending.length; r++) {
    var e = t.pending[r], n = e.cb;
    n && n(this, e.cbPayload), e.hostEl.dirty();
  }
  t.pending.length = 0;
}
function a2(t) {
  return t && t.width && t.height;
}
var Z5 = /\{([a-zA-Z0-9_]+)\|([^}]*)\}/g;
function LN(t, r, e, n, i) {
  if (!r)
    return "";
  var a = (t + "").split(`
`);
  i = EN(r, e, n, i);
  for (var o = 0, s = a.length; o < s; o++)
    a[o] = kN(a[o], i);
  return a.join(`
`);
}
function EN(t, r, e, n) {
  n = n || {};
  var i = ae({}, n);
  i.font = r, e = je(e, "..."), i.maxIterations = je(n.maxIterations, 2);
  var a = i.minChar = je(n.minChar, 0);
  i.cnCharWidth = qi("国", r);
  var o = i.ascCharWidth = qi("a", r);
  i.placeholder = je(n.placeholder, "");
  for (var s = t = Math.max(0, t - 1), l = 0; l < a && s >= o; l++)
    s -= o;
  var u = qi(e, r);
  return u > s && (e = "", u = 0), s = t - u, i.ellipsis = e, i.ellipsisWidth = u, i.contentWidth = s, i.containerWidth = t, i;
}
function kN(t, r) {
  var e = r.containerWidth, n = r.font, i = r.contentWidth;
  if (!e)
    return "";
  var a = qi(t, n);
  if (a <= e)
    return t;
  for (var o = 0; ; o++) {
    if (a <= i || o >= r.maxIterations) {
      t += r.ellipsis;
      break;
    }
    var s = o === 0 ? J$(t, i, r.ascCharWidth, r.cnCharWidth) : a > 0 ? Math.floor(t.length * i / a) : 0;
    t = t.substr(0, s), a = qi(t, n);
  }
  return t === "" && (t = r.placeholder), t;
}
function J$(t, r, e, n) {
  for (var i = 0, a = 0, o = t.length; a < o && i < r; a++) {
    var s = t.charCodeAt(a);
    i += 0 <= s && s <= 127 ? e : n;
  }
  return a;
}
function K$(t, r) {
  t != null && (t += "");
  var e = r.overflow, n = r.padding, i = r.font, a = e === "truncate", o = e2(i), s = je(r.lineHeight, o), l = !!r.backgroundColor, u = r.lineOverflow === "truncate", c = r.width, d;
  c != null && (e === "break" || e === "breakAll") ? d = t ? PN(t, r.font, c, e === "breakAll", 0).lines : [] : d = t ? t.split(`
`) : [];
  var f = d.length * s, h = je(r.height, f);
  if (f > h && u) {
    var p = Math.floor(h / s);
    d = d.slice(0, p);
  }
  if (t && a && c != null)
    for (var v = EN(c, i, r.ellipsis, {
      minChar: r.truncateMinChar,
      placeholder: r.placeholder
    }), g = 0; g < d.length; g++)
      d[g] = kN(d[g], v);
  for (var m = h, y = 0, g = 0; g < d.length; g++)
    y = Math.max(qi(d[g], i), y);
  c == null && (c = y);
  var b = y;
  return n && (m += n[0] + n[2], b += n[1] + n[3], c += n[1] + n[3]), l && (b = c), {
    lines: d,
    height: h,
    outerWidth: b,
    outerHeight: m,
    lineHeight: s,
    calculatedLineHeight: o,
    contentWidth: y,
    contentHeight: f,
    width: c
  };
}
var q$ = /* @__PURE__ */ function() {
  function t() {
  }
  return t;
}(), yS = /* @__PURE__ */ function() {
  function t(r) {
    this.tokens = [], r && (this.tokens = r);
  }
  return t;
}(), Q$ = /* @__PURE__ */ function() {
  function t() {
    this.width = 0, this.height = 0, this.contentWidth = 0, this.contentHeight = 0, this.outerWidth = 0, this.outerHeight = 0, this.lines = [];
  }
  return t;
}();
function eU(t, r) {
  var e = new Q$();
  if (t != null && (t += ""), !t)
    return e;
  for (var n = r.width, i = r.height, a = r.overflow, o = (a === "break" || a === "breakAll") && n != null ? { width: n, accumWidth: 0, breakAll: a === "breakAll" } : null, s = Z5.lastIndex = 0, l; (l = Z5.exec(t)) != null; ) {
    var u = l.index;
    u > s && j5(e, t.substring(s, u), r, o), j5(e, l[2], r, o, l[1]), s = Z5.lastIndex;
  }
  s < t.length && j5(e, t.substring(s, t.length), r, o);
  var c = [], d = 0, f = 0, h = r.padding, p = a === "truncate", v = r.lineOverflow === "truncate";
  function g(O, W, V) {
    O.width = W, O.lineHeight = V, d += V, f = Math.max(f, W);
  }
  e: for (var m = 0; m < e.lines.length; m++) {
    for (var y = e.lines[m], b = 0, C = 0, w = 0; w < y.tokens.length; w++) {
      var _ = y.tokens[w], x = _.styleName && r.rich[_.styleName] || {}, I = _.textPadding = x.padding, D = I ? I[1] + I[3] : 0, T = _.font = x.font || r.font;
      _.contentHeight = e2(T);
      var A = je(x.height, _.contentHeight);
      if (_.innerHeight = A, I && (A += I[0] + I[2]), _.height = A, _.lineHeight = Ki(x.lineHeight, r.lineHeight, A), _.align = x && x.align || r.align, _.verticalAlign = x && x.verticalAlign || "middle", v && i != null && d + _.lineHeight > i) {
        w > 0 ? (y.tokens = y.tokens.slice(0, w), g(y, C, b), e.lines = e.lines.slice(0, m + 1)) : e.lines = e.lines.slice(0, m);
        break e;
      }
      var M = x.width, R = M == null || M === "auto";
      if (typeof M == "string" && M.charAt(M.length - 1) === "%")
        _.percentWidth = M, c.push(_), _.contentWidth = qi(_.text, T);
      else {
        if (R) {
          var E = x.backgroundColor, k = E && E.image;
          k && (k = U$(k), a2(k) && (_.width = Math.max(_.width, k.width * A / k.height)));
        }
        var P = p && n != null ? n - C : null;
        P != null && P < _.width ? !R || P < D ? (_.text = "", _.width = _.contentWidth = 0) : (_.text = LN(_.text, P - D, T, r.ellipsis, { minChar: r.truncateMinChar }), _.width = _.contentWidth = qi(_.text, T)) : _.contentWidth = qi(_.text, T);
      }
      _.width += D, C += _.width, x && (b = Math.max(b, _.lineHeight));
    }
    g(y, C, b);
  }
  e.outerWidth = e.width = je(n, f), e.outerHeight = e.height = je(i, d), e.contentHeight = d, e.contentWidth = f, h && (e.outerWidth += h[1] + h[3], e.outerHeight += h[0] + h[2]);
  for (var m = 0; m < c.length; m++) {
    var _ = c[m], N = _.percentWidth;
    _.width = parseInt(N, 10) / 100 * e.width;
  }
  return e;
}
function j5(t, r, e, n, i) {
  var a = r === "", o = i && e.rich[i] || {}, s = t.lines, l = o.font || e.font, u = !1, c, d;
  if (n) {
    var f = o.padding, h = f ? f[1] + f[3] : 0;
    if (o.width != null && o.width !== "auto") {
      var p = to(o.width, n.width) + h;
      s.length > 0 && p + n.accumWidth > n.width && (c = r.split(`
`), u = !0), n.accumWidth = p;
    } else {
      var v = PN(r, l, n.width, n.breakAll, n.accumWidth);
      n.accumWidth = v.accumWidth + h, d = v.linesWidths, c = v.lines;
    }
  } else
    c = r.split(`
`);
  for (var g = 0; g < c.length; g++) {
    var m = c[g], y = new q$();
    if (y.styleName = i, y.text = m, y.isLineHolder = !m && !a, typeof o.width == "number" ? y.width = o.width : y.width = d ? d[g] : qi(m, l), !g && !u) {
      var b = (s[s.length - 1] || (s[0] = new yS())).tokens, C = b.length;
      C === 1 && b[0].isLineHolder ? b[0] = y : (m || !C || a) && b.push(y);
    } else
      s.push(new yS([y]));
  }
}
function tU(t) {
  var r = t.charCodeAt(0);
  return r >= 32 && r <= 591 || r >= 880 && r <= 4351 || r >= 4608 && r <= 5119 || r >= 7680 && r <= 8303;
}
var rU = Ma(",&?/;] ".split(""), function(t, r) {
  return t[r] = !0, t;
}, {});
function nU(t) {
  return tU(t) ? !!rU[t] : !0;
}
function PN(t, r, e, n, i) {
  for (var a = [], o = [], s = "", l = "", u = 0, c = 0, d = 0; d < t.length; d++) {
    var f = t.charAt(d);
    if (f === `
`) {
      l && (s += l, c += u), a.push(s), o.push(c), s = "", l = "", u = 0, c = 0;
      continue;
    }
    var h = qi(f, r), p = n ? !1 : !nU(f);
    if (a.length ? c + h > e : i + c + h > e) {
      c ? (s || l) && (p ? (s || (s = l, l = "", u = 0, c = u), a.push(s), o.push(c - u), l += f, u += h, s = "", c = u) : (l && (s += l, l = "", u = 0), a.push(s), o.push(c), s = f, c = h)) : p ? (a.push(l), o.push(u), l = f, u = h) : (a.push(f), o.push(h));
      continue;
    }
    c += h, p ? (l += f, u += h) : (l && (s += l, l = "", u = 0), s += f);
  }
  return !a.length && !s && (s = t, l = "", u = 0), l && (s += l), s && (a.push(s), o.push(c)), a.length === 1 && (c += i), {
    accumWidth: c,
    lines: a,
    linesWidths: o
  };
}
var HC = "__zr_style_" + Math.round(Math.random() * 10), xc = {
  shadowBlur: 0,
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  shadowColor: "#000",
  opacity: 1,
  blend: "source-over"
}, o2 = {
  style: {
    shadowBlur: !0,
    shadowOffsetX: !0,
    shadowOffsetY: !0,
    shadowColor: !0,
    opacity: !0
  }
};
xc[HC] = !0;
var bS = ["z", "z2", "invisible"], iU = ["invisible"], La = function(t) {
  _r(r, t);
  function r(e) {
    return t.call(this, e) || this;
  }
  return r.prototype._init = function(e) {
    for (var n = yt(e), i = 0; i < n.length; i++) {
      var a = n[i];
      a === "style" ? this.useStyle(e[a]) : t.prototype.attrKV.call(this, a, e[a]);
    }
    this.style || this.useStyle({});
  }, r.prototype.beforeBrush = function() {
  }, r.prototype.afterBrush = function() {
  }, r.prototype.innerBeforeBrush = function() {
  }, r.prototype.innerAfterBrush = function() {
  }, r.prototype.shouldBePainted = function(e, n, i, a) {
    var o = this.transform;
    if (this.ignore || this.invisible || this.style.opacity === 0 || this.culling && aU(this, e, n) || o && !o[0] && !o[3])
      return !1;
    if (i && this.__clipPaths) {
      for (var s = 0; s < this.__clipPaths.length; ++s)
        if (this.__clipPaths[s].isZeroArea())
          return !1;
    }
    if (a && this.parent)
      for (var l = this.parent; l; ) {
        if (l.ignore)
          return !1;
        l = l.parent;
      }
    return !0;
  }, r.prototype.contain = function(e, n) {
    return this.rectContain(e, n);
  }, r.prototype.traverse = function(e, n) {
    e.call(n, this);
  }, r.prototype.rectContain = function(e, n) {
    var i = this.transformCoordToLocal(e, n), a = this.getBoundingRect();
    return a.contain(i[0], i[1]);
  }, r.prototype.getPaintRect = function() {
    var e = this._paintRect;
    if (!this._paintRect || this.__dirty) {
      var n = this.transform, i = this.getBoundingRect(), a = this.style, o = a.shadowBlur || 0, s = a.shadowOffsetX || 0, l = a.shadowOffsetY || 0;
      e = this._paintRect || (this._paintRect = new rt(0, 0, 0, 0)), n ? rt.applyTransform(e, i, n) : e.copy(i), (o || s || l) && (e.width += o * 2 + Math.abs(s), e.height += o * 2 + Math.abs(l), e.x = Math.min(e.x, e.x + s - o), e.y = Math.min(e.y, e.y + l - o));
      var u = this.dirtyRectTolerance;
      e.isZero() || (e.x = Math.floor(e.x - u), e.y = Math.floor(e.y - u), e.width = Math.ceil(e.width + 1 + u * 2), e.height = Math.ceil(e.height + 1 + u * 2));
    }
    return e;
  }, r.prototype.setPrevPaintRect = function(e) {
    e ? (this._prevPaintRect = this._prevPaintRect || new rt(0, 0, 0, 0), this._prevPaintRect.copy(e)) : this._prevPaintRect = null;
  }, r.prototype.getPrevPaintRect = function() {
    return this._prevPaintRect;
  }, r.prototype.animateStyle = function(e) {
    return this.animate("style", e);
  }, r.prototype.updateDuringAnimation = function(e) {
    e === "style" ? this.dirtyStyle() : this.markRedraw();
  }, r.prototype.attrKV = function(e, n) {
    e !== "style" ? t.prototype.attrKV.call(this, e, n) : this.style ? this.setStyle(n) : this.useStyle(n);
  }, r.prototype.setStyle = function(e, n) {
    return typeof e == "string" ? this.style[e] = n : ae(this.style, e), this.dirtyStyle(), this;
  }, r.prototype.dirtyStyle = function(e) {
    e || this.markRedraw(), this.__dirty |= Sp, this._rect && (this._rect = null);
  }, r.prototype.dirty = function() {
    this.dirtyStyle();
  }, r.prototype.styleChanged = function() {
    return !!(this.__dirty & Sp);
  }, r.prototype.styleUpdated = function() {
    this.__dirty &= ~Sp;
  }, r.prototype.createStyle = function(e) {
    return sg(xc, e);
  }, r.prototype.useStyle = function(e) {
    e[HC] || (e = this.createStyle(e)), this.__inHover ? this.__hoverStyle = e : this.style = e, this.dirtyStyle();
  }, r.prototype.isStyleObject = function(e) {
    return e[HC];
  }, r.prototype._innerSaveToNormal = function(e) {
    t.prototype._innerSaveToNormal.call(this, e);
    var n = this._normalState;
    e.style && !n.style && (n.style = this._mergeStyle(this.createStyle(), this.style)), this._savePrimaryToNormal(e, n, bS);
  }, r.prototype._applyStateObj = function(e, n, i, a, o, s) {
    t.prototype._applyStateObj.call(this, e, n, i, a, o, s);
    var l = !(n && a), u;
    if (n && n.style ? o ? a ? u = n.style : (u = this._mergeStyle(this.createStyle(), i.style), this._mergeStyle(u, n.style)) : (u = this._mergeStyle(this.createStyle(), a ? this.style : i.style), this._mergeStyle(u, n.style)) : l && (u = i.style), u)
      if (o) {
        var c = this.style;
        if (this.style = this.createStyle(l ? {} : c), l)
          for (var d = yt(c), f = 0; f < d.length; f++) {
            var h = d[f];
            h in u && (u[h] = u[h], this.style[h] = c[h]);
          }
        for (var p = yt(u), f = 0; f < p.length; f++) {
          var h = p[f];
          this.style[h] = this.style[h];
        }
        this._transitionState(e, {
          style: u
        }, s, this.getAnimationStyleProps());
      } else
        this.useStyle(u);
    for (var v = this.__inHover ? iU : bS, f = 0; f < v.length; f++) {
      var h = v[f];
      n && n[h] != null ? this[h] = n[h] : l && i[h] != null && (this[h] = i[h]);
    }
  }, r.prototype._mergeStates = function(e) {
    for (var n = t.prototype._mergeStates.call(this, e), i, a = 0; a < e.length; a++) {
      var o = e[a];
      o.style && (i = i || {}, this._mergeStyle(i, o.style));
    }
    return i && (n.style = i), n;
  }, r.prototype._mergeStyle = function(e, n) {
    return ae(e, n), e;
  }, r.prototype.getAnimationStyleProps = function() {
    return o2;
  }, r.initDefaultProps = function() {
    var e = r.prototype;
    e.type = "displayable", e.invisible = !1, e.z = 0, e.z2 = 0, e.zlevel = 0, e.culling = !1, e.cursor = "pointer", e.rectHover = !1, e.incremental = !1, e._rect = null, e.dirtyRectTolerance = 0, e.__dirty = ji | Sp;
  }(), r;
}(t2), Y5 = new rt(0, 0, 0, 0), X5 = new rt(0, 0, 0, 0);
function aU(t, r, e) {
  return Y5.copy(t.getBoundingRect()), t.transform && Y5.applyTransform(t.transform), X5.width = r, X5.height = e, !Y5.intersect(X5);
}
var Ei = Math.min, ki = Math.max, $5 = Math.sin, U5 = Math.cos, Mu = Math.PI * 2, s1 = fu(), l1 = fu(), u1 = fu();
function s2(t, r, e) {
  if (t.length !== 0) {
    for (var n = t[0], i = n[0], a = n[0], o = n[1], s = n[1], l = 1; l < t.length; l++)
      n = t[l], i = Ei(i, n[0]), a = ki(a, n[0]), o = Ei(o, n[1]), s = ki(s, n[1]);
    r[0] = i, r[1] = o, e[0] = a, e[1] = s;
  }
}
function CS(t, r, e, n, i, a) {
  i[0] = Ei(t, e), i[1] = Ei(r, n), a[0] = ki(t, e), a[1] = ki(r, n);
}
var wS = [], _S = [];
function oU(t, r, e, n, i, a, o, s, l, u) {
  var c = qP, d = bn, f = c(t, e, i, o, wS);
  l[0] = 1 / 0, l[1] = 1 / 0, u[0] = -1 / 0, u[1] = -1 / 0;
  for (var h = 0; h < f; h++) {
    var p = d(t, e, i, o, wS[h]);
    l[0] = Ei(p, l[0]), u[0] = ki(p, u[0]);
  }
  f = c(r, n, a, s, _S);
  for (var h = 0; h < f; h++) {
    var v = d(r, n, a, s, _S[h]);
    l[1] = Ei(v, l[1]), u[1] = ki(v, u[1]);
  }
  l[0] = Ei(t, l[0]), u[0] = ki(t, u[0]), l[0] = Ei(o, l[0]), u[0] = ki(o, u[0]), l[1] = Ei(r, l[1]), u[1] = ki(r, u[1]), l[1] = Ei(s, l[1]), u[1] = ki(s, u[1]);
}
function sU(t, r, e, n, i, a, o, s) {
  var l = eN, u = Rn, c = ki(Ei(l(t, e, i), 1), 0), d = ki(Ei(l(r, n, a), 1), 0), f = u(t, e, i, c), h = u(r, n, a, d);
  o[0] = Ei(t, i, f), o[1] = Ei(r, a, h), s[0] = ki(t, i, f), s[1] = ki(r, a, h);
}
function lU(t, r, e, n, i, a, o, s, l) {
  var u = Ms, c = Rs, d = Math.abs(i - a);
  if (d % Mu < 1e-4 && d > 1e-4) {
    s[0] = t - e, s[1] = r - n, l[0] = t + e, l[1] = r + n;
    return;
  }
  if (s1[0] = U5(i) * e + t, s1[1] = $5(i) * n + r, l1[0] = U5(a) * e + t, l1[1] = $5(a) * n + r, u(s, s1, l1), c(l, s1, l1), i = i % Mu, i < 0 && (i = i + Mu), a = a % Mu, a < 0 && (a = a + Mu), i > a && !o ? a += Mu : i < a && o && (i += Mu), o) {
    var f = a;
    a = i, i = f;
  }
  for (var h = 0; h < a; h += Math.PI / 2)
    h > i && (u1[0] = U5(h) * e + t, u1[1] = $5(h) * n + r, u(s, u1, s), c(l, u1, l));
}
var ur = {
  M: 1,
  L: 2,
  C: 3,
  Q: 4,
  A: 5,
  Z: 6,
  R: 7
}, Ru = [], Lu = [], mo = [], cl = [], yo = [], bo = [], J5 = Math.min, K5 = Math.max, Eu = Math.cos, ku = Math.sin, fs = Math.abs, zC = Math.PI, bl = zC * 2, q5 = typeof Float32Array < "u", Gh = [];
function Q5(t) {
  var r = Math.round(t / zC * 1e8) / 1e8;
  return r % 2 * zC;
}
function V7(t, r) {
  var e = Q5(t[0]);
  e < 0 && (e += bl);
  var n = e - t[0], i = t[1];
  i += n, !r && i - e >= bl ? i = e + bl : r && e - i >= bl ? i = e - bl : !r && e > i ? i = e + (bl - Q5(e - i)) : r && e < i && (i = e - (bl - Q5(i - e))), t[0] = e, t[1] = i;
}
var Qo = function() {
  function t(r) {
    this.dpr = 1, this._xi = 0, this._yi = 0, this._x0 = 0, this._y0 = 0, this._len = 0, r && (this._saveData = !1), this._saveData && (this.data = []);
  }
  return t.prototype.increaseVersion = function() {
    this._version++;
  }, t.prototype.getVersion = function() {
    return this._version;
  }, t.prototype.setScale = function(r, e, n) {
    n = n || 0, n > 0 && (this._ux = fs(n / vm / r) || 0, this._uy = fs(n / vm / e) || 0);
  }, t.prototype.setDPR = function(r) {
    this.dpr = r;
  }, t.prototype.setContext = function(r) {
    this._ctx = r;
  }, t.prototype.getContext = function() {
    return this._ctx;
  }, t.prototype.beginPath = function() {
    return this._ctx && this._ctx.beginPath(), this.reset(), this;
  }, t.prototype.reset = function() {
    this._saveData && (this._len = 0), this._pathSegLen && (this._pathSegLen = null, this._pathLen = 0), this._version++;
  }, t.prototype.moveTo = function(r, e) {
    return this._drawPendingPt(), this.addData(ur.M, r, e), this._ctx && this._ctx.moveTo(r, e), this._x0 = r, this._y0 = e, this._xi = r, this._yi = e, this;
  }, t.prototype.lineTo = function(r, e) {
    var n = fs(r - this._xi), i = fs(e - this._yi), a = n > this._ux || i > this._uy;
    if (this.addData(ur.L, r, e), this._ctx && a && this._ctx.lineTo(r, e), a)
      this._xi = r, this._yi = e, this._pendingPtDist = 0;
    else {
      var o = n * n + i * i;
      o > this._pendingPtDist && (this._pendingPtX = r, this._pendingPtY = e, this._pendingPtDist = o);
    }
    return this;
  }, t.prototype.bezierCurveTo = function(r, e, n, i, a, o) {
    return this._drawPendingPt(), this.addData(ur.C, r, e, n, i, a, o), this._ctx && this._ctx.bezierCurveTo(r, e, n, i, a, o), this._xi = a, this._yi = o, this;
  }, t.prototype.quadraticCurveTo = function(r, e, n, i) {
    return this._drawPendingPt(), this.addData(ur.Q, r, e, n, i), this._ctx && this._ctx.quadraticCurveTo(r, e, n, i), this._xi = n, this._yi = i, this;
  }, t.prototype.arc = function(r, e, n, i, a, o) {
    this._drawPendingPt(), Gh[0] = i, Gh[1] = a, V7(Gh, o), i = Gh[0], a = Gh[1];
    var s = a - i;
    return this.addData(ur.A, r, e, n, n, i, s, 0, o ? 0 : 1), this._ctx && this._ctx.arc(r, e, n, i, a, o), this._xi = Eu(a) * n + r, this._yi = ku(a) * n + e, this;
  }, t.prototype.arcTo = function(r, e, n, i, a) {
    return this._drawPendingPt(), this._ctx && this._ctx.arcTo(r, e, n, i, a), this;
  }, t.prototype.rect = function(r, e, n, i) {
    return this._drawPendingPt(), this._ctx && this._ctx.rect(r, e, n, i), this.addData(ur.R, r, e, n, i), this;
  }, t.prototype.closePath = function() {
    this._drawPendingPt(), this.addData(ur.Z);
    var r = this._ctx, e = this._x0, n = this._y0;
    return r && r.closePath(), this._xi = e, this._yi = n, this;
  }, t.prototype.fill = function(r) {
    r && r.fill(), this.toStatic();
  }, t.prototype.stroke = function(r) {
    r && r.stroke(), this.toStatic();
  }, t.prototype.len = function() {
    return this._len;
  }, t.prototype.setData = function(r) {
    var e = r.length;
    !(this.data && this.data.length === e) && q5 && (this.data = new Float32Array(e));
    for (var n = 0; n < e; n++)
      this.data[n] = r[n];
    this._len = e;
  }, t.prototype.appendPath = function(r) {
    r instanceof Array || (r = [r]);
    for (var e = r.length, n = 0, i = this._len, a = 0; a < e; a++)
      n += r[a].len();
    q5 && this.data instanceof Float32Array && (this.data = new Float32Array(i + n));
    for (var a = 0; a < e; a++)
      for (var o = r[a].data, s = 0; s < o.length; s++)
        this.data[i++] = o[s];
    this._len = i;
  }, t.prototype.addData = function(r, e, n, i, a, o, s, l, u) {
    if (this._saveData) {
      var c = this.data;
      this._len + arguments.length > c.length && (this._expandData(), c = this.data);
      for (var d = 0; d < arguments.length; d++)
        c[this._len++] = arguments[d];
    }
  }, t.prototype._drawPendingPt = function() {
    this._pendingPtDist > 0 && (this._ctx && this._ctx.lineTo(this._pendingPtX, this._pendingPtY), this._pendingPtDist = 0);
  }, t.prototype._expandData = function() {
    if (!(this.data instanceof Array)) {
      for (var r = [], e = 0; e < this._len; e++)
        r[e] = this.data[e];
      this.data = r;
    }
  }, t.prototype.toStatic = function() {
    if (this._saveData) {
      this._drawPendingPt();
      var r = this.data;
      r instanceof Array && (r.length = this._len, q5 && this._len > 11 && (this.data = new Float32Array(r)));
    }
  }, t.prototype.getBoundingRect = function() {
    mo[0] = mo[1] = yo[0] = yo[1] = Number.MAX_VALUE, cl[0] = cl[1] = bo[0] = bo[1] = -Number.MAX_VALUE;
    var r = this.data, e = 0, n = 0, i = 0, a = 0, o;
    for (o = 0; o < this._len; ) {
      var s = r[o++], l = o === 1;
      switch (l && (e = r[o], n = r[o + 1], i = e, a = n), s) {
        case ur.M:
          e = i = r[o++], n = a = r[o++], yo[0] = i, yo[1] = a, bo[0] = i, bo[1] = a;
          break;
        case ur.L:
          CS(e, n, r[o], r[o + 1], yo, bo), e = r[o++], n = r[o++];
          break;
        case ur.C:
          oU(e, n, r[o++], r[o++], r[o++], r[o++], r[o], r[o + 1], yo, bo), e = r[o++], n = r[o++];
          break;
        case ur.Q:
          sU(e, n, r[o++], r[o++], r[o], r[o + 1], yo, bo), e = r[o++], n = r[o++];
          break;
        case ur.A:
          var u = r[o++], c = r[o++], d = r[o++], f = r[o++], h = r[o++], p = r[o++] + h;
          o += 1;
          var v = !r[o++];
          l && (i = Eu(h) * d + u, a = ku(h) * f + c), lU(u, c, d, f, h, p, v, yo, bo), e = Eu(p) * d + u, n = ku(p) * f + c;
          break;
        case ur.R:
          i = e = r[o++], a = n = r[o++];
          var g = r[o++], m = r[o++];
          CS(i, a, i + g, a + m, yo, bo);
          break;
        case ur.Z:
          e = i, n = a;
          break;
      }
      Ms(mo, mo, yo), Rs(cl, cl, bo);
    }
    return o === 0 && (mo[0] = mo[1] = cl[0] = cl[1] = 0), new rt(mo[0], mo[1], cl[0] - mo[0], cl[1] - mo[1]);
  }, t.prototype._calculateLength = function() {
    var r = this.data, e = this._len, n = this._ux, i = this._uy, a = 0, o = 0, s = 0, l = 0;
    this._pathSegLen || (this._pathSegLen = []);
    for (var u = this._pathSegLen, c = 0, d = 0, f = 0; f < e; ) {
      var h = r[f++], p = f === 1;
      p && (a = r[f], o = r[f + 1], s = a, l = o);
      var v = -1;
      switch (h) {
        case ur.M:
          a = s = r[f++], o = l = r[f++];
          break;
        case ur.L: {
          var g = r[f++], m = r[f++], y = g - a, b = m - o;
          (fs(y) > n || fs(b) > i || f === e - 1) && (v = Math.sqrt(y * y + b * b), a = g, o = m);
          break;
        }
        case ur.C: {
          var C = r[f++], w = r[f++], g = r[f++], m = r[f++], _ = r[f++], x = r[f++];
          v = _X(a, o, C, w, g, m, _, x, 10), a = _, o = x;
          break;
        }
        case ur.Q: {
          var C = r[f++], w = r[f++], g = r[f++], m = r[f++];
          v = SX(a, o, C, w, g, m, 10), a = g, o = m;
          break;
        }
        case ur.A:
          var I = r[f++], D = r[f++], T = r[f++], A = r[f++], M = r[f++], R = r[f++], E = R + M;
          f += 1, p && (s = Eu(M) * T + I, l = ku(M) * A + D), v = K5(T, A) * J5(bl, Math.abs(R)), a = Eu(E) * T + I, o = ku(E) * A + D;
          break;
        case ur.R: {
          s = a = r[f++], l = o = r[f++];
          var k = r[f++], P = r[f++];
          v = k * 2 + P * 2;
          break;
        }
        case ur.Z: {
          var y = s - a, b = l - o;
          v = Math.sqrt(y * y + b * b), a = s, o = l;
          break;
        }
      }
      v >= 0 && (u[d++] = v, c += v);
    }
    return this._pathLen = c, c;
  }, t.prototype.rebuildPath = function(r, e) {
    var n = this.data, i = this._ux, a = this._uy, o = this._len, s, l, u, c, d, f, h = e < 1, p, v, g = 0, m = 0, y, b = 0, C, w;
    if (!(h && (this._pathSegLen || this._calculateLength(), p = this._pathSegLen, v = this._pathLen, y = e * v, !y)))
      e: for (var _ = 0; _ < o; ) {
        var x = n[_++], I = _ === 1;
        switch (I && (u = n[_], c = n[_ + 1], s = u, l = c), x !== ur.L && b > 0 && (r.lineTo(C, w), b = 0), x) {
          case ur.M:
            s = u = n[_++], l = c = n[_++], r.moveTo(u, c);
            break;
          case ur.L: {
            d = n[_++], f = n[_++];
            var D = fs(d - u), T = fs(f - c);
            if (D > i || T > a) {
              if (h) {
                var A = p[m++];
                if (g + A > y) {
                  var M = (y - g) / A;
                  r.lineTo(u * (1 - M) + d * M, c * (1 - M) + f * M);
                  break e;
                }
                g += A;
              }
              r.lineTo(d, f), u = d, c = f, b = 0;
            } else {
              var R = D * D + T * T;
              R > b && (C = d, w = f, b = R);
            }
            break;
          }
          case ur.C: {
            var E = n[_++], k = n[_++], P = n[_++], N = n[_++], O = n[_++], W = n[_++];
            if (h) {
              var A = p[m++];
              if (g + A > y) {
                var M = (y - g) / A;
                Ql(u, E, P, O, M, Ru), Ql(c, k, N, W, M, Lu), r.bezierCurveTo(Ru[1], Lu[1], Ru[2], Lu[2], Ru[3], Lu[3]);
                break e;
              }
              g += A;
            }
            r.bezierCurveTo(E, k, P, N, O, W), u = O, c = W;
            break;
          }
          case ur.Q: {
            var E = n[_++], k = n[_++], P = n[_++], N = n[_++];
            if (h) {
              var A = p[m++];
              if (g + A > y) {
                var M = (y - g) / A;
                vv(u, E, P, M, Ru), vv(c, k, N, M, Lu), r.quadraticCurveTo(Ru[1], Lu[1], Ru[2], Lu[2]);
                break e;
              }
              g += A;
            }
            r.quadraticCurveTo(E, k, P, N), u = P, c = N;
            break;
          }
          case ur.A:
            var V = n[_++], B = n[_++], Z = n[_++], q = n[_++], z = n[_++], U = n[_++], J = n[_++], K = !n[_++], j = Z > q ? Z : q, oe = fs(Z - q) > 1e-3, ie = z + U, le = !1;
            if (h) {
              var A = p[m++];
              g + A > y && (ie = z + U * (y - g) / A, le = !0), g += A;
            }
            if (oe && r.ellipse ? r.ellipse(V, B, Z, q, J, z, ie, K) : r.arc(V, B, j, z, ie, K), le)
              break e;
            I && (s = Eu(z) * Z + V, l = ku(z) * q + B), u = Eu(ie) * Z + V, c = ku(ie) * q + B;
            break;
          case ur.R:
            s = u = n[_], l = c = n[_ + 1], d = n[_++], f = n[_++];
            var re = n[_++], Re = n[_++];
            if (h) {
              var A = p[m++];
              if (g + A > y) {
                var ve = y - g;
                r.moveTo(d, f), r.lineTo(d + J5(ve, re), f), ve -= re, ve > 0 && r.lineTo(d + re, f + J5(ve, Re)), ve -= Re, ve > 0 && r.lineTo(d + K5(re - ve, 0), f + Re), ve -= re, ve > 0 && r.lineTo(d, f + K5(Re - ve, 0));
                break e;
              }
              g += A;
            }
            r.rect(d, f, re, Re);
            break;
          case ur.Z:
            if (h) {
              var A = p[m++];
              if (g + A > y) {
                var M = (y - g) / A;
                r.lineTo(u * (1 - M) + s * M, c * (1 - M) + l * M);
                break e;
              }
              g += A;
            }
            r.closePath(), u = s, c = l;
        }
      }
  }, t.prototype.clone = function() {
    var r = new t(), e = this.data;
    return r.data = e.slice ? e.slice() : Array.prototype.slice.call(e), r._len = this._len, r;
  }, t.CMD = ur, t.initDefaultProps = function() {
    var r = t.prototype;
    r._saveData = !0, r._ux = 0, r._uy = 0, r._pendingPtDist = 0, r._version = 0;
  }(), t;
}();
function _l(t, r, e, n, i, a, o) {
  if (i === 0)
    return !1;
  var s = i, l = 0, u = t;
  if (o > r + s && o > n + s || o < r - s && o < n - s || a > t + s && a > e + s || a < t - s && a < e - s)
    return !1;
  if (t !== e)
    l = (r - n) / (t - e), u = (t * n - e * r) / (t - e);
  else
    return Math.abs(a - t) <= s / 2;
  var c = l * a - o + u, d = c * c / (l * l + 1);
  return d <= s / 2 * s / 2;
}
function uU(t, r, e, n, i, a, o, s, l, u, c) {
  if (l === 0)
    return !1;
  var d = l;
  if (c > r + d && c > n + d && c > a + d && c > s + d || c < r - d && c < n - d && c < a - d && c < s - d || u > t + d && u > e + d && u > i + d && u > o + d || u < t - d && u < e - d && u < i - d && u < o - d)
    return !1;
  var f = QP(t, r, e, n, i, a, o, s, u, c, null);
  return f <= d / 2;
}
function NN(t, r, e, n, i, a, o, s, l) {
  if (o === 0)
    return !1;
  var u = o;
  if (l > r + u && l > n + u && l > a + u || l < r - u && l < n - u && l < a - u || s > t + u && s > e + u && s > i + u || s < t - u && s < e - u && s < i - u)
    return !1;
  var c = tN(t, r, e, n, i, a, s, l, null);
  return c <= u / 2;
}
var xS = Math.PI * 2;
function Ji(t) {
  return t %= xS, t < 0 && (t += xS), t;
}
var Bh = Math.PI * 2;
function cU(t, r, e, n, i, a, o, s, l) {
  if (o === 0)
    return !1;
  var u = o;
  s -= t, l -= r;
  var c = Math.sqrt(s * s + l * l);
  if (c - u > e || c + u < e)
    return !1;
  if (Math.abs(n - i) % Bh < 1e-4)
    return !0;
  if (a) {
    var d = n;
    n = Ji(i), i = Ji(d);
  } else
    n = Ji(n), i = Ji(i);
  n > i && (i += Bh);
  var f = Math.atan2(l, s);
  return f < 0 && (f += Bh), f >= n && f <= i || f + Bh >= n && f + Bh <= i;
}
function _s(t, r, e, n, i, a) {
  if (a > r && a > n || a < r && a < n || n === r)
    return 0;
  var o = (a - r) / (n - r), s = n < r ? 1 : -1;
  (o === 1 || o === 0) && (s = n < r ? 0.5 : -0.5);
  var l = o * (e - t) + t;
  return l === i ? 1 / 0 : l > i ? s : 0;
}
var dl = Qo.CMD, Pu = Math.PI * 2, dU = 1e-4;
function fU(t, r) {
  return Math.abs(t - r) < dU;
}
var vi = [-1, -1, -1], ya = [-1, -1];
function hU() {
  var t = ya[0];
  ya[0] = ya[1], ya[1] = t;
}
function pU(t, r, e, n, i, a, o, s, l, u) {
  if (u > r && u > n && u > a && u > s || u < r && u < n && u < a && u < s)
    return 0;
  var c = dm(r, n, a, s, u, vi);
  if (c === 0)
    return 0;
  for (var d = 0, f = -1, h = void 0, p = void 0, v = 0; v < c; v++) {
    var g = vi[v], m = g === 0 || g === 1 ? 0.5 : 1, y = bn(t, e, i, o, g);
    y < l || (f < 0 && (f = qP(r, n, a, s, ya), ya[1] < ya[0] && f > 1 && hU(), h = bn(r, n, a, s, ya[0]), f > 1 && (p = bn(r, n, a, s, ya[1]))), f === 2 ? g < ya[0] ? d += h < r ? m : -m : g < ya[1] ? d += p < h ? m : -m : d += s < p ? m : -m : g < ya[0] ? d += h < r ? m : -m : d += s < h ? m : -m);
  }
  return d;
}
function vU(t, r, e, n, i, a, o, s) {
  if (s > r && s > n && s > a || s < r && s < n && s < a)
    return 0;
  var l = xX(r, n, a, s, vi);
  if (l === 0)
    return 0;
  var u = eN(r, n, a);
  if (u >= 0 && u <= 1) {
    for (var c = 0, d = Rn(r, n, a, u), f = 0; f < l; f++) {
      var h = vi[f] === 0 || vi[f] === 1 ? 0.5 : 1, p = Rn(t, e, i, vi[f]);
      p < o || (vi[f] < u ? c += d < r ? h : -h : c += a < d ? h : -h);
    }
    return c;
  } else {
    var h = vi[0] === 0 || vi[0] === 1 ? 0.5 : 1, p = Rn(t, e, i, vi[0]);
    return p < o ? 0 : a < r ? h : -h;
  }
}
function gU(t, r, e, n, i, a, o, s) {
  if (s -= r, s > e || s < -e)
    return 0;
  var l = Math.sqrt(e * e - s * s);
  vi[0] = -l, vi[1] = l;
  var u = Math.abs(n - i);
  if (u < 1e-4)
    return 0;
  if (u >= Pu - 1e-4) {
    n = 0, i = Pu;
    var c = a ? 1 : -1;
    return o >= vi[0] + t && o <= vi[1] + t ? c : 0;
  }
  if (n > i) {
    var d = n;
    n = i, i = d;
  }
  n < 0 && (n += Pu, i += Pu);
  for (var f = 0, h = 0; h < 2; h++) {
    var p = vi[h];
    if (p + t > o) {
      var v = Math.atan2(s, p), c = a ? 1 : -1;
      v < 0 && (v = Pu + v), (v >= n && v <= i || v + Pu >= n && v + Pu <= i) && (v > Math.PI / 2 && v < Math.PI * 1.5 && (c = -c), f += c);
    }
  }
  return f;
}
function ON(t, r, e, n, i) {
  for (var a = t.data, o = t.len(), s = 0, l = 0, u = 0, c = 0, d = 0, f, h, p = 0; p < o; ) {
    var v = a[p++], g = p === 1;
    switch (v === dl.M && p > 1 && (e || (s += _s(l, u, c, d, n, i))), g && (l = a[p], u = a[p + 1], c = l, d = u), v) {
      case dl.M:
        c = a[p++], d = a[p++], l = c, u = d;
        break;
      case dl.L:
        if (e) {
          if (_l(l, u, a[p], a[p + 1], r, n, i))
            return !0;
        } else
          s += _s(l, u, a[p], a[p + 1], n, i) || 0;
        l = a[p++], u = a[p++];
        break;
      case dl.C:
        if (e) {
          if (uU(l, u, a[p++], a[p++], a[p++], a[p++], a[p], a[p + 1], r, n, i))
            return !0;
        } else
          s += pU(l, u, a[p++], a[p++], a[p++], a[p++], a[p], a[p + 1], n, i) || 0;
        l = a[p++], u = a[p++];
        break;
      case dl.Q:
        if (e) {
          if (NN(l, u, a[p++], a[p++], a[p], a[p + 1], r, n, i))
            return !0;
        } else
          s += vU(l, u, a[p++], a[p++], a[p], a[p + 1], n, i) || 0;
        l = a[p++], u = a[p++];
        break;
      case dl.A:
        var m = a[p++], y = a[p++], b = a[p++], C = a[p++], w = a[p++], _ = a[p++];
        p += 1;
        var x = !!(1 - a[p++]);
        f = Math.cos(w) * b + m, h = Math.sin(w) * C + y, g ? (c = f, d = h) : s += _s(l, u, f, h, n, i);
        var I = (n - m) * C / b + m;
        if (e) {
          if (cU(m, y, C, w, w + _, x, r, I, i))
            return !0;
        } else
          s += gU(m, y, C, w, w + _, x, I, i);
        l = Math.cos(w + _) * b + m, u = Math.sin(w + _) * C + y;
        break;
      case dl.R:
        c = l = a[p++], d = u = a[p++];
        var D = a[p++], T = a[p++];
        if (f = c + D, h = d + T, e) {
          if (_l(c, d, f, d, r, n, i) || _l(f, d, f, h, r, n, i) || _l(f, h, c, h, r, n, i) || _l(c, h, c, d, r, n, i))
            return !0;
        } else
          s += _s(f, d, f, h, n, i), s += _s(c, h, c, d, n, i);
        break;
      case dl.Z:
        if (e) {
          if (_l(l, u, c, d, r, n, i))
            return !0;
        } else
          s += _s(l, u, c, d, n, i);
        l = c, u = d;
        break;
    }
  }
  return !e && !fU(u, d) && (s += _s(l, u, c, d, n, i) || 0), s !== 0;
}
function mU(t, r, e) {
  return ON(t, 0, !1, r, e);
}
function yU(t, r, e, n) {
  return ON(t, r, !0, e, n);
}
var ym = Ee({
  fill: "#000",
  stroke: null,
  strokePercent: 1,
  fillOpacity: 1,
  strokeOpacity: 1,
  lineDashOffset: 0,
  lineWidth: 1,
  lineCap: "butt",
  miterLimit: 10,
  strokeNoScale: !1,
  strokeFirst: !1
}, xc), bU = {
  style: Ee({
    fill: !0,
    stroke: !0,
    strokePercent: !0,
    fillOpacity: !0,
    strokeOpacity: !0,
    lineDashOffset: !0,
    lineWidth: !0,
    miterLimit: !0
  }, o2.style)
}, eb = Ko.concat([
  "invisible",
  "culling",
  "z",
  "z2",
  "zlevel",
  "parent"
]), gt = function(t) {
  _r(r, t);
  function r(e) {
    return t.call(this, e) || this;
  }
  return r.prototype.update = function() {
    var e = this;
    t.prototype.update.call(this);
    var n = this.style;
    if (n.decal) {
      var i = this._decalEl = this._decalEl || new r();
      i.buildPath === r.prototype.buildPath && (i.buildPath = function(l) {
        e.buildPath(l, e.shape);
      }), i.silent = !0;
      var a = i.style;
      for (var o in n)
        a[o] !== n[o] && (a[o] = n[o]);
      a.fill = n.fill ? n.decal : null, a.decal = null, a.shadowColor = null, n.strokeFirst && (a.stroke = null);
      for (var s = 0; s < eb.length; ++s)
        i[eb[s]] = this[eb[s]];
      i.__dirty |= ji;
    } else this._decalEl && (this._decalEl = null);
  }, r.prototype.getDecalElement = function() {
    return this._decalEl;
  }, r.prototype._init = function(e) {
    var n = yt(e);
    this.shape = this.getDefaultShape();
    var i = this.getDefaultStyle();
    i && this.useStyle(i);
    for (var a = 0; a < n.length; a++) {
      var o = n[a], s = e[o];
      o === "style" ? this.style ? ae(this.style, s) : this.useStyle(s) : o === "shape" ? ae(this.shape, s) : t.prototype.attrKV.call(this, o, s);
    }
    this.style || this.useStyle({});
  }, r.prototype.getDefaultStyle = function() {
    return null;
  }, r.prototype.getDefaultShape = function() {
    return {};
  }, r.prototype.canBeInsideText = function() {
    return this.hasFill();
  }, r.prototype.getInsideTextFill = function() {
    var e = this.style.fill;
    if (e !== "none") {
      if (pe(e)) {
        var n = yv(e, 0);
        return n > 0.5 ? kC : n > 0.2 ? t$ : PC;
      } else if (e)
        return PC;
    }
    return kC;
  }, r.prototype.getInsideTextStroke = function(e) {
    var n = this.style.fill;
    if (pe(n)) {
      var i = this.__zr, a = !!(i && i.isDarkMode()), o = yv(e, 0) < EC;
      if (a === o)
        return n;
    }
  }, r.prototype.buildPath = function(e, n, i) {
  }, r.prototype.pathUpdated = function() {
    this.__dirty &= ~zd;
  }, r.prototype.getUpdatedPathProxy = function(e) {
    return !this.path && this.createPathProxy(), this.path.beginPath(), this.buildPath(this.path, this.shape, e), this.path;
  }, r.prototype.createPathProxy = function() {
    this.path = new Qo(!1);
  }, r.prototype.hasStroke = function() {
    var e = this.style, n = e.stroke;
    return !(n == null || n === "none" || !(e.lineWidth > 0));
  }, r.prototype.hasFill = function() {
    var e = this.style, n = e.fill;
    return n != null && n !== "none";
  }, r.prototype.getBoundingRect = function() {
    var e = this._rect, n = this.style, i = !e;
    if (i) {
      var a = !1;
      this.path || (a = !0, this.createPathProxy());
      var o = this.path;
      (a || this.__dirty & zd) && (o.beginPath(), this.buildPath(o, this.shape, !1), this.pathUpdated()), e = o.getBoundingRect();
    }
    if (this._rect = e, this.hasStroke() && this.path && this.path.len() > 0) {
      var s = this._rectStroke || (this._rectStroke = e.clone());
      if (this.__dirty || i) {
        s.copy(e);
        var l = n.strokeNoScale ? this.getLineScale() : 1, u = n.lineWidth;
        if (!this.hasFill()) {
          var c = this.strokeContainThreshold;
          u = Math.max(u, c ?? 4);
        }
        l > 1e-10 && (s.width += u / l, s.height += u / l, s.x -= u / l / 2, s.y -= u / l / 2);
      }
      return s;
    }
    return e;
  }, r.prototype.contain = function(e, n) {
    var i = this.transformCoordToLocal(e, n), a = this.getBoundingRect(), o = this.style;
    if (e = i[0], n = i[1], a.contain(e, n)) {
      var s = this.path;
      if (this.hasStroke()) {
        var l = o.lineWidth, u = o.strokeNoScale ? this.getLineScale() : 1;
        if (u > 1e-10 && (this.hasFill() || (l = Math.max(l, this.strokeContainThreshold)), yU(s, l / u, e, n)))
          return !0;
      }
      if (this.hasFill())
        return mU(s, e, n);
    }
    return !1;
  }, r.prototype.dirtyShape = function() {
    this.__dirty |= zd, this._rect && (this._rect = null), this._decalEl && this._decalEl.dirtyShape(), this.markRedraw();
  }, r.prototype.dirty = function() {
    this.dirtyStyle(), this.dirtyShape();
  }, r.prototype.animateShape = function(e) {
    return this.animate("shape", e);
  }, r.prototype.updateDuringAnimation = function(e) {
    e === "style" ? this.dirtyStyle() : e === "shape" ? this.dirtyShape() : this.markRedraw();
  }, r.prototype.attrKV = function(e, n) {
    e === "shape" ? this.setShape(n) : t.prototype.attrKV.call(this, e, n);
  }, r.prototype.setShape = function(e, n) {
    var i = this.shape;
    return i || (i = this.shape = {}), typeof e == "string" ? i[e] = n : ae(i, e), this.dirtyShape(), this;
  }, r.prototype.shapeChanged = function() {
    return !!(this.__dirty & zd);
  }, r.prototype.createStyle = function(e) {
    return sg(ym, e);
  }, r.prototype._innerSaveToNormal = function(e) {
    t.prototype._innerSaveToNormal.call(this, e);
    var n = this._normalState;
    e.shape && !n.shape && (n.shape = ae({}, this.shape));
  }, r.prototype._applyStateObj = function(e, n, i, a, o, s) {
    t.prototype._applyStateObj.call(this, e, n, i, a, o, s);
    var l = !(n && a), u;
    if (n && n.shape ? o ? a ? u = n.shape : (u = ae({}, i.shape), ae(u, n.shape)) : (u = ae({}, a ? this.shape : i.shape), ae(u, n.shape)) : l && (u = i.shape), u)
      if (o) {
        this.shape = ae({}, this.shape);
        for (var c = {}, d = yt(u), f = 0; f < d.length; f++) {
          var h = d[f];
          typeof u[h] == "object" ? this.shape[h] = u[h] : c[h] = u[h];
        }
        this._transitionState(e, {
          shape: c
        }, s);
      } else
        this.shape = u, this.dirtyShape();
  }, r.prototype._mergeStates = function(e) {
    for (var n = t.prototype._mergeStates.call(this, e), i, a = 0; a < e.length; a++) {
      var o = e[a];
      o.shape && (i = i || {}, this._mergeStyle(i, o.shape));
    }
    return i && (n.shape = i), n;
  }, r.prototype.getAnimationStyleProps = function() {
    return bU;
  }, r.prototype.isZeroArea = function() {
    return !1;
  }, r.extend = function(e) {
    var n = function(a) {
      _r(o, a);
      function o(s) {
        var l = a.call(this, s) || this;
        return e.init && e.init.call(l, s), l;
      }
      return o.prototype.getDefaultStyle = function() {
        return Ge(e.style);
      }, o.prototype.getDefaultShape = function() {
        return Ge(e.shape);
      }, o;
    }(r);
    for (var i in e)
      typeof e[i] == "function" && (n.prototype[i] = e[i]);
    return n;
  }, r.initDefaultProps = function() {
    var e = r.prototype;
    e.type = "path", e.strokeContainThreshold = 5, e.segmentIgnoreThreshold = 0, e.subPixelOptimize = !1, e.autoBatch = !1, e.__dirty = ji | Sp | zd;
  }(), r;
}(La), CU = Ee({
  strokeFirst: !0,
  font: Jl,
  x: 0,
  y: 0,
  textAlign: "left",
  textBaseline: "top",
  miterLimit: 2
}, ym), Tf = function(t) {
  _r(r, t);
  function r() {
    return t !== null && t.apply(this, arguments) || this;
  }
  return r.prototype.hasStroke = function() {
    var e = this.style, n = e.stroke;
    return n != null && n !== "none" && e.lineWidth > 0;
  }, r.prototype.hasFill = function() {
    var e = this.style, n = e.fill;
    return n != null && n !== "none";
  }, r.prototype.createStyle = function(e) {
    return sg(CU, e);
  }, r.prototype.setBoundingRect = function(e) {
    this._rect = e;
  }, r.prototype.getBoundingRect = function() {
    var e = this.style;
    if (!this._rect) {
      var n = e.text;
      n != null ? n += "" : n = "";
      var i = cg(n, e.font, e.textAlign, e.textBaseline);
      if (i.x += e.x || 0, i.y += e.y || 0, this.hasStroke()) {
        var a = e.lineWidth;
        i.x -= a / 2, i.y -= a / 2, i.width += a, i.height += a;
      }
      this._rect = i;
    }
    return this._rect;
  }, r.initDefaultProps = function() {
    var e = r.prototype;
    e.dirtyRectTolerance = 10;
  }(), r;
}(La);
Tf.prototype.type = "tspan";
var wU = Ee({
  x: 0,
  y: 0
}, xc), _U = {
  style: Ee({
    x: !0,
    y: !0,
    width: !0,
    height: !0,
    sx: !0,
    sy: !0,
    sWidth: !0,
    sHeight: !0
  }, o2.style)
};
function xU(t) {
  return !!(t && typeof t != "string" && t.width && t.height);
}
var An = function(t) {
  _r(r, t);
  function r() {
    return t !== null && t.apply(this, arguments) || this;
  }
  return r.prototype.createStyle = function(e) {
    return sg(wU, e);
  }, r.prototype._getSize = function(e) {
    var n = this.style, i = n[e];
    if (i != null)
      return i;
    var a = xU(n.image) ? n.image : this.__image;
    if (!a)
      return 0;
    var o = e === "width" ? "height" : "width", s = n[o];
    return s == null ? a[e] : a[e] / a[o] * s;
  }, r.prototype.getWidth = function() {
    return this._getSize("width");
  }, r.prototype.getHeight = function() {
    return this._getSize("height");
  }, r.prototype.getAnimationStyleProps = function() {
    return _U;
  }, r.prototype.getBoundingRect = function() {
    var e = this.style;
    return this._rect || (this._rect = new rt(e.x || 0, e.y || 0, this.getWidth(), this.getHeight())), this._rect;
  }, r;
}(La);
An.prototype.type = "image";
function SU(t, r) {
  var e = r.x, n = r.y, i = r.width, a = r.height, o = r.r, s, l, u, c;
  i < 0 && (e = e + i, i = -i), a < 0 && (n = n + a, a = -a), typeof o == "number" ? s = l = u = c = o : o instanceof Array ? o.length === 1 ? s = l = u = c = o[0] : o.length === 2 ? (s = u = o[0], l = c = o[1]) : o.length === 3 ? (s = o[0], l = c = o[1], u = o[2]) : (s = o[0], l = o[1], u = o[2], c = o[3]) : s = l = u = c = 0;
  var d;
  s + l > i && (d = s + l, s *= i / d, l *= i / d), u + c > i && (d = u + c, u *= i / d, c *= i / d), l + u > a && (d = l + u, l *= a / d, u *= a / d), s + c > a && (d = s + c, s *= a / d, c *= a / d), t.moveTo(e + s, n), t.lineTo(e + i - l, n), l !== 0 && t.arc(e + i - l, n + l, l, -Math.PI / 2, 0), t.lineTo(e + i, n + a - u), u !== 0 && t.arc(e + i - u, n + a - u, u, 0, Math.PI / 2), t.lineTo(e + c, n + a), c !== 0 && t.arc(e + c, n + a - c, c, Math.PI / 2, Math.PI), t.lineTo(e, n + s), s !== 0 && t.arc(e + s, n + s, s, Math.PI, Math.PI * 1.5);
}
var Jd = Math.round;
function VN(t, r, e) {
  if (r) {
    var n = r.x1, i = r.x2, a = r.y1, o = r.y2;
    t.x1 = n, t.x2 = i, t.y1 = a, t.y2 = o;
    var s = e && e.lineWidth;
    return s && (Jd(n * 2) === Jd(i * 2) && (t.x1 = t.x2 = cc(n, s, !0)), Jd(a * 2) === Jd(o * 2) && (t.y1 = t.y2 = cc(a, s, !0))), t;
  }
}
function GN(t, r, e) {
  if (r) {
    var n = r.x, i = r.y, a = r.width, o = r.height;
    t.x = n, t.y = i, t.width = a, t.height = o;
    var s = e && e.lineWidth;
    return s && (t.x = cc(n, s, !0), t.y = cc(i, s, !0), t.width = Math.max(cc(n + a, s, !1) - t.x, a === 0 ? 0 : 1), t.height = Math.max(cc(i + o, s, !1) - t.y, o === 0 ? 0 : 1)), t;
  }
}
function cc(t, r, e) {
  if (!r)
    return t;
  var n = Jd(t * 2);
  return (n + Jd(r)) % 2 === 0 ? n / 2 : (n + (e ? 1 : -1)) / 2;
}
var IU = /* @__PURE__ */ function() {
  function t() {
    this.x = 0, this.y = 0, this.width = 0, this.height = 0;
  }
  return t;
}(), AU = {}, xt = function(t) {
  _r(r, t);
  function r(e) {
    return t.call(this, e) || this;
  }
  return r.prototype.getDefaultShape = function() {
    return new IU();
  }, r.prototype.buildPath = function(e, n) {
    var i, a, o, s;
    if (this.subPixelOptimize) {
      var l = GN(AU, n, this.style);
      i = l.x, a = l.y, o = l.width, s = l.height, l.r = n.r, n = l;
    } else
      i = n.x, a = n.y, o = n.width, s = n.height;
    n.r ? SU(e, n) : e.rect(i, a, o, s);
  }, r.prototype.isZeroArea = function() {
    return !this.shape.width || !this.shape.height;
  }, r;
}(gt);
xt.prototype.type = "rect";
var SS = {
  fill: "#000"
}, IS = 2, DU = {
  style: Ee({
    fill: !0,
    stroke: !0,
    fillOpacity: !0,
    strokeOpacity: !0,
    lineWidth: !0,
    fontSize: !0,
    lineHeight: !0,
    width: !0,
    height: !0,
    textShadowColor: !0,
    textShadowBlur: !0,
    textShadowOffsetX: !0,
    textShadowOffsetY: !0,
    backgroundColor: !0,
    padding: !0,
    borderColor: !0,
    borderWidth: !0,
    borderRadius: !0
  }, o2.style)
}, _t = function(t) {
  _r(r, t);
  function r(e) {
    var n = t.call(this) || this;
    return n.type = "text", n._children = [], n._defaultStyle = SS, n.attr(e), n;
  }
  return r.prototype.childrenRef = function() {
    return this._children;
  }, r.prototype.update = function() {
    t.prototype.update.call(this), this.styleChanged() && this._updateSubTexts();
    for (var e = 0; e < this._children.length; e++) {
      var n = this._children[e];
      n.zlevel = this.zlevel, n.z = this.z, n.z2 = this.z2, n.culling = this.culling, n.cursor = this.cursor, n.invisible = this.invisible;
    }
  }, r.prototype.updateTransform = function() {
    var e = this.innerTransformable;
    e ? (e.updateTransform(), e.transform && (this.transform = e.transform)) : t.prototype.updateTransform.call(this);
  }, r.prototype.getLocalTransform = function(e) {
    var n = this.innerTransformable;
    return n ? n.getLocalTransform(e) : t.prototype.getLocalTransform.call(this, e);
  }, r.prototype.getComputedTransform = function() {
    return this.__hostTarget && (this.__hostTarget.getComputedTransform(), this.__hostTarget.updateInnerText(!0)), t.prototype.getComputedTransform.call(this);
  }, r.prototype._updateSubTexts = function() {
    this._childCursor = 0, RU(this.style), this.style.rich ? this._updateRichTexts() : this._updatePlainTexts(), this._children.length = this._childCursor, this.styleUpdated();
  }, r.prototype.addSelfToZr = function(e) {
    t.prototype.addSelfToZr.call(this, e);
    for (var n = 0; n < this._children.length; n++)
      this._children[n].__zr = e;
  }, r.prototype.removeSelfFromZr = function(e) {
    t.prototype.removeSelfFromZr.call(this, e);
    for (var n = 0; n < this._children.length; n++)
      this._children[n].__zr = null;
  }, r.prototype.getBoundingRect = function() {
    if (this.styleChanged() && this._updateSubTexts(), !this._rect) {
      for (var e = new rt(0, 0, 0, 0), n = this._children, i = [], a = null, o = 0; o < n.length; o++) {
        var s = n[o], l = s.getBoundingRect(), u = s.getLocalTransform(i);
        u ? (e.copy(l), e.applyTransform(u), a = a || e.clone(), a.union(e)) : (a = a || l.clone(), a.union(l));
      }
      this._rect = a || e;
    }
    return this._rect;
  }, r.prototype.setDefaultTextStyle = function(e) {
    this._defaultStyle = e || SS;
  }, r.prototype.setTextContent = function(e) {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Can't attach text on another text");
  }, r.prototype._mergeStyle = function(e, n) {
    if (!n)
      return e;
    var i = n.rich, a = e.rich || i && {};
    return ae(e, n), i && a ? (this._mergeRich(a, i), e.rich = a) : a && (e.rich = a), e;
  }, r.prototype._mergeRich = function(e, n) {
    for (var i = yt(n), a = 0; a < i.length; a++) {
      var o = i[a];
      e[o] = e[o] || {}, ae(e[o], n[o]);
    }
  }, r.prototype.getAnimationStyleProps = function() {
    return DU;
  }, r.prototype._getOrCreateChild = function(e) {
    var n = this._children[this._childCursor];
    return (!n || !(n instanceof e)) && (n = new e()), this._children[this._childCursor++] = n, n.__zr = this.__zr, n.parent = this, n;
  }, r.prototype._updatePlainTexts = function() {
    var e = this.style, n = e.font || Jl, i = e.padding, a = ES(e), o = K$(a, e), s = tb(e), l = !!e.backgroundColor, u = o.outerHeight, c = o.outerWidth, d = o.contentWidth, f = o.lines, h = o.lineHeight, p = this._defaultStyle, v = e.x || 0, g = e.y || 0, m = e.align || p.align || "left", y = e.verticalAlign || p.verticalAlign || "top", b = v, C = Wd(g, o.contentHeight, y);
    if (s || i) {
      var w = Ap(v, c, m), _ = Wd(g, u, y);
      s && this._renderBackground(e, e, w, _, c, u);
    }
    C += h / 2, i && (b = LS(v, m, i), y === "top" ? C += i[0] : y === "bottom" && (C -= i[2]));
    for (var x = 0, I = !1, D = RS("fill" in e ? e.fill : (I = !0, p.fill)), T = MS("stroke" in e ? e.stroke : !l && (!p.autoStroke || I) ? (x = IS, p.stroke) : null), A = e.textShadowBlur > 0, M = e.width != null && (e.overflow === "truncate" || e.overflow === "break" || e.overflow === "breakAll"), R = o.calculatedLineHeight, E = 0; E < f.length; E++) {
      var k = this._getOrCreateChild(Tf), P = k.createStyle();
      k.useStyle(P), P.text = f[E], P.x = b, P.y = C, m && (P.textAlign = m), P.textBaseline = "middle", P.opacity = e.opacity, P.strokeFirst = !0, A && (P.shadowBlur = e.textShadowBlur || 0, P.shadowColor = e.textShadowColor || "transparent", P.shadowOffsetX = e.textShadowOffsetX || 0, P.shadowOffsetY = e.textShadowOffsetY || 0), P.stroke = T, P.fill = D, T && (P.lineWidth = e.lineWidth || x, P.lineDash = e.lineDash, P.lineDashOffset = e.lineDashOffset || 0), P.font = n, DS(P, e), C += h, M && k.setBoundingRect(new rt(Ap(P.x, e.width, P.textAlign), Wd(P.y, R, P.textBaseline), d, R));
    }
  }, r.prototype._updateRichTexts = function() {
    var e = this.style, n = ES(e), i = eU(n, e), a = i.width, o = i.outerWidth, s = i.outerHeight, l = e.padding, u = e.x || 0, c = e.y || 0, d = this._defaultStyle, f = e.align || d.align, h = e.verticalAlign || d.verticalAlign, p = Ap(u, o, f), v = Wd(c, s, h), g = p, m = v;
    l && (g += l[3], m += l[0]);
    var y = g + a;
    tb(e) && this._renderBackground(e, e, p, v, o, s);
    for (var b = !!e.backgroundColor, C = 0; C < i.lines.length; C++) {
      for (var w = i.lines[C], _ = w.tokens, x = _.length, I = w.lineHeight, D = w.width, T = 0, A = g, M = y, R = x - 1, E = void 0; T < x && (E = _[T], !E.align || E.align === "left"); )
        this._placeToken(E, e, I, m, A, "left", b), D -= E.width, A += E.width, T++;
      for (; R >= 0 && (E = _[R], E.align === "right"); )
        this._placeToken(E, e, I, m, M, "right", b), D -= E.width, M -= E.width, R--;
      for (A += (a - (A - g) - (y - M) - D) / 2; T <= R; )
        E = _[T], this._placeToken(E, e, I, m, A + E.width / 2, "center", b), A += E.width, T++;
      m += I;
    }
  }, r.prototype._placeToken = function(e, n, i, a, o, s, l) {
    var u = n.rich[e.styleName] || {};
    u.text = e.text;
    var c = e.verticalAlign, d = a + i / 2;
    c === "top" ? d = a + e.height / 2 : c === "bottom" && (d = a + i - e.height / 2);
    var f = !e.isLineHolder && tb(u);
    f && this._renderBackground(u, n, s === "right" ? o - e.width : s === "center" ? o - e.width / 2 : o, d - e.height / 2, e.width, e.height);
    var h = !!u.backgroundColor, p = e.textPadding;
    p && (o = LS(o, s, p), d -= e.height / 2 - p[0] - e.innerHeight / 2);
    var v = this._getOrCreateChild(Tf), g = v.createStyle();
    v.useStyle(g);
    var m = this._defaultStyle, y = !1, b = 0, C = RS("fill" in u ? u.fill : "fill" in n ? n.fill : (y = !0, m.fill)), w = MS("stroke" in u ? u.stroke : "stroke" in n ? n.stroke : !h && !l && (!m.autoStroke || y) ? (b = IS, m.stroke) : null), _ = u.textShadowBlur > 0 || n.textShadowBlur > 0;
    g.text = e.text, g.x = o, g.y = d, _ && (g.shadowBlur = u.textShadowBlur || n.textShadowBlur || 0, g.shadowColor = u.textShadowColor || n.textShadowColor || "transparent", g.shadowOffsetX = u.textShadowOffsetX || n.textShadowOffsetX || 0, g.shadowOffsetY = u.textShadowOffsetY || n.textShadowOffsetY || 0), g.textAlign = s, g.textBaseline = "middle", g.font = e.font || Jl, g.opacity = Ki(u.opacity, n.opacity, 1), DS(g, u), w && (g.lineWidth = Ki(u.lineWidth, n.lineWidth, b), g.lineDash = je(u.lineDash, n.lineDash), g.lineDashOffset = n.lineDashOffset || 0, g.stroke = w), C && (g.fill = C);
    var x = e.contentWidth, I = e.contentHeight;
    v.setBoundingRect(new rt(Ap(g.x, x, g.textAlign), Wd(g.y, I, g.textBaseline), x, I));
  }, r.prototype._renderBackground = function(e, n, i, a, o, s) {
    var l = e.backgroundColor, u = e.borderWidth, c = e.borderColor, d = l && l.image, f = l && !d, h = e.borderRadius, p = this, v, g;
    if (f || e.lineHeight || u && c) {
      v = this._getOrCreateChild(xt), v.useStyle(v.createStyle()), v.style.fill = null;
      var m = v.shape;
      m.x = i, m.y = a, m.width = o, m.height = s, m.r = h, v.dirtyShape();
    }
    if (f) {
      var y = v.style;
      y.fill = l || null, y.fillOpacity = je(e.fillOpacity, 1);
    } else if (d) {
      g = this._getOrCreateChild(An), g.onload = function() {
        p.dirtyStyle();
      };
      var b = g.style;
      b.image = l.image, b.x = i, b.y = a, b.width = o, b.height = s;
    }
    if (u && c) {
      var y = v.style;
      y.lineWidth = u, y.stroke = c, y.strokeOpacity = je(e.strokeOpacity, 1), y.lineDash = e.borderDash, y.lineDashOffset = e.borderDashOffset || 0, v.strokeContainThreshold = 0, v.hasFill() && v.hasStroke() && (y.strokeFirst = !0, y.lineWidth *= 2);
    }
    var C = (v || g).style;
    C.shadowBlur = e.shadowBlur || 0, C.shadowColor = e.shadowColor || "transparent", C.shadowOffsetX = e.shadowOffsetX || 0, C.shadowOffsetY = e.shadowOffsetY || 0, C.opacity = Ki(e.opacity, n.opacity, 1);
  }, r.makeFont = function(e) {
    var n = "";
    return FN(e) && (n = [
      e.fontStyle,
      e.fontWeight,
      BN(e.fontSize),
      e.fontFamily || "sans-serif"
    ].join(" ")), n && Aa(n) || e.textFont || e.font;
  }, r;
}(La), TU = { left: !0, right: 1, center: 1 }, MU = { top: 1, bottom: 1, middle: 1 }, AS = ["fontStyle", "fontWeight", "fontSize", "fontFamily"];
function BN(t) {
  return typeof t == "string" && (t.indexOf("px") !== -1 || t.indexOf("rem") !== -1 || t.indexOf("em") !== -1) ? t : isNaN(+t) ? m7 + "px" : t + "px";
}
function DS(t, r) {
  for (var e = 0; e < AS.length; e++) {
    var n = AS[e], i = r[n];
    i != null && (t[n] = i);
  }
}
function FN(t) {
  return t.fontSize != null || t.fontFamily || t.fontWeight;
}
function RU(t) {
  return TS(t), L(t.rich, TS), t;
}
function TS(t) {
  if (t) {
    t.font = _t.makeFont(t);
    var r = t.align;
    r === "middle" && (r = "center"), t.align = r == null || TU[r] ? r : "left";
    var e = t.verticalAlign;
    e === "center" && (e = "middle"), t.verticalAlign = e == null || MU[e] ? e : "top";
    var n = t.padding;
    n && (t.padding = Jy(t.padding));
  }
}
function MS(t, r) {
  return t == null || r <= 0 || t === "transparent" || t === "none" ? null : t.image || t.colorStops ? "#000" : t;
}
function RS(t) {
  return t == null || t === "none" ? null : t.image || t.colorStops ? "#000" : t;
}
function LS(t, r, e) {
  return r === "right" ? t - e[1] : r === "center" ? t + e[3] / 2 - e[1] / 2 : t + e[3];
}
function ES(t) {
  var r = t.text;
  return r != null && (r += ""), r;
}
function tb(t) {
  return !!(t.backgroundColor || t.lineHeight || t.borderWidth && t.borderColor);
}
var Ze = It(), WC = function(t, r, e, n) {
  if (n) {
    var i = Ze(n);
    i.dataIndex = e, i.dataType = r, i.seriesIndex = t, i.ssrType = "chart", n.type === "group" && n.traverse(function(a) {
      var o = Ze(a);
      o.seriesIndex = t, o.dataIndex = e, o.dataType = r, o.ssrType = "chart";
    });
  }
}, kS = 1, PS = {}, HN = It(), G7 = It(), B7 = 0, hg = 1, l2 = 2, xi = ["emphasis", "blur", "select"], Cv = ["normal", "emphasis", "blur", "select"], Qf = 10, LU = 9, Sc = "highlight", T0 = "downplay", Jp = "select", M0 = "unselect", Kp = "toggleSelect";
function gd(t) {
  return t != null && t !== "none";
}
function u2(t, r, e) {
  t.onHoverStateChange && (t.hoverState || 0) !== e && t.onHoverStateChange(r), t.hoverState = e;
}
function zN(t) {
  u2(t, "emphasis", l2);
}
function WN(t) {
  t.hoverState === l2 && u2(t, "normal", B7);
}
function F7(t) {
  u2(t, "blur", hg);
}
function ZN(t) {
  t.hoverState === hg && u2(t, "normal", B7);
}
function EU(t) {
  t.selected = !0;
}
function kU(t) {
  t.selected = !1;
}
function NS(t, r, e) {
  r(t, e);
}
function al(t, r, e) {
  NS(t, r, e), t.isGroup && t.traverse(function(n) {
    NS(n, r, e);
  });
}
function bm(t, r) {
  switch (r) {
    case "emphasis":
      t.hoverState = l2;
      break;
    case "normal":
      t.hoverState = B7;
      break;
    case "blur":
      t.hoverState = hg;
      break;
    case "select":
      t.selected = !0;
  }
}
function PU(t, r, e, n) {
  for (var i = t.style, a = {}, o = 0; o < r.length; o++) {
    var s = r[o], l = i[s];
    a[s] = l ?? (n && n[s]);
  }
  for (var o = 0; o < t.animators.length; o++) {
    var u = t.animators[o];
    u.__fromStateTransition && u.__fromStateTransition.indexOf(e) < 0 && u.targetName === "style" && u.saveTo(a, r);
  }
  return a;
}
function NU(t, r, e, n) {
  var i = e && nt(e, "select") >= 0, a = !1;
  if (t instanceof gt) {
    var o = HN(t), s = i && o.selectFill || o.normalFill, l = i && o.selectStroke || o.normalStroke;
    if (gd(s) || gd(l)) {
      n = n || {};
      var u = n.style || {};
      u.fill === "inherit" ? (a = !0, n = ae({}, n), u = ae({}, u), u.fill = s) : !gd(u.fill) && gd(s) ? (a = !0, n = ae({}, n), u = ae({}, u), u.fill = hm(s)) : !gd(u.stroke) && gd(l) && (a || (n = ae({}, n), u = ae({}, u)), u.stroke = hm(l)), n.style = u;
    }
  }
  if (n && n.z2 == null) {
    a || (n = ae({}, n));
    var c = t.z2EmphasisLift;
    n.z2 = t.z2 + (c ?? Qf);
  }
  return n;
}
function OU(t, r, e) {
  if (e && e.z2 == null) {
    e = ae({}, e);
    var n = t.z2SelectLift;
    e.z2 = t.z2 + (n ?? LU);
  }
  return e;
}
function VU(t, r, e) {
  var n = nt(t.currentStates, r) >= 0, i = t.style.opacity, a = n ? null : PU(t, ["opacity"], r, {
    opacity: 1
  });
  e = e || {};
  var o = e.style || {};
  return o.opacity == null && (e = ae({}, e), o = ae({
    // Already being applied 'emphasis'. DON'T mul opacity multiple times.
    opacity: n ? i : a.opacity * 0.1
  }, o), e.style = o), e;
}
function rb(t, r) {
  var e = this.states[t];
  if (this.style) {
    if (t === "emphasis")
      return NU(this, t, r, e);
    if (t === "blur")
      return VU(this, t, e);
    if (t === "select")
      return OU(this, t, e);
  }
  return e;
}
function Fc(t) {
  t.stateProxy = rb;
  var r = t.getTextContent(), e = t.getTextGuideLine();
  r && (r.stateProxy = rb), e && (e.stateProxy = rb);
}
function OS(t, r) {
  !$N(t, r) && !t.__highByOuter && al(t, zN);
}
function VS(t, r) {
  !$N(t, r) && !t.__highByOuter && al(t, WN);
}
function Xs(t, r) {
  t.__highByOuter |= 1 << (r || 0), al(t, zN);
}
function $s(t, r) {
  !(t.__highByOuter &= ~(1 << (r || 0))) && al(t, WN);
}
function jN(t) {
  al(t, F7);
}
function H7(t) {
  al(t, ZN);
}
function YN(t) {
  al(t, EU);
}
function XN(t) {
  al(t, kU);
}
function $N(t, r) {
  return t.__highDownSilentOnTouch && r.zrByTouch;
}
function UN(t) {
  var r = t.getModel(), e = [], n = [];
  r.eachComponent(function(i, a) {
    var o = G7(a), s = i === "series", l = s ? t.getViewOfSeriesModel(a) : t.getViewOfComponentModel(a);
    !s && n.push(l), o.isBlured && (l.group.traverse(function(u) {
      ZN(u);
    }), s && e.push(a)), o.isBlured = !1;
  }), L(n, function(i) {
    i && i.toggleBlurSeries && i.toggleBlurSeries(e, !1, r);
  });
}
function ZC(t, r, e, n) {
  var i = n.getModel();
  e = e || "coordinateSystem";
  function a(u, c) {
    for (var d = 0; d < c.length; d++) {
      var f = u.getItemGraphicEl(c[d]);
      f && H7(f);
    }
  }
  if (t != null && !(!r || r === "none")) {
    var o = i.getSeriesByIndex(t), s = o.coordinateSystem;
    s && s.master && (s = s.master);
    var l = [];
    i.eachSeries(function(u) {
      var c = o === u, d = u.coordinateSystem;
      d && d.master && (d = d.master);
      var f = d && s ? d === s : c;
      if (!// Not blur other series if blurScope series
      (e === "series" && !c || e === "coordinateSystem" && !f || r === "series" && c)) {
        var h = n.getViewOfSeriesModel(u);
        if (h.group.traverse(function(g) {
          g.__highByOuter && c && r === "self" || F7(g);
        }), Zn(r))
          a(u.getData(), r);
        else if (Me(r))
          for (var p = yt(r), v = 0; v < p.length; v++)
            a(u.getData(p[v]), r[p[v]]);
        l.push(u), G7(u).isBlured = !0;
      }
    }), i.eachComponent(function(u, c) {
      if (u !== "series") {
        var d = n.getViewOfComponentModel(c);
        d && d.toggleBlurSeries && d.toggleBlurSeries(l, !0, i);
      }
    });
  }
}
function jC(t, r, e) {
  if (!(t == null || r == null)) {
    var n = e.getModel().getComponent(t, r);
    if (n) {
      G7(n).isBlured = !0;
      var i = e.getViewOfComponentModel(n);
      !i || !i.focusBlurEnabled || i.group.traverse(function(a) {
        F7(a);
      });
    }
  }
}
function GU(t, r, e) {
  var n = t.seriesIndex, i = t.getData(r.dataType);
  if (!i) {
    process.env.NODE_ENV !== "production" && jn("Unknown dataType " + r.dataType);
    return;
  }
  var a = Gc(i, r);
  a = (ue(a) ? a[0] : a) || 0;
  var o = i.getItemGraphicEl(a);
  if (!o)
    for (var s = i.count(), l = 0; !o && l < s; )
      o = i.getItemGraphicEl(l++);
  if (o) {
    var u = Ze(o);
    ZC(n, u.focus, u.blurScope, e);
  } else {
    var c = t.get(["emphasis", "focus"]), d = t.get(["emphasis", "blurScope"]);
    c != null && ZC(n, c, d, e);
  }
}
function z7(t, r, e, n) {
  var i = {
    focusSelf: !1,
    dispatchers: null
  };
  if (t == null || t === "series" || r == null || e == null)
    return i;
  var a = n.getModel().getComponent(t, r);
  if (!a)
    return i;
  var o = n.getViewOfComponentModel(a);
  if (!o || !o.findHighDownDispatchers)
    return i;
  for (var s = o.findHighDownDispatchers(e), l, u = 0; u < s.length; u++)
    if (process.env.NODE_ENV !== "production" && !eu(s[u]) && jn("param should be highDownDispatcher"), Ze(s[u]).focus === "self") {
      l = !0;
      break;
    }
  return {
    focusSelf: l,
    dispatchers: s
  };
}
function BU(t, r, e) {
  process.env.NODE_ENV !== "production" && !eu(t) && jn("param should be highDownDispatcher");
  var n = Ze(t), i = z7(n.componentMainType, n.componentIndex, n.componentHighDownName, e), a = i.dispatchers, o = i.focusSelf;
  a ? (o && jC(n.componentMainType, n.componentIndex, e), L(a, function(s) {
    return OS(s, r);
  })) : (ZC(n.seriesIndex, n.focus, n.blurScope, e), n.focus === "self" && jC(n.componentMainType, n.componentIndex, e), OS(t, r));
}
function FU(t, r, e) {
  process.env.NODE_ENV !== "production" && !eu(t) && jn("param should be highDownDispatcher"), UN(e);
  var n = Ze(t), i = z7(n.componentMainType, n.componentIndex, n.componentHighDownName, e).dispatchers;
  i ? L(i, function(a) {
    return VS(a, r);
  }) : VS(t, r);
}
function HU(t, r, e) {
  if (XC(r)) {
    var n = r.dataType, i = t.getData(n), a = Gc(i, r);
    ue(a) || (a = [a]), t[r.type === Kp ? "toggleSelect" : r.type === Jp ? "select" : "unselect"](a, n);
  }
}
function GS(t) {
  var r = t.getAllData();
  L(r, function(e) {
    var n = e.data, i = e.type;
    n.eachItemGraphicEl(function(a, o) {
      t.isSelected(o, i) ? YN(a) : XN(a);
    });
  });
}
function zU(t) {
  var r = [];
  return t.eachSeries(function(e) {
    var n = e.getAllData();
    L(n, function(i) {
      i.data;
      var a = i.type, o = e.getSelectedDataIndices();
      if (o.length > 0) {
        var s = {
          dataIndex: o,
          seriesIndex: e.seriesIndex
        };
        a != null && (s.dataType = a), r.push(s);
      }
    });
  }), r;
}
function Fl(t, r, e) {
  dc(t, !0), al(t, Fc), YC(t, r, e);
}
function WU(t) {
  dc(t, !1);
}
function Vr(t, r, e, n) {
  n ? WU(t) : Fl(t, r, e);
}
function YC(t, r, e) {
  var n = Ze(t);
  r != null ? (n.focus = r, n.blurScope = e) : n.focus && (n.focus = null);
}
var BS = ["emphasis", "blur", "select"], ZU = {
  itemStyle: "getItemStyle",
  lineStyle: "getLineStyle",
  areaStyle: "getAreaStyle"
};
function Yn(t, r, e, n) {
  e = e || "itemStyle";
  for (var i = 0; i < BS.length; i++) {
    var a = BS[i], o = r.getModel([a, e]), s = t.ensureState(a);
    s.style = n ? n(o) : o[ZU[e]]();
  }
}
function dc(t, r) {
  var e = r === !1, n = t;
  t.highDownSilentOnTouch && (n.__highDownSilentOnTouch = t.highDownSilentOnTouch), (!e || n.__highDownDispatcher) && (n.__highByOuter = n.__highByOuter || 0, n.__highDownDispatcher = !e);
}
function eu(t) {
  return !!(t && t.__highDownDispatcher);
}
function jU(t, r, e) {
  var n = Ze(t);
  n.componentMainType = r.mainType, n.componentIndex = r.componentIndex, n.componentHighDownName = e;
}
function YU(t) {
  var r = PS[t];
  return r == null && kS <= 32 && (r = PS[t] = kS++), r;
}
function XC(t) {
  var r = t.type;
  return r === Jp || r === M0 || r === Kp;
}
function FS(t) {
  var r = t.type;
  return r === Sc || r === T0;
}
function XU(t) {
  var r = HN(t);
  r.normalFill = t.style.fill, r.normalStroke = t.style.stroke;
  var e = t.states.select || {};
  r.selectFill = e.style && e.style.fill || null, r.selectStroke = e.style && e.style.stroke || null;
}
var md = Qo.CMD, $U = [[], [], []], HS = Math.sqrt, UU = Math.atan2;
function JN(t, r) {
  if (r) {
    var e = t.data, n = t.len(), i, a, o, s, l, u, c = md.M, d = md.C, f = md.L, h = md.R, p = md.A, v = md.Q;
    for (o = 0, s = 0; o < n; ) {
      switch (i = e[o++], s = o, a = 0, i) {
        case c:
          a = 1;
          break;
        case f:
          a = 1;
          break;
        case d:
          a = 3;
          break;
        case v:
          a = 2;
          break;
        case p:
          var g = r[4], m = r[5], y = HS(r[0] * r[0] + r[1] * r[1]), b = HS(r[2] * r[2] + r[3] * r[3]), C = UU(-r[1] / b, r[0] / y);
          e[o] *= y, e[o++] += g, e[o] *= b, e[o++] += m, e[o++] *= y, e[o++] *= b, e[o++] += C, e[o++] += C, o += 2, s = o;
          break;
        case h:
          u[0] = e[o++], u[1] = e[o++], En(u, u, r), e[s++] = u[0], e[s++] = u[1], u[0] += e[o++], u[1] += e[o++], En(u, u, r), e[s++] = u[0], e[s++] = u[1];
      }
      for (l = 0; l < a; l++) {
        var w = $U[l];
        w[0] = e[o++], w[1] = e[o++], En(w, w, r), e[s++] = w[0], e[s++] = w[1];
      }
    }
    t.increaseVersion();
  }
}
var nb = Math.sqrt, c1 = Math.sin, d1 = Math.cos, Fh = Math.PI;
function zS(t) {
  return Math.sqrt(t[0] * t[0] + t[1] * t[1]);
}
function $C(t, r) {
  return (t[0] * r[0] + t[1] * r[1]) / (zS(t) * zS(r));
}
function WS(t, r) {
  return (t[0] * r[1] < t[1] * r[0] ? -1 : 1) * Math.acos($C(t, r));
}
function ZS(t, r, e, n, i, a, o, s, l, u, c) {
  var d = l * (Fh / 180), f = d1(d) * (t - e) / 2 + c1(d) * (r - n) / 2, h = -1 * c1(d) * (t - e) / 2 + d1(d) * (r - n) / 2, p = f * f / (o * o) + h * h / (s * s);
  p > 1 && (o *= nb(p), s *= nb(p));
  var v = (i === a ? -1 : 1) * nb((o * o * (s * s) - o * o * (h * h) - s * s * (f * f)) / (o * o * (h * h) + s * s * (f * f))) || 0, g = v * o * h / s, m = v * -s * f / o, y = (t + e) / 2 + d1(d) * g - c1(d) * m, b = (r + n) / 2 + c1(d) * g + d1(d) * m, C = WS([1, 0], [(f - g) / o, (h - m) / s]), w = [(f - g) / o, (h - m) / s], _ = [(-1 * f - g) / o, (-1 * h - m) / s], x = WS(w, _);
  if ($C(w, _) <= -1 && (x = Fh), $C(w, _) >= 1 && (x = 0), x < 0) {
    var I = Math.round(x / Fh * 1e6) / 1e6;
    x = Fh * 2 + I % 2 * Fh;
  }
  c.addData(u, y, b, o, s, C, x, d, a);
}
var JU = /([mlvhzcqtsa])([^mlvhzcqtsa]*)/ig, KU = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g;
function qU(t) {
  var r = new Qo();
  if (!t)
    return r;
  var e = 0, n = 0, i = e, a = n, o, s = Qo.CMD, l = t.match(JU);
  if (!l)
    return r;
  for (var u = 0; u < l.length; u++) {
    for (var c = l[u], d = c.charAt(0), f = void 0, h = c.match(KU) || [], p = h.length, v = 0; v < p; v++)
      h[v] = parseFloat(h[v]);
    for (var g = 0; g < p; ) {
      var m = void 0, y = void 0, b = void 0, C = void 0, w = void 0, _ = void 0, x = void 0, I = e, D = n, T = void 0, A = void 0;
      switch (d) {
        case "l":
          e += h[g++], n += h[g++], f = s.L, r.addData(f, e, n);
          break;
        case "L":
          e = h[g++], n = h[g++], f = s.L, r.addData(f, e, n);
          break;
        case "m":
          e += h[g++], n += h[g++], f = s.M, r.addData(f, e, n), i = e, a = n, d = "l";
          break;
        case "M":
          e = h[g++], n = h[g++], f = s.M, r.addData(f, e, n), i = e, a = n, d = "L";
          break;
        case "h":
          e += h[g++], f = s.L, r.addData(f, e, n);
          break;
        case "H":
          e = h[g++], f = s.L, r.addData(f, e, n);
          break;
        case "v":
          n += h[g++], f = s.L, r.addData(f, e, n);
          break;
        case "V":
          n = h[g++], f = s.L, r.addData(f, e, n);
          break;
        case "C":
          f = s.C, r.addData(f, h[g++], h[g++], h[g++], h[g++], h[g++], h[g++]), e = h[g - 2], n = h[g - 1];
          break;
        case "c":
          f = s.C, r.addData(f, h[g++] + e, h[g++] + n, h[g++] + e, h[g++] + n, h[g++] + e, h[g++] + n), e += h[g - 2], n += h[g - 1];
          break;
        case "S":
          m = e, y = n, T = r.len(), A = r.data, o === s.C && (m += e - A[T - 4], y += n - A[T - 3]), f = s.C, I = h[g++], D = h[g++], e = h[g++], n = h[g++], r.addData(f, m, y, I, D, e, n);
          break;
        case "s":
          m = e, y = n, T = r.len(), A = r.data, o === s.C && (m += e - A[T - 4], y += n - A[T - 3]), f = s.C, I = e + h[g++], D = n + h[g++], e += h[g++], n += h[g++], r.addData(f, m, y, I, D, e, n);
          break;
        case "Q":
          I = h[g++], D = h[g++], e = h[g++], n = h[g++], f = s.Q, r.addData(f, I, D, e, n);
          break;
        case "q":
          I = h[g++] + e, D = h[g++] + n, e += h[g++], n += h[g++], f = s.Q, r.addData(f, I, D, e, n);
          break;
        case "T":
          m = e, y = n, T = r.len(), A = r.data, o === s.Q && (m += e - A[T - 4], y += n - A[T - 3]), e = h[g++], n = h[g++], f = s.Q, r.addData(f, m, y, e, n);
          break;
        case "t":
          m = e, y = n, T = r.len(), A = r.data, o === s.Q && (m += e - A[T - 4], y += n - A[T - 3]), e += h[g++], n += h[g++], f = s.Q, r.addData(f, m, y, e, n);
          break;
        case "A":
          b = h[g++], C = h[g++], w = h[g++], _ = h[g++], x = h[g++], I = e, D = n, e = h[g++], n = h[g++], f = s.A, ZS(I, D, e, n, _, x, b, C, w, f, r);
          break;
        case "a":
          b = h[g++], C = h[g++], w = h[g++], _ = h[g++], x = h[g++], I = e, D = n, e += h[g++], n += h[g++], f = s.A, ZS(I, D, e, n, _, x, b, C, w, f, r);
          break;
      }
    }
    (d === "z" || d === "Z") && (f = s.Z, r.addData(f), e = i, n = a), o = f;
  }
  return r.toStatic(), r;
}
var KN = function(t) {
  _r(r, t);
  function r() {
    return t !== null && t.apply(this, arguments) || this;
  }
  return r.prototype.applyTransform = function(e) {
  }, r;
}(gt);
function qN(t) {
  return t.setData != null;
}
function QN(t, r) {
  var e = qU(t), n = ae({}, r);
  return n.buildPath = function(i) {
    if (qN(i)) {
      i.setData(e.data);
      var a = i.getContext();
      a && i.rebuildPath(a, 1);
    } else {
      var a = i;
      e.rebuildPath(a, 1);
    }
  }, n.applyTransform = function(i) {
    JN(e, i), this.dirtyShape();
  }, n;
}
function eO(t, r) {
  return new KN(QN(t, r));
}
function QU(t, r) {
  var e = QN(t, r), n = function(i) {
    _r(a, i);
    function a(o) {
      var s = i.call(this, o) || this;
      return s.applyTransform = e.applyTransform, s.buildPath = e.buildPath, s;
    }
    return a;
  }(KN);
  return n;
}
function eJ(t, r) {
  for (var e = [], n = t.length, i = 0; i < n; i++) {
    var a = t[i];
    e.push(a.getUpdatedPathProxy(!0));
  }
  var o = new gt(r);
  return o.createPathProxy(), o.buildPath = function(s) {
    if (qN(s)) {
      s.appendPath(e);
      var l = s.getContext();
      l && s.rebuildPath(l, 1);
    }
  }, o;
}
function W7(t, r) {
  r = r || {};
  var e = new gt();
  return t.shape && e.setShape(t.shape), e.setStyle(t.style), r.bakeTransform ? JN(e.path, t.getComputedTransform()) : r.toLocal ? e.setLocalTransform(t.getComputedTransform()) : e.copyTransform(t), e.buildPath = t.buildPath, e.applyTransform = e.applyTransform, e.z = t.z, e.z2 = t.z2, e.zlevel = t.zlevel, e;
}
var tJ = /* @__PURE__ */ function() {
  function t() {
    this.cx = 0, this.cy = 0, this.r = 0;
  }
  return t;
}(), is = function(t) {
  _r(r, t);
  function r(e) {
    return t.call(this, e) || this;
  }
  return r.prototype.getDefaultShape = function() {
    return new tJ();
  }, r.prototype.buildPath = function(e, n) {
    e.moveTo(n.cx + n.r, n.cy), e.arc(n.cx, n.cy, n.r, 0, Math.PI * 2);
  }, r;
}(gt);
is.prototype.type = "circle";
var rJ = /* @__PURE__ */ function() {
  function t() {
    this.cx = 0, this.cy = 0, this.rx = 0, this.ry = 0;
  }
  return t;
}(), pg = function(t) {
  _r(r, t);
  function r(e) {
    return t.call(this, e) || this;
  }
  return r.prototype.getDefaultShape = function() {
    return new rJ();
  }, r.prototype.buildPath = function(e, n) {
    var i = 0.5522848, a = n.cx, o = n.cy, s = n.rx, l = n.ry, u = s * i, c = l * i;
    e.moveTo(a - s, o), e.bezierCurveTo(a - s, o - c, a - u, o - l, a, o - l), e.bezierCurveTo(a + u, o - l, a + s, o - c, a + s, o), e.bezierCurveTo(a + s, o + c, a + u, o + l, a, o + l), e.bezierCurveTo(a - u, o + l, a - s, o + c, a - s, o), e.closePath();
  }, r;
}(gt);
pg.prototype.type = "ellipse";
var tO = Math.PI, ib = tO * 2, Nu = Math.sin, yd = Math.cos, nJ = Math.acos, Un = Math.atan2, jS = Math.abs, qp = Math.sqrt, Tp = Math.max, Co = Math.min, Ha = 1e-4;
function iJ(t, r, e, n, i, a, o, s) {
  var l = e - t, u = n - r, c = o - i, d = s - a, f = d * l - c * u;
  if (!(f * f < Ha))
    return f = (c * (r - a) - d * (t - i)) / f, [t + f * l, r + f * u];
}
function f1(t, r, e, n, i, a, o) {
  var s = t - e, l = r - n, u = (o ? a : -a) / qp(s * s + l * l), c = u * l, d = -u * s, f = t + c, h = r + d, p = e + c, v = n + d, g = (f + p) / 2, m = (h + v) / 2, y = p - f, b = v - h, C = y * y + b * b, w = i - a, _ = f * v - p * h, x = (b < 0 ? -1 : 1) * qp(Tp(0, w * w * C - _ * _)), I = (_ * b - y * x) / C, D = (-_ * y - b * x) / C, T = (_ * b + y * x) / C, A = (-_ * y + b * x) / C, M = I - g, R = D - m, E = T - g, k = A - m;
  return M * M + R * R > E * E + k * k && (I = T, D = A), {
    cx: I,
    cy: D,
    x0: -c,
    y0: -d,
    x1: I * (i / w - 1),
    y1: D * (i / w - 1)
  };
}
function aJ(t) {
  var r;
  if (ue(t)) {
    var e = t.length;
    if (!e)
      return t;
    e === 1 ? r = [t[0], t[0], 0, 0] : e === 2 ? r = [t[0], t[0], t[1], t[1]] : e === 3 ? r = t.concat(t[2]) : r = t;
  } else
    r = [t, t, t, t];
  return r;
}
function oJ(t, r) {
  var e, n = Tp(r.r, 0), i = Tp(r.r0 || 0, 0), a = n > 0, o = i > 0;
  if (!(!a && !o)) {
    if (a || (n = i, i = 0), i > n) {
      var s = n;
      n = i, i = s;
    }
    var l = r.startAngle, u = r.endAngle;
    if (!(isNaN(l) || isNaN(u))) {
      var c = r.cx, d = r.cy, f = !!r.clockwise, h = jS(u - l), p = h > ib && h % ib;
      if (p > Ha && (h = p), !(n > Ha))
        t.moveTo(c, d);
      else if (h > ib - Ha)
        t.moveTo(c + n * yd(l), d + n * Nu(l)), t.arc(c, d, n, l, u, !f), i > Ha && (t.moveTo(c + i * yd(u), d + i * Nu(u)), t.arc(c, d, i, u, l, f));
      else {
        var v = void 0, g = void 0, m = void 0, y = void 0, b = void 0, C = void 0, w = void 0, _ = void 0, x = void 0, I = void 0, D = void 0, T = void 0, A = void 0, M = void 0, R = void 0, E = void 0, k = n * yd(l), P = n * Nu(l), N = i * yd(u), O = i * Nu(u), W = h > Ha;
        if (W) {
          var V = r.cornerRadius;
          V && (e = aJ(V), v = e[0], g = e[1], m = e[2], y = e[3]);
          var B = jS(n - i) / 2;
          if (b = Co(B, m), C = Co(B, y), w = Co(B, v), _ = Co(B, g), D = x = Tp(b, C), T = I = Tp(w, _), (x > Ha || I > Ha) && (A = n * yd(u), M = n * Nu(u), R = i * yd(l), E = i * Nu(l), h < tO)) {
            var Z = iJ(k, P, R, E, A, M, N, O);
            if (Z) {
              var q = k - Z[0], z = P - Z[1], U = A - Z[0], J = M - Z[1], K = 1 / Nu(nJ((q * U + z * J) / (qp(q * q + z * z) * qp(U * U + J * J))) / 2), j = qp(Z[0] * Z[0] + Z[1] * Z[1]);
              D = Co(x, (n - j) / (K + 1)), T = Co(I, (i - j) / (K - 1));
            }
          }
        }
        if (!W)
          t.moveTo(c + k, d + P);
        else if (D > Ha) {
          var oe = Co(m, D), ie = Co(y, D), le = f1(R, E, k, P, n, oe, f), re = f1(A, M, N, O, n, ie, f);
          t.moveTo(c + le.cx + le.x0, d + le.cy + le.y0), D < x && oe === ie ? t.arc(c + le.cx, d + le.cy, D, Un(le.y0, le.x0), Un(re.y0, re.x0), !f) : (oe > 0 && t.arc(c + le.cx, d + le.cy, oe, Un(le.y0, le.x0), Un(le.y1, le.x1), !f), t.arc(c, d, n, Un(le.cy + le.y1, le.cx + le.x1), Un(re.cy + re.y1, re.cx + re.x1), !f), ie > 0 && t.arc(c + re.cx, d + re.cy, ie, Un(re.y1, re.x1), Un(re.y0, re.x0), !f));
        } else
          t.moveTo(c + k, d + P), t.arc(c, d, n, l, u, !f);
        if (!(i > Ha) || !W)
          t.lineTo(c + N, d + O);
        else if (T > Ha) {
          var oe = Co(v, T), ie = Co(g, T), le = f1(N, O, A, M, i, -ie, f), re = f1(k, P, R, E, i, -oe, f);
          t.lineTo(c + le.cx + le.x0, d + le.cy + le.y0), T < I && oe === ie ? t.arc(c + le.cx, d + le.cy, T, Un(le.y0, le.x0), Un(re.y0, re.x0), !f) : (ie > 0 && t.arc(c + le.cx, d + le.cy, ie, Un(le.y0, le.x0), Un(le.y1, le.x1), !f), t.arc(c, d, i, Un(le.cy + le.y1, le.cx + le.x1), Un(re.cy + re.y1, re.cx + re.x1), f), oe > 0 && t.arc(c + re.cx, d + re.cy, oe, Un(re.y1, re.x1), Un(re.y0, re.x0), !f));
        } else
          t.lineTo(c + N, d + O), t.arc(c, d, i, u, l, f);
      }
      t.closePath();
    }
  }
}
var sJ = /* @__PURE__ */ function() {
  function t() {
    this.cx = 0, this.cy = 0, this.r0 = 0, this.r = 0, this.startAngle = 0, this.endAngle = Math.PI * 2, this.clockwise = !0, this.cornerRadius = 0;
  }
  return t;
}(), oi = function(t) {
  _r(r, t);
  function r(e) {
    return t.call(this, e) || this;
  }
  return r.prototype.getDefaultShape = function() {
    return new sJ();
  }, r.prototype.buildPath = function(e, n) {
    oJ(e, n);
  }, r.prototype.isZeroArea = function() {
    return this.shape.startAngle === this.shape.endAngle || this.shape.r === this.shape.r0;
  }, r;
}(gt);
oi.prototype.type = "sector";
var lJ = /* @__PURE__ */ function() {
  function t() {
    this.cx = 0, this.cy = 0, this.r = 0, this.r0 = 0;
  }
  return t;
}(), eh = function(t) {
  _r(r, t);
  function r(e) {
    return t.call(this, e) || this;
  }
  return r.prototype.getDefaultShape = function() {
    return new lJ();
  }, r.prototype.buildPath = function(e, n) {
    var i = n.cx, a = n.cy, o = Math.PI * 2;
    e.moveTo(i + n.r, a), e.arc(i, a, n.r, 0, o, !1), e.moveTo(i + n.r0, a), e.arc(i, a, n.r0, 0, o, !0);
  }, r;
}(gt);
eh.prototype.type = "ring";
function uJ(t, r, e, n) {
  var i = [], a = [], o = [], s = [], l, u, c, d;
  if (n) {
    c = [1 / 0, 1 / 0], d = [-1 / 0, -1 / 0];
    for (var f = 0, h = t.length; f < h; f++)
      Ms(c, c, t[f]), Rs(d, d, t[f]);
    Ms(c, c, n[0]), Rs(d, d, n[1]);
  }
  for (var f = 0, h = t.length; f < h; f++) {
    var p = t[f];
    if (e)
      l = t[f ? f - 1 : h - 1], u = t[(f + 1) % h];
    else if (f === 0 || f === h - 1) {
      i.push(Ho(t[f]));
      continue;
    } else
      l = t[f - 1], u = t[f + 1];
    Il(a, u, l), Wp(a, a, r);
    var v = lm(p, l), g = lm(p, u), m = v + g;
    m !== 0 && (v /= m, g /= m), Wp(o, a, -v), Wp(s, a, g);
    var y = yC([], p, o), b = yC([], p, s);
    n && (Rs(y, y, c), Ms(y, y, d), Rs(b, b, c), Ms(b, b, d)), i.push(y), i.push(b);
  }
  return e && i.push(i.shift()), i;
}
function rO(t, r, e) {
  var n = r.smooth, i = r.points;
  if (i && i.length >= 2) {
    if (n) {
      var a = uJ(i, n, e, r.smoothConstraint);
      t.moveTo(i[0][0], i[0][1]);
      for (var o = i.length, s = 0; s < (e ? o : o - 1); s++) {
        var l = a[s * 2], u = a[s * 2 + 1], c = i[(s + 1) % o];
        t.bezierCurveTo(l[0], l[1], u[0], u[1], c[0], c[1]);
      }
    } else {
      t.moveTo(i[0][0], i[0][1]);
      for (var s = 1, d = i.length; s < d; s++)
        t.lineTo(i[s][0], i[s][1]);
    }
    e && t.closePath();
  }
}
var cJ = /* @__PURE__ */ function() {
  function t() {
    this.points = null, this.smooth = 0, this.smoothConstraint = null;
  }
  return t;
}(), si = function(t) {
  _r(r, t);
  function r(e) {
    return t.call(this, e) || this;
  }
  return r.prototype.getDefaultShape = function() {
    return new cJ();
  }, r.prototype.buildPath = function(e, n) {
    rO(e, n, !0);
  }, r;
}(gt);
si.prototype.type = "polygon";
var dJ = /* @__PURE__ */ function() {
  function t() {
    this.points = null, this.percent = 1, this.smooth = 0, this.smoothConstraint = null;
  }
  return t;
}(), ci = function(t) {
  _r(r, t);
  function r(e) {
    return t.call(this, e) || this;
  }
  return r.prototype.getDefaultStyle = function() {
    return {
      stroke: "#000",
      fill: null
    };
  }, r.prototype.getDefaultShape = function() {
    return new dJ();
  }, r.prototype.buildPath = function(e, n) {
    rO(e, n, !1);
  }, r;
}(gt);
ci.prototype.type = "polyline";
var fJ = {}, hJ = /* @__PURE__ */ function() {
  function t() {
    this.x1 = 0, this.y1 = 0, this.x2 = 0, this.y2 = 0, this.percent = 1;
  }
  return t;
}(), gn = function(t) {
  _r(r, t);
  function r(e) {
    return t.call(this, e) || this;
  }
  return r.prototype.getDefaultStyle = function() {
    return {
      stroke: "#000",
      fill: null
    };
  }, r.prototype.getDefaultShape = function() {
    return new hJ();
  }, r.prototype.buildPath = function(e, n) {
    var i, a, o, s;
    if (this.subPixelOptimize) {
      var l = VN(fJ, n, this.style);
      i = l.x1, a = l.y1, o = l.x2, s = l.y2;
    } else
      i = n.x1, a = n.y1, o = n.x2, s = n.y2;
    var u = n.percent;
    u !== 0 && (e.moveTo(i, a), u < 1 && (o = i * (1 - u) + o * u, s = a * (1 - u) + s * u), e.lineTo(o, s));
  }, r.prototype.pointAt = function(e) {
    var n = this.shape;
    return [
      n.x1 * (1 - e) + n.x2 * e,
      n.y1 * (1 - e) + n.y2 * e
    ];
  }, r;
}(gt);
gn.prototype.type = "line";
var Mi = [], pJ = /* @__PURE__ */ function() {
  function t() {
    this.x1 = 0, this.y1 = 0, this.x2 = 0, this.y2 = 0, this.cpx1 = 0, this.cpy1 = 0, this.percent = 1;
  }
  return t;
}();
function YS(t, r, e) {
  var n = t.cpx2, i = t.cpy2;
  return n != null || i != null ? [
    (e ? J8 : bn)(t.x1, t.cpx1, t.cpx2, t.x2, r),
    (e ? J8 : bn)(t.y1, t.cpy1, t.cpy2, t.y2, r)
  ] : [
    (e ? xC : Rn)(t.x1, t.cpx1, t.x2, r),
    (e ? xC : Rn)(t.y1, t.cpy1, t.y2, r)
  ];
}
var th = function(t) {
  _r(r, t);
  function r(e) {
    return t.call(this, e) || this;
  }
  return r.prototype.getDefaultStyle = function() {
    return {
      stroke: "#000",
      fill: null
    };
  }, r.prototype.getDefaultShape = function() {
    return new pJ();
  }, r.prototype.buildPath = function(e, n) {
    var i = n.x1, a = n.y1, o = n.x2, s = n.y2, l = n.cpx1, u = n.cpy1, c = n.cpx2, d = n.cpy2, f = n.percent;
    f !== 0 && (e.moveTo(i, a), c == null || d == null ? (f < 1 && (vv(i, l, o, f, Mi), l = Mi[1], o = Mi[2], vv(a, u, s, f, Mi), u = Mi[1], s = Mi[2]), e.quadraticCurveTo(l, u, o, s)) : (f < 1 && (Ql(i, l, c, o, f, Mi), l = Mi[1], c = Mi[2], o = Mi[3], Ql(a, u, d, s, f, Mi), u = Mi[1], d = Mi[2], s = Mi[3]), e.bezierCurveTo(l, u, c, d, o, s)));
  }, r.prototype.pointAt = function(e) {
    return YS(this.shape, e, !1);
  }, r.prototype.tangentAt = function(e) {
    var n = YS(this.shape, e, !0);
    return Jc(n, n);
  }, r;
}(gt);
th.prototype.type = "bezier-curve";
var vJ = /* @__PURE__ */ function() {
  function t() {
    this.cx = 0, this.cy = 0, this.r = 0, this.startAngle = 0, this.endAngle = Math.PI * 2, this.clockwise = !0;
  }
  return t;
}(), vg = function(t) {
  _r(r, t);
  function r(e) {
    return t.call(this, e) || this;
  }
  return r.prototype.getDefaultStyle = function() {
    return {
      stroke: "#000",
      fill: null
    };
  }, r.prototype.getDefaultShape = function() {
    return new vJ();
  }, r.prototype.buildPath = function(e, n) {
    var i = n.cx, a = n.cy, o = Math.max(n.r, 0), s = n.startAngle, l = n.endAngle, u = n.clockwise, c = Math.cos(s), d = Math.sin(s);
    e.moveTo(c * o + i, d * o + a), e.arc(i, a, o, s, l, !u);
  }, r;
}(gt);
vg.prototype.type = "arc";
var c2 = function(t) {
  _r(r, t);
  function r() {
    var e = t !== null && t.apply(this, arguments) || this;
    return e.type = "compound", e;
  }
  return r.prototype._updatePathDirty = function() {
    for (var e = this.shape.paths, n = this.shapeChanged(), i = 0; i < e.length; i++)
      n = n || e[i].shapeChanged();
    n && this.dirtyShape();
  }, r.prototype.beforeBrush = function() {
    this._updatePathDirty();
    for (var e = this.shape.paths || [], n = this.getGlobalScale(), i = 0; i < e.length; i++)
      e[i].path || e[i].createPathProxy(), e[i].path.setScale(n[0], n[1], e[i].segmentIgnoreThreshold);
  }, r.prototype.buildPath = function(e, n) {
    for (var i = n.paths || [], a = 0; a < i.length; a++)
      i[a].buildPath(e, i[a].shape, !0);
  }, r.prototype.afterBrush = function() {
    for (var e = this.shape.paths || [], n = 0; n < e.length; n++)
      e[n].pathUpdated();
  }, r.prototype.getBoundingRect = function() {
    return this._updatePathDirty.call(this), gt.prototype.getBoundingRect.call(this);
  }, r;
}(gt), nO = function() {
  function t(r) {
    this.colorStops = r || [];
  }
  return t.prototype.addColorStop = function(r, e) {
    this.colorStops.push({
      offset: r,
      color: e
    });
  }, t;
}(), rh = function(t) {
  _r(r, t);
  function r(e, n, i, a, o, s) {
    var l = t.call(this, o) || this;
    return l.x = e ?? 0, l.y = n ?? 0, l.x2 = i ?? 1, l.y2 = a ?? 0, l.type = "linear", l.global = s || !1, l;
  }
  return r;
}(nO), Z7 = function(t) {
  _r(r, t);
  function r(e, n, i, a, o) {
    var s = t.call(this, a) || this;
    return s.x = e ?? 0.5, s.y = n ?? 0.5, s.r = i ?? 0.5, s.type = "radial", s.global = o || !1, s;
  }
  return r;
}(nO), Ou = [0, 0], Vu = [0, 0], h1 = new tt(), p1 = new tt(), Cm = function() {
  function t(r, e) {
    this._corners = [], this._axes = [], this._origin = [0, 0];
    for (var n = 0; n < 4; n++)
      this._corners[n] = new tt();
    for (var n = 0; n < 2; n++)
      this._axes[n] = new tt();
    r && this.fromBoundingRect(r, e);
  }
  return t.prototype.fromBoundingRect = function(r, e) {
    var n = this._corners, i = this._axes, a = r.x, o = r.y, s = a + r.width, l = o + r.height;
    if (n[0].set(a, o), n[1].set(s, o), n[2].set(s, l), n[3].set(a, l), e)
      for (var u = 0; u < 4; u++)
        n[u].transform(e);
    tt.sub(i[0], n[1], n[0]), tt.sub(i[1], n[3], n[0]), i[0].normalize(), i[1].normalize();
    for (var u = 0; u < 2; u++)
      this._origin[u] = i[u].dot(n[0]);
  }, t.prototype.intersect = function(r, e) {
    var n = !0, i = !e;
    return h1.set(1 / 0, 1 / 0), p1.set(0, 0), !this._intersectCheckOneSide(this, r, h1, p1, i, 1) && (n = !1, i) || !this._intersectCheckOneSide(r, this, h1, p1, i, -1) && (n = !1, i) || i || tt.copy(e, n ? h1 : p1), n;
  }, t.prototype._intersectCheckOneSide = function(r, e, n, i, a, o) {
    for (var s = !0, l = 0; l < 2; l++) {
      var u = this._axes[l];
      if (this._getProjMinMaxOnAxis(l, r._corners, Ou), this._getProjMinMaxOnAxis(l, e._corners, Vu), Ou[1] < Vu[0] || Ou[0] > Vu[1]) {
        if (s = !1, a)
          return s;
        var c = Math.abs(Vu[0] - Ou[1]), d = Math.abs(Ou[0] - Vu[1]);
        Math.min(c, d) > i.len() && (c < d ? tt.scale(i, u, -c * o) : tt.scale(i, u, d * o));
      } else if (n) {
        var c = Math.abs(Vu[0] - Ou[1]), d = Math.abs(Ou[0] - Vu[1]);
        Math.min(c, d) < n.len() && (c < d ? tt.scale(n, u, c * o) : tt.scale(n, u, -d * o));
      }
    }
    return s;
  }, t.prototype._getProjMinMaxOnAxis = function(r, e, n) {
    for (var i = this._axes[r], a = this._origin, o = e[0].dot(i) + a[r], s = o, l = o, u = 1; u < e.length; u++) {
      var c = e[u].dot(i) + a[r];
      s = Math.min(c, s), l = Math.max(c, l);
    }
    n[0] = s, n[1] = l;
  }, t;
}(), gJ = [], iO = function(t) {
  _r(r, t);
  function r() {
    var e = t !== null && t.apply(this, arguments) || this;
    return e.notClear = !0, e.incremental = !0, e._displayables = [], e._temporaryDisplayables = [], e._cursor = 0, e;
  }
  return r.prototype.traverse = function(e, n) {
    e.call(n, this);
  }, r.prototype.useStyle = function() {
    this.style = {};
  }, r.prototype.getCursor = function() {
    return this._cursor;
  }, r.prototype.innerAfterBrush = function() {
    this._cursor = this._displayables.length;
  }, r.prototype.clearDisplaybles = function() {
    this._displayables = [], this._temporaryDisplayables = [], this._cursor = 0, this.markRedraw(), this.notClear = !1;
  }, r.prototype.clearTemporalDisplayables = function() {
    this._temporaryDisplayables = [];
  }, r.prototype.addDisplayable = function(e, n) {
    n ? this._temporaryDisplayables.push(e) : this._displayables.push(e), this.markRedraw();
  }, r.prototype.addDisplayables = function(e, n) {
    n = n || !1;
    for (var i = 0; i < e.length; i++)
      this.addDisplayable(e[i], n);
  }, r.prototype.getDisplayables = function() {
    return this._displayables;
  }, r.prototype.getTemporalDisplayables = function() {
    return this._temporaryDisplayables;
  }, r.prototype.eachPendingDisplayable = function(e) {
    for (var n = this._cursor; n < this._displayables.length; n++)
      e && e(this._displayables[n]);
    for (var n = 0; n < this._temporaryDisplayables.length; n++)
      e && e(this._temporaryDisplayables[n]);
  }, r.prototype.update = function() {
    this.updateTransform();
    for (var e = this._cursor; e < this._displayables.length; e++) {
      var n = this._displayables[e];
      n.parent = this, n.update(), n.parent = null;
    }
    for (var e = 0; e < this._temporaryDisplayables.length; e++) {
      var n = this._temporaryDisplayables[e];
      n.parent = this, n.update(), n.parent = null;
    }
  }, r.prototype.getBoundingRect = function() {
    if (!this._rect) {
      for (var e = new rt(1 / 0, 1 / 0, -1 / 0, -1 / 0), n = 0; n < this._displayables.length; n++) {
        var i = this._displayables[n], a = i.getBoundingRect().clone();
        i.needLocalTransform() && a.applyTransform(i.getLocalTransform(gJ)), e.union(a);
      }
      this._rect = e;
    }
    return this._rect;
  }, r.prototype.contain = function(e, n) {
    var i = this.transformCoordToLocal(e, n), a = this.getBoundingRect();
    if (a.contain(i[0], i[1]))
      for (var o = 0; o < this._displayables.length; o++) {
        var s = this._displayables[o];
        if (s.contain(e, n))
          return !0;
      }
    return !1;
  }, r;
}(La), aO = It();
function nh(t, r, e, n, i) {
  var a;
  if (r && r.ecModel) {
    var o = r.ecModel.getUpdatePayload();
    a = o && o.animation;
  }
  var s = r && r.isAnimationEnabled(), l = t === "update";
  if (s) {
    var u = void 0, c = void 0, d = void 0;
    n ? (u = je(n.duration, 200), c = je(n.easing, "cubicOut"), d = 0) : (u = r.getShallow(l ? "animationDurationUpdate" : "animationDuration"), c = r.getShallow(l ? "animationEasingUpdate" : "animationEasing"), d = r.getShallow(l ? "animationDelayUpdate" : "animationDelay")), a && (a.duration != null && (u = a.duration), a.easing != null && (c = a.easing), a.delay != null && (d = a.delay)), Ae(d) && (d = d(e, i)), Ae(u) && (u = u(e));
    var f = {
      duration: u || 0,
      delay: d,
      easing: c
    };
    return f;
  } else
    return null;
}
function j7(t, r, e, n, i, a, o) {
  var s = !1, l;
  Ae(i) ? (o = a, a = i, i = null) : Me(i) && (a = i.cb, o = i.during, s = i.isFrom, l = i.removeOpt, i = i.dataIndex);
  var u = t === "leave";
  u || r.stopAnimation("leave");
  var c = nh(t, n, i, u ? l || {} : null, n && n.getAnimationDelayParams ? n.getAnimationDelayParams(r, i) : null);
  if (c && c.duration > 0) {
    var d = c.duration, f = c.delay, h = c.easing, p = {
      duration: d,
      delay: f || 0,
      easing: h,
      done: a,
      force: !!a || !!o,
      // Set to final state in update/init animation.
      // So the post processing based on the path shape can be done correctly.
      setToFinal: !u,
      scope: t,
      during: o
    };
    s ? r.animateFrom(e, p) : r.animateTo(e, p);
  } else
    r.stopAnimation(), !s && r.attr(e), o && o(1), a && a();
}
function kt(t, r, e, n, i, a) {
  j7("update", t, r, e, n, i, a);
}
function Cr(t, r, e, n, i, a) {
  j7("enter", t, r, e, n, i, a);
}
function hf(t) {
  if (!t.__zr)
    return !0;
  for (var r = 0; r < t.animators.length; r++) {
    var e = t.animators[r];
    if (e.scope === "leave")
      return !0;
  }
  return !1;
}
function tu(t, r, e, n, i, a) {
  hf(t) || j7("leave", t, r, e, n, i, a);
}
function XS(t, r, e, n) {
  t.removeTextContent(), t.removeTextGuideLine(), tu(t, {
    style: {
      opacity: 0
    }
  }, r, e, n);
}
function wv(t, r, e) {
  function n() {
    t.parent && t.parent.remove(t);
  }
  t.isGroup ? t.traverse(function(i) {
    i.isGroup || XS(i, r, e, n);
  }) : XS(t, r, e, n);
}
function ro(t) {
  aO(t).oldStyle = t.style;
}
function mJ(t) {
  return aO(t).oldStyle;
}
var wm = Math.max, _m = Math.min, UC = {};
function oO(t) {
  return gt.extend(t);
}
var yJ = QU;
function sO(t, r) {
  return yJ(t, r);
}
function Pa(t, r) {
  UC[t] = r;
}
function d2(t) {
  if (UC.hasOwnProperty(t))
    return UC[t];
}
function gg(t, r, e, n) {
  var i = eO(t, r);
  return e && (n === "center" && (e = lO(e, i.getBoundingRect())), X7(i, e)), i;
}
function Y7(t, r, e) {
  var n = new An({
    style: {
      image: t,
      x: r.x,
      y: r.y,
      width: r.width,
      height: r.height
    },
    onload: function(i) {
      if (e === "center") {
        var a = {
          width: i.width,
          height: i.height
        };
        n.setStyle(lO(r, a));
      }
    }
  });
  return n;
}
function lO(t, r) {
  var e = r.width / r.height, n = t.height * e, i;
  n <= t.width ? i = t.height : (n = t.width, i = n / e);
  var a = t.x + t.width / 2, o = t.y + t.height / 2;
  return {
    x: a - n / 2,
    y: o - i / 2,
    width: n,
    height: i
  };
}
var Yi = eJ;
function X7(t, r) {
  if (t.applyTransform) {
    var e = t.getBoundingRect(), n = e.calculateTransform(r);
    t.applyTransform(n);
  }
}
function Mf(t, r) {
  return VN(t, t, {
    lineWidth: r
  }), t;
}
function bJ(t) {
  return GN(t.shape, t.shape, t.style), t;
}
var R0 = cc;
function Hl(t, r) {
  for (var e = lg([]); t && t !== r; )
    zo(e, t.getLocalTransform(), e), t = t.parent;
  return e;
}
function Ka(t, r, e) {
  return r && !Zn(r) && (r = Ls.getLocalTransform(r)), e && (r = Kc([], r)), En([], t, r);
}
function f2(t, r, e) {
  var n = r[4] === 0 || r[5] === 0 || r[0] === 0 ? 1 : Math.abs(2 * r[4] / r[0]), i = r[4] === 0 || r[5] === 0 || r[2] === 0 ? 1 : Math.abs(2 * r[4] / r[2]), a = [t === "left" ? -n : t === "right" ? n : 0, t === "top" ? -i : t === "bottom" ? i : 0];
  return a = Ka(a, r, e), Math.abs(a[0]) > Math.abs(a[1]) ? a[0] > 0 ? "right" : "left" : a[1] > 0 ? "bottom" : "top";
}
function $S(t) {
  return !t.isGroup;
}
function CJ(t) {
  return t.shape != null;
}
function mg(t, r, e) {
  if (!t || !r)
    return;
  function n(o) {
    var s = {};
    return o.traverse(function(l) {
      $S(l) && l.anid && (s[l.anid] = l);
    }), s;
  }
  function i(o) {
    var s = {
      x: o.x,
      y: o.y,
      rotation: o.rotation
    };
    return CJ(o) && (s.shape = ae({}, o.shape)), s;
  }
  var a = n(t);
  r.traverse(function(o) {
    if ($S(o) && o.anid) {
      var s = a[o.anid];
      if (s) {
        var l = i(o);
        o.attr(i(s)), kt(o, l, e, Ze(o).dataIndex);
      }
    }
  });
}
function $7(t, r) {
  return ce(t, function(e) {
    var n = e[0];
    n = wm(n, r.x), n = _m(n, r.x + r.width);
    var i = e[1];
    return i = wm(i, r.y), i = _m(i, r.y + r.height), [n, i];
  });
}
function uO(t, r) {
  var e = wm(t.x, r.x), n = _m(t.x + t.width, r.x + r.width), i = wm(t.y, r.y), a = _m(t.y + t.height, r.y + r.height);
  if (n >= e && a >= i)
    return {
      x: e,
      y: i,
      width: n - e,
      height: a - i
    };
}
function ih(t, r, e) {
  var n = ae({
    rectHover: !0
  }, r), i = n.style = {
    strokeNoScale: !0
  };
  if (e = e || {
    x: -1,
    y: -1,
    width: 2,
    height: 2
  }, t)
    return t.indexOf("image://") === 0 ? (i.image = t.slice(8), Ee(i, e), new An(n)) : gg(t.replace("path://", ""), n, e, "center");
}
function Mp(t, r, e, n, i) {
  for (var a = 0, o = i[i.length - 1]; a < i.length; a++) {
    var s = i[a];
    if (cO(t, r, e, n, s[0], s[1], o[0], o[1]))
      return !0;
    o = s;
  }
}
function cO(t, r, e, n, i, a, o, s) {
  var l = e - t, u = n - r, c = o - i, d = s - a, f = ab(c, d, l, u);
  if (wJ(f))
    return !1;
  var h = t - i, p = r - a, v = ab(h, p, l, u) / f;
  if (v < 0 || v > 1)
    return !1;
  var g = ab(h, p, c, d) / f;
  return !(g < 0 || g > 1);
}
function ab(t, r, e, n) {
  return t * n - e * r;
}
function wJ(t) {
  return t <= 1e-6 && t >= -1e-6;
}
function ah(t) {
  var r = t.itemTooltipOption, e = t.componentModel, n = t.itemName, i = pe(r) ? {
    formatter: r
  } : r, a = e.mainType, o = e.componentIndex, s = {
    componentType: a,
    name: n,
    $vars: ["name"]
  };
  s[a + "Index"] = o;
  var l = t.formatterParamsExtra;
  l && L(yt(l), function(c) {
    be(s, c) || (s[c] = l[c], s.$vars.push(c));
  });
  var u = Ze(t.el);
  u.componentMainType = a, u.componentIndex = o, u.tooltipConfig = {
    name: n,
    option: Ee({
      content: n,
      encodeHTMLContent: !0,
      formatterParams: s
    }, i)
  };
}
function US(t, r) {
  var e;
  t.isGroup && (e = r(t)), e || t.traverse(r);
}
function pu(t, r) {
  if (t)
    if (ue(t))
      for (var e = 0; e < t.length; e++)
        US(t[e], r);
    else
      US(t, r);
}
Pa("circle", is);
Pa("ellipse", pg);
Pa("sector", oi);
Pa("ring", eh);
Pa("polygon", si);
Pa("polyline", ci);
Pa("rect", xt);
Pa("line", gn);
Pa("bezierCurve", th);
Pa("arc", vg);
const qc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Arc: vg,
  BezierCurve: th,
  BoundingRect: rt,
  Circle: is,
  CompoundPath: c2,
  Ellipse: pg,
  Group: ze,
  Image: An,
  IncrementalDisplayable: iO,
  Line: gn,
  LinearGradient: rh,
  OrientedBoundingRect: Cm,
  Path: gt,
  Point: tt,
  Polygon: si,
  Polyline: ci,
  RadialGradient: Z7,
  Rect: xt,
  Ring: eh,
  Sector: oi,
  Text: _t,
  applyTransform: Ka,
  clipPointsByRect: $7,
  clipRectByRect: uO,
  createIcon: ih,
  extendPath: sO,
  extendShape: oO,
  getShapeClass: d2,
  getTransform: Hl,
  groupTransition: mg,
  initProps: Cr,
  isElementRemoved: hf,
  lineLineIntersect: cO,
  linePolygonIntersect: Mp,
  makeImage: Y7,
  makePath: gg,
  mergePath: Yi,
  registerShape: Pa,
  removeElement: tu,
  removeElementWithFadeOut: wv,
  resizePath: X7,
  setTooltipConfig: ah,
  subPixelOptimize: R0,
  subPixelOptimizeLine: Mf,
  subPixelOptimizeRect: bJ,
  transformDirection: f2,
  traverseElements: pu,
  updateProps: kt
}, Symbol.toStringTag, { value: "Module" }));
var h2 = {};
function dO(t, r) {
  for (var e = 0; e < xi.length; e++) {
    var n = xi[e], i = r[n], a = t.ensureState(n);
    a.style = a.style || {}, a.style.text = i;
  }
  var o = t.currentStates.slice();
  t.clearStates(!0), t.setStyle({
    text: r.normal
  }), t.useStates(o, !0);
}
function JC(t, r, e) {
  var n = t.labelFetcher, i = t.labelDataIndex, a = t.labelDimIndex, o = r.normal, s;
  n && (s = n.getFormattedLabel(i, "normal", null, a, o && o.get("formatter"), e != null ? {
    interpolatedValue: e
  } : null)), s == null && (s = Ae(t.defaultText) ? t.defaultText(i, t, e) : t.defaultText);
  for (var l = {
    normal: s
  }, u = 0; u < xi.length; u++) {
    var c = xi[u], d = r[c];
    l[c] = je(n ? n.getFormattedLabel(i, c, null, a, d && d.get("formatter")) : null, s);
  }
  return l;
}
function Xn(t, r, e, n) {
  e = e || h2;
  for (var i = t instanceof _t, a = !1, o = 0; o < Cv.length; o++) {
    var s = r[Cv[o]];
    if (s && s.getShallow("show")) {
      a = !0;
      break;
    }
  }
  var l = i ? t : t.getTextContent();
  if (a) {
    i || (l || (l = new _t(), t.setTextContent(l)), t.stateProxy && (l.stateProxy = t.stateProxy));
    var u = JC(e, r), c = r.normal, d = !!c.getShallow("show"), f = fr(c, n && n.normal, e, !1, !i);
    f.text = u.normal, i || t.setTextConfig(xm(c, e, !1));
    for (var o = 0; o < xi.length; o++) {
      var h = xi[o], s = r[h];
      if (s) {
        var p = l.ensureState(h), v = !!je(s.getShallow("show"), d);
        if (v !== d && (p.ignore = !v), p.style = fr(s, n && n[h], e, !0, !i), p.style.text = u[h], !i) {
          var g = t.ensureState(h);
          g.textConfig = xm(s, e, !0);
        }
      }
    }
    l.silent = !!c.getShallow("silent"), l.style.x != null && (f.x = l.style.x), l.style.y != null && (f.y = l.style.y), l.ignore = !d, l.useStyle(f), l.dirty(), e.enableTextSetter && (oh(l).setLabelText = function(m) {
      var y = JC(e, r, m);
      dO(l, y);
    });
  } else l && (l.ignore = !0);
  t.dirty();
}
function xn(t, r) {
  r = r || "label";
  for (var e = {
    normal: t.getModel(r)
  }, n = 0; n < xi.length; n++) {
    var i = xi[n];
    e[i] = t.getModel([i, r]);
  }
  return e;
}
function fr(t, r, e, n, i) {
  var a = {};
  return _J(a, t, e, n, i), r && ae(a, r), a;
}
function xm(t, r, e) {
  r = r || {};
  var n = {}, i, a = t.getShallow("rotate"), o = je(t.getShallow("distance"), e ? null : 5), s = t.getShallow("offset");
  return i = t.getShallow("position") || (e ? null : "inside"), i === "outside" && (i = r.defaultOutsidePosition || "top"), i != null && (n.position = i), s != null && (n.offset = s), a != null && (a *= Math.PI / 180, n.rotation = a), o != null && (n.distance = o), n.outsideFill = t.get("color") === "inherit" ? r.inheritColor || null : "auto", n;
}
function _J(t, r, e, n, i) {
  e = e || h2;
  var a = r.ecModel, o = a && a.option.textStyle, s = xJ(r), l;
  if (s) {
    l = {};
    for (var u in s)
      if (s.hasOwnProperty(u)) {
        var c = r.getModel(["rich", u]);
        QS(l[u] = {}, c, o, e, n, i, !1, !0);
      }
  }
  l && (t.rich = l);
  var d = r.get("overflow");
  d && (t.overflow = d);
  var f = r.get("minMargin");
  f != null && (t.margin = f), QS(t, r, o, e, n, i, !0, !1);
}
function xJ(t) {
  for (var r; t && t !== t.ecModel; ) {
    var e = (t.option || h2).rich;
    if (e) {
      r = r || {};
      for (var n = yt(e), i = 0; i < n.length; i++) {
        var a = n[i];
        r[a] = 1;
      }
    }
    t = t.parentModel;
  }
  return r;
}
var JS = ["fontStyle", "fontWeight", "fontSize", "fontFamily", "textShadowColor", "textShadowBlur", "textShadowOffsetX", "textShadowOffsetY"], KS = ["align", "lineHeight", "width", "height", "tag", "verticalAlign", "ellipsis"], qS = ["padding", "borderWidth", "borderRadius", "borderDashOffset", "backgroundColor", "borderColor", "shadowColor", "shadowBlur", "shadowOffsetX", "shadowOffsetY"];
function QS(t, r, e, n, i, a, o, s) {
  e = !i && e || h2;
  var l = n && n.inheritColor, u = r.getShallow("color"), c = r.getShallow("textBorderColor"), d = je(r.getShallow("opacity"), e.opacity);
  (u === "inherit" || u === "auto") && (process.env.NODE_ENV !== "production" && u === "auto" && qr("color: 'auto'", "color: 'inherit'"), l ? u = l : u = null), (c === "inherit" || c === "auto") && (process.env.NODE_ENV !== "production" && c === "auto" && qr("color: 'auto'", "color: 'inherit'"), l ? c = l : c = null), a || (u = u || e.color, c = c || e.textBorderColor), u != null && (t.fill = u), c != null && (t.stroke = c);
  var f = je(r.getShallow("textBorderWidth"), e.textBorderWidth);
  f != null && (t.lineWidth = f);
  var h = je(r.getShallow("textBorderType"), e.textBorderType);
  h != null && (t.lineDash = h);
  var p = je(r.getShallow("textBorderDashOffset"), e.textBorderDashOffset);
  p != null && (t.lineDashOffset = p), !i && d == null && !s && (d = n && n.defaultOpacity), d != null && (t.opacity = d), !i && !a && t.fill == null && n.inheritColor && (t.fill = n.inheritColor);
  for (var v = 0; v < JS.length; v++) {
    var g = JS[v], m = je(r.getShallow(g), e[g]);
    m != null && (t[g] = m);
  }
  for (var v = 0; v < KS.length; v++) {
    var g = KS[v], m = r.getShallow(g);
    m != null && (t[g] = m);
  }
  if (t.verticalAlign == null) {
    var y = r.getShallow("baseline");
    y != null && (t.verticalAlign = y);
  }
  if (!o || !n.disableBox) {
    for (var v = 0; v < qS.length; v++) {
      var g = qS[v], m = r.getShallow(g);
      m != null && (t[g] = m);
    }
    var b = r.getShallow("borderType");
    b != null && (t.borderDash = b), (t.backgroundColor === "auto" || t.backgroundColor === "inherit") && l && (process.env.NODE_ENV !== "production" && t.backgroundColor === "auto" && qr("backgroundColor: 'auto'", "backgroundColor: 'inherit'"), t.backgroundColor = l), (t.borderColor === "auto" || t.borderColor === "inherit") && l && (process.env.NODE_ENV !== "production" && t.borderColor === "auto" && qr("borderColor: 'auto'", "borderColor: 'inherit'"), t.borderColor = l);
  }
}
function U7(t, r) {
  var e = r && r.getModel("textStyle");
  return Aa([
    // FIXME in node-canvas fontWeight is before fontStyle
    t.fontStyle || e && e.getShallow("fontStyle") || "",
    t.fontWeight || e && e.getShallow("fontWeight") || "",
    (t.fontSize || e && e.getShallow("fontSize") || 12) + "px",
    t.fontFamily || e && e.getShallow("fontFamily") || "sans-serif"
  ].join(" "));
}
var oh = It();
function fO(t, r, e, n) {
  if (t) {
    var i = oh(t);
    i.prevValue = i.value, i.value = e;
    var a = r.normal;
    i.valueAnimation = a.get("valueAnimation"), i.valueAnimation && (i.precision = a.get("precision"), i.defaultInterpolatedText = n, i.statesModels = r);
  }
}
function hO(t, r, e, n, i) {
  var a = oh(t);
  if (!a.valueAnimation || a.prevValue === a.value)
    return;
  var o = a.defaultInterpolatedText, s = je(a.interpolatedValue, a.prevValue), l = a.value;
  function u(c) {
    var d = TN(e, a.precision, s, l, c);
    a.interpolatedValue = c === 1 ? null : d;
    var f = JC({
      labelDataIndex: r,
      labelFetcher: i,
      defaultText: o ? o(d) : d + ""
    }, a.statesModels, d);
    dO(t, f);
  }
  t.percent = 0, (a.prevValue == null ? Cr : kt)(t, {
    // percent is used to prevent animation from being aborted #15916
    percent: 1
  }, n, r, null, u);
}
var SJ = ["textStyle", "color"], ob = ["fontStyle", "fontWeight", "fontSize", "fontFamily", "padding", "lineHeight", "rich", "width", "height", "overflow"], sb = new _t(), IJ = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.getTextColor = function(r) {
      var e = this.ecModel;
      return this.getShallow("color") || (!r && e ? e.get(SJ) : null);
    }, t.prototype.getFont = function() {
      return U7({
        fontStyle: this.getShallow("fontStyle"),
        fontWeight: this.getShallow("fontWeight"),
        fontSize: this.getShallow("fontSize"),
        fontFamily: this.getShallow("fontFamily")
      }, this.ecModel);
    }, t.prototype.getTextRect = function(r) {
      for (var e = {
        text: r,
        verticalAlign: this.getShallow("verticalAlign") || this.getShallow("baseline")
      }, n = 0; n < ob.length; n++)
        e[ob[n]] = this.getShallow(ob[n]);
      return sb.useStyle(e), sb.update(), sb.getBoundingRect();
    }, t;
  }()
), pO = [
  ["lineWidth", "width"],
  ["stroke", "color"],
  ["opacity"],
  ["shadowBlur"],
  ["shadowOffsetX"],
  ["shadowOffsetY"],
  ["shadowColor"],
  ["lineDash", "type"],
  ["lineDashOffset", "dashOffset"],
  ["lineCap", "cap"],
  ["lineJoin", "join"],
  ["miterLimit"]
  // Option decal is in `DecalObject` but style.decal is in `PatternObject`.
  // So do not transfer decal directly.
], AJ = Bc(pO), DJ = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.getLineStyle = function(r) {
      return AJ(this, r);
    }, t;
  }()
), vO = [
  ["fill", "color"],
  ["stroke", "borderColor"],
  ["lineWidth", "borderWidth"],
  ["opacity"],
  ["shadowBlur"],
  ["shadowOffsetX"],
  ["shadowOffsetY"],
  ["shadowColor"],
  ["lineDash", "borderType"],
  ["lineDashOffset", "borderDashOffset"],
  ["lineCap", "borderCap"],
  ["lineJoin", "borderJoin"],
  ["miterLimit", "borderMiterLimit"]
  // Option decal is in `DecalObject` but style.decal is in `PatternObject`.
  // So do not transfer decal directly.
], TJ = Bc(vO), MJ = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.getItemStyle = function(r, e) {
      return TJ(this, r, e);
    }, t;
  }()
), Pt = (
  /** @class */
  function() {
    function t(r, e, n) {
      this.parentModel = e, this.ecModel = n, this.option = r;
    }
    return t.prototype.init = function(r, e, n) {
    }, t.prototype.mergeOption = function(r, e) {
      Qe(this.option, r, !0);
    }, t.prototype.get = function(r, e) {
      return r == null ? this.option : this._doGet(this.parsePath(r), !e && this.parentModel);
    }, t.prototype.getShallow = function(r, e) {
      var n = this.option, i = n == null ? n : n[r];
      if (i == null && !e) {
        var a = this.parentModel;
        a && (i = a.getShallow(r));
      }
      return i;
    }, t.prototype.getModel = function(r, e) {
      var n = r != null, i = n ? this.parsePath(r) : null, a = n ? this._doGet(i) : this.option;
      return e = e || this.parentModel && this.parentModel.getModel(this.resolveParentPath(i)), new t(a, e, this.ecModel);
    }, t.prototype.isEmpty = function() {
      return this.option == null;
    }, t.prototype.restoreData = function() {
    }, t.prototype.clone = function() {
      var r = this.constructor;
      return new r(Ge(this.option));
    }, t.prototype.parsePath = function(r) {
      return typeof r == "string" ? r.split(".") : r;
    }, t.prototype.resolveParentPath = function(r) {
      return r;
    }, t.prototype.isAnimationEnabled = function() {
      if (!vt.node && this.option) {
        if (this.option.animation != null)
          return !!this.option.animation;
        if (this.parentModel)
          return this.parentModel.isAnimationEnabled();
      }
    }, t.prototype._doGet = function(r, e) {
      var n = this.option;
      if (!r)
        return n;
      for (var i = 0; i < r.length && !(r[i] && (n = n && typeof n == "object" ? n[r[i]] : null, n == null)); i++)
        ;
      return n == null && e && (n = e._doGet(this.resolveParentPath(r), e.parentModel)), n;
    }, t;
  }()
);
N7(Pt);
W$(Pt);
Xr(Pt, DJ);
Xr(Pt, MJ);
Xr(Pt, $$);
Xr(Pt, IJ);
var RJ = Math.round(Math.random() * 10);
function sh(t) {
  return [t || "", RJ++].join("_");
}
function LJ(t) {
  var r = {};
  t.registerSubTypeDefaulter = function(e, n) {
    var i = No(e);
    r[i.main] = n;
  }, t.determineSubType = function(e, n) {
    var i = n.type;
    if (!i) {
      var a = No(e).main;
      t.hasSubTypes(e) && r[a] && (i = r[a](n));
    }
    return i;
  };
}
function EJ(t, r) {
  t.topologicalTravel = function(a, o, s, l) {
    if (!a.length)
      return;
    var u = e(o), c = u.graph, d = u.noEntryList, f = {};
    for (L(a, function(y) {
      f[y] = !0;
    }); d.length; ) {
      var h = d.pop(), p = c[h], v = !!f[h];
      v && (s.call(l, h, p.originalDeps.slice()), delete f[h]), L(p.successor, v ? m : g);
    }
    L(f, function() {
      var y = "";
      throw process.env.NODE_ENV !== "production" && (y = _i("Circular dependency may exists: ", f, a, o)), new Error(y);
    });
    function g(y) {
      c[y].entryCount--, c[y].entryCount === 0 && d.push(y);
    }
    function m(y) {
      f[y] = !0, g(y);
    }
  };
  function e(a) {
    var o = {}, s = [];
    return L(a, function(l) {
      var u = n(o, l), c = u.originalDeps = r(l), d = i(c, a);
      u.entryCount = d.length, u.entryCount === 0 && s.push(l), L(d, function(f) {
        nt(u.predecessor, f) < 0 && u.predecessor.push(f);
        var h = n(o, f);
        nt(h.successor, f) < 0 && h.successor.push(l);
      });
    }), {
      graph: o,
      noEntryList: s
    };
  }
  function n(a, o) {
    return a[o] || (a[o] = {
      predecessor: [],
      successor: []
    }), a[o];
  }
  function i(a, o) {
    var s = [];
    return L(a, function(l) {
      nt(o, l) >= 0 && s.push(l);
    }), s;
  }
}
function vu(t, r) {
  return Qe(Qe({}, t, !0), r, !0);
}
const kJ = {
  time: {
    month: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    monthAbbr: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    dayOfWeek: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    dayOfWeekAbbr: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
  },
  legend: {
    selector: {
      all: "All",
      inverse: "Inv"
    }
  },
  toolbox: {
    brush: {
      title: {
        rect: "Box Select",
        polygon: "Lasso Select",
        lineX: "Horizontally Select",
        lineY: "Vertically Select",
        keep: "Keep Selections",
        clear: "Clear Selections"
      }
    },
    dataView: {
      title: "Data View",
      lang: ["Data View", "Close", "Refresh"]
    },
    dataZoom: {
      title: {
        zoom: "Zoom",
        back: "Zoom Reset"
      }
    },
    magicType: {
      title: {
        line: "Switch to Line Chart",
        bar: "Switch to Bar Chart",
        stack: "Stack",
        tiled: "Tile"
      }
    },
    restore: {
      title: "Restore"
    },
    saveAsImage: {
      title: "Save as Image",
      lang: ["Right Click to Save Image"]
    }
  },
  series: {
    typeNames: {
      pie: "Pie chart",
      bar: "Bar chart",
      line: "Line chart",
      scatter: "Scatter plot",
      effectScatter: "Ripple scatter plot",
      radar: "Radar chart",
      tree: "Tree",
      treemap: "Treemap",
      boxplot: "Boxplot",
      candlestick: "Candlestick",
      k: "K line chart",
      heatmap: "Heat map",
      map: "Map",
      parallel: "Parallel coordinate map",
      lines: "Line graph",
      graph: "Relationship graph",
      sankey: "Sankey diagram",
      funnel: "Funnel chart",
      gauge: "Gauge",
      pictorialBar: "Pictorial bar",
      themeRiver: "Theme River Map",
      sunburst: "Sunburst",
      custom: "Custom chart",
      chart: "Chart"
    }
  },
  aria: {
    general: {
      withTitle: 'This is a chart about "{title}"',
      withoutTitle: "This is a chart"
    },
    series: {
      single: {
        prefix: "",
        withName: " with type {seriesType} named {seriesName}.",
        withoutName: " with type {seriesType}."
      },
      multiple: {
        prefix: ". It consists of {seriesCount} series count.",
        withName: " The {seriesId} series is a {seriesType} representing {seriesName}.",
        withoutName: " The {seriesId} series is a {seriesType}.",
        separator: {
          middle: "",
          end: ""
        }
      }
    },
    data: {
      allData: "The data is as follows: ",
      partialData: "The first {displayCnt} items are: ",
      withName: "the data for {name} is {value}",
      withoutName: "{value}",
      separator: {
        middle: ", ",
        end: ". "
      }
    }
  }
}, PJ = {
  time: {
    month: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
    monthAbbr: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
    dayOfWeek: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"],
    dayOfWeekAbbr: ["日", "一", "二", "三", "四", "五", "六"]
  },
  legend: {
    selector: {
      all: "全选",
      inverse: "反选"
    }
  },
  toolbox: {
    brush: {
      title: {
        rect: "矩形选择",
        polygon: "圈选",
        lineX: "横向选择",
        lineY: "纵向选择",
        keep: "保持选择",
        clear: "清除选择"
      }
    },
    dataView: {
      title: "数据视图",
      lang: ["数据视图", "关闭", "刷新"]
    },
    dataZoom: {
      title: {
        zoom: "区域缩放",
        back: "区域缩放还原"
      }
    },
    magicType: {
      title: {
        line: "切换为折线图",
        bar: "切换为柱状图",
        stack: "切换为堆叠",
        tiled: "切换为平铺"
      }
    },
    restore: {
      title: "还原"
    },
    saveAsImage: {
      title: "保存为图片",
      lang: ["右键另存为图片"]
    }
  },
  series: {
    typeNames: {
      pie: "饼图",
      bar: "柱状图",
      line: "折线图",
      scatter: "散点图",
      effectScatter: "涟漪散点图",
      radar: "雷达图",
      tree: "树图",
      treemap: "矩形树图",
      boxplot: "箱型图",
      candlestick: "K线图",
      k: "K线图",
      heatmap: "热力图",
      map: "地图",
      parallel: "平行坐标图",
      lines: "线图",
      graph: "关系图",
      sankey: "桑基图",
      funnel: "漏斗图",
      gauge: "仪表盘图",
      pictorialBar: "象形柱图",
      themeRiver: "主题河流图",
      sunburst: "旭日图",
      custom: "自定义图表",
      chart: "图表"
    }
  },
  aria: {
    general: {
      withTitle: "这是一个关于“{title}”的图表。",
      withoutTitle: "这是一个图表，"
    },
    series: {
      single: {
        prefix: "",
        withName: "图表类型是{seriesType}，表示{seriesName}。",
        withoutName: "图表类型是{seriesType}。"
      },
      multiple: {
        prefix: "它由{seriesCount}个图表系列组成。",
        withName: "第{seriesId}个系列是一个表示{seriesName}的{seriesType}，",
        withoutName: "第{seriesId}个系列是一个{seriesType}，",
        separator: {
          middle: "；",
          end: "。"
        }
      }
    },
    data: {
      allData: "其数据是——",
      partialData: "其中，前{displayCnt}项是——",
      withName: "{name}的数据是{value}",
      withoutName: "{value}",
      separator: {
        middle: "，",
        end: ""
      }
    }
  }
};
var Sm = "ZH", J7 = "EN", pf = J7, L0 = {}, K7 = {}, gO = vt.domSupported ? function() {
  var t = (
    /* eslint-disable-next-line */
    (document.documentElement.lang || navigator.language || navigator.browserLanguage || pf).toUpperCase()
  );
  return t.indexOf(Sm) > -1 ? Sm : pf;
}() : pf;
function q7(t, r) {
  t = t.toUpperCase(), K7[t] = new Pt(r), L0[t] = r;
}
function NJ(t) {
  if (pe(t)) {
    var r = L0[t.toUpperCase()] || {};
    return t === Sm || t === J7 ? Ge(r) : Qe(Ge(r), Ge(L0[pf]), !1);
  } else
    return Qe(Ge(t), Ge(L0[pf]), !1);
}
function KC(t) {
  return K7[t];
}
function OJ() {
  return K7[pf];
}
q7(J7, kJ);
q7(Sm, PJ);
var Q7 = 1e3, ew = Q7 * 60, Qp = ew * 60, Ia = Qp * 24, eI = Ia * 365, Rp = {
  year: "{yyyy}",
  month: "{MMM}",
  day: "{d}",
  hour: "{HH}:{mm}",
  minute: "{HH}:{mm}",
  second: "{HH}:{mm}:{ss}",
  millisecond: "{HH}:{mm}:{ss} {SSS}",
  none: "{yyyy}-{MM}-{dd} {HH}:{mm}:{ss} {SSS}"
}, v1 = "{yyyy}-{MM}-{dd}", tI = {
  year: "{yyyy}",
  month: "{yyyy}-{MM}",
  day: v1,
  hour: v1 + " " + Rp.hour,
  minute: v1 + " " + Rp.minute,
  second: v1 + " " + Rp.second,
  millisecond: Rp.none
}, lb = ["year", "month", "day", "hour", "minute", "second", "millisecond"], mO = ["year", "half-year", "quarter", "month", "week", "half-week", "day", "half-day", "quarter-day", "hour", "minute", "second", "millisecond"];
function gi(t, r) {
  return t += "", "0000".substr(0, r - t.length) + t;
}
function vf(t) {
  switch (t) {
    case "half-year":
    case "quarter":
      return "month";
    case "week":
    case "half-week":
      return "day";
    case "half-day":
    case "quarter-day":
      return "hour";
    default:
      return t;
  }
}
function VJ(t) {
  return t === vf(t);
}
function GJ(t) {
  switch (t) {
    case "year":
    case "month":
      return "day";
    case "millisecond":
      return "millisecond";
    default:
      return "second";
  }
}
function yg(t, r, e, n) {
  var i = ra(t), a = i[tw(e)](), o = i[gf(e)]() + 1, s = Math.floor((o - 1) / 3) + 1, l = i[p2(e)](), u = i["get" + (e ? "UTC" : "") + "Day"](), c = i[_v(e)](), d = (c - 1) % 12 + 1, f = i[v2(e)](), h = i[g2(e)](), p = i[m2(e)](), v = c >= 12 ? "pm" : "am", g = v.toUpperCase(), m = n instanceof Pt ? n : KC(n || gO) || OJ(), y = m.getModel("time"), b = y.get("month"), C = y.get("monthAbbr"), w = y.get("dayOfWeek"), _ = y.get("dayOfWeekAbbr");
  return (r || "").replace(/{a}/g, v + "").replace(/{A}/g, g + "").replace(/{yyyy}/g, a + "").replace(/{yy}/g, gi(a % 100 + "", 2)).replace(/{Q}/g, s + "").replace(/{MMMM}/g, b[o - 1]).replace(/{MMM}/g, C[o - 1]).replace(/{MM}/g, gi(o, 2)).replace(/{M}/g, o + "").replace(/{dd}/g, gi(l, 2)).replace(/{d}/g, l + "").replace(/{eeee}/g, w[u]).replace(/{ee}/g, _[u]).replace(/{e}/g, u + "").replace(/{HH}/g, gi(c, 2)).replace(/{H}/g, c + "").replace(/{hh}/g, gi(d + "", 2)).replace(/{h}/g, d + "").replace(/{mm}/g, gi(f, 2)).replace(/{m}/g, f + "").replace(/{ss}/g, gi(h, 2)).replace(/{s}/g, h + "").replace(/{SSS}/g, gi(p, 3)).replace(/{S}/g, p + "");
}
function BJ(t, r, e, n, i) {
  var a = null;
  if (pe(e))
    a = e;
  else if (Ae(e))
    a = e(t.value, r, {
      level: t.level
    });
  else {
    var o = ae({}, Rp);
    if (t.level > 0)
      for (var s = 0; s < lb.length; ++s)
        o[lb[s]] = "{primary|" + o[lb[s]] + "}";
    var l = e ? e.inherit === !1 ? e : Ee(e, o) : o, u = yO(t.value, i);
    if (l[u])
      a = l[u];
    else if (l.inherit) {
      for (var c = mO.indexOf(u), s = c - 1; s >= 0; --s)
        if (l[u]) {
          a = l[u];
          break;
        }
      a = a || o.none;
    }
    if (ue(a)) {
      var d = t.level == null ? 0 : t.level >= 0 ? t.level : a.length + t.level;
      d = Math.min(d, a.length - 1), a = a[d];
    }
  }
  return yg(new Date(t.value), a, i, n);
}
function yO(t, r) {
  var e = ra(t), n = e[gf(r)]() + 1, i = e[p2(r)](), a = e[_v(r)](), o = e[v2(r)](), s = e[g2(r)](), l = e[m2(r)](), u = l === 0, c = u && s === 0, d = c && o === 0, f = d && a === 0, h = f && i === 1, p = h && n === 1;
  return p ? "year" : h ? "month" : f ? "day" : d ? "hour" : c ? "minute" : u ? "second" : "millisecond";
}
function rI(t, r, e) {
  var n = Mt(t) ? ra(t) : t;
  switch (r = r || yO(t, e), r) {
    case "year":
      return n[tw(e)]();
    case "half-year":
      return n[gf(e)]() >= 6 ? 1 : 0;
    case "quarter":
      return Math.floor((n[gf(e)]() + 1) / 4);
    case "month":
      return n[gf(e)]();
    case "day":
      return n[p2(e)]();
    case "half-day":
      return n[_v(e)]() / 24;
    case "hour":
      return n[_v(e)]();
    case "minute":
      return n[v2(e)]();
    case "second":
      return n[g2(e)]();
    case "millisecond":
      return n[m2(e)]();
  }
}
function tw(t) {
  return t ? "getUTCFullYear" : "getFullYear";
}
function gf(t) {
  return t ? "getUTCMonth" : "getMonth";
}
function p2(t) {
  return t ? "getUTCDate" : "getDate";
}
function _v(t) {
  return t ? "getUTCHours" : "getHours";
}
function v2(t) {
  return t ? "getUTCMinutes" : "getMinutes";
}
function g2(t) {
  return t ? "getUTCSeconds" : "getSeconds";
}
function m2(t) {
  return t ? "getUTCMilliseconds" : "getMilliseconds";
}
function FJ(t) {
  return t ? "setUTCFullYear" : "setFullYear";
}
function bO(t) {
  return t ? "setUTCMonth" : "setMonth";
}
function CO(t) {
  return t ? "setUTCDate" : "setDate";
}
function wO(t) {
  return t ? "setUTCHours" : "setHours";
}
function _O(t) {
  return t ? "setUTCMinutes" : "setMinutes";
}
function xO(t) {
  return t ? "setUTCSeconds" : "setSeconds";
}
function SO(t) {
  return t ? "setUTCMilliseconds" : "setMilliseconds";
}
function HJ(t, r, e, n, i, a, o, s) {
  var l = new _t({
    style: {
      text: t,
      font: r,
      align: e,
      verticalAlign: n,
      padding: i,
      rich: a,
      overflow: o ? "truncate" : null,
      lineHeight: s
    }
  });
  return l.getBoundingRect();
}
function rw(t) {
  if (!r2(t))
    return pe(t) ? t : "-";
  var r = (t + "").split(".");
  return r[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, "$1,") + (r.length > 1 ? "." + r[1] : "");
}
function nw(t, r) {
  return t = (t || "").toLowerCase().replace(/-(.)/g, function(e, n) {
    return n.toUpperCase();
  }), r && t && (t = t.charAt(0).toUpperCase() + t.slice(1)), t;
}
var Qc = Jy;
function qC(t, r, e) {
  var n = "{yyyy}-{MM}-{dd} {HH}:{mm}:{ss}";
  function i(c) {
    return c && Aa(c) ? c : "-";
  }
  function a(c) {
    return !!(c != null && !isNaN(c) && isFinite(c));
  }
  var o = r === "time", s = t instanceof Date;
  if (o || s) {
    var l = o ? ra(t) : t;
    if (isNaN(+l)) {
      if (s)
        return "-";
    } else return yg(l, n, e);
  }
  if (r === "ordinal")
    return dv(t) ? i(t) : Mt(t) && a(t) ? t + "" : "-";
  var u = qo(t);
  return a(u) ? rw(u) : dv(t) ? i(t) : typeof t == "boolean" ? t + "" : "-";
}
var nI = ["a", "b", "c", "d", "e", "f", "g"], ub = function(t, r) {
  return "{" + t + (r ?? "") + "}";
};
function iw(t, r, e) {
  ue(r) || (r = [r]);
  var n = r.length;
  if (!n)
    return "";
  for (var i = r[0].$vars || [], a = 0; a < i.length; a++) {
    var o = nI[a];
    t = t.replace(ub(o), ub(o, 0));
  }
  for (var s = 0; s < n; s++)
    for (var l = 0; l < i.length; l++) {
      var u = r[s][i[l]];
      t = t.replace(ub(nI[l], s), e ? bi(u) : u);
    }
  return t;
}
function zJ(t, r, e) {
  return L(r, function(n, i) {
    t = t.replace("{" + i + "}", n);
  }), t;
}
function IO(t, r) {
  var e = pe(t) ? {
    color: t,
    extraCssText: r
  } : t || {}, n = e.color, i = e.type;
  r = e.extraCssText;
  var a = e.renderMode || "html";
  if (!n)
    return "";
  if (a === "html")
    return i === "subItem" ? '<span style="display:inline-block;vertical-align:middle;margin-right:8px;margin-left:3px;border-radius:4px;width:4px;height:4px;background-color:' + bi(n) + ";" + (r || "") + '"></span>' : '<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:' + bi(n) + ";" + (r || "") + '"></span>';
  var o = e.markerId || "markerX";
  return {
    renderMode: a,
    content: "{" + o + "|}  ",
    style: i === "subItem" ? {
      width: 4,
      height: 4,
      borderRadius: 2,
      backgroundColor: n
    } : {
      width: 10,
      height: 10,
      borderRadius: 5,
      backgroundColor: n
    }
  };
}
function WJ(t, r, e) {
  process.env.NODE_ENV !== "production" && qr("echarts.format.formatTime", "echarts.time.format"), (t === "week" || t === "month" || t === "quarter" || t === "half-year" || t === "year") && (t = `MM-dd
yyyy`);
  var n = ra(r), i = e ? "getUTC" : "get", a = n[i + "FullYear"](), o = n[i + "Month"]() + 1, s = n[i + "Date"](), l = n[i + "Hours"](), u = n[i + "Minutes"](), c = n[i + "Seconds"](), d = n[i + "Milliseconds"]();
  return t = t.replace("MM", gi(o, 2)).replace("M", o).replace("yyyy", a).replace("yy", gi(a % 100 + "", 2)).replace("dd", gi(s, 2)).replace("d", s).replace("hh", gi(l, 2)).replace("h", l).replace("mm", gi(u, 2)).replace("m", u).replace("ss", gi(c, 2)).replace("s", c).replace("SSS", gi(d, 3)), t;
}
function ZJ(t) {
  return t && t.charAt(0).toUpperCase() + t.substr(1);
}
function Hc(t, r) {
  return r = r || "transparent", pe(t) ? t : Me(t) && t.colorStops && (t.colorStops[0] || {}).color || r;
}
function Im(t, r) {
  if (r === "_blank" || r === "blank") {
    var e = window.open();
    e.opener = null, e.location.href = t;
  } else
    window.open(t, r);
}
var E0 = L, AO = ["left", "right", "top", "bottom", "width", "height"], fc = [["width", "left", "right"], ["height", "top", "bottom"]];
function aw(t, r, e, n, i) {
  var a = 0, o = 0;
  n == null && (n = 1 / 0), i == null && (i = 1 / 0);
  var s = 0;
  r.eachChild(function(l, u) {
    var c = l.getBoundingRect(), d = r.childAt(u + 1), f = d && d.getBoundingRect(), h, p;
    if (t === "horizontal") {
      var v = c.width + (f ? -f.x + c.x : 0);
      h = a + v, h > n || l.newline ? (a = 0, h = v, o += s + e, s = c.height) : s = Math.max(s, c.height);
    } else {
      var g = c.height + (f ? -f.y + c.y : 0);
      p = o + g, p > i || l.newline ? (a += s + e, o = 0, p = g, s = c.width) : s = Math.max(s, c.width);
    }
    l.newline || (l.x = a, l.y = o, l.markRedraw(), t === "horizontal" ? a = h + e : o = p + e);
  });
}
var Ic = aw;
Ye(aw, "vertical");
Ye(aw, "horizontal");
function jJ(t, r, e) {
  var n = r.width, i = r.height, a = he(t.left, n), o = he(t.top, i), s = he(t.right, n), l = he(t.bottom, i);
  return (isNaN(a) || isNaN(parseFloat(t.left))) && (a = 0), (isNaN(s) || isNaN(parseFloat(t.right))) && (s = n), (isNaN(o) || isNaN(parseFloat(t.top))) && (o = 0), (isNaN(l) || isNaN(parseFloat(t.bottom))) && (l = i), e = Qc(e || 0), {
    width: Math.max(s - a - e[1] - e[3], 0),
    height: Math.max(l - o - e[0] - e[2], 0)
  };
}
function cn(t, r, e) {
  e = Qc(e || 0);
  var n = r.width, i = r.height, a = he(t.left, n), o = he(t.top, i), s = he(t.right, n), l = he(t.bottom, i), u = he(t.width, n), c = he(t.height, i), d = e[2] + e[0], f = e[1] + e[3], h = t.aspect;
  switch (isNaN(u) && (u = n - s - f - a), isNaN(c) && (c = i - l - d - o), h != null && (isNaN(u) && isNaN(c) && (h > n / i ? u = n * 0.8 : c = i * 0.8), isNaN(u) && (u = h * c), isNaN(c) && (c = u / h)), isNaN(a) && (a = n - s - u - f), isNaN(o) && (o = i - l - c - d), t.left || t.right) {
    case "center":
      a = n / 2 - u / 2 - e[3];
      break;
    case "right":
      a = n - u - f;
      break;
  }
  switch (t.top || t.bottom) {
    case "middle":
    case "center":
      o = i / 2 - c / 2 - e[0];
      break;
    case "bottom":
      o = i - c - d;
      break;
  }
  a = a || 0, o = o || 0, isNaN(u) && (u = n - f - a - (s || 0)), isNaN(c) && (c = i - d - o - (l || 0));
  var p = new rt(a + e[3], o + e[0], u, c);
  return p.margin = e, p;
}
function y2(t, r, e, n, i, a) {
  var o = !i || !i.hv || i.hv[0], s = !i || !i.hv || i.hv[1], l = i && i.boundingMode || "all";
  if (a = a || t, a.x = t.x, a.y = t.y, !o && !s)
    return !1;
  var u;
  if (l === "raw")
    u = t.type === "group" ? new rt(0, 0, +r.width || 0, +r.height || 0) : t.getBoundingRect();
  else if (u = t.getBoundingRect(), t.needLocalTransform()) {
    var c = t.getLocalTransform();
    u = u.clone(), u.applyTransform(c);
  }
  var d = cn(Ee({
    width: u.width,
    height: u.height
  }, r), e, n), f = o ? d.x - u.x : 0, h = s ? d.y - u.y : 0;
  return l === "raw" ? (a.x = f, a.y = h) : (a.x += f, a.y += h), a === t && t.markRedraw(), !0;
}
function YJ(t, r) {
  return t[fc[r][0]] != null || t[fc[r][1]] != null && t[fc[r][2]] != null;
}
function xv(t) {
  var r = t.layoutMode || t.constructor.layoutMode;
  return Me(r) ? r : r ? {
    type: r
  } : null;
}
function ru(t, r, e) {
  var n = e && e.ignoreSize;
  !ue(n) && (n = [n, n]);
  var i = o(fc[0], 0), a = o(fc[1], 1);
  u(fc[0], t, i), u(fc[1], t, a);
  function o(c, d) {
    var f = {}, h = 0, p = {}, v = 0, g = 2;
    if (E0(c, function(b) {
      p[b] = t[b];
    }), E0(c, function(b) {
      s(r, b) && (f[b] = p[b] = r[b]), l(f, b) && h++, l(p, b) && v++;
    }), n[d])
      return l(r, c[1]) ? p[c[2]] = null : l(r, c[2]) && (p[c[1]] = null), p;
    if (v === g || !h)
      return p;
    if (h >= g)
      return f;
    for (var m = 0; m < c.length; m++) {
      var y = c[m];
      if (!s(f, y) && s(t, y)) {
        f[y] = t[y];
        break;
      }
    }
    return f;
  }
  function s(c, d) {
    return c.hasOwnProperty(d);
  }
  function l(c, d) {
    return c[d] != null && c[d] !== "auto";
  }
  function u(c, d, f) {
    E0(c, function(h) {
      d[h] = f[h];
    });
  }
}
function lh(t) {
  return DO({}, t);
}
function DO(t, r) {
  return r && t && E0(AO, function(e) {
    r.hasOwnProperty(e) && (t[e] = r[e]);
  }), t;
}
var XJ = It(), st = (
  /** @class */
  function(t) {
    ee(r, t);
    function r(e, n, i) {
      var a = t.call(this, e, n, i) || this;
      return a.uid = sh("ec_cpt_model"), a;
    }
    return r.prototype.init = function(e, n, i) {
      this.mergeDefaultAndTheme(e, i);
    }, r.prototype.mergeDefaultAndTheme = function(e, n) {
      var i = xv(this), a = i ? lh(e) : {}, o = n.getTheme();
      Qe(e, o.get(this.mainType)), Qe(e, this.getDefaultOption()), i && ru(e, a, i);
    }, r.prototype.mergeOption = function(e, n) {
      Qe(this.option, e, !0);
      var i = xv(this);
      i && ru(this.option, e, i);
    }, r.prototype.optionUpdated = function(e, n) {
    }, r.prototype.getDefaultOption = function() {
      var e = this.constructor;
      if (!F$(e))
        return e.defaultOption;
      var n = XJ(this);
      if (!n.defaultOption) {
        for (var i = [], a = e; a; ) {
          var o = a.prototype.defaultOption;
          o && i.push(o), a = a.superClass;
        }
        for (var s = {}, l = i.length - 1; l >= 0; l--)
          s = Qe(s, i[l], !0);
        n.defaultOption = s;
      }
      return n.defaultOption;
    }, r.prototype.getReferringComponents = function(e, n) {
      var i = e + "Index", a = e + "Id";
      return fg(this.ecModel, e, {
        index: this.get(i, !0),
        id: this.get(a, !0)
      }, n);
    }, r.prototype.getBoxLayoutParams = function() {
      var e = this;
      return {
        left: e.get("left"),
        top: e.get("top"),
        right: e.get("right"),
        bottom: e.get("bottom"),
        width: e.get("width"),
        height: e.get("height")
      };
    }, r.prototype.getZLevelKey = function() {
      return "";
    }, r.prototype.setZLevel = function(e) {
      this.option.zlevel = e;
    }, r.protoInitialize = function() {
      var e = r.prototype;
      e.type = "component", e.id = "", e.name = "", e.mainType = "", e.subType = "", e.componentIndex = 0;
    }(), r;
  }(Pt)
);
RN(st, Pt);
i2(st);
LJ(st);
EJ(st, $J);
function $J(t) {
  var r = [];
  return L(st.getClassesByMainType(t), function(e) {
    r = r.concat(e.dependencies || e.prototype.dependencies || []);
  }), r = ce(r, function(e) {
    return No(e).main;
  }), t !== "dataset" && nt(r, "dataset") <= 0 && r.unshift("dataset"), r;
}
var TO = "";
typeof navigator < "u" && (TO = navigator.platform || "");
var bd = "rgba(0, 0, 0, 0.2)";
const UJ = {
  darkMode: "auto",
  // backgroundColor: 'rgba(0,0,0,0)',
  colorBy: "series",
  color: ["#5470c6", "#91cc75", "#fac858", "#ee6666", "#73c0de", "#3ba272", "#fc8452", "#9a60b4", "#ea7ccc"],
  gradientColor: ["#f6efa6", "#d88273", "#bf444c"],
  aria: {
    decal: {
      decals: [{
        color: bd,
        dashArrayX: [1, 0],
        dashArrayY: [2, 5],
        symbolSize: 1,
        rotation: Math.PI / 6
      }, {
        color: bd,
        symbol: "circle",
        dashArrayX: [[8, 8], [0, 8, 8, 0]],
        dashArrayY: [6, 0],
        symbolSize: 0.8
      }, {
        color: bd,
        dashArrayX: [1, 0],
        dashArrayY: [4, 3],
        rotation: -Math.PI / 4
      }, {
        color: bd,
        dashArrayX: [[6, 6], [0, 6, 6, 0]],
        dashArrayY: [6, 0]
      }, {
        color: bd,
        dashArrayX: [[1, 0], [1, 6]],
        dashArrayY: [1, 0, 6, 0],
        rotation: Math.PI / 4
      }, {
        color: bd,
        symbol: "triangle",
        dashArrayX: [[9, 9], [0, 9, 9, 0]],
        dashArrayY: [7, 2],
        symbolSize: 0.75
      }]
    }
  },
  // If xAxis and yAxis declared, grid is created by default.
  // grid: {},
  textStyle: {
    // color: '#000',
    // decoration: 'none',
    // PENDING
    fontFamily: TO.match(/^Win/) ? "Microsoft YaHei" : "sans-serif",
    // fontFamily: 'Arial, Verdana, sans-serif',
    fontSize: 12,
    fontStyle: "normal",
    fontWeight: "normal"
  },
  // http://blogs.adobe.com/webplatform/2014/02/24/using-blend-modes-in-html-canvas/
  // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
  // Default is source-over
  blendMode: null,
  stateAnimation: {
    duration: 300,
    easing: "cubicOut"
  },
  animation: "auto",
  animationDuration: 1e3,
  animationDurationUpdate: 500,
  animationEasing: "cubicInOut",
  animationEasingUpdate: "cubicInOut",
  animationThreshold: 2e3,
  // Configuration for progressive/incremental rendering
  progressiveThreshold: 3e3,
  progressive: 400,
  // Threshold of if use single hover layer to optimize.
  // It is recommended that `hoverLayerThreshold` is equivalent to or less than
  // `progressiveThreshold`, otherwise hover will cause restart of progressive,
  // which is unexpected.
  // see example <echarts/test/heatmap-large.html>.
  hoverLayerThreshold: 3e3,
  // See: module:echarts/scale/Time
  useUTC: !1
};
var QC = xe(["tooltip", "label", "itemName", "itemId", "itemGroupId", "itemChildGroupId", "seriesName"]), Na = "original", li = "arrayRows", Oa = "objectRows", as = "keyedColumns", Os = "typedArray", MO = "unknown", Wo = "column", uh = "row", Bn = {
  Must: 1,
  Might: 2,
  Not: 3
  // Other cases
}, RO = It();
function JJ(t) {
  RO(t).datasetMap = xe();
}
function LO(t, r, e) {
  var n = {}, i = sw(r);
  if (!i || !t)
    return n;
  var a = [], o = [], s = r.ecModel, l = RO(s).datasetMap, u = i.uid + "_" + e.seriesLayoutBy, c, d;
  t = t.slice(), L(t, function(v, g) {
    var m = Me(v) ? v : t[g] = {
      name: v
    };
    m.type === "ordinal" && c == null && (c = g, d = p(m)), n[m.name] = [];
  });
  var f = l.get(u) || l.set(u, {
    categoryWayDim: d,
    valueWayDim: 0
  });
  L(t, function(v, g) {
    var m = v.name, y = p(v);
    if (c == null) {
      var b = f.valueWayDim;
      h(n[m], b, y), h(o, b, y), f.valueWayDim += y;
    } else if (c === g)
      h(n[m], 0, y), h(a, 0, y);
    else {
      var b = f.categoryWayDim;
      h(n[m], b, y), h(o, b, y), f.categoryWayDim += y;
    }
  });
  function h(v, g, m) {
    for (var y = 0; y < m; y++)
      v.push(g + y);
  }
  function p(v) {
    var g = v.dimsDef;
    return g ? g.length : 1;
  }
  return a.length && (n.itemName = a), o.length && (n.seriesName = o), n;
}
function ow(t, r, e) {
  var n = {}, i = sw(t);
  if (!i)
    return n;
  var a = r.sourceFormat, o = r.dimensionsDefine, s;
  (a === Oa || a === as) && L(o, function(c, d) {
    (Me(c) ? c.name : c) === "name" && (s = d);
  });
  var l = function() {
    for (var c = {}, d = {}, f = [], h = 0, p = Math.min(5, e); h < p; h++) {
      var v = kO(r.data, a, r.seriesLayoutBy, o, r.startIndex, h);
      f.push(v);
      var g = v === Bn.Not;
      if (g && c.v == null && h !== s && (c.v = h), (c.n == null || c.n === c.v || !g && f[c.n] === Bn.Not) && (c.n = h), m(c) && f[c.n] !== Bn.Not)
        return c;
      g || (v === Bn.Might && d.v == null && h !== s && (d.v = h), (d.n == null || d.n === d.v) && (d.n = h));
    }
    function m(y) {
      return y.v != null && y.n != null;
    }
    return m(c) ? c : m(d) ? d : null;
  }();
  if (l) {
    n.value = [l.v];
    var u = s ?? l.n;
    n.itemName = [u], n.seriesName = [u];
  }
  return n;
}
function sw(t) {
  var r = t.get("data", !0);
  if (!r)
    return fg(t.ecModel, "dataset", {
      index: t.get("datasetIndex", !0),
      id: t.get("datasetId", !0)
    }, on).models[0];
}
function KJ(t) {
  return !t.get("transform", !0) && !t.get("fromTransformResult", !0) ? [] : fg(t.ecModel, "dataset", {
    index: t.get("fromDatasetIndex", !0),
    id: t.get("fromDatasetId", !0)
  }, on).models;
}
function EO(t, r) {
  return kO(t.data, t.sourceFormat, t.seriesLayoutBy, t.dimensionsDefine, t.startIndex, r);
}
function kO(t, r, e, n, i, a) {
  var o, s = 5;
  if (ai(t))
    return Bn.Not;
  var l, u;
  if (n) {
    var c = n[a];
    Me(c) ? (l = c.name, u = c.type) : pe(c) && (l = c);
  }
  if (u != null)
    return u === "ordinal" ? Bn.Must : Bn.Not;
  if (r === li) {
    var d = t;
    if (e === uh) {
      for (var f = d[a], h = 0; h < (f || []).length && h < s; h++)
        if ((o = C(f[i + h])) != null)
          return o;
    } else
      for (var h = 0; h < d.length && h < s; h++) {
        var p = d[i + h];
        if (p && (o = C(p[a])) != null)
          return o;
      }
  } else if (r === Oa) {
    var v = t;
    if (!l)
      return Bn.Not;
    for (var h = 0; h < v.length && h < s; h++) {
      var g = v[h];
      if (g && (o = C(g[l])) != null)
        return o;
    }
  } else if (r === as) {
    var m = t;
    if (!l)
      return Bn.Not;
    var f = m[l];
    if (!f || ai(f))
      return Bn.Not;
    for (var h = 0; h < f.length && h < s; h++)
      if ((o = C(f[h])) != null)
        return o;
  } else if (r === Na)
    for (var y = t, h = 0; h < y.length && h < s; h++) {
      var g = y[h], b = qf(g);
      if (!ue(b))
        return Bn.Not;
      if ((o = C(b[a])) != null)
        return o;
    }
  function C(w) {
    var _ = pe(w);
    if (w != null && Number.isFinite(Number(w)) && w !== "")
      return _ ? Bn.Might : Bn.Not;
    if (_ && w !== "-")
      return Bn.Must;
  }
  return Bn.Not;
}
var e9 = xe();
function qJ(t, r) {
  ke(e9.get(t) == null && r), e9.set(t, r);
}
function QJ(t, r, e) {
  var n = e9.get(r);
  if (!n)
    return e;
  var i = n(t);
  if (!i)
    return e;
  if (process.env.NODE_ENV !== "production")
    for (var a = 0; a < i.length; a++)
      ke(Df(i[a]));
  return e.concat(i);
}
var iI = It(), eK = It(), lw = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.getColorFromPalette = function(r, e, n) {
      var i = Qt(this.get("color", !0)), a = this.get("colorLayer", !0);
      return PO(this, iI, i, a, r, e, n);
    }, t.prototype.clearColorPalette = function() {
      rK(this, iI);
    }, t;
  }()
);
function t9(t, r, e, n) {
  var i = Qt(t.get(["aria", "decal", "decals"]));
  return PO(t, eK, i, null, r, e, n);
}
function tK(t, r) {
  for (var e = t.length, n = 0; n < e; n++)
    if (t[n].length > r)
      return t[n];
  return t[e - 1];
}
function PO(t, r, e, n, i, a, o) {
  a = a || t;
  var s = r(a), l = s.paletteIdx || 0, u = s.paletteNameMap = s.paletteNameMap || {};
  if (u.hasOwnProperty(i))
    return u[i];
  var c = o == null || !n ? e : tK(n, o);
  if (c = c || e, !(!c || !c.length)) {
    var d = c[l];
    return i && (u[i] = d), s.paletteIdx = (l + 1) % c.length, d;
  }
}
function rK(t, r) {
  r(t).paletteIdx = 0, r(t).paletteNameMap = {};
}
var g1, Hh, aI, cb = "\0_ec_inner", oI = 1, nK = {
  grid: "GridComponent",
  polar: "PolarComponent",
  geo: "GeoComponent",
  singleAxis: "SingleAxisComponent",
  parallel: "ParallelComponent",
  calendar: "CalendarComponent",
  graphic: "GraphicComponent",
  toolbox: "ToolboxComponent",
  tooltip: "TooltipComponent",
  axisPointer: "AxisPointerComponent",
  brush: "BrushComponent",
  title: "TitleComponent",
  timeline: "TimelineComponent",
  markPoint: "MarkPointComponent",
  markLine: "MarkLineComponent",
  markArea: "MarkAreaComponent",
  legend: "LegendComponent",
  dataZoom: "DataZoomComponent",
  visualMap: "VisualMapComponent",
  // aria: 'AriaComponent',
  // dataset: 'DatasetComponent',
  // Dependencies
  xAxis: "GridComponent",
  yAxis: "GridComponent",
  angleAxis: "PolarComponent",
  radiusAxis: "PolarComponent"
}, iK = {
  line: "LineChart",
  bar: "BarChart",
  pie: "PieChart",
  scatter: "ScatterChart",
  radar: "RadarChart",
  map: "MapChart",
  tree: "TreeChart",
  treemap: "TreemapChart",
  graph: "GraphChart",
  gauge: "GaugeChart",
  funnel: "FunnelChart",
  parallel: "ParallelChart",
  sankey: "SankeyChart",
  boxplot: "BoxplotChart",
  candlestick: "CandlestickChart",
  effectScatter: "EffectScatterChart",
  lines: "LinesChart",
  heatmap: "HeatmapChart",
  pictorialBar: "PictorialBarChart",
  themeRiver: "ThemeRiverChart",
  sunburst: "SunburstChart",
  custom: "CustomChart"
}, Am = {};
function aK(t) {
  L(t, function(r, e) {
    if (!st.hasClass(e)) {
      var n = nK[e];
      n && !Am[n] && (jn("Component " + e + ` is used but not imported.
import { ` + n + ` } from 'echarts/components';
echarts.use([` + n + "]);"), Am[n] = !0);
    }
  });
}
var uw = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return r.prototype.init = function(e, n, i, a, o, s) {
      a = a || {}, this.option = null, this._theme = new Pt(a), this._locale = new Pt(o), this._optionManager = s;
    }, r.prototype.setOption = function(e, n, i) {
      process.env.NODE_ENV !== "production" && (ke(e != null, "option is null/undefined"), ke(e[cb] !== oI, "please use chart.getOption()"));
      var a = uI(n);
      this._optionManager.setOption(e, i, a), this._resetOption(null, a);
    }, r.prototype.resetOption = function(e, n) {
      return this._resetOption(e, uI(n));
    }, r.prototype._resetOption = function(e, n) {
      var i = !1, a = this._optionManager;
      if (!e || e === "recreate") {
        var o = a.mountOption(e === "recreate");
        process.env.NODE_ENV !== "production" && aK(o), !this.option || e === "recreate" ? aI(this, o) : (this.restoreData(), this._mergeOption(o, n)), i = !0;
      }
      if ((e === "timeline" || e === "media") && this.restoreData(), !e || e === "recreate" || e === "timeline") {
        var s = a.getTimelineOption(this);
        s && (i = !0, this._mergeOption(s, n));
      }
      if (!e || e === "recreate" || e === "media") {
        var l = a.getMediaOption(this);
        l.length && L(l, function(u) {
          i = !0, this._mergeOption(u, n);
        }, this);
      }
      return i;
    }, r.prototype.mergeOption = function(e) {
      this._mergeOption(e, null);
    }, r.prototype._mergeOption = function(e, n) {
      var i = this.option, a = this._componentsMap, o = this._componentsCount, s = [], l = xe(), u = n && n.replaceMergeMainTypeMap;
      JJ(this), L(e, function(d, f) {
        d != null && (st.hasClass(f) ? f && (s.push(f), l.set(f, !0)) : i[f] = i[f] == null ? Ge(d) : Qe(i[f], d, !0));
      }), u && u.each(function(d, f) {
        st.hasClass(f) && !l.get(f) && (s.push(f), l.set(f, !0));
      }), st.topologicalTravel(s, st.getAllClassMainTypes(), c, this);
      function c(d) {
        var f = QJ(this, d, Qt(e[d])), h = a.get(d), p = (
          // `!oldCmptList` means init. See the comment in `mappingToExists`
          h ? u && u.get(d) ? "replaceMerge" : "normalMerge" : "replaceAll"
        ), v = IN(h, f, p);
        L$(v, d, st), i[d] = null, a.set(d, null), o.set(d, 0);
        var g = [], m = [], y = 0, b, C;
        L(v, function(w, _) {
          var x = w.existing, I = w.newOption;
          if (!I)
            x && (x.mergeOption({}, this), x.optionUpdated({}, !1));
          else {
            var D = d === "series", T = st.getClass(
              d,
              w.keyInfo.subType,
              !D
              // Give a more detailed warn later if series don't exists
            );
            if (!T) {
              if (process.env.NODE_ENV !== "production") {
                var A = w.keyInfo.subType, M = iK[A];
                Am[A] || (Am[A] = !0, jn(M ? "Series " + A + ` is used but not imported.
import { ` + M + ` } from 'echarts/charts';
echarts.use([` + M + "]);" : "Unknown series " + A));
              }
              return;
            }
            if (d === "tooltip") {
              if (b) {
                process.env.NODE_ENV !== "production" && (C || (Mr("Currently only one tooltip component is allowed."), C = !0));
                return;
              }
              b = !0;
            }
            if (x && x.constructor === T)
              x.name = w.keyInfo.name, x.mergeOption(I, this), x.optionUpdated(I, !1);
            else {
              var R = ae({
                componentIndex: _
              }, w.keyInfo);
              x = new T(I, this, this, R), ae(x, R), w.brandNew && (x.__requireNewView = !0), x.init(I, this, this), x.optionUpdated(null, !0);
            }
          }
          x ? (g.push(x.option), m.push(x), y++) : (g.push(void 0), m.push(void 0));
        }, this), i[d] = g, a.set(d, m), o.set(d, y), d === "series" && g1(this);
      }
      this._seriesIndices || g1(this);
    }, r.prototype.getOption = function() {
      var e = Ge(this.option);
      return L(e, function(n, i) {
        if (st.hasClass(i)) {
          for (var a = Qt(n), o = a.length, s = !1, l = o - 1; l >= 0; l--)
            a[l] && !Df(a[l]) ? s = !0 : (a[l] = null, !s && o--);
          a.length = o, e[i] = a;
        }
      }), delete e[cb], e;
    }, r.prototype.getTheme = function() {
      return this._theme;
    }, r.prototype.getLocaleModel = function() {
      return this._locale;
    }, r.prototype.setUpdatePayload = function(e) {
      this._payload = e;
    }, r.prototype.getUpdatePayload = function() {
      return this._payload;
    }, r.prototype.getComponent = function(e, n) {
      var i = this._componentsMap.get(e);
      if (i) {
        var a = i[n || 0];
        if (a)
          return a;
        if (n == null) {
          for (var o = 0; o < i.length; o++)
            if (i[o])
              return i[o];
        }
      }
    }, r.prototype.queryComponents = function(e) {
      var n = e.mainType;
      if (!n)
        return [];
      var i = e.index, a = e.id, o = e.name, s = this._componentsMap.get(n);
      if (!s || !s.length)
        return [];
      var l;
      return i != null ? (l = [], L(Qt(i), function(u) {
        s[u] && l.push(s[u]);
      })) : a != null ? l = sI("id", a, s) : o != null ? l = sI("name", o, s) : l = Wt(s, function(u) {
        return !!u;
      }), lI(l, e);
    }, r.prototype.findComponents = function(e) {
      var n = e.query, i = e.mainType, a = s(n), o = a ? this.queryComponents(a) : Wt(this._componentsMap.get(i), function(u) {
        return !!u;
      });
      return l(lI(o, e));
      function s(u) {
        var c = i + "Index", d = i + "Id", f = i + "Name";
        return u && (u[c] != null || u[d] != null || u[f] != null) ? {
          mainType: i,
          // subType will be filtered finally.
          index: u[c],
          id: u[d],
          name: u[f]
        } : null;
      }
      function l(u) {
        return e.filter ? Wt(u, e.filter) : u;
      }
    }, r.prototype.eachComponent = function(e, n, i) {
      var a = this._componentsMap;
      if (Ae(e)) {
        var o = n, s = e;
        a.each(function(d, f) {
          for (var h = 0; d && h < d.length; h++) {
            var p = d[h];
            p && s.call(o, f, p, p.componentIndex);
          }
        });
      } else
        for (var l = pe(e) ? a.get(e) : Me(e) ? this.findComponents(e) : null, u = 0; l && u < l.length; u++) {
          var c = l[u];
          c && n.call(i, c, c.componentIndex);
        }
    }, r.prototype.getSeriesByName = function(e) {
      var n = vn(e, null);
      return Wt(this._componentsMap.get("series"), function(i) {
        return !!i && n != null && i.name === n;
      });
    }, r.prototype.getSeriesByIndex = function(e) {
      return this._componentsMap.get("series")[e];
    }, r.prototype.getSeriesByType = function(e) {
      return Wt(this._componentsMap.get("series"), function(n) {
        return !!n && n.subType === e;
      });
    }, r.prototype.getSeries = function() {
      return Wt(this._componentsMap.get("series"), function(e) {
        return !!e;
      });
    }, r.prototype.getSeriesCount = function() {
      return this._componentsCount.get("series");
    }, r.prototype.eachSeries = function(e, n) {
      Hh(this), L(this._seriesIndices, function(i) {
        var a = this._componentsMap.get("series")[i];
        e.call(n, a, i);
      }, this);
    }, r.prototype.eachRawSeries = function(e, n) {
      L(this._componentsMap.get("series"), function(i) {
        i && e.call(n, i, i.componentIndex);
      });
    }, r.prototype.eachSeriesByType = function(e, n, i) {
      Hh(this), L(this._seriesIndices, function(a) {
        var o = this._componentsMap.get("series")[a];
        o.subType === e && n.call(i, o, a);
      }, this);
    }, r.prototype.eachRawSeriesByType = function(e, n, i) {
      return L(this.getSeriesByType(e), n, i);
    }, r.prototype.isSeriesFiltered = function(e) {
      return Hh(this), this._seriesIndicesMap.get(e.componentIndex) == null;
    }, r.prototype.getCurrentSeriesIndices = function() {
      return (this._seriesIndices || []).slice();
    }, r.prototype.filterSeries = function(e, n) {
      Hh(this);
      var i = [];
      L(this._seriesIndices, function(a) {
        var o = this._componentsMap.get("series")[a];
        e.call(n, o, a) && i.push(a);
      }, this), this._seriesIndices = i, this._seriesIndicesMap = xe(i);
    }, r.prototype.restoreData = function(e) {
      g1(this);
      var n = this._componentsMap, i = [];
      n.each(function(a, o) {
        st.hasClass(o) && i.push(o);
      }), st.topologicalTravel(i, st.getAllClassMainTypes(), function(a) {
        L(n.get(a), function(o) {
          o && (a !== "series" || !oK(o, e)) && o.restoreData();
        });
      });
    }, r.internalField = function() {
      g1 = function(e) {
        var n = e._seriesIndices = [];
        L(e._componentsMap.get("series"), function(i) {
          i && n.push(i.componentIndex);
        }), e._seriesIndicesMap = xe(n);
      }, Hh = function(e) {
        if (process.env.NODE_ENV !== "production" && !e._seriesIndices)
          throw new Error("Option should contains series.");
      }, aI = function(e, n) {
        e.option = {}, e.option[cb] = oI, e._componentsMap = xe({
          series: []
        }), e._componentsCount = xe();
        var i = n.aria;
        Me(i) && i.enabled == null && (i.enabled = !0), sK(n, e._theme.option), Qe(n, UJ, !1), e._mergeOption(n, null);
      };
    }(), r;
  }(Pt)
);
function oK(t, r) {
  if (r) {
    var e = r.seriesIndex, n = r.seriesId, i = r.seriesName;
    return e != null && t.componentIndex !== e || n != null && t.id !== n || i != null && t.name !== i;
  }
}
function sK(t, r) {
  var e = t.color && !t.colorLayer;
  L(r, function(n, i) {
    i === "colorLayer" && e || st.hasClass(i) || (typeof n == "object" ? t[i] = t[i] ? Qe(t[i], n, !1) : Ge(n) : t[i] == null && (t[i] = n));
  });
}
function sI(t, r, e) {
  if (ue(r)) {
    var n = xe();
    return L(r, function(a) {
      if (a != null) {
        var o = vn(a, null);
        o != null && n.set(a, !0);
      }
    }), Wt(e, function(a) {
      return a && n.get(a[t]);
    });
  } else {
    var i = vn(r, null);
    return Wt(e, function(a) {
      return a && i != null && a[t] === i;
    });
  }
}
function lI(t, r) {
  return r.hasOwnProperty("subType") ? Wt(t, function(e) {
    return e && e.subType === r.subType;
  }) : t;
}
function uI(t) {
  var r = xe();
  return t && L(Qt(t.replaceMerge), function(e) {
    process.env.NODE_ENV !== "production" && ke(st.hasClass(e), '"' + e + '" is not valid component main type in "replaceMerge"'), r.set(e, !0);
  }), {
    replaceMergeMainTypeMap: r
  };
}
Xr(uw, lw);
var lK = [
  "getDom",
  "getZr",
  "getWidth",
  "getHeight",
  "getDevicePixelRatio",
  "dispatchAction",
  "isSSR",
  "isDisposed",
  "on",
  "off",
  "getDataURL",
  "getConnectedDataURL",
  // 'getModel',
  "getOption",
  // 'getViewOfComponentModel',
  // 'getViewOfSeriesModel',
  "getId",
  "updateLabelLayout"
], NO = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(r) {
      L(lK, function(e) {
        this[e] = ye(r[e], r);
      }, this);
    }
    return t;
  }()
), db = {}, ed = (
  /** @class */
  function() {
    function t() {
      this._coordinateSystems = [];
    }
    return t.prototype.create = function(r, e) {
      var n = [];
      L(db, function(i, a) {
        var o = i.create(r, e);
        n = n.concat(o || []);
      }), this._coordinateSystems = n;
    }, t.prototype.update = function(r, e) {
      L(this._coordinateSystems, function(n) {
        n.update && n.update(r, e);
      });
    }, t.prototype.getCoordinateSystems = function() {
      return this._coordinateSystems.slice();
    }, t.register = function(r, e) {
      db[r] = e;
    }, t.get = function(r) {
      return db[r];
    }, t;
  }()
), uK = /^(min|max)?(.+)$/, cK = (
  /** @class */
  function() {
    function t(r) {
      this._timelineOptions = [], this._mediaList = [], this._currentMediaIndices = [], this._api = r;
    }
    return t.prototype.setOption = function(r, e, n) {
      r && (L(Qt(r.series), function(o) {
        o && o.data && ai(o.data) && fv(o.data);
      }), L(Qt(r.dataset), function(o) {
        o && o.source && ai(o.source) && fv(o.source);
      })), r = Ge(r);
      var i = this._optionBackup, a = dK(r, e, !i);
      this._newBaseOption = a.baseOption, i ? (a.timelineOptions.length && (i.timelineOptions = a.timelineOptions), a.mediaList.length && (i.mediaList = a.mediaList), a.mediaDefault && (i.mediaDefault = a.mediaDefault)) : this._optionBackup = a;
    }, t.prototype.mountOption = function(r) {
      var e = this._optionBackup;
      return this._timelineOptions = e.timelineOptions, this._mediaList = e.mediaList, this._mediaDefault = e.mediaDefault, this._currentMediaIndices = [], Ge(r ? e.baseOption : this._newBaseOption);
    }, t.prototype.getTimelineOption = function(r) {
      var e, n = this._timelineOptions;
      if (n.length) {
        var i = r.getComponent("timeline");
        i && (e = Ge(
          // FIXME:TS as TimelineModel or quivlant interface
          n[i.getCurrentIndex()]
        ));
      }
      return e;
    }, t.prototype.getMediaOption = function(r) {
      var e = this._api.getWidth(), n = this._api.getHeight(), i = this._mediaList, a = this._mediaDefault, o = [], s = [];
      if (!i.length && !a)
        return s;
      for (var l = 0, u = i.length; l < u; l++)
        fK(i[l].query, e, n) && o.push(l);
      return !o.length && a && (o = [-1]), o.length && !pK(o, this._currentMediaIndices) && (s = ce(o, function(c) {
        return Ge(c === -1 ? a.option : i[c].option);
      })), this._currentMediaIndices = o, s;
    }, t;
  }()
);
function dK(t, r, e) {
  var n = [], i, a, o = t.baseOption, s = t.timeline, l = t.options, u = t.media, c = !!t.media, d = !!(l || s || o && o.timeline);
  o ? (a = o, a.timeline || (a.timeline = s)) : ((d || c) && (t.options = t.media = null), a = t), c && (ue(u) ? L(u, function(h) {
    process.env.NODE_ENV !== "production" && h && !h.option && Me(h.query) && Me(h.query.option) && jn("Illegal media option. Must be like { media: [ { query: {}, option: {} } ] }"), h && h.option && (h.query ? n.push(h) : i || (i = h));
  }) : process.env.NODE_ENV !== "production" && jn("Illegal media option. Must be an array. Like { media: [ {...}, {...} ] }")), f(a), L(l, function(h) {
    return f(h);
  }), L(n, function(h) {
    return f(h.option);
  });
  function f(h) {
    L(r, function(p) {
      p(h, e);
    });
  }
  return {
    baseOption: a,
    timelineOptions: l || [],
    mediaDefault: i,
    mediaList: n
  };
}
function fK(t, r, e) {
  var n = {
    width: r,
    height: e,
    aspectratio: r / e
    // lower case for convenience.
  }, i = !0;
  return L(t, function(a, o) {
    var s = o.match(uK);
    if (!(!s || !s[1] || !s[2])) {
      var l = s[1], u = s[2].toLowerCase();
      hK(n[u], a, l) || (i = !1);
    }
  }), i;
}
function hK(t, r, e) {
  return e === "min" ? t >= r : e === "max" ? t <= r : t === r;
}
function pK(t, r) {
  return t.join(",") === r.join(",");
}
var sa = L, Sv = Me, cI = ["areaStyle", "lineStyle", "nodeStyle", "linkStyle", "chordStyle", "label", "labelLine"];
function fb(t) {
  var r = t && t.itemStyle;
  if (r)
    for (var e = 0, n = cI.length; e < n; e++) {
      var i = cI[e], a = r.normal, o = r.emphasis;
      a && a[i] && (process.env.NODE_ENV !== "production" && qr("itemStyle.normal." + i, i), t[i] = t[i] || {}, t[i].normal ? Qe(t[i].normal, a[i]) : t[i].normal = a[i], a[i] = null), o && o[i] && (process.env.NODE_ENV !== "production" && qr("itemStyle.emphasis." + i, "emphasis." + i), t[i] = t[i] || {}, t[i].emphasis ? Qe(t[i].emphasis, o[i]) : t[i].emphasis = o[i], o[i] = null);
    }
}
function ti(t, r, e) {
  if (t && t[r] && (t[r].normal || t[r].emphasis)) {
    var n = t[r].normal, i = t[r].emphasis;
    n && (process.env.NODE_ENV !== "production" && Ra("'normal' hierarchy in " + r + " has been removed since 4.0. All style properties are configured in " + r + " directly now."), e ? (t[r].normal = t[r].emphasis = null, Ee(t[r], n)) : t[r] = n), i && (process.env.NODE_ENV !== "production" && Ra(r + ".emphasis has been changed to emphasis." + r + " since 4.0"), t.emphasis = t.emphasis || {}, t.emphasis[r] = i, i.focus && (t.emphasis.focus = i.focus), i.blurScope && (t.emphasis.blurScope = i.blurScope));
  }
}
function Lp(t) {
  ti(t, "itemStyle"), ti(t, "lineStyle"), ti(t, "areaStyle"), ti(t, "label"), ti(t, "labelLine"), ti(t, "upperLabel"), ti(t, "edgeLabel");
}
function an(t, r) {
  var e = Sv(t) && t[r], n = Sv(e) && e.textStyle;
  if (n) {
    process.env.NODE_ENV !== "production" && Ra("textStyle hierarchy in " + r + " has been removed since 4.0. All textStyle properties are configured in " + r + " directly now.");
    for (var i = 0, a = pS.length; i < a; i++) {
      var o = pS[i];
      n.hasOwnProperty(o) && (e[o] = n[o]);
    }
  }
}
function ma(t) {
  t && (Lp(t), an(t, "label"), t.emphasis && an(t.emphasis, "label"));
}
function vK(t) {
  if (Sv(t)) {
    fb(t), Lp(t), an(t, "label"), an(t, "upperLabel"), an(t, "edgeLabel"), t.emphasis && (an(t.emphasis, "label"), an(t.emphasis, "upperLabel"), an(t.emphasis, "edgeLabel"));
    var r = t.markPoint;
    r && (fb(r), ma(r));
    var e = t.markLine;
    e && (fb(e), ma(e));
    var n = t.markArea;
    n && ma(n);
    var i = t.data;
    if (t.type === "graph") {
      i = i || t.nodes;
      var a = t.links || t.edges;
      if (a && !ai(a))
        for (var o = 0; o < a.length; o++)
          ma(a[o]);
      L(t.categories, function(u) {
        Lp(u);
      });
    }
    if (i && !ai(i))
      for (var o = 0; o < i.length; o++)
        ma(i[o]);
    if (r = t.markPoint, r && r.data)
      for (var s = r.data, o = 0; o < s.length; o++)
        ma(s[o]);
    if (e = t.markLine, e && e.data)
      for (var l = e.data, o = 0; o < l.length; o++)
        ue(l[o]) ? (ma(l[o][0]), ma(l[o][1])) : ma(l[o]);
    t.type === "gauge" ? (an(t, "axisLabel"), an(t, "title"), an(t, "detail")) : t.type === "treemap" ? (ti(t.breadcrumb, "itemStyle"), L(t.levels, function(u) {
      Lp(u);
    })) : t.type === "tree" && Lp(t.leaves);
  }
}
function hs(t) {
  return ue(t) ? t : t ? [t] : [];
}
function dI(t) {
  return (ue(t) ? t[0] : t) || {};
}
function gK(t, r) {
  sa(hs(t.series), function(n) {
    Sv(n) && vK(n);
  });
  var e = ["xAxis", "yAxis", "radiusAxis", "angleAxis", "singleAxis", "parallelAxis", "radar"];
  r && e.push("valueAxis", "categoryAxis", "logAxis", "timeAxis"), sa(e, function(n) {
    sa(hs(t[n]), function(i) {
      i && (an(i, "axisLabel"), an(i.axisPointer, "label"));
    });
  }), sa(hs(t.parallel), function(n) {
    var i = n && n.parallelAxisDefault;
    an(i, "axisLabel"), an(i && i.axisPointer, "label");
  }), sa(hs(t.calendar), function(n) {
    ti(n, "itemStyle"), an(n, "dayLabel"), an(n, "monthLabel"), an(n, "yearLabel");
  }), sa(hs(t.radar), function(n) {
    an(n, "name"), n.name && n.axisName == null && (n.axisName = n.name, delete n.name, process.env.NODE_ENV !== "production" && Ra("name property in radar component has been changed to axisName")), n.nameGap != null && n.axisNameGap == null && (n.axisNameGap = n.nameGap, delete n.nameGap, process.env.NODE_ENV !== "production" && Ra("nameGap property in radar component has been changed to axisNameGap")), process.env.NODE_ENV !== "production" && sa(n.indicator, function(i) {
      i.text && qr("text", "name", "radar.indicator");
    });
  }), sa(hs(t.geo), function(n) {
    Sv(n) && (ma(n), sa(hs(n.regions), function(i) {
      ma(i);
    }));
  }), sa(hs(t.timeline), function(n) {
    ma(n), ti(n, "label"), ti(n, "itemStyle"), ti(n, "controlStyle", !0);
    var i = n.data;
    ue(i) && L(i, function(a) {
      Me(a) && (ti(a, "label"), ti(a, "itemStyle"));
    });
  }), sa(hs(t.toolbox), function(n) {
    ti(n, "iconStyle"), sa(n.feature, function(i) {
      ti(i, "iconStyle");
    });
  }), an(dI(t.axisPointer), "label"), an(dI(t.tooltip).axisPointer, "label");
}
function mK(t, r) {
  for (var e = r.split(","), n = t, i = 0; i < e.length && (n = n && n[e[i]], n != null); i++)
    ;
  return n;
}
function yK(t, r, e, n) {
  for (var i = r.split(","), a = t, o, s = 0; s < i.length - 1; s++)
    o = i[s], a[o] == null && (a[o] = {}), a = a[o];
  a[i[s]] == null && (a[i[s]] = e);
}
function fI(t) {
  t && L(bK, function(r) {
    r[0] in t && !(r[1] in t) && (t[r[1]] = t[r[0]]);
  });
}
var bK = [["x", "left"], ["y", "top"], ["x2", "right"], ["y2", "bottom"]], CK = ["grid", "geo", "parallel", "legend", "toolbox", "title", "visualMap", "dataZoom", "timeline"], hb = [["borderRadius", "barBorderRadius"], ["borderColor", "barBorderColor"], ["borderWidth", "barBorderWidth"]];
function zh(t) {
  var r = t && t.itemStyle;
  if (r)
    for (var e = 0; e < hb.length; e++) {
      var n = hb[e][1], i = hb[e][0];
      r[n] != null && (r[i] = r[n], process.env.NODE_ENV !== "production" && qr(n, i));
    }
}
function hI(t) {
  t && t.alignTo === "edge" && t.margin != null && t.edgeDistance == null && (process.env.NODE_ENV !== "production" && qr("label.margin", "label.edgeDistance", "pie"), t.edgeDistance = t.margin);
}
function pI(t) {
  t && t.downplay && !t.blur && (t.blur = t.downplay, process.env.NODE_ENV !== "production" && qr("downplay", "blur", "sunburst"));
}
function wK(t) {
  t && t.focusNodeAdjacency != null && (t.emphasis = t.emphasis || {}, t.emphasis.focus == null && (process.env.NODE_ENV !== "production" && qr("focusNodeAdjacency", "emphasis: { focus: 'adjacency'}", "graph/sankey"), t.emphasis.focus = "adjacency"));
}
function OO(t, r) {
  if (t)
    for (var e = 0; e < t.length; e++)
      r(t[e]), t[e] && OO(t[e].children, r);
}
function VO(t, r) {
  gK(t, r), t.series = Qt(t.series), L(t.series, function(e) {
    if (Me(e)) {
      var n = e.type;
      if (n === "line")
        e.clipOverflow != null && (e.clip = e.clipOverflow, process.env.NODE_ENV !== "production" && qr("clipOverflow", "clip", "line"));
      else if (n === "pie" || n === "gauge") {
        e.clockWise != null && (e.clockwise = e.clockWise, process.env.NODE_ENV !== "production" && qr("clockWise", "clockwise")), hI(e.label);
        var i = e.data;
        if (i && !ai(i))
          for (var a = 0; a < i.length; a++)
            hI(i[a]);
        e.hoverOffset != null && (e.emphasis = e.emphasis || {}, (e.emphasis.scaleSize = null) && (process.env.NODE_ENV !== "production" && qr("hoverOffset", "emphasis.scaleSize"), e.emphasis.scaleSize = e.hoverOffset));
      } else if (n === "gauge") {
        var o = mK(e, "pointer.color");
        o != null && yK(e, "itemStyle.color", o);
      } else if (n === "bar") {
        zh(e), zh(e.backgroundStyle), zh(e.emphasis);
        var i = e.data;
        if (i && !ai(i))
          for (var a = 0; a < i.length; a++)
            typeof i[a] == "object" && (zh(i[a]), zh(i[a] && i[a].emphasis));
      } else if (n === "sunburst") {
        var s = e.highlightPolicy;
        s && (e.emphasis = e.emphasis || {}, e.emphasis.focus || (e.emphasis.focus = s, process.env.NODE_ENV !== "production" && qr("highlightPolicy", "emphasis.focus", "sunburst"))), pI(e), OO(e.data, pI);
      } else n === "graph" || n === "sankey" ? wK(e) : n === "map" && (e.mapType && !e.map && (process.env.NODE_ENV !== "production" && qr("mapType", "map", "map"), e.map = e.mapType), e.mapLocation && (process.env.NODE_ENV !== "production" && Ra("`mapLocation` is not used anymore."), Ee(e, e.mapLocation)));
      e.hoverAnimation != null && (e.emphasis = e.emphasis || {}, e.emphasis && e.emphasis.scale == null && (process.env.NODE_ENV !== "production" && qr("hoverAnimation", "emphasis.scale"), e.emphasis.scale = e.hoverAnimation)), fI(e);
    }
  }), t.dataRange && (t.visualMap = t.dataRange), L(CK, function(e) {
    var n = t[e];
    n && (ue(n) || (n = [n]), L(n, function(i) {
      fI(i);
    }));
  });
}
function _K(t) {
  var r = xe();
  t.eachSeries(function(e) {
    var n = e.get("stack");
    if (n) {
      var i = r.get(n) || r.set(n, []), a = e.getData(), o = {
        // Used for calculate axis extent automatically.
        // TODO: Type getCalculationInfo return more specific type?
        stackResultDimension: a.getCalculationInfo("stackResultDimension"),
        stackedOverDimension: a.getCalculationInfo("stackedOverDimension"),
        stackedDimension: a.getCalculationInfo("stackedDimension"),
        stackedByDimension: a.getCalculationInfo("stackedByDimension"),
        isStackedByIndex: a.getCalculationInfo("isStackedByIndex"),
        data: a,
        seriesModel: e
      };
      if (!o.stackedDimension || !(o.isStackedByIndex || o.stackedByDimension))
        return;
      i.length && a.setCalculationInfo("stackedOnSeries", i[i.length - 1].seriesModel), i.push(o);
    }
  }), r.each(xK);
}
function xK(t) {
  L(t, function(r, e) {
    var n = [], i = [NaN, NaN], a = [r.stackResultDimension, r.stackedOverDimension], o = r.data, s = r.isStackedByIndex, l = r.seriesModel.get("stackStrategy") || "samesign";
    o.modify(a, function(u, c, d) {
      var f = o.get(r.stackedDimension, d);
      if (isNaN(f))
        return i;
      var h, p;
      s ? p = o.getRawIndex(d) : h = o.get(r.stackedByDimension, d);
      for (var v = NaN, g = e - 1; g >= 0; g--) {
        var m = t[g];
        if (s || (p = m.data.rawIndexOf(m.stackedByDimension, h)), p >= 0) {
          var y = m.data.getByRawIndex(m.stackResultDimension, p);
          if (l === "all" || l === "positive" && y > 0 || l === "negative" && y < 0 || l === "samesign" && f >= 0 && y > 0 || l === "samesign" && f <= 0 && y < 0) {
            f = y$(f, y), v = y;
            break;
          }
        }
      }
      return n[0] = f, n[1] = v, n;
    });
  });
}
var b2 = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(r) {
      this.data = r.data || (r.sourceFormat === as ? {} : []), this.sourceFormat = r.sourceFormat || MO, this.seriesLayoutBy = r.seriesLayoutBy || Wo, this.startIndex = r.startIndex || 0, this.dimensionsDetectedCount = r.dimensionsDetectedCount, this.metaRawOption = r.metaRawOption;
      var e = this.dimensionsDefine = r.dimensionsDefine;
      if (e)
        for (var n = 0; n < e.length; n++) {
          var i = e[n];
          i.type == null && EO(this, n) === Bn.Must && (i.type = "ordinal");
        }
    }
    return t;
  }()
);
function cw(t) {
  return t instanceof b2;
}
function r9(t, r, e) {
  e = e || GO(t);
  var n = r.seriesLayoutBy, i = IK(t, e, n, r.sourceHeader, r.dimensions), a = new b2({
    data: t,
    sourceFormat: e,
    seriesLayoutBy: n,
    dimensionsDefine: i.dimensionsDefine,
    startIndex: i.startIndex,
    dimensionsDetectedCount: i.dimensionsDetectedCount,
    metaRawOption: Ge(r)
  });
  return a;
}
function dw(t) {
  return new b2({
    data: t,
    sourceFormat: ai(t) ? Os : Na
  });
}
function SK(t) {
  return new b2({
    data: t.data,
    sourceFormat: t.sourceFormat,
    seriesLayoutBy: t.seriesLayoutBy,
    dimensionsDefine: Ge(t.dimensionsDefine),
    startIndex: t.startIndex,
    dimensionsDetectedCount: t.dimensionsDetectedCount
  });
}
function GO(t) {
  var r = MO;
  if (ai(t))
    r = Os;
  else if (ue(t)) {
    t.length === 0 && (r = li);
    for (var e = 0, n = t.length; e < n; e++) {
      var i = t[e];
      if (i != null) {
        if (ue(i) || ai(i)) {
          r = li;
          break;
        } else if (Me(i)) {
          r = Oa;
          break;
        }
      }
    }
  } else if (Me(t)) {
    for (var a in t)
      if (be(t, a) && Zn(t[a])) {
        r = as;
        break;
      }
  }
  return r;
}
function IK(t, r, e, n, i) {
  var a, o;
  if (!t)
    return {
      dimensionsDefine: vI(i),
      startIndex: o,
      dimensionsDetectedCount: a
    };
  if (r === li) {
    var s = t;
    n === "auto" || n == null ? gI(function(u) {
      u != null && u !== "-" && (pe(u) ? o == null && (o = 1) : o = 0);
    }, e, s, 10) : o = Mt(n) ? n : n ? 1 : 0, !i && o === 1 && (i = [], gI(function(u, c) {
      i[c] = u != null ? u + "" : "";
    }, e, s, 1 / 0)), a = i ? i.length : e === uh ? s.length : s[0] ? s[0].length : null;
  } else if (r === Oa)
    i || (i = AK(t));
  else if (r === as)
    i || (i = [], L(t, function(u, c) {
      i.push(c);
    }));
  else if (r === Na) {
    var l = qf(t[0]);
    a = ue(l) && l.length || 1;
  } else r === Os && process.env.NODE_ENV !== "production" && ke(!!i, "dimensions must be given if data is TypedArray.");
  return {
    startIndex: o,
    dimensionsDefine: vI(i),
    dimensionsDetectedCount: a
  };
}
function AK(t) {
  for (var r = 0, e; r < t.length && !(e = t[r++]); )
    ;
  if (e)
    return yt(e);
}
function vI(t) {
  if (t) {
    var r = xe();
    return ce(t, function(e, n) {
      e = Me(e) ? e : {
        name: e
      };
      var i = {
        name: e.name,
        displayName: e.displayName,
        type: e.type
      };
      if (i.name == null)
        return i;
      i.name += "", i.displayName == null && (i.displayName = i.name);
      var a = r.get(i.name);
      return a ? i.name += "-" + a.count++ : r.set(i.name, {
        count: 1
      }), i;
    });
  }
}
function gI(t, r, e, n) {
  if (r === uh)
    for (var i = 0; i < e.length && i < n; i++)
      t(e[i] ? e[i][0] : null, i);
  else
    for (var a = e[0] || [], i = 0; i < a.length && i < n; i++)
      t(a[i], i);
}
function BO(t) {
  var r = t.sourceFormat;
  return r === Oa || r === as;
}
var Gu, Bu, Fu, mI, yI, FO = (
  /** @class */
  function() {
    function t(r, e) {
      var n = cw(r) ? r : dw(r);
      this._source = n;
      var i = this._data = n.data;
      if (n.sourceFormat === Os) {
        if (process.env.NODE_ENV !== "production" && e == null)
          throw new Error("Typed array data must specify dimension size");
        this._offset = 0, this._dimSize = e, this._data = i;
      }
      yI(this, i, n);
    }
    return t.prototype.getSource = function() {
      return this._source;
    }, t.prototype.count = function() {
      return 0;
    }, t.prototype.getItem = function(r, e) {
    }, t.prototype.appendData = function(r) {
    }, t.prototype.clean = function() {
    }, t.protoInitialize = function() {
      var r = t.prototype;
      r.pure = !1, r.persistent = !0;
    }(), t.internalField = function() {
      var r;
      yI = function(o, s, l) {
        var u = l.sourceFormat, c = l.seriesLayoutBy, d = l.startIndex, f = l.dimensionsDefine, h = mI[fw(u, c)];
        if (process.env.NODE_ENV !== "production" && ke(h, "Invalide sourceFormat: " + u), ae(o, h), u === Os)
          o.getItem = e, o.count = i, o.fillStorage = n;
        else {
          var p = HO(u, c);
          o.getItem = ye(p, null, s, d, f);
          var v = zO(u, c);
          o.count = ye(v, null, s, d, f);
        }
      };
      var e = function(o, s) {
        o = o - this._offset, s = s || [];
        for (var l = this._data, u = this._dimSize, c = u * o, d = 0; d < u; d++)
          s[d] = l[c + d];
        return s;
      }, n = function(o, s, l, u) {
        for (var c = this._data, d = this._dimSize, f = 0; f < d; f++) {
          for (var h = u[f], p = h[0] == null ? 1 / 0 : h[0], v = h[1] == null ? -1 / 0 : h[1], g = s - o, m = l[f], y = 0; y < g; y++) {
            var b = c[y * d + f];
            m[o + y] = b, b < p && (p = b), b > v && (v = b);
          }
          h[0] = p, h[1] = v;
        }
      }, i = function() {
        return this._data ? this._data.length / this._dimSize : 0;
      };
      mI = (r = {}, r[li + "_" + Wo] = {
        pure: !0,
        appendData: a
      }, r[li + "_" + uh] = {
        pure: !0,
        appendData: function() {
          throw new Error('Do not support appendData when set seriesLayoutBy: "row".');
        }
      }, r[Oa] = {
        pure: !0,
        appendData: a
      }, r[as] = {
        pure: !0,
        appendData: function(o) {
          var s = this._data;
          L(o, function(l, u) {
            for (var c = s[u] || (s[u] = []), d = 0; d < (l || []).length; d++)
              c.push(l[d]);
          });
        }
      }, r[Na] = {
        appendData: a
      }, r[Os] = {
        persistent: !1,
        pure: !0,
        appendData: function(o) {
          process.env.NODE_ENV !== "production" && ke(ai(o), "Added data must be TypedArray if data in initialization is TypedArray"), this._data = o;
        },
        // Clean self if data is already used.
        clean: function() {
          this._offset += this.count(), this._data = null;
        }
      }, r);
      function a(o) {
        for (var s = 0; s < o.length; s++)
          this._data.push(o[s]);
      }
    }(), t;
  }()
), bI = function(t, r, e, n) {
  return t[n];
}, DK = (Gu = {}, Gu[li + "_" + Wo] = function(t, r, e, n) {
  return t[n + r];
}, Gu[li + "_" + uh] = function(t, r, e, n, i) {
  n += r;
  for (var a = i || [], o = t, s = 0; s < o.length; s++) {
    var l = o[s];
    a[s] = l ? l[n] : null;
  }
  return a;
}, Gu[Oa] = bI, Gu[as] = function(t, r, e, n, i) {
  for (var a = i || [], o = 0; o < e.length; o++) {
    var s = e[o].name;
    if (process.env.NODE_ENV !== "production" && s == null)
      throw new Error();
    var l = t[s];
    a[o] = l ? l[n] : null;
  }
  return a;
}, Gu[Na] = bI, Gu);
function HO(t, r) {
  var e = DK[fw(t, r)];
  return process.env.NODE_ENV !== "production" && ke(e, 'Do not support get item on "' + t + '", "' + r + '".'), e;
}
var CI = function(t, r, e) {
  return t.length;
}, TK = (Bu = {}, Bu[li + "_" + Wo] = function(t, r, e) {
  return Math.max(0, t.length - r);
}, Bu[li + "_" + uh] = function(t, r, e) {
  var n = t[0];
  return n ? Math.max(0, n.length - r) : 0;
}, Bu[Oa] = CI, Bu[as] = function(t, r, e) {
  var n = e[0].name;
  if (process.env.NODE_ENV !== "production" && n == null)
    throw new Error();
  var i = t[n];
  return i ? i.length : 0;
}, Bu[Na] = CI, Bu);
function zO(t, r) {
  var e = TK[fw(t, r)];
  return process.env.NODE_ENV !== "production" && ke(e, 'Do not support count on "' + t + '", "' + r + '".'), e;
}
var pb = function(t, r, e) {
  return t[r];
}, MK = (Fu = {}, Fu[li] = pb, Fu[Oa] = function(t, r, e) {
  return t[e];
}, Fu[as] = pb, Fu[Na] = function(t, r, e) {
  var n = qf(t);
  return n instanceof Array ? n[r] : n;
}, Fu[Os] = pb, Fu);
function WO(t) {
  var r = MK[t];
  return process.env.NODE_ENV !== "production" && ke(r, 'Do not support get value on "' + t + '".'), r;
}
function fw(t, r) {
  return t === li ? t + "_" + r : t;
}
function Rf(t, r, e) {
  if (t) {
    var n = t.getRawDataItem(r);
    if (n != null) {
      var i = t.getStore(), a = i.getSource().sourceFormat;
      if (e != null) {
        var o = t.getDimensionIndex(e), s = i.getDimensionProperty(o);
        return WO(a)(n, o, s);
      } else {
        var l = n;
        return a === Na && (l = qf(n)), l;
      }
    }
  }
}
var RK = /\{@(.+?)\}/g, C2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.getDataParams = function(r, e) {
      var n = this.getData(e), i = this.getRawValue(r, e), a = n.getRawIndex(r), o = n.getName(r), s = n.getRawDataItem(r), l = n.getItemVisual(r, "style"), u = l && l[n.getItemVisual(r, "drawType") || "fill"], c = l && l.stroke, d = this.mainType, f = d === "series", h = n.userOutput && n.userOutput.get();
      return {
        componentType: d,
        componentSubType: this.subType,
        componentIndex: this.componentIndex,
        seriesType: f ? this.subType : null,
        seriesIndex: this.seriesIndex,
        seriesId: f ? this.id : null,
        seriesName: f ? this.name : null,
        name: o,
        dataIndex: a,
        data: s,
        dataType: e,
        value: i,
        color: u,
        borderColor: c,
        dimensionNames: h ? h.fullDimensions : null,
        encode: h ? h.encode : null,
        // Param name list for mapping `a`, `b`, `c`, `d`, `e`
        $vars: ["seriesName", "name", "value"]
      };
    }, t.prototype.getFormattedLabel = function(r, e, n, i, a, o) {
      e = e || "normal";
      var s = this.getData(n), l = this.getDataParams(r, n);
      if (o && (l.value = o.interpolatedValue), i != null && ue(l.value) && (l.value = l.value[i]), !a) {
        var u = s.getItemModel(r);
        a = u.get(e === "normal" ? ["label", "formatter"] : [e, "label", "formatter"]);
      }
      if (Ae(a))
        return l.status = e, l.dimensionIndex = i, a(l);
      if (pe(a)) {
        var c = iw(a, l);
        return c.replace(RK, function(d, f) {
          var h = f.length, p = f;
          p.charAt(0) === "[" && p.charAt(h - 1) === "]" && (p = +p.slice(1, h - 1), process.env.NODE_ENV !== "production" && isNaN(p) && jn("Invalide label formatter: @" + f + ", only support @[0], @[1], @[2], ..."));
          var v = Rf(s, r, p);
          if (o && ue(o.interpolatedValue)) {
            var g = s.getDimensionIndex(p);
            g >= 0 && (v = o.interpolatedValue[g]);
          }
          return v != null ? v + "" : "";
        });
      }
    }, t.prototype.getRawValue = function(r, e) {
      return Rf(this.getData(e), r);
    }, t.prototype.formatTooltip = function(r, e, n) {
    }, t;
  }()
);
function wI(t) {
  var r, e;
  return Me(t) ? t.type ? e = t : process.env.NODE_ENV !== "production" && console.warn("The return type of `formatTooltip` is not supported: " + _i(t)) : r = t, {
    text: r,
    // markers: markers || markersExisting,
    frag: e
  };
}
function ev(t) {
  return new LK(t);
}
var LK = (
  /** @class */
  function() {
    function t(r) {
      r = r || {}, this._reset = r.reset, this._plan = r.plan, this._count = r.count, this._onDirty = r.onDirty, this._dirty = !0;
    }
    return t.prototype.perform = function(r) {
      var e = this._upstream, n = r && r.skip;
      if (this._dirty && e) {
        var i = this.context;
        i.data = i.outputData = e.context.outputData;
      }
      this.__pipeline && (this.__pipeline.currentTask = this);
      var a;
      this._plan && !n && (a = this._plan(this.context));
      var o = c(this._modBy), s = this._modDataCount || 0, l = c(r && r.modBy), u = r && r.modDataCount || 0;
      (o !== l || s !== u) && (a = "reset");
      function c(y) {
        return !(y >= 1) && (y = 1), y;
      }
      var d;
      (this._dirty || a === "reset") && (this._dirty = !1, d = this._doReset(n)), this._modBy = l, this._modDataCount = u;
      var f = r && r.step;
      if (e ? (process.env.NODE_ENV !== "production" && ke(e._outputDueEnd != null), this._dueEnd = e._outputDueEnd) : (process.env.NODE_ENV !== "production" && ke(!this._progress || this._count), this._dueEnd = this._count ? this._count(this.context) : 1 / 0), this._progress) {
        var h = this._dueIndex, p = Math.min(f != null ? this._dueIndex + f : 1 / 0, this._dueEnd);
        if (!n && (d || h < p)) {
          var v = this._progress;
          if (ue(v))
            for (var g = 0; g < v.length; g++)
              this._doProgress(v[g], h, p, l, u);
          else
            this._doProgress(v, h, p, l, u);
        }
        this._dueIndex = p;
        var m = this._settedOutputEnd != null ? this._settedOutputEnd : p;
        process.env.NODE_ENV !== "production" && ke(m >= this._outputDueEnd), this._outputDueEnd = m;
      } else
        this._dueIndex = this._outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : this._dueEnd;
      return this.unfinished();
    }, t.prototype.dirty = function() {
      this._dirty = !0, this._onDirty && this._onDirty(this.context);
    }, t.prototype._doProgress = function(r, e, n, i, a) {
      _I.reset(e, n, i, a), this._callingProgress = r, this._callingProgress({
        start: e,
        end: n,
        count: n - e,
        next: _I.next
      }, this.context);
    }, t.prototype._doReset = function(r) {
      this._dueIndex = this._outputDueEnd = this._dueEnd = 0, this._settedOutputEnd = null;
      var e, n;
      !r && this._reset && (e = this._reset(this.context), e && e.progress && (n = e.forceFirstProgress, e = e.progress), ue(e) && !e.length && (e = null)), this._progress = e, this._modBy = this._modDataCount = null;
      var i = this._downstream;
      return i && i.dirty(), n;
    }, t.prototype.unfinished = function() {
      return this._progress && this._dueIndex < this._dueEnd;
    }, t.prototype.pipe = function(r) {
      process.env.NODE_ENV !== "production" && ke(r && !r._disposed && r !== this), (this._downstream !== r || this._dirty) && (this._downstream = r, r._upstream = this, r.dirty());
    }, t.prototype.dispose = function() {
      this._disposed || (this._upstream && (this._upstream._downstream = null), this._downstream && (this._downstream._upstream = null), this._dirty = !1, this._disposed = !0);
    }, t.prototype.getUpstream = function() {
      return this._upstream;
    }, t.prototype.getDownstream = function() {
      return this._downstream;
    }, t.prototype.setOutputEnd = function(r) {
      this._outputDueEnd = this._settedOutputEnd = r;
    }, t;
  }()
), _I = /* @__PURE__ */ function() {
  var t, r, e, n, i, a = {
    reset: function(l, u, c, d) {
      r = l, t = u, e = c, n = d, i = Math.ceil(n / e), a.next = e > 1 && n > 0 ? s : o;
    }
  };
  return a;
  function o() {
    return r < t ? r++ : null;
  }
  function s() {
    var l = r % i * e + Math.ceil(r / i), u = r >= t ? null : l < n ? l : r;
    return r++, u;
  }
}();
function zl(t, r) {
  var e = r && r.type;
  return e === "ordinal" ? t : (e === "time" && !Mt(t) && t != null && t !== "-" && (t = +ra(t)), t == null || t === "" ? NaN : Number(t));
}
var EK = xe({
  number: function(t) {
    return parseFloat(t);
  },
  time: function(t) {
    return +ra(t);
  },
  trim: function(t) {
    return pe(t) ? Aa(t) : t;
  }
});
function ZO(t) {
  return EK.get(t);
}
var jO = {
  lt: function(t, r) {
    return t < r;
  },
  lte: function(t, r) {
    return t <= r;
  },
  gt: function(t, r) {
    return t > r;
  },
  gte: function(t, r) {
    return t >= r;
  }
}, kK = (
  /** @class */
  function() {
    function t(r, e) {
      if (!Mt(e)) {
        var n = "";
        process.env.NODE_ENV !== "production" && (n = 'rvalue of "<", ">", "<=", ">=" can only be number in filter.'), Gt(n);
      }
      this._opFn = jO[r], this._rvalFloat = qo(e);
    }
    return t.prototype.evaluate = function(r) {
      return Mt(r) ? this._opFn(r, this._rvalFloat) : this._opFn(qo(r), this._rvalFloat);
    }, t;
  }()
), YO = (
  /** @class */
  function() {
    function t(r, e) {
      var n = r === "desc";
      this._resultLT = n ? 1 : -1, e == null && (e = n ? "min" : "max"), this._incomparable = e === "min" ? -1 / 0 : 1 / 0;
    }
    return t.prototype.evaluate = function(r, e) {
      var n = Mt(r) ? r : qo(r), i = Mt(e) ? e : qo(e), a = isNaN(n), o = isNaN(i);
      if (a && (n = this._incomparable), o && (i = this._incomparable), a && o) {
        var s = pe(r), l = pe(e);
        s && (n = l ? r : 0), l && (i = s ? e : 0);
      }
      return n < i ? this._resultLT : n > i ? -this._resultLT : 0;
    }, t;
  }()
), PK = (
  /** @class */
  function() {
    function t(r, e) {
      this._rval = e, this._isEQ = r, this._rvalTypeof = typeof e, this._rvalFloat = qo(e);
    }
    return t.prototype.evaluate = function(r) {
      var e = r === this._rval;
      if (!e) {
        var n = typeof r;
        n !== this._rvalTypeof && (n === "number" || this._rvalTypeof === "number") && (e = qo(r) === this._rvalFloat);
      }
      return this._isEQ ? e : !e;
    }, t;
  }()
);
function NK(t, r) {
  return t === "eq" || t === "ne" ? new PK(t === "eq", r) : be(jO, t) ? new kK(t, r) : null;
}
var OK = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.getRawData = function() {
      throw new Error("not supported");
    }, t.prototype.getRawDataItem = function(r) {
      throw new Error("not supported");
    }, t.prototype.cloneRawData = function() {
    }, t.prototype.getDimensionInfo = function(r) {
    }, t.prototype.cloneAllDimensionInfo = function() {
    }, t.prototype.count = function() {
    }, t.prototype.retrieveValue = function(r, e) {
    }, t.prototype.retrieveValueFromItem = function(r, e) {
    }, t.prototype.convertValue = function(r, e) {
      return zl(r, e);
    }, t;
  }()
);
function VK(t, r) {
  var e = new OK(), n = t.data, i = e.sourceFormat = t.sourceFormat, a = t.startIndex, o = "";
  t.seriesLayoutBy !== Wo && (process.env.NODE_ENV !== "production" && (o = '`seriesLayoutBy` of upstream dataset can only be "column" in data transform.'), Gt(o));
  var s = [], l = {}, u = t.dimensionsDefine;
  if (u)
    L(u, function(v, g) {
      var m = v.name, y = {
        index: g,
        name: m,
        displayName: v.displayName
      };
      if (s.push(y), m != null) {
        var b = "";
        be(l, m) && (process.env.NODE_ENV !== "production" && (b = 'dimension name "' + m + '" duplicated.'), Gt(b)), l[m] = y;
      }
    });
  else
    for (var c = 0; c < t.dimensionsDetectedCount; c++)
      s.push({
        index: c
      });
  var d = HO(i, Wo);
  r.__isBuiltIn && (e.getRawDataItem = function(v) {
    return d(n, a, s, v);
  }, e.getRawData = ye(GK, null, t)), e.cloneRawData = ye(BK, null, t);
  var f = zO(i, Wo);
  e.count = ye(f, null, n, a, s);
  var h = WO(i);
  e.retrieveValue = function(v, g) {
    var m = d(n, a, s, v);
    return p(m, g);
  };
  var p = e.retrieveValueFromItem = function(v, g) {
    if (v != null) {
      var m = s[g];
      if (m)
        return h(v, g, m.name);
    }
  };
  return e.getDimensionInfo = ye(FK, null, s, l), e.cloneAllDimensionInfo = ye(HK, null, s), e;
}
function GK(t) {
  var r = t.sourceFormat;
  if (!hw(r)) {
    var e = "";
    process.env.NODE_ENV !== "production" && (e = "`getRawData` is not supported in source format " + r), Gt(e);
  }
  return t.data;
}
function BK(t) {
  var r = t.sourceFormat, e = t.data;
  if (!hw(r)) {
    var n = "";
    process.env.NODE_ENV !== "production" && (n = "`cloneRawData` is not supported in source format " + r), Gt(n);
  }
  if (r === li) {
    for (var i = [], a = 0, o = e.length; a < o; a++)
      i.push(e[a].slice());
    return i;
  } else if (r === Oa) {
    for (var i = [], a = 0, o = e.length; a < o; a++)
      i.push(ae({}, e[a]));
    return i;
  }
}
function FK(t, r, e) {
  if (e != null) {
    if (Mt(e) || !isNaN(e) && !be(r, e))
      return t[e];
    if (be(r, e))
      return r[e];
  }
}
function HK(t) {
  return Ge(t);
}
var XO = xe();
function zK(t) {
  t = Ge(t);
  var r = t.type, e = "";
  r || (process.env.NODE_ENV !== "production" && (e = "Must have a `type` when `registerTransform`."), Gt(e));
  var n = r.split(":");
  n.length !== 2 && (process.env.NODE_ENV !== "production" && (e = 'Name must include namespace like "ns:regression".'), Gt(e));
  var i = !1;
  n[0] === "echarts" && (r = n[1], i = !0), t.__isBuiltIn = i, XO.set(r, t);
}
function WK(t, r, e) {
  var n = Qt(t), i = n.length, a = "";
  i || (process.env.NODE_ENV !== "production" && (a = "If `transform` declared, it should at least contain one transform."), Gt(a));
  for (var o = 0, s = i; o < s; o++) {
    var l = n[o];
    r = ZK(l, r, e, i === 1 ? null : o), o !== s - 1 && (r.length = Math.max(r.length, 1));
  }
  return r;
}
function ZK(t, r, e, n) {
  var i = "";
  r.length || (process.env.NODE_ENV !== "production" && (i = "Must have at least one upstream dataset."), Gt(i)), Me(t) || (process.env.NODE_ENV !== "production" && (i = "transform declaration must be an object rather than " + typeof t + "."), Gt(i));
  var a = t.type, o = XO.get(a);
  o || (process.env.NODE_ENV !== "production" && (i = 'Can not find transform on type "' + a + '".'), Gt(i));
  var s = ce(r, function(c) {
    return VK(c, o);
  }), l = Qt(o.transform({
    upstream: s[0],
    upstreamList: s,
    config: Ge(t.config)
  }));
  if (process.env.NODE_ENV !== "production" && t.print) {
    var u = ce(l, function(c) {
      var d = n != null ? " === pipe index: " + n : "";
      return ["=== dataset index: " + e.datasetIndex + d + " ===", "- transform result data:", _i(c.data), "- transform result dimensions:", _i(c.dimensions)].join(`
`);
    }).join(`
`);
    _$(u);
  }
  return ce(l, function(c, d) {
    var f = "";
    Me(c) || (process.env.NODE_ENV !== "production" && (f = "A transform should not return some empty results."), Gt(f)), c.data || (process.env.NODE_ENV !== "production" && (f = "Transform result data should be not be null or undefined"), Gt(f));
    var h = GO(c.data);
    hw(h) || (process.env.NODE_ENV !== "production" && (f = "Transform result data should be array rows or object rows."), Gt(f));
    var p, v = r[0];
    if (v && d === 0 && !c.dimensions) {
      var g = v.startIndex;
      g && (c.data = v.data.slice(0, g).concat(c.data)), p = {
        seriesLayoutBy: Wo,
        sourceHeader: g,
        dimensions: v.metaRawOption.dimensions
      };
    } else
      p = {
        seriesLayoutBy: Wo,
        sourceHeader: 0,
        dimensions: c.dimensions
      };
    return r9(c.data, p, null);
  });
}
function hw(t) {
  return t === li || t === Oa;
}
var w2 = "undefined", jK = typeof Uint32Array === w2 ? Array : Uint32Array, YK = typeof Uint16Array === w2 ? Array : Uint16Array, $O = typeof Int32Array === w2 ? Array : Int32Array, xI = typeof Float64Array === w2 ? Array : Float64Array, UO = {
  float: xI,
  int: $O,
  // Ordinal data type can be string or int
  ordinal: Array,
  number: Array,
  time: xI
}, vb;
function Wh(t) {
  return t > 65535 ? jK : YK;
}
function Cd() {
  return [1 / 0, -1 / 0];
}
function XK(t) {
  var r = t.constructor;
  return r === Array ? t.slice() : new r(t);
}
function SI(t, r, e, n, i) {
  var a = UO[e || "float"];
  if (i) {
    var o = t[r], s = o && o.length;
    if (s !== n) {
      for (var l = new a(n), u = 0; u < s; u++)
        l[u] = o[u];
      t[r] = l;
    }
  } else
    t[r] = new a(n);
}
var n9 = (
  /** @class */
  function() {
    function t() {
      this._chunks = [], this._rawExtent = [], this._extent = [], this._count = 0, this._rawCount = 0, this._calcDimNameToIdx = xe();
    }
    return t.prototype.initData = function(r, e, n) {
      process.env.NODE_ENV !== "production" && ke(Ae(r.getItem) && Ae(r.count), "Invalid data provider."), this._provider = r, this._chunks = [], this._indices = null, this.getRawIndex = this._getRawIdxIdentity;
      var i = r.getSource(), a = this.defaultDimValueGetter = vb[i.sourceFormat];
      this._dimValueGetter = n || a, this._rawExtent = [];
      var o = BO(i);
      this._dimensions = ce(e, function(s) {
        return process.env.NODE_ENV !== "production" && o && ke(s.property != null), {
          // Only pick these two props. Not leak other properties like orderMeta.
          type: s.type,
          property: s.property
        };
      }), this._initDataFromProvider(0, r.count());
    }, t.prototype.getProvider = function() {
      return this._provider;
    }, t.prototype.getSource = function() {
      return this._provider.getSource();
    }, t.prototype.ensureCalculationDimension = function(r, e) {
      var n = this._calcDimNameToIdx, i = this._dimensions, a = n.get(r);
      if (a != null) {
        if (i[a].type === e)
          return a;
      } else
        a = i.length;
      return i[a] = {
        type: e
      }, n.set(r, a), this._chunks[a] = new UO[e || "float"](this._rawCount), this._rawExtent[a] = Cd(), a;
    }, t.prototype.collectOrdinalMeta = function(r, e) {
      var n = this._chunks[r], i = this._dimensions[r], a = this._rawExtent, o = i.ordinalOffset || 0, s = n.length;
      o === 0 && (a[r] = Cd());
      for (var l = a[r], u = o; u < s; u++) {
        var c = n[u] = e.parseAndCollect(n[u]);
        isNaN(c) || (l[0] = Math.min(c, l[0]), l[1] = Math.max(c, l[1]));
      }
      i.ordinalMeta = e, i.ordinalOffset = s, i.type = "ordinal";
    }, t.prototype.getOrdinalMeta = function(r) {
      var e = this._dimensions[r], n = e.ordinalMeta;
      return n;
    }, t.prototype.getDimensionProperty = function(r) {
      var e = this._dimensions[r];
      return e && e.property;
    }, t.prototype.appendData = function(r) {
      process.env.NODE_ENV !== "production" && ke(!this._indices, "appendData can only be called on raw data.");
      var e = this._provider, n = this.count();
      e.appendData(r);
      var i = e.count();
      return e.persistent || (i += n), n < i && this._initDataFromProvider(n, i, !0), [n, i];
    }, t.prototype.appendValues = function(r, e) {
      for (var n = this._chunks, i = this._dimensions, a = i.length, o = this._rawExtent, s = this.count(), l = s + Math.max(r.length, e || 0), u = 0; u < a; u++) {
        var c = i[u];
        SI(n, u, c.type, l, !0);
      }
      for (var d = [], f = s; f < l; f++)
        for (var h = f - s, p = 0; p < a; p++) {
          var c = i[p], v = vb.arrayRows.call(this, r[h] || d, c.property, h, p);
          n[p][f] = v;
          var g = o[p];
          v < g[0] && (g[0] = v), v > g[1] && (g[1] = v);
        }
      return this._rawCount = this._count = l, {
        start: s,
        end: l
      };
    }, t.prototype._initDataFromProvider = function(r, e, n) {
      for (var i = this._provider, a = this._chunks, o = this._dimensions, s = o.length, l = this._rawExtent, u = ce(o, function(y) {
        return y.property;
      }), c = 0; c < s; c++) {
        var d = o[c];
        l[c] || (l[c] = Cd()), SI(a, c, d.type, e, n);
      }
      if (i.fillStorage)
        i.fillStorage(r, e, a, l);
      else
        for (var f = [], h = r; h < e; h++) {
          f = i.getItem(h, f);
          for (var p = 0; p < s; p++) {
            var v = a[p], g = this._dimValueGetter(f, u[p], h, p);
            v[h] = g;
            var m = l[p];
            g < m[0] && (m[0] = g), g > m[1] && (m[1] = g);
          }
        }
      !i.persistent && i.clean && i.clean(), this._rawCount = this._count = e, this._extent = [];
    }, t.prototype.count = function() {
      return this._count;
    }, t.prototype.get = function(r, e) {
      if (!(e >= 0 && e < this._count))
        return NaN;
      var n = this._chunks[r];
      return n ? n[this.getRawIndex(e)] : NaN;
    }, t.prototype.getValues = function(r, e) {
      var n = [], i = [];
      if (e == null) {
        e = r, r = [];
        for (var a = 0; a < this._dimensions.length; a++)
          i.push(a);
      } else
        i = r;
      for (var a = 0, o = i.length; a < o; a++)
        n.push(this.get(i[a], e));
      return n;
    }, t.prototype.getByRawIndex = function(r, e) {
      if (!(e >= 0 && e < this._rawCount))
        return NaN;
      var n = this._chunks[r];
      return n ? n[e] : NaN;
    }, t.prototype.getSum = function(r) {
      var e = this._chunks[r], n = 0;
      if (e)
        for (var i = 0, a = this.count(); i < a; i++) {
          var o = this.get(r, i);
          isNaN(o) || (n += o);
        }
      return n;
    }, t.prototype.getMedian = function(r) {
      var e = [];
      this.each([r], function(a) {
        isNaN(a) || e.push(a);
      });
      var n = e.sort(function(a, o) {
        return a - o;
      }), i = this.count();
      return i === 0 ? 0 : i % 2 === 1 ? n[(i - 1) / 2] : (n[i / 2] + n[i / 2 - 1]) / 2;
    }, t.prototype.indexOfRawIndex = function(r) {
      if (r >= this._rawCount || r < 0)
        return -1;
      if (!this._indices)
        return r;
      var e = this._indices, n = e[r];
      if (n != null && n < this._count && n === r)
        return r;
      for (var i = 0, a = this._count - 1; i <= a; ) {
        var o = (i + a) / 2 | 0;
        if (e[o] < r)
          i = o + 1;
        else if (e[o] > r)
          a = o - 1;
        else
          return o;
      }
      return -1;
    }, t.prototype.indicesOfNearest = function(r, e, n) {
      var i = this._chunks, a = i[r], o = [];
      if (!a)
        return o;
      n == null && (n = 1 / 0);
      for (var s = 1 / 0, l = -1, u = 0, c = 0, d = this.count(); c < d; c++) {
        var f = this.getRawIndex(c), h = e - a[f], p = Math.abs(h);
        p <= n && ((p < s || p === s && h >= 0 && l < 0) && (s = p, l = h, u = 0), h === l && (o[u++] = c));
      }
      return o.length = u, o;
    }, t.prototype.getIndices = function() {
      var r, e = this._indices;
      if (e) {
        var n = e.constructor, i = this._count;
        if (n === Array) {
          r = new n(i);
          for (var a = 0; a < i; a++)
            r[a] = e[a];
        } else
          r = new n(e.buffer, 0, i);
      } else {
        var n = Wh(this._rawCount);
        r = new n(this.count());
        for (var a = 0; a < r.length; a++)
          r[a] = a;
      }
      return r;
    }, t.prototype.filter = function(r, e) {
      if (!this._count)
        return this;
      for (var n = this.clone(), i = n.count(), a = Wh(n._rawCount), o = new a(i), s = [], l = r.length, u = 0, c = r[0], d = n._chunks, f = 0; f < i; f++) {
        var h = void 0, p = n.getRawIndex(f);
        if (l === 0)
          h = e(f);
        else if (l === 1) {
          var v = d[c][p];
          h = e(v, f);
        } else {
          for (var g = 0; g < l; g++)
            s[g] = d[r[g]][p];
          s[g] = f, h = e.apply(null, s);
        }
        h && (o[u++] = p);
      }
      return u < i && (n._indices = o), n._count = u, n._extent = [], n._updateGetRawIdx(), n;
    }, t.prototype.selectRange = function(r) {
      var e = this.clone(), n = e._count;
      if (!n)
        return this;
      var i = yt(r), a = i.length;
      if (!a)
        return this;
      var o = e.count(), s = Wh(e._rawCount), l = new s(o), u = 0, c = i[0], d = r[c][0], f = r[c][1], h = e._chunks, p = !1;
      if (!e._indices) {
        var v = 0;
        if (a === 1) {
          for (var g = h[i[0]], m = 0; m < n; m++) {
            var y = g[m];
            (y >= d && y <= f || isNaN(y)) && (l[u++] = v), v++;
          }
          p = !0;
        } else if (a === 2) {
          for (var g = h[i[0]], b = h[i[1]], C = r[i[1]][0], w = r[i[1]][1], m = 0; m < n; m++) {
            var y = g[m], _ = b[m];
            (y >= d && y <= f || isNaN(y)) && (_ >= C && _ <= w || isNaN(_)) && (l[u++] = v), v++;
          }
          p = !0;
        }
      }
      if (!p)
        if (a === 1)
          for (var m = 0; m < o; m++) {
            var x = e.getRawIndex(m), y = h[i[0]][x];
            (y >= d && y <= f || isNaN(y)) && (l[u++] = x);
          }
        else
          for (var m = 0; m < o; m++) {
            for (var I = !0, x = e.getRawIndex(m), D = 0; D < a; D++) {
              var T = i[D], y = h[T][x];
              (y < r[T][0] || y > r[T][1]) && (I = !1);
            }
            I && (l[u++] = e.getRawIndex(m));
          }
      return u < o && (e._indices = l), e._count = u, e._extent = [], e._updateGetRawIdx(), e;
    }, t.prototype.map = function(r, e) {
      var n = this.clone(r);
      return this._updateDims(n, r, e), n;
    }, t.prototype.modify = function(r, e) {
      this._updateDims(this, r, e);
    }, t.prototype._updateDims = function(r, e, n) {
      for (var i = r._chunks, a = [], o = e.length, s = r.count(), l = [], u = r._rawExtent, c = 0; c < e.length; c++)
        u[e[c]] = Cd();
      for (var d = 0; d < s; d++) {
        for (var f = r.getRawIndex(d), h = 0; h < o; h++)
          l[h] = i[e[h]][f];
        l[o] = d;
        var p = n && n.apply(null, l);
        if (p != null) {
          typeof p != "object" && (a[0] = p, p = a);
          for (var c = 0; c < p.length; c++) {
            var v = e[c], g = p[c], m = u[v], y = i[v];
            y && (y[f] = g), g < m[0] && (m[0] = g), g > m[1] && (m[1] = g);
          }
        }
      }
    }, t.prototype.lttbDownSample = function(r, e) {
      var n = this.clone([r], !0), i = n._chunks, a = i[r], o = this.count(), s = 0, l = Math.floor(1 / e), u = this.getRawIndex(0), c, d, f, h = new (Wh(this._rawCount))(Math.min((Math.ceil(o / l) + 2) * 2, o));
      h[s++] = u;
      for (var p = 1; p < o - 1; p += l) {
        for (var v = Math.min(p + l, o - 1), g = Math.min(p + l * 2, o), m = (g + v) / 2, y = 0, b = v; b < g; b++) {
          var C = this.getRawIndex(b), w = a[C];
          isNaN(w) || (y += w);
        }
        y /= g - v;
        var _ = p, x = Math.min(p + l, o), I = p - 1, D = a[u];
        c = -1, f = _;
        for (var T = -1, A = 0, b = _; b < x; b++) {
          var C = this.getRawIndex(b), w = a[C];
          if (isNaN(w)) {
            A++, T < 0 && (T = C);
            continue;
          }
          d = Math.abs((I - m) * (w - D) - (I - b) * (y - D)), d > c && (c = d, f = C);
        }
        A > 0 && A < x - _ && (h[s++] = Math.min(T, f), f = Math.max(T, f)), h[s++] = f, u = f;
      }
      return h[s++] = this.getRawIndex(o - 1), n._count = s, n._indices = h, n.getRawIndex = this._getRawIdx, n;
    }, t.prototype.downSample = function(r, e, n, i) {
      for (var a = this.clone([r], !0), o = a._chunks, s = [], l = Math.floor(1 / e), u = o[r], c = this.count(), d = a._rawExtent[r] = Cd(), f = new (Wh(this._rawCount))(Math.ceil(c / l)), h = 0, p = 0; p < c; p += l) {
        l > c - p && (l = c - p, s.length = l);
        for (var v = 0; v < l; v++) {
          var g = this.getRawIndex(p + v);
          s[v] = u[g];
        }
        var m = n(s), y = this.getRawIndex(Math.min(p + i(s, m) || 0, c - 1));
        u[y] = m, m < d[0] && (d[0] = m), m > d[1] && (d[1] = m), f[h++] = y;
      }
      return a._count = h, a._indices = f, a._updateGetRawIdx(), a;
    }, t.prototype.each = function(r, e) {
      if (this._count)
        for (var n = r.length, i = this._chunks, a = 0, o = this.count(); a < o; a++) {
          var s = this.getRawIndex(a);
          switch (n) {
            case 0:
              e(a);
              break;
            case 1:
              e(i[r[0]][s], a);
              break;
            case 2:
              e(i[r[0]][s], i[r[1]][s], a);
              break;
            default:
              for (var l = 0, u = []; l < n; l++)
                u[l] = i[r[l]][s];
              u[l] = a, e.apply(null, u);
          }
        }
    }, t.prototype.getDataExtent = function(r) {
      var e = this._chunks[r], n = Cd();
      if (!e)
        return n;
      var i = this.count(), a = !this._indices, o;
      if (a)
        return this._rawExtent[r].slice();
      if (o = this._extent[r], o)
        return o.slice();
      o = n;
      for (var s = o[0], l = o[1], u = 0; u < i; u++) {
        var c = this.getRawIndex(u), d = e[c];
        d < s && (s = d), d > l && (l = d);
      }
      return o = [s, l], this._extent[r] = o, o;
    }, t.prototype.getRawDataItem = function(r) {
      var e = this.getRawIndex(r);
      if (this._provider.persistent)
        return this._provider.getItem(e);
      for (var n = [], i = this._chunks, a = 0; a < i.length; a++)
        n.push(i[a][e]);
      return n;
    }, t.prototype.clone = function(r, e) {
      var n = new t(), i = this._chunks, a = r && Ma(r, function(s, l) {
        return s[l] = !0, s;
      }, {});
      if (a)
        for (var o = 0; o < i.length; o++)
          n._chunks[o] = a[o] ? XK(i[o]) : i[o];
      else
        n._chunks = i;
      return this._copyCommonProps(n), e || (n._indices = this._cloneIndices()), n._updateGetRawIdx(), n;
    }, t.prototype._copyCommonProps = function(r) {
      r._count = this._count, r._rawCount = this._rawCount, r._provider = this._provider, r._dimensions = this._dimensions, r._extent = Ge(this._extent), r._rawExtent = Ge(this._rawExtent);
    }, t.prototype._cloneIndices = function() {
      if (this._indices) {
        var r = this._indices.constructor, e = void 0;
        if (r === Array) {
          var n = this._indices.length;
          e = new r(n);
          for (var i = 0; i < n; i++)
            e[i] = this._indices[i];
        } else
          e = new r(this._indices);
        return e;
      }
      return null;
    }, t.prototype._getRawIdxIdentity = function(r) {
      return r;
    }, t.prototype._getRawIdx = function(r) {
      return r < this._count && r >= 0 ? this._indices[r] : -1;
    }, t.prototype._updateGetRawIdx = function() {
      this.getRawIndex = this._indices ? this._getRawIdx : this._getRawIdxIdentity;
    }, t.internalField = function() {
      function r(e, n, i, a) {
        return zl(e[a], this._dimensions[a]);
      }
      vb = {
        arrayRows: r,
        objectRows: function(e, n, i, a) {
          return zl(e[n], this._dimensions[a]);
        },
        keyedColumns: r,
        original: function(e, n, i, a) {
          var o = e && (e.value == null ? e : e.value);
          return zl(o instanceof Array ? o[a] : o, this._dimensions[a]);
        },
        typedArray: function(e, n, i, a) {
          return e[a];
        }
      };
    }(), t;
  }()
), JO = (
  /** @class */
  function() {
    function t(r) {
      this._sourceList = [], this._storeList = [], this._upstreamSignList = [], this._versionSignBase = 0, this._dirty = !0, this._sourceHost = r;
    }
    return t.prototype.dirty = function() {
      this._setLocalSource([], []), this._storeList = [], this._dirty = !0;
    }, t.prototype._setLocalSource = function(r, e) {
      this._sourceList = r, this._upstreamSignList = e, this._versionSignBase++, this._versionSignBase > 9e10 && (this._versionSignBase = 0);
    }, t.prototype._getVersionSign = function() {
      return this._sourceHost.uid + "_" + this._versionSignBase;
    }, t.prototype.prepareSource = function() {
      this._isDirty() && (this._createSource(), this._dirty = !1);
    }, t.prototype._createSource = function() {
      this._setLocalSource([], []);
      var r = this._sourceHost, e = this._getUpstreamSourceManagers(), n = !!e.length, i, a;
      if (Zh(r)) {
        var o = r, s = void 0, l = void 0, u = void 0;
        if (n) {
          var c = e[0];
          c.prepareSource(), u = c.getSource(), s = u.data, l = u.sourceFormat, a = [c._getVersionSign()];
        } else
          s = o.get("data", !0), l = ai(s) ? Os : Na, a = [];
        var d = this._getSourceMetaRawOption() || {}, f = u && u.metaRawOption || {}, h = je(d.seriesLayoutBy, f.seriesLayoutBy) || null, p = je(d.sourceHeader, f.sourceHeader), v = je(d.dimensions, f.dimensions), g = h !== f.seriesLayoutBy || !!p != !!f.sourceHeader || v;
        i = g ? [r9(s, {
          seriesLayoutBy: h,
          sourceHeader: p,
          dimensions: v
        }, l)] : [];
      } else {
        var m = r;
        if (n) {
          var y = this._applyTransform(e);
          i = y.sourceList, a = y.upstreamSignList;
        } else {
          var b = m.get("source", !0);
          i = [r9(b, this._getSourceMetaRawOption(), null)], a = [];
        }
      }
      process.env.NODE_ENV !== "production" && ke(i && a), this._setLocalSource(i, a);
    }, t.prototype._applyTransform = function(r) {
      var e = this._sourceHost, n = e.get("transform", !0), i = e.get("fromTransformResult", !0);
      if (process.env.NODE_ENV !== "production" && ke(i != null || n != null), i != null) {
        var a = "";
        r.length !== 1 && (process.env.NODE_ENV !== "production" && (a = "When using `fromTransformResult`, there should be only one upstream dataset"), AI(a));
      }
      var o, s = [], l = [];
      return L(r, function(u) {
        u.prepareSource();
        var c = u.getSource(i || 0), d = "";
        i != null && !c && (process.env.NODE_ENV !== "production" && (d = "Can not retrieve result by `fromTransformResult`: " + i), AI(d)), s.push(c), l.push(u._getVersionSign());
      }), n ? o = WK(n, s, {
        datasetIndex: e.componentIndex
      }) : i != null && (o = [SK(s[0])]), {
        sourceList: o,
        upstreamSignList: l
      };
    }, t.prototype._isDirty = function() {
      if (this._dirty)
        return !0;
      for (var r = this._getUpstreamSourceManagers(), e = 0; e < r.length; e++) {
        var n = r[e];
        if (
          // Consider the case that there is ancestor diry, call it recursively.
          // The performance is probably not an issue because usually the chain is not long.
          n._isDirty() || this._upstreamSignList[e] !== n._getVersionSign()
        )
          return !0;
      }
    }, t.prototype.getSource = function(r) {
      r = r || 0;
      var e = this._sourceList[r];
      if (!e) {
        var n = this._getUpstreamSourceManagers();
        return n[0] && n[0].getSource(r);
      }
      return e;
    }, t.prototype.getSharedDataStore = function(r) {
      process.env.NODE_ENV !== "production" && ke(Zh(this._sourceHost), "Can only call getDataStore on series source manager.");
      var e = r.makeStoreSchema();
      return this._innerGetDataStore(e.dimensions, r.source, e.hash);
    }, t.prototype._innerGetDataStore = function(r, e, n) {
      var i = 0, a = this._storeList, o = a[i];
      o || (o = a[i] = {});
      var s = o[n];
      if (!s) {
        var l = this._getUpstreamSourceManagers()[0];
        Zh(this._sourceHost) && l ? s = l._innerGetDataStore(r, e, n) : (s = new n9(), s.initData(new FO(e, r.length), r)), o[n] = s;
      }
      return s;
    }, t.prototype._getUpstreamSourceManagers = function() {
      var r = this._sourceHost;
      if (Zh(r)) {
        var e = sw(r);
        return e ? [e.getSourceManager()] : [];
      } else
        return ce(KJ(r), function(n) {
          return n.getSourceManager();
        });
    }, t.prototype._getSourceMetaRawOption = function() {
      var r = this._sourceHost, e, n, i;
      if (Zh(r))
        e = r.get("seriesLayoutBy", !0), n = r.get("sourceHeader", !0), i = r.get("dimensions", !0);
      else if (!this._getUpstreamSourceManagers().length) {
        var a = r;
        e = a.get("seriesLayoutBy", !0), n = a.get("sourceHeader", !0), i = a.get("dimensions", !0);
      }
      return {
        seriesLayoutBy: e,
        sourceHeader: n,
        dimensions: i
      };
    }, t;
  }()
);
function II(t) {
  var r = t.option.transform;
  r && fv(t.option.transform);
}
function Zh(t) {
  return t.mainType === "series";
}
function AI(t) {
  throw new Error(t);
}
var KO = "line-height:1";
function qO(t, r) {
  var e = t.color || "#6e7079", n = t.fontSize || 12, i = t.fontWeight || "400", a = t.color || "#464646", o = t.fontSize || 14, s = t.fontWeight || "900";
  return r === "html" ? {
    // eslint-disable-next-line max-len
    nameStyle: "font-size:" + bi(n + "") + "px;color:" + bi(e) + ";font-weight:" + bi(i + ""),
    // eslint-disable-next-line max-len
    valueStyle: "font-size:" + bi(o + "") + "px;color:" + bi(a) + ";font-weight:" + bi(s + "")
  } : {
    nameStyle: {
      fontSize: n,
      fill: e,
      fontWeight: i
    },
    valueStyle: {
      fontSize: o,
      fill: a,
      fontWeight: s
    }
  };
}
var $K = [0, 10, 20, 30], UK = ["", `
`, `

`, `


`];
function Sn(t, r) {
  return r.type = t, r;
}
function i9(t) {
  return t.type === "section";
}
function QO(t) {
  return i9(t) ? JK : KK;
}
function eV(t) {
  if (i9(t)) {
    var r = 0, e = t.blocks.length, n = e > 1 || e > 0 && !t.noHeader;
    return L(t.blocks, function(i) {
      var a = eV(i);
      a >= r && (r = a + +(n && // 0 always can not be readable gap level.
      (!a || i9(i) && !i.noHeader)));
    }), r;
  }
  return 0;
}
function JK(t, r, e, n) {
  var i = r.noHeader, a = qK(eV(r)), o = [], s = r.blocks || [];
  ke(!s || ue(s)), s = s || [];
  var l = t.orderMode;
  if (r.sortBlocks && l) {
    s = s.slice();
    var u = {
      valueAsc: "asc",
      valueDesc: "desc"
    };
    if (be(u, l)) {
      var c = new YO(u[l], null);
      s.sort(function(p, v) {
        return c.evaluate(p.sortParam, v.sortParam);
      });
    } else l === "seriesDesc" && s.reverse();
  }
  L(s, function(p, v) {
    var g = r.valueFormatter, m = QO(p)(
      // Inherit valueFormatter
      g ? ae(ae({}, t), {
        valueFormatter: g
      }) : t,
      p,
      v > 0 ? a.html : 0,
      n
    );
    m != null && o.push(m);
  });
  var d = t.renderMode === "richText" ? o.join(a.richText) : a9(o.join(""), i ? e : a.html);
  if (i)
    return d;
  var f = qC(r.header, "ordinal", t.useUTC), h = qO(n, t.renderMode).nameStyle;
  return t.renderMode === "richText" ? tV(t, f, h) + a.richText + d : a9('<div style="' + h + ";" + KO + ';">' + bi(f) + "</div>" + d, e);
}
function KK(t, r, e, n) {
  var i = t.renderMode, a = r.noName, o = r.noValue, s = !r.markerType, l = r.name, u = t.useUTC, c = r.valueFormatter || t.valueFormatter || function(C) {
    return C = ue(C) ? C : [C], ce(C, function(w, _) {
      return qC(w, ue(h) ? h[_] : h, u);
    });
  };
  if (!(a && o)) {
    var d = s ? "" : t.markupStyleCreator.makeTooltipMarker(r.markerType, r.markerColor || "#333", i), f = a ? "" : qC(l, "ordinal", u), h = r.valueType, p = o ? [] : c(r.value, r.dataIndex), v = !s || !a, g = !s && a, m = qO(n, i), y = m.nameStyle, b = m.valueStyle;
    return i === "richText" ? (s ? "" : d) + (a ? "" : tV(t, f, y)) + (o ? "" : tq(t, p, v, g, b)) : a9((s ? "" : d) + (a ? "" : QK(f, !s, y)) + (o ? "" : eq(p, v, g, b)), e);
  }
}
function DI(t, r, e, n, i, a) {
  if (t) {
    var o = QO(t), s = {
      useUTC: i,
      renderMode: e,
      orderMode: n,
      markupStyleCreator: r,
      valueFormatter: t.valueFormatter
    };
    return o(s, t, 0, a);
  }
}
function qK(t) {
  return {
    html: $K[t],
    richText: UK[t]
  };
}
function a9(t, r) {
  var e = '<div style="clear:both"></div>', n = "margin: " + r + "px 0 0";
  return '<div style="' + n + ";" + KO + ';">' + t + e + "</div>";
}
function QK(t, r, e) {
  var n = r ? "margin-left:2px" : "";
  return '<span style="' + e + ";" + n + '">' + bi(t) + "</span>";
}
function eq(t, r, e, n) {
  var i = e ? "10px" : "20px", a = r ? "float:right;margin-left:" + i : "";
  return t = ue(t) ? t : [t], '<span style="' + a + ";" + n + '">' + ce(t, function(o) {
    return bi(o);
  }).join("&nbsp;&nbsp;") + "</span>";
}
function tV(t, r, e) {
  return t.markupStyleCreator.wrapRichTextStyle(r, e);
}
function tq(t, r, e, n, i) {
  var a = [i], o = n ? 10 : 20;
  return e && a.push({
    padding: [0, 0, 0, o],
    align: "right"
  }), t.markupStyleCreator.wrapRichTextStyle(ue(r) ? r.join("  ") : r, a);
}
function rV(t, r) {
  var e = t.getData().getItemVisual(r, "style"), n = e[t.visualDrawType];
  return Hc(n);
}
function nV(t, r) {
  var e = t.get("padding");
  return e ?? (r === "richText" ? [8, 10] : 10);
}
var gb = (
  /** @class */
  function() {
    function t() {
      this.richTextStyles = {}, this._nextStyleNameId = wN();
    }
    return t.prototype._generateStyleName = function() {
      return "__EC_aUTo_" + this._nextStyleNameId++;
    }, t.prototype.makeTooltipMarker = function(r, e, n) {
      var i = n === "richText" ? this._generateStyleName() : null, a = IO({
        color: e,
        type: r,
        renderMode: n,
        markerId: i
      });
      return pe(a) ? a : (process.env.NODE_ENV !== "production" && ke(i), this.richTextStyles[i] = a.style, a.content);
    }, t.prototype.wrapRichTextStyle = function(r, e) {
      var n = {};
      ue(e) ? L(e, function(a) {
        return ae(n, a);
      }) : ae(n, e);
      var i = this._generateStyleName();
      return this.richTextStyles[i] = n, "{" + i + "|" + r + "}";
    }, t;
  }()
);
function iV(t) {
  var r = t.series, e = t.dataIndex, n = t.multipleSeries, i = r.getData(), a = i.mapDimensionsAll("defaultedTooltip"), o = a.length, s = r.getRawValue(e), l = ue(s), u = rV(r, e), c, d, f, h;
  if (o > 1 || l && !o) {
    var p = rq(s, r, e, a, u);
    c = p.inlineValues, d = p.inlineValueTypes, f = p.blocks, h = p.inlineValues[0];
  } else if (o) {
    var v = i.getDimensionInfo(a[0]);
    h = c = Rf(i, e, a[0]), d = v.type;
  } else
    h = c = l ? s[0] : s;
  var g = k7(r), m = g && r.name || "", y = i.getName(e), b = n ? m : y;
  return Sn("section", {
    header: m,
    // When series name is not specified, do not show a header line with only '-'.
    // This case always happens in tooltip.trigger: 'item'.
    noHeader: n || !g,
    sortParam: h,
    blocks: [Sn("nameValue", {
      markerType: "item",
      markerColor: u,
      // Do not mix display seriesName and itemName in one tooltip,
      // which might confuses users.
      name: b,
      // name dimension might be auto assigned, where the name might
      // be not readable. So we check trim here.
      noName: !Aa(b),
      value: c,
      valueType: d,
      dataIndex: e
    })].concat(f || [])
  });
}
function rq(t, r, e, n, i) {
  var a = r.getData(), o = Ma(t, function(d, f, h) {
    var p = a.getDimensionInfo(h);
    return d = d || p && p.tooltip !== !1 && p.displayName != null;
  }, !1), s = [], l = [], u = [];
  n.length ? L(n, function(d) {
    c(Rf(a, e, d), d);
  }) : L(t, c);
  function c(d, f) {
    var h = a.getDimensionInfo(f);
    !h || h.otherDims.tooltip === !1 || (o ? u.push(Sn("nameValue", {
      markerType: "subItem",
      markerColor: i,
      name: h.displayName,
      value: d,
      valueType: h.type
    })) : (s.push(d), l.push(h.type)));
  }
  return {
    inlineValues: s,
    inlineValueTypes: l,
    blocks: u
  };
}
var fl = It();
function m1(t, r) {
  return t.getName(r) || t.getId(r);
}
var k0 = "__universalTransitionEnabled", tr = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e._selectedDataIndicesMap = {}, e;
    }
    return r.prototype.init = function(e, n, i) {
      this.seriesIndex = this.componentIndex, this.dataTask = ev({
        count: iq,
        reset: aq
      }), this.dataTask.context = {
        model: this
      }, this.mergeDefaultAndTheme(e, i);
      var a = fl(this).sourceManager = new JO(this);
      a.prepareSource();
      var o = this.getInitialData(e, i);
      MI(o, this), this.dataTask.context.data = o, process.env.NODE_ENV !== "production" && ke(o, "getInitialData returned invalid data."), fl(this).dataBeforeProcessed = o, TI(this), this._initSelectedMapFromData(o);
    }, r.prototype.mergeDefaultAndTheme = function(e, n) {
      var i = xv(this), a = i ? lh(e) : {}, o = this.subType;
      st.hasClass(o) && (o += "Series"), Qe(e, n.getTheme().get(this.subType)), Qe(e, this.getDefaultOption()), Vc(e, "label", ["show"]), this.fillDataTextStyle(e.data), i && ru(e, a, i);
    }, r.prototype.mergeOption = function(e, n) {
      e = Qe(this.option, e, !0), this.fillDataTextStyle(e.data);
      var i = xv(this);
      i && ru(this.option, e, i);
      var a = fl(this).sourceManager;
      a.dirty(), a.prepareSource();
      var o = this.getInitialData(e, n);
      MI(o, this), this.dataTask.dirty(), this.dataTask.context.data = o, fl(this).dataBeforeProcessed = o, TI(this), this._initSelectedMapFromData(o);
    }, r.prototype.fillDataTextStyle = function(e) {
      if (e && !ai(e))
        for (var n = ["show"], i = 0; i < e.length; i++)
          e[i] && e[i].label && Vc(e[i], "label", n);
    }, r.prototype.getInitialData = function(e, n) {
    }, r.prototype.appendData = function(e) {
      var n = this.getRawData();
      n.appendData(e.data);
    }, r.prototype.getData = function(e) {
      var n = o9(this);
      if (n) {
        var i = n.context.data;
        return e == null || !i.getLinkedData ? i : i.getLinkedData(e);
      } else
        return fl(this).data;
    }, r.prototype.getAllData = function() {
      var e = this.getData();
      return e && e.getLinkedDataAll ? e.getLinkedDataAll() : [{
        data: e
      }];
    }, r.prototype.setData = function(e) {
      var n = o9(this);
      if (n) {
        var i = n.context;
        i.outputData = e, n !== this.dataTask && (i.data = e);
      }
      fl(this).data = e;
    }, r.prototype.getEncode = function() {
      var e = this.get("encode", !0);
      if (e)
        return xe(e);
    }, r.prototype.getSourceManager = function() {
      return fl(this).sourceManager;
    }, r.prototype.getSource = function() {
      return this.getSourceManager().getSource();
    }, r.prototype.getRawData = function() {
      return fl(this).dataBeforeProcessed;
    }, r.prototype.getColorBy = function() {
      var e = this.get("colorBy");
      return e || "series";
    }, r.prototype.isColorBySeries = function() {
      return this.getColorBy() === "series";
    }, r.prototype.getBaseAxis = function() {
      var e = this.coordinateSystem;
      return e && e.getBaseAxis && e.getBaseAxis();
    }, r.prototype.formatTooltip = function(e, n, i) {
      return iV({
        series: this,
        dataIndex: e,
        multipleSeries: n
      });
    }, r.prototype.isAnimationEnabled = function() {
      var e = this.ecModel;
      if (vt.node && !(e && e.ssr))
        return !1;
      var n = this.getShallow("animation");
      return n && this.getData().count() > this.getShallow("animationThreshold") && (n = !1), !!n;
    }, r.prototype.restoreData = function() {
      this.dataTask.dirty();
    }, r.prototype.getColorFromPalette = function(e, n, i) {
      var a = this.ecModel, o = lw.prototype.getColorFromPalette.call(this, e, n, i);
      return o || (o = a.getColorFromPalette(e, n, i)), o;
    }, r.prototype.coordDimToDataDim = function(e) {
      return this.getRawData().mapDimensionsAll(e);
    }, r.prototype.getProgressive = function() {
      return this.get("progressive");
    }, r.prototype.getProgressiveThreshold = function() {
      return this.get("progressiveThreshold");
    }, r.prototype.select = function(e, n) {
      this._innerSelect(this.getData(n), e);
    }, r.prototype.unselect = function(e, n) {
      var i = this.option.selectedMap;
      if (i) {
        var a = this.option.selectedMode, o = this.getData(n);
        if (a === "series" || i === "all") {
          this.option.selectedMap = {}, this._selectedDataIndicesMap = {};
          return;
        }
        for (var s = 0; s < e.length; s++) {
          var l = e[s], u = m1(o, l);
          i[u] = !1, this._selectedDataIndicesMap[u] = -1;
        }
      }
    }, r.prototype.toggleSelect = function(e, n) {
      for (var i = [], a = 0; a < e.length; a++)
        i[0] = e[a], this.isSelected(e[a], n) ? this.unselect(i, n) : this.select(i, n);
    }, r.prototype.getSelectedDataIndices = function() {
      if (this.option.selectedMap === "all")
        return [].slice.call(this.getData().getIndices());
      for (var e = this._selectedDataIndicesMap, n = yt(e), i = [], a = 0; a < n.length; a++) {
        var o = e[n[a]];
        o >= 0 && i.push(o);
      }
      return i;
    }, r.prototype.isSelected = function(e, n) {
      var i = this.option.selectedMap;
      if (!i)
        return !1;
      var a = this.getData(n);
      return (i === "all" || i[m1(a, e)]) && !a.getItemModel(e).get(["select", "disabled"]);
    }, r.prototype.isUniversalTransitionEnabled = function() {
      if (this[k0])
        return !0;
      var e = this.option.universalTransition;
      return e ? e === !0 ? !0 : e && e.enabled : !1;
    }, r.prototype._innerSelect = function(e, n) {
      var i, a, o = this.option, s = o.selectedMode, l = n.length;
      if (!(!s || !l)) {
        if (s === "series")
          o.selectedMap = "all";
        else if (s === "multiple") {
          Me(o.selectedMap) || (o.selectedMap = {});
          for (var u = o.selectedMap, c = 0; c < l; c++) {
            var d = n[c], f = m1(e, d);
            u[f] = !0, this._selectedDataIndicesMap[f] = e.getRawIndex(d);
          }
        } else if (s === "single" || s === !0) {
          var h = n[l - 1], f = m1(e, h);
          o.selectedMap = (i = {}, i[f] = !0, i), this._selectedDataIndicesMap = (a = {}, a[f] = e.getRawIndex(h), a);
        }
      }
    }, r.prototype._initSelectedMapFromData = function(e) {
      if (!this.option.selectedMap) {
        var n = [];
        e.hasItemOption && e.each(function(i) {
          var a = e.getRawDataItem(i);
          a && a.selected && n.push(i);
        }), n.length > 0 && this._innerSelect(e, n);
      }
    }, r.registerClass = function(e) {
      return st.registerClass(e);
    }, r.protoInitialize = function() {
      var e = r.prototype;
      e.type = "series.__base__", e.seriesIndex = 0, e.ignoreStyleOnData = !1, e.hasSymbolVisual = !1, e.defaultSymbol = "circle", e.visualStyleAccessPath = "itemStyle", e.visualDrawType = "fill";
    }(), r;
  }(st)
);
Xr(tr, C2);
Xr(tr, lw);
RN(tr, st);
function TI(t) {
  var r = t.name;
  k7(t) || (t.name = nq(t) || r);
}
function nq(t) {
  var r = t.getRawData(), e = r.mapDimensionsAll("seriesName"), n = [];
  return L(e, function(i) {
    var a = r.getDimensionInfo(i);
    a.displayName && n.push(a.displayName);
  }), n.join(" ");
}
function iq(t) {
  return t.model.getRawData().count();
}
function aq(t) {
  var r = t.model;
  return r.setData(r.getRawData().cloneShallow()), oq;
}
function oq(t, r) {
  r.outputData && t.end > r.outputData.count() && r.model.getRawData().cloneShallow(r.outputData);
}
function MI(t, r) {
  L(hv(t.CHANGABLE_METHODS, t.DOWNSAMPLE_METHODS), function(e) {
    t.wrapMethod(e, Ye(sq, r));
  });
}
function sq(t, r) {
  var e = o9(t);
  return e && e.setOutputEnd((r || this).count()), r;
}
function o9(t) {
  var r = (t.ecModel || {}).scheduler, e = r && r.getPipeline(t.uid);
  if (e) {
    var n = e.currentTask;
    if (n) {
      var i = n.agentStubMap;
      i && (n = i.get(t.uid));
    }
    return n;
  }
}
var yr = (
  /** @class */
  function() {
    function t() {
      this.group = new ze(), this.uid = sh("viewComponent");
    }
    return t.prototype.init = function(r, e) {
    }, t.prototype.render = function(r, e, n, i) {
    }, t.prototype.dispose = function(r, e) {
    }, t.prototype.updateView = function(r, e, n, i) {
    }, t.prototype.updateLayout = function(r, e, n, i) {
    }, t.prototype.updateVisual = function(r, e, n, i) {
    }, t.prototype.toggleBlurSeries = function(r, e, n) {
    }, t.prototype.eachRendered = function(r) {
      var e = this.group;
      e && e.traverse(r);
    }, t;
  }()
);
N7(yr);
i2(yr);
function ch() {
  var t = It();
  return function(r) {
    var e = t(r), n = r.pipelineContext, i = !!e.large, a = !!e.progressiveRender, o = e.large = !!(n && n.large), s = e.progressiveRender = !!(n && n.progressiveRender);
    return (i !== o || a !== s) && "reset";
  };
}
var aV = It(), lq = ch(), Yt = (
  /** @class */
  function() {
    function t() {
      this.group = new ze(), this.uid = sh("viewChart"), this.renderTask = ev({
        plan: uq,
        reset: cq
      }), this.renderTask.context = {
        view: this
      };
    }
    return t.prototype.init = function(r, e) {
    }, t.prototype.render = function(r, e, n, i) {
      if (process.env.NODE_ENV !== "production")
        throw new Error("render method must been implemented");
    }, t.prototype.highlight = function(r, e, n, i) {
      var a = r.getData(i && i.dataType);
      if (!a) {
        process.env.NODE_ENV !== "production" && jn("Unknown dataType " + i.dataType);
        return;
      }
      LI(a, i, "emphasis");
    }, t.prototype.downplay = function(r, e, n, i) {
      var a = r.getData(i && i.dataType);
      if (!a) {
        process.env.NODE_ENV !== "production" && jn("Unknown dataType " + i.dataType);
        return;
      }
      LI(a, i, "normal");
    }, t.prototype.remove = function(r, e) {
      this.group.removeAll();
    }, t.prototype.dispose = function(r, e) {
    }, t.prototype.updateView = function(r, e, n, i) {
      this.render(r, e, n, i);
    }, t.prototype.updateLayout = function(r, e, n, i) {
      this.render(r, e, n, i);
    }, t.prototype.updateVisual = function(r, e, n, i) {
      this.render(r, e, n, i);
    }, t.prototype.eachRendered = function(r) {
      pu(this.group, r);
    }, t.markUpdateMethod = function(r, e) {
      aV(r).updateMethod = e;
    }, t.protoInitialize = function() {
      var r = t.prototype;
      r.type = "chart";
    }(), t;
  }()
);
function RI(t, r, e) {
  t && eu(t) && (r === "emphasis" ? Xs : $s)(t, e);
}
function LI(t, r, e) {
  var n = Gc(t, r), i = r && r.highlightKey != null ? YU(r.highlightKey) : null;
  n != null ? L(Qt(n), function(a) {
    RI(t.getItemGraphicEl(a), e, i);
  }) : t.eachItemGraphicEl(function(a) {
    RI(a, e, i);
  });
}
N7(Yt, ["dispose"]);
i2(Yt);
function uq(t) {
  return lq(t.model);
}
function cq(t) {
  var r = t.model, e = t.ecModel, n = t.api, i = t.payload, a = r.pipelineContext.progressiveRender, o = t.view, s = i && aV(i).updateMethod, l = a ? "incrementalPrepareRender" : s && o[s] ? s : "render";
  return l !== "render" && o[l](r, e, n, i), dq[l];
}
var dq = {
  incrementalPrepareRender: {
    progress: function(t, r) {
      r.view.incrementalRender(t, r.model, r.ecModel, r.api, r.payload);
    }
  },
  render: {
    // Put view.render in `progress` to support appendData. But in this case
    // view.render should not be called in reset, otherwise it will be called
    // twise. Use `forceFirstProgress` to make sure that view.render is called
    // in any cases.
    forceFirstProgress: !0,
    progress: function(t, r) {
      r.view.render(r.model, r.ecModel, r.api, r.payload);
    }
  }
}, Dm = "\0__throttleOriginMethod", EI = "\0__throttleRate", kI = "\0__throttleType";
function _2(t, r, e) {
  var n, i = 0, a = 0, o = null, s, l, u, c;
  r = r || 0;
  function d() {
    a = (/* @__PURE__ */ new Date()).getTime(), o = null, t.apply(l, u || []);
  }
  var f = function() {
    for (var h = [], p = 0; p < arguments.length; p++)
      h[p] = arguments[p];
    n = (/* @__PURE__ */ new Date()).getTime(), l = this, u = h;
    var v = c || r, g = c || e;
    c = null, s = n - (g ? i : a) - v, clearTimeout(o), g ? o = setTimeout(d, v) : s >= 0 ? d() : o = setTimeout(d, -s), i = n;
  };
  return f.clear = function() {
    o && (clearTimeout(o), o = null);
  }, f.debounceNextCall = function(h) {
    c = h;
  }, f;
}
function dh(t, r, e, n) {
  var i = t[r];
  if (i) {
    var a = i[Dm] || i, o = i[kI], s = i[EI];
    if (s !== e || o !== n) {
      if (e == null || !n)
        return t[r] = a;
      i = t[r] = _2(a, e, n === "debounce"), i[Dm] = a, i[kI] = n, i[EI] = e;
    }
    return i;
  }
}
function Iv(t, r) {
  var e = t[r];
  e && e[Dm] && (e.clear && e.clear(), t[r] = e[Dm]);
}
var PI = It(), NI = {
  itemStyle: Bc(vO, !0),
  lineStyle: Bc(pO, !0)
}, fq = {
  lineStyle: "stroke",
  itemStyle: "fill"
};
function oV(t, r) {
  var e = t.visualStyleMapper || NI[r];
  return e || (console.warn("Unknown style type '" + r + "'."), NI.itemStyle);
}
function sV(t, r) {
  var e = t.visualDrawType || fq[r];
  return e || (console.warn("Unknown style type '" + r + "'."), "fill");
}
var hq = {
  createOnAllSeries: !0,
  performRawSeries: !0,
  reset: function(t, r) {
    var e = t.getData(), n = t.visualStyleAccessPath || "itemStyle", i = t.getModel(n), a = oV(t, n), o = a(i), s = i.getShallow("decal");
    s && (e.setVisual("decal", s), s.dirty = !0);
    var l = sV(t, n), u = o[l], c = Ae(u) ? u : null, d = o.fill === "auto" || o.stroke === "auto";
    if (!o[l] || c || d) {
      var f = t.getColorFromPalette(
        // TODO series count changed.
        t.name,
        null,
        r.getSeriesCount()
      );
      o[l] || (o[l] = f, e.setVisual("colorFromPalette", !0)), o.fill = o.fill === "auto" || Ae(o.fill) ? f : o.fill, o.stroke = o.stroke === "auto" || Ae(o.stroke) ? f : o.stroke;
    }
    if (e.setVisual("style", o), e.setVisual("drawType", l), !r.isSeriesFiltered(t) && c)
      return e.setVisual("colorFromPalette", !1), {
        dataEach: function(h, p) {
          var v = t.getDataParams(p), g = ae({}, o);
          g[l] = c(v), h.setItemVisual(p, "style", g);
        }
      };
  }
}, jh = new Pt(), pq = {
  createOnAllSeries: !0,
  performRawSeries: !0,
  reset: function(t, r) {
    if (!(t.ignoreStyleOnData || r.isSeriesFiltered(t))) {
      var e = t.getData(), n = t.visualStyleAccessPath || "itemStyle", i = oV(t, n), a = e.getVisual("drawType");
      return {
        dataEach: e.hasItemOption ? function(o, s) {
          var l = o.getRawDataItem(s);
          if (l && l[n]) {
            jh.option = l[n];
            var u = i(jh), c = o.ensureUniqueItemVisual(s, "style");
            ae(c, u), jh.option.decal && (o.setItemVisual(s, "decal", jh.option.decal), jh.option.decal.dirty = !0), a in u && o.setItemVisual(s, "colorFromPalette", !1);
          }
        } : null
      };
    }
  }
}, vq = {
  performRawSeries: !0,
  overallReset: function(t) {
    var r = xe();
    t.eachSeries(function(e) {
      var n = e.getColorBy();
      if (!e.isColorBySeries()) {
        var i = e.type + "-" + n, a = r.get(i);
        a || (a = {}, r.set(i, a)), PI(e).scope = a;
      }
    }), t.eachSeries(function(e) {
      if (!(e.isColorBySeries() || t.isSeriesFiltered(e))) {
        var n = e.getRawData(), i = {}, a = e.getData(), o = PI(e).scope, s = e.visualStyleAccessPath || "itemStyle", l = sV(e, s);
        a.each(function(u) {
          var c = a.getRawIndex(u);
          i[c] = u;
        }), n.each(function(u) {
          var c = i[u], d = a.getItemVisual(c, "colorFromPalette");
          if (d) {
            var f = a.ensureUniqueItemVisual(c, "style"), h = n.getName(u) || u + "", p = n.count();
            f[l] = e.getColorFromPalette(h, o, p);
          }
        });
      }
    });
  }
}, y1 = Math.PI;
function gq(t, r) {
  r = r || {}, Ee(r, {
    text: "loading",
    textColor: "#000",
    fontSize: 12,
    fontWeight: "normal",
    fontStyle: "normal",
    fontFamily: "sans-serif",
    maskColor: "rgba(255, 255, 255, 0.8)",
    showSpinner: !0,
    color: "#5470c6",
    spinnerRadius: 10,
    lineWidth: 5,
    zlevel: 0
  });
  var e = new ze(), n = new xt({
    style: {
      fill: r.maskColor
    },
    zlevel: r.zlevel,
    z: 1e4
  });
  e.add(n);
  var i = new _t({
    style: {
      text: r.text,
      fill: r.textColor,
      fontSize: r.fontSize,
      fontWeight: r.fontWeight,
      fontStyle: r.fontStyle,
      fontFamily: r.fontFamily
    },
    zlevel: r.zlevel,
    z: 10001
  }), a = new xt({
    style: {
      fill: "none"
    },
    textContent: i,
    textConfig: {
      position: "right",
      distance: 10
    },
    zlevel: r.zlevel,
    z: 10001
  });
  e.add(a);
  var o;
  return r.showSpinner && (o = new vg({
    shape: {
      startAngle: -y1 / 2,
      endAngle: -y1 / 2 + 0.1,
      r: r.spinnerRadius
    },
    style: {
      stroke: r.color,
      lineCap: "round",
      lineWidth: r.lineWidth
    },
    zlevel: r.zlevel,
    z: 10001
  }), o.animateShape(!0).when(1e3, {
    endAngle: y1 * 3 / 2
  }).start("circularInOut"), o.animateShape(!0).when(1e3, {
    startAngle: y1 * 3 / 2
  }).delay(300).start("circularInOut"), e.add(o)), e.resize = function() {
    var s = i.getBoundingRect().width, l = r.showSpinner ? r.spinnerRadius : 0, u = (t.getWidth() - l * 2 - (r.showSpinner && s ? 10 : 0) - s) / 2 - (r.showSpinner && s ? 0 : 5 + s / 2) + (r.showSpinner ? 0 : s / 2) + (s ? 0 : l), c = t.getHeight() / 2;
    r.showSpinner && o.setShape({
      cx: u,
      cy: c
    }), a.setShape({
      x: u - l,
      y: c - l,
      width: l * 2,
      height: l * 2
    }), n.setShape({
      x: 0,
      y: 0,
      width: t.getWidth(),
      height: t.getHeight()
    });
  }, e.resize(), e;
}
var lV = (
  /** @class */
  function() {
    function t(r, e, n, i) {
      this._stageTaskMap = xe(), this.ecInstance = r, this.api = e, n = this._dataProcessorHandlers = n.slice(), i = this._visualHandlers = i.slice(), this._allHandlers = n.concat(i);
    }
    return t.prototype.restoreData = function(r, e) {
      r.restoreData(e), this._stageTaskMap.each(function(n) {
        var i = n.overallTask;
        i && i.dirty();
      });
    }, t.prototype.getPerformArgs = function(r, e) {
      if (r.__pipeline) {
        var n = this._pipelineMap.get(r.__pipeline.id), i = n.context, a = !e && n.progressiveEnabled && (!i || i.progressiveRender) && r.__idxInPipeline > n.blockIndex, o = a ? n.step : null, s = i && i.modDataCount, l = s != null ? Math.ceil(s / o) : null;
        return {
          step: o,
          modBy: l,
          modDataCount: s
        };
      }
    }, t.prototype.getPipeline = function(r) {
      return this._pipelineMap.get(r);
    }, t.prototype.updateStreamModes = function(r, e) {
      var n = this._pipelineMap.get(r.uid), i = r.getData(), a = i.count(), o = n.progressiveEnabled && e.incrementalPrepareRender && a >= n.threshold, s = r.get("large") && a >= r.get("largeThreshold"), l = r.get("progressiveChunkMode") === "mod" ? a : null;
      r.pipelineContext = n.context = {
        progressiveRender: o,
        modDataCount: l,
        large: s
      };
    }, t.prototype.restorePipelines = function(r) {
      var e = this, n = e._pipelineMap = xe();
      r.eachSeries(function(i) {
        var a = i.getProgressive(), o = i.uid;
        n.set(o, {
          id: o,
          head: null,
          tail: null,
          threshold: i.getProgressiveThreshold(),
          progressiveEnabled: a && !(i.preventIncremental && i.preventIncremental()),
          blockIndex: -1,
          step: Math.round(a || 700),
          count: 0
        }), e._pipe(i, i.dataTask);
      });
    }, t.prototype.prepareStageTasks = function() {
      var r = this._stageTaskMap, e = this.api.getModel(), n = this.api;
      L(this._allHandlers, function(i) {
        var a = r.get(i.uid) || r.set(i.uid, {}), o = "";
        process.env.NODE_ENV !== "production" && (o = '"reset" and "overallReset" must not be both specified.'), ke(!(i.reset && i.overallReset), o), i.reset && this._createSeriesStageTask(i, a, e, n), i.overallReset && this._createOverallStageTask(i, a, e, n);
      }, this);
    }, t.prototype.prepareView = function(r, e, n, i) {
      var a = r.renderTask, o = a.context;
      o.model = e, o.ecModel = n, o.api = i, a.__block = !r.incrementalPrepareRender, this._pipe(e, a);
    }, t.prototype.performDataProcessorTasks = function(r, e) {
      this._performStageTasks(this._dataProcessorHandlers, r, e, {
        block: !0
      });
    }, t.prototype.performVisualTasks = function(r, e, n) {
      this._performStageTasks(this._visualHandlers, r, e, n);
    }, t.prototype._performStageTasks = function(r, e, n, i) {
      i = i || {};
      var a = !1, o = this;
      L(r, function(l, u) {
        if (!(i.visualType && i.visualType !== l.visualType)) {
          var c = o._stageTaskMap.get(l.uid), d = c.seriesTaskMap, f = c.overallTask;
          if (f) {
            var h, p = f.agentStubMap;
            p.each(function(g) {
              s(i, g) && (g.dirty(), h = !0);
            }), h && f.dirty(), o.updatePayload(f, n);
            var v = o.getPerformArgs(f, i.block);
            p.each(function(g) {
              g.perform(v);
            }), f.perform(v) && (a = !0);
          } else d && d.each(function(g, m) {
            s(i, g) && g.dirty();
            var y = o.getPerformArgs(g, i.block);
            y.skip = !l.performRawSeries && e.isSeriesFiltered(g.context.model), o.updatePayload(g, n), g.perform(y) && (a = !0);
          });
        }
      });
      function s(l, u) {
        return l.setDirty && (!l.dirtyMap || l.dirtyMap.get(u.__pipeline.id));
      }
      this.unfinished = a || this.unfinished;
    }, t.prototype.performSeriesTasks = function(r) {
      var e;
      r.eachSeries(function(n) {
        e = n.dataTask.perform() || e;
      }), this.unfinished = e || this.unfinished;
    }, t.prototype.plan = function() {
      this._pipelineMap.each(function(r) {
        var e = r.tail;
        do {
          if (e.__block) {
            r.blockIndex = e.__idxInPipeline;
            break;
          }
          e = e.getUpstream();
        } while (e);
      });
    }, t.prototype.updatePayload = function(r, e) {
      e !== "remain" && (r.context.payload = e);
    }, t.prototype._createSeriesStageTask = function(r, e, n, i) {
      var a = this, o = e.seriesTaskMap, s = e.seriesTaskMap = xe(), l = r.seriesType, u = r.getTargetSeries;
      r.createOnAllSeries ? n.eachRawSeries(c) : l ? n.eachRawSeriesByType(l, c) : u && u(n, i).each(c);
      function c(d) {
        var f = d.uid, h = s.set(f, o && o.get(f) || ev({
          plan: wq,
          reset: _q,
          count: Sq
        }));
        h.context = {
          model: d,
          ecModel: n,
          api: i,
          // PENDING: `useClearVisual` not used?
          useClearVisual: r.isVisual && !r.isLayout,
          plan: r.plan,
          reset: r.reset,
          scheduler: a
        }, a._pipe(d, h);
      }
    }, t.prototype._createOverallStageTask = function(r, e, n, i) {
      var a = this, o = e.overallTask = e.overallTask || ev({
        reset: mq
      });
      o.context = {
        ecModel: n,
        api: i,
        overallReset: r.overallReset,
        scheduler: a
      };
      var s = o.agentStubMap, l = o.agentStubMap = xe(), u = r.seriesType, c = r.getTargetSeries, d = !0, f = !1, h = "";
      process.env.NODE_ENV !== "production" && (h = '"createOnAllSeries" is not supported for "overallReset", because it will block all streams.'), ke(!r.createOnAllSeries, h), u ? n.eachRawSeriesByType(u, p) : c ? c(n, i).each(p) : (d = !1, L(n.getSeries(), p));
      function p(v) {
        var g = v.uid, m = l.set(g, s && s.get(g) || // When the result of `getTargetSeries` changed, the overallTask
        // should be set as dirty and re-performed.
        (f = !0, ev({
          reset: yq,
          onDirty: Cq
        })));
        m.context = {
          model: v,
          overallProgress: d
          // FIXME:TS never used, so comment it
          // modifyOutputEnd: modifyOutputEnd
        }, m.agent = o, m.__block = d, a._pipe(v, m);
      }
      f && o.dirty();
    }, t.prototype._pipe = function(r, e) {
      var n = r.uid, i = this._pipelineMap.get(n);
      !i.head && (i.head = e), i.tail && i.tail.pipe(e), i.tail = e, e.__idxInPipeline = i.count++, e.__pipeline = i;
    }, t.wrapStageHandler = function(r, e) {
      return Ae(r) && (r = {
        overallReset: r,
        seriesType: Iq(r)
      }), r.uid = sh("stageHandler"), e && (r.visualType = e), r;
    }, t;
  }()
);
function mq(t) {
  t.overallReset(t.ecModel, t.api, t.payload);
}
function yq(t) {
  return t.overallProgress && bq;
}
function bq() {
  this.agent.dirty(), this.getDownstream().dirty();
}
function Cq() {
  this.agent && this.agent.dirty();
}
function wq(t) {
  return t.plan ? t.plan(t.model, t.ecModel, t.api, t.payload) : null;
}
function _q(t) {
  t.useClearVisual && t.data.clearAllVisual();
  var r = t.resetDefines = Qt(t.reset(t.model, t.ecModel, t.api, t.payload));
  return r.length > 1 ? ce(r, function(e, n) {
    return uV(n);
  }) : xq;
}
var xq = uV(0);
function uV(t) {
  return function(r, e) {
    var n = e.data, i = e.resetDefines[t];
    if (i && i.dataEach)
      for (var a = r.start; a < r.end; a++)
        i.dataEach(n, a);
    else i && i.progress && i.progress(r, n);
  };
}
function Sq(t) {
  return t.data.count();
}
function Iq(t) {
  Tm = null;
  try {
    t(Av, cV);
  } catch {
  }
  return Tm;
}
var Av = {}, cV = {}, Tm;
dV(Av, uw);
dV(cV, NO);
Av.eachSeriesByType = Av.eachRawSeriesByType = function(t) {
  Tm = t;
};
Av.eachComponent = function(t) {
  t.mainType === "series" && t.subType && (Tm = t.subType);
};
function dV(t, r) {
  for (var e in r.prototype)
    t[e] = Yr;
}
var OI = ["#37A2DA", "#32C5E9", "#67E0E3", "#9FE6B8", "#FFDB5C", "#ff9f7f", "#fb7293", "#E062AE", "#E690D1", "#e7bcf3", "#9d96f5", "#8378EA", "#96BFFF"];
const Aq = {
  color: OI,
  colorLayer: [["#37A2DA", "#ffd85c", "#fd7b5f"], ["#37A2DA", "#67E0E3", "#FFDB5C", "#ff9f7f", "#E062AE", "#9d96f5"], ["#37A2DA", "#32C5E9", "#9FE6B8", "#FFDB5C", "#ff9f7f", "#fb7293", "#e7bcf3", "#8378EA", "#96BFFF"], OI]
};
var pi = "#B9B8CE", VI = "#100C2A", b1 = function() {
  return {
    axisLine: {
      lineStyle: {
        color: pi
      }
    },
    splitLine: {
      lineStyle: {
        color: "#484753"
      }
    },
    splitArea: {
      areaStyle: {
        color: ["rgba(255,255,255,0.02)", "rgba(255,255,255,0.05)"]
      }
    },
    minorSplitLine: {
      lineStyle: {
        color: "#20203B"
      }
    }
  };
}, GI = ["#4992ff", "#7cffb2", "#fddd60", "#ff6e76", "#58d9f9", "#05c091", "#ff8a45", "#8d48e3", "#dd79ff"], fV = {
  darkMode: !0,
  color: GI,
  backgroundColor: VI,
  axisPointer: {
    lineStyle: {
      color: "#817f91"
    },
    crossStyle: {
      color: "#817f91"
    },
    label: {
      // TODO Contrast of label backgorundColor
      color: "#fff"
    }
  },
  legend: {
    textStyle: {
      color: pi
    }
  },
  textStyle: {
    color: pi
  },
  title: {
    textStyle: {
      color: "#EEF1FA"
    },
    subtextStyle: {
      color: "#B9B8CE"
    }
  },
  toolbox: {
    iconStyle: {
      borderColor: pi
    }
  },
  dataZoom: {
    borderColor: "#71708A",
    textStyle: {
      color: pi
    },
    brushStyle: {
      color: "rgba(135,163,206,0.3)"
    },
    handleStyle: {
      color: "#353450",
      borderColor: "#C5CBE3"
    },
    moveHandleStyle: {
      color: "#B0B6C3",
      opacity: 0.3
    },
    fillerColor: "rgba(135,163,206,0.2)",
    emphasis: {
      handleStyle: {
        borderColor: "#91B7F2",
        color: "#4D587D"
      },
      moveHandleStyle: {
        color: "#636D9A",
        opacity: 0.7
      }
    },
    dataBackground: {
      lineStyle: {
        color: "#71708A",
        width: 1
      },
      areaStyle: {
        color: "#71708A"
      }
    },
    selectedDataBackground: {
      lineStyle: {
        color: "#87A3CE"
      },
      areaStyle: {
        color: "#87A3CE"
      }
    }
  },
  visualMap: {
    textStyle: {
      color: pi
    }
  },
  timeline: {
    lineStyle: {
      color: pi
    },
    label: {
      color: pi
    },
    controlStyle: {
      color: pi,
      borderColor: pi
    }
  },
  calendar: {
    itemStyle: {
      color: VI
    },
    dayLabel: {
      color: pi
    },
    monthLabel: {
      color: pi
    },
    yearLabel: {
      color: pi
    }
  },
  timeAxis: b1(),
  logAxis: b1(),
  valueAxis: b1(),
  categoryAxis: b1(),
  line: {
    symbol: "circle"
  },
  graph: {
    color: GI
  },
  gauge: {
    title: {
      color: pi
    },
    axisLine: {
      lineStyle: {
        color: [[1, "rgba(207,212,219,0.2)"]]
      }
    },
    axisLabel: {
      color: pi
    },
    detail: {
      color: "#EEF1FA"
    }
  },
  candlestick: {
    itemStyle: {
      color: "#f64e56",
      color0: "#54ea92",
      borderColor: "#f64e56",
      borderColor0: "#54ea92"
      // borderColor: '#ca2824',
      // borderColor0: '#09a443'
    }
  }
};
fV.categoryAxis.splitLine.show = !1;
var Dq = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.normalizeQuery = function(r) {
      var e = {}, n = {}, i = {};
      if (pe(r)) {
        var a = No(r);
        e.mainType = a.main || null, e.subType = a.sub || null;
      } else {
        var o = ["Index", "Name", "Id"], s = {
          name: 1,
          dataIndex: 1,
          dataType: 1
        };
        L(r, function(l, u) {
          for (var c = !1, d = 0; d < o.length; d++) {
            var f = o[d], h = u.lastIndexOf(f);
            if (h > 0 && h === u.length - f.length) {
              var p = u.slice(0, h);
              p !== "data" && (e.mainType = p, e[f.toLowerCase()] = l, c = !0);
            }
          }
          s.hasOwnProperty(u) && (n[u] = l, c = !0), c || (i[u] = l);
        });
      }
      return {
        cptQuery: e,
        dataQuery: n,
        otherQuery: i
      };
    }, t.prototype.filter = function(r, e) {
      var n = this.eventInfo;
      if (!n)
        return !0;
      var i = n.targetEl, a = n.packedEvent, o = n.model, s = n.view;
      if (!o || !s)
        return !0;
      var l = e.cptQuery, u = e.dataQuery;
      return c(l, o, "mainType") && c(l, o, "subType") && c(l, o, "index", "componentIndex") && c(l, o, "name") && c(l, o, "id") && c(u, a, "name") && c(u, a, "dataIndex") && c(u, a, "dataType") && (!s.filterForExposedEvent || s.filterForExposedEvent(r, e.otherQuery, i, a));
      function c(d, f, h, p) {
        return d[h] == null || f[p || h] === d[h];
      }
    }, t.prototype.afterTrigger = function() {
      this.eventInfo = null;
    }, t;
  }()
), s9 = ["symbol", "symbolSize", "symbolRotate", "symbolOffset"], BI = s9.concat(["symbolKeepAspect"]), Tq = {
  createOnAllSeries: !0,
  // For legend.
  performRawSeries: !0,
  reset: function(t, r) {
    var e = t.getData();
    if (t.legendIcon && e.setVisual("legendIcon", t.legendIcon), !t.hasSymbolVisual)
      return;
    for (var n = {}, i = {}, a = !1, o = 0; o < s9.length; o++) {
      var s = s9[o], l = t.get(s);
      Ae(l) ? (a = !0, i[s] = l) : n[s] = l;
    }
    if (n.symbol = n.symbol || t.defaultSymbol, e.setVisual(ae({
      legendIcon: t.legendIcon || n.symbol,
      symbolKeepAspect: t.get("symbolKeepAspect")
    }, n)), r.isSeriesFiltered(t))
      return;
    var u = yt(i);
    function c(d, f) {
      for (var h = t.getRawValue(f), p = t.getDataParams(f), v = 0; v < u.length; v++) {
        var g = u[v];
        d.setItemVisual(f, g, i[g](h, p));
      }
    }
    return {
      dataEach: a ? c : null
    };
  }
}, Mq = {
  createOnAllSeries: !0,
  // For legend.
  performRawSeries: !0,
  reset: function(t, r) {
    if (!t.hasSymbolVisual || r.isSeriesFiltered(t))
      return;
    var e = t.getData();
    function n(i, a) {
      for (var o = i.getItemModel(a), s = 0; s < BI.length; s++) {
        var l = BI[s], u = o.getShallow(l, !0);
        u != null && i.setItemVisual(a, l, u);
      }
    }
    return {
      dataEach: e.hasItemOption ? n : null
    };
  }
};
function pw(t, r, e) {
  switch (e) {
    case "color":
      var n = t.getItemVisual(r, "style");
      return n[t.getVisual("drawType")];
    case "opacity":
      return t.getItemVisual(r, "style").opacity;
    case "symbol":
    case "symbolSize":
    case "liftZ":
      return t.getItemVisual(r, e);
    default:
      process.env.NODE_ENV !== "production" && console.warn("Unknown visual type " + e);
  }
}
function bg(t, r) {
  switch (r) {
    case "color":
      var e = t.getVisual("style");
      return e[t.getVisual("drawType")];
    case "opacity":
      return t.getVisual("style").opacity;
    case "symbol":
    case "symbolSize":
    case "liftZ":
      return t.getVisual(r);
    default:
      process.env.NODE_ENV !== "production" && console.warn("Unknown visual type " + r);
  }
}
function hV(t, r, e, n) {
  switch (e) {
    case "color":
      var i = t.ensureUniqueItemVisual(r, "style");
      i[t.getVisual("drawType")] = n, t.setItemVisual(r, "colorFromPalette", !1);
      break;
    case "opacity":
      t.ensureUniqueItemVisual(r, "style").opacity = n;
      break;
    case "symbol":
    case "symbolSize":
    case "liftZ":
      t.setItemVisual(r, e, n);
      break;
    default:
      process.env.NODE_ENV !== "production" && console.warn("Unknown visual type " + e);
  }
}
function pV(t, r) {
  function e(n, i) {
    var a = [];
    return n.eachComponent({
      mainType: "series",
      subType: t,
      query: i
    }, function(o) {
      a.push(o.seriesIndex);
    }), a;
  }
  L([[t + "ToggleSelect", "toggleSelect"], [t + "Select", "select"], [t + "UnSelect", "unselect"]], function(n) {
    r(n[0], function(i, a, o) {
      i = ae({}, i), process.env.NODE_ENV !== "production" && qr(i.type, n[1]), o.dispatchAction(ae(i, {
        type: n[1],
        seriesIndex: e(a, i)
      }));
    });
  });
}
function wd(t, r, e, n, i) {
  var a = t + r;
  e.isSilent(a) || (process.env.NODE_ENV !== "production" && Ra("event " + a + " is deprecated."), n.eachComponent({
    mainType: "series",
    subType: "pie"
  }, function(o) {
    for (var s = o.seriesIndex, l = o.option.selectedMap, u = i.selected, c = 0; c < u.length; c++)
      if (u[c].seriesIndex === s) {
        var d = o.getData(), f = Gc(d, i.fromActionPayload);
        e.trigger(a, {
          type: a,
          seriesId: o.id,
          name: ue(f) ? d.getName(f[0]) : d.getName(f),
          selected: pe(l) ? l : ae({}, l)
        });
      }
  }));
}
function Rq(t, r, e) {
  t.on("selectchanged", function(n) {
    var i = e.getModel();
    n.isFromClick ? (wd("map", "selectchanged", r, i, n), wd("pie", "selectchanged", r, i, n)) : n.fromAction === "select" ? (wd("map", "selected", r, i, n), wd("pie", "selected", r, i, n)) : n.fromAction === "unselect" && (wd("map", "unselected", r, i, n), wd("pie", "unselected", r, i, n));
  });
}
function hc(t, r, e) {
  for (var n; t && !(r(t) && (n = t, e)); )
    t = t.__hostTarget || t.parent;
  return n;
}
var Lq = Math.round(Math.random() * 9), Eq = typeof Object.defineProperty == "function", kq = function() {
  function t() {
    this._id = "__ec_inner_" + Lq++;
  }
  return t.prototype.get = function(r) {
    return this._guard(r)[this._id];
  }, t.prototype.set = function(r, e) {
    var n = this._guard(r);
    return Eq ? Object.defineProperty(n, this._id, {
      value: e,
      enumerable: !1,
      configurable: !0
    }) : n[this._id] = e, this;
  }, t.prototype.delete = function(r) {
    return this.has(r) ? (delete this._guard(r)[this._id], !0) : !1;
  }, t.prototype.has = function(r) {
    return !!this._guard(r)[this._id];
  }, t.prototype._guard = function(r) {
    if (r !== Object(r))
      throw TypeError("Value of WeakMap is not a non-null object.");
    return r;
  }, t;
}(), Pq = gt.extend({
  type: "triangle",
  shape: {
    cx: 0,
    cy: 0,
    width: 0,
    height: 0
  },
  buildPath: function(t, r) {
    var e = r.cx, n = r.cy, i = r.width / 2, a = r.height / 2;
    t.moveTo(e, n - a), t.lineTo(e + i, n + a), t.lineTo(e - i, n + a), t.closePath();
  }
}), Nq = gt.extend({
  type: "diamond",
  shape: {
    cx: 0,
    cy: 0,
    width: 0,
    height: 0
  },
  buildPath: function(t, r) {
    var e = r.cx, n = r.cy, i = r.width / 2, a = r.height / 2;
    t.moveTo(e, n - a), t.lineTo(e + i, n), t.lineTo(e, n + a), t.lineTo(e - i, n), t.closePath();
  }
}), Oq = gt.extend({
  type: "pin",
  shape: {
    // x, y on the cusp
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  buildPath: function(t, r) {
    var e = r.x, n = r.y, i = r.width / 5 * 3, a = Math.max(i, r.height), o = i / 2, s = o * o / (a - o), l = n - a + o + s, u = Math.asin(s / o), c = Math.cos(u) * o, d = Math.sin(u), f = Math.cos(u), h = o * 0.6, p = o * 0.7;
    t.moveTo(e - c, l + s), t.arc(e, l, o, Math.PI - u, Math.PI * 2 + u), t.bezierCurveTo(e + c - d * h, l + s + f * h, e, n - p, e, n), t.bezierCurveTo(e, n - p, e - c + d * h, l + s + f * h, e - c, l + s), t.closePath();
  }
}), Vq = gt.extend({
  type: "arrow",
  shape: {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  buildPath: function(t, r) {
    var e = r.height, n = r.width, i = r.x, a = r.y, o = n / 3 * 2;
    t.moveTo(i, a), t.lineTo(i + o, a + e), t.lineTo(i, a + e / 4 * 3), t.lineTo(i - o, a + e), t.lineTo(i, a), t.closePath();
  }
}), Gq = {
  line: gn,
  rect: xt,
  roundRect: xt,
  square: xt,
  circle: is,
  diamond: Nq,
  pin: Oq,
  arrow: Vq,
  triangle: Pq
}, Bq = {
  line: function(t, r, e, n, i) {
    i.x1 = t, i.y1 = r + n / 2, i.x2 = t + e, i.y2 = r + n / 2;
  },
  rect: function(t, r, e, n, i) {
    i.x = t, i.y = r, i.width = e, i.height = n;
  },
  roundRect: function(t, r, e, n, i) {
    i.x = t, i.y = r, i.width = e, i.height = n, i.r = Math.min(e, n) / 4;
  },
  square: function(t, r, e, n, i) {
    var a = Math.min(e, n);
    i.x = t, i.y = r, i.width = a, i.height = a;
  },
  circle: function(t, r, e, n, i) {
    i.cx = t + e / 2, i.cy = r + n / 2, i.r = Math.min(e, n) / 2;
  },
  diamond: function(t, r, e, n, i) {
    i.cx = t + e / 2, i.cy = r + n / 2, i.width = e, i.height = n;
  },
  pin: function(t, r, e, n, i) {
    i.x = t + e / 2, i.y = r + n / 2, i.width = e, i.height = n;
  },
  arrow: function(t, r, e, n, i) {
    i.x = t + e / 2, i.y = r + n / 2, i.width = e, i.height = n;
  },
  triangle: function(t, r, e, n, i) {
    i.cx = t + e / 2, i.cy = r + n / 2, i.width = e, i.height = n;
  }
}, Mm = {};
L(Gq, function(t, r) {
  Mm[r] = new t();
});
var Fq = gt.extend({
  type: "symbol",
  shape: {
    symbolType: "",
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  calculateTextPosition: function(t, r, e) {
    var n = gm(t, r, e), i = this.shape;
    return i && i.symbolType === "pin" && r.position === "inside" && (n.y = e.y + e.height * 0.4), n;
  },
  buildPath: function(t, r, e) {
    var n = r.symbolType;
    if (n !== "none") {
      var i = Mm[n];
      i || (n = "rect", i = Mm[n]), Bq[n](r.x, r.y, r.width, r.height, i.shape), i.buildPath(t, i.shape, e);
    }
  }
});
function Hq(t, r) {
  if (this.type !== "image") {
    var e = this.style;
    this.__isEmptyBrush ? (e.stroke = t, e.fill = r || "#fff", e.lineWidth = 2) : this.shape.symbolType === "line" ? e.stroke = t : e.fill = t, this.markRedraw();
  }
}
function en(t, r, e, n, i, a, o) {
  var s = t.indexOf("empty") === 0;
  s && (t = t.substr(5, 1).toLowerCase() + t.substr(6));
  var l;
  return t.indexOf("image://") === 0 ? l = Y7(t.slice(8), new rt(r, e, n, i), o ? "center" : "cover") : t.indexOf("path://") === 0 ? l = gg(t.slice(7), {}, new rt(r, e, n, i), o ? "center" : "cover") : l = new Fq({
    shape: {
      symbolType: t,
      x: r,
      y: e,
      width: n,
      height: i
    }
  }), l.__isEmptyBrush = s, l.setColor = Hq, a && l.setColor(a), l;
}
function fh(t) {
  return ue(t) || (t = [+t, +t]), [t[0] || 0, t[1] || 0];
}
function td(t, r) {
  if (t != null)
    return ue(t) || (t = [t, t]), [he(t[0], r[0]) || 0, he(je(t[1], t[0]), r[1]) || 0];
}
function pc(t) {
  return isFinite(t);
}
function zq(t, r, e) {
  var n = r.x == null ? 0 : r.x, i = r.x2 == null ? 1 : r.x2, a = r.y == null ? 0 : r.y, o = r.y2 == null ? 0 : r.y2;
  r.global || (n = n * e.width + e.x, i = i * e.width + e.x, a = a * e.height + e.y, o = o * e.height + e.y), n = pc(n) ? n : 0, i = pc(i) ? i : 1, a = pc(a) ? a : 0, o = pc(o) ? o : 0;
  var s = t.createLinearGradient(n, a, i, o);
  return s;
}
function Wq(t, r, e) {
  var n = e.width, i = e.height, a = Math.min(n, i), o = r.x == null ? 0.5 : r.x, s = r.y == null ? 0.5 : r.y, l = r.r == null ? 0.5 : r.r;
  r.global || (o = o * n + e.x, s = s * i + e.y, l = l * a), o = pc(o) ? o : 0.5, s = pc(s) ? s : 0.5, l = l >= 0 && pc(l) ? l : 0.5;
  var u = t.createRadialGradient(o, s, 0, o, s, l);
  return u;
}
function l9(t, r, e) {
  for (var n = r.type === "radial" ? Wq(t, r, e) : zq(t, r, e), i = r.colorStops, a = 0; a < i.length; a++)
    n.addColorStop(i[a].offset, i[a].color);
  return n;
}
function Zq(t, r) {
  if (t === r || !t && !r)
    return !1;
  if (!t || !r || t.length !== r.length)
    return !0;
  for (var e = 0; e < t.length; e++)
    if (t[e] !== r[e])
      return !0;
  return !1;
}
function C1(t) {
  return parseInt(t, 10);
}
function Kd(t, r, e) {
  var n = ["width", "height"][r], i = ["clientWidth", "clientHeight"][r], a = ["paddingLeft", "paddingTop"][r], o = ["paddingRight", "paddingBottom"][r];
  if (e[n] != null && e[n] !== "auto")
    return parseFloat(e[n]);
  var s = document.defaultView.getComputedStyle(t);
  return (t[i] || C1(s[n]) || C1(t.style[n])) - (C1(s[a]) || 0) - (C1(s[o]) || 0) | 0;
}
function jq(t, r) {
  return !t || t === "solid" || !(r > 0) ? null : t === "dashed" ? [4 * r, 2 * r] : t === "dotted" ? [r] : Mt(t) ? [t] : ue(t) ? t : null;
}
function vw(t) {
  var r = t.style, e = r.lineDash && r.lineWidth > 0 && jq(r.lineDash, r.lineWidth), n = r.lineDashOffset;
  if (e) {
    var i = r.strokeNoScale && t.getLineScale ? t.getLineScale() : 1;
    i && i !== 1 && (e = ce(e, function(a) {
      return a / i;
    }), n /= i);
  }
  return [e, n];
}
var Yq = new Qo(!0);
function Rm(t) {
  var r = t.stroke;
  return !(r == null || r === "none" || !(t.lineWidth > 0));
}
function FI(t) {
  return typeof t == "string" && t !== "none";
}
function Lm(t) {
  var r = t.fill;
  return r != null && r !== "none";
}
function HI(t, r) {
  if (r.fillOpacity != null && r.fillOpacity !== 1) {
    var e = t.globalAlpha;
    t.globalAlpha = r.fillOpacity * r.opacity, t.fill(), t.globalAlpha = e;
  } else
    t.fill();
}
function zI(t, r) {
  if (r.strokeOpacity != null && r.strokeOpacity !== 1) {
    var e = t.globalAlpha;
    t.globalAlpha = r.strokeOpacity * r.opacity, t.stroke(), t.globalAlpha = e;
  } else
    t.stroke();
}
function u9(t, r, e) {
  var n = O7(r.image, r.__image, e);
  if (a2(n)) {
    var i = t.createPattern(n, r.repeat || "repeat");
    if (typeof DOMMatrix == "function" && i && i.setTransform) {
      var a = new DOMMatrix();
      a.translateSelf(r.x || 0, r.y || 0), a.rotateSelf(0, 0, (r.rotation || 0) * zp), a.scaleSelf(r.scaleX || 1, r.scaleY || 1), i.setTransform(a);
    }
    return i;
  }
}
function Xq(t, r, e, n) {
  var i, a = Rm(e), o = Lm(e), s = e.strokePercent, l = s < 1, u = !r.path;
  (!r.silent || l) && u && r.createPathProxy();
  var c = r.path || Yq, d = r.__dirty;
  if (!n) {
    var f = e.fill, h = e.stroke, p = o && !!f.colorStops, v = a && !!h.colorStops, g = o && !!f.image, m = a && !!h.image, y = void 0, b = void 0, C = void 0, w = void 0, _ = void 0;
    (p || v) && (_ = r.getBoundingRect()), p && (y = d ? l9(t, f, _) : r.__canvasFillGradient, r.__canvasFillGradient = y), v && (b = d ? l9(t, h, _) : r.__canvasStrokeGradient, r.__canvasStrokeGradient = b), g && (C = d || !r.__canvasFillPattern ? u9(t, f, r) : r.__canvasFillPattern, r.__canvasFillPattern = C), m && (w = d || !r.__canvasStrokePattern ? u9(t, h, r) : r.__canvasStrokePattern, r.__canvasStrokePattern = C), p ? t.fillStyle = y : g && (C ? t.fillStyle = C : o = !1), v ? t.strokeStyle = b : m && (w ? t.strokeStyle = w : a = !1);
  }
  var x = r.getGlobalScale();
  c.setScale(x[0], x[1], r.segmentIgnoreThreshold);
  var I, D;
  t.setLineDash && e.lineDash && (i = vw(r), I = i[0], D = i[1]);
  var T = !0;
  (u || d & zd) && (c.setDPR(t.dpr), l ? c.setContext(null) : (c.setContext(t), T = !1), c.reset(), r.buildPath(c, r.shape, n), c.toStatic(), r.pathUpdated()), T && c.rebuildPath(t, l ? s : 1), I && (t.setLineDash(I), t.lineDashOffset = D), n || (e.strokeFirst ? (a && zI(t, e), o && HI(t, e)) : (o && HI(t, e), a && zI(t, e))), I && t.setLineDash([]);
}
function $q(t, r, e) {
  var n = r.__image = O7(e.image, r.__image, r, r.onload);
  if (!(!n || !a2(n))) {
    var i = e.x || 0, a = e.y || 0, o = r.getWidth(), s = r.getHeight(), l = n.width / n.height;
    if (o == null && s != null ? o = s * l : s == null && o != null ? s = o / l : o == null && s == null && (o = n.width, s = n.height), e.sWidth && e.sHeight) {
      var u = e.sx || 0, c = e.sy || 0;
      t.drawImage(n, u, c, e.sWidth, e.sHeight, i, a, o, s);
    } else if (e.sx && e.sy) {
      var u = e.sx, c = e.sy, d = o - u, f = s - c;
      t.drawImage(n, u, c, d, f, i, a, o, s);
    } else
      t.drawImage(n, i, a, o, s);
  }
}
function Uq(t, r, e) {
  var n, i = e.text;
  if (i != null && (i += ""), i) {
    t.font = e.font || Jl, t.textAlign = e.textAlign, t.textBaseline = e.textBaseline;
    var a = void 0, o = void 0;
    t.setLineDash && e.lineDash && (n = vw(r), a = n[0], o = n[1]), a && (t.setLineDash(a), t.lineDashOffset = o), e.strokeFirst ? (Rm(e) && t.strokeText(i, e.x, e.y), Lm(e) && t.fillText(i, e.x, e.y)) : (Lm(e) && t.fillText(i, e.x, e.y), Rm(e) && t.strokeText(i, e.x, e.y)), a && t.setLineDash([]);
  }
}
var WI = ["shadowBlur", "shadowOffsetX", "shadowOffsetY"], ZI = [
  ["lineCap", "butt"],
  ["lineJoin", "miter"],
  ["miterLimit", 10]
];
function vV(t, r, e, n, i) {
  var a = !1;
  if (!n && (e = e || {}, r === e))
    return !1;
  if (n || r.opacity !== e.opacity) {
    Pi(t, i), a = !0;
    var o = Math.max(Math.min(r.opacity, 1), 0);
    t.globalAlpha = isNaN(o) ? xc.opacity : o;
  }
  (n || r.blend !== e.blend) && (a || (Pi(t, i), a = !0), t.globalCompositeOperation = r.blend || xc.blend);
  for (var s = 0; s < WI.length; s++) {
    var l = WI[s];
    (n || r[l] !== e[l]) && (a || (Pi(t, i), a = !0), t[l] = t.dpr * (r[l] || 0));
  }
  return (n || r.shadowColor !== e.shadowColor) && (a || (Pi(t, i), a = !0), t.shadowColor = r.shadowColor || xc.shadowColor), a;
}
function jI(t, r, e, n, i) {
  var a = Dv(r, i.inHover), o = n ? null : e && Dv(e, i.inHover) || {};
  if (a === o)
    return !1;
  var s = vV(t, a, o, n, i);
  if ((n || a.fill !== o.fill) && (s || (Pi(t, i), s = !0), FI(a.fill) && (t.fillStyle = a.fill)), (n || a.stroke !== o.stroke) && (s || (Pi(t, i), s = !0), FI(a.stroke) && (t.strokeStyle = a.stroke)), (n || a.opacity !== o.opacity) && (s || (Pi(t, i), s = !0), t.globalAlpha = a.opacity == null ? 1 : a.opacity), r.hasStroke()) {
    var l = a.lineWidth, u = l / (a.strokeNoScale && r.getLineScale ? r.getLineScale() : 1);
    t.lineWidth !== u && (s || (Pi(t, i), s = !0), t.lineWidth = u);
  }
  for (var c = 0; c < ZI.length; c++) {
    var d = ZI[c], f = d[0];
    (n || a[f] !== o[f]) && (s || (Pi(t, i), s = !0), t[f] = a[f] || d[1]);
  }
  return s;
}
function Jq(t, r, e, n, i) {
  return vV(t, Dv(r, i.inHover), e && Dv(e, i.inHover), n, i);
}
function gV(t, r) {
  var e = r.transform, n = t.dpr || 1;
  e ? t.setTransform(n * e[0], n * e[1], n * e[2], n * e[3], n * e[4], n * e[5]) : t.setTransform(n, 0, 0, n, 0, 0);
}
function Kq(t, r, e) {
  for (var n = !1, i = 0; i < t.length; i++) {
    var a = t[i];
    n = n || a.isZeroArea(), gV(r, a), r.beginPath(), a.buildPath(r, a.shape), r.clip();
  }
  e.allClipped = n;
}
function qq(t, r) {
  return t && r ? t[0] !== r[0] || t[1] !== r[1] || t[2] !== r[2] || t[3] !== r[3] || t[4] !== r[4] || t[5] !== r[5] : !(!t && !r);
}
var YI = 1, XI = 2, $I = 3, UI = 4;
function Qq(t) {
  var r = Lm(t), e = Rm(t);
  return !(t.lineDash || !(+r ^ +e) || r && typeof t.fill != "string" || e && typeof t.stroke != "string" || t.strokePercent < 1 || t.strokeOpacity < 1 || t.fillOpacity < 1);
}
function Pi(t, r) {
  r.batchFill && t.fill(), r.batchStroke && t.stroke(), r.batchFill = "", r.batchStroke = "";
}
function Dv(t, r) {
  return r && t.__hoverStyle || t.style;
}
function gw(t, r) {
  vc(t, r, { inHover: !1, viewWidth: 0, viewHeight: 0 }, !0);
}
function vc(t, r, e, n) {
  var i = r.transform;
  if (!r.shouldBePainted(e.viewWidth, e.viewHeight, !1, !1)) {
    r.__dirty &= ~ji, r.__isRendered = !1;
    return;
  }
  var a = r.__clipPaths, o = e.prevElClipPaths, s = !1, l = !1;
  if ((!o || Zq(a, o)) && (o && o.length && (Pi(t, e), t.restore(), l = s = !0, e.prevElClipPaths = null, e.allClipped = !1, e.prevEl = null), a && a.length && (Pi(t, e), t.save(), Kq(a, t, e), s = !0), e.prevElClipPaths = a), e.allClipped) {
    r.__isRendered = !1;
    return;
  }
  r.beforeBrush && r.beforeBrush(), r.innerBeforeBrush();
  var u = e.prevEl;
  u || (l = s = !0);
  var c = r instanceof gt && r.autoBatch && Qq(r.style);
  s || qq(i, u.transform) ? (Pi(t, e), gV(t, r)) : c || Pi(t, e);
  var d = Dv(r, e.inHover);
  r instanceof gt ? (e.lastDrawType !== YI && (l = !0, e.lastDrawType = YI), jI(t, r, u, l, e), (!c || !e.batchFill && !e.batchStroke) && t.beginPath(), Xq(t, r, d, c), c && (e.batchFill = d.fill || "", e.batchStroke = d.stroke || "")) : r instanceof Tf ? (e.lastDrawType !== $I && (l = !0, e.lastDrawType = $I), jI(t, r, u, l, e), Uq(t, r, d)) : r instanceof An ? (e.lastDrawType !== XI && (l = !0, e.lastDrawType = XI), Jq(t, r, u, l, e), $q(t, r, d)) : r.getTemporalDisplayables && (e.lastDrawType !== UI && (l = !0, e.lastDrawType = UI), eQ(t, r, e)), c && n && Pi(t, e), r.innerAfterBrush(), r.afterBrush && r.afterBrush(), e.prevEl = r, r.__dirty = 0, r.__isRendered = !0;
}
function eQ(t, r, e) {
  var n = r.getDisplayables(), i = r.getTemporalDisplayables();
  t.save();
  var a = {
    prevElClipPaths: null,
    prevEl: null,
    allClipped: !1,
    viewWidth: e.viewWidth,
    viewHeight: e.viewHeight,
    inHover: e.inHover
  }, o, s;
  for (o = r.getCursor(), s = n.length; o < s; o++) {
    var l = n[o];
    l.beforeBrush && l.beforeBrush(), l.innerBeforeBrush(), vc(t, l, a, o === s - 1), l.innerAfterBrush(), l.afterBrush && l.afterBrush(), a.prevEl = l;
  }
  for (var u = 0, c = i.length; u < c; u++) {
    var l = i[u];
    l.beforeBrush && l.beforeBrush(), l.innerBeforeBrush(), vc(t, l, a, u === c - 1), l.innerAfterBrush(), l.afterBrush && l.afterBrush(), a.prevEl = l;
  }
  r.clearTemporalDisplayables(), r.notClear = !0, t.restore();
}
var mb = new kq(), JI = new ug(100), KI = ["symbol", "symbolSize", "symbolKeepAspect", "color", "backgroundColor", "dashArrayX", "dashArrayY", "maxTileWidth", "maxTileHeight"];
function Lf(t, r) {
  if (t === "none")
    return null;
  var e = r.getDevicePixelRatio(), n = r.getZr(), i = n.painter.type === "svg";
  t.dirty && mb.delete(t);
  var a = mb.get(t);
  if (a)
    return a;
  var o = Ee(t, {
    symbol: "rect",
    symbolSize: 1,
    symbolKeepAspect: !0,
    color: "rgba(0, 0, 0, 0.2)",
    backgroundColor: null,
    dashArrayX: 5,
    dashArrayY: 5,
    rotation: 0,
    maxTileWidth: 512,
    maxTileHeight: 512
  });
  o.backgroundColor === "none" && (o.backgroundColor = null);
  var s = {
    repeat: "repeat"
  };
  return l(s), s.rotation = o.rotation, s.scaleX = s.scaleY = i ? 1 : 1 / e, mb.set(t, s), t.dirty = !1, s;
  function l(u) {
    for (var c = [e], d = !0, f = 0; f < KI.length; ++f) {
      var h = o[KI[f]];
      if (h != null && !ue(h) && !pe(h) && !Mt(h) && typeof h != "boolean") {
        d = !1;
        break;
      }
      c.push(h);
    }
    var p;
    if (d) {
      p = c.join(",") + (i ? "-svg" : "");
      var v = JI.get(p);
      v && (i ? u.svgElement = v : u.image = v);
    }
    var g = yV(o.dashArrayX), m = tQ(o.dashArrayY), y = mV(o.symbol), b = rQ(g), C = bV(m), w = !i && Qa.createCanvas(), _ = i && {
      tag: "g",
      attrs: {},
      key: "dcl",
      children: []
    }, x = D(), I;
    w && (w.width = x.width * e, w.height = x.height * e, I = w.getContext("2d")), T(), d && JI.put(p, w || _), u.image = w, u.svgElement = _, u.svgWidth = x.width, u.svgHeight = x.height;
    function D() {
      for (var A = 1, M = 0, R = b.length; M < R; ++M)
        A = dS(A, b[M]);
      for (var E = 1, M = 0, R = y.length; M < R; ++M)
        E = dS(E, y[M].length);
      A *= E;
      var k = C * b.length * y.length;
      if (process.env.NODE_ENV !== "production") {
        var P = function(N) {
          console.warn("Calculated decal size is greater than " + N + " due to decal option settings so " + N + " is used for the decal size. Please consider changing the decal option to make a smaller decal or set " + N + " to be larger to avoid incontinuity.");
        };
        A > o.maxTileWidth && P("maxTileWidth"), k > o.maxTileHeight && P("maxTileHeight");
      }
      return {
        width: Math.max(1, Math.min(A, o.maxTileWidth)),
        height: Math.max(1, Math.min(k, o.maxTileHeight))
      };
    }
    function T() {
      I && (I.clearRect(0, 0, w.width, w.height), o.backgroundColor && (I.fillStyle = o.backgroundColor, I.fillRect(0, 0, w.width, w.height)));
      for (var A = 0, M = 0; M < m.length; ++M)
        A += m[M];
      if (A <= 0)
        return;
      for (var R = -C, E = 0, k = 0, P = 0; R < x.height; ) {
        if (E % 2 === 0) {
          for (var N = k / 2 % y.length, O = 0, W = 0, V = 0; O < x.width * 2; ) {
            for (var B = 0, M = 0; M < g[P].length; ++M)
              B += g[P][M];
            if (B <= 0)
              break;
            if (W % 2 === 0) {
              var Z = (1 - o.symbolSize) * 0.5, q = O + g[P][W] * Z, z = R + m[E] * Z, U = g[P][W] * o.symbolSize, J = m[E] * o.symbolSize, K = V / 2 % y[N].length;
              j(q, z, U, J, y[N][K]);
            }
            O += g[P][W], ++V, ++W, W === g[P].length && (W = 0);
          }
          ++P, P === g.length && (P = 0);
        }
        R += m[E], ++k, ++E, E === m.length && (E = 0);
      }
      function j(oe, ie, le, re, Re) {
        var ve = i ? 1 : e, Oe = en(Re, oe * ve, ie * ve, le * ve, re * ve, o.color, o.symbolKeepAspect);
        if (i) {
          var qe = n.painter.renderOneToVNode(Oe);
          qe && _.children.push(qe);
        } else
          gw(I, Oe);
      }
    }
  }
}
function mV(t) {
  if (!t || t.length === 0)
    return [["rect"]];
  if (pe(t))
    return [[t]];
  for (var r = !0, e = 0; e < t.length; ++e)
    if (!pe(t[e])) {
      r = !1;
      break;
    }
  if (r)
    return mV([t]);
  for (var n = [], e = 0; e < t.length; ++e)
    pe(t[e]) ? n.push([t[e]]) : n.push(t[e]);
  return n;
}
function yV(t) {
  if (!t || t.length === 0)
    return [[0, 0]];
  if (Mt(t)) {
    var r = Math.ceil(t);
    return [[r, r]];
  }
  for (var e = !0, n = 0; n < t.length; ++n)
    if (!Mt(t[n])) {
      e = !1;
      break;
    }
  if (e)
    return yV([t]);
  for (var i = [], n = 0; n < t.length; ++n)
    if (Mt(t[n])) {
      var r = Math.ceil(t[n]);
      i.push([r, r]);
    } else {
      var r = ce(t[n], function(s) {
        return Math.ceil(s);
      });
      r.length % 2 === 1 ? i.push(r.concat(r)) : i.push(r);
    }
  return i;
}
function tQ(t) {
  if (!t || typeof t == "object" && t.length === 0)
    return [0, 0];
  if (Mt(t)) {
    var r = Math.ceil(t);
    return [r, r];
  }
  var e = ce(t, function(n) {
    return Math.ceil(n);
  });
  return t.length % 2 ? e.concat(e) : e;
}
function rQ(t) {
  return ce(t, function(r) {
    return bV(r);
  });
}
function bV(t) {
  for (var r = 0, e = 0; e < t.length; ++e)
    r += t[e];
  return t.length % 2 === 1 ? r * 2 : r;
}
function nQ(t, r) {
  t.eachRawSeries(function(e) {
    if (!t.isSeriesFiltered(e)) {
      var n = e.getData();
      n.hasItemVisual() && n.each(function(o) {
        var s = n.getItemVisual(o, "decal");
        if (s) {
          var l = n.ensureUniqueItemVisual(o, "style");
          l.decal = Lf(s, r);
        }
      });
      var i = n.getVisual("decal");
      if (i) {
        var a = n.getVisual("style");
        a.decal = Lf(i, r);
      }
    }
  });
}
var Wa = new ka(), Em = {};
function iQ(t, r) {
  process.env.NODE_ENV !== "production" && Em[t] && jn("Already has an implementation of " + t + "."), Em[t] = r;
}
function CV(t) {
  return process.env.NODE_ENV !== "production" && (Em[t] || jn("Implementation of " + t + " doesn't exists.")), Em[t];
}
var aQ = "5.5.1", oQ = {
  zrender: "5.6.0"
}, sQ = 1, lQ = 800, uQ = 900, cQ = 1e3, dQ = 2e3, fQ = 5e3, wV = 1e3, hQ = 1100, mw = 2e3, _V = 3e3, pQ = 4e3, x2 = 4500, vQ = 4600, gQ = 5e3, mQ = 6e3, xV = 7e3, SV = {
  PROCESSOR: {
    FILTER: cQ,
    SERIES_FILTER: lQ,
    STATISTIC: fQ
  },
  VISUAL: {
    LAYOUT: wV,
    PROGRESSIVE_LAYOUT: hQ,
    GLOBAL: mw,
    CHART: _V,
    POST_CHART_LAYOUT: vQ,
    COMPONENT: pQ,
    BRUSH: gQ,
    CHART_ITEM: x2,
    ARIA: mQ,
    DECAL: xV
  }
}, Jn = "__flagInMainProcess", Ri = "__pendingUpdate", yb = "__needsUpdateStatus", qI = /^[a-zA-Z0-9_]+$/, bb = "__connectUpdateStatus", QI = 0, yQ = 1, bQ = 2;
function IV(t) {
  return function() {
    for (var r = [], e = 0; e < arguments.length; e++)
      r[e] = arguments[e];
    if (this.isDisposed()) {
      zi(this.id);
      return;
    }
    return DV(this, t, r);
  };
}
function AV(t) {
  return function() {
    for (var r = [], e = 0; e < arguments.length; e++)
      r[e] = arguments[e];
    return DV(this, t, r);
  };
}
function DV(t, r, e) {
  return e[0] = e[0] && e[0].toLowerCase(), ka.prototype[r].apply(t, e);
}
var TV = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return r;
  }(ka)
), MV = TV.prototype;
MV.on = AV("on");
MV.off = AV("off");
var _d, Cb, w1, hl, wb, _b, xb, Yh, Xh, eA, tA, Sb, rA, _1, nA, RV, la, iA, km = (
  /** @class */
  function(t) {
    ee(r, t);
    function r(e, n, i) {
      var a = t.call(this, new Dq()) || this;
      a._chartsViews = [], a._chartsMap = {}, a._componentsViews = [], a._componentsMap = {}, a._pendingActions = [], i = i || {}, pe(n) && (n = LV[n]), a._dom = e;
      var o = "canvas", s = "auto", l = !1;
      if (process.env.NODE_ENV !== "production") {
        var u = (
          /* eslint-disable-next-line */
          vt.hasGlobalWindow ? window : global
        );
        u && (o = je(u.__ECHARTS__DEFAULT__RENDERER__, o), s = je(u.__ECHARTS__DEFAULT__COARSE_POINTER, s), l = je(u.__ECHARTS__DEFAULT__USE_DIRTY_RECT__, l));
      }
      i.ssr && mN(function(h) {
        var p = Ze(h), v = p.dataIndex;
        if (v != null) {
          var g = xe();
          return g.set("series_index", p.seriesIndex), g.set("data_index", v), p.ssrType && g.set("ssr_type", p.ssrType), g;
        }
      });
      var c = a._zr = NC(e, {
        renderer: i.renderer || o,
        devicePixelRatio: i.devicePixelRatio,
        width: i.width,
        height: i.height,
        ssr: i.ssr,
        useDirtyRect: je(i.useDirtyRect, l),
        useCoarsePointer: je(i.useCoarsePointer, s),
        pointerSize: i.pointerSize
      });
      a._ssr = i.ssr, a._throttledZrFlush = _2(ye(c.flush, c), 17), n = Ge(n), n && VO(n, !0), a._theme = n, a._locale = NJ(i.locale || gO), a._coordSysMgr = new ed();
      var d = a._api = nA(a);
      function f(h, p) {
        return h.__prio - p.__prio;
      }
      return x0(Nm, f), x0(c9, f), a._scheduler = new lV(a, d, c9, Nm), a._messageCenter = new TV(), a._initEvents(), a.resize = ye(a.resize, a), c.animation.on("frame", a._onframe, a), eA(c, a), tA(c, a), fv(a), a;
    }
    return r.prototype._onframe = function() {
      if (!this._disposed) {
        iA(this);
        var e = this._scheduler;
        if (this[Ri]) {
          var n = this[Ri].silent;
          this[Jn] = !0;
          try {
            _d(this), hl.update.call(this, null, this[Ri].updateParams);
          } catch (l) {
            throw this[Jn] = !1, this[Ri] = null, l;
          }
          this._zr.flush(), this[Jn] = !1, this[Ri] = null, Yh.call(this, n), Xh.call(this, n);
        } else if (e.unfinished) {
          var i = sQ, a = this._model, o = this._api;
          e.unfinished = !1;
          do {
            var s = +/* @__PURE__ */ new Date();
            e.performSeriesTasks(a), e.performDataProcessorTasks(a), _b(this, a), e.performVisualTasks(a), _1(this, this._model, o, "remain", {}), i -= +/* @__PURE__ */ new Date() - s;
          } while (i > 0 && e.unfinished);
          e.unfinished || this._zr.flush();
        }
      }
    }, r.prototype.getDom = function() {
      return this._dom;
    }, r.prototype.getId = function() {
      return this.id;
    }, r.prototype.getZr = function() {
      return this._zr;
    }, r.prototype.isSSR = function() {
      return this._ssr;
    }, r.prototype.setOption = function(e, n, i) {
      if (this[Jn]) {
        process.env.NODE_ENV !== "production" && jn("`setOption` should not be called during main process.");
        return;
      }
      if (this._disposed) {
        zi(this.id);
        return;
      }
      var a, o, s;
      if (Me(n) && (i = n.lazyUpdate, a = n.silent, o = n.replaceMerge, s = n.transition, n = n.notMerge), this[Jn] = !0, !this._model || n) {
        var l = new cK(this._api), u = this._theme, c = this._model = new uw();
        c.scheduler = this._scheduler, c.ssr = this._ssr, c.init(null, null, null, u, this._locale, l);
      }
      this._model.setOption(e, {
        replaceMerge: o
      }, d9);
      var d = {
        seriesTransition: s,
        optionChanged: !0
      };
      if (i)
        this[Ri] = {
          silent: a,
          updateParams: d
        }, this[Jn] = !1, this.getZr().wakeUp();
      else {
        try {
          _d(this), hl.update.call(this, null, d);
        } catch (f) {
          throw this[Ri] = null, this[Jn] = !1, f;
        }
        this._ssr || this._zr.flush(), this[Ri] = null, this[Jn] = !1, Yh.call(this, a), Xh.call(this, a);
      }
    }, r.prototype.setTheme = function() {
      Ra("ECharts#setTheme() is DEPRECATED in ECharts 3.0");
    }, r.prototype.getModel = function() {
      return this._model;
    }, r.prototype.getOption = function() {
      return this._model && this._model.getOption();
    }, r.prototype.getWidth = function() {
      return this._zr.getWidth();
    }, r.prototype.getHeight = function() {
      return this._zr.getHeight();
    }, r.prototype.getDevicePixelRatio = function() {
      return this._zr.painter.dpr || vt.hasGlobalWindow && window.devicePixelRatio || 1;
    }, r.prototype.getRenderedCanvas = function(e) {
      return process.env.NODE_ENV !== "production" && qr("getRenderedCanvas", "renderToCanvas"), this.renderToCanvas(e);
    }, r.prototype.renderToCanvas = function(e) {
      e = e || {};
      var n = this._zr.painter;
      if (process.env.NODE_ENV !== "production" && n.type !== "canvas")
        throw new Error("renderToCanvas can only be used in the canvas renderer.");
      return n.getRenderedCanvas({
        backgroundColor: e.backgroundColor || this._model.get("backgroundColor"),
        pixelRatio: e.pixelRatio || this.getDevicePixelRatio()
      });
    }, r.prototype.renderToSVGString = function(e) {
      e = e || {};
      var n = this._zr.painter;
      if (process.env.NODE_ENV !== "production" && n.type !== "svg")
        throw new Error("renderToSVGString can only be used in the svg renderer.");
      return n.renderToString({
        useViewBox: e.useViewBox
      });
    }, r.prototype.getSvgDataURL = function() {
      if (vt.svgSupported) {
        var e = this._zr, n = e.storage.getDisplayList();
        return L(n, function(i) {
          i.stopAnimation(null, !0);
        }), e.painter.toDataURL();
      }
    }, r.prototype.getDataURL = function(e) {
      if (this._disposed) {
        zi(this.id);
        return;
      }
      e = e || {};
      var n = e.excludeComponents, i = this._model, a = [], o = this;
      L(n, function(l) {
        i.eachComponent({
          mainType: l
        }, function(u) {
          var c = o._componentsMap[u.__viewId];
          c.group.ignore || (a.push(c), c.group.ignore = !0);
        });
      });
      var s = this._zr.painter.getType() === "svg" ? this.getSvgDataURL() : this.renderToCanvas(e).toDataURL("image/" + (e && e.type || "png"));
      return L(a, function(l) {
        l.group.ignore = !1;
      }), s;
    }, r.prototype.getConnectedDataURL = function(e) {
      if (this._disposed) {
        zi(this.id);
        return;
      }
      var n = e.type === "svg", i = this.group, a = Math.min, o = Math.max, s = 1 / 0;
      if (Om[i]) {
        var l = s, u = s, c = -s, d = -s, f = [], h = e && e.pixelRatio || this.getDevicePixelRatio();
        L(Ac, function(b, C) {
          if (b.group === i) {
            var w = n ? b.getZr().painter.getSvgDom().innerHTML : b.renderToCanvas(Ge(e)), _ = b.getDom().getBoundingClientRect();
            l = a(_.left, l), u = a(_.top, u), c = o(_.right, c), d = o(_.bottom, d), f.push({
              dom: w,
              left: _.left,
              top: _.top
            });
          }
        }), l *= h, u *= h, c *= h, d *= h;
        var p = c - l, v = d - u, g = Qa.createCanvas(), m = NC(g, {
          renderer: n ? "svg" : "canvas"
        });
        if (m.resize({
          width: p,
          height: v
        }), n) {
          var y = "";
          return L(f, function(b) {
            var C = b.left - l, w = b.top - u;
            y += '<g transform="translate(' + C + "," + w + ')">' + b.dom + "</g>";
          }), m.painter.getSvgRoot().innerHTML = y, e.connectedBackgroundColor && m.painter.setBackgroundColor(e.connectedBackgroundColor), m.refreshImmediately(), m.painter.toDataURL();
        } else
          return e.connectedBackgroundColor && m.add(new xt({
            shape: {
              x: 0,
              y: 0,
              width: p,
              height: v
            },
            style: {
              fill: e.connectedBackgroundColor
            }
          })), L(f, function(b) {
            var C = new An({
              style: {
                x: b.left * h - l,
                y: b.top * h - u,
                image: b.dom
              }
            });
            m.add(C);
          }), m.refreshImmediately(), g.toDataURL("image/" + (e && e.type || "png"));
      } else
        return this.getDataURL(e);
    }, r.prototype.convertToPixel = function(e, n) {
      return wb(this, "convertToPixel", e, n);
    }, r.prototype.convertFromPixel = function(e, n) {
      return wb(this, "convertFromPixel", e, n);
    }, r.prototype.containPixel = function(e, n) {
      if (this._disposed) {
        zi(this.id);
        return;
      }
      var i = this._model, a, o = Up(i, e);
      return L(o, function(s, l) {
        l.indexOf("Models") >= 0 && L(s, function(u) {
          var c = u.coordinateSystem;
          if (c && c.containPoint)
            a = a || !!c.containPoint(n);
          else if (l === "seriesModels") {
            var d = this._chartsMap[u.__viewId];
            d && d.containPoint ? a = a || d.containPoint(n, u) : process.env.NODE_ENV !== "production" && Mr(l + ": " + (d ? "The found component do not support containPoint." : "No view mapping to the found component."));
          } else
            process.env.NODE_ENV !== "production" && Mr(l + ": containPoint is not supported");
        }, this);
      }, this), !!a;
    }, r.prototype.getVisual = function(e, n) {
      var i = this._model, a = Up(i, e, {
        defaultMainType: "series"
      }), o = a.seriesModel;
      process.env.NODE_ENV !== "production" && (o || Mr("There is no specified series model"));
      var s = o.getData(), l = a.hasOwnProperty("dataIndexInside") ? a.dataIndexInside : a.hasOwnProperty("dataIndex") ? s.indexOfRawIndex(a.dataIndex) : null;
      return l != null ? pw(s, l, n) : bg(s, n);
    }, r.prototype.getViewOfComponentModel = function(e) {
      return this._componentsMap[e.__viewId];
    }, r.prototype.getViewOfSeriesModel = function(e) {
      return this._chartsMap[e.__viewId];
    }, r.prototype._initEvents = function() {
      var e = this;
      L(CQ, function(n) {
        var i = function(a) {
          var o = e.getModel(), s = a.target, l, u = n === "globalout";
          if (u ? l = {} : s && hc(s, function(p) {
            var v = Ze(p);
            if (v && v.dataIndex != null) {
              var g = v.dataModel || o.getSeriesByIndex(v.seriesIndex);
              return l = g && g.getDataParams(v.dataIndex, v.dataType, s) || {}, !0;
            } else if (v.eventData)
              return l = ae({}, v.eventData), !0;
          }, !0), l) {
            var c = l.componentType, d = l.componentIndex;
            (c === "markLine" || c === "markPoint" || c === "markArea") && (c = "series", d = l.seriesIndex);
            var f = c && d != null && o.getComponent(c, d), h = f && e[f.mainType === "series" ? "_chartsMap" : "_componentsMap"][f.__viewId];
            process.env.NODE_ENV !== "production" && !u && !(f && h) && Mr("model or view can not be found by params"), l.event = a, l.type = n, e._$eventProcessor.eventInfo = {
              targetEl: s,
              packedEvent: l,
              model: f,
              view: h
            }, e.trigger(n, l);
          }
        };
        i.zrEventfulCallAtLast = !0, e._zr.on(n, i, e);
      }), L(tv, function(n, i) {
        e._messageCenter.on(i, function(a) {
          this.trigger(i, a);
        }, e);
      }), L(["selectchanged"], function(n) {
        e._messageCenter.on(n, function(i) {
          this.trigger(n, i);
        }, e);
      }), Rq(this._messageCenter, this, this._api);
    }, r.prototype.isDisposed = function() {
      return this._disposed;
    }, r.prototype.clear = function() {
      if (this._disposed) {
        zi(this.id);
        return;
      }
      this.setOption({
        series: []
      }, !0);
    }, r.prototype.dispose = function() {
      if (this._disposed) {
        zi(this.id);
        return;
      }
      this._disposed = !0;
      var e = this.getDom();
      e && DN(this.getDom(), bw, "");
      var n = this, i = n._api, a = n._model;
      L(n._componentsViews, function(o) {
        o.dispose(a, i);
      }), L(n._chartsViews, function(o) {
        o.dispose(a, i);
      }), n._zr.dispose(), n._dom = n._model = n._chartsMap = n._componentsMap = n._chartsViews = n._componentsViews = n._scheduler = n._api = n._zr = n._throttledZrFlush = n._theme = n._coordSysMgr = n._messageCenter = null, delete Ac[n.id];
    }, r.prototype.resize = function(e) {
      if (this[Jn]) {
        process.env.NODE_ENV !== "production" && jn("`resize` should not be called during main process.");
        return;
      }
      if (this._disposed) {
        zi(this.id);
        return;
      }
      this._zr.resize(e);
      var n = this._model;
      if (this._loadingFX && this._loadingFX.resize(), !!n) {
        var i = n.resetOption("media"), a = e && e.silent;
        this[Ri] && (a == null && (a = this[Ri].silent), i = !0, this[Ri] = null), this[Jn] = !0;
        try {
          i && _d(this), hl.update.call(this, {
            type: "resize",
            animation: ae({
              // Disable animation
              duration: 0
            }, e && e.animation)
          });
        } catch (o) {
          throw this[Jn] = !1, o;
        }
        this[Jn] = !1, Yh.call(this, a), Xh.call(this, a);
      }
    }, r.prototype.showLoading = function(e, n) {
      if (this._disposed) {
        zi(this.id);
        return;
      }
      if (Me(e) && (n = e, e = ""), e = e || "default", this.hideLoading(), !f9[e]) {
        process.env.NODE_ENV !== "production" && Mr("Loading effects " + e + " not exists.");
        return;
      }
      var i = f9[e](this._api, n), a = this._zr;
      this._loadingFX = i, a.add(i);
    }, r.prototype.hideLoading = function() {
      if (this._disposed) {
        zi(this.id);
        return;
      }
      this._loadingFX && this._zr.remove(this._loadingFX), this._loadingFX = null;
    }, r.prototype.makeActionFromEvent = function(e) {
      var n = ae({}, e);
      return n.type = tv[e.type], n;
    }, r.prototype.dispatchAction = function(e, n) {
      if (this._disposed) {
        zi(this.id);
        return;
      }
      if (Me(n) || (n = {
        silent: !!n
      }), !!Pm[e.type] && this._model) {
        if (this[Jn]) {
          this._pendingActions.push(e);
          return;
        }
        var i = n.silent;
        xb.call(this, e, i);
        var a = n.flush;
        a ? this._zr.flush() : a !== !1 && vt.browser.weChat && this._throttledZrFlush(), Yh.call(this, i), Xh.call(this, i);
      }
    }, r.prototype.updateLabelLayout = function() {
      Wa.trigger("series:layoutlabels", this._model, this._api, {
        // Not adding series labels.
        // TODO
        updatedSeries: []
      });
    }, r.prototype.appendData = function(e) {
      if (this._disposed) {
        zi(this.id);
        return;
      }
      var n = e.seriesIndex, i = this.getModel(), a = i.getSeriesByIndex(n);
      process.env.NODE_ENV !== "production" && ke(e.data && a), a.appendData(e), this._scheduler.unfinished = !0, this.getZr().wakeUp();
    }, r.internalField = function() {
      _d = function(d) {
        var f = d._scheduler;
        f.restorePipelines(d._model), f.prepareStageTasks(), Cb(d, !0), Cb(d, !1), f.plan();
      }, Cb = function(d, f) {
        for (var h = d._model, p = d._scheduler, v = f ? d._componentsViews : d._chartsViews, g = f ? d._componentsMap : d._chartsMap, m = d._zr, y = d._api, b = 0; b < v.length; b++)
          v[b].__alive = !1;
        f ? h.eachComponent(function(_, x) {
          _ !== "series" && C(x);
        }) : h.eachSeries(C);
        function C(_) {
          var x = _.__requireNewView;
          _.__requireNewView = !1;
          var I = "_ec_" + _.id + "_" + _.type, D = !x && g[I];
          if (!D) {
            var T = No(_.type), A = f ? yr.getClass(T.main, T.sub) : (
              // FIXME:TS
              // (ChartView as ChartViewConstructor).getClass('series', classType.sub)
              // For backward compat, still support a chart type declared as only subType
              // like "liquidfill", but recommend "series.liquidfill"
              // But need a base class to make a type series.
              Yt.getClass(T.sub)
            );
            process.env.NODE_ENV !== "production" && ke(A, T.sub + " does not exist."), D = new A(), D.init(h, y), g[I] = D, v.push(D), m.add(D.group);
          }
          _.__viewId = D.__id = I, D.__alive = !0, D.__model = _, D.group.__ecComponentInfo = {
            mainType: _.mainType,
            index: _.componentIndex
          }, !f && p.prepareView(D, _, h, y);
        }
        for (var b = 0; b < v.length; ) {
          var w = v[b];
          w.__alive ? b++ : (!f && w.renderTask.dispose(), m.remove(w.group), w.dispose(h, y), v.splice(b, 1), g[w.__id] === w && delete g[w.__id], w.__id = w.group.__ecComponentInfo = null);
        }
      }, w1 = function(d, f, h, p, v) {
        var g = d._model;
        if (g.setUpdatePayload(h), !p) {
          L([].concat(d._componentsViews).concat(d._chartsViews), w);
          return;
        }
        var m = {};
        m[p + "Id"] = h[p + "Id"], m[p + "Index"] = h[p + "Index"], m[p + "Name"] = h[p + "Name"];
        var y = {
          mainType: p,
          query: m
        };
        v && (y.subType = v);
        var b = h.excludeSeriesId, C;
        b != null && (C = xe(), L(Qt(b), function(_) {
          var x = vn(_, null);
          x != null && C.set(x, !0);
        })), g && g.eachComponent(y, function(_) {
          var x = C && C.get(_.id) != null;
          if (!x)
            if (FS(h))
              if (_ instanceof tr)
                h.type === Sc && !h.notBlur && !_.get(["emphasis", "disabled"]) && GU(_, h, d._api);
              else {
                var I = z7(_.mainType, _.componentIndex, h.name, d._api), D = I.focusSelf, T = I.dispatchers;
                h.type === Sc && D && !h.notBlur && jC(_.mainType, _.componentIndex, d._api), T && L(T, function(A) {
                  h.type === Sc ? Xs(A) : $s(A);
                });
              }
            else XC(h) && _ instanceof tr && (HU(_, h, d._api), GS(_), la(d));
        }, d), g && g.eachComponent(y, function(_) {
          var x = C && C.get(_.id) != null;
          x || w(d[p === "series" ? "_chartsMap" : "_componentsMap"][_.__viewId]);
        }, d);
        function w(_) {
          _ && _.__alive && _[f] && _[f](_.__model, g, d._api, h);
        }
      }, hl = {
        prepareAndUpdate: function(d) {
          _d(this), hl.update.call(this, d, {
            // Needs to mark option changed if newOption is given.
            // It's from MagicType.
            // TODO If use a separate flag optionChanged in payload?
            optionChanged: d.newOption != null
          });
        },
        update: function(d, f) {
          var h = this._model, p = this._api, v = this._zr, g = this._coordSysMgr, m = this._scheduler;
          if (h) {
            h.setUpdatePayload(d), m.restoreData(h, d), m.performSeriesTasks(h), g.create(h, p), m.performDataProcessorTasks(h, d), _b(this, h), g.update(h, p), e(h), m.performVisualTasks(h, d), Sb(this, h, p, d, f);
            var y = h.get("backgroundColor") || "transparent", b = h.get("darkMode");
            v.setBackgroundColor(y), b != null && b !== "auto" && v.setDarkMode(b), Wa.trigger("afterupdate", h, p);
          }
        },
        updateTransform: function(d) {
          var f = this, h = this._model, p = this._api;
          if (h) {
            h.setUpdatePayload(d);
            var v = [];
            h.eachComponent(function(m, y) {
              if (m !== "series") {
                var b = f.getViewOfComponentModel(y);
                if (b && b.__alive)
                  if (b.updateTransform) {
                    var C = b.updateTransform(y, h, p, d);
                    C && C.update && v.push(b);
                  } else
                    v.push(b);
              }
            });
            var g = xe();
            h.eachSeries(function(m) {
              var y = f._chartsMap[m.__viewId];
              if (y.updateTransform) {
                var b = y.updateTransform(m, h, p, d);
                b && b.update && g.set(m.uid, 1);
              } else
                g.set(m.uid, 1);
            }), e(h), this._scheduler.performVisualTasks(h, d, {
              setDirty: !0,
              dirtyMap: g
            }), _1(this, h, p, d, {}, g), Wa.trigger("afterupdate", h, p);
          }
        },
        updateView: function(d) {
          var f = this._model;
          f && (f.setUpdatePayload(d), Yt.markUpdateMethod(d, "updateView"), e(f), this._scheduler.performVisualTasks(f, d, {
            setDirty: !0
          }), Sb(this, f, this._api, d, {}), Wa.trigger("afterupdate", f, this._api));
        },
        updateVisual: function(d) {
          var f = this, h = this._model;
          h && (h.setUpdatePayload(d), h.eachSeries(function(p) {
            p.getData().clearAllVisual();
          }), Yt.markUpdateMethod(d, "updateVisual"), e(h), this._scheduler.performVisualTasks(h, d, {
            visualType: "visual",
            setDirty: !0
          }), h.eachComponent(function(p, v) {
            if (p !== "series") {
              var g = f.getViewOfComponentModel(v);
              g && g.__alive && g.updateVisual(v, h, f._api, d);
            }
          }), h.eachSeries(function(p) {
            var v = f._chartsMap[p.__viewId];
            v.updateVisual(p, h, f._api, d);
          }), Wa.trigger("afterupdate", h, this._api));
        },
        updateLayout: function(d) {
          hl.update.call(this, d);
        }
      }, wb = function(d, f, h, p) {
        if (d._disposed) {
          zi(d.id);
          return;
        }
        for (var v = d._model, g = d._coordSysMgr.getCoordinateSystems(), m, y = Up(v, h), b = 0; b < g.length; b++) {
          var C = g[b];
          if (C[f] && (m = C[f](v, y, p)) != null)
            return m;
        }
        process.env.NODE_ENV !== "production" && Mr("No coordinate system that supports " + f + " found by the given finder.");
      }, _b = function(d, f) {
        var h = d._chartsMap, p = d._scheduler;
        f.eachSeries(function(v) {
          p.updateStreamModes(v, h[v.__viewId]);
        });
      }, xb = function(d, f) {
        var h = this, p = this.getModel(), v = d.type, g = d.escapeConnect, m = Pm[v], y = m.actionInfo, b = (y.update || "update").split(":"), C = b.pop(), w = b[0] != null && No(b[0]);
        this[Jn] = !0;
        var _ = [d], x = !1;
        d.batch && (x = !0, _ = ce(d.batch, function(E) {
          return E = Ee(ae({}, E), d), E.batch = null, E;
        }));
        var I = [], D, T = XC(d), A = FS(d);
        if (A && UN(this._api), L(_, function(E) {
          if (D = m.action(E, h._model, h._api), D = D || ae({}, E), D.type = y.event || D.type, I.push(D), A) {
            var k = P7(d), P = k.queryOptionMap, N = k.mainTypeSpecified, O = N ? P.keys()[0] : "series";
            w1(h, C, E, O), la(h);
          } else T ? (w1(h, C, E, "series"), la(h)) : w && w1(h, C, E, w.main, w.sub);
        }), C !== "none" && !A && !T && !w)
          try {
            this[Ri] ? (_d(this), hl.update.call(this, d), this[Ri] = null) : hl[C].call(this, d);
          } catch (E) {
            throw this[Jn] = !1, E;
          }
        if (x ? D = {
          type: y.event || v,
          escapeConnect: g,
          batch: I
        } : D = I[0], this[Jn] = !1, !f) {
          var M = this._messageCenter;
          if (M.trigger(D.type, D), T) {
            var R = {
              type: "selectchanged",
              escapeConnect: g,
              selected: zU(p),
              isFromClick: d.isFromClick || !1,
              fromAction: d.type,
              fromActionPayload: d
            };
            M.trigger(R.type, R);
          }
        }
      }, Yh = function(d) {
        for (var f = this._pendingActions; f.length; ) {
          var h = f.shift();
          xb.call(this, h, d);
        }
      }, Xh = function(d) {
        !d && this.trigger("updated");
      }, eA = function(d, f) {
        d.on("rendered", function(h) {
          f.trigger("rendered", h), // Although zr is dirty if initial animation is not finished
          // and this checking is called on frame, we also check
          // animation finished for robustness.
          d.animation.isFinished() && !f[Ri] && !f._scheduler.unfinished && !f._pendingActions.length && f.trigger("finished");
        });
      }, tA = function(d, f) {
        d.on("mouseover", function(h) {
          var p = h.target, v = hc(p, eu);
          v && (BU(v, h, f._api), la(f));
        }).on("mouseout", function(h) {
          var p = h.target, v = hc(p, eu);
          v && (FU(v, h, f._api), la(f));
        }).on("click", function(h) {
          var p = h.target, v = hc(p, function(y) {
            return Ze(y).dataIndex != null;
          }, !0);
          if (v) {
            var g = v.selected ? "unselect" : "select", m = Ze(v);
            f._api.dispatchAction({
              type: g,
              dataType: m.dataType,
              dataIndexInside: m.dataIndex,
              seriesIndex: m.seriesIndex,
              isFromClick: !0
            });
          }
        });
      };
      function e(d) {
        d.clearColorPalette(), d.eachSeries(function(f) {
          f.clearColorPalette();
        });
      }
      function n(d) {
        var f = [], h = [], p = !1;
        if (d.eachComponent(function(y, b) {
          var C = b.get("zlevel") || 0, w = b.get("z") || 0, _ = b.getZLevelKey();
          p = p || !!_, (y === "series" ? h : f).push({
            zlevel: C,
            z: w,
            idx: b.componentIndex,
            type: y,
            key: _
          });
        }), p) {
          var v = f.concat(h), g, m;
          x0(v, function(y, b) {
            return y.zlevel === b.zlevel ? y.z - b.z : y.zlevel - b.zlevel;
          }), L(v, function(y) {
            var b = d.getComponent(y.type, y.idx), C = y.zlevel, w = y.key;
            g != null && (C = Math.max(g, C)), w ? (C === g && w !== m && C++, m = w) : m && (C === g && C++, m = ""), g = C, b.setZLevel(C);
          });
        }
      }
      Sb = function(d, f, h, p, v) {
        n(f), rA(d, f, h, p, v), L(d._chartsViews, function(g) {
          g.__alive = !1;
        }), _1(d, f, h, p, v), L(d._chartsViews, function(g) {
          g.__alive || g.remove(f, h);
        });
      }, rA = function(d, f, h, p, v, g) {
        L(g || d._componentsViews, function(m) {
          var y = m.__model;
          u(y, m), m.render(y, f, h, p), s(y, m), c(y, m);
        });
      }, _1 = function(d, f, h, p, v, g) {
        var m = d._scheduler;
        v = ae(v || {}, {
          updatedSeries: f.getSeries()
        }), Wa.trigger("series:beforeupdate", f, h, v);
        var y = !1;
        f.eachSeries(function(b) {
          var C = d._chartsMap[b.__viewId];
          C.__alive = !0;
          var w = C.renderTask;
          m.updatePayload(w, p), u(b, C), g && g.get(b.uid) && w.dirty(), w.perform(m.getPerformArgs(w)) && (y = !0), C.group.silent = !!b.get("silent"), o(b, C), GS(b);
        }), m.unfinished = y || m.unfinished, Wa.trigger("series:layoutlabels", f, h, v), Wa.trigger("series:transition", f, h, v), f.eachSeries(function(b) {
          var C = d._chartsMap[b.__viewId];
          s(b, C), c(b, C);
        }), a(d, f), Wa.trigger("series:afterupdate", f, h, v);
      }, la = function(d) {
        d[yb] = !0, d.getZr().wakeUp();
      }, iA = function(d) {
        d[yb] && (d.getZr().storage.traverse(function(f) {
          hf(f) || i(f);
        }), d[yb] = !1);
      };
      function i(d) {
        for (var f = [], h = d.currentStates, p = 0; p < h.length; p++) {
          var v = h[p];
          v === "emphasis" || v === "blur" || v === "select" || f.push(v);
        }
        d.selected && d.states.select && f.push("select"), d.hoverState === l2 && d.states.emphasis ? f.push("emphasis") : d.hoverState === hg && d.states.blur && f.push("blur"), d.useStates(f);
      }
      function a(d, f) {
        var h = d._zr, p = h.storage, v = 0;
        p.traverse(function(g) {
          g.isGroup || v++;
        }), v > f.get("hoverLayerThreshold") && !vt.node && !vt.worker && f.eachSeries(function(g) {
          if (!g.preventUsingHoverLayer) {
            var m = d._chartsMap[g.__viewId];
            m.__alive && m.eachRendered(function(y) {
              y.states.emphasis && (y.states.emphasis.hoverLayer = !0);
            });
          }
        });
      }
      function o(d, f) {
        var h = d.get("blendMode") || null;
        f.eachRendered(function(p) {
          p.isGroup || (p.style.blend = h);
        });
      }
      function s(d, f) {
        if (!d.preventAutoZ) {
          var h = d.get("z") || 0, p = d.get("zlevel") || 0;
          f.eachRendered(function(v) {
            return l(v, h, p, -1 / 0), !0;
          });
        }
      }
      function l(d, f, h, p) {
        var v = d.getTextContent(), g = d.getTextGuideLine(), m = d.isGroup;
        if (m)
          for (var y = d.childrenRef(), b = 0; b < y.length; b++)
            p = Math.max(l(y[b], f, h, p), p);
        else
          d.z = f, d.zlevel = h, p = Math.max(d.z2, p);
        if (v && (v.z = f, v.zlevel = h, isFinite(p) && (v.z2 = p + 2)), g) {
          var C = d.textGuideLineConfig;
          g.z = f, g.zlevel = h, isFinite(p) && (g.z2 = p + (C && C.showAbove ? 1 : -1));
        }
        return p;
      }
      function u(d, f) {
        f.eachRendered(function(h) {
          if (!hf(h)) {
            var p = h.getTextContent(), v = h.getTextGuideLine();
            h.stateTransition && (h.stateTransition = null), p && p.stateTransition && (p.stateTransition = null), v && v.stateTransition && (v.stateTransition = null), h.hasState() ? (h.prevStates = h.currentStates, h.clearStates()) : h.prevStates && (h.prevStates = null);
          }
        });
      }
      function c(d, f) {
        var h = d.getModel("stateAnimation"), p = d.isAnimationEnabled(), v = h.get("duration"), g = v > 0 ? {
          duration: v,
          delay: h.get("delay"),
          easing: h.get("easing")
          // additive: stateAnimationModel.get('additive')
        } : null;
        f.eachRendered(function(m) {
          if (m.states && m.states.emphasis) {
            if (hf(m))
              return;
            if (m instanceof gt && XU(m), m.__dirty) {
              var y = m.prevStates;
              y && m.useStates(y);
            }
            if (p) {
              m.stateTransition = g;
              var b = m.getTextContent(), C = m.getTextGuideLine();
              b && (b.stateTransition = g), C && (C.stateTransition = g);
            }
            m.__dirty && i(m);
          }
        });
      }
      nA = function(d) {
        return new /** @class */
        (function(f) {
          ee(h, f);
          function h() {
            return f !== null && f.apply(this, arguments) || this;
          }
          return h.prototype.getCoordinateSystems = function() {
            return d._coordSysMgr.getCoordinateSystems();
          }, h.prototype.getComponentByElement = function(p) {
            for (; p; ) {
              var v = p.__ecComponentInfo;
              if (v != null)
                return d._model.getComponent(v.mainType, v.index);
              p = p.parent;
            }
          }, h.prototype.enterEmphasis = function(p, v) {
            Xs(p, v), la(d);
          }, h.prototype.leaveEmphasis = function(p, v) {
            $s(p, v), la(d);
          }, h.prototype.enterBlur = function(p) {
            jN(p), la(d);
          }, h.prototype.leaveBlur = function(p) {
            H7(p), la(d);
          }, h.prototype.enterSelect = function(p) {
            YN(p), la(d);
          }, h.prototype.leaveSelect = function(p) {
            XN(p), la(d);
          }, h.prototype.getModel = function() {
            return d.getModel();
          }, h.prototype.getViewOfComponentModel = function(p) {
            return d.getViewOfComponentModel(p);
          }, h.prototype.getViewOfSeriesModel = function(p) {
            return d.getViewOfSeriesModel(p);
          }, h;
        }(NO))(d);
      }, RV = function(d) {
        function f(h, p) {
          for (var v = 0; v < h.length; v++) {
            var g = h[v];
            g[bb] = p;
          }
        }
        L(tv, function(h, p) {
          d._messageCenter.on(p, function(v) {
            if (Om[d.group] && d[bb] !== QI) {
              if (v && v.escapeConnect)
                return;
              var g = d.makeActionFromEvent(v), m = [];
              L(Ac, function(y) {
                y !== d && y.group === d.group && m.push(y);
              }), f(m, QI), L(m, function(y) {
                y[bb] !== yQ && y.dispatchAction(g);
              }), f(m, bQ);
            }
          });
        });
      };
    }(), r;
  }(ka)
), yw = km.prototype;
yw.on = IV("on");
yw.off = IV("off");
yw.one = function(t, r, e) {
  var n = this;
  Ra("ECharts#one is deprecated.");
  function i() {
    for (var a = [], o = 0; o < arguments.length; o++)
      a[o] = arguments[o];
    r && r.apply && r.apply(this, a), n.off(t, i);
  }
  this.on.call(this, t, i, e);
};
var CQ = ["click", "dblclick", "mouseover", "mouseout", "mousemove", "mousedown", "mouseup", "globalout", "contextmenu"];
function zi(t) {
  process.env.NODE_ENV !== "production" && Mr("Instance " + t + " has been disposed");
}
var Pm = {}, tv = {}, c9 = [], d9 = [], Nm = [], LV = {}, f9 = {}, Ac = {}, Om = {}, wQ = +/* @__PURE__ */ new Date() - 0, _Q = +/* @__PURE__ */ new Date() - 0, bw = "_echarts_instance_";
function xQ(t, r, e) {
  var n = !(e && e.ssr);
  if (n) {
    if (process.env.NODE_ENV !== "production" && !t)
      throw new Error("Initialize failed: invalid dom.");
    var i = Cw(t);
    if (i)
      return process.env.NODE_ENV !== "production" && Mr("There is a chart instance already initialized on the dom."), i;
    process.env.NODE_ENV !== "production" && Kl(t) && t.nodeName.toUpperCase() !== "CANVAS" && (!t.clientWidth && (!e || e.width == null) || !t.clientHeight && (!e || e.height == null)) && Mr("Can't get DOM width or height. Please check dom.clientWidth and dom.clientHeight. They should not be 0.For example, you may need to call this in the callback of window.onload.");
  }
  var a = new km(t, r, e);
  return a.id = "ec_" + wQ++, Ac[a.id] = a, n && DN(t, bw, a.id), RV(a), Wa.trigger("afterinit", a), a;
}
function SQ(t) {
  if (ue(t)) {
    var r = t;
    t = null, L(r, function(e) {
      e.group != null && (t = e.group);
    }), t = t || "g_" + _Q++, L(r, function(e) {
      e.group = t;
    });
  }
  return Om[t] = !0, t;
}
function EV(t) {
  Om[t] = !1;
}
var IQ = EV;
function AQ(t) {
  pe(t) ? t = Ac[t] : t instanceof km || (t = Cw(t)), t instanceof km && !t.isDisposed() && t.dispose();
}
function Cw(t) {
  return Ac[O$(t, bw)];
}
function DQ(t) {
  return Ac[t];
}
function ww(t, r) {
  LV[t] = r;
}
function _w(t) {
  nt(d9, t) < 0 && d9.push(t);
}
function xw(t, r) {
  Sw(c9, t, r, dQ);
}
function kV(t) {
  S2("afterinit", t);
}
function PV(t) {
  S2("afterupdate", t);
}
function S2(t, r) {
  Wa.on(t, r);
}
function co(t, r, e) {
  Ae(r) && (e = r, r = "");
  var n = Me(t) ? t.type : [t, t = {
    event: r
  }][0];
  t.event = (t.event || n).toLowerCase(), r = t.event, !tv[r] && (ke(qI.test(n) && qI.test(r)), Pm[n] || (Pm[n] = {
    action: e,
    actionInfo: t
  }), tv[r] = n);
}
function NV(t, r) {
  ed.register(t, r);
}
function TQ(t) {
  var r = ed.get(t);
  if (r)
    return r.getDimensionsInfo ? r.getDimensionsInfo() : r.dimensions.slice();
}
function OV(t, r) {
  Sw(Nm, t, r, wV, "layout");
}
function gu(t, r) {
  Sw(Nm, t, r, _V, "visual");
}
var aA = [];
function Sw(t, r, e, n, i) {
  if ((Ae(r) || Me(r)) && (e = r, r = n), process.env.NODE_ENV !== "production") {
    if (isNaN(r) || r == null)
      throw new Error("Illegal priority");
    L(t, function(o) {
      ke(o.__raw !== e);
    });
  }
  if (!(nt(aA, e) >= 0)) {
    aA.push(e);
    var a = lV.wrapStageHandler(e, i);
    a.__prio = r, a.__raw = e, t.push(a);
  }
}
function Iw(t, r) {
  f9[t] = r;
}
function MQ(t) {
  process.env.NODE_ENV !== "production" && Ra("setCanvasCreator is deprecated. Use setPlatformAPI({ createCanvas }) instead."), PP({
    createCanvas: t
  });
}
function VV(t, r, e) {
  var n = CV("registerMap");
  n && n(t, r, e);
}
function RQ(t) {
  var r = CV("getMap");
  return r && r(t);
}
var GV = zK;
gu(mw, hq);
gu(x2, pq);
gu(x2, vq);
gu(mw, Tq);
gu(x2, Mq);
gu(xV, nQ);
_w(VO);
xw(uQ, _K);
Iw("default", gq);
co({
  type: Sc,
  event: Sc,
  update: Sc
}, Yr);
co({
  type: T0,
  event: T0,
  update: T0
}, Yr);
co({
  type: Jp,
  event: Jp,
  update: Jp
}, Yr);
co({
  type: M0,
  event: M0,
  update: M0
}, Yr);
co({
  type: Kp,
  event: Kp,
  update: Kp
}, Yr);
ww("light", Aq);
ww("dark", fV);
var LQ = {}, oA = [], EQ = {
  registerPreprocessor: _w,
  registerProcessor: xw,
  registerPostInit: kV,
  registerPostUpdate: PV,
  registerUpdateLifecycle: S2,
  registerAction: co,
  registerCoordinateSystem: NV,
  registerLayout: OV,
  registerVisual: gu,
  registerTransform: GV,
  registerLoading: Iw,
  registerMap: VV,
  registerImpl: iQ,
  PRIORITY: SV,
  ComponentModel: st,
  ComponentView: yr,
  SeriesModel: tr,
  ChartView: Yt,
  // TODO Use ComponentModel and SeriesModel instead of Constructor
  registerComponentModel: function(t) {
    st.registerClass(t);
  },
  registerComponentView: function(t) {
    yr.registerClass(t);
  },
  registerSeriesModel: function(t) {
    tr.registerClass(t);
  },
  registerChartView: function(t) {
    Yt.registerClass(t);
  },
  registerSubTypeDefaulter: function(t, r) {
    st.registerSubTypeDefaulter(t, r);
  },
  registerPainter: function(t, r) {
    vN(t, r);
  }
};
function lt(t) {
  if (ue(t)) {
    L(t, function(r) {
      lt(r);
    });
    return;
  }
  nt(oA, t) >= 0 || (oA.push(t), Ae(t) && (t = {
    install: t
  }), t.install(EQ));
}
function $h(t) {
  return t == null ? 0 : t.length || 1;
}
function sA(t) {
  return t;
}
var Us = (
  /** @class */
  function() {
    function t(r, e, n, i, a, o) {
      this._old = r, this._new = e, this._oldKeyGetter = n || sA, this._newKeyGetter = i || sA, this.context = a, this._diffModeMultiple = o === "multiple";
    }
    return t.prototype.add = function(r) {
      return this._add = r, this;
    }, t.prototype.update = function(r) {
      return this._update = r, this;
    }, t.prototype.updateManyToOne = function(r) {
      return this._updateManyToOne = r, this;
    }, t.prototype.updateOneToMany = function(r) {
      return this._updateOneToMany = r, this;
    }, t.prototype.updateManyToMany = function(r) {
      return this._updateManyToMany = r, this;
    }, t.prototype.remove = function(r) {
      return this._remove = r, this;
    }, t.prototype.execute = function() {
      this[this._diffModeMultiple ? "_executeMultiple" : "_executeOneToOne"]();
    }, t.prototype._executeOneToOne = function() {
      var r = this._old, e = this._new, n = {}, i = new Array(r.length), a = new Array(e.length);
      this._initIndexMap(r, null, i, "_oldKeyGetter"), this._initIndexMap(e, n, a, "_newKeyGetter");
      for (var o = 0; o < r.length; o++) {
        var s = i[o], l = n[s], u = $h(l);
        if (u > 1) {
          var c = l.shift();
          l.length === 1 && (n[s] = l[0]), this._update && this._update(c, o);
        } else u === 1 ? (n[s] = null, this._update && this._update(l, o)) : this._remove && this._remove(o);
      }
      this._performRestAdd(a, n);
    }, t.prototype._executeMultiple = function() {
      var r = this._old, e = this._new, n = {}, i = {}, a = [], o = [];
      this._initIndexMap(r, n, a, "_oldKeyGetter"), this._initIndexMap(e, i, o, "_newKeyGetter");
      for (var s = 0; s < a.length; s++) {
        var l = a[s], u = n[l], c = i[l], d = $h(u), f = $h(c);
        if (d > 1 && f === 1)
          this._updateManyToOne && this._updateManyToOne(c, u), i[l] = null;
        else if (d === 1 && f > 1)
          this._updateOneToMany && this._updateOneToMany(c, u), i[l] = null;
        else if (d === 1 && f === 1)
          this._update && this._update(c, u), i[l] = null;
        else if (d > 1 && f > 1)
          this._updateManyToMany && this._updateManyToMany(c, u), i[l] = null;
        else if (d > 1)
          for (var h = 0; h < d; h++)
            this._remove && this._remove(u[h]);
        else
          this._remove && this._remove(u);
      }
      this._performRestAdd(o, i);
    }, t.prototype._performRestAdd = function(r, e) {
      for (var n = 0; n < r.length; n++) {
        var i = r[n], a = e[i], o = $h(a);
        if (o > 1)
          for (var s = 0; s < o; s++)
            this._add && this._add(a[s]);
        else o === 1 && this._add && this._add(a);
        e[i] = null;
      }
    }, t.prototype._initIndexMap = function(r, e, n, i) {
      for (var a = this._diffModeMultiple, o = 0; o < r.length; o++) {
        var s = "_ec_" + this[i](r[o], o);
        if (a || (n[o] = s), !!e) {
          var l = e[s], u = $h(l);
          u === 0 ? (e[s] = o, a && n.push(s)) : u === 1 ? e[s] = [l, o] : l.push(o);
        }
      }
    }, t;
  }()
), kQ = (
  /** @class */
  function() {
    function t(r, e) {
      this._encode = r, this._schema = e;
    }
    return t.prototype.get = function() {
      return {
        // Do not generate full dimension name until fist used.
        fullDimensions: this._getFullDimensionNames(),
        encode: this._encode
      };
    }, t.prototype._getFullDimensionNames = function() {
      return this._cachedDimNames || (this._cachedDimNames = this._schema ? this._schema.makeOutputDimensionNames() : []), this._cachedDimNames;
    }, t;
  }()
);
function PQ(t, r) {
  var e = {}, n = e.encode = {}, i = xe(), a = [], o = [], s = {};
  L(t.dimensions, function(f) {
    var h = t.getDimensionInfo(f), p = h.coordDim;
    if (p) {
      process.env.NODE_ENV !== "production" && ke(QC.get(p) == null);
      var v = h.coordDimIndex;
      Ib(n, p)[v] = f, h.isExtraCoord || (i.set(p, 1), NQ(h.type) && (a[0] = f), Ib(s, p)[v] = t.getDimensionIndex(h.name)), h.defaultTooltip && o.push(f);
    }
    QC.each(function(g, m) {
      var y = Ib(n, m), b = h.otherDims[m];
      b != null && b !== !1 && (y[b] = h.name);
    });
  });
  var l = [], u = {};
  i.each(function(f, h) {
    var p = n[h];
    u[h] = p[0], l = l.concat(p);
  }), e.dataDimsOnCoord = l, e.dataDimIndicesOnCoord = ce(l, function(f) {
    return t.getDimensionInfo(f).storeDimIndex;
  }), e.encodeFirstDimNotExtra = u;
  var c = n.label;
  c && c.length && (a = c.slice());
  var d = n.tooltip;
  return d && d.length ? o = d.slice() : o.length || (o = a.slice()), n.defaultedLabel = a, n.defaultedTooltip = o, e.userOutput = new kQ(s, r), e;
}
function Ib(t, r) {
  return t.hasOwnProperty(r) || (t[r] = []), t[r];
}
function Vm(t) {
  return t === "category" ? "ordinal" : t === "time" ? "time" : "float";
}
function NQ(t) {
  return !(t === "ordinal" || t === "time");
}
var P0 = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(r) {
      this.otherDims = {}, r != null && ae(this, r);
    }
    return t;
  }()
), OQ = It(), VQ = {
  float: "f",
  int: "i",
  ordinal: "o",
  number: "n",
  time: "t"
}, BV = (
  /** @class */
  function() {
    function t(r) {
      this.dimensions = r.dimensions, this._dimOmitted = r.dimensionOmitted, this.source = r.source, this._fullDimCount = r.fullDimensionCount, this._updateDimOmitted(r.dimensionOmitted);
    }
    return t.prototype.isDimensionOmitted = function() {
      return this._dimOmitted;
    }, t.prototype._updateDimOmitted = function(r) {
      this._dimOmitted = r, r && (this._dimNameMap || (this._dimNameMap = zV(this.source)));
    }, t.prototype.getSourceDimensionIndex = function(r) {
      return je(this._dimNameMap.get(r), -1);
    }, t.prototype.getSourceDimension = function(r) {
      var e = this.source.dimensionsDefine;
      if (e)
        return e[r];
    }, t.prototype.makeStoreSchema = function() {
      for (var r = this._fullDimCount, e = BO(this.source), n = !WV(r), i = "", a = [], o = 0, s = 0; o < r; o++) {
        var l = void 0, u = void 0, c = void 0, d = this.dimensions[s];
        if (d && d.storeDimIndex === o)
          l = e ? d.name : null, u = d.type, c = d.ordinalMeta, s++;
        else {
          var f = this.getSourceDimension(o);
          f && (l = e ? f.name : null, u = f.type);
        }
        a.push({
          property: l,
          type: u,
          ordinalMeta: c
        }), e && l != null && (!d || !d.isCalculationCoord) && (i += n ? l.replace(/\`/g, "`1").replace(/\$/g, "`2") : l), i += "$", i += VQ[u] || "f", c && (i += c.uid), i += "$";
      }
      var h = this.source, p = [h.seriesLayoutBy, h.startIndex, i].join("$$");
      return {
        dimensions: a,
        hash: p
      };
    }, t.prototype.makeOutputDimensionNames = function() {
      for (var r = [], e = 0, n = 0; e < this._fullDimCount; e++) {
        var i = void 0, a = this.dimensions[n];
        if (a && a.storeDimIndex === e)
          a.isCalculationCoord || (i = a.name), n++;
        else {
          var o = this.getSourceDimension(e);
          o && (i = o.name);
        }
        r.push(i);
      }
      return r;
    }, t.prototype.appendCalculationDimension = function(r) {
      this.dimensions.push(r), r.isCalculationCoord = !0, this._fullDimCount++, this._updateDimOmitted(!0);
    }, t;
  }()
);
function FV(t) {
  return t instanceof BV;
}
function HV(t) {
  for (var r = xe(), e = 0; e < (t || []).length; e++) {
    var n = t[e], i = Me(n) ? n.name : n;
    i != null && r.get(i) == null && r.set(i, e);
  }
  return r;
}
function zV(t) {
  var r = OQ(t);
  return r.dimNameMap || (r.dimNameMap = HV(t.dimensionsDefine));
}
function WV(t) {
  return t > 30;
}
var Uh = Me, pl = ce, GQ = typeof Int32Array > "u" ? Array : Int32Array, BQ = "e\0\0", lA = -1, FQ = ["hasItemOption", "_nameList", "_idList", "_invertedIndicesMap", "_dimSummary", "userOutput", "_rawData", "_dimValueGetter", "_nameDimIdx", "_idDimIdx", "_nameRepeatCount"], HQ = ["_approximateExtent"], uA, x1, Jh, xd, Ab, S1, Db, ni = (
  /** @class */
  function() {
    function t(r, e) {
      this.type = "list", this._dimOmitted = !1, this._nameList = [], this._idList = [], this._visual = {}, this._layout = {}, this._itemVisuals = [], this._itemLayouts = [], this._graphicEls = [], this._approximateExtent = {}, this._calculationInfo = {}, this.hasItemOption = !1, this.TRANSFERABLE_METHODS = ["cloneShallow", "downSample", "lttbDownSample", "map"], this.CHANGABLE_METHODS = ["filterSelf", "selectRange"], this.DOWNSAMPLE_METHODS = ["downSample", "lttbDownSample"];
      var n, i = !1;
      FV(r) ? (n = r.dimensions, this._dimOmitted = r.isDimensionOmitted(), this._schema = r) : (i = !0, n = r), n = n || ["x", "y"];
      for (var a = {}, o = [], s = {}, l = !1, u = {}, c = 0; c < n.length; c++) {
        var d = n[c], f = pe(d) ? new P0({
          name: d
        }) : d instanceof P0 ? d : new P0(d), h = f.name;
        f.type = f.type || "float", f.coordDim || (f.coordDim = h, f.coordDimIndex = 0);
        var p = f.otherDims = f.otherDims || {};
        o.push(h), a[h] = f, u[h] != null && (l = !0), f.createInvertedIndices && (s[h] = []), p.itemName === 0 && (this._nameDimIdx = c), p.itemId === 0 && (this._idDimIdx = c), process.env.NODE_ENV !== "production" && ke(i || f.storeDimIndex >= 0), i && (f.storeDimIndex = c);
      }
      if (this.dimensions = o, this._dimInfos = a, this._initGetDimensionInfo(l), this.hostModel = e, this._invertedIndicesMap = s, this._dimOmitted) {
        var v = this._dimIdxToName = xe();
        L(o, function(g) {
          v.set(a[g].storeDimIndex, g);
        });
      }
    }
    return t.prototype.getDimension = function(r) {
      var e = this._recognizeDimIndex(r);
      if (e == null)
        return r;
      if (e = r, !this._dimOmitted)
        return this.dimensions[e];
      var n = this._dimIdxToName.get(e);
      if (n != null)
        return n;
      var i = this._schema.getSourceDimension(e);
      if (i)
        return i.name;
    }, t.prototype.getDimensionIndex = function(r) {
      var e = this._recognizeDimIndex(r);
      if (e != null)
        return e;
      if (r == null)
        return -1;
      var n = this._getDimInfo(r);
      return n ? n.storeDimIndex : this._dimOmitted ? this._schema.getSourceDimensionIndex(r) : -1;
    }, t.prototype._recognizeDimIndex = function(r) {
      if (Mt(r) || r != null && !isNaN(r) && !this._getDimInfo(r) && (!this._dimOmitted || this._schema.getSourceDimensionIndex(r) < 0))
        return +r;
    }, t.prototype._getStoreDimIndex = function(r) {
      var e = this.getDimensionIndex(r);
      if (process.env.NODE_ENV !== "production" && e == null)
        throw new Error("Unknown dimension " + r);
      return e;
    }, t.prototype.getDimensionInfo = function(r) {
      return this._getDimInfo(this.getDimension(r));
    }, t.prototype._initGetDimensionInfo = function(r) {
      var e = this._dimInfos;
      this._getDimInfo = r ? function(n) {
        return e.hasOwnProperty(n) ? e[n] : void 0;
      } : function(n) {
        return e[n];
      };
    }, t.prototype.getDimensionsOnCoord = function() {
      return this._dimSummary.dataDimsOnCoord.slice();
    }, t.prototype.mapDimension = function(r, e) {
      var n = this._dimSummary;
      if (e == null)
        return n.encodeFirstDimNotExtra[r];
      var i = n.encode[r];
      return i ? i[e] : null;
    }, t.prototype.mapDimensionsAll = function(r) {
      var e = this._dimSummary, n = e.encode[r];
      return (n || []).slice();
    }, t.prototype.getStore = function() {
      return this._store;
    }, t.prototype.initData = function(r, e, n) {
      var i = this, a;
      if (r instanceof n9 && (a = r), !a) {
        var o = this.dimensions, s = cw(r) || Zn(r) ? new FO(r, o.length) : r;
        a = new n9();
        var l = pl(o, function(u) {
          return {
            type: i._dimInfos[u].type,
            property: u
          };
        });
        a.initData(s, l, n);
      }
      this._store = a, this._nameList = (e || []).slice(), this._idList = [], this._nameRepeatCount = {}, this._doInit(0, a.count()), this._dimSummary = PQ(this, this._schema), this.userOutput = this._dimSummary.userOutput;
    }, t.prototype.appendData = function(r) {
      var e = this._store.appendData(r);
      this._doInit(e[0], e[1]);
    }, t.prototype.appendValues = function(r, e) {
      var n = this._store.appendValues(r, e.length), i = n.start, a = n.end, o = this._shouldMakeIdFromName();
      if (this._updateOrdinalMeta(), e)
        for (var s = i; s < a; s++) {
          var l = s - i;
          this._nameList[s] = e[l], o && Db(this, s);
        }
    }, t.prototype._updateOrdinalMeta = function() {
      for (var r = this._store, e = this.dimensions, n = 0; n < e.length; n++) {
        var i = this._dimInfos[e[n]];
        i.ordinalMeta && r.collectOrdinalMeta(i.storeDimIndex, i.ordinalMeta);
      }
    }, t.prototype._shouldMakeIdFromName = function() {
      var r = this._store.getProvider();
      return this._idDimIdx == null && r.getSource().sourceFormat !== Os && !r.fillStorage;
    }, t.prototype._doInit = function(r, e) {
      if (!(r >= e)) {
        var n = this._store, i = n.getProvider();
        this._updateOrdinalMeta();
        var a = this._nameList, o = this._idList, s = i.getSource().sourceFormat, l = s === Na;
        if (l && !i.pure)
          for (var u = [], c = r; c < e; c++) {
            var d = i.getItem(c, u);
            if (!this.hasItemOption && x$(d) && (this.hasItemOption = !0), d) {
              var f = d.name;
              a[c] == null && f != null && (a[c] = vn(f, null));
              var h = d.id;
              o[c] == null && h != null && (o[c] = vn(h, null));
            }
          }
        if (this._shouldMakeIdFromName())
          for (var c = r; c < e; c++)
            Db(this, c);
        uA(this);
      }
    }, t.prototype.getApproximateExtent = function(r) {
      return this._approximateExtent[r] || this._store.getDataExtent(this._getStoreDimIndex(r));
    }, t.prototype.setApproximateExtent = function(r, e) {
      e = this.getDimension(e), this._approximateExtent[e] = r.slice();
    }, t.prototype.getCalculationInfo = function(r) {
      return this._calculationInfo[r];
    }, t.prototype.setCalculationInfo = function(r, e) {
      Uh(r) ? ae(this._calculationInfo, r) : this._calculationInfo[r] = e;
    }, t.prototype.getName = function(r) {
      var e = this.getRawIndex(r), n = this._nameList[e];
      return n == null && this._nameDimIdx != null && (n = Jh(this, this._nameDimIdx, e)), n == null && (n = ""), n;
    }, t.prototype._getCategory = function(r, e) {
      var n = this._store.get(r, e), i = this._store.getOrdinalMeta(r);
      return i ? i.categories[n] : n;
    }, t.prototype.getId = function(r) {
      return x1(this, this.getRawIndex(r));
    }, t.prototype.count = function() {
      return this._store.count();
    }, t.prototype.get = function(r, e) {
      var n = this._store, i = this._dimInfos[r];
      if (i)
        return n.get(i.storeDimIndex, e);
    }, t.prototype.getByRawIndex = function(r, e) {
      var n = this._store, i = this._dimInfos[r];
      if (i)
        return n.getByRawIndex(i.storeDimIndex, e);
    }, t.prototype.getIndices = function() {
      return this._store.getIndices();
    }, t.prototype.getDataExtent = function(r) {
      return this._store.getDataExtent(this._getStoreDimIndex(r));
    }, t.prototype.getSum = function(r) {
      return this._store.getSum(this._getStoreDimIndex(r));
    }, t.prototype.getMedian = function(r) {
      return this._store.getMedian(this._getStoreDimIndex(r));
    }, t.prototype.getValues = function(r, e) {
      var n = this, i = this._store;
      return ue(r) ? i.getValues(pl(r, function(a) {
        return n._getStoreDimIndex(a);
      }), e) : i.getValues(r);
    }, t.prototype.hasValue = function(r) {
      for (var e = this._dimSummary.dataDimIndicesOnCoord, n = 0, i = e.length; n < i; n++)
        if (isNaN(this._store.get(e[n], r)))
          return !1;
      return !0;
    }, t.prototype.indexOfName = function(r) {
      for (var e = 0, n = this._store.count(); e < n; e++)
        if (this.getName(e) === r)
          return e;
      return -1;
    }, t.prototype.getRawIndex = function(r) {
      return this._store.getRawIndex(r);
    }, t.prototype.indexOfRawIndex = function(r) {
      return this._store.indexOfRawIndex(r);
    }, t.prototype.rawIndexOf = function(r, e) {
      var n = r && this._invertedIndicesMap[r];
      if (process.env.NODE_ENV !== "production" && !n)
        throw new Error("Do not supported yet");
      var i = n[e];
      return i == null || isNaN(i) ? lA : i;
    }, t.prototype.indicesOfNearest = function(r, e, n) {
      return this._store.indicesOfNearest(this._getStoreDimIndex(r), e, n);
    }, t.prototype.each = function(r, e, n) {
      Ae(r) && (n = e, e = r, r = []);
      var i = n || this, a = pl(xd(r), this._getStoreDimIndex, this);
      this._store.each(a, i ? ye(e, i) : e);
    }, t.prototype.filterSelf = function(r, e, n) {
      Ae(r) && (n = e, e = r, r = []);
      var i = n || this, a = pl(xd(r), this._getStoreDimIndex, this);
      return this._store = this._store.filter(a, i ? ye(e, i) : e), this;
    }, t.prototype.selectRange = function(r) {
      var e = this, n = {}, i = yt(r);
      return L(i, function(a) {
        var o = e._getStoreDimIndex(a);
        n[o] = r[a];
      }), this._store = this._store.selectRange(n), this;
    }, t.prototype.mapArray = function(r, e, n) {
      Ae(r) && (n = e, e = r, r = []), n = n || this;
      var i = [];
      return this.each(r, function() {
        i.push(e && e.apply(this, arguments));
      }, n), i;
    }, t.prototype.map = function(r, e, n, i) {
      var a = n || i || this, o = pl(xd(r), this._getStoreDimIndex, this), s = S1(this);
      return s._store = this._store.map(o, a ? ye(e, a) : e), s;
    }, t.prototype.modify = function(r, e, n, i) {
      var a = this, o = n || i || this;
      process.env.NODE_ENV !== "production" && L(xd(r), function(l) {
        var u = a.getDimensionInfo(l);
        u.isCalculationCoord || console.error("Danger: only stack dimension can be modified");
      });
      var s = pl(xd(r), this._getStoreDimIndex, this);
      this._store.modify(s, o ? ye(e, o) : e);
    }, t.prototype.downSample = function(r, e, n, i) {
      var a = S1(this);
      return a._store = this._store.downSample(this._getStoreDimIndex(r), e, n, i), a;
    }, t.prototype.lttbDownSample = function(r, e) {
      var n = S1(this);
      return n._store = this._store.lttbDownSample(this._getStoreDimIndex(r), e), n;
    }, t.prototype.getRawDataItem = function(r) {
      return this._store.getRawDataItem(r);
    }, t.prototype.getItemModel = function(r) {
      var e = this.hostModel, n = this.getRawDataItem(r);
      return new Pt(n, e, e && e.ecModel);
    }, t.prototype.diff = function(r) {
      var e = this;
      return new Us(r ? r.getStore().getIndices() : [], this.getStore().getIndices(), function(n) {
        return x1(r, n);
      }, function(n) {
        return x1(e, n);
      });
    }, t.prototype.getVisual = function(r) {
      var e = this._visual;
      return e && e[r];
    }, t.prototype.setVisual = function(r, e) {
      this._visual = this._visual || {}, Uh(r) ? ae(this._visual, r) : this._visual[r] = e;
    }, t.prototype.getItemVisual = function(r, e) {
      var n = this._itemVisuals[r], i = n && n[e];
      return i ?? this.getVisual(e);
    }, t.prototype.hasItemVisual = function() {
      return this._itemVisuals.length > 0;
    }, t.prototype.ensureUniqueItemVisual = function(r, e) {
      var n = this._itemVisuals, i = n[r];
      i || (i = n[r] = {});
      var a = i[e];
      return a == null && (a = this.getVisual(e), ue(a) ? a = a.slice() : Uh(a) && (a = ae({}, a)), i[e] = a), a;
    }, t.prototype.setItemVisual = function(r, e, n) {
      var i = this._itemVisuals[r] || {};
      this._itemVisuals[r] = i, Uh(e) ? ae(i, e) : i[e] = n;
    }, t.prototype.clearAllVisual = function() {
      this._visual = {}, this._itemVisuals = [];
    }, t.prototype.setLayout = function(r, e) {
      Uh(r) ? ae(this._layout, r) : this._layout[r] = e;
    }, t.prototype.getLayout = function(r) {
      return this._layout[r];
    }, t.prototype.getItemLayout = function(r) {
      return this._itemLayouts[r];
    }, t.prototype.setItemLayout = function(r, e, n) {
      this._itemLayouts[r] = n ? ae(this._itemLayouts[r] || {}, e) : e;
    }, t.prototype.clearItemLayouts = function() {
      this._itemLayouts.length = 0;
    }, t.prototype.setItemGraphicEl = function(r, e) {
      var n = this.hostModel && this.hostModel.seriesIndex;
      WC(n, this.dataType, r, e), this._graphicEls[r] = e;
    }, t.prototype.getItemGraphicEl = function(r) {
      return this._graphicEls[r];
    }, t.prototype.eachItemGraphicEl = function(r, e) {
      L(this._graphicEls, function(n, i) {
        n && r && r.call(e, n, i);
      });
    }, t.prototype.cloneShallow = function(r) {
      return r || (r = new t(this._schema ? this._schema : pl(this.dimensions, this._getDimInfo, this), this.hostModel)), Ab(r, this), r._store = this._store, r;
    }, t.prototype.wrapMethod = function(r, e) {
      var n = this[r];
      Ae(n) && (this.__wrappedMethods = this.__wrappedMethods || [], this.__wrappedMethods.push(r), this[r] = function() {
        var i = n.apply(this, arguments);
        return e.apply(this, [i].concat(Uy(arguments)));
      });
    }, t.internalField = function() {
      uA = function(r) {
        var e = r._invertedIndicesMap;
        L(e, function(n, i) {
          var a = r._dimInfos[i], o = a.ordinalMeta, s = r._store;
          if (o) {
            n = e[i] = new GQ(o.categories.length);
            for (var l = 0; l < n.length; l++)
              n[l] = lA;
            for (var l = 0; l < s.count(); l++)
              n[s.get(a.storeDimIndex, l)] = l;
          }
        });
      }, Jh = function(r, e, n) {
        return vn(r._getCategory(e, n), null);
      }, x1 = function(r, e) {
        var n = r._idList[e];
        return n == null && r._idDimIdx != null && (n = Jh(r, r._idDimIdx, e)), n == null && (n = BQ + e), n;
      }, xd = function(r) {
        return ue(r) || (r = r != null ? [r] : []), r;
      }, S1 = function(r) {
        var e = new t(r._schema ? r._schema : pl(r.dimensions, r._getDimInfo, r), r.hostModel);
        return Ab(e, r), e;
      }, Ab = function(r, e) {
        L(FQ.concat(e.__wrappedMethods || []), function(n) {
          e.hasOwnProperty(n) && (r[n] = e[n]);
        }), r.__wrappedMethods = e.__wrappedMethods, L(HQ, function(n) {
          r[n] = Ge(e[n]);
        }), r._calculationInfo = ae({}, e._calculationInfo);
      }, Db = function(r, e) {
        var n = r._nameList, i = r._idList, a = r._nameDimIdx, o = r._idDimIdx, s = n[e], l = i[e];
        if (s == null && a != null && (n[e] = s = Jh(r, a, e)), l == null && o != null && (i[e] = l = Jh(r, o, e)), l == null && s != null) {
          var u = r._nameRepeatCount, c = u[s] = (u[s] || 0) + 1;
          l = s, c > 1 && (l += "__ec__" + c), i[e] = l;
        }
      };
    }(), t;
  }()
);
function zQ(t, r) {
  return hh(t, r).dimensions;
}
function hh(t, r) {
  cw(t) || (t = dw(t)), r = r || {};
  var e = r.coordDimensions || [], n = r.dimensionsDefine || t.dimensionsDefine || [], i = xe(), a = [], o = ZQ(t, e, n, r.dimensionsCount), s = r.canOmitUnusedDimensions && WV(o), l = n === t.dimensionsDefine, u = l ? zV(t) : HV(n), c = r.encodeDefine;
  !c && r.encodeDefaulter && (c = r.encodeDefaulter(t, o));
  for (var d = xe(c), f = new $O(o), h = 0; h < f.length; h++)
    f[h] = -1;
  function p(D) {
    var T = f[D];
    if (T < 0) {
      var A = n[D], M = Me(A) ? A : {
        name: A
      }, R = new P0(), E = M.name;
      E != null && u.get(E) != null && (R.name = R.displayName = E), M.type != null && (R.type = M.type), M.displayName != null && (R.displayName = M.displayName);
      var k = a.length;
      return f[D] = k, R.storeDimIndex = D, a.push(R), R;
    }
    return a[T];
  }
  if (!s)
    for (var h = 0; h < o; h++)
      p(h);
  d.each(function(D, T) {
    var A = Qt(D).slice();
    if (A.length === 1 && !pe(A[0]) && A[0] < 0) {
      d.set(T, !1);
      return;
    }
    var M = d.set(T, []);
    L(A, function(R, E) {
      var k = pe(R) ? u.get(R) : R;
      k != null && k < o && (M[E] = k, g(p(k), T, E));
    });
  });
  var v = 0;
  L(e, function(D) {
    var T, A, M, R;
    if (pe(D))
      T = D, R = {};
    else {
      R = D, T = R.name;
      var E = R.ordinalMeta;
      R.ordinalMeta = null, R = ae({}, R), R.ordinalMeta = E, A = R.dimsDef, M = R.otherDims, R.name = R.coordDim = R.coordDimIndex = R.dimsDef = R.otherDims = null;
    }
    var k = d.get(T);
    if (k !== !1) {
      if (k = Qt(k), !k.length)
        for (var P = 0; P < (A && A.length || 1); P++) {
          for (; v < o && p(v).coordDim != null; )
            v++;
          v < o && k.push(v++);
        }
      L(k, function(N, O) {
        var W = p(N);
        if (l && R.type != null && (W.type = R.type), g(Ee(W, R), T, O), W.name == null && A) {
          var V = A[O];
          !Me(V) && (V = {
            name: V
          }), W.name = W.displayName = V.name, W.defaultTooltip = V.defaultTooltip;
        }
        M && Ee(W.otherDims, M);
      });
    }
  });
  function g(D, T, A) {
    QC.get(T) != null ? D.otherDims[T] = A : (D.coordDim = T, D.coordDimIndex = A, i.set(T, !0));
  }
  var m = r.generateCoord, y = r.generateCoordCount, b = y != null;
  y = m ? y || 1 : 0;
  var C = m || "value";
  function w(D) {
    D.name == null && (D.name = D.coordDim);
  }
  if (s)
    L(a, function(D) {
      w(D);
    }), a.sort(function(D, T) {
      return D.storeDimIndex - T.storeDimIndex;
    });
  else
    for (var _ = 0; _ < o; _++) {
      var x = p(_), I = x.coordDim;
      I == null && (x.coordDim = jQ(C, i, b), x.coordDimIndex = 0, (!m || y <= 0) && (x.isExtraCoord = !0), y--), w(x), x.type == null && (EO(t, _) === Bn.Must || x.isExtraCoord && (x.otherDims.itemName != null || x.otherDims.seriesName != null)) && (x.type = "ordinal");
    }
  return WQ(a), new BV({
    source: t,
    dimensions: a,
    fullDimensionCount: o,
    dimensionOmitted: s
  });
}
function WQ(t) {
  for (var r = xe(), e = 0; e < t.length; e++) {
    var n = t[e], i = n.name, a = r.get(i) || 0;
    a > 0 && (n.name = i + (a - 1)), a++, r.set(i, a);
  }
}
function ZQ(t, r, e, n) {
  var i = Math.max(t.dimensionsDetectedCount || 1, r.length, e.length, n || 0);
  return L(r, function(a) {
    var o;
    Me(a) && (o = a.dimsDef) && (i = Math.max(i, o.length));
  }), i;
}
function jQ(t, r, e) {
  if (e || r.hasKey(t)) {
    for (var n = 0; r.hasKey(t + n); )
      n++;
    t += n;
  }
  return r.set(t, !0), t;
}
var YQ = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(r) {
      this.coordSysDims = [], this.axisMap = xe(), this.categoryAxisMap = xe(), this.coordSysName = r;
    }
    return t;
  }()
);
function XQ(t) {
  var r = t.get("coordinateSystem"), e = new YQ(r), n = $Q[r];
  if (n)
    return n(t, e, e.axisMap, e.categoryAxisMap), e;
}
var $Q = {
  cartesian2d: function(t, r, e, n) {
    var i = t.getReferringComponents("xAxis", on).models[0], a = t.getReferringComponents("yAxis", on).models[0];
    if (process.env.NODE_ENV !== "production") {
      if (!i)
        throw new Error('xAxis "' + Qr(t.get("xAxisIndex"), t.get("xAxisId"), 0) + '" not found');
      if (!a)
        throw new Error('yAxis "' + Qr(t.get("xAxisIndex"), t.get("yAxisId"), 0) + '" not found');
    }
    r.coordSysDims = ["x", "y"], e.set("x", i), e.set("y", a), Sd(i) && (n.set("x", i), r.firstCategoryDimIndex = 0), Sd(a) && (n.set("y", a), r.firstCategoryDimIndex == null && (r.firstCategoryDimIndex = 1));
  },
  singleAxis: function(t, r, e, n) {
    var i = t.getReferringComponents("singleAxis", on).models[0];
    if (process.env.NODE_ENV !== "production" && !i)
      throw new Error("singleAxis should be specified.");
    r.coordSysDims = ["single"], e.set("single", i), Sd(i) && (n.set("single", i), r.firstCategoryDimIndex = 0);
  },
  polar: function(t, r, e, n) {
    var i = t.getReferringComponents("polar", on).models[0], a = i.findAxisModel("radiusAxis"), o = i.findAxisModel("angleAxis");
    if (process.env.NODE_ENV !== "production") {
      if (!o)
        throw new Error("angleAxis option not found");
      if (!a)
        throw new Error("radiusAxis option not found");
    }
    r.coordSysDims = ["radius", "angle"], e.set("radius", a), e.set("angle", o), Sd(a) && (n.set("radius", a), r.firstCategoryDimIndex = 0), Sd(o) && (n.set("angle", o), r.firstCategoryDimIndex == null && (r.firstCategoryDimIndex = 1));
  },
  geo: function(t, r, e, n) {
    r.coordSysDims = ["lng", "lat"];
  },
  parallel: function(t, r, e, n) {
    var i = t.ecModel, a = i.getComponent("parallel", t.get("parallelIndex")), o = r.coordSysDims = a.dimensions.slice();
    L(a.parallelAxisIndex, function(s, l) {
      var u = i.getComponent("parallelAxis", s), c = o[l];
      e.set(c, u), Sd(u) && (n.set(c, u), r.firstCategoryDimIndex == null && (r.firstCategoryDimIndex = l));
    });
  }
};
function Sd(t) {
  return t.get("type") === "category";
}
function ZV(t, r, e) {
  e = e || {};
  var n = e.byIndex, i = e.stackedCoordDimension, a, o, s;
  UQ(r) ? a = r : (o = r.schema, a = o.dimensions, s = r.store);
  var l = !!(t && t.get("stack")), u, c, d, f;
  if (L(a, function(y, b) {
    pe(y) && (a[b] = y = {
      name: y
    }), l && !y.isExtraCoord && (!n && !u && y.ordinalMeta && (u = y), !c && y.type !== "ordinal" && y.type !== "time" && (!i || i === y.coordDim) && (c = y));
  }), c && !n && !u && (n = !0), c) {
    d = "__\0ecstackresult_" + t.id, f = "__\0ecstackedover_" + t.id, u && (u.createInvertedIndices = !0);
    var h = c.coordDim, p = c.type, v = 0;
    L(a, function(y) {
      y.coordDim === h && v++;
    });
    var g = {
      name: d,
      coordDim: h,
      coordDimIndex: v,
      type: p,
      isExtraCoord: !0,
      isCalculationCoord: !0,
      storeDimIndex: a.length
    }, m = {
      name: f,
      // This dimension contains stack base (generally, 0), so do not set it as
      // `stackedDimCoordDim` to avoid extent calculation, consider log scale.
      coordDim: f,
      coordDimIndex: v + 1,
      type: p,
      isExtraCoord: !0,
      isCalculationCoord: !0,
      storeDimIndex: a.length + 1
    };
    o ? (s && (g.storeDimIndex = s.ensureCalculationDimension(f, p), m.storeDimIndex = s.ensureCalculationDimension(d, p)), o.appendCalculationDimension(g), o.appendCalculationDimension(m)) : (a.push(g), a.push(m));
  }
  return {
    stackedDimension: c && c.name,
    stackedByDimension: u && u.name,
    isStackedByIndex: n,
    stackedOverDimension: f,
    stackResultDimension: d
  };
}
function UQ(t) {
  return !FV(t.schema);
}
function Js(t, r) {
  return !!r && r === t.getCalculationInfo("stackedDimension");
}
function Aw(t, r) {
  return Js(t, r) ? t.getCalculationInfo("stackResultDimension") : r;
}
function JQ(t, r) {
  var e = t.get("coordinateSystem"), n = ed.get(e), i;
  return r && r.coordSysDims && (i = ce(r.coordSysDims, function(a) {
    var o = {
      name: a
    }, s = r.axisMap.get(a);
    if (s) {
      var l = s.get("type");
      o.type = Vm(l);
    }
    return o;
  })), i || (i = n && (n.getDimensionsInfo ? n.getDimensionsInfo() : n.dimensions.slice()) || ["x", "y"]), i;
}
function KQ(t, r, e) {
  var n, i;
  return e && L(t, function(a, o) {
    var s = a.coordDim, l = e.categoryAxisMap.get(s);
    l && (n == null && (n = o), a.ordinalMeta = l.getOrdinalMeta(), r && (a.createInvertedIndices = !0)), a.otherDims.itemName != null && (i = !0);
  }), !i && n != null && (t[n].otherDims.itemName = 0), n;
}
function os(t, r, e) {
  e = e || {};
  var n = r.getSourceManager(), i, a = !1;
  t ? (a = !0, i = dw(t)) : (i = n.getSource(), a = i.sourceFormat === Na);
  var o = XQ(r), s = JQ(r, o), l = e.useEncodeDefaulter, u = Ae(l) ? l : l ? Ye(LO, s, r) : null, c = {
    coordDimensions: s,
    generateCoord: e.generateCoord,
    encodeDefine: r.getEncode(),
    encodeDefaulter: u,
    canOmitUnusedDimensions: !a
  }, d = hh(i, c), f = KQ(d.dimensions, e.createInvertedIndices, o), h = a ? null : n.getSharedDataStore(d), p = ZV(r, {
    schema: d,
    store: h
  }), v = new ni(d, r);
  v.setCalculationInfo(p);
  var g = f != null && qQ(i) ? function(m, y, b, C) {
    return C === f ? b : this.defaultDimValueGetter(m, y, b, C);
  } : null;
  return v.hasItemOption = !1, v.initData(
    // Try to reuse the data store in sourceManager if using dataset.
    a ? i : h,
    null,
    g
  ), v;
}
function qQ(t) {
  if (t.sourceFormat === Na) {
    var r = QQ(t.data || []);
    return !ue(qf(r));
  }
}
function QQ(t) {
  for (var r = 0; r < t.length && t[r] == null; )
    r++;
  return t[r];
}
var ss = (
  /** @class */
  function() {
    function t(r) {
      this._setting = r || {}, this._extent = [1 / 0, -1 / 0];
    }
    return t.prototype.getSetting = function(r) {
      return this._setting[r];
    }, t.prototype.unionExtent = function(r) {
      var e = this._extent;
      r[0] < e[0] && (e[0] = r[0]), r[1] > e[1] && (e[1] = r[1]);
    }, t.prototype.unionExtentFromData = function(r, e) {
      this.unionExtent(r.getApproximateExtent(e));
    }, t.prototype.getExtent = function() {
      return this._extent.slice();
    }, t.prototype.setExtent = function(r, e) {
      var n = this._extent;
      isNaN(r) || (n[0] = r), isNaN(e) || (n[1] = e);
    }, t.prototype.isInExtentRange = function(r) {
      return this._extent[0] <= r && this._extent[1] >= r;
    }, t.prototype.isBlank = function() {
      return this._isBlank;
    }, t.prototype.setBlank = function(r) {
      this._isBlank = r;
    }, t;
  }()
);
i2(ss);
var eee = 0, h9 = (
  /** @class */
  function() {
    function t(r) {
      this.categories = r.categories || [], this._needCollect = r.needCollect, this._deduplication = r.deduplication, this.uid = ++eee;
    }
    return t.createByAxisModel = function(r) {
      var e = r.option, n = e.data, i = n && ce(n, tee);
      return new t({
        categories: i,
        needCollect: !i,
        // deduplication is default in axis.
        deduplication: e.dedplication !== !1
      });
    }, t.prototype.getOrdinal = function(r) {
      return this._getOrCreateMap().get(r);
    }, t.prototype.parseAndCollect = function(r) {
      var e, n = this._needCollect;
      if (!pe(r) && !n)
        return r;
      if (n && !this._deduplication)
        return e = this.categories.length, this.categories[e] = r, e;
      var i = this._getOrCreateMap();
      return e = i.get(r), e == null && (n ? (e = this.categories.length, this.categories[e] = r, i.set(r, e)) : e = NaN), e;
    }, t.prototype._getOrCreateMap = function() {
      return this._map || (this._map = xe(this.categories));
    }, t;
  }()
);
function tee(t) {
  return Me(t) && t.value != null ? t.value : t + "";
}
function ree(t) {
  var r = Math.pow(10, dg(Math.abs(t))), e = Math.abs(t / r);
  return e === 0 || e === 1 || e === 2 || e === 3 || e === 5;
}
function p9(t) {
  return t.type === "interval" || t.type === "log";
}
function nee(t, r, e, n) {
  var i = {}, a = t[1] - t[0], o = i.interval = E7(a / r, !0);
  e != null && o < e && (o = i.interval = e), n != null && o > n && (o = i.interval = n);
  var s = i.intervalPrecision = jV(o), l = i.niceTickExtent = [Or(Math.ceil(t[0] / o) * o, s), Or(Math.floor(t[1] / o) * o, s)];
  return iee(l, t), i;
}
function Tb(t) {
  var r = Math.pow(10, dg(t)), e = t / r;
  return e ? e === 2 ? e = 3 : e === 3 ? e = 5 : e *= 2 : e = 1, Or(e * r);
}
function jV(t) {
  return Ya(t) + 2;
}
function cA(t, r, e) {
  t[r] = Math.max(Math.min(t[r], e[1]), e[0]);
}
function iee(t, r) {
  !isFinite(t[0]) && (t[0] = r[0]), !isFinite(t[1]) && (t[1] = r[1]), cA(t, 0, r), cA(t, 1, r), t[0] > t[1] && (t[0] = t[1]);
}
function I2(t, r) {
  return t >= r[0] && t <= r[1];
}
function A2(t, r) {
  return r[1] === r[0] ? 0.5 : (t - r[0]) / (r[1] - r[0]);
}
function D2(t, r) {
  return t * (r[1] - r[0]) + r[0];
}
var T2 = (
  /** @class */
  function(t) {
    ee(r, t);
    function r(e) {
      var n = t.call(this, e) || this;
      n.type = "ordinal";
      var i = n.getSetting("ordinalMeta");
      return i || (i = new h9({})), ue(i) && (i = new h9({
        categories: ce(i, function(a) {
          return Me(a) ? a.value : a;
        })
      })), n._ordinalMeta = i, n._extent = n.getSetting("extent") || [0, i.categories.length - 1], n;
    }
    return r.prototype.parse = function(e) {
      return e == null ? NaN : pe(e) ? this._ordinalMeta.getOrdinal(e) : Math.round(e);
    }, r.prototype.contain = function(e) {
      return e = this.parse(e), I2(e, this._extent) && this._ordinalMeta.categories[e] != null;
    }, r.prototype.normalize = function(e) {
      return e = this._getTickNumber(this.parse(e)), A2(e, this._extent);
    }, r.prototype.scale = function(e) {
      return e = Math.round(D2(e, this._extent)), this.getRawOrdinalNumber(e);
    }, r.prototype.getTicks = function() {
      for (var e = [], n = this._extent, i = n[0]; i <= n[1]; )
        e.push({
          value: i
        }), i++;
      return e;
    }, r.prototype.getMinorTicks = function(e) {
    }, r.prototype.setSortInfo = function(e) {
      if (e == null) {
        this._ordinalNumbersByTick = this._ticksByOrdinalNumber = null;
        return;
      }
      for (var n = e.ordinalNumbers, i = this._ordinalNumbersByTick = [], a = this._ticksByOrdinalNumber = [], o = 0, s = this._ordinalMeta.categories.length, l = Math.min(s, n.length); o < l; ++o) {
        var u = n[o];
        i[o] = u, a[u] = o;
      }
      for (var c = 0; o < s; ++o) {
        for (; a[c] != null; )
          c++;
        i.push(c), a[c] = o;
      }
    }, r.prototype._getTickNumber = function(e) {
      var n = this._ticksByOrdinalNumber;
      return n && e >= 0 && e < n.length ? n[e] : e;
    }, r.prototype.getRawOrdinalNumber = function(e) {
      var n = this._ordinalNumbersByTick;
      return n && e >= 0 && e < n.length ? n[e] : e;
    }, r.prototype.getLabel = function(e) {
      if (!this.isBlank()) {
        var n = this.getRawOrdinalNumber(e.value), i = this._ordinalMeta.categories[n];
        return i == null ? "" : i + "";
      }
    }, r.prototype.count = function() {
      return this._extent[1] - this._extent[0] + 1;
    }, r.prototype.unionExtentFromData = function(e, n) {
      this.unionExtent(e.getApproximateExtent(n));
    }, r.prototype.isInExtentRange = function(e) {
      return e = this._getTickNumber(e), this._extent[0] <= e && this._extent[1] >= e;
    }, r.prototype.getOrdinalMeta = function() {
      return this._ordinalMeta;
    }, r.prototype.calcNiceTicks = function() {
    }, r.prototype.calcNiceExtent = function() {
    }, r.type = "ordinal", r;
  }(ss)
);
ss.registerClass(T2);
var Hu = Or, Ks = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = "interval", e._interval = 0, e._intervalPrecision = 2, e;
    }
    return r.prototype.parse = function(e) {
      return e;
    }, r.prototype.contain = function(e) {
      return I2(e, this._extent);
    }, r.prototype.normalize = function(e) {
      return A2(e, this._extent);
    }, r.prototype.scale = function(e) {
      return D2(e, this._extent);
    }, r.prototype.setExtent = function(e, n) {
      var i = this._extent;
      isNaN(e) || (i[0] = parseFloat(e)), isNaN(n) || (i[1] = parseFloat(n));
    }, r.prototype.unionExtent = function(e) {
      var n = this._extent;
      e[0] < n[0] && (n[0] = e[0]), e[1] > n[1] && (n[1] = e[1]), this.setExtent(n[0], n[1]);
    }, r.prototype.getInterval = function() {
      return this._interval;
    }, r.prototype.setInterval = function(e) {
      this._interval = e, this._niceExtent = this._extent.slice(), this._intervalPrecision = jV(e);
    }, r.prototype.getTicks = function(e) {
      var n = this._interval, i = this._extent, a = this._niceExtent, o = this._intervalPrecision, s = [];
      if (!n)
        return s;
      var l = 1e4;
      i[0] < a[0] && (e ? s.push({
        value: Hu(a[0] - n, o)
      }) : s.push({
        value: i[0]
      }));
      for (var u = a[0]; u <= a[1] && (s.push({
        value: u
      }), u = Hu(u + n, o), u !== s[s.length - 1].value); )
        if (s.length > l)
          return [];
      var c = s.length ? s[s.length - 1].value : a[1];
      return i[1] > c && (e ? s.push({
        value: Hu(c + n, o)
      }) : s.push({
        value: i[1]
      })), s;
    }, r.prototype.getMinorTicks = function(e) {
      for (var n = this.getTicks(!0), i = [], a = this.getExtent(), o = 1; o < n.length; o++) {
        for (var s = n[o], l = n[o - 1], u = 0, c = [], d = s.value - l.value, f = d / e; u < e - 1; ) {
          var h = Hu(l.value + (u + 1) * f);
          h > a[0] && h < a[1] && c.push(h), u++;
        }
        i.push(c);
      }
      return i;
    }, r.prototype.getLabel = function(e, n) {
      if (e == null)
        return "";
      var i = n && n.precision;
      i == null ? i = Ya(e.value) || 0 : i === "auto" && (i = this._intervalPrecision);
      var a = Hu(e.value, i, !0);
      return rw(a);
    }, r.prototype.calcNiceTicks = function(e, n, i) {
      e = e || 5;
      var a = this._extent, o = a[1] - a[0];
      if (isFinite(o)) {
        o < 0 && (o = -o, a.reverse());
        var s = nee(a, e, n, i);
        this._intervalPrecision = s.intervalPrecision, this._interval = s.interval, this._niceExtent = s.niceTickExtent;
      }
    }, r.prototype.calcNiceExtent = function(e) {
      var n = this._extent;
      if (n[0] === n[1])
        if (n[0] !== 0) {
          var i = Math.abs(n[0]);
          e.fixMax || (n[1] += i / 2), n[0] -= i / 2;
        } else
          n[1] = 1;
      var a = n[1] - n[0];
      isFinite(a) || (n[0] = 0, n[1] = 1), this.calcNiceTicks(e.splitNumber, e.minInterval, e.maxInterval);
      var o = this._interval;
      e.fixMin || (n[0] = Hu(Math.floor(n[0] / o) * o)), e.fixMax || (n[1] = Hu(Math.ceil(n[1] / o) * o));
    }, r.prototype.setNiceExtent = function(e, n) {
      this._niceExtent = [e, n];
    }, r.type = "interval", r;
  }(ss)
);
ss.registerClass(Ks);
var YV = typeof Float32Array < "u", aee = YV ? Float32Array : Array;
function Oo(t) {
  return ue(t) ? YV ? new Float32Array(t) : t : new aee(t);
}
var v9 = "__ec_stack_";
function Dw(t) {
  return t.get("stack") || v9 + t.seriesIndex;
}
function Tw(t) {
  return t.dim + t.index;
}
function oee(t) {
  var r = [], e = t.axis, n = "axis0";
  if (e.type === "category") {
    for (var i = e.getBandWidth(), a = 0; a < t.count; a++)
      r.push(Ee({
        bandWidth: i,
        axisKey: n,
        stackId: v9 + a
      }, t));
    for (var o = UV(r), s = [], a = 0; a < t.count; a++) {
      var l = o[n][v9 + a];
      l.offsetCenter = l.offset + l.width / 2, s.push(l);
    }
    return s;
  }
}
function XV(t, r) {
  var e = [];
  return r.eachSeriesByType(t, function(n) {
    qV(n) && e.push(n);
  }), e;
}
function see(t) {
  var r = {};
  L(t, function(l) {
    var u = l.coordinateSystem, c = u.getBaseAxis();
    if (!(c.type !== "time" && c.type !== "value"))
      for (var d = l.getData(), f = c.dim + "_" + c.index, h = d.getDimensionIndex(d.mapDimension(c.dim)), p = d.getStore(), v = 0, g = p.count(); v < g; ++v) {
        var m = p.get(h, v);
        r[f] ? r[f].push(m) : r[f] = [m];
      }
  });
  var e = {};
  for (var n in r)
    if (r.hasOwnProperty(n)) {
      var i = r[n];
      if (i) {
        i.sort(function(l, u) {
          return l - u;
        });
        for (var a = null, o = 1; o < i.length; ++o) {
          var s = i[o] - i[o - 1];
          s > 0 && (a = a === null ? s : Math.min(a, s));
        }
        e[n] = a;
      }
    }
  return e;
}
function $V(t) {
  var r = see(t), e = [];
  return L(t, function(n) {
    var i = n.coordinateSystem, a = i.getBaseAxis(), o = a.getExtent(), s;
    if (a.type === "category")
      s = a.getBandWidth();
    else if (a.type === "value" || a.type === "time") {
      var l = a.dim + "_" + a.index, u = r[l], c = Math.abs(o[1] - o[0]), d = a.scale.getExtent(), f = Math.abs(d[1] - d[0]);
      s = u ? c / f * u : c;
    } else {
      var h = n.getData();
      s = Math.abs(o[1] - o[0]) / h.count();
    }
    var p = he(n.get("barWidth"), s), v = he(n.get("barMaxWidth"), s), g = he(
      // barMinWidth by default is 0.5 / 1 in cartesian. Because in value axis,
      // the auto-calculated bar width might be less than 0.5 / 1.
      n.get("barMinWidth") || (QV(n) ? 0.5 : 1),
      s
    ), m = n.get("barGap"), y = n.get("barCategoryGap");
    e.push({
      bandWidth: s,
      barWidth: p,
      barMaxWidth: v,
      barMinWidth: g,
      barGap: m,
      barCategoryGap: y,
      axisKey: Tw(a),
      stackId: Dw(n)
    });
  }), UV(e);
}
function UV(t) {
  var r = {};
  L(t, function(n, i) {
    var a = n.axisKey, o = n.bandWidth, s = r[a] || {
      bandWidth: o,
      remainedWidth: o,
      autoWidthCount: 0,
      categoryGap: null,
      gap: "20%",
      stacks: {}
    }, l = s.stacks;
    r[a] = s;
    var u = n.stackId;
    l[u] || s.autoWidthCount++, l[u] = l[u] || {
      width: 0,
      maxWidth: 0
    };
    var c = n.barWidth;
    c && !l[u].width && (l[u].width = c, c = Math.min(s.remainedWidth, c), s.remainedWidth -= c);
    var d = n.barMaxWidth;
    d && (l[u].maxWidth = d);
    var f = n.barMinWidth;
    f && (l[u].minWidth = f);
    var h = n.barGap;
    h != null && (s.gap = h);
    var p = n.barCategoryGap;
    p != null && (s.categoryGap = p);
  });
  var e = {};
  return L(r, function(n, i) {
    e[i] = {};
    var a = n.stacks, o = n.bandWidth, s = n.categoryGap;
    if (s == null) {
      var l = yt(a).length;
      s = Math.max(35 - l * 4, 15) + "%";
    }
    var u = he(s, o), c = he(n.gap, 1), d = n.remainedWidth, f = n.autoWidthCount, h = (d - u) / (f + (f - 1) * c);
    h = Math.max(h, 0), L(a, function(m) {
      var y = m.maxWidth, b = m.minWidth;
      if (m.width) {
        var C = m.width;
        y && (C = Math.min(C, y)), b && (C = Math.max(C, b)), m.width = C, d -= C + c * C, f--;
      } else {
        var C = h;
        y && y < C && (C = Math.min(y, d)), b && b > C && (C = b), C !== h && (m.width = C, d -= C + c * C, f--);
      }
    }), h = (d - u) / (f + (f - 1) * c), h = Math.max(h, 0);
    var p = 0, v;
    L(a, function(m, y) {
      m.width || (m.width = h), v = m, p += m.width * (1 + c);
    }), v && (p -= v.width * c);
    var g = -p / 2;
    L(a, function(m, y) {
      e[i][y] = e[i][y] || {
        bandWidth: o,
        offset: g,
        width: m.width
      }, g += m.width * (1 + c);
    });
  }), e;
}
function lee(t, r, e) {
  if (t && r) {
    var n = t[Tw(r)];
    return n != null && e != null ? n[Dw(e)] : n;
  }
}
function JV(t, r) {
  var e = XV(t, r), n = $V(e);
  L(e, function(i) {
    var a = i.getData(), o = i.coordinateSystem, s = o.getBaseAxis(), l = Dw(i), u = n[Tw(s)][l], c = u.offset, d = u.width;
    a.setLayout({
      bandWidth: u.bandWidth,
      offset: c,
      size: d
    });
  });
}
function KV(t) {
  return {
    seriesType: t,
    plan: ch(),
    reset: function(r) {
      if (qV(r)) {
        var e = r.getData(), n = r.coordinateSystem, i = n.getBaseAxis(), a = n.getOtherAxis(i), o = e.getDimensionIndex(e.mapDimension(a.dim)), s = e.getDimensionIndex(e.mapDimension(i.dim)), l = r.get("showBackground", !0), u = e.mapDimension(a.dim), c = e.getCalculationInfo("stackResultDimension"), d = Js(e, u) && !!e.getCalculationInfo("stackedOnSeries"), f = a.isHorizontal(), h = uee(i, a), p = QV(r), v = r.get("barMinHeight") || 0, g = c && e.getDimensionIndex(c), m = e.getLayout("size"), y = e.getLayout("offset");
        return {
          progress: function(b, C) {
            for (var w = b.count, _ = p && Oo(w * 3), x = p && l && Oo(w * 3), I = p && Oo(w), D = n.master.getRect(), T = f ? D.width : D.height, A, M = C.getStore(), R = 0; (A = b.next()) != null; ) {
              var E = M.get(d ? g : o, A), k = M.get(s, A), P = h, N = void 0;
              d && (N = +E - M.get(o, A));
              var O = void 0, W = void 0, V = void 0, B = void 0;
              if (f) {
                var Z = n.dataToPoint([E, k]);
                if (d) {
                  var q = n.dataToPoint([N, k]);
                  P = q[0];
                }
                O = P, W = Z[1] + y, V = Z[0] - P, B = m, Math.abs(V) < v && (V = (V < 0 ? -1 : 1) * v);
              } else {
                var Z = n.dataToPoint([k, E]);
                if (d) {
                  var q = n.dataToPoint([k, N]);
                  P = q[1];
                }
                O = Z[0] + y, W = P, V = m, B = Z[1] - P, Math.abs(B) < v && (B = (B <= 0 ? -1 : 1) * v);
              }
              p ? (_[R] = O, _[R + 1] = W, _[R + 2] = f ? V : B, x && (x[R] = f ? D.x : O, x[R + 1] = f ? W : D.y, x[R + 2] = T), I[A] = A) : C.setItemLayout(A, {
                x: O,
                y: W,
                width: V,
                height: B
              }), R += 3;
            }
            p && C.setLayout({
              largePoints: _,
              largeDataIndices: I,
              largeBackgroundPoints: x,
              valueAxisHorizontal: f
            });
          }
        };
      }
    }
  };
}
function qV(t) {
  return t.coordinateSystem && t.coordinateSystem.type === "cartesian2d";
}
function QV(t) {
  return t.pipelineContext && t.pipelineContext.large;
}
function uee(t, r) {
  var e = r.model.get("startValue");
  return e || (e = 0), r.toGlobalCoord(r.dataToCoord(r.type === "log" ? e > 0 ? e : 1 : e));
}
var cee = function(t, r, e, n) {
  for (; e < n; ) {
    var i = e + n >>> 1;
    t[i][1] < r ? e = i + 1 : n = i;
  }
  return e;
}, Mw = (
  /** @class */
  function(t) {
    ee(r, t);
    function r(e) {
      var n = t.call(this, e) || this;
      return n.type = "time", n;
    }
    return r.prototype.getLabel = function(e) {
      var n = this.getSetting("useUTC");
      return yg(e.value, tI[GJ(vf(this._minLevelUnit))] || tI.second, n, this.getSetting("locale"));
    }, r.prototype.getFormattedLabel = function(e, n, i) {
      var a = this.getSetting("useUTC"), o = this.getSetting("locale");
      return BJ(e, n, i, o, a);
    }, r.prototype.getTicks = function() {
      var e = this._interval, n = this._extent, i = [];
      if (!e)
        return i;
      i.push({
        value: n[0],
        level: 0
      });
      var a = this.getSetting("useUTC"), o = mee(this._minLevelUnit, this._approxInterval, a, n);
      return i = i.concat(o), i.push({
        value: n[1],
        level: 0
      }), i;
    }, r.prototype.calcNiceExtent = function(e) {
      var n = this._extent;
      if (n[0] === n[1] && (n[0] -= Ia, n[1] += Ia), n[1] === -1 / 0 && n[0] === 1 / 0) {
        var i = /* @__PURE__ */ new Date();
        n[1] = +new Date(i.getFullYear(), i.getMonth(), i.getDate()), n[0] = n[1] - Ia;
      }
      this.calcNiceTicks(e.splitNumber, e.minInterval, e.maxInterval);
    }, r.prototype.calcNiceTicks = function(e, n, i) {
      e = e || 10;
      var a = this._extent, o = a[1] - a[0];
      this._approxInterval = o / e, n != null && this._approxInterval < n && (this._approxInterval = n), i != null && this._approxInterval > i && (this._approxInterval = i);
      var s = I1.length, l = Math.min(cee(I1, this._approxInterval, 0, s), s - 1);
      this._interval = I1[l][1], this._minLevelUnit = I1[Math.max(l - 1, 0)][0];
    }, r.prototype.parse = function(e) {
      return Mt(e) ? e : +ra(e);
    }, r.prototype.contain = function(e) {
      return I2(this.parse(e), this._extent);
    }, r.prototype.normalize = function(e) {
      return A2(this.parse(e), this._extent);
    }, r.prototype.scale = function(e) {
      return D2(e, this._extent);
    }, r.type = "time", r;
  }(Ks)
), I1 = [
  // Format                           interval
  ["second", Q7],
  ["minute", ew],
  ["hour", Qp],
  ["quarter-day", Qp * 6],
  ["half-day", Qp * 12],
  ["day", Ia * 1.2],
  ["half-week", Ia * 3.5],
  ["week", Ia * 7],
  ["month", Ia * 31],
  ["quarter", Ia * 95],
  ["half-year", eI / 2],
  ["year", eI]
  // 1Y
];
function dee(t, r, e, n) {
  var i = ra(r), a = ra(e), o = function(p) {
    return rI(i, p, n) === rI(a, p, n);
  }, s = function() {
    return o("year");
  }, l = function() {
    return s() && o("month");
  }, u = function() {
    return l() && o("day");
  }, c = function() {
    return u() && o("hour");
  }, d = function() {
    return c() && o("minute");
  }, f = function() {
    return d() && o("second");
  }, h = function() {
    return f() && o("millisecond");
  };
  switch (t) {
    case "year":
      return s();
    case "month":
      return l();
    case "day":
      return u();
    case "hour":
      return c();
    case "minute":
      return d();
    case "second":
      return f();
    case "millisecond":
      return h();
  }
}
function fee(t, r) {
  return t /= Ia, t > 16 ? 16 : t > 7.5 ? 7 : t > 3.5 ? 4 : t > 1.5 ? 2 : 1;
}
function hee(t) {
  var r = 30 * Ia;
  return t /= r, t > 6 ? 6 : t > 3 ? 3 : t > 2 ? 2 : 1;
}
function pee(t) {
  return t /= Qp, t > 12 ? 12 : t > 6 ? 6 : t > 3.5 ? 4 : t > 2 ? 2 : 1;
}
function dA(t, r) {
  return t /= r ? ew : Q7, t > 30 ? 30 : t > 20 ? 20 : t > 15 ? 15 : t > 10 ? 10 : t > 5 ? 5 : t > 2 ? 2 : 1;
}
function vee(t) {
  return E7(t, !0);
}
function gee(t, r, e) {
  var n = new Date(t);
  switch (vf(r)) {
    case "year":
    case "month":
      n[bO(e)](0);
    case "day":
      n[CO(e)](1);
    case "hour":
      n[wO(e)](0);
    case "minute":
      n[_O(e)](0);
    case "second":
      n[xO(e)](0), n[SO(e)](0);
  }
  return n.getTime();
}
function mee(t, r, e, n) {
  var i = 1e4, a = mO, o = 0;
  function s(T, A, M, R, E, k, P) {
    for (var N = new Date(A), O = A, W = N[R](); O < M && O <= n[1]; )
      P.push({
        value: O
      }), W += T, N[E](W), O = N.getTime();
    P.push({
      value: O,
      notAdd: !0
    });
  }
  function l(T, A, M) {
    var R = [], E = !A.length;
    if (!dee(vf(T), n[0], n[1], e)) {
      E && (A = [{
        // TODO Optimize. Not include so may ticks.
        value: gee(new Date(n[0]), T, e)
      }, {
        value: n[1]
      }]);
      for (var k = 0; k < A.length - 1; k++) {
        var P = A[k].value, N = A[k + 1].value;
        if (P !== N) {
          var O = void 0, W = void 0, V = void 0, B = !1;
          switch (T) {
            case "year":
              O = Math.max(1, Math.round(r / Ia / 365)), W = tw(e), V = FJ(e);
              break;
            case "half-year":
            case "quarter":
            case "month":
              O = hee(r), W = gf(e), V = bO(e);
              break;
            case "week":
            // PENDING If week is added. Ignore day.
            case "half-week":
            case "day":
              O = fee(r), W = p2(e), V = CO(e), B = !0;
              break;
            case "half-day":
            case "quarter-day":
            case "hour":
              O = pee(r), W = _v(e), V = wO(e);
              break;
            case "minute":
              O = dA(r, !0), W = v2(e), V = _O(e);
              break;
            case "second":
              O = dA(r, !1), W = g2(e), V = xO(e);
              break;
            case "millisecond":
              O = vee(r), W = m2(e), V = SO(e);
              break;
          }
          s(O, P, N, W, V, B, R), T === "year" && M.length > 1 && k === 0 && M.unshift({
            value: M[0].value - O
          });
        }
      }
      for (var k = 0; k < R.length; k++)
        M.push(R[k]);
      return R;
    }
  }
  for (var u = [], c = [], d = 0, f = 0, h = 0; h < a.length && o++ < i; ++h) {
    var p = vf(a[h]);
    if (VJ(a[h])) {
      l(a[h], u[u.length - 1] || [], c);
      var v = a[h + 1] ? vf(a[h + 1]) : null;
      if (p !== v) {
        if (c.length) {
          f = d, c.sort(function(T, A) {
            return T.value - A.value;
          });
          for (var g = [], m = 0; m < c.length; ++m) {
            var y = c[m].value;
            (m === 0 || c[m - 1].value !== y) && (g.push(c[m]), y >= n[0] && y <= n[1] && d++);
          }
          var b = (n[1] - n[0]) / r;
          if (d > b * 1.5 && f > b / 1.5 || (u.push(g), d > b || t === a[h]))
            break;
        }
        c = [];
      }
    }
  }
  process.env.NODE_ENV !== "production" && o >= i && Mr("Exceed safe limit.");
  for (var C = Wt(ce(u, function(T) {
    return Wt(T, function(A) {
      return A.value >= n[0] && A.value <= n[1] && !A.notAdd;
    });
  }), function(T) {
    return T.length > 0;
  }), w = [], _ = C.length - 1, h = 0; h < C.length; ++h)
    for (var x = C[h], I = 0; I < x.length; ++I)
      w.push({
        value: x[I].value,
        level: _ - h
      });
  w.sort(function(T, A) {
    return T.value - A.value;
  });
  for (var D = [], h = 0; h < w.length; ++h)
    (h === 0 || w[h].value !== w[h - 1].value) && D.push(w[h]);
  return D;
}
ss.registerClass(Mw);
var fA = ss.prototype, rv = Ks.prototype, yee = Or, bee = Math.floor, Cee = Math.ceil, A1 = Math.pow, Fa = Math.log, Rw = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = "log", e.base = 10, e._originalScale = new Ks(), e._interval = 0, e;
    }
    return r.prototype.getTicks = function(e) {
      var n = this._originalScale, i = this._extent, a = n.getExtent(), o = rv.getTicks.call(this, e);
      return ce(o, function(s) {
        var l = s.value, u = Or(A1(this.base, l));
        return u = l === i[0] && this._fixMin ? D1(u, a[0]) : u, u = l === i[1] && this._fixMax ? D1(u, a[1]) : u, {
          value: u
        };
      }, this);
    }, r.prototype.setExtent = function(e, n) {
      var i = Fa(this.base);
      e = Fa(Math.max(0, e)) / i, n = Fa(Math.max(0, n)) / i, rv.setExtent.call(this, e, n);
    }, r.prototype.getExtent = function() {
      var e = this.base, n = fA.getExtent.call(this);
      n[0] = A1(e, n[0]), n[1] = A1(e, n[1]);
      var i = this._originalScale, a = i.getExtent();
      return this._fixMin && (n[0] = D1(n[0], a[0])), this._fixMax && (n[1] = D1(n[1], a[1])), n;
    }, r.prototype.unionExtent = function(e) {
      this._originalScale.unionExtent(e);
      var n = this.base;
      e[0] = Fa(e[0]) / Fa(n), e[1] = Fa(e[1]) / Fa(n), fA.unionExtent.call(this, e);
    }, r.prototype.unionExtentFromData = function(e, n) {
      this.unionExtent(e.getApproximateExtent(n));
    }, r.prototype.calcNiceTicks = function(e) {
      e = e || 10;
      var n = this._extent, i = n[1] - n[0];
      if (!(i === 1 / 0 || i <= 0)) {
        var a = CN(i), o = e / i * a;
        for (o <= 0.5 && (a *= 10); !isNaN(a) && Math.abs(a) < 1 && Math.abs(a) > 0; )
          a *= 10;
        var s = [Or(Cee(n[0] / a) * a), Or(bee(n[1] / a) * a)];
        this._interval = a, this._niceExtent = s;
      }
    }, r.prototype.calcNiceExtent = function(e) {
      rv.calcNiceExtent.call(this, e), this._fixMin = e.fixMin, this._fixMax = e.fixMax;
    }, r.prototype.parse = function(e) {
      return e;
    }, r.prototype.contain = function(e) {
      return e = Fa(e) / Fa(this.base), I2(e, this._extent);
    }, r.prototype.normalize = function(e) {
      return e = Fa(e) / Fa(this.base), A2(e, this._extent);
    }, r.prototype.scale = function(e) {
      return e = D2(e, this._extent), A1(this.base, e);
    }, r.type = "log", r;
  }(ss)
), eG = Rw.prototype;
eG.getMinorTicks = rv.getMinorTicks;
eG.getLabel = rv.getLabel;
function D1(t, r) {
  return yee(t, Ya(r));
}
ss.registerClass(Rw);
var wee = (
  /** @class */
  function() {
    function t(r, e, n) {
      this._prepareParams(r, e, n);
    }
    return t.prototype._prepareParams = function(r, e, n) {
      n[1] < n[0] && (n = [NaN, NaN]), this._dataMin = n[0], this._dataMax = n[1];
      var i = this._isOrdinal = r.type === "ordinal";
      this._needCrossZero = r.type === "interval" && e.getNeedCrossZero && e.getNeedCrossZero();
      var a = e.get("min", !0);
      a == null && (a = e.get("startValue", !0));
      var o = this._modelMinRaw = a;
      Ae(o) ? this._modelMinNum = T1(r, o({
        min: n[0],
        max: n[1]
      })) : o !== "dataMin" && (this._modelMinNum = T1(r, o));
      var s = this._modelMaxRaw = e.get("max", !0);
      if (Ae(s) ? this._modelMaxNum = T1(r, s({
        min: n[0],
        max: n[1]
      })) : s !== "dataMax" && (this._modelMaxNum = T1(r, s)), i)
        this._axisDataLen = e.getCategories().length;
      else {
        var l = e.get("boundaryGap"), u = ue(l) ? l : [l || 0, l || 0];
        typeof u[0] == "boolean" || typeof u[1] == "boolean" ? (process.env.NODE_ENV !== "production" && console.warn('Boolean type for boundaryGap is only allowed for ordinal axis. Please use string in percentage instead, e.g., "20%". Currently, boundaryGap is set to be 0.'), this._boundaryGapInner = [0, 0]) : this._boundaryGapInner = [to(u[0], 1), to(u[1], 1)];
      }
    }, t.prototype.calculate = function() {
      var r = this._isOrdinal, e = this._dataMin, n = this._dataMax, i = this._axisDataLen, a = this._boundaryGapInner, o = r ? null : n - e || Math.abs(e), s = this._modelMinRaw === "dataMin" ? e : this._modelMinNum, l = this._modelMaxRaw === "dataMax" ? n : this._modelMaxNum, u = s != null, c = l != null;
      s == null && (s = r ? i ? 0 : NaN : e - a[0] * o), l == null && (l = r ? i ? i - 1 : NaN : n + a[1] * o), (s == null || !isFinite(s)) && (s = NaN), (l == null || !isFinite(l)) && (l = NaN);
      var d = ql(s) || ql(l) || r && !i;
      this._needCrossZero && (s > 0 && l > 0 && !u && (s = 0), s < 0 && l < 0 && !c && (l = 0));
      var f = this._determinedMin, h = this._determinedMax;
      return f != null && (s = f, u = !0), h != null && (l = h, c = !0), {
        min: s,
        max: l,
        minFixed: u,
        maxFixed: c,
        isBlank: d
      };
    }, t.prototype.modifyDataMinMax = function(r, e) {
      process.env.NODE_ENV !== "production" && ke(!this.frozen), this[xee[r]] = e;
    }, t.prototype.setDeterminedMinMax = function(r, e) {
      var n = _ee[r];
      process.env.NODE_ENV !== "production" && ke(!this.frozen && this[n] == null), this[n] = e;
    }, t.prototype.freeze = function() {
      this.frozen = !0;
    }, t;
  }()
), _ee = {
  min: "_determinedMin",
  max: "_determinedMax"
}, xee = {
  min: "_dataMin",
  max: "_dataMax"
};
function tG(t, r, e) {
  var n = t.rawExtentInfo;
  return n || (n = new wee(t, r, e), t.rawExtentInfo = n, n);
}
function T1(t, r) {
  return r == null ? null : ql(r) ? NaN : t.parse(r);
}
function rG(t, r) {
  var e = t.type, n = tG(t, r, t.getExtent()).calculate();
  t.setBlank(n.isBlank);
  var i = n.min, a = n.max, o = r.ecModel;
  if (o && e === "time") {
    var s = XV("bar", o), l = !1;
    if (L(s, function(d) {
      l = l || d.getBaseAxis() === r.axis;
    }), l) {
      var u = $V(s), c = See(i, a, r, u);
      i = c.min, a = c.max;
    }
  }
  return {
    extent: [i, a],
    // "fix" means "fixed", the value should not be
    // changed in the subsequent steps.
    fixMin: n.minFixed,
    fixMax: n.maxFixed
  };
}
function See(t, r, e, n) {
  var i = e.axis.getExtent(), a = i[1] - i[0], o = lee(n, e.axis);
  if (o === void 0)
    return {
      min: t,
      max: r
    };
  var s = 1 / 0;
  L(o, function(h) {
    s = Math.min(h.offset, s);
  });
  var l = -1 / 0;
  L(o, function(h) {
    l = Math.max(h.offset + h.width, l);
  }), s = Math.abs(s), l = Math.abs(l);
  var u = s + l, c = r - t, d = 1 - (s + l) / a, f = c / d - c;
  return r += f * (l / u), t -= f * (s / u), {
    min: t,
    max: r
  };
}
function zc(t, r) {
  var e = r, n = rG(t, e), i = n.extent, a = e.get("splitNumber");
  t instanceof Rw && (t.base = e.get("logBase"));
  var o = t.type, s = e.get("interval"), l = o === "interval" || o === "time";
  t.setExtent(i[0], i[1]), t.calcNiceExtent({
    splitNumber: a,
    fixMin: n.fixMin,
    fixMax: n.fixMax,
    minInterval: l ? e.get("minInterval") : null,
    maxInterval: l ? e.get("maxInterval") : null
  }), s != null && t.setInterval && t.setInterval(s);
}
function Cg(t, r) {
  if (r = r || t.get("type"), r)
    switch (r) {
      // Buildin scale
      case "category":
        return new T2({
          ordinalMeta: t.getOrdinalMeta ? t.getOrdinalMeta() : t.getCategories(),
          extent: [1 / 0, -1 / 0]
        });
      case "time":
        return new Mw({
          locale: t.ecModel.getLocaleModel(),
          useUTC: t.ecModel.get("useUTC")
        });
      default:
        return new (ss.getClass(r) || Ks)();
    }
}
function Iee(t) {
  var r = t.scale.getExtent(), e = r[0], n = r[1];
  return !(e > 0 && n > 0 || e < 0 && n < 0);
}
function ph(t) {
  var r = t.getLabelModel().get("formatter"), e = t.type === "category" ? t.scale.getExtent()[0] : null;
  return t.scale.type === "time" ? /* @__PURE__ */ function(n) {
    return function(i, a) {
      return t.scale.getFormattedLabel(i, a, n);
    };
  }(r) : pe(r) ? /* @__PURE__ */ function(n) {
    return function(i) {
      var a = t.scale.getLabel(i), o = n.replace("{value}", a ?? "");
      return o;
    };
  }(r) : Ae(r) ? /* @__PURE__ */ function(n) {
    return function(i, a) {
      return e != null && (a = i.value - e), n(Lw(t, i), a, i.level != null ? {
        level: i.level
      } : null);
    };
  }(r) : function(n) {
    return t.scale.getLabel(n);
  };
}
function Lw(t, r) {
  return t.type === "category" ? t.scale.getLabel(r) : r.value;
}
function Aee(t) {
  var r = t.model, e = t.scale;
  if (!(!r.get(["axisLabel", "show"]) || e.isBlank())) {
    var n, i, a = e.getExtent();
    e instanceof T2 ? i = e.count() : (n = e.getTicks(), i = n.length);
    var o = t.getLabelModel(), s = ph(t), l, u = 1;
    i > 40 && (u = Math.ceil(i / 40));
    for (var c = 0; c < i; c += u) {
      var d = n ? n[c] : {
        value: a[0] + c
      }, f = s(d, c), h = o.getTextRect(f), p = Dee(h, o.get("rotate") || 0);
      l ? l.union(p) : l = p;
    }
    return l;
  }
}
function Dee(t, r) {
  var e = r * Math.PI / 180, n = t.width, i = t.height, a = n * Math.abs(Math.cos(e)) + Math.abs(i * Math.sin(e)), o = n * Math.abs(Math.sin(e)) + Math.abs(i * Math.cos(e)), s = new rt(t.x, t.y, a, o);
  return s;
}
function Ew(t) {
  var r = t.get("interval");
  return r ?? "auto";
}
function nG(t) {
  return t.type === "category" && Ew(t.getLabelModel()) === 0;
}
function Gm(t, r) {
  var e = {};
  return L(t.mapDimensionsAll(r), function(n) {
    e[Aw(t, n)] = !0;
  }), yt(e);
}
function Tee(t, r, e) {
  r && L(Gm(r, e), function(n) {
    var i = r.getApproximateExtent(n);
    i[0] < t[0] && (t[0] = i[0]), i[1] > t[1] && (t[1] = i[1]);
  });
}
var vh = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.getNeedCrossZero = function() {
      var r = this.option;
      return !r.scale;
    }, t.prototype.getCoordSysModel = function() {
    }, t;
  }()
);
function Mee(t) {
  return os(null, t);
}
var Ree = {
  isDimensionStacked: Js,
  enableDataStack: ZV,
  getStackedDimension: Aw
};
function Lee(t, r) {
  var e = r;
  r instanceof Pt || (e = new Pt(r));
  var n = Cg(e);
  return n.setExtent(t[0], t[1]), zc(n, e), n;
}
function Eee(t) {
  Xr(t, vh);
}
function kee(t, r) {
  return r = r || {}, fr(t, null, null, r.state !== "normal");
}
const Pee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createDimensions: zQ,
  createList: Mee,
  createScale: Lee,
  createSymbol: en,
  createTextStyle: kee,
  dataStack: Ree,
  enableHoverEmphasis: Fl,
  getECData: Ze,
  getLayoutRect: cn,
  mixinAxisModelCommonMethods: Eee
}, Symbol.toStringTag, { value: "Module" }));
var Nee = 1e-8;
function hA(t, r) {
  return Math.abs(t - r) < Nee;
}
function ic(t, r, e) {
  var n = 0, i = t[0];
  if (!i)
    return !1;
  for (var a = 1; a < t.length; a++) {
    var o = t[a];
    n += _s(i[0], i[1], o[0], o[1], r, e), i = o;
  }
  var s = t[0];
  return (!hA(i[0], s[0]) || !hA(i[1], s[1])) && (n += _s(i[0], i[1], s[0], s[1], r, e)), n !== 0;
}
var Oee = [];
function Mb(t, r) {
  for (var e = 0; e < t.length; e++)
    En(t[e], t[e], r);
}
function pA(t, r, e, n) {
  for (var i = 0; i < t.length; i++) {
    var a = t[i];
    n && (a = n.project(a)), a && isFinite(a[0]) && isFinite(a[1]) && (Ms(r, r, a), Rs(e, e, a));
  }
}
function Vee(t) {
  for (var r = 0, e = 0, n = 0, i = t.length, a = t[i - 1][0], o = t[i - 1][1], s = 0; s < i; s++) {
    var l = t[s][0], u = t[s][1], c = a * u - l * o;
    r += c, e += (a + l) * c, n += (o + u) * c, a = l, o = u;
  }
  return r ? [e / r / 3, n / r / 3, r] : [t[0][0] || 0, t[0][1] || 0];
}
var iG = (
  /** @class */
  function() {
    function t(r) {
      this.name = r;
    }
    return t.prototype.setCenter = function(r) {
      this._center = r;
    }, t.prototype.getCenter = function() {
      var r = this._center;
      return r || (r = this._center = this.calcCenter()), r;
    }, t;
  }()
), vA = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(r, e) {
      this.type = "polygon", this.exterior = r, this.interiors = e;
    }
    return t;
  }()
), gA = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(r) {
      this.type = "linestring", this.points = r;
    }
    return t;
  }()
), aG = (
  /** @class */
  function(t) {
    ee(r, t);
    function r(e, n, i) {
      var a = t.call(this, e) || this;
      return a.type = "geoJSON", a.geometries = n, a._center = i && [i[0], i[1]], a;
    }
    return r.prototype.calcCenter = function() {
      for (var e = this.geometries, n, i = 0, a = 0; a < e.length; a++) {
        var o = e[a], s = o.exterior, l = s && s.length;
        l > i && (n = o, i = l);
      }
      if (n)
        return Vee(n.exterior);
      var u = this.getBoundingRect();
      return [u.x + u.width / 2, u.y + u.height / 2];
    }, r.prototype.getBoundingRect = function(e) {
      var n = this._rect;
      if (n && !e)
        return n;
      var i = [1 / 0, 1 / 0], a = [-1 / 0, -1 / 0], o = this.geometries;
      return L(o, function(s) {
        s.type === "polygon" ? pA(s.exterior, i, a, e) : L(s.points, function(l) {
          pA(l, i, a, e);
        });
      }), isFinite(i[0]) && isFinite(i[1]) && isFinite(a[0]) && isFinite(a[1]) || (i[0] = i[1] = a[0] = a[1] = 0), n = new rt(i[0], i[1], a[0] - i[0], a[1] - i[1]), e || (this._rect = n), n;
    }, r.prototype.contain = function(e) {
      var n = this.getBoundingRect(), i = this.geometries;
      if (!n.contain(e[0], e[1]))
        return !1;
      e: for (var a = 0, o = i.length; a < o; a++) {
        var s = i[a];
        if (s.type === "polygon") {
          var l = s.exterior, u = s.interiors;
          if (ic(l, e[0], e[1])) {
            for (var c = 0; c < (u ? u.length : 0); c++)
              if (ic(u[c], e[0], e[1]))
                continue e;
            return !0;
          }
        }
      }
      return !1;
    }, r.prototype.transformTo = function(e, n, i, a) {
      var o = this.getBoundingRect(), s = o.width / o.height;
      i ? a || (a = i / s) : i = s * a;
      for (var l = new rt(e, n, i, a), u = o.calculateTransform(l), c = this.geometries, d = 0; d < c.length; d++) {
        var f = c[d];
        f.type === "polygon" ? (Mb(f.exterior, u), L(f.interiors, function(h) {
          Mb(h, u);
        })) : L(f.points, function(h) {
          Mb(h, u);
        });
      }
      o = this._rect, o.copy(l), this._center = [o.x + o.width / 2, o.y + o.height / 2];
    }, r.prototype.cloneShallow = function(e) {
      e == null && (e = this.name);
      var n = new r(e, this.geometries, this._center);
      return n._rect = this._rect, n.transformTo = null, n;
    }, r;
  }(iG)
), Gee = (
  /** @class */
  function(t) {
    ee(r, t);
    function r(e, n) {
      var i = t.call(this, e) || this;
      return i.type = "geoSVG", i._elOnlyForCalculate = n, i;
    }
    return r.prototype.calcCenter = function() {
      for (var e = this._elOnlyForCalculate, n = e.getBoundingRect(), i = [n.x + n.width / 2, n.y + n.height / 2], a = lg(Oee), o = e; o && !o.isGeoSVGGraphicRoot; )
        zo(a, o.getLocalTransform(), a), o = o.parent;
      return Kc(a, a), En(i, i, a), i;
    }, r;
  }(iG)
);
function Bee(t) {
  if (!t.UTF8Encoding)
    return t;
  var r = t, e = r.UTF8Scale;
  e == null && (e = 1024);
  var n = r.features;
  return L(n, function(i) {
    var a = i.geometry, o = a.encodeOffsets, s = a.coordinates;
    if (o)
      switch (a.type) {
        case "LineString":
          a.coordinates = oG(s, o, e);
          break;
        case "Polygon":
          Rb(s, o, e);
          break;
        case "MultiLineString":
          Rb(s, o, e);
          break;
        case "MultiPolygon":
          L(s, function(l, u) {
            return Rb(l, o[u], e);
          });
      }
  }), r.UTF8Encoding = !1, r;
}
function Rb(t, r, e) {
  for (var n = 0; n < t.length; n++)
    t[n] = oG(t[n], r[n], e);
}
function oG(t, r, e) {
  for (var n = [], i = r[0], a = r[1], o = 0; o < t.length; o += 2) {
    var s = t.charCodeAt(o) - 64, l = t.charCodeAt(o + 1) - 64;
    s = s >> 1 ^ -(s & 1), l = l >> 1 ^ -(l & 1), s += i, l += a, i = s, a = l, n.push([s / e, l / e]);
  }
  return n;
}
function g9(t, r) {
  return t = Bee(t), ce(Wt(t.features, function(e) {
    return e.geometry && e.properties && e.geometry.coordinates.length > 0;
  }), function(e) {
    var n = e.properties, i = e.geometry, a = [];
    switch (i.type) {
      case "Polygon":
        var o = i.coordinates;
        a.push(new vA(o[0], o.slice(1)));
        break;
      case "MultiPolygon":
        L(i.coordinates, function(l) {
          l[0] && a.push(new vA(l[0], l.slice(1)));
        });
        break;
      case "LineString":
        a.push(new gA([i.coordinates]));
        break;
      case "MultiLineString":
        a.push(new gA(i.coordinates));
    }
    var s = new aG(n[r || "name"], a, n.cp);
    return s.properties = n, s;
  });
}
const Fee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MAX_SAFE_INTEGER: VC,
  asc: Ui,
  getPercentWithPrecision: m$,
  getPixelPrecision: R7,
  getPrecision: Ya,
  getPrecisionSafe: mm,
  isNumeric: r2,
  isRadianAroundZero: Af,
  linearMap: zt,
  nice: E7,
  numericToNumber: qo,
  parseDate: ra,
  quantile: D0,
  quantity: CN,
  quantityExponent: dg,
  reformIntervals: GC,
  remRadian: L7,
  round: Or
}, Symbol.toStringTag, { value: "Module" })), Hee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  format: yg,
  parse: ra
}, Symbol.toStringTag, { value: "Module" })), zee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Arc: vg,
  BezierCurve: th,
  BoundingRect: rt,
  Circle: is,
  CompoundPath: c2,
  Ellipse: pg,
  Group: ze,
  Image: An,
  IncrementalDisplayable: iO,
  Line: gn,
  LinearGradient: rh,
  Polygon: si,
  Polyline: ci,
  RadialGradient: Z7,
  Rect: xt,
  Ring: eh,
  Sector: oi,
  Text: _t,
  clipPointsByRect: $7,
  clipRectByRect: uO,
  createIcon: ih,
  extendPath: sO,
  extendShape: oO,
  getShapeClass: d2,
  getTransform: Hl,
  initProps: Cr,
  makeImage: Y7,
  makePath: gg,
  mergePath: Yi,
  registerShape: Pa,
  resizePath: X7,
  updateProps: kt
}, Symbol.toStringTag, { value: "Module" })), Wee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  addCommas: rw,
  capitalFirst: ZJ,
  encodeHTML: bi,
  formatTime: WJ,
  formatTpl: iw,
  getTextRect: HJ,
  getTooltipMarker: IO,
  normalizeCssArray: Qc,
  toCamelCase: nw,
  truncateText: LN
}, Symbol.toStringTag, { value: "Module" })), Zee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  bind: ye,
  clone: Ge,
  curry: Ye,
  defaults: Ee,
  each: L,
  extend: ae,
  filter: Wt,
  indexOf: nt,
  inherits: w7,
  isArray: ue,
  isFunction: Ae,
  isObject: Me,
  isString: pe,
  map: ce,
  merge: Qe,
  reduce: Ma
}, Symbol.toStringTag, { value: "Module" }));
var Tv = It();
function sG(t, r) {
  var e = ce(r, function(n) {
    return t.scale.parse(n);
  });
  return t.type === "time" && e.length > 0 && (e.sort(), e.unshift(e[0]), e.push(e[e.length - 1])), e;
}
function jee(t) {
  var r = t.getLabelModel().get("customValues");
  if (r) {
    var e = ph(t);
    return {
      labels: sG(t, r).map(function(n) {
        var i = {
          value: n
        };
        return {
          formattedLabel: e(i),
          rawLabel: t.scale.getLabel(i),
          tickValue: n
        };
      })
    };
  }
  return t.type === "category" ? Xee(t) : Uee(t);
}
function Yee(t, r) {
  var e = t.getTickModel().get("customValues");
  return e ? {
    ticks: sG(t, e)
  } : t.type === "category" ? $ee(t, r) : {
    ticks: ce(t.scale.getTicks(), function(n) {
      return n.value;
    })
  };
}
function Xee(t) {
  var r = t.getLabelModel(), e = lG(t, r);
  return !r.get("show") || t.scale.isBlank() ? {
    labels: [],
    labelCategoryInterval: e.labelCategoryInterval
  } : e;
}
function lG(t, r) {
  var e = uG(t, "labels"), n = Ew(r), i = cG(e, n);
  if (i)
    return i;
  var a, o;
  return Ae(n) ? a = hG(t, n) : (o = n === "auto" ? Jee(t) : n, a = fG(t, o)), dG(e, n, {
    labels: a,
    labelCategoryInterval: o
  });
}
function $ee(t, r) {
  var e = uG(t, "ticks"), n = Ew(r), i = cG(e, n);
  if (i)
    return i;
  var a, o;
  if ((!r.get("show") || t.scale.isBlank()) && (a = []), Ae(n))
    a = hG(t, n, !0);
  else if (n === "auto") {
    var s = lG(t, t.getLabelModel());
    o = s.labelCategoryInterval, a = ce(s.labels, function(l) {
      return l.tickValue;
    });
  } else
    o = n, a = fG(t, o, !0);
  return dG(e, n, {
    ticks: a,
    tickCategoryInterval: o
  });
}
function Uee(t) {
  var r = t.scale.getTicks(), e = ph(t);
  return {
    labels: ce(r, function(n, i) {
      return {
        level: n.level,
        formattedLabel: e(n, i),
        rawLabel: t.scale.getLabel(n),
        tickValue: n.value
      };
    })
  };
}
function uG(t, r) {
  return Tv(t)[r] || (Tv(t)[r] = []);
}
function cG(t, r) {
  for (var e = 0; e < t.length; e++)
    if (t[e].key === r)
      return t[e].value;
}
function dG(t, r, e) {
  return t.push({
    key: r,
    value: e
  }), e;
}
function Jee(t) {
  var r = Tv(t).autoInterval;
  return r ?? (Tv(t).autoInterval = t.calculateCategoryInterval());
}
function Kee(t) {
  var r = qee(t), e = ph(t), n = (r.axisRotate - r.labelRotate) / 180 * Math.PI, i = t.scale, a = i.getExtent(), o = i.count();
  if (a[1] - a[0] < 1)
    return 0;
  var s = 1;
  o > 40 && (s = Math.max(1, Math.floor(o / 40)));
  for (var l = a[0], u = t.dataToCoord(l + 1) - t.dataToCoord(l), c = Math.abs(u * Math.cos(n)), d = Math.abs(u * Math.sin(n)), f = 0, h = 0; l <= a[1]; l += s) {
    var p = 0, v = 0, g = cg(e({
      value: l
    }), r.font, "center", "top");
    p = g.width * 1.3, v = g.height * 1.3, f = Math.max(f, p, 7), h = Math.max(h, v, 7);
  }
  var m = f / c, y = h / d;
  isNaN(m) && (m = 1 / 0), isNaN(y) && (y = 1 / 0);
  var b = Math.max(0, Math.floor(Math.min(m, y))), C = Tv(t.model), w = t.getExtent(), _ = C.lastAutoInterval, x = C.lastTickCount;
  return _ != null && x != null && Math.abs(_ - b) <= 1 && Math.abs(x - o) <= 1 && _ > b && C.axisExtent0 === w[0] && C.axisExtent1 === w[1] ? b = _ : (C.lastTickCount = o, C.lastAutoInterval = b, C.axisExtent0 = w[0], C.axisExtent1 = w[1]), b;
}
function qee(t) {
  var r = t.getLabelModel();
  return {
    axisRotate: t.getRotate ? t.getRotate() : t.isHorizontal && !t.isHorizontal() ? 90 : 0,
    labelRotate: r.get("rotate") || 0,
    font: r.getFont()
  };
}
function fG(t, r, e) {
  var n = ph(t), i = t.scale, a = i.getExtent(), o = t.getLabelModel(), s = [], l = Math.max((r || 0) + 1, 1), u = a[0], c = i.count();
  u !== 0 && l > 1 && c / l > 2 && (u = Math.round(Math.ceil(u / l) * l));
  var d = nG(t), f = o.get("showMinLabel") || d, h = o.get("showMaxLabel") || d;
  f && u !== a[0] && v(a[0]);
  for (var p = u; p <= a[1]; p += l)
    v(p);
  h && p - l !== a[1] && v(a[1]);
  function v(g) {
    var m = {
      value: g
    };
    s.push(e ? g : {
      formattedLabel: n(m),
      rawLabel: i.getLabel(m),
      tickValue: g
    });
  }
  return s;
}
function hG(t, r, e) {
  var n = t.scale, i = ph(t), a = [];
  return L(n.getTicks(), function(o) {
    var s = n.getLabel(o), l = o.value;
    r(o.value, s) && a.push(e ? l : {
      formattedLabel: i(o),
      rawLabel: s,
      tickValue: l
    });
  }), a;
}
var mA = [0, 1], Va = (
  /** @class */
  function() {
    function t(r, e, n) {
      this.onBand = !1, this.inverse = !1, this.dim = r, this.scale = e, this._extent = n || [0, 0];
    }
    return t.prototype.contain = function(r) {
      var e = this._extent, n = Math.min(e[0], e[1]), i = Math.max(e[0], e[1]);
      return r >= n && r <= i;
    }, t.prototype.containData = function(r) {
      return this.scale.contain(r);
    }, t.prototype.getExtent = function() {
      return this._extent.slice();
    }, t.prototype.getPixelPrecision = function(r) {
      return R7(r || this.scale.getExtent(), this._extent);
    }, t.prototype.setExtent = function(r, e) {
      var n = this._extent;
      n[0] = r, n[1] = e;
    }, t.prototype.dataToCoord = function(r, e) {
      var n = this._extent, i = this.scale;
      return r = i.normalize(r), this.onBand && i.type === "ordinal" && (n = n.slice(), yA(n, i.count())), zt(r, mA, n, e);
    }, t.prototype.coordToData = function(r, e) {
      var n = this._extent, i = this.scale;
      this.onBand && i.type === "ordinal" && (n = n.slice(), yA(n, i.count()));
      var a = zt(r, n, mA, e);
      return this.scale.scale(a);
    }, t.prototype.pointToData = function(r, e) {
    }, t.prototype.getTicksCoords = function(r) {
      r = r || {};
      var e = r.tickModel || this.getTickModel(), n = Yee(this, e), i = n.ticks, a = ce(i, function(s) {
        return {
          coord: this.dataToCoord(this.scale.type === "ordinal" ? this.scale.getRawOrdinalNumber(s) : s),
          tickValue: s
        };
      }, this), o = e.get("alignWithLabel");
      return Qee(this, a, o, r.clamp), a;
    }, t.prototype.getMinorTicksCoords = function() {
      if (this.scale.type === "ordinal")
        return [];
      var r = this.model.getModel("minorTick"), e = r.get("splitNumber");
      e > 0 && e < 100 || (e = 5);
      var n = this.scale.getMinorTicks(e), i = ce(n, function(a) {
        return ce(a, function(o) {
          return {
            coord: this.dataToCoord(o),
            tickValue: o
          };
        }, this);
      }, this);
      return i;
    }, t.prototype.getViewLabels = function() {
      return jee(this).labels;
    }, t.prototype.getLabelModel = function() {
      return this.model.getModel("axisLabel");
    }, t.prototype.getTickModel = function() {
      return this.model.getModel("axisTick");
    }, t.prototype.getBandWidth = function() {
      var r = this._extent, e = this.scale.getExtent(), n = e[1] - e[0] + (this.onBand ? 1 : 0);
      n === 0 && (n = 1);
      var i = Math.abs(r[1] - r[0]);
      return Math.abs(i) / n;
    }, t.prototype.calculateCategoryInterval = function() {
      return Kee(this);
    }, t;
  }()
);
function yA(t, r) {
  var e = t[1] - t[0], n = r, i = e / n / 2;
  t[0] += i, t[1] -= i;
}
function Qee(t, r, e, n) {
  var i = r.length;
  if (!t.onBand || e || !i)
    return;
  var a = t.getExtent(), o, s;
  if (i === 1)
    r[0].coord = a[0], o = r[1] = {
      coord: a[1]
    };
  else {
    var l = r[i - 1].tickValue - r[0].tickValue, u = (r[i - 1].coord - r[0].coord) / l;
    L(r, function(h) {
      h.coord -= u / 2;
    });
    var c = t.scale.getExtent();
    s = 1 + c[1] - r[i - 1].tickValue, o = {
      coord: r[i - 1].coord + u * s
    }, r.push(o);
  }
  var d = a[0] > a[1];
  f(r[0].coord, a[0]) && (n ? r[0].coord = a[0] : r.shift()), n && f(a[0], r[0].coord) && r.unshift({
    coord: a[0]
  }), f(a[1], o.coord) && (n ? o.coord = a[1] : r.pop()), n && f(o.coord, a[1]) && r.push({
    coord: a[1]
  });
  function f(h, p) {
    return h = Or(h), p = Or(p), d ? h > p : h < p;
  }
}
function ete(t) {
  var r = st.extend(t);
  return st.registerClass(r), r;
}
function tte(t) {
  var r = yr.extend(t);
  return yr.registerClass(r), r;
}
function rte(t) {
  var r = tr.extend(t);
  return tr.registerClass(r), r;
}
function nte(t) {
  var r = Yt.extend(t);
  return Yt.registerClass(r), r;
}
var Kh = Math.PI * 2, zu = Qo.CMD, ite = ["top", "right", "bottom", "left"];
function ate(t, r, e, n, i) {
  var a = e.width, o = e.height;
  switch (t) {
    case "top":
      n.set(e.x + a / 2, e.y - r), i.set(0, -1);
      break;
    case "bottom":
      n.set(e.x + a / 2, e.y + o + r), i.set(0, 1);
      break;
    case "left":
      n.set(e.x - r, e.y + o / 2), i.set(-1, 0);
      break;
    case "right":
      n.set(e.x + a + r, e.y + o / 2), i.set(1, 0);
      break;
  }
}
function ote(t, r, e, n, i, a, o, s, l) {
  o -= t, s -= r;
  var u = Math.sqrt(o * o + s * s);
  o /= u, s /= u;
  var c = o * e + t, d = s * e + r;
  if (Math.abs(n - i) % Kh < 1e-4)
    return l[0] = c, l[1] = d, u - e;
  if (a) {
    var f = n;
    n = Ji(i), i = Ji(f);
  } else
    n = Ji(n), i = Ji(i);
  n > i && (i += Kh);
  var h = Math.atan2(s, o);
  if (h < 0 && (h += Kh), h >= n && h <= i || h + Kh >= n && h + Kh <= i)
    return l[0] = c, l[1] = d, u - e;
  var p = e * Math.cos(n) + t, v = e * Math.sin(n) + r, g = e * Math.cos(i) + t, m = e * Math.sin(i) + r, y = (p - o) * (p - o) + (v - s) * (v - s), b = (g - o) * (g - o) + (m - s) * (m - s);
  return y < b ? (l[0] = p, l[1] = v, Math.sqrt(y)) : (l[0] = g, l[1] = m, Math.sqrt(b));
}
function Bm(t, r, e, n, i, a, o, s) {
  var l = i - t, u = a - r, c = e - t, d = n - r, f = Math.sqrt(c * c + d * d);
  c /= f, d /= f;
  var h = l * c + u * d, p = h / f;
  s && (p = Math.min(Math.max(p, 0), 1)), p *= f;
  var v = o[0] = t + p * c, g = o[1] = r + p * d;
  return Math.sqrt((v - i) * (v - i) + (g - a) * (g - a));
}
function pG(t, r, e, n, i, a, o) {
  e < 0 && (t = t + e, e = -e), n < 0 && (r = r + n, n = -n);
  var s = t + e, l = r + n, u = o[0] = Math.min(Math.max(i, t), s), c = o[1] = Math.min(Math.max(a, r), l);
  return Math.sqrt((u - i) * (u - i) + (c - a) * (c - a));
}
var ja = [];
function ste(t, r, e) {
  var n = pG(r.x, r.y, r.width, r.height, t.x, t.y, ja);
  return e.set(ja[0], ja[1]), n;
}
function lte(t, r, e) {
  for (var n = 0, i = 0, a = 0, o = 0, s, l, u = 1 / 0, c = r.data, d = t.x, f = t.y, h = 0; h < c.length; ) {
    var p = c[h++];
    h === 1 && (n = c[h], i = c[h + 1], a = n, o = i);
    var v = u;
    switch (p) {
      case zu.M:
        a = c[h++], o = c[h++], n = a, i = o;
        break;
      case zu.L:
        v = Bm(n, i, c[h], c[h + 1], d, f, ja, !0), n = c[h++], i = c[h++];
        break;
      case zu.C:
        v = QP(n, i, c[h++], c[h++], c[h++], c[h++], c[h], c[h + 1], d, f, ja), n = c[h++], i = c[h++];
        break;
      case zu.Q:
        v = tN(n, i, c[h++], c[h++], c[h], c[h + 1], d, f, ja), n = c[h++], i = c[h++];
        break;
      case zu.A:
        var g = c[h++], m = c[h++], y = c[h++], b = c[h++], C = c[h++], w = c[h++];
        h += 1;
        var _ = !!(1 - c[h++]);
        s = Math.cos(C) * y + g, l = Math.sin(C) * b + m, h <= 1 && (a = s, o = l);
        var x = (d - g) * b / y + g;
        v = ote(g, m, b, C, C + w, _, x, f, ja), n = Math.cos(C + w) * y + g, i = Math.sin(C + w) * b + m;
        break;
      case zu.R:
        a = n = c[h++], o = i = c[h++];
        var I = c[h++], D = c[h++];
        v = pG(a, o, I, D, d, f, ja);
        break;
      case zu.Z:
        v = Bm(n, i, a, o, d, f, ja, !0), n = a, i = o;
        break;
    }
    v < u && (u = v, e.set(ja[0], ja[1]));
  }
  return u;
}
var Xa = new tt(), vr = new tt(), Kr = new tt(), Vo = new tt(), Lo = new tt();
function bA(t, r) {
  if (t) {
    var e = t.getTextGuideLine(), n = t.getTextContent();
    if (n && e) {
      var i = t.textGuideLineConfig || {}, a = [[0, 0], [0, 0], [0, 0]], o = i.candidates || ite, s = n.getBoundingRect().clone();
      s.applyTransform(n.getComputedTransform());
      var l = 1 / 0, u = i.anchor, c = t.getComputedTransform(), d = c && Kc([], c), f = r.get("length2") || 0;
      u && Kr.copy(u);
      for (var h = 0; h < o.length; h++) {
        var p = o[h];
        ate(p, 0, s, Xa, Vo), tt.scaleAndAdd(vr, Xa, Vo, f), vr.transform(d);
        var v = t.getBoundingRect(), g = u ? u.distance(vr) : t instanceof gt ? lte(vr, t.path, Kr) : ste(vr, v, Kr);
        g < l && (l = g, vr.transform(c), Kr.transform(c), Kr.toArray(a[0]), vr.toArray(a[1]), Xa.toArray(a[2]));
      }
      vG(a, r.get("minTurnAngle")), e.setShape({
        points: a
      });
    }
  }
}
var Fm = [], mi = new tt();
function vG(t, r) {
  if (r <= 180 && r > 0) {
    r = r / 180 * Math.PI, Xa.fromArray(t[0]), vr.fromArray(t[1]), Kr.fromArray(t[2]), tt.sub(Vo, Xa, vr), tt.sub(Lo, Kr, vr);
    var e = Vo.len(), n = Lo.len();
    if (!(e < 1e-3 || n < 1e-3)) {
      Vo.scale(1 / e), Lo.scale(1 / n);
      var i = Vo.dot(Lo), a = Math.cos(r);
      if (a < i) {
        var o = Bm(vr.x, vr.y, Kr.x, Kr.y, Xa.x, Xa.y, Fm, !1);
        mi.fromArray(Fm), mi.scaleAndAdd(Lo, o / Math.tan(Math.PI - r));
        var s = Kr.x !== vr.x ? (mi.x - vr.x) / (Kr.x - vr.x) : (mi.y - vr.y) / (Kr.y - vr.y);
        if (isNaN(s))
          return;
        s < 0 ? tt.copy(mi, vr) : s > 1 && tt.copy(mi, Kr), mi.toArray(t[1]);
      }
    }
  }
}
function ute(t, r, e) {
  if (e <= 180 && e > 0) {
    e = e / 180 * Math.PI, Xa.fromArray(t[0]), vr.fromArray(t[1]), Kr.fromArray(t[2]), tt.sub(Vo, vr, Xa), tt.sub(Lo, Kr, vr);
    var n = Vo.len(), i = Lo.len();
    if (!(n < 1e-3 || i < 1e-3)) {
      Vo.scale(1 / n), Lo.scale(1 / i);
      var a = Vo.dot(r), o = Math.cos(e);
      if (a < o) {
        var s = Bm(vr.x, vr.y, Kr.x, Kr.y, Xa.x, Xa.y, Fm, !1);
        mi.fromArray(Fm);
        var l = Math.PI / 2, u = Math.acos(Lo.dot(r)), c = l + u - e;
        if (c >= l)
          tt.copy(mi, Kr);
        else {
          mi.scaleAndAdd(Lo, s / Math.tan(Math.PI / 2 - c));
          var d = Kr.x !== vr.x ? (mi.x - vr.x) / (Kr.x - vr.x) : (mi.y - vr.y) / (Kr.y - vr.y);
          if (isNaN(d))
            return;
          d < 0 ? tt.copy(mi, vr) : d > 1 && tt.copy(mi, Kr);
        }
        mi.toArray(t[1]);
      }
    }
  }
}
function Lb(t, r, e, n) {
  var i = e === "normal", a = i ? t : t.ensureState(e);
  a.ignore = r;
  var o = n.get("smooth");
  o && o === !0 && (o = 0.3), a.shape = a.shape || {}, o > 0 && (a.shape.smooth = o);
  var s = n.getModel("lineStyle").getLineStyle();
  i ? t.useStyle(s) : a.style = s;
}
function cte(t, r) {
  var e = r.smooth, n = r.points;
  if (n)
    if (t.moveTo(n[0][0], n[0][1]), e > 0 && n.length >= 3) {
      var i = Ts(n[0], n[1]), a = Ts(n[1], n[2]);
      if (!i || !a) {
        t.lineTo(n[1][0], n[1][1]), t.lineTo(n[2][0], n[2][1]);
        return;
      }
      var o = Math.min(i, a) * e, s = Zp([], n[1], n[0], o / i), l = Zp([], n[1], n[2], o / a), u = Zp([], s, l, 0.5);
      t.bezierCurveTo(s[0], s[1], s[0], s[1], u[0], u[1]), t.bezierCurveTo(l[0], l[1], l[0], l[1], n[2][0], n[2][1]);
    } else
      for (var c = 1; c < n.length; c++)
        t.lineTo(n[c][0], n[c][1]);
}
function kw(t, r, e) {
  var n = t.getTextGuideLine(), i = t.getTextContent();
  if (!i) {
    n && t.removeTextGuideLine();
    return;
  }
  for (var a = r.normal, o = a.get("show"), s = i.ignore, l = 0; l < Cv.length; l++) {
    var u = Cv[l], c = r[u], d = u === "normal";
    if (c) {
      var f = c.get("show"), h = d ? s : je(i.states[u] && i.states[u].ignore, s);
      if (h || !je(f, o)) {
        var p = d ? n : n && n.states[u];
        p && (p.ignore = !0), n && Lb(n, !0, u, c);
        continue;
      }
      n || (n = new ci(), t.setTextGuideLine(n), !d && (s || !o) && Lb(n, !0, "normal", r.normal), t.stateProxy && (n.stateProxy = t.stateProxy)), Lb(n, !1, u, c);
    }
  }
  if (n) {
    Ee(n.style, e), n.style.fill = null;
    var v = a.get("showAbove"), g = t.textGuideLineConfig = t.textGuideLineConfig || {};
    g.showAbove = v || !1, n.buildPath = cte;
  }
}
function Pw(t, r) {
  r = r || "labelLine";
  for (var e = {
    normal: t.getModel(r)
  }, n = 0; n < xi.length; n++) {
    var i = xi[n];
    e[i] = t.getModel([i, r]);
  }
  return e;
}
function gG(t) {
  for (var r = [], e = 0; e < t.length; e++) {
    var n = t[e];
    if (!n.defaultAttr.ignore) {
      var i = n.label, a = i.getComputedTransform(), o = i.getBoundingRect(), s = !a || a[1] < 1e-5 && a[2] < 1e-5, l = i.style.margin || 0, u = o.clone();
      u.applyTransform(a), u.x -= l / 2, u.y -= l / 2, u.width += l, u.height += l;
      var c = s ? new Cm(o, a) : null;
      r.push({
        label: i,
        labelLine: n.labelLine,
        rect: u,
        localRect: o,
        obb: c,
        priority: n.priority,
        defaultAttr: n.defaultAttr,
        layoutOption: n.computedLayoutOption,
        axisAligned: s,
        transform: a
      });
    }
  }
  return r;
}
function mG(t, r, e, n, i, a) {
  var o = t.length;
  if (o < 2)
    return;
  t.sort(function(I, D) {
    return I.rect[r] - D.rect[r];
  });
  for (var s = 0, l, u = !1, c = 0, d = 0; d < o; d++) {
    var f = t[d], h = f.rect;
    l = h[r] - s, l < 0 && (h[r] -= l, f.label[r] -= l, u = !0);
    var p = Math.max(-l, 0);
    c += p, s = h[r] + h[e];
  }
  c > 0 && a && w(-c / o, 0, o);
  var v = t[0], g = t[o - 1], m, y;
  b(), m < 0 && _(-m, 0.8), y < 0 && _(y, 0.8), b(), C(m, y, 1), C(y, m, -1), b(), m < 0 && x(-m), y < 0 && x(y);
  function b() {
    m = v.rect[r] - n, y = i - g.rect[r] - g.rect[e];
  }
  function C(I, D, T) {
    if (I < 0) {
      var A = Math.min(D, -I);
      if (A > 0) {
        w(A * T, 0, o);
        var M = A + I;
        M < 0 && _(-M * T, 1);
      } else
        _(-I * T, 1);
    }
  }
  function w(I, D, T) {
    I !== 0 && (u = !0);
    for (var A = D; A < T; A++) {
      var M = t[A], R = M.rect;
      R[r] += I, M.label[r] += I;
    }
  }
  function _(I, D) {
    for (var T = [], A = 0, M = 1; M < o; M++) {
      var R = t[M - 1].rect, E = Math.max(t[M].rect[r] - R[r] - R[e], 0);
      T.push(E), A += E;
    }
    if (A) {
      var k = Math.min(Math.abs(I) / A, D);
      if (I > 0)
        for (var M = 0; M < o - 1; M++) {
          var P = T[M] * k;
          w(P, 0, M + 1);
        }
      else
        for (var M = o - 1; M > 0; M--) {
          var P = T[M - 1] * k;
          w(-P, M, o);
        }
    }
  }
  function x(I) {
    var D = I < 0 ? -1 : 1;
    I = Math.abs(I);
    for (var T = Math.ceil(I / (o - 1)), A = 0; A < o - 1; A++)
      if (D > 0 ? w(T, 0, A + 1) : w(-T, o - A - 1, o), I -= T, I <= 0)
        return;
  }
  return u;
}
function dte(t, r, e, n) {
  return mG(t, "x", "width", r, e, n);
}
function yG(t, r, e, n) {
  return mG(t, "y", "height", r, e, n);
}
function bG(t) {
  var r = [];
  t.sort(function(v, g) {
    return g.priority - v.priority;
  });
  var e = new rt(0, 0, 0, 0);
  function n(v) {
    if (!v.ignore) {
      var g = v.ensureState("emphasis");
      g.ignore == null && (g.ignore = !1);
    }
    v.ignore = !0;
  }
  for (var i = 0; i < t.length; i++) {
    var a = t[i], o = a.axisAligned, s = a.localRect, l = a.transform, u = a.label, c = a.labelLine;
    e.copy(a.rect), e.width -= 0.1, e.height -= 0.1, e.x += 0.05, e.y += 0.05;
    for (var d = a.obb, f = !1, h = 0; h < r.length; h++) {
      var p = r[h];
      if (e.intersect(p.rect)) {
        if (o && p.axisAligned) {
          f = !0;
          break;
        }
        if (p.obb || (p.obb = new Cm(p.localRect, p.transform)), d || (d = new Cm(s, l)), d.intersect(p.obb)) {
          f = !0;
          break;
        }
      }
    }
    f ? (n(u), c && n(c)) : (u.attr("ignore", a.defaultAttr.ignore), c && c.attr("ignore", a.defaultAttr.labelGuideIgnore), r.push(a));
  }
}
function fte(t) {
  if (t) {
    for (var r = [], e = 0; e < t.length; e++)
      r.push(t[e].slice());
    return r;
  }
}
function hte(t, r) {
  var e = t.label, n = r && r.getTextGuideLine();
  return {
    dataIndex: t.dataIndex,
    dataType: t.dataType,
    seriesIndex: t.seriesModel.seriesIndex,
    text: t.label.style.text,
    rect: t.hostRect,
    labelRect: t.rect,
    // x: labelAttr.x,
    // y: labelAttr.y,
    align: e.style.align,
    verticalAlign: e.style.verticalAlign,
    labelLinePoints: fte(n && n.shape.points)
  };
}
var CA = ["align", "verticalAlign", "width", "height", "fontSize"], hi = new Ls(), Eb = It(), pte = It();
function M1(t, r, e) {
  for (var n = 0; n < e.length; n++) {
    var i = e[n];
    r[i] != null && (t[i] = r[i]);
  }
}
var R1 = ["x", "y", "rotation"], vte = (
  /** @class */
  function() {
    function t() {
      this._labelList = [], this._chartViewList = [];
    }
    return t.prototype.clearLabels = function() {
      this._labelList = [], this._chartViewList = [];
    }, t.prototype._addLabel = function(r, e, n, i, a) {
      var o = i.style, s = i.__hostTarget, l = s.textConfig || {}, u = i.getComputedTransform(), c = i.getBoundingRect().plain();
      rt.applyTransform(c, c, u), u ? hi.setLocalTransform(u) : (hi.x = hi.y = hi.rotation = hi.originX = hi.originY = 0, hi.scaleX = hi.scaleY = 1), hi.rotation = Ji(hi.rotation);
      var d = i.__hostTarget, f;
      if (d) {
        f = d.getBoundingRect().plain();
        var h = d.getComputedTransform();
        rt.applyTransform(f, f, h);
      }
      var p = f && d.getTextGuideLine();
      this._labelList.push({
        label: i,
        labelLine: p,
        seriesModel: n,
        dataIndex: r,
        dataType: e,
        layoutOption: a,
        computedLayoutOption: null,
        rect: c,
        hostRect: f,
        // Label with lower priority will be hidden when overlapped
        // Use rect size as default priority
        priority: f ? f.width * f.height : 0,
        // Save default label attributes.
        // For restore if developers want get back to default value in callback.
        defaultAttr: {
          ignore: i.ignore,
          labelGuideIgnore: p && p.ignore,
          x: hi.x,
          y: hi.y,
          scaleX: hi.scaleX,
          scaleY: hi.scaleY,
          rotation: hi.rotation,
          style: {
            x: o.x,
            y: o.y,
            align: o.align,
            verticalAlign: o.verticalAlign,
            width: o.width,
            height: o.height,
            fontSize: o.fontSize
          },
          cursor: i.cursor,
          attachedPos: l.position,
          attachedRot: l.rotation
        }
      });
    }, t.prototype.addLabelsOfSeries = function(r) {
      var e = this;
      this._chartViewList.push(r);
      var n = r.__model, i = n.get("labelLayout");
      (Ae(i) || yt(i).length) && r.group.traverse(function(a) {
        if (a.ignore)
          return !0;
        var o = a.getTextContent(), s = Ze(a);
        o && !o.disableLabelLayout && e._addLabel(s.dataIndex, s.dataType, n, o, i);
      });
    }, t.prototype.updateLayoutConfig = function(r) {
      var e = r.getWidth(), n = r.getHeight();
      function i(b, C) {
        return function() {
          bA(b, C);
        };
      }
      for (var a = 0; a < this._labelList.length; a++) {
        var o = this._labelList[a], s = o.label, l = s.__hostTarget, u = o.defaultAttr, c = void 0;
        Ae(o.layoutOption) ? c = o.layoutOption(hte(o, l)) : c = o.layoutOption, c = c || {}, o.computedLayoutOption = c;
        var d = Math.PI / 180;
        l && l.setTextConfig({
          // Force to set local false.
          local: !1,
          // Ignore position and rotation config on the host el if x or y is changed.
          position: c.x != null || c.y != null ? null : u.attachedPos,
          // Ignore rotation config on the host el if rotation is changed.
          rotation: c.rotate != null ? c.rotate * d : u.attachedRot,
          offset: [c.dx || 0, c.dy || 0]
        });
        var f = !1;
        if (c.x != null ? (s.x = he(c.x, e), s.setStyle("x", 0), f = !0) : (s.x = u.x, s.setStyle("x", u.style.x)), c.y != null ? (s.y = he(c.y, n), s.setStyle("y", 0), f = !0) : (s.y = u.y, s.setStyle("y", u.style.y)), c.labelLinePoints) {
          var h = l.getTextGuideLine();
          h && (h.setShape({
            points: c.labelLinePoints
          }), f = !1);
        }
        var p = Eb(s);
        p.needsUpdateLabelLine = f, s.rotation = c.rotate != null ? c.rotate * d : u.rotation, s.scaleX = u.scaleX, s.scaleY = u.scaleY;
        for (var v = 0; v < CA.length; v++) {
          var g = CA[v];
          s.setStyle(g, c[g] != null ? c[g] : u.style[g]);
        }
        if (c.draggable) {
          if (s.draggable = !0, s.cursor = "move", l) {
            var m = o.seriesModel;
            if (o.dataIndex != null) {
              var y = o.seriesModel.getData(o.dataType);
              m = y.getItemModel(o.dataIndex);
            }
            s.on("drag", i(l, m.getModel("labelLine")));
          }
        } else
          s.off("drag"), s.cursor = u.cursor;
      }
    }, t.prototype.layout = function(r) {
      var e = r.getWidth(), n = r.getHeight(), i = gG(this._labelList), a = Wt(i, function(l) {
        return l.layoutOption.moveOverlap === "shiftX";
      }), o = Wt(i, function(l) {
        return l.layoutOption.moveOverlap === "shiftY";
      });
      dte(a, 0, e), yG(o, 0, n);
      var s = Wt(i, function(l) {
        return l.layoutOption.hideOverlap;
      });
      bG(s);
    }, t.prototype.processLabelsOverall = function() {
      var r = this;
      L(this._chartViewList, function(e) {
        var n = e.__model, i = e.ignoreLabelLineUpdate, a = n.isAnimationEnabled();
        e.group.traverse(function(o) {
          if (o.ignore && !o.forceLabelAnimation)
            return !0;
          var s = !i, l = o.getTextContent();
          !s && l && (s = Eb(l).needsUpdateLabelLine), s && r._updateLabelLine(o, n), a && r._animateLabels(o, n);
        });
      });
    }, t.prototype._updateLabelLine = function(r, e) {
      var n = r.getTextContent(), i = Ze(r), a = i.dataIndex;
      if (n && a != null) {
        var o = e.getData(i.dataType), s = o.getItemModel(a), l = {}, u = o.getItemVisual(a, "style");
        if (u) {
          var c = o.getVisual("drawType");
          l.stroke = u[c];
        }
        var d = s.getModel("labelLine");
        kw(r, Pw(s), l), bA(r, d);
      }
    }, t.prototype._animateLabels = function(r, e) {
      var n = r.getTextContent(), i = r.getTextGuideLine();
      if (n && (r.forceLabelAnimation || !n.ignore && !n.invisible && !r.disableLabelAnimation && !hf(r))) {
        var a = Eb(n), o = a.oldLayout, s = Ze(r), l = s.dataIndex, u = {
          x: n.x,
          y: n.y,
          rotation: n.rotation
        }, c = e.getData(s.dataType);
        if (o) {
          n.attr(o);
          var f = r.prevStates;
          f && (nt(f, "select") >= 0 && n.attr(a.oldLayoutSelect), nt(f, "emphasis") >= 0 && n.attr(a.oldLayoutEmphasis)), kt(n, u, e, l);
        } else if (n.attr(u), !oh(n).valueAnimation) {
          var d = je(n.style.opacity, 1);
          n.style.opacity = 0, Cr(n, {
            style: {
              opacity: d
            }
          }, e, l);
        }
        if (a.oldLayout = u, n.states.select) {
          var h = a.oldLayoutSelect = {};
          M1(h, u, R1), M1(h, n.states.select, R1);
        }
        if (n.states.emphasis) {
          var p = a.oldLayoutEmphasis = {};
          M1(p, u, R1), M1(p, n.states.emphasis, R1);
        }
        hO(n, l, c, e, e);
      }
      if (i && !i.ignore && !i.invisible) {
        var a = pte(i), o = a.oldLayout, v = {
          points: i.shape.points
        };
        o ? (i.attr({
          shape: o
        }), kt(i, {
          shape: v
        }, e)) : (i.setShape(v), i.style.strokePercent = 0, Cr(i, {
          style: {
            strokePercent: 1
          }
        }, e)), a.oldLayout = v;
      }
    }, t;
  }()
), kb = It();
function gte(t) {
  t.registerUpdateLifecycle("series:beforeupdate", function(r, e, n) {
    var i = kb(e).labelManager;
    i || (i = kb(e).labelManager = new vte()), i.clearLabels();
  }), t.registerUpdateLifecycle("series:layoutlabels", function(r, e, n) {
    var i = kb(e).labelManager;
    n.updatedSeries.forEach(function(a) {
      i.addLabelsOfSeries(e.getViewOfSeriesModel(a));
    }), i.updateLayoutConfig(e), i.layout(e), i.processLabelsOverall();
  });
}
var Pb = Math.sin, Nb = Math.cos, CG = Math.PI, Wu = Math.PI * 2, mte = 180 / CG, wG = function() {
  function t() {
  }
  return t.prototype.reset = function(r) {
    this._start = !0, this._d = [], this._str = "", this._p = Math.pow(10, r || 4);
  }, t.prototype.moveTo = function(r, e) {
    this._add("M", r, e);
  }, t.prototype.lineTo = function(r, e) {
    this._add("L", r, e);
  }, t.prototype.bezierCurveTo = function(r, e, n, i, a, o) {
    this._add("C", r, e, n, i, a, o);
  }, t.prototype.quadraticCurveTo = function(r, e, n, i) {
    this._add("Q", r, e, n, i);
  }, t.prototype.arc = function(r, e, n, i, a, o) {
    this.ellipse(r, e, n, n, 0, i, a, o);
  }, t.prototype.ellipse = function(r, e, n, i, a, o, s, l) {
    var u = s - o, c = !l, d = Math.abs(u), f = Tl(d - Wu) || (c ? u >= Wu : -u >= Wu), h = u > 0 ? u % Wu : u % Wu + Wu, p = !1;
    f ? p = !0 : Tl(d) ? p = !1 : p = h >= CG == !!c;
    var v = r + n * Nb(o), g = e + i * Pb(o);
    this._start && this._add("M", v, g);
    var m = Math.round(a * mte);
    if (f) {
      var y = 1 / this._p, b = (c ? 1 : -1) * (Wu - y);
      this._add("A", n, i, m, 1, +c, r + n * Nb(o + b), e + i * Pb(o + b)), y > 0.01 && this._add("A", n, i, m, 0, +c, v, g);
    } else {
      var C = r + n * Nb(s), w = e + i * Pb(s);
      this._add("A", n, i, m, +p, +c, C, w);
    }
  }, t.prototype.rect = function(r, e, n, i) {
    this._add("M", r, e), this._add("l", n, 0), this._add("l", 0, i), this._add("l", -n, 0), this._add("Z");
  }, t.prototype.closePath = function() {
    this._d.length > 0 && this._add("Z");
  }, t.prototype._add = function(r, e, n, i, a, o, s, l, u) {
    for (var c = [], d = this._p, f = 1; f < arguments.length; f++) {
      var h = arguments[f];
      if (isNaN(h)) {
        this._invalid = !0;
        return;
      }
      c.push(Math.round(h * d) / d);
    }
    this._d.push(r + c.join(" ")), this._start = r === "Z";
  }, t.prototype.generateStr = function() {
    this._str = this._invalid ? "" : this._d.join(""), this._d = [];
  }, t.prototype.getStr = function() {
    return this._str;
  }, t;
}(), Nw = "none", yte = Math.round;
function bte(t) {
  var r = t.fill;
  return r != null && r !== Nw;
}
function Cte(t) {
  var r = t.stroke;
  return r != null && r !== Nw;
}
var m9 = ["lineCap", "miterLimit", "lineJoin"], wte = ce(m9, function(t) {
  return "stroke-" + t.toLowerCase();
});
function _te(t, r, e, n) {
  var i = r.opacity == null ? 1 : r.opacity;
  if (e instanceof An) {
    t("opacity", i);
    return;
  }
  if (bte(r)) {
    var a = bv(r.fill);
    t("fill", a.color);
    var o = r.fillOpacity != null ? r.fillOpacity * a.opacity * i : a.opacity * i;
    o < 1 && t("fill-opacity", o);
  } else
    t("fill", Nw);
  if (Cte(r)) {
    var s = bv(r.stroke);
    t("stroke", s.color);
    var l = r.strokeNoScale ? e.getLineScale() : 1, u = l ? (r.lineWidth || 0) / l : 0, c = r.strokeOpacity != null ? r.strokeOpacity * s.opacity * i : s.opacity * i, d = r.strokeFirst;
    if (u !== 1 && t("stroke-width", u), d && t("paint-order", d ? "stroke" : "fill"), c < 1 && t("stroke-opacity", c), r.lineDash) {
      var f = vw(e), h = f[0], p = f[1];
      h && (p = yte(p || 0), t("stroke-dasharray", h.join(",")), (p || n) && t("stroke-dashoffset", p));
    }
    for (var v = 0; v < m9.length; v++) {
      var g = m9[v];
      if (r[g] !== ym[g]) {
        var m = r[g] || ym[g];
        m && t(wte[v], m);
      }
    }
  }
}
var _G = "http://www.w3.org/2000/svg", xG = "http://www.w3.org/1999/xlink", xte = "http://www.w3.org/2000/xmlns/", Ste = "http://www.w3.org/XML/1998/namespace", wA = "ecmeta_";
function SG(t) {
  return document.createElementNS(_G, t);
}
function Cn(t, r, e, n, i) {
  return {
    tag: t,
    attrs: e || {},
    children: n,
    text: i,
    key: r
  };
}
function Ite(t, r) {
  var e = [];
  if (r)
    for (var n in r) {
      var i = r[n], a = n;
      i !== !1 && (i !== !0 && i != null && (a += '="' + i + '"'), e.push(a));
    }
  return "<" + t + " " + e.join(" ") + ">";
}
function Ate(t) {
  return "</" + t + ">";
}
function Ow(t, r) {
  r = r || {};
  var e = r.newline ? `
` : "";
  function n(i) {
    var a = i.children, o = i.tag, s = i.attrs, l = i.text;
    return Ite(o, s) + (o !== "style" ? bi(l) : l || "") + (a ? "" + e + ce(a, function(u) {
      return n(u);
    }).join(e) + e : "") + Ate(o);
  }
  return n(t);
}
function Dte(t, r, e) {
  e = e || {};
  var n = e.newline ? `
` : "", i = " {" + n, a = n + "}", o = ce(yt(t), function(l) {
    return l + i + ce(yt(t[l]), function(u) {
      return u + ":" + t[l][u] + ";";
    }).join(n) + a;
  }).join(n), s = ce(yt(r), function(l) {
    return "@keyframes " + l + i + ce(yt(r[l]), function(u) {
      return u + i + ce(yt(r[l][u]), function(c) {
        var d = r[l][u][c];
        return c === "d" && (d = 'path("' + d + '")'), c + ":" + d + ";";
      }).join(n) + a;
    }).join(n) + a;
  }).join(n);
  return !o && !s ? "" : ["<![CDATA[", o, s, "]]>"].join(n);
}
function y9(t) {
  return {
    zrId: t,
    shadowCache: {},
    patternCache: {},
    gradientCache: {},
    clipPathCache: {},
    defs: {},
    cssNodes: {},
    cssAnims: {},
    cssStyleCache: {},
    cssAnimIdx: 0,
    shadowIdx: 0,
    gradientIdx: 0,
    patternIdx: 0,
    clipPathIdx: 0
  };
}
function _A(t, r, e, n) {
  return Cn("svg", "root", {
    width: t,
    height: r,
    xmlns: _G,
    "xmlns:xlink": xG,
    version: "1.1",
    baseProfile: "full",
    viewBox: n ? "0 0 " + t + " " + r : !1
  }, e);
}
var Tte = 0;
function IG() {
  return Tte++;
}
var xA = {
  cubicIn: "0.32,0,0.67,0",
  cubicOut: "0.33,1,0.68,1",
  cubicInOut: "0.65,0,0.35,1",
  quadraticIn: "0.11,0,0.5,0",
  quadraticOut: "0.5,1,0.89,1",
  quadraticInOut: "0.45,0,0.55,1",
  quarticIn: "0.5,0,0.75,0",
  quarticOut: "0.25,1,0.5,1",
  quarticInOut: "0.76,0,0.24,1",
  quinticIn: "0.64,0,0.78,0",
  quinticOut: "0.22,1,0.36,1",
  quinticInOut: "0.83,0,0.17,1",
  sinusoidalIn: "0.12,0,0.39,0",
  sinusoidalOut: "0.61,1,0.88,1",
  sinusoidalInOut: "0.37,0,0.63,1",
  exponentialIn: "0.7,0,0.84,0",
  exponentialOut: "0.16,1,0.3,1",
  exponentialInOut: "0.87,0,0.13,1",
  circularIn: "0.55,0,1,0.45",
  circularOut: "0,0.55,0.45,1",
  circularInOut: "0.85,0,0.15,1"
}, $u = "transform-origin";
function Mte(t, r, e) {
  var n = ae({}, t.shape);
  ae(n, r), t.buildPath(e, n);
  var i = new wG();
  return i.reset(lN(t)), e.rebuildPath(i, 1), i.generateStr(), i.getStr();
}
function Rte(t, r) {
  var e = r.originX, n = r.originY;
  (e || n) && (t[$u] = e + "px " + n + "px");
}
var Lte = {
  fill: "fill",
  opacity: "opacity",
  lineWidth: "stroke-width",
  lineDashOffset: "stroke-dashoffset"
};
function AG(t, r) {
  var e = r.zrId + "-ani-" + r.cssAnimIdx++;
  return r.cssAnims[e] = t, e;
}
function Ete(t, r, e) {
  var n = t.shape.paths, i = {}, a, o;
  if (L(n, function(l) {
    var u = y9(e.zrId);
    u.animation = !0, M2(l, {}, u, !0);
    var c = u.cssAnims, d = u.cssNodes, f = yt(c), h = f.length;
    if (h) {
      o = f[h - 1];
      var p = c[o];
      for (var v in p) {
        var g = p[v];
        i[v] = i[v] || { d: "" }, i[v].d += g.d || "";
      }
      for (var m in d) {
        var y = d[m].animation;
        y.indexOf(o) >= 0 && (a = y);
      }
    }
  }), !!a) {
    r.d = !1;
    var s = AG(i, e);
    return a.replace(o, s);
  }
}
function SA(t) {
  return pe(t) ? xA[t] ? "cubic-bezier(" + xA[t] + ")" : A7(t) ? t : "" : "";
}
function M2(t, r, e, n) {
  var i = t.animators, a = i.length, o = [];
  if (t instanceof c2) {
    var s = Ete(t, r, e);
    if (s)
      o.push(s);
    else if (!a)
      return;
  } else if (!a)
    return;
  for (var l = {}, u = 0; u < a; u++) {
    var c = i[u], d = [c.getMaxTime() / 1e3 + "s"], f = SA(c.getClip().easing), h = c.getDelay();
    f ? d.push(f) : d.push("linear"), h && d.push(h / 1e3 + "s"), c.getLoop() && d.push("infinite");
    var p = d.join(" ");
    l[p] = l[p] || [p, []], l[p][1].push(c);
  }
  function v(y) {
    var b = y[1], C = b.length, w = {}, _ = {}, x = {}, I = "animation-timing-function";
    function D(j, oe, ie) {
      for (var le = j.getTracks(), re = j.getMaxTime(), Re = 0; Re < le.length; Re++) {
        var ve = le[Re];
        if (ve.needsAnimate()) {
          var Oe = ve.keyframes, qe = ve.propName;
          if (ie && (qe = ie(qe)), qe)
            for (var dt = 0; dt < Oe.length; dt++) {
              var At = Oe[dt], Be = Math.round(At.time / re * 100) + "%", Nt = SA(At.easing), wt = At.rawValue;
              (pe(wt) || Mt(wt)) && (oe[Be] = oe[Be] || {}, oe[Be][qe] = At.rawValue, Nt && (oe[Be][I] = Nt));
            }
        }
      }
    }
    for (var T = 0; T < C; T++) {
      var A = b[T], M = A.targetName;
      M ? M === "shape" && D(A, _) : !n && D(A, w);
    }
    for (var R in w) {
      var E = {};
      hN(E, t), ae(E, w[R]);
      var k = uN(E), P = w[R][I];
      x[R] = k ? {
        transform: k
      } : {}, Rte(x[R], E), P && (x[R][I] = P);
    }
    var N, O = !0;
    for (var R in _) {
      x[R] = x[R] || {};
      var W = !N, P = _[R][I];
      W && (N = new Qo());
      var V = N.len();
      N.reset(), x[R].d = Mte(t, _[R], N);
      var B = N.len();
      if (!W && V !== B) {
        O = !1;
        break;
      }
      P && (x[R][I] = P);
    }
    if (!O)
      for (var R in x)
        delete x[R].d;
    if (!n)
      for (var T = 0; T < C; T++) {
        var A = b[T], M = A.targetName;
        M === "style" && D(A, x, function(le) {
          return Lte[le];
        });
      }
    for (var Z = yt(x), q = !0, z, T = 1; T < Z.length; T++) {
      var U = Z[T - 1], J = Z[T];
      if (x[U][$u] !== x[J][$u]) {
        q = !1;
        break;
      }
      z = x[U][$u];
    }
    if (q && z) {
      for (var R in x)
        x[R][$u] && delete x[R][$u];
      r[$u] = z;
    }
    if (Wt(Z, function(j) {
      return yt(x[j]).length > 0;
    }).length) {
      var K = AG(x, e);
      return K + " " + y[0] + " both";
    }
  }
  for (var g in l) {
    var s = v(l[g]);
    s && o.push(s);
  }
  if (o.length) {
    var m = e.zrId + "-cls-" + IG();
    e.cssNodes["." + m] = {
      animation: o.join(",")
    }, r.class = m;
  }
}
function kte(t, r, e) {
  if (!t.ignore)
    if (t.isSilent()) {
      var n = {
        "pointer-events": "none"
      };
      IA(n, r, e);
    } else {
      var i = t.states.emphasis && t.states.emphasis.style ? t.states.emphasis.style : {}, a = i.fill;
      if (!a) {
        var o = t.style && t.style.fill, s = t.states.select && t.states.select.style && t.states.select.style.fill, l = t.currentStates.indexOf("select") >= 0 && s || o;
        l && (a = hm(l));
      }
      var u = i.lineWidth;
      if (u) {
        var c = !i.strokeNoScale && t.transform ? t.transform[0] : 1;
        u = u / c;
      }
      var n = {
        cursor: "pointer"
      };
      a && (n.fill = a), i.stroke && (n.stroke = i.stroke), u && (n["stroke-width"] = u), IA(n, r, e);
    }
}
function IA(t, r, e, n) {
  var i = JSON.stringify(t), a = e.cssStyleCache[i];
  a || (a = e.zrId + "-cls-" + IG(), e.cssStyleCache[i] = a, e.cssNodes["." + a + ":hover"] = t), r.class = r.class ? r.class + " " + a : a;
}
var Mv = Math.round;
function DG(t) {
  return t && pe(t.src);
}
function TG(t) {
  return t && Ae(t.toDataURL);
}
function Vw(t, r, e, n) {
  _te(function(i, a) {
    var o = i === "fill" || i === "stroke";
    o && sN(a) ? RG(r, t, i, n) : o && T7(a) ? LG(e, t, i, n) : o && a === "none" ? t[i] = "transparent" : t[i] = a;
  }, r, e, !1), Fte(e, t, n);
}
function Gw(t, r) {
  var e = gN(r);
  e && (e.each(function(n, i) {
    n != null && (t[(wA + i).toLowerCase()] = n + "");
  }), r.isSilent() && (t[wA + "silent"] = "true"));
}
function AA(t) {
  return Tl(t[0] - 1) && Tl(t[1]) && Tl(t[2]) && Tl(t[3] - 1);
}
function Pte(t) {
  return Tl(t[4]) && Tl(t[5]);
}
function Bw(t, r, e) {
  if (r && !(Pte(r) && AA(r))) {
    var n = 1e4;
    t.transform = AA(r) ? "translate(" + Mv(r[4] * n) / n + " " + Mv(r[5] * n) / n + ")" : NX(r);
  }
}
function DA(t, r, e) {
  for (var n = t.points, i = [], a = 0; a < n.length; a++)
    i.push(Mv(n[a][0] * e) / e), i.push(Mv(n[a][1] * e) / e);
  r.points = i.join(" ");
}
function TA(t) {
  return !t.smooth;
}
function Nte(t) {
  var r = ce(t, function(e) {
    return typeof e == "string" ? [e, e] : e;
  });
  return function(e, n, i) {
    for (var a = 0; a < r.length; a++) {
      var o = r[a], s = e[o[0]];
      s != null && (n[o[1]] = Mv(s * i) / i);
    }
  };
}
var Ote = {
  circle: [Nte(["cx", "cy", "r"])],
  polyline: [DA, TA],
  polygon: [DA, TA]
};
function Vte(t) {
  for (var r = t.animators, e = 0; e < r.length; e++)
    if (r[e].targetName === "shape")
      return !0;
  return !1;
}
function MG(t, r) {
  var e = t.style, n = t.shape, i = Ote[t.type], a = {}, o = r.animation, s = "path", l = t.style.strokePercent, u = r.compress && lN(t) || 4;
  if (i && !r.willUpdate && !(i[1] && !i[1](n)) && !(o && Vte(t)) && !(l < 1)) {
    s = t.type;
    var c = Math.pow(10, u);
    i[0](n, a, c);
  } else {
    var d = !t.path || t.shapeChanged();
    t.path || t.createPathProxy();
    var f = t.path;
    d && (f.beginPath(), t.buildPath(f, t.shape), t.pathUpdated());
    var h = f.getVersion(), p = t, v = p.__svgPathBuilder;
    (p.__svgPathVersion !== h || !v || l !== p.__svgPathStrokePercent) && (v || (v = p.__svgPathBuilder = new wG()), v.reset(u), f.rebuildPath(v, l), v.generateStr(), p.__svgPathVersion = h, p.__svgPathStrokePercent = l), a.d = v.getStr();
  }
  return Bw(a, t.transform), Vw(a, e, t, r), Gw(a, t), r.animation && M2(t, a, r), r.emphasis && kte(t, a, r), Cn(s, t.id + "", a);
}
function Gte(t, r) {
  var e = t.style, n = e.image;
  if (n && !pe(n) && (DG(n) ? n = n.src : TG(n) && (n = n.toDataURL())), !!n) {
    var i = e.x || 0, a = e.y || 0, o = e.width, s = e.height, l = {
      href: n,
      width: o,
      height: s
    };
    return i && (l.x = i), a && (l.y = a), Bw(l, t.transform), Vw(l, e, t, r), Gw(l, t), r.animation && M2(t, l, r), Cn("image", t.id + "", l);
  }
}
function Bte(t, r) {
  var e = t.style, n = e.text;
  if (n != null && (n += ""), !(!n || isNaN(e.x) || isNaN(e.y))) {
    var i = e.font || Jl, a = e.x || 0, o = VX(e.y || 0, e2(i), e.textBaseline), s = OX[e.textAlign] || e.textAlign, l = {
      "dominant-baseline": "central",
      "text-anchor": s
    };
    if (FN(e)) {
      var u = "", c = e.fontStyle, d = BN(e.fontSize);
      if (!parseFloat(d))
        return;
      var f = e.fontFamily || kP, h = e.fontWeight;
      u += "font-size:" + d + ";font-family:" + f + ";", c && c !== "normal" && (u += "font-style:" + c + ";"), h && h !== "normal" && (u += "font-weight:" + h + ";"), l.style = u;
    } else
      l.style = "font: " + i;
    return n.match(/\s/) && (l["xml:space"] = "preserve"), a && (l.x = a), o && (l.y = o), Bw(l, t.transform), Vw(l, e, t, r), Gw(l, t), r.animation && M2(t, l, r), Cn("text", t.id + "", l, void 0, n);
  }
}
function MA(t, r) {
  if (t instanceof gt)
    return MG(t, r);
  if (t instanceof An)
    return Gte(t, r);
  if (t instanceof Tf)
    return Bte(t, r);
}
function Fte(t, r, e) {
  var n = t.style;
  if (GX(n)) {
    var i = BX(t), a = e.shadowCache, o = a[i];
    if (!o) {
      var s = t.getGlobalScale(), l = s[0], u = s[1];
      if (!l || !u)
        return;
      var c = n.shadowOffsetX || 0, d = n.shadowOffsetY || 0, f = n.shadowBlur, h = bv(n.shadowColor), p = h.opacity, v = h.color, g = f / 2 / l, m = f / 2 / u, y = g + " " + m;
      o = e.zrId + "-s" + e.shadowIdx++, e.defs[o] = Cn("filter", o, {
        id: o,
        x: "-100%",
        y: "-100%",
        width: "300%",
        height: "300%"
      }, [
        Cn("feDropShadow", "", {
          dx: c / l,
          dy: d / u,
          stdDeviation: y,
          "flood-color": v,
          "flood-opacity": p
        })
      ]), a[i] = o;
    }
    r.filter = Qy(o);
  }
}
function RG(t, r, e, n) {
  var i = t[e], a, o = {
    gradientUnits: i.global ? "userSpaceOnUse" : "objectBoundingBox"
  };
  if (aN(i))
    a = "linearGradient", o.x1 = i.x, o.y1 = i.y, o.x2 = i.x2, o.y2 = i.y2;
  else if (oN(i))
    a = "radialGradient", o.cx = je(i.x, 0.5), o.cy = je(i.y, 0.5), o.r = je(i.r, 0.5);
  else {
    process.env.NODE_ENV !== "production" && Da("Illegal gradient type.");
    return;
  }
  for (var s = i.colorStops, l = [], u = 0, c = s.length; u < c; ++u) {
    var d = AC(s[u].offset) * 100 + "%", f = s[u].color, h = bv(f), p = h.color, v = h.opacity, g = {
      offset: d
    };
    g["stop-color"] = p, v < 1 && (g["stop-opacity"] = v), l.push(Cn("stop", u + "", g));
  }
  var m = Cn(a, "", o, l), y = Ow(m), b = n.gradientCache, C = b[y];
  C || (C = n.zrId + "-g" + n.gradientIdx++, b[y] = C, o.id = C, n.defs[C] = Cn(a, C, o, l)), r[e] = Qy(C);
}
function LG(t, r, e, n) {
  var i = t.style[e], a = t.getBoundingRect(), o = {}, s = i.repeat, l = s === "no-repeat", u = s === "repeat-x", c = s === "repeat-y", d;
  if (iN(i)) {
    var f = i.imageWidth, h = i.imageHeight, p = void 0, v = i.image;
    if (pe(v) ? p = v : DG(v) ? p = v.src : TG(v) && (p = v.toDataURL()), typeof Image > "u") {
      var g = "Image width/height must been given explictly in svg-ssr renderer.";
      ke(f, g), ke(h, g);
    } else if (f == null || h == null) {
      var m = function(T, A) {
        if (T) {
          var M = T.elm, R = f || A.width, E = h || A.height;
          T.tag === "pattern" && (u ? (E = 1, R /= a.width) : c && (R = 1, E /= a.height)), T.attrs.width = R, T.attrs.height = E, M && (M.setAttribute("width", R), M.setAttribute("height", E));
        }
      }, y = O7(p, null, t, function(T) {
        l || m(_, T), m(d, T);
      });
      y && y.width && y.height && (f = f || y.width, h = h || y.height);
    }
    d = Cn("image", "img", {
      href: p,
      width: f,
      height: h
    }), o.width = f, o.height = h;
  } else i.svgElement && (d = Ge(i.svgElement), o.width = i.svgWidth, o.height = i.svgHeight);
  if (d) {
    var b, C;
    l ? b = C = 1 : u ? (C = 1, b = o.width / a.width) : c ? (b = 1, C = o.height / a.height) : o.patternUnits = "userSpaceOnUse", b != null && !isNaN(b) && (o.width = b), C != null && !isNaN(C) && (o.height = C);
    var w = uN(i);
    w && (o.patternTransform = w);
    var _ = Cn("pattern", "", o, [d]), x = Ow(_), I = n.patternCache, D = I[x];
    D || (D = n.zrId + "-p" + n.patternIdx++, I[x] = D, o.id = D, _ = n.defs[D] = Cn("pattern", D, o, [d])), r[e] = Qy(D);
  }
}
function Hte(t, r, e) {
  var n = e.clipPathCache, i = e.defs, a = n[t.id];
  if (!a) {
    a = e.zrId + "-c" + e.clipPathIdx++;
    var o = {
      id: a
    };
    n[t.id] = a, i[a] = Cn("clipPath", a, o, [MG(t, e)]);
  }
  r["clip-path"] = Qy(a);
}
function RA(t) {
  return document.createTextNode(t);
}
function ac(t, r, e) {
  t.insertBefore(r, e);
}
function LA(t, r) {
  t.removeChild(r);
}
function EA(t, r) {
  t.appendChild(r);
}
function EG(t) {
  return t.parentNode;
}
function kG(t) {
  return t.nextSibling;
}
function Ob(t, r) {
  t.textContent = r;
}
var kA = 58, zte = 120, Wte = Cn("", "");
function b9(t) {
  return t === void 0;
}
function Io(t) {
  return t !== void 0;
}
function Zte(t, r, e) {
  for (var n = {}, i = r; i <= e; ++i) {
    var a = t[i].key;
    a !== void 0 && (process.env.NODE_ENV !== "production" && n[a] != null && console.error("Duplicate key " + a), n[a] = i);
  }
  return n;
}
function Ep(t, r) {
  var e = t.key === r.key, n = t.tag === r.tag;
  return n && e;
}
function Rv(t) {
  var r, e = t.children, n = t.tag;
  if (Io(n)) {
    var i = t.elm = SG(n);
    if (Fw(Wte, t), ue(e))
      for (r = 0; r < e.length; ++r) {
        var a = e[r];
        a != null && EA(i, Rv(a));
      }
    else Io(t.text) && !Me(t.text) && EA(i, RA(t.text));
  } else
    t.elm = RA(t.text);
  return t.elm;
}
function PG(t, r, e, n, i) {
  for (; n <= i; ++n) {
    var a = e[n];
    a != null && ac(t, Rv(a), r);
  }
}
function Hm(t, r, e, n) {
  for (; e <= n; ++e) {
    var i = r[e];
    if (i != null)
      if (Io(i.tag)) {
        var a = EG(i.elm);
        LA(a, i.elm);
      } else
        LA(t, i.elm);
  }
}
function Fw(t, r) {
  var e, n = r.elm, i = t && t.attrs || {}, a = r.attrs || {};
  if (i !== a) {
    for (e in a) {
      var o = a[e], s = i[e];
      s !== o && (o === !0 ? n.setAttribute(e, "") : o === !1 ? n.removeAttribute(e) : e === "style" ? n.style.cssText = o : e.charCodeAt(0) !== zte ? n.setAttribute(e, o) : e === "xmlns:xlink" || e === "xmlns" ? n.setAttributeNS(xte, e, o) : e.charCodeAt(3) === kA ? n.setAttributeNS(Ste, e, o) : e.charCodeAt(5) === kA ? n.setAttributeNS(xG, e, o) : n.setAttribute(e, o));
    }
    for (e in i)
      e in a || n.removeAttribute(e);
  }
}
function jte(t, r, e) {
  for (var n = 0, i = 0, a = r.length - 1, o = r[0], s = r[a], l = e.length - 1, u = e[0], c = e[l], d, f, h, p; n <= a && i <= l; )
    o == null ? o = r[++n] : s == null ? s = r[--a] : u == null ? u = e[++i] : c == null ? c = e[--l] : Ep(o, u) ? (Zd(o, u), o = r[++n], u = e[++i]) : Ep(s, c) ? (Zd(s, c), s = r[--a], c = e[--l]) : Ep(o, c) ? (Zd(o, c), ac(t, o.elm, kG(s.elm)), o = r[++n], c = e[--l]) : Ep(s, u) ? (Zd(s, u), ac(t, s.elm, o.elm), s = r[--a], u = e[++i]) : (b9(d) && (d = Zte(r, n, a)), f = d[u.key], b9(f) ? ac(t, Rv(u), o.elm) : (h = r[f], h.tag !== u.tag ? ac(t, Rv(u), o.elm) : (Zd(h, u), r[f] = void 0, ac(t, h.elm, o.elm))), u = e[++i]);
  (n <= a || i <= l) && (n > a ? (p = e[l + 1] == null ? null : e[l + 1].elm, PG(t, p, e, i, l)) : Hm(t, r, n, a));
}
function Zd(t, r) {
  var e = r.elm = t.elm, n = t.children, i = r.children;
  t !== r && (Fw(t, r), b9(r.text) ? Io(n) && Io(i) ? n !== i && jte(e, n, i) : Io(i) ? (Io(t.text) && Ob(e, ""), PG(e, null, i, 0, i.length - 1)) : Io(n) ? Hm(e, n, 0, n.length - 1) : Io(t.text) && Ob(e, "") : t.text !== r.text && (Io(n) && Hm(e, n, 0, n.length - 1), Ob(e, r.text)));
}
function Yte(t, r) {
  if (Ep(t, r))
    Zd(t, r);
  else {
    var e = t.elm, n = EG(e);
    Rv(r), n !== null && (ac(n, r.elm, kG(e)), Hm(n, [t], 0, 0));
  }
  return r;
}
var Xte = 0, $te = function() {
  function t(r, e, n) {
    if (this.type = "svg", this.refreshHover = PA("refreshHover"), this.configLayer = PA("configLayer"), this.storage = e, this._opts = n = ae({}, n), this.root = r, this._id = "zr" + Xte++, this._oldVNode = _A(n.width, n.height), r && !n.ssr) {
      var i = this._viewport = document.createElement("div");
      i.style.cssText = "position:relative;overflow:hidden";
      var a = this._svgDom = this._oldVNode.elm = SG("svg");
      Fw(null, this._oldVNode), i.appendChild(a), r.appendChild(i);
    }
    this.resize(n.width, n.height);
  }
  return t.prototype.getType = function() {
    return this.type;
  }, t.prototype.getViewportRoot = function() {
    return this._viewport;
  }, t.prototype.getViewportRootOffset = function() {
    var r = this.getViewportRoot();
    if (r)
      return {
        offsetLeft: r.offsetLeft || 0,
        offsetTop: r.offsetTop || 0
      };
  }, t.prototype.getSvgDom = function() {
    return this._svgDom;
  }, t.prototype.refresh = function() {
    if (this.root) {
      var r = this.renderToVNode({
        willUpdate: !0
      });
      r.attrs.style = "position:absolute;left:0;top:0;user-select:none", Yte(this._oldVNode, r), this._oldVNode = r;
    }
  }, t.prototype.renderOneToVNode = function(r) {
    return MA(r, y9(this._id));
  }, t.prototype.renderToVNode = function(r) {
    r = r || {};
    var e = this.storage.getDisplayList(!0), n = this._width, i = this._height, a = y9(this._id);
    a.animation = r.animation, a.willUpdate = r.willUpdate, a.compress = r.compress, a.emphasis = r.emphasis;
    var o = [], s = this._bgVNode = Ute(n, i, this._backgroundColor, a);
    s && o.push(s);
    var l = r.compress ? null : this._mainVNode = Cn("g", "main", {}, []);
    this._paintList(e, a, l ? l.children : o), l && o.push(l);
    var u = ce(yt(a.defs), function(f) {
      return a.defs[f];
    });
    if (u.length && o.push(Cn("defs", "defs", {}, u)), r.animation) {
      var c = Dte(a.cssNodes, a.cssAnims, { newline: !0 });
      if (c) {
        var d = Cn("style", "stl", {}, [], c);
        o.push(d);
      }
    }
    return _A(n, i, o, r.useViewBox);
  }, t.prototype.renderToString = function(r) {
    return r = r || {}, Ow(this.renderToVNode({
      animation: je(r.cssAnimation, !0),
      emphasis: je(r.cssEmphasis, !0),
      willUpdate: !1,
      compress: !0,
      useViewBox: je(r.useViewBox, !0)
    }), { newline: !0 });
  }, t.prototype.setBackgroundColor = function(r) {
    this._backgroundColor = r;
  }, t.prototype.getSvgRoot = function() {
    return this._mainVNode && this._mainVNode.elm;
  }, t.prototype._paintList = function(r, e, n) {
    for (var i = r.length, a = [], o = 0, s, l, u = 0, c = 0; c < i; c++) {
      var d = r[c];
      if (!d.invisible) {
        var f = d.__clipPaths, h = f && f.length || 0, p = l && l.length || 0, v = void 0;
        for (v = Math.max(h - 1, p - 1); v >= 0 && !(f && l && f[v] === l[v]); v--)
          ;
        for (var g = p - 1; g > v; g--)
          o--, s = a[o - 1];
        for (var m = v + 1; m < h; m++) {
          var y = {};
          Hte(f[m], y, e);
          var b = Cn("g", "clip-g-" + u++, y, []);
          (s ? s.children : n).push(b), a[o++] = b, s = b;
        }
        l = f;
        var C = MA(d, e);
        C && (s ? s.children : n).push(C);
      }
    }
  }, t.prototype.resize = function(r, e) {
    var n = this._opts, i = this.root, a = this._viewport;
    if (r != null && (n.width = r), e != null && (n.height = e), i && a && (a.style.display = "none", r = Kd(i, 0, n), e = Kd(i, 1, n), a.style.display = ""), this._width !== r || this._height !== e) {
      if (this._width = r, this._height = e, a) {
        var o = a.style;
        o.width = r + "px", o.height = e + "px";
      }
      if (T7(this._backgroundColor))
        this.refresh();
      else {
        var s = this._svgDom;
        s && (s.setAttribute("width", r), s.setAttribute("height", e));
        var l = this._bgVNode && this._bgVNode.elm;
        l && (l.setAttribute("width", r), l.setAttribute("height", e));
      }
    }
  }, t.prototype.getWidth = function() {
    return this._width;
  }, t.prototype.getHeight = function() {
    return this._height;
  }, t.prototype.dispose = function() {
    this.root && (this.root.innerHTML = ""), this._svgDom = this._viewport = this.storage = this._oldVNode = this._bgVNode = this._mainVNode = null;
  }, t.prototype.clear = function() {
    this._svgDom && (this._svgDom.innerHTML = null), this._oldVNode = null;
  }, t.prototype.toDataURL = function(r) {
    var e = this.renderToString(), n = "data:image/svg+xml;";
    return r ? (e = HX(e), e && n + "base64," + e) : n + "charset=UTF-8," + encodeURIComponent(e);
  }, t;
}();
function PA(t) {
  return function() {
    process.env.NODE_ENV !== "production" && Da('In SVG mode painter not support method "' + t + '"');
  };
}
function Ute(t, r, e, n) {
  var i;
  if (e && e !== "none")
    if (i = Cn("rect", "bg", {
      width: t,
      height: r,
      x: "0",
      y: "0"
    }), sN(e))
      RG({ fill: e }, i.attrs, "fill", n);
    else if (T7(e))
      LG({
        style: {
          fill: e
        },
        dirty: Yr,
        getBoundingRect: function() {
          return { width: t, height: r };
        }
      }, i.attrs, "fill", n);
    else {
      var a = bv(e), o = a.color, s = a.opacity;
      i.attrs.fill = o, s < 1 && (i.attrs["fill-opacity"] = s);
    }
  return i;
}
function Jte(t) {
  t.registerPainter("svg", $te);
}
function NA(t, r, e) {
  var n = Qa.createCanvas(), i = r.getWidth(), a = r.getHeight(), o = n.style;
  return o && (o.position = "absolute", o.left = "0", o.top = "0", o.width = i + "px", o.height = a + "px", n.setAttribute("data-zr-dom-id", t)), n.width = i * e, n.height = a * e, n;
}
var Vb = function(t) {
  _r(r, t);
  function r(e, n, i) {
    var a = t.call(this) || this;
    a.motionBlur = !1, a.lastFrameAlpha = 0.7, a.dpr = 1, a.virtual = !1, a.config = {}, a.incremental = !1, a.zlevel = 0, a.maxRepaintRectCount = 5, a.__dirty = !0, a.__firstTimePaint = !0, a.__used = !1, a.__drawIndex = 0, a.__startIndex = 0, a.__endIndex = 0, a.__prevStartIndex = null, a.__prevEndIndex = null;
    var o;
    i = i || vm, typeof e == "string" ? o = NA(e, n, i) : Me(e) && (o = e, e = o.id), a.id = e, a.dom = o;
    var s = o.style;
    return s && (x7(o), o.onselectstart = function() {
      return !1;
    }, s.padding = "0", s.margin = "0", s.borderWidth = "0"), a.painter = n, a.dpr = i, a;
  }
  return r.prototype.getElementCount = function() {
    return this.__endIndex - this.__startIndex;
  }, r.prototype.afterBrush = function() {
    this.__prevStartIndex = this.__startIndex, this.__prevEndIndex = this.__endIndex;
  }, r.prototype.initContext = function() {
    this.ctx = this.dom.getContext("2d"), this.ctx.dpr = this.dpr;
  }, r.prototype.setUnpainted = function() {
    this.__firstTimePaint = !0;
  }, r.prototype.createBackBuffer = function() {
    var e = this.dpr;
    this.domBack = NA("back-" + this.id, this.painter, e), this.ctxBack = this.domBack.getContext("2d"), e !== 1 && this.ctxBack.scale(e, e);
  }, r.prototype.createRepaintRects = function(e, n, i, a) {
    if (this.__firstTimePaint)
      return this.__firstTimePaint = !1, null;
    var o = [], s = this.maxRepaintRectCount, l = !1, u = new rt(0, 0, 0, 0);
    function c(y) {
      if (!(!y.isFinite() || y.isZero()))
        if (o.length === 0) {
          var b = new rt(0, 0, 0, 0);
          b.copy(y), o.push(b);
        } else {
          for (var C = !1, w = 1 / 0, _ = 0, x = 0; x < o.length; ++x) {
            var I = o[x];
            if (I.intersect(y)) {
              var D = new rt(0, 0, 0, 0);
              D.copy(I), D.union(y), o[x] = D, C = !0;
              break;
            } else if (l) {
              u.copy(y), u.union(I);
              var T = y.width * y.height, A = I.width * I.height, M = u.width * u.height, R = M - T - A;
              R < w && (w = R, _ = x);
            }
          }
          if (l && (o[_].union(y), C = !0), !C) {
            var b = new rt(0, 0, 0, 0);
            b.copy(y), o.push(b);
          }
          l || (l = o.length >= s);
        }
    }
    for (var d = this.__startIndex; d < this.__endIndex; ++d) {
      var f = e[d];
      if (f) {
        var h = f.shouldBePainted(i, a, !0, !0), p = f.__isRendered && (f.__dirty & ji || !h) ? f.getPrevPaintRect() : null;
        p && c(p);
        var v = h && (f.__dirty & ji || !f.__isRendered) ? f.getPaintRect() : null;
        v && c(v);
      }
    }
    for (var d = this.__prevStartIndex; d < this.__prevEndIndex; ++d) {
      var f = n[d], h = f && f.shouldBePainted(i, a, !0, !0);
      if (f && (!h || !f.__zr) && f.__isRendered) {
        var p = f.getPrevPaintRect();
        p && c(p);
      }
    }
    var g;
    do {
      g = !1;
      for (var d = 0; d < o.length; ) {
        if (o[d].isZero()) {
          o.splice(d, 1);
          continue;
        }
        for (var m = d + 1; m < o.length; )
          o[d].intersect(o[m]) ? (g = !0, o[d].union(o[m]), o.splice(m, 1)) : m++;
        d++;
      }
    } while (g);
    return this._paintRects = o, o;
  }, r.prototype.debugGetPaintRects = function() {
    return (this._paintRects || []).slice();
  }, r.prototype.resize = function(e, n) {
    var i = this.dpr, a = this.dom, o = a.style, s = this.domBack;
    o && (o.width = e + "px", o.height = n + "px"), a.width = e * i, a.height = n * i, s && (s.width = e * i, s.height = n * i, i !== 1 && this.ctxBack.scale(i, i));
  }, r.prototype.clear = function(e, n, i) {
    var a = this.dom, o = this.ctx, s = a.width, l = a.height;
    n = n || this.clearColor;
    var u = this.motionBlur && !e, c = this.lastFrameAlpha, d = this.dpr, f = this;
    u && (this.domBack || this.createBackBuffer(), this.ctxBack.globalCompositeOperation = "copy", this.ctxBack.drawImage(a, 0, 0, s / d, l / d));
    var h = this.domBack;
    function p(v, g, m, y) {
      if (o.clearRect(v, g, m, y), n && n !== "transparent") {
        var b = void 0;
        if (og(n)) {
          var C = n.global || n.__width === m && n.__height === y;
          b = C && n.__canvasGradient || l9(o, n, {
            x: 0,
            y: 0,
            width: m,
            height: y
          }), n.__canvasGradient = b, n.__width = m, n.__height = y;
        } else GP(n) && (n.scaleX = n.scaleX || d, n.scaleY = n.scaleY || d, b = u9(o, n, {
          dirty: function() {
            f.setUnpainted(), f.painter.refresh();
          }
        }));
        o.save(), o.fillStyle = b || n, o.fillRect(v, g, m, y), o.restore();
      }
      u && (o.save(), o.globalAlpha = c, o.drawImage(h, v, g, m, y), o.restore());
    }
    !i || u ? p(0, 0, s, l) : i.length && L(i, function(v) {
      p(v.x * d, v.y * d, v.width * d, v.height * d);
    });
  }, r;
}(ka), OA = 1e5, Zu = 314159, L1 = 0.01, Kte = 1e-3;
function qte(t) {
  return t ? t.__builtin__ ? !0 : !(typeof t.resize != "function" || typeof t.refresh != "function") : !1;
}
function Qte(t, r) {
  var e = document.createElement("div");
  return e.style.cssText = [
    "position:relative",
    "width:" + t + "px",
    "height:" + r + "px",
    "padding:0",
    "margin:0",
    "border-width:0"
  ].join(";") + ";", e;
}
var ere = function() {
  function t(r, e, n, i) {
    this.type = "canvas", this._zlevelList = [], this._prevDisplayList = [], this._layers = {}, this._layerConfig = {}, this._needsManuallyCompositing = !1, this.type = "canvas";
    var a = !r.nodeName || r.nodeName.toUpperCase() === "CANVAS";
    this._opts = n = ae({}, n || {}), this.dpr = n.devicePixelRatio || vm, this._singleCanvas = a, this.root = r;
    var o = r.style;
    o && (x7(r), r.innerHTML = ""), this.storage = e;
    var s = this._zlevelList;
    this._prevDisplayList = [];
    var l = this._layers;
    if (a) {
      var c = r, d = c.width, f = c.height;
      n.width != null && (d = n.width), n.height != null && (f = n.height), this.dpr = n.devicePixelRatio || 1, c.width = d * this.dpr, c.height = f * this.dpr, this._width = d, this._height = f;
      var h = new Vb(c, this, this.dpr);
      h.__builtin__ = !0, h.initContext(), l[Zu] = h, h.zlevel = Zu, s.push(Zu), this._domRoot = r;
    } else {
      this._width = Kd(r, 0, n), this._height = Kd(r, 1, n);
      var u = this._domRoot = Qte(this._width, this._height);
      r.appendChild(u);
    }
  }
  return t.prototype.getType = function() {
    return "canvas";
  }, t.prototype.isSingleCanvas = function() {
    return this._singleCanvas;
  }, t.prototype.getViewportRoot = function() {
    return this._domRoot;
  }, t.prototype.getViewportRootOffset = function() {
    var r = this.getViewportRoot();
    if (r)
      return {
        offsetLeft: r.offsetLeft || 0,
        offsetTop: r.offsetTop || 0
      };
  }, t.prototype.refresh = function(r) {
    var e = this.storage.getDisplayList(!0), n = this._prevDisplayList, i = this._zlevelList;
    this._redrawId = Math.random(), this._paintList(e, n, r, this._redrawId);
    for (var a = 0; a < i.length; a++) {
      var o = i[a], s = this._layers[o];
      if (!s.__builtin__ && s.refresh) {
        var l = a === 0 ? this._backgroundColor : null;
        s.refresh(l);
      }
    }
    return this._opts.useDirtyRect && (this._prevDisplayList = e.slice()), this;
  }, t.prototype.refreshHover = function() {
    this._paintHoverList(this.storage.getDisplayList(!1));
  }, t.prototype._paintHoverList = function(r) {
    var e = r.length, n = this._hoverlayer;
    if (n && n.clear(), !!e) {
      for (var i = {
        inHover: !0,
        viewWidth: this._width,
        viewHeight: this._height
      }, a, o = 0; o < e; o++) {
        var s = r[o];
        s.__inHover && (n || (n = this._hoverlayer = this.getLayer(OA)), a || (a = n.ctx, a.save()), vc(a, s, i, o === e - 1));
      }
      a && a.restore();
    }
  }, t.prototype.getHoverLayer = function() {
    return this.getLayer(OA);
  }, t.prototype.paintOne = function(r, e) {
    gw(r, e);
  }, t.prototype._paintList = function(r, e, n, i) {
    if (this._redrawId === i) {
      n = n || !1, this._updateLayerStatus(r);
      var a = this._doPaintList(r, e, n), o = a.finished, s = a.needsRefreshHover;
      if (this._needsManuallyCompositing && this._compositeManually(), s && this._paintHoverList(r), o)
        this.eachLayer(function(u) {
          u.afterBrush && u.afterBrush();
        });
      else {
        var l = this;
        um(function() {
          l._paintList(r, e, n, i);
        });
      }
    }
  }, t.prototype._compositeManually = function() {
    var r = this.getLayer(Zu).ctx, e = this._domRoot.width, n = this._domRoot.height;
    r.clearRect(0, 0, e, n), this.eachBuiltinLayer(function(i) {
      i.virtual && r.drawImage(i.dom, 0, 0, e, n);
    });
  }, t.prototype._doPaintList = function(r, e, n) {
    for (var i = this, a = [], o = this._opts.useDirtyRect, s = 0; s < this._zlevelList.length; s++) {
      var l = this._zlevelList[s], u = this._layers[l];
      u.__builtin__ && u !== this._hoverlayer && (u.__dirty || n) && a.push(u);
    }
    for (var c = !0, d = !1, f = function(v) {
      var g = a[v], m = g.ctx, y = o && g.createRepaintRects(r, e, h._width, h._height), b = n ? g.__startIndex : g.__drawIndex, C = !n && g.incremental && Date.now, w = C && Date.now(), _ = g.zlevel === h._zlevelList[0] ? h._backgroundColor : null;
      if (g.__startIndex === g.__endIndex)
        g.clear(!1, _, y);
      else if (b === g.__startIndex) {
        var x = r[b];
        (!x.incremental || !x.notClear || n) && g.clear(!1, _, y);
      }
      b === -1 && (console.error("For some unknown reason. drawIndex is -1"), b = g.__startIndex);
      var I, D = function(R) {
        var E = {
          inHover: !1,
          allClipped: !1,
          prevEl: null,
          viewWidth: i._width,
          viewHeight: i._height
        };
        for (I = b; I < g.__endIndex; I++) {
          var k = r[I];
          if (k.__inHover && (d = !0), i._doPaintEl(k, g, o, R, E, I === g.__endIndex - 1), C) {
            var P = Date.now() - w;
            if (P > 15)
              break;
          }
        }
        E.prevElClipPaths && m.restore();
      };
      if (y)
        if (y.length === 0)
          I = g.__endIndex;
        else
          for (var T = h.dpr, A = 0; A < y.length; ++A) {
            var M = y[A];
            m.save(), m.beginPath(), m.rect(M.x * T, M.y * T, M.width * T, M.height * T), m.clip(), D(M), m.restore();
          }
      else
        m.save(), D(), m.restore();
      g.__drawIndex = I, g.__drawIndex < g.__endIndex && (c = !1);
    }, h = this, p = 0; p < a.length; p++)
      f(p);
    return vt.wxa && L(this._layers, function(v) {
      v && v.ctx && v.ctx.draw && v.ctx.draw();
    }), {
      finished: c,
      needsRefreshHover: d
    };
  }, t.prototype._doPaintEl = function(r, e, n, i, a, o) {
    var s = e.ctx;
    if (n) {
      var l = r.getPaintRect();
      (!i || l && l.intersect(i)) && (vc(s, r, a, o), r.setPrevPaintRect(l));
    } else
      vc(s, r, a, o);
  }, t.prototype.getLayer = function(r, e) {
    this._singleCanvas && !this._needsManuallyCompositing && (r = Zu);
    var n = this._layers[r];
    return n || (n = new Vb("zr_" + r, this, this.dpr), n.zlevel = r, n.__builtin__ = !0, this._layerConfig[r] ? Qe(n, this._layerConfig[r], !0) : this._layerConfig[r - L1] && Qe(n, this._layerConfig[r - L1], !0), e && (n.virtual = e), this.insertLayer(r, n), n.initContext()), n;
  }, t.prototype.insertLayer = function(r, e) {
    var n = this._layers, i = this._zlevelList, a = i.length, o = this._domRoot, s = null, l = -1;
    if (n[r]) {
      process.env.NODE_ENV !== "production" && Da("ZLevel " + r + " has been used already");
      return;
    }
    if (!qte(e)) {
      process.env.NODE_ENV !== "production" && Da("Layer of zlevel " + r + " is not valid");
      return;
    }
    if (a > 0 && r > i[0]) {
      for (l = 0; l < a - 1 && !(i[l] < r && i[l + 1] > r); l++)
        ;
      s = n[i[l]];
    }
    if (i.splice(l + 1, 0, r), n[r] = e, !e.virtual)
      if (s) {
        var u = s.dom;
        u.nextSibling ? o.insertBefore(e.dom, u.nextSibling) : o.appendChild(e.dom);
      } else
        o.firstChild ? o.insertBefore(e.dom, o.firstChild) : o.appendChild(e.dom);
    e.painter || (e.painter = this);
  }, t.prototype.eachLayer = function(r, e) {
    for (var n = this._zlevelList, i = 0; i < n.length; i++) {
      var a = n[i];
      r.call(e, this._layers[a], a);
    }
  }, t.prototype.eachBuiltinLayer = function(r, e) {
    for (var n = this._zlevelList, i = 0; i < n.length; i++) {
      var a = n[i], o = this._layers[a];
      o.__builtin__ && r.call(e, o, a);
    }
  }, t.prototype.eachOtherLayer = function(r, e) {
    for (var n = this._zlevelList, i = 0; i < n.length; i++) {
      var a = n[i], o = this._layers[a];
      o.__builtin__ || r.call(e, o, a);
    }
  }, t.prototype.getLayers = function() {
    return this._layers;
  }, t.prototype._updateLayerStatus = function(r) {
    this.eachBuiltinLayer(function(d, f) {
      d.__dirty = d.__used = !1;
    });
    function e(d) {
      a && (a.__endIndex !== d && (a.__dirty = !0), a.__endIndex = d);
    }
    if (this._singleCanvas)
      for (var n = 1; n < r.length; n++) {
        var i = r[n];
        if (i.zlevel !== r[n - 1].zlevel || i.incremental) {
          this._needsManuallyCompositing = !0;
          break;
        }
      }
    var a = null, o = 0, s, l;
    for (l = 0; l < r.length; l++) {
      var i = r[l], u = i.zlevel, c = void 0;
      s !== u && (s = u, o = 0), i.incremental ? (c = this.getLayer(u + Kte, this._needsManuallyCompositing), c.incremental = !0, o = 1) : c = this.getLayer(u + (o > 0 ? L1 : 0), this._needsManuallyCompositing), c.__builtin__ || Da("ZLevel " + u + " has been used by unkown layer " + c.id), c !== a && (c.__used = !0, c.__startIndex !== l && (c.__dirty = !0), c.__startIndex = l, c.incremental ? c.__drawIndex = -1 : c.__drawIndex = l, e(l), a = c), i.__dirty & ji && !i.__inHover && (c.__dirty = !0, c.incremental && c.__drawIndex < 0 && (c.__drawIndex = l));
    }
    e(l), this.eachBuiltinLayer(function(d, f) {
      !d.__used && d.getElementCount() > 0 && (d.__dirty = !0, d.__startIndex = d.__endIndex = d.__drawIndex = 0), d.__dirty && d.__drawIndex < 0 && (d.__drawIndex = d.__startIndex);
    });
  }, t.prototype.clear = function() {
    return this.eachBuiltinLayer(this._clearLayer), this;
  }, t.prototype._clearLayer = function(r) {
    r.clear();
  }, t.prototype.setBackgroundColor = function(r) {
    this._backgroundColor = r, L(this._layers, function(e) {
      e.setUnpainted();
    });
  }, t.prototype.configLayer = function(r, e) {
    if (e) {
      var n = this._layerConfig;
      n[r] ? Qe(n[r], e, !0) : n[r] = e;
      for (var i = 0; i < this._zlevelList.length; i++) {
        var a = this._zlevelList[i];
        if (a === r || a === r + L1) {
          var o = this._layers[a];
          Qe(o, n[r], !0);
        }
      }
    }
  }, t.prototype.delLayer = function(r) {
    var e = this._layers, n = this._zlevelList, i = e[r];
    i && (i.dom.parentNode.removeChild(i.dom), delete e[r], n.splice(nt(n, r), 1));
  }, t.prototype.resize = function(r, e) {
    if (this._domRoot.style) {
      var n = this._domRoot;
      n.style.display = "none";
      var i = this._opts, a = this.root;
      if (r != null && (i.width = r), e != null && (i.height = e), r = Kd(a, 0, i), e = Kd(a, 1, i), n.style.display = "", this._width !== r || e !== this._height) {
        n.style.width = r + "px", n.style.height = e + "px";
        for (var o in this._layers)
          this._layers.hasOwnProperty(o) && this._layers[o].resize(r, e);
        this.refresh(!0);
      }
      this._width = r, this._height = e;
    } else {
      if (r == null || e == null)
        return;
      this._width = r, this._height = e, this.getLayer(Zu).resize(r, e);
    }
    return this;
  }, t.prototype.clearLayer = function(r) {
    var e = this._layers[r];
    e && e.clear();
  }, t.prototype.dispose = function() {
    this.root.innerHTML = "", this.root = this.storage = this._domRoot = this._layers = null;
  }, t.prototype.getRenderedCanvas = function(r) {
    if (r = r || {}, this._singleCanvas && !this._compositeManually)
      return this._layers[Zu].dom;
    var e = new Vb("image", this, r.pixelRatio || this.dpr);
    e.initContext(), e.clear(!1, r.backgroundColor || this._backgroundColor);
    var n = e.ctx;
    if (r.pixelRatio <= this.dpr) {
      this.refresh();
      var i = e.dom.width, a = e.dom.height;
      this.eachLayer(function(d) {
        d.__builtin__ ? n.drawImage(d.dom, 0, 0, i, a) : d.renderToCanvas && (n.save(), d.renderToCanvas(n), n.restore());
      });
    } else
      for (var o = {
        inHover: !1,
        viewWidth: this._width,
        viewHeight: this._height
      }, s = this.storage.getDisplayList(!0), l = 0, u = s.length; l < u; l++) {
        var c = s[l];
        vc(n, c, o, l === u - 1);
      }
    return e.dom;
  }, t.prototype.getWidth = function() {
    return this._width;
  }, t.prototype.getHeight = function() {
    return this._height;
  }, t;
}();
function tre(t) {
  t.registerPainter("canvas", ere);
}
var rre = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e.hasSymbolVisual = !0, e;
    }
    return r.prototype.getInitialData = function(e) {
      if (process.env.NODE_ENV !== "production") {
        var n = e.coordinateSystem;
        if (n !== "polar" && n !== "cartesian2d")
          throw new Error("Line not support coordinateSystem besides cartesian and polar");
      }
      return os(null, this, {
        useEncodeDefaulter: !0
      });
    }, r.prototype.getLegendIcon = function(e) {
      var n = new ze(), i = en("line", 0, e.itemHeight / 2, e.itemWidth, 0, e.lineStyle.stroke, !1);
      n.add(i), i.setStyle(e.lineStyle);
      var a = this.getData().getVisual("symbol"), o = this.getData().getVisual("symbolRotate"), s = a === "none" ? "circle" : a, l = e.itemHeight * 0.8, u = en(s, (e.itemWidth - l) / 2, (e.itemHeight - l) / 2, l, l, e.itemStyle.fill);
      n.add(u), u.setStyle(e.itemStyle);
      var c = e.iconRotate === "inherit" ? o : e.iconRotate || 0;
      return u.rotation = c * Math.PI / 180, u.setOrigin([e.itemWidth / 2, e.itemHeight / 2]), s.indexOf("empty") > -1 && (u.style.stroke = u.style.fill, u.style.fill = "#fff", u.style.lineWidth = 2), n;
    }, r.type = "series.line", r.dependencies = ["grid", "polar"], r.defaultOption = {
      // zlevel: 0,
      z: 3,
      coordinateSystem: "cartesian2d",
      legendHoverLink: !0,
      clip: !0,
      label: {
        position: "top"
      },
      // itemStyle: {
      // },
      endLabel: {
        show: !1,
        valueAnimation: !0,
        distance: 8
      },
      lineStyle: {
        width: 2,
        type: "solid"
      },
      emphasis: {
        scale: !0
      },
      // areaStyle: {
      // origin of areaStyle. Valid values:
      // `'auto'/null/undefined`: from axisLine to data
      // `'start'`: from min to data
      // `'end'`: from data to max
      // origin: 'auto'
      // },
      // false, 'start', 'end', 'middle'
      step: !1,
      // Disabled if step is true
      smooth: !1,
      smoothMonotone: null,
      symbol: "emptyCircle",
      symbolSize: 4,
      symbolRotate: null,
      showSymbol: !0,
      // `false`: follow the label interval strategy.
      // `true`: show all symbols.
      // `'auto'`: If possible, show all symbols, otherwise
      //           follow the label interval strategy.
      showAllSymbol: "auto",
      // Whether to connect break point.
      connectNulls: !1,
      // Sampling for large data. Can be: 'average', 'max', 'min', 'sum', 'lttb'.
      sampling: "none",
      animationEasing: "linear",
      // Disable progressive
      progressive: 0,
      hoverLayerThreshold: 1 / 0,
      universalTransition: {
        divideShape: "clone"
      },
      triggerLineEvent: !1
    }, r;
  }(tr)
);
function Ef(t, r) {
  var e = t.mapDimensionsAll("defaultedLabel"), n = e.length;
  if (n === 1) {
    var i = Rf(t, r, e[0]);
    return i != null ? i + "" : null;
  } else if (n) {
    for (var a = [], o = 0; o < e.length; o++)
      a.push(Rf(t, r, e[o]));
    return a.join(" ");
  }
}
function NG(t, r) {
  var e = t.mapDimensionsAll("defaultedLabel");
  if (!ue(r))
    return r + "";
  for (var n = [], i = 0; i < e.length; i++) {
    var a = t.getDimensionIndex(e[i]);
    a >= 0 && n.push(r[a]);
  }
  return n.join(" ");
}
var wg = (
  /** @class */
  function(t) {
    ee(r, t);
    function r(e, n, i, a) {
      var o = t.call(this) || this;
      return o.updateData(e, n, i, a), o;
    }
    return r.prototype._createSymbol = function(e, n, i, a, o) {
      this.removeAll();
      var s = en(e, -1, -1, 2, 2, null, o);
      s.attr({
        z2: 100,
        culling: !0,
        scaleX: a[0] / 2,
        scaleY: a[1] / 2
      }), s.drift = nre, this._symbolType = e, this.add(s);
    }, r.prototype.stopSymbolAnimation = function(e) {
      this.childAt(0).stopAnimation(null, e);
    }, r.prototype.getSymbolType = function() {
      return this._symbolType;
    }, r.prototype.getSymbolPath = function() {
      return this.childAt(0);
    }, r.prototype.highlight = function() {
      Xs(this.childAt(0));
    }, r.prototype.downplay = function() {
      $s(this.childAt(0));
    }, r.prototype.setZ = function(e, n) {
      var i = this.childAt(0);
      i.zlevel = e, i.z = n;
    }, r.prototype.setDraggable = function(e, n) {
      var i = this.childAt(0);
      i.draggable = e, i.cursor = !n && e ? "move" : i.cursor;
    }, r.prototype.updateData = function(e, n, i, a) {
      this.silent = !1;
      var o = e.getItemVisual(n, "symbol") || "circle", s = e.hostModel, l = r.getSymbolSize(e, n), u = o !== this._symbolType, c = a && a.disableAnimation;
      if (u) {
        var d = e.getItemVisual(n, "symbolKeepAspect");
        this._createSymbol(o, e, n, l, d);
      } else {
        var f = this.childAt(0);
        f.silent = !1;
        var h = {
          scaleX: l[0] / 2,
          scaleY: l[1] / 2
        };
        c ? f.attr(h) : kt(f, h, s, n), ro(f);
      }
      if (this._updateCommon(e, n, l, i, a), u) {
        var f = this.childAt(0);
        if (!c) {
          var h = {
            scaleX: this._sizeX,
            scaleY: this._sizeY,
            style: {
              // Always fadeIn. Because it has fadeOut animation when symbol is removed..
              opacity: f.style.opacity
            }
          };
          f.scaleX = f.scaleY = 0, f.style.opacity = 0, Cr(f, h, s, n);
        }
      }
      c && this.childAt(0).stopAnimation("leave");
    }, r.prototype._updateCommon = function(e, n, i, a, o) {
      var s = this.childAt(0), l = e.hostModel, u, c, d, f, h, p, v, g, m;
      if (a && (u = a.emphasisItemStyle, c = a.blurItemStyle, d = a.selectItemStyle, f = a.focus, h = a.blurScope, v = a.labelStatesModels, g = a.hoverScale, m = a.cursorStyle, p = a.emphasisDisabled), !a || e.hasItemOption) {
        var y = a && a.itemModel ? a.itemModel : e.getItemModel(n), b = y.getModel("emphasis");
        u = b.getModel("itemStyle").getItemStyle(), d = y.getModel(["select", "itemStyle"]).getItemStyle(), c = y.getModel(["blur", "itemStyle"]).getItemStyle(), f = b.get("focus"), h = b.get("blurScope"), p = b.get("disabled"), v = xn(y), g = b.getShallow("scale"), m = y.getShallow("cursor");
      }
      var C = e.getItemVisual(n, "symbolRotate");
      s.attr("rotation", (C || 0) * Math.PI / 180 || 0);
      var w = td(e.getItemVisual(n, "symbolOffset"), i);
      w && (s.x = w[0], s.y = w[1]), m && s.attr("cursor", m);
      var _ = e.getItemVisual(n, "style"), x = _.fill;
      if (s instanceof An) {
        var I = s.style;
        s.useStyle(ae({
          // TODO other properties like x, y ?
          image: I.image,
          x: I.x,
          y: I.y,
          width: I.width,
          height: I.height
        }, _));
      } else
        s.__isEmptyBrush ? s.useStyle(ae({}, _)) : s.useStyle(_), s.style.decal = null, s.setColor(x, o && o.symbolInnerColor), s.style.strokeNoScale = !0;
      var D = e.getItemVisual(n, "liftZ"), T = this._z2;
      D != null ? T == null && (this._z2 = s.z2, s.z2 += D) : T != null && (s.z2 = T, this._z2 = null);
      var A = o && o.useNameLabel;
      Xn(s, v, {
        labelFetcher: l,
        labelDataIndex: n,
        defaultText: M,
        inheritColor: x,
        defaultOpacity: _.opacity
      });
      function M(k) {
        return A ? e.getName(k) : Ef(e, k);
      }
      this._sizeX = i[0] / 2, this._sizeY = i[1] / 2;
      var R = s.ensureState("emphasis");
      R.style = u, s.ensureState("select").style = d, s.ensureState("blur").style = c;
      var E = g == null || g === !0 ? Math.max(1.1, 3 / this._sizeY) : isFinite(g) && g > 0 ? +g : 1;
      R.scaleX = this._sizeX * E, R.scaleY = this._sizeY * E, this.setSymbolScale(1), Vr(this, f, h, p);
    }, r.prototype.setSymbolScale = function(e) {
      this.scaleX = this.scaleY = e;
    }, r.prototype.fadeOut = function(e, n, i) {
      var a = this.childAt(0), o = Ze(this).dataIndex, s = i && i.animation;
      if (this.silent = a.silent = !0, i && i.fadeLabel) {
        var l = a.getTextContent();
        l && tu(l, {
          style: {
            opacity: 0
          }
        }, n, {
          dataIndex: o,
          removeOpt: s,
          cb: function() {
            a.removeTextContent();
          }
        });
      } else
        a.removeTextContent();
      tu(a, {
        style: {
          opacity: 0
        },
        scaleX: 0,
        scaleY: 0
      }, n, {
        dataIndex: o,
        cb: e,
        removeOpt: s
      });
    }, r.getSymbolSize = function(e, n) {
      return fh(e.getItemVisual(n, "symbolSize"));
    }, r;
  }(ze)
);
function nre(t, r) {
  this.parent.drift(t, r);
}
function Gb(t, r, e, n) {
  return r && !isNaN(r[0]) && !isNaN(r[1]) && !(n.isIgnore && n.isIgnore(e)) && !(n.clipShape && !n.clipShape.contain(r[0], r[1])) && t.getItemVisual(e, "symbol") !== "none";
}
function VA(t) {
  return t != null && !Me(t) && (t = {
    isIgnore: t
  }), t || {};
}
function GA(t) {
  var r = t.hostModel, e = r.getModel("emphasis");
  return {
    emphasisItemStyle: e.getModel("itemStyle").getItemStyle(),
    blurItemStyle: r.getModel(["blur", "itemStyle"]).getItemStyle(),
    selectItemStyle: r.getModel(["select", "itemStyle"]).getItemStyle(),
    focus: e.get("focus"),
    blurScope: e.get("blurScope"),
    emphasisDisabled: e.get("disabled"),
    hoverScale: e.get("scale"),
    labelStatesModels: xn(r),
    cursorStyle: r.get("cursor")
  };
}
var _g = (
  /** @class */
  function() {
    function t(r) {
      this.group = new ze(), this._SymbolCtor = r || wg;
    }
    return t.prototype.updateData = function(r, e) {
      this._progressiveEls = null, e = VA(e);
      var n = this.group, i = r.hostModel, a = this._data, o = this._SymbolCtor, s = e.disableAnimation, l = GA(r), u = {
        disableAnimation: s
      }, c = e.getSymbolPoint || function(d) {
        return r.getItemLayout(d);
      };
      a || n.removeAll(), r.diff(a).add(function(d) {
        var f = c(d);
        if (Gb(r, f, d, e)) {
          var h = new o(r, d, l, u);
          h.setPosition(f), r.setItemGraphicEl(d, h), n.add(h);
        }
      }).update(function(d, f) {
        var h = a.getItemGraphicEl(f), p = c(d);
        if (!Gb(r, p, d, e)) {
          n.remove(h);
          return;
        }
        var v = r.getItemVisual(d, "symbol") || "circle", g = h && h.getSymbolType && h.getSymbolType();
        if (!h || g && g !== v)
          n.remove(h), h = new o(r, d, l, u), h.setPosition(p);
        else {
          h.updateData(r, d, l, u);
          var m = {
            x: p[0],
            y: p[1]
          };
          s ? h.attr(m) : kt(h, m, i);
        }
        n.add(h), r.setItemGraphicEl(d, h);
      }).remove(function(d) {
        var f = a.getItemGraphicEl(d);
        f && f.fadeOut(function() {
          n.remove(f);
        }, i);
      }).execute(), this._getSymbolPoint = c, this._data = r;
    }, t.prototype.updateLayout = function() {
      var r = this, e = this._data;
      e && e.eachItemGraphicEl(function(n, i) {
        var a = r._getSymbolPoint(i);
        n.setPosition(a), n.markRedraw();
      });
    }, t.prototype.incrementalPrepareUpdate = function(r) {
      this._seriesScope = GA(r), this._data = null, this.group.removeAll();
    }, t.prototype.incrementalUpdate = function(r, e, n) {
      this._progressiveEls = [], n = VA(n);
      function i(l) {
        l.isGroup || (l.incremental = !0, l.ensureState("emphasis").hoverLayer = !0);
      }
      for (var a = r.start; a < r.end; a++) {
        var o = e.getItemLayout(a);
        if (Gb(e, o, a, n)) {
          var s = new this._SymbolCtor(e, a, this._seriesScope);
          s.traverse(i), s.setPosition(o), this.group.add(s), e.setItemGraphicEl(a, s), this._progressiveEls.push(s);
        }
      }
    }, t.prototype.eachRendered = function(r) {
      pu(this._progressiveEls || this.group, r);
    }, t.prototype.remove = function(r) {
      var e = this.group, n = this._data;
      n && r ? n.eachItemGraphicEl(function(i) {
        i.fadeOut(function() {
          e.remove(i);
        }, n.hostModel);
      }) : e.removeAll();
    }, t;
  }()
);
function OG(t, r, e) {
  var n = t.getBaseAxis(), i = t.getOtherAxis(n), a = ire(i, e), o = n.dim, s = i.dim, l = r.mapDimension(s), u = r.mapDimension(o), c = s === "x" || s === "radius" ? 1 : 0, d = ce(t.dimensions, function(p) {
    return r.mapDimension(p);
  }), f = !1, h = r.getCalculationInfo("stackResultDimension");
  return Js(
    r,
    d[0]
    /* , dims[1] */
  ) && (f = !0, d[0] = h), Js(
    r,
    d[1]
    /* , dims[0] */
  ) && (f = !0, d[1] = h), {
    dataDimsForPoint: d,
    valueStart: a,
    valueAxisDim: s,
    baseAxisDim: o,
    stacked: !!f,
    valueDim: l,
    baseDim: u,
    baseDataOffset: c,
    stackedOverDimension: r.getCalculationInfo("stackedOverDimension")
  };
}
function ire(t, r) {
  var e = 0, n = t.scale.getExtent();
  return r === "start" ? e = n[0] : r === "end" ? e = n[1] : Mt(r) && !isNaN(r) ? e = r : n[0] > 0 ? e = n[0] : n[1] < 0 && (e = n[1]), e;
}
function VG(t, r, e, n) {
  var i = NaN;
  t.stacked && (i = e.get(e.getCalculationInfo("stackedOverDimension"), n)), isNaN(i) && (i = t.valueStart);
  var a = t.baseDataOffset, o = [];
  return o[a] = e.get(t.baseDim, n), o[1 - a] = i, r.dataToPoint(o);
}
function are(t, r) {
  var e = [];
  return r.diff(t).add(function(n) {
    e.push({
      cmd: "+",
      idx: n
    });
  }).update(function(n, i) {
    e.push({
      cmd: "=",
      idx: i,
      idx1: n
    });
  }).remove(function(n) {
    e.push({
      cmd: "-",
      idx: n
    });
  }).execute(), e;
}
function ore(t, r, e, n, i, a, o, s) {
  for (var l = are(t, r), u = [], c = [], d = [], f = [], h = [], p = [], v = [], g = OG(i, r, o), m = t.getLayout("points") || [], y = r.getLayout("points") || [], b = 0; b < l.length; b++) {
    var C = l[b], w = !0, _ = void 0, x = void 0;
    switch (C.cmd) {
      case "=":
        _ = C.idx * 2, x = C.idx1 * 2;
        var I = m[_], D = m[_ + 1], T = y[x], A = y[x + 1];
        (isNaN(I) || isNaN(D)) && (I = T, D = A), u.push(I, D), c.push(T, A), d.push(e[_], e[_ + 1]), f.push(n[x], n[x + 1]), v.push(r.getRawIndex(C.idx1));
        break;
      case "+":
        var M = C.idx, R = g.dataDimsForPoint, E = i.dataToPoint([r.get(R[0], M), r.get(R[1], M)]);
        x = M * 2, u.push(E[0], E[1]), c.push(y[x], y[x + 1]);
        var k = VG(g, i, r, M);
        d.push(k[0], k[1]), f.push(n[x], n[x + 1]), v.push(r.getRawIndex(M));
        break;
      case "-":
        w = !1;
    }
    w && (h.push(C), p.push(p.length));
  }
  p.sort(function(U, J) {
    return v[U] - v[J];
  });
  for (var P = u.length, N = Oo(P), O = Oo(P), W = Oo(P), V = Oo(P), B = [], b = 0; b < p.length; b++) {
    var Z = p[b], q = b * 2, z = Z * 2;
    N[q] = u[z], N[q + 1] = u[z + 1], O[q] = c[z], O[q + 1] = c[z + 1], W[q] = d[z], W[q + 1] = d[z + 1], V[q] = f[z], V[q + 1] = f[z + 1], B[b] = h[Z];
  }
  return {
    current: N,
    next: O,
    stackedOnCurrent: W,
    stackedOnNext: V,
    status: B
  };
}
var vl = Math.min, gl = Math.max;
function Dc(t, r) {
  return isNaN(t) || isNaN(r);
}
function C9(t, r, e, n, i, a, o, s, l) {
  for (var u, c, d, f, h, p, v = e, g = 0; g < n; g++) {
    var m = r[v * 2], y = r[v * 2 + 1];
    if (v >= i || v < 0)
      break;
    if (Dc(m, y)) {
      if (l) {
        v += a;
        continue;
      }
      break;
    }
    if (v === e)
      t[a > 0 ? "moveTo" : "lineTo"](m, y), d = m, f = y;
    else {
      var b = m - u, C = y - c;
      if (b * b + C * C < 0.5) {
        v += a;
        continue;
      }
      if (o > 0) {
        for (var w = v + a, _ = r[w * 2], x = r[w * 2 + 1]; _ === m && x === y && g < n; )
          g++, w += a, v += a, _ = r[w * 2], x = r[w * 2 + 1], m = r[v * 2], y = r[v * 2 + 1], b = m - u, C = y - c;
        var I = g + 1;
        if (l)
          for (; Dc(_, x) && I < n; )
            I++, w += a, _ = r[w * 2], x = r[w * 2 + 1];
        var D = 0.5, T = 0, A = 0, M = void 0, R = void 0;
        if (I >= n || Dc(_, x))
          h = m, p = y;
        else {
          T = _ - u, A = x - c;
          var E = m - u, k = _ - m, P = y - c, N = x - y, O = void 0, W = void 0;
          if (s === "x") {
            O = Math.abs(E), W = Math.abs(k);
            var V = T > 0 ? 1 : -1;
            h = m - V * O * o, p = y, M = m + V * W * o, R = y;
          } else if (s === "y") {
            O = Math.abs(P), W = Math.abs(N);
            var B = A > 0 ? 1 : -1;
            h = m, p = y - B * O * o, M = m, R = y + B * W * o;
          } else
            O = Math.sqrt(E * E + P * P), W = Math.sqrt(k * k + N * N), D = W / (W + O), h = m - T * o * (1 - D), p = y - A * o * (1 - D), M = m + T * o * D, R = y + A * o * D, M = vl(M, gl(_, m)), R = vl(R, gl(x, y)), M = gl(M, vl(_, m)), R = gl(R, vl(x, y)), T = M - m, A = R - y, h = m - T * O / W, p = y - A * O / W, h = vl(h, gl(u, m)), p = vl(p, gl(c, y)), h = gl(h, vl(u, m)), p = gl(p, vl(c, y)), T = m - h, A = y - p, M = m + T * W / O, R = y + A * W / O;
        }
        t.bezierCurveTo(d, f, h, p, m, y), d = M, f = R;
      } else
        t.lineTo(m, y);
    }
    u = m, c = y, v += a;
  }
  return g;
}
var GG = (
  /** @class */
  /* @__PURE__ */ function() {
    function t() {
      this.smooth = 0, this.smoothConstraint = !0;
    }
    return t;
  }()
), sre = (
  /** @class */
  function(t) {
    ee(r, t);
    function r(e) {
      var n = t.call(this, e) || this;
      return n.type = "ec-polyline", n;
    }
    return r.prototype.getDefaultStyle = function() {
      return {
        stroke: "#000",
        fill: null
      };
    }, r.prototype.getDefaultShape = function() {
      return new GG();
    }, r.prototype.buildPath = function(e, n) {
      var i = n.points, a = 0, o = i.length / 2;
      if (n.connectNulls) {
        for (; o > 0 && Dc(i[o * 2 - 2], i[o * 2 - 1]); o--)
          ;
        for (; a < o && Dc(i[a * 2], i[a * 2 + 1]); a++)
          ;
      }
      for (; a < o; )
        a += C9(e, i, a, o, o, 1, n.smooth, n.smoothMonotone, n.connectNulls) + 1;
    }, r.prototype.getPointOn = function(e, n) {
      this.path || (this.createPathProxy(), this.buildPath(this.path, this.shape));
      for (var i = this.path, a = i.data, o = Qo.CMD, s, l, u = n === "x", c = [], d = 0; d < a.length; ) {
        var f = a[d++], h = void 0, p = void 0, v = void 0, g = void 0, m = void 0, y = void 0, b = void 0;
        switch (f) {
          case o.M:
            s = a[d++], l = a[d++];
            break;
          case o.L:
            if (h = a[d++], p = a[d++], b = u ? (e - s) / (h - s) : (e - l) / (p - l), b <= 1 && b >= 0) {
              var C = u ? (p - l) * b + l : (h - s) * b + s;
              return u ? [e, C] : [C, e];
            }
            s = h, l = p;
            break;
          case o.C:
            h = a[d++], p = a[d++], v = a[d++], g = a[d++], m = a[d++], y = a[d++];
            var w = u ? dm(s, h, v, m, e, c) : dm(l, p, g, y, e, c);
            if (w > 0)
              for (var _ = 0; _ < w; _++) {
                var x = c[_];
                if (x <= 1 && x >= 0) {
                  var C = u ? bn(l, p, g, y, x) : bn(s, h, v, m, x);
                  return u ? [e, C] : [C, e];
                }
              }
            s = m, l = y;
            break;
        }
      }
    }, r;
  }(gt)
), lre = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return r;
  }(GG)
), BG = (
  /** @class */
  function(t) {
    ee(r, t);
    function r(e) {
      var n = t.call(this, e) || this;
      return n.type = "ec-polygon", n;
    }
    return r.prototype.getDefaultShape = function() {
      return new lre();
    }, r.prototype.buildPath = function(e, n) {
      var i = n.points, a = n.stackedOnPoints, o = 0, s = i.length / 2, l = n.smoothMonotone;
      if (n.connectNulls) {
        for (; s > 0 && Dc(i[s * 2 - 2], i[s * 2 - 1]); s--)
          ;
        for (; o < s && Dc(i[o * 2], i[o * 2 + 1]); o++)
          ;
      }
      for (; o < s; ) {
        var u = C9(e, i, o, s, s, 1, n.smooth, l, n.connectNulls);
        C9(e, a, o + u - 1, u, s, -1, n.stackedOnSmooth, l, n.connectNulls), o += u + 1, e.closePath();
      }
    }, r;
  }(gt)
);
function FG(t, r, e, n, i) {
  var a = t.getArea(), o = a.x, s = a.y, l = a.width, u = a.height, c = e.get(["lineStyle", "width"]) || 2;
  o -= c / 2, s -= c / 2, l += c, u += c, l = Math.ceil(l), o !== Math.floor(o) && (o = Math.floor(o), l++);
  var d = new xt({
    shape: {
      x: o,
      y: s,
      width: l,
      height: u
    }
  });
  if (r) {
    var f = t.getBaseAxis(), h = f.isHorizontal(), p = f.inverse;
    h ? (p && (d.shape.x += l), d.shape.width = 0) : (p || (d.shape.y += u), d.shape.height = 0);
    var v = Ae(i) ? function(g) {
      i(g, d);
    } : null;
    Cr(d, {
      shape: {
        width: l,
        height: u,
        x: o,
        y: s
      }
    }, e, null, n, v);
  }
  return d;
}
function HG(t, r, e) {
  var n = t.getArea(), i = Or(n.r0, 1), a = Or(n.r, 1), o = new oi({
    shape: {
      cx: Or(t.cx, 1),
      cy: Or(t.cy, 1),
      r0: i,
      r: a,
      startAngle: n.startAngle,
      endAngle: n.endAngle,
      clockwise: n.clockwise
    }
  });
  if (r) {
    var s = t.getBaseAxis().dim === "angle";
    s ? o.shape.endAngle = n.startAngle : o.shape.r = i, Cr(o, {
      shape: {
        endAngle: n.endAngle,
        r: a
      }
    }, e);
  }
  return o;
}
function xg(t, r, e, n, i) {
  if (t) {
    if (t.type === "polar")
      return HG(t, r, e);
    if (t.type === "cartesian2d")
      return FG(t, r, e, n, i);
  } else return null;
  return null;
}
function rd(t, r) {
  return t.type === r;
}
function BA(t, r) {
  if (t.length === r.length) {
    for (var e = 0; e < t.length; e++)
      if (t[e] !== r[e])
        return;
    return !0;
  }
}
function FA(t) {
  for (var r = 1 / 0, e = 1 / 0, n = -1 / 0, i = -1 / 0, a = 0; a < t.length; ) {
    var o = t[a++], s = t[a++];
    isNaN(o) || (r = Math.min(o, r), n = Math.max(o, n)), isNaN(s) || (e = Math.min(s, e), i = Math.max(s, i));
  }
  return [[r, e], [n, i]];
}
function HA(t, r) {
  var e = FA(t), n = e[0], i = e[1], a = FA(r), o = a[0], s = a[1];
  return Math.max(Math.abs(n[0] - o[0]), Math.abs(n[1] - o[1]), Math.abs(i[0] - s[0]), Math.abs(i[1] - s[1]));
}
function zA(t) {
  return Mt(t) ? t : t ? 0.5 : 0;
}
function ure(t, r, e) {
  if (!e.valueDim)
    return [];
  for (var n = r.count(), i = Oo(n * 2), a = 0; a < n; a++) {
    var o = VG(e, t, r, a);
    i[a * 2] = o[0], i[a * 2 + 1] = o[1];
  }
  return i;
}
function ml(t, r, e, n) {
  var i = r.getBaseAxis(), a = i.dim === "x" || i.dim === "radius" ? 0 : 1, o = [], s = 0, l = [], u = [], c = [], d = [];
  if (n) {
    for (s = 0; s < t.length; s += 2)
      !isNaN(t[s]) && !isNaN(t[s + 1]) && d.push(t[s], t[s + 1]);
    t = d;
  }
  for (s = 0; s < t.length - 2; s += 2)
    switch (c[0] = t[s + 2], c[1] = t[s + 3], u[0] = t[s], u[1] = t[s + 1], o.push(u[0], u[1]), e) {
      case "end":
        l[a] = c[a], l[1 - a] = u[1 - a], o.push(l[0], l[1]);
        break;
      case "middle":
        var f = (u[a] + c[a]) / 2, h = [];
        l[a] = h[a] = f, l[1 - a] = u[1 - a], h[1 - a] = c[1 - a], o.push(l[0], l[1]), o.push(h[0], h[1]);
        break;
      default:
        l[a] = u[a], l[1 - a] = c[1 - a], o.push(l[0], l[1]);
    }
  return o.push(t[s++], t[s++]), o;
}
function cre(t, r) {
  var e = [], n = t.length, i, a;
  function o(c, d, f) {
    var h = c.coord, p = (f - h) / (d.coord - h), v = D7(p, [c.color, d.color]);
    return {
      coord: f,
      color: v
    };
  }
  for (var s = 0; s < n; s++) {
    var l = t[s], u = l.coord;
    if (u < 0)
      i = l;
    else if (u > r) {
      a ? e.push(o(a, l, r)) : i && e.push(o(i, l, 0), o(i, l, r));
      break;
    } else
      i && (e.push(o(i, l, 0)), i = null), e.push(l), a = l;
  }
  return e;
}
function dre(t, r, e) {
  var n = t.getVisual("visualMeta");
  if (!(!n || !n.length || !t.count())) {
    if (r.type !== "cartesian2d") {
      process.env.NODE_ENV !== "production" && console.warn("Visual map on line style is only supported on cartesian2d.");
      return;
    }
    for (var i, a, o = n.length - 1; o >= 0; o--) {
      var s = t.getDimensionInfo(n[o].dimension);
      if (i = s && s.coordDim, i === "x" || i === "y") {
        a = n[o];
        break;
      }
    }
    if (!a) {
      process.env.NODE_ENV !== "production" && console.warn("Visual map on line style only support x or y dimension.");
      return;
    }
    var l = r.getAxis(i), u = ce(a.stops, function(b) {
      return {
        coord: l.toGlobalCoord(l.dataToCoord(b.value)),
        color: b.color
      };
    }), c = u.length, d = a.outerColors.slice();
    c && u[0].coord > u[c - 1].coord && (u.reverse(), d.reverse());
    var f = cre(u, i === "x" ? e.getWidth() : e.getHeight()), h = f.length;
    if (!h && c)
      return u[0].coord < 0 ? d[1] ? d[1] : u[c - 1].color : d[0] ? d[0] : u[0].color;
    var p = 10, v = f[0].coord - p, g = f[h - 1].coord + p, m = g - v;
    if (m < 1e-3)
      return "transparent";
    L(f, function(b) {
      b.offset = (b.coord - v) / m;
    }), f.push({
      // NOTE: inRangeStopLen may still be 0 if stoplen is zero.
      offset: h ? f[h - 1].offset : 0.5,
      color: d[1] || "transparent"
    }), f.unshift({
      offset: h ? f[0].offset : 0.5,
      color: d[0] || "transparent"
    });
    var y = new rh(0, 0, 0, 0, f, !0);
    return y[i] = v, y[i + "2"] = g, y;
  }
}
function fre(t, r, e) {
  var n = t.get("showAllSymbol"), i = n === "auto";
  if (!(n && !i)) {
    var a = e.getAxesByScale("ordinal")[0];
    if (a && !(i && hre(a, r))) {
      var o = r.mapDimension(a.dim), s = {};
      return L(a.getViewLabels(), function(l) {
        var u = a.scale.getRawOrdinalNumber(l.tickValue);
        s[u] = 1;
      }), function(l) {
        return !s.hasOwnProperty(r.get(o, l));
      };
    }
  }
}
function hre(t, r) {
  var e = t.getExtent(), n = Math.abs(e[1] - e[0]) / t.scale.count();
  isNaN(n) && (n = 0);
  for (var i = r.count(), a = Math.max(1, Math.round(i / 5)), o = 0; o < i; o += a)
    if (wg.getSymbolSize(
      r,
      o
      // Only for cartesian, where `isHorizontal` exists.
    )[t.isHorizontal() ? 1 : 0] * 1.5 > n)
      return !1;
  return !0;
}
function pre(t, r) {
  return isNaN(t) || isNaN(r);
}
function vre(t) {
  for (var r = t.length / 2; r > 0 && pre(t[r * 2 - 2], t[r * 2 - 1]); r--)
    ;
  return r - 1;
}
function WA(t, r) {
  return [t[r * 2], t[r * 2 + 1]];
}
function gre(t, r, e) {
  for (var n = t.length / 2, i = e === "x" ? 0 : 1, a, o, s = 0, l = -1, u = 0; u < n; u++)
    if (o = t[u * 2 + i], !(isNaN(o) || isNaN(t[u * 2 + 1 - i]))) {
      if (u === 0) {
        a = o;
        continue;
      }
      if (a <= r && o >= r || a >= r && o <= r) {
        l = u;
        break;
      }
      s = u, a = o;
    }
  return {
    range: [s, l],
    t: (r - a) / (o - a)
  };
}
function zG(t) {
  if (t.get(["endLabel", "show"]))
    return !0;
  for (var r = 0; r < xi.length; r++)
    if (t.get([xi[r], "endLabel", "show"]))
      return !0;
  return !1;
}
function Bb(t, r, e, n) {
  if (rd(r, "cartesian2d")) {
    var i = n.getModel("endLabel"), a = i.get("valueAnimation"), o = n.getData(), s = {
      lastFrameIndex: 0
    }, l = zG(n) ? function(h, p) {
      t._endLabelOnDuring(h, p, o, s, a, i, r);
    } : null, u = r.getBaseAxis().isHorizontal(), c = FG(r, e, n, function() {
      var h = t._endLabel;
      h && e && s.originalX != null && h.attr({
        x: s.originalX,
        y: s.originalY
      });
    }, l);
    if (!n.get("clip", !0)) {
      var d = c.shape, f = Math.max(d.width, d.height);
      u ? (d.y -= f, d.height += f * 2) : (d.x -= f, d.width += f * 2);
    }
    return l && l(1, c), c;
  } else
    return process.env.NODE_ENV !== "production" && n.get(["endLabel", "show"]) && console.warn("endLabel is not supported for lines in polar systems."), HG(r, e, n);
}
function mre(t, r) {
  var e = r.getBaseAxis(), n = e.isHorizontal(), i = e.inverse, a = n ? i ? "right" : "left" : "center", o = n ? "middle" : i ? "top" : "bottom";
  return {
    normal: {
      align: t.get("align") || a,
      verticalAlign: t.get("verticalAlign") || o
    }
  };
}
var yre = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return r.prototype.init = function() {
      var e = new ze(), n = new _g();
      this.group.add(n.group), this._symbolDraw = n, this._lineGroup = e;
    }, r.prototype.render = function(e, n, i) {
      var a = this, o = e.coordinateSystem, s = this.group, l = e.getData(), u = e.getModel("lineStyle"), c = e.getModel("areaStyle"), d = l.getLayout("points") || [], f = o.type === "polar", h = this._coordSys, p = this._symbolDraw, v = this._polyline, g = this._polygon, m = this._lineGroup, y = !n.ssr && e.get("animation"), b = !c.isEmpty(), C = c.get("origin"), w = OG(o, l, C), _ = b && ure(o, l, w), x = e.get("showSymbol"), I = e.get("connectNulls"), D = x && !f && fre(e, l, o), T = this._data;
      T && T.eachItemGraphicEl(function(J, K) {
        J.__temp && (s.remove(J), T.setItemGraphicEl(K, null));
      }), x || p.remove(), s.add(m);
      var A = f ? !1 : e.get("step"), M;
      o && o.getArea && e.get("clip", !0) && (M = o.getArea(), M.width != null ? (M.x -= 0.1, M.y -= 0.1, M.width += 0.2, M.height += 0.2) : M.r0 && (M.r0 -= 0.5, M.r += 0.5)), this._clipShapeForSymbol = M;
      var R = dre(l, o, i) || l.getVisual("style")[l.getVisual("drawType")];
      if (!(v && h.type === o.type && A === this._step))
        x && p.updateData(l, {
          isIgnore: D,
          clipShape: M,
          disableAnimation: !0,
          getSymbolPoint: function(J) {
            return [d[J * 2], d[J * 2 + 1]];
          }
        }), y && this._initSymbolLabelAnimation(l, o, M), A && (d = ml(d, o, A, I), _ && (_ = ml(_, o, A, I))), v = this._newPolyline(d), b ? g = this._newPolygon(d, _) : g && (m.remove(g), g = this._polygon = null), f || this._initOrUpdateEndLabel(e, o, Hc(R)), m.setClipPath(Bb(this, o, !0, e));
      else {
        b && !g ? g = this._newPolygon(d, _) : g && !b && (m.remove(g), g = this._polygon = null), f || this._initOrUpdateEndLabel(e, o, Hc(R));
        var E = m.getClipPath();
        if (E) {
          var k = Bb(this, o, !1, e);
          Cr(E, {
            shape: k.shape
          }, e);
        } else
          m.setClipPath(Bb(this, o, !0, e));
        x && p.updateData(l, {
          isIgnore: D,
          clipShape: M,
          disableAnimation: !0,
          getSymbolPoint: function(J) {
            return [d[J * 2], d[J * 2 + 1]];
          }
        }), (!BA(this._stackedOnPoints, _) || !BA(this._points, d)) && (y ? this._doUpdateAnimation(l, _, o, i, A, C, I) : (A && (d = ml(d, o, A, I), _ && (_ = ml(_, o, A, I))), v.setShape({
          points: d
        }), g && g.setShape({
          points: d,
          stackedOnPoints: _
        })));
      }
      var P = e.getModel("emphasis"), N = P.get("focus"), O = P.get("blurScope"), W = P.get("disabled");
      if (v.useStyle(Ee(
        // Use color in lineStyle first
        u.getLineStyle(),
        {
          fill: "none",
          stroke: R,
          lineJoin: "bevel"
        }
      )), Yn(v, e, "lineStyle"), v.style.lineWidth > 0 && e.get(["emphasis", "lineStyle", "width"]) === "bolder") {
        var V = v.getState("emphasis").style;
        V.lineWidth = +v.style.lineWidth + 1;
      }
      Ze(v).seriesIndex = e.seriesIndex, Vr(v, N, O, W);
      var B = zA(e.get("smooth")), Z = e.get("smoothMonotone");
      if (v.setShape({
        smooth: B,
        smoothMonotone: Z,
        connectNulls: I
      }), g) {
        var q = l.getCalculationInfo("stackedOnSeries"), z = 0;
        g.useStyle(Ee(c.getAreaStyle(), {
          fill: R,
          opacity: 0.7,
          lineJoin: "bevel",
          decal: l.getVisual("style").decal
        })), q && (z = zA(q.get("smooth"))), g.setShape({
          smooth: B,
          stackedOnSmooth: z,
          smoothMonotone: Z,
          connectNulls: I
        }), Yn(g, e, "areaStyle"), Ze(g).seriesIndex = e.seriesIndex, Vr(g, N, O, W);
      }
      var U = function(J) {
        a._changePolyState(J);
      };
      l.eachItemGraphicEl(function(J) {
        J && (J.onHoverStateChange = U);
      }), this._polyline.onHoverStateChange = U, this._data = l, this._coordSys = o, this._stackedOnPoints = _, this._points = d, this._step = A, this._valueOrigin = C, e.get("triggerLineEvent") && (this.packEventData(e, v), g && this.packEventData(e, g));
    }, r.prototype.packEventData = function(e, n) {
      Ze(n).eventData = {
        componentType: "series",
        componentSubType: "line",
        componentIndex: e.componentIndex,
        seriesIndex: e.seriesIndex,
        seriesName: e.name,
        seriesType: "line"
      };
    }, r.prototype.highlight = function(e, n, i, a) {
      var o = e.getData(), s = Gc(o, a);
      if (this._changePolyState("emphasis"), !(s instanceof Array) && s != null && s >= 0) {
        var l = o.getLayout("points"), u = o.getItemGraphicEl(s);
        if (!u) {
          var c = l[s * 2], d = l[s * 2 + 1];
          if (isNaN(c) || isNaN(d) || this._clipShapeForSymbol && !this._clipShapeForSymbol.contain(c, d))
            return;
          var f = e.get("zlevel") || 0, h = e.get("z") || 0;
          u = new wg(o, s), u.x = c, u.y = d, u.setZ(f, h);
          var p = u.getSymbolPath().getTextContent();
          p && (p.zlevel = f, p.z = h, p.z2 = this._polyline.z2 + 1), u.__temp = !0, o.setItemGraphicEl(s, u), u.stopSymbolAnimation(!0), this.group.add(u);
        }
        u.highlight();
      } else
        Yt.prototype.highlight.call(this, e, n, i, a);
    }, r.prototype.downplay = function(e, n, i, a) {
      var o = e.getData(), s = Gc(o, a);
      if (this._changePolyState("normal"), s != null && s >= 0) {
        var l = o.getItemGraphicEl(s);
        l && (l.__temp ? (o.setItemGraphicEl(s, null), this.group.remove(l)) : l.downplay());
      } else
        Yt.prototype.downplay.call(this, e, n, i, a);
    }, r.prototype._changePolyState = function(e) {
      var n = this._polygon;
      bm(this._polyline, e), n && bm(n, e);
    }, r.prototype._newPolyline = function(e) {
      var n = this._polyline;
      return n && this._lineGroup.remove(n), n = new sre({
        shape: {
          points: e
        },
        segmentIgnoreThreshold: 2,
        z2: 10
      }), this._lineGroup.add(n), this._polyline = n, n;
    }, r.prototype._newPolygon = function(e, n) {
      var i = this._polygon;
      return i && this._lineGroup.remove(i), i = new BG({
        shape: {
          points: e,
          stackedOnPoints: n
        },
        segmentIgnoreThreshold: 2
      }), this._lineGroup.add(i), this._polygon = i, i;
    }, r.prototype._initSymbolLabelAnimation = function(e, n, i) {
      var a, o, s = n.getBaseAxis(), l = s.inverse;
      n.type === "cartesian2d" ? (a = s.isHorizontal(), o = !1) : n.type === "polar" && (a = s.dim === "angle", o = !0);
      var u = e.hostModel, c = u.get("animationDuration");
      Ae(c) && (c = c(null));
      var d = u.get("animationDelay") || 0, f = Ae(d) ? d(null) : d;
      e.eachItemGraphicEl(function(h, p) {
        var v = h;
        if (v) {
          var g = [h.x, h.y], m = void 0, y = void 0, b = void 0;
          if (i)
            if (o) {
              var C = i, w = n.pointToCoord(g);
              a ? (m = C.startAngle, y = C.endAngle, b = -w[1] / 180 * Math.PI) : (m = C.r0, y = C.r, b = w[0]);
            } else {
              var _ = i;
              a ? (m = _.x, y = _.x + _.width, b = h.x) : (m = _.y + _.height, y = _.y, b = h.y);
            }
          var x = y === m ? 0 : (b - m) / (y - m);
          l && (x = 1 - x);
          var I = Ae(d) ? d(p) : c * x + f, D = v.getSymbolPath(), T = D.getTextContent();
          v.attr({
            scaleX: 0,
            scaleY: 0
          }), v.animateTo({
            scaleX: 1,
            scaleY: 1
          }, {
            duration: 200,
            setToFinal: !0,
            delay: I
          }), T && T.animateFrom({
            style: {
              opacity: 0
            }
          }, {
            duration: 300,
            delay: I
          }), D.disableLabelAnimation = !0;
        }
      });
    }, r.prototype._initOrUpdateEndLabel = function(e, n, i) {
      var a = e.getModel("endLabel");
      if (zG(e)) {
        var o = e.getData(), s = this._polyline, l = o.getLayout("points");
        if (!l) {
          s.removeTextContent(), this._endLabel = null;
          return;
        }
        var u = this._endLabel;
        u || (u = this._endLabel = new _t({
          z2: 200
          // should be higher than item symbol
        }), u.ignoreClip = !0, s.setTextContent(this._endLabel), s.disableLabelAnimation = !0);
        var c = vre(l);
        c >= 0 && (Xn(s, xn(e, "endLabel"), {
          inheritColor: i,
          labelFetcher: e,
          labelDataIndex: c,
          defaultText: function(d, f, h) {
            return h != null ? NG(o, h) : Ef(o, d);
          },
          enableTextSetter: !0
        }, mre(a, n)), s.textConfig.position = null);
      } else this._endLabel && (this._polyline.removeTextContent(), this._endLabel = null);
    }, r.prototype._endLabelOnDuring = function(e, n, i, a, o, s, l) {
      var u = this._endLabel, c = this._polyline;
      if (u) {
        e < 1 && a.originalX == null && (a.originalX = u.x, a.originalY = u.y);
        var d = i.getLayout("points"), f = i.hostModel, h = f.get("connectNulls"), p = s.get("precision"), v = s.get("distance") || 0, g = l.getBaseAxis(), m = g.isHorizontal(), y = g.inverse, b = n.shape, C = y ? m ? b.x : b.y + b.height : m ? b.x + b.width : b.y, w = (m ? v : 0) * (y ? -1 : 1), _ = (m ? 0 : -v) * (y ? -1 : 1), x = m ? "x" : "y", I = gre(d, C, x), D = I.range, T = D[1] - D[0], A = void 0;
        if (T >= 1) {
          if (T > 1 && !h) {
            var M = WA(d, D[0]);
            u.attr({
              x: M[0] + w,
              y: M[1] + _
            }), o && (A = f.getRawValue(D[0]));
          } else {
            var M = c.getPointOn(C, x);
            M && u.attr({
              x: M[0] + w,
              y: M[1] + _
            });
            var R = f.getRawValue(D[0]), E = f.getRawValue(D[1]);
            o && (A = TN(i, p, R, E, I.t));
          }
          a.lastFrameIndex = D[0];
        } else {
          var k = e === 1 || a.lastFrameIndex > 0 ? D[0] : 0, M = WA(d, k);
          o && (A = f.getRawValue(k)), u.attr({
            x: M[0] + w,
            y: M[1] + _
          });
        }
        if (o) {
          var P = oh(u);
          typeof P.setLabelText == "function" && P.setLabelText(A);
        }
      }
    }, r.prototype._doUpdateAnimation = function(e, n, i, a, o, s, l) {
      var u = this._polyline, c = this._polygon, d = e.hostModel, f = ore(this._data, e, this._stackedOnPoints, n, this._coordSys, i, this._valueOrigin), h = f.current, p = f.stackedOnCurrent, v = f.next, g = f.stackedOnNext;
      if (o && (h = ml(f.current, i, o, l), p = ml(f.stackedOnCurrent, i, o, l), v = ml(f.next, i, o, l), g = ml(f.stackedOnNext, i, o, l)), HA(h, v) > 3e3 || c && HA(p, g) > 3e3) {
        u.stopAnimation(), u.setShape({
          points: v
        }), c && (c.stopAnimation(), c.setShape({
          points: v,
          stackedOnPoints: g
        }));
        return;
      }
      u.shape.__points = f.current, u.shape.points = h;
      var m = {
        shape: {
          points: v
        }
      };
      f.current !== h && (m.shape.__points = f.next), u.stopAnimation(), kt(u, m, d), c && (c.setShape({
        // Reuse the points with polyline.
        points: h,
        stackedOnPoints: p
      }), c.stopAnimation(), kt(c, {
        shape: {
          stackedOnPoints: g
        }
      }, d), u.shape.points !== c.shape.points && (c.shape.points = u.shape.points));
      for (var y = [], b = f.status, C = 0; C < b.length; C++) {
        var w = b[C].cmd;
        if (w === "=") {
          var _ = e.getItemGraphicEl(b[C].idx1);
          _ && y.push({
            el: _,
            ptIdx: C
            // Index of points
          });
        }
      }
      u.animators && u.animators.length && u.animators[0].during(function() {
        c && c.dirtyShape();
        for (var x = u.shape.__points, I = 0; I < y.length; I++) {
          var D = y[I].el, T = y[I].ptIdx * 2;
          D.x = x[T], D.y = x[T + 1], D.markRedraw();
        }
      });
    }, r.prototype.remove = function(e) {
      var n = this.group, i = this._data;
      this._lineGroup.removeAll(), this._symbolDraw.remove(!0), i && i.eachItemGraphicEl(function(a, o) {
        a.__temp && (n.remove(a), i.setItemGraphicEl(o, null));
      }), this._polyline = this._polygon = this._coordSys = this._points = this._stackedOnPoints = this._endLabel = this._data = null;
    }, r.type = "line", r;
  }(Yt)
);
function Sg(t, r) {
  return {
    seriesType: t,
    plan: ch(),
    reset: function(e) {
      var n = e.getData(), i = e.coordinateSystem, a = e.pipelineContext, o = r || a.large;
      if (i) {
        var s = ce(i.dimensions, function(h) {
          return n.mapDimension(h);
        }).slice(0, 2), l = s.length, u = n.getCalculationInfo("stackResultDimension");
        Js(n, s[0]) && (s[0] = u), Js(n, s[1]) && (s[1] = u);
        var c = n.getStore(), d = n.getDimensionIndex(s[0]), f = n.getDimensionIndex(s[1]);
        return l && {
          progress: function(h, p) {
            for (var v = h.end - h.start, g = o && Oo(v * l), m = [], y = [], b = h.start, C = 0; b < h.end; b++) {
              var w = void 0;
              if (l === 1) {
                var _ = c.get(d, b);
                w = i.dataToPoint(_, null, y);
              } else
                m[0] = c.get(d, b), m[1] = c.get(f, b), w = i.dataToPoint(m, null, y);
              o ? (g[C++] = w[0], g[C++] = w[1]) : p.setItemLayout(b, w.slice());
            }
            o && p.setLayout("points", g);
          }
        };
      }
    }
  };
}
var bre = {
  average: function(t) {
    for (var r = 0, e = 0, n = 0; n < t.length; n++)
      isNaN(t[n]) || (r += t[n], e++);
    return e === 0 ? NaN : r / e;
  },
  sum: function(t) {
    for (var r = 0, e = 0; e < t.length; e++)
      r += t[e] || 0;
    return r;
  },
  max: function(t) {
    for (var r = -1 / 0, e = 0; e < t.length; e++)
      t[e] > r && (r = t[e]);
    return isFinite(r) ? r : NaN;
  },
  min: function(t) {
    for (var r = 1 / 0, e = 0; e < t.length; e++)
      t[e] < r && (r = t[e]);
    return isFinite(r) ? r : NaN;
  },
  minmax: function(t) {
    for (var r = -1 / 0, e = -1 / 0, n = 0; n < t.length; n++) {
      var i = t[n], a = Math.abs(i);
      a > r && (r = a, e = i);
    }
    return isFinite(e) ? e : NaN;
  },
  // TODO
  // Median
  nearest: function(t) {
    return t[0];
  }
}, Cre = function(t) {
  return Math.round(t.length / 2);
};
function WG(t) {
  return {
    seriesType: t,
    // FIXME:TS never used, so comment it
    // modifyOutputEnd: true,
    reset: function(r, e, n) {
      var i = r.getData(), a = r.get("sampling"), o = r.coordinateSystem, s = i.count();
      if (s > 10 && o.type === "cartesian2d" && a) {
        var l = o.getBaseAxis(), u = o.getOtherAxis(l), c = l.getExtent(), d = n.getDevicePixelRatio(), f = Math.abs(c[1] - c[0]) * (d || 1), h = Math.round(s / f);
        if (isFinite(h) && h > 1) {
          a === "lttb" && r.setData(i.lttbDownSample(i.mapDimension(u.dim), 1 / h));
          var p = void 0;
          pe(a) ? p = bre[a] : Ae(a) && (p = a), p && r.setData(i.downSample(i.mapDimension(u.dim), 1 / h, p, Cre));
        }
      }
    }
  };
}
function wre(t) {
  t.registerChartView(yre), t.registerSeriesModel(rre), t.registerLayout(Sg("line", !0)), t.registerVisual({
    seriesType: "line",
    reset: function(r) {
      var e = r.getData(), n = r.getModel("lineStyle").getLineStyle();
      n && !n.stroke && (n.stroke = e.getVisual("style").fill), e.setVisual("legendLineStyle", n);
    }
  }), t.registerProcessor(t.PRIORITY.PROCESSOR.STATISTIC, WG("line"));
}
var Lv = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.getInitialData = function(e, n) {
      return os(null, this, {
        useEncodeDefaulter: !0
      });
    }, r.prototype.getMarkerPosition = function(e, n, i) {
      var a = this.coordinateSystem;
      if (a && a.clampData) {
        var o = a.clampData(e), s = a.dataToPoint(o);
        if (i)
          L(a.getAxes(), function(f, h) {
            if (f.type === "category" && n != null) {
              var p = f.getTicksCoords(), v = f.getTickModel().get("alignWithLabel"), g = o[h], m = n[h] === "x1" || n[h] === "y1";
              if (m && !v && (g += 1), p.length < 2)
                return;
              if (p.length === 2) {
                s[h] = f.toGlobalCoord(f.getExtent()[m ? 1 : 0]);
                return;
              }
              for (var y = void 0, b = void 0, C = 1, w = 0; w < p.length; w++) {
                var _ = p[w].coord, x = w === p.length - 1 ? p[w - 1].tickValue + C : p[w].tickValue;
                if (x === g) {
                  b = _;
                  break;
                } else if (x < g)
                  y = _;
                else if (y != null && x > g) {
                  b = (_ + y) / 2;
                  break;
                }
                w === 1 && (C = x - p[0].tickValue);
              }
              b == null && (y ? y && (b = p[p.length - 1].coord) : b = p[0].coord), s[h] = f.toGlobalCoord(b);
            }
          });
        else {
          var l = this.getData(), u = l.getLayout("offset"), c = l.getLayout("size"), d = a.getBaseAxis().isHorizontal() ? 0 : 1;
          s[d] += u + c / 2;
        }
        return s;
      }
      return [NaN, NaN];
    }, r.type = "series.__base_bar__", r.defaultOption = {
      // zlevel: 0,
      z: 2,
      coordinateSystem: "cartesian2d",
      legendHoverLink: !0,
      // stack: null
      // Cartesian coordinate system
      // xAxisIndex: 0,
      // yAxisIndex: 0,
      barMinHeight: 0,
      barMinAngle: 0,
      // cursor: null,
      large: !1,
      largeThreshold: 400,
      progressive: 3e3,
      progressiveChunkMode: "mod"
    }, r;
  }(tr)
);
tr.registerClass(Lv);
var _re = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.getInitialData = function() {
      return os(null, this, {
        useEncodeDefaulter: !0,
        createInvertedIndices: !!this.get("realtimeSort", !0) || null
      });
    }, r.prototype.getProgressive = function() {
      return this.get("large") ? this.get("progressive") : !1;
    }, r.prototype.getProgressiveThreshold = function() {
      var e = this.get("progressiveThreshold"), n = this.get("largeThreshold");
      return n > e && (e = n), e;
    }, r.prototype.brushSelector = function(e, n, i) {
      return i.rect(n.getItemLayout(e));
    }, r.type = "series.bar", r.dependencies = ["grid", "polar"], r.defaultOption = vu(Lv.defaultOption, {
      // If clipped
      // Only available on cartesian2d
      clip: !0,
      roundCap: !1,
      showBackground: !1,
      backgroundStyle: {
        color: "rgba(180, 180, 180, 0.2)",
        borderColor: null,
        borderWidth: 0,
        borderType: "solid",
        borderRadius: 0,
        shadowBlur: 0,
        shadowColor: null,
        shadowOffsetX: 0,
        shadowOffsetY: 0,
        opacity: 1
      },
      select: {
        itemStyle: {
          borderColor: "#212121"
        }
      },
      realtimeSort: !1
    }), r;
  }(Lv)
), xre = (
  /** @class */
  /* @__PURE__ */ function() {
    function t() {
      this.cx = 0, this.cy = 0, this.r0 = 0, this.r = 0, this.startAngle = 0, this.endAngle = Math.PI * 2, this.clockwise = !0;
    }
    return t;
  }()
), zm = (
  /** @class */
  function(t) {
    ee(r, t);
    function r(e) {
      var n = t.call(this, e) || this;
      return n.type = "sausage", n;
    }
    return r.prototype.getDefaultShape = function() {
      return new xre();
    }, r.prototype.buildPath = function(e, n) {
      var i = n.cx, a = n.cy, o = Math.max(n.r0 || 0, 0), s = Math.max(n.r, 0), l = (s - o) * 0.5, u = o + l, c = n.startAngle, d = n.endAngle, f = n.clockwise, h = Math.PI * 2, p = f ? d - c < h : c - d < h;
      p || (c = d - (f ? h : -h));
      var v = Math.cos(c), g = Math.sin(c), m = Math.cos(d), y = Math.sin(d);
      p ? (e.moveTo(v * o + i, g * o + a), e.arc(v * u + i, g * u + a, l, -Math.PI + c, c, !f)) : e.moveTo(v * s + i, g * s + a), e.arc(i, a, s, c, d, !f), e.arc(m * u + i, y * u + a, l, d - Math.PI * 2, d - Math.PI, !f), o !== 0 && e.arc(i, a, o, d, c, f);
    }, r;
  }(gt)
);
function Sre(t, r) {
  r = r || {};
  var e = r.isRoundCap;
  return function(n, i, a) {
    var o = i.position;
    if (!o || o instanceof Array)
      return gm(n, i, a);
    var s = t(o), l = i.distance != null ? i.distance : 5, u = this.shape, c = u.cx, d = u.cy, f = u.r, h = u.r0, p = (f + h) / 2, v = u.startAngle, g = u.endAngle, m = (v + g) / 2, y = e ? Math.abs(f - h) / 2 : 0, b = Math.cos, C = Math.sin, w = c + f * b(v), _ = d + f * C(v), x = "left", I = "top";
    switch (s) {
      case "startArc":
        w = c + (h - l) * b(m), _ = d + (h - l) * C(m), x = "center", I = "top";
        break;
      case "insideStartArc":
        w = c + (h + l) * b(m), _ = d + (h + l) * C(m), x = "center", I = "bottom";
        break;
      case "startAngle":
        w = c + p * b(v) + E1(v, l + y, !1), _ = d + p * C(v) + k1(v, l + y, !1), x = "right", I = "middle";
        break;
      case "insideStartAngle":
        w = c + p * b(v) + E1(v, -l + y, !1), _ = d + p * C(v) + k1(v, -l + y, !1), x = "left", I = "middle";
        break;
      case "middle":
        w = c + p * b(m), _ = d + p * C(m), x = "center", I = "middle";
        break;
      case "endArc":
        w = c + (f + l) * b(m), _ = d + (f + l) * C(m), x = "center", I = "bottom";
        break;
      case "insideEndArc":
        w = c + (f - l) * b(m), _ = d + (f - l) * C(m), x = "center", I = "top";
        break;
      case "endAngle":
        w = c + p * b(g) + E1(g, l + y, !0), _ = d + p * C(g) + k1(g, l + y, !0), x = "left", I = "middle";
        break;
      case "insideEndAngle":
        w = c + p * b(g) + E1(g, -l + y, !0), _ = d + p * C(g) + k1(g, -l + y, !0), x = "right", I = "middle";
        break;
      default:
        return gm(n, i, a);
    }
    return n = n || {}, n.x = w, n.y = _, n.align = x, n.verticalAlign = I, n;
  };
}
function Ire(t, r, e, n) {
  if (Mt(n)) {
    t.setTextConfig({
      rotation: n
    });
    return;
  } else if (ue(r)) {
    t.setTextConfig({
      rotation: 0
    });
    return;
  }
  var i = t.shape, a = i.clockwise ? i.startAngle : i.endAngle, o = i.clockwise ? i.endAngle : i.startAngle, s = (a + o) / 2, l, u = e(r);
  switch (u) {
    case "startArc":
    case "insideStartArc":
    case "middle":
    case "insideEndArc":
    case "endArc":
      l = s;
      break;
    case "startAngle":
    case "insideStartAngle":
      l = a;
      break;
    case "endAngle":
    case "insideEndAngle":
      l = o;
      break;
    default:
      t.setTextConfig({
        rotation: 0
      });
      return;
  }
  var c = Math.PI * 1.5 - l;
  u === "middle" && c > Math.PI / 2 && c < Math.PI * 1.5 && (c -= Math.PI), t.setTextConfig({
    rotation: c
  });
}
function E1(t, r, e) {
  return r * Math.sin(t) * (e ? -1 : 1);
}
function k1(t, r, e) {
  return r * Math.cos(t) * (e ? 1 : -1);
}
function gc(t, r, e) {
  var n = t.get("borderRadius");
  if (n == null)
    return e ? {
      cornerRadius: 0
    } : null;
  ue(n) || (n = [n, n, n, n]);
  var i = Math.abs(r.r || 0 - r.r0 || 0);
  return {
    cornerRadius: ce(n, function(a) {
      return to(a, i);
    })
  };
}
var Fb = Math.max, Hb = Math.min;
function Are(t, r) {
  var e = t.getArea && t.getArea();
  if (rd(t, "cartesian2d")) {
    var n = t.getBaseAxis();
    if (n.type !== "category" || !n.onBand) {
      var i = r.getLayout("bandWidth");
      n.isHorizontal() ? (e.x -= i, e.width += i * 2) : (e.y -= i, e.height += i * 2);
    }
  }
  return e;
}
var Dre = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t.call(this) || this;
      return e.type = r.type, e._isFirstFrame = !0, e;
    }
    return r.prototype.render = function(e, n, i, a) {
      this._model = e, this._removeOnRenderedListener(i), this._updateDrawMode(e);
      var o = e.get("coordinateSystem");
      o === "cartesian2d" || o === "polar" ? (this._progressiveEls = null, this._isLargeDraw ? this._renderLarge(e, n, i) : this._renderNormal(e, n, i, a)) : process.env.NODE_ENV !== "production" && Mr("Only cartesian2d and polar supported for bar.");
    }, r.prototype.incrementalPrepareRender = function(e) {
      this._clear(), this._updateDrawMode(e), this._updateLargeClip(e);
    }, r.prototype.incrementalRender = function(e, n) {
      this._progressiveEls = [], this._incrementalRenderLarge(e, n);
    }, r.prototype.eachRendered = function(e) {
      pu(this._progressiveEls || this.group, e);
    }, r.prototype._updateDrawMode = function(e) {
      var n = e.pipelineContext.large;
      (this._isLargeDraw == null || n !== this._isLargeDraw) && (this._isLargeDraw = n, this._clear());
    }, r.prototype._renderNormal = function(e, n, i, a) {
      var o = this.group, s = e.getData(), l = this._data, u = e.coordinateSystem, c = u.getBaseAxis(), d;
      u.type === "cartesian2d" ? d = c.isHorizontal() : u.type === "polar" && (d = c.dim === "angle");
      var f = e.isAnimationEnabled() ? e : null, h = Tre(e, u);
      h && this._enableRealtimeSort(h, s, i);
      var p = e.get("clip", !0) || h, v = Are(u, s);
      o.removeClipPath();
      var g = e.get("roundCap", !0), m = e.get("showBackground", !0), y = e.getModel("backgroundStyle"), b = y.get("borderRadius") || 0, C = [], w = this._backgroundEls, _ = a && a.isInitSort, x = a && a.type === "changeAxisOrder";
      function I(A) {
        var M = P1[u.type](s, A), R = Nre(u, d, M);
        return R.useStyle(y.getItemStyle()), u.type === "cartesian2d" ? R.setShape("r", b) : R.setShape("cornerRadius", b), C[A] = R, R;
      }
      s.diff(l).add(function(A) {
        var M = s.getItemModel(A), R = P1[u.type](s, A, M);
        if (m && I(A), !(!s.hasValue(A) || !$A[u.type](R))) {
          var E = !1;
          p && (E = ZA[u.type](v, R));
          var k = jA[u.type](e, s, A, R, d, f, c.model, !1, g);
          h && (k.forceLabelAnimation = !0), UA(k, s, A, M, R, e, d, u.type === "polar"), _ ? k.attr({
            shape: R
          }) : h ? YA(h, f, k, R, A, d, !1, !1) : Cr(k, {
            shape: R
          }, e, A), s.setItemGraphicEl(A, k), o.add(k), k.ignore = E;
        }
      }).update(function(A, M) {
        var R = s.getItemModel(A), E = P1[u.type](s, A, R);
        if (m) {
          var k = void 0;
          w.length === 0 ? k = I(M) : (k = w[M], k.useStyle(y.getItemStyle()), u.type === "cartesian2d" ? k.setShape("r", b) : k.setShape("cornerRadius", b), C[A] = k);
          var P = P1[u.type](s, A), N = jG(d, P, u);
          kt(k, {
            shape: N
          }, f, A);
        }
        var O = l.getItemGraphicEl(M);
        if (!s.hasValue(A) || !$A[u.type](E)) {
          o.remove(O);
          return;
        }
        var W = !1;
        if (p && (W = ZA[u.type](v, E), W && o.remove(O)), O ? ro(O) : O = jA[u.type](e, s, A, E, d, f, c.model, !!O, g), h && (O.forceLabelAnimation = !0), x) {
          var V = O.getTextContent();
          if (V) {
            var B = oh(V);
            B.prevValue != null && (B.prevValue = B.value);
          }
        } else
          UA(O, s, A, R, E, e, d, u.type === "polar");
        _ ? O.attr({
          shape: E
        }) : h ? YA(h, f, O, E, A, d, !0, x) : kt(O, {
          shape: E
        }, e, A, null), s.setItemGraphicEl(A, O), O.ignore = W, o.add(O);
      }).remove(function(A) {
        var M = l.getItemGraphicEl(A);
        M && wv(M, e, A);
      }).execute();
      var D = this._backgroundGroup || (this._backgroundGroup = new ze());
      D.removeAll();
      for (var T = 0; T < C.length; ++T)
        D.add(C[T]);
      o.add(D), this._backgroundEls = C, this._data = s;
    }, r.prototype._renderLarge = function(e, n, i) {
      this._clear(), KA(e, this.group), this._updateLargeClip(e);
    }, r.prototype._incrementalRenderLarge = function(e, n) {
      this._removeBackground(), KA(n, this.group, this._progressiveEls, !0);
    }, r.prototype._updateLargeClip = function(e) {
      var n = e.get("clip", !0) && xg(e.coordinateSystem, !1, e), i = this.group;
      n ? i.setClipPath(n) : i.removeClipPath();
    }, r.prototype._enableRealtimeSort = function(e, n, i) {
      var a = this;
      if (n.count()) {
        var o = e.baseAxis;
        if (this._isFirstFrame)
          this._dispatchInitSort(n, e, i), this._isFirstFrame = !1;
        else {
          var s = function(l) {
            var u = n.getItemGraphicEl(l), c = u && u.shape;
            return c && // The result should be consistent with the initial sort by data value.
            // Do not support the case that both positive and negative exist.
            Math.abs(o.isHorizontal() ? c.height : c.width) || 0;
          };
          this._onRendered = function() {
            a._updateSortWithinSameData(n, s, o, i);
          }, i.getZr().on("rendered", this._onRendered);
        }
      }
    }, r.prototype._dataSort = function(e, n, i) {
      var a = [];
      return e.each(e.mapDimension(n.dim), function(o, s) {
        var l = i(s);
        l = l ?? NaN, a.push({
          dataIndex: s,
          mappedValue: l,
          ordinalNumber: o
        });
      }), a.sort(function(o, s) {
        return s.mappedValue - o.mappedValue;
      }), {
        ordinalNumbers: ce(a, function(o) {
          return o.ordinalNumber;
        })
      };
    }, r.prototype._isOrderChangedWithinSameData = function(e, n, i) {
      for (var a = i.scale, o = e.mapDimension(i.dim), s = Number.MAX_VALUE, l = 0, u = a.getOrdinalMeta().categories.length; l < u; ++l) {
        var c = e.rawIndexOf(o, a.getRawOrdinalNumber(l)), d = c < 0 ? Number.MIN_VALUE : n(e.indexOfRawIndex(c));
        if (d > s)
          return !0;
        s = d;
      }
      return !1;
    }, r.prototype._isOrderDifferentInView = function(e, n) {
      for (var i = n.scale, a = i.getExtent(), o = Math.max(0, a[0]), s = Math.min(a[1], i.getOrdinalMeta().categories.length - 1); o <= s; ++o)
        if (e.ordinalNumbers[o] !== i.getRawOrdinalNumber(o))
          return !0;
    }, r.prototype._updateSortWithinSameData = function(e, n, i, a) {
      if (this._isOrderChangedWithinSameData(e, n, i)) {
        var o = this._dataSort(e, i, n);
        this._isOrderDifferentInView(o, i) && (this._removeOnRenderedListener(a), a.dispatchAction({
          type: "changeAxisOrder",
          componentType: i.dim + "Axis",
          axisId: i.index,
          sortInfo: o
        }));
      }
    }, r.prototype._dispatchInitSort = function(e, n, i) {
      var a = n.baseAxis, o = this._dataSort(e, a, function(s) {
        return e.get(e.mapDimension(n.otherAxis.dim), s);
      });
      i.dispatchAction({
        type: "changeAxisOrder",
        componentType: a.dim + "Axis",
        isInitSort: !0,
        axisId: a.index,
        sortInfo: o
      });
    }, r.prototype.remove = function(e, n) {
      this._clear(this._model), this._removeOnRenderedListener(n);
    }, r.prototype.dispose = function(e, n) {
      this._removeOnRenderedListener(n);
    }, r.prototype._removeOnRenderedListener = function(e) {
      this._onRendered && (e.getZr().off("rendered", this._onRendered), this._onRendered = null);
    }, r.prototype._clear = function(e) {
      var n = this.group, i = this._data;
      e && e.isAnimationEnabled() && i && !this._isLargeDraw ? (this._removeBackground(), this._backgroundEls = [], i.eachItemGraphicEl(function(a) {
        wv(a, e, Ze(a).dataIndex);
      })) : n.removeAll(), this._data = null, this._isFirstFrame = !0;
    }, r.prototype._removeBackground = function() {
      this.group.remove(this._backgroundGroup), this._backgroundGroup = null;
    }, r.type = "bar", r;
  }(Yt)
), ZA = {
  cartesian2d: function(t, r) {
    var e = r.width < 0 ? -1 : 1, n = r.height < 0 ? -1 : 1;
    e < 0 && (r.x += r.width, r.width = -r.width), n < 0 && (r.y += r.height, r.height = -r.height);
    var i = t.x + t.width, a = t.y + t.height, o = Fb(r.x, t.x), s = Hb(r.x + r.width, i), l = Fb(r.y, t.y), u = Hb(r.y + r.height, a), c = s < o, d = u < l;
    return r.x = c && o > i ? s : o, r.y = d && l > a ? u : l, r.width = c ? 0 : s - o, r.height = d ? 0 : u - l, e < 0 && (r.x += r.width, r.width = -r.width), n < 0 && (r.y += r.height, r.height = -r.height), c || d;
  },
  polar: function(t, r) {
    var e = r.r0 <= r.r ? 1 : -1;
    if (e < 0) {
      var n = r.r;
      r.r = r.r0, r.r0 = n;
    }
    var i = Hb(r.r, t.r), a = Fb(r.r0, t.r0);
    r.r = i, r.r0 = a;
    var o = i - a < 0;
    if (e < 0) {
      var n = r.r;
      r.r = r.r0, r.r0 = n;
    }
    return o;
  }
}, jA = {
  cartesian2d: function(t, r, e, n, i, a, o, s, l) {
    var u = new xt({
      shape: ae({}, n),
      z2: 1
    });
    if (u.__dataIndex = e, u.name = "item", a) {
      var c = u.shape, d = i ? "height" : "width";
      c[d] = 0;
    }
    return u;
  },
  polar: function(t, r, e, n, i, a, o, s, l) {
    var u = !i && l ? zm : oi, c = new u({
      shape: n,
      z2: 1
    });
    c.name = "item";
    var d = ZG(i);
    if (c.calculateTextPosition = Sre(d, {
      isRoundCap: u === zm
    }), a) {
      var f = c.shape, h = i ? "r" : "endAngle", p = {};
      f[h] = i ? n.r0 : n.startAngle, p[h] = n[h], (s ? kt : Cr)(c, {
        shape: p
        // __value: typeof dataValue === 'string' ? parseInt(dataValue, 10) : dataValue
      }, a);
    }
    return c;
  }
};
function Tre(t, r) {
  var e = t.get("realtimeSort", !0), n = r.getBaseAxis();
  if (process.env.NODE_ENV !== "production" && e && (n.type !== "category" && Mr("`realtimeSort` will not work because this bar series is not based on a category axis."), r.type !== "cartesian2d" && Mr("`realtimeSort` will not work because this bar series is not on cartesian2d.")), e && n.type === "category" && r.type === "cartesian2d")
    return {
      baseAxis: n,
      otherAxis: r.getOtherAxis(n)
    };
}
function YA(t, r, e, n, i, a, o, s) {
  var l, u;
  a ? (u = {
    x: n.x,
    width: n.width
  }, l = {
    y: n.y,
    height: n.height
  }) : (u = {
    y: n.y,
    height: n.height
  }, l = {
    x: n.x,
    width: n.width
  }), s || (o ? kt : Cr)(e, {
    shape: l
  }, r, i, null);
  var c = r ? t.baseAxis.model : null;
  (o ? kt : Cr)(e, {
    shape: u
  }, c, i);
}
function XA(t, r) {
  for (var e = 0; e < r.length; e++)
    if (!isFinite(t[r[e]]))
      return !0;
  return !1;
}
var Mre = ["x", "y", "width", "height"], Rre = ["cx", "cy", "r", "startAngle", "endAngle"], $A = {
  cartesian2d: function(t) {
    return !XA(t, Mre);
  },
  polar: function(t) {
    return !XA(t, Rre);
  }
}, P1 = {
  // itemModel is only used to get borderWidth, which is not needed
  // when calculating bar background layout.
  cartesian2d: function(t, r, e) {
    var n = t.getItemLayout(r), i = e ? Ere(e, n) : 0, a = n.width > 0 ? 1 : -1, o = n.height > 0 ? 1 : -1;
    return {
      x: n.x + a * i / 2,
      y: n.y + o * i / 2,
      width: n.width - a * i,
      height: n.height - o * i
    };
  },
  polar: function(t, r, e) {
    var n = t.getItemLayout(r);
    return {
      cx: n.cx,
      cy: n.cy,
      r0: n.r0,
      r: n.r,
      startAngle: n.startAngle,
      endAngle: n.endAngle,
      clockwise: n.clockwise
    };
  }
};
function Lre(t) {
  return t.startAngle != null && t.endAngle != null && t.startAngle === t.endAngle;
}
function ZG(t) {
  return /* @__PURE__ */ function(r) {
    var e = r ? "Arc" : "Angle";
    return function(n) {
      switch (n) {
        case "start":
        case "insideStart":
        case "end":
        case "insideEnd":
          return n + e;
        default:
          return n;
      }
    };
  }(t);
}
function UA(t, r, e, n, i, a, o, s) {
  var l = r.getItemVisual(e, "style");
  if (s) {
    if (!a.get("roundCap")) {
      var c = t.shape, d = gc(n.getModel("itemStyle"), c, !0);
      ae(c, d), t.setShape(c);
    }
  } else {
    var u = n.get(["itemStyle", "borderRadius"]) || 0;
    t.setShape("r", u);
  }
  t.useStyle(l);
  var f = n.getShallow("cursor");
  f && t.attr("cursor", f);
  var h = s ? o ? i.r >= i.r0 ? "endArc" : "startArc" : i.endAngle >= i.startAngle ? "endAngle" : "startAngle" : o ? i.height >= 0 ? "bottom" : "top" : i.width >= 0 ? "right" : "left", p = xn(n);
  Xn(t, p, {
    labelFetcher: a,
    labelDataIndex: e,
    defaultText: Ef(a.getData(), e),
    inheritColor: l.fill,
    defaultOpacity: l.opacity,
    defaultOutsidePosition: h
  });
  var v = t.getTextContent();
  if (s && v) {
    var g = n.get(["label", "position"]);
    t.textConfig.inside = g === "middle" ? !0 : null, Ire(t, g === "outside" ? h : g, ZG(o), n.get(["label", "rotate"]));
  }
  fO(v, p, a.getRawValue(e), function(y) {
    return NG(r, y);
  });
  var m = n.getModel(["emphasis"]);
  Vr(t, m.get("focus"), m.get("blurScope"), m.get("disabled")), Yn(t, n), Lre(i) && (t.style.fill = "none", t.style.stroke = "none", L(t.states, function(y) {
    y.style && (y.style.fill = y.style.stroke = "none");
  }));
}
function Ere(t, r) {
  var e = t.get(["itemStyle", "borderColor"]);
  if (!e || e === "none")
    return 0;
  var n = t.get(["itemStyle", "borderWidth"]) || 0, i = isNaN(r.width) ? Number.MAX_VALUE : Math.abs(r.width), a = isNaN(r.height) ? Number.MAX_VALUE : Math.abs(r.height);
  return Math.min(n, i, a);
}
var kre = (
  /** @class */
  /* @__PURE__ */ function() {
    function t() {
    }
    return t;
  }()
), JA = (
  /** @class */
  function(t) {
    ee(r, t);
    function r(e) {
      var n = t.call(this, e) || this;
      return n.type = "largeBar", n;
    }
    return r.prototype.getDefaultShape = function() {
      return new kre();
    }, r.prototype.buildPath = function(e, n) {
      for (var i = n.points, a = this.baseDimIdx, o = 1 - this.baseDimIdx, s = [], l = [], u = this.barWidth, c = 0; c < i.length; c += 3)
        l[a] = u, l[o] = i[c + 2], s[a] = i[c + a], s[o] = i[c + o], e.rect(s[0], s[1], l[0], l[1]);
    }, r;
  }(gt)
);
function KA(t, r, e, n) {
  var i = t.getData(), a = i.getLayout("valueAxisHorizontal") ? 1 : 0, o = i.getLayout("largeDataIndices"), s = i.getLayout("size"), l = t.getModel("backgroundStyle"), u = i.getLayout("largeBackgroundPoints");
  if (u) {
    var c = new JA({
      shape: {
        points: u
      },
      incremental: !!n,
      silent: !0,
      z2: 0
    });
    c.baseDimIdx = a, c.largeDataIndices = o, c.barWidth = s, c.useStyle(l.getItemStyle()), r.add(c), e && e.push(c);
  }
  var d = new JA({
    shape: {
      points: i.getLayout("largePoints")
    },
    incremental: !!n,
    ignoreCoarsePointer: !0,
    z2: 1
  });
  d.baseDimIdx = a, d.largeDataIndices = o, d.barWidth = s, r.add(d), d.useStyle(i.getVisual("style")), Ze(d).seriesIndex = t.seriesIndex, t.get("silent") || (d.on("mousedown", qA), d.on("mousemove", qA)), e && e.push(d);
}
var qA = _2(function(t) {
  var r = this, e = Pre(r, t.offsetX, t.offsetY);
  Ze(r).dataIndex = e >= 0 ? e : null;
}, 30, !1);
function Pre(t, r, e) {
  for (var n = t.baseDimIdx, i = 1 - n, a = t.shape.points, o = t.largeDataIndices, s = [], l = [], u = t.barWidth, c = 0, d = a.length / 3; c < d; c++) {
    var f = c * 3;
    if (l[n] = u, l[i] = a[f + 2], s[n] = a[f + n], s[i] = a[f + i], l[i] < 0 && (s[i] += l[i], l[i] = -l[i]), r >= s[0] && r <= s[0] + l[0] && e >= s[1] && e <= s[1] + l[1])
      return o[c];
  }
  return -1;
}
function jG(t, r, e) {
  if (rd(e, "cartesian2d")) {
    var n = r, i = e.getArea();
    return {
      x: t ? n.x : i.x,
      y: t ? i.y : n.y,
      width: t ? n.width : i.width,
      height: t ? i.height : n.height
    };
  } else {
    var i = e.getArea(), a = r;
    return {
      cx: i.cx,
      cy: i.cy,
      r0: t ? i.r0 : a.r0,
      r: t ? i.r : a.r,
      startAngle: t ? a.startAngle : 0,
      endAngle: t ? a.endAngle : Math.PI * 2
    };
  }
}
function Nre(t, r, e) {
  var n = t.type === "polar" ? oi : xt;
  return new n({
    shape: jG(r, e, t),
    silent: !0,
    z2: 0
  });
}
function Ore(t) {
  t.registerChartView(Dre), t.registerSeriesModel(_re), t.registerLayout(t.PRIORITY.VISUAL.LAYOUT, Ye(JV, "bar")), t.registerLayout(t.PRIORITY.VISUAL.PROGRESSIVE_LAYOUT, KV("bar")), t.registerProcessor(t.PRIORITY.PROCESSOR.STATISTIC, WG("bar")), t.registerAction({
    type: "changeAxisOrder",
    event: "changeAxisOrder",
    update: "update"
  }, function(r, e) {
    var n = r.componentType || "series";
    e.eachComponent({
      mainType: n,
      query: r
    }, function(i) {
      r.sortInfo && i.axis.setCategorySortInfo(r.sortInfo);
    });
  });
}
var QA = Math.PI * 2, N1 = Math.PI / 180;
function YG(t, r) {
  return cn(t.getBoxLayoutParams(), {
    width: r.getWidth(),
    height: r.getHeight()
  });
}
function XG(t, r) {
  var e = YG(t, r), n = t.get("center"), i = t.get("radius");
  ue(i) || (i = [0, i]);
  var a = he(e.width, r.getWidth()), o = he(e.height, r.getHeight()), s = Math.min(a, o), l = he(i[0], s / 2), u = he(i[1], s / 2), c, d, f = t.coordinateSystem;
  if (f) {
    var h = f.dataToPoint(n);
    c = h[0] || 0, d = h[1] || 0;
  } else
    ue(n) || (n = [n, n]), c = he(n[0], a) + e.x, d = he(n[1], o) + e.y;
  return {
    cx: c,
    cy: d,
    r0: l,
    r: u
  };
}
function Vre(t, r, e) {
  r.eachSeriesByType(t, function(n) {
    var i = n.getData(), a = i.mapDimension("value"), o = YG(n, e), s = XG(n, e), l = s.cx, u = s.cy, c = s.r, d = s.r0, f = -n.get("startAngle") * N1, h = n.get("endAngle"), p = n.get("padAngle") * N1;
    h = h === "auto" ? f - QA : -h * N1;
    var v = n.get("minAngle") * N1, g = v + p, m = 0;
    i.each(a, function(N) {
      !isNaN(N) && m++;
    });
    var y = i.getSum(a), b = Math.PI / (y || m) * 2, C = n.get("clockwise"), w = n.get("roseType"), _ = n.get("stillShowZeroSum"), x = i.getDataExtent(a);
    x[0] = 0;
    var I = C ? 1 : -1, D = [f, h], T = I * p / 2;
    V7(D, !C), f = D[0], h = D[1];
    var A = $G(n);
    A.startAngle = f, A.endAngle = h, A.clockwise = C;
    var M = Math.abs(h - f), R = M, E = 0, k = f;
    if (i.setLayout({
      viewRect: o,
      r: c
    }), i.each(a, function(N, O) {
      var W;
      if (isNaN(N)) {
        i.setItemLayout(O, {
          angle: NaN,
          startAngle: NaN,
          endAngle: NaN,
          clockwise: C,
          cx: l,
          cy: u,
          r0: d,
          r: w ? NaN : c
        });
        return;
      }
      w !== "area" ? W = y === 0 && _ ? b : N * b : W = M / m, W < g ? (W = g, R -= g) : E += N;
      var V = k + I * W, B = 0, Z = 0;
      p > W ? (B = k + I * W / 2, Z = B) : (B = k + T, Z = V - T), i.setItemLayout(O, {
        angle: W,
        startAngle: B,
        endAngle: Z,
        clockwise: C,
        cx: l,
        cy: u,
        r0: d,
        r: w ? zt(N, x, [d, c]) : c
      }), k = V;
    }), R < QA && m)
      if (R <= 1e-3) {
        var P = M / m;
        i.each(a, function(N, O) {
          if (!isNaN(N)) {
            var W = i.getItemLayout(O);
            W.angle = P;
            var V = 0, B = 0;
            P < p ? (V = f + I * (O + 1 / 2) * P, B = V) : (V = f + I * O * P + T, B = f + I * (O + 1) * P - T), W.startAngle = V, W.endAngle = B;
          }
        });
      } else
        b = R / E, k = f, i.each(a, function(N, O) {
          if (!isNaN(N)) {
            var W = i.getItemLayout(O), V = W.angle === g ? g : N * b, B = 0, Z = 0;
            V < p ? (B = k + I * V / 2, Z = B) : (B = k + T, Z = k + I * V - T), W.startAngle = B, W.endAngle = Z, k += I * V;
          }
        });
  });
}
var $G = It();
function Ig(t) {
  return {
    seriesType: t,
    reset: function(r, e) {
      var n = e.findComponents({
        mainType: "legend"
      });
      if (!(!n || !n.length)) {
        var i = r.getData();
        i.filterSelf(function(a) {
          for (var o = i.getName(a), s = 0; s < n.length; s++)
            if (!n[s].isSelected(o))
              return !1;
          return !0;
        });
      }
    }
  };
}
var Gre = Math.PI / 180;
function eD(t, r, e, n, i, a, o, s, l, u) {
  if (t.length < 2)
    return;
  function c(v) {
    for (var g = v.rB, m = g * g, y = 0; y < v.list.length; y++) {
      var b = v.list[y], C = Math.abs(b.label.y - e), w = n + b.len, _ = w * w, x = Math.sqrt((1 - Math.abs(C * C / m)) * _), I = r + (x + b.len2) * i, D = I - b.label.x, T = b.targetTextWidth - D * i;
      UG(b, T, !0), b.label.x = I;
    }
  }
  function d(v) {
    for (var g = {
      list: [],
      maxY: 0
    }, m = {
      list: [],
      maxY: 0
    }, y = 0; y < v.length; y++)
      if (v[y].labelAlignTo === "none") {
        var b = v[y], C = b.label.y > e ? m : g, w = Math.abs(b.label.y - e);
        if (w >= C.maxY) {
          var _ = b.label.x - r - b.len2 * i, x = n + b.len, I = Math.abs(_) < x ? Math.sqrt(w * w / (1 - _ * _ / x / x)) : x;
          C.rB = I, C.maxY = w;
        }
        C.list.push(b);
      }
    c(g), c(m);
  }
  for (var f = t.length, h = 0; h < f; h++)
    if (t[h].position === "outer" && t[h].labelAlignTo === "labelLine") {
      var p = t[h].label.x - u;
      t[h].linePoints[1][0] += p, t[h].label.x = u;
    }
  yG(t, l, l + o) && d(t);
}
function Bre(t, r, e, n, i, a, o, s) {
  for (var l = [], u = [], c = Number.MAX_VALUE, d = -Number.MAX_VALUE, f = 0; f < t.length; f++) {
    var h = t[f].label;
    zb(t[f]) || (h.x < r ? (c = Math.min(c, h.x), l.push(t[f])) : (d = Math.max(d, h.x), u.push(t[f])));
  }
  for (var f = 0; f < t.length; f++) {
    var p = t[f];
    if (!zb(p) && p.linePoints) {
      if (p.labelStyleWidth != null)
        continue;
      var h = p.label, v = p.linePoints, g = void 0;
      p.labelAlignTo === "edge" ? h.x < r ? g = v[2][0] - p.labelDistance - o - p.edgeDistance : g = o + i - p.edgeDistance - v[2][0] - p.labelDistance : p.labelAlignTo === "labelLine" ? h.x < r ? g = c - o - p.bleedMargin : g = o + i - d - p.bleedMargin : h.x < r ? g = h.x - o - p.bleedMargin : g = o + i - h.x - p.bleedMargin, p.targetTextWidth = g, UG(p, g);
    }
  }
  eD(u, r, e, n, 1, i, a, o, s, d), eD(l, r, e, n, -1, i, a, o, s, c);
  for (var f = 0; f < t.length; f++) {
    var p = t[f];
    if (!zb(p) && p.linePoints) {
      var h = p.label, v = p.linePoints, m = p.labelAlignTo === "edge", y = h.style.padding, b = y ? y[1] + y[3] : 0, C = h.style.backgroundColor ? 0 : b, w = p.rect.width + C, _ = v[1][0] - v[2][0];
      m ? h.x < r ? v[2][0] = o + p.edgeDistance + w + p.labelDistance : v[2][0] = o + i - p.edgeDistance - w - p.labelDistance : (h.x < r ? v[2][0] = h.x + p.labelDistance : v[2][0] = h.x - p.labelDistance, v[1][0] = v[2][0] + _), v[1][1] = v[2][1] = h.y;
    }
  }
}
function UG(t, r, e) {
  if (e === void 0 && (e = !1), t.labelStyleWidth == null) {
    var n = t.label, i = n.style, a = t.rect, o = i.backgroundColor, s = i.padding, l = s ? s[1] + s[3] : 0, u = i.overflow, c = a.width + (o ? 0 : l);
    if (r < c || e) {
      var d = a.height;
      if (u && u.match("break")) {
        n.setStyle("backgroundColor", null), n.setStyle("width", r - l);
        var f = n.getBoundingRect();
        n.setStyle("width", Math.ceil(f.width)), n.setStyle("backgroundColor", o);
      } else {
        var h = r - l, p = r < c ? h : (
          // Current available width is enough, but the text may have
          // already been wrapped with a smaller available width.
          e ? h > t.unconstrainedWidth ? null : h : null
        );
        n.setStyle("width", p);
      }
      var v = n.getBoundingRect();
      a.width = v.width;
      var g = (n.style.margin || 0) + 2.1;
      a.height = v.height + g, a.y -= (a.height - d) / 2;
    }
  }
}
function zb(t) {
  return t.position === "center";
}
function Fre(t) {
  var r = t.getData(), e = [], n, i, a = !1, o = (t.get("minShowLabelAngle") || 0) * Gre, s = r.getLayout("viewRect"), l = r.getLayout("r"), u = s.width, c = s.x, d = s.y, f = s.height;
  function h(_) {
    _.ignore = !0;
  }
  function p(_) {
    if (!_.ignore)
      return !0;
    for (var x in _.states)
      if (_.states[x].ignore === !1)
        return !0;
    return !1;
  }
  r.each(function(_) {
    var x = r.getItemGraphicEl(_), I = x.shape, D = x.getTextContent(), T = x.getTextGuideLine(), A = r.getItemModel(_), M = A.getModel("label"), R = M.get("position") || A.get(["emphasis", "label", "position"]), E = M.get("distanceToLabelLine"), k = M.get("alignTo"), P = he(M.get("edgeDistance"), u), N = M.get("bleedMargin"), O = A.getModel("labelLine"), W = O.get("length");
    W = he(W, u);
    var V = O.get("length2");
    if (V = he(V, u), Math.abs(I.endAngle - I.startAngle) < o) {
      L(D.states, h), D.ignore = !0, T && (L(T.states, h), T.ignore = !0);
      return;
    }
    if (p(D)) {
      var B = (I.startAngle + I.endAngle) / 2, Z = Math.cos(B), q = Math.sin(B), z, U, J, K;
      n = I.cx, i = I.cy;
      var j = R === "inside" || R === "inner";
      if (R === "center")
        z = I.cx, U = I.cy, K = "center";
      else {
        var oe = (j ? (I.r + I.r0) / 2 * Z : I.r * Z) + n, ie = (j ? (I.r + I.r0) / 2 * q : I.r * q) + i;
        if (z = oe + Z * 3, U = ie + q * 3, !j) {
          var le = oe + Z * (W + l - I.r), re = ie + q * (W + l - I.r), Re = le + (Z < 0 ? -1 : 1) * V, ve = re;
          k === "edge" ? z = Z < 0 ? c + P : c + u - P : z = Re + (Z < 0 ? -E : E), U = ve, J = [[oe, ie], [le, re], [Re, ve]];
        }
        K = j ? "center" : k === "edge" ? Z > 0 ? "right" : "left" : Z > 0 ? "left" : "right";
      }
      var Oe = Math.PI, qe = 0, dt = M.get("rotate");
      if (Mt(dt))
        qe = dt * (Oe / 180);
      else if (R === "center")
        qe = 0;
      else if (dt === "radial" || dt === !0) {
        var At = Z < 0 ? -B + Oe : -B;
        qe = At;
      } else if (dt === "tangential" && R !== "outside" && R !== "outer") {
        var Be = Math.atan2(Z, q);
        Be < 0 && (Be = Oe * 2 + Be);
        var Nt = q > 0;
        Nt && (Be = Oe + Be), qe = Be - Oe;
      }
      if (a = !!qe, D.x = z, D.y = U, D.rotation = qe, D.setStyle({
        verticalAlign: "middle"
      }), j) {
        D.setStyle({
          align: K
        });
        var Ot = D.states.select;
        Ot && (Ot.x += D.x, Ot.y += D.y);
      } else {
        var wt = D.getBoundingRect().clone();
        wt.applyTransform(D.getComputedTransform());
        var Dt = (D.style.margin || 0) + 2.1;
        wt.y -= Dt / 2, wt.height += Dt, e.push({
          label: D,
          labelLine: T,
          position: R,
          len: W,
          len2: V,
          minTurnAngle: O.get("minTurnAngle"),
          maxSurfaceAngle: O.get("maxSurfaceAngle"),
          surfaceNormal: new tt(Z, q),
          linePoints: J,
          textAlign: K,
          labelDistance: E,
          labelAlignTo: k,
          edgeDistance: P,
          bleedMargin: N,
          rect: wt,
          unconstrainedWidth: wt.width,
          labelStyleWidth: D.style.width
        });
      }
      x.setTextConfig({
        inside: j
      });
    }
  }), !a && t.get("avoidLabelOverlap") && Bre(e, n, i, l, u, f, c, d);
  for (var v = 0; v < e.length; v++) {
    var g = e[v], m = g.label, y = g.labelLine, b = isNaN(m.x) || isNaN(m.y);
    if (m) {
      m.setStyle({
        align: g.textAlign
      }), b && (L(m.states, h), m.ignore = !0);
      var C = m.states.select;
      C && (C.x += m.x, C.y += m.y);
    }
    if (y) {
      var w = g.linePoints;
      b || !w ? (L(y.states, h), y.ignore = !0) : (vG(w, g.minTurnAngle), ute(w, g.surfaceNormal, g.maxSurfaceAngle), y.setShape({
        points: w
      }), m.__hostTarget.textGuideLineConfig = {
        anchor: new tt(w[0][0], w[0][1])
      });
    }
  }
}
var Hre = (
  /** @class */
  function(t) {
    ee(r, t);
    function r(e, n, i) {
      var a = t.call(this) || this;
      a.z2 = 2;
      var o = new _t();
      return a.setTextContent(o), a.updateData(e, n, i, !0), a;
    }
    return r.prototype.updateData = function(e, n, i, a) {
      var o = this, s = e.hostModel, l = e.getItemModel(n), u = l.getModel("emphasis"), c = e.getItemLayout(n), d = ae(gc(l.getModel("itemStyle"), c, !0), c);
      if (isNaN(d.startAngle)) {
        o.setShape(d);
        return;
      }
      if (a) {
        o.setShape(d);
        var f = s.getShallow("animationType");
        s.ecModel.ssr ? (Cr(o, {
          scaleX: 0,
          scaleY: 0
        }, s, {
          dataIndex: n,
          isFrom: !0
        }), o.originX = d.cx, o.originY = d.cy) : f === "scale" ? (o.shape.r = c.r0, Cr(o, {
          shape: {
            r: c.r
          }
        }, s, n)) : i != null ? (o.setShape({
          startAngle: i,
          endAngle: i
        }), Cr(o, {
          shape: {
            startAngle: c.startAngle,
            endAngle: c.endAngle
          }
        }, s, n)) : (o.shape.endAngle = c.startAngle, kt(o, {
          shape: {
            endAngle: c.endAngle
          }
        }, s, n));
      } else
        ro(o), kt(o, {
          shape: d
        }, s, n);
      o.useStyle(e.getItemVisual(n, "style")), Yn(o, l);
      var h = (c.startAngle + c.endAngle) / 2, p = s.get("selectedOffset"), v = Math.cos(h) * p, g = Math.sin(h) * p, m = l.getShallow("cursor");
      m && o.attr("cursor", m), this._updateLabel(s, e, n), o.ensureState("emphasis").shape = ae({
        r: c.r + (u.get("scale") && u.get("scaleSize") || 0)
      }, gc(u.getModel("itemStyle"), c)), ae(o.ensureState("select"), {
        x: v,
        y: g,
        shape: gc(l.getModel(["select", "itemStyle"]), c)
      }), ae(o.ensureState("blur"), {
        shape: gc(l.getModel(["blur", "itemStyle"]), c)
      });
      var y = o.getTextGuideLine(), b = o.getTextContent();
      y && ae(y.ensureState("select"), {
        x: v,
        y: g
      }), ae(b.ensureState("select"), {
        x: v,
        y: g
      }), Vr(this, u.get("focus"), u.get("blurScope"), u.get("disabled"));
    }, r.prototype._updateLabel = function(e, n, i) {
      var a = this, o = n.getItemModel(i), s = o.getModel("labelLine"), l = n.getItemVisual(i, "style"), u = l && l.fill, c = l && l.opacity;
      Xn(a, xn(o), {
        labelFetcher: n.hostModel,
        labelDataIndex: i,
        inheritColor: u,
        defaultOpacity: c,
        defaultText: e.getFormattedLabel(i, "normal") || n.getName(i)
      });
      var d = a.getTextContent();
      a.setTextConfig({
        // reset position, rotation
        position: null,
        rotation: null
      }), d.attr({
        z2: 10
      });
      var f = e.get(["label", "position"]);
      if (f !== "outside" && f !== "outer")
        a.removeTextGuideLine();
      else {
        var h = this.getTextGuideLine();
        h || (h = new ci(), this.setTextGuideLine(h)), kw(this, Pw(o), {
          stroke: u,
          opacity: Ki(s.get(["lineStyle", "opacity"]), c, 1)
        });
      }
    }, r;
  }(oi)
), zre = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.ignoreLabelLineUpdate = !0, e;
    }
    return r.prototype.render = function(e, n, i, a) {
      var o = e.getData(), s = this._data, l = this.group, u;
      if (!s && o.count() > 0) {
        for (var c = o.getItemLayout(0), d = 1; isNaN(c && c.startAngle) && d < o.count(); ++d)
          c = o.getItemLayout(d);
        c && (u = c.startAngle);
      }
      if (this._emptyCircleSector && l.remove(this._emptyCircleSector), o.count() === 0 && e.get("showEmptyCircle")) {
        var f = $G(e), h = new oi({
          shape: ae(XG(e, i), f)
        });
        h.useStyle(e.getModel("emptyCircleStyle").getItemStyle()), this._emptyCircleSector = h, l.add(h);
      }
      o.diff(s).add(function(p) {
        var v = new Hre(o, p, u);
        o.setItemGraphicEl(p, v), l.add(v);
      }).update(function(p, v) {
        var g = s.getItemGraphicEl(v);
        g.updateData(o, p, u), g.off("click"), l.add(g), o.setItemGraphicEl(p, g);
      }).remove(function(p) {
        var v = s.getItemGraphicEl(p);
        wv(v, e, p);
      }).execute(), Fre(e), e.get("animationTypeUpdate") !== "expansion" && (this._data = o);
    }, r.prototype.dispose = function() {
    }, r.prototype.containPoint = function(e, n) {
      var i = n.getData(), a = i.getItemLayout(0);
      if (a) {
        var o = e[0] - a.cx, s = e[1] - a.cy, l = Math.sqrt(o * o + s * s);
        return l <= a.r && l >= a.r0;
      }
    }, r.type = "pie", r;
  }(Yt)
);
function gh(t, r, e) {
  r = ue(r) && {
    coordDimensions: r
  } || ae({
    encodeDefine: t.getEncode()
  }, r);
  var n = t.getSource(), i = hh(n, r).dimensions, a = new ni(i, t);
  return a.initData(n, e), a;
}
var Ag = (
  /** @class */
  function() {
    function t(r, e) {
      this._getDataWithEncodedVisual = r, this._getRawData = e;
    }
    return t.prototype.getAllNames = function() {
      var r = this._getRawData();
      return r.mapArray(r.getName);
    }, t.prototype.containName = function(r) {
      var e = this._getRawData();
      return e.indexOfName(r) >= 0;
    }, t.prototype.indexOfName = function(r) {
      var e = this._getDataWithEncodedVisual();
      return e.indexOfName(r);
    }, t.prototype.getItemVisual = function(r, e) {
      var n = this._getDataWithEncodedVisual();
      return n.getItemVisual(r, e);
    }, t;
  }()
), Wre = It(), Zre = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return r.prototype.init = function(e) {
      t.prototype.init.apply(this, arguments), this.legendVisualProvider = new Ag(ye(this.getData, this), ye(this.getRawData, this)), this._defaultLabelLine(e);
    }, r.prototype.mergeOption = function() {
      t.prototype.mergeOption.apply(this, arguments);
    }, r.prototype.getInitialData = function() {
      return gh(this, {
        coordDimensions: ["value"],
        encodeDefaulter: Ye(ow, this)
      });
    }, r.prototype.getDataParams = function(e) {
      var n = this.getData(), i = Wre(n), a = i.seats;
      if (!a) {
        var o = [];
        n.each(n.mapDimension("value"), function(l) {
          o.push(l);
        }), a = i.seats = bN(o, n.hostModel.get("percentPrecision"));
      }
      var s = t.prototype.getDataParams.call(this, e);
      return s.percent = a[e] || 0, s.$vars.push("percent"), s;
    }, r.prototype._defaultLabelLine = function(e) {
      Vc(e, "labelLine", ["show"]);
      var n = e.labelLine, i = e.emphasis.labelLine;
      n.show = n.show && e.label.show, i.show = i.show && e.emphasis.label.show;
    }, r.type = "series.pie", r.defaultOption = {
      // zlevel: 0,
      z: 2,
      legendHoverLink: !0,
      colorBy: "data",
      // 默认全局居中
      center: ["50%", "50%"],
      radius: [0, "75%"],
      // 默认顺时针
      clockwise: !0,
      startAngle: 90,
      endAngle: "auto",
      padAngle: 0,
      // 最小角度改为0
      minAngle: 0,
      // If the angle of a sector less than `minShowLabelAngle`,
      // the label will not be displayed.
      minShowLabelAngle: 0,
      // 选中时扇区偏移量
      selectedOffset: 10,
      // 选择模式，默认关闭，可选single，multiple
      // selectedMode: false,
      // 南丁格尔玫瑰图模式，'radius'（半径） | 'area'（面积）
      // roseType: null,
      percentPrecision: 2,
      // If still show when all data zero.
      stillShowZeroSum: !0,
      // cursor: null,
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
      width: null,
      height: null,
      label: {
        // color: 'inherit',
        // If rotate around circle
        rotate: 0,
        show: !0,
        overflow: "truncate",
        // 'outer', 'inside', 'center'
        position: "outer",
        // 'none', 'labelLine', 'edge'. Works only when position is 'outer'
        alignTo: "none",
        // Closest distance between label and chart edge.
        // Works only position is 'outer' and alignTo is 'edge'.
        edgeDistance: "25%",
        // Works only position is 'outer' and alignTo is not 'edge'.
        bleedMargin: 10,
        // Distance between text and label line.
        distanceToLabelLine: 5
        // formatter: 标签文本格式器，同 tooltip.formatter，不支持异步回调
        // 默认使用全局文本样式，详见 textStyle
        // distance: 当position为inner时有效，为label位置到圆心的距离与圆半径(环状图为内外半径和)的比例系数
      },
      // Enabled when label.normal.position is 'outer'
      labelLine: {
        show: !0,
        // 引导线两段中的第一段长度
        length: 15,
        // 引导线两段中的第二段长度
        length2: 15,
        smooth: !1,
        minTurnAngle: 90,
        maxSurfaceAngle: 90,
        lineStyle: {
          // color: 各异,
          width: 1,
          type: "solid"
        }
      },
      itemStyle: {
        borderWidth: 1,
        borderJoin: "round"
      },
      showEmptyCircle: !0,
      emptyCircleStyle: {
        color: "lightgray",
        opacity: 1
      },
      labelLayout: {
        // Hide the overlapped label.
        hideOverlap: !0
      },
      emphasis: {
        scale: !0,
        scaleSize: 5
      },
      // If use strategy to avoid label overlapping
      avoidLabelOverlap: !0,
      // Animation type. Valid values: expansion, scale
      animationType: "expansion",
      animationDuration: 1e3,
      // Animation type when update. Valid values: transition, expansion
      animationTypeUpdate: "transition",
      animationEasingUpdate: "cubicInOut",
      animationDurationUpdate: 500,
      animationEasing: "cubicInOut"
    }, r;
  }(tr)
);
function jre(t) {
  return {
    seriesType: t,
    reset: function(r, e) {
      var n = r.getData();
      n.filterSelf(function(i) {
        var a = n.mapDimension("value"), o = n.get(a, i);
        return !(Mt(o) && !isNaN(o) && o < 0);
      });
    }
  };
}
function Yre(t) {
  t.registerChartView(zre), t.registerSeriesModel(Zre), pV("pie", t.registerAction), t.registerLayout(Ye(Vre, "pie")), t.registerProcessor(Ig("pie")), t.registerProcessor(jre("pie"));
}
var Xre = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e.hasSymbolVisual = !0, e;
    }
    return r.prototype.getInitialData = function(e, n) {
      return os(null, this, {
        useEncodeDefaulter: !0
      });
    }, r.prototype.getProgressive = function() {
      var e = this.option.progressive;
      return e ?? (this.option.large ? 5e3 : this.get("progressive"));
    }, r.prototype.getProgressiveThreshold = function() {
      var e = this.option.progressiveThreshold;
      return e ?? (this.option.large ? 1e4 : this.get("progressiveThreshold"));
    }, r.prototype.brushSelector = function(e, n, i) {
      return i.point(n.getItemLayout(e));
    }, r.prototype.getZLevelKey = function() {
      return this.getData().count() > this.getProgressiveThreshold() ? this.id : "";
    }, r.type = "series.scatter", r.dependencies = ["grid", "polar", "geo", "singleAxis", "calendar"], r.defaultOption = {
      coordinateSystem: "cartesian2d",
      // zlevel: 0,
      z: 2,
      legendHoverLink: !0,
      symbolSize: 10,
      // symbolRotate: null,  // 图形旋转控制
      large: !1,
      // Available when large is true
      largeThreshold: 2e3,
      // cursor: null,
      itemStyle: {
        opacity: 0.8
        // color: 各异
      },
      emphasis: {
        scale: !0
      },
      // If clip the overflow graphics
      // Works on cartesian / polar series
      clip: !0,
      select: {
        itemStyle: {
          borderColor: "#212121"
        }
      },
      universalTransition: {
        divideShape: "clone"
      }
      // progressive: null
    }, r;
  }(tr)
), JG = 4, $re = (
  /** @class */
  /* @__PURE__ */ function() {
    function t() {
    }
    return t;
  }()
), Ure = (
  /** @class */
  function(t) {
    ee(r, t);
    function r(e) {
      var n = t.call(this, e) || this;
      return n._off = 0, n.hoverDataIdx = -1, n;
    }
    return r.prototype.getDefaultShape = function() {
      return new $re();
    }, r.prototype.reset = function() {
      this.notClear = !1, this._off = 0;
    }, r.prototype.buildPath = function(e, n) {
      var i = n.points, a = n.size, o = this.symbolProxy, s = o.shape, l = e.getContext ? e.getContext() : e, u = l && a[0] < JG, c = this.softClipShape, d;
      if (u) {
        this._ctx = l;
        return;
      }
      for (this._ctx = null, d = this._off; d < i.length; ) {
        var f = i[d++], h = i[d++];
        isNaN(f) || isNaN(h) || c && !c.contain(f, h) || (s.x = f - a[0] / 2, s.y = h - a[1] / 2, s.width = a[0], s.height = a[1], o.buildPath(e, s, !0));
      }
      this.incremental && (this._off = d, this.notClear = !0);
    }, r.prototype.afterBrush = function() {
      var e = this.shape, n = e.points, i = e.size, a = this._ctx, o = this.softClipShape, s;
      if (a) {
        for (s = this._off; s < n.length; ) {
          var l = n[s++], u = n[s++];
          isNaN(l) || isNaN(u) || o && !o.contain(l, u) || a.fillRect(l - i[0] / 2, u - i[1] / 2, i[0], i[1]);
        }
        this.incremental && (this._off = s, this.notClear = !0);
      }
    }, r.prototype.findDataIndex = function(e, n) {
      for (var i = this.shape, a = i.points, o = i.size, s = Math.max(o[0], 4), l = Math.max(o[1], 4), u = a.length / 2 - 1; u >= 0; u--) {
        var c = u * 2, d = a[c] - s / 2, f = a[c + 1] - l / 2;
        if (e >= d && n >= f && e <= d + s && n <= f + l)
          return u;
      }
      return -1;
    }, r.prototype.contain = function(e, n) {
      var i = this.transformCoordToLocal(e, n), a = this.getBoundingRect();
      if (e = i[0], n = i[1], a.contain(e, n)) {
        var o = this.hoverDataIdx = this.findDataIndex(e, n);
        return o >= 0;
      }
      return this.hoverDataIdx = -1, !1;
    }, r.prototype.getBoundingRect = function() {
      var e = this._rect;
      if (!e) {
        for (var n = this.shape, i = n.points, a = n.size, o = a[0], s = a[1], l = 1 / 0, u = 1 / 0, c = -1 / 0, d = -1 / 0, f = 0; f < i.length; ) {
          var h = i[f++], p = i[f++];
          l = Math.min(h, l), c = Math.max(h, c), u = Math.min(p, u), d = Math.max(p, d);
        }
        e = this._rect = new rt(l - o / 2, u - s / 2, c - l + o, d - u + s);
      }
      return e;
    }, r;
  }(gt)
), Jre = (
  /** @class */
  function() {
    function t() {
      this.group = new ze();
    }
    return t.prototype.updateData = function(r, e) {
      this._clear();
      var n = this._create();
      n.setShape({
        points: r.getLayout("points")
      }), this._setCommon(n, r, e);
    }, t.prototype.updateLayout = function(r) {
      var e = r.getLayout("points");
      this.group.eachChild(function(n) {
        if (n.startIndex != null) {
          var i = (n.endIndex - n.startIndex) * 2, a = n.startIndex * 4 * 2;
          e = new Float32Array(e.buffer, a, i);
        }
        n.setShape("points", e), n.reset();
      });
    }, t.prototype.incrementalPrepareUpdate = function(r) {
      this._clear();
    }, t.prototype.incrementalUpdate = function(r, e, n) {
      var i = this._newAdded[0], a = e.getLayout("points"), o = i && i.shape.points;
      if (o && o.length < 2e4) {
        var s = o.length, l = new Float32Array(s + a.length);
        l.set(o), l.set(a, s), i.endIndex = r.end, i.setShape({
          points: l
        });
      } else {
        this._newAdded = [];
        var u = this._create();
        u.startIndex = r.start, u.endIndex = r.end, u.incremental = !0, u.setShape({
          points: a
        }), this._setCommon(u, e, n);
      }
    }, t.prototype.eachRendered = function(r) {
      this._newAdded[0] && r(this._newAdded[0]);
    }, t.prototype._create = function() {
      var r = new Ure({
        cursor: "default"
      });
      return r.ignoreCoarsePointer = !0, this.group.add(r), this._newAdded.push(r), r;
    }, t.prototype._setCommon = function(r, e, n) {
      var i = e.hostModel;
      n = n || {};
      var a = e.getVisual("symbolSize");
      r.setShape("size", a instanceof Array ? a : [a, a]), r.softClipShape = n.clipShape || null, r.symbolProxy = en(e.getVisual("symbol"), 0, 0, 0, 0), r.setColor = r.symbolProxy.setColor;
      var o = r.shape.size[0] < JG;
      r.useStyle(
        // Draw shadow when doing fillRect is extremely slow.
        i.getModel("itemStyle").getItemStyle(o ? ["color", "shadowBlur", "shadowColor"] : ["color"])
      );
      var s = e.getVisual("style"), l = s && s.fill;
      l && r.setColor(l);
      var u = Ze(r);
      u.seriesIndex = i.seriesIndex, r.on("mousemove", function(c) {
        u.dataIndex = null;
        var d = r.hoverDataIdx;
        d >= 0 && (u.dataIndex = d + (r.startIndex || 0));
      });
    }, t.prototype.remove = function() {
      this._clear();
    }, t.prototype._clear = function() {
      this._newAdded = [], this.group.removeAll();
    }, t;
  }()
), Kre = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.render = function(e, n, i) {
      var a = e.getData(), o = this._updateSymbolDraw(a, e);
      o.updateData(a, {
        // TODO
        // If this parameter should be a shape or a bounding volume
        // shape will be more general.
        // But bounding volume like bounding rect will be much faster in the contain calculation
        clipShape: this._getClipShape(e)
      }), this._finished = !0;
    }, r.prototype.incrementalPrepareRender = function(e, n, i) {
      var a = e.getData(), o = this._updateSymbolDraw(a, e);
      o.incrementalPrepareUpdate(a), this._finished = !1;
    }, r.prototype.incrementalRender = function(e, n, i) {
      this._symbolDraw.incrementalUpdate(e, n.getData(), {
        clipShape: this._getClipShape(n)
      }), this._finished = e.end === n.getData().count();
    }, r.prototype.updateTransform = function(e, n, i) {
      var a = e.getData();
      if (this.group.dirty(), !this._finished || a.count() > 1e4)
        return {
          update: !0
        };
      var o = Sg("").reset(e, n, i);
      o.progress && o.progress({
        start: 0,
        end: a.count(),
        count: a.count()
      }, a), this._symbolDraw.updateLayout(a);
    }, r.prototype.eachRendered = function(e) {
      this._symbolDraw && this._symbolDraw.eachRendered(e);
    }, r.prototype._getClipShape = function(e) {
      if (e.get("clip", !0)) {
        var n = e.coordinateSystem;
        return n && n.getArea && n.getArea(0.1);
      }
    }, r.prototype._updateSymbolDraw = function(e, n) {
      var i = this._symbolDraw, a = n.pipelineContext, o = a.large;
      return (!i || o !== this._isLargeDraw) && (i && i.remove(), i = this._symbolDraw = o ? new Jre() : new _g(), this._isLargeDraw = o, this.group.removeAll()), this.group.add(i.group), i;
    }, r.prototype.remove = function(e, n) {
      this._symbolDraw && this._symbolDraw.remove(!0), this._symbolDraw = null;
    }, r.prototype.dispose = function() {
    }, r.type = "scatter", r;
  }(Yt)
), qre = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return r.type = "grid", r.dependencies = ["xAxis", "yAxis"], r.layoutMode = "box", r.defaultOption = {
      show: !1,
      // zlevel: 0,
      z: 0,
      left: "10%",
      top: 60,
      right: "10%",
      bottom: 70,
      // If grid size contain label
      containLabel: !1,
      // width: {totalWidth} - left - right,
      // height: {totalHeight} - top - bottom,
      backgroundColor: "rgba(0,0,0,0)",
      borderWidth: 1,
      borderColor: "#ccc"
    }, r;
  }(st)
), w9 = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return r.prototype.getCoordSysModel = function() {
      return this.getReferringComponents("grid", on).models[0];
    }, r.type = "cartesian2dAxis", r;
  }(st)
);
Xr(w9, vh);
var KG = {
  show: !0,
  // zlevel: 0,
  z: 0,
  // Inverse the axis.
  inverse: !1,
  // Axis name displayed.
  name: "",
  // 'start' | 'middle' | 'end'
  nameLocation: "end",
  // By degree. By default auto rotate by nameLocation.
  nameRotate: null,
  nameTruncate: {
    maxWidth: null,
    ellipsis: "...",
    placeholder: "."
  },
  // Use global text style by default.
  nameTextStyle: {},
  // The gap between axisName and axisLine.
  nameGap: 15,
  // Default `false` to support tooltip.
  silent: !1,
  // Default `false` to avoid legacy user event listener fail.
  triggerEvent: !1,
  tooltip: {
    show: !1
  },
  axisPointer: {},
  axisLine: {
    show: !0,
    onZero: !0,
    onZeroAxisIndex: null,
    lineStyle: {
      color: "#6E7079",
      width: 1,
      type: "solid"
    },
    // The arrow at both ends the the axis.
    symbol: ["none", "none"],
    symbolSize: [10, 15]
  },
  axisTick: {
    show: !0,
    // Whether axisTick is inside the grid or outside the grid.
    inside: !1,
    // The length of axisTick.
    length: 5,
    lineStyle: {
      width: 1
    }
  },
  axisLabel: {
    show: !0,
    // Whether axisLabel is inside the grid or outside the grid.
    inside: !1,
    rotate: 0,
    // true | false | null/undefined (auto)
    showMinLabel: null,
    // true | false | null/undefined (auto)
    showMaxLabel: null,
    margin: 8,
    // formatter: null,
    fontSize: 12
  },
  splitLine: {
    show: !0,
    lineStyle: {
      color: ["#E0E6F1"],
      width: 1,
      type: "solid"
    }
  },
  splitArea: {
    show: !1,
    areaStyle: {
      color: ["rgba(250,250,250,0.2)", "rgba(210,219,238,0.2)"]
    }
  }
}, Qre = Qe({
  // The gap at both ends of the axis. For categoryAxis, boolean.
  boundaryGap: !0,
  // Set false to faster category collection.
  deduplication: null,
  // splitArea: {
  // show: false
  // },
  splitLine: {
    show: !1
  },
  axisTick: {
    // If tick is align with label when boundaryGap is true
    alignWithLabel: !1,
    interval: "auto"
  },
  axisLabel: {
    interval: "auto"
  }
}, KG), Hw = Qe({
  boundaryGap: [0, 0],
  axisLine: {
    // Not shown when other axis is categoryAxis in cartesian
    show: "auto"
  },
  axisTick: {
    // Not shown when other axis is categoryAxis in cartesian
    show: "auto"
  },
  // TODO
  // min/max: [30, datamin, 60] or [20, datamin] or [datamin, 60]
  splitNumber: 5,
  minorTick: {
    // Minor tick, not available for cateogry axis.
    show: !1,
    // Split number of minor ticks. The value should be in range of (0, 100)
    splitNumber: 5,
    // Length of minor tick
    length: 3,
    // Line style
    lineStyle: {
      // Default to be same with axisTick
    }
  },
  minorSplitLine: {
    show: !1,
    lineStyle: {
      color: "#F4F7FD",
      width: 1
    }
  }
}, KG), ene = Qe({
  splitNumber: 6,
  axisLabel: {
    // To eliminate labels that are not nice
    showMinLabel: !1,
    showMaxLabel: !1,
    rich: {
      primary: {
        fontWeight: "bold"
      }
    }
  },
  splitLine: {
    show: !1
  }
}, Hw), tne = Ee({
  logBase: 10
}, Hw);
const qG = {
  category: Qre,
  value: Hw,
  time: ene,
  log: tne
};
var rne = {
  value: 1,
  category: 1,
  time: 1,
  log: 1
};
function kf(t, r, e, n) {
  L(rne, function(i, a) {
    var o = Qe(Qe({}, qG[a], !0), n, !0), s = (
      /** @class */
      function(l) {
        ee(u, l);
        function u() {
          var c = l !== null && l.apply(this, arguments) || this;
          return c.type = r + "Axis." + a, c;
        }
        return u.prototype.mergeDefaultAndTheme = function(c, d) {
          var f = xv(this), h = f ? lh(c) : {}, p = d.getTheme();
          Qe(c, p.get(a + "Axis")), Qe(c, this.getDefaultOption()), c.type = tD(c), f && ru(c, h, f);
        }, u.prototype.optionUpdated = function() {
          var c = this.option;
          c.type === "category" && (this.__ordinalMeta = h9.createByAxisModel(this));
        }, u.prototype.getCategories = function(c) {
          var d = this.option;
          if (d.type === "category")
            return c ? d.data : this.__ordinalMeta.categories;
        }, u.prototype.getOrdinalMeta = function() {
          return this.__ordinalMeta;
        }, u.type = r + "Axis." + a, u.defaultOption = o, u;
      }(e)
    );
    t.registerComponentModel(s);
  }), t.registerSubTypeDefaulter(r + "Axis", tD);
}
function tD(t) {
  return t.type || (t.data ? "category" : "value");
}
var nne = (
  /** @class */
  function() {
    function t(r) {
      this.type = "cartesian", this._dimList = [], this._axes = {}, this.name = r || "";
    }
    return t.prototype.getAxis = function(r) {
      return this._axes[r];
    }, t.prototype.getAxes = function() {
      return ce(this._dimList, function(r) {
        return this._axes[r];
      }, this);
    }, t.prototype.getAxesByScale = function(r) {
      return r = r.toLowerCase(), Wt(this.getAxes(), function(e) {
        return e.scale.type === r;
      });
    }, t.prototype.addAxis = function(r) {
      var e = r.dim;
      this._axes[e] = r, this._dimList.push(e);
    }, t;
  }()
), _9 = ["x", "y"];
function rD(t) {
  return t.type === "interval" || t.type === "time";
}
var ine = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = "cartesian2d", e.dimensions = _9, e;
    }
    return r.prototype.calcAffineTransform = function() {
      this._transform = this._invTransform = null;
      var e = this.getAxis("x").scale, n = this.getAxis("y").scale;
      if (!(!rD(e) || !rD(n))) {
        var i = e.getExtent(), a = n.getExtent(), o = this.dataToPoint([i[0], a[0]]), s = this.dataToPoint([i[1], a[1]]), l = i[1] - i[0], u = a[1] - a[0];
        if (!(!l || !u)) {
          var c = (s[0] - o[0]) / l, d = (s[1] - o[1]) / u, f = o[0] - i[0] * c, h = o[1] - a[0] * d, p = this._transform = [c, 0, 0, d, f, h];
          this._invTransform = Kc([], p);
        }
      }
    }, r.prototype.getBaseAxis = function() {
      return this.getAxesByScale("ordinal")[0] || this.getAxesByScale("time")[0] || this.getAxis("x");
    }, r.prototype.containPoint = function(e) {
      var n = this.getAxis("x"), i = this.getAxis("y");
      return n.contain(n.toLocalCoord(e[0])) && i.contain(i.toLocalCoord(e[1]));
    }, r.prototype.containData = function(e) {
      return this.getAxis("x").containData(e[0]) && this.getAxis("y").containData(e[1]);
    }, r.prototype.containZone = function(e, n) {
      var i = this.dataToPoint(e), a = this.dataToPoint(n), o = this.getArea(), s = new rt(i[0], i[1], a[0] - i[0], a[1] - i[1]);
      return o.intersect(s);
    }, r.prototype.dataToPoint = function(e, n, i) {
      i = i || [];
      var a = e[0], o = e[1];
      if (this._transform && a != null && isFinite(a) && o != null && isFinite(o))
        return En(i, e, this._transform);
      var s = this.getAxis("x"), l = this.getAxis("y");
      return i[0] = s.toGlobalCoord(s.dataToCoord(a, n)), i[1] = l.toGlobalCoord(l.dataToCoord(o, n)), i;
    }, r.prototype.clampData = function(e, n) {
      var i = this.getAxis("x").scale, a = this.getAxis("y").scale, o = i.getExtent(), s = a.getExtent(), l = i.parse(e[0]), u = a.parse(e[1]);
      return n = n || [], n[0] = Math.min(Math.max(Math.min(o[0], o[1]), l), Math.max(o[0], o[1])), n[1] = Math.min(Math.max(Math.min(s[0], s[1]), u), Math.max(s[0], s[1])), n;
    }, r.prototype.pointToData = function(e, n) {
      var i = [];
      if (this._invTransform)
        return En(i, e, this._invTransform);
      var a = this.getAxis("x"), o = this.getAxis("y");
      return i[0] = a.coordToData(a.toLocalCoord(e[0]), n), i[1] = o.coordToData(o.toLocalCoord(e[1]), n), i;
    }, r.prototype.getOtherAxis = function(e) {
      return this.getAxis(e.dim === "x" ? "y" : "x");
    }, r.prototype.getArea = function(e) {
      e = e || 0;
      var n = this.getAxis("x").getGlobalExtent(), i = this.getAxis("y").getGlobalExtent(), a = Math.min(n[0], n[1]) - e, o = Math.min(i[0], i[1]) - e, s = Math.max(n[0], n[1]) - a + e, l = Math.max(i[0], i[1]) - o + e;
      return new rt(a, o, s, l);
    }, r;
  }(nne)
), ane = (
  /** @class */
  function(t) {
    ee(r, t);
    function r(e, n, i, a, o) {
      var s = t.call(this, e, n, i) || this;
      return s.index = 0, s.type = a || "value", s.position = o || "bottom", s;
    }
    return r.prototype.isHorizontal = function() {
      var e = this.position;
      return e === "top" || e === "bottom";
    }, r.prototype.getGlobalExtent = function(e) {
      var n = this.getExtent();
      return n[0] = this.toGlobalCoord(n[0]), n[1] = this.toGlobalCoord(n[1]), e && n[0] > n[1] && n.reverse(), n;
    }, r.prototype.pointToData = function(e, n) {
      return this.coordToData(this.toLocalCoord(e[this.dim === "x" ? 0 : 1]), n);
    }, r.prototype.setCategorySortInfo = function(e) {
      if (this.type !== "category")
        return !1;
      this.model.option.categorySortInfo = e, this.scale.setSortInfo(e);
    }, r;
  }(Va)
);
function x9(t, r, e) {
  e = e || {};
  var n = t.coordinateSystem, i = r.axis, a = {}, o = i.getAxesOnZeroOf()[0], s = i.position, l = o ? "onZero" : s, u = i.dim, c = n.getRect(), d = [c.x, c.x + c.width, c.y, c.y + c.height], f = {
    left: 0,
    right: 1,
    top: 0,
    bottom: 1,
    onZero: 2
  }, h = r.get("offset") || 0, p = u === "x" ? [d[2] - h, d[3] + h] : [d[0] - h, d[1] + h];
  if (o) {
    var v = o.toGlobalCoord(o.dataToCoord(0));
    p[f.onZero] = Math.max(Math.min(v, p[1]), p[0]);
  }
  a.position = [u === "y" ? p[f[l]] : d[0], u === "x" ? p[f[l]] : d[3]], a.rotation = Math.PI / 2 * (u === "x" ? 0 : 1);
  var g = {
    top: -1,
    bottom: 1,
    left: -1,
    right: 1
  };
  a.labelDirection = a.tickDirection = a.nameDirection = g[s], a.labelOffset = o ? p[f[s]] - p[f.onZero] : 0, r.get(["axisTick", "inside"]) && (a.tickDirection = -a.tickDirection), Qr(e.labelInside, r.get(["axisLabel", "inside"])) && (a.labelDirection = -a.labelDirection);
  var m = r.get(["axisLabel", "rotate"]);
  return a.labelRotate = l === "top" ? -m : m, a.z2 = 1, a;
}
function nD(t) {
  return t.get("coordinateSystem") === "cartesian2d";
}
function iD(t) {
  var r = {
    xAxisModel: null,
    yAxisModel: null
  };
  return L(r, function(e, n) {
    var i = n.replace(/Model$/, ""), a = t.getReferringComponents(i, on).models[0];
    if (process.env.NODE_ENV !== "production" && !a)
      throw new Error(i + ' "' + Ki(t.get(i + "Index"), t.get(i + "Id"), 0) + '" not found');
    r[n] = a;
  }), r;
}
var Wb = Math.log;
function QG(t, r, e) {
  var n = Ks.prototype, i = n.getTicks.call(e), a = n.getTicks.call(e, !0), o = i.length - 1, s = n.getInterval.call(e), l = rG(t, r), u = l.extent, c = l.fixMin, d = l.fixMax;
  if (t.type === "log") {
    var f = Wb(t.base);
    u = [Wb(u[0]) / f, Wb(u[1]) / f];
  }
  t.setExtent(u[0], u[1]), t.calcNiceExtent({
    splitNumber: o,
    fixMin: c,
    fixMax: d
  });
  var h = n.getExtent.call(t);
  c && (u[0] = h[0]), d && (u[1] = h[1]);
  var p = n.getInterval.call(t), v = u[0], g = u[1];
  if (c && d)
    p = (g - v) / o;
  else if (c)
    for (g = u[0] + p * o; g < u[1] && isFinite(g) && isFinite(u[1]); )
      p = Tb(p), g = u[0] + p * o;
  else if (d)
    for (v = u[1] - p * o; v > u[0] && isFinite(v) && isFinite(u[0]); )
      p = Tb(p), v = u[1] - p * o;
  else {
    var m = t.getTicks().length - 1;
    m > o && (p = Tb(p));
    var y = p * o;
    g = Math.ceil(u[1] / p) * p, v = Or(g - y), v < 0 && u[0] >= 0 ? (v = 0, g = Or(y)) : g > 0 && u[1] <= 0 && (g = 0, v = -Or(y));
  }
  var b = (i[0].value - a[0].value) / s, C = (i[o].value - a[o].value) / s;
  if (n.setExtent.call(t, v + p * b, g + p * C), n.setInterval.call(t, p), (b || C) && n.setNiceExtent.call(t, v + p, g - p), process.env.NODE_ENV !== "production") {
    var w = n.getTicks.call(t);
    w[1] && (!ree(p) || mm(w[1].value) > mm(p)) && Mr(
      // eslint-disable-next-line
      "The ticks may be not readable when set min: " + r.get("min") + ", max: " + r.get("max") + " and alignTicks: true"
    );
  }
}
var one = (
  /** @class */
  function() {
    function t(r, e, n) {
      this.type = "grid", this._coordsMap = {}, this._coordsList = [], this._axesMap = {}, this._axesList = [], this.axisPointerEnabled = !0, this.dimensions = _9, this._initCartesian(r, e, n), this.model = r;
    }
    return t.prototype.getRect = function() {
      return this._rect;
    }, t.prototype.update = function(r, e) {
      var n = this._axesMap;
      this._updateScale(r, this.model);
      function i(o) {
        var s, l = yt(o), u = l.length;
        if (u) {
          for (var c = [], d = u - 1; d >= 0; d--) {
            var f = +l[d], h = o[f], p = h.model, v = h.scale;
            // Only value and log axis without interval support alignTicks.
            p9(v) && p.get("alignTicks") && p.get("interval") == null ? c.push(h) : (zc(v, p), p9(v) && (s = h));
          }
          c.length && (s || (s = c.pop(), zc(s.scale, s.model)), L(c, function(g) {
            QG(g.scale, g.model, s.scale);
          }));
        }
      }
      i(n.x), i(n.y);
      var a = {};
      L(n.x, function(o) {
        aD(n, "y", o, a);
      }), L(n.y, function(o) {
        aD(n, "x", o, a);
      }), this.resize(this.model, e);
    }, t.prototype.resize = function(r, e, n) {
      var i = r.getBoxLayoutParams(), a = !n && r.get("containLabel"), o = cn(i, {
        width: e.getWidth(),
        height: e.getHeight()
      });
      this._rect = o;
      var s = this._axesList;
      l(), a && (L(s, function(u) {
        if (!u.model.get(["axisLabel", "inside"])) {
          var c = Aee(u);
          if (c) {
            var d = u.isHorizontal() ? "height" : "width", f = u.model.get(["axisLabel", "margin"]);
            o[d] -= c[d] + f, u.position === "top" ? o.y += c.height + f : u.position === "left" && (o.x += c.width + f);
          }
        }
      }), l()), L(this._coordsList, function(u) {
        u.calcAffineTransform();
      });
      function l() {
        L(s, function(u) {
          var c = u.isHorizontal(), d = c ? [0, o.width] : [0, o.height], f = u.inverse ? 1 : 0;
          u.setExtent(d[f], d[1 - f]), sne(u, c ? o.x : o.y);
        });
      }
    }, t.prototype.getAxis = function(r, e) {
      var n = this._axesMap[r];
      if (n != null)
        return n[e || 0];
    }, t.prototype.getAxes = function() {
      return this._axesList.slice();
    }, t.prototype.getCartesian = function(r, e) {
      if (r != null && e != null) {
        var n = "x" + r + "y" + e;
        return this._coordsMap[n];
      }
      Me(r) && (e = r.yAxisIndex, r = r.xAxisIndex);
      for (var i = 0, a = this._coordsList; i < a.length; i++)
        if (a[i].getAxis("x").index === r || a[i].getAxis("y").index === e)
          return a[i];
    }, t.prototype.getCartesians = function() {
      return this._coordsList.slice();
    }, t.prototype.convertToPixel = function(r, e, n) {
      var i = this._findConvertTarget(e);
      return i.cartesian ? i.cartesian.dataToPoint(n) : i.axis ? i.axis.toGlobalCoord(i.axis.dataToCoord(n)) : null;
    }, t.prototype.convertFromPixel = function(r, e, n) {
      var i = this._findConvertTarget(e);
      return i.cartesian ? i.cartesian.pointToData(n) : i.axis ? i.axis.coordToData(i.axis.toLocalCoord(n)) : null;
    }, t.prototype._findConvertTarget = function(r) {
      var e = r.seriesModel, n = r.xAxisModel || e && e.getReferringComponents("xAxis", on).models[0], i = r.yAxisModel || e && e.getReferringComponents("yAxis", on).models[0], a = r.gridModel, o = this._coordsList, s, l;
      if (e)
        s = e.coordinateSystem, nt(o, s) < 0 && (s = null);
      else if (n && i)
        s = this.getCartesian(n.componentIndex, i.componentIndex);
      else if (n)
        l = this.getAxis("x", n.componentIndex);
      else if (i)
        l = this.getAxis("y", i.componentIndex);
      else if (a) {
        var u = a.coordinateSystem;
        u === this && (s = this._coordsList[0]);
      }
      return {
        cartesian: s,
        axis: l
      };
    }, t.prototype.containPoint = function(r) {
      var e = this._coordsList[0];
      if (e)
        return e.containPoint(r);
    }, t.prototype._initCartesian = function(r, e, n) {
      var i = this, a = this, o = {
        left: !1,
        right: !1,
        top: !1,
        bottom: !1
      }, s = {
        x: {},
        y: {}
      }, l = {
        x: 0,
        y: 0
      };
      if (e.eachComponent("xAxis", u("x"), this), e.eachComponent("yAxis", u("y"), this), !l.x || !l.y) {
        this._axesMap = {}, this._axesList = [];
        return;
      }
      this._axesMap = s, L(s.x, function(c, d) {
        L(s.y, function(f, h) {
          var p = "x" + d + "y" + h, v = new ine(p);
          v.master = i, v.model = r, i._coordsMap[p] = v, i._coordsList.push(v), v.addAxis(c), v.addAxis(f);
        });
      });
      function u(c) {
        return function(d, f) {
          if (Zb(d, r)) {
            var h = d.get("position");
            c === "x" ? h !== "top" && h !== "bottom" && (h = o.bottom ? "top" : "bottom") : h !== "left" && h !== "right" && (h = o.left ? "right" : "left"), o[h] = !0;
            var p = new ane(c, Cg(d), [0, 0], d.get("type"), h), v = p.type === "category";
            p.onBand = v && d.get("boundaryGap"), p.inverse = d.get("inverse"), d.axis = p, p.model = d, p.grid = a, p.index = f, a._axesList.push(p), s[c][f] = p, l[c]++;
          }
        };
      }
    }, t.prototype._updateScale = function(r, e) {
      L(this._axesList, function(i) {
        if (i.scale.setExtent(1 / 0, -1 / 0), i.type === "category") {
          var a = i.model.get("categorySortInfo");
          i.scale.setSortInfo(a);
        }
      }), r.eachSeries(function(i) {
        if (nD(i)) {
          var a = iD(i), o = a.xAxisModel, s = a.yAxisModel;
          if (!Zb(o, e) || !Zb(s, e))
            return;
          var l = this.getCartesian(o.componentIndex, s.componentIndex), u = i.getData(), c = l.getAxis("x"), d = l.getAxis("y");
          n(u, c), n(u, d);
        }
      }, this);
      function n(i, a) {
        L(Gm(i, a.dim), function(o) {
          a.scale.unionExtentFromData(i, o);
        });
      }
    }, t.prototype.getTooltipAxes = function(r) {
      var e = [], n = [];
      return L(this.getCartesians(), function(i) {
        var a = r != null && r !== "auto" ? i.getAxis(r) : i.getBaseAxis(), o = i.getOtherAxis(a);
        nt(e, a) < 0 && e.push(a), nt(n, o) < 0 && n.push(o);
      }), {
        baseAxes: e,
        otherAxes: n
      };
    }, t.create = function(r, e) {
      var n = [];
      return r.eachComponent("grid", function(i, a) {
        var o = new t(i, r, e);
        o.name = "grid_" + a, o.resize(i, e, !0), i.coordinateSystem = o, n.push(o);
      }), r.eachSeries(function(i) {
        if (nD(i)) {
          var a = iD(i), o = a.xAxisModel, s = a.yAxisModel, l = o.getCoordSysModel();
          if (process.env.NODE_ENV !== "production") {
            if (!l)
              throw new Error('Grid "' + Ki(o.get("gridIndex"), o.get("gridId"), 0) + '" not found');
            if (o.getCoordSysModel() !== s.getCoordSysModel())
              throw new Error("xAxis and yAxis must use the same grid");
          }
          var u = l.coordinateSystem;
          i.coordinateSystem = u.getCartesian(o.componentIndex, s.componentIndex);
        }
      }), n;
    }, t.dimensions = _9, t;
  }()
);
function Zb(t, r) {
  return t.getCoordSysModel() === r;
}
function aD(t, r, e, n) {
  e.getAxesOnZeroOf = function() {
    return a ? [a] : [];
  };
  var i = t[r], a, o = e.model, s = o.get(["axisLine", "onZero"]), l = o.get(["axisLine", "onZeroAxisIndex"]);
  if (!s)
    return;
  if (l != null)
    oD(i[l]) && (a = i[l]);
  else
    for (var u in i)
      if (i.hasOwnProperty(u) && oD(i[u]) && !n[c(i[u])]) {
        a = i[u];
        break;
      }
  a && (n[c(a)] = !0);
  function c(d) {
    return d.dim + "_" + d.index;
  }
}
function oD(t) {
  return t && t.type !== "category" && t.type !== "time" && Iee(t);
}
function sne(t, r) {
  var e = t.getExtent(), n = e[0] + e[1];
  t.toGlobalCoord = t.dim === "x" ? function(i) {
    return i + r;
  } : function(i) {
    return n - i + r;
  }, t.toLocalCoord = t.dim === "x" ? function(i) {
    return i - r;
  } : function(i) {
    return n - i + r;
  };
}
var Ml = Math.PI, wi = (
  /** @class */
  function() {
    function t(r, e) {
      this.group = new ze(), this.opt = e, this.axisModel = r, Ee(e, {
        labelOffset: 0,
        nameDirection: 1,
        tickDirection: 1,
        labelDirection: 1,
        silent: !0,
        handleAutoShown: function() {
          return !0;
        }
      });
      var n = new ze({
        x: e.position[0],
        y: e.position[1],
        rotation: e.rotation
      });
      n.updateTransform(), this._transformGroup = n;
    }
    return t.prototype.hasBuilder = function(r) {
      return !!sD[r];
    }, t.prototype.add = function(r) {
      sD[r](this.opt, this.axisModel, this.group, this._transformGroup);
    }, t.prototype.getGroup = function() {
      return this.group;
    }, t.innerTextLayout = function(r, e, n) {
      var i = L7(e - r), a, o;
      return Af(i) ? (o = n > 0 ? "top" : "bottom", a = "center") : Af(i - Ml) ? (o = n > 0 ? "bottom" : "top", a = "center") : (o = "middle", i > 0 && i < Ml ? a = n > 0 ? "right" : "left" : a = n > 0 ? "left" : "right"), {
        rotation: i,
        textAlign: a,
        textVerticalAlign: o
      };
    }, t.makeAxisEventDataBase = function(r) {
      var e = {
        componentType: r.mainType,
        componentIndex: r.componentIndex
      };
      return e[r.mainType + "Index"] = r.componentIndex, e;
    }, t.isLabelSilent = function(r) {
      var e = r.get("tooltip");
      return r.get("silent") || !(r.get("triggerEvent") || e && e.show);
    }, t;
  }()
), sD = {
  axisLine: function(t, r, e, n) {
    var i = r.get(["axisLine", "show"]);
    if (i === "auto" && t.handleAutoShown && (i = t.handleAutoShown("axisLine")), !!i) {
      var a = r.axis.getExtent(), o = n.transform, s = [a[0], 0], l = [a[1], 0], u = s[0] > l[0];
      o && (En(s, s, o), En(l, l, o));
      var c = ae({
        lineCap: "round"
      }, r.getModel(["axisLine", "lineStyle"]).getLineStyle()), d = new gn({
        shape: {
          x1: s[0],
          y1: s[1],
          x2: l[0],
          y2: l[1]
        },
        style: c,
        strokeContainThreshold: t.strokeContainThreshold || 5,
        silent: !0,
        z2: 1
      });
      Mf(d.shape, d.style.lineWidth), d.anid = "line", e.add(d);
      var f = r.get(["axisLine", "symbol"]);
      if (f != null) {
        var h = r.get(["axisLine", "symbolSize"]);
        pe(f) && (f = [f, f]), (pe(h) || Mt(h)) && (h = [h, h]);
        var p = td(r.get(["axisLine", "symbolOffset"]) || 0, h), v = h[0], g = h[1];
        L([{
          rotate: t.rotation + Math.PI / 2,
          offset: p[0],
          r: 0
        }, {
          rotate: t.rotation - Math.PI / 2,
          offset: p[1],
          r: Math.sqrt((s[0] - l[0]) * (s[0] - l[0]) + (s[1] - l[1]) * (s[1] - l[1]))
        }], function(m, y) {
          if (f[y] !== "none" && f[y] != null) {
            var b = en(f[y], -v / 2, -g / 2, v, g, c.stroke, !0), C = m.r + m.offset, w = u ? l : s;
            b.attr({
              rotation: m.rotate,
              x: w[0] + C * Math.cos(t.rotation),
              y: w[1] - C * Math.sin(t.rotation),
              silent: !0,
              z2: 11
            }), e.add(b);
          }
        });
      }
    }
  },
  axisTickLabel: function(t, r, e, n) {
    var i = cne(e, n, r, t), a = fne(e, n, r, t);
    if (une(r, a, i), dne(e, n, r, t.tickDirection), r.get(["axisLabel", "hideOverlap"])) {
      var o = gG(ce(a, function(s) {
        return {
          label: s,
          priority: s.z2,
          defaultAttr: {
            ignore: s.ignore
          }
        };
      }));
      bG(o);
    }
  },
  axisName: function(t, r, e, n) {
    var i = Qr(t.axisName, r.get("name"));
    if (i) {
      var a = r.get("nameLocation"), o = t.nameDirection, s = r.getModel("nameTextStyle"), l = r.get("nameGap") || 0, u = r.axis.getExtent(), c = u[0] > u[1] ? -1 : 1, d = [
        a === "start" ? u[0] - c * l : a === "end" ? u[1] + c * l : (u[0] + u[1]) / 2,
        // Reuse labelOffset.
        uD(a) ? t.labelOffset + o * l : 0
      ], f, h = r.get("nameRotate");
      h != null && (h = h * Ml / 180);
      var p;
      uD(a) ? f = wi.innerTextLayout(
        t.rotation,
        h ?? t.rotation,
        // Adapt to axis.
        o
      ) : (f = lne(t.rotation, a, h || 0, u), p = t.axisNameAvailableWidth, p != null && (p = Math.abs(p / Math.sin(f.rotation)), !isFinite(p) && (p = null)));
      var v = s.getFont(), g = r.get("nameTruncate", !0) || {}, m = g.ellipsis, y = Qr(t.nameTruncateMaxWidth, g.maxWidth, p), b = new _t({
        x: d[0],
        y: d[1],
        rotation: f.rotation,
        silent: wi.isLabelSilent(r),
        style: fr(s, {
          text: i,
          font: v,
          overflow: "truncate",
          width: y,
          ellipsis: m,
          fill: s.getTextColor() || r.get(["axisLine", "lineStyle", "color"]),
          align: s.get("align") || f.textAlign,
          verticalAlign: s.get("verticalAlign") || f.textVerticalAlign
        }),
        z2: 1
      });
      if (ah({
        el: b,
        componentModel: r,
        itemName: i
      }), b.__fullText = i, b.anid = "name", r.get("triggerEvent")) {
        var C = wi.makeAxisEventDataBase(r);
        C.targetType = "axisName", C.name = i, Ze(b).eventData = C;
      }
      n.add(b), b.updateTransform(), e.add(b), b.decomposeTransform();
    }
  }
};
function lne(t, r, e, n) {
  var i = L7(e - t), a, o, s = n[0] > n[1], l = r === "start" && !s || r !== "start" && s;
  return Af(i - Ml / 2) ? (o = l ? "bottom" : "top", a = "center") : Af(i - Ml * 1.5) ? (o = l ? "top" : "bottom", a = "center") : (o = "middle", i < Ml * 1.5 && i > Ml / 2 ? a = l ? "left" : "right" : a = l ? "right" : "left"), {
    rotation: i,
    textAlign: a,
    textVerticalAlign: o
  };
}
function une(t, r, e) {
  if (!nG(t.axis)) {
    var n = t.get(["axisLabel", "showMinLabel"]), i = t.get(["axisLabel", "showMaxLabel"]);
    r = r || [], e = e || [];
    var a = r[0], o = r[1], s = r[r.length - 1], l = r[r.length - 2], u = e[0], c = e[1], d = e[e.length - 1], f = e[e.length - 2];
    n === !1 ? (ua(a), ua(u)) : lD(a, o) && (n ? (ua(o), ua(c)) : (ua(a), ua(u))), i === !1 ? (ua(s), ua(d)) : lD(l, s) && (i ? (ua(l), ua(f)) : (ua(s), ua(d)));
  }
}
function ua(t) {
  t && (t.ignore = !0);
}
function lD(t, r) {
  var e = t && t.getBoundingRect().clone(), n = r && r.getBoundingRect().clone();
  if (!(!e || !n)) {
    var i = lg([]);
    return hu(i, i, -t.rotation), e.applyTransform(zo([], i, t.getLocalTransform())), n.applyTransform(zo([], i, r.getLocalTransform())), e.intersect(n);
  }
}
function uD(t) {
  return t === "middle" || t === "center";
}
function eB(t, r, e, n, i) {
  for (var a = [], o = [], s = [], l = 0; l < t.length; l++) {
    var u = t[l].coord;
    o[0] = u, o[1] = 0, s[0] = u, s[1] = e, r && (En(o, o, r), En(s, s, r));
    var c = new gn({
      shape: {
        x1: o[0],
        y1: o[1],
        x2: s[0],
        y2: s[1]
      },
      style: n,
      z2: 2,
      autoBatch: !0,
      silent: !0
    });
    Mf(c.shape, c.style.lineWidth), c.anid = i + "_" + t[l].tickValue, a.push(c);
  }
  return a;
}
function cne(t, r, e, n) {
  var i = e.axis, a = e.getModel("axisTick"), o = a.get("show");
  if (o === "auto" && n.handleAutoShown && (o = n.handleAutoShown("axisTick")), !(!o || i.scale.isBlank())) {
    for (var s = a.getModel("lineStyle"), l = n.tickDirection * a.get("length"), u = i.getTicksCoords(), c = eB(u, r.transform, l, Ee(s.getLineStyle(), {
      stroke: e.get(["axisLine", "lineStyle", "color"])
    }), "ticks"), d = 0; d < c.length; d++)
      t.add(c[d]);
    return c;
  }
}
function dne(t, r, e, n) {
  var i = e.axis, a = e.getModel("minorTick");
  if (!(!a.get("show") || i.scale.isBlank())) {
    var o = i.getMinorTicksCoords();
    if (o.length)
      for (var s = a.getModel("lineStyle"), l = n * a.get("length"), u = Ee(s.getLineStyle(), Ee(e.getModel("axisTick").getLineStyle(), {
        stroke: e.get(["axisLine", "lineStyle", "color"])
      })), c = 0; c < o.length; c++)
        for (var d = eB(o[c], r.transform, l, u, "minorticks_" + c), f = 0; f < d.length; f++)
          t.add(d[f]);
  }
}
function fne(t, r, e, n) {
  var i = e.axis, a = Qr(n.axisLabelShow, e.get(["axisLabel", "show"]));
  if (!(!a || i.scale.isBlank())) {
    var o = e.getModel("axisLabel"), s = o.get("margin"), l = i.getViewLabels(), u = (Qr(n.labelRotate, o.get("rotate")) || 0) * Ml / 180, c = wi.innerTextLayout(n.rotation, u, n.labelDirection), d = e.getCategories && e.getCategories(!0), f = [], h = wi.isLabelSilent(e), p = e.get("triggerEvent");
    return L(l, function(v, g) {
      var m = i.scale.type === "ordinal" ? i.scale.getRawOrdinalNumber(v.tickValue) : v.tickValue, y = v.formattedLabel, b = v.rawLabel, C = o;
      if (d && d[m]) {
        var w = d[m];
        Me(w) && w.textStyle && (C = new Pt(w.textStyle, o, e.ecModel));
      }
      var _ = C.getTextColor() || e.get(["axisLine", "lineStyle", "color"]), x = i.dataToCoord(m), I = C.getShallow("align", !0) || c.textAlign, D = je(C.getShallow("alignMinLabel", !0), I), T = je(C.getShallow("alignMaxLabel", !0), I), A = C.getShallow("verticalAlign", !0) || C.getShallow("baseline", !0) || c.textVerticalAlign, M = je(C.getShallow("verticalAlignMinLabel", !0), A), R = je(C.getShallow("verticalAlignMaxLabel", !0), A), E = new _t({
        x,
        y: n.labelOffset + n.labelDirection * s,
        rotation: c.rotation,
        silent: h,
        z2: 10 + (v.level || 0),
        style: fr(C, {
          text: y,
          align: g === 0 ? D : g === l.length - 1 ? T : I,
          verticalAlign: g === 0 ? M : g === l.length - 1 ? R : A,
          fill: Ae(_) ? _(
            // (1) In category axis with data zoom, tick is not the original
            // index of axis.data. So tick should not be exposed to user
            // in category axis.
            // (2) Compatible with previous version, which always use formatted label as
            // input. But in interval scale the formatted label is like '223,445', which
            // maked user replace ','. So we modify it to return original val but remain
            // it as 'string' to avoid error in replacing.
            i.type === "category" ? b : i.type === "value" ? m + "" : m,
            g
          ) : _
        })
      });
      if (E.anid = "label_" + m, p) {
        var k = wi.makeAxisEventDataBase(e);
        k.targetType = "axisLabel", k.value = b, k.tickIndex = g, i.type === "category" && (k.dataIndex = m), Ze(E).eventData = k;
      }
      r.add(E), E.updateTransform(), f.push(E), t.add(E), E.decomposeTransform();
    }), f;
  }
}
function hne(t, r) {
  var e = {
    /**
     * key: makeKey(axis.model)
     * value: {
     *      axis,
     *      coordSys,
     *      axisPointerModel,
     *      triggerTooltip,
     *      triggerEmphasis,
     *      involveSeries,
     *      snap,
     *      seriesModels,
     *      seriesDataCount
     * }
     */
    axesInfo: {},
    seriesInvolved: !1,
    /**
     * key: makeKey(coordSys.model)
     * value: Object: key makeKey(axis.model), value: axisInfo
     */
    coordSysAxesInfo: {},
    coordSysMap: {}
  };
  return pne(e, t, r), e.seriesInvolved && gne(e, t), e;
}
function pne(t, r, e) {
  var n = r.getComponent("tooltip"), i = r.getComponent("axisPointer"), a = i.get("link", !0) || [], o = [];
  L(e.getCoordinateSystems(), function(s) {
    if (!s.axisPointerEnabled)
      return;
    var l = Ev(s.model), u = t.coordSysAxesInfo[l] = {};
    t.coordSysMap[l] = s;
    var c = s.model, d = c.getModel("tooltip", n);
    if (L(s.getAxes(), Ye(v, !1, null)), s.getTooltipAxes && n && d.get("show")) {
      var f = d.get("trigger") === "axis", h = d.get(["axisPointer", "type"]) === "cross", p = s.getTooltipAxes(d.get(["axisPointer", "axis"]));
      (f || h) && L(p.baseAxes, Ye(v, h ? "cross" : !0, f)), h && L(p.otherAxes, Ye(v, "cross", !1));
    }
    function v(g, m, y) {
      var b = y.model.getModel("axisPointer", i), C = b.get("show");
      if (!(!C || C === "auto" && !g && !S9(b))) {
        m == null && (m = b.get("triggerTooltip")), b = g ? vne(y, d, i, r, g, m) : b;
        var w = b.get("snap"), _ = b.get("triggerEmphasis"), x = Ev(y.model), I = m || w || y.type === "category", D = t.axesInfo[x] = {
          key: x,
          axis: y,
          coordSys: s,
          axisPointerModel: b,
          triggerTooltip: m,
          triggerEmphasis: _,
          involveSeries: I,
          snap: w,
          useHandle: S9(b),
          seriesModels: [],
          linkGroup: null
        };
        u[x] = D, t.seriesInvolved = t.seriesInvolved || I;
        var T = mne(a, y);
        if (T != null) {
          var A = o[T] || (o[T] = {
            axesInfo: {}
          });
          A.axesInfo[x] = D, A.mapper = a[T].mapper, D.linkGroup = A;
        }
      }
    }
  });
}
function vne(t, r, e, n, i, a) {
  var o = r.getModel("axisPointer"), s = ["type", "snap", "lineStyle", "shadowStyle", "label", "animation", "animationDurationUpdate", "animationEasingUpdate", "z"], l = {};
  L(s, function(f) {
    l[f] = Ge(o.get(f));
  }), l.snap = t.type !== "category" && !!a, o.get("type") === "cross" && (l.type = "line");
  var u = l.label || (l.label = {});
  if (u.show == null && (u.show = !1), i === "cross") {
    var c = o.get(["label", "show"]);
    if (u.show = c ?? !0, !a) {
      var d = l.lineStyle = o.get("crossStyle");
      d && Ee(u, d.textStyle);
    }
  }
  return t.model.getModel("axisPointer", new Pt(l, e, n));
}
function gne(t, r) {
  r.eachSeries(function(e) {
    var n = e.coordinateSystem, i = e.get(["tooltip", "trigger"], !0), a = e.get(["tooltip", "show"], !0);
    !n || i === "none" || i === !1 || i === "item" || a === !1 || e.get(["axisPointer", "show"], !0) === !1 || L(t.coordSysAxesInfo[Ev(n.model)], function(o) {
      var s = o.axis;
      n.getAxis(s.dim) === s && (o.seriesModels.push(e), o.seriesDataCount == null && (o.seriesDataCount = 0), o.seriesDataCount += e.getData().count());
    });
  });
}
function mne(t, r) {
  for (var e = r.model, n = r.dim, i = 0; i < t.length; i++) {
    var a = t[i] || {};
    if (jb(a[n + "AxisId"], e.id) || jb(a[n + "AxisIndex"], e.componentIndex) || jb(a[n + "AxisName"], e.name))
      return i;
  }
}
function jb(t, r) {
  return t === "all" || ue(t) && nt(t, r) >= 0 || t === r;
}
function yne(t) {
  var r = zw(t);
  if (r) {
    var e = r.axisPointerModel, n = r.axis.scale, i = e.option, a = e.get("status"), o = e.get("value");
    o != null && (o = n.parse(o));
    var s = S9(e);
    a == null && (i.status = s ? "show" : "hide");
    var l = n.getExtent().slice();
    l[0] > l[1] && l.reverse(), // Pick a value on axis when initializing.
    (o == null || o > l[1]) && (o = l[1]), o < l[0] && (o = l[0]), i.value = o, s && (i.status = r.axis.scale.isBlank() ? "hide" : "show");
  }
}
function zw(t) {
  var r = (t.ecModel.getComponent("axisPointer") || {}).coordSysAxesInfo;
  return r && r.axesInfo[Ev(t)];
}
function bne(t) {
  var r = zw(t);
  return r && r.axisPointerModel;
}
function S9(t) {
  return !!t.get(["handle", "show"]);
}
function Ev(t) {
  return t.type + "||" + t.id;
}
var Yb = {}, nd = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.render = function(e, n, i, a) {
      this.axisPointerClass && yne(e), t.prototype.render.apply(this, arguments), this._doUpdateAxisPointerClass(e, i, !0);
    }, r.prototype.updateAxisPointer = function(e, n, i, a) {
      this._doUpdateAxisPointerClass(e, i, !1);
    }, r.prototype.remove = function(e, n) {
      var i = this._axisPointer;
      i && i.remove(n);
    }, r.prototype.dispose = function(e, n) {
      this._disposeAxisPointer(n), t.prototype.dispose.apply(this, arguments);
    }, r.prototype._doUpdateAxisPointerClass = function(e, n, i) {
      var a = r.getAxisPointerClass(this.axisPointerClass);
      if (a) {
        var o = bne(e);
        o ? (this._axisPointer || (this._axisPointer = new a())).render(e, o, n, i) : this._disposeAxisPointer(n);
      }
    }, r.prototype._disposeAxisPointer = function(e) {
      this._axisPointer && this._axisPointer.dispose(e), this._axisPointer = null;
    }, r.registerAxisPointerClass = function(e, n) {
      if (process.env.NODE_ENV !== "production" && Yb[e])
        throw new Error("axisPointer " + e + " exists");
      Yb[e] = n;
    }, r.getAxisPointerClass = function(e) {
      return e && Yb[e];
    }, r.type = "axis", r;
  }(yr)
), I9 = It();
function tB(t, r, e, n) {
  var i = e.axis;
  if (!i.scale.isBlank()) {
    var a = e.getModel("splitArea"), o = a.getModel("areaStyle"), s = o.get("color"), l = n.coordinateSystem.getRect(), u = i.getTicksCoords({
      tickModel: a,
      clamp: !0
    });
    if (u.length) {
      var c = s.length, d = I9(t).splitAreaColors, f = xe(), h = 0;
      if (d)
        for (var p = 0; p < u.length; p++) {
          var v = d.get(u[p].tickValue);
          if (v != null) {
            h = (v + (c - 1) * p) % c;
            break;
          }
        }
      var g = i.toGlobalCoord(u[0].coord), m = o.getAreaStyle();
      s = ue(s) ? s : [s];
      for (var p = 1; p < u.length; p++) {
        var y = i.toGlobalCoord(u[p].coord), b = void 0, C = void 0, w = void 0, _ = void 0;
        i.isHorizontal() ? (b = g, C = l.y, w = y - b, _ = l.height, g = b + w) : (b = l.x, C = g, w = l.width, _ = y - C, g = C + _);
        var x = u[p - 1].tickValue;
        x != null && f.set(x, h), r.add(new xt({
          anid: x != null ? "area_" + x : null,
          shape: {
            x: b,
            y: C,
            width: w,
            height: _
          },
          style: Ee({
            fill: s[h]
          }, m),
          autoBatch: !0,
          silent: !0
        })), h = (h + 1) % c;
      }
      I9(t).splitAreaColors = f;
    }
  }
}
function rB(t) {
  I9(t).splitAreaColors = null;
}
var Cne = ["axisLine", "axisTickLabel", "axisName"], wne = ["splitArea", "splitLine", "minorSplitLine"], nB = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e.axisPointerClass = "CartesianAxisPointer", e;
    }
    return r.prototype.render = function(e, n, i, a) {
      this.group.removeAll();
      var o = this._axisGroup;
      if (this._axisGroup = new ze(), this.group.add(this._axisGroup), !!e.get("show")) {
        var s = e.getCoordSysModel(), l = x9(s, e), u = new wi(e, ae({
          handleAutoShown: function(d) {
            for (var f = s.coordinateSystem.getCartesians(), h = 0; h < f.length; h++)
              if (p9(f[h].getOtherAxis(e.axis).scale))
                return !0;
            return !1;
          }
        }, l));
        L(Cne, u.add, u), this._axisGroup.add(u.getGroup()), L(wne, function(d) {
          e.get([d, "show"]) && _ne[d](this, this._axisGroup, e, s);
        }, this);
        var c = a && a.type === "changeAxisOrder" && a.isInitSort;
        c || mg(o, this._axisGroup, e), t.prototype.render.call(this, e, n, i, a);
      }
    }, r.prototype.remove = function() {
      rB(this);
    }, r.type = "cartesianAxis", r;
  }(nd)
), _ne = {
  splitLine: function(t, r, e, n) {
    var i = e.axis;
    if (!i.scale.isBlank()) {
      var a = e.getModel("splitLine"), o = a.getModel("lineStyle"), s = o.get("color");
      s = ue(s) ? s : [s];
      for (var l = n.coordinateSystem.getRect(), u = i.isHorizontal(), c = 0, d = i.getTicksCoords({
        tickModel: a
      }), f = [], h = [], p = o.getLineStyle(), v = 0; v < d.length; v++) {
        var g = i.toGlobalCoord(d[v].coord);
        u ? (f[0] = g, f[1] = l.y, h[0] = g, h[1] = l.y + l.height) : (f[0] = l.x, f[1] = g, h[0] = l.x + l.width, h[1] = g);
        var m = c++ % s.length, y = d[v].tickValue, b = new gn({
          anid: y != null ? "line_" + d[v].tickValue : null,
          autoBatch: !0,
          shape: {
            x1: f[0],
            y1: f[1],
            x2: h[0],
            y2: h[1]
          },
          style: Ee({
            stroke: s[m]
          }, p),
          silent: !0
        });
        Mf(b.shape, p.lineWidth), r.add(b);
      }
    }
  },
  minorSplitLine: function(t, r, e, n) {
    var i = e.axis, a = e.getModel("minorSplitLine"), o = a.getModel("lineStyle"), s = n.coordinateSystem.getRect(), l = i.isHorizontal(), u = i.getMinorTicksCoords();
    if (u.length)
      for (var c = [], d = [], f = o.getLineStyle(), h = 0; h < u.length; h++)
        for (var p = 0; p < u[h].length; p++) {
          var v = i.toGlobalCoord(u[h][p].coord);
          l ? (c[0] = v, c[1] = s.y, d[0] = v, d[1] = s.y + s.height) : (c[0] = s.x, c[1] = v, d[0] = s.x + s.width, d[1] = v);
          var g = new gn({
            anid: "minor_line_" + u[h][p].tickValue,
            autoBatch: !0,
            shape: {
              x1: c[0],
              y1: c[1],
              x2: d[0],
              y2: d[1]
            },
            style: f,
            silent: !0
          });
          Mf(g.shape, f.lineWidth), r.add(g);
        }
  },
  splitArea: function(t, r, e, n) {
    tB(t, r, e, n);
  }
}, iB = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.type = "xAxis", r;
  }(nB)
), xne = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = iB.type, e;
    }
    return r.type = "yAxis", r;
  }(nB)
), Sne = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = "grid", e;
    }
    return r.prototype.render = function(e, n) {
      this.group.removeAll(), e.get("show") && this.group.add(new xt({
        shape: e.coordinateSystem.getRect(),
        style: Ee({
          fill: e.get("backgroundColor")
        }, e.getItemStyle()),
        silent: !0,
        z2: -1
      }));
    }, r.type = "grid", r;
  }(yr)
), cD = {
  // gridIndex: 0,
  // gridId: '',
  offset: 0
};
function aB(t) {
  t.registerComponentView(Sne), t.registerComponentModel(qre), t.registerCoordinateSystem("cartesian2d", one), kf(t, "x", w9, cD), kf(t, "y", w9, cD), t.registerComponentView(iB), t.registerComponentView(xne), t.registerPreprocessor(function(r) {
    r.xAxis && r.yAxis && !r.grid && (r.grid = {});
  });
}
function Ine(t) {
  lt(aB), t.registerSeriesModel(Xre), t.registerChartView(Kre), t.registerLayout(Sg("scatter"));
}
function Ane(t) {
  t.eachSeriesByType("radar", function(r) {
    var e = r.getData(), n = [], i = r.coordinateSystem;
    if (i) {
      var a = i.getIndicatorAxes();
      L(a, function(o, s) {
        e.each(e.mapDimension(a[s].dim), function(l, u) {
          n[u] = n[u] || [];
          var c = i.dataToPoint(l, s);
          n[u][s] = dD(c) ? c : fD(i);
        });
      }), e.each(function(o) {
        var s = VP(n[o], function(l) {
          return dD(l);
        }) || fD(i);
        n[o].push(s.slice()), e.setItemLayout(o, n[o]);
      });
    }
  });
}
function dD(t) {
  return !isNaN(t[0]) && !isNaN(t[1]);
}
function fD(t) {
  return [t.cx, t.cy];
}
function Dne(t) {
  var r = t.polar;
  if (r) {
    ue(r) || (r = [r]);
    var e = [];
    L(r, function(n, i) {
      n.indicator ? (n.type && !n.shape && (n.shape = n.type), t.radar = t.radar || [], ue(t.radar) || (t.radar = [t.radar]), t.radar.push(n)) : e.push(n);
    }), t.polar = e;
  }
  L(t.series, function(n) {
    n && n.type === "radar" && n.polarIndex && (n.radarIndex = n.polarIndex);
  });
}
var Tne = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.render = function(e, n, i) {
      var a = e.coordinateSystem, o = this.group, s = e.getData(), l = this._data;
      function u(f, h) {
        var p = f.getItemVisual(h, "symbol") || "circle";
        if (p !== "none") {
          var v = fh(f.getItemVisual(h, "symbolSize")), g = en(p, -1, -1, 2, 2), m = f.getItemVisual(h, "symbolRotate") || 0;
          return g.attr({
            style: {
              strokeNoScale: !0
            },
            z2: 100,
            scaleX: v[0] / 2,
            scaleY: v[1] / 2,
            rotation: m * Math.PI / 180 || 0
          }), g;
        }
      }
      function c(f, h, p, v, g, m) {
        p.removeAll();
        for (var y = 0; y < h.length - 1; y++) {
          var b = u(v, g);
          b && (b.__dimIdx = y, f[y] ? (b.setPosition(f[y]), qc[m ? "initProps" : "updateProps"](b, {
            x: h[y][0],
            y: h[y][1]
          }, e, g)) : b.setPosition(h[y]), p.add(b));
        }
      }
      function d(f) {
        return ce(f, function(h) {
          return [a.cx, a.cy];
        });
      }
      s.diff(l).add(function(f) {
        var h = s.getItemLayout(f);
        if (h) {
          var p = new si(), v = new ci(), g = {
            shape: {
              points: h
            }
          };
          p.shape.points = d(h), v.shape.points = d(h), Cr(p, g, e, f), Cr(v, g, e, f);
          var m = new ze(), y = new ze();
          m.add(v), m.add(p), m.add(y), c(v.shape.points, h, y, s, f, !0), s.setItemGraphicEl(f, m);
        }
      }).update(function(f, h) {
        var p = l.getItemGraphicEl(h), v = p.childAt(0), g = p.childAt(1), m = p.childAt(2), y = {
          shape: {
            points: s.getItemLayout(f)
          }
        };
        y.shape.points && (c(v.shape.points, y.shape.points, m, s, f, !1), ro(g), ro(v), kt(v, y, e), kt(g, y, e), s.setItemGraphicEl(f, p));
      }).remove(function(f) {
        o.remove(l.getItemGraphicEl(f));
      }).execute(), s.eachItemGraphicEl(function(f, h) {
        var p = s.getItemModel(h), v = f.childAt(0), g = f.childAt(1), m = f.childAt(2), y = s.getItemVisual(h, "style"), b = y.fill;
        o.add(f), v.useStyle(Ee(p.getModel("lineStyle").getLineStyle(), {
          fill: "none",
          stroke: b
        })), Yn(v, p, "lineStyle"), Yn(g, p, "areaStyle");
        var C = p.getModel("areaStyle"), w = C.isEmpty() && C.parentModel.isEmpty();
        g.ignore = w, L(["emphasis", "select", "blur"], function(I) {
          var D = p.getModel([I, "areaStyle"]), T = D.isEmpty() && D.parentModel.isEmpty();
          g.ensureState(I).ignore = T && w;
        }), g.useStyle(Ee(C.getAreaStyle(), {
          fill: b,
          opacity: 0.7,
          decal: y.decal
        }));
        var _ = p.getModel("emphasis"), x = _.getModel("itemStyle").getItemStyle();
        m.eachChild(function(I) {
          if (I instanceof An) {
            var D = I.style;
            I.useStyle(ae({
              // TODO other properties like x, y ?
              image: D.image,
              x: D.x,
              y: D.y,
              width: D.width,
              height: D.height
            }, y));
          } else
            I.useStyle(y), I.setColor(b), I.style.strokeNoScale = !0;
          var T = I.ensureState("emphasis");
          T.style = Ge(x);
          var A = s.getStore().get(s.getDimensionIndex(I.__dimIdx), h);
          (A == null || isNaN(A)) && (A = ""), Xn(I, xn(p), {
            labelFetcher: s.hostModel,
            labelDataIndex: h,
            labelDimIndex: I.__dimIdx,
            defaultText: A,
            inheritColor: b,
            defaultOpacity: y.opacity
          });
        }), Vr(f, _.get("focus"), _.get("blurScope"), _.get("disabled"));
      }), this._data = s;
    }, r.prototype.remove = function() {
      this.group.removeAll(), this._data = null;
    }, r.type = "radar", r;
  }(Yt)
), Mne = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e.hasSymbolVisual = !0, e;
    }
    return r.prototype.init = function(e) {
      t.prototype.init.apply(this, arguments), this.legendVisualProvider = new Ag(ye(this.getData, this), ye(this.getRawData, this));
    }, r.prototype.getInitialData = function(e, n) {
      return gh(this, {
        generateCoord: "indicator_",
        generateCoordCount: 1 / 0
      });
    }, r.prototype.formatTooltip = function(e, n, i) {
      var a = this.getData(), o = this.coordinateSystem, s = o.getIndicatorAxes(), l = this.getData().getName(e), u = l === "" ? this.name : l, c = rV(this, e);
      return Sn("section", {
        header: u,
        sortBlocks: !0,
        blocks: ce(s, function(d) {
          var f = a.get(a.mapDimension(d.dim), e);
          return Sn("nameValue", {
            markerType: "subItem",
            markerColor: c,
            name: d.name,
            value: f,
            sortParam: f
          });
        })
      });
    }, r.prototype.getTooltipPosition = function(e) {
      if (e != null) {
        for (var n = this.getData(), i = this.coordinateSystem, a = n.getValues(ce(i.dimensions, function(u) {
          return n.mapDimension(u);
        }), e), o = 0, s = a.length; o < s; o++)
          if (!isNaN(a[o])) {
            var l = i.getIndicatorAxes();
            return i.coordToPoint(l[o].dataToCoord(a[o]), o);
          }
      }
    }, r.type = "series.radar", r.dependencies = ["radar"], r.defaultOption = {
      // zlevel: 0,
      z: 2,
      colorBy: "data",
      coordinateSystem: "radar",
      legendHoverLink: !0,
      radarIndex: 0,
      lineStyle: {
        width: 2,
        type: "solid",
        join: "round"
      },
      label: {
        position: "top"
      },
      // areaStyle: {
      // },
      // itemStyle: {}
      symbolSize: 8
      // symbolRotate: null
    }, r;
  }(tr)
), qh = qG.value;
function O1(t, r) {
  return Ee({
    show: r
  }, t);
}
var Rne = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.optionUpdated = function() {
      var e = this.get("boundaryGap"), n = this.get("splitNumber"), i = this.get("scale"), a = this.get("axisLine"), o = this.get("axisTick"), s = this.get("axisLabel"), l = this.get("axisName"), u = this.get(["axisName", "show"]), c = this.get(["axisName", "formatter"]), d = this.get("axisNameGap"), f = this.get("triggerEvent"), h = ce(this.get("indicator") || [], function(p) {
        p.max != null && p.max > 0 && !p.min ? p.min = 0 : p.min != null && p.min < 0 && !p.max && (p.max = 0);
        var v = l;
        p.color != null && (v = Ee({
          color: p.color
        }, l));
        var g = Qe(Ge(p), {
          boundaryGap: e,
          splitNumber: n,
          scale: i,
          axisLine: a,
          axisTick: o,
          // axisType: axisType,
          axisLabel: s,
          // Compatible with 2 and use text
          name: p.text,
          showName: u,
          nameLocation: "end",
          nameGap: d,
          // min: 0,
          nameTextStyle: v,
          triggerEvent: f
        }, !1);
        if (pe(c)) {
          var m = g.name;
          g.name = c.replace("{value}", m ?? "");
        } else Ae(c) && (g.name = c(g.name, g));
        var y = new Pt(g, null, this.ecModel);
        return Xr(y, vh.prototype), y.mainType = "radar", y.componentIndex = this.componentIndex, y;
      }, this);
      this._indicatorModels = h;
    }, r.prototype.getIndicatorModels = function() {
      return this._indicatorModels;
    }, r.type = "radar", r.defaultOption = {
      // zlevel: 0,
      z: 0,
      center: ["50%", "50%"],
      radius: "75%",
      startAngle: 90,
      axisName: {
        show: !0
        // formatter: null
        // textStyle: {}
      },
      boundaryGap: [0, 0],
      splitNumber: 5,
      axisNameGap: 15,
      scale: !1,
      // Polygon or circle
      shape: "polygon",
      axisLine: Qe({
        lineStyle: {
          color: "#bbb"
        }
      }, qh.axisLine),
      axisLabel: O1(qh.axisLabel, !1),
      axisTick: O1(qh.axisTick, !1),
      // axisType: 'value',
      splitLine: O1(qh.splitLine, !0),
      splitArea: O1(qh.splitArea, !0),
      // {text, min, max}
      indicator: []
    }, r;
  }(st)
), Lne = ["axisLine", "axisTickLabel", "axisName"], Ene = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.render = function(e, n, i) {
      var a = this.group;
      a.removeAll(), this._buildAxes(e), this._buildSplitLineAndArea(e);
    }, r.prototype._buildAxes = function(e) {
      var n = e.coordinateSystem, i = n.getIndicatorAxes(), a = ce(i, function(o) {
        var s = o.model.get("showName") ? o.name : "", l = new wi(o.model, {
          axisName: s,
          position: [n.cx, n.cy],
          rotation: o.angle,
          labelDirection: -1,
          tickDirection: -1,
          nameDirection: 1
        });
        return l;
      });
      L(a, function(o) {
        L(Lne, o.add, o), this.group.add(o.getGroup());
      }, this);
    }, r.prototype._buildSplitLineAndArea = function(e) {
      var n = e.coordinateSystem, i = n.getIndicatorAxes();
      if (!i.length)
        return;
      var a = e.get("shape"), o = e.getModel("splitLine"), s = e.getModel("splitArea"), l = o.getModel("lineStyle"), u = s.getModel("areaStyle"), c = o.get("show"), d = s.get("show"), f = l.get("color"), h = u.get("color"), p = ue(f) ? f : [f], v = ue(h) ? h : [h], g = [], m = [];
      function y(k, P, N) {
        var O = N % P.length;
        return k[O] = k[O] || [], O;
      }
      if (a === "circle")
        for (var b = i[0].getTicksCoords(), C = n.cx, w = n.cy, _ = 0; _ < b.length; _++) {
          if (c) {
            var x = y(g, p, _);
            g[x].push(new is({
              shape: {
                cx: C,
                cy: w,
                r: b[_].coord
              }
            }));
          }
          if (d && _ < b.length - 1) {
            var x = y(m, v, _);
            m[x].push(new eh({
              shape: {
                cx: C,
                cy: w,
                r0: b[_].coord,
                r: b[_ + 1].coord
              }
            }));
          }
        }
      else
        for (var I, D = ce(i, function(k, P) {
          var N = k.getTicksCoords();
          return I = I == null ? N.length - 1 : Math.min(N.length - 1, I), ce(N, function(O) {
            return n.coordToPoint(O.coord, P);
          });
        }), T = [], _ = 0; _ <= I; _++) {
          for (var A = [], M = 0; M < i.length; M++)
            A.push(D[M][_]);
          if (A[0] ? A.push(A[0].slice()) : process.env.NODE_ENV !== "production" && console.error("Can't draw value axis " + _), c) {
            var x = y(g, p, _);
            g[x].push(new ci({
              shape: {
                points: A
              }
            }));
          }
          if (d && T) {
            var x = y(m, v, _ - 1);
            m[x].push(new si({
              shape: {
                points: A.concat(T)
              }
            }));
          }
          T = A.slice().reverse();
        }
      var R = l.getLineStyle(), E = u.getAreaStyle();
      L(m, function(k, P) {
        this.group.add(Yi(k, {
          style: Ee({
            stroke: "none",
            fill: v[P % v.length]
          }, E),
          silent: !0
        }));
      }, this), L(g, function(k, P) {
        this.group.add(Yi(k, {
          style: Ee({
            fill: "none",
            stroke: p[P % p.length]
          }, R),
          silent: !0
        }));
      }, this);
    }, r.type = "radar", r;
  }(yr)
), kne = (
  /** @class */
  function(t) {
    ee(r, t);
    function r(e, n, i) {
      var a = t.call(this, e, n, i) || this;
      return a.type = "value", a.angle = 0, a.name = "", a;
    }
    return r;
  }(Va)
), Pne = (
  /** @class */
  function() {
    function t(r, e, n) {
      this.dimensions = [], this._model = r, this._indicatorAxes = ce(r.getIndicatorModels(), function(i, a) {
        var o = "indicator_" + a, s = new kne(
          o,
          new Ks()
          // (indicatorModel.get('axisType') === 'log') ? new LogScale() : new IntervalScale()
        );
        return s.name = i.get("name"), s.model = i, i.axis = s, this.dimensions.push(o), s;
      }, this), this.resize(r, n);
    }
    return t.prototype.getIndicatorAxes = function() {
      return this._indicatorAxes;
    }, t.prototype.dataToPoint = function(r, e) {
      var n = this._indicatorAxes[e];
      return this.coordToPoint(n.dataToCoord(r), e);
    }, t.prototype.coordToPoint = function(r, e) {
      var n = this._indicatorAxes[e], i = n.angle, a = this.cx + r * Math.cos(i), o = this.cy - r * Math.sin(i);
      return [a, o];
    }, t.prototype.pointToData = function(r) {
      var e = r[0] - this.cx, n = r[1] - this.cy, i = Math.sqrt(e * e + n * n);
      e /= i, n /= i;
      for (var a = Math.atan2(-n, e), o = 1 / 0, s, l = -1, u = 0; u < this._indicatorAxes.length; u++) {
        var c = this._indicatorAxes[u], d = Math.abs(a - c.angle);
        d < o && (s = c, l = u, o = d);
      }
      return [l, +(s && s.coordToData(i))];
    }, t.prototype.resize = function(r, e) {
      var n = r.get("center"), i = e.getWidth(), a = e.getHeight(), o = Math.min(i, a) / 2;
      this.cx = he(n[0], i), this.cy = he(n[1], a), this.startAngle = r.get("startAngle") * Math.PI / 180;
      var s = r.get("radius");
      (pe(s) || Mt(s)) && (s = [0, s]), this.r0 = he(s[0], o), this.r = he(s[1], o), L(this._indicatorAxes, function(l, u) {
        l.setExtent(this.r0, this.r);
        var c = this.startAngle + u * Math.PI * 2 / this._indicatorAxes.length;
        c = Math.atan2(Math.sin(c), Math.cos(c)), l.angle = c;
      }, this);
    }, t.prototype.update = function(r, e) {
      var n = this._indicatorAxes, i = this._model;
      L(n, function(s) {
        s.scale.setExtent(1 / 0, -1 / 0);
      }), r.eachSeriesByType("radar", function(s, l) {
        if (!(s.get("coordinateSystem") !== "radar" || r.getComponent("radar", s.get("radarIndex")) !== i)) {
          var u = s.getData();
          L(n, function(c) {
            c.scale.unionExtentFromData(u, u.mapDimension(c.dim));
          });
        }
      }, this);
      var a = i.get("splitNumber"), o = new Ks();
      o.setExtent(0, a), o.setInterval(1), L(n, function(s, l) {
        QG(s.scale, s.model, o);
      });
    }, t.prototype.convertToPixel = function(r, e, n) {
      return console.warn("Not implemented."), null;
    }, t.prototype.convertFromPixel = function(r, e, n) {
      return console.warn("Not implemented."), null;
    }, t.prototype.containPoint = function(r) {
      return console.warn("Not implemented."), !1;
    }, t.create = function(r, e) {
      var n = [];
      return r.eachComponent("radar", function(i) {
        var a = new t(i, r, e);
        n.push(a), i.coordinateSystem = a;
      }), r.eachSeriesByType("radar", function(i) {
        i.get("coordinateSystem") === "radar" && (i.coordinateSystem = n[i.get("radarIndex") || 0]);
      }), n;
    }, t.dimensions = [], t;
  }()
);
function Nne(t) {
  t.registerCoordinateSystem("radar", Pne), t.registerComponentModel(Rne), t.registerComponentView(Ene), t.registerVisual({
    seriesType: "radar",
    reset: function(r) {
      var e = r.getData();
      e.each(function(n) {
        e.setItemVisual(n, "legendIcon", "roundRect");
      }), e.setVisual("legendIcon", "roundRect");
    }
  });
}
function One(t) {
  lt(Nne), t.registerChartView(Tne), t.registerSeriesModel(Mne), t.registerLayout(Ane), t.registerProcessor(Ig("radar")), t.registerPreprocessor(Dne);
}
var hD = "\0_ec_interaction_mutex";
function Vne(t, r, e) {
  var n = Ww(t);
  n[r] = e;
}
function Gne(t, r, e) {
  var n = Ww(t), i = n[r];
  i === e && (n[r] = null);
}
function pD(t, r) {
  return !!Ww(t)[r];
}
function Ww(t) {
  return t[hD] || (t[hD] = {});
}
co({
  type: "takeGlobalCursor",
  event: "globalCursorTaken",
  update: "update"
}, Yr);
var Dg = (
  /** @class */
  function(t) {
    ee(r, t);
    function r(e) {
      var n = t.call(this) || this;
      n._zr = e;
      var i = ye(n._mousedownHandler, n), a = ye(n._mousemoveHandler, n), o = ye(n._mouseupHandler, n), s = ye(n._mousewheelHandler, n), l = ye(n._pinchHandler, n);
      return n.enable = function(u, c) {
        this.disable(), this._opt = Ee(Ge(c) || {}, {
          zoomOnMouseWheel: !0,
          moveOnMouseMove: !0,
          // By default, wheel do not trigger move.
          moveOnMouseWheel: !1,
          preventDefaultMouseMove: !0
        }), u == null && (u = !0), (u === !0 || u === "move" || u === "pan") && (e.on("mousedown", i), e.on("mousemove", a), e.on("mouseup", o)), (u === !0 || u === "scale" || u === "zoom") && (e.on("mousewheel", s), e.on("pinch", l));
      }, n.disable = function() {
        e.off("mousedown", i), e.off("mousemove", a), e.off("mouseup", o), e.off("mousewheel", s), e.off("pinch", l);
      }, n;
    }
    return r.prototype.isDragging = function() {
      return this._dragging;
    }, r.prototype.isPinching = function() {
      return this._pinching;
    }, r.prototype.setPointerChecker = function(e) {
      this.pointerChecker = e;
    }, r.prototype.dispose = function() {
      this.disable();
    }, r.prototype._mousedownHandler = function(e) {
      if (!z8(e)) {
        for (var n = e.target; n; ) {
          if (n.draggable)
            return;
          n = n.__hostTarget || n.parent;
        }
        var i = e.offsetX, a = e.offsetY;
        this.pointerChecker && this.pointerChecker(e, i, a) && (this._x = i, this._y = a, this._dragging = !0);
      }
    }, r.prototype._mousemoveHandler = function(e) {
      if (!(!this._dragging || !N0("moveOnMouseMove", e, this._opt) || e.gestureEvent === "pinch" || pD(this._zr, "globalPan"))) {
        var n = e.offsetX, i = e.offsetY, a = this._x, o = this._y, s = n - a, l = i - o;
        this._x = n, this._y = i, this._opt.preventDefaultMouseMove && Ys(e.event), oB(this, "pan", "moveOnMouseMove", e, {
          dx: s,
          dy: l,
          oldX: a,
          oldY: o,
          newX: n,
          newY: i,
          isAvailableBehavior: null
        });
      }
    }, r.prototype._mouseupHandler = function(e) {
      z8(e) || (this._dragging = !1);
    }, r.prototype._mousewheelHandler = function(e) {
      var n = N0("zoomOnMouseWheel", e, this._opt), i = N0("moveOnMouseWheel", e, this._opt), a = e.wheelDelta, o = Math.abs(a), s = e.offsetX, l = e.offsetY;
      if (!(a === 0 || !n && !i)) {
        if (n) {
          var u = o > 3 ? 1.4 : o > 1 ? 1.2 : 1.1, c = a > 0 ? u : 1 / u;
          Xb(this, "zoom", "zoomOnMouseWheel", e, {
            scale: c,
            originX: s,
            originY: l,
            isAvailableBehavior: null
          });
        }
        if (i) {
          var d = Math.abs(a), f = (a > 0 ? 1 : -1) * (d > 3 ? 0.4 : d > 1 ? 0.15 : 0.05);
          Xb(this, "scrollMove", "moveOnMouseWheel", e, {
            scrollDelta: f,
            originX: s,
            originY: l,
            isAvailableBehavior: null
          });
        }
      }
    }, r.prototype._pinchHandler = function(e) {
      if (!pD(this._zr, "globalPan")) {
        var n = e.pinchScale > 1 ? 1.1 : 1 / 1.1;
        Xb(this, "zoom", null, e, {
          scale: n,
          originX: e.pinchX,
          originY: e.pinchY,
          isAvailableBehavior: null
        });
      }
    }, r;
  }(ka)
);
function Xb(t, r, e, n, i) {
  t.pointerChecker && t.pointerChecker(n, i.originX, i.originY) && (Ys(n.event), oB(t, r, e, n, i));
}
function oB(t, r, e, n, i) {
  i.isAvailableBehavior = ye(N0, null, e, n), t.trigger(r, i);
}
function N0(t, r, e) {
  var n = e[t];
  return !t || n && (!pe(n) || r.event[n + "Key"]);
}
function Zw(t, r, e) {
  var n = t.target;
  n.x += r, n.y += e, n.dirty();
}
function jw(t, r, e, n) {
  var i = t.target, a = t.zoomLimit, o = t.zoom = t.zoom || 1;
  if (o *= r, a) {
    var s = a.min || 0, l = a.max || 1 / 0;
    o = Math.max(Math.min(l, o), s);
  }
  var u = o / t.zoom;
  t.zoom = o, i.x -= (e - i.x) * (u - 1), i.y -= (n - i.y) * (u - 1), i.scaleX *= u, i.scaleY *= u, i.dirty();
}
var Bne = {
  axisPointer: 1,
  tooltip: 1,
  brush: 1
};
function R2(t, r, e) {
  var n = r.getComponentByElement(t.topTarget), i = n && n.coordinateSystem;
  return n && n !== e && !Bne.hasOwnProperty(n.mainType) && i && i.model !== e;
}
function sB(t) {
  if (pe(t)) {
    var r = new DOMParser();
    t = r.parseFromString(t, "text/xml");
  }
  var e = t;
  for (e.nodeType === 9 && (e = e.firstChild); e.nodeName.toLowerCase() !== "svg" || e.nodeType !== 1; )
    e = e.nextSibling;
  return e;
}
var $b, Wm = {
  fill: "fill",
  stroke: "stroke",
  "stroke-width": "lineWidth",
  opacity: "opacity",
  "fill-opacity": "fillOpacity",
  "stroke-opacity": "strokeOpacity",
  "stroke-dasharray": "lineDash",
  "stroke-dashoffset": "lineDashOffset",
  "stroke-linecap": "lineCap",
  "stroke-linejoin": "lineJoin",
  "stroke-miterlimit": "miterLimit",
  "font-family": "fontFamily",
  "font-size": "fontSize",
  "font-style": "fontStyle",
  "font-weight": "fontWeight",
  "text-anchor": "textAlign",
  visibility: "visibility",
  display: "display"
}, vD = yt(Wm), Zm = {
  "alignment-baseline": "textBaseline",
  "stop-color": "stopColor"
}, gD = yt(Zm), Fne = function() {
  function t() {
    this._defs = {}, this._root = null;
  }
  return t.prototype.parse = function(r, e) {
    e = e || {};
    var n = sB(r);
    if (process.env.NODE_ENV !== "production" && !n)
      throw new Error("Illegal svg");
    this._defsUsePending = [];
    var i = new ze();
    this._root = i;
    var a = [], o = n.getAttribute("viewBox") || "", s = parseFloat(n.getAttribute("width") || e.width), l = parseFloat(n.getAttribute("height") || e.height);
    isNaN(s) && (s = null), isNaN(l) && (l = null), Hi(n, i, null, !0, !1);
    for (var u = n.firstChild; u; )
      this._parseNode(u, i, a, null, !1, !1), u = u.nextSibling;
    Wne(this._defs, this._defsUsePending), this._defsUsePending = [];
    var c, d;
    if (o) {
      var f = L2(o);
      f.length >= 4 && (c = {
        x: parseFloat(f[0] || 0),
        y: parseFloat(f[1] || 0),
        width: parseFloat(f[2]),
        height: parseFloat(f[3])
      });
    }
    if (c && s != null && l != null && (d = uB(c, { x: 0, y: 0, width: s, height: l }), !e.ignoreViewBox)) {
      var h = i;
      i = new ze(), i.add(h), h.scaleX = h.scaleY = d.scale, h.x = d.x, h.y = d.y;
    }
    return !e.ignoreRootClip && s != null && l != null && i.setClipPath(new xt({
      shape: { x: 0, y: 0, width: s, height: l }
    })), {
      root: i,
      width: s,
      height: l,
      viewBoxRect: c,
      viewBoxTransform: d,
      named: a
    };
  }, t.prototype._parseNode = function(r, e, n, i, a, o) {
    var s = r.nodeName.toLowerCase(), l, u = i;
    if (s === "defs" && (a = !0), s === "text" && (o = !0), s === "defs" || s === "switch")
      l = e;
    else {
      if (!a) {
        var c = $b[s];
        if (c && be($b, s)) {
          l = c.call(this, r, e);
          var d = r.getAttribute("name");
          if (d) {
            var f = {
              name: d,
              namedFrom: null,
              svgNodeTagLower: s,
              el: l
            };
            n.push(f), s === "g" && (u = f);
          } else i && n.push({
            name: i.name,
            namedFrom: i,
            svgNodeTagLower: s,
            el: l
          });
          e.add(l);
        }
      }
      var h = mD[s];
      if (h && be(mD, s)) {
        var p = h.call(this, r), v = r.getAttribute("id");
        v && (this._defs[v] = p);
      }
    }
    if (l && l.isGroup)
      for (var g = r.firstChild; g; )
        g.nodeType === 1 ? this._parseNode(g, l, n, u, a, o) : g.nodeType === 3 && o && this._parseText(g, l), g = g.nextSibling;
  }, t.prototype._parseText = function(r, e) {
    var n = new Tf({
      style: {
        text: r.textContent
      },
      silent: !0,
      x: this._textX || 0,
      y: this._textY || 0
    });
    ca(e, n), Hi(r, n, this._defsUsePending, !1, !1), Hne(n, e);
    var i = n.style, a = i.fontSize;
    a && a < 9 && (i.fontSize = 9, n.scaleX *= a / 9, n.scaleY *= a / 9);
    var o = (i.fontSize || i.fontFamily) && [
      i.fontStyle,
      i.fontWeight,
      (i.fontSize || 12) + "px",
      i.fontFamily || "sans-serif"
    ].join(" ");
    i.font = o;
    var s = n.getBoundingRect();
    return this._textX += s.width, e.add(n), n;
  }, t.internalField = function() {
    $b = {
      g: function(r, e) {
        var n = new ze();
        return ca(e, n), Hi(r, n, this._defsUsePending, !1, !1), n;
      },
      rect: function(r, e) {
        var n = new xt();
        return ca(e, n), Hi(r, n, this._defsUsePending, !1, !1), n.setShape({
          x: parseFloat(r.getAttribute("x") || "0"),
          y: parseFloat(r.getAttribute("y") || "0"),
          width: parseFloat(r.getAttribute("width") || "0"),
          height: parseFloat(r.getAttribute("height") || "0")
        }), n.silent = !0, n;
      },
      circle: function(r, e) {
        var n = new is();
        return ca(e, n), Hi(r, n, this._defsUsePending, !1, !1), n.setShape({
          cx: parseFloat(r.getAttribute("cx") || "0"),
          cy: parseFloat(r.getAttribute("cy") || "0"),
          r: parseFloat(r.getAttribute("r") || "0")
        }), n.silent = !0, n;
      },
      line: function(r, e) {
        var n = new gn();
        return ca(e, n), Hi(r, n, this._defsUsePending, !1, !1), n.setShape({
          x1: parseFloat(r.getAttribute("x1") || "0"),
          y1: parseFloat(r.getAttribute("y1") || "0"),
          x2: parseFloat(r.getAttribute("x2") || "0"),
          y2: parseFloat(r.getAttribute("y2") || "0")
        }), n.silent = !0, n;
      },
      ellipse: function(r, e) {
        var n = new pg();
        return ca(e, n), Hi(r, n, this._defsUsePending, !1, !1), n.setShape({
          cx: parseFloat(r.getAttribute("cx") || "0"),
          cy: parseFloat(r.getAttribute("cy") || "0"),
          rx: parseFloat(r.getAttribute("rx") || "0"),
          ry: parseFloat(r.getAttribute("ry") || "0")
        }), n.silent = !0, n;
      },
      polygon: function(r, e) {
        var n = r.getAttribute("points"), i;
        n && (i = CD(n));
        var a = new si({
          shape: {
            points: i || []
          },
          silent: !0
        });
        return ca(e, a), Hi(r, a, this._defsUsePending, !1, !1), a;
      },
      polyline: function(r, e) {
        var n = r.getAttribute("points"), i;
        n && (i = CD(n));
        var a = new ci({
          shape: {
            points: i || []
          },
          silent: !0
        });
        return ca(e, a), Hi(r, a, this._defsUsePending, !1, !1), a;
      },
      image: function(r, e) {
        var n = new An();
        return ca(e, n), Hi(r, n, this._defsUsePending, !1, !1), n.setStyle({
          image: r.getAttribute("xlink:href") || r.getAttribute("href"),
          x: +r.getAttribute("x"),
          y: +r.getAttribute("y"),
          width: +r.getAttribute("width"),
          height: +r.getAttribute("height")
        }), n.silent = !0, n;
      },
      text: function(r, e) {
        var n = r.getAttribute("x") || "0", i = r.getAttribute("y") || "0", a = r.getAttribute("dx") || "0", o = r.getAttribute("dy") || "0";
        this._textX = parseFloat(n) + parseFloat(a), this._textY = parseFloat(i) + parseFloat(o);
        var s = new ze();
        return ca(e, s), Hi(r, s, this._defsUsePending, !1, !0), s;
      },
      tspan: function(r, e) {
        var n = r.getAttribute("x"), i = r.getAttribute("y");
        n != null && (this._textX = parseFloat(n)), i != null && (this._textY = parseFloat(i));
        var a = r.getAttribute("dx") || "0", o = r.getAttribute("dy") || "0", s = new ze();
        return ca(e, s), Hi(r, s, this._defsUsePending, !1, !0), this._textX += parseFloat(a), this._textY += parseFloat(o), s;
      },
      path: function(r, e) {
        var n = r.getAttribute("d") || "", i = eO(n);
        return ca(e, i), Hi(r, i, this._defsUsePending, !1, !1), i.silent = !0, i;
      }
    };
  }(), t;
}(), mD = {
  lineargradient: function(t) {
    var r = parseInt(t.getAttribute("x1") || "0", 10), e = parseInt(t.getAttribute("y1") || "0", 10), n = parseInt(t.getAttribute("x2") || "10", 10), i = parseInt(t.getAttribute("y2") || "0", 10), a = new rh(r, e, n, i);
    return yD(t, a), bD(t, a), a;
  },
  radialgradient: function(t) {
    var r = parseInt(t.getAttribute("cx") || "0", 10), e = parseInt(t.getAttribute("cy") || "0", 10), n = parseInt(t.getAttribute("r") || "0", 10), i = new Z7(r, e, n);
    return yD(t, i), bD(t, i), i;
  }
};
function yD(t, r) {
  var e = t.getAttribute("gradientUnits");
  e === "userSpaceOnUse" && (r.global = !0);
}
function bD(t, r) {
  for (var e = t.firstChild; e; ) {
    if (e.nodeType === 1 && e.nodeName.toLocaleLowerCase() === "stop") {
      var n = e.getAttribute("offset"), i = void 0;
      n && n.indexOf("%") > 0 ? i = parseInt(n, 10) / 100 : n ? i = parseFloat(n) : i = 0;
      var a = {};
      lB(e, a, a);
      var o = a.stopColor || e.getAttribute("stop-color") || "#000000";
      r.colorStops.push({
        offset: i,
        color: o
      });
    }
    e = e.nextSibling;
  }
}
function ca(t, r) {
  t && t.__inheritedStyle && (r.__inheritedStyle || (r.__inheritedStyle = {}), Ee(r.__inheritedStyle, t.__inheritedStyle));
}
function CD(t) {
  for (var r = L2(t), e = [], n = 0; n < r.length; n += 2) {
    var i = parseFloat(r[n]), a = parseFloat(r[n + 1]);
    e.push([i, a]);
  }
  return e;
}
function Hi(t, r, e, n, i) {
  var a = r, o = a.__inheritedStyle = a.__inheritedStyle || {}, s = {};
  t.nodeType === 1 && (Yne(t, r), lB(t, o, s), n || Xne(t, o, s)), a.style = a.style || {}, o.fill != null && (a.style.fill = wD(a, "fill", o.fill, e)), o.stroke != null && (a.style.stroke = wD(a, "stroke", o.stroke, e)), L([
    "lineWidth",
    "opacity",
    "fillOpacity",
    "strokeOpacity",
    "miterLimit",
    "fontSize"
  ], function(l) {
    o[l] != null && (a.style[l] = parseFloat(o[l]));
  }), L([
    "lineDashOffset",
    "lineCap",
    "lineJoin",
    "fontWeight",
    "fontFamily",
    "fontStyle",
    "textAlign"
  ], function(l) {
    o[l] != null && (a.style[l] = o[l]);
  }), i && (a.__selfStyle = s), o.lineDash && (a.style.lineDash = ce(L2(o.lineDash), function(l) {
    return parseFloat(l);
  })), (o.visibility === "hidden" || o.visibility === "collapse") && (a.invisible = !0), o.display === "none" && (a.ignore = !0);
}
function Hne(t, r) {
  var e = r.__selfStyle;
  if (e) {
    var n = e.textBaseline, i = n;
    !n || n === "auto" || n === "baseline" ? i = "alphabetic" : n === "before-edge" || n === "text-before-edge" ? i = "top" : n === "after-edge" || n === "text-after-edge" ? i = "bottom" : (n === "central" || n === "mathematical") && (i = "middle"), t.style.textBaseline = i;
  }
  var a = r.__inheritedStyle;
  if (a) {
    var o = a.textAlign, s = o;
    o && (o === "middle" && (s = "center"), t.style.textAlign = s);
  }
}
var zne = /^url\(\s*#(.*?)\)/;
function wD(t, r, e, n) {
  var i = e && e.match(zne);
  if (i) {
    var a = Aa(i[1]);
    n.push([t, r, a]);
    return;
  }
  return e === "none" && (e = null), e;
}
function Wne(t, r) {
  for (var e = 0; e < r.length; e++) {
    var n = r[e];
    n[0].style[n[1]] = t[n[2]];
  }
}
var Zne = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g;
function L2(t) {
  return t.match(Zne) || [];
}
var jne = /(translate|scale|rotate|skewX|skewY|matrix)\(([\-\s0-9\.eE,]*)\)/g, Ub = Math.PI / 180;
function Yne(t, r) {
  var e = t.getAttribute("transform");
  if (e) {
    e = e.replace(/,/g, " ");
    var n = [], i = null;
    e.replace(jne, function(d, f, h) {
      return n.push(f, h), "";
    });
    for (var a = n.length - 1; a > 0; a -= 2) {
      var o = n[a], s = n[a - 1], l = L2(o);
      switch (i = i || Oi(), s) {
        case "translate":
          eo(i, i, [parseFloat(l[0]), parseFloat(l[1] || "0")]);
          break;
        case "scale":
          qy(i, i, [parseFloat(l[0]), parseFloat(l[1] || l[0])]);
          break;
        case "rotate":
          hu(i, i, -parseFloat(l[0]) * Ub, [
            parseFloat(l[1] || "0"),
            parseFloat(l[2] || "0")
          ]);
          break;
        case "skewX":
          var u = Math.tan(parseFloat(l[0]) * Ub);
          zo(i, [1, 0, u, 1, 0, 0], i);
          break;
        case "skewY":
          var c = Math.tan(parseFloat(l[0]) * Ub);
          zo(i, [1, c, 0, 1, 0, 0], i);
          break;
        case "matrix":
          i[0] = parseFloat(l[0]), i[1] = parseFloat(l[1]), i[2] = parseFloat(l[2]), i[3] = parseFloat(l[3]), i[4] = parseFloat(l[4]), i[5] = parseFloat(l[5]);
          break;
      }
    }
    r.setLocalTransform(i);
  }
}
var _D = /([^\s:;]+)\s*:\s*([^:;]+)/g;
function lB(t, r, e) {
  var n = t.getAttribute("style");
  if (n) {
    _D.lastIndex = 0;
    for (var i; (i = _D.exec(n)) != null; ) {
      var a = i[1], o = be(Wm, a) ? Wm[a] : null;
      o && (r[o] = i[2]);
      var s = be(Zm, a) ? Zm[a] : null;
      s && (e[s] = i[2]);
    }
  }
}
function Xne(t, r, e) {
  for (var n = 0; n < vD.length; n++) {
    var i = vD[n], a = t.getAttribute(i);
    a != null && (r[Wm[i]] = a);
  }
  for (var n = 0; n < gD.length; n++) {
    var i = gD[n], a = t.getAttribute(i);
    a != null && (e[Zm[i]] = a);
  }
}
function uB(t, r) {
  var e = r.width / t.width, n = r.height / t.height, i = Math.min(e, n);
  return {
    scale: i,
    x: -(t.x + t.width / 2) * i + (r.x + r.width / 2),
    y: -(t.y + t.height / 2) * i + (r.y + r.height / 2)
  };
}
function $ne(t, r) {
  var e = new Fne();
  return e.parse(t, r);
}
var Une = xe([
  "rect",
  "circle",
  "line",
  "ellipse",
  "polygon",
  "polyline",
  "path",
  // <text> <tspan> are also enabled because some SVG might paint text itself,
  // but still need to trigger events or tooltip.
  "text",
  "tspan",
  // <g> is also enabled because this case: if multiple tags share one name
  // and need label displayed, every tags will display the name, which is not
  // expected. So we can put them into a <g name="xxx">. Thereby only one label
  // displayed and located based on the bounding rect of the <g>.
  "g"
]), Jne = (
  /** @class */
  function() {
    function t(r, e) {
      this.type = "geoSVG", this._usedGraphicMap = xe(), this._freedGraphics = [], this._mapName = r, this._parsedXML = sB(e);
    }
    return t.prototype.load = function() {
      var r = this._firstGraphic;
      if (!r) {
        r = this._firstGraphic = this._buildGraphic(this._parsedXML), this._freedGraphics.push(r), this._boundingRect = this._firstGraphic.boundingRect.clone();
        var e = qne(r.named), n = e.regions, i = e.regionsMap;
        this._regions = n, this._regionsMap = i;
      }
      return {
        boundingRect: this._boundingRect,
        regions: this._regions,
        regionsMap: this._regionsMap
      };
    }, t.prototype._buildGraphic = function(r) {
      var e, n;
      try {
        e = r && $ne(r, {
          ignoreViewBox: !0,
          ignoreRootClip: !0
        }) || {}, n = e.root, ke(n != null);
      } catch (g) {
        throw new Error(`Invalid svg format
` + g.message);
      }
      var i = new ze();
      i.add(n), i.isGeoSVGGraphicRoot = !0;
      var a = e.width, o = e.height, s = e.viewBoxRect, l = this._boundingRect;
      if (!l) {
        var u = void 0, c = void 0, d = void 0, f = void 0;
        if (a != null ? (u = 0, d = a) : s && (u = s.x, d = s.width), o != null ? (c = 0, f = o) : s && (c = s.y, f = s.height), u == null || c == null) {
          var h = n.getBoundingRect();
          u == null && (u = h.x, d = h.width), c == null && (c = h.y, f = h.height);
        }
        l = this._boundingRect = new rt(u, c, d, f);
      }
      if (s) {
        var p = uB(s, l);
        n.scaleX = n.scaleY = p.scale, n.x = p.x, n.y = p.y;
      }
      i.setClipPath(new xt({
        shape: l.plain()
      }));
      var v = [];
      return L(e.named, function(g) {
        Une.get(g.svgNodeTagLower) != null && (v.push(g), Kne(g.el));
      }), {
        root: i,
        boundingRect: l,
        named: v
      };
    }, t.prototype.useGraphic = function(r) {
      var e = this._usedGraphicMap, n = e.get(r);
      return n || (n = this._freedGraphics.pop() || this._buildGraphic(this._parsedXML), e.set(r, n), n);
    }, t.prototype.freeGraphic = function(r) {
      var e = this._usedGraphicMap, n = e.get(r);
      n && (e.removeKey(r), this._freedGraphics.push(n));
    }, t;
  }()
);
function Kne(t) {
  t.silent = !1, t.isGroup && t.traverse(function(r) {
    r.silent = !1;
  });
}
function qne(t) {
  var r = [], e = xe();
  return L(t, function(n) {
    if (n.namedFrom == null) {
      var i = new Gee(n.name, n.el);
      r.push(i), e.set(n.name, i);
    }
  }), {
    regions: r,
    regionsMap: e
  };
}
var A9 = [126, 25], xD = "南海诸岛", Uu = [[[0, 3.5], [7, 11.2], [15, 11.9], [30, 7], [42, 0.7], [52, 0.7], [56, 7.7], [59, 0.7], [64, 0.7], [64, 0], [5, 0], [0, 3.5]], [[13, 16.1], [19, 14.7], [16, 21.7], [11, 23.1], [13, 16.1]], [[12, 32.2], [14, 38.5], [15, 38.5], [13, 32.2], [12, 32.2]], [[16, 47.6], [12, 53.2], [13, 53.2], [18, 47.6], [16, 47.6]], [[6, 64.4], [8, 70], [9, 70], [8, 64.4], [6, 64.4]], [[23, 82.6], [29, 79.8], [30, 79.8], [25, 82.6], [23, 82.6]], [[37, 70.7], [43, 62.3], [44, 62.3], [39, 70.7], [37, 70.7]], [[48, 51.1], [51, 45.5], [53, 45.5], [50, 51.1], [48, 51.1]], [[51, 35], [51, 28.7], [53, 28.7], [53, 35], [51, 35]], [[52, 22.4], [55, 17.5], [56, 17.5], [53, 22.4], [52, 22.4]], [[58, 12.6], [62, 7], [63, 7], [60, 12.6], [58, 12.6]], [[0, 3.5], [0, 93.1], [64, 93.1], [64, 0], [63, 0], [63, 92.4], [1, 92.4], [1, 3.5], [0, 3.5]]];
for (var ju = 0; ju < Uu.length; ju++)
  for (var Id = 0; Id < Uu[ju].length; Id++)
    Uu[ju][Id][0] /= 10.5, Uu[ju][Id][1] /= -10.5 / 0.75, Uu[ju][Id][0] += A9[0], Uu[ju][Id][1] += A9[1];
function Qne(t, r) {
  if (t === "china") {
    for (var e = 0; e < r.length; e++)
      if (r[e].name === xD)
        return;
    r.push(new aG(xD, ce(Uu, function(n) {
      return {
        type: "polygon",
        exterior: n
      };
    }), A9));
  }
}
var eie = {
  南海诸岛: [32, 80],
  // 全国
  广东: [0, -10],
  香港: [10, 5],
  澳门: [-10, 10],
  // '北京': [-10, 0],
  天津: [5, 5]
};
function tie(t, r) {
  if (t === "china") {
    var e = eie[r.name];
    if (e) {
      var n = r.getCenter();
      n[0] += e[0] / 10.5, n[1] += -e[1] / (10.5 / 0.75), r.setCenter(n);
    }
  }
}
var rie = [[[123.45165252685547, 25.73527164402261], [123.49731445312499, 25.73527164402261], [123.49731445312499, 25.750734064600884], [123.45165252685547, 25.750734064600884], [123.45165252685547, 25.73527164402261]]];
function nie(t, r) {
  t === "china" && r.name === "台湾" && r.geometries.push({
    type: "polygon",
    exterior: rie[0]
  });
}
var iie = "name", aie = (
  /** @class */
  function() {
    function t(r, e, n) {
      this.type = "geoJSON", this._parsedMap = xe(), this._mapName = r, this._specialAreas = n, this._geoJSON = sie(e);
    }
    return t.prototype.load = function(r, e) {
      e = e || iie;
      var n = this._parsedMap.get(e);
      if (!n) {
        var i = this._parseToRegions(e);
        n = this._parsedMap.set(e, {
          regions: i,
          boundingRect: oie(i)
        });
      }
      var a = xe(), o = [];
      return L(n.regions, function(s) {
        var l = s.name;
        r && be(r, l) && (s = s.cloneShallow(l = r[l])), o.push(s), a.set(l, s);
      }), {
        regions: o,
        boundingRect: n.boundingRect || new rt(0, 0, 0, 0),
        regionsMap: a
      };
    }, t.prototype._parseToRegions = function(r) {
      var e = this._mapName, n = this._geoJSON, i;
      try {
        i = n ? g9(n, r) : [];
      } catch (a) {
        throw new Error(`Invalid geoJson format
` + a.message);
      }
      return Qne(e, i), L(i, function(a) {
        var o = a.name;
        tie(e, a), nie(e, a);
        var s = this._specialAreas && this._specialAreas[o];
        s && a.transformTo(s.left, s.top, s.width, s.height);
      }, this), i;
    }, t.prototype.getMapForUser = function() {
      return {
        // For backward compatibility, use geoJson
        // PENDING: it has been returning them without clone.
        // do we need to avoid outsite modification?
        geoJson: this._geoJSON,
        geoJSON: this._geoJSON,
        specialAreas: this._specialAreas
      };
    }, t;
  }()
);
function oie(t) {
  for (var r, e = 0; e < t.length; e++) {
    var n = t[e].getBoundingRect();
    r = r || n.clone(), r.union(n);
  }
  return r;
}
function sie(t) {
  return pe(t) ? typeof JSON < "u" && JSON.parse ? JSON.parse(t) : new Function("return (" + t + ");")() : t;
}
var Qh = xe();
const qs = {
  /**
   * Compatible with previous `echarts.registerMap`.
   *
   * @usage
   * ```js
   *
   * echarts.registerMap('USA', geoJson, specialAreas);
   *
   * echarts.registerMap('USA', {
   *     geoJson: geoJson,
   *     specialAreas: {...}
   * });
   * echarts.registerMap('USA', {
   *     geoJSON: geoJson,
   *     specialAreas: {...}
   * });
   *
   * echarts.registerMap('airport', {
   *     svg: svg
   * }
   * ```
   *
   * Note:
   * Do not support that register multiple geoJSON or SVG
   * one map name. Because different geoJSON and SVG have
   * different unit. It's not easy to make sure how those
   * units are mapping/normalize.
   * If intending to use multiple geoJSON or SVG, we can
   * use multiple geo coordinate system.
   */
  registerMap: function(t, r, e) {
    if (r.svg) {
      var n = new Jne(t, r.svg);
      Qh.set(t, n);
    } else {
      var i = r.geoJson || r.geoJSON;
      i && !r.features ? e = r.specialAreas : i = r;
      var n = new aie(t, i, e);
      Qh.set(t, n);
    }
  },
  getGeoResource: function(t) {
    return Qh.get(t);
  },
  /**
   * Only for exporting to users.
   * **MUST NOT** used internally.
   */
  getMapForUser: function(t) {
    var r = Qh.get(t);
    return r && r.type === "geoJSON" && r.getMapForUser();
  },
  load: function(t, r, e) {
    var n = Qh.get(t);
    if (!n) {
      process.env.NODE_ENV !== "production" && console.error("Map " + t + " not exists. The GeoJSON of the map must be provided.");
      return;
    }
    return n.load(r, e);
  }
};
var Yw = ["rect", "circle", "line", "ellipse", "polygon", "polyline", "path"], lie = xe(Yw), uie = xe(Yw.concat(["g"])), cie = xe(Yw.concat(["g"])), cB = It();
function V1(t) {
  var r = t.getItemStyle(), e = t.get("areaColor");
  return e != null && (r.fill = e), r;
}
function SD(t) {
  var r = t.style;
  r && (r.stroke = r.stroke || r.fill, r.fill = null);
}
var dB = (
  /** @class */
  function() {
    function t(r) {
      var e = new ze();
      this.uid = sh("ec_map_draw"), this._controller = new Dg(r.getZr()), this._controllerHost = {
        target: e
      }, this.group = e, e.add(this._regionsGroup = new ze()), e.add(this._svgGroup = new ze());
    }
    return t.prototype.draw = function(r, e, n, i, a) {
      var o = r.mainType === "geo", s = r.getData && r.getData();
      o && e.eachComponent({
        mainType: "series",
        subType: "map"
      }, function(m) {
        !s && m.getHostGeoModel() === r && (s = m.getData());
      });
      var l = r.coordinateSystem, u = this._regionsGroup, c = this.group, d = l.getTransformInfo(), f = d.raw, h = d.roam, p = !u.childAt(0) || a;
      p ? (c.x = h.x, c.y = h.y, c.scaleX = h.scaleX, c.scaleY = h.scaleY, c.dirty()) : kt(c, h, r);
      var v = s && s.getVisual("visualMeta") && s.getVisual("visualMeta").length > 0, g = {
        api: n,
        geo: l,
        mapOrGeoModel: r,
        data: s,
        isVisualEncodedByVisualMap: v,
        isGeo: o,
        transformInfoRaw: f
      };
      l.resourceType === "geoJSON" ? this._buildGeoJSON(g) : l.resourceType === "geoSVG" && this._buildSVG(g), this._updateController(r, e, n), this._updateMapSelectHandler(r, u, n, i);
    }, t.prototype._buildGeoJSON = function(r) {
      var e = this._regionsGroupByName = xe(), n = xe(), i = this._regionsGroup, a = r.transformInfoRaw, o = r.mapOrGeoModel, s = r.data, l = r.geo.projection, u = l && l.stream;
      function c(h, p) {
        return p && (h = p(h)), h && [h[0] * a.scaleX + a.x, h[1] * a.scaleY + a.y];
      }
      function d(h) {
        for (var p = [], v = !u && l && l.project, g = 0; g < h.length; ++g) {
          var m = c(h[g], v);
          m && p.push(m);
        }
        return p;
      }
      function f(h) {
        return {
          shape: {
            points: d(h)
          }
        };
      }
      i.removeAll(), L(r.geo.regions, function(h) {
        var p = h.name, v = e.get(p), g = n.get(p) || {}, m = g.dataIdx, y = g.regionModel;
        v || (v = e.set(p, new ze()), i.add(v), m = s ? s.indexOfName(p) : null, y = r.isGeo ? o.getRegionModel(p) : s ? s.getItemModel(m) : null, n.set(p, {
          dataIdx: m,
          regionModel: y
        }));
        var b = [], C = [];
        L(h.geometries, function(x) {
          if (x.type === "polygon") {
            var I = [x.exterior].concat(x.interiors || []);
            u && (I = RD(I, u)), L(I, function(T) {
              b.push(new si(f(T)));
            });
          } else {
            var D = x.points;
            u && (D = RD(D, u, !0)), L(D, function(T) {
              C.push(new ci(f(T)));
            });
          }
        });
        var w = c(h.getCenter(), l && l.project);
        function _(x, I) {
          if (x.length) {
            var D = new c2({
              culling: !0,
              segmentIgnoreThreshold: 1,
              shape: {
                paths: x
              }
            });
            v.add(D), ID(r, D, m, y), AD(r, D, p, y, o, m, w), I && (SD(D), L(D.states, SD));
          }
        }
        _(b), _(C, !0);
      }), e.each(function(h, p) {
        var v = n.get(p), g = v.dataIdx, m = v.regionModel;
        DD(r, h, p, m, o, g), TD(r, h, p, m, o), MD(r, h, p, m, o);
      }, this);
    }, t.prototype._buildSVG = function(r) {
      var e = r.geo.map, n = r.transformInfoRaw;
      this._svgGroup.x = n.x, this._svgGroup.y = n.y, this._svgGroup.scaleX = n.scaleX, this._svgGroup.scaleY = n.scaleY, this._svgResourceChanged(e) && (this._freeSVG(), this._useSVG(e));
      var i = this._svgDispatcherMap = xe(), a = !1;
      L(this._svgGraphicRecord.named, function(o) {
        var s = o.name, l = r.mapOrGeoModel, u = r.data, c = o.svgNodeTagLower, d = o.el, f = u ? u.indexOfName(s) : null, h = l.getRegionModel(s);
        if (lie.get(c) != null && d instanceof La && ID(r, d, f, h), d instanceof La && (d.culling = !0), d.z2EmphasisLift = 0, !o.namedFrom && (cie.get(c) != null && AD(r, d, s, h, l, f, null), DD(r, d, s, h, l, f), TD(r, d, s, h, l), uie.get(c) != null)) {
          var p = MD(r, d, s, h, l);
          p === "self" && (a = !0);
          var v = i.get(s) || i.set(s, []);
          v.push(d);
        }
      }, this), this._enableBlurEntireSVG(a, r);
    }, t.prototype._enableBlurEntireSVG = function(r, e) {
      if (r && e.isGeo) {
        var n = e.mapOrGeoModel.getModel(["blur", "itemStyle"]).getItemStyle(), i = n.opacity;
        this._svgGraphicRecord.root.traverse(function(a) {
          if (!a.isGroup) {
            Fc(a);
            var o = a.ensureState("blur").style || {};
            o.opacity == null && i != null && (o.opacity = i), a.ensureState("emphasis");
          }
        });
      }
    }, t.prototype.remove = function() {
      this._regionsGroup.removeAll(), this._regionsGroupByName = null, this._svgGroup.removeAll(), this._freeSVG(), this._controller.dispose(), this._controllerHost = null;
    }, t.prototype.findHighDownDispatchers = function(r, e) {
      if (r == null)
        return [];
      var n = e.coordinateSystem;
      if (n.resourceType === "geoJSON") {
        var i = this._regionsGroupByName;
        if (i) {
          var a = i.get(r);
          return a ? [a] : [];
        }
      } else if (n.resourceType === "geoSVG")
        return this._svgDispatcherMap && this._svgDispatcherMap.get(r) || [];
    }, t.prototype._svgResourceChanged = function(r) {
      return this._svgMapName !== r;
    }, t.prototype._useSVG = function(r) {
      var e = qs.getGeoResource(r);
      if (e && e.type === "geoSVG") {
        var n = e.useGraphic(this.uid);
        this._svgGroup.add(n.root), this._svgGraphicRecord = n, this._svgMapName = r;
      }
    }, t.prototype._freeSVG = function() {
      var r = this._svgMapName;
      if (r != null) {
        var e = qs.getGeoResource(r);
        e && e.type === "geoSVG" && e.freeGraphic(this.uid), this._svgGraphicRecord = null, this._svgDispatcherMap = null, this._svgGroup.removeAll(), this._svgMapName = null;
      }
    }, t.prototype._updateController = function(r, e, n) {
      var i = r.coordinateSystem, a = this._controller, o = this._controllerHost;
      o.zoomLimit = r.get("scaleLimit"), o.zoom = i.getZoom(), a.enable(r.get("roam") || !1);
      var s = r.mainType;
      function l() {
        var u = {
          type: "geoRoam",
          componentType: s
        };
        return u[s + "Id"] = r.id, u;
      }
      a.off("pan").on("pan", function(u) {
        this._mouseDownFlag = !1, Zw(o, u.dx, u.dy), n.dispatchAction(ae(l(), {
          dx: u.dx,
          dy: u.dy,
          animation: {
            duration: 0
          }
        }));
      }, this), a.off("zoom").on("zoom", function(u) {
        this._mouseDownFlag = !1, jw(o, u.scale, u.originX, u.originY), n.dispatchAction(ae(l(), {
          totalZoom: o.zoom,
          zoom: u.scale,
          originX: u.originX,
          originY: u.originY,
          animation: {
            duration: 0
          }
        }));
      }, this), a.setPointerChecker(function(u, c, d) {
        return i.containPoint([c, d]) && !R2(u, n, r);
      });
    }, t.prototype.resetForLabelLayout = function() {
      this.group.traverse(function(r) {
        var e = r.getTextContent();
        e && (e.ignore = cB(e).ignore);
      });
    }, t.prototype._updateMapSelectHandler = function(r, e, n, i) {
      var a = this;
      e.off("mousedown"), e.off("click"), r.get("selectedMode") && (e.on("mousedown", function() {
        a._mouseDownFlag = !0;
      }), e.on("click", function(o) {
        a._mouseDownFlag && (a._mouseDownFlag = !1);
      }));
    }, t;
  }()
);
function ID(t, r, e, n) {
  var i = n.getModel("itemStyle"), a = n.getModel(["emphasis", "itemStyle"]), o = n.getModel(["blur", "itemStyle"]), s = n.getModel(["select", "itemStyle"]), l = V1(i), u = V1(a), c = V1(s), d = V1(o), f = t.data;
  if (f) {
    var h = f.getItemVisual(e, "style"), p = f.getItemVisual(e, "decal");
    t.isVisualEncodedByVisualMap && h.fill && (l.fill = h.fill), p && (l.decal = Lf(p, t.api));
  }
  r.setStyle(l), r.style.strokeNoScale = !0, r.ensureState("emphasis").style = u, r.ensureState("select").style = c, r.ensureState("blur").style = d, Fc(r);
}
function AD(t, r, e, n, i, a, o) {
  var s = t.data, l = t.isGeo, u = s && isNaN(s.get(s.mapDimension("value"), a)), c = s && s.getItemLayout(a);
  if (l || u || c && c.showLabel) {
    var d = l ? e : a, f = void 0;
    (!s || a >= 0) && (f = i);
    var h = o ? {
      normal: {
        align: "center",
        verticalAlign: "middle"
      }
    } : null;
    Xn(r, xn(n), {
      labelFetcher: f,
      labelDataIndex: d,
      defaultText: e
    }, h);
    var p = r.getTextContent();
    if (p && (cB(p).ignore = p.ignore, r.textConfig && o)) {
      var v = r.getBoundingRect().clone();
      r.textConfig.layoutRect = v, r.textConfig.position = [(o[0] - v.x) / v.width * 100 + "%", (o[1] - v.y) / v.height * 100 + "%"];
    }
    r.disableLabelAnimation = !0;
  } else
    r.removeTextContent(), r.removeTextConfig(), r.disableLabelAnimation = null;
}
function DD(t, r, e, n, i, a) {
  t.data ? t.data.setItemGraphicEl(a, r) : Ze(r).eventData = {
    componentType: "geo",
    componentIndex: i.componentIndex,
    geoIndex: i.componentIndex,
    name: e,
    region: n && n.option || {}
  };
}
function TD(t, r, e, n, i) {
  t.data || ah({
    el: r,
    componentModel: i,
    itemName: e,
    // @ts-ignore FIXME:TS fix the "compatible with each other"?
    itemTooltipOption: n.get("tooltip")
  });
}
function MD(t, r, e, n, i) {
  r.highDownSilentOnTouch = !!i.get("selectedMode");
  var a = n.getModel("emphasis"), o = a.get("focus");
  return Vr(r, o, a.get("blurScope"), a.get("disabled")), t.isGeo && jU(r, i, e), o;
}
function RD(t, r, e) {
  var n = [], i;
  function a() {
    i = [];
  }
  function o() {
    i.length && (n.push(i), i = []);
  }
  var s = r({
    polygonStart: a,
    polygonEnd: o,
    lineStart: a,
    lineEnd: o,
    point: function(l, u) {
      isFinite(l) && isFinite(u) && i.push([l, u]);
    },
    sphere: function() {
    }
  });
  return !e && s.polygonStart(), L(t, function(l) {
    s.lineStart();
    for (var u = 0; u < l.length; u++)
      s.point(l[u][0], l[u][1]);
    s.lineEnd();
  }), !e && s.polygonEnd(), n;
}
var die = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.render = function(e, n, i, a) {
      if (!(a && a.type === "mapToggleSelect" && a.from === this.uid)) {
        var o = this.group;
        if (o.removeAll(), !e.getHostGeoModel()) {
          if (this._mapDraw && a && a.type === "geoRoam" && this._mapDraw.resetForLabelLayout(), a && a.type === "geoRoam" && a.componentType === "series" && a.seriesId === e.id) {
            var s = this._mapDraw;
            s && o.add(s.group);
          } else if (e.needsDrawMap) {
            var s = this._mapDraw || new dB(i);
            o.add(s.group), s.draw(e, n, i, this, a), this._mapDraw = s;
          } else
            this._mapDraw && this._mapDraw.remove(), this._mapDraw = null;
          e.get("showLegendSymbol") && n.getComponent("legend") && this._renderSymbols(e, n, i);
        }
      }
    }, r.prototype.remove = function() {
      this._mapDraw && this._mapDraw.remove(), this._mapDraw = null, this.group.removeAll();
    }, r.prototype.dispose = function() {
      this._mapDraw && this._mapDraw.remove(), this._mapDraw = null;
    }, r.prototype._renderSymbols = function(e, n, i) {
      var a = e.originalData, o = this.group;
      a.each(a.mapDimension("value"), function(s, l) {
        if (!isNaN(s)) {
          var u = a.getItemLayout(l);
          if (!(!u || !u.point)) {
            var c = u.point, d = u.offset, f = new is({
              style: {
                // Because the special of map draw.
                // Which needs statistic of multiple series and draw on one map.
                // And each series also need a symbol with legend color
                //
                // Layout and visual are put one the different data
                // TODO
                fill: e.getData().getVisual("style").fill
              },
              shape: {
                cx: c[0] + d * 9,
                cy: c[1],
                r: 3
              },
              silent: !0,
              // Do not overlap the first series, on which labels are displayed.
              z2: 8 + (d ? 0 : Qf + 1)
            });
            if (!d) {
              var h = e.mainSeries.getData(), p = a.getName(l), v = h.indexOfName(p), g = a.getItemModel(l), m = g.getModel("label"), y = h.getItemGraphicEl(v);
              Xn(f, xn(g), {
                labelFetcher: {
                  getFormattedLabel: function(b, C) {
                    return e.getFormattedLabel(v, C);
                  }
                },
                defaultText: p
              }), f.disableLabelAnimation = !0, m.get("position") || f.setTextConfig({
                position: "bottom"
              }), y.onHoverStateChange = function(b) {
                bm(f, b);
              };
            }
            o.add(f);
          }
        }
      });
    }, r.type = "map", r;
  }(Yt)
), fie = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e.needsDrawMap = !1, e.seriesGroup = [], e.getTooltipPosition = function(n) {
        if (n != null) {
          var i = this.getData().getName(n), a = this.coordinateSystem, o = a.getRegion(i);
          return o && a.dataToPoint(o.getCenter());
        }
      }, e;
    }
    return r.prototype.getInitialData = function(e) {
      for (var n = gh(this, {
        coordDimensions: ["value"],
        encodeDefaulter: Ye(ow, this)
      }), i = xe(), a = [], o = 0, s = n.count(); o < s; o++) {
        var l = n.getName(o);
        i.set(l, !0);
      }
      var u = qs.load(this.getMapType(), this.option.nameMap, this.option.nameProperty);
      return L(u.regions, function(c) {
        var d = c.name;
        i.get(d) || a.push(d);
      }), n.appendValues([], a), n;
    }, r.prototype.getHostGeoModel = function() {
      var e = this.option.geoIndex;
      return e != null ? this.ecModel.getComponent("geo", e) : null;
    }, r.prototype.getMapType = function() {
      return (this.getHostGeoModel() || this).option.map;
    }, r.prototype.getRawValue = function(e) {
      var n = this.getData();
      return n.get(n.mapDimension("value"), e);
    }, r.prototype.getRegionModel = function(e) {
      var n = this.getData();
      return n.getItemModel(n.indexOfName(e));
    }, r.prototype.formatTooltip = function(e, n, i) {
      for (var a = this.getData(), o = this.getRawValue(e), s = a.getName(e), l = this.seriesGroup, u = [], c = 0; c < l.length; c++) {
        var d = l[c].originalData.indexOfName(s), f = a.mapDimension("value");
        isNaN(l[c].originalData.get(f, d)) || u.push(l[c].name);
      }
      return Sn("section", {
        header: u.join(", "),
        noHeader: !u.length,
        blocks: [Sn("nameValue", {
          name: s,
          value: o
        })]
      });
    }, r.prototype.setZoom = function(e) {
      this.option.zoom = e;
    }, r.prototype.setCenter = function(e) {
      this.option.center = e;
    }, r.prototype.getLegendIcon = function(e) {
      var n = e.icon || "roundRect", i = en(n, 0, 0, e.itemWidth, e.itemHeight, e.itemStyle.fill);
      return i.setStyle(e.itemStyle), i.style.stroke = "none", n.indexOf("empty") > -1 && (i.style.stroke = i.style.fill, i.style.fill = "#fff", i.style.lineWidth = 2), i;
    }, r.type = "series.map", r.dependencies = ["geo"], r.layoutMode = "box", r.defaultOption = {
      // 一级层叠
      // zlevel: 0,
      // 二级层叠
      z: 2,
      coordinateSystem: "geo",
      // map should be explicitly specified since ec3.
      map: "",
      // If `geoIndex` is not specified, a exclusive geo will be
      // created. Otherwise use the specified geo component, and
      // `map` and `mapType` are ignored.
      // geoIndex: 0,
      // 'center' | 'left' | 'right' | 'x%' | {number}
      left: "center",
      // 'center' | 'top' | 'bottom' | 'x%' | {number}
      top: "center",
      // right
      // bottom
      // width:
      // height
      // Aspect is width / height. Inited to be geoJson bbox aspect
      // This parameter is used for scale this aspect
      // Default value:
      // for geoSVG source: 1,
      // for geoJSON source: 0.75.
      aspectScale: null,
      // Layout with center and size
      // If you want to put map in a fixed size box with right aspect ratio
      // This two properties may be more convenient.
      // layoutCenter: [50%, 50%]
      // layoutSize: 100
      showLegendSymbol: !0,
      // Define left-top, right-bottom coords to control view
      // For example, [ [180, 90], [-180, -90] ],
      // higher priority than center and zoom
      boundingCoords: null,
      // Default on center of map
      center: null,
      zoom: 1,
      scaleLimit: null,
      selectedMode: !0,
      label: {
        show: !1,
        color: "#000"
      },
      // scaleLimit: null,
      itemStyle: {
        borderWidth: 0.5,
        borderColor: "#444",
        areaColor: "#eee"
      },
      emphasis: {
        label: {
          show: !0,
          color: "rgb(100,0,0)"
        },
        itemStyle: {
          areaColor: "rgba(255,215,0,0.8)"
        }
      },
      select: {
        label: {
          show: !0,
          color: "rgb(100,0,0)"
        },
        itemStyle: {
          color: "rgba(255,215,0,0.8)"
        }
      },
      nameProperty: "name"
    }, r;
  }(tr)
);
function hie(t, r) {
  var e = {};
  return L(t, function(n) {
    n.each(n.mapDimension("value"), function(i, a) {
      var o = "ec-" + n.getName(a);
      e[o] = e[o] || [], isNaN(i) || e[o].push(i);
    });
  }), t[0].map(t[0].mapDimension("value"), function(n, i) {
    for (var a = "ec-" + t[0].getName(i), o = 0, s = 1 / 0, l = -1 / 0, u = e[a].length, c = 0; c < u; c++)
      s = Math.min(s, e[a][c]), l = Math.max(l, e[a][c]), o += e[a][c];
    var d;
    return r === "min" ? d = s : r === "max" ? d = l : r === "average" ? d = o / u : d = o, u === 0 ? NaN : d;
  });
}
function pie(t) {
  var r = {};
  t.eachSeriesByType("map", function(e) {
    var n = e.getHostGeoModel(), i = n ? "o" + n.id : "i" + e.getMapType();
    (r[i] = r[i] || []).push(e);
  }), L(r, function(e, n) {
    for (var i = hie(ce(e, function(o) {
      return o.getData();
    }), e[0].get("mapValueCalculation")), a = 0; a < e.length; a++)
      e[a].originalData = e[a].getData();
    for (var a = 0; a < e.length; a++)
      e[a].seriesGroup = e, e[a].needsDrawMap = a === 0 && !e[a].getHostGeoModel(), e[a].setData(i.cloneShallow()), e[a].mainSeries = e[0];
  });
}
function vie(t) {
  var r = {};
  t.eachSeriesByType("map", function(e) {
    var n = e.getMapType();
    if (!(e.getHostGeoModel() || r[n])) {
      var i = {};
      L(e.seriesGroup, function(o) {
        var s = o.coordinateSystem, l = o.originalData;
        o.get("showLegendSymbol") && t.getComponent("legend") && l.each(l.mapDimension("value"), function(u, c) {
          var d = l.getName(c), f = s.getRegion(d);
          if (!(!f || isNaN(u))) {
            var h = i[d] || 0, p = s.dataToPoint(f.getCenter());
            i[d] = h + 1, l.setItemLayout(c, {
              point: p,
              offset: h
            });
          }
        });
      });
      var a = e.getData();
      a.each(function(o) {
        var s = a.getName(o), l = a.getItemLayout(o) || {};
        l.showLabel = !i[s], a.setItemLayout(o, l);
      }), r[n] = !0;
    }
  });
}
var LD = En, Tg = (
  /** @class */
  function(t) {
    ee(r, t);
    function r(e) {
      var n = t.call(this) || this;
      return n.type = "view", n.dimensions = ["x", "y"], n._roamTransformable = new Ls(), n._rawTransformable = new Ls(), n.name = e, n;
    }
    return r.prototype.setBoundingRect = function(e, n, i, a) {
      return this._rect = new rt(e, n, i, a), this._rect;
    }, r.prototype.getBoundingRect = function() {
      return this._rect;
    }, r.prototype.setViewRect = function(e, n, i, a) {
      this._transformTo(e, n, i, a), this._viewRect = new rt(e, n, i, a);
    }, r.prototype._transformTo = function(e, n, i, a) {
      var o = this.getBoundingRect(), s = this._rawTransformable;
      s.transform = o.calculateTransform(new rt(e, n, i, a));
      var l = s.parent;
      s.parent = null, s.decomposeTransform(), s.parent = l, this._updateTransform();
    }, r.prototype.setCenter = function(e, n) {
      e && (this._center = [he(e[0], n.getWidth()), he(e[1], n.getHeight())], this._updateCenterAndZoom());
    }, r.prototype.setZoom = function(e) {
      e = e || 1;
      var n = this.zoomLimit;
      n && (n.max != null && (e = Math.min(n.max, e)), n.min != null && (e = Math.max(n.min, e))), this._zoom = e, this._updateCenterAndZoom();
    }, r.prototype.getDefaultCenter = function() {
      var e = this.getBoundingRect(), n = e.x + e.width / 2, i = e.y + e.height / 2;
      return [n, i];
    }, r.prototype.getCenter = function() {
      return this._center || this.getDefaultCenter();
    }, r.prototype.getZoom = function() {
      return this._zoom || 1;
    }, r.prototype.getRoamTransform = function() {
      return this._roamTransformable.getLocalTransform();
    }, r.prototype._updateCenterAndZoom = function() {
      var e = this._rawTransformable.getLocalTransform(), n = this._roamTransformable, i = this.getDefaultCenter(), a = this.getCenter(), o = this.getZoom();
      a = En([], a, e), i = En([], i, e), n.originX = a[0], n.originY = a[1], n.x = i[0] - a[0], n.y = i[1] - a[1], n.scaleX = n.scaleY = o, this._updateTransform();
    }, r.prototype._updateTransform = function() {
      var e = this._roamTransformable, n = this._rawTransformable;
      n.parent = e, e.updateTransform(), n.updateTransform(), Ky(this.transform || (this.transform = []), n.transform || Oi()), this._rawTransform = n.getLocalTransform(), this.invTransform = this.invTransform || [], Kc(this.invTransform, this.transform), this.decomposeTransform();
    }, r.prototype.getTransformInfo = function() {
      var e = this._rawTransformable, n = this._roamTransformable, i = new Ls();
      return i.transform = n.transform, i.decomposeTransform(), {
        roam: {
          x: i.x,
          y: i.y,
          scaleX: i.scaleX,
          scaleY: i.scaleY
        },
        raw: {
          x: e.x,
          y: e.y,
          scaleX: e.scaleX,
          scaleY: e.scaleY
        }
      };
    }, r.prototype.getViewRect = function() {
      return this._viewRect;
    }, r.prototype.getViewRectAfterRoam = function() {
      var e = this.getBoundingRect().clone();
      return e.applyTransform(this.transform), e;
    }, r.prototype.dataToPoint = function(e, n, i) {
      var a = n ? this._rawTransform : this.transform;
      return i = i || [], a ? LD(i, e, a) : Qn(i, e);
    }, r.prototype.pointToData = function(e) {
      var n = this.invTransform;
      return n ? LD([], e, n) : [e[0], e[1]];
    }, r.prototype.convertToPixel = function(e, n, i) {
      var a = ED(n);
      return a === this ? a.dataToPoint(i) : null;
    }, r.prototype.convertFromPixel = function(e, n, i) {
      var a = ED(n);
      return a === this ? a.pointToData(i) : null;
    }, r.prototype.containPoint = function(e) {
      return this.getViewRectAfterRoam().contain(e[0], e[1]);
    }, r.dimensions = ["x", "y"], r;
  }(Ls)
);
function ED(t) {
  var r = t.seriesModel;
  return r ? r.coordinateSystem : null;
}
var gie = {
  geoJSON: {
    aspectScale: 0.75,
    invertLongitute: !0
  },
  geoSVG: {
    aspectScale: 1,
    invertLongitute: !1
  }
}, fB = ["lng", "lat"], D9 = (
  /** @class */
  function(t) {
    ee(r, t);
    function r(e, n, i) {
      var a = t.call(this, e) || this;
      a.dimensions = fB, a.type = "geo", a._nameCoordMap = xe(), a.map = n;
      var o = i.projection, s = qs.load(n, i.nameMap, i.nameProperty), l = qs.getGeoResource(n), u = a.resourceType = l ? l.type : null, c = a.regions = s.regions, d = gie[l.type];
      a._regionsMap = s.regionsMap, a.regions = s.regions, process.env.NODE_ENV !== "production" && o && (u === "geoSVG" && (process.env.NODE_ENV !== "production" && Mr("Map " + n + " with SVG source can't use projection. Only GeoJSON source supports projection."), o = null), o.project && o.unproject || (process.env.NODE_ENV !== "production" && Mr("project and unproject must be both provided in the projeciton."), o = null)), a.projection = o;
      var f;
      if (o)
        for (var h = 0; h < c.length; h++) {
          var p = c[h].getBoundingRect(o);
          f = f || p.clone(), f.union(p);
        }
      else
        f = s.boundingRect;
      return a.setBoundingRect(f.x, f.y, f.width, f.height), a.aspectScale = o ? 1 : je(i.aspectScale, d.aspectScale), a._invertLongitute = o ? !1 : d.invertLongitute, a;
    }
    return r.prototype._transformTo = function(e, n, i, a) {
      var o = this.getBoundingRect(), s = this._invertLongitute;
      o = o.clone(), s && (o.y = -o.y - o.height);
      var l = this._rawTransformable;
      l.transform = o.calculateTransform(new rt(e, n, i, a));
      var u = l.parent;
      l.parent = null, l.decomposeTransform(), l.parent = u, s && (l.scaleY = -l.scaleY), this._updateTransform();
    }, r.prototype.getRegion = function(e) {
      return this._regionsMap.get(e);
    }, r.prototype.getRegionByCoord = function(e) {
      for (var n = this.regions, i = 0; i < n.length; i++) {
        var a = n[i];
        if (a.type === "geoJSON" && a.contain(e))
          return n[i];
      }
    }, r.prototype.addGeoCoord = function(e, n) {
      this._nameCoordMap.set(e, n);
    }, r.prototype.getGeoCoord = function(e) {
      var n = this._regionsMap.get(e);
      return this._nameCoordMap.get(e) || n && n.getCenter();
    }, r.prototype.dataToPoint = function(e, n, i) {
      if (pe(e) && (e = this.getGeoCoord(e)), e) {
        var a = this.projection;
        return a && (e = a.project(e)), e && this.projectedToPoint(e, n, i);
      }
    }, r.prototype.pointToData = function(e) {
      var n = this.projection;
      return n && (e = n.unproject(e)), e && this.pointToProjected(e);
    }, r.prototype.pointToProjected = function(e) {
      return t.prototype.pointToData.call(this, e);
    }, r.prototype.projectedToPoint = function(e, n, i) {
      return t.prototype.dataToPoint.call(this, e, n, i);
    }, r.prototype.convertToPixel = function(e, n, i) {
      var a = kD(n);
      return a === this ? a.dataToPoint(i) : null;
    }, r.prototype.convertFromPixel = function(e, n, i) {
      var a = kD(n);
      return a === this ? a.pointToData(i) : null;
    }, r;
  }(Tg)
);
Xr(D9, Tg);
function kD(t) {
  var r = t.geoModel, e = t.seriesModel;
  return r ? r.coordinateSystem : e ? e.coordinateSystem || (e.getReferringComponents("geo", on).models[0] || {}).coordinateSystem : null;
}
function PD(t, r) {
  var e = t.get("boundingCoords");
  if (e != null) {
    var n = e[0], i = e[1];
    if (!(isFinite(n[0]) && isFinite(n[1]) && isFinite(i[0]) && isFinite(i[1])))
      process.env.NODE_ENV !== "production" && console.error("Invalid boundingCoords");
    else {
      var a = this.projection;
      if (a) {
        var o = n[0], s = n[1], l = i[0], u = i[1];
        n = [1 / 0, 1 / 0], i = [-1 / 0, -1 / 0];
        var c = function(_, x, I, D) {
          for (var T = I - _, A = D - x, M = 0; M <= 100; M++) {
            var R = M / 100, E = a.project([_ + T * R, x + A * R]);
            Ms(n, n, E), Rs(i, i, E);
          }
        };
        c(o, s, l, s), c(l, s, l, u), c(l, u, o, u), c(o, u, l, s);
      }
      this.setBoundingRect(n[0], n[1], i[0] - n[0], i[1] - n[1]);
    }
  }
  var d = this.getBoundingRect(), f = t.get("layoutCenter"), h = t.get("layoutSize"), p = r.getWidth(), v = r.getHeight(), g = d.width / d.height * this.aspectScale, m = !1, y, b;
  f && h && (y = [he(f[0], p), he(f[1], v)], b = he(h, Math.min(p, v)), !isNaN(y[0]) && !isNaN(y[1]) && !isNaN(b) ? m = !0 : process.env.NODE_ENV !== "production" && console.warn("Given layoutCenter or layoutSize data are invalid. Use left/top/width/height instead."));
  var C;
  if (m)
    C = {}, g > 1 ? (C.width = b, C.height = b / g) : (C.height = b, C.width = b * g), C.y = y[1] - C.height / 2, C.x = y[0] - C.width / 2;
  else {
    var w = t.getBoxLayoutParams();
    w.aspect = g, C = cn(w, {
      width: p,
      height: v
    });
  }
  this.setViewRect(C.x, C.y, C.width, C.height), this.setCenter(t.get("center"), r), this.setZoom(t.get("zoom"));
}
function mie(t, r) {
  L(r.get("geoCoord"), function(e, n) {
    t.addGeoCoord(n, e);
  });
}
var yie = (
  /** @class */
  function() {
    function t() {
      this.dimensions = fB;
    }
    return t.prototype.create = function(r, e) {
      var n = [];
      function i(o) {
        return {
          nameProperty: o.get("nameProperty"),
          aspectScale: o.get("aspectScale"),
          projection: o.get("projection")
        };
      }
      r.eachComponent("geo", function(o, s) {
        var l = o.get("map"), u = new D9(l + s, l, ae({
          nameMap: o.get("nameMap")
        }, i(o)));
        u.zoomLimit = o.get("scaleLimit"), n.push(u), o.coordinateSystem = u, u.model = o, u.resize = PD, u.resize(o, e);
      }), r.eachSeries(function(o) {
        var s = o.get("coordinateSystem");
        if (s === "geo") {
          var l = o.get("geoIndex") || 0;
          o.coordinateSystem = n[l];
        }
      });
      var a = {};
      return r.eachSeriesByType("map", function(o) {
        if (!o.getHostGeoModel()) {
          var s = o.getMapType();
          a[s] = a[s] || [], a[s].push(o);
        }
      }), L(a, function(o, s) {
        var l = ce(o, function(c) {
          return c.get("nameMap");
        }), u = new D9(s, s, ae({
          nameMap: $y(l)
        }, i(o[0])));
        u.zoomLimit = Qr.apply(null, ce(o, function(c) {
          return c.get("scaleLimit");
        })), n.push(u), u.resize = PD, u.resize(o[0], e), L(o, function(c) {
          c.coordinateSystem = u, mie(u, c);
        });
      }), n;
    }, t.prototype.getFilledRegions = function(r, e, n, i) {
      for (var a = (r || []).slice(), o = xe(), s = 0; s < a.length; s++)
        o.set(a[s].name, a[s]);
      var l = qs.load(e, n, i);
      return L(l.regions, function(u) {
        var c = u.name;
        !o.get(c) && a.push({
          name: c
        });
      }), a;
    }, t;
  }()
), hB = new yie(), bie = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.init = function(e, n, i) {
      var a = qs.getGeoResource(e.map);
      if (a && a.type === "geoJSON") {
        var o = e.itemStyle = e.itemStyle || {};
        "color" in o || (o.color = "#eee");
      }
      this.mergeDefaultAndTheme(e, i), Vc(e, "label", ["show"]);
    }, r.prototype.optionUpdated = function() {
      var e = this, n = this.option;
      n.regions = hB.getFilledRegions(n.regions, n.map, n.nameMap, n.nameProperty);
      var i = {};
      this._optionModelMap = Ma(n.regions || [], function(a, o) {
        var s = o.name;
        return s && (a.set(s, new Pt(o, e, e.ecModel)), o.selected && (i[s] = !0)), a;
      }, xe()), n.selectedMap || (n.selectedMap = i);
    }, r.prototype.getRegionModel = function(e) {
      return this._optionModelMap.get(e) || new Pt(null, this, this.ecModel);
    }, r.prototype.getFormattedLabel = function(e, n) {
      var i = this.getRegionModel(e), a = n === "normal" ? i.get(["label", "formatter"]) : i.get(["emphasis", "label", "formatter"]), o = {
        name: e
      };
      if (Ae(a))
        return o.status = n, a(o);
      if (pe(a))
        return a.replace("{a}", e ?? "");
    }, r.prototype.setZoom = function(e) {
      this.option.zoom = e;
    }, r.prototype.setCenter = function(e) {
      this.option.center = e;
    }, r.prototype.select = function(e) {
      var n = this.option, i = n.selectedMode;
      if (i) {
        i !== "multiple" && (n.selectedMap = null);
        var a = n.selectedMap || (n.selectedMap = {});
        a[e] = !0;
      }
    }, r.prototype.unSelect = function(e) {
      var n = this.option.selectedMap;
      n && (n[e] = !1);
    }, r.prototype.toggleSelected = function(e) {
      this[this.isSelected(e) ? "unSelect" : "select"](e);
    }, r.prototype.isSelected = function(e) {
      var n = this.option.selectedMap;
      return !!(n && n[e]);
    }, r.type = "geo", r.layoutMode = "box", r.defaultOption = {
      // zlevel: 0,
      z: 0,
      show: !0,
      left: "center",
      top: "center",
      // Default value:
      // for geoSVG source: 1,
      // for geoJSON source: 0.75.
      aspectScale: null,
      // /// Layout with center and size
      // If you want to put map in a fixed size box with right aspect ratio
      // This two properties may be more convenient
      // layoutCenter: [50%, 50%]
      // layoutSize: 100
      silent: !1,
      // Map type
      map: "",
      // Define left-top, right-bottom coords to control view
      // For example, [ [180, 90], [-180, -90] ]
      boundingCoords: null,
      // Default on center of map
      center: null,
      zoom: 1,
      scaleLimit: null,
      // selectedMode: false
      label: {
        show: !1,
        color: "#000"
      },
      itemStyle: {
        borderWidth: 0.5,
        borderColor: "#444"
        // Default color:
        // + geoJSON: #eee
        // + geoSVG: null (use SVG original `fill`)
        // color: '#eee'
      },
      emphasis: {
        label: {
          show: !0,
          color: "rgb(100,0,0)"
        },
        itemStyle: {
          color: "rgba(255,215,0,0.8)"
        }
      },
      select: {
        label: {
          show: !0,
          color: "rgb(100,0,0)"
        },
        itemStyle: {
          color: "rgba(255,215,0,0.8)"
        }
      },
      regions: []
      // tooltip: {
      //     show: false
      // }
    }, r;
  }(st)
);
function ND(t, r) {
  return t.pointToProjected ? t.pointToProjected(r) : t.pointToData(r);
}
function Xw(t, r, e, n) {
  var i = t.getZoom(), a = t.getCenter(), o = r.zoom, s = t.projectedToPoint ? t.projectedToPoint(a) : t.dataToPoint(a);
  if (r.dx != null && r.dy != null && (s[0] -= r.dx, s[1] -= r.dy, t.setCenter(ND(t, s), n)), o != null) {
    if (e) {
      var l = e.min || 0, u = e.max || 1 / 0;
      o = Math.max(Math.min(i * o, u), l) / i;
    }
    t.scaleX *= o, t.scaleY *= o;
    var c = (r.originX - t.x) * (o - 1), d = (r.originY - t.y) * (o - 1);
    t.x -= c, t.y -= d, t.updateTransform(), t.setCenter(ND(t, s), n), t.setZoom(o * i);
  }
  return {
    center: t.getCenter(),
    zoom: t.getZoom()
  };
}
var Cie = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e.focusBlurEnabled = !0, e;
    }
    return r.prototype.init = function(e, n) {
      this._api = n;
    }, r.prototype.render = function(e, n, i, a) {
      if (this._model = e, !e.get("show")) {
        this._mapDraw && this._mapDraw.remove(), this._mapDraw = null;
        return;
      }
      this._mapDraw || (this._mapDraw = new dB(i));
      var o = this._mapDraw;
      o.draw(e, n, i, this, a), o.group.on("click", this._handleRegionClick, this), o.group.silent = e.get("silent"), this.group.add(o.group), this.updateSelectStatus(e, n, i);
    }, r.prototype._handleRegionClick = function(e) {
      var n;
      hc(e.target, function(i) {
        return (n = Ze(i).eventData) != null;
      }, !0), n && this._api.dispatchAction({
        type: "geoToggleSelect",
        geoId: this._model.id,
        name: n.name
      });
    }, r.prototype.updateSelectStatus = function(e, n, i) {
      var a = this;
      this._mapDraw.group.traverse(function(o) {
        var s = Ze(o).eventData;
        if (s)
          return a._model.isSelected(s.name) ? i.enterSelect(o) : i.leaveSelect(o), !0;
      });
    }, r.prototype.findHighDownDispatchers = function(e) {
      return this._mapDraw && this._mapDraw.findHighDownDispatchers(e, this._model);
    }, r.prototype.dispose = function() {
      this._mapDraw && this._mapDraw.remove();
    }, r.type = "geo", r;
  }(yr)
);
function wie(t, r, e) {
  qs.registerMap(t, r, e);
}
function pB(t) {
  t.registerCoordinateSystem("geo", hB), t.registerComponentModel(bie), t.registerComponentView(Cie), t.registerImpl("registerMap", wie), t.registerImpl("getMap", function(e) {
    return qs.getMapForUser(e);
  });
  function r(e, n) {
    n.update = "geo:updateSelectStatus", t.registerAction(n, function(i, a) {
      var o = {}, s = [];
      return a.eachComponent({
        mainType: "geo",
        query: i
      }, function(l) {
        l[e](i.name);
        var u = l.coordinateSystem;
        L(u.regions, function(d) {
          o[d.name] = l.isSelected(d.name) || !1;
        });
        var c = [];
        L(o, function(d, f) {
          o[f] && c.push(f);
        }), s.push({
          geoIndex: l.componentIndex,
          // Use singular, the same naming convention as the event `selectchanged`.
          name: c
        });
      }), {
        selected: o,
        allSelected: s,
        name: i.name
      };
    });
  }
  r("toggleSelected", {
    type: "geoToggleSelect",
    event: "geoselectchanged"
  }), r("select", {
    type: "geoSelect",
    event: "geoselected"
  }), r("unSelect", {
    type: "geoUnSelect",
    event: "geounselected"
  }), t.registerAction({
    type: "geoRoam",
    event: "geoRoam",
    update: "updateTransform"
  }, function(e, n, i) {
    var a = e.componentType || "series";
    n.eachComponent({
      mainType: a,
      query: e
    }, function(o) {
      var s = o.coordinateSystem;
      if (s.type === "geo") {
        var l = Xw(s, e, o.get("scaleLimit"), i);
        o.setCenter && o.setCenter(l.center), o.setZoom && o.setZoom(l.zoom), a === "series" && L(o.seriesGroup, function(u) {
          u.setCenter(l.center), u.setZoom(l.zoom);
        });
      }
    });
  });
}
function _ie(t) {
  lt(pB), t.registerChartView(die), t.registerSeriesModel(fie), t.registerLayout(vie), t.registerProcessor(t.PRIORITY.PROCESSOR.STATISTIC, pie), pV("map", t.registerAction);
}
function xie(t) {
  var r = t;
  r.hierNode = {
    defaultAncestor: null,
    ancestor: r,
    prelim: 0,
    modifier: 0,
    change: 0,
    shift: 0,
    i: 0,
    thread: null
  };
  for (var e = [r], n, i; n = e.pop(); )
    if (i = n.children, n.isExpand && i.length)
      for (var a = i.length, o = a - 1; o >= 0; o--) {
        var s = i[o];
        s.hierNode = {
          defaultAncestor: null,
          ancestor: s,
          prelim: 0,
          modifier: 0,
          change: 0,
          shift: 0,
          i: o,
          thread: null
        }, e.push(s);
      }
}
function Sie(t, r) {
  var e = t.isExpand ? t.children : [], n = t.parentNode.children, i = t.hierNode.i ? n[t.hierNode.i - 1] : null;
  if (e.length) {
    Die(t);
    var a = (e[0].hierNode.prelim + e[e.length - 1].hierNode.prelim) / 2;
    i ? (t.hierNode.prelim = i.hierNode.prelim + r(t, i), t.hierNode.modifier = t.hierNode.prelim - a) : t.hierNode.prelim = a;
  } else i && (t.hierNode.prelim = i.hierNode.prelim + r(t, i));
  t.parentNode.hierNode.defaultAncestor = Tie(t, i, t.parentNode.hierNode.defaultAncestor || n[0], r);
}
function Iie(t) {
  var r = t.hierNode.prelim + t.parentNode.hierNode.modifier;
  t.setLayout({
    x: r
  }, !0), t.hierNode.modifier += t.parentNode.hierNode.modifier;
}
function OD(t) {
  return arguments.length ? t : Lie;
}
function kp(t, r) {
  return t -= Math.PI / 2, {
    x: r * Math.cos(t),
    y: r * Math.sin(t)
  };
}
function Aie(t, r) {
  return cn(t.getBoxLayoutParams(), {
    width: r.getWidth(),
    height: r.getHeight()
  });
}
function Die(t) {
  for (var r = t.children, e = r.length, n = 0, i = 0; --e >= 0; ) {
    var a = r[e];
    a.hierNode.prelim += n, a.hierNode.modifier += n, i += a.hierNode.change, n += a.hierNode.shift + i;
  }
}
function Tie(t, r, e, n) {
  if (r) {
    for (var i = t, a = t, o = a.parentNode.children[0], s = r, l = i.hierNode.modifier, u = a.hierNode.modifier, c = o.hierNode.modifier, d = s.hierNode.modifier; s = Jb(s), a = Kb(a), s && a; ) {
      i = Jb(i), o = Kb(o), i.hierNode.ancestor = t;
      var f = s.hierNode.prelim + d - a.hierNode.prelim - u + n(s, a);
      f > 0 && (Rie(Mie(s, t, e), t, f), u += f, l += f), d += s.hierNode.modifier, u += a.hierNode.modifier, l += i.hierNode.modifier, c += o.hierNode.modifier;
    }
    s && !Jb(i) && (i.hierNode.thread = s, i.hierNode.modifier += d - l), a && !Kb(o) && (o.hierNode.thread = a, o.hierNode.modifier += u - c, e = t);
  }
  return e;
}
function Jb(t) {
  var r = t.children;
  return r.length && t.isExpand ? r[r.length - 1] : t.hierNode.thread;
}
function Kb(t) {
  var r = t.children;
  return r.length && t.isExpand ? r[0] : t.hierNode.thread;
}
function Mie(t, r, e) {
  return t.hierNode.ancestor.parentNode === r.parentNode ? t.hierNode.ancestor : e;
}
function Rie(t, r, e) {
  var n = e / (r.hierNode.i - t.hierNode.i);
  r.hierNode.change -= n, r.hierNode.shift += e, r.hierNode.modifier += e, r.hierNode.prelim += e, t.hierNode.change += n;
}
function Lie(t, r) {
  return t.parentNode === r.parentNode ? 1 : 2;
}
var Eie = (
  /** @class */
  /* @__PURE__ */ function() {
    function t() {
      this.parentPoint = [], this.childPoints = [];
    }
    return t;
  }()
), kie = (
  /** @class */
  function(t) {
    ee(r, t);
    function r(e) {
      return t.call(this, e) || this;
    }
    return r.prototype.getDefaultStyle = function() {
      return {
        stroke: "#000",
        fill: null
      };
    }, r.prototype.getDefaultShape = function() {
      return new Eie();
    }, r.prototype.buildPath = function(e, n) {
      var i = n.childPoints, a = i.length, o = n.parentPoint, s = i[0], l = i[a - 1];
      if (a === 1) {
        e.moveTo(o[0], o[1]), e.lineTo(s[0], s[1]);
        return;
      }
      var u = n.orient, c = u === "TB" || u === "BT" ? 0 : 1, d = 1 - c, f = he(n.forkPosition, 1), h = [];
      h[c] = o[c], h[d] = o[d] + (l[d] - o[d]) * f, e.moveTo(o[0], o[1]), e.lineTo(h[0], h[1]), e.moveTo(s[0], s[1]), h[c] = s[c], e.lineTo(h[0], h[1]), h[c] = l[c], e.lineTo(h[0], h[1]), e.lineTo(l[0], l[1]);
      for (var p = 1; p < a - 1; p++) {
        var v = i[p];
        e.moveTo(v[0], v[1]), h[c] = v[c], e.lineTo(h[0], h[1]);
      }
    }, r;
  }(gt)
), Pie = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e._mainGroup = new ze(), e;
    }
    return r.prototype.init = function(e, n) {
      this._controller = new Dg(n.getZr()), this._controllerHost = {
        target: this.group
      }, this.group.add(this._mainGroup);
    }, r.prototype.render = function(e, n, i) {
      var a = e.getData(), o = e.layoutInfo, s = this._mainGroup, l = e.get("layout");
      l === "radial" ? (s.x = o.x + o.width / 2, s.y = o.y + o.height / 2) : (s.x = o.x, s.y = o.y), this._updateViewCoordSys(e, i), this._updateController(e, n, i);
      var u = this._data;
      a.diff(u).add(function(c) {
        VD(a, c) && GD(a, c, null, s, e);
      }).update(function(c, d) {
        var f = u.getItemGraphicEl(d);
        if (!VD(a, c)) {
          f && FD(u, d, f, s, e);
          return;
        }
        GD(a, c, f, s, e);
      }).remove(function(c) {
        var d = u.getItemGraphicEl(c);
        d && FD(u, c, d, s, e);
      }).execute(), this._nodeScaleRatio = e.get("nodeScaleRatio"), this._updateNodeAndLinkScale(e), e.get("expandAndCollapse") === !0 && a.eachItemGraphicEl(function(c, d) {
        c.off("click").on("click", function() {
          i.dispatchAction({
            type: "treeExpandAndCollapse",
            seriesId: e.id,
            dataIndex: d
          });
        });
      }), this._data = a;
    }, r.prototype._updateViewCoordSys = function(e, n) {
      var i = e.getData(), a = [];
      i.each(function(d) {
        var f = i.getItemLayout(d);
        f && !isNaN(f.x) && !isNaN(f.y) && a.push([+f.x, +f.y]);
      });
      var o = [], s = [];
      s2(a, o, s);
      var l = this._min, u = this._max;
      s[0] - o[0] === 0 && (o[0] = l ? l[0] : o[0] - 1, s[0] = u ? u[0] : s[0] + 1), s[1] - o[1] === 0 && (o[1] = l ? l[1] : o[1] - 1, s[1] = u ? u[1] : s[1] + 1);
      var c = e.coordinateSystem = new Tg();
      c.zoomLimit = e.get("scaleLimit"), c.setBoundingRect(o[0], o[1], s[0] - o[0], s[1] - o[1]), c.setCenter(e.get("center"), n), c.setZoom(e.get("zoom")), this.group.attr({
        x: c.x,
        y: c.y,
        scaleX: c.scaleX,
        scaleY: c.scaleY
      }), this._min = o, this._max = s;
    }, r.prototype._updateController = function(e, n, i) {
      var a = this, o = this._controller, s = this._controllerHost, l = this.group;
      o.setPointerChecker(function(u, c, d) {
        var f = l.getBoundingRect();
        return f.applyTransform(l.transform), f.contain(c, d) && !R2(u, i, e);
      }), o.enable(e.get("roam")), s.zoomLimit = e.get("scaleLimit"), s.zoom = e.coordinateSystem.getZoom(), o.off("pan").off("zoom").on("pan", function(u) {
        Zw(s, u.dx, u.dy), i.dispatchAction({
          seriesId: e.id,
          type: "treeRoam",
          dx: u.dx,
          dy: u.dy
        });
      }).on("zoom", function(u) {
        jw(s, u.scale, u.originX, u.originY), i.dispatchAction({
          seriesId: e.id,
          type: "treeRoam",
          zoom: u.scale,
          originX: u.originX,
          originY: u.originY
        }), a._updateNodeAndLinkScale(e), i.updateLabelLayout();
      });
    }, r.prototype._updateNodeAndLinkScale = function(e) {
      var n = e.getData(), i = this._getNodeGlobalScale(e);
      n.eachItemGraphicEl(function(a, o) {
        a.setSymbolScale(i);
      });
    }, r.prototype._getNodeGlobalScale = function(e) {
      var n = e.coordinateSystem;
      if (n.type !== "view")
        return 1;
      var i = this._nodeScaleRatio, a = n.scaleX || 1, o = n.getZoom(), s = (o - 1) * i + 1;
      return s / a;
    }, r.prototype.dispose = function() {
      this._controller && this._controller.dispose(), this._controllerHost = null;
    }, r.prototype.remove = function() {
      this._mainGroup.removeAll(), this._data = null;
    }, r.type = "tree", r;
  }(Yt)
);
function VD(t, r) {
  var e = t.getItemLayout(r);
  return e && !isNaN(e.x) && !isNaN(e.y);
}
function GD(t, r, e, n, i) {
  var a = !e, o = t.tree.getNodeByDataIndex(r), s = o.getModel(), l = o.getVisual("style").fill, u = o.isExpand === !1 && o.children.length !== 0 ? l : "#fff", c = t.tree.root, d = o.parentNode === c ? o : o.parentNode || o, f = t.getItemGraphicEl(d.dataIndex), h = d.getLayout(), p = f ? {
    x: f.__oldX,
    y: f.__oldY,
    rawX: f.__radialOldRawX,
    rawY: f.__radialOldRawY
  } : h, v = o.getLayout();
  a ? (e = new wg(t, r, null, {
    symbolInnerColor: u,
    useNameLabel: !0
  }), e.x = p.x, e.y = p.y) : e.updateData(t, r, null, {
    symbolInnerColor: u,
    useNameLabel: !0
  }), e.__radialOldRawX = e.__radialRawX, e.__radialOldRawY = e.__radialRawY, e.__radialRawX = v.rawX, e.__radialRawY = v.rawY, n.add(e), t.setItemGraphicEl(r, e), e.__oldX = e.x, e.__oldY = e.y, kt(e, {
    x: v.x,
    y: v.y
  }, i);
  var g = e.getSymbolPath();
  if (i.get("layout") === "radial") {
    var m = c.children[0], y = m.getLayout(), b = m.children.length, C = void 0, w = void 0;
    if (v.x === y.x && o.isExpand === !0 && m.children.length) {
      var _ = {
        x: (m.children[0].getLayout().x + m.children[b - 1].getLayout().x) / 2,
        y: (m.children[0].getLayout().y + m.children[b - 1].getLayout().y) / 2
      };
      C = Math.atan2(_.y - y.y, _.x - y.x), C < 0 && (C = Math.PI * 2 + C), w = _.x < y.x, w && (C = C - Math.PI);
    } else
      C = Math.atan2(v.y - y.y, v.x - y.x), C < 0 && (C = Math.PI * 2 + C), o.children.length === 0 || o.children.length !== 0 && o.isExpand === !1 ? (w = v.x < y.x, w && (C = C - Math.PI)) : (w = v.x > y.x, w || (C = C - Math.PI));
    var x = w ? "left" : "right", I = s.getModel("label"), D = I.get("rotate"), T = D * (Math.PI / 180), A = g.getTextContent();
    A && (g.setTextConfig({
      position: I.get("position") || x,
      rotation: D == null ? -C : T,
      origin: "center"
    }), A.setStyle("verticalAlign", "middle"));
  }
  var M = s.get(["emphasis", "focus"]), R = M === "relative" ? hv(o.getAncestorsIndices(), o.getDescendantIndices()) : M === "ancestor" ? o.getAncestorsIndices() : M === "descendant" ? o.getDescendantIndices() : null;
  R && (Ze(e).focus = R), Nie(i, o, c, e, p, h, v, n), e.__edge && (e.onHoverStateChange = function(E) {
    if (E !== "blur") {
      var k = o.parentNode && t.getItemGraphicEl(o.parentNode.dataIndex);
      k && k.hoverState === hg || bm(e.__edge, E);
    }
  });
}
function Nie(t, r, e, n, i, a, o, s) {
  var l = r.getModel(), u = t.get("edgeShape"), c = t.get("layout"), d = t.getOrient(), f = t.get(["lineStyle", "curveness"]), h = t.get("edgeForkPosition"), p = l.getModel("lineStyle").getLineStyle(), v = n.__edge;
  if (u === "curve")
    r.parentNode && r.parentNode !== e && (v || (v = n.__edge = new th({
      shape: T9(c, d, f, i, i)
    })), kt(v, {
      shape: T9(c, d, f, a, o)
    }, t));
  else if (u === "polyline") {
    if (c === "orthogonal") {
      if (r !== e && r.children && r.children.length !== 0 && r.isExpand === !0) {
        for (var g = r.children, m = [], y = 0; y < g.length; y++) {
          var b = g[y].getLayout();
          m.push([b.x, b.y]);
        }
        v || (v = n.__edge = new kie({
          shape: {
            parentPoint: [o.x, o.y],
            childPoints: [[o.x, o.y]],
            orient: d,
            forkPosition: h
          }
        })), kt(v, {
          shape: {
            parentPoint: [o.x, o.y],
            childPoints: m
          }
        }, t);
      }
    } else if (process.env.NODE_ENV !== "production")
      throw new Error("The polyline edgeShape can only be used in orthogonal layout");
  }
  v && !(u === "polyline" && !r.isExpand) && (v.useStyle(Ee({
    strokeNoScale: !0,
    fill: null
  }, p)), Yn(v, l, "lineStyle"), Fc(v), s.add(v));
}
function BD(t, r, e, n, i) {
  var a = r.tree.root, o = vB(a, t), s = o.source, l = o.sourceLayout, u = r.getItemGraphicEl(t.dataIndex);
  if (u) {
    var c = r.getItemGraphicEl(s.dataIndex), d = c.__edge, f = u.__edge || (s.isExpand === !1 || s.children.length === 1 ? d : void 0), h = n.get("edgeShape"), p = n.get("layout"), v = n.get("orient"), g = n.get(["lineStyle", "curveness"]);
    f && (h === "curve" ? tu(f, {
      shape: T9(p, v, g, l, l),
      style: {
        opacity: 0
      }
    }, n, {
      cb: function() {
        e.remove(f);
      },
      removeOpt: i
    }) : h === "polyline" && n.get("layout") === "orthogonal" && tu(f, {
      shape: {
        parentPoint: [l.x, l.y],
        childPoints: [[l.x, l.y]]
      },
      style: {
        opacity: 0
      }
    }, n, {
      cb: function() {
        e.remove(f);
      },
      removeOpt: i
    }));
  }
}
function vB(t, r) {
  for (var e = r.parentNode === t ? r : r.parentNode || r, n; n = e.getLayout(), n == null; )
    e = e.parentNode === t ? e : e.parentNode || e;
  return {
    source: e,
    sourceLayout: n
  };
}
function FD(t, r, e, n, i) {
  var a = t.tree.getNodeByDataIndex(r), o = t.tree.root, s = vB(o, a).sourceLayout, l = {
    duration: i.get("animationDurationUpdate"),
    easing: i.get("animationEasingUpdate")
  };
  tu(e, {
    x: s.x + 1,
    y: s.y + 1
  }, i, {
    cb: function() {
      n.remove(e), t.setItemGraphicEl(r, null);
    },
    removeOpt: l
  }), e.fadeOut(null, t.hostModel, {
    fadeLabel: !0,
    animation: l
  }), a.children.forEach(function(u) {
    BD(u, t, n, i, l);
  }), BD(a, t, n, i, l);
}
function T9(t, r, e, n, i) {
  var a, o, s, l, u, c, d, f;
  if (t === "radial") {
    u = n.rawX, d = n.rawY, c = i.rawX, f = i.rawY;
    var h = kp(u, d), p = kp(u, d + (f - d) * e), v = kp(c, f + (d - f) * e), g = kp(c, f);
    return {
      x1: h.x || 0,
      y1: h.y || 0,
      x2: g.x || 0,
      y2: g.y || 0,
      cpx1: p.x || 0,
      cpy1: p.y || 0,
      cpx2: v.x || 0,
      cpy2: v.y || 0
    };
  } else
    u = n.x, d = n.y, c = i.x, f = i.y, (r === "LR" || r === "RL") && (a = u + (c - u) * e, o = d, s = c + (u - c) * e, l = f), (r === "TB" || r === "BT") && (a = u, o = d + (f - d) * e, s = c, l = f + (d - f) * e);
  return {
    x1: u,
    y1: d,
    x2: c,
    y2: f,
    cpx1: a,
    cpy1: o,
    cpx2: s,
    cpy2: l
  };
}
var Ta = It();
function gB(t) {
  var r = t.mainData, e = t.datas;
  e || (e = {
    main: r
  }, t.datasAttr = {
    main: "data"
  }), t.datas = t.mainData = null, mB(r, e, t), L(e, function(n) {
    L(r.TRANSFERABLE_METHODS, function(i) {
      n.wrapMethod(i, Ye(Oie, t));
    });
  }), r.wrapMethod("cloneShallow", Ye(Gie, t)), L(r.CHANGABLE_METHODS, function(n) {
    r.wrapMethod(n, Ye(Vie, t));
  }), ke(e[r.dataType] === r);
}
function Oie(t, r) {
  if (Hie(this)) {
    var e = ae({}, Ta(this).datas);
    e[this.dataType] = r, mB(r, e, t);
  } else
    $w(r, this.dataType, Ta(this).mainData, t);
  return r;
}
function Vie(t, r) {
  return t.struct && t.struct.update(), r;
}
function Gie(t, r) {
  return L(Ta(r).datas, function(e, n) {
    e !== r && $w(e.cloneShallow(), n, r, t);
  }), r;
}
function Bie(t) {
  var r = Ta(this).mainData;
  return t == null || r == null ? r : Ta(r).datas[t];
}
function Fie() {
  var t = Ta(this).mainData;
  return t == null ? [{
    data: t
  }] : ce(yt(Ta(t).datas), function(r) {
    return {
      type: r,
      data: Ta(t).datas[r]
    };
  });
}
function Hie(t) {
  return Ta(t).mainData === t;
}
function mB(t, r, e) {
  Ta(t).datas = {}, L(r, function(n, i) {
    $w(n, i, t, e);
  });
}
function $w(t, r, e, n) {
  Ta(e).datas[r] = t, Ta(t).mainData = e, t.dataType = r, n.struct && (t[n.structAttr] = n.struct, n.struct[n.datasAttr[r]] = t), t.getLinkedData = Bie, t.getLinkedDataAll = Fie;
}
var zie = (
  /** @class */
  function() {
    function t(r, e) {
      this.depth = 0, this.height = 0, this.dataIndex = -1, this.children = [], this.viewChildren = [], this.isExpand = !1, this.name = r || "", this.hostTree = e;
    }
    return t.prototype.isRemoved = function() {
      return this.dataIndex < 0;
    }, t.prototype.eachNode = function(r, e, n) {
      Ae(r) && (n = e, e = r, r = null), r = r || {}, pe(r) && (r = {
        order: r
      });
      var i = r.order || "preorder", a = this[r.attr || "children"], o;
      i === "preorder" && (o = e.call(n, this));
      for (var s = 0; !o && s < a.length; s++)
        a[s].eachNode(r, e, n);
      i === "postorder" && e.call(n, this);
    }, t.prototype.updateDepthAndHeight = function(r) {
      var e = 0;
      this.depth = r;
      for (var n = 0; n < this.children.length; n++) {
        var i = this.children[n];
        i.updateDepthAndHeight(r + 1), i.height > e && (e = i.height);
      }
      this.height = e + 1;
    }, t.prototype.getNodeById = function(r) {
      if (this.getId() === r)
        return this;
      for (var e = 0, n = this.children, i = n.length; e < i; e++) {
        var a = n[e].getNodeById(r);
        if (a)
          return a;
      }
    }, t.prototype.contains = function(r) {
      if (r === this)
        return !0;
      for (var e = 0, n = this.children, i = n.length; e < i; e++) {
        var a = n[e].contains(r);
        if (a)
          return a;
      }
    }, t.prototype.getAncestors = function(r) {
      for (var e = [], n = r ? this : this.parentNode; n; )
        e.push(n), n = n.parentNode;
      return e.reverse(), e;
    }, t.prototype.getAncestorsIndices = function() {
      for (var r = [], e = this; e; )
        r.push(e.dataIndex), e = e.parentNode;
      return r.reverse(), r;
    }, t.prototype.getDescendantIndices = function() {
      var r = [];
      return this.eachNode(function(e) {
        r.push(e.dataIndex);
      }), r;
    }, t.prototype.getValue = function(r) {
      var e = this.hostTree.data;
      return e.getStore().get(e.getDimensionIndex(r || "value"), this.dataIndex);
    }, t.prototype.setLayout = function(r, e) {
      this.dataIndex >= 0 && this.hostTree.data.setItemLayout(this.dataIndex, r, e);
    }, t.prototype.getLayout = function() {
      return this.hostTree.data.getItemLayout(this.dataIndex);
    }, t.prototype.getModel = function(r) {
      if (!(this.dataIndex < 0)) {
        var e = this.hostTree, n = e.data.getItemModel(this.dataIndex);
        return n.getModel(r);
      }
    }, t.prototype.getLevelModel = function() {
      return (this.hostTree.levelModels || [])[this.depth];
    }, t.prototype.setVisual = function(r, e) {
      this.dataIndex >= 0 && this.hostTree.data.setItemVisual(this.dataIndex, r, e);
    }, t.prototype.getVisual = function(r) {
      return this.hostTree.data.getItemVisual(this.dataIndex, r);
    }, t.prototype.getRawIndex = function() {
      return this.hostTree.data.getRawIndex(this.dataIndex);
    }, t.prototype.getId = function() {
      return this.hostTree.data.getId(this.dataIndex);
    }, t.prototype.getChildIndex = function() {
      if (this.parentNode) {
        for (var r = this.parentNode.children, e = 0; e < r.length; ++e)
          if (r[e] === this)
            return e;
        return -1;
      }
      return -1;
    }, t.prototype.isAncestorOf = function(r) {
      for (var e = r.parentNode; e; ) {
        if (e === this)
          return !0;
        e = e.parentNode;
      }
      return !1;
    }, t.prototype.isDescendantOf = function(r) {
      return r !== this && r.isAncestorOf(this);
    }, t;
  }()
), Uw = (
  /** @class */
  function() {
    function t(r) {
      this.type = "tree", this._nodes = [], this.hostModel = r;
    }
    return t.prototype.eachNode = function(r, e, n) {
      this.root.eachNode(r, e, n);
    }, t.prototype.getNodeByDataIndex = function(r) {
      var e = this.data.getRawIndex(r);
      return this._nodes[e];
    }, t.prototype.getNodeById = function(r) {
      return this.root.getNodeById(r);
    }, t.prototype.update = function() {
      for (var r = this.data, e = this._nodes, n = 0, i = e.length; n < i; n++)
        e[n].dataIndex = -1;
      for (var n = 0, i = r.count(); n < i; n++)
        e[r.getRawIndex(n)].dataIndex = n;
    }, t.prototype.clearLayouts = function() {
      this.data.clearItemLayouts();
    }, t.createTree = function(r, e, n) {
      var i = new t(e), a = [], o = 1;
      s(r);
      function s(c, d) {
        var f = c.value;
        o = Math.max(o, ue(f) ? f.length : 1), a.push(c);
        var h = new zie(vn(c.name, ""), i);
        d ? Wie(h, d) : i.root = h, i._nodes.push(h);
        var p = c.children;
        if (p)
          for (var v = 0; v < p.length; v++)
            s(p[v], h);
      }
      i.root.updateDepthAndHeight(0);
      var l = hh(a, {
        coordDimensions: ["value"],
        dimensionsCount: o
      }).dimensions, u = new ni(l, e);
      return u.initData(a), n && n(u), gB({
        mainData: u,
        struct: i,
        structAttr: "tree"
      }), i.update(), i;
    }, t;
  }()
);
function Wie(t, r) {
  var e = r.children;
  t.parentNode !== r && (e.push(t), t.parentNode = r);
}
function kv(t, r, e) {
  if (t && nt(r, t.type) >= 0) {
    var n = e.getData().tree.root, i = t.targetNode;
    if (pe(i) && (i = n.getNodeById(i)), i && n.contains(i))
      return {
        node: i
      };
    var a = t.targetNodeId;
    if (a != null && (i = n.getNodeById(a)))
      return {
        node: i
      };
  }
}
function yB(t) {
  for (var r = []; t; )
    t = t.parentNode, t && r.push(t);
  return r.reverse();
}
function Jw(t, r) {
  var e = yB(t);
  return nt(e, r) >= 0;
}
function E2(t, r) {
  for (var e = []; t; ) {
    var n = t.dataIndex;
    e.push({
      name: t.name,
      dataIndex: n,
      value: r.getRawValue(n)
    }), t = t.parentNode;
  }
  return e.reverse(), e;
}
var Zie = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.hasSymbolVisual = !0, e.ignoreStyleOnData = !0, e;
    }
    return r.prototype.getInitialData = function(e) {
      var n = {
        name: e.name,
        children: e.data
      }, i = e.leaves || {}, a = new Pt(i, this, this.ecModel), o = Uw.createTree(n, this, s);
      function s(d) {
        d.wrapMethod("getItemModel", function(f, h) {
          var p = o.getNodeByDataIndex(h);
          return p && p.children.length && p.isExpand || (f.parentModel = a), f;
        });
      }
      var l = 0;
      o.eachNode("preorder", function(d) {
        d.depth > l && (l = d.depth);
      });
      var u = e.expandAndCollapse, c = u && e.initialTreeDepth >= 0 ? e.initialTreeDepth : l;
      return o.root.eachNode("preorder", function(d) {
        var f = d.hostTree.data.getRawDataItem(d.dataIndex);
        d.isExpand = f && f.collapsed != null ? !f.collapsed : d.depth <= c;
      }), o.data;
    }, r.prototype.getOrient = function() {
      var e = this.get("orient");
      return e === "horizontal" ? e = "LR" : e === "vertical" && (e = "TB"), e;
    }, r.prototype.setZoom = function(e) {
      this.option.zoom = e;
    }, r.prototype.setCenter = function(e) {
      this.option.center = e;
    }, r.prototype.formatTooltip = function(e, n, i) {
      for (var a = this.getData().tree, o = a.root.children[0], s = a.getNodeByDataIndex(e), l = s.getValue(), u = s.name; s && s !== o; )
        u = s.parentNode.name + "." + u, s = s.parentNode;
      return Sn("nameValue", {
        name: u,
        value: l,
        noValue: isNaN(l) || l == null
      });
    }, r.prototype.getDataParams = function(e) {
      var n = t.prototype.getDataParams.apply(this, arguments), i = this.getData().tree.getNodeByDataIndex(e);
      return n.treeAncestors = E2(i, this), n.collapsed = !i.isExpand, n;
    }, r.type = "series.tree", r.layoutMode = "box", r.defaultOption = {
      // zlevel: 0,
      z: 2,
      coordinateSystem: "view",
      // the position of the whole view
      left: "12%",
      top: "12%",
      right: "12%",
      bottom: "12%",
      // the layout of the tree, two value can be selected, 'orthogonal' or 'radial'
      layout: "orthogonal",
      // value can be 'polyline'
      edgeShape: "curve",
      edgeForkPosition: "50%",
      // true | false | 'move' | 'scale', see module:component/helper/RoamController.
      roam: !1,
      // Symbol size scale ratio in roam
      nodeScaleRatio: 0.4,
      // Default on center of graph
      center: null,
      zoom: 1,
      orient: "LR",
      symbol: "emptyCircle",
      symbolSize: 7,
      expandAndCollapse: !0,
      initialTreeDepth: 2,
      lineStyle: {
        color: "#ccc",
        width: 1.5,
        curveness: 0.5
      },
      itemStyle: {
        color: "lightsteelblue",
        // borderColor: '#c23531',
        borderWidth: 1.5
      },
      label: {
        show: !0
      },
      animationEasing: "linear",
      animationDuration: 700,
      animationDurationUpdate: 500
    }, r;
  }(tr)
);
function jie(t, r, e) {
  for (var n = [t], i = [], a; a = n.pop(); )
    if (i.push(a), a.isExpand) {
      var o = a.children;
      if (o.length)
        for (var s = 0; s < o.length; s++)
          n.push(o[s]);
    }
  for (; a = i.pop(); )
    r(a, e);
}
function ep(t, r) {
  for (var e = [t], n; n = e.pop(); )
    if (r(n), n.isExpand) {
      var i = n.children;
      if (i.length)
        for (var a = i.length - 1; a >= 0; a--)
          e.push(i[a]);
    }
}
function Yie(t, r) {
  t.eachSeriesByType("tree", function(e) {
    Xie(e, r);
  });
}
function Xie(t, r) {
  var e = Aie(t, r);
  t.layoutInfo = e;
  var n = t.get("layout"), i = 0, a = 0, o = null;
  n === "radial" ? (i = 2 * Math.PI, a = Math.min(e.height, e.width) / 2, o = OD(function(b, C) {
    return (b.parentNode === C.parentNode ? 1 : 2) / b.depth;
  })) : (i = e.width, a = e.height, o = OD());
  var s = t.getData().tree.root, l = s.children[0];
  if (l) {
    xie(s), jie(l, Sie, o), s.hierNode.modifier = -l.hierNode.prelim, ep(l, Iie);
    var u = l, c = l, d = l;
    ep(l, function(b) {
      var C = b.getLayout().x;
      C < u.getLayout().x && (u = b), C > c.getLayout().x && (c = b), b.depth > d.depth && (d = b);
    });
    var f = u === c ? 1 : o(u, c) / 2, h = f - u.getLayout().x, p = 0, v = 0, g = 0, m = 0;
    if (n === "radial")
      p = i / (c.getLayout().x + f + h), v = a / (d.depth - 1 || 1), ep(l, function(b) {
        g = (b.getLayout().x + h) * p, m = (b.depth - 1) * v;
        var C = kp(g, m);
        b.setLayout({
          x: C.x,
          y: C.y,
          rawX: g,
          rawY: m
        }, !0);
      });
    else {
      var y = t.getOrient();
      y === "RL" || y === "LR" ? (v = a / (c.getLayout().x + f + h), p = i / (d.depth - 1 || 1), ep(l, function(b) {
        m = (b.getLayout().x + h) * v, g = y === "LR" ? (b.depth - 1) * p : i - (b.depth - 1) * p, b.setLayout({
          x: g,
          y: m
        }, !0);
      })) : (y === "TB" || y === "BT") && (p = i / (c.getLayout().x + f + h), v = a / (d.depth - 1 || 1), ep(l, function(b) {
        g = (b.getLayout().x + h) * p, m = y === "TB" ? (b.depth - 1) * v : a - (b.depth - 1) * v, b.setLayout({
          x: g,
          y: m
        }, !0);
      }));
    }
  }
}
function $ie(t) {
  t.eachSeriesByType("tree", function(r) {
    var e = r.getData(), n = e.tree;
    n.eachNode(function(i) {
      var a = i.getModel(), o = a.getModel("itemStyle").getItemStyle(), s = e.ensureUniqueItemVisual(i.dataIndex, "style");
      ae(s, o);
    });
  });
}
function Uie(t) {
  t.registerAction({
    type: "treeExpandAndCollapse",
    event: "treeExpandAndCollapse",
    update: "update"
  }, function(r, e) {
    e.eachComponent({
      mainType: "series",
      subType: "tree",
      query: r
    }, function(n) {
      var i = r.dataIndex, a = n.getData().tree, o = a.getNodeByDataIndex(i);
      o.isExpand = !o.isExpand;
    });
  }), t.registerAction({
    type: "treeRoam",
    event: "treeRoam",
    // Here we set 'none' instead of 'update', because roam action
    // just need to update the transform matrix without having to recalculate
    // the layout. So don't need to go through the whole update process, such
    // as 'dataPrcocess', 'coordSystemUpdate', 'layout' and so on.
    update: "none"
  }, function(r, e, n) {
    e.eachComponent({
      mainType: "series",
      subType: "tree",
      query: r
    }, function(i) {
      var a = i.coordinateSystem, o = Xw(a, r, void 0, n);
      i.setCenter && i.setCenter(o.center), i.setZoom && i.setZoom(o.zoom);
    });
  });
}
function Jie(t) {
  t.registerChartView(Pie), t.registerSeriesModel(Zie), t.registerLayout(Yie), t.registerVisual($ie), Uie(t);
}
var HD = ["treemapZoomToNode", "treemapRender", "treemapMove"];
function Kie(t) {
  for (var r = 0; r < HD.length; r++)
    t.registerAction({
      type: HD[r],
      update: "updateView"
    }, Yr);
  t.registerAction({
    type: "treemapRootToNode",
    update: "updateView"
  }, function(e, n) {
    n.eachComponent({
      mainType: "series",
      subType: "treemap",
      query: e
    }, i);
    function i(a, o) {
      var s = ["treemapZoomToNode", "treemapRootToNode"], l = kv(e, s, a);
      if (l) {
        var u = a.getViewRoot();
        u && (e.direction = Jw(u, l.node) ? "rollUp" : "drillDown"), a.resetViewRoot(l.node);
      }
    }
  });
}
function bB(t) {
  var r = t.getData(), e = r.tree, n = {};
  e.eachNode(function(i) {
    for (var a = i; a && a.depth > 1; )
      a = a.parentNode;
    var o = t9(t.ecModel, a.name || a.dataIndex + "", n);
    i.setVisual("decal", o);
  });
}
var qie = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e.preventUsingHoverLayer = !0, e;
    }
    return r.prototype.getInitialData = function(e, n) {
      var i = {
        name: e.name,
        children: e.data
      };
      CB(i);
      var a = e.levels || [], o = this.designatedVisualItemStyle = {}, s = new Pt({
        itemStyle: o
      }, this, n);
      a = e.levels = Qie(a, n);
      var l = ce(a || [], function(d) {
        return new Pt(d, s, n);
      }, this), u = Uw.createTree(i, this, c);
      function c(d) {
        d.wrapMethod("getItemModel", function(f, h) {
          var p = u.getNodeByDataIndex(h), v = p ? l[p.depth] : null;
          return f.parentModel = v || s, f;
        });
      }
      return u.data;
    }, r.prototype.optionUpdated = function() {
      this.resetViewRoot();
    }, r.prototype.formatTooltip = function(e, n, i) {
      var a = this.getData(), o = this.getRawValue(e), s = a.getName(e);
      return Sn("nameValue", {
        name: s,
        value: o
      });
    }, r.prototype.getDataParams = function(e) {
      var n = t.prototype.getDataParams.apply(this, arguments), i = this.getData().tree.getNodeByDataIndex(e);
      return n.treeAncestors = E2(i, this), n.treePathInfo = n.treeAncestors, n;
    }, r.prototype.setLayoutInfo = function(e) {
      this.layoutInfo = this.layoutInfo || {}, ae(this.layoutInfo, e);
    }, r.prototype.mapIdToIndex = function(e) {
      var n = this._idIndexMap;
      n || (n = this._idIndexMap = xe(), this._idIndexMapCount = 0);
      var i = n.get(e);
      return i == null && n.set(e, i = this._idIndexMapCount++), i;
    }, r.prototype.getViewRoot = function() {
      return this._viewRoot;
    }, r.prototype.resetViewRoot = function(e) {
      e ? this._viewRoot = e : e = this._viewRoot;
      var n = this.getRawData().tree.root;
      (!e || e !== n && !n.contains(e)) && (this._viewRoot = n);
    }, r.prototype.enableAriaDecal = function() {
      bB(this);
    }, r.type = "series.treemap", r.layoutMode = "box", r.defaultOption = {
      // Disable progressive rendering
      progressive: 0,
      // size: ['80%', '80%'],            // deprecated, compatible with ec2.
      left: "center",
      top: "middle",
      width: "80%",
      height: "80%",
      sort: !0,
      clipWindow: "origin",
      squareRatio: 0.5 * (1 + Math.sqrt(5)),
      leafDepth: null,
      drillDownIcon: "▶",
      // to align specialized icon. ▷▶❒❐▼✚
      zoomToNodeRatio: 0.32 * 0.32,
      scaleLimit: null,
      roam: !0,
      nodeClick: "zoomToNode",
      animation: !0,
      animationDurationUpdate: 900,
      animationEasing: "quinticInOut",
      breadcrumb: {
        show: !0,
        height: 22,
        left: "center",
        top: "bottom",
        // right
        // bottom
        emptyItemWidth: 25,
        itemStyle: {
          color: "rgba(0,0,0,0.7)",
          textStyle: {
            color: "#fff"
          }
        },
        emphasis: {
          itemStyle: {
            color: "rgba(0,0,0,0.9)"
            // '#5793f3',
          }
        }
      },
      label: {
        show: !0,
        // Do not use textDistance, for ellipsis rect just the same as treemap node rect.
        distance: 0,
        padding: 5,
        position: "inside",
        // formatter: null,
        color: "#fff",
        overflow: "truncate"
        // align
        // verticalAlign
      },
      upperLabel: {
        show: !1,
        position: [0, "50%"],
        height: 20,
        // formatter: null,
        // color: '#fff',
        overflow: "truncate",
        // align: null,
        verticalAlign: "middle"
      },
      itemStyle: {
        color: null,
        colorAlpha: null,
        colorSaturation: null,
        borderWidth: 0,
        gapWidth: 0,
        borderColor: "#fff",
        borderColorSaturation: null
        // If specified, borderColor will be ineffective, and the
        // border color is evaluated by color of current node and
        // borderColorSaturation.
      },
      emphasis: {
        upperLabel: {
          show: !0,
          position: [0, "50%"],
          overflow: "truncate",
          verticalAlign: "middle"
        }
      },
      visualDimension: 0,
      visualMin: null,
      visualMax: null,
      color: [],
      // level[n].color (if necessary).
      // + Specify color list of each level. level[0].color would be global
      // color list if not specified. (see method `setDefault`).
      // + But set as a empty array to forbid fetch color from global palette
      // when using nodeModel.get('color'), otherwise nodes on deep level
      // will always has color palette set and are not able to inherit color
      // from parent node.
      // + TreemapSeries.color can not be set as 'none', otherwise effect
      // legend color fetching (see seriesColor.js).
      colorAlpha: null,
      colorSaturation: null,
      colorMappingBy: "index",
      visibleMin: 10,
      // be rendered. Only works when sort is 'asc' or 'desc'.
      childrenVisibleMin: null,
      // grandchildren will not show.
      // Why grandchildren? If not grandchildren but children,
      // some siblings show children and some not,
      // the appearance may be mess and not consistent,
      levels: []
      // Each item: {
      //     visibleMin, itemStyle, visualDimension, label
      // }
    }, r;
  }(tr)
);
function CB(t) {
  var r = 0;
  L(t.children, function(n) {
    CB(n);
    var i = n.value;
    ue(i) && (i = i[0]), r += i;
  });
  var e = t.value;
  ue(e) && (e = e[0]), (e == null || isNaN(e)) && (e = r), e < 0 && (e = 0), ue(t.value) ? t.value[0] = e : t.value = e;
}
function Qie(t, r) {
  var e = Qt(r.get("color")), n = Qt(r.get(["aria", "decal", "decals"]));
  if (e) {
    t = t || [];
    var i, a;
    L(t, function(s) {
      var l = new Pt(s), u = l.get("color"), c = l.get("decal");
      (l.get(["itemStyle", "color"]) || u && u !== "none") && (i = !0), (l.get(["itemStyle", "decal"]) || c && c !== "none") && (a = !0);
    });
    var o = t[0] || (t[0] = {});
    return i || (o.color = e.slice()), !a && n && (o.decal = n.slice()), t;
  }
}
var eae = 8, zD = 8, qb = 5, tae = (
  /** @class */
  function() {
    function t(r) {
      this.group = new ze(), r.add(this.group);
    }
    return t.prototype.render = function(r, e, n, i) {
      var a = r.getModel("breadcrumb"), o = this.group;
      if (o.removeAll(), !(!a.get("show") || !n)) {
        var s = a.getModel("itemStyle"), l = a.getModel("emphasis"), u = s.getModel("textStyle"), c = l.getModel(["itemStyle", "textStyle"]), d = {
          pos: {
            left: a.get("left"),
            right: a.get("right"),
            top: a.get("top"),
            bottom: a.get("bottom")
          },
          box: {
            width: e.getWidth(),
            height: e.getHeight()
          },
          emptyItemWidth: a.get("emptyItemWidth"),
          totalWidth: 0,
          renderList: []
        };
        this._prepare(n, d, u), this._renderContent(r, d, s, l, u, c, i), y2(o, d.pos, d.box);
      }
    }, t.prototype._prepare = function(r, e, n) {
      for (var i = r; i; i = i.parentNode) {
        var a = vn(i.getModel().get("name"), ""), o = n.getTextRect(a), s = Math.max(o.width + eae * 2, e.emptyItemWidth);
        e.totalWidth += s + zD, e.renderList.push({
          node: i,
          text: a,
          width: s
        });
      }
    }, t.prototype._renderContent = function(r, e, n, i, a, o, s) {
      for (var l = 0, u = e.emptyItemWidth, c = r.get(["breadcrumb", "height"]), d = jJ(e.pos, e.box), f = e.totalWidth, h = e.renderList, p = i.getModel("itemStyle").getItemStyle(), v = h.length - 1; v >= 0; v--) {
        var g = h[v], m = g.node, y = g.width, b = g.text;
        f > d.width && (f -= y - u, y = u, b = null);
        var C = new si({
          shape: {
            points: rae(l, 0, y, c, v === h.length - 1, v === 0)
          },
          style: Ee(n.getItemStyle(), {
            lineJoin: "bevel"
          }),
          textContent: new _t({
            style: fr(a, {
              text: b
            })
          }),
          textConfig: {
            position: "inside"
          },
          z2: Qf * 1e4,
          onclick: Ye(s, m)
        });
        C.disableLabelAnimation = !0, C.getTextContent().ensureState("emphasis").style = fr(o, {
          text: b
        }), C.ensureState("emphasis").style = p, Vr(C, i.get("focus"), i.get("blurScope"), i.get("disabled")), this.group.add(C), nae(C, r, m), l += y + zD;
      }
    }, t.prototype.remove = function() {
      this.group.removeAll();
    }, t;
  }()
);
function rae(t, r, e, n, i, a) {
  var o = [[i ? t : t - qb, r], [t + e, r], [t + e, r + n], [i ? t : t - qb, r + n]];
  return !a && o.splice(2, 0, [t + e + qb, r + n / 2]), !i && o.push([t, r + n / 2]), o;
}
function nae(t, r, e) {
  Ze(t).eventData = {
    componentType: "series",
    componentSubType: "treemap",
    componentIndex: r.componentIndex,
    seriesIndex: r.seriesIndex,
    seriesName: r.name,
    seriesType: "treemap",
    selfType: "breadcrumb",
    nodeData: {
      dataIndex: e && e.dataIndex,
      name: e && e.name
    },
    treePathInfo: e && E2(e, r)
  };
}
var iae = (
  /** @class */
  function() {
    function t() {
      this._storage = [], this._elExistsMap = {};
    }
    return t.prototype.add = function(r, e, n, i, a) {
      return this._elExistsMap[r.id] ? !1 : (this._elExistsMap[r.id] = !0, this._storage.push({
        el: r,
        target: e,
        duration: n,
        delay: i,
        easing: a
      }), !0);
    }, t.prototype.finished = function(r) {
      return this._finishedCallback = r, this;
    }, t.prototype.start = function() {
      for (var r = this, e = this._storage.length, n = function() {
        e--, e <= 0 && (r._storage.length = 0, r._elExistsMap = {}, r._finishedCallback && r._finishedCallback());
      }, i = 0, a = this._storage.length; i < a; i++) {
        var o = this._storage[i];
        o.el.animateTo(o.target, {
          duration: o.duration,
          delay: o.delay,
          easing: o.easing,
          setToFinal: !0,
          done: n,
          aborted: n
        });
      }
      return this;
    }, t;
  }()
);
function aae() {
  return new iae();
}
var M9 = ze, WD = xt, ZD = 3, jD = "label", YD = "upperLabel", oae = Qf * 10, sae = Qf * 2, lae = Qf * 3, Ju = Bc([
  ["fill", "color"],
  // `borderColor` and `borderWidth` has been occupied,
  // so use `stroke` to indicate the stroke of the rect.
  ["stroke", "strokeColor"],
  ["lineWidth", "strokeWidth"],
  ["shadowBlur"],
  ["shadowOffsetX"],
  ["shadowOffsetY"],
  ["shadowColor"]
  // Option decal is in `DecalObject` but style.decal is in `PatternObject`.
  // So do not transfer decal directly.
]), XD = function(t) {
  var r = Ju(t);
  return r.stroke = r.fill = r.lineWidth = null, r;
}, jm = It(), uae = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e._state = "ready", e._storage = tp(), e;
    }
    return r.prototype.render = function(e, n, i, a) {
      var o = n.findComponents({
        mainType: "series",
        subType: "treemap",
        query: a
      });
      if (!(nt(o, e) < 0)) {
        this.seriesModel = e, this.api = i, this.ecModel = n;
        var s = ["treemapZoomToNode", "treemapRootToNode"], l = kv(a, s, e), u = a && a.type, c = e.layoutInfo, d = !this._oldTree, f = this._storage, h = u === "treemapRootToNode" && l && f ? {
          rootNodeGroup: f.nodeGroup[l.node.getRawIndex()],
          direction: a.direction
        } : null, p = this._giveContainerGroup(c), v = e.get("animation"), g = this._doRender(p, e, h);
        v && !d && (!u || u === "treemapZoomToNode" || u === "treemapRootToNode") ? this._doAnimation(p, g, e, h) : g.renderFinally(), this._resetController(i), this._renderBreadcrumb(e, i, l);
      }
    }, r.prototype._giveContainerGroup = function(e) {
      var n = this._containerGroup;
      return n || (n = this._containerGroup = new M9(), this._initEvents(n), this.group.add(n)), n.x = e.x, n.y = e.y, n;
    }, r.prototype._doRender = function(e, n, i) {
      var a = n.getData().tree, o = this._oldTree, s = tp(), l = tp(), u = this._storage, c = [];
      function d(y, b, C, w) {
        return cae(n, l, u, i, s, c, y, b, C, w);
      }
      v(a.root ? [a.root] : [], o && o.root ? [o.root] : [], e, a === o || !o, 0);
      var f = g(u);
      if (this._oldTree = a, this._storage = l, this._controllerHost) {
        var h = this.seriesModel.layoutInfo, p = a.root.getLayout();
        p.width === h.width && p.height === h.height && (this._controllerHost.zoom = 1);
      }
      return {
        lastsForAnimation: s,
        willDeleteEls: f,
        renderFinally: m
      };
      function v(y, b, C, w, _) {
        w ? (b = y, L(y, function(D, T) {
          !D.isRemoved() && I(T, T);
        })) : new Us(b, y, x, x).add(I).update(I).remove(Ye(I, null)).execute();
        function x(D) {
          return D.getId();
        }
        function I(D, T) {
          var A = D != null ? y[D] : null, M = T != null ? b[T] : null, R = d(A, M, C, _);
          R && v(A && A.viewChildren || [], M && M.viewChildren || [], R, w, _ + 1);
        }
      }
      function g(y) {
        var b = tp();
        return y && L(y, function(C, w) {
          var _ = b[w];
          L(C, function(x) {
            x && (_.push(x), jm(x).willDelete = !0);
          });
        }), b;
      }
      function m() {
        L(f, function(y) {
          L(y, function(b) {
            b.parent && b.parent.remove(b);
          });
        }), L(c, function(y) {
          y.invisible = !0, y.dirty();
        });
      }
    }, r.prototype._doAnimation = function(e, n, i, a) {
      var o = i.get("animationDurationUpdate"), s = i.get("animationEasing"), l = (Ae(o) ? 0 : o) || 0, u = (Ae(s) ? null : s) || "cubicOut", c = aae();
      L(n.willDeleteEls, function(d, f) {
        L(d, function(h, p) {
          if (!h.invisible) {
            var v = h.parent, g, m = jm(v);
            if (a && a.direction === "drillDown")
              g = v === a.rootNodeGroup ? {
                shape: {
                  x: 0,
                  y: 0,
                  width: m.nodeWidth,
                  height: m.nodeHeight
                },
                style: {
                  opacity: 0
                }
              } : {
                style: {
                  opacity: 0
                }
              };
            else {
              var y = 0, b = 0;
              m.willDelete || (y = m.nodeWidth / 2, b = m.nodeHeight / 2), g = f === "nodeGroup" ? {
                x: y,
                y: b,
                style: {
                  opacity: 0
                }
              } : {
                shape: {
                  x: y,
                  y: b,
                  width: 0,
                  height: 0
                },
                style: {
                  opacity: 0
                }
              };
            }
            g && c.add(h, g, l, 0, u);
          }
        });
      }), L(this._storage, function(d, f) {
        L(d, function(h, p) {
          var v = n.lastsForAnimation[f][p], g = {};
          v && (h instanceof ze ? v.oldX != null && (g.x = h.x, g.y = h.y, h.x = v.oldX, h.y = v.oldY) : (v.oldShape && (g.shape = ae({}, h.shape), h.setShape(v.oldShape)), v.fadein ? (h.setStyle("opacity", 0), g.style = {
            opacity: 1
          }) : h.style.opacity !== 1 && (g.style = {
            opacity: 1
          })), c.add(h, g, l, 0, u));
        });
      }, this), this._state = "animating", c.finished(ye(function() {
        this._state = "ready", n.renderFinally();
      }, this)).start();
    }, r.prototype._resetController = function(e) {
      var n = this._controller, i = this._controllerHost;
      i || (this._controllerHost = {
        target: this.group
      }, i = this._controllerHost), n || (n = this._controller = new Dg(e.getZr()), n.enable(this.seriesModel.get("roam")), i.zoomLimit = this.seriesModel.get("scaleLimit"), i.zoom = this.seriesModel.get("zoom"), n.on("pan", ye(this._onPan, this)), n.on("zoom", ye(this._onZoom, this)));
      var a = new rt(0, 0, e.getWidth(), e.getHeight());
      n.setPointerChecker(function(o, s, l) {
        return a.contain(s, l);
      });
    }, r.prototype._clearController = function() {
      var e = this._controller;
      this._controllerHost = null, e && (e.dispose(), e = null);
    }, r.prototype._onPan = function(e) {
      if (this._state !== "animating" && (Math.abs(e.dx) > ZD || Math.abs(e.dy) > ZD)) {
        var n = this.seriesModel.getData().tree.root;
        if (!n)
          return;
        var i = n.getLayout();
        if (!i)
          return;
        this.api.dispatchAction({
          type: "treemapMove",
          from: this.uid,
          seriesId: this.seriesModel.id,
          rootRect: {
            x: i.x + e.dx,
            y: i.y + e.dy,
            width: i.width,
            height: i.height
          }
        });
      }
    }, r.prototype._onZoom = function(e) {
      var n = e.originX, i = e.originY, a = e.scale;
      if (this._state !== "animating") {
        var o = this.seriesModel.getData().tree.root;
        if (!o)
          return;
        var s = o.getLayout();
        if (!s)
          return;
        var l = new rt(s.x, s.y, s.width, s.height), u = null, c = this._controllerHost;
        u = c.zoomLimit;
        var d = c.zoom = c.zoom || 1;
        if (d *= a, u) {
          var f = u.min || 0, h = u.max || 1 / 0;
          d = Math.max(Math.min(h, d), f);
        }
        var p = d / c.zoom;
        c.zoom = d;
        var v = this.seriesModel.layoutInfo;
        n -= v.x, i -= v.y;
        var g = Oi();
        eo(g, g, [-n, -i]), qy(g, g, [p, p]), eo(g, g, [n, i]), l.applyTransform(g), this.api.dispatchAction({
          type: "treemapRender",
          from: this.uid,
          seriesId: this.seriesModel.id,
          rootRect: {
            x: l.x,
            y: l.y,
            width: l.width,
            height: l.height
          }
        });
      }
    }, r.prototype._initEvents = function(e) {
      var n = this;
      e.on("click", function(i) {
        if (n._state === "ready") {
          var a = n.seriesModel.get("nodeClick", !0);
          if (a) {
            var o = n.findTarget(i.offsetX, i.offsetY);
            if (o) {
              var s = o.node;
              if (s.getLayout().isLeafRoot)
                n._rootToNode(o);
              else if (a === "zoomToNode")
                n._zoomToNode(o);
              else if (a === "link") {
                var l = s.hostTree.data.getItemModel(s.dataIndex), u = l.get("link", !0), c = l.get("target", !0) || "blank";
                u && Im(u, c);
              }
            }
          }
        }
      }, this);
    }, r.prototype._renderBreadcrumb = function(e, n, i) {
      var a = this;
      i || (i = e.get("leafDepth", !0) != null ? {
        node: e.getViewRoot()
      } : this.findTarget(n.getWidth() / 2, n.getHeight() / 2), i || (i = {
        node: e.getData().tree.root
      })), (this._breadcrumb || (this._breadcrumb = new tae(this.group))).render(e, n, i.node, function(o) {
        a._state !== "animating" && (Jw(e.getViewRoot(), o) ? a._rootToNode({
          node: o
        }) : a._zoomToNode({
          node: o
        }));
      });
    }, r.prototype.remove = function() {
      this._clearController(), this._containerGroup && this._containerGroup.removeAll(), this._storage = tp(), this._state = "ready", this._breadcrumb && this._breadcrumb.remove();
    }, r.prototype.dispose = function() {
      this._clearController();
    }, r.prototype._zoomToNode = function(e) {
      this.api.dispatchAction({
        type: "treemapZoomToNode",
        from: this.uid,
        seriesId: this.seriesModel.id,
        targetNode: e.node
      });
    }, r.prototype._rootToNode = function(e) {
      this.api.dispatchAction({
        type: "treemapRootToNode",
        from: this.uid,
        seriesId: this.seriesModel.id,
        targetNode: e.node
      });
    }, r.prototype.findTarget = function(e, n) {
      var i, a = this.seriesModel.getViewRoot();
      return a.eachNode({
        attr: "viewChildren",
        order: "preorder"
      }, function(o) {
        var s = this._storage.background[o.getRawIndex()];
        if (s) {
          var l = s.transformCoordToLocal(e, n), u = s.shape;
          if (u.x <= l[0] && l[0] <= u.x + u.width && u.y <= l[1] && l[1] <= u.y + u.height)
            i = {
              node: o,
              offsetX: l[0],
              offsetY: l[1]
            };
          else
            return !1;
        }
      }, this), i;
    }, r.type = "treemap", r;
  }(Yt)
);
function tp() {
  return {
    nodeGroup: [],
    background: [],
    content: []
  };
}
function cae(t, r, e, n, i, a, o, s, l, u) {
  if (!o)
    return;
  var c = o.getLayout(), d = t.getData(), f = o.getModel();
  if (d.setItemGraphicEl(o.dataIndex, null), !c || !c.isInView)
    return;
  var h = c.width, p = c.height, v = c.borderWidth, g = c.invisible, m = o.getRawIndex(), y = s && s.getRawIndex(), b = o.viewChildren, C = c.upperHeight, w = b && b.length, _ = f.getModel("itemStyle"), x = f.getModel(["emphasis", "itemStyle"]), I = f.getModel(["blur", "itemStyle"]), D = f.getModel(["select", "itemStyle"]), T = _.get("borderRadius") || 0, A = z("nodeGroup", M9);
  if (!A)
    return;
  if (l.add(A), A.x = c.x || 0, A.y = c.y || 0, A.markRedraw(), jm(A).nodeWidth = h, jm(A).nodeHeight = p, c.isAboveViewRoot)
    return A;
  var M = z("background", WD, u, sae);
  M && W(A, M, w && c.upperLabelHeight);
  var R = f.getModel("emphasis"), E = R.get("focus"), k = R.get("blurScope"), P = R.get("disabled"), N = E === "ancestor" ? o.getAncestorsIndices() : E === "descendant" ? o.getDescendantIndices() : E;
  if (w)
    eu(A) && dc(A, !1), M && (dc(M, !P), d.setItemGraphicEl(o.dataIndex, M), YC(M, N, k));
  else {
    var O = z("content", WD, u, lae);
    O && V(A, O), M.disableMorphing = !0, M && eu(M) && dc(M, !1), dc(A, !P), d.setItemGraphicEl(o.dataIndex, A), YC(A, N, k);
  }
  return A;
  function W(K, j, oe) {
    var ie = Ze(j);
    if (ie.dataIndex = o.dataIndex, ie.seriesIndex = t.seriesIndex, j.setShape({
      x: 0,
      y: 0,
      width: h,
      height: p,
      r: T
    }), g)
      B(j);
    else {
      j.invisible = !1;
      var le = o.getVisual("style"), re = le.stroke, Re = XD(_);
      Re.fill = re;
      var ve = Ju(x);
      ve.fill = x.get("borderColor");
      var Oe = Ju(I);
      Oe.fill = I.get("borderColor");
      var qe = Ju(D);
      if (qe.fill = D.get("borderColor"), oe) {
        var dt = h - 2 * v;
        Z(
          // PENDING: convert ZRColor to ColorString for text.
          j,
          re,
          le.opacity,
          {
            x: v,
            y: 0,
            width: dt,
            height: C
          }
        );
      } else
        j.removeTextContent();
      j.setStyle(Re), j.ensureState("emphasis").style = ve, j.ensureState("blur").style = Oe, j.ensureState("select").style = qe, Fc(j);
    }
    K.add(j);
  }
  function V(K, j) {
    var oe = Ze(j);
    oe.dataIndex = o.dataIndex, oe.seriesIndex = t.seriesIndex;
    var ie = Math.max(h - 2 * v, 0), le = Math.max(p - 2 * v, 0);
    if (j.culling = !0, j.setShape({
      x: v,
      y: v,
      width: ie,
      height: le,
      r: T
    }), g)
      B(j);
    else {
      j.invisible = !1;
      var re = o.getVisual("style"), Re = re.fill, ve = XD(_);
      ve.fill = Re, ve.decal = re.decal;
      var Oe = Ju(x), qe = Ju(I), dt = Ju(D);
      Z(j, Re, re.opacity, null), j.setStyle(ve), j.ensureState("emphasis").style = Oe, j.ensureState("blur").style = qe, j.ensureState("select").style = dt, Fc(j);
    }
    K.add(j);
  }
  function B(K) {
    !K.invisible && a.push(K);
  }
  function Z(K, j, oe, ie) {
    var le = f.getModel(ie ? YD : jD), re = vn(f.get("name"), null), Re = le.getShallow("show");
    Xn(K, xn(f, ie ? YD : jD), {
      defaultText: Re ? re : null,
      inheritColor: j,
      defaultOpacity: oe,
      labelFetcher: t,
      labelDataIndex: o.dataIndex
    });
    var ve = K.getTextContent();
    if (ve) {
      var Oe = ve.style, qe = Jy(Oe.padding || 0);
      ie && (K.setTextConfig({
        layoutRect: ie
      }), ve.disableLabelLayout = !0), ve.beforeUpdate = function() {
        var At = Math.max((ie ? ie.width : K.shape.width) - qe[1] - qe[3], 0), Be = Math.max((ie ? ie.height : K.shape.height) - qe[0] - qe[2], 0);
        (Oe.width !== At || Oe.height !== Be) && ve.setStyle({
          width: At,
          height: Be
        });
      }, Oe.truncateMinChar = 2, Oe.lineOverflow = "truncate", q(Oe, ie, c);
      var dt = ve.getState("emphasis");
      q(dt ? dt.style : null, ie, c);
    }
  }
  function q(K, j, oe) {
    var ie = K ? K.text : null;
    if (!j && oe.isLeafRoot && ie != null) {
      var le = t.get("drillDownIcon", !0);
      K.text = le ? le + " " + ie : ie;
    }
  }
  function z(K, j, oe, ie) {
    var le = y != null && e[K][y], re = i[K];
    return le ? (e[K][y] = null, U(re, le)) : g || (le = new j(), le instanceof La && (le.z2 = dae(oe, ie)), J(re, le)), r[K][m] = le;
  }
  function U(K, j) {
    var oe = K[m] = {};
    j instanceof M9 ? (oe.oldX = j.x, oe.oldY = j.y) : oe.oldShape = ae({}, j.shape);
  }
  function J(K, j) {
    var oe = K[m] = {}, ie = o.parentNode, le = j instanceof ze;
    if (ie && (!n || n.direction === "drillDown")) {
      var re = 0, Re = 0, ve = i.background[ie.getRawIndex()];
      !n && ve && ve.oldShape && (re = ve.oldShape.width, Re = ve.oldShape.height), le ? (oe.oldX = 0, oe.oldY = Re) : oe.oldShape = {
        x: re,
        y: Re,
        width: 0,
        height: 0
      };
    }
    oe.fadein = !le;
  }
}
function dae(t, r) {
  return t * oae + r;
}
var Pv = L, fae = Me, Ym = -1, _n = (
  /** @class */
  function() {
    function t(r) {
      var e = r.mappingMethod, n = r.type, i = this.option = Ge(r);
      this.type = n, this.mappingMethod = e, this._normalizeData = vae[e];
      var a = t.visualHandlers[n];
      this.applyVisual = a.applyVisual, this.getColorMapper = a.getColorMapper, this._normalizedToVisual = a._normalizedToVisual[e], e === "piecewise" ? (Qb(i), hae(i)) : e === "category" ? i.categories ? pae(i) : Qb(i, !0) : (ke(e !== "linear" || i.dataExtent), Qb(i));
    }
    return t.prototype.mapValueToVisual = function(r) {
      var e = this._normalizeData(r);
      return this._normalizedToVisual(e, r);
    }, t.prototype.getNormalizer = function() {
      return ye(this._normalizeData, this);
    }, t.listVisualTypes = function() {
      return yt(t.visualHandlers);
    }, t.isValidType = function(r) {
      return t.visualHandlers.hasOwnProperty(r);
    }, t.eachVisual = function(r, e, n) {
      Me(r) ? L(r, e, n) : e.call(n, r);
    }, t.mapVisual = function(r, e, n) {
      var i, a = ue(r) ? [] : Me(r) ? {} : (i = !0, null);
      return t.eachVisual(r, function(o, s) {
        var l = e.call(n, o, s);
        i ? a = l : a[s] = l;
      }), a;
    }, t.retrieveVisuals = function(r) {
      var e = {}, n;
      return r && Pv(t.visualHandlers, function(i, a) {
        r.hasOwnProperty(a) && (e[a] = r[a], n = !0);
      }), n ? e : null;
    }, t.prepareVisualTypes = function(r) {
      if (ue(r))
        r = r.slice();
      else if (fae(r)) {
        var e = [];
        Pv(r, function(n, i) {
          e.push(i);
        }), r = e;
      } else
        return [];
      return r.sort(function(n, i) {
        return i === "color" && n !== "color" && n.indexOf("color") === 0 ? 1 : -1;
      }), r;
    }, t.dependsOn = function(r, e) {
      return e === "color" ? !!(r && r.indexOf(e) === 0) : r === e;
    }, t.findPieceIndex = function(r, e, n) {
      for (var i, a = 1 / 0, o = 0, s = e.length; o < s; o++) {
        var l = e[o].value;
        if (l != null) {
          if (l === r || pe(l) && l === r + "")
            return o;
          n && f(l, o);
        }
      }
      for (var o = 0, s = e.length; o < s; o++) {
        var u = e[o], c = u.interval, d = u.close;
        if (c) {
          if (c[0] === -1 / 0) {
            if (B1(d[1], r, c[1]))
              return o;
          } else if (c[1] === 1 / 0) {
            if (B1(d[0], c[0], r))
              return o;
          } else if (B1(d[0], c[0], r) && B1(d[1], r, c[1]))
            return o;
          n && f(c[0], o), n && f(c[1], o);
        }
      }
      if (n)
        return r === 1 / 0 ? e.length - 1 : r === -1 / 0 ? 0 : i;
      function f(h, p) {
        var v = Math.abs(h - r);
        v < a && (a = v, i = p);
      }
    }, t.visualHandlers = {
      color: {
        applyVisual: rp("color"),
        getColorMapper: function() {
          var r = this.option;
          return ye(r.mappingMethod === "category" ? function(e, n) {
            return !n && (e = this._normalizeData(e)), Pp.call(this, e);
          } : function(e, n, i) {
            var a = !!i;
            return !n && (e = this._normalizeData(e)), i = Yp(e, r.parsedVisual, i), a ? i : Ja(i, "rgba");
          }, this);
        },
        _normalizedToVisual: {
          linear: function(r) {
            return Ja(Yp(r, this.option.parsedVisual), "rgba");
          },
          category: Pp,
          piecewise: function(r, e) {
            var n = L9.call(this, e);
            return n == null && (n = Ja(Yp(r, this.option.parsedVisual), "rgba")), n;
          },
          fixed: Ku
        }
      },
      colorHue: G1(function(r, e) {
        return ff(r, e);
      }),
      colorSaturation: G1(function(r, e) {
        return ff(r, null, e);
      }),
      colorLightness: G1(function(r, e) {
        return ff(r, null, null, e);
      }),
      colorAlpha: G1(function(r, e) {
        return mv(r, e);
      }),
      decal: {
        applyVisual: rp("decal"),
        _normalizedToVisual: {
          linear: null,
          category: Pp,
          piecewise: null,
          fixed: null
        }
      },
      opacity: {
        applyVisual: rp("opacity"),
        _normalizedToVisual: R9([0, 1])
      },
      liftZ: {
        applyVisual: rp("liftZ"),
        _normalizedToVisual: {
          linear: Ku,
          category: Ku,
          piecewise: Ku,
          fixed: Ku
        }
      },
      symbol: {
        applyVisual: function(r, e, n) {
          var i = this.mapValueToVisual(r);
          n("symbol", i);
        },
        _normalizedToVisual: {
          linear: $D,
          category: Pp,
          piecewise: function(r, e) {
            var n = L9.call(this, e);
            return n == null && (n = $D.call(this, r)), n;
          },
          fixed: Ku
        }
      },
      symbolSize: {
        applyVisual: rp("symbolSize"),
        _normalizedToVisual: R9([0, 1])
      }
    }, t;
  }()
);
function hae(t) {
  var r = t.pieceList;
  t.hasSpecialVisual = !1, L(r, function(e, n) {
    e.originIndex = n, e.visual != null && (t.hasSpecialVisual = !0);
  });
}
function pae(t) {
  var r = t.categories, e = t.categoryMap = {}, n = t.visual;
  if (Pv(r, function(o, s) {
    e[o] = s;
  }), !ue(n)) {
    var i = [];
    Me(n) ? Pv(n, function(o, s) {
      var l = e[s];
      i[l ?? Ym] = o;
    }) : i[Ym] = n, n = wB(t, i);
  }
  for (var a = r.length - 1; a >= 0; a--)
    n[a] == null && (delete e[r[a]], r.pop());
}
function Qb(t, r) {
  var e = t.visual, n = [];
  Me(e) ? Pv(e, function(a) {
    n.push(a);
  }) : e != null && n.push(e);
  var i = {
    color: 1,
    symbol: 1
  };
  !r && n.length === 1 && !i.hasOwnProperty(t.type) && (n[1] = n[0]), wB(t, n);
}
function G1(t) {
  return {
    applyVisual: function(r, e, n) {
      var i = this.mapValueToVisual(r);
      n("color", t(e("color"), i));
    },
    _normalizedToVisual: R9([0, 1])
  };
}
function $D(t) {
  var r = this.option.visual;
  return r[Math.round(zt(t, [0, 1], [0, r.length - 1], !0))] || {};
}
function rp(t) {
  return function(r, e, n) {
    n(t, this.mapValueToVisual(r));
  };
}
function Pp(t) {
  var r = this.option.visual;
  return r[this.option.loop && t !== Ym ? t % r.length : t];
}
function Ku() {
  return this.option.visual[0];
}
function R9(t) {
  return {
    linear: function(r) {
      return zt(r, t, this.option.visual, !0);
    },
    category: Pp,
    piecewise: function(r, e) {
      var n = L9.call(this, e);
      return n == null && (n = zt(r, t, this.option.visual, !0)), n;
    },
    fixed: Ku
  };
}
function L9(t) {
  var r = this.option, e = r.pieceList;
  if (r.hasSpecialVisual) {
    var n = _n.findPieceIndex(t, e), i = e[n];
    if (i && i.visual)
      return i.visual[this.type];
  }
}
function wB(t, r) {
  return t.visual = r, t.type === "color" && (t.parsedVisual = ce(r, function(e) {
    var n = Ci(e);
    return !n && process.env.NODE_ENV !== "production" && Mr("'" + e + "' is an illegal color, fallback to '#000000'", !0), n || [0, 0, 0, 1];
  })), r;
}
var vae = {
  linear: function(t) {
    return zt(t, this.option.dataExtent, [0, 1], !0);
  },
  piecewise: function(t) {
    var r = this.option.pieceList, e = _n.findPieceIndex(t, r, !0);
    if (e != null)
      return zt(e, [0, r.length - 1], [0, 1], !0);
  },
  category: function(t) {
    var r = this.option.categories ? this.option.categoryMap[t] : t;
    return r ?? Ym;
  },
  fixed: Yr
};
function B1(t, r, e) {
  return t ? r <= e : r < e;
}
var gae = "itemStyle", _B = It();
const mae = {
  seriesType: "treemap",
  reset: function(t) {
    var r = t.getData().tree, e = r.root;
    e.isRemoved() || xB(
      e,
      // Visual should calculate from tree root but not view root.
      {},
      t.getViewRoot().getAncestors(),
      t
    );
  }
};
function xB(t, r, e, n) {
  var i = t.getModel(), a = t.getLayout(), o = t.hostTree.data;
  if (!(!a || a.invisible || !a.isInView)) {
    var s = i.getModel(gae), l = yae(s, r, n), u = o.ensureUniqueItemVisual(t.dataIndex, "style"), c = s.get("borderColor"), d = s.get("borderColorSaturation"), f;
    d != null && (f = UD(l), c = bae(d, f)), u.stroke = c;
    var h = t.viewChildren;
    if (!h || !h.length)
      f = UD(l), u.fill = f;
    else {
      var p = Cae(t, i, a, s, l, h);
      L(h, function(v, g) {
        if (v.depth >= e.length || v === e[v.depth]) {
          var m = wae(i, l, v, g, p, n);
          xB(v, m, e, n);
        }
      });
    }
  }
}
function yae(t, r, e) {
  var n = ae({}, r), i = e.designatedVisualItemStyle;
  return L(["color", "colorAlpha", "colorSaturation"], function(a) {
    i[a] = r[a];
    var o = t.get(a);
    i[a] = null, o != null && (n[a] = o);
  }), n;
}
function UD(t) {
  var r = e3(t, "color");
  if (r) {
    var e = e3(t, "colorAlpha"), n = e3(t, "colorSaturation");
    return n && (r = ff(r, null, null, n)), e && (r = mv(r, e)), r;
  }
}
function bae(t, r) {
  return r != null ? ff(r, null, null, t) : null;
}
function e3(t, r) {
  var e = t[r];
  if (e != null && e !== "none")
    return e;
}
function Cae(t, r, e, n, i, a) {
  if (!(!a || !a.length)) {
    var o = t3(r, "color") || i.color != null && i.color !== "none" && (t3(r, "colorAlpha") || t3(r, "colorSaturation"));
    if (o) {
      var s = r.get("visualMin"), l = r.get("visualMax"), u = e.dataExtent.slice();
      s != null && s < u[0] && (u[0] = s), l != null && l > u[1] && (u[1] = l);
      var c = r.get("colorMappingBy"), d = {
        type: o.name,
        dataExtent: u,
        visual: o.range
      };
      d.type === "color" && (c === "index" || c === "id") ? (d.mappingMethod = "category", d.loop = !0) : d.mappingMethod = "linear";
      var f = new _n(d);
      return _B(f).drColorMappingBy = c, f;
    }
  }
}
function t3(t, r) {
  var e = t.get(r);
  return ue(e) && e.length ? {
    name: r,
    range: e
  } : null;
}
function wae(t, r, e, n, i, a) {
  var o = ae({}, r);
  if (i) {
    var s = i.type, l = s === "color" && _B(i).drColorMappingBy, u = l === "index" ? n : l === "id" ? a.mapIdToIndex(e.getId()) : e.getValue(t.get("visualDimension"));
    o[s] = i.mapValueToVisual(u);
  }
  return o;
}
var Nv = Math.max, Xm = Math.min, JD = Qr, Kw = L, SB = ["itemStyle", "borderWidth"], _ae = ["itemStyle", "gapWidth"], xae = ["upperLabel", "show"], Sae = ["upperLabel", "height"];
const Iae = {
  seriesType: "treemap",
  reset: function(t, r, e, n) {
    var i = e.getWidth(), a = e.getHeight(), o = t.option, s = cn(t.getBoxLayoutParams(), {
      width: e.getWidth(),
      height: e.getHeight()
    }), l = o.size || [], u = he(JD(s.width, l[0]), i), c = he(JD(s.height, l[1]), a), d = n && n.type, f = ["treemapZoomToNode", "treemapRootToNode"], h = kv(n, f, t), p = d === "treemapRender" || d === "treemapMove" ? n.rootRect : null, v = t.getViewRoot(), g = yB(v);
    if (d !== "treemapMove") {
      var m = d === "treemapZoomToNode" ? Lae(t, h, v, u, c) : p ? [p.width, p.height] : [u, c], y = o.sort;
      y && y !== "asc" && y !== "desc" && (y = "desc");
      var b = {
        squareRatio: o.squareRatio,
        sort: y,
        leafDepth: o.leafDepth
      };
      v.hostTree.clearLayouts();
      var C = {
        x: 0,
        y: 0,
        width: m[0],
        height: m[1],
        area: m[0] * m[1]
      };
      v.setLayout(C), IB(v, b, !1, 0), C = v.getLayout(), Kw(g, function(_, x) {
        var I = (g[x + 1] || v).getValue();
        _.setLayout(ae({
          dataExtent: [I, I],
          borderWidth: 0,
          upperHeight: 0
        }, C));
      });
    }
    var w = t.getData().tree.root;
    w.setLayout(Eae(s, p, h), !0), t.setLayoutInfo(s), AB(
      w,
      // Transform to base element coordinate system.
      new rt(-s.x, -s.y, i, a),
      g,
      v,
      0
    );
  }
};
function IB(t, r, e, n) {
  var i, a;
  if (!t.isRemoved()) {
    var o = t.getLayout();
    i = o.width, a = o.height;
    var s = t.getModel(), l = s.get(SB), u = s.get(_ae) / 2, c = DB(s), d = Math.max(l, c), f = l - u, h = d - u;
    t.setLayout({
      borderWidth: l,
      upperHeight: d,
      upperLabelHeight: c
    }, !0), i = Nv(i - 2 * f, 0), a = Nv(a - f - h, 0);
    var p = i * a, v = Aae(t, s, p, r, e, n);
    if (v.length) {
      var g = {
        x: f,
        y: h,
        width: i,
        height: a
      }, m = Xm(i, a), y = 1 / 0, b = [];
      b.area = 0;
      for (var C = 0, w = v.length; C < w; ) {
        var _ = v[C];
        b.push(_), b.area += _.getLayout().area;
        var x = Rae(b, m, r.squareRatio);
        x <= y ? (C++, y = x) : (b.area -= b.pop().getLayout().area, KD(b, m, g, u, !1), m = Xm(g.width, g.height), b.length = b.area = 0, y = 1 / 0);
      }
      if (b.length && KD(b, m, g, u, !0), !e) {
        var I = s.get("childrenVisibleMin");
        I != null && p < I && (e = !0);
      }
      for (var C = 0, w = v.length; C < w; C++)
        IB(v[C], r, e, n + 1);
    }
  }
}
function Aae(t, r, e, n, i, a) {
  var o = t.children || [], s = n.sort;
  s !== "asc" && s !== "desc" && (s = null);
  var l = n.leafDepth != null && n.leafDepth <= a;
  if (i && !l)
    return t.viewChildren = [];
  o = Wt(o, function(h) {
    return !h.isRemoved();
  }), Tae(o, s);
  var u = Mae(r, o, s);
  if (u.sum === 0)
    return t.viewChildren = [];
  if (u.sum = Dae(r, e, u.sum, s, o), u.sum === 0)
    return t.viewChildren = [];
  for (var c = 0, d = o.length; c < d; c++) {
    var f = o[c].getValue() / u.sum * e;
    o[c].setLayout({
      area: f
    });
  }
  return l && (o.length && t.setLayout({
    isLeafRoot: !0
  }, !0), o.length = 0), t.viewChildren = o, t.setLayout({
    dataExtent: u.dataExtent
  }, !0), o;
}
function Dae(t, r, e, n, i) {
  if (!n)
    return e;
  for (var a = t.get("visibleMin"), o = i.length, s = o, l = o - 1; l >= 0; l--) {
    var u = i[n === "asc" ? o - l - 1 : l].getValue();
    u / e * r < a && (s = l, e -= u);
  }
  return n === "asc" ? i.splice(0, o - s) : i.splice(s, o - s), e;
}
function Tae(t, r) {
  return r && t.sort(function(e, n) {
    var i = r === "asc" ? e.getValue() - n.getValue() : n.getValue() - e.getValue();
    return i === 0 ? r === "asc" ? e.dataIndex - n.dataIndex : n.dataIndex - e.dataIndex : i;
  }), t;
}
function Mae(t, r, e) {
  for (var n = 0, i = 0, a = r.length; i < a; i++)
    n += r[i].getValue();
  var o = t.get("visualDimension"), s;
  return !r || !r.length ? s = [NaN, NaN] : o === "value" && e ? (s = [r[r.length - 1].getValue(), r[0].getValue()], e === "asc" && s.reverse()) : (s = [1 / 0, -1 / 0], Kw(r, function(l) {
    var u = l.getValue(o);
    u < s[0] && (s[0] = u), u > s[1] && (s[1] = u);
  })), {
    sum: n,
    dataExtent: s
  };
}
function Rae(t, r, e) {
  for (var n = 0, i = 1 / 0, a = 0, o = void 0, s = t.length; a < s; a++)
    o = t[a].getLayout().area, o && (o < i && (i = o), o > n && (n = o));
  var l = t.area * t.area, u = r * r * e;
  return l ? Nv(u * n / l, l / (u * i)) : 1 / 0;
}
function KD(t, r, e, n, i) {
  var a = r === e.width ? 0 : 1, o = 1 - a, s = ["x", "y"], l = ["width", "height"], u = e[s[a]], c = r ? t.area / r : 0;
  (i || c > e[l[o]]) && (c = e[l[o]]);
  for (var d = 0, f = t.length; d < f; d++) {
    var h = t[d], p = {}, v = c ? h.getLayout().area / c : 0, g = p[l[o]] = Nv(c - 2 * n, 0), m = e[s[a]] + e[l[a]] - u, y = d === f - 1 || m < v ? m : v, b = p[l[a]] = Nv(y - 2 * n, 0);
    p[s[o]] = e[s[o]] + Xm(n, g / 2), p[s[a]] = u + Xm(n, b / 2), u += y, h.setLayout(p, !0);
  }
  e[s[o]] += c, e[l[o]] -= c;
}
function Lae(t, r, e, n, i) {
  var a = (r || {}).node, o = [n, i];
  if (!a || a === e)
    return o;
  for (var s, l = n * i, u = l * t.option.zoomToNodeRatio; s = a.parentNode; ) {
    for (var c = 0, d = s.children, f = 0, h = d.length; f < h; f++)
      c += d[f].getValue();
    var p = a.getValue();
    if (p === 0)
      return o;
    u *= c / p;
    var v = s.getModel(), g = v.get(SB), m = Math.max(g, DB(v));
    u += 4 * g * g + (3 * g + m) * Math.pow(u, 0.5), u > VC && (u = VC), a = s;
  }
  u < l && (u = l);
  var y = Math.pow(u / l, 0.5);
  return [n * y, i * y];
}
function Eae(t, r, e) {
  if (r)
    return {
      x: r.x,
      y: r.y
    };
  var n = {
    x: 0,
    y: 0
  };
  if (!e)
    return n;
  var i = e.node, a = i.getLayout();
  if (!a)
    return n;
  for (var o = [a.width / 2, a.height / 2], s = i; s; ) {
    var l = s.getLayout();
    o[0] += l.x, o[1] += l.y, s = s.parentNode;
  }
  return {
    x: t.width / 2 - o[0],
    y: t.height / 2 - o[1]
  };
}
function AB(t, r, e, n, i) {
  var a = t.getLayout(), o = e[i], s = o && o === t;
  if (!(o && !s || i === e.length && t !== n)) {
    t.setLayout({
      // isInView means: viewRoot sub tree + viewAbovePath
      isInView: !0,
      // invisible only means: outside view clip so that the node can not
      // see but still layout for animation preparation but not render.
      invisible: !s && !r.intersect(a),
      isAboveViewRoot: s
    }, !0);
    var l = new rt(r.x - a.x, r.y - a.y, r.width, r.height);
    Kw(t.viewChildren || [], function(u) {
      AB(u, l, e, n, i + 1);
    });
  }
}
function DB(t) {
  return t.get(xae) ? t.get(Sae) : 0;
}
function kae(t) {
  t.registerSeriesModel(qie), t.registerChartView(uae), t.registerVisual(mae), t.registerLayout(Iae), Kie(t);
}
function Pae(t) {
  var r = t.findComponents({
    mainType: "legend"
  });
  !r || !r.length || t.eachSeriesByType("graph", function(e) {
    var n = e.getCategoriesData(), i = e.getGraph(), a = i.data, o = n.mapArray(n.getName);
    a.filterSelf(function(s) {
      var l = a.getItemModel(s), u = l.getShallow("category");
      if (u != null) {
        Mt(u) && (u = o[u]);
        for (var c = 0; c < r.length; c++)
          if (!r[c].isSelected(u))
            return !1;
      }
      return !0;
    });
  });
}
function Nae(t) {
  var r = {};
  t.eachSeriesByType("graph", function(e) {
    var n = e.getCategoriesData(), i = e.getData(), a = {};
    n.each(function(o) {
      var s = n.getName(o);
      a["ec-" + s] = o;
      var l = n.getItemModel(o), u = l.getModel("itemStyle").getItemStyle();
      u.fill || (u.fill = e.getColorFromPalette(s, r)), n.setItemVisual(o, "style", u);
      for (var c = ["symbol", "symbolSize", "symbolKeepAspect"], d = 0; d < c.length; d++) {
        var f = l.getShallow(c[d], !0);
        f != null && n.setItemVisual(o, c[d], f);
      }
    }), n.count() && i.each(function(o) {
      var s = i.getItemModel(o), l = s.getShallow("category");
      if (l != null) {
        pe(l) && (l = a["ec-" + l]);
        var u = n.getItemVisual(l, "style"), c = i.ensureUniqueItemVisual(o, "style");
        ae(c, u);
        for (var d = ["symbol", "symbolSize", "symbolKeepAspect"], f = 0; f < d.length; f++)
          i.setItemVisual(o, d[f], n.getItemVisual(l, d[f]));
      }
    });
  });
}
function F1(t) {
  return t instanceof Array || (t = [t, t]), t;
}
function Oae(t) {
  t.eachSeriesByType("graph", function(r) {
    var e = r.getGraph(), n = r.getEdgeData(), i = F1(r.get("edgeSymbol")), a = F1(r.get("edgeSymbolSize"));
    n.setVisual("fromSymbol", i && i[0]), n.setVisual("toSymbol", i && i[1]), n.setVisual("fromSymbolSize", a && a[0]), n.setVisual("toSymbolSize", a && a[1]), n.setVisual("style", r.getModel("lineStyle").getLineStyle()), n.each(function(o) {
      var s = n.getItemModel(o), l = e.getEdgeByIndex(o), u = F1(s.getShallow("symbol", !0)), c = F1(s.getShallow("symbolSize", !0)), d = s.getModel("lineStyle").getLineStyle(), f = n.ensureUniqueItemVisual(o, "style");
      switch (ae(f, d), f.stroke) {
        case "source": {
          var h = l.node1.getVisual("style");
          f.stroke = h && h.fill;
          break;
        }
        case "target": {
          var h = l.node2.getVisual("style");
          f.stroke = h && h.fill;
          break;
        }
      }
      u[0] && l.setVisual("fromSymbol", u[0]), u[1] && l.setVisual("toSymbol", u[1]), c[0] && l.setVisual("fromSymbolSize", c[0]), c[1] && l.setVisual("toSymbolSize", c[1]);
    });
  });
}
var E9 = "-->", k2 = function(t) {
  return t.get("autoCurveness") || null;
}, TB = function(t, r) {
  var e = k2(t), n = 20, i = [];
  if (Mt(e))
    n = e;
  else if (ue(e)) {
    t.__curvenessList = e;
    return;
  }
  r > n && (n = r);
  var a = n % 2 ? n + 2 : n + 3;
  i = [];
  for (var o = 0; o < a; o++)
    i.push((o % 2 ? o + 1 : o) / 10 * (o % 2 ? -1 : 1));
  t.__curvenessList = i;
}, Ov = function(t, r, e) {
  var n = [t.id, t.dataIndex].join("."), i = [r.id, r.dataIndex].join(".");
  return [e.uid, n, i].join(E9);
}, MB = function(t) {
  var r = t.split(E9);
  return [r[0], r[2], r[1]].join(E9);
}, Vae = function(t, r) {
  var e = Ov(t.node1, t.node2, r);
  return r.__edgeMap[e];
}, Gae = function(t, r) {
  var e = k9(Ov(t.node1, t.node2, r), r), n = k9(Ov(t.node2, t.node1, r), r);
  return e + n;
}, k9 = function(t, r) {
  var e = r.__edgeMap;
  return e[t] ? e[t].length : 0;
};
function Bae(t) {
  k2(t) && (t.__curvenessList = [], t.__edgeMap = {}, TB(t));
}
function Fae(t, r, e, n) {
  if (k2(e)) {
    var i = Ov(t, r, e), a = e.__edgeMap, o = a[MB(i)];
    a[i] && !o ? a[i].isForward = !0 : o && a[i] && (o.isForward = !0, a[i].isForward = !1), a[i] = a[i] || [], a[i].push(n);
  }
}
function qw(t, r, e, n) {
  var i = k2(r), a = ue(i);
  if (!i)
    return null;
  var o = Vae(t, r);
  if (!o)
    return null;
  for (var s = -1, l = 0; l < o.length; l++)
    if (o[l] === e) {
      s = l;
      break;
    }
  var u = Gae(t, r);
  TB(r, u), t.lineStyle = t.lineStyle || {};
  var c = Ov(t.node1, t.node2, r), d = r.__curvenessList, f = a || u % 2 ? 0 : 1;
  if (o.isForward)
    return d[f + s];
  var h = MB(c), p = k9(h, r), v = d[s + p + f];
  return n ? a ? i && i[0] === 0 ? (p + f) % 2 ? v : -v : ((p % 2 ? 0 : 1) + f) % 2 ? v : -v : (p + f) % 2 ? v : -v : d[s + p + f];
}
function RB(t) {
  var r = t.coordinateSystem;
  if (!(r && r.type !== "view")) {
    var e = t.getGraph();
    e.eachNode(function(n) {
      var i = n.getModel();
      n.setLayout([+i.get("x"), +i.get("y")]);
    }), Qw(e, t);
  }
}
function Qw(t, r) {
  t.eachEdge(function(e, n) {
    var i = Ki(e.getModel().get(["lineStyle", "curveness"]), -qw(e, r, n, !0), 0), a = Ho(e.node1.getLayout()), o = Ho(e.node2.getLayout()), s = [a, o];
    +i && s.push([(a[0] + o[0]) / 2 - (a[1] - o[1]) * i, (a[1] + o[1]) / 2 - (o[0] - a[0]) * i]), e.setLayout(s);
  });
}
function Hae(t, r) {
  t.eachSeriesByType("graph", function(e) {
    var n = e.get("layout"), i = e.coordinateSystem;
    if (i && i.type !== "view") {
      var a = e.getData(), o = [];
      L(i.dimensions, function(f) {
        o = o.concat(a.mapDimensionsAll(f));
      });
      for (var s = 0; s < a.count(); s++) {
        for (var l = [], u = !1, c = 0; c < o.length; c++) {
          var d = a.get(o[c], s);
          isNaN(d) || (u = !0), l.push(d);
        }
        u ? a.setItemLayout(s, i.dataToPoint(l)) : a.setItemLayout(s, [NaN, NaN]);
      }
      Qw(a.graph, e);
    } else (!n || n === "none") && RB(e);
  });
}
function Np(t) {
  var r = t.coordinateSystem;
  if (r.type !== "view")
    return 1;
  var e = t.option.nodeScaleRatio, n = r.scaleX, i = r.getZoom(), a = (i - 1) * e + 1;
  return a / n;
}
function Op(t) {
  var r = t.getVisual("symbolSize");
  return r instanceof Array && (r = (r[0] + r[1]) / 2), +r;
}
var qD = Math.PI, r3 = [];
function e_(t, r, e, n) {
  var i = t.coordinateSystem;
  if (!(i && i.type !== "view")) {
    var a = i.getBoundingRect(), o = t.getData(), s = o.graph, l = a.width / 2 + a.x, u = a.height / 2 + a.y, c = Math.min(a.width, a.height) / 2, d = o.count();
    if (o.setLayout({
      cx: l,
      cy: u
    }), !!d) {
      if (e) {
        var f = i.pointToData(n), h = f[0], p = f[1], v = [h - l, p - u];
        Jc(v, v), Wp(v, v, c), e.setLayout([l + v[0], u + v[1]], !0);
        var g = t.get(["circular", "rotateLabel"]);
        LB(e, g, l, u);
      }
      zae[r](t, s, o, c, l, u, d), s.eachEdge(function(m, y) {
        var b = Ki(m.getModel().get(["lineStyle", "curveness"]), qw(m, t, y), 0), C = Ho(m.node1.getLayout()), w = Ho(m.node2.getLayout()), _, x = (C[0] + w[0]) / 2, I = (C[1] + w[1]) / 2;
        +b && (b *= 3, _ = [l * b + x * (1 - b), u * b + I * (1 - b)]), m.setLayout([C, w, _]);
      });
    }
  }
}
var zae = {
  value: function(t, r, e, n, i, a, o) {
    var s = 0, l = e.getSum("value"), u = Math.PI * 2 / (l || o);
    r.eachNode(function(c) {
      var d = c.getValue("value"), f = u * (l ? d : 1) / 2;
      s += f, c.setLayout([n * Math.cos(s) + i, n * Math.sin(s) + a]), s += f;
    });
  },
  symbolSize: function(t, r, e, n, i, a, o) {
    var s = 0;
    r3.length = o;
    var l = Np(t);
    r.eachNode(function(d) {
      var f = Op(d);
      isNaN(f) && (f = 2), f < 0 && (f = 0), f *= l;
      var h = Math.asin(f / 2 / n);
      isNaN(h) && (h = qD / 2), r3[d.dataIndex] = h, s += h * 2;
    });
    var u = (2 * qD - s) / o / 2, c = 0;
    r.eachNode(function(d) {
      var f = u + r3[d.dataIndex];
      c += f, (!d.getLayout() || !d.getLayout().fixed) && d.setLayout([n * Math.cos(c) + i, n * Math.sin(c) + a]), c += f;
    });
  }
};
function LB(t, r, e, n) {
  var i = t.getGraphicEl();
  if (i) {
    var a = t.getModel(), o = a.get(["label", "rotate"]) || 0, s = i.getSymbolPath();
    if (r) {
      var l = t.getLayout(), u = Math.atan2(l[1] - n, l[0] - e);
      u < 0 && (u = Math.PI * 2 + u);
      var c = l[0] < e;
      c && (u = u - Math.PI);
      var d = c ? "left" : "right";
      s.setTextConfig({
        rotation: -u,
        position: d,
        origin: "center"
      });
      var f = s.ensureState("emphasis");
      ae(f.textConfig || (f.textConfig = {}), {
        position: d
      });
    } else
      s.setTextConfig({
        rotation: o *= Math.PI / 180
      });
  }
}
function Wae(t) {
  t.eachSeriesByType("graph", function(r) {
    r.get("layout") === "circular" && e_(r, "symbolSize");
  });
}
var Ad = sm;
function Zae(t, r, e) {
  for (var n = t, i = r, a = e.rect, o = a.width, s = a.height, l = [a.x + o / 2, a.y + s / 2], u = e.gravity == null ? 0.1 : e.gravity, c = 0; c < n.length; c++) {
    var d = n[c];
    d.p || (d.p = fu(o * (Math.random() - 0.5) + l[0], s * (Math.random() - 0.5) + l[1])), d.pp = Ho(d.p), d.edges = null;
  }
  var f = e.friction == null ? 0.6 : e.friction, h = f, p, v;
  return {
    warmUp: function() {
      h = f * 0.8;
    },
    setFixed: function(g) {
      n[g].fixed = !0;
    },
    setUnfixed: function(g) {
      n[g].fixed = !1;
    },
    /**
     * Before step hook
     */
    beforeStep: function(g) {
      p = g;
    },
    /**
     * After step hook
     */
    afterStep: function(g) {
      v = g;
    },
    /**
     * Some formulas were originally copied from "d3.js"
     * https://github.com/d3/d3/blob/b516d77fb8566b576088e73410437494717ada26/src/layout/force.js
     * with some modifications made for this project.
     * See the license statement at the head of this file.
     */
    step: function(g) {
      p && p(n, i);
      for (var m = [], y = n.length, b = 0; b < i.length; b++) {
        var C = i[b];
        if (!C.ignoreForceLayout) {
          var w = C.n1, _ = C.n2;
          Il(m, _.p, w.p);
          var x = pv(m) - C.d, I = _.w / (w.w + _.w);
          isNaN(I) && (I = 0), Jc(m, m), !w.fixed && Ad(w.p, w.p, m, I * x * h), !_.fixed && Ad(_.p, _.p, m, -(1 - I) * x * h);
        }
      }
      for (var b = 0; b < y; b++) {
        var D = n[b];
        D.fixed || (Il(m, l, D.p), Ad(D.p, D.p, m, u * h));
      }
      for (var b = 0; b < y; b++)
        for (var w = n[b], T = b + 1; T < y; T++) {
          var _ = n[T];
          Il(m, _.p, w.p);
          var x = pv(m);
          x === 0 && (zP(m, Math.random() - 0.5, Math.random() - 0.5), x = 1);
          var A = (w.rep + _.rep) / x / x;
          !w.fixed && Ad(w.pp, w.pp, m, A), !_.fixed && Ad(_.pp, _.pp, m, -A);
        }
      for (var M = [], b = 0; b < y; b++) {
        var D = n[b];
        D.fixed || (Il(M, D.p, D.pp), Ad(D.p, D.p, M, h), Qn(D.pp, D.p));
      }
      h = h * 0.992;
      var R = h < 0.01;
      v && v(n, i, R), g && g(R);
    }
  };
}
function jae(t) {
  t.eachSeriesByType("graph", function(r) {
    var e = r.coordinateSystem;
    if (!(e && e.type !== "view"))
      if (r.get("layout") === "force") {
        var n = r.preservedPoints || {}, i = r.getGraph(), a = i.data, o = i.edgeData, s = r.getModel("force"), l = s.get("initLayout");
        r.preservedPoints ? a.each(function(b) {
          var C = a.getId(b);
          a.setItemLayout(b, n[C] || [NaN, NaN]);
        }) : !l || l === "none" ? RB(r) : l === "circular" && e_(r, "value");
        var u = a.getDataExtent("value"), c = o.getDataExtent("value"), d = s.get("repulsion"), f = s.get("edgeLength"), h = ue(d) ? d : [d, d], p = ue(f) ? f : [f, f];
        p = [p[1], p[0]];
        var v = a.mapArray("value", function(b, C) {
          var w = a.getItemLayout(C), _ = zt(b, u, h);
          return isNaN(_) && (_ = (h[0] + h[1]) / 2), {
            w: _,
            rep: _,
            fixed: a.getItemModel(C).get("fixed"),
            p: !w || isNaN(w[0]) || isNaN(w[1]) ? null : w
          };
        }), g = o.mapArray("value", function(b, C) {
          var w = i.getEdgeByIndex(C), _ = zt(b, c, p);
          isNaN(_) && (_ = (p[0] + p[1]) / 2);
          var x = w.getModel(), I = Ki(w.getModel().get(["lineStyle", "curveness"]), -qw(w, r, C, !0), 0);
          return {
            n1: v[w.node1.dataIndex],
            n2: v[w.node2.dataIndex],
            d: _,
            curveness: I,
            ignoreForceLayout: x.get("ignoreForceLayout")
          };
        }), m = e.getBoundingRect(), y = Zae(v, g, {
          rect: m,
          gravity: s.get("gravity"),
          friction: s.get("friction")
        });
        y.beforeStep(function(b, C) {
          for (var w = 0, _ = b.length; w < _; w++)
            b[w].fixed && Qn(b[w].p, i.getNodeByIndex(w).getLayout());
        }), y.afterStep(function(b, C, w) {
          for (var _ = 0, x = b.length; _ < x; _++)
            b[_].fixed || i.getNodeByIndex(_).setLayout(b[_].p), n[a.getId(_)] = b[_].p;
          for (var _ = 0, x = C.length; _ < x; _++) {
            var I = C[_], D = i.getEdgeByIndex(_), T = I.n1.p, A = I.n2.p, M = D.getLayout();
            M = M ? M.slice() : [], M[0] = M[0] || [], M[1] = M[1] || [], Qn(M[0], T), Qn(M[1], A), +I.curveness && (M[2] = [(T[0] + A[0]) / 2 - (T[1] - A[1]) * I.curveness, (T[1] + A[1]) / 2 - (A[0] - T[0]) * I.curveness]), D.setLayout(M);
          }
        }), r.forceLayout = y, r.preservedPoints = n, y.step();
      } else
        r.forceLayout = null;
  });
}
function Yae(t, r, e) {
  var n = ae(t.getBoxLayoutParams(), {
    aspect: e
  });
  return cn(n, {
    width: r.getWidth(),
    height: r.getHeight()
  });
}
function Xae(t, r) {
  var e = [];
  return t.eachSeriesByType("graph", function(n) {
    var i = n.get("coordinateSystem");
    if (!i || i === "view") {
      var a = n.getData(), o = a.mapArray(function(g) {
        var m = a.getItemModel(g);
        return [+m.get("x"), +m.get("y")];
      }), s = [], l = [];
      s2(o, s, l), l[0] - s[0] === 0 && (l[0] += 1, s[0] -= 1), l[1] - s[1] === 0 && (l[1] += 1, s[1] -= 1);
      var u = (l[0] - s[0]) / (l[1] - s[1]), c = Yae(n, r, u);
      isNaN(u) && (s = [c.x, c.y], l = [c.x + c.width, c.y + c.height]);
      var d = l[0] - s[0], f = l[1] - s[1], h = c.width, p = c.height, v = n.coordinateSystem = new Tg();
      v.zoomLimit = n.get("scaleLimit"), v.setBoundingRect(s[0], s[1], d, f), v.setViewRect(c.x, c.y, h, p), v.setCenter(n.get("center"), r), v.setZoom(n.get("zoom")), e.push(v);
    }
  }), e;
}
var QD = gn.prototype, n3 = th.prototype, EB = (
  /** @class */
  /* @__PURE__ */ function() {
    function t() {
      this.x1 = 0, this.y1 = 0, this.x2 = 0, this.y2 = 0, this.percent = 1;
    }
    return t;
  }()
);
(function(t) {
  ee(r, t);
  function r() {
    return t !== null && t.apply(this, arguments) || this;
  }
  return r;
})(EB);
function i3(t) {
  return isNaN(+t.cpx1) || isNaN(+t.cpy1);
}
var $ae = (
  /** @class */
  function(t) {
    ee(r, t);
    function r(e) {
      var n = t.call(this, e) || this;
      return n.type = "ec-line", n;
    }
    return r.prototype.getDefaultStyle = function() {
      return {
        stroke: "#000",
        fill: null
      };
    }, r.prototype.getDefaultShape = function() {
      return new EB();
    }, r.prototype.buildPath = function(e, n) {
      i3(n) ? QD.buildPath.call(this, e, n) : n3.buildPath.call(this, e, n);
    }, r.prototype.pointAt = function(e) {
      return i3(this.shape) ? QD.pointAt.call(this, e) : n3.pointAt.call(this, e);
    }, r.prototype.tangentAt = function(e) {
      var n = this.shape, i = i3(n) ? [n.x2 - n.x1, n.y2 - n.y1] : n3.tangentAt.call(this, e);
      return Jc(i, i);
    }, r;
  }(gt)
), a3 = ["fromSymbol", "toSymbol"];
function eT(t) {
  return "_" + t + "Type";
}
function tT(t, r, e) {
  var n = r.getItemVisual(e, t);
  if (!n || n === "none")
    return n;
  var i = r.getItemVisual(e, t + "Size"), a = r.getItemVisual(e, t + "Rotate"), o = r.getItemVisual(e, t + "Offset"), s = r.getItemVisual(e, t + "KeepAspect"), l = fh(i), u = td(o || 0, l);
  return n + l + u + (a || "") + (s || "");
}
function rT(t, r, e) {
  var n = r.getItemVisual(e, t);
  if (!(!n || n === "none")) {
    var i = r.getItemVisual(e, t + "Size"), a = r.getItemVisual(e, t + "Rotate"), o = r.getItemVisual(e, t + "Offset"), s = r.getItemVisual(e, t + "KeepAspect"), l = fh(i), u = td(o || 0, l), c = en(n, -l[0] / 2 + u[0], -l[1] / 2 + u[1], l[0], l[1], null, s);
    return c.__specifiedRotation = a == null || isNaN(a) ? void 0 : +a * Math.PI / 180 || 0, c.name = t, c;
  }
}
function Uae(t) {
  var r = new $ae({
    name: "line",
    subPixelOptimize: !0
  });
  return P9(r.shape, t), r;
}
function P9(t, r) {
  t.x1 = r[0][0], t.y1 = r[0][1], t.x2 = r[1][0], t.y2 = r[1][1], t.percent = 1;
  var e = r[2];
  e ? (t.cpx1 = e[0], t.cpy1 = e[1]) : (t.cpx1 = NaN, t.cpy1 = NaN);
}
var t_ = (
  /** @class */
  function(t) {
    ee(r, t);
    function r(e, n, i) {
      var a = t.call(this) || this;
      return a._createLine(e, n, i), a;
    }
    return r.prototype._createLine = function(e, n, i) {
      var a = e.hostModel, o = e.getItemLayout(n), s = Uae(o);
      s.shape.percent = 0, Cr(s, {
        shape: {
          percent: 1
        }
      }, a, n), this.add(s), L(a3, function(l) {
        var u = rT(l, e, n);
        this.add(u), this[eT(l)] = tT(l, e, n);
      }, this), this._updateCommonStl(e, n, i);
    }, r.prototype.updateData = function(e, n, i) {
      var a = e.hostModel, o = this.childOfName("line"), s = e.getItemLayout(n), l = {
        shape: {}
      };
      P9(l.shape, s), kt(o, l, a, n), L(a3, function(u) {
        var c = tT(u, e, n), d = eT(u);
        if (this[d] !== c) {
          this.remove(this.childOfName(u));
          var f = rT(u, e, n);
          this.add(f);
        }
        this[d] = c;
      }, this), this._updateCommonStl(e, n, i);
    }, r.prototype.getLinePath = function() {
      return this.childAt(0);
    }, r.prototype._updateCommonStl = function(e, n, i) {
      var a = e.hostModel, o = this.childOfName("line"), s = i && i.emphasisLineStyle, l = i && i.blurLineStyle, u = i && i.selectLineStyle, c = i && i.labelStatesModels, d = i && i.emphasisDisabled, f = i && i.focus, h = i && i.blurScope;
      if (!i || e.hasItemOption) {
        var p = e.getItemModel(n), v = p.getModel("emphasis");
        s = v.getModel("lineStyle").getLineStyle(), l = p.getModel(["blur", "lineStyle"]).getLineStyle(), u = p.getModel(["select", "lineStyle"]).getLineStyle(), d = v.get("disabled"), f = v.get("focus"), h = v.get("blurScope"), c = xn(p);
      }
      var g = e.getItemVisual(n, "style"), m = g.stroke;
      o.useStyle(g), o.style.fill = null, o.style.strokeNoScale = !0, o.ensureState("emphasis").style = s, o.ensureState("blur").style = l, o.ensureState("select").style = u, L(a3, function(_) {
        var x = this.childOfName(_);
        if (x) {
          x.setColor(m), x.style.opacity = g.opacity;
          for (var I = 0; I < xi.length; I++) {
            var D = xi[I], T = o.getState(D);
            if (T) {
              var A = T.style || {}, M = x.ensureState(D), R = M.style || (M.style = {});
              A.stroke != null && (R[x.__isEmptyBrush ? "stroke" : "fill"] = A.stroke), A.opacity != null && (R.opacity = A.opacity);
            }
          }
          x.markRedraw();
        }
      }, this);
      var y = a.getRawValue(n);
      Xn(this, c, {
        labelDataIndex: n,
        labelFetcher: {
          getFormattedLabel: function(_, x) {
            return a.getFormattedLabel(_, x, e.dataType);
          }
        },
        inheritColor: m || "#000",
        defaultOpacity: g.opacity,
        defaultText: (y == null ? e.getName(n) : isFinite(y) ? Or(y) : y) + ""
      });
      var b = this.getTextContent();
      if (b) {
        var C = c.normal;
        b.__align = b.style.align, b.__verticalAlign = b.style.verticalAlign, b.__position = C.get("position") || "middle";
        var w = C.get("distance");
        ue(w) || (w = [w, w]), b.__labelDistance = w;
      }
      this.setTextConfig({
        position: null,
        local: !0,
        inside: !1
        // Can't be inside for stroke element.
      }), Vr(this, f, h, d);
    }, r.prototype.highlight = function() {
      Xs(this);
    }, r.prototype.downplay = function() {
      $s(this);
    }, r.prototype.updateLayout = function(e, n) {
      this.setLinePoints(e.getItemLayout(n));
    }, r.prototype.setLinePoints = function(e) {
      var n = this.childOfName("line");
      P9(n.shape, e), n.dirty();
    }, r.prototype.beforeUpdate = function() {
      var e = this, n = e.childOfName("fromSymbol"), i = e.childOfName("toSymbol"), a = e.getTextContent();
      if (!n && !i && (!a || a.ignore))
        return;
      for (var o = 1, s = this.parent; s; )
        s.scaleX && (o /= s.scaleX), s = s.parent;
      var l = e.childOfName("line");
      if (!this.__dirty && !l.__dirty)
        return;
      var u = l.shape.percent, c = l.pointAt(0), d = l.pointAt(u), f = Il([], d, c);
      Jc(f, f);
      function h(T, A) {
        var M = T.__specifiedRotation;
        if (M == null) {
          var R = l.tangentAt(A);
          T.attr("rotation", (A === 1 ? -1 : 1) * Math.PI / 2 - Math.atan2(R[1], R[0]));
        } else
          T.attr("rotation", M);
      }
      if (n && (n.setPosition(c), h(n, 0), n.scaleX = n.scaleY = o * u, n.markRedraw()), i && (i.setPosition(d), h(i, 1), i.scaleX = i.scaleY = o * u, i.markRedraw()), a && !a.ignore) {
        a.x = a.y = 0, a.originX = a.originY = 0;
        var p = void 0, v = void 0, g = a.__labelDistance, m = g[0] * o, y = g[1] * o, b = u / 2, C = l.tangentAt(b), w = [C[1], -C[0]], _ = l.pointAt(b);
        w[1] > 0 && (w[0] = -w[0], w[1] = -w[1]);
        var x = C[0] < 0 ? -1 : 1;
        if (a.__position !== "start" && a.__position !== "end") {
          var I = -Math.atan2(C[1], C[0]);
          d[0] < c[0] && (I = Math.PI + I), a.rotation = I;
        }
        var D = void 0;
        switch (a.__position) {
          case "insideStartTop":
          case "insideMiddleTop":
          case "insideEndTop":
          case "middle":
            D = -y, v = "bottom";
            break;
          case "insideStartBottom":
          case "insideMiddleBottom":
          case "insideEndBottom":
            D = y, v = "top";
            break;
          default:
            D = 0, v = "middle";
        }
        switch (a.__position) {
          case "end":
            a.x = f[0] * m + d[0], a.y = f[1] * y + d[1], p = f[0] > 0.8 ? "left" : f[0] < -0.8 ? "right" : "center", v = f[1] > 0.8 ? "top" : f[1] < -0.8 ? "bottom" : "middle";
            break;
          case "start":
            a.x = -f[0] * m + c[0], a.y = -f[1] * y + c[1], p = f[0] > 0.8 ? "right" : f[0] < -0.8 ? "left" : "center", v = f[1] > 0.8 ? "bottom" : f[1] < -0.8 ? "top" : "middle";
            break;
          case "insideStartTop":
          case "insideStart":
          case "insideStartBottom":
            a.x = m * x + c[0], a.y = c[1] + D, p = C[0] < 0 ? "right" : "left", a.originX = -m * x, a.originY = -D;
            break;
          case "insideMiddleTop":
          case "insideMiddle":
          case "insideMiddleBottom":
          case "middle":
            a.x = _[0], a.y = _[1] + D, p = "center", a.originY = -D;
            break;
          case "insideEndTop":
          case "insideEnd":
          case "insideEndBottom":
            a.x = -m * x + d[0], a.y = d[1] + D, p = C[0] >= 0 ? "right" : "left", a.originX = m * x, a.originY = -D;
            break;
        }
        a.scaleX = a.scaleY = o, a.setStyle({
          // Use the user specified text align and baseline first
          verticalAlign: a.__verticalAlign || v,
          align: a.__align || p
        });
      }
    }, r;
  }(ze)
), r_ = (
  /** @class */
  function() {
    function t(r) {
      this.group = new ze(), this._LineCtor = r || t_;
    }
    return t.prototype.updateData = function(r) {
      var e = this;
      this._progressiveEls = null;
      var n = this, i = n.group, a = n._lineData;
      n._lineData = r, a || i.removeAll();
      var o = nT(r);
      r.diff(a).add(function(s) {
        e._doAdd(r, s, o);
      }).update(function(s, l) {
        e._doUpdate(a, r, l, s, o);
      }).remove(function(s) {
        i.remove(a.getItemGraphicEl(s));
      }).execute();
    }, t.prototype.updateLayout = function() {
      var r = this._lineData;
      r && r.eachItemGraphicEl(function(e, n) {
        e.updateLayout(r, n);
      }, this);
    }, t.prototype.incrementalPrepareUpdate = function(r) {
      this._seriesScope = nT(r), this._lineData = null, this.group.removeAll();
    }, t.prototype.incrementalUpdate = function(r, e) {
      this._progressiveEls = [];
      function n(s) {
        !s.isGroup && !Jae(s) && (s.incremental = !0, s.ensureState("emphasis").hoverLayer = !0);
      }
      for (var i = r.start; i < r.end; i++) {
        var a = e.getItemLayout(i);
        if (o3(a)) {
          var o = new this._LineCtor(e, i, this._seriesScope);
          o.traverse(n), this.group.add(o), e.setItemGraphicEl(i, o), this._progressiveEls.push(o);
        }
      }
    }, t.prototype.remove = function() {
      this.group.removeAll();
    }, t.prototype.eachRendered = function(r) {
      pu(this._progressiveEls || this.group, r);
    }, t.prototype._doAdd = function(r, e, n) {
      var i = r.getItemLayout(e);
      if (o3(i)) {
        var a = new this._LineCtor(r, e, n);
        r.setItemGraphicEl(e, a), this.group.add(a);
      }
    }, t.prototype._doUpdate = function(r, e, n, i, a) {
      var o = r.getItemGraphicEl(n);
      if (!o3(e.getItemLayout(i))) {
        this.group.remove(o);
        return;
      }
      o ? o.updateData(e, i, a) : o = new this._LineCtor(e, i, a), e.setItemGraphicEl(i, o), this.group.add(o);
    }, t;
  }()
);
function Jae(t) {
  return t.animators && t.animators.length > 0;
}
function nT(t) {
  var r = t.hostModel, e = r.getModel("emphasis");
  return {
    lineStyle: r.getModel("lineStyle").getLineStyle(),
    emphasisLineStyle: e.getModel(["lineStyle"]).getLineStyle(),
    blurLineStyle: r.getModel(["blur", "lineStyle"]).getLineStyle(),
    selectLineStyle: r.getModel(["select", "lineStyle"]).getLineStyle(),
    emphasisDisabled: e.get("disabled"),
    blurScope: e.get("blurScope"),
    focus: e.get("focus"),
    labelStatesModels: xn(r)
  };
}
function iT(t) {
  return isNaN(t[0]) || isNaN(t[1]);
}
function o3(t) {
  return t && !iT(t[0]) && !iT(t[1]);
}
var s3 = [], l3 = [], u3 = [], Dd = Rn, c3 = Gl, aT = Math.abs;
function oT(t, r, e) {
  for (var n = t[0], i = t[1], a = t[2], o = 1 / 0, s, l = e * e, u = 0.1, c = 0.1; c <= 0.9; c += 0.1) {
    s3[0] = Dd(n[0], i[0], a[0], c), s3[1] = Dd(n[1], i[1], a[1], c);
    var d = aT(c3(s3, r) - l);
    d < o && (o = d, s = c);
  }
  for (var f = 0; f < 32; f++) {
    var h = s + u;
    l3[0] = Dd(n[0], i[0], a[0], s), l3[1] = Dd(n[1], i[1], a[1], s), u3[0] = Dd(n[0], i[0], a[0], h), u3[1] = Dd(n[1], i[1], a[1], h);
    var d = c3(l3, r) - l;
    if (aT(d) < 0.01)
      break;
    var p = c3(u3, r) - l;
    u /= 2, d < 0 ? p >= 0 ? s = s + u : s = s - u : p >= 0 ? s = s - u : s = s + u;
  }
  return s;
}
function d3(t, r) {
  var e = [], n = vv, i = [[], [], []], a = [[], []], o = [];
  r /= 2, t.eachEdge(function(s, l) {
    var u = s.getLayout(), c = s.getVisual("fromSymbol"), d = s.getVisual("toSymbol");
    u.__original || (u.__original = [Ho(u[0]), Ho(u[1])], u[2] && u.__original.push(Ho(u[2])));
    var f = u.__original;
    if (u[2] != null) {
      if (Qn(i[0], f[0]), Qn(i[1], f[2]), Qn(i[2], f[1]), c && c !== "none") {
        var h = Op(s.node1), p = oT(i, f[0], h * r);
        n(i[0][0], i[1][0], i[2][0], p, e), i[0][0] = e[3], i[1][0] = e[4], n(i[0][1], i[1][1], i[2][1], p, e), i[0][1] = e[3], i[1][1] = e[4];
      }
      if (d && d !== "none") {
        var h = Op(s.node2), p = oT(i, f[1], h * r);
        n(i[0][0], i[1][0], i[2][0], p, e), i[1][0] = e[1], i[2][0] = e[2], n(i[0][1], i[1][1], i[2][1], p, e), i[1][1] = e[1], i[2][1] = e[2];
      }
      Qn(u[0], i[0]), Qn(u[1], i[2]), Qn(u[2], i[1]);
    } else {
      if (Qn(a[0], f[0]), Qn(a[1], f[1]), Il(o, a[1], a[0]), Jc(o, o), c && c !== "none") {
        var h = Op(s.node1);
        sm(a[0], a[0], o, h * r);
      }
      if (d && d !== "none") {
        var h = Op(s.node2);
        sm(a[1], a[1], o, -h * r);
      }
      Qn(u[0], a[0]), Qn(u[1], a[1]);
    }
  });
}
function sT(t) {
  return t.type === "view";
}
var Kae = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.init = function(e, n) {
      var i = new _g(), a = new r_(), o = this.group;
      this._controller = new Dg(n.getZr()), this._controllerHost = {
        target: o
      }, o.add(i.group), o.add(a.group), this._symbolDraw = i, this._lineDraw = a, this._firstRender = !0;
    }, r.prototype.render = function(e, n, i) {
      var a = this, o = e.coordinateSystem;
      this._model = e;
      var s = this._symbolDraw, l = this._lineDraw, u = this.group;
      if (sT(o)) {
        var c = {
          x: o.x,
          y: o.y,
          scaleX: o.scaleX,
          scaleY: o.scaleY
        };
        this._firstRender ? u.attr(c) : kt(u, c, e);
      }
      d3(e.getGraph(), Np(e));
      var d = e.getData();
      s.updateData(d);
      var f = e.getEdgeData();
      l.updateData(f), this._updateNodeAndLinkScale(), this._updateController(e, n, i), clearTimeout(this._layoutTimeout);
      var h = e.forceLayout, p = e.get(["force", "layoutAnimation"]);
      h && this._startForceLayoutIteration(h, p);
      var v = e.get("layout");
      d.graph.eachNode(function(b) {
        var C = b.dataIndex, w = b.getGraphicEl(), _ = b.getModel();
        if (w) {
          w.off("drag").off("dragend");
          var x = _.get("draggable");
          x && w.on("drag", function(D) {
            switch (v) {
              case "force":
                h.warmUp(), !a._layouting && a._startForceLayoutIteration(h, p), h.setFixed(C), d.setItemLayout(C, [w.x, w.y]);
                break;
              case "circular":
                d.setItemLayout(C, [w.x, w.y]), b.setLayout({
                  fixed: !0
                }, !0), e_(e, "symbolSize", b, [D.offsetX, D.offsetY]), a.updateLayout(e);
                break;
              case "none":
              default:
                d.setItemLayout(C, [w.x, w.y]), Qw(e.getGraph(), e), a.updateLayout(e);
                break;
            }
          }).on("dragend", function() {
            h && h.setUnfixed(C);
          }), w.setDraggable(x, !!_.get("cursor"));
          var I = _.get(["emphasis", "focus"]);
          I === "adjacency" && (Ze(w).focus = b.getAdjacentDataIndices());
        }
      }), d.graph.eachEdge(function(b) {
        var C = b.getGraphicEl(), w = b.getModel().get(["emphasis", "focus"]);
        C && w === "adjacency" && (Ze(C).focus = {
          edge: [b.dataIndex],
          node: [b.node1.dataIndex, b.node2.dataIndex]
        });
      });
      var g = e.get("layout") === "circular" && e.get(["circular", "rotateLabel"]), m = d.getLayout("cx"), y = d.getLayout("cy");
      d.graph.eachNode(function(b) {
        LB(b, g, m, y);
      }), this._firstRender = !1;
    }, r.prototype.dispose = function() {
      this.remove(), this._controller && this._controller.dispose(), this._controllerHost = null;
    }, r.prototype._startForceLayoutIteration = function(e, n) {
      var i = this;
      (function a() {
        e.step(function(o) {
          i.updateLayout(i._model), (i._layouting = !o) && (n ? i._layoutTimeout = setTimeout(a, 16) : a());
        });
      })();
    }, r.prototype._updateController = function(e, n, i) {
      var a = this, o = this._controller, s = this._controllerHost, l = this.group;
      if (o.setPointerChecker(function(u, c, d) {
        var f = l.getBoundingRect();
        return f.applyTransform(l.transform), f.contain(c, d) && !R2(u, i, e);
      }), !sT(e.coordinateSystem)) {
        o.disable();
        return;
      }
      o.enable(e.get("roam")), s.zoomLimit = e.get("scaleLimit"), s.zoom = e.coordinateSystem.getZoom(), o.off("pan").off("zoom").on("pan", function(u) {
        Zw(s, u.dx, u.dy), i.dispatchAction({
          seriesId: e.id,
          type: "graphRoam",
          dx: u.dx,
          dy: u.dy
        });
      }).on("zoom", function(u) {
        jw(s, u.scale, u.originX, u.originY), i.dispatchAction({
          seriesId: e.id,
          type: "graphRoam",
          zoom: u.scale,
          originX: u.originX,
          originY: u.originY
        }), a._updateNodeAndLinkScale(), d3(e.getGraph(), Np(e)), a._lineDraw.updateLayout(), i.updateLabelLayout();
      });
    }, r.prototype._updateNodeAndLinkScale = function() {
      var e = this._model, n = e.getData(), i = Np(e);
      n.eachItemGraphicEl(function(a, o) {
        a && a.setSymbolScale(i);
      });
    }, r.prototype.updateLayout = function(e) {
      d3(e.getGraph(), Np(e)), this._symbolDraw.updateLayout(), this._lineDraw.updateLayout();
    }, r.prototype.remove = function() {
      clearTimeout(this._layoutTimeout), this._layouting = !1, this._layoutTimeout = null, this._symbolDraw && this._symbolDraw.remove(), this._lineDraw && this._lineDraw.remove();
    }, r.type = "graph", r;
  }(Yt)
);
function Td(t) {
  return "_EC_" + t;
}
var qae = (
  /** @class */
  function() {
    function t(r) {
      this.type = "graph", this.nodes = [], this.edges = [], this._nodesMap = {}, this._edgesMap = {}, this._directed = r || !1;
    }
    return t.prototype.isDirected = function() {
      return this._directed;
    }, t.prototype.addNode = function(r, e) {
      r = r == null ? "" + e : "" + r;
      var n = this._nodesMap;
      if (n[Td(r)]) {
        process.env.NODE_ENV !== "production" && console.error("Graph nodes have duplicate name or id");
        return;
      }
      var i = new qu(r, e);
      return i.hostGraph = this, this.nodes.push(i), n[Td(r)] = i, i;
    }, t.prototype.getNodeByIndex = function(r) {
      var e = this.data.getRawIndex(r);
      return this.nodes[e];
    }, t.prototype.getNodeById = function(r) {
      return this._nodesMap[Td(r)];
    }, t.prototype.addEdge = function(r, e, n) {
      var i = this._nodesMap, a = this._edgesMap;
      if (Mt(r) && (r = this.nodes[r]), Mt(e) && (e = this.nodes[e]), r instanceof qu || (r = i[Td(r)]), e instanceof qu || (e = i[Td(e)]), !(!r || !e)) {
        var o = r.id + "-" + e.id, s = new kB(r, e, n);
        return s.hostGraph = this, this._directed && (r.outEdges.push(s), e.inEdges.push(s)), r.edges.push(s), r !== e && e.edges.push(s), this.edges.push(s), a[o] = s, s;
      }
    }, t.prototype.getEdgeByIndex = function(r) {
      var e = this.edgeData.getRawIndex(r);
      return this.edges[e];
    }, t.prototype.getEdge = function(r, e) {
      r instanceof qu && (r = r.id), e instanceof qu && (e = e.id);
      var n = this._edgesMap;
      return this._directed ? n[r + "-" + e] : n[r + "-" + e] || n[e + "-" + r];
    }, t.prototype.eachNode = function(r, e) {
      for (var n = this.nodes, i = n.length, a = 0; a < i; a++)
        n[a].dataIndex >= 0 && r.call(e, n[a], a);
    }, t.prototype.eachEdge = function(r, e) {
      for (var n = this.edges, i = n.length, a = 0; a < i; a++)
        n[a].dataIndex >= 0 && n[a].node1.dataIndex >= 0 && n[a].node2.dataIndex >= 0 && r.call(e, n[a], a);
    }, t.prototype.breadthFirstTraverse = function(r, e, n, i) {
      if (e instanceof qu || (e = this._nodesMap[Td(e)]), !!e) {
        for (var a = n === "out" ? "outEdges" : n === "in" ? "inEdges" : "edges", o = 0; o < this.nodes.length; o++)
          this.nodes[o].__visited = !1;
        if (!r.call(i, e, null))
          for (var s = [e]; s.length; )
            for (var l = s.shift(), u = l[a], o = 0; o < u.length; o++) {
              var c = u[o], d = c.node1 === l ? c.node2 : c.node1;
              if (!d.__visited) {
                if (r.call(i, d, l))
                  return;
                s.push(d), d.__visited = !0;
              }
            }
      }
    }, t.prototype.update = function() {
      for (var r = this.data, e = this.edgeData, n = this.nodes, i = this.edges, a = 0, o = n.length; a < o; a++)
        n[a].dataIndex = -1;
      for (var a = 0, o = r.count(); a < o; a++)
        n[r.getRawIndex(a)].dataIndex = a;
      e.filterSelf(function(s) {
        var l = i[e.getRawIndex(s)];
        return l.node1.dataIndex >= 0 && l.node2.dataIndex >= 0;
      });
      for (var a = 0, o = i.length; a < o; a++)
        i[a].dataIndex = -1;
      for (var a = 0, o = e.count(); a < o; a++)
        i[e.getRawIndex(a)].dataIndex = a;
    }, t.prototype.clone = function() {
      for (var r = new t(this._directed), e = this.nodes, n = this.edges, i = 0; i < e.length; i++)
        r.addNode(e[i].id, e[i].dataIndex);
      for (var i = 0; i < n.length; i++) {
        var a = n[i];
        r.addEdge(a.node1.id, a.node2.id, a.dataIndex);
      }
      return r;
    }, t;
  }()
), qu = (
  /** @class */
  function() {
    function t(r, e) {
      this.inEdges = [], this.outEdges = [], this.edges = [], this.dataIndex = -1, this.id = r ?? "", this.dataIndex = e ?? -1;
    }
    return t.prototype.degree = function() {
      return this.edges.length;
    }, t.prototype.inDegree = function() {
      return this.inEdges.length;
    }, t.prototype.outDegree = function() {
      return this.outEdges.length;
    }, t.prototype.getModel = function(r) {
      if (!(this.dataIndex < 0)) {
        var e = this.hostGraph, n = e.data.getItemModel(this.dataIndex);
        return n.getModel(r);
      }
    }, t.prototype.getAdjacentDataIndices = function() {
      for (var r = {
        edge: [],
        node: []
      }, e = 0; e < this.edges.length; e++) {
        var n = this.edges[e];
        n.dataIndex < 0 || (r.edge.push(n.dataIndex), r.node.push(n.node1.dataIndex, n.node2.dataIndex));
      }
      return r;
    }, t.prototype.getTrajectoryDataIndices = function() {
      for (var r = xe(), e = xe(), n = 0; n < this.edges.length; n++) {
        var i = this.edges[n];
        if (!(i.dataIndex < 0)) {
          r.set(i.dataIndex, !0);
          for (var a = [i.node1], o = [i.node2], s = 0; s < a.length; ) {
            var l = a[s];
            s++, e.set(l.dataIndex, !0);
            for (var u = 0; u < l.inEdges.length; u++)
              r.set(l.inEdges[u].dataIndex, !0), a.push(l.inEdges[u].node1);
          }
          for (s = 0; s < o.length; ) {
            var c = o[s];
            s++, e.set(c.dataIndex, !0);
            for (var u = 0; u < c.outEdges.length; u++)
              r.set(c.outEdges[u].dataIndex, !0), o.push(c.outEdges[u].node2);
          }
        }
      }
      return {
        edge: r.keys(),
        node: e.keys()
      };
    }, t;
  }()
), kB = (
  /** @class */
  function() {
    function t(r, e, n) {
      this.dataIndex = -1, this.node1 = r, this.node2 = e, this.dataIndex = n ?? -1;
    }
    return t.prototype.getModel = function(r) {
      if (!(this.dataIndex < 0)) {
        var e = this.hostGraph, n = e.edgeData.getItemModel(this.dataIndex);
        return n.getModel(r);
      }
    }, t.prototype.getAdjacentDataIndices = function() {
      return {
        edge: [this.dataIndex],
        node: [this.node1.dataIndex, this.node2.dataIndex]
      };
    }, t.prototype.getTrajectoryDataIndices = function() {
      var r = xe(), e = xe();
      r.set(this.dataIndex, !0);
      for (var n = [this.node1], i = [this.node2], a = 0; a < n.length; ) {
        var o = n[a];
        a++, e.set(o.dataIndex, !0);
        for (var s = 0; s < o.inEdges.length; s++)
          r.set(o.inEdges[s].dataIndex, !0), n.push(o.inEdges[s].node1);
      }
      for (a = 0; a < i.length; ) {
        var l = i[a];
        a++, e.set(l.dataIndex, !0);
        for (var s = 0; s < l.outEdges.length; s++)
          r.set(l.outEdges[s].dataIndex, !0), i.push(l.outEdges[s].node2);
      }
      return {
        edge: r.keys(),
        node: e.keys()
      };
    }, t;
  }()
);
function PB(t, r) {
  return {
    /**
     * @param Default 'value'. can be 'a', 'b', 'c', 'd', 'e'.
     */
    getValue: function(e) {
      var n = this[t][r];
      return n.getStore().get(n.getDimensionIndex(e || "value"), this.dataIndex);
    },
    // TODO: TYPE stricter type.
    setVisual: function(e, n) {
      this.dataIndex >= 0 && this[t][r].setItemVisual(this.dataIndex, e, n);
    },
    getVisual: function(e) {
      return this[t][r].getItemVisual(this.dataIndex, e);
    },
    setLayout: function(e, n) {
      this.dataIndex >= 0 && this[t][r].setItemLayout(this.dataIndex, e, n);
    },
    getLayout: function() {
      return this[t][r].getItemLayout(this.dataIndex);
    },
    getGraphicEl: function() {
      return this[t][r].getItemGraphicEl(this.dataIndex);
    },
    getRawIndex: function() {
      return this[t][r].getRawIndex(this.dataIndex);
    }
  };
}
Xr(qu, PB("hostGraph", "data"));
Xr(kB, PB("hostGraph", "edgeData"));
function NB(t, r, e, n, i) {
  for (var a = new qae(n), o = 0; o < t.length; o++)
    a.addNode(Qr(
      // Id, name, dataIndex
      t[o].id,
      t[o].name,
      o
    ), o);
  for (var s = [], l = [], u = 0, o = 0; o < r.length; o++) {
    var c = r[o], d = c.source, f = c.target;
    a.addEdge(d, f, u) && (l.push(c), s.push(Qr(vn(c.id, null), d + " > " + f)), u++);
  }
  var h = e.get("coordinateSystem"), p;
  if (h === "cartesian2d" || h === "polar")
    p = os(t, e);
  else {
    var v = ed.get(h), g = v ? v.dimensions || [] : [];
    nt(g, "value") < 0 && g.concat(["value"]);
    var m = hh(t, {
      coordDimensions: g,
      encodeDefine: e.getEncode()
    }).dimensions;
    p = new ni(m, e), p.initData(t);
  }
  var y = new ni(["value"], e);
  return y.initData(l, s), i && i(p, y), gB({
    mainData: p,
    struct: a,
    structAttr: "graph",
    datas: {
      node: p,
      edge: y
    },
    datasAttr: {
      node: "data",
      edge: "edgeData"
    }
  }), a.update(), a;
}
var Qae = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e.hasSymbolVisual = !0, e;
    }
    return r.prototype.init = function(e) {
      t.prototype.init.apply(this, arguments);
      var n = this;
      function i() {
        return n._categoriesData;
      }
      this.legendVisualProvider = new Ag(i, i), this.fillDataTextStyle(e.edges || e.links), this._updateCategoriesData();
    }, r.prototype.mergeOption = function(e) {
      t.prototype.mergeOption.apply(this, arguments), this.fillDataTextStyle(e.edges || e.links), this._updateCategoriesData();
    }, r.prototype.mergeDefaultAndTheme = function(e) {
      t.prototype.mergeDefaultAndTheme.apply(this, arguments), Vc(e, "edgeLabel", ["show"]);
    }, r.prototype.getInitialData = function(e, n) {
      var i = e.edges || e.links || [], a = e.data || e.nodes || [], o = this;
      if (a && i) {
        Bae(this);
        var s = NB(a, i, this, !0, l);
        return L(s.edges, function(u) {
          Fae(u.node1, u.node2, this, u.dataIndex);
        }, this), s.data;
      }
      function l(u, c) {
        u.wrapMethod("getItemModel", function(p) {
          var v = o._categoriesModels, g = p.getShallow("category"), m = v[g];
          return m && (m.parentModel = p.parentModel, p.parentModel = m), p;
        });
        var d = Pt.prototype.getModel;
        function f(p, v) {
          var g = d.call(this, p, v);
          return g.resolveParentPath = h, g;
        }
        c.wrapMethod("getItemModel", function(p) {
          return p.resolveParentPath = h, p.getModel = f, p;
        });
        function h(p) {
          if (p && (p[0] === "label" || p[1] === "label")) {
            var v = p.slice();
            return p[0] === "label" ? v[0] = "edgeLabel" : p[1] === "label" && (v[1] = "edgeLabel"), v;
          }
          return p;
        }
      }
    }, r.prototype.getGraph = function() {
      return this.getData().graph;
    }, r.prototype.getEdgeData = function() {
      return this.getGraph().edgeData;
    }, r.prototype.getCategoriesData = function() {
      return this._categoriesData;
    }, r.prototype.formatTooltip = function(e, n, i) {
      if (i === "edge") {
        var a = this.getData(), o = this.getDataParams(e, i), s = a.graph.getEdgeByIndex(e), l = a.getName(s.node1.dataIndex), u = a.getName(s.node2.dataIndex), c = [];
        return l != null && c.push(l), u != null && c.push(u), Sn("nameValue", {
          name: c.join(" > "),
          value: o.value,
          noValue: o.value == null
        });
      }
      var d = iV({
        series: this,
        dataIndex: e,
        multipleSeries: n
      });
      return d;
    }, r.prototype._updateCategoriesData = function() {
      var e = ce(this.option.categories || [], function(i) {
        return i.value != null ? i : ae({
          value: 0
        }, i);
      }), n = new ni(["value"], this);
      n.initData(e), this._categoriesData = n, this._categoriesModels = n.mapArray(function(i) {
        return n.getItemModel(i);
      });
    }, r.prototype.setZoom = function(e) {
      this.option.zoom = e;
    }, r.prototype.setCenter = function(e) {
      this.option.center = e;
    }, r.prototype.isAnimationEnabled = function() {
      return t.prototype.isAnimationEnabled.call(this) && !(this.get("layout") === "force" && this.get(["force", "layoutAnimation"]));
    }, r.type = "series.graph", r.dependencies = ["grid", "polar", "geo", "singleAxis", "calendar"], r.defaultOption = {
      // zlevel: 0,
      z: 2,
      coordinateSystem: "view",
      // Default option for all coordinate systems
      // xAxisIndex: 0,
      // yAxisIndex: 0,
      // polarIndex: 0,
      // geoIndex: 0,
      legendHoverLink: !0,
      layout: null,
      // Configuration of circular layout
      circular: {
        rotateLabel: !1
      },
      // Configuration of force directed layout
      force: {
        initLayout: null,
        // Node repulsion. Can be an array to represent range.
        repulsion: [0, 50],
        gravity: 0.1,
        // Initial friction
        friction: 0.6,
        // Edge length. Can be an array to represent range.
        edgeLength: 30,
        layoutAnimation: !0
      },
      left: "center",
      top: "center",
      // right: null,
      // bottom: null,
      // width: '80%',
      // height: '80%',
      symbol: "circle",
      symbolSize: 10,
      edgeSymbol: ["none", "none"],
      edgeSymbolSize: 10,
      edgeLabel: {
        position: "middle",
        distance: 5
      },
      draggable: !1,
      roam: !1,
      // Default on center of graph
      center: null,
      zoom: 1,
      // Symbol size scale ratio in roam
      nodeScaleRatio: 0.6,
      // cursor: null,
      // categories: [],
      // data: []
      // Or
      // nodes: []
      //
      // links: []
      // Or
      // edges: []
      label: {
        show: !1,
        formatter: "{b}"
      },
      itemStyle: {},
      lineStyle: {
        color: "#aaa",
        width: 1,
        opacity: 0.5
      },
      emphasis: {
        scale: !0,
        label: {
          show: !0
        }
      },
      select: {
        itemStyle: {
          borderColor: "#212121"
        }
      }
    }, r;
  }(tr)
), eoe = {
  type: "graphRoam",
  event: "graphRoam",
  update: "none"
};
function toe(t) {
  t.registerChartView(Kae), t.registerSeriesModel(Qae), t.registerProcessor(Pae), t.registerVisual(Nae), t.registerVisual(Oae), t.registerLayout(Hae), t.registerLayout(t.PRIORITY.VISUAL.POST_CHART_LAYOUT, Wae), t.registerLayout(jae), t.registerCoordinateSystem("graphView", {
    dimensions: Tg.dimensions,
    create: Xae
  }), t.registerAction({
    type: "focusNodeAdjacency",
    event: "focusNodeAdjacency",
    update: "series:focusNodeAdjacency"
  }, Yr), t.registerAction({
    type: "unfocusNodeAdjacency",
    event: "unfocusNodeAdjacency",
    update: "series:unfocusNodeAdjacency"
  }, Yr), t.registerAction(eoe, function(r, e, n) {
    e.eachComponent({
      mainType: "series",
      query: r
    }, function(i) {
      var a = i.coordinateSystem, o = Xw(a, r, void 0, n);
      i.setCenter && i.setCenter(o.center), i.setZoom && i.setZoom(o.zoom);
    });
  });
}
var roe = (
  /** @class */
  /* @__PURE__ */ function() {
    function t() {
      this.angle = 0, this.width = 10, this.r = 10, this.x = 0, this.y = 0;
    }
    return t;
  }()
), noe = (
  /** @class */
  function(t) {
    ee(r, t);
    function r(e) {
      var n = t.call(this, e) || this;
      return n.type = "pointer", n;
    }
    return r.prototype.getDefaultShape = function() {
      return new roe();
    }, r.prototype.buildPath = function(e, n) {
      var i = Math.cos, a = Math.sin, o = n.r, s = n.width, l = n.angle, u = n.x - i(l) * s * (s >= o / 3 ? 1 : 2), c = n.y - a(l) * s * (s >= o / 3 ? 1 : 2);
      l = n.angle - Math.PI / 2, e.moveTo(u, c), e.lineTo(n.x + i(l) * s, n.y + a(l) * s), e.lineTo(n.x + i(n.angle) * o, n.y + a(n.angle) * o), e.lineTo(n.x - i(l) * s, n.y - a(l) * s), e.lineTo(u, c);
    }, r;
  }(gt)
);
function ioe(t, r) {
  var e = t.get("center"), n = r.getWidth(), i = r.getHeight(), a = Math.min(n, i), o = he(e[0], r.getWidth()), s = he(e[1], r.getHeight()), l = he(t.get("radius"), a / 2);
  return {
    cx: o,
    cy: s,
    r: l
  };
}
function H1(t, r) {
  var e = t == null ? "" : t + "";
  return r && (pe(r) ? e = r.replace("{value}", e) : Ae(r) && (e = r(t))), e;
}
var aoe = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.render = function(e, n, i) {
      this.group.removeAll();
      var a = e.get(["axisLine", "lineStyle", "color"]), o = ioe(e, i);
      this._renderMain(e, n, i, a, o), this._data = e.getData();
    }, r.prototype.dispose = function() {
    }, r.prototype._renderMain = function(e, n, i, a, o) {
      var s = this.group, l = e.get("clockwise"), u = -e.get("startAngle") / 180 * Math.PI, c = -e.get("endAngle") / 180 * Math.PI, d = e.getModel("axisLine"), f = d.get("roundCap"), h = f ? zm : oi, p = d.get("show"), v = d.getModel("lineStyle"), g = v.get("width"), m = [u, c];
      V7(m, !l), u = m[0], c = m[1];
      for (var y = c - u, b = u, C = [], w = 0; p && w < a.length; w++) {
        var _ = Math.min(Math.max(a[w][0], 0), 1);
        c = u + y * _;
        var x = new h({
          shape: {
            startAngle: b,
            endAngle: c,
            cx: o.cx,
            cy: o.cy,
            clockwise: l,
            r0: o.r - g,
            r: o.r
          },
          silent: !0
        });
        x.setStyle({
          fill: a[w][1]
        }), x.setStyle(v.getLineStyle(
          // Because we use sector to simulate arc
          // so the properties for stroking are useless
          ["color", "width"]
        )), C.push(x), b = c;
      }
      C.reverse(), L(C, function(D) {
        return s.add(D);
      });
      var I = function(D) {
        if (D <= 0)
          return a[0][1];
        var T;
        for (T = 0; T < a.length; T++)
          if (a[T][0] >= D && (T === 0 ? 0 : a[T - 1][0]) < D)
            return a[T][1];
        return a[T - 1][1];
      };
      this._renderTicks(e, n, i, I, o, u, c, l, g), this._renderTitleAndDetail(e, n, i, I, o), this._renderAnchor(e, o), this._renderPointer(e, n, i, I, o, u, c, l, g);
    }, r.prototype._renderTicks = function(e, n, i, a, o, s, l, u, c) {
      for (var d = this.group, f = o.cx, h = o.cy, p = o.r, v = +e.get("min"), g = +e.get("max"), m = e.getModel("splitLine"), y = e.getModel("axisTick"), b = e.getModel("axisLabel"), C = e.get("splitNumber"), w = y.get("splitNumber"), _ = he(m.get("length"), p), x = he(y.get("length"), p), I = s, D = (l - s) / C, T = D / w, A = m.getModel("lineStyle").getLineStyle(), M = y.getModel("lineStyle").getLineStyle(), R = m.get("distance"), E, k, P = 0; P <= C; P++) {
        if (E = Math.cos(I), k = Math.sin(I), m.get("show")) {
          var N = R ? R + c : c, O = new gn({
            shape: {
              x1: E * (p - N) + f,
              y1: k * (p - N) + h,
              x2: E * (p - _ - N) + f,
              y2: k * (p - _ - N) + h
            },
            style: A,
            silent: !0
          });
          A.stroke === "auto" && O.setStyle({
            stroke: a(P / C)
          }), d.add(O);
        }
        if (b.get("show")) {
          var N = b.get("distance") + R, W = H1(Or(P / C * (g - v) + v), b.get("formatter")), V = a(P / C), B = E * (p - _ - N) + f, Z = k * (p - _ - N) + h, q = b.get("rotate"), z = 0;
          q === "radial" ? (z = -I + 2 * Math.PI, z > Math.PI / 2 && (z += Math.PI)) : q === "tangential" ? z = -I - Math.PI / 2 : Mt(q) && (z = q * Math.PI / 180), z === 0 ? d.add(new _t({
            style: fr(b, {
              text: W,
              x: B,
              y: Z,
              verticalAlign: k < -0.8 ? "top" : k > 0.8 ? "bottom" : "middle",
              align: E < -0.4 ? "left" : E > 0.4 ? "right" : "center"
            }, {
              inheritColor: V
            }),
            silent: !0
          })) : d.add(new _t({
            style: fr(b, {
              text: W,
              x: B,
              y: Z,
              verticalAlign: "middle",
              align: "center"
            }, {
              inheritColor: V
            }),
            silent: !0,
            originX: B,
            originY: Z,
            rotation: z
          }));
        }
        if (y.get("show") && P !== C) {
          var N = y.get("distance");
          N = N ? N + c : c;
          for (var U = 0; U <= w; U++) {
            E = Math.cos(I), k = Math.sin(I);
            var J = new gn({
              shape: {
                x1: E * (p - N) + f,
                y1: k * (p - N) + h,
                x2: E * (p - x - N) + f,
                y2: k * (p - x - N) + h
              },
              silent: !0,
              style: M
            });
            M.stroke === "auto" && J.setStyle({
              stroke: a((P + U / w) / C)
            }), d.add(J), I += T;
          }
          I -= T;
        } else
          I += D;
      }
    }, r.prototype._renderPointer = function(e, n, i, a, o, s, l, u, c) {
      var d = this.group, f = this._data, h = this._progressEls, p = [], v = e.get(["pointer", "show"]), g = e.getModel("progress"), m = g.get("show"), y = e.getData(), b = y.mapDimension("value"), C = +e.get("min"), w = +e.get("max"), _ = [C, w], x = [s, l];
      function I(T, A) {
        var M = y.getItemModel(T), R = M.getModel("pointer"), E = he(R.get("width"), o.r), k = he(R.get("length"), o.r), P = e.get(["pointer", "icon"]), N = R.get("offsetCenter"), O = he(N[0], o.r), W = he(N[1], o.r), V = R.get("keepAspect"), B;
        return P ? B = en(P, O - E / 2, W - k, E, k, null, V) : B = new noe({
          shape: {
            angle: -Math.PI / 2,
            width: E,
            r: k,
            x: O,
            y: W
          }
        }), B.rotation = -(A + Math.PI / 2), B.x = o.cx, B.y = o.cy, B;
      }
      function D(T, A) {
        var M = g.get("roundCap"), R = M ? zm : oi, E = g.get("overlap"), k = E ? g.get("width") : c / y.count(), P = E ? o.r - k : o.r - (T + 1) * k, N = E ? o.r : o.r - T * k, O = new R({
          shape: {
            startAngle: s,
            endAngle: A,
            cx: o.cx,
            cy: o.cy,
            clockwise: u,
            r0: P,
            r: N
          }
        });
        return E && (O.z2 = w - y.get(b, T) % w), O;
      }
      (m || v) && (y.diff(f).add(function(T) {
        var A = y.get(b, T);
        if (v) {
          var M = I(T, s);
          Cr(M, {
            rotation: -((isNaN(+A) ? x[0] : zt(A, _, x, !0)) + Math.PI / 2)
          }, e), d.add(M), y.setItemGraphicEl(T, M);
        }
        if (m) {
          var R = D(T, s), E = g.get("clip");
          Cr(R, {
            shape: {
              endAngle: zt(A, _, x, E)
            }
          }, e), d.add(R), WC(e.seriesIndex, y.dataType, T, R), p[T] = R;
        }
      }).update(function(T, A) {
        var M = y.get(b, T);
        if (v) {
          var R = f.getItemGraphicEl(A), E = R ? R.rotation : s, k = I(T, E);
          k.rotation = E, kt(k, {
            rotation: -((isNaN(+M) ? x[0] : zt(M, _, x, !0)) + Math.PI / 2)
          }, e), d.add(k), y.setItemGraphicEl(T, k);
        }
        if (m) {
          var P = h[A], N = P ? P.shape.endAngle : s, O = D(T, N), W = g.get("clip");
          kt(O, {
            shape: {
              endAngle: zt(M, _, x, W)
            }
          }, e), d.add(O), WC(e.seriesIndex, y.dataType, T, O), p[T] = O;
        }
      }).execute(), y.each(function(T) {
        var A = y.getItemModel(T), M = A.getModel("emphasis"), R = M.get("focus"), E = M.get("blurScope"), k = M.get("disabled");
        if (v) {
          var P = y.getItemGraphicEl(T), N = y.getItemVisual(T, "style"), O = N.fill;
          if (P instanceof An) {
            var W = P.style;
            P.useStyle(ae({
              image: W.image,
              x: W.x,
              y: W.y,
              width: W.width,
              height: W.height
            }, N));
          } else
            P.useStyle(N), P.type !== "pointer" && P.setColor(O);
          P.setStyle(A.getModel(["pointer", "itemStyle"]).getItemStyle()), P.style.fill === "auto" && P.setStyle("fill", a(zt(y.get(b, T), _, [0, 1], !0))), P.z2EmphasisLift = 0, Yn(P, A), Vr(P, R, E, k);
        }
        if (m) {
          var V = p[T];
          V.useStyle(y.getItemVisual(T, "style")), V.setStyle(A.getModel(["progress", "itemStyle"]).getItemStyle()), V.z2EmphasisLift = 0, Yn(V, A), Vr(V, R, E, k);
        }
      }), this._progressEls = p);
    }, r.prototype._renderAnchor = function(e, n) {
      var i = e.getModel("anchor"), a = i.get("show");
      if (a) {
        var o = i.get("size"), s = i.get("icon"), l = i.get("offsetCenter"), u = i.get("keepAspect"), c = en(s, n.cx - o / 2 + he(l[0], n.r), n.cy - o / 2 + he(l[1], n.r), o, o, null, u);
        c.z2 = i.get("showAbove") ? 1 : 0, c.setStyle(i.getModel("itemStyle").getItemStyle()), this.group.add(c);
      }
    }, r.prototype._renderTitleAndDetail = function(e, n, i, a, o) {
      var s = this, l = e.getData(), u = l.mapDimension("value"), c = +e.get("min"), d = +e.get("max"), f = new ze(), h = [], p = [], v = e.isAnimationEnabled(), g = e.get(["pointer", "showAbove"]);
      l.diff(this._data).add(function(m) {
        h[m] = new _t({
          silent: !0
        }), p[m] = new _t({
          silent: !0
        });
      }).update(function(m, y) {
        h[m] = s._titleEls[y], p[m] = s._detailEls[y];
      }).execute(), l.each(function(m) {
        var y = l.getItemModel(m), b = l.get(u, m), C = new ze(), w = a(zt(b, [c, d], [0, 1], !0)), _ = y.getModel("title");
        if (_.get("show")) {
          var x = _.get("offsetCenter"), I = o.cx + he(x[0], o.r), D = o.cy + he(x[1], o.r), T = h[m];
          T.attr({
            z2: g ? 0 : 2,
            style: fr(_, {
              x: I,
              y: D,
              text: l.getName(m),
              align: "center",
              verticalAlign: "middle"
            }, {
              inheritColor: w
            })
          }), C.add(T);
        }
        var A = y.getModel("detail");
        if (A.get("show")) {
          var M = A.get("offsetCenter"), R = o.cx + he(M[0], o.r), E = o.cy + he(M[1], o.r), k = he(A.get("width"), o.r), P = he(A.get("height"), o.r), N = e.get(["progress", "show"]) ? l.getItemVisual(m, "style").fill : w, T = p[m], O = A.get("formatter");
          T.attr({
            z2: g ? 0 : 2,
            style: fr(A, {
              x: R,
              y: E,
              text: H1(b, O),
              width: isNaN(k) ? null : k,
              height: isNaN(P) ? null : P,
              align: "center",
              verticalAlign: "middle"
            }, {
              inheritColor: N
            })
          }), fO(T, {
            normal: A
          }, b, function(V) {
            return H1(V, O);
          }), v && hO(T, m, l, e, {
            getFormattedLabel: function(V, B, Z, q, z, U) {
              return H1(U ? U.interpolatedValue : b, O);
            }
          }), C.add(T);
        }
        f.add(C);
      }), this.group.add(f), this._titleEls = h, this._detailEls = p;
    }, r.type = "gauge", r;
  }(Yt)
), ooe = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e.visualStyleAccessPath = "itemStyle", e;
    }
    return r.prototype.getInitialData = function(e, n) {
      return gh(this, ["value"]);
    }, r.type = "series.gauge", r.defaultOption = {
      // zlevel: 0,
      z: 2,
      colorBy: "data",
      // 默认全局居中
      center: ["50%", "50%"],
      legendHoverLink: !0,
      radius: "75%",
      startAngle: 225,
      endAngle: -45,
      clockwise: !0,
      // 最小值
      min: 0,
      // 最大值
      max: 100,
      // 分割段数，默认为10
      splitNumber: 10,
      // 坐标轴线
      axisLine: {
        // 默认显示，属性show控制显示与否
        show: !0,
        roundCap: !1,
        lineStyle: {
          color: [[1, "#E6EBF8"]],
          width: 10
        }
      },
      // 坐标轴线
      progress: {
        // 默认显示，属性show控制显示与否
        show: !1,
        overlap: !0,
        width: 10,
        roundCap: !1,
        clip: !0
      },
      // 分隔线
      splitLine: {
        // 默认显示，属性show控制显示与否
        show: !0,
        // 属性length控制线长
        length: 10,
        distance: 10,
        // 属性lineStyle（详见lineStyle）控制线条样式
        lineStyle: {
          color: "#63677A",
          width: 3,
          type: "solid"
        }
      },
      // 坐标轴小标记
      axisTick: {
        // 属性show控制显示与否，默认不显示
        show: !0,
        // 每份split细分多少段
        splitNumber: 5,
        // 属性length控制线长
        length: 6,
        distance: 10,
        // 属性lineStyle控制线条样式
        lineStyle: {
          color: "#63677A",
          width: 1,
          type: "solid"
        }
      },
      axisLabel: {
        show: !0,
        distance: 15,
        // formatter: null,
        color: "#464646",
        fontSize: 12,
        rotate: 0
      },
      pointer: {
        icon: null,
        offsetCenter: [0, 0],
        show: !0,
        showAbove: !0,
        length: "60%",
        width: 6,
        keepAspect: !1
      },
      anchor: {
        show: !1,
        showAbove: !1,
        size: 6,
        icon: "circle",
        offsetCenter: [0, 0],
        keepAspect: !1,
        itemStyle: {
          color: "#fff",
          borderWidth: 0,
          borderColor: "#5470c6"
        }
      },
      title: {
        show: !0,
        // x, y，单位px
        offsetCenter: [0, "20%"],
        // 其余属性默认使用全局文本样式，详见TEXTSTYLE
        color: "#464646",
        fontSize: 16,
        valueAnimation: !1
      },
      detail: {
        show: !0,
        backgroundColor: "rgba(0,0,0,0)",
        borderWidth: 0,
        borderColor: "#ccc",
        width: 100,
        height: null,
        padding: [5, 10],
        // x, y，单位px
        offsetCenter: [0, "40%"],
        // formatter: null,
        // 其余属性默认使用全局文本样式，详见TEXTSTYLE
        color: "#464646",
        fontSize: 30,
        fontWeight: "bold",
        lineHeight: 30,
        valueAnimation: !1
      }
    }, r;
  }(tr)
);
function soe(t) {
  t.registerChartView(aoe), t.registerSeriesModel(ooe);
}
var loe = ["itemStyle", "opacity"], uoe = (
  /** @class */
  function(t) {
    ee(r, t);
    function r(e, n) {
      var i = t.call(this) || this, a = i, o = new ci(), s = new _t();
      return a.setTextContent(s), i.setTextGuideLine(o), i.updateData(e, n, !0), i;
    }
    return r.prototype.updateData = function(e, n, i) {
      var a = this, o = e.hostModel, s = e.getItemModel(n), l = e.getItemLayout(n), u = s.getModel("emphasis"), c = s.get(loe);
      c = c ?? 1, i || ro(a), a.useStyle(e.getItemVisual(n, "style")), a.style.lineJoin = "round", i ? (a.setShape({
        points: l.points
      }), a.style.opacity = 0, Cr(a, {
        style: {
          opacity: c
        }
      }, o, n)) : kt(a, {
        style: {
          opacity: c
        },
        shape: {
          points: l.points
        }
      }, o, n), Yn(a, s), this._updateLabel(e, n), Vr(this, u.get("focus"), u.get("blurScope"), u.get("disabled"));
    }, r.prototype._updateLabel = function(e, n) {
      var i = this, a = this.getTextGuideLine(), o = i.getTextContent(), s = e.hostModel, l = e.getItemModel(n), u = e.getItemLayout(n), c = u.label, d = e.getItemVisual(n, "style"), f = d.fill;
      Xn(
        // position will not be used in setLabelStyle
        o,
        xn(l),
        {
          labelFetcher: e.hostModel,
          labelDataIndex: n,
          defaultOpacity: d.opacity,
          defaultText: e.getName(n)
        },
        {
          normal: {
            align: c.textAlign,
            verticalAlign: c.verticalAlign
          }
        }
      ), i.setTextConfig({
        local: !0,
        inside: !!c.inside,
        insideStroke: f,
        // insideFill: 'auto',
        outsideFill: f
      });
      var h = c.linePoints;
      a.setShape({
        points: h
      }), i.textGuideLineConfig = {
        anchor: h ? new tt(h[0][0], h[0][1]) : null
      }, kt(o, {
        style: {
          x: c.x,
          y: c.y
        }
      }, s, n), o.attr({
        rotation: c.rotation,
        originX: c.x,
        originY: c.y,
        z2: 10
      }), kw(i, Pw(l), {
        // Default use item visual color
        stroke: f
      });
    }, r;
  }(si)
), coe = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e.ignoreLabelLineUpdate = !0, e;
    }
    return r.prototype.render = function(e, n, i) {
      var a = e.getData(), o = this._data, s = this.group;
      a.diff(o).add(function(l) {
        var u = new uoe(a, l);
        a.setItemGraphicEl(l, u), s.add(u);
      }).update(function(l, u) {
        var c = o.getItemGraphicEl(u);
        c.updateData(a, l), s.add(c), a.setItemGraphicEl(l, c);
      }).remove(function(l) {
        var u = o.getItemGraphicEl(l);
        wv(u, e, l);
      }).execute(), this._data = a;
    }, r.prototype.remove = function() {
      this.group.removeAll(), this._data = null;
    }, r.prototype.dispose = function() {
    }, r.type = "funnel", r;
  }(Yt)
), doe = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.init = function(e) {
      t.prototype.init.apply(this, arguments), this.legendVisualProvider = new Ag(ye(this.getData, this), ye(this.getRawData, this)), this._defaultLabelLine(e);
    }, r.prototype.getInitialData = function(e, n) {
      return gh(this, {
        coordDimensions: ["value"],
        encodeDefaulter: Ye(ow, this)
      });
    }, r.prototype._defaultLabelLine = function(e) {
      Vc(e, "labelLine", ["show"]);
      var n = e.labelLine, i = e.emphasis.labelLine;
      n.show = n.show && e.label.show, i.show = i.show && e.emphasis.label.show;
    }, r.prototype.getDataParams = function(e) {
      var n = this.getData(), i = t.prototype.getDataParams.call(this, e), a = n.mapDimension("value"), o = n.getSum(a);
      return i.percent = o ? +(n.get(a, e) / o * 100).toFixed(2) : 0, i.$vars.push("percent"), i;
    }, r.type = "series.funnel", r.defaultOption = {
      // zlevel: 0,                  // 一级层叠
      z: 2,
      legendHoverLink: !0,
      colorBy: "data",
      left: 80,
      top: 60,
      right: 80,
      bottom: 60,
      // width: {totalWidth} - left - right,
      // height: {totalHeight} - top - bottom,
      // 默认取数据最小最大值
      // min: 0,
      // max: 100,
      minSize: "0%",
      maxSize: "100%",
      sort: "descending",
      orient: "vertical",
      gap: 0,
      funnelAlign: "center",
      label: {
        show: !0,
        position: "outer"
        // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调
      },
      labelLine: {
        show: !0,
        length: 20,
        lineStyle: {
          // color: 各异,
          width: 1
        }
      },
      itemStyle: {
        // color: 各异,
        borderColor: "#fff",
        borderWidth: 1
      },
      emphasis: {
        label: {
          show: !0
        }
      },
      select: {
        itemStyle: {
          borderColor: "#212121"
        }
      }
    }, r;
  }(tr)
);
function foe(t, r) {
  return cn(t.getBoxLayoutParams(), {
    width: r.getWidth(),
    height: r.getHeight()
  });
}
function hoe(t, r) {
  for (var e = t.mapDimension("value"), n = t.mapArray(e, function(l) {
    return l;
  }), i = [], a = r === "ascending", o = 0, s = t.count(); o < s; o++)
    i[o] = o;
  return Ae(r) ? i.sort(r) : r !== "none" && i.sort(function(l, u) {
    return a ? n[l] - n[u] : n[u] - n[l];
  }), i;
}
function poe(t) {
  var r = t.hostModel, e = r.get("orient");
  t.each(function(n) {
    var i = t.getItemModel(n), a = i.getModel("label"), o = a.get("position"), s = i.getModel("labelLine"), l = t.getItemLayout(n), u = l.points, c = o === "inner" || o === "inside" || o === "center" || o === "insideLeft" || o === "insideRight", d, f, h, p;
    if (c)
      o === "insideLeft" ? (f = (u[0][0] + u[3][0]) / 2 + 5, h = (u[0][1] + u[3][1]) / 2, d = "left") : o === "insideRight" ? (f = (u[1][0] + u[2][0]) / 2 - 5, h = (u[1][1] + u[2][1]) / 2, d = "right") : (f = (u[0][0] + u[1][0] + u[2][0] + u[3][0]) / 4, h = (u[0][1] + u[1][1] + u[2][1] + u[3][1]) / 4, d = "center"), p = [[f, h], [f, h]];
    else {
      var v = void 0, g = void 0, m = void 0, y = void 0, b = s.get("length");
      process.env.NODE_ENV !== "production" && (e === "vertical" && ["top", "bottom"].indexOf(o) > -1 && (o = "left", console.warn("Position error: Funnel chart on vertical orient dose not support top and bottom.")), e === "horizontal" && ["left", "right"].indexOf(o) > -1 && (o = "bottom", console.warn("Position error: Funnel chart on horizontal orient dose not support left and right."))), o === "left" ? (v = (u[3][0] + u[0][0]) / 2, g = (u[3][1] + u[0][1]) / 2, m = v - b, f = m - 5, d = "right") : o === "right" ? (v = (u[1][0] + u[2][0]) / 2, g = (u[1][1] + u[2][1]) / 2, m = v + b, f = m + 5, d = "left") : o === "top" ? (v = (u[3][0] + u[0][0]) / 2, g = (u[3][1] + u[0][1]) / 2, y = g - b, h = y - 5, d = "center") : o === "bottom" ? (v = (u[1][0] + u[2][0]) / 2, g = (u[1][1] + u[2][1]) / 2, y = g + b, h = y + 5, d = "center") : o === "rightTop" ? (v = e === "horizontal" ? u[3][0] : u[1][0], g = e === "horizontal" ? u[3][1] : u[1][1], e === "horizontal" ? (y = g - b, h = y - 5, d = "center") : (m = v + b, f = m + 5, d = "top")) : o === "rightBottom" ? (v = u[2][0], g = u[2][1], e === "horizontal" ? (y = g + b, h = y + 5, d = "center") : (m = v + b, f = m + 5, d = "bottom")) : o === "leftTop" ? (v = u[0][0], g = e === "horizontal" ? u[0][1] : u[1][1], e === "horizontal" ? (y = g - b, h = y - 5, d = "center") : (m = v - b, f = m - 5, d = "right")) : o === "leftBottom" ? (v = e === "horizontal" ? u[1][0] : u[3][0], g = e === "horizontal" ? u[1][1] : u[2][1], e === "horizontal" ? (y = g + b, h = y + 5, d = "center") : (m = v - b, f = m - 5, d = "right")) : (v = (u[1][0] + u[2][0]) / 2, g = (u[1][1] + u[2][1]) / 2, e === "horizontal" ? (y = g + b, h = y + 5, d = "center") : (m = v + b, f = m + 5, d = "left")), e === "horizontal" ? (m = v, f = m) : (y = g, h = y), p = [[v, g], [m, y]];
    }
    l.label = {
      linePoints: p,
      x: f,
      y: h,
      verticalAlign: "middle",
      textAlign: d,
      inside: c
    };
  });
}
function voe(t, r) {
  t.eachSeriesByType("funnel", function(e) {
    var n = e.getData(), i = n.mapDimension("value"), a = e.get("sort"), o = foe(e, r), s = e.get("orient"), l = o.width, u = o.height, c = hoe(n, a), d = o.x, f = o.y, h = s === "horizontal" ? [he(e.get("minSize"), u), he(e.get("maxSize"), u)] : [he(e.get("minSize"), l), he(e.get("maxSize"), l)], p = n.getDataExtent(i), v = e.get("min"), g = e.get("max");
    v == null && (v = Math.min(p[0], 0)), g == null && (g = p[1]);
    var m = e.get("funnelAlign"), y = e.get("gap"), b = s === "horizontal" ? l : u, C = (b - y * (n.count() - 1)) / n.count(), w = function(E, k) {
      if (s === "horizontal") {
        var P = n.get(i, E) || 0, N = zt(P, [v, g], h, !0), O = void 0;
        switch (m) {
          case "top":
            O = f;
            break;
          case "center":
            O = f + (u - N) / 2;
            break;
          case "bottom":
            O = f + (u - N);
            break;
        }
        return [[k, O], [k, O + N]];
      }
      var W = n.get(i, E) || 0, V = zt(W, [v, g], h, !0), B;
      switch (m) {
        case "left":
          B = d;
          break;
        case "center":
          B = d + (l - V) / 2;
          break;
        case "right":
          B = d + l - V;
          break;
      }
      return [[B, k], [B + V, k]];
    };
    a === "ascending" && (C = -C, y = -y, s === "horizontal" ? d += l : f += u, c = c.reverse());
    for (var _ = 0; _ < c.length; _++) {
      var x = c[_], I = c[_ + 1], D = n.getItemModel(x);
      if (s === "horizontal") {
        var T = D.get(["itemStyle", "width"]);
        T == null ? T = C : (T = he(T, l), a === "ascending" && (T = -T));
        var A = w(x, d), M = w(I, d + T);
        d += T + y, n.setItemLayout(x, {
          points: A.concat(M.slice().reverse())
        });
      } else {
        var R = D.get(["itemStyle", "height"]);
        R == null ? R = C : (R = he(R, u), a === "ascending" && (R = -R));
        var A = w(x, f), M = w(I, f + R);
        f += R + y, n.setItemLayout(x, {
          points: A.concat(M.slice().reverse())
        });
      }
    }
    poe(n);
  });
}
function goe(t) {
  t.registerChartView(coe), t.registerSeriesModel(doe), t.registerLayout(voe), t.registerProcessor(Ig("funnel"));
}
var moe = 0.3, yoe = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e._dataGroup = new ze(), e._initialized = !1, e;
    }
    return r.prototype.init = function() {
      this.group.add(this._dataGroup);
    }, r.prototype.render = function(e, n, i, a) {
      this._progressiveEls = null;
      var o = this._dataGroup, s = e.getData(), l = this._data, u = e.coordinateSystem, c = u.dimensions, d = uT(e);
      s.diff(l).add(f).update(h).remove(p).execute();
      function f(g) {
        var m = lT(s, o, g, c, u);
        f3(m, s, g, d);
      }
      function h(g, m) {
        var y = l.getItemGraphicEl(m), b = OB(s, g, c, u);
        s.setItemGraphicEl(g, y), kt(y, {
          shape: {
            points: b
          }
        }, e, g), ro(y), f3(y, s, g, d);
      }
      function p(g) {
        var m = l.getItemGraphicEl(g);
        o.remove(m);
      }
      if (!this._initialized) {
        this._initialized = !0;
        var v = boe(u, e, function() {
          setTimeout(function() {
            o.removeClipPath();
          });
        });
        o.setClipPath(v);
      }
      this._data = s;
    }, r.prototype.incrementalPrepareRender = function(e, n, i) {
      this._initialized = !0, this._data = null, this._dataGroup.removeAll();
    }, r.prototype.incrementalRender = function(e, n, i) {
      for (var a = n.getData(), o = n.coordinateSystem, s = o.dimensions, l = uT(n), u = this._progressiveEls = [], c = e.start; c < e.end; c++) {
        var d = lT(a, this._dataGroup, c, s, o);
        d.incremental = !0, f3(d, a, c, l), u.push(d);
      }
    }, r.prototype.remove = function() {
      this._dataGroup && this._dataGroup.removeAll(), this._data = null;
    }, r.type = "parallel", r;
  }(Yt)
);
function boe(t, r, e) {
  var n = t.model, i = t.getRect(), a = new xt({
    shape: {
      x: i.x,
      y: i.y,
      width: i.width,
      height: i.height
    }
  }), o = n.get("layout") === "horizontal" ? "width" : "height";
  return a.setShape(o, 0), Cr(a, {
    shape: {
      width: i.width,
      height: i.height
    }
  }, r, e), a;
}
function OB(t, r, e, n) {
  for (var i = [], a = 0; a < e.length; a++) {
    var o = e[a], s = t.get(t.mapDimension(o), r);
    Coe(s, n.getAxis(o).type) || i.push(n.dataToPoint(s, o));
  }
  return i;
}
function lT(t, r, e, n, i) {
  var a = OB(t, e, n, i), o = new ci({
    shape: {
      points: a
    },
    // silent: true,
    z2: 10
  });
  return r.add(o), t.setItemGraphicEl(e, o), o;
}
function uT(t) {
  var r = t.get("smooth", !0);
  return r === !0 && (r = moe), r = qo(r), ql(r) && (r = 0), {
    smooth: r
  };
}
function f3(t, r, e, n) {
  t.useStyle(r.getItemVisual(e, "style")), t.style.fill = null, t.setShape("smooth", n.smooth);
  var i = r.getItemModel(e), a = i.getModel("emphasis");
  Yn(t, i, "lineStyle"), Vr(t, a.get("focus"), a.get("blurScope"), a.get("disabled"));
}
function Coe(t, r) {
  return r === "category" ? t == null : t == null || isNaN(t);
}
var woe = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e.visualStyleAccessPath = "lineStyle", e.visualDrawType = "stroke", e;
    }
    return r.prototype.getInitialData = function(e, n) {
      return os(null, this, {
        useEncodeDefaulter: ye(_oe, null, this)
      });
    }, r.prototype.getRawIndicesByActiveState = function(e) {
      var n = this.coordinateSystem, i = this.getData(), a = [];
      return n.eachActiveState(i, function(o, s) {
        e === o && a.push(i.getRawIndex(s));
      }), a;
    }, r.type = "series.parallel", r.dependencies = ["parallel"], r.defaultOption = {
      // zlevel: 0,
      z: 2,
      coordinateSystem: "parallel",
      parallelIndex: 0,
      label: {
        show: !1
      },
      inactiveOpacity: 0.05,
      activeOpacity: 1,
      lineStyle: {
        width: 1,
        opacity: 0.45,
        type: "solid"
      },
      emphasis: {
        label: {
          show: !1
        }
      },
      progressive: 500,
      smooth: !1,
      animationEasing: "linear"
    }, r;
  }(tr)
);
function _oe(t) {
  var r = t.ecModel.getComponent("parallel", t.get("parallelIndex"));
  if (r) {
    var e = {};
    return L(r.dimensions, function(n) {
      var i = xoe(n);
      e[n] = i;
    }), e;
  }
}
function xoe(t) {
  return +t.replace("dim", "");
}
var Soe = ["lineStyle", "opacity"], Ioe = {
  seriesType: "parallel",
  reset: function(t, r) {
    var e = t.coordinateSystem, n = {
      normal: t.get(["lineStyle", "opacity"]),
      active: t.get("activeOpacity"),
      inactive: t.get("inactiveOpacity")
    };
    return {
      progress: function(i, a) {
        e.eachActiveState(a, function(o, s) {
          var l = n[o];
          if (o === "normal" && a.hasItemOption) {
            var u = a.getItemModel(s).get(Soe, !0);
            u != null && (l = u);
          }
          var c = a.ensureUniqueItemVisual(s, "style");
          c.opacity = l;
        }, i.start, i.end);
      }
    };
  }
};
function Aoe(t) {
  Doe(t), Toe(t);
}
function Doe(t) {
  if (!t.parallel) {
    var r = !1;
    L(t.series, function(e) {
      e && e.type === "parallel" && (r = !0);
    }), r && (t.parallel = [{}]);
  }
}
function Toe(t) {
  var r = Qt(t.parallelAxis);
  L(r, function(e) {
    if (Me(e)) {
      var n = e.parallelIndex || 0, i = Qt(t.parallel)[n];
      i && i.parallelAxisDefault && Qe(e, i.parallelAxisDefault, !1);
    }
  });
}
var Moe = 5, Roe = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.render = function(e, n, i) {
      this._model = e, this._api = i, this._handlers || (this._handlers = {}, L(Loe, function(a, o) {
        i.getZr().on(o, this._handlers[o] = ye(a, this));
      }, this)), dh(this, "_throttledDispatchExpand", e.get("axisExpandRate"), "fixRate");
    }, r.prototype.dispose = function(e, n) {
      Iv(this, "_throttledDispatchExpand"), L(this._handlers, function(i, a) {
        n.getZr().off(a, i);
      }), this._handlers = null;
    }, r.prototype._throttledDispatchExpand = function(e) {
      this._dispatchExpand(e);
    }, r.prototype._dispatchExpand = function(e) {
      e && this._api.dispatchAction(ae({
        type: "parallelAxisExpand"
      }, e));
    }, r.type = "parallel", r;
  }(yr)
), Loe = {
  mousedown: function(t) {
    h3(this, "click") && (this._mouseDownPoint = [t.offsetX, t.offsetY]);
  },
  mouseup: function(t) {
    var r = this._mouseDownPoint;
    if (h3(this, "click") && r) {
      var e = [t.offsetX, t.offsetY], n = Math.pow(r[0] - e[0], 2) + Math.pow(r[1] - e[1], 2);
      if (n > Moe)
        return;
      var i = this._model.coordinateSystem.getSlidedAxisExpandWindow([t.offsetX, t.offsetY]);
      i.behavior !== "none" && this._dispatchExpand({
        axisExpandWindow: i.axisExpandWindow
      });
    }
    this._mouseDownPoint = null;
  },
  mousemove: function(t) {
    if (!(this._mouseDownPoint || !h3(this, "mousemove"))) {
      var r = this._model, e = r.coordinateSystem.getSlidedAxisExpandWindow([t.offsetX, t.offsetY]), n = e.behavior;
      n === "jump" && this._throttledDispatchExpand.debounceNextCall(r.get("axisExpandDebounce")), this._throttledDispatchExpand(n === "none" ? null : {
        axisExpandWindow: e.axisExpandWindow,
        // Jumping uses animation, and sliding suppresses animation.
        animation: n === "jump" ? null : {
          duration: 0
          // Disable animation.
        }
      });
    }
  }
};
function h3(t, r) {
  var e = t._model;
  return e.get("axisExpandable") && e.get("axisExpandTriggerOn") === r;
}
var Eoe = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.init = function() {
      t.prototype.init.apply(this, arguments), this.mergeOption({});
    }, r.prototype.mergeOption = function(e) {
      var n = this.option;
      e && Qe(n, e, !0), this._initDimensions();
    }, r.prototype.contains = function(e, n) {
      var i = e.get("parallelIndex");
      return i != null && n.getComponent("parallel", i) === this;
    }, r.prototype.setAxisExpand = function(e) {
      L(["axisExpandable", "axisExpandCenter", "axisExpandCount", "axisExpandWidth", "axisExpandWindow"], function(n) {
        e.hasOwnProperty(n) && (this.option[n] = e[n]);
      }, this);
    }, r.prototype._initDimensions = function() {
      var e = this.dimensions = [], n = this.parallelAxisIndex = [], i = Wt(this.ecModel.queryComponents({
        mainType: "parallelAxis"
      }), function(a) {
        return (a.get("parallelIndex") || 0) === this.componentIndex;
      }, this);
      L(i, function(a) {
        e.push("dim" + a.get("dim")), n.push(a.componentIndex);
      });
    }, r.type = "parallel", r.dependencies = ["parallelAxis"], r.layoutMode = "box", r.defaultOption = {
      // zlevel: 0,
      z: 0,
      left: 80,
      top: 60,
      right: 80,
      bottom: 60,
      // width: {totalWidth} - left - right,
      // height: {totalHeight} - top - bottom,
      layout: "horizontal",
      // FIXME
      // naming?
      axisExpandable: !1,
      axisExpandCenter: null,
      axisExpandCount: 0,
      axisExpandWidth: 50,
      axisExpandRate: 17,
      axisExpandDebounce: 50,
      // [out, in, jumpTarget]. In percentage. If use [null, 0.05], null means full.
      // Do not doc to user until necessary.
      axisExpandSlideTriggerArea: [-0.15, 0.05, 0.4],
      axisExpandTriggerOn: "click",
      parallelAxisDefault: null
    }, r;
  }(st)
), koe = (
  /** @class */
  function(t) {
    ee(r, t);
    function r(e, n, i, a, o) {
      var s = t.call(this, e, n, i) || this;
      return s.type = a || "value", s.axisIndex = o, s;
    }
    return r.prototype.isHorizontal = function() {
      return this.coordinateSystem.getModel().get("layout") !== "horizontal";
    }, r;
  }(Va)
);
function id(t, r, e, n, i, a) {
  t = t || 0;
  var o = e[1] - e[0];
  if (i != null && (i = Md(i, [0, o])), a != null && (a = Math.max(a, i ?? 0)), n === "all") {
    var s = Math.abs(r[1] - r[0]);
    s = Md(s, [0, o]), i = a = Md(s, [i, a]), n = 0;
  }
  r[0] = Md(r[0], e), r[1] = Md(r[1], e);
  var l = p3(r, n);
  r[n] += t;
  var u = i || 0, c = e.slice();
  l.sign < 0 ? c[0] += u : c[1] -= u, r[n] = Md(r[n], c);
  var d;
  return d = p3(r, n), i != null && (d.sign !== l.sign || d.span < i) && (r[1 - n] = r[n] + l.sign * i), d = p3(r, n), a != null && d.span > a && (r[1 - n] = r[n] + d.sign * a), r;
}
function p3(t, r) {
  var e = t[r] - t[1 - r];
  return {
    span: Math.abs(e),
    sign: e > 0 ? -1 : e < 0 ? 1 : r ? -1 : 1
  };
}
function Md(t, r) {
  return Math.min(r[1] != null ? r[1] : 1 / 0, Math.max(r[0] != null ? r[0] : -1 / 0, t));
}
var v3 = L, VB = Math.min, GB = Math.max, cT = Math.floor, Poe = Math.ceil, dT = Or, Noe = Math.PI, Ooe = (
  /** @class */
  function() {
    function t(r, e, n) {
      this.type = "parallel", this._axesMap = xe(), this._axesLayout = {}, this.dimensions = r.dimensions, this._model = r, this._init(r, e, n);
    }
    return t.prototype._init = function(r, e, n) {
      var i = r.dimensions, a = r.parallelAxisIndex;
      v3(i, function(o, s) {
        var l = a[s], u = e.getComponent("parallelAxis", l), c = this._axesMap.set(o, new koe(o, Cg(u), [0, 0], u.get("type"), l)), d = c.type === "category";
        c.onBand = d && u.get("boundaryGap"), c.inverse = u.get("inverse"), u.axis = c, c.model = u, c.coordinateSystem = u.coordinateSystem = this;
      }, this);
    }, t.prototype.update = function(r, e) {
      this._updateAxesFromSeries(this._model, r);
    }, t.prototype.containPoint = function(r) {
      var e = this._makeLayoutInfo(), n = e.axisBase, i = e.layoutBase, a = e.pixelDimIndex, o = r[1 - a], s = r[a];
      return o >= n && o <= n + e.axisLength && s >= i && s <= i + e.layoutLength;
    }, t.prototype.getModel = function() {
      return this._model;
    }, t.prototype._updateAxesFromSeries = function(r, e) {
      e.eachSeries(function(n) {
        if (r.contains(n, e)) {
          var i = n.getData();
          v3(this.dimensions, function(a) {
            var o = this._axesMap.get(a);
            o.scale.unionExtentFromData(i, i.mapDimension(a)), zc(o.scale, o.model);
          }, this);
        }
      }, this);
    }, t.prototype.resize = function(r, e) {
      this._rect = cn(r.getBoxLayoutParams(), {
        width: e.getWidth(),
        height: e.getHeight()
      }), this._layoutAxes();
    }, t.prototype.getRect = function() {
      return this._rect;
    }, t.prototype._makeLayoutInfo = function() {
      var r = this._model, e = this._rect, n = ["x", "y"], i = ["width", "height"], a = r.get("layout"), o = a === "horizontal" ? 0 : 1, s = e[i[o]], l = [0, s], u = this.dimensions.length, c = z1(r.get("axisExpandWidth"), l), d = z1(r.get("axisExpandCount") || 0, [0, u]), f = r.get("axisExpandable") && u > 3 && u > d && d > 1 && c > 0 && s > 0, h = r.get("axisExpandWindow"), p;
      if (h)
        p = z1(h[1] - h[0], l), h[1] = h[0] + p;
      else {
        p = z1(c * (d - 1), l);
        var v = r.get("axisExpandCenter") || cT(u / 2);
        h = [c * v - p / 2], h[1] = h[0] + p;
      }
      var g = (s - p) / (u - d);
      g < 3 && (g = 0);
      var m = [cT(dT(h[0] / c, 1)) + 1, Poe(dT(h[1] / c, 1)) - 1], y = g / c * h[0];
      return {
        layout: a,
        pixelDimIndex: o,
        layoutBase: e[n[o]],
        layoutLength: s,
        axisBase: e[n[1 - o]],
        axisLength: e[i[1 - o]],
        axisExpandable: f,
        axisExpandWidth: c,
        axisCollapseWidth: g,
        axisExpandWindow: h,
        axisCount: u,
        winInnerIndices: m,
        axisExpandWindow0Pos: y
      };
    }, t.prototype._layoutAxes = function() {
      var r = this._rect, e = this._axesMap, n = this.dimensions, i = this._makeLayoutInfo(), a = i.layout;
      e.each(function(o) {
        var s = [0, i.axisLength], l = o.inverse ? 1 : 0;
        o.setExtent(s[l], s[1 - l]);
      }), v3(n, function(o, s) {
        var l = (i.axisExpandable ? Goe : Voe)(s, i), u = {
          horizontal: {
            x: l.position,
            y: i.axisLength
          },
          vertical: {
            x: 0,
            y: l.position
          }
        }, c = {
          horizontal: Noe / 2,
          vertical: 0
        }, d = [u[a].x + r.x, u[a].y + r.y], f = c[a], h = Oi();
        hu(h, h, f), eo(h, h, d), this._axesLayout[o] = {
          position: d,
          rotation: f,
          transform: h,
          axisNameAvailableWidth: l.axisNameAvailableWidth,
          axisLabelShow: l.axisLabelShow,
          nameTruncateMaxWidth: l.nameTruncateMaxWidth,
          tickDirection: 1,
          labelDirection: 1
        };
      }, this);
    }, t.prototype.getAxis = function(r) {
      return this._axesMap.get(r);
    }, t.prototype.dataToPoint = function(r, e) {
      return this.axisCoordToPoint(this._axesMap.get(e).dataToCoord(r), e);
    }, t.prototype.eachActiveState = function(r, e, n, i) {
      n == null && (n = 0), i == null && (i = r.count());
      var a = this._axesMap, o = this.dimensions, s = [], l = [];
      L(o, function(g) {
        s.push(r.mapDimension(g)), l.push(a.get(g).model);
      });
      for (var u = this.hasAxisBrushed(), c = n; c < i; c++) {
        var d = void 0;
        if (!u)
          d = "normal";
        else {
          d = "active";
          for (var f = r.getValues(s, c), h = 0, p = o.length; h < p; h++) {
            var v = l[h].getActiveState(f[h]);
            if (v === "inactive") {
              d = "inactive";
              break;
            }
          }
        }
        e(d, c);
      }
    }, t.prototype.hasAxisBrushed = function() {
      for (var r = this.dimensions, e = this._axesMap, n = !1, i = 0, a = r.length; i < a; i++)
        e.get(r[i]).model.getActiveState() !== "normal" && (n = !0);
      return n;
    }, t.prototype.axisCoordToPoint = function(r, e) {
      var n = this._axesLayout[e];
      return Ka([r, 0], n.transform);
    }, t.prototype.getAxisLayout = function(r) {
      return Ge(this._axesLayout[r]);
    }, t.prototype.getSlidedAxisExpandWindow = function(r) {
      var e = this._makeLayoutInfo(), n = e.pixelDimIndex, i = e.axisExpandWindow.slice(), a = i[1] - i[0], o = [0, e.axisExpandWidth * (e.axisCount - 1)];
      if (!this.containPoint(r))
        return {
          behavior: "none",
          axisExpandWindow: i
        };
      var s = r[n] - e.layoutBase - e.axisExpandWindow0Pos, l, u = "slide", c = e.axisCollapseWidth, d = this._model.get("axisExpandSlideTriggerArea"), f = d[0] != null;
      if (c)
        f && c && s < a * d[0] ? (u = "jump", l = s - a * d[2]) : f && c && s > a * (1 - d[0]) ? (u = "jump", l = s - a * (1 - d[2])) : (l = s - a * d[1]) >= 0 && (l = s - a * (1 - d[1])) <= 0 && (l = 0), l *= e.axisExpandWidth / c, l ? id(l, i, o, "all") : u = "none";
      else {
        var h = i[1] - i[0], p = o[1] * s / h;
        i = [GB(0, p - h / 2)], i[1] = VB(o[1], i[0] + h), i[0] = i[1] - h;
      }
      return {
        axisExpandWindow: i,
        behavior: u
      };
    }, t;
  }()
);
function z1(t, r) {
  return VB(GB(t, r[0]), r[1]);
}
function Voe(t, r) {
  var e = r.layoutLength / (r.axisCount - 1);
  return {
    position: e * t,
    axisNameAvailableWidth: e,
    axisLabelShow: !0
  };
}
function Goe(t, r) {
  var e = r.layoutLength, n = r.axisExpandWidth, i = r.axisCount, a = r.axisCollapseWidth, o = r.winInnerIndices, s, l = a, u = !1, c;
  return t < o[0] ? (s = t * a, c = a) : t <= o[1] ? (s = r.axisExpandWindow0Pos + t * n - r.axisExpandWindow[0], l = n, u = !0) : (s = e - (i - 1 - t) * a, c = a), {
    position: s,
    axisNameAvailableWidth: l,
    axisLabelShow: u,
    nameTruncateMaxWidth: c
  };
}
function Boe(t, r) {
  var e = [];
  return t.eachComponent("parallel", function(n, i) {
    var a = new Ooe(n, t, r);
    a.name = "parallel_" + i, a.resize(n, r), n.coordinateSystem = a, a.model = n, e.push(a);
  }), t.eachSeries(function(n) {
    if (n.get("coordinateSystem") === "parallel") {
      var i = n.getReferringComponents("parallel", on).models[0];
      n.coordinateSystem = i.coordinateSystem;
    }
  }), e;
}
var Foe = {
  create: Boe
}, N9 = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e.activeIntervals = [], e;
    }
    return r.prototype.getAreaSelectStyle = function() {
      return Bc([
        ["fill", "color"],
        ["lineWidth", "borderWidth"],
        ["stroke", "borderColor"],
        ["width", "width"],
        ["opacity", "opacity"]
        // Option decal is in `DecalObject` but style.decal is in `PatternObject`.
        // So do not transfer decal directly.
      ])(this.getModel("areaSelectStyle"));
    }, r.prototype.setActiveIntervals = function(e) {
      var n = this.activeIntervals = Ge(e);
      if (n)
        for (var i = n.length - 1; i >= 0; i--)
          Ui(n[i]);
    }, r.prototype.getActiveState = function(e) {
      var n = this.activeIntervals;
      if (!n.length)
        return "normal";
      if (e == null || isNaN(+e))
        return "inactive";
      if (n.length === 1) {
        var i = n[0];
        if (i[0] <= e && e <= i[1])
          return "active";
      } else
        for (var a = 0, o = n.length; a < o; a++)
          if (n[a][0] <= e && e <= n[a][1])
            return "active";
      return "inactive";
    }, r;
  }(st)
);
Xr(N9, vh);
var Wc = !0, Vv = Math.min, Pf = Math.max, Hoe = Math.pow, zoe = 1e4, Woe = 6, Zoe = 6, fT = "globalPan", joe = {
  w: [0, 0],
  e: [0, 1],
  n: [1, 0],
  s: [1, 1]
}, Yoe = {
  w: "ew",
  e: "ew",
  n: "ns",
  s: "ns",
  ne: "nesw",
  sw: "nesw",
  nw: "nwse",
  se: "nwse"
}, hT = {
  brushStyle: {
    lineWidth: 2,
    stroke: "rgba(210,219,238,0.3)",
    fill: "#D2DBEE"
  },
  transformable: !0,
  brushMode: "single",
  removeOnClick: !1
}, Xoe = 0, n_ = (
  /** @class */
  function(t) {
    ee(r, t);
    function r(e) {
      var n = t.call(this) || this;
      return n._track = [], n._covers = [], n._handlers = {}, process.env.NODE_ENV !== "production" && ke(e), n._zr = e, n.group = new ze(), n._uid = "brushController_" + Xoe++, L(ese, function(i, a) {
        this._handlers[a] = ye(i, this);
      }, n), n;
    }
    return r.prototype.enableBrush = function(e) {
      return process.env.NODE_ENV !== "production" && ke(this._mounted), this._brushType && this._doDisableBrush(), e.brushType && this._doEnableBrush(e), this;
    }, r.prototype._doEnableBrush = function(e) {
      var n = this._zr;
      this._enableGlobalPan || Vne(n, fT, this._uid), L(this._handlers, function(i, a) {
        n.on(a, i);
      }), this._brushType = e.brushType, this._brushOption = Qe(Ge(hT), e, !0);
    }, r.prototype._doDisableBrush = function() {
      var e = this._zr;
      Gne(e, fT, this._uid), L(this._handlers, function(n, i) {
        e.off(i, n);
      }), this._brushType = this._brushOption = null;
    }, r.prototype.setPanels = function(e) {
      if (e && e.length) {
        var n = this._panels = {};
        L(e, function(i) {
          n[i.panelId] = Ge(i);
        });
      } else
        this._panels = null;
      return this;
    }, r.prototype.mount = function(e) {
      e = e || {}, process.env.NODE_ENV !== "production" && (this._mounted = !0), this._enableGlobalPan = e.enableGlobalPan;
      var n = this.group;
      return this._zr.add(n), n.attr({
        x: e.x || 0,
        y: e.y || 0,
        rotation: e.rotation || 0,
        scaleX: e.scaleX || 1,
        scaleY: e.scaleY || 1
      }), this._transform = n.getLocalTransform(), this;
    }, r.prototype.updateCovers = function(e) {
      process.env.NODE_ENV !== "production" && ke(this._mounted), e = ce(e, function(f) {
        return Qe(Ge(hT), f, !0);
      });
      var n = "\0-brush-index-", i = this._covers, a = this._covers = [], o = this, s = this._creatingCover;
      return new Us(i, e, u, l).add(c).update(c).remove(d).execute(), this;
      function l(f, h) {
        return (f.id != null ? f.id : n + h) + "-" + f.brushType;
      }
      function u(f, h) {
        return l(f.__brushOption, h);
      }
      function c(f, h) {
        var p = e[f];
        if (h != null && i[h] === s)
          a[f] = i[h];
        else {
          var v = a[f] = h != null ? (i[h].__brushOption = p, i[h]) : FB(o, BB(o, p));
          i_(o, v);
        }
      }
      function d(f) {
        i[f] !== s && o.group.remove(i[f]);
      }
    }, r.prototype.unmount = function() {
      if (!(process.env.NODE_ENV !== "production" && !this._mounted))
        return this.enableBrush(!1), O9(this), this._zr.remove(this.group), process.env.NODE_ENV !== "production" && (this._mounted = !1), this;
    }, r.prototype.dispose = function() {
      this.unmount(), this.off();
    }, r;
  }(ka)
);
function BB(t, r) {
  var e = P2[r.brushType].createCover(t, r);
  return e.__brushOption = r, zB(e, r), t.group.add(e), e;
}
function FB(t, r) {
  var e = a_(r);
  return e.endCreating && (e.endCreating(t, r), zB(r, r.__brushOption)), r;
}
function HB(t, r) {
  var e = r.__brushOption;
  a_(r).updateCoverShape(t, r, e.range, e);
}
function zB(t, r) {
  var e = r.z;
  e == null && (e = zoe), t.traverse(function(n) {
    n.z = e, n.z2 = e;
  });
}
function i_(t, r) {
  a_(r).updateCommon(t, r), HB(t, r);
}
function a_(t) {
  return P2[t.__brushOption.brushType];
}
function o_(t, r, e) {
  var n = t._panels;
  if (!n)
    return Wc;
  var i, a = t._transform;
  return L(n, function(o) {
    o.isTargetByCursor(r, e, a) && (i = o);
  }), i;
}
function WB(t, r) {
  var e = t._panels;
  if (!e)
    return Wc;
  var n = r.__brushOption.panelId;
  return n != null ? e[n] : Wc;
}
function O9(t) {
  var r = t._covers, e = r.length;
  return L(r, function(n) {
    t.group.remove(n);
  }, t), r.length = 0, !!e;
}
function Zc(t, r) {
  var e = ce(t._covers, function(n) {
    var i = n.__brushOption, a = Ge(i.range);
    return {
      brushType: i.brushType,
      panelId: i.panelId,
      range: a
    };
  });
  t.trigger("brush", {
    areas: e,
    isEnd: !!r.isEnd,
    removeOnClick: !!r.removeOnClick
  });
}
function $oe(t) {
  var r = t._track;
  if (!r.length)
    return !1;
  var e = r[r.length - 1], n = r[0], i = e[0] - n[0], a = e[1] - n[1], o = Hoe(i * i + a * a, 0.5);
  return o > Woe;
}
function ZB(t) {
  var r = t.length - 1;
  return r < 0 && (r = 0), [t[0], t[r]];
}
function jB(t, r, e, n) {
  var i = new ze();
  return i.add(new xt({
    name: "main",
    style: s_(e),
    silent: !0,
    draggable: !0,
    cursor: "move",
    drift: Ye(pT, t, r, i, ["n", "s", "w", "e"]),
    ondragend: Ye(Zc, r, {
      isEnd: !0
    })
  })), L(n, function(a) {
    i.add(new xt({
      name: a.join(""),
      style: {
        opacity: 0
      },
      draggable: !0,
      silent: !0,
      invisible: !0,
      drift: Ye(pT, t, r, i, a),
      ondragend: Ye(Zc, r, {
        isEnd: !0
      })
    }));
  }), i;
}
function YB(t, r, e, n) {
  var i = n.brushStyle.lineWidth || 0, a = Pf(i, Zoe), o = e[0][0], s = e[1][0], l = o - i / 2, u = s - i / 2, c = e[0][1], d = e[1][1], f = c - a + i / 2, h = d - a + i / 2, p = c - o, v = d - s, g = p + i, m = v + i;
  ps(t, r, "main", o, s, p, v), n.transformable && (ps(t, r, "w", l, u, a, m), ps(t, r, "e", f, u, a, m), ps(t, r, "n", l, u, g, a), ps(t, r, "s", l, h, g, a), ps(t, r, "nw", l, u, a, a), ps(t, r, "ne", f, u, a, a), ps(t, r, "sw", l, h, a, a), ps(t, r, "se", f, h, a, a));
}
function V9(t, r) {
  var e = r.__brushOption, n = e.transformable, i = r.childAt(0);
  i.useStyle(s_(e)), i.attr({
    silent: !n,
    cursor: n ? "move" : "default"
  }), L([["w"], ["e"], ["n"], ["s"], ["s", "e"], ["s", "w"], ["n", "e"], ["n", "w"]], function(a) {
    var o = r.childOfName(a.join("")), s = a.length === 1 ? G9(t, a[0]) : Joe(t, a);
    o && o.attr({
      silent: !n,
      invisible: !n,
      cursor: n ? Yoe[s] + "-resize" : null
    });
  });
}
function ps(t, r, e, n, i, a, o) {
  var s = r.childOfName(e);
  s && s.setShape(qoe(l_(t, r, [[n, i], [n + a, i + o]])));
}
function s_(t) {
  return Ee({
    strokeNoScale: !0
  }, t.brushStyle);
}
function XB(t, r, e, n) {
  var i = [Vv(t, e), Vv(r, n)], a = [Pf(t, e), Pf(r, n)];
  return [
    [i[0], a[0]],
    [i[1], a[1]]
    // y range
  ];
}
function Uoe(t) {
  return Hl(t.group);
}
function G9(t, r) {
  var e = {
    w: "left",
    e: "right",
    n: "top",
    s: "bottom"
  }, n = {
    left: "w",
    right: "e",
    top: "n",
    bottom: "s"
  }, i = f2(e[r], Uoe(t));
  return n[i];
}
function Joe(t, r) {
  var e = [G9(t, r[0]), G9(t, r[1])];
  return (e[0] === "e" || e[0] === "w") && e.reverse(), e.join("");
}
function pT(t, r, e, n, i, a) {
  var o = e.__brushOption, s = t.toRectRange(o.range), l = $B(r, i, a);
  L(n, function(u) {
    var c = joe[u];
    s[c[0]][c[1]] += l[c[0]];
  }), o.range = t.fromRectRange(XB(s[0][0], s[1][0], s[0][1], s[1][1])), i_(r, e), Zc(r, {
    isEnd: !1
  });
}
function Koe(t, r, e, n) {
  var i = r.__brushOption.range, a = $B(t, e, n);
  L(i, function(o) {
    o[0] += a[0], o[1] += a[1];
  }), i_(t, r), Zc(t, {
    isEnd: !1
  });
}
function $B(t, r, e) {
  var n = t.group, i = n.transformCoordToLocal(r, e), a = n.transformCoordToLocal(0, 0);
  return [i[0] - a[0], i[1] - a[1]];
}
function l_(t, r, e) {
  var n = WB(t, r);
  return n && n !== Wc ? n.clipPath(e, t._transform) : Ge(e);
}
function qoe(t) {
  var r = Vv(t[0][0], t[1][0]), e = Vv(t[0][1], t[1][1]), n = Pf(t[0][0], t[1][0]), i = Pf(t[0][1], t[1][1]);
  return {
    x: r,
    y: e,
    width: n - r,
    height: i - e
  };
}
function Qoe(t, r, e) {
  if (
    // Check active
    !(!t._brushType || tse(t, r.offsetX, r.offsetY))
  ) {
    var n = t._zr, i = t._covers, a = o_(t, r, e);
    if (!t._dragging)
      for (var o = 0; o < i.length; o++) {
        var s = i[o].__brushOption;
        if (a && (a === Wc || s.panelId === a.panelId) && P2[s.brushType].contain(i[o], e[0], e[1]))
          return;
      }
    a && n.setCursorStyle("crosshair");
  }
}
function B9(t) {
  var r = t.event;
  r.preventDefault && r.preventDefault();
}
function F9(t, r, e) {
  return t.childOfName("main").contain(r, e);
}
function UB(t, r, e, n) {
  var i = t._creatingCover, a = t._creatingPanel, o = t._brushOption, s;
  if (t._track.push(e.slice()), $oe(t) || i) {
    if (a && !i) {
      o.brushMode === "single" && O9(t);
      var l = Ge(o);
      l.brushType = vT(l.brushType, a), l.panelId = a === Wc ? null : a.panelId, i = t._creatingCover = BB(t, l), t._covers.push(i);
    }
    if (i) {
      var u = P2[vT(t._brushType, a)], c = i.__brushOption;
      c.range = u.getCreatingRange(l_(t, i, t._track)), n && (FB(t, i), u.updateCommon(t, i)), HB(t, i), s = {
        isEnd: n
      };
    }
  } else n && o.brushMode === "single" && o.removeOnClick && o_(t, r, e) && O9(t) && (s = {
    isEnd: n,
    removeOnClick: !0
  });
  return s;
}
function vT(t, r) {
  return t === "auto" ? (process.env.NODE_ENV !== "production" && ke(r && r.defaultBrushType, 'MUST have defaultBrushType when brushType is "atuo"'), r.defaultBrushType) : t;
}
var ese = {
  mousedown: function(t) {
    if (this._dragging)
      gT(this, t);
    else if (!t.target || !t.target.draggable) {
      B9(t);
      var r = this.group.transformCoordToLocal(t.offsetX, t.offsetY);
      this._creatingCover = null;
      var e = this._creatingPanel = o_(this, t, r);
      e && (this._dragging = !0, this._track = [r.slice()]);
    }
  },
  mousemove: function(t) {
    var r = t.offsetX, e = t.offsetY, n = this.group.transformCoordToLocal(r, e);
    if (Qoe(this, t, n), this._dragging) {
      B9(t);
      var i = UB(this, t, n, !1);
      i && Zc(this, i);
    }
  },
  mouseup: function(t) {
    gT(this, t);
  }
};
function gT(t, r) {
  if (t._dragging) {
    B9(r);
    var e = r.offsetX, n = r.offsetY, i = t.group.transformCoordToLocal(e, n), a = UB(t, r, i, !0);
    t._dragging = !1, t._track = [], t._creatingCover = null, a && Zc(t, a);
  }
}
function tse(t, r, e) {
  var n = t._zr;
  return r < 0 || r > n.getWidth() || e < 0 || e > n.getHeight();
}
var P2 = {
  lineX: mT(0),
  lineY: mT(1),
  rect: {
    createCover: function(t, r) {
      function e(n) {
        return n;
      }
      return jB({
        toRectRange: e,
        fromRectRange: e
      }, t, r, [["w"], ["e"], ["n"], ["s"], ["s", "e"], ["s", "w"], ["n", "e"], ["n", "w"]]);
    },
    getCreatingRange: function(t) {
      var r = ZB(t);
      return XB(r[1][0], r[1][1], r[0][0], r[0][1]);
    },
    updateCoverShape: function(t, r, e, n) {
      YB(t, r, e, n);
    },
    updateCommon: V9,
    contain: F9
  },
  polygon: {
    createCover: function(t, r) {
      var e = new ze();
      return e.add(new ci({
        name: "main",
        style: s_(r),
        silent: !0
      })), e;
    },
    getCreatingRange: function(t) {
      return t;
    },
    endCreating: function(t, r) {
      r.remove(r.childAt(0)), r.add(new si({
        name: "main",
        draggable: !0,
        drift: Ye(Koe, t, r),
        ondragend: Ye(Zc, t, {
          isEnd: !0
        })
      }));
    },
    updateCoverShape: function(t, r, e, n) {
      r.childAt(0).setShape({
        points: l_(t, r, e)
      });
    },
    updateCommon: V9,
    contain: F9
  }
};
function mT(t) {
  return {
    createCover: function(r, e) {
      return jB({
        toRectRange: function(n) {
          var i = [n, [0, 100]];
          return t && i.reverse(), i;
        },
        fromRectRange: function(n) {
          return n[t];
        }
      }, r, e, [[["w"], ["e"]], [["n"], ["s"]]][t]);
    },
    getCreatingRange: function(r) {
      var e = ZB(r), n = Vv(e[0][t], e[1][t]), i = Pf(e[0][t], e[1][t]);
      return [n, i];
    },
    updateCoverShape: function(r, e, n, i) {
      var a, o = WB(r, e);
      if (o !== Wc && o.getLinearBrushOtherExtent)
        a = o.getLinearBrushOtherExtent(t);
      else {
        var s = r._zr;
        a = [0, [s.getWidth(), s.getHeight()][1 - t]];
      }
      var l = [n, a];
      t && l.reverse(), YB(r, e, l, i);
    },
    updateCommon: V9,
    contain: F9
  };
}
function JB(t) {
  return t = u_(t), function(r) {
    return $7(r, t);
  };
}
function KB(t, r) {
  return t = u_(t), function(e) {
    var n = r ?? e, i = n ? t.width : t.height, a = n ? t.x : t.y;
    return [a, a + (i || 0)];
  };
}
function qB(t, r, e) {
  var n = u_(t);
  return function(i, a) {
    return n.contain(a[0], a[1]) && !R2(i, r, e);
  };
}
function u_(t) {
  return rt.create(t);
}
var rse = ["axisLine", "axisTickLabel", "axisName"], nse = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.init = function(e, n) {
      t.prototype.init.apply(this, arguments), (this._brushController = new n_(n.getZr())).on("brush", ye(this._onBrush, this));
    }, r.prototype.render = function(e, n, i, a) {
      if (!ise(e, n, a)) {
        this.axisModel = e, this.api = i, this.group.removeAll();
        var o = this._axisGroup;
        if (this._axisGroup = new ze(), this.group.add(this._axisGroup), !!e.get("show")) {
          var s = ose(e, n), l = s.coordinateSystem, u = e.getAreaSelectStyle(), c = u.width, d = e.axis.dim, f = l.getAxisLayout(d), h = ae({
            strokeContainThreshold: c
          }, f), p = new wi(e, h);
          L(rse, p.add, p), this._axisGroup.add(p.getGroup()), this._refreshBrushController(h, u, e, s, c, i), mg(o, this._axisGroup, e);
        }
      }
    }, r.prototype._refreshBrushController = function(e, n, i, a, o, s) {
      var l = i.axis.getExtent(), u = l[1] - l[0], c = Math.min(30, Math.abs(u) * 0.1), d = rt.create({
        x: l[0],
        y: -o / 2,
        width: u,
        height: o
      });
      d.x -= c, d.width += 2 * c, this._brushController.mount({
        enableGlobalPan: !0,
        rotation: e.rotation,
        x: e.position[0],
        y: e.position[1]
      }).setPanels([{
        panelId: "pl",
        clipPath: JB(d),
        isTargetByCursor: qB(d, s, a),
        getLinearBrushOtherExtent: KB(d, 0)
      }]).enableBrush({
        brushType: "lineX",
        brushStyle: n,
        removeOnClick: !0
      }).updateCovers(ase(i));
    }, r.prototype._onBrush = function(e) {
      var n = e.areas, i = this.axisModel, a = i.axis, o = ce(n, function(s) {
        return [a.coordToData(s.range[0], !0), a.coordToData(s.range[1], !0)];
      });
      (!i.option.realtime === e.isEnd || e.removeOnClick) && this.api.dispatchAction({
        type: "axisAreaSelect",
        parallelAxisId: i.id,
        intervals: o
      });
    }, r.prototype.dispose = function() {
      this._brushController.dispose();
    }, r.type = "parallelAxis", r;
  }(yr)
);
function ise(t, r, e) {
  return e && e.type === "axisAreaSelect" && r.findComponents({
    mainType: "parallelAxis",
    query: e
  })[0] === t;
}
function ase(t) {
  var r = t.axis;
  return ce(t.activeIntervals, function(e) {
    return {
      brushType: "lineX",
      panelId: "pl",
      range: [r.dataToCoord(e[0], !0), r.dataToCoord(e[1], !0)]
    };
  });
}
function ose(t, r) {
  return r.getComponent("parallel", t.get("parallelIndex"));
}
var sse = {
  type: "axisAreaSelect",
  event: "axisAreaSelected"
  // update: 'updateVisual'
};
function lse(t) {
  t.registerAction(sse, function(r, e) {
    e.eachComponent({
      mainType: "parallelAxis",
      query: r
    }, function(n) {
      n.axis.model.setActiveIntervals(r.intervals);
    });
  }), t.registerAction("parallelAxisExpand", function(r, e) {
    e.eachComponent({
      mainType: "parallel",
      query: r
    }, function(n) {
      n.setAxisExpand(r);
    });
  });
}
var use = {
  type: "value",
  areaSelectStyle: {
    width: 20,
    borderWidth: 1,
    borderColor: "rgba(160,197,232)",
    color: "rgba(160,197,232)",
    opacity: 0.3
  },
  realtime: !0,
  z: 10
};
function QB(t) {
  t.registerComponentView(Roe), t.registerComponentModel(Eoe), t.registerCoordinateSystem("parallel", Foe), t.registerPreprocessor(Aoe), t.registerComponentModel(N9), t.registerComponentView(nse), kf(t, "parallel", N9, use), lse(t);
}
function cse(t) {
  lt(QB), t.registerChartView(yoe), t.registerSeriesModel(woe), t.registerVisual(t.PRIORITY.VISUAL.BRUSH, Ioe);
}
var dse = (
  /** @class */
  /* @__PURE__ */ function() {
    function t() {
      this.x1 = 0, this.y1 = 0, this.x2 = 0, this.y2 = 0, this.cpx1 = 0, this.cpy1 = 0, this.cpx2 = 0, this.cpy2 = 0, this.extent = 0;
    }
    return t;
  }()
), fse = (
  /** @class */
  function(t) {
    ee(r, t);
    function r(e) {
      return t.call(this, e) || this;
    }
    return r.prototype.getDefaultShape = function() {
      return new dse();
    }, r.prototype.buildPath = function(e, n) {
      var i = n.extent;
      e.moveTo(n.x1, n.y1), e.bezierCurveTo(n.cpx1, n.cpy1, n.cpx2, n.cpy2, n.x2, n.y2), n.orient === "vertical" ? (e.lineTo(n.x2 + i, n.y2), e.bezierCurveTo(n.cpx2 + i, n.cpy2, n.cpx1 + i, n.cpy1, n.x1 + i, n.y1)) : (e.lineTo(n.x2, n.y2 + i), e.bezierCurveTo(n.cpx2, n.cpy2 + i, n.cpx1, n.cpy1 + i, n.x1, n.y1 + i)), e.closePath();
    }, r.prototype.highlight = function() {
      Xs(this);
    }, r.prototype.downplay = function() {
      $s(this);
    }, r;
  }(gt)
), hse = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e._focusAdjacencyDisabled = !1, e;
    }
    return r.prototype.render = function(e, n, i) {
      var a = this, o = e.getGraph(), s = this.group, l = e.layoutInfo, u = l.width, c = l.height, d = e.getData(), f = e.getData("edge"), h = e.get("orient");
      this._model = e, s.removeAll(), s.x = l.x, s.y = l.y, o.eachEdge(function(p) {
        var v = new fse(), g = Ze(v);
        g.dataIndex = p.dataIndex, g.seriesIndex = e.seriesIndex, g.dataType = "edge";
        var m = p.getModel(), y = m.getModel("lineStyle"), b = y.get("curveness"), C = p.node1.getLayout(), w = p.node1.getModel(), _ = w.get("localX"), x = w.get("localY"), I = p.node2.getLayout(), D = p.node2.getModel(), T = D.get("localX"), A = D.get("localY"), M = p.getLayout(), R, E, k, P, N, O, W, V;
        v.shape.extent = Math.max(1, M.dy), v.shape.orient = h, h === "vertical" ? (R = (_ != null ? _ * u : C.x) + M.sy, E = (x != null ? x * c : C.y) + C.dy, k = (T != null ? T * u : I.x) + M.ty, P = A != null ? A * c : I.y, N = R, O = E * (1 - b) + P * b, W = k, V = E * b + P * (1 - b)) : (R = (_ != null ? _ * u : C.x) + C.dx, E = (x != null ? x * c : C.y) + M.sy, k = T != null ? T * u : I.x, P = (A != null ? A * c : I.y) + M.ty, N = R * (1 - b) + k * b, O = E, W = R * b + k * (1 - b), V = P), v.setShape({
          x1: R,
          y1: E,
          x2: k,
          y2: P,
          cpx1: N,
          cpy1: O,
          cpx2: W,
          cpy2: V
        }), v.useStyle(y.getItemStyle()), yT(v.style, h, p);
        var B = "" + m.get("value"), Z = xn(m, "edgeLabel");
        Xn(v, Z, {
          labelFetcher: {
            getFormattedLabel: function(U, J, K, j, oe, ie) {
              return e.getFormattedLabel(
                U,
                J,
                "edge",
                j,
                // ensure edgeLabel formatter is provided
                // to prevent the inheritance from `label.formatter` of the series
                Ki(oe, Z.normal && Z.normal.get("formatter"), B),
                ie
              );
            }
          },
          labelDataIndex: p.dataIndex,
          defaultText: B
        }), v.setTextConfig({
          position: "inside"
        });
        var q = m.getModel("emphasis");
        Yn(v, m, "lineStyle", function(U) {
          var J = U.getItemStyle();
          return yT(J, h, p), J;
        }), s.add(v), f.setItemGraphicEl(p.dataIndex, v);
        var z = q.get("focus");
        Vr(v, z === "adjacency" ? p.getAdjacentDataIndices() : z === "trajectory" ? p.getTrajectoryDataIndices() : z, q.get("blurScope"), q.get("disabled"));
      }), o.eachNode(function(p) {
        var v = p.getLayout(), g = p.getModel(), m = g.get("localX"), y = g.get("localY"), b = g.getModel("emphasis"), C = g.get(["itemStyle", "borderRadius"]) || 0, w = new xt({
          shape: {
            x: m != null ? m * u : v.x,
            y: y != null ? y * c : v.y,
            width: v.dx,
            height: v.dy,
            r: C
          },
          style: g.getModel("itemStyle").getItemStyle(),
          z2: 10
        });
        Xn(w, xn(g), {
          labelFetcher: {
            getFormattedLabel: function(x, I) {
              return e.getFormattedLabel(x, I, "node");
            }
          },
          labelDataIndex: p.dataIndex,
          defaultText: p.id
        }), w.disableLabelAnimation = !0, w.setStyle("fill", p.getVisual("color")), w.setStyle("decal", p.getVisual("style").decal), Yn(w, g), s.add(w), d.setItemGraphicEl(p.dataIndex, w), Ze(w).dataType = "node";
        var _ = b.get("focus");
        Vr(w, _ === "adjacency" ? p.getAdjacentDataIndices() : _ === "trajectory" ? p.getTrajectoryDataIndices() : _, b.get("blurScope"), b.get("disabled"));
      }), d.eachItemGraphicEl(function(p, v) {
        var g = d.getItemModel(v);
        g.get("draggable") && (p.drift = function(m, y) {
          a._focusAdjacencyDisabled = !0, this.shape.x += m, this.shape.y += y, this.dirty(), i.dispatchAction({
            type: "dragNode",
            seriesId: e.id,
            dataIndex: d.getRawIndex(v),
            localX: this.shape.x / u,
            localY: this.shape.y / c
          });
        }, p.ondragend = function() {
          a._focusAdjacencyDisabled = !1;
        }, p.draggable = !0, p.cursor = "move");
      }), !this._data && e.isAnimationEnabled() && s.setClipPath(pse(s.getBoundingRect(), e, function() {
        s.removeClipPath();
      })), this._data = e.getData();
    }, r.prototype.dispose = function() {
    }, r.type = "sankey", r;
  }(Yt)
);
function yT(t, r, e) {
  switch (t.fill) {
    case "source":
      t.fill = e.node1.getVisual("color"), t.decal = e.node1.getVisual("style").decal;
      break;
    case "target":
      t.fill = e.node2.getVisual("color"), t.decal = e.node2.getVisual("style").decal;
      break;
    case "gradient":
      var n = e.node1.getVisual("color"), i = e.node2.getVisual("color");
      pe(n) && pe(i) && (t.fill = new rh(0, 0, +(r === "horizontal"), +(r === "vertical"), [{
        color: n,
        offset: 0
      }, {
        color: i,
        offset: 1
      }]));
  }
}
function pse(t, r, e) {
  var n = new xt({
    shape: {
      x: t.x - 10,
      y: t.y - 10,
      width: 0,
      height: t.height + 20
    }
  });
  return Cr(n, {
    shape: {
      width: t.width + 20
    }
  }, r, e), n;
}
var vse = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.getInitialData = function(e, n) {
      var i = e.edges || e.links, a = e.data || e.nodes, o = e.levels;
      this.levelModels = [];
      for (var s = this.levelModels, l = 0; l < o.length; l++)
        if (o[l].depth != null && o[l].depth >= 0)
          s[o[l].depth] = new Pt(o[l], this, n);
        else if (process.env.NODE_ENV !== "production")
          throw new Error("levels[i].depth is mandatory and should be natural number");
      if (a && i) {
        var u = NB(a, i, this, !0, c);
        return u.data;
      }
      function c(d, f) {
        d.wrapMethod("getItemModel", function(h, p) {
          var v = h.parentModel, g = v.getData().getItemLayout(p);
          if (g) {
            var m = g.depth, y = v.levelModels[m];
            y && (h.parentModel = y);
          }
          return h;
        }), f.wrapMethod("getItemModel", function(h, p) {
          var v = h.parentModel, g = v.getGraph().getEdgeByIndex(p), m = g.node1.getLayout();
          if (m) {
            var y = m.depth, b = v.levelModels[y];
            b && (h.parentModel = b);
          }
          return h;
        });
      }
    }, r.prototype.setNodePosition = function(e, n) {
      var i = this.option.data || this.option.nodes, a = i[e];
      a.localX = n[0], a.localY = n[1];
    }, r.prototype.getGraph = function() {
      return this.getData().graph;
    }, r.prototype.getEdgeData = function() {
      return this.getGraph().edgeData;
    }, r.prototype.formatTooltip = function(e, n, i) {
      function a(h) {
        return isNaN(h) || h == null;
      }
      if (i === "edge") {
        var o = this.getDataParams(e, i), s = o.data, l = o.value, u = s.source + " -- " + s.target;
        return Sn("nameValue", {
          name: u,
          value: l,
          noValue: a(l)
        });
      } else {
        var c = this.getGraph().getNodeByIndex(e), d = c.getLayout().value, f = this.getDataParams(e, i).data.name;
        return Sn("nameValue", {
          name: f != null ? f + "" : null,
          value: d,
          noValue: a(d)
        });
      }
    }, r.prototype.optionUpdated = function() {
    }, r.prototype.getDataParams = function(e, n) {
      var i = t.prototype.getDataParams.call(this, e, n);
      if (i.value == null && n === "node") {
        var a = this.getGraph().getNodeByIndex(e), o = a.getLayout().value;
        i.value = o;
      }
      return i;
    }, r.type = "series.sankey", r.defaultOption = {
      // zlevel: 0,
      z: 2,
      coordinateSystem: "view",
      left: "5%",
      top: "5%",
      right: "20%",
      bottom: "5%",
      orient: "horizontal",
      nodeWidth: 20,
      nodeGap: 8,
      draggable: !0,
      layoutIterations: 32,
      label: {
        show: !0,
        position: "right",
        fontSize: 12
      },
      edgeLabel: {
        show: !1,
        fontSize: 12
      },
      levels: [],
      nodeAlign: "justify",
      lineStyle: {
        color: "#314656",
        opacity: 0.2,
        curveness: 0.5
      },
      emphasis: {
        label: {
          show: !0
        },
        lineStyle: {
          opacity: 0.5
        }
      },
      select: {
        itemStyle: {
          borderColor: "#212121"
        }
      },
      animationEasing: "linear",
      animationDuration: 1e3
    }, r;
  }(tr)
);
function gse(t, r) {
  t.eachSeriesByType("sankey", function(e) {
    var n = e.get("nodeWidth"), i = e.get("nodeGap"), a = mse(e, r);
    e.layoutInfo = a;
    var o = a.width, s = a.height, l = e.getGraph(), u = l.nodes, c = l.edges;
    bse(u);
    var d = Wt(u, function(v) {
      return v.getLayout().value === 0;
    }), f = d.length !== 0 ? 0 : e.get("layoutIterations"), h = e.get("orient"), p = e.get("nodeAlign");
    yse(u, c, n, i, o, s, f, h, p);
  });
}
function mse(t, r) {
  return cn(t.getBoxLayoutParams(), {
    width: r.getWidth(),
    height: r.getHeight()
  });
}
function yse(t, r, e, n, i, a, o, s, l) {
  Cse(t, r, e, i, a, s, l), Sse(t, r, a, i, n, o, s), kse(t, s);
}
function bse(t) {
  L(t, function(r) {
    var e = Wl(r.outEdges, $m), n = Wl(r.inEdges, $m), i = r.getValue() || 0, a = Math.max(e, n, i);
    r.setLayout({
      value: a
    }, !0);
  });
}
function Cse(t, r, e, n, i, a, o) {
  for (var s = [], l = [], u = [], c = [], d = 0, f = 0; f < r.length; f++)
    s[f] = 1;
  for (var f = 0; f < t.length; f++)
    l[f] = t[f].inEdges.length, l[f] === 0 && u.push(t[f]);
  for (var h = -1; u.length; ) {
    for (var p = 0; p < u.length; p++) {
      var v = u[p], g = v.hostGraph.data.getRawDataItem(v.dataIndex), m = g.depth != null && g.depth >= 0;
      m && g.depth > h && (h = g.depth), v.setLayout({
        depth: m ? g.depth : d
      }, !0), a === "vertical" ? v.setLayout({
        dy: e
      }, !0) : v.setLayout({
        dx: e
      }, !0);
      for (var y = 0; y < v.outEdges.length; y++) {
        var b = v.outEdges[y], C = r.indexOf(b);
        s[C] = 0;
        var w = b.node2, _ = t.indexOf(w);
        --l[_] === 0 && c.indexOf(w) < 0 && c.push(w);
      }
    }
    ++d, u = c, c = [];
  }
  for (var f = 0; f < s.length; f++)
    if (s[f] === 1)
      throw new Error("Sankey is a DAG, the original data has cycle!");
  var x = h > d - 1 ? h : d - 1;
  o && o !== "left" && wse(t, o, a, x);
  var I = a === "vertical" ? (i - e) / x : (n - e) / x;
  xse(t, I, a);
}
function eF(t) {
  var r = t.hostGraph.data.getRawDataItem(t.dataIndex);
  return r.depth != null && r.depth >= 0;
}
function wse(t, r, e, n) {
  if (r === "right") {
    for (var i = [], a = t, o = 0; a.length; ) {
      for (var s = 0; s < a.length; s++) {
        var l = a[s];
        l.setLayout({
          skNodeHeight: o
        }, !0);
        for (var u = 0; u < l.inEdges.length; u++) {
          var c = l.inEdges[u];
          i.indexOf(c.node1) < 0 && i.push(c.node1);
        }
      }
      a = i, i = [], ++o;
    }
    L(t, function(d) {
      eF(d) || d.setLayout({
        depth: Math.max(0, n - d.getLayout().skNodeHeight)
      }, !0);
    });
  } else r === "justify" && _se(t, n);
}
function _se(t, r) {
  L(t, function(e) {
    !eF(e) && !e.outEdges.length && e.setLayout({
      depth: r
    }, !0);
  });
}
function xse(t, r, e) {
  L(t, function(n) {
    var i = n.getLayout().depth * r;
    e === "vertical" ? n.setLayout({
      y: i
    }, !0) : n.setLayout({
      x: i
    }, !0);
  });
}
function Sse(t, r, e, n, i, a, o) {
  var s = Ise(t, o);
  Ase(s, r, e, n, i, o), g3(s, i, e, n, o);
  for (var l = 1; a > 0; a--)
    l *= 0.99, Dse(s, l, o), g3(s, i, e, n, o), Ese(s, l, o), g3(s, i, e, n, o);
}
function Ise(t, r) {
  var e = [], n = r === "vertical" ? "y" : "x", i = BC(t, function(a) {
    return a.getLayout()[n];
  });
  return i.keys.sort(function(a, o) {
    return a - o;
  }), L(i.keys, function(a) {
    e.push(i.buckets.get(a));
  }), e;
}
function Ase(t, r, e, n, i, a) {
  var o = 1 / 0;
  L(t, function(s) {
    var l = s.length, u = 0;
    L(s, function(d) {
      u += d.getLayout().value;
    });
    var c = a === "vertical" ? (n - (l - 1) * i) / u : (e - (l - 1) * i) / u;
    c < o && (o = c);
  }), L(t, function(s) {
    L(s, function(l, u) {
      var c = l.getLayout().value * o;
      a === "vertical" ? (l.setLayout({
        x: u
      }, !0), l.setLayout({
        dx: c
      }, !0)) : (l.setLayout({
        y: u
      }, !0), l.setLayout({
        dy: c
      }, !0));
    });
  }), L(r, function(s) {
    var l = +s.getValue() * o;
    s.setLayout({
      dy: l
    }, !0);
  });
}
function g3(t, r, e, n, i) {
  var a = i === "vertical" ? "x" : "y";
  L(t, function(o) {
    o.sort(function(v, g) {
      return v.getLayout()[a] - g.getLayout()[a];
    });
    for (var s, l, u, c = 0, d = o.length, f = i === "vertical" ? "dx" : "dy", h = 0; h < d; h++)
      l = o[h], u = c - l.getLayout()[a], u > 0 && (s = l.getLayout()[a] + u, i === "vertical" ? l.setLayout({
        x: s
      }, !0) : l.setLayout({
        y: s
      }, !0)), c = l.getLayout()[a] + l.getLayout()[f] + r;
    var p = i === "vertical" ? n : e;
    if (u = c - r - p, u > 0) {
      s = l.getLayout()[a] - u, i === "vertical" ? l.setLayout({
        x: s
      }, !0) : l.setLayout({
        y: s
      }, !0), c = s;
      for (var h = d - 2; h >= 0; --h)
        l = o[h], u = l.getLayout()[a] + l.getLayout()[f] + r - c, u > 0 && (s = l.getLayout()[a] - u, i === "vertical" ? l.setLayout({
          x: s
        }, !0) : l.setLayout({
          y: s
        }, !0)), c = l.getLayout()[a];
    }
  });
}
function Dse(t, r, e) {
  L(t.slice().reverse(), function(n) {
    L(n, function(i) {
      if (i.outEdges.length) {
        var a = Wl(i.outEdges, Tse, e) / Wl(i.outEdges, $m);
        if (isNaN(a)) {
          var o = i.outEdges.length;
          a = o ? Wl(i.outEdges, Mse, e) / o : 0;
        }
        if (e === "vertical") {
          var s = i.getLayout().x + (a - nu(i, e)) * r;
          i.setLayout({
            x: s
          }, !0);
        } else {
          var l = i.getLayout().y + (a - nu(i, e)) * r;
          i.setLayout({
            y: l
          }, !0);
        }
      }
    });
  });
}
function Tse(t, r) {
  return nu(t.node2, r) * t.getValue();
}
function Mse(t, r) {
  return nu(t.node2, r);
}
function Rse(t, r) {
  return nu(t.node1, r) * t.getValue();
}
function Lse(t, r) {
  return nu(t.node1, r);
}
function nu(t, r) {
  return r === "vertical" ? t.getLayout().x + t.getLayout().dx / 2 : t.getLayout().y + t.getLayout().dy / 2;
}
function $m(t) {
  return t.getValue();
}
function Wl(t, r, e) {
  for (var n = 0, i = t.length, a = -1; ++a < i; ) {
    var o = +r(t[a], e);
    isNaN(o) || (n += o);
  }
  return n;
}
function Ese(t, r, e) {
  L(t, function(n) {
    L(n, function(i) {
      if (i.inEdges.length) {
        var a = Wl(i.inEdges, Rse, e) / Wl(i.inEdges, $m);
        if (isNaN(a)) {
          var o = i.inEdges.length;
          a = o ? Wl(i.inEdges, Lse, e) / o : 0;
        }
        if (e === "vertical") {
          var s = i.getLayout().x + (a - nu(i, e)) * r;
          i.setLayout({
            x: s
          }, !0);
        } else {
          var l = i.getLayout().y + (a - nu(i, e)) * r;
          i.setLayout({
            y: l
          }, !0);
        }
      }
    });
  });
}
function kse(t, r) {
  var e = r === "vertical" ? "x" : "y";
  L(t, function(n) {
    n.outEdges.sort(function(i, a) {
      return i.node2.getLayout()[e] - a.node2.getLayout()[e];
    }), n.inEdges.sort(function(i, a) {
      return i.node1.getLayout()[e] - a.node1.getLayout()[e];
    });
  }), L(t, function(n) {
    var i = 0, a = 0;
    L(n.outEdges, function(o) {
      o.setLayout({
        sy: i
      }, !0), i += o.getLayout().dy;
    }), L(n.inEdges, function(o) {
      o.setLayout({
        ty: a
      }, !0), a += o.getLayout().dy;
    });
  });
}
function Pse(t) {
  t.eachSeriesByType("sankey", function(r) {
    var e = r.getGraph(), n = e.nodes, i = e.edges;
    if (n.length) {
      var a = 1 / 0, o = -1 / 0;
      L(n, function(s) {
        var l = s.getLayout().value;
        l < a && (a = l), l > o && (o = l);
      }), L(n, function(s) {
        var l = new _n({
          type: "color",
          mappingMethod: "linear",
          dataExtent: [a, o],
          visual: r.get("color")
        }), u = l.mapValueToVisual(s.getLayout().value), c = s.getModel().get(["itemStyle", "color"]);
        c != null ? (s.setVisual("color", c), s.setVisual("style", {
          fill: c
        })) : (s.setVisual("color", u), s.setVisual("style", {
          fill: u
        }));
      });
    }
    i.length && L(i, function(s) {
      var l = s.getModel().get("lineStyle");
      s.setVisual("style", l);
    });
  });
}
function Nse(t) {
  t.registerChartView(hse), t.registerSeriesModel(vse), t.registerLayout(gse), t.registerVisual(Pse), t.registerAction({
    type: "dragNode",
    event: "dragnode",
    // here can only use 'update' now, other value is not support in echarts.
    update: "update"
  }, function(r, e) {
    e.eachComponent({
      mainType: "series",
      subType: "sankey",
      query: r
    }, function(n) {
      n.setNodePosition(r.dataIndex, [r.localX, r.localY]);
    });
  });
}
var tF = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.getInitialData = function(r, e) {
      var n, i = e.getComponent("xAxis", this.get("xAxisIndex")), a = e.getComponent("yAxis", this.get("yAxisIndex")), o = i.get("type"), s = a.get("type"), l;
      o === "category" ? (r.layout = "horizontal", n = i.getOrdinalMeta(), l = !0) : s === "category" ? (r.layout = "vertical", n = a.getOrdinalMeta(), l = !0) : r.layout = r.layout || "horizontal";
      var u = ["x", "y"], c = r.layout === "horizontal" ? 0 : 1, d = this._baseAxisDim = u[c], f = u[1 - c], h = [i, a], p = h[c].get("type"), v = h[1 - c].get("type"), g = r.data;
      if (g && l) {
        var m = [];
        L(g, function(C, w) {
          var _;
          ue(C) ? (_ = C.slice(), C.unshift(w)) : ue(C.value) ? (_ = ae({}, C), _.value = _.value.slice(), C.value.unshift(w)) : _ = C, m.push(_);
        }), r.data = m;
      }
      var y = this.defaultValueDimensions, b = [{
        name: d,
        type: Vm(p),
        ordinalMeta: n,
        otherDims: {
          tooltip: !1,
          itemName: 0
        },
        dimsDef: ["base"]
      }, {
        name: f,
        type: Vm(v),
        dimsDef: y.slice()
      }];
      return gh(this, {
        coordDimensions: b,
        dimensionsCount: y.length + 1,
        encodeDefaulter: Ye(LO, b, this)
      });
    }, t.prototype.getBaseAxis = function() {
      var r = this._baseAxisDim;
      return this.ecModel.getComponent(r + "Axis", this.get(r + "AxisIndex")).axis;
    }, t;
  }()
), rF = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e.defaultValueDimensions = [{
        name: "min",
        defaultTooltip: !0
      }, {
        name: "Q1",
        defaultTooltip: !0
      }, {
        name: "median",
        defaultTooltip: !0
      }, {
        name: "Q3",
        defaultTooltip: !0
      }, {
        name: "max",
        defaultTooltip: !0
      }], e.visualDrawType = "stroke", e;
    }
    return r.type = "series.boxplot", r.dependencies = ["xAxis", "yAxis", "grid"], r.defaultOption = {
      // zlevel: 0,
      z: 2,
      coordinateSystem: "cartesian2d",
      legendHoverLink: !0,
      layout: null,
      boxWidth: [7, 50],
      itemStyle: {
        color: "#fff",
        borderWidth: 1
      },
      emphasis: {
        scale: !0,
        itemStyle: {
          borderWidth: 2,
          shadowBlur: 5,
          shadowOffsetX: 1,
          shadowOffsetY: 1,
          shadowColor: "rgba(0,0,0,0.2)"
        }
      },
      animationDuration: 800
    }, r;
  }(tr)
);
Xr(rF, tF, !0);
var Ose = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.render = function(e, n, i) {
      var a = e.getData(), o = this.group, s = this._data;
      this._data || o.removeAll();
      var l = e.get("layout") === "horizontal" ? 1 : 0;
      a.diff(s).add(function(u) {
        if (a.hasValue(u)) {
          var c = a.getItemLayout(u), d = bT(c, a, u, l, !0);
          a.setItemGraphicEl(u, d), o.add(d);
        }
      }).update(function(u, c) {
        var d = s.getItemGraphicEl(c);
        if (!a.hasValue(u)) {
          o.remove(d);
          return;
        }
        var f = a.getItemLayout(u);
        d ? (ro(d), nF(f, d, a, u)) : d = bT(f, a, u, l), o.add(d), a.setItemGraphicEl(u, d);
      }).remove(function(u) {
        var c = s.getItemGraphicEl(u);
        c && o.remove(c);
      }).execute(), this._data = a;
    }, r.prototype.remove = function(e) {
      var n = this.group, i = this._data;
      this._data = null, i && i.eachItemGraphicEl(function(a) {
        a && n.remove(a);
      });
    }, r.type = "boxplot", r;
  }(Yt)
), Vse = (
  /** @class */
  /* @__PURE__ */ function() {
    function t() {
    }
    return t;
  }()
), Gse = (
  /** @class */
  function(t) {
    ee(r, t);
    function r(e) {
      var n = t.call(this, e) || this;
      return n.type = "boxplotBoxPath", n;
    }
    return r.prototype.getDefaultShape = function() {
      return new Vse();
    }, r.prototype.buildPath = function(e, n) {
      var i = n.points, a = 0;
      for (e.moveTo(i[a][0], i[a][1]), a++; a < 4; a++)
        e.lineTo(i[a][0], i[a][1]);
      for (e.closePath(); a < i.length; a++)
        e.moveTo(i[a][0], i[a][1]), a++, e.lineTo(i[a][0], i[a][1]);
    }, r;
  }(gt)
);
function bT(t, r, e, n, i) {
  var a = t.ends, o = new Gse({
    shape: {
      points: i ? Bse(a, n, t) : a
    }
  });
  return nF(t, o, r, e, i), o;
}
function nF(t, r, e, n, i) {
  var a = e.hostModel, o = qc[i ? "initProps" : "updateProps"];
  o(r, {
    shape: {
      points: t.ends
    }
  }, a, n), r.useStyle(e.getItemVisual(n, "style")), r.style.strokeNoScale = !0, r.z2 = 100;
  var s = e.getItemModel(n), l = s.getModel("emphasis");
  Yn(r, s), Vr(r, l.get("focus"), l.get("blurScope"), l.get("disabled"));
}
function Bse(t, r, e) {
  return ce(t, function(n) {
    return n = n.slice(), n[r] = e.initBaseline, n;
  });
}
var nv = L;
function Fse(t) {
  var r = Hse(t);
  nv(r, function(e) {
    var n = e.seriesModels;
    n.length && (zse(e), nv(n, function(i, a) {
      Wse(i, e.boxOffsetList[a], e.boxWidthList[a]);
    }));
  });
}
function Hse(t) {
  var r = [], e = [];
  return t.eachSeriesByType("boxplot", function(n) {
    var i = n.getBaseAxis(), a = nt(e, i);
    a < 0 && (a = e.length, e[a] = i, r[a] = {
      axis: i,
      seriesModels: []
    }), r[a].seriesModels.push(n);
  }), r;
}
function zse(t) {
  var r = t.axis, e = t.seriesModels, n = e.length, i = t.boxWidthList = [], a = t.boxOffsetList = [], o = [], s;
  if (r.type === "category")
    s = r.getBandWidth();
  else {
    var l = 0;
    nv(e, function(p) {
      l = Math.max(l, p.getData().count());
    });
    var u = r.getExtent();
    s = Math.abs(u[1] - u[0]) / l;
  }
  nv(e, function(p) {
    var v = p.get("boxWidth");
    ue(v) || (v = [v, v]), o.push([he(v[0], s) || 0, he(v[1], s) || 0]);
  });
  var c = s * 0.8 - 2, d = c / n * 0.3, f = (c - d * (n - 1)) / n, h = f / 2 - c / 2;
  nv(e, function(p, v) {
    a.push(h), h += d + f, i.push(Math.min(Math.max(f, o[v][0]), o[v][1]));
  });
}
function Wse(t, r, e) {
  var n = t.coordinateSystem, i = t.getData(), a = e / 2, o = t.get("layout") === "horizontal" ? 0 : 1, s = 1 - o, l = ["x", "y"], u = i.mapDimension(l[o]), c = i.mapDimensionsAll(l[s]);
  if (u == null || c.length < 5)
    return;
  for (var d = 0; d < i.count(); d++) {
    var f = i.get(u, d), h = b(f, c[2], d), p = b(f, c[0], d), v = b(f, c[1], d), g = b(f, c[3], d), m = b(f, c[4], d), y = [];
    C(y, v, !1), C(y, g, !0), y.push(p, v, m, g), w(y, p), w(y, m), w(y, h), i.setItemLayout(d, {
      initBaseline: h[s],
      ends: y
    });
  }
  function b(_, x, I) {
    var D = i.get(x, I), T = [];
    T[o] = _, T[s] = D;
    var A;
    return isNaN(_) || isNaN(D) ? A = [NaN, NaN] : (A = n.dataToPoint(T), A[o] += r), A;
  }
  function C(_, x, I) {
    var D = x.slice(), T = x.slice();
    D[o] += a, T[o] -= a, I ? _.push(D, T) : _.push(T, D);
  }
  function w(_, x) {
    var I = x.slice(), D = x.slice();
    I[o] -= a, D[o] += a, _.push(I, D);
  }
}
function Zse(t, r) {
  r = r || {};
  for (var e = [], n = [], i = r.boundIQR, a = i === "none" || i === 0, o = 0; o < t.length; o++) {
    var s = Ui(t[o].slice()), l = D0(s, 0.25), u = D0(s, 0.5), c = D0(s, 0.75), d = s[0], f = s[s.length - 1], h = (i ?? 1.5) * (c - l), p = a ? d : Math.max(d, l - h), v = a ? f : Math.min(f, c + h), g = r.itemNameFormatter, m = Ae(g) ? g({
      value: o
    }) : pe(g) ? g.replace("{value}", o + "") : o + "";
    e.push([m, p, l, u, c, v]);
    for (var y = 0; y < s.length; y++) {
      var b = s[y];
      if (b < p || b > v) {
        var C = [m, b];
        n.push(C);
      }
    }
  }
  return {
    boxData: e,
    outliers: n
  };
}
var jse = {
  type: "echarts:boxplot",
  transform: function(r) {
    var e = r.upstream;
    if (e.sourceFormat !== li) {
      var n = "";
      process.env.NODE_ENV !== "production" && (n = _i("source data is not applicable for this boxplot transform. Expect number[][].")), Gt(n);
    }
    var i = Zse(e.getRawData(), r.config);
    return [{
      dimensions: ["ItemName", "Low", "Q1", "Q2", "Q3", "High"],
      data: i.boxData
    }, {
      data: i.outliers
    }];
  }
};
function Yse(t) {
  t.registerSeriesModel(rF), t.registerChartView(Ose), t.registerLayout(Fse), t.registerTransform(jse);
}
var Xse = ["color", "borderColor"], $se = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.render = function(e, n, i) {
      this.group.removeClipPath(), this._progressiveEls = null, this._updateDrawMode(e), this._isLargeDraw ? this._renderLarge(e) : this._renderNormal(e);
    }, r.prototype.incrementalPrepareRender = function(e, n, i) {
      this._clear(), this._updateDrawMode(e);
    }, r.prototype.incrementalRender = function(e, n, i, a) {
      this._progressiveEls = [], this._isLargeDraw ? this._incrementalRenderLarge(e, n) : this._incrementalRenderNormal(e, n);
    }, r.prototype.eachRendered = function(e) {
      pu(this._progressiveEls || this.group, e);
    }, r.prototype._updateDrawMode = function(e) {
      var n = e.pipelineContext.large;
      (this._isLargeDraw == null || n !== this._isLargeDraw) && (this._isLargeDraw = n, this._clear());
    }, r.prototype._renderNormal = function(e) {
      var n = e.getData(), i = this._data, a = this.group, o = n.getLayout("isSimpleBox"), s = e.get("clip", !0), l = e.coordinateSystem, u = l.getArea && l.getArea();
      this._data || a.removeAll(), n.diff(i).add(function(c) {
        if (n.hasValue(c)) {
          var d = n.getItemLayout(c);
          if (s && CT(u, d))
            return;
          var f = m3(d, c, !0);
          Cr(f, {
            shape: {
              points: d.ends
            }
          }, e, c), y3(f, n, c, o), a.add(f), n.setItemGraphicEl(c, f);
        }
      }).update(function(c, d) {
        var f = i.getItemGraphicEl(d);
        if (!n.hasValue(c)) {
          a.remove(f);
          return;
        }
        var h = n.getItemLayout(c);
        if (s && CT(u, h)) {
          a.remove(f);
          return;
        }
        f ? (kt(f, {
          shape: {
            points: h.ends
          }
        }, e, c), ro(f)) : f = m3(h), y3(f, n, c, o), a.add(f), n.setItemGraphicEl(c, f);
      }).remove(function(c) {
        var d = i.getItemGraphicEl(c);
        d && a.remove(d);
      }).execute(), this._data = n;
    }, r.prototype._renderLarge = function(e) {
      this._clear(), wT(e, this.group);
      var n = e.get("clip", !0) ? xg(e.coordinateSystem, !1, e) : null;
      n ? this.group.setClipPath(n) : this.group.removeClipPath();
    }, r.prototype._incrementalRenderNormal = function(e, n) {
      for (var i = n.getData(), a = i.getLayout("isSimpleBox"), o; (o = e.next()) != null; ) {
        var s = i.getItemLayout(o), l = m3(s);
        y3(l, i, o, a), l.incremental = !0, this.group.add(l), this._progressiveEls.push(l);
      }
    }, r.prototype._incrementalRenderLarge = function(e, n) {
      wT(n, this.group, this._progressiveEls, !0);
    }, r.prototype.remove = function(e) {
      this._clear();
    }, r.prototype._clear = function() {
      this.group.removeAll(), this._data = null;
    }, r.type = "candlestick", r;
  }(Yt)
), Use = (
  /** @class */
  /* @__PURE__ */ function() {
    function t() {
    }
    return t;
  }()
), Jse = (
  /** @class */
  function(t) {
    ee(r, t);
    function r(e) {
      var n = t.call(this, e) || this;
      return n.type = "normalCandlestickBox", n;
    }
    return r.prototype.getDefaultShape = function() {
      return new Use();
    }, r.prototype.buildPath = function(e, n) {
      var i = n.points;
      this.__simpleBox ? (e.moveTo(i[4][0], i[4][1]), e.lineTo(i[6][0], i[6][1])) : (e.moveTo(i[0][0], i[0][1]), e.lineTo(i[1][0], i[1][1]), e.lineTo(i[2][0], i[2][1]), e.lineTo(i[3][0], i[3][1]), e.closePath(), e.moveTo(i[4][0], i[4][1]), e.lineTo(i[5][0], i[5][1]), e.moveTo(i[6][0], i[6][1]), e.lineTo(i[7][0], i[7][1]));
    }, r;
  }(gt)
);
function m3(t, r, e) {
  var n = t.ends;
  return new Jse({
    shape: {
      points: e ? Kse(n, t) : n
    },
    z2: 100
  });
}
function CT(t, r) {
  for (var e = !0, n = 0; n < r.ends.length; n++)
    if (t.contain(r.ends[n][0], r.ends[n][1])) {
      e = !1;
      break;
    }
  return e;
}
function y3(t, r, e, n) {
  var i = r.getItemModel(e);
  t.useStyle(r.getItemVisual(e, "style")), t.style.strokeNoScale = !0, t.__simpleBox = n, Yn(t, i);
}
function Kse(t, r) {
  return ce(t, function(e) {
    return e = e.slice(), e[1] = r.initBaseline, e;
  });
}
var qse = (
  /** @class */
  /* @__PURE__ */ function() {
    function t() {
    }
    return t;
  }()
), b3 = (
  /** @class */
  function(t) {
    ee(r, t);
    function r(e) {
      var n = t.call(this, e) || this;
      return n.type = "largeCandlestickBox", n;
    }
    return r.prototype.getDefaultShape = function() {
      return new qse();
    }, r.prototype.buildPath = function(e, n) {
      for (var i = n.points, a = 0; a < i.length; )
        if (this.__sign === i[a++]) {
          var o = i[a++];
          e.moveTo(o, i[a++]), e.lineTo(o, i[a++]);
        } else
          a += 3;
    }, r;
  }(gt)
);
function wT(t, r, e, n) {
  var i = t.getData(), a = i.getLayout("largePoints"), o = new b3({
    shape: {
      points: a
    },
    __sign: 1,
    ignoreCoarsePointer: !0
  });
  r.add(o);
  var s = new b3({
    shape: {
      points: a
    },
    __sign: -1,
    ignoreCoarsePointer: !0
  });
  r.add(s);
  var l = new b3({
    shape: {
      points: a
    },
    __sign: 0,
    ignoreCoarsePointer: !0
  });
  r.add(l), C3(1, o, t), C3(-1, s, t), C3(0, l, t), n && (o.incremental = !0, s.incremental = !0), e && e.push(o, s);
}
function C3(t, r, e, n) {
  var i = e.get(["itemStyle", t > 0 ? "borderColor" : "borderColor0"]) || e.get(["itemStyle", t > 0 ? "color" : "color0"]);
  t === 0 && (i = e.get(["itemStyle", "borderColorDoji"]));
  var a = e.getModel("itemStyle").getItemStyle(Xse);
  r.useStyle(a), r.style.fill = null, r.style.stroke = i;
}
var iF = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e.defaultValueDimensions = [{
        name: "open",
        defaultTooltip: !0
      }, {
        name: "close",
        defaultTooltip: !0
      }, {
        name: "lowest",
        defaultTooltip: !0
      }, {
        name: "highest",
        defaultTooltip: !0
      }], e;
    }
    return r.prototype.getShadowDim = function() {
      return "open";
    }, r.prototype.brushSelector = function(e, n, i) {
      var a = n.getItemLayout(e);
      return a && i.rect(a.brushRect);
    }, r.type = "series.candlestick", r.dependencies = ["xAxis", "yAxis", "grid"], r.defaultOption = {
      // zlevel: 0,
      z: 2,
      coordinateSystem: "cartesian2d",
      legendHoverLink: !0,
      // xAxisIndex: 0,
      // yAxisIndex: 0,
      layout: null,
      clip: !0,
      itemStyle: {
        color: "#eb5454",
        color0: "#47b262",
        borderColor: "#eb5454",
        borderColor0: "#47b262",
        borderColorDoji: null,
        // borderColor: '#d24040',
        // borderColor0: '#398f4f',
        borderWidth: 1
      },
      emphasis: {
        scale: !0,
        itemStyle: {
          borderWidth: 2
        }
      },
      barMaxWidth: null,
      barMinWidth: null,
      barWidth: null,
      large: !0,
      largeThreshold: 600,
      progressive: 3e3,
      progressiveThreshold: 1e4,
      progressiveChunkMode: "mod",
      animationEasing: "linear",
      animationDuration: 300
    }, r;
  }(tr)
);
Xr(iF, tF, !0);
function Qse(t) {
  !t || !ue(t.series) || L(t.series, function(r) {
    Me(r) && r.type === "k" && (r.type = "candlestick");
  });
}
var ele = ["itemStyle", "borderColor"], tle = ["itemStyle", "borderColor0"], rle = ["itemStyle", "borderColorDoji"], nle = ["itemStyle", "color"], ile = ["itemStyle", "color0"], ale = {
  seriesType: "candlestick",
  plan: ch(),
  // For legend.
  performRawSeries: !0,
  reset: function(t, r) {
    function e(a, o) {
      return o.get(a > 0 ? nle : ile);
    }
    function n(a, o) {
      return o.get(a === 0 ? rle : a > 0 ? ele : tle);
    }
    if (!r.isSeriesFiltered(t)) {
      var i = t.pipelineContext.large;
      return !i && {
        progress: function(a, o) {
          for (var s; (s = a.next()) != null; ) {
            var l = o.getItemModel(s), u = o.getItemLayout(s).sign, c = l.getItemStyle();
            c.fill = e(u, l), c.stroke = n(u, l) || c.fill;
            var d = o.ensureUniqueItemVisual(s, "style");
            ae(d, c);
          }
        }
      };
    }
  }
}, ole = {
  seriesType: "candlestick",
  plan: ch(),
  reset: function(t) {
    var r = t.coordinateSystem, e = t.getData(), n = sle(t, e), i = 0, a = 1, o = ["x", "y"], s = e.getDimensionIndex(e.mapDimension(o[i])), l = ce(e.mapDimensionsAll(o[a]), e.getDimensionIndex, e), u = l[0], c = l[1], d = l[2], f = l[3];
    if (e.setLayout({
      candleWidth: n,
      // The value is experimented visually.
      isSimpleBox: n <= 1.3
    }), s < 0 || l.length < 4)
      return;
    return {
      progress: t.pipelineContext.large ? p : h
    };
    function h(v, g) {
      for (var m, y = g.getStore(); (m = v.next()) != null; ) {
        var b = y.get(s, m), C = y.get(u, m), w = y.get(c, m), _ = y.get(d, m), x = y.get(f, m), I = Math.min(C, w), D = Math.max(C, w), T = N(I, b), A = N(D, b), M = N(_, b), R = N(x, b), E = [];
        O(E, A, 0), O(E, T, 1), E.push(V(R), V(A), V(M), V(T));
        var k = g.getItemModel(m), P = !!k.get(["itemStyle", "borderColorDoji"]);
        g.setItemLayout(m, {
          sign: _T(y, m, C, w, c, P),
          initBaseline: C > w ? A[a] : T[a],
          ends: E,
          brushRect: W(_, x, b)
        });
      }
      function N(B, Z) {
        var q = [];
        return q[i] = Z, q[a] = B, isNaN(Z) || isNaN(B) ? [NaN, NaN] : r.dataToPoint(q);
      }
      function O(B, Z, q) {
        var z = Z.slice(), U = Z.slice();
        z[i] = R0(z[i] + n / 2, 1, !1), U[i] = R0(U[i] - n / 2, 1, !0), q ? B.push(z, U) : B.push(U, z);
      }
      function W(B, Z, q) {
        var z = N(B, q), U = N(Z, q);
        return z[i] -= n / 2, U[i] -= n / 2, {
          x: z[0],
          y: z[1],
          width: n,
          height: U[1] - z[1]
        };
      }
      function V(B) {
        return B[i] = R0(B[i], 1), B;
      }
    }
    function p(v, g) {
      for (var m = Oo(v.count * 4), y = 0, b, C = [], w = [], _, x = g.getStore(), I = !!t.get(["itemStyle", "borderColorDoji"]); (_ = v.next()) != null; ) {
        var D = x.get(s, _), T = x.get(u, _), A = x.get(c, _), M = x.get(d, _), R = x.get(f, _);
        if (isNaN(D) || isNaN(M) || isNaN(R)) {
          m[y++] = NaN, y += 3;
          continue;
        }
        m[y++] = _T(x, _, T, A, c, I), C[i] = D, C[a] = M, b = r.dataToPoint(C, null, w), m[y++] = b ? b[0] : NaN, m[y++] = b ? b[1] : NaN, C[a] = R, b = r.dataToPoint(C, null, w), m[y++] = b ? b[1] : NaN;
      }
      g.setLayout("largePoints", m);
    }
  }
};
function _T(t, r, e, n, i, a) {
  var o;
  return e > n ? o = -1 : e < n ? o = 1 : o = a ? 0 : r > 0 ? t.get(i, r - 1) <= n ? 1 : -1 : 1, o;
}
function sle(t, r) {
  var e = t.getBaseAxis(), n, i = e.type === "category" ? e.getBandWidth() : (n = e.getExtent(), Math.abs(n[1] - n[0]) / r.count()), a = he(je(t.get("barMaxWidth"), i), i), o = he(je(t.get("barMinWidth"), 1), i), s = t.get("barWidth");
  return s != null ? he(s, i) : Math.max(Math.min(i / 2, a), o);
}
function lle(t) {
  t.registerChartView($se), t.registerSeriesModel(iF), t.registerPreprocessor(Qse), t.registerVisual(ale), t.registerLayout(ole);
}
function xT(t, r) {
  var e = r.rippleEffectColor || r.color;
  t.eachChild(function(n) {
    n.attr({
      z: r.z,
      zlevel: r.zlevel,
      style: {
        stroke: r.brushType === "stroke" ? e : null,
        fill: r.brushType === "fill" ? e : null
      }
    });
  });
}
var ule = (
  /** @class */
  function(t) {
    ee(r, t);
    function r(e, n) {
      var i = t.call(this) || this, a = new wg(e, n), o = new ze();
      return i.add(a), i.add(o), i.updateData(e, n), i;
    }
    return r.prototype.stopEffectAnimation = function() {
      this.childAt(1).removeAll();
    }, r.prototype.startEffectAnimation = function(e) {
      for (var n = e.symbolType, i = e.color, a = e.rippleNumber, o = this.childAt(1), s = 0; s < a; s++) {
        var l = en(n, -1, -1, 2, 2, i);
        l.attr({
          style: {
            strokeNoScale: !0
          },
          z2: 99,
          silent: !0,
          scaleX: 0.5,
          scaleY: 0.5
        });
        var u = -s / a * e.period + e.effectOffset;
        l.animate("", !0).when(e.period, {
          scaleX: e.rippleScale / 2,
          scaleY: e.rippleScale / 2
        }).delay(u).start(), l.animateStyle(!0).when(e.period, {
          opacity: 0
        }).delay(u).start(), o.add(l);
      }
      xT(o, e);
    }, r.prototype.updateEffectAnimation = function(e) {
      for (var n = this._effectCfg, i = this.childAt(1), a = ["symbolType", "period", "rippleScale", "rippleNumber"], o = 0; o < a.length; o++) {
        var s = a[o];
        if (n[s] !== e[s]) {
          this.stopEffectAnimation(), this.startEffectAnimation(e);
          return;
        }
      }
      xT(i, e);
    }, r.prototype.highlight = function() {
      Xs(this);
    }, r.prototype.downplay = function() {
      $s(this);
    }, r.prototype.getSymbolType = function() {
      var e = this.childAt(0);
      return e && e.getSymbolType();
    }, r.prototype.updateData = function(e, n) {
      var i = this, a = e.hostModel;
      this.childAt(0).updateData(e, n);
      var o = this.childAt(1), s = e.getItemModel(n), l = e.getItemVisual(n, "symbol"), u = fh(e.getItemVisual(n, "symbolSize")), c = e.getItemVisual(n, "style"), d = c && c.fill, f = s.getModel("emphasis");
      o.setScale(u), o.traverse(function(g) {
        g.setStyle("fill", d);
      });
      var h = td(e.getItemVisual(n, "symbolOffset"), u);
      h && (o.x = h[0], o.y = h[1]);
      var p = e.getItemVisual(n, "symbolRotate");
      o.rotation = (p || 0) * Math.PI / 180 || 0;
      var v = {};
      v.showEffectOn = a.get("showEffectOn"), v.rippleScale = s.get(["rippleEffect", "scale"]), v.brushType = s.get(["rippleEffect", "brushType"]), v.period = s.get(["rippleEffect", "period"]) * 1e3, v.effectOffset = n / e.count(), v.z = a.getShallow("z") || 0, v.zlevel = a.getShallow("zlevel") || 0, v.symbolType = l, v.color = d, v.rippleEffectColor = s.get(["rippleEffect", "color"]), v.rippleNumber = s.get(["rippleEffect", "number"]), v.showEffectOn === "render" ? (this._effectCfg ? this.updateEffectAnimation(v) : this.startEffectAnimation(v), this._effectCfg = v) : (this._effectCfg = null, this.stopEffectAnimation(), this.onHoverStateChange = function(g) {
        g === "emphasis" ? v.showEffectOn !== "render" && i.startEffectAnimation(v) : g === "normal" && v.showEffectOn !== "render" && i.stopEffectAnimation();
      }), this._effectCfg = v, Vr(this, f.get("focus"), f.get("blurScope"), f.get("disabled"));
    }, r.prototype.fadeOut = function(e) {
      e && e();
    }, r;
  }(ze)
), cle = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.init = function() {
      this._symbolDraw = new _g(ule);
    }, r.prototype.render = function(e, n, i) {
      var a = e.getData(), o = this._symbolDraw;
      o.updateData(a, {
        clipShape: this._getClipShape(e)
      }), this.group.add(o.group);
    }, r.prototype._getClipShape = function(e) {
      var n = e.coordinateSystem, i = n && n.getArea && n.getArea();
      return e.get("clip", !0) ? i : null;
    }, r.prototype.updateTransform = function(e, n, i) {
      var a = e.getData();
      this.group.dirty();
      var o = Sg("").reset(e, n, i);
      o.progress && o.progress({
        start: 0,
        end: a.count(),
        count: a.count()
      }, a), this._symbolDraw.updateLayout();
    }, r.prototype._updateGroupTransform = function(e) {
      var n = e.coordinateSystem;
      n && n.getRoamTransform && (this.group.transform = jP(n.getRoamTransform()), this.group.decomposeTransform());
    }, r.prototype.remove = function(e, n) {
      this._symbolDraw && this._symbolDraw.remove(!0);
    }, r.type = "effectScatter", r;
  }(Yt)
), dle = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e.hasSymbolVisual = !0, e;
    }
    return r.prototype.getInitialData = function(e, n) {
      return os(null, this, {
        useEncodeDefaulter: !0
      });
    }, r.prototype.brushSelector = function(e, n, i) {
      return i.point(n.getItemLayout(e));
    }, r.type = "series.effectScatter", r.dependencies = ["grid", "polar"], r.defaultOption = {
      coordinateSystem: "cartesian2d",
      // zlevel: 0,
      z: 2,
      legendHoverLink: !0,
      effectType: "ripple",
      progressive: 0,
      // When to show the effect, option: 'render'|'emphasis'
      showEffectOn: "render",
      clip: !0,
      // Ripple effect config
      rippleEffect: {
        period: 4,
        // Scale of ripple
        scale: 2.5,
        // Brush type can be fill or stroke
        brushType: "fill",
        // Ripple number
        number: 3
      },
      universalTransition: {
        divideShape: "clone"
      },
      // Cartesian coordinate system
      // xAxisIndex: 0,
      // yAxisIndex: 0,
      // Polar coordinate system
      // polarIndex: 0,
      // Geo coordinate system
      // geoIndex: 0,
      // symbol: null,        // 图形类型
      symbolSize: 10
      // 图形大小，半宽（半径）参数，当图形为方向或菱形则总宽度为symbolSize * 2
      // symbolRotate: null,  // 图形旋转控制
      // itemStyle: {
      //     opacity: 1
      // }
    }, r;
  }(tr)
);
function fle(t) {
  t.registerChartView(cle), t.registerSeriesModel(dle), t.registerLayout(Sg("effectScatter"));
}
var aF = (
  /** @class */
  function(t) {
    ee(r, t);
    function r(e, n, i) {
      var a = t.call(this) || this;
      return a.add(a.createLine(e, n, i)), a._updateEffectSymbol(e, n), a;
    }
    return r.prototype.createLine = function(e, n, i) {
      return new t_(e, n, i);
    }, r.prototype._updateEffectSymbol = function(e, n) {
      var i = e.getItemModel(n), a = i.getModel("effect"), o = a.get("symbolSize"), s = a.get("symbol");
      ue(o) || (o = [o, o]);
      var l = e.getItemVisual(n, "style"), u = a.get("color") || l && l.stroke, c = this.childAt(1);
      this._symbolType !== s && (this.remove(c), c = en(s, -0.5, -0.5, 1, 1, u), c.z2 = 100, c.culling = !0, this.add(c)), c && (c.setStyle("shadowColor", u), c.setStyle(a.getItemStyle(["color"])), c.scaleX = o[0], c.scaleY = o[1], c.setColor(u), this._symbolType = s, this._symbolScale = o, this._updateEffectAnimation(e, a, n));
    }, r.prototype._updateEffectAnimation = function(e, n, i) {
      var a = this.childAt(1);
      if (a) {
        var o = e.getItemLayout(i), s = n.get("period") * 1e3, l = n.get("loop"), u = n.get("roundTrip"), c = n.get("constantSpeed"), d = Qr(n.get("delay"), function(h) {
          return h / e.count() * s / 3;
        });
        if (a.ignore = !0, this._updateAnimationPoints(a, o), c > 0 && (s = this._getLineLength(a) / c * 1e3), s !== this._period || l !== this._loop || u !== this._roundTrip) {
          a.stopAnimation();
          var f = void 0;
          Ae(d) ? f = d(i) : f = d, a.__t > 0 && (f = -s * a.__t), this._animateSymbol(a, s, f, l, u);
        }
        this._period = s, this._loop = l, this._roundTrip = u;
      }
    }, r.prototype._animateSymbol = function(e, n, i, a, o) {
      if (n > 0) {
        e.__t = 0;
        var s = this, l = e.animate("", a).when(o ? n * 2 : n, {
          __t: o ? 2 : 1
        }).delay(i).during(function() {
          s._updateSymbolPosition(e);
        });
        a || l.done(function() {
          s.remove(e);
        }), l.start();
      }
    }, r.prototype._getLineLength = function(e) {
      return Ts(e.__p1, e.__cp1) + Ts(e.__cp1, e.__p2);
    }, r.prototype._updateAnimationPoints = function(e, n) {
      e.__p1 = n[0], e.__p2 = n[1], e.__cp1 = n[2] || [(n[0][0] + n[1][0]) / 2, (n[0][1] + n[1][1]) / 2];
    }, r.prototype.updateData = function(e, n, i) {
      this.childAt(0).updateData(e, n, i), this._updateEffectSymbol(e, n);
    }, r.prototype._updateSymbolPosition = function(e) {
      var n = e.__p1, i = e.__p2, a = e.__cp1, o = e.__t < 1 ? e.__t : 2 - e.__t, s = [e.x, e.y], l = s.slice(), u = Rn, c = xC;
      s[0] = u(n[0], a[0], i[0], o), s[1] = u(n[1], a[1], i[1], o);
      var d = e.__t < 1 ? c(n[0], a[0], i[0], o) : c(i[0], a[0], n[0], 1 - o), f = e.__t < 1 ? c(n[1], a[1], i[1], o) : c(i[1], a[1], n[1], 1 - o);
      e.rotation = -Math.atan2(f, d) - Math.PI / 2, (this._symbolType === "line" || this._symbolType === "rect" || this._symbolType === "roundRect") && (e.__lastT !== void 0 && e.__lastT < e.__t ? (e.scaleY = Ts(l, s) * 1.05, o === 1 && (s[0] = l[0] + (s[0] - l[0]) / 2, s[1] = l[1] + (s[1] - l[1]) / 2)) : e.__lastT === 1 ? e.scaleY = 2 * Ts(n, s) : e.scaleY = this._symbolScale[1]), e.__lastT = e.__t, e.ignore = !1, e.x = s[0], e.y = s[1];
    }, r.prototype.updateLayout = function(e, n) {
      this.childAt(0).updateLayout(e, n);
      var i = e.getItemModel(n).getModel("effect");
      this._updateEffectAnimation(e, i, n);
    }, r;
  }(ze)
), oF = (
  /** @class */
  function(t) {
    ee(r, t);
    function r(e, n, i) {
      var a = t.call(this) || this;
      return a._createPolyline(e, n, i), a;
    }
    return r.prototype._createPolyline = function(e, n, i) {
      var a = e.getItemLayout(n), o = new ci({
        shape: {
          points: a
        }
      });
      this.add(o), this._updateCommonStl(e, n, i);
    }, r.prototype.updateData = function(e, n, i) {
      var a = e.hostModel, o = this.childAt(0), s = {
        shape: {
          points: e.getItemLayout(n)
        }
      };
      kt(o, s, a, n), this._updateCommonStl(e, n, i);
    }, r.prototype._updateCommonStl = function(e, n, i) {
      var a = this.childAt(0), o = e.getItemModel(n), s = i && i.emphasisLineStyle, l = i && i.focus, u = i && i.blurScope, c = i && i.emphasisDisabled;
      if (!i || e.hasItemOption) {
        var d = o.getModel("emphasis");
        s = d.getModel("lineStyle").getLineStyle(), c = d.get("disabled"), l = d.get("focus"), u = d.get("blurScope");
      }
      a.useStyle(e.getItemVisual(n, "style")), a.style.fill = null, a.style.strokeNoScale = !0;
      var f = a.ensureState("emphasis");
      f.style = s, Vr(this, l, u, c);
    }, r.prototype.updateLayout = function(e, n) {
      var i = this.childAt(0);
      i.setShape("points", e.getItemLayout(n));
    }, r;
  }(ze)
), hle = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e._lastFrame = 0, e._lastFramePercent = 0, e;
    }
    return r.prototype.createLine = function(e, n, i) {
      return new oF(e, n, i);
    }, r.prototype._updateAnimationPoints = function(e, n) {
      this._points = n;
      for (var i = [0], a = 0, o = 1; o < n.length; o++) {
        var s = n[o - 1], l = n[o];
        a += Ts(s, l), i.push(a);
      }
      if (a === 0) {
        this._length = 0;
        return;
      }
      for (var o = 0; o < i.length; o++)
        i[o] /= a;
      this._offsets = i, this._length = a;
    }, r.prototype._getLineLength = function() {
      return this._length;
    }, r.prototype._updateSymbolPosition = function(e) {
      var n = e.__t < 1 ? e.__t : 2 - e.__t, i = this._points, a = this._offsets, o = i.length;
      if (a) {
        var s = this._lastFrame, l;
        if (n < this._lastFramePercent) {
          var u = Math.min(s + 1, o - 1);
          for (l = u; l >= 0 && !(a[l] <= n); l--)
            ;
          l = Math.min(l, o - 2);
        } else {
          for (l = s; l < o && !(a[l] > n); l++)
            ;
          l = Math.min(l - 1, o - 2);
        }
        var c = (n - a[l]) / (a[l + 1] - a[l]), d = i[l], f = i[l + 1];
        e.x = d[0] * (1 - c) + c * f[0], e.y = d[1] * (1 - c) + c * f[1];
        var h = e.__t < 1 ? f[0] - d[0] : d[0] - f[0], p = e.__t < 1 ? f[1] - d[1] : d[1] - f[1];
        e.rotation = -Math.atan2(p, h) - Math.PI / 2, this._lastFrame = l, this._lastFramePercent = n, e.ignore = !1;
      }
    }, r;
  }(aF)
), ple = (
  /** @class */
  /* @__PURE__ */ function() {
    function t() {
      this.polyline = !1, this.curveness = 0, this.segs = [];
    }
    return t;
  }()
), vle = (
  /** @class */
  function(t) {
    ee(r, t);
    function r(e) {
      var n = t.call(this, e) || this;
      return n._off = 0, n.hoverDataIdx = -1, n;
    }
    return r.prototype.reset = function() {
      this.notClear = !1, this._off = 0;
    }, r.prototype.getDefaultStyle = function() {
      return {
        stroke: "#000",
        fill: null
      };
    }, r.prototype.getDefaultShape = function() {
      return new ple();
    }, r.prototype.buildPath = function(e, n) {
      var i = n.segs, a = n.curveness, o;
      if (n.polyline)
        for (o = this._off; o < i.length; ) {
          var s = i[o++];
          if (s > 0) {
            e.moveTo(i[o++], i[o++]);
            for (var l = 1; l < s; l++)
              e.lineTo(i[o++], i[o++]);
          }
        }
      else
        for (o = this._off; o < i.length; ) {
          var u = i[o++], c = i[o++], d = i[o++], f = i[o++];
          if (e.moveTo(u, c), a > 0) {
            var h = (u + d) / 2 - (c - f) * a, p = (c + f) / 2 - (d - u) * a;
            e.quadraticCurveTo(h, p, d, f);
          } else
            e.lineTo(d, f);
        }
      this.incremental && (this._off = o, this.notClear = !0);
    }, r.prototype.findDataIndex = function(e, n) {
      var i = this.shape, a = i.segs, o = i.curveness, s = this.style.lineWidth;
      if (i.polyline)
        for (var l = 0, u = 0; u < a.length; ) {
          var c = a[u++];
          if (c > 0)
            for (var d = a[u++], f = a[u++], h = 1; h < c; h++) {
              var p = a[u++], v = a[u++];
              if (_l(d, f, p, v, s, e, n))
                return l;
            }
          l++;
        }
      else
        for (var l = 0, u = 0; u < a.length; ) {
          var d = a[u++], f = a[u++], p = a[u++], v = a[u++];
          if (o > 0) {
            var g = (d + p) / 2 - (f - v) * o, m = (f + v) / 2 - (p - d) * o;
            if (NN(d, f, g, m, p, v, s, e, n))
              return l;
          } else if (_l(d, f, p, v, s, e, n))
            return l;
          l++;
        }
      return -1;
    }, r.prototype.contain = function(e, n) {
      var i = this.transformCoordToLocal(e, n), a = this.getBoundingRect();
      if (e = i[0], n = i[1], a.contain(e, n)) {
        var o = this.hoverDataIdx = this.findDataIndex(e, n);
        return o >= 0;
      }
      return this.hoverDataIdx = -1, !1;
    }, r.prototype.getBoundingRect = function() {
      var e = this._rect;
      if (!e) {
        for (var n = this.shape, i = n.segs, a = 1 / 0, o = 1 / 0, s = -1 / 0, l = -1 / 0, u = 0; u < i.length; ) {
          var c = i[u++], d = i[u++];
          a = Math.min(c, a), s = Math.max(c, s), o = Math.min(d, o), l = Math.max(d, l);
        }
        e = this._rect = new rt(a, o, s, l);
      }
      return e;
    }, r;
  }(gt)
), gle = (
  /** @class */
  function() {
    function t() {
      this.group = new ze();
    }
    return t.prototype.updateData = function(r) {
      this._clear();
      var e = this._create();
      e.setShape({
        segs: r.getLayout("linesPoints")
      }), this._setCommon(e, r);
    }, t.prototype.incrementalPrepareUpdate = function(r) {
      this.group.removeAll(), this._clear();
    }, t.prototype.incrementalUpdate = function(r, e) {
      var n = this._newAdded[0], i = e.getLayout("linesPoints"), a = n && n.shape.segs;
      if (a && a.length < 2e4) {
        var o = a.length, s = new Float32Array(o + i.length);
        s.set(a), s.set(i, o), n.setShape({
          segs: s
        });
      } else {
        this._newAdded = [];
        var l = this._create();
        l.incremental = !0, l.setShape({
          segs: i
        }), this._setCommon(l, e), l.__startIndex = r.start;
      }
    }, t.prototype.remove = function() {
      this._clear();
    }, t.prototype.eachRendered = function(r) {
      this._newAdded[0] && r(this._newAdded[0]);
    }, t.prototype._create = function() {
      var r = new vle({
        cursor: "default",
        ignoreCoarsePointer: !0
      });
      return this._newAdded.push(r), this.group.add(r), r;
    }, t.prototype._setCommon = function(r, e, n) {
      var i = e.hostModel;
      r.setShape({
        polyline: i.get("polyline"),
        curveness: i.get(["lineStyle", "curveness"])
      }), r.useStyle(i.getModel("lineStyle").getLineStyle()), r.style.strokeNoScale = !0;
      var a = e.getVisual("style");
      a && a.stroke && r.setStyle("stroke", a.stroke), r.setStyle("fill", null);
      var o = Ze(r);
      o.seriesIndex = i.seriesIndex, r.on("mousemove", function(s) {
        o.dataIndex = null;
        var l = r.hoverDataIdx;
        l > 0 && (o.dataIndex = l + r.__startIndex);
      });
    }, t.prototype._clear = function() {
      this._newAdded = [], this.group.removeAll();
    }, t;
  }()
), sF = {
  seriesType: "lines",
  plan: ch(),
  reset: function(t) {
    var r = t.coordinateSystem;
    if (!r) {
      process.env.NODE_ENV !== "production" && jn("The lines series must have a coordinate system.");
      return;
    }
    var e = t.get("polyline"), n = t.pipelineContext.large;
    return {
      progress: function(i, a) {
        var o = [];
        if (n) {
          var s = void 0, l = i.end - i.start;
          if (e) {
            for (var u = 0, c = i.start; c < i.end; c++)
              u += t.getLineCoordsCount(c);
            s = new Float32Array(l + u * 2);
          } else
            s = new Float32Array(l * 4);
          for (var d = 0, f = [], c = i.start; c < i.end; c++) {
            var h = t.getLineCoords(c, o);
            e && (s[d++] = h);
            for (var p = 0; p < h; p++)
              f = r.dataToPoint(o[p], !1, f), s[d++] = f[0], s[d++] = f[1];
          }
          a.setLayout("linesPoints", s);
        } else
          for (var c = i.start; c < i.end; c++) {
            var v = a.getItemModel(c), h = t.getLineCoords(c, o), g = [];
            if (e)
              for (var m = 0; m < h; m++)
                g.push(r.dataToPoint(o[m]));
            else {
              g[0] = r.dataToPoint(o[0]), g[1] = r.dataToPoint(o[1]);
              var y = v.get(["lineStyle", "curveness"]);
              +y && (g[2] = [(g[0][0] + g[1][0]) / 2 - (g[0][1] - g[1][1]) * y, (g[0][1] + g[1][1]) / 2 - (g[1][0] - g[0][0]) * y]);
            }
            a.setItemLayout(c, g);
          }
      }
    };
  }
}, mle = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.render = function(e, n, i) {
      var a = e.getData(), o = this._updateLineDraw(a, e), s = e.get("zlevel"), l = e.get(["effect", "trailLength"]), u = i.getZr(), c = u.painter.getType() === "svg";
      c || u.painter.getLayer(s).clear(!0), this._lastZlevel != null && !c && u.configLayer(this._lastZlevel, {
        motionBlur: !1
      }), this._showEffect(e) && l > 0 && (c ? process.env.NODE_ENV !== "production" && console.warn("SVG render mode doesn't support lines with trail effect") : u.configLayer(s, {
        motionBlur: !0,
        lastFrameAlpha: Math.max(Math.min(l / 10 + 0.9, 1), 0)
      })), o.updateData(a);
      var d = e.get("clip", !0) && xg(e.coordinateSystem, !1, e);
      d ? this.group.setClipPath(d) : this.group.removeClipPath(), this._lastZlevel = s, this._finished = !0;
    }, r.prototype.incrementalPrepareRender = function(e, n, i) {
      var a = e.getData(), o = this._updateLineDraw(a, e);
      o.incrementalPrepareUpdate(a), this._clearLayer(i), this._finished = !1;
    }, r.prototype.incrementalRender = function(e, n, i) {
      this._lineDraw.incrementalUpdate(e, n.getData()), this._finished = e.end === n.getData().count();
    }, r.prototype.eachRendered = function(e) {
      this._lineDraw && this._lineDraw.eachRendered(e);
    }, r.prototype.updateTransform = function(e, n, i) {
      var a = e.getData(), o = e.pipelineContext;
      if (!this._finished || o.large || o.progressiveRender)
        return {
          update: !0
        };
      var s = sF.reset(e, n, i);
      s.progress && s.progress({
        start: 0,
        end: a.count(),
        count: a.count()
      }, a), this._lineDraw.updateLayout(), this._clearLayer(i);
    }, r.prototype._updateLineDraw = function(e, n) {
      var i = this._lineDraw, a = this._showEffect(n), o = !!n.get("polyline"), s = n.pipelineContext, l = s.large;
      return process.env.NODE_ENV !== "production" && a && l && console.warn("Large lines not support effect"), (!i || a !== this._hasEffet || o !== this._isPolyline || l !== this._isLargeDraw) && (i && i.remove(), i = this._lineDraw = l ? new gle() : new r_(o ? a ? hle : oF : a ? aF : t_), this._hasEffet = a, this._isPolyline = o, this._isLargeDraw = l), this.group.add(i.group), i;
    }, r.prototype._showEffect = function(e) {
      return !!e.get(["effect", "show"]);
    }, r.prototype._clearLayer = function(e) {
      var n = e.getZr(), i = n.painter.getType() === "svg";
      !i && this._lastZlevel != null && n.painter.getLayer(this._lastZlevel).clear(!0);
    }, r.prototype.remove = function(e, n) {
      this._lineDraw && this._lineDraw.remove(), this._lineDraw = null, this._clearLayer(n);
    }, r.prototype.dispose = function(e, n) {
      this.remove(e, n);
    }, r.type = "lines", r;
  }(Yt)
), yle = typeof Uint32Array > "u" ? Array : Uint32Array, ble = typeof Float64Array > "u" ? Array : Float64Array;
function ST(t) {
  var r = t.data;
  r && r[0] && r[0][0] && r[0][0].coord && (process.env.NODE_ENV !== "production" && console.warn("Lines data configuration has been changed to { coords:[[1,2],[2,3]] }"), t.data = ce(r, function(e) {
    var n = [e[0].coord, e[1].coord], i = {
      coords: n
    };
    return e[0].name && (i.fromName = e[0].name), e[1].name && (i.toName = e[1].name), $y([i, e[0], e[1]]);
  }));
}
var Cle = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e.visualStyleAccessPath = "lineStyle", e.visualDrawType = "stroke", e;
    }
    return r.prototype.init = function(e) {
      e.data = e.data || [], ST(e);
      var n = this._processFlatCoordsArray(e.data);
      this._flatCoords = n.flatCoords, this._flatCoordsOffset = n.flatCoordsOffset, n.flatCoords && (e.data = new Float32Array(n.count)), t.prototype.init.apply(this, arguments);
    }, r.prototype.mergeOption = function(e) {
      if (ST(e), e.data) {
        var n = this._processFlatCoordsArray(e.data);
        this._flatCoords = n.flatCoords, this._flatCoordsOffset = n.flatCoordsOffset, n.flatCoords && (e.data = new Float32Array(n.count));
      }
      t.prototype.mergeOption.apply(this, arguments);
    }, r.prototype.appendData = function(e) {
      var n = this._processFlatCoordsArray(e.data);
      n.flatCoords && (this._flatCoords ? (this._flatCoords = hv(this._flatCoords, n.flatCoords), this._flatCoordsOffset = hv(this._flatCoordsOffset, n.flatCoordsOffset)) : (this._flatCoords = n.flatCoords, this._flatCoordsOffset = n.flatCoordsOffset), e.data = new Float32Array(n.count)), this.getRawData().appendData(e.data);
    }, r.prototype._getCoordsFromItemModel = function(e) {
      var n = this.getData().getItemModel(e), i = n.option instanceof Array ? n.option : n.getShallow("coords");
      if (process.env.NODE_ENV !== "production" && !(i instanceof Array && i.length > 0 && i[0] instanceof Array))
        throw new Error("Invalid coords " + JSON.stringify(i) + ". Lines must have 2d coords array in data item.");
      return i;
    }, r.prototype.getLineCoordsCount = function(e) {
      return this._flatCoordsOffset ? this._flatCoordsOffset[e * 2 + 1] : this._getCoordsFromItemModel(e).length;
    }, r.prototype.getLineCoords = function(e, n) {
      if (this._flatCoordsOffset) {
        for (var i = this._flatCoordsOffset[e * 2], a = this._flatCoordsOffset[e * 2 + 1], o = 0; o < a; o++)
          n[o] = n[o] || [], n[o][0] = this._flatCoords[i + o * 2], n[o][1] = this._flatCoords[i + o * 2 + 1];
        return a;
      } else {
        for (var s = this._getCoordsFromItemModel(e), o = 0; o < s.length; o++)
          n[o] = n[o] || [], n[o][0] = s[o][0], n[o][1] = s[o][1];
        return s.length;
      }
    }, r.prototype._processFlatCoordsArray = function(e) {
      var n = 0;
      if (this._flatCoords && (n = this._flatCoords.length), Mt(e[0])) {
        for (var i = e.length, a = new yle(i), o = new ble(i), s = 0, l = 0, u = 0, c = 0; c < i; ) {
          u++;
          var d = e[c++];
          a[l++] = s + n, a[l++] = d;
          for (var f = 0; f < d; f++) {
            var h = e[c++], p = e[c++];
            if (o[s++] = h, o[s++] = p, c > i && process.env.NODE_ENV !== "production")
              throw new Error("Invalid data format.");
          }
        }
        return {
          flatCoordsOffset: new Uint32Array(a.buffer, 0, l),
          flatCoords: o,
          count: u
        };
      }
      return {
        flatCoordsOffset: null,
        flatCoords: null,
        count: e.length
      };
    }, r.prototype.getInitialData = function(e, n) {
      if (process.env.NODE_ENV !== "production") {
        var i = ed.get(e.coordinateSystem);
        if (!i)
          throw new Error("Unknown coordinate system " + e.coordinateSystem);
      }
      var a = new ni(["value"], this);
      return a.hasItemOption = !1, a.initData(e.data, [], function(o, s, l, u) {
        if (o instanceof Array)
          return NaN;
        a.hasItemOption = !0;
        var c = o.value;
        if (c != null)
          return c instanceof Array ? c[u] : c;
      }), a;
    }, r.prototype.formatTooltip = function(e, n, i) {
      var a = this.getData(), o = a.getItemModel(e), s = o.get("name");
      if (s)
        return s;
      var l = o.get("fromName"), u = o.get("toName"), c = [];
      return l != null && c.push(l), u != null && c.push(u), Sn("nameValue", {
        name: c.join(" > ")
      });
    }, r.prototype.preventIncremental = function() {
      return !!this.get(["effect", "show"]);
    }, r.prototype.getProgressive = function() {
      var e = this.option.progressive;
      return e ?? (this.option.large ? 1e4 : this.get("progressive"));
    }, r.prototype.getProgressiveThreshold = function() {
      var e = this.option.progressiveThreshold;
      return e ?? (this.option.large ? 2e4 : this.get("progressiveThreshold"));
    }, r.prototype.getZLevelKey = function() {
      var e = this.getModel("effect"), n = e.get("trailLength");
      return this.getData().count() > this.getProgressiveThreshold() ? this.id : e.get("show") && n > 0 ? n + "" : "";
    }, r.type = "series.lines", r.dependencies = ["grid", "polar", "geo", "calendar"], r.defaultOption = {
      coordinateSystem: "geo",
      // zlevel: 0,
      z: 2,
      legendHoverLink: !0,
      // Cartesian coordinate system
      xAxisIndex: 0,
      yAxisIndex: 0,
      symbol: ["none", "none"],
      symbolSize: [10, 10],
      // Geo coordinate system
      geoIndex: 0,
      effect: {
        show: !1,
        period: 4,
        constantSpeed: 0,
        symbol: "circle",
        symbolSize: 3,
        loop: !0,
        trailLength: 0.2
      },
      large: !1,
      // Available when large is true
      largeThreshold: 2e3,
      polyline: !1,
      clip: !0,
      label: {
        show: !1,
        position: "end"
        // distance: 5,
        // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调
      },
      lineStyle: {
        opacity: 0.5
      }
    }, r;
  }(tr)
);
function W1(t) {
  return t instanceof Array || (t = [t, t]), t;
}
var wle = {
  seriesType: "lines",
  reset: function(t) {
    var r = W1(t.get("symbol")), e = W1(t.get("symbolSize")), n = t.getData();
    n.setVisual("fromSymbol", r && r[0]), n.setVisual("toSymbol", r && r[1]), n.setVisual("fromSymbolSize", e && e[0]), n.setVisual("toSymbolSize", e && e[1]);
    function i(a, o) {
      var s = a.getItemModel(o), l = W1(s.getShallow("symbol", !0)), u = W1(s.getShallow("symbolSize", !0));
      l[0] && a.setItemVisual(o, "fromSymbol", l[0]), l[1] && a.setItemVisual(o, "toSymbol", l[1]), u[0] && a.setItemVisual(o, "fromSymbolSize", u[0]), u[1] && a.setItemVisual(o, "toSymbolSize", u[1]);
    }
    return {
      dataEach: n.hasItemOption ? i : null
    };
  }
};
function _le(t) {
  t.registerChartView(mle), t.registerSeriesModel(Cle), t.registerLayout(sF), t.registerVisual(wle);
}
var xle = 256, Sle = (
  /** @class */
  function() {
    function t() {
      this.blurSize = 30, this.pointSize = 20, this.maxOpacity = 1, this.minOpacity = 0, this._gradientPixels = {
        inRange: null,
        outOfRange: null
      };
      var r = Qa.createCanvas();
      this.canvas = r;
    }
    return t.prototype.update = function(r, e, n, i, a, o) {
      var s = this._getBrush(), l = this._getGradient(a, "inRange"), u = this._getGradient(a, "outOfRange"), c = this.pointSize + this.blurSize, d = this.canvas, f = d.getContext("2d"), h = r.length;
      d.width = e, d.height = n;
      for (var p = 0; p < h; ++p) {
        var v = r[p], g = v[0], m = v[1], y = v[2], b = i(y);
        f.globalAlpha = b, f.drawImage(s, g - c, m - c);
      }
      if (!d.width || !d.height)
        return d;
      for (var C = f.getImageData(0, 0, d.width, d.height), w = C.data, _ = 0, x = w.length, I = this.minOpacity, D = this.maxOpacity, T = D - I; _ < x; ) {
        var b = w[_ + 3] / 256, A = Math.floor(b * (xle - 1)) * 4;
        if (b > 0) {
          var M = o(b) ? l : u;
          b > 0 && (b = b * T + I), w[_++] = M[A], w[_++] = M[A + 1], w[_++] = M[A + 2], w[_++] = M[A + 3] * b * 256;
        } else
          _ += 4;
      }
      return f.putImageData(C, 0, 0), d;
    }, t.prototype._getBrush = function() {
      var r = this._brushCanvas || (this._brushCanvas = Qa.createCanvas()), e = this.pointSize + this.blurSize, n = e * 2;
      r.width = n, r.height = n;
      var i = r.getContext("2d");
      return i.clearRect(0, 0, n, n), i.shadowOffsetX = n, i.shadowBlur = this.blurSize, i.shadowColor = "#000", i.beginPath(), i.arc(-e, e, this.pointSize, 0, Math.PI * 2, !0), i.closePath(), i.fill(), r;
    }, t.prototype._getGradient = function(r, e) {
      for (var n = this._gradientPixels, i = n[e] || (n[e] = new Uint8ClampedArray(256 * 4)), a = [0, 0, 0, 0], o = 0, s = 0; s < 256; s++)
        r[e](s / 255, !0, a), i[o++] = a[0], i[o++] = a[1], i[o++] = a[2], i[o++] = a[3];
      return i;
    }, t;
  }()
);
function Ile(t, r, e) {
  var n = t[1] - t[0];
  r = ce(r, function(o) {
    return {
      interval: [(o.interval[0] - t[0]) / n, (o.interval[1] - t[0]) / n]
    };
  });
  var i = r.length, a = 0;
  return function(o) {
    var s;
    for (s = a; s < i; s++) {
      var l = r[s].interval;
      if (l[0] <= o && o <= l[1]) {
        a = s;
        break;
      }
    }
    if (s === i)
      for (s = a - 1; s >= 0; s--) {
        var l = r[s].interval;
        if (l[0] <= o && o <= l[1]) {
          a = s;
          break;
        }
      }
    return s >= 0 && s < i && e[s];
  };
}
function Ale(t, r) {
  var e = t[1] - t[0];
  return r = [(r[0] - t[0]) / e, (r[1] - t[0]) / e], function(n) {
    return n >= r[0] && n <= r[1];
  };
}
function IT(t) {
  var r = t.dimensions;
  return r[0] === "lng" && r[1] === "lat";
}
var Dle = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.render = function(e, n, i) {
      var a;
      if (n.eachComponent("visualMap", function(s) {
        s.eachTargetSeries(function(l) {
          l === e && (a = s);
        });
      }), process.env.NODE_ENV !== "production" && !a)
        throw new Error("Heatmap must use with visualMap");
      this._progressiveEls = null, this.group.removeAll();
      var o = e.coordinateSystem;
      o.type === "cartesian2d" || o.type === "calendar" ? this._renderOnCartesianAndCalendar(e, i, 0, e.getData().count()) : IT(o) && this._renderOnGeo(o, e, a, i);
    }, r.prototype.incrementalPrepareRender = function(e, n, i) {
      this.group.removeAll();
    }, r.prototype.incrementalRender = function(e, n, i, a) {
      var o = n.coordinateSystem;
      o && (IT(o) ? this.render(n, i, a) : (this._progressiveEls = [], this._renderOnCartesianAndCalendar(n, a, e.start, e.end, !0)));
    }, r.prototype.eachRendered = function(e) {
      pu(this._progressiveEls || this.group, e);
    }, r.prototype._renderOnCartesianAndCalendar = function(e, n, i, a, o) {
      var s = e.coordinateSystem, l = rd(s, "cartesian2d"), u, c, d, f;
      if (l) {
        var h = s.getAxis("x"), p = s.getAxis("y");
        if (process.env.NODE_ENV !== "production") {
          if (!(h.type === "category" && p.type === "category"))
            throw new Error("Heatmap on cartesian must have two category axes");
          if (!(h.onBand && p.onBand))
            throw new Error("Heatmap on cartesian must have two axes with boundaryGap true");
        }
        u = h.getBandWidth() + 0.5, c = p.getBandWidth() + 0.5, d = h.scale.getExtent(), f = p.scale.getExtent();
      }
      for (var v = this.group, g = e.getData(), m = e.getModel(["emphasis", "itemStyle"]).getItemStyle(), y = e.getModel(["blur", "itemStyle"]).getItemStyle(), b = e.getModel(["select", "itemStyle"]).getItemStyle(), C = e.get(["itemStyle", "borderRadius"]), w = xn(e), _ = e.getModel("emphasis"), x = _.get("focus"), I = _.get("blurScope"), D = _.get("disabled"), T = l ? [g.mapDimension("x"), g.mapDimension("y"), g.mapDimension("value")] : [g.mapDimension("time"), g.mapDimension("value")], A = i; A < a; A++) {
        var M = void 0, R = g.getItemVisual(A, "style");
        if (l) {
          var E = g.get(T[0], A), k = g.get(T[1], A);
          if (isNaN(g.get(T[2], A)) || isNaN(E) || isNaN(k) || E < d[0] || E > d[1] || k < f[0] || k > f[1])
            continue;
          var P = s.dataToPoint([E, k]);
          M = new xt({
            shape: {
              x: P[0] - u / 2,
              y: P[1] - c / 2,
              width: u,
              height: c
            },
            style: R
          });
        } else {
          if (isNaN(g.get(T[1], A)))
            continue;
          M = new xt({
            z2: 1,
            shape: s.dataToRect([g.get(T[0], A)]).contentShape,
            style: R
          });
        }
        if (g.hasItemOption) {
          var N = g.getItemModel(A), O = N.getModel("emphasis");
          m = O.getModel("itemStyle").getItemStyle(), y = N.getModel(["blur", "itemStyle"]).getItemStyle(), b = N.getModel(["select", "itemStyle"]).getItemStyle(), C = N.get(["itemStyle", "borderRadius"]), x = O.get("focus"), I = O.get("blurScope"), D = O.get("disabled"), w = xn(N);
        }
        M.shape.r = C;
        var W = e.getRawValue(A), V = "-";
        W && W[2] != null && (V = W[2] + ""), Xn(M, w, {
          labelFetcher: e,
          labelDataIndex: A,
          defaultOpacity: R.opacity,
          defaultText: V
        }), M.ensureState("emphasis").style = m, M.ensureState("blur").style = y, M.ensureState("select").style = b, Vr(M, x, I, D), M.incremental = o, o && (M.states.emphasis.hoverLayer = !0), v.add(M), g.setItemGraphicEl(A, M), this._progressiveEls && this._progressiveEls.push(M);
      }
    }, r.prototype._renderOnGeo = function(e, n, i, a) {
      var o = i.targetVisuals.inRange, s = i.targetVisuals.outOfRange, l = n.getData(), u = this._hmLayer || this._hmLayer || new Sle();
      u.blurSize = n.get("blurSize"), u.pointSize = n.get("pointSize"), u.minOpacity = n.get("minOpacity"), u.maxOpacity = n.get("maxOpacity");
      var c = e.getViewRect().clone(), d = e.getRoamTransform();
      c.applyTransform(d);
      var f = Math.max(c.x, 0), h = Math.max(c.y, 0), p = Math.min(c.width + c.x, a.getWidth()), v = Math.min(c.height + c.y, a.getHeight()), g = p - f, m = v - h, y = [l.mapDimension("lng"), l.mapDimension("lat"), l.mapDimension("value")], b = l.mapArray(y, function(x, I, D) {
        var T = e.dataToPoint([x, I]);
        return T[0] -= f, T[1] -= h, T.push(D), T;
      }), C = i.getExtent(), w = i.type === "visualMap.continuous" ? Ale(C, i.option.range) : Ile(C, i.getPieceList(), i.option.selected);
      u.update(b, g, m, o.color.getNormalizer(), {
        inRange: o.color.getColorMapper(),
        outOfRange: s.color.getColorMapper()
      }, w);
      var _ = new An({
        style: {
          width: g,
          height: m,
          x: f,
          y: h,
          image: u.canvas
        },
        silent: !0
      });
      this.group.add(_);
    }, r.type = "heatmap", r;
  }(Yt)
), Tle = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.getInitialData = function(e, n) {
      return os(null, this, {
        generateCoord: "value"
      });
    }, r.prototype.preventIncremental = function() {
      var e = ed.get(this.get("coordinateSystem"));
      if (e && e.dimensions)
        return e.dimensions[0] === "lng" && e.dimensions[1] === "lat";
    }, r.type = "series.heatmap", r.dependencies = ["grid", "geo", "calendar"], r.defaultOption = {
      coordinateSystem: "cartesian2d",
      // zlevel: 0,
      z: 2,
      // Cartesian coordinate system
      // xAxisIndex: 0,
      // yAxisIndex: 0,
      // Geo coordinate system
      geoIndex: 0,
      blurSize: 30,
      pointSize: 20,
      maxOpacity: 1,
      minOpacity: 0,
      select: {
        itemStyle: {
          borderColor: "#212121"
        }
      }
    }, r;
  }(tr)
);
function Mle(t) {
  t.registerChartView(Dle), t.registerSeriesModel(Tle);
}
var Rle = ["itemStyle", "borderWidth"], AT = [{
  xy: "x",
  wh: "width",
  index: 0,
  posDesc: ["left", "right"]
}, {
  xy: "y",
  wh: "height",
  index: 1,
  posDesc: ["top", "bottom"]
}], w3 = new is(), Lle = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.render = function(e, n, i) {
      var a = this.group, o = e.getData(), s = this._data, l = e.coordinateSystem, u = l.getBaseAxis(), c = u.isHorizontal(), d = l.master.getRect(), f = {
        ecSize: {
          width: i.getWidth(),
          height: i.getHeight()
        },
        seriesModel: e,
        coordSys: l,
        coordSysExtent: [[d.x, d.x + d.width], [d.y, d.y + d.height]],
        isHorizontal: c,
        valueDim: AT[+c],
        categoryDim: AT[1 - +c]
      };
      o.diff(s).add(function(p) {
        if (o.hasValue(p)) {
          var v = TT(o, p), g = DT(o, p, v, f), m = MT(o, f, g);
          o.setItemGraphicEl(p, m), a.add(m), LT(m, f, g);
        }
      }).update(function(p, v) {
        var g = s.getItemGraphicEl(v);
        if (!o.hasValue(p)) {
          a.remove(g);
          return;
        }
        var m = TT(o, p), y = DT(o, p, m, f), b = hF(o, y);
        g && b !== g.__pictorialShapeStr && (a.remove(g), o.setItemGraphicEl(p, null), g = null), g ? Gle(g, f, y) : g = MT(o, f, y, !0), o.setItemGraphicEl(p, g), g.__pictorialSymbolMeta = y, a.add(g), LT(g, f, y);
      }).remove(function(p) {
        var v = s.getItemGraphicEl(p);
        v && RT(s, p, v.__pictorialSymbolMeta.animationModel, v);
      }).execute();
      var h = e.get("clip", !0) ? xg(e.coordinateSystem, !1, e) : null;
      return h ? a.setClipPath(h) : a.removeClipPath(), this._data = o, this.group;
    }, r.prototype.remove = function(e, n) {
      var i = this.group, a = this._data;
      e.get("animation") ? a && a.eachItemGraphicEl(function(o) {
        RT(a, Ze(o).dataIndex, e, o);
      }) : i.removeAll();
    }, r.type = "pictorialBar", r;
  }(Yt)
);
function DT(t, r, e, n) {
  var i = t.getItemLayout(r), a = e.get("symbolRepeat"), o = e.get("symbolClip"), s = e.get("symbolPosition") || "start", l = e.get("symbolRotate"), u = (l || 0) * Math.PI / 180 || 0, c = e.get("symbolPatternSize") || 2, d = e.isAnimationEnabled(), f = {
    dataIndex: r,
    layout: i,
    itemModel: e,
    symbolType: t.getItemVisual(r, "symbol") || "circle",
    style: t.getItemVisual(r, "style"),
    symbolClip: o,
    symbolRepeat: a,
    symbolRepeatDirection: e.get("symbolRepeatDirection"),
    symbolPatternSize: c,
    rotation: u,
    animationModel: d ? e : null,
    hoverScale: d && e.get(["emphasis", "scale"]),
    z2: e.getShallow("z", !0) || 0
  };
  Ele(e, a, i, n, f), kle(t, r, i, a, o, f.boundingLength, f.pxSign, c, n, f), Ple(e, f.symbolScale, u, n, f);
  var h = f.symbolSize, p = td(e.get("symbolOffset"), h);
  return Nle(e, h, i, a, o, p, s, f.valueLineWidth, f.boundingLength, f.repeatCutLength, n, f), f;
}
function Ele(t, r, e, n, i) {
  var a = n.valueDim, o = t.get("symbolBoundingData"), s = n.coordSys.getOtherAxis(n.coordSys.getBaseAxis()), l = s.toGlobalCoord(s.dataToCoord(0)), u = 1 - +(e[a.wh] <= 0), c;
  if (ue(o)) {
    var d = [_3(s, o[0]) - l, _3(s, o[1]) - l];
    d[1] < d[0] && d.reverse(), c = d[u];
  } else o != null ? c = _3(s, o) - l : r ? c = n.coordSysExtent[a.index][u] - l : c = e[a.wh];
  i.boundingLength = c, r && (i.repeatCutLength = e[a.wh]), i.pxSign = c > 0 ? 1 : -1;
}
function _3(t, r) {
  return t.toGlobalCoord(t.dataToCoord(t.scale.parse(r)));
}
function kle(t, r, e, n, i, a, o, s, l, u) {
  var c = l.valueDim, d = l.categoryDim, f = Math.abs(e[d.wh]), h = t.getItemVisual(r, "symbolSize"), p;
  ue(h) ? p = h.slice() : h == null ? p = ["100%", "100%"] : p = [h, h], p[d.index] = he(p[d.index], f), p[c.index] = he(p[c.index], n ? f : Math.abs(a)), u.symbolSize = p;
  var v = u.symbolScale = [p[0] / s, p[1] / s];
  v[c.index] *= (l.isHorizontal ? -1 : 1) * o;
}
function Ple(t, r, e, n, i) {
  var a = t.get(Rle) || 0;
  a && (w3.attr({
    scaleX: r[0],
    scaleY: r[1],
    rotation: e
  }), w3.updateTransform(), a /= w3.getLineScale(), a *= r[n.valueDim.index]), i.valueLineWidth = a || 0;
}
function Nle(t, r, e, n, i, a, o, s, l, u, c, d) {
  var f = c.categoryDim, h = c.valueDim, p = d.pxSign, v = Math.max(r[h.index] + s, 0), g = v;
  if (n) {
    var m = Math.abs(l), y = Qr(t.get("symbolMargin"), "15%") + "", b = !1;
    y.lastIndexOf("!") === y.length - 1 && (b = !0, y = y.slice(0, y.length - 1));
    var C = he(y, r[h.index]), w = Math.max(v + C * 2, 0), _ = b ? 0 : C * 2, x = r2(n), I = x ? n : ET((m + _) / w), D = m - I * v;
    C = D / 2 / (b ? I : Math.max(I - 1, 1)), w = v + C * 2, _ = b ? 0 : C * 2, !x && n !== "fixed" && (I = u ? ET((Math.abs(u) + _) / w) : 0), g = I * w - _, d.repeatTimes = I, d.symbolMargin = C;
  }
  var T = p * (g / 2), A = d.pathPosition = [];
  A[f.index] = e[f.wh] / 2, A[h.index] = o === "start" ? T : o === "end" ? l - T : l / 2, a && (A[0] += a[0], A[1] += a[1]);
  var M = d.bundlePosition = [];
  M[f.index] = e[f.xy], M[h.index] = e[h.xy];
  var R = d.barRectShape = ae({}, e);
  R[h.wh] = p * Math.max(Math.abs(e[h.wh]), Math.abs(A[h.index] + T)), R[f.wh] = e[f.wh];
  var E = d.clipShape = {};
  E[f.xy] = -e[f.xy], E[f.wh] = c.ecSize[f.wh], E[h.xy] = 0, E[h.wh] = e[h.wh];
}
function lF(t) {
  var r = t.symbolPatternSize, e = en(
    // Consider texture img, make a big size.
    t.symbolType,
    -r / 2,
    -r / 2,
    r,
    r
  );
  return e.attr({
    culling: !0
  }), e.type !== "image" && e.setStyle({
    strokeNoScale: !0
  }), e;
}
function uF(t, r, e, n) {
  var i = t.__pictorialBundle, a = e.symbolSize, o = e.valueLineWidth, s = e.pathPosition, l = r.valueDim, u = e.repeatTimes || 0, c = 0, d = a[r.valueDim.index] + o + e.symbolMargin * 2;
  for (c_(t, function(v) {
    v.__pictorialAnimationIndex = c, v.__pictorialRepeatTimes = u, c < u ? mf(v, null, p(c), e, n) : mf(v, null, {
      scaleX: 0,
      scaleY: 0
    }, e, n, function() {
      i.remove(v);
    }), c++;
  }); c < u; c++) {
    var f = lF(e);
    f.__pictorialAnimationIndex = c, f.__pictorialRepeatTimes = u, i.add(f);
    var h = p(c);
    mf(f, {
      x: h.x,
      y: h.y,
      scaleX: 0,
      scaleY: 0
    }, {
      scaleX: h.scaleX,
      scaleY: h.scaleY,
      rotation: h.rotation
    }, e, n);
  }
  function p(v) {
    var g = s.slice(), m = e.pxSign, y = v;
    return (e.symbolRepeatDirection === "start" ? m > 0 : m < 0) && (y = u - 1 - v), g[l.index] = d * (y - u / 2 + 0.5) + s[l.index], {
      x: g[0],
      y: g[1],
      scaleX: e.symbolScale[0],
      scaleY: e.symbolScale[1],
      rotation: e.rotation
    };
  }
}
function cF(t, r, e, n) {
  var i = t.__pictorialBundle, a = t.__pictorialMainPath;
  a ? mf(a, null, {
    x: e.pathPosition[0],
    y: e.pathPosition[1],
    scaleX: e.symbolScale[0],
    scaleY: e.symbolScale[1],
    rotation: e.rotation
  }, e, n) : (a = t.__pictorialMainPath = lF(e), i.add(a), mf(a, {
    x: e.pathPosition[0],
    y: e.pathPosition[1],
    scaleX: 0,
    scaleY: 0,
    rotation: e.rotation
  }, {
    scaleX: e.symbolScale[0],
    scaleY: e.symbolScale[1]
  }, e, n));
}
function dF(t, r, e) {
  var n = ae({}, r.barRectShape), i = t.__pictorialBarRect;
  i ? mf(i, null, {
    shape: n
  }, r, e) : (i = t.__pictorialBarRect = new xt({
    z2: 2,
    shape: n,
    silent: !0,
    style: {
      stroke: "transparent",
      fill: "transparent",
      lineWidth: 0
    }
  }), i.disableMorphing = !0, t.add(i));
}
function fF(t, r, e, n) {
  if (e.symbolClip) {
    var i = t.__pictorialClipPath, a = ae({}, e.clipShape), o = r.valueDim, s = e.animationModel, l = e.dataIndex;
    if (i)
      kt(i, {
        shape: a
      }, s, l);
    else {
      a[o.wh] = 0, i = new xt({
        shape: a
      }), t.__pictorialBundle.setClipPath(i), t.__pictorialClipPath = i;
      var u = {};
      u[o.wh] = e.clipShape[o.wh], qc[n ? "updateProps" : "initProps"](i, {
        shape: u
      }, s, l);
    }
  }
}
function TT(t, r) {
  var e = t.getItemModel(r);
  return e.getAnimationDelayParams = Ole, e.isAnimationEnabled = Vle, e;
}
function Ole(t) {
  return {
    index: t.__pictorialAnimationIndex,
    count: t.__pictorialRepeatTimes
  };
}
function Vle() {
  return this.parentModel.isAnimationEnabled() && !!this.getShallow("animation");
}
function MT(t, r, e, n) {
  var i = new ze(), a = new ze();
  return i.add(a), i.__pictorialBundle = a, a.x = e.bundlePosition[0], a.y = e.bundlePosition[1], e.symbolRepeat ? uF(i, r, e) : cF(i, r, e), dF(i, e, n), fF(i, r, e, n), i.__pictorialShapeStr = hF(t, e), i.__pictorialSymbolMeta = e, i;
}
function Gle(t, r, e) {
  var n = e.animationModel, i = e.dataIndex, a = t.__pictorialBundle;
  kt(a, {
    x: e.bundlePosition[0],
    y: e.bundlePosition[1]
  }, n, i), e.symbolRepeat ? uF(t, r, e, !0) : cF(t, r, e, !0), dF(t, e, !0), fF(t, r, e, !0);
}
function RT(t, r, e, n) {
  var i = n.__pictorialBarRect;
  i && i.removeTextContent();
  var a = [];
  c_(n, function(o) {
    a.push(o);
  }), n.__pictorialMainPath && a.push(n.__pictorialMainPath), n.__pictorialClipPath && (e = null), L(a, function(o) {
    tu(o, {
      scaleX: 0,
      scaleY: 0
    }, e, r, function() {
      n.parent && n.parent.remove(n);
    });
  }), t.setItemGraphicEl(r, null);
}
function hF(t, r) {
  return [t.getItemVisual(r.dataIndex, "symbol") || "none", !!r.symbolRepeat, !!r.symbolClip].join(":");
}
function c_(t, r, e) {
  L(t.__pictorialBundle.children(), function(n) {
    n !== t.__pictorialBarRect && r.call(e, n);
  });
}
function mf(t, r, e, n, i, a) {
  r && t.attr(r), n.symbolClip && !i ? e && t.attr(e) : e && qc[i ? "updateProps" : "initProps"](t, e, n.animationModel, n.dataIndex, a);
}
function LT(t, r, e) {
  var n = e.dataIndex, i = e.itemModel, a = i.getModel("emphasis"), o = a.getModel("itemStyle").getItemStyle(), s = i.getModel(["blur", "itemStyle"]).getItemStyle(), l = i.getModel(["select", "itemStyle"]).getItemStyle(), u = i.getShallow("cursor"), c = a.get("focus"), d = a.get("blurScope"), f = a.get("scale");
  c_(t, function(v) {
    if (v instanceof An) {
      var g = v.style;
      v.useStyle(ae({
        // TODO other properties like dx, dy ?
        image: g.image,
        x: g.x,
        y: g.y,
        width: g.width,
        height: g.height
      }, e.style));
    } else
      v.useStyle(e.style);
    var m = v.ensureState("emphasis");
    m.style = o, f && (m.scaleX = v.scaleX * 1.1, m.scaleY = v.scaleY * 1.1), v.ensureState("blur").style = s, v.ensureState("select").style = l, u && (v.cursor = u), v.z2 = e.z2;
  });
  var h = r.valueDim.posDesc[+(e.boundingLength > 0)], p = t.__pictorialBarRect;
  p.ignoreClip = !0, Xn(p, xn(i), {
    labelFetcher: r.seriesModel,
    labelDataIndex: n,
    defaultText: Ef(r.seriesModel.getData(), n),
    inheritColor: e.style.fill,
    defaultOpacity: e.style.opacity,
    defaultOutsidePosition: h
  }), Vr(t, c, d, a.get("disabled"));
}
function ET(t) {
  var r = Math.round(t);
  return Math.abs(t - r) < 1e-4 ? r : Math.ceil(t);
}
var Ble = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e.hasSymbolVisual = !0, e.defaultSymbol = "roundRect", e;
    }
    return r.prototype.getInitialData = function(e) {
      return e.stack = null, t.prototype.getInitialData.apply(this, arguments);
    }, r.type = "series.pictorialBar", r.dependencies = ["grid"], r.defaultOption = vu(Lv.defaultOption, {
      symbol: "circle",
      symbolSize: null,
      symbolRotate: null,
      symbolPosition: null,
      symbolOffset: null,
      symbolMargin: null,
      symbolRepeat: !1,
      symbolRepeatDirection: "end",
      symbolClip: !1,
      symbolBoundingData: null,
      symbolPatternSize: 400,
      barGap: "-100%",
      // Pictorial bar do not clip by default because in many cases
      // xAxis and yAxis are not displayed and it's expected not to clip
      clip: !1,
      // z can be set in data item, which is z2 actually.
      // Disable progressive
      progressive: 0,
      emphasis: {
        // By default pictorialBar do not hover scale. Hover scale is not suitable
        // for the case that both has foreground and background.
        scale: !1
      },
      select: {
        itemStyle: {
          borderColor: "#212121"
        }
      }
    }), r;
  }(Lv)
);
function Fle(t) {
  t.registerChartView(Lle), t.registerSeriesModel(Ble), t.registerLayout(t.PRIORITY.VISUAL.LAYOUT, Ye(JV, "pictorialBar")), t.registerLayout(t.PRIORITY.VISUAL.PROGRESSIVE_LAYOUT, KV("pictorialBar"));
}
var Hle = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e._layers = [], e;
    }
    return r.prototype.render = function(e, n, i) {
      var a = e.getData(), o = this, s = this.group, l = e.getLayerSeries(), u = a.getLayout("layoutInfo"), c = u.rect, d = u.boundaryGap;
      s.x = 0, s.y = c.y + d[0];
      function f(g) {
        return g.name;
      }
      var h = new Us(this._layersSeries || [], l, f, f), p = [];
      h.add(ye(v, this, "add")).update(ye(v, this, "update")).remove(ye(v, this, "remove")).execute();
      function v(g, m, y) {
        var b = o._layers;
        if (g === "remove") {
          s.remove(b[m]);
          return;
        }
        for (var C = [], w = [], _, x = l[m].indices, I = 0; I < x.length; I++) {
          var D = a.getItemLayout(x[I]), T = D.x, A = D.y0, M = D.y;
          C.push(T, A), w.push(T, A + M), _ = a.getItemVisual(x[I], "style");
        }
        var R, E = a.getItemLayout(x[0]), k = e.getModel("label"), P = k.get("margin"), N = e.getModel("emphasis");
        if (g === "add") {
          var O = p[m] = new ze();
          R = new BG({
            shape: {
              points: C,
              stackedOnPoints: w,
              smooth: 0.4,
              stackedOnSmooth: 0.4,
              smoothConstraint: !1
            },
            z2: 0
          }), O.add(R), s.add(O), e.isAnimationEnabled() && R.setClipPath(zle(R.getBoundingRect(), e, function() {
            R.removeClipPath();
          }));
        } else {
          var O = b[y];
          R = O.childAt(0), s.add(O), p[m] = O, kt(R, {
            shape: {
              points: C,
              stackedOnPoints: w
            }
          }, e), ro(R);
        }
        Xn(R, xn(e), {
          labelDataIndex: x[I - 1],
          defaultText: a.getName(x[I - 1]),
          inheritColor: _.fill
        }, {
          normal: {
            verticalAlign: "middle"
            // align: 'right'
          }
        }), R.setTextConfig({
          position: null,
          local: !0
        });
        var W = R.getTextContent();
        W && (W.x = E.x - P, W.y = E.y0 + E.y / 2), R.useStyle(_), a.setItemGraphicEl(m, R), Yn(R, e), Vr(R, N.get("focus"), N.get("blurScope"), N.get("disabled"));
      }
      this._layersSeries = l, this._layers = p;
    }, r.type = "themeRiver", r;
  }(Yt)
);
function zle(t, r, e) {
  var n = new xt({
    shape: {
      x: t.x - 10,
      y: t.y - 10,
      width: 0,
      height: t.height + 20
    }
  });
  return Cr(n, {
    shape: {
      x: t.x - 50,
      width: t.width + 100,
      height: t.height + 20
    }
  }, r, e), n;
}
var x3 = 2, Wle = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.init = function(e) {
      t.prototype.init.apply(this, arguments), this.legendVisualProvider = new Ag(ye(this.getData, this), ye(this.getRawData, this));
    }, r.prototype.fixData = function(e) {
      var n = e.length, i = {}, a = BC(e, function(f) {
        return i.hasOwnProperty(f[0] + "") || (i[f[0] + ""] = -1), f[2];
      }), o = [];
      a.buckets.each(function(f, h) {
        o.push({
          name: h,
          dataList: f
        });
      });
      for (var s = o.length, l = 0; l < s; ++l) {
        for (var u = o[l].name, c = 0; c < o[l].dataList.length; ++c) {
          var d = o[l].dataList[c][0] + "";
          i[d] = l;
        }
        for (var d in i)
          i.hasOwnProperty(d) && i[d] !== l && (i[d] = l, e[n] = [d, 0, u], n++);
      }
      return e;
    }, r.prototype.getInitialData = function(e, n) {
      for (var i = this.getReferringComponents("singleAxis", on).models[0], a = i.get("type"), o = Wt(e.data, function(p) {
        return p[2] !== void 0;
      }), s = this.fixData(o || []), l = [], u = this.nameMap = xe(), c = 0, d = 0; d < s.length; ++d)
        l.push(s[d][x3]), u.get(s[d][x3]) || (u.set(s[d][x3], c), c++);
      var f = hh(s, {
        coordDimensions: ["single"],
        dimensionsDefine: [{
          name: "time",
          type: Vm(a)
        }, {
          name: "value",
          type: "float"
        }, {
          name: "name",
          type: "ordinal"
        }],
        encodeDefine: {
          single: 0,
          value: 1,
          itemName: 2
        }
      }).dimensions, h = new ni(f, this);
      return h.initData(s), h;
    }, r.prototype.getLayerSeries = function() {
      for (var e = this.getData(), n = e.count(), i = [], a = 0; a < n; ++a)
        i[a] = a;
      var o = e.mapDimension("single"), s = BC(i, function(u) {
        return e.get("name", u);
      }), l = [];
      return s.buckets.each(function(u, c) {
        u.sort(function(d, f) {
          return e.get(o, d) - e.get(o, f);
        }), l.push({
          name: c,
          indices: u
        });
      }), l;
    }, r.prototype.getAxisTooltipData = function(e, n, i) {
      ue(e) || (e = e ? [e] : []);
      for (var a = this.getData(), o = this.getLayerSeries(), s = [], l = o.length, u, c = 0; c < l; ++c) {
        for (var d = Number.MAX_VALUE, f = -1, h = o[c].indices.length, p = 0; p < h; ++p) {
          var v = a.get(e[0], o[c].indices[p]), g = Math.abs(v - n);
          g <= d && (u = v, d = g, f = o[c].indices[p]);
        }
        s.push(f);
      }
      return {
        dataIndices: s,
        nestestValue: u
      };
    }, r.prototype.formatTooltip = function(e, n, i) {
      var a = this.getData(), o = a.getName(e), s = a.get(a.mapDimension("value"), e);
      return Sn("nameValue", {
        name: o,
        value: s
      });
    }, r.type = "series.themeRiver", r.dependencies = ["singleAxis"], r.defaultOption = {
      // zlevel: 0,
      z: 2,
      colorBy: "data",
      coordinateSystem: "singleAxis",
      // gap in axis's orthogonal orientation
      boundaryGap: ["10%", "10%"],
      // legendHoverLink: true,
      singleAxisIndex: 0,
      animationEasing: "linear",
      label: {
        margin: 4,
        show: !0,
        position: "left",
        fontSize: 11
      },
      emphasis: {
        label: {
          show: !0
        }
      }
    }, r;
  }(tr)
);
function Zle(t, r) {
  t.eachSeriesByType("themeRiver", function(e) {
    var n = e.getData(), i = e.coordinateSystem, a = {}, o = i.getRect();
    a.rect = o;
    var s = e.get("boundaryGap"), l = i.getAxis();
    if (a.boundaryGap = s, l.orient === "horizontal") {
      s[0] = he(s[0], o.height), s[1] = he(s[1], o.height);
      var u = o.height - s[0] - s[1];
      kT(n, e, u);
    } else {
      s[0] = he(s[0], o.width), s[1] = he(s[1], o.width);
      var c = o.width - s[0] - s[1];
      kT(n, e, c);
    }
    n.setLayout("layoutInfo", a);
  });
}
function kT(t, r, e) {
  if (t.count())
    for (var n = r.coordinateSystem, i = r.getLayerSeries(), a = t.mapDimension("single"), o = t.mapDimension("value"), s = ce(i, function(g) {
      return ce(g.indices, function(m) {
        var y = n.dataToPoint(t.get(a, m));
        return y[1] = t.get(o, m), y;
      });
    }), l = jle(s), u = l.y0, c = e / l.max, d = i.length, f = i[0].indices.length, h, p = 0; p < f; ++p) {
      h = u[p] * c, t.setItemLayout(i[0].indices[p], {
        layerIndex: 0,
        x: s[0][p][0],
        y0: h,
        y: s[0][p][1] * c
      });
      for (var v = 1; v < d; ++v)
        h += s[v - 1][p][1] * c, t.setItemLayout(i[v].indices[p], {
          layerIndex: v,
          x: s[v][p][0],
          y0: h,
          y: s[v][p][1] * c
        });
    }
}
function jle(t) {
  for (var r = t.length, e = t[0].length, n = [], i = [], a = 0, o = 0; o < e; ++o) {
    for (var s = 0, l = 0; l < r; ++l)
      s += t[l][o][1];
    s > a && (a = s), n.push(s);
  }
  for (var u = 0; u < e; ++u)
    i[u] = (a - n[u]) / 2;
  a = 0;
  for (var c = 0; c < e; ++c) {
    var d = n[c] + i[c];
    d > a && (a = d);
  }
  return {
    y0: i,
    max: a
  };
}
function Yle(t) {
  t.registerChartView(Hle), t.registerSeriesModel(Wle), t.registerLayout(Zle), t.registerProcessor(Ig("themeRiver"));
}
var Xle = 2, $le = 4, PT = (
  /** @class */
  function(t) {
    ee(r, t);
    function r(e, n, i, a) {
      var o = t.call(this) || this;
      o.z2 = Xle, o.textConfig = {
        inside: !0
      }, Ze(o).seriesIndex = n.seriesIndex;
      var s = new _t({
        z2: $le,
        silent: e.getModel().get(["label", "silent"])
      });
      return o.setTextContent(s), o.updateData(!0, e, n, i, a), o;
    }
    return r.prototype.updateData = function(e, n, i, a, o) {
      this.node = n, n.piece = this, i = i || this._seriesModel, a = a || this._ecModel;
      var s = this;
      Ze(s).dataIndex = n.dataIndex;
      var l = n.getModel(), u = l.getModel("emphasis"), c = n.getLayout(), d = ae({}, c);
      d.label = null;
      var f = n.getVisual("style");
      f.lineJoin = "bevel";
      var h = n.getVisual("decal");
      h && (f.decal = Lf(h, o));
      var p = gc(l.getModel("itemStyle"), d, !0);
      ae(d, p), L(xi, function(y) {
        var b = s.ensureState(y), C = l.getModel([y, "itemStyle"]);
        b.style = C.getItemStyle();
        var w = gc(C, d);
        w && (b.shape = w);
      }), e ? (s.setShape(d), s.shape.r = c.r0, Cr(s, {
        shape: {
          r: c.r
        }
      }, i, n.dataIndex)) : (kt(s, {
        shape: d
      }, i), ro(s)), s.useStyle(f), this._updateLabel(i);
      var v = l.getShallow("cursor");
      v && s.attr("cursor", v), this._seriesModel = i || this._seriesModel, this._ecModel = a || this._ecModel;
      var g = u.get("focus"), m = g === "ancestor" ? n.getAncestorsIndices() : g === "descendant" ? n.getDescendantIndices() : g;
      Vr(this, m, u.get("blurScope"), u.get("disabled"));
    }, r.prototype._updateLabel = function(e) {
      var n = this, i = this.node.getModel(), a = i.getModel("label"), o = this.node.getLayout(), s = o.endAngle - o.startAngle, l = (o.startAngle + o.endAngle) / 2, u = Math.cos(l), c = Math.sin(l), d = this, f = d.getTextContent(), h = this.node.dataIndex, p = a.get("minAngle") / 180 * Math.PI, v = a.get("show") && !(p != null && Math.abs(s) < p);
      f.ignore = !v, L(Cv, function(m) {
        var y = m === "normal" ? i.getModel("label") : i.getModel([m, "label"]), b = m === "normal", C = b ? f : f.ensureState(m), w = e.getFormattedLabel(h, m);
        b && (w = w || n.node.name), C.style = fr(y, {}, null, m !== "normal", !0), w && (C.style.text = w);
        var _ = y.get("show");
        _ != null && !b && (C.ignore = !_);
        var x = g(y, "position"), I = b ? d : d.states[m], D = I.style.fill;
        I.textConfig = {
          outsideFill: y.get("color") === "inherit" ? D : null,
          inside: x !== "outside"
        };
        var T, A = g(y, "distance") || 0, M = g(y, "align"), R = g(y, "rotate"), E = Math.PI * 0.5, k = Math.PI * 1.5, P = Ji(R === "tangential" ? Math.PI / 2 - l : l), N = P > E && !Af(P - E) && P < k;
        x === "outside" ? (T = o.r + A, M = N ? "right" : "left") : !M || M === "center" ? (s === 2 * Math.PI && o.r0 === 0 ? T = 0 : T = (o.r + o.r0) / 2, M = "center") : M === "left" ? (T = o.r0 + A, M = N ? "right" : "left") : M === "right" && (T = o.r - A, M = N ? "left" : "right"), C.style.align = M, C.style.verticalAlign = g(y, "verticalAlign") || "middle", C.x = T * u + o.cx, C.y = T * c + o.cy;
        var O = 0;
        R === "radial" ? O = Ji(-l) + (N ? Math.PI : 0) : R === "tangential" ? O = Ji(Math.PI / 2 - l) + (N ? Math.PI : 0) : Mt(R) && (O = R * Math.PI / 180), C.rotation = Ji(O);
      });
      function g(m, y) {
        var b = m.get(y);
        return b ?? a.get(y);
      }
      f.dirtyStyle();
    }, r;
  }(oi)
), H9 = "sunburstRootToNode", NT = "sunburstHighlight", Ule = "sunburstUnhighlight";
function Jle(t) {
  t.registerAction({
    type: H9,
    update: "updateView"
  }, function(r, e) {
    e.eachComponent({
      mainType: "series",
      subType: "sunburst",
      query: r
    }, n);
    function n(i, a) {
      var o = kv(r, [H9], i);
      if (o) {
        var s = i.getViewRoot();
        s && (r.direction = Jw(s, o.node) ? "rollUp" : "drillDown"), i.resetViewRoot(o.node);
      }
    }
  }), t.registerAction({
    type: NT,
    update: "none"
  }, function(r, e, n) {
    r = ae({}, r), e.eachComponent({
      mainType: "series",
      subType: "sunburst",
      query: r
    }, i);
    function i(a) {
      var o = kv(r, [NT], a);
      o && (r.dataIndex = o.node.dataIndex);
    }
    process.env.NODE_ENV !== "production" && qr("sunburstHighlight", "highlight"), n.dispatchAction(ae(r, {
      type: "highlight"
    }));
  }), t.registerAction({
    type: Ule,
    update: "updateView"
  }, function(r, e, n) {
    r = ae({}, r), process.env.NODE_ENV !== "production" && qr("sunburstUnhighlight", "downplay"), n.dispatchAction(ae(r, {
      type: "downplay"
    }));
  });
}
var Kle = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.render = function(e, n, i, a) {
      var o = this;
      this.seriesModel = e, this.api = i, this.ecModel = n;
      var s = e.getData(), l = s.tree.root, u = e.getViewRoot(), c = this.group, d = e.get("renderLabelForZeroData"), f = [];
      u.eachNode(function(y) {
        f.push(y);
      });
      var h = this._oldChildren || [];
      p(f, h), m(l, u), this._initEvents(), this._oldChildren = f;
      function p(y, b) {
        if (y.length === 0 && b.length === 0)
          return;
        new Us(b, y, C, C).add(w).update(w).remove(Ye(w, null)).execute();
        function C(_) {
          return _.getId();
        }
        function w(_, x) {
          var I = _ == null ? null : y[_], D = x == null ? null : b[x];
          v(I, D);
        }
      }
      function v(y, b) {
        if (!d && y && !y.getValue() && (y = null), y !== l && b !== l) {
          if (b && b.piece)
            y ? (b.piece.updateData(!1, y, e, n, i), s.setItemGraphicEl(y.dataIndex, b.piece)) : g(b);
          else if (y) {
            var C = new PT(y, e, n, i);
            c.add(C), s.setItemGraphicEl(y.dataIndex, C);
          }
        }
      }
      function g(y) {
        y && y.piece && (c.remove(y.piece), y.piece = null);
      }
      function m(y, b) {
        b.depth > 0 ? (o.virtualPiece ? o.virtualPiece.updateData(!1, y, e, n, i) : (o.virtualPiece = new PT(y, e, n, i), c.add(o.virtualPiece)), b.piece.off("click"), o.virtualPiece.on("click", function(C) {
          o._rootToNode(b.parentNode);
        })) : o.virtualPiece && (c.remove(o.virtualPiece), o.virtualPiece = null);
      }
    }, r.prototype._initEvents = function() {
      var e = this;
      this.group.off("click"), this.group.on("click", function(n) {
        var i = !1, a = e.seriesModel.getViewRoot();
        a.eachNode(function(o) {
          if (!i && o.piece && o.piece === n.target) {
            var s = o.getModel().get("nodeClick");
            if (s === "rootToNode")
              e._rootToNode(o);
            else if (s === "link") {
              var l = o.getModel(), u = l.get("link");
              if (u) {
                var c = l.get("target", !0) || "_blank";
                Im(u, c);
              }
            }
            i = !0;
          }
        });
      });
    }, r.prototype._rootToNode = function(e) {
      e !== this.seriesModel.getViewRoot() && this.api.dispatchAction({
        type: H9,
        from: this.uid,
        seriesId: this.seriesModel.id,
        targetNode: e
      });
    }, r.prototype.containPoint = function(e, n) {
      var i = n.getData(), a = i.getItemLayout(0);
      if (a) {
        var o = e[0] - a.cx, s = e[1] - a.cy, l = Math.sqrt(o * o + s * s);
        return l <= a.r && l >= a.r0;
      }
    }, r.type = "sunburst", r;
  }(Yt)
), qle = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e.ignoreStyleOnData = !0, e;
    }
    return r.prototype.getInitialData = function(e, n) {
      var i = {
        name: e.name,
        children: e.data
      };
      pF(i);
      var a = this._levelModels = ce(e.levels || [], function(l) {
        return new Pt(l, this, n);
      }, this), o = Uw.createTree(i, this, s);
      function s(l) {
        l.wrapMethod("getItemModel", function(u, c) {
          var d = o.getNodeByDataIndex(c), f = a[d.depth];
          return f && (u.parentModel = f), u;
        });
      }
      return o.data;
    }, r.prototype.optionUpdated = function() {
      this.resetViewRoot();
    }, r.prototype.getDataParams = function(e) {
      var n = t.prototype.getDataParams.apply(this, arguments), i = this.getData().tree.getNodeByDataIndex(e);
      return n.treePathInfo = E2(i, this), n;
    }, r.prototype.getLevelModel = function(e) {
      return this._levelModels && this._levelModels[e.depth];
    }, r.prototype.getViewRoot = function() {
      return this._viewRoot;
    }, r.prototype.resetViewRoot = function(e) {
      e ? this._viewRoot = e : e = this._viewRoot;
      var n = this.getRawData().tree.root;
      (!e || e !== n && !n.contains(e)) && (this._viewRoot = n);
    }, r.prototype.enableAriaDecal = function() {
      bB(this);
    }, r.type = "series.sunburst", r.defaultOption = {
      // zlevel: 0,
      z: 2,
      // 默认全局居中
      center: ["50%", "50%"],
      radius: [0, "75%"],
      // 默认顺时针
      clockwise: !0,
      startAngle: 90,
      // 最小角度改为0
      minAngle: 0,
      // If still show when all data zero.
      stillShowZeroSum: !0,
      // 'rootToNode', 'link', or false
      nodeClick: "rootToNode",
      renderLabelForZeroData: !1,
      label: {
        // could be: 'radial', 'tangential', or 'none'
        rotate: "radial",
        show: !0,
        opacity: 1,
        // 'left' is for inner side of inside, and 'right' is for outer
        // side for inside
        align: "center",
        position: "inside",
        distance: 5,
        silent: !0
      },
      itemStyle: {
        borderWidth: 1,
        borderColor: "white",
        borderType: "solid",
        shadowBlur: 0,
        shadowColor: "rgba(0, 0, 0, 0.2)",
        shadowOffsetX: 0,
        shadowOffsetY: 0,
        opacity: 1
      },
      emphasis: {
        focus: "descendant"
      },
      blur: {
        itemStyle: {
          opacity: 0.2
        },
        label: {
          opacity: 0.1
        }
      },
      // Animation type can be expansion, scale.
      animationType: "expansion",
      animationDuration: 1e3,
      animationDurationUpdate: 500,
      data: [],
      /**
       * Sort order.
       *
       * Valid values: 'desc', 'asc', null, or callback function.
       * 'desc' and 'asc' for descend and ascendant order;
       * null for not sorting;
       * example of callback function:
       * function(nodeA, nodeB) {
       *     return nodeA.getValue() - nodeB.getValue();
       * }
       */
      sort: "desc"
    }, r;
  }(tr)
);
function pF(t) {
  var r = 0;
  L(t.children, function(n) {
    pF(n);
    var i = n.value;
    ue(i) && (i = i[0]), r += i;
  });
  var e = t.value;
  ue(e) && (e = e[0]), (e == null || isNaN(e)) && (e = r), e < 0 && (e = 0), ue(t.value) ? t.value[0] = e : t.value = e;
}
var OT = Math.PI / 180;
function Qle(t, r, e) {
  r.eachSeriesByType(t, function(n) {
    var i = n.get("center"), a = n.get("radius");
    ue(a) || (a = [0, a]), ue(i) || (i = [i, i]);
    var o = e.getWidth(), s = e.getHeight(), l = Math.min(o, s), u = he(i[0], o), c = he(i[1], s), d = he(a[0], l / 2), f = he(a[1], l / 2), h = -n.get("startAngle") * OT, p = n.get("minAngle") * OT, v = n.getData().tree.root, g = n.getViewRoot(), m = g.depth, y = n.get("sort");
    y != null && vF(g, y);
    var b = 0;
    L(g.children, function(P) {
      !isNaN(P.getValue()) && b++;
    });
    var C = g.getValue(), w = Math.PI / (C || b) * 2, _ = g.depth > 0, x = g.height - (_ ? -1 : 1), I = (f - d) / (x || 1), D = n.get("clockwise"), T = n.get("stillShowZeroSum"), A = D ? 1 : -1, M = function(P, N) {
      if (P) {
        var O = N;
        if (P !== v) {
          var W = P.getValue(), V = C === 0 && T ? w : W * w;
          V < p && (V = p), O = N + A * V;
          var B = P.depth - m - (_ ? -1 : 1), Z = d + I * B, q = d + I * (B + 1), z = n.getLevelModel(P);
          if (z) {
            var U = z.get("r0", !0), J = z.get("r", !0), K = z.get("radius", !0);
            K != null && (U = K[0], J = K[1]), U != null && (Z = he(U, l / 2)), J != null && (q = he(J, l / 2));
          }
          P.setLayout({
            angle: V,
            startAngle: N,
            endAngle: O,
            clockwise: D,
            cx: u,
            cy: c,
            r0: Z,
            r: q
          });
        }
        if (P.children && P.children.length) {
          var j = 0;
          L(P.children, function(oe) {
            j += M(oe, N + j);
          });
        }
        return O - N;
      }
    };
    if (_) {
      var R = d, E = d + I, k = Math.PI * 2;
      v.setLayout({
        angle: k,
        startAngle: h,
        endAngle: h + k,
        clockwise: D,
        cx: u,
        cy: c,
        r0: R,
        r: E
      });
    }
    M(g, h);
  });
}
function vF(t, r) {
  var e = t.children || [];
  t.children = eue(e, r), e.length && L(t.children, function(n) {
    vF(n, r);
  });
}
function eue(t, r) {
  if (Ae(r)) {
    var e = ce(t, function(i, a) {
      var o = i.getValue();
      return {
        params: {
          depth: i.depth,
          height: i.height,
          dataIndex: i.dataIndex,
          getValue: function() {
            return o;
          }
        },
        index: a
      };
    });
    return e.sort(function(i, a) {
      return r(i.params, a.params);
    }), ce(e, function(i) {
      return t[i.index];
    });
  } else {
    var n = r === "asc";
    return t.sort(function(i, a) {
      var o = (i.getValue() - a.getValue()) * (n ? 1 : -1);
      return o === 0 ? (i.dataIndex - a.dataIndex) * (n ? -1 : 1) : o;
    });
  }
}
function tue(t) {
  var r = {};
  function e(n, i, a) {
    for (var o = n; o && o.depth > 1; )
      o = o.parentNode;
    var s = i.getColorFromPalette(o.name || o.dataIndex + "", r);
    return n.depth > 1 && pe(s) && (s = fm(s, (n.depth - 1) / (a - 1) * 0.5)), s;
  }
  t.eachSeriesByType("sunburst", function(n) {
    var i = n.getData(), a = i.tree;
    a.eachNode(function(o) {
      var s = o.getModel(), l = s.getModel("itemStyle").getItemStyle();
      l.fill || (l.fill = e(o, n, a.root.height));
      var u = i.ensureUniqueItemVisual(o.dataIndex, "style");
      ae(u, l);
    });
  });
}
function rue(t) {
  t.registerChartView(Kle), t.registerSeriesModel(qle), t.registerLayout(Ye(Qle, "sunburst")), t.registerProcessor(Ye(Ig, "sunburst")), t.registerVisual(tue), Jle(t);
}
var VT = {
  color: "fill",
  borderColor: "stroke"
}, nue = {
  symbol: 1,
  symbolSize: 1,
  symbolKeepAspect: 1,
  legendIcon: 1,
  visualMeta: 1,
  liftZ: 1,
  decal: 1
}, Vs = It(), iue = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.optionUpdated = function() {
      this.currentZLevel = this.get("zlevel", !0), this.currentZ = this.get("z", !0);
    }, r.prototype.getInitialData = function(e, n) {
      return os(null, this);
    }, r.prototype.getDataParams = function(e, n, i) {
      var a = t.prototype.getDataParams.call(this, e, n);
      return i && (a.info = Vs(i).info), a;
    }, r.type = "series.custom", r.dependencies = ["grid", "polar", "geo", "singleAxis", "calendar"], r.defaultOption = {
      coordinateSystem: "cartesian2d",
      // zlevel: 0,
      z: 2,
      legendHoverLink: !0,
      // Custom series will not clip by default.
      // Some case will use custom series to draw label
      // For example https://echarts.apache.org/examples/en/editor.html?c=custom-gantt-flight
      clip: !1
      // Cartesian coordinate system
      // xAxisIndex: 0,
      // yAxisIndex: 0,
      // Polar coordinate system
      // polarIndex: 0,
      // Geo coordinate system
      // geoIndex: 0,
    }, r;
  }(tr)
);
function aue(t, r) {
  return r = r || [0, 0], ce(["x", "y"], function(e, n) {
    var i = this.getAxis(e), a = r[n], o = t[n] / 2;
    return i.type === "category" ? i.getBandWidth() : Math.abs(i.dataToCoord(a - o) - i.dataToCoord(a + o));
  }, this);
}
function oue(t) {
  var r = t.master.getRect();
  return {
    coordSys: {
      // The name exposed to user is always 'cartesian2d' but not 'grid'.
      type: "cartesian2d",
      x: r.x,
      y: r.y,
      width: r.width,
      height: r.height
    },
    api: {
      coord: function(e) {
        return t.dataToPoint(e);
      },
      size: ye(aue, t)
    }
  };
}
function sue(t, r) {
  return r = r || [0, 0], ce([0, 1], function(e) {
    var n = r[e], i = t[e] / 2, a = [], o = [];
    return a[e] = n - i, o[e] = n + i, a[1 - e] = o[1 - e] = r[1 - e], Math.abs(this.dataToPoint(a)[e] - this.dataToPoint(o)[e]);
  }, this);
}
function lue(t) {
  var r = t.getBoundingRect();
  return {
    coordSys: {
      type: "geo",
      x: r.x,
      y: r.y,
      width: r.width,
      height: r.height,
      zoom: t.getZoom()
    },
    api: {
      coord: function(e) {
        return t.dataToPoint(e);
      },
      size: ye(sue, t)
    }
  };
}
function uue(t, r) {
  var e = this.getAxis(), n = r instanceof Array ? r[0] : r, i = (t instanceof Array ? t[0] : t) / 2;
  return e.type === "category" ? e.getBandWidth() : Math.abs(e.dataToCoord(n - i) - e.dataToCoord(n + i));
}
function cue(t) {
  var r = t.getRect();
  return {
    coordSys: {
      type: "singleAxis",
      x: r.x,
      y: r.y,
      width: r.width,
      height: r.height
    },
    api: {
      coord: function(e) {
        return t.dataToPoint(e);
      },
      size: ye(uue, t)
    }
  };
}
function due(t, r) {
  return r = r || [0, 0], ce(["Radius", "Angle"], function(e, n) {
    var i = "get" + e + "Axis", a = this[i](), o = r[n], s = t[n] / 2, l = a.type === "category" ? a.getBandWidth() : Math.abs(a.dataToCoord(o - s) - a.dataToCoord(o + s));
    return e === "Angle" && (l = l * Math.PI / 180), l;
  }, this);
}
function fue(t) {
  var r = t.getRadiusAxis(), e = t.getAngleAxis(), n = r.getExtent();
  return n[0] > n[1] && n.reverse(), {
    coordSys: {
      type: "polar",
      cx: t.cx,
      cy: t.cy,
      r: n[1],
      r0: n[0]
    },
    api: {
      coord: function(i) {
        var a = r.dataToRadius(i[0]), o = e.dataToAngle(i[1]), s = t.coordToPoint([a, o]);
        return s.push(a, o * Math.PI / 180), s;
      },
      size: ye(due, t)
    }
  };
}
function hue(t) {
  var r = t.getRect(), e = t.getRangeInfo();
  return {
    coordSys: {
      type: "calendar",
      x: r.x,
      y: r.y,
      width: r.width,
      height: r.height,
      cellWidth: t.getCellWidth(),
      cellHeight: t.getCellHeight(),
      rangeInfo: {
        start: e.start,
        end: e.end,
        weeks: e.weeks,
        dayCount: e.allDay
      }
    },
    api: {
      coord: function(n, i) {
        return t.dataToPoint(n, i);
      }
    }
  };
}
var GT = {};
function gF(t, r, e, n) {
  return t && (t.legacy || t.legacy !== !1 && !e && !n && r !== "tspan" && (r === "text" || be(t, "text")));
}
function mF(t, r, e) {
  var n = t, i, a, o;
  if (r === "text")
    o = n;
  else {
    o = {}, be(n, "text") && (o.text = n.text), be(n, "rich") && (o.rich = n.rich), be(n, "textFill") && (o.fill = n.textFill), be(n, "textStroke") && (o.stroke = n.textStroke), be(n, "fontFamily") && (o.fontFamily = n.fontFamily), be(n, "fontSize") && (o.fontSize = n.fontSize), be(n, "fontStyle") && (o.fontStyle = n.fontStyle), be(n, "fontWeight") && (o.fontWeight = n.fontWeight), a = {
      type: "text",
      style: o,
      // ec4 does not support rectText trigger.
      // And when text position is different in normal and emphasis
      // => hover text trigger emphasis;
      // => text position changed, leave mouse pointer immediately;
      // That might cause incorrect state.
      silent: !0
    }, i = {};
    var s = be(n, "textPosition");
    e ? i.position = s ? n.textPosition : "inside" : s && (i.position = n.textPosition), be(n, "textPosition") && (i.position = n.textPosition), be(n, "textOffset") && (i.offset = n.textOffset), be(n, "textRotation") && (i.rotation = n.textRotation), be(n, "textDistance") && (i.distance = n.textDistance);
  }
  return BT(o, t), L(o.rich, function(l) {
    BT(l, l);
  }), {
    textConfig: i,
    textContent: a
  };
}
function BT(t, r) {
  r && (r.font = r.textFont || r.font, be(r, "textStrokeWidth") && (t.lineWidth = r.textStrokeWidth), be(r, "textAlign") && (t.align = r.textAlign), be(r, "textVerticalAlign") && (t.verticalAlign = r.textVerticalAlign), be(r, "textLineHeight") && (t.lineHeight = r.textLineHeight), be(r, "textWidth") && (t.width = r.textWidth), be(r, "textHeight") && (t.height = r.textHeight), be(r, "textBackgroundColor") && (t.backgroundColor = r.textBackgroundColor), be(r, "textPadding") && (t.padding = r.textPadding), be(r, "textBorderColor") && (t.borderColor = r.textBorderColor), be(r, "textBorderWidth") && (t.borderWidth = r.textBorderWidth), be(r, "textBorderRadius") && (t.borderRadius = r.textBorderRadius), be(r, "textBoxShadowColor") && (t.shadowColor = r.textBoxShadowColor), be(r, "textBoxShadowBlur") && (t.shadowBlur = r.textBoxShadowBlur), be(r, "textBoxShadowOffsetX") && (t.shadowOffsetX = r.textBoxShadowOffsetX), be(r, "textBoxShadowOffsetY") && (t.shadowOffsetY = r.textBoxShadowOffsetY));
}
function FT(t, r, e) {
  var n = t;
  n.textPosition = n.textPosition || e.position || "inside", e.offset != null && (n.textOffset = e.offset), e.rotation != null && (n.textRotation = e.rotation), e.distance != null && (n.textDistance = e.distance);
  var i = n.textPosition.indexOf("inside") >= 0, a = t.fill || "#000";
  HT(n, r);
  var o = n.textFill == null;
  return i ? o && (n.textFill = e.insideFill || "#fff", !n.textStroke && e.insideStroke && (n.textStroke = e.insideStroke), !n.textStroke && (n.textStroke = a), n.textStrokeWidth == null && (n.textStrokeWidth = 2)) : (o && (n.textFill = t.fill || e.outsideFill || "#000"), !n.textStroke && e.outsideStroke && (n.textStroke = e.outsideStroke)), n.text = r.text, n.rich = r.rich, L(r.rich, function(s) {
    HT(s, s);
  }), n;
}
function HT(t, r) {
  r && (be(r, "fill") && (t.textFill = r.fill), be(r, "stroke") && (t.textStroke = r.fill), be(r, "lineWidth") && (t.textStrokeWidth = r.lineWidth), be(r, "font") && (t.font = r.font), be(r, "fontStyle") && (t.fontStyle = r.fontStyle), be(r, "fontWeight") && (t.fontWeight = r.fontWeight), be(r, "fontSize") && (t.fontSize = r.fontSize), be(r, "fontFamily") && (t.fontFamily = r.fontFamily), be(r, "align") && (t.textAlign = r.align), be(r, "verticalAlign") && (t.textVerticalAlign = r.verticalAlign), be(r, "lineHeight") && (t.textLineHeight = r.lineHeight), be(r, "width") && (t.textWidth = r.width), be(r, "height") && (t.textHeight = r.height), be(r, "backgroundColor") && (t.textBackgroundColor = r.backgroundColor), be(r, "padding") && (t.textPadding = r.padding), be(r, "borderColor") && (t.textBorderColor = r.borderColor), be(r, "borderWidth") && (t.textBorderWidth = r.borderWidth), be(r, "borderRadius") && (t.textBorderRadius = r.borderRadius), be(r, "shadowColor") && (t.textBoxShadowColor = r.shadowColor), be(r, "shadowBlur") && (t.textBoxShadowBlur = r.shadowBlur), be(r, "shadowOffsetX") && (t.textBoxShadowOffsetX = r.shadowOffsetX), be(r, "shadowOffsetY") && (t.textBoxShadowOffsetY = r.shadowOffsetY), be(r, "textShadowColor") && (t.textShadowColor = r.textShadowColor), be(r, "textShadowBlur") && (t.textShadowBlur = r.textShadowBlur), be(r, "textShadowOffsetX") && (t.textShadowOffsetX = r.textShadowOffsetX), be(r, "textShadowOffsetY") && (t.textShadowOffsetY = r.textShadowOffsetY));
}
function zT(t, r) {
  if (process.env.NODE_ENV !== "production") {
    var e = t + "^_^" + r;
    GT[e] || (console.warn('[ECharts] DEPRECATED: "' + t + '" has been deprecated. ' + r), GT[e] = !0);
  }
}
var yF = {
  position: ["x", "y"],
  scale: ["scaleX", "scaleY"],
  origin: ["originX", "originY"]
}, WT = yt(yF), Um = Ma(Ko, function(t, r) {
  return t[r] = 1, t;
}, {}), ZT = Ko.join(", "), Jm = ["", "style", "shape", "extra"], Nf = It();
function d_(t, r, e, n, i) {
  var a = t + "Animation", o = nh(t, n, i) || {}, s = Nf(r).userDuring;
  return o.duration > 0 && (o.during = s ? ye(yue, {
    el: r,
    userDuring: s
  }) : null, o.setToFinal = !0, o.scope = t), ae(o, e[a]), o;
}
function O0(t, r, e, n) {
  n = n || {};
  var i = n.dataIndex, a = n.isInit, o = n.clearStyle, s = e.isAnimationEnabled(), l = Nf(t), u = r.style;
  l.userDuring = r.during;
  var c = {}, d = {};
  if (Cue(t, r, d), YT("shape", r, d), YT("extra", r, d), !a && s && (bue(t, r, c), jT("shape", t, r, c), jT("extra", t, r, c), wue(t, r, u, c)), d.style = u, pue(t, d, o), gue(t, r), s)
    if (a) {
      var f = {};
      L(Jm, function(p) {
        var v = p ? r[p] : r;
        v && v.enterFrom && (p && (f[p] = f[p] || {}), ae(p ? f[p] : f, v.enterFrom));
      });
      var h = d_("enter", t, r, e, i);
      h.duration > 0 && t.animateFrom(f, h);
    } else
      vue(t, r, i || 0, e, c);
  bF(t, r), u ? t.dirty() : t.markRedraw();
}
function bF(t, r) {
  for (var e = Nf(t).leaveToProps, n = 0; n < Jm.length; n++) {
    var i = Jm[n], a = i ? r[i] : r;
    a && a.leaveTo && (e || (e = Nf(t).leaveToProps = {}), i && (e[i] = e[i] || {}), ae(i ? e[i] : e, a.leaveTo));
  }
}
function N2(t, r, e, n) {
  if (t) {
    var i = t.parent, a = Nf(t).leaveToProps;
    if (a) {
      var o = d_("update", t, r, e, 0);
      o.done = function() {
        i.remove(t);
      }, t.animateTo(a, o);
    } else
      i.remove(t);
  }
}
function Tc(t) {
  return t === "all";
}
function pue(t, r, e) {
  var n = r.style;
  if (!t.isGroup && n) {
    if (e) {
      t.useStyle({});
      for (var i = t.animators, a = 0; a < i.length; a++) {
        var o = i[a];
        o.targetName === "style" && o.changeTarget(t.style);
      }
    }
    t.setStyle(n);
  }
  r && (r.style = null, r && t.attr(r), r.style = n);
}
function vue(t, r, e, n, i) {
  if (i) {
    var a = d_("update", t, r, n, e);
    a.duration > 0 && t.animateFrom(i, a);
  }
}
function gue(t, r) {
  be(r, "silent") && (t.silent = r.silent), be(r, "ignore") && (t.ignore = r.ignore), t instanceof La && be(r, "invisible") && (t.invisible = r.invisible), t instanceof gt && be(r, "autoBatch") && (t.autoBatch = r.autoBatch);
}
var _o = {}, mue = {
  // Usually other props do not need to be changed in animation during.
  setTransform: function(t, r) {
    return process.env.NODE_ENV !== "production" && ke(be(Um, t), "Only " + ZT + " available in `setTransform`."), _o.el[t] = r, this;
  },
  getTransform: function(t) {
    return process.env.NODE_ENV !== "production" && ke(be(Um, t), "Only " + ZT + " available in `getTransform`."), _o.el[t];
  },
  setShape: function(t, r) {
    process.env.NODE_ENV !== "production" && Rd(t);
    var e = _o.el, n = e.shape || (e.shape = {});
    return n[t] = r, e.dirtyShape && e.dirtyShape(), this;
  },
  getShape: function(t) {
    process.env.NODE_ENV !== "production" && Rd(t);
    var r = _o.el.shape;
    if (r)
      return r[t];
  },
  setStyle: function(t, r) {
    process.env.NODE_ENV !== "production" && Rd(t);
    var e = _o.el, n = e.style;
    return n && (process.env.NODE_ENV !== "production" && ql(r) && Mr("style." + t + " must not be assigned with NaN."), n[t] = r, e.dirtyStyle && e.dirtyStyle()), this;
  },
  getStyle: function(t) {
    process.env.NODE_ENV !== "production" && Rd(t);
    var r = _o.el.style;
    if (r)
      return r[t];
  },
  setExtra: function(t, r) {
    process.env.NODE_ENV !== "production" && Rd(t);
    var e = _o.el.extra || (_o.el.extra = {});
    return e[t] = r, this;
  },
  getExtra: function(t) {
    process.env.NODE_ENV !== "production" && Rd(t);
    var r = _o.el.extra;
    if (r)
      return r[t];
  }
};
function Rd(t) {
  if (process.env.NODE_ENV !== "production" && (t === "transition" || t === "enterFrom" || t === "leaveTo"))
    throw new Error('key must not be "' + t + '"');
}
function yue() {
  var t = this, r = t.el;
  if (r) {
    var e = Nf(r).userDuring, n = t.userDuring;
    if (e !== n) {
      t.el = t.userDuring = null;
      return;
    }
    _o.el = r, n(mue);
  }
}
function jT(t, r, e, n) {
  var i = e[t];
  if (i) {
    var a = r[t], o;
    if (a) {
      var s = e.transition, l = i.transition;
      if (l)
        if (!o && (o = n[t] = {}), Tc(l))
          ae(o, a);
        else
          for (var u = Qt(l), c = 0; c < u.length; c++) {
            var d = u[c], f = a[d];
            o[d] = f;
          }
      else if (Tc(s) || nt(s, t) >= 0) {
        !o && (o = n[t] = {});
        for (var h = yt(a), c = 0; c < h.length; c++) {
          var d = h[c], f = a[d];
          _ue(i[d], f) && (o[d] = f);
        }
      }
    }
  }
}
function YT(t, r, e) {
  var n = r[t];
  if (n)
    for (var i = e[t] = {}, a = yt(n), o = 0; o < a.length; o++) {
      var s = a[o];
      i[s] = Xp(n[s]);
    }
}
function bue(t, r, e) {
  for (var n = r.transition, i = Tc(n) ? Ko : Qt(n || []), a = 0; a < i.length; a++) {
    var o = i[a];
    if (!(o === "style" || o === "shape" || o === "extra")) {
      var s = t[o];
      process.env.NODE_ENV !== "production" && CF(o, "el.transition"), e[o] = s;
    }
  }
}
function Cue(t, r, e) {
  for (var n = 0; n < WT.length; n++) {
    var i = WT[n], a = yF[i], o = r[i];
    o && (e[a[0]] = o[0], e[a[1]] = o[1]);
  }
  for (var n = 0; n < Ko.length; n++) {
    var s = Ko[n];
    r[s] != null && (e[s] = r[s]);
  }
}
function wue(t, r, e, n) {
  if (e) {
    var i = t.style, a;
    if (i) {
      var o = e.transition, s = r.transition;
      if (o && !Tc(o)) {
        var l = Qt(o);
        !a && (a = n.style = {});
        for (var u = 0; u < l.length; u++) {
          var c = l[u], d = i[c];
          a[c] = d;
        }
      } else if (t.getAnimationStyleProps && (Tc(s) || Tc(o) || nt(s, "style") >= 0)) {
        var f = t.getAnimationStyleProps(), h = f ? f.style : null;
        if (h) {
          !a && (a = n.style = {});
          for (var p = yt(e), u = 0; u < p.length; u++) {
            var c = p[u];
            if (h[c]) {
              var d = i[c];
              a[c] = d;
            }
          }
        }
      }
    }
  }
}
function _ue(t, r) {
  return Zn(t) ? t !== r : t != null && isFinite(t);
}
var CF;
process.env.NODE_ENV !== "production" && (CF = function(t, r) {
  be(Um, t) || Mr("Prop `" + t + "` is not a permitted in `" + r + "`. Only `" + yt(Um).join("`, `") + "` are permitted.");
});
var wF = It(), xue = ["percent", "easing", "shape", "style", "extra"];
function _F(t) {
  t.stopAnimation("keyframe"), t.attr(wF(t));
}
function Km(t, r, e) {
  if (!(!e.isAnimationEnabled() || !r)) {
    if (ue(r)) {
      L(r, function(s) {
        Km(t, s, e);
      });
      return;
    }
    var n = r.keyframes, i = r.duration;
    if (e && i == null) {
      var a = nh("enter", e, 0);
      i = a && a.duration;
    }
    if (!(!n || !i)) {
      var o = wF(t);
      L(Jm, function(s) {
        if (!(s && !t[s])) {
          var l, u = !1;
          n.sort(function(c, d) {
            return c.percent - d.percent;
          }), L(n, function(c) {
            var d = t.animators, f = s ? c[s] : c;
            if (process.env.NODE_ENV !== "production" && c.percent >= 1 && (u = !0), !!f) {
              var h = yt(f);
              if (s || (h = Wt(h, function(g) {
                return nt(xue, g) < 0;
              })), !!h.length) {
                l || (l = t.animate(s, r.loop, !0), l.scope = "keyframe");
                for (var p = 0; p < d.length; p++)
                  d[p] !== l && d[p].targetName === l.targetName && d[p].stopTracks(h);
                s && (o[s] = o[s] || {});
                var v = s ? o[s] : o;
                L(h, function(g) {
                  v[g] = ((s ? t[s] : t) || {})[g];
                }), l.whenWithKeys(i * c.percent, f, h, c.easing);
              }
            }
          }), l && (process.env.NODE_ENV !== "production" && (u || Mr("End frame with percent: 1 is missing in the keyframeAnimation.", !0)), l.delay(r.delay || 0).duration(i).start(r.easing));
        }
      });
    }
  }
}
var Gs = "emphasis", Rl = "normal", f_ = "blur", h_ = "select", iu = [Rl, Gs, f_, h_], S3 = {
  normal: ["itemStyle"],
  emphasis: [Gs, "itemStyle"],
  blur: [f_, "itemStyle"],
  select: [h_, "itemStyle"]
}, I3 = {
  normal: ["label"],
  emphasis: [Gs, "label"],
  blur: [f_, "label"],
  select: [h_, "label"]
}, Sue = ["x", "y"], Iue = "e\0\0", da = {
  normal: {},
  emphasis: {},
  blur: {},
  select: {}
}, XT = {
  cartesian2d: oue,
  geo: lue,
  single: cue,
  polar: fue,
  calendar: hue
};
function qm(t) {
  return t instanceof gt;
}
function z9(t) {
  return t instanceof La;
}
function Aue(t, r) {
  r.copyTransform(t), z9(r) && z9(t) && (r.setStyle(t.style), r.z = t.z, r.z2 = t.z2, r.zlevel = t.zlevel, r.invisible = t.invisible, r.ignore = t.ignore, qm(r) && qm(t) && r.setShape(t.shape));
}
var Due = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.render = function(e, n, i, a) {
      this._progressiveEls = null;
      var o = this._data, s = e.getData(), l = this.group, u = $T(e, s, n, i);
      o || l.removeAll(), s.diff(o).add(function(d) {
        A3(i, null, d, u(d, a), e, l, s);
      }).remove(function(d) {
        var f = o.getItemGraphicEl(d);
        f && N2(f, Vs(f).option, e);
      }).update(function(d, f) {
        var h = o.getItemGraphicEl(f);
        A3(i, h, d, u(d, a), e, l, s);
      }).execute();
      var c = e.get("clip", !0) ? xg(e.coordinateSystem, !1, e) : null;
      c ? l.setClipPath(c) : l.removeClipPath(), this._data = s;
    }, r.prototype.incrementalPrepareRender = function(e, n, i) {
      this.group.removeAll(), this._data = null;
    }, r.prototype.incrementalRender = function(e, n, i, a, o) {
      var s = n.getData(), l = $T(n, s, i, a), u = this._progressiveEls = [];
      function c(h) {
        h.isGroup || (h.incremental = !0, h.ensureState("emphasis").hoverLayer = !0);
      }
      for (var d = e.start; d < e.end; d++) {
        var f = A3(null, null, d, l(d, o), n, this.group, s);
        f && (f.traverse(c), u.push(f));
      }
    }, r.prototype.eachRendered = function(e) {
      pu(this._progressiveEls || this.group, e);
    }, r.prototype.filterForExposedEvent = function(e, n, i, a) {
      var o = n.element;
      if (o == null || i.name === o)
        return !0;
      for (; (i = i.__hostTarget || i.parent) && i !== this.group; )
        if (i.name === o)
          return !0;
      return !1;
    }, r.type = "custom", r;
  }(Yt)
);
function p_(t) {
  var r = t.type, e;
  if (r === "path") {
    var n = t.shape, i = n.width != null && n.height != null ? {
      x: n.x || 0,
      y: n.y || 0,
      width: n.width,
      height: n.height
    } : null, a = IF(n);
    e = gg(a, null, i, n.layout || "center"), Vs(e).customPathData = a;
  } else if (r === "image")
    e = new An({}), Vs(e).customImagePath = t.style.image;
  else if (r === "text")
    e = new _t({});
  else if (r === "group")
    e = new ze();
  else {
    if (r === "compoundPath")
      throw new Error('"compoundPath" is not supported yet.');
    var o = d2(r);
    if (!o) {
      var s = "";
      process.env.NODE_ENV !== "production" && (s = 'graphic type "' + r + '" can not be found.'), Gt(s);
    }
    e = new o();
  }
  return Vs(e).customGraphicType = r, e.name = t.name, e.z2EmphasisLift = 1, e.z2SelectLift = 1, e;
}
function v_(t, r, e, n, i, a, o) {
  _F(r);
  var s = i && i.normal.cfg;
  s && r.setTextConfig(s), n && n.transition == null && (n.transition = Sue);
  var l = n && n.style;
  if (l) {
    if (r.type === "text") {
      var u = l;
      be(u, "textFill") && (u.fill = u.textFill), be(u, "textStroke") && (u.stroke = u.textStroke);
    }
    var c = void 0, d = qm(r) ? l.decal : null;
    t && d && (d.dirty = !0, c = Lf(d, t)), l.__decalPattern = c;
  }
  if (z9(r) && l) {
    var c = l.__decalPattern;
    c && (l.decal = c);
  }
  O0(r, n, a, {
    dataIndex: e,
    isInit: o,
    clearStyle: !0
  }), Km(r, n.keyframeAnimation, a);
}
function xF(t, r, e, n, i) {
  var a = r.isGroup ? null : r, o = i && i[t].cfg;
  if (a) {
    var s = a.ensureState(t);
    if (n === !1) {
      var l = a.getState(t);
      l && (l.style = null);
    } else
      s.style = n || null;
    o && (s.textConfig = o), Fc(a);
  }
}
function Tue(t, r, e) {
  if (!t.isGroup) {
    var n = t, i = e.currentZ, a = e.currentZLevel;
    n.z = i, n.zlevel = a;
    var o = r.z2;
    o != null && (n.z2 = o || 0);
    for (var s = 0; s < iu.length; s++)
      Mue(n, r, iu[s]);
  }
}
function Mue(t, r, e) {
  var n = e === Rl, i = n ? r : Qm(r, e), a = i ? i.z2 : null, o;
  a != null && (o = n ? t : t.ensureState(e), o.z2 = a || 0);
}
function $T(t, r, e, n) {
  var i = t.get("renderItem"), a = t.coordinateSystem, o = {};
  a && (process.env.NODE_ENV !== "production" && (ke(i, "series.render is required."), ke(a.prepareCustoms || XT[a.type], "This coordSys does not support custom series.")), o = a.prepareCustoms ? a.prepareCustoms(a) : XT[a.type](a));
  for (var s = Ee({
    getWidth: n.getWidth,
    getHeight: n.getHeight,
    getZr: n.getZr,
    getDevicePixelRatio: n.getDevicePixelRatio,
    value: C,
    style: _,
    ordinalRawValue: w,
    styleEmphasis: x,
    visual: T,
    barLayout: A,
    currentSeriesIndices: M,
    font: R
  }, o.api || {}), l = {
    // The life cycle of context: current round of rendering.
    // The global life cycle is probably not necessary, because
    // user can store global status by themselves.
    context: {},
    seriesId: t.id,
    seriesName: t.name,
    seriesIndex: t.seriesIndex,
    coordSys: o.coordSys,
    dataInsideLength: r.count(),
    encode: Rue(t.getData())
  }, u, c, d = {}, f = {}, h = {}, p = {}, v = 0; v < iu.length; v++) {
    var g = iu[v];
    h[g] = t.getModel(S3[g]), p[g] = t.getModel(I3[g]);
  }
  function m(E) {
    return E === u ? c || (c = r.getItemModel(E)) : r.getItemModel(E);
  }
  function y(E, k) {
    return r.hasItemOption ? E === u ? d[k] || (d[k] = m(E).getModel(S3[k])) : m(E).getModel(S3[k]) : h[k];
  }
  function b(E, k) {
    return r.hasItemOption ? E === u ? f[k] || (f[k] = m(E).getModel(I3[k])) : m(E).getModel(I3[k]) : p[k];
  }
  return function(E, k) {
    return u = E, c = null, d = {}, f = {}, i && i(Ee({
      dataIndexInside: E,
      dataIndex: r.getRawIndex(E),
      // Can be used for optimization when zoom or roam.
      actionType: k ? k.type : null
    }, l), s);
  };
  function C(E, k) {
    return k == null && (k = u), r.getStore().get(r.getDimensionIndex(E || 0), k);
  }
  function w(E, k) {
    k == null && (k = u), E = E || 0;
    var P = r.getDimensionInfo(E);
    if (!P) {
      var N = r.getDimensionIndex(E);
      return N >= 0 ? r.getStore().get(N, k) : void 0;
    }
    var O = r.get(P.name, k), W = P && P.ordinalMeta;
    return W ? W.categories[O] : O;
  }
  function _(E, k) {
    process.env.NODE_ENV !== "production" && zT("api.style", "Please write literal style directly instead."), k == null && (k = u);
    var P = r.getItemVisual(k, "style"), N = P && P.fill, O = P && P.opacity, W = y(k, Rl).getItemStyle();
    N != null && (W.fill = N), O != null && (W.opacity = O);
    var V = {
      inheritColor: pe(N) ? N : "#000"
    }, B = b(k, Rl), Z = fr(B, null, V, !1, !0);
    Z.text = B.getShallow("show") ? je(t.getFormattedLabel(k, Rl), Ef(r, k)) : null;
    var q = xm(B, V, !1);
    return D(E, W), W = FT(W, Z, q), E && I(W, E), W.legacy = !0, W;
  }
  function x(E, k) {
    process.env.NODE_ENV !== "production" && zT("api.styleEmphasis", "Please write literal style directly instead."), k == null && (k = u);
    var P = y(k, Gs).getItemStyle(), N = b(k, Gs), O = fr(N, null, null, !0, !0);
    O.text = N.getShallow("show") ? Ki(t.getFormattedLabel(k, Gs), t.getFormattedLabel(k, Rl), Ef(r, k)) : null;
    var W = xm(N, null, !0);
    return D(E, P), P = FT(P, O, W), E && I(P, E), P.legacy = !0, P;
  }
  function I(E, k) {
    for (var P in k)
      be(k, P) && (E[P] = k[P]);
  }
  function D(E, k) {
    E && (E.textFill && (k.textFill = E.textFill), E.textPosition && (k.textPosition = E.textPosition));
  }
  function T(E, k) {
    if (k == null && (k = u), be(VT, E)) {
      var P = r.getItemVisual(k, "style");
      return P ? P[VT[E]] : null;
    }
    if (be(nue, E))
      return r.getItemVisual(k, E);
  }
  function A(E) {
    if (a.type === "cartesian2d") {
      var k = a.getBaseAxis();
      return oee(Ee({
        axis: k
      }, E));
    }
  }
  function M() {
    return e.getCurrentSeriesIndices();
  }
  function R(E) {
    return U7(E, e);
  }
}
function Rue(t) {
  var r = {};
  return L(t.dimensions, function(e) {
    var n = t.getDimensionInfo(e);
    if (!n.isExtraCoord) {
      var i = n.coordDim, a = r[i] = r[i] || [];
      a[n.coordDimIndex] = t.getDimensionIndex(e);
    }
  }), r;
}
function A3(t, r, e, n, i, a, o) {
  if (!n) {
    a.remove(r);
    return;
  }
  var s = g_(t, r, e, n, i, a);
  return s && o.setItemGraphicEl(e, s), s && Vr(s, n.focus, n.blurScope, n.emphasisDisabled), s;
}
function g_(t, r, e, n, i, a) {
  process.env.NODE_ENV !== "production" && ke(n, "should not have an null/undefined element setting");
  var o = -1, s = r;
  r && SF(r, n, i) && (o = nt(a.childrenRef(), r), r = null);
  var l = !r, u = r;
  u ? u.clearStates() : (u = p_(n), s && Aue(s, u)), n.morph === !1 ? u.disableMorphing = !0 : u.disableMorphing && (u.disableMorphing = !1), da.normal.cfg = da.normal.conOpt = da.emphasis.cfg = da.emphasis.conOpt = da.blur.cfg = da.blur.conOpt = da.select.cfg = da.select.conOpt = null, da.isLegacy = !1, Eue(u, e, n, i, l, da), Lue(u, e, n, i, l), v_(t, u, e, n, da, i, l), be(n, "info") && (Vs(u).info = n.info);
  for (var c = 0; c < iu.length; c++) {
    var d = iu[c];
    if (d !== Rl) {
      var f = Qm(n, d), h = m_(n, f, d);
      xF(d, u, f, h, da);
    }
  }
  return Tue(u, n, i), n.type === "group" && kue(t, u, e, n, i), o >= 0 ? a.replaceAt(u, o) : a.add(u), u;
}
function SF(t, r, e) {
  var n = Vs(t), i = r.type, a = r.shape, o = r.style;
  return (
    // Always create new if universal transition is enabled.
    // Because we do transition after render. It needs to know what old element is. Replacement will loose it.
    e.isUniversalTransitionEnabled() || i != null && i !== n.customGraphicType || i === "path" && Vue(a) && IF(a) !== n.customPathData || i === "image" && be(o, "image") && o.image !== n.customImagePath
  );
}
function Lue(t, r, e, n, i) {
  var a = e.clipPath;
  if (a === !1)
    t && t.getClipPath() && t.removeClipPath();
  else if (a) {
    var o = t.getClipPath();
    o && SF(o, a, n) && (o = null), o || (o = p_(a), process.env.NODE_ENV !== "production" && ke(qm(o), "Only any type of `path` can be used in `clipPath`, rather than " + o.type + "."), t.setClipPath(o)), v_(null, o, r, a, null, n, i);
  }
}
function Eue(t, r, e, n, i, a) {
  if (!t.isGroup) {
    UT(e, null, a), UT(e, Gs, a);
    var o = a.normal.conOpt, s = a.emphasis.conOpt, l = a.blur.conOpt, u = a.select.conOpt;
    if (o != null || s != null || u != null || l != null) {
      var c = t.getTextContent();
      if (o === !1)
        c && t.removeTextContent();
      else {
        o = a.normal.conOpt = o || {
          type: "text"
        }, c ? c.clearStates() : (c = p_(o), t.setTextContent(c)), v_(null, c, r, o, null, n, i);
        for (var d = o && o.style, f = 0; f < iu.length; f++) {
          var h = iu[f];
          if (h !== Rl) {
            var p = a[h].conOpt;
            xF(h, c, p, m_(o, p, h), null);
          }
        }
        d ? c.dirty() : c.markRedraw();
      }
    }
  }
}
function UT(t, r, e) {
  var n = r ? Qm(t, r) : t, i = r ? m_(t, n, Gs) : t.style, a = t.type, o = n ? n.textConfig : null, s = t.textContent, l = s ? r ? Qm(s, r) : s : null;
  if (i && // Because emphasis style has little info to detect legacy,
  // if normal is legacy, emphasis is trade as legacy.
  (e.isLegacy || gF(i, a, !!o, !!l))) {
    e.isLegacy = !0;
    var u = mF(i, a, !r);
    !o && u.textConfig && (o = u.textConfig), !l && u.textContent && (l = u.textContent);
  }
  if (!r && l) {
    var c = l;
    !c.type && (c.type = "text"), process.env.NODE_ENV !== "production" && ke(c.type === "text", 'textContent.type must be "text"');
  }
  var d = r ? e[r] : e.normal;
  d.cfg = o, d.conOpt = l;
}
function Qm(t, r) {
  return r ? t ? t[r] : null : t;
}
function m_(t, r, e) {
  var n = r && r.style;
  return n == null && e === Gs && t && (n = t.styleEmphasis), n;
}
function kue(t, r, e, n, i) {
  var a = n.children, o = a ? a.length : 0, s = n.$mergeChildren, l = s === "byName" || n.diffChildrenByName, u = s === !1;
  if (!(!o && !l && !u)) {
    if (l) {
      Nue({
        api: t,
        oldChildren: r.children() || [],
        newChildren: a || [],
        dataIndex: e,
        seriesModel: i,
        group: r
      });
      return;
    }
    u && r.removeAll();
    for (var c = 0; c < o; c++) {
      var d = a[c], f = r.childAt(c);
      d ? (d.ignore == null && (d.ignore = !1), g_(t, f, e, d, i, r)) : (process.env.NODE_ENV !== "production" && ke(f, "renderItem should not return a group containing elements as null/undefined/{} if they do not exist before."), f.ignore = !0);
    }
    for (var h = r.childCount() - 1; h >= c; h--) {
      var p = r.childAt(h);
      Pue(r, p, i);
    }
  }
}
function Pue(t, r, e) {
  r && N2(r, Vs(t).option, e);
}
function Nue(t) {
  new Us(t.oldChildren, t.newChildren, JT, JT, t).add(KT).update(KT).remove(Oue).execute();
}
function JT(t, r) {
  var e = t && t.name;
  return e ?? Iue + r;
}
function KT(t, r) {
  var e = this.context, n = t != null ? e.newChildren[t] : null, i = r != null ? e.oldChildren[r] : null;
  g_(e.api, i, e.dataIndex, n, e.seriesModel, e.group);
}
function Oue(t) {
  var r = this.context, e = r.oldChildren[t];
  e && N2(e, Vs(e).option, r.seriesModel);
}
function IF(t) {
  return t && (t.pathData || t.d);
}
function Vue(t) {
  return t && (be(t, "pathData") || be(t, "d"));
}
function Gue(t) {
  t.registerChartView(Due), t.registerSeriesModel(iue);
}
var oc = It(), qT = Ge, D3 = ye, y_ = (
  /** @class */
  function() {
    function t() {
      this._dragging = !1, this.animationThreshold = 15;
    }
    return t.prototype.render = function(r, e, n, i) {
      var a = e.get("value"), o = e.get("status");
      if (this._axisModel = r, this._axisPointerModel = e, this._api = n, !(!i && this._lastValue === a && this._lastStatus === o)) {
        this._lastValue = a, this._lastStatus = o;
        var s = this._group, l = this._handle;
        if (!o || o === "hide") {
          s && s.hide(), l && l.hide();
          return;
        }
        s && s.show(), l && l.show();
        var u = {};
        this.makeElOption(u, a, r, e, n);
        var c = u.graphicKey;
        c !== this._lastGraphicKey && this.clear(n), this._lastGraphicKey = c;
        var d = this._moveAnimation = this.determineAnimation(r, e);
        if (!s)
          s = this._group = new ze(), this.createPointerEl(s, u, r, e), this.createLabelEl(s, u, r, e), n.getZr().add(s);
        else {
          var f = Ye(QT, e, d);
          this.updatePointerEl(s, u, f), this.updateLabelEl(s, u, f, e);
        }
        tM(s, e, !0), this._renderHandle(a);
      }
    }, t.prototype.remove = function(r) {
      this.clear(r);
    }, t.prototype.dispose = function(r) {
      this.clear(r);
    }, t.prototype.determineAnimation = function(r, e) {
      var n = e.get("animation"), i = r.axis, a = i.type === "category", o = e.get("snap");
      if (!o && !a)
        return !1;
      if (n === "auto" || n == null) {
        var s = this.animationThreshold;
        if (a && i.getBandWidth() > s)
          return !0;
        if (o) {
          var l = zw(r).seriesDataCount, u = i.getExtent();
          return Math.abs(u[0] - u[1]) / l > s;
        }
        return !1;
      }
      return n === !0;
    }, t.prototype.makeElOption = function(r, e, n, i, a) {
    }, t.prototype.createPointerEl = function(r, e, n, i) {
      var a = e.pointer;
      if (a) {
        var o = oc(r).pointerEl = new qc[a.type](qT(e.pointer));
        r.add(o);
      }
    }, t.prototype.createLabelEl = function(r, e, n, i) {
      if (e.label) {
        var a = oc(r).labelEl = new _t(qT(e.label));
        r.add(a), eM(a, i);
      }
    }, t.prototype.updatePointerEl = function(r, e, n) {
      var i = oc(r).pointerEl;
      i && e.pointer && (i.setStyle(e.pointer.style), n(i, {
        shape: e.pointer.shape
      }));
    }, t.prototype.updateLabelEl = function(r, e, n, i) {
      var a = oc(r).labelEl;
      a && (a.setStyle(e.label.style), n(a, {
        // Consider text length change in vertical axis, animation should
        // be used on shape, otherwise the effect will be weird.
        // TODOTODO
        // shape: elOption.label.shape,
        x: e.label.x,
        y: e.label.y
      }), eM(a, i));
    }, t.prototype._renderHandle = function(r) {
      if (!(this._dragging || !this.updateHandleTransform)) {
        var e = this._axisPointerModel, n = this._api.getZr(), i = this._handle, a = e.getModel("handle"), o = e.get("status");
        if (!a.get("show") || !o || o === "hide") {
          i && n.remove(i), this._handle = null;
          return;
        }
        var s;
        this._handle || (s = !0, i = this._handle = ih(a.get("icon"), {
          cursor: "move",
          draggable: !0,
          onmousemove: function(u) {
            Ys(u.event);
          },
          onmousedown: D3(this._onHandleDragMove, this, 0, 0),
          drift: D3(this._onHandleDragMove, this),
          ondragend: D3(this._onHandleDragEnd, this)
        }), n.add(i)), tM(i, e, !1), i.setStyle(a.getItemStyle(null, ["color", "borderColor", "borderWidth", "opacity", "shadowColor", "shadowBlur", "shadowOffsetX", "shadowOffsetY"]));
        var l = a.get("size");
        ue(l) || (l = [l, l]), i.scaleX = l[0] / 2, i.scaleY = l[1] / 2, dh(this, "_doDispatchAxisPointer", a.get("throttle") || 0, "fixRate"), this._moveHandleToValue(r, s);
      }
    }, t.prototype._moveHandleToValue = function(r, e) {
      QT(this._axisPointerModel, !e && this._moveAnimation, this._handle, T3(this.getHandleTransform(r, this._axisModel, this._axisPointerModel)));
    }, t.prototype._onHandleDragMove = function(r, e) {
      var n = this._handle;
      if (n) {
        this._dragging = !0;
        var i = this.updateHandleTransform(T3(n), [r, e], this._axisModel, this._axisPointerModel);
        this._payloadInfo = i, n.stopAnimation(), n.attr(T3(i)), oc(n).lastProp = null, this._doDispatchAxisPointer();
      }
    }, t.prototype._doDispatchAxisPointer = function() {
      var r = this._handle;
      if (r) {
        var e = this._payloadInfo, n = this._axisModel;
        this._api.dispatchAction({
          type: "updateAxisPointer",
          x: e.cursorPoint[0],
          y: e.cursorPoint[1],
          tooltipOption: e.tooltipOption,
          axesInfo: [{
            axisDim: n.axis.dim,
            axisIndex: n.componentIndex
          }]
        });
      }
    }, t.prototype._onHandleDragEnd = function() {
      this._dragging = !1;
      var r = this._handle;
      if (r) {
        var e = this._axisPointerModel.get("value");
        this._moveHandleToValue(e), this._api.dispatchAction({
          type: "hideTip"
        });
      }
    }, t.prototype.clear = function(r) {
      this._lastValue = null, this._lastStatus = null;
      var e = r.getZr(), n = this._group, i = this._handle;
      e && n && (this._lastGraphicKey = null, n && e.remove(n), i && e.remove(i), this._group = null, this._handle = null, this._payloadInfo = null), Iv(this, "_doDispatchAxisPointer");
    }, t.prototype.doClear = function() {
    }, t.prototype.buildLabel = function(r, e, n) {
      return n = n || 0, {
        x: r[n],
        y: r[1 - n],
        width: e[n],
        height: e[1 - n]
      };
    }, t;
  }()
);
function QT(t, r, e, n) {
  AF(oc(e).lastProp, n) || (oc(e).lastProp = n, r ? kt(e, n, t) : (e.stopAnimation(), e.attr(n)));
}
function AF(t, r) {
  if (Me(t) && Me(r)) {
    var e = !0;
    return L(r, function(n, i) {
      e = e && AF(t[i], n);
    }), !!e;
  } else
    return t === r;
}
function eM(t, r) {
  t[r.get(["label", "show"]) ? "show" : "hide"]();
}
function T3(t) {
  return {
    x: t.x || 0,
    y: t.y || 0,
    rotation: t.rotation || 0
  };
}
function tM(t, r, e) {
  var n = r.get("z"), i = r.get("zlevel");
  t && t.traverse(function(a) {
    a.type !== "group" && (n != null && (a.z = n), i != null && (a.zlevel = i), a.silent = e);
  });
}
function b_(t) {
  var r = t.get("type"), e = t.getModel(r + "Style"), n;
  return r === "line" ? (n = e.getLineStyle(), n.fill = null) : r === "shadow" && (n = e.getAreaStyle(), n.stroke = null), n;
}
function DF(t, r, e, n, i) {
  var a = e.get("value"), o = TF(a, r.axis, r.ecModel, e.get("seriesDataIndices"), {
    precision: e.get(["label", "precision"]),
    formatter: e.get(["label", "formatter"])
  }), s = e.getModel("label"), l = Qc(s.get("padding") || 0), u = s.getFont(), c = cg(o, u), d = i.position, f = c.width + l[1] + l[3], h = c.height + l[0] + l[2], p = i.align;
  p === "right" && (d[0] -= f), p === "center" && (d[0] -= f / 2);
  var v = i.verticalAlign;
  v === "bottom" && (d[1] -= h), v === "middle" && (d[1] -= h / 2), Bue(d, f, h, n);
  var g = s.get("backgroundColor");
  (!g || g === "auto") && (g = r.get(["axisLine", "lineStyle", "color"])), t.label = {
    // shape: {x: 0, y: 0, width: width, height: height, r: labelModel.get('borderRadius')},
    x: d[0],
    y: d[1],
    style: fr(s, {
      text: o,
      font: u,
      fill: s.getTextColor(),
      padding: l,
      backgroundColor: g
    }),
    // Label should be over axisPointer.
    z2: 10
  };
}
function Bue(t, r, e, n) {
  var i = n.getWidth(), a = n.getHeight();
  t[0] = Math.min(t[0] + r, i) - r, t[1] = Math.min(t[1] + e, a) - e, t[0] = Math.max(t[0], 0), t[1] = Math.max(t[1], 0);
}
function TF(t, r, e, n, i) {
  t = r.scale.parse(t);
  var a = r.scale.getLabel({
    value: t
  }, {
    // If `precision` is set, width can be fixed (like '12.00500'), which
    // helps to debounce when when moving label.
    precision: i.precision
  }), o = i.formatter;
  if (o) {
    var s = {
      value: Lw(r, {
        value: t
      }),
      axisDimension: r.dim,
      axisIndex: r.index,
      seriesData: []
    };
    L(n, function(l) {
      var u = e.getSeriesByIndex(l.seriesIndex), c = l.dataIndexInside, d = u && u.getDataParams(c);
      d && s.seriesData.push(d);
    }), pe(o) ? a = o.replace("{value}", a) : Ae(o) && (a = o(s));
  }
  return a;
}
function C_(t, r, e) {
  var n = Oi();
  return hu(n, n, e.rotation), eo(n, n, e.position), Ka([t.dataToCoord(r), (e.labelOffset || 0) + (e.labelDirection || 1) * (e.labelMargin || 0)], n);
}
function MF(t, r, e, n, i, a) {
  var o = wi.innerTextLayout(e.rotation, 0, e.labelDirection);
  e.labelMargin = i.get(["label", "margin"]), DF(r, n, i, a, {
    position: C_(n.axis, t, e),
    align: o.textAlign,
    verticalAlign: o.textVerticalAlign
  });
}
function w_(t, r, e) {
  return e = e || 0, {
    x1: t[e],
    y1: t[1 - e],
    x2: r[e],
    y2: r[1 - e]
  };
}
function RF(t, r, e) {
  return e = e || 0, {
    x: t[e],
    y: t[1 - e],
    width: r[e],
    height: r[1 - e]
  };
}
function rM(t, r, e, n, i, a) {
  return {
    cx: t,
    cy: r,
    r0: e,
    r: n,
    startAngle: i,
    endAngle: a,
    clockwise: !0
  };
}
var Fue = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return r.prototype.makeElOption = function(e, n, i, a, o) {
      var s = i.axis, l = s.grid, u = a.get("type"), c = nM(l, s).getOtherAxis(s).getGlobalExtent(), d = s.toGlobalCoord(s.dataToCoord(n, !0));
      if (u && u !== "none") {
        var f = b_(a), h = Hue[u](s, d, c);
        h.style = f, e.graphicKey = h.type, e.pointer = h;
      }
      var p = x9(l.model, i);
      MF(
        // @ts-ignore
        n,
        e,
        p,
        i,
        a,
        o
      );
    }, r.prototype.getHandleTransform = function(e, n, i) {
      var a = x9(n.axis.grid.model, n, {
        labelInside: !1
      });
      a.labelMargin = i.get(["handle", "margin"]);
      var o = C_(n.axis, e, a);
      return {
        x: o[0],
        y: o[1],
        rotation: a.rotation + (a.labelDirection < 0 ? Math.PI : 0)
      };
    }, r.prototype.updateHandleTransform = function(e, n, i, a) {
      var o = i.axis, s = o.grid, l = o.getGlobalExtent(!0), u = nM(s, o).getOtherAxis(o).getGlobalExtent(), c = o.dim === "x" ? 0 : 1, d = [e.x, e.y];
      d[c] += n[c], d[c] = Math.min(l[1], d[c]), d[c] = Math.max(l[0], d[c]);
      var f = (u[1] + u[0]) / 2, h = [f, f];
      h[c] = d[c];
      var p = [{
        verticalAlign: "middle"
      }, {
        align: "center"
      }];
      return {
        x: d[0],
        y: d[1],
        rotation: e.rotation,
        cursorPoint: h,
        tooltipOption: p[c]
      };
    }, r;
  }(y_)
);
function nM(t, r) {
  var e = {};
  return e[r.dim + "AxisIndex"] = r.index, t.getCartesian(e);
}
var Hue = {
  line: function(t, r, e) {
    var n = w_([r, e[0]], [r, e[1]], iM(t));
    return {
      type: "Line",
      subPixelOptimize: !0,
      shape: n
    };
  },
  shadow: function(t, r, e) {
    var n = Math.max(1, t.getBandWidth()), i = e[1] - e[0];
    return {
      type: "Rect",
      shape: RF([r - n / 2, e[0]], [n, i], iM(t))
    };
  }
};
function iM(t) {
  return t.dim === "x" ? 0 : 1;
}
var zue = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.type = "axisPointer", r.defaultOption = {
      // 'auto' means that show when triggered by tooltip or handle.
      show: "auto",
      // zlevel: 0,
      z: 50,
      type: "line",
      // axispointer triggered by tootip determine snap automatically,
      // see `modelHelper`.
      snap: !1,
      triggerTooltip: !0,
      triggerEmphasis: !0,
      value: null,
      status: null,
      link: [],
      // Do not set 'auto' here, otherwise global animation: false
      // will not effect at this axispointer.
      animation: null,
      animationDurationUpdate: 200,
      lineStyle: {
        color: "#B9BEC9",
        width: 1,
        type: "dashed"
      },
      shadowStyle: {
        color: "rgba(210,219,238,0.2)"
      },
      label: {
        show: !0,
        formatter: null,
        precision: "auto",
        margin: 3,
        color: "#fff",
        padding: [5, 7, 5, 7],
        backgroundColor: "auto",
        borderColor: null,
        borderWidth: 0,
        borderRadius: 3
      },
      handle: {
        show: !1,
        // eslint-disable-next-line
        icon: "M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7v-1.2h6.6z M13.3,22H6.7v-1.2h6.6z M13.3,19.6H6.7v-1.2h6.6z",
        size: 45,
        // handle margin is from symbol center to axis, which is stable when circular move.
        margin: 50,
        // color: '#1b8bbd'
        // color: '#2f4554'
        color: "#333",
        shadowBlur: 3,
        shadowColor: "#aaa",
        shadowOffsetX: 0,
        shadowOffsetY: 2,
        // For mobile performance
        throttle: 40
      }
    }, r;
  }(st)
), Es = It(), Wue = L;
function LF(t, r, e) {
  if (!vt.node) {
    var n = r.getZr();
    Es(n).records || (Es(n).records = {}), Zue(n, r);
    var i = Es(n).records[t] || (Es(n).records[t] = {});
    i.handler = e;
  }
}
function Zue(t, r) {
  if (Es(t).initialized)
    return;
  Es(t).initialized = !0, e("click", Ye(aM, "click")), e("mousemove", Ye(aM, "mousemove")), e("globalout", Yue);
  function e(n, i) {
    t.on(n, function(a) {
      var o = Xue(r);
      Wue(Es(t).records, function(s) {
        s && i(s, a, o.dispatchAction);
      }), jue(o.pendings, r);
    });
  }
}
function jue(t, r) {
  var e = t.showTip.length, n = t.hideTip.length, i;
  e ? i = t.showTip[e - 1] : n && (i = t.hideTip[n - 1]), i && (i.dispatchAction = null, r.dispatchAction(i));
}
function Yue(t, r, e) {
  t.handler("leave", null, e);
}
function aM(t, r, e, n) {
  r.handler(t, e, n);
}
function Xue(t) {
  var r = {
    showTip: [],
    hideTip: []
  }, e = function(n) {
    var i = r[n.type];
    i ? i.push(n) : (n.dispatchAction = e, t.dispatchAction(n));
  };
  return {
    dispatchAction: e,
    pendings: r
  };
}
function W9(t, r) {
  if (!vt.node) {
    var e = r.getZr(), n = (Es(e).records || {})[t];
    n && (Es(e).records[t] = null);
  }
}
var $ue = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.render = function(e, n, i) {
      var a = n.getComponent("tooltip"), o = e.get("triggerOn") || a && a.get("triggerOn") || "mousemove|click";
      LF("axisPointer", i, function(s, l, u) {
        o !== "none" && (s === "leave" || o.indexOf(s) >= 0) && u({
          type: "updateAxisPointer",
          currTrigger: s,
          x: l && l.offsetX,
          y: l && l.offsetY
        });
      });
    }, r.prototype.remove = function(e, n) {
      W9("axisPointer", n);
    }, r.prototype.dispose = function(e, n) {
      W9("axisPointer", n);
    }, r.type = "axisPointer", r;
  }(yr)
);
function EF(t, r) {
  var e = [], n = t.seriesIndex, i;
  if (n == null || !(i = r.getSeriesByIndex(n)))
    return {
      point: []
    };
  var a = i.getData(), o = Gc(a, t);
  if (o == null || o < 0 || ue(o))
    return {
      point: []
    };
  var s = a.getItemGraphicEl(o), l = i.coordinateSystem;
  if (i.getTooltipPosition)
    e = i.getTooltipPosition(o) || [];
  else if (l && l.dataToPoint)
    if (t.isStacked) {
      var u = l.getBaseAxis(), c = l.getOtherAxis(u), d = c.dim, f = u.dim, h = d === "x" || d === "radius" ? 1 : 0, p = a.mapDimension(f), v = [];
      v[h] = a.get(p, o), v[1 - h] = a.get(a.getCalculationInfo("stackResultDimension"), o), e = l.dataToPoint(v) || [];
    } else
      e = l.dataToPoint(a.getValues(ce(l.dimensions, function(m) {
        return a.mapDimension(m);
      }), o)) || [];
  else if (s) {
    var g = s.getBoundingRect().clone();
    g.applyTransform(s.transform), e = [g.x + g.width / 2, g.y + g.height / 2];
  }
  return {
    point: e,
    el: s
  };
}
var oM = It();
function Uue(t, r, e) {
  var n = t.currTrigger, i = [t.x, t.y], a = t, o = t.dispatchAction || ye(e.dispatchAction, e), s = r.getComponent("axisPointer").coordSysAxesInfo;
  if (s) {
    V0(i) && (i = EF({
      seriesIndex: a.seriesIndex,
      // Do not use dataIndexInside from other ec instance.
      // FIXME: auto detect it?
      dataIndex: a.dataIndex
    }, r).point);
    var l = V0(i), u = a.axesInfo, c = s.axesInfo, d = n === "leave" || V0(i), f = {}, h = {}, p = {
      list: [],
      map: {}
    }, v = {
      showPointer: Ye(Kue, h),
      showTooltip: Ye(que, p)
    };
    L(s.coordSysMap, function(m, y) {
      var b = l || m.containPoint(i);
      L(s.coordSysAxesInfo[y], function(C, w) {
        var _ = C.axis, x = rce(u, C);
        if (!d && b && (!u || x)) {
          var I = x && x.value;
          I == null && !l && (I = _.pointToData(i)), I != null && sM(C, I, v, !1, f);
        }
      });
    });
    var g = {};
    return L(c, function(m, y) {
      var b = m.linkGroup;
      b && !h[y] && L(b.axesInfo, function(C, w) {
        var _ = h[w];
        if (C !== m && _) {
          var x = _.value;
          b.mapper && (x = m.axis.scale.parse(b.mapper(x, lM(C), lM(m)))), g[m.key] = x;
        }
      });
    }), L(g, function(m, y) {
      sM(c[y], m, v, !0, f);
    }), Que(h, c, f), ece(p, i, t, o), tce(c, o, e), f;
  }
}
function sM(t, r, e, n, i) {
  var a = t.axis;
  if (!(a.scale.isBlank() || !a.containData(r))) {
    if (!t.involveSeries) {
      e.showPointer(t, r);
      return;
    }
    var o = Jue(r, t), s = o.payloadBatch, l = o.snapToValue;
    s[0] && i.seriesIndex == null && ae(i, s[0]), !n && t.snap && a.containData(l) && l != null && (r = l), e.showPointer(t, r, s), e.showTooltip(t, o, l);
  }
}
function Jue(t, r) {
  var e = r.axis, n = e.dim, i = t, a = [], o = Number.MAX_VALUE, s = -1;
  return L(r.seriesModels, function(l, u) {
    var c = l.getData().mapDimensionsAll(n), d, f;
    if (l.getAxisTooltipData) {
      var h = l.getAxisTooltipData(c, t, e);
      f = h.dataIndices, d = h.nestestValue;
    } else {
      if (f = l.getData().indicesOfNearest(
        c[0],
        t,
        // Add a threshold to avoid find the wrong dataIndex
        // when data length is not same.
        // false,
        e.type === "category" ? 0.5 : null
      ), !f.length)
        return;
      d = l.getData().get(c[0], f[0]);
    }
    if (!(d == null || !isFinite(d))) {
      var p = t - d, v = Math.abs(p);
      v <= o && ((v < o || p >= 0 && s < 0) && (o = v, s = p, i = d, a.length = 0), L(f, function(g) {
        a.push({
          seriesIndex: l.seriesIndex,
          dataIndexInside: g,
          dataIndex: l.getData().getRawIndex(g)
        });
      }));
    }
  }), {
    payloadBatch: a,
    snapToValue: i
  };
}
function Kue(t, r, e, n) {
  t[r.key] = {
    value: e,
    payloadBatch: n
  };
}
function que(t, r, e, n) {
  var i = e.payloadBatch, a = r.axis, o = a.model, s = r.axisPointerModel;
  if (!(!r.triggerTooltip || !i.length)) {
    var l = r.coordSys.model, u = Ev(l), c = t.map[u];
    c || (c = t.map[u] = {
      coordSysId: l.id,
      coordSysIndex: l.componentIndex,
      coordSysType: l.type,
      coordSysMainType: l.mainType,
      dataByAxis: []
    }, t.list.push(c)), c.dataByAxis.push({
      axisDim: a.dim,
      axisIndex: o.componentIndex,
      axisType: o.type,
      axisId: o.id,
      value: n,
      // Caustion: viewHelper.getValueLabel is actually on "view stage", which
      // depends that all models have been updated. So it should not be performed
      // here. Considering axisPointerModel used here is volatile, which is hard
      // to be retrieve in TooltipView, we prepare parameters here.
      valueLabelOpt: {
        precision: s.get(["label", "precision"]),
        formatter: s.get(["label", "formatter"])
      },
      seriesDataIndices: i.slice()
    });
  }
}
function Que(t, r, e) {
  var n = e.axesInfo = [];
  L(r, function(i, a) {
    var o = i.axisPointerModel.option, s = t[a];
    s ? (!i.useHandle && (o.status = "show"), o.value = s.value, o.seriesDataIndices = (s.payloadBatch || []).slice()) : !i.useHandle && (o.status = "hide"), o.status === "show" && n.push({
      axisDim: i.axis.dim,
      axisIndex: i.axis.model.componentIndex,
      value: o.value
    });
  });
}
function ece(t, r, e, n) {
  if (V0(r) || !t.list.length) {
    n({
      type: "hideTip"
    });
    return;
  }
  var i = ((t.list[0].dataByAxis[0] || {}).seriesDataIndices || [])[0] || {};
  n({
    type: "showTip",
    escapeConnect: !0,
    x: r[0],
    y: r[1],
    tooltipOption: e.tooltipOption,
    position: e.position,
    dataIndexInside: i.dataIndexInside,
    dataIndex: i.dataIndex,
    seriesIndex: i.seriesIndex,
    dataByCoordSys: t.list
  });
}
function tce(t, r, e) {
  var n = e.getZr(), i = "axisPointerLastHighlights", a = oM(n)[i] || {}, o = oM(n)[i] = {};
  L(t, function(u, c) {
    var d = u.axisPointerModel.option;
    d.status === "show" && u.triggerEmphasis && L(d.seriesDataIndices, function(f) {
      var h = f.seriesIndex + " | " + f.dataIndex;
      o[h] = f;
    });
  });
  var s = [], l = [];
  L(a, function(u, c) {
    !o[c] && l.push(u);
  }), L(o, function(u, c) {
    !a[c] && s.push(u);
  }), l.length && e.dispatchAction({
    type: "downplay",
    escapeConnect: !0,
    // Not blur others when highlight in axisPointer.
    notBlur: !0,
    batch: l
  }), s.length && e.dispatchAction({
    type: "highlight",
    escapeConnect: !0,
    // Not blur others when highlight in axisPointer.
    notBlur: !0,
    batch: s
  });
}
function rce(t, r) {
  for (var e = 0; e < (t || []).length; e++) {
    var n = t[e];
    if (r.axis.dim === n.axisDim && r.axis.model.componentIndex === n.axisIndex)
      return n;
  }
}
function lM(t) {
  var r = t.axis.model, e = {}, n = e.axisDim = t.axis.dim;
  return e.axisIndex = e[n + "AxisIndex"] = r.componentIndex, e.axisName = e[n + "AxisName"] = r.name, e.axisId = e[n + "AxisId"] = r.id, e;
}
function V0(t) {
  return !t || t[0] == null || isNaN(t[0]) || t[1] == null || isNaN(t[1]);
}
function Mg(t) {
  nd.registerAxisPointerClass("CartesianAxisPointer", Fue), t.registerComponentModel(zue), t.registerComponentView($ue), t.registerPreprocessor(function(r) {
    if (r) {
      (!r.axisPointer || r.axisPointer.length === 0) && (r.axisPointer = {});
      var e = r.axisPointer.link;
      e && !ue(e) && (r.axisPointer.link = [e]);
    }
  }), t.registerProcessor(t.PRIORITY.PROCESSOR.STATISTIC, function(r, e) {
    r.getComponent("axisPointer").coordSysAxesInfo = hne(r, e);
  }), t.registerAction({
    type: "updateAxisPointer",
    event: "updateAxisPointer",
    update: ":updateAxisPointer"
  }, Uue);
}
function nce(t) {
  lt(aB), lt(Mg);
}
var ice = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return r.prototype.makeElOption = function(e, n, i, a, o) {
      var s = i.axis;
      s.dim === "angle" && (this.animationThreshold = Math.PI / 18);
      var l = s.polar, u = l.getOtherAxis(s), c = u.getExtent(), d = s.dataToCoord(n), f = a.get("type");
      if (f && f !== "none") {
        var h = b_(a), p = oce[f](s, l, d, c);
        p.style = h, e.graphicKey = p.type, e.pointer = p;
      }
      var v = a.get(["label", "margin"]), g = ace(n, i, a, l, v);
      DF(e, i, a, o, g);
    }, r;
  }(y_)
);
function ace(t, r, e, n, i) {
  var a = r.axis, o = a.dataToCoord(t), s = n.getAngleAxis().getExtent()[0];
  s = s / 180 * Math.PI;
  var l = n.getRadiusAxis().getExtent(), u, c, d;
  if (a.dim === "radius") {
    var f = Oi();
    hu(f, f, s), eo(f, f, [n.cx, n.cy]), u = Ka([o, -i], f);
    var h = r.getModel("axisLabel").get("rotate") || 0, p = wi.innerTextLayout(s, h * Math.PI / 180, -1);
    c = p.textAlign, d = p.textVerticalAlign;
  } else {
    var v = l[1];
    u = n.coordToPoint([v + i, o]);
    var g = n.cx, m = n.cy;
    c = Math.abs(u[0] - g) / v < 0.3 ? "center" : u[0] > g ? "left" : "right", d = Math.abs(u[1] - m) / v < 0.3 ? "middle" : u[1] > m ? "top" : "bottom";
  }
  return {
    position: u,
    align: c,
    verticalAlign: d
  };
}
var oce = {
  line: function(t, r, e, n) {
    return t.dim === "angle" ? {
      type: "Line",
      shape: w_(r.coordToPoint([n[0], e]), r.coordToPoint([n[1], e]))
    } : {
      type: "Circle",
      shape: {
        cx: r.cx,
        cy: r.cy,
        r: e
      }
    };
  },
  shadow: function(t, r, e, n) {
    var i = Math.max(1, t.getBandWidth()), a = Math.PI / 180;
    return t.dim === "angle" ? {
      type: "Sector",
      shape: rM(
        r.cx,
        r.cy,
        n[0],
        n[1],
        // In ECharts y is negative if angle is positive
        (-e - i / 2) * a,
        (-e + i / 2) * a
      )
    } : {
      type: "Sector",
      shape: rM(r.cx, r.cy, e - i / 2, e + i / 2, 0, Math.PI * 2)
    };
  }
}, sce = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.findAxisModel = function(e) {
      var n, i = this.ecModel;
      return i.eachComponent(e, function(a) {
        a.getCoordSysModel() === this && (n = a);
      }, this), n;
    }, r.type = "polar", r.dependencies = ["radiusAxis", "angleAxis"], r.defaultOption = {
      // zlevel: 0,
      z: 0,
      center: ["50%", "50%"],
      radius: "80%"
    }, r;
  }(st)
), __ = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return r.prototype.getCoordSysModel = function() {
      return this.getReferringComponents("polar", on).models[0];
    }, r.type = "polarAxis", r;
  }(st)
);
Xr(__, vh);
var lce = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.type = "angleAxis", r;
  }(__)
), uce = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.type = "radiusAxis", r;
  }(__)
), x_ = (
  /** @class */
  function(t) {
    ee(r, t);
    function r(e, n) {
      return t.call(this, "radius", e, n) || this;
    }
    return r.prototype.pointToData = function(e, n) {
      return this.polar.pointToData(e, n)[this.dim === "radius" ? 0 : 1];
    }, r;
  }(Va)
);
x_.prototype.dataToRadius = Va.prototype.dataToCoord;
x_.prototype.radiusToData = Va.prototype.coordToData;
var cce = It(), S_ = (
  /** @class */
  function(t) {
    ee(r, t);
    function r(e, n) {
      return t.call(this, "angle", e, n || [0, 360]) || this;
    }
    return r.prototype.pointToData = function(e, n) {
      return this.polar.pointToData(e, n)[this.dim === "radius" ? 0 : 1];
    }, r.prototype.calculateCategoryInterval = function() {
      var e = this, n = e.getLabelModel(), i = e.scale, a = i.getExtent(), o = i.count();
      if (a[1] - a[0] < 1)
        return 0;
      var s = a[0], l = e.dataToCoord(s + 1) - e.dataToCoord(s), u = Math.abs(l), c = cg(s == null ? "" : s + "", n.getFont(), "center", "top"), d = Math.max(c.height, 7), f = d / u;
      isNaN(f) && (f = 1 / 0);
      var h = Math.max(0, Math.floor(f)), p = cce(e.model), v = p.lastAutoInterval, g = p.lastTickCount;
      return v != null && g != null && Math.abs(v - h) <= 1 && Math.abs(g - o) <= 1 && v > h ? h = v : (p.lastTickCount = o, p.lastAutoInterval = h), h;
    }, r;
  }(Va)
);
S_.prototype.dataToAngle = Va.prototype.dataToCoord;
S_.prototype.angleToData = Va.prototype.coordToData;
var kF = ["radius", "angle"], dce = (
  /** @class */
  function() {
    function t(r) {
      this.dimensions = kF, this.type = "polar", this.cx = 0, this.cy = 0, this._radiusAxis = new x_(), this._angleAxis = new S_(), this.axisPointerEnabled = !0, this.name = r || "", this._radiusAxis.polar = this._angleAxis.polar = this;
    }
    return t.prototype.containPoint = function(r) {
      var e = this.pointToCoord(r);
      return this._radiusAxis.contain(e[0]) && this._angleAxis.contain(e[1]);
    }, t.prototype.containData = function(r) {
      return this._radiusAxis.containData(r[0]) && this._angleAxis.containData(r[1]);
    }, t.prototype.getAxis = function(r) {
      var e = "_" + r + "Axis";
      return this[e];
    }, t.prototype.getAxes = function() {
      return [this._radiusAxis, this._angleAxis];
    }, t.prototype.getAxesByScale = function(r) {
      var e = [], n = this._angleAxis, i = this._radiusAxis;
      return n.scale.type === r && e.push(n), i.scale.type === r && e.push(i), e;
    }, t.prototype.getAngleAxis = function() {
      return this._angleAxis;
    }, t.prototype.getRadiusAxis = function() {
      return this._radiusAxis;
    }, t.prototype.getOtherAxis = function(r) {
      var e = this._angleAxis;
      return r === e ? this._radiusAxis : e;
    }, t.prototype.getBaseAxis = function() {
      return this.getAxesByScale("ordinal")[0] || this.getAxesByScale("time")[0] || this.getAngleAxis();
    }, t.prototype.getTooltipAxes = function(r) {
      var e = r != null && r !== "auto" ? this.getAxis(r) : this.getBaseAxis();
      return {
        baseAxes: [e],
        otherAxes: [this.getOtherAxis(e)]
      };
    }, t.prototype.dataToPoint = function(r, e) {
      return this.coordToPoint([this._radiusAxis.dataToRadius(r[0], e), this._angleAxis.dataToAngle(r[1], e)]);
    }, t.prototype.pointToData = function(r, e) {
      var n = this.pointToCoord(r);
      return [this._radiusAxis.radiusToData(n[0], e), this._angleAxis.angleToData(n[1], e)];
    }, t.prototype.pointToCoord = function(r) {
      var e = r[0] - this.cx, n = r[1] - this.cy, i = this.getAngleAxis(), a = i.getExtent(), o = Math.min(a[0], a[1]), s = Math.max(a[0], a[1]);
      i.inverse ? o = s - 360 : s = o + 360;
      var l = Math.sqrt(e * e + n * n);
      e /= l, n /= l;
      for (var u = Math.atan2(-n, e) / Math.PI * 180, c = u < o ? 1 : -1; u < o || u > s; )
        u += c * 360;
      return [l, u];
    }, t.prototype.coordToPoint = function(r) {
      var e = r[0], n = r[1] / 180 * Math.PI, i = Math.cos(n) * e + this.cx, a = -Math.sin(n) * e + this.cy;
      return [i, a];
    }, t.prototype.getArea = function() {
      var r = this.getAngleAxis(), e = this.getRadiusAxis(), n = e.getExtent().slice();
      n[0] > n[1] && n.reverse();
      var i = r.getExtent(), a = Math.PI / 180;
      return {
        cx: this.cx,
        cy: this.cy,
        r0: n[0],
        r: n[1],
        startAngle: -i[0] * a,
        endAngle: -i[1] * a,
        clockwise: r.inverse,
        contain: function(o, s) {
          var l = o - this.cx, u = s - this.cy, c = l * l + u * u - 1e-4, d = this.r, f = this.r0;
          return c <= d * d && c >= f * f;
        }
      };
    }, t.prototype.convertToPixel = function(r, e, n) {
      var i = uM(e);
      return i === this ? this.dataToPoint(n) : null;
    }, t.prototype.convertFromPixel = function(r, e, n) {
      var i = uM(e);
      return i === this ? this.pointToData(n) : null;
    }, t;
  }()
);
function uM(t) {
  var r = t.seriesModel, e = t.polarModel;
  return e && e.coordinateSystem || r && r.coordinateSystem;
}
function fce(t, r, e) {
  var n = r.get("center"), i = e.getWidth(), a = e.getHeight();
  t.cx = he(n[0], i), t.cy = he(n[1], a);
  var o = t.getRadiusAxis(), s = Math.min(i, a) / 2, l = r.get("radius");
  l == null ? l = [0, "100%"] : ue(l) || (l = [0, l]);
  var u = [he(l[0], s), he(l[1], s)];
  o.inverse ? o.setExtent(u[1], u[0]) : o.setExtent(u[0], u[1]);
}
function hce(t, r) {
  var e = this, n = e.getAngleAxis(), i = e.getRadiusAxis();
  if (n.scale.setExtent(1 / 0, -1 / 0), i.scale.setExtent(1 / 0, -1 / 0), t.eachSeries(function(s) {
    if (s.coordinateSystem === e) {
      var l = s.getData();
      L(Gm(l, "radius"), function(u) {
        i.scale.unionExtentFromData(l, u);
      }), L(Gm(l, "angle"), function(u) {
        n.scale.unionExtentFromData(l, u);
      });
    }
  }), zc(n.scale, n.model), zc(i.scale, i.model), n.type === "category" && !n.onBand) {
    var a = n.getExtent(), o = 360 / n.scale.count();
    n.inverse ? a[1] += o : a[1] -= o, n.setExtent(a[0], a[1]);
  }
}
function pce(t) {
  return t.mainType === "angleAxis";
}
function cM(t, r) {
  var e;
  if (t.type = r.get("type"), t.scale = Cg(r), t.onBand = r.get("boundaryGap") && t.type === "category", t.inverse = r.get("inverse"), pce(r)) {
    t.inverse = t.inverse !== r.get("clockwise");
    var n = r.get("startAngle"), i = (e = r.get("endAngle")) !== null && e !== void 0 ? e : n + (t.inverse ? -360 : 360);
    t.setExtent(n, i);
  }
  r.axis = t, t.model = r;
}
var vce = {
  dimensions: kF,
  create: function(t, r) {
    var e = [];
    return t.eachComponent("polar", function(n, i) {
      var a = new dce(i + "");
      a.update = hce;
      var o = a.getRadiusAxis(), s = a.getAngleAxis(), l = n.findAxisModel("radiusAxis"), u = n.findAxisModel("angleAxis");
      cM(o, l), cM(s, u), fce(a, n, r), e.push(a), n.coordinateSystem = a, a.model = n;
    }), t.eachSeries(function(n) {
      if (n.get("coordinateSystem") === "polar") {
        var i = n.getReferringComponents("polar", on).models[0];
        if (process.env.NODE_ENV !== "production" && !i)
          throw new Error('Polar "' + Qr(n.get("polarIndex"), n.get("polarId"), 0) + '" not found');
        n.coordinateSystem = i.coordinateSystem;
      }
    }), e;
  }
}, gce = ["axisLine", "axisLabel", "axisTick", "minorTick", "splitLine", "minorSplitLine", "splitArea"];
function Z1(t, r, e) {
  r[1] > r[0] && (r = r.slice().reverse());
  var n = t.coordToPoint([r[0], e]), i = t.coordToPoint([r[1], e]);
  return {
    x1: n[0],
    y1: n[1],
    x2: i[0],
    y2: i[1]
  };
}
function j1(t) {
  var r = t.getRadiusAxis();
  return r.inverse ? 0 : 1;
}
function dM(t) {
  var r = t[0], e = t[t.length - 1];
  r && e && Math.abs(Math.abs(r.coord - e.coord) - 360) < 1e-4 && t.pop();
}
var mce = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e.axisPointerClass = "PolarAxisPointer", e;
    }
    return r.prototype.render = function(e, n) {
      if (this.group.removeAll(), !!e.get("show")) {
        var i = e.axis, a = i.polar, o = a.getRadiusAxis().getExtent(), s = i.getTicksCoords(), l = i.getMinorTicksCoords(), u = ce(i.getViewLabels(), function(c) {
          c = Ge(c);
          var d = i.scale, f = d.type === "ordinal" ? d.getRawOrdinalNumber(c.tickValue) : c.tickValue;
          return c.coord = i.dataToCoord(f), c;
        });
        dM(u), dM(s), L(gce, function(c) {
          e.get([c, "show"]) && (!i.scale.isBlank() || c === "axisLine") && yce[c](this.group, e, a, s, l, o, u);
        }, this);
      }
    }, r.type = "angleAxis", r;
  }(nd)
), yce = {
  axisLine: function(t, r, e, n, i, a) {
    var o = r.getModel(["axisLine", "lineStyle"]), s = e.getAngleAxis(), l = Math.PI / 180, u = s.getExtent(), c = j1(e), d = c ? 0 : 1, f, h = Math.abs(u[1] - u[0]) === 360 ? "Circle" : "Arc";
    a[d] === 0 ? f = new qc[h]({
      shape: {
        cx: e.cx,
        cy: e.cy,
        r: a[c],
        startAngle: -u[0] * l,
        endAngle: -u[1] * l,
        clockwise: s.inverse
      },
      style: o.getLineStyle(),
      z2: 1,
      silent: !0
    }) : f = new eh({
      shape: {
        cx: e.cx,
        cy: e.cy,
        r: a[c],
        r0: a[d]
      },
      style: o.getLineStyle(),
      z2: 1,
      silent: !0
    }), f.style.fill = null, t.add(f);
  },
  axisTick: function(t, r, e, n, i, a) {
    var o = r.getModel("axisTick"), s = (o.get("inside") ? -1 : 1) * o.get("length"), l = a[j1(e)], u = ce(n, function(c) {
      return new gn({
        shape: Z1(e, [l, l + s], c.coord)
      });
    });
    t.add(Yi(u, {
      style: Ee(o.getModel("lineStyle").getLineStyle(), {
        stroke: r.get(["axisLine", "lineStyle", "color"])
      })
    }));
  },
  minorTick: function(t, r, e, n, i, a) {
    if (i.length) {
      for (var o = r.getModel("axisTick"), s = r.getModel("minorTick"), l = (o.get("inside") ? -1 : 1) * s.get("length"), u = a[j1(e)], c = [], d = 0; d < i.length; d++)
        for (var f = 0; f < i[d].length; f++)
          c.push(new gn({
            shape: Z1(e, [u, u + l], i[d][f].coord)
          }));
      t.add(Yi(c, {
        style: Ee(s.getModel("lineStyle").getLineStyle(), Ee(o.getLineStyle(), {
          stroke: r.get(["axisLine", "lineStyle", "color"])
        }))
      }));
    }
  },
  axisLabel: function(t, r, e, n, i, a, o) {
    var s = r.getCategories(!0), l = r.getModel("axisLabel"), u = l.get("margin"), c = r.get("triggerEvent");
    L(o, function(d, f) {
      var h = l, p = d.tickValue, v = a[j1(e)], g = e.coordToPoint([v + u, d.coord]), m = e.cx, y = e.cy, b = Math.abs(g[0] - m) / v < 0.3 ? "center" : g[0] > m ? "left" : "right", C = Math.abs(g[1] - y) / v < 0.3 ? "middle" : g[1] > y ? "top" : "bottom";
      if (s && s[p]) {
        var w = s[p];
        Me(w) && w.textStyle && (h = new Pt(w.textStyle, l, l.ecModel));
      }
      var _ = new _t({
        silent: wi.isLabelSilent(r),
        style: fr(h, {
          x: g[0],
          y: g[1],
          fill: h.getTextColor() || r.get(["axisLine", "lineStyle", "color"]),
          text: d.formattedLabel,
          align: b,
          verticalAlign: C
        })
      });
      if (t.add(_), c) {
        var x = wi.makeAxisEventDataBase(r);
        x.targetType = "axisLabel", x.value = d.rawLabel, Ze(_).eventData = x;
      }
    }, this);
  },
  splitLine: function(t, r, e, n, i, a) {
    var o = r.getModel("splitLine"), s = o.getModel("lineStyle"), l = s.get("color"), u = 0;
    l = l instanceof Array ? l : [l];
    for (var c = [], d = 0; d < n.length; d++) {
      var f = u++ % l.length;
      c[f] = c[f] || [], c[f].push(new gn({
        shape: Z1(e, a, n[d].coord)
      }));
    }
    for (var d = 0; d < c.length; d++)
      t.add(Yi(c[d], {
        style: Ee({
          stroke: l[d % l.length]
        }, s.getLineStyle()),
        silent: !0,
        z: r.get("z")
      }));
  },
  minorSplitLine: function(t, r, e, n, i, a) {
    if (i.length) {
      for (var o = r.getModel("minorSplitLine"), s = o.getModel("lineStyle"), l = [], u = 0; u < i.length; u++)
        for (var c = 0; c < i[u].length; c++)
          l.push(new gn({
            shape: Z1(e, a, i[u][c].coord)
          }));
      t.add(Yi(l, {
        style: s.getLineStyle(),
        silent: !0,
        z: r.get("z")
      }));
    }
  },
  splitArea: function(t, r, e, n, i, a) {
    if (n.length) {
      var o = r.getModel("splitArea"), s = o.getModel("areaStyle"), l = s.get("color"), u = 0;
      l = l instanceof Array ? l : [l];
      for (var c = [], d = Math.PI / 180, f = -n[0].coord * d, h = Math.min(a[0], a[1]), p = Math.max(a[0], a[1]), v = r.get("clockwise"), g = 1, m = n.length; g <= m; g++) {
        var y = g === m ? n[0].coord : n[g].coord, b = u++ % l.length;
        c[b] = c[b] || [], c[b].push(new oi({
          shape: {
            cx: e.cx,
            cy: e.cy,
            r0: h,
            r: p,
            startAngle: f,
            endAngle: -y * d,
            clockwise: v
          },
          silent: !0
        })), f = -y * d;
      }
      for (var g = 0; g < c.length; g++)
        t.add(Yi(c[g], {
          style: Ee({
            fill: l[g % l.length]
          }, s.getAreaStyle()),
          silent: !0
        }));
    }
  }
}, bce = ["axisLine", "axisTickLabel", "axisName"], Cce = ["splitLine", "splitArea", "minorSplitLine"], wce = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e.axisPointerClass = "PolarAxisPointer", e;
    }
    return r.prototype.render = function(e, n) {
      if (this.group.removeAll(), !!e.get("show")) {
        var i = this._axisGroup, a = this._axisGroup = new ze();
        this.group.add(a);
        var o = e.axis, s = o.polar, l = s.getAngleAxis(), u = o.getTicksCoords(), c = o.getMinorTicksCoords(), d = l.getExtent()[0], f = o.getExtent(), h = xce(s, e, d), p = new wi(e, h);
        L(bce, p.add, p), a.add(p.getGroup()), mg(i, a, e), L(Cce, function(v) {
          e.get([v, "show"]) && !o.scale.isBlank() && _ce[v](this.group, e, s, d, f, u, c);
        }, this);
      }
    }, r.type = "radiusAxis", r;
  }(nd)
), _ce = {
  splitLine: function(t, r, e, n, i, a) {
    var o = r.getModel("splitLine"), s = o.getModel("lineStyle"), l = s.get("color"), u = 0, c = e.getAngleAxis(), d = Math.PI / 180, f = c.getExtent(), h = Math.abs(f[1] - f[0]) === 360 ? "Circle" : "Arc";
    l = l instanceof Array ? l : [l];
    for (var p = [], v = 0; v < a.length; v++) {
      var g = u++ % l.length;
      p[g] = p[g] || [], p[g].push(new qc[h]({
        shape: {
          cx: e.cx,
          cy: e.cy,
          // ensure circle radius >= 0
          r: Math.max(a[v].coord, 0),
          startAngle: -f[0] * d,
          endAngle: -f[1] * d,
          clockwise: c.inverse
        }
      }));
    }
    for (var v = 0; v < p.length; v++)
      t.add(Yi(p[v], {
        style: Ee({
          stroke: l[v % l.length],
          fill: null
        }, s.getLineStyle()),
        silent: !0
      }));
  },
  minorSplitLine: function(t, r, e, n, i, a, o) {
    if (o.length) {
      for (var s = r.getModel("minorSplitLine"), l = s.getModel("lineStyle"), u = [], c = 0; c < o.length; c++)
        for (var d = 0; d < o[c].length; d++)
          u.push(new is({
            shape: {
              cx: e.cx,
              cy: e.cy,
              r: o[c][d].coord
            }
          }));
      t.add(Yi(u, {
        style: Ee({
          fill: null
        }, l.getLineStyle()),
        silent: !0
      }));
    }
  },
  splitArea: function(t, r, e, n, i, a) {
    if (a.length) {
      var o = r.getModel("splitArea"), s = o.getModel("areaStyle"), l = s.get("color"), u = 0;
      l = l instanceof Array ? l : [l];
      for (var c = [], d = a[0].coord, f = 1; f < a.length; f++) {
        var h = u++ % l.length;
        c[h] = c[h] || [], c[h].push(new oi({
          shape: {
            cx: e.cx,
            cy: e.cy,
            r0: d,
            r: a[f].coord,
            startAngle: 0,
            endAngle: Math.PI * 2
          },
          silent: !0
        })), d = a[f].coord;
      }
      for (var f = 0; f < c.length; f++)
        t.add(Yi(c[f], {
          style: Ee({
            fill: l[f % l.length]
          }, s.getAreaStyle()),
          silent: !0
        }));
    }
  }
};
function xce(t, r, e) {
  return {
    position: [t.cx, t.cy],
    rotation: e / 180 * Math.PI,
    labelDirection: -1,
    tickDirection: -1,
    nameDirection: 1,
    labelRotate: r.getModel("axisLabel").get("rotate"),
    // Over splitLine and splitArea
    z2: 1
  };
}
function PF(t) {
  return t.get("stack") || "__ec_stack_" + t.seriesIndex;
}
function NF(t, r) {
  return r.dim + t.model.componentIndex;
}
function Sce(t, r, e) {
  var n = {}, i = Ice(Wt(r.getSeriesByType(t), function(a) {
    return !r.isSeriesFiltered(a) && a.coordinateSystem && a.coordinateSystem.type === "polar";
  }));
  r.eachSeriesByType(t, function(a) {
    if (a.coordinateSystem.type === "polar") {
      var o = a.getData(), s = a.coordinateSystem, l = s.getBaseAxis(), u = NF(s, l), c = PF(a), d = i[u][c], f = d.offset, h = d.width, p = s.getOtherAxis(l), v = a.coordinateSystem.cx, g = a.coordinateSystem.cy, m = a.get("barMinHeight") || 0, y = a.get("barMinAngle") || 0;
      n[c] = n[c] || [];
      for (var b = o.mapDimension(p.dim), C = o.mapDimension(l.dim), w = Js(
        o,
        b
        /* , baseDim */
      ), _ = l.dim !== "radius" || !a.get("roundCap", !0), x = p.model, I = x.get("startValue"), D = p.dataToCoord(I || 0), T = 0, A = o.count(); T < A; T++) {
        var M = o.get(b, T), R = o.get(C, T), E = M >= 0 ? "p" : "n", k = D;
        w && (n[c][R] || (n[c][R] = {
          p: D,
          n: D
          // Negative stack
        }), k = n[c][R][E]);
        var P = void 0, N = void 0, O = void 0, W = void 0;
        if (p.dim === "radius") {
          var V = p.dataToCoord(M) - D, B = l.dataToCoord(R);
          Math.abs(V) < m && (V = (V < 0 ? -1 : 1) * m), P = k, N = k + V, O = B - f, W = O - h, w && (n[c][R][E] = N);
        } else {
          var Z = p.dataToCoord(M, _) - D, q = l.dataToCoord(R);
          Math.abs(Z) < y && (Z = (Z < 0 ? -1 : 1) * y), P = q + f, N = P + h, O = k, W = k + Z, w && (n[c][R][E] = W);
        }
        o.setItemLayout(T, {
          cx: v,
          cy: g,
          r0: P,
          r: N,
          // Consider that positive angle is anti-clockwise,
          // while positive radian of sector is clockwise
          startAngle: -O * Math.PI / 180,
          endAngle: -W * Math.PI / 180,
          /**
           * Keep the same logic with bar in catesion: use end value to
           * control direction. Notice that if clockwise is true (by
           * default), the sector will always draw clockwisely, no matter
           * whether endAngle is greater or less than startAngle.
           */
          clockwise: O >= W
        });
      }
    }
  });
}
function Ice(t) {
  var r = {};
  L(t, function(n, i) {
    var a = n.getData(), o = n.coordinateSystem, s = o.getBaseAxis(), l = NF(o, s), u = s.getExtent(), c = s.type === "category" ? s.getBandWidth() : Math.abs(u[1] - u[0]) / a.count(), d = r[l] || {
      bandWidth: c,
      remainedWidth: c,
      autoWidthCount: 0,
      categoryGap: "20%",
      gap: "30%",
      stacks: {}
    }, f = d.stacks;
    r[l] = d;
    var h = PF(n);
    f[h] || d.autoWidthCount++, f[h] = f[h] || {
      width: 0,
      maxWidth: 0
    };
    var p = he(n.get("barWidth"), c), v = he(n.get("barMaxWidth"), c), g = n.get("barGap"), m = n.get("barCategoryGap");
    p && !f[h].width && (p = Math.min(d.remainedWidth, p), f[h].width = p, d.remainedWidth -= p), v && (f[h].maxWidth = v), g != null && (d.gap = g), m != null && (d.categoryGap = m);
  });
  var e = {};
  return L(r, function(n, i) {
    e[i] = {};
    var a = n.stacks, o = n.bandWidth, s = he(n.categoryGap, o), l = he(n.gap, 1), u = n.remainedWidth, c = n.autoWidthCount, d = (u - s) / (c + (c - 1) * l);
    d = Math.max(d, 0), L(a, function(v, g) {
      var m = v.maxWidth;
      m && m < d && (m = Math.min(m, u), v.width && (m = Math.min(m, v.width)), u -= m, v.width = m, c--);
    }), d = (u - s) / (c + (c - 1) * l), d = Math.max(d, 0);
    var f = 0, h;
    L(a, function(v, g) {
      v.width || (v.width = d), h = v, f += v.width * (1 + l);
    }), h && (f -= h.width * l);
    var p = -f / 2;
    L(a, function(v, g) {
      e[i][g] = e[i][g] || {
        offset: p,
        width: v.width
      }, p += v.width * (1 + l);
    });
  }), e;
}
var Ace = {
  startAngle: 90,
  clockwise: !0,
  splitNumber: 12,
  axisLabel: {
    rotate: 0
  }
}, Dce = {
  splitNumber: 5
}, Tce = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.type = "polar", r;
  }(yr)
);
function Mce(t) {
  lt(Mg), nd.registerAxisPointerClass("PolarAxisPointer", ice), t.registerCoordinateSystem("polar", vce), t.registerComponentModel(sce), t.registerComponentView(Tce), kf(t, "angle", lce, Ace), kf(t, "radius", uce, Dce), t.registerComponentView(mce), t.registerComponentView(wce), t.registerLayout(Ye(Sce, "bar"));
}
function Z9(t, r) {
  r = r || {};
  var e = t.coordinateSystem, n = t.axis, i = {}, a = n.position, o = n.orient, s = e.getRect(), l = [s.x, s.x + s.width, s.y, s.y + s.height], u = {
    horizontal: {
      top: l[2],
      bottom: l[3]
    },
    vertical: {
      left: l[0],
      right: l[1]
    }
  };
  i.position = [o === "vertical" ? u.vertical[a] : l[0], o === "horizontal" ? u.horizontal[a] : l[3]];
  var c = {
    horizontal: 0,
    vertical: 1
  };
  i.rotation = Math.PI / 2 * c[o];
  var d = {
    top: -1,
    bottom: 1,
    right: 1,
    left: -1
  };
  i.labelDirection = i.tickDirection = i.nameDirection = d[a], t.get(["axisTick", "inside"]) && (i.tickDirection = -i.tickDirection), Qr(r.labelInside, t.get(["axisLabel", "inside"])) && (i.labelDirection = -i.labelDirection);
  var f = r.rotate;
  return f == null && (f = t.get(["axisLabel", "rotate"])), i.labelRotation = a === "top" ? -f : f, i.z2 = 1, i;
}
var Rce = ["axisLine", "axisTickLabel", "axisName"], Lce = ["splitArea", "splitLine"], Ece = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e.axisPointerClass = "SingleAxisPointer", e;
    }
    return r.prototype.render = function(e, n, i, a) {
      var o = this.group;
      o.removeAll();
      var s = this._axisGroup;
      this._axisGroup = new ze();
      var l = Z9(e), u = new wi(e, l);
      L(Rce, u.add, u), o.add(this._axisGroup), o.add(u.getGroup()), L(Lce, function(c) {
        e.get([c, "show"]) && kce[c](this, this.group, this._axisGroup, e);
      }, this), mg(s, this._axisGroup, e), t.prototype.render.call(this, e, n, i, a);
    }, r.prototype.remove = function() {
      rB(this);
    }, r.type = "singleAxis", r;
  }(nd)
), kce = {
  splitLine: function(t, r, e, n) {
    var i = n.axis;
    if (!i.scale.isBlank()) {
      var a = n.getModel("splitLine"), o = a.getModel("lineStyle"), s = o.get("color");
      s = s instanceof Array ? s : [s];
      for (var l = o.get("width"), u = n.coordinateSystem.getRect(), c = i.isHorizontal(), d = [], f = 0, h = i.getTicksCoords({
        tickModel: a
      }), p = [], v = [], g = 0; g < h.length; ++g) {
        var m = i.toGlobalCoord(h[g].coord);
        c ? (p[0] = m, p[1] = u.y, v[0] = m, v[1] = u.y + u.height) : (p[0] = u.x, p[1] = m, v[0] = u.x + u.width, v[1] = m);
        var y = new gn({
          shape: {
            x1: p[0],
            y1: p[1],
            x2: v[0],
            y2: v[1]
          },
          silent: !0
        });
        Mf(y.shape, l);
        var b = f++ % s.length;
        d[b] = d[b] || [], d[b].push(y);
      }
      for (var C = o.getLineStyle(["color"]), g = 0; g < d.length; ++g)
        r.add(Yi(d[g], {
          style: Ee({
            stroke: s[g % s.length]
          }, C),
          silent: !0
        }));
    }
  },
  splitArea: function(t, r, e, n) {
    tB(t, e, n, n);
  }
}, G0 = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.getCoordSysModel = function() {
      return this;
    }, r.type = "singleAxis", r.layoutMode = "box", r.defaultOption = {
      left: "5%",
      top: "5%",
      right: "5%",
      bottom: "5%",
      type: "value",
      position: "bottom",
      orient: "horizontal",
      axisLine: {
        show: !0,
        lineStyle: {
          width: 1,
          type: "solid"
        }
      },
      // Single coordinate system and single axis is the,
      // which is used as the parent tooltip model.
      // same model, so we set default tooltip show as true.
      tooltip: {
        show: !0
      },
      axisTick: {
        show: !0,
        length: 6,
        lineStyle: {
          width: 1
        }
      },
      axisLabel: {
        show: !0,
        interval: "auto"
      },
      splitLine: {
        show: !0,
        lineStyle: {
          type: "dashed",
          opacity: 0.2
        }
      }
    }, r;
  }(st)
);
Xr(G0, vh.prototype);
var Pce = (
  /** @class */
  function(t) {
    ee(r, t);
    function r(e, n, i, a, o) {
      var s = t.call(this, e, n, i) || this;
      return s.type = a || "value", s.position = o || "bottom", s;
    }
    return r.prototype.isHorizontal = function() {
      var e = this.position;
      return e === "top" || e === "bottom";
    }, r.prototype.pointToData = function(e, n) {
      return this.coordinateSystem.pointToData(e)[0];
    }, r;
  }(Va)
), OF = ["single"], Nce = (
  /** @class */
  function() {
    function t(r, e, n) {
      this.type = "single", this.dimension = "single", this.dimensions = OF, this.axisPointerEnabled = !0, this.model = r, this._init(r, e, n);
    }
    return t.prototype._init = function(r, e, n) {
      var i = this.dimension, a = new Pce(i, Cg(r), [0, 0], r.get("type"), r.get("position")), o = a.type === "category";
      a.onBand = o && r.get("boundaryGap"), a.inverse = r.get("inverse"), a.orient = r.get("orient"), r.axis = a, a.model = r, a.coordinateSystem = this, this._axis = a;
    }, t.prototype.update = function(r, e) {
      r.eachSeries(function(n) {
        if (n.coordinateSystem === this) {
          var i = n.getData();
          L(i.mapDimensionsAll(this.dimension), function(a) {
            this._axis.scale.unionExtentFromData(i, a);
          }, this), zc(this._axis.scale, this._axis.model);
        }
      }, this);
    }, t.prototype.resize = function(r, e) {
      this._rect = cn({
        left: r.get("left"),
        top: r.get("top"),
        right: r.get("right"),
        bottom: r.get("bottom"),
        width: r.get("width"),
        height: r.get("height")
      }, {
        width: e.getWidth(),
        height: e.getHeight()
      }), this._adjustAxis();
    }, t.prototype.getRect = function() {
      return this._rect;
    }, t.prototype._adjustAxis = function() {
      var r = this._rect, e = this._axis, n = e.isHorizontal(), i = n ? [0, r.width] : [0, r.height], a = e.inverse ? 1 : 0;
      e.setExtent(i[a], i[1 - a]), this._updateAxisTransform(e, n ? r.x : r.y);
    }, t.prototype._updateAxisTransform = function(r, e) {
      var n = r.getExtent(), i = n[0] + n[1], a = r.isHorizontal();
      r.toGlobalCoord = a ? function(o) {
        return o + e;
      } : function(o) {
        return i - o + e;
      }, r.toLocalCoord = a ? function(o) {
        return o - e;
      } : function(o) {
        return i - o + e;
      };
    }, t.prototype.getAxis = function() {
      return this._axis;
    }, t.prototype.getBaseAxis = function() {
      return this._axis;
    }, t.prototype.getAxes = function() {
      return [this._axis];
    }, t.prototype.getTooltipAxes = function() {
      return {
        baseAxes: [this.getAxis()],
        // Empty otherAxes
        otherAxes: []
      };
    }, t.prototype.containPoint = function(r) {
      var e = this.getRect(), n = this.getAxis(), i = n.orient;
      return i === "horizontal" ? n.contain(n.toLocalCoord(r[0])) && r[1] >= e.y && r[1] <= e.y + e.height : n.contain(n.toLocalCoord(r[1])) && r[0] >= e.y && r[0] <= e.y + e.height;
    }, t.prototype.pointToData = function(r) {
      var e = this.getAxis();
      return [e.coordToData(e.toLocalCoord(r[e.orient === "horizontal" ? 0 : 1]))];
    }, t.prototype.dataToPoint = function(r) {
      var e = this.getAxis(), n = this.getRect(), i = [], a = e.orient === "horizontal" ? 0 : 1;
      return r instanceof Array && (r = r[0]), i[a] = e.toGlobalCoord(e.dataToCoord(+r)), i[1 - a] = a === 0 ? n.y + n.height / 2 : n.x + n.width / 2, i;
    }, t.prototype.convertToPixel = function(r, e, n) {
      var i = fM(e);
      return i === this ? this.dataToPoint(n) : null;
    }, t.prototype.convertFromPixel = function(r, e, n) {
      var i = fM(e);
      return i === this ? this.pointToData(n) : null;
    }, t;
  }()
);
function fM(t) {
  var r = t.seriesModel, e = t.singleAxisModel;
  return e && e.coordinateSystem || r && r.coordinateSystem;
}
function Oce(t, r) {
  var e = [];
  return t.eachComponent("singleAxis", function(n, i) {
    var a = new Nce(n, t, r);
    a.name = "single_" + i, a.resize(n, r), n.coordinateSystem = a, e.push(a);
  }), t.eachSeries(function(n) {
    if (n.get("coordinateSystem") === "singleAxis") {
      var i = n.getReferringComponents("singleAxis", on).models[0];
      n.coordinateSystem = i && i.coordinateSystem;
    }
  }), e;
}
var Vce = {
  create: Oce,
  dimensions: OF
}, hM = ["x", "y"], Gce = ["width", "height"], Bce = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return r.prototype.makeElOption = function(e, n, i, a, o) {
      var s = i.axis, l = s.coordinateSystem, u = M3(l, 1 - ey(s)), c = l.dataToPoint(n)[0], d = a.get("type");
      if (d && d !== "none") {
        var f = b_(a), h = Fce[d](s, c, u);
        h.style = f, e.graphicKey = h.type, e.pointer = h;
      }
      var p = Z9(i);
      MF(
        // @ts-ignore
        n,
        e,
        p,
        i,
        a,
        o
      );
    }, r.prototype.getHandleTransform = function(e, n, i) {
      var a = Z9(n, {
        labelInside: !1
      });
      a.labelMargin = i.get(["handle", "margin"]);
      var o = C_(n.axis, e, a);
      return {
        x: o[0],
        y: o[1],
        rotation: a.rotation + (a.labelDirection < 0 ? Math.PI : 0)
      };
    }, r.prototype.updateHandleTransform = function(e, n, i, a) {
      var o = i.axis, s = o.coordinateSystem, l = ey(o), u = M3(s, l), c = [e.x, e.y];
      c[l] += n[l], c[l] = Math.min(u[1], c[l]), c[l] = Math.max(u[0], c[l]);
      var d = M3(s, 1 - l), f = (d[1] + d[0]) / 2, h = [f, f];
      return h[l] = c[l], {
        x: c[0],
        y: c[1],
        rotation: e.rotation,
        cursorPoint: h,
        tooltipOption: {
          verticalAlign: "middle"
        }
      };
    }, r;
  }(y_)
), Fce = {
  line: function(t, r, e) {
    var n = w_([r, e[0]], [r, e[1]], ey(t));
    return {
      type: "Line",
      subPixelOptimize: !0,
      shape: n
    };
  },
  shadow: function(t, r, e) {
    var n = t.getBandWidth(), i = e[1] - e[0];
    return {
      type: "Rect",
      shape: RF([r - n / 2, e[0]], [n, i], ey(t))
    };
  }
};
function ey(t) {
  return t.isHorizontal() ? 0 : 1;
}
function M3(t, r) {
  var e = t.getRect();
  return [e[hM[r]], e[hM[r]] + e[Gce[r]]];
}
var Hce = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.type = "single", r;
  }(yr)
);
function zce(t) {
  lt(Mg), nd.registerAxisPointerClass("SingleAxisPointer", Bce), t.registerComponentView(Hce), t.registerComponentView(Ece), t.registerComponentModel(G0), kf(t, "single", G0, G0.defaultOption), t.registerCoordinateSystem("single", Vce);
}
var Wce = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.init = function(e, n, i) {
      var a = lh(e);
      t.prototype.init.apply(this, arguments), pM(e, a);
    }, r.prototype.mergeOption = function(e) {
      t.prototype.mergeOption.apply(this, arguments), pM(this.option, e);
    }, r.prototype.getCellSize = function() {
      return this.option.cellSize;
    }, r.type = "calendar", r.defaultOption = {
      // zlevel: 0,
      z: 2,
      left: 80,
      top: 60,
      cellSize: 20,
      // horizontal vertical
      orient: "horizontal",
      // month separate line style
      splitLine: {
        show: !0,
        lineStyle: {
          color: "#000",
          width: 1,
          type: "solid"
        }
      },
      // rect style  temporarily unused emphasis
      itemStyle: {
        color: "#fff",
        borderWidth: 1,
        borderColor: "#ccc"
      },
      // week text style
      dayLabel: {
        show: !0,
        firstDay: 0,
        // start end
        position: "start",
        margin: "50%",
        color: "#000"
      },
      // month text style
      monthLabel: {
        show: !0,
        // start end
        position: "start",
        margin: 5,
        // center or left
        align: "center",
        formatter: null,
        color: "#000"
      },
      // year text style
      yearLabel: {
        show: !0,
        // top bottom left right
        position: null,
        margin: 30,
        formatter: null,
        color: "#ccc",
        fontFamily: "sans-serif",
        fontWeight: "bolder",
        fontSize: 20
      }
    }, r;
  }(st)
);
function pM(t, r) {
  var e = t.cellSize, n;
  ue(e) ? n = e : n = t.cellSize = [e, e], n.length === 1 && (n[1] = n[0]);
  var i = ce([0, 1], function(a) {
    return YJ(r, a) && (n[a] = "auto"), n[a] != null && n[a] !== "auto";
  });
  ru(t, r, {
    type: "box",
    ignoreSize: i
  });
}
var Zce = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.render = function(e, n, i) {
      var a = this.group;
      a.removeAll();
      var o = e.coordinateSystem, s = o.getRangeInfo(), l = o.getOrient(), u = n.getLocaleModel();
      this._renderDayRect(e, s, a), this._renderLines(e, s, l, a), this._renderYearText(e, s, l, a), this._renderMonthText(e, u, l, a), this._renderWeekText(e, u, s, l, a);
    }, r.prototype._renderDayRect = function(e, n, i) {
      for (var a = e.coordinateSystem, o = e.getModel("itemStyle").getItemStyle(), s = a.getCellWidth(), l = a.getCellHeight(), u = n.start.time; u <= n.end.time; u = a.getNextNDay(u, 1).time) {
        var c = a.dataToRect([u], !1).tl, d = new xt({
          shape: {
            x: c[0],
            y: c[1],
            width: s,
            height: l
          },
          cursor: "default",
          style: o
        });
        i.add(d);
      }
    }, r.prototype._renderLines = function(e, n, i, a) {
      var o = this, s = e.coordinateSystem, l = e.getModel(["splitLine", "lineStyle"]).getLineStyle(), u = e.get(["splitLine", "show"]), c = l.lineWidth;
      this._tlpoints = [], this._blpoints = [], this._firstDayOfMonth = [], this._firstDayPoints = [];
      for (var d = n.start, f = 0; d.time <= n.end.time; f++) {
        p(d.formatedDate), f === 0 && (d = s.getDateInfo(n.start.y + "-" + n.start.m));
        var h = d.date;
        h.setMonth(h.getMonth() + 1), d = s.getDateInfo(h);
      }
      p(s.getNextNDay(n.end.time, 1).formatedDate);
      function p(v) {
        o._firstDayOfMonth.push(s.getDateInfo(v)), o._firstDayPoints.push(s.dataToRect([v], !1).tl);
        var g = o._getLinePointsOfOneWeek(e, v, i);
        o._tlpoints.push(g[0]), o._blpoints.push(g[g.length - 1]), u && o._drawSplitline(g, l, a);
      }
      u && this._drawSplitline(o._getEdgesPoints(o._tlpoints, c, i), l, a), u && this._drawSplitline(o._getEdgesPoints(o._blpoints, c, i), l, a);
    }, r.prototype._getEdgesPoints = function(e, n, i) {
      var a = [e[0].slice(), e[e.length - 1].slice()], o = i === "horizontal" ? 0 : 1;
      return a[0][o] = a[0][o] - n / 2, a[1][o] = a[1][o] + n / 2, a;
    }, r.prototype._drawSplitline = function(e, n, i) {
      var a = new ci({
        z2: 20,
        shape: {
          points: e
        },
        style: n
      });
      i.add(a);
    }, r.prototype._getLinePointsOfOneWeek = function(e, n, i) {
      for (var a = e.coordinateSystem, o = a.getDateInfo(n), s = [], l = 0; l < 7; l++) {
        var u = a.getNextNDay(o.time, l), c = a.dataToRect([u.time], !1);
        s[2 * u.day] = c.tl, s[2 * u.day + 1] = c[i === "horizontal" ? "bl" : "tr"];
      }
      return s;
    }, r.prototype._formatterLabel = function(e, n) {
      return pe(e) && e ? zJ(e, n) : Ae(e) ? e(n) : n.nameMap;
    }, r.prototype._yearTextPositionControl = function(e, n, i, a, o) {
      var s = n[0], l = n[1], u = ["center", "bottom"];
      a === "bottom" ? (l += o, u = ["center", "top"]) : a === "left" ? s -= o : a === "right" ? (s += o, u = ["center", "top"]) : l -= o;
      var c = 0;
      return (a === "left" || a === "right") && (c = Math.PI / 2), {
        rotation: c,
        x: s,
        y: l,
        style: {
          align: u[0],
          verticalAlign: u[1]
        }
      };
    }, r.prototype._renderYearText = function(e, n, i, a) {
      var o = e.getModel("yearLabel");
      if (o.get("show")) {
        var s = o.get("margin"), l = o.get("position");
        l || (l = i !== "horizontal" ? "top" : "left");
        var u = [this._tlpoints[this._tlpoints.length - 1], this._blpoints[0]], c = (u[0][0] + u[1][0]) / 2, d = (u[0][1] + u[1][1]) / 2, f = i === "horizontal" ? 0 : 1, h = {
          top: [c, u[f][1]],
          bottom: [c, u[1 - f][1]],
          left: [u[1 - f][0], d],
          right: [u[f][0], d]
        }, p = n.start.y;
        +n.end.y > +n.start.y && (p = p + "-" + n.end.y);
        var v = o.get("formatter"), g = {
          start: n.start.y,
          end: n.end.y,
          nameMap: p
        }, m = this._formatterLabel(v, g), y = new _t({
          z2: 30,
          style: fr(o, {
            text: m
          })
        });
        y.attr(this._yearTextPositionControl(y, h[l], i, l, s)), a.add(y);
      }
    }, r.prototype._monthTextPositionControl = function(e, n, i, a, o) {
      var s = "left", l = "top", u = e[0], c = e[1];
      return i === "horizontal" ? (c = c + o, n && (s = "center"), a === "start" && (l = "bottom")) : (u = u + o, n && (l = "middle"), a === "start" && (s = "right")), {
        x: u,
        y: c,
        align: s,
        verticalAlign: l
      };
    }, r.prototype._renderMonthText = function(e, n, i, a) {
      var o = e.getModel("monthLabel");
      if (o.get("show")) {
        var s = o.get("nameMap"), l = o.get("margin"), u = o.get("position"), c = o.get("align"), d = [this._tlpoints, this._blpoints];
        (!s || pe(s)) && (s && (n = KC(s) || n), s = n.get(["time", "monthAbbr"]) || []);
        var f = u === "start" ? 0 : 1, h = i === "horizontal" ? 0 : 1;
        l = u === "start" ? -l : l;
        for (var p = c === "center", v = 0; v < d[f].length - 1; v++) {
          var g = d[f][v].slice(), m = this._firstDayOfMonth[v];
          if (p) {
            var y = this._firstDayPoints[v];
            g[h] = (y[h] + d[0][v + 1][h]) / 2;
          }
          var b = o.get("formatter"), C = s[+m.m - 1], w = {
            yyyy: m.y,
            yy: (m.y + "").slice(2),
            MM: m.m,
            M: +m.m,
            nameMap: C
          }, _ = this._formatterLabel(b, w), x = new _t({
            z2: 30,
            style: ae(fr(o, {
              text: _
            }), this._monthTextPositionControl(g, p, i, u, l))
          });
          a.add(x);
        }
      }
    }, r.prototype._weekTextPositionControl = function(e, n, i, a, o) {
      var s = "center", l = "middle", u = e[0], c = e[1], d = i === "start";
      return n === "horizontal" ? (u = u + a + (d ? 1 : -1) * o[0] / 2, s = d ? "right" : "left") : (c = c + a + (d ? 1 : -1) * o[1] / 2, l = d ? "bottom" : "top"), {
        x: u,
        y: c,
        align: s,
        verticalAlign: l
      };
    }, r.prototype._renderWeekText = function(e, n, i, a, o) {
      var s = e.getModel("dayLabel");
      if (s.get("show")) {
        var l = e.coordinateSystem, u = s.get("position"), c = s.get("nameMap"), d = s.get("margin"), f = l.getFirstDayOfWeek();
        if (!c || pe(c)) {
          c && (n = KC(c) || n);
          var h = n.get(["time", "dayOfWeekShort"]);
          c = h || ce(n.get(["time", "dayOfWeekAbbr"]), function(w) {
            return w[0];
          });
        }
        var p = l.getNextNDay(i.end.time, 7 - i.lweek).time, v = [l.getCellWidth(), l.getCellHeight()];
        d = he(d, Math.min(v[1], v[0])), u === "start" && (p = l.getNextNDay(i.start.time, -(7 + i.fweek)).time, d = -d);
        for (var g = 0; g < 7; g++) {
          var m = l.getNextNDay(p, g), y = l.dataToRect([m.time], !1).center, b = g;
          b = Math.abs((g + f) % 7);
          var C = new _t({
            z2: 30,
            style: ae(fr(s, {
              text: c[b]
            }), this._weekTextPositionControl(y, a, u, d, v))
          });
          o.add(C);
        }
      }
    }, r.type = "calendar", r;
  }(yr)
), R3 = 864e5, jce = (
  /** @class */
  function() {
    function t(r, e, n) {
      this.type = "calendar", this.dimensions = t.dimensions, this.getDimensionsInfo = t.getDimensionsInfo, this._model = r;
    }
    return t.getDimensionsInfo = function() {
      return [{
        name: "time",
        type: "time"
      }, "value"];
    }, t.prototype.getRangeInfo = function() {
      return this._rangeInfo;
    }, t.prototype.getModel = function() {
      return this._model;
    }, t.prototype.getRect = function() {
      return this._rect;
    }, t.prototype.getCellWidth = function() {
      return this._sw;
    }, t.prototype.getCellHeight = function() {
      return this._sh;
    }, t.prototype.getOrient = function() {
      return this._orient;
    }, t.prototype.getFirstDayOfWeek = function() {
      return this._firstDayOfWeek;
    }, t.prototype.getDateInfo = function(r) {
      r = ra(r);
      var e = r.getFullYear(), n = r.getMonth() + 1, i = n < 10 ? "0" + n : "" + n, a = r.getDate(), o = a < 10 ? "0" + a : "" + a, s = r.getDay();
      return s = Math.abs((s + 7 - this.getFirstDayOfWeek()) % 7), {
        y: e + "",
        m: i,
        d: o,
        day: s,
        time: r.getTime(),
        formatedDate: e + "-" + i + "-" + o,
        date: r
      };
    }, t.prototype.getNextNDay = function(r, e) {
      return e = e || 0, e === 0 ? this.getDateInfo(r) : (r = new Date(this.getDateInfo(r).time), r.setDate(r.getDate() + e), this.getDateInfo(r));
    }, t.prototype.update = function(r, e) {
      this._firstDayOfWeek = +this._model.getModel("dayLabel").get("firstDay"), this._orient = this._model.get("orient"), this._lineWidth = this._model.getModel("itemStyle").getItemStyle().lineWidth || 0, this._rangeInfo = this._getRangeInfo(this._initRangeOption());
      var n = this._rangeInfo.weeks || 1, i = ["width", "height"], a = this._model.getCellSize().slice(), o = this._model.getBoxLayoutParams(), s = this._orient === "horizontal" ? [n, 7] : [7, n];
      L([0, 1], function(d) {
        c(a, d) && (o[i[d]] = a[d] * s[d]);
      });
      var l = {
        width: e.getWidth(),
        height: e.getHeight()
      }, u = this._rect = cn(o, l);
      L([0, 1], function(d) {
        c(a, d) || (a[d] = u[i[d]] / s[d]);
      });
      function c(d, f) {
        return d[f] != null && d[f] !== "auto";
      }
      this._sw = a[0], this._sh = a[1];
    }, t.prototype.dataToPoint = function(r, e) {
      ue(r) && (r = r[0]), e == null && (e = !0);
      var n = this.getDateInfo(r), i = this._rangeInfo, a = n.formatedDate;
      if (e && !(n.time >= i.start.time && n.time < i.end.time + R3))
        return [NaN, NaN];
      var o = n.day, s = this._getRangeInfo([i.start.time, a]).nthWeek;
      return this._orient === "vertical" ? [this._rect.x + o * this._sw + this._sw / 2, this._rect.y + s * this._sh + this._sh / 2] : [this._rect.x + s * this._sw + this._sw / 2, this._rect.y + o * this._sh + this._sh / 2];
    }, t.prototype.pointToData = function(r) {
      var e = this.pointToDate(r);
      return e && e.time;
    }, t.prototype.dataToRect = function(r, e) {
      var n = this.dataToPoint(r, e);
      return {
        contentShape: {
          x: n[0] - (this._sw - this._lineWidth) / 2,
          y: n[1] - (this._sh - this._lineWidth) / 2,
          width: this._sw - this._lineWidth,
          height: this._sh - this._lineWidth
        },
        center: n,
        tl: [n[0] - this._sw / 2, n[1] - this._sh / 2],
        tr: [n[0] + this._sw / 2, n[1] - this._sh / 2],
        br: [n[0] + this._sw / 2, n[1] + this._sh / 2],
        bl: [n[0] - this._sw / 2, n[1] + this._sh / 2]
      };
    }, t.prototype.pointToDate = function(r) {
      var e = Math.floor((r[0] - this._rect.x) / this._sw) + 1, n = Math.floor((r[1] - this._rect.y) / this._sh) + 1, i = this._rangeInfo.range;
      return this._orient === "vertical" ? this._getDateByWeeksAndDay(n, e - 1, i) : this._getDateByWeeksAndDay(e, n - 1, i);
    }, t.prototype.convertToPixel = function(r, e, n) {
      var i = vM(e);
      return i === this ? i.dataToPoint(n) : null;
    }, t.prototype.convertFromPixel = function(r, e, n) {
      var i = vM(e);
      return i === this ? i.pointToData(n) : null;
    }, t.prototype.containPoint = function(r) {
      return console.warn("Not implemented."), !1;
    }, t.prototype._initRangeOption = function() {
      var r = this._model.get("range"), e;
      if (ue(r) && r.length === 1 && (r = r[0]), ue(r))
        e = r;
      else {
        var n = r.toString();
        if (/^\d{4}$/.test(n) && (e = [n + "-01-01", n + "-12-31"]), /^\d{4}[\/|-]\d{1,2}$/.test(n)) {
          var i = this.getDateInfo(n), a = i.date;
          a.setMonth(a.getMonth() + 1);
          var o = this.getNextNDay(a, -1);
          e = [i.formatedDate, o.formatedDate];
        }
        /^\d{4}[\/|-]\d{1,2}[\/|-]\d{1,2}$/.test(n) && (e = [n, n]);
      }
      if (!e)
        return process.env.NODE_ENV !== "production" && Da("Invalid date range."), r;
      var s = this._getRangeInfo(e);
      return s.start.time > s.end.time && e.reverse(), e;
    }, t.prototype._getRangeInfo = function(r) {
      var e = [this.getDateInfo(r[0]), this.getDateInfo(r[1])], n;
      e[0].time > e[1].time && (n = !0, e.reverse());
      var i = Math.floor(e[1].time / R3) - Math.floor(e[0].time / R3) + 1, a = new Date(e[0].time), o = a.getDate(), s = e[1].date.getDate();
      a.setDate(o + i - 1);
      var l = a.getDate();
      if (l !== s)
        for (var u = a.getTime() - e[1].time > 0 ? 1 : -1; (l = a.getDate()) !== s && (a.getTime() - e[1].time) * u > 0; )
          i -= u, a.setDate(l - u);
      var c = Math.floor((i + e[0].day + 6) / 7), d = n ? -c + 1 : c - 1;
      return n && e.reverse(), {
        range: [e[0].formatedDate, e[1].formatedDate],
        start: e[0],
        end: e[1],
        allDay: i,
        weeks: c,
        // From 0.
        nthWeek: d,
        fweek: e[0].day,
        lweek: e[1].day
      };
    }, t.prototype._getDateByWeeksAndDay = function(r, e, n) {
      var i = this._getRangeInfo(n);
      if (r > i.weeks || r === 0 && e < i.fweek || r === i.weeks && e > i.lweek)
        return null;
      var a = (r - 1) * 7 - i.fweek + e, o = new Date(i.start.time);
      return o.setDate(+i.start.d + a), this.getDateInfo(o);
    }, t.create = function(r, e) {
      var n = [];
      return r.eachComponent("calendar", function(i) {
        var a = new t(i);
        n.push(a), i.coordinateSystem = a;
      }), r.eachSeries(function(i) {
        i.get("coordinateSystem") === "calendar" && (i.coordinateSystem = n[i.get("calendarIndex") || 0]);
      }), n;
    }, t.dimensions = ["time", "value"], t;
  }()
);
function vM(t) {
  var r = t.calendarModel, e = t.seriesModel, n = r ? r.coordinateSystem : e ? e.coordinateSystem : null;
  return n;
}
function Yce(t) {
  t.registerComponentModel(Wce), t.registerComponentView(Zce), t.registerCoordinateSystem("calendar", jce);
}
function Xce(t, r) {
  var e = t.existing;
  if (r.id = t.keyInfo.id, !r.type && e && (r.type = e.type), r.parentId == null) {
    var n = r.parentOption;
    n ? r.parentId = n.id : e && (r.parentId = e.parentId);
  }
  r.parentOption = null;
}
function gM(t, r) {
  var e;
  return L(r, function(n) {
    t[n] != null && t[n] !== "auto" && (e = !0);
  }), e;
}
function $ce(t, r, e) {
  var n = ae({}, e), i = t[r], a = e.$action || "merge";
  if (a === "merge")
    if (i) {
      if (process.env.NODE_ENV !== "production") {
        var o = e.type;
        ke(!o || i.type === o, 'Please set $action: "replace" to change `type`');
      }
      Qe(i, n, !0), ru(i, n, {
        ignoreSize: !0
      }), DO(e, i), Y1(e, i), Y1(e, i, "shape"), Y1(e, i, "style"), Y1(e, i, "extra"), e.clipPath = i.clipPath;
    } else
      t[r] = n;
  else a === "replace" ? t[r] = n : a === "remove" && i && (t[r] = null);
}
var VF = ["transition", "enterFrom", "leaveTo"], Uce = VF.concat(["enterAnimation", "updateAnimation", "leaveAnimation"]);
function Y1(t, r, e) {
  if (e && (!t[e] && r[e] && (t[e] = {}), t = t[e], r = r[e]), !(!t || !r))
    for (var n = e ? VF : Uce, i = 0; i < n.length; i++) {
      var a = n[i];
      t[a] == null && r[a] != null && (t[a] = r[a]);
    }
}
function Jce(t, r) {
  if (t && (t.hv = r.hv = [
    // Rigid body, don't care about `width`.
    gM(r, ["left", "right"]),
    // Rigid body, don't care about `height`.
    gM(r, ["top", "bottom"])
  ], t.type === "group")) {
    var e = t, n = r;
    e.width == null && (e.width = n.width = 0), e.height == null && (e.height = n.height = 0);
  }
}
var Kce = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e.preventAutoZ = !0, e;
    }
    return r.prototype.mergeOption = function(e, n) {
      var i = this.option.elements;
      this.option.elements = null, t.prototype.mergeOption.call(this, e, n), this.option.elements = i;
    }, r.prototype.optionUpdated = function(e, n) {
      var i = this.option, a = (n ? i : e).elements, o = i.elements = n ? [] : i.elements, s = [];
      this._flatten(a, s, null);
      var l = IN(o, s, "normalMerge"), u = this._elOptionsToUpdate = [];
      L(l, function(c, d) {
        var f = c.newOption;
        process.env.NODE_ENV !== "production" && ke(Me(f) || c.existing, "Empty graphic option definition"), f && (u.push(f), Xce(c, f), $ce(o, d, f), Jce(o[d], f));
      }, this), i.elements = Wt(o, function(c) {
        return c && delete c.$action, c != null;
      });
    }, r.prototype._flatten = function(e, n, i) {
      L(e, function(a) {
        if (a) {
          i && (a.parentOption = i), n.push(a);
          var o = a.children;
          o && o.length && this._flatten(o, n, a), delete a.children;
        }
      }, this);
    }, r.prototype.useElOptionsToUpdate = function() {
      var e = this._elOptionsToUpdate;
      return this._elOptionsToUpdate = null, e;
    }, r.type = "graphic", r.defaultOption = {
      elements: []
      // parentId: null
    }, r;
  }(st)
), mM = {
  // Reserved but not supported in graphic component.
  path: null,
  compoundPath: null,
  // Supported in graphic component.
  group: ze,
  image: An,
  text: _t
}, ba = It(), qce = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.init = function() {
      this._elMap = xe();
    }, r.prototype.render = function(e, n, i) {
      e !== this._lastGraphicModel && this._clear(), this._lastGraphicModel = e, this._updateElements(e), this._relocate(e, i);
    }, r.prototype._updateElements = function(e) {
      var n = e.useElOptionsToUpdate();
      if (n) {
        var i = this._elMap, a = this.group, o = e.get("z"), s = e.get("zlevel");
        L(n, function(l) {
          var u = vn(l.id, null), c = u != null ? i.get(u) : null, d = vn(l.parentId, null), f = d != null ? i.get(d) : a, h = l.type, p = l.style;
          h === "text" && p && l.hv && l.hv[1] && (p.textVerticalAlign = p.textBaseline = p.verticalAlign = p.align = null);
          var v = l.textContent, g = l.textConfig;
          if (p && gF(p, h, !!g, !!v)) {
            var m = mF(p, h, !0);
            !g && m.textConfig && (g = l.textConfig = m.textConfig), !v && m.textContent && (v = m.textContent);
          }
          var y = Qce(l);
          process.env.NODE_ENV !== "production" && c && ke(f === c.parent, "Changing parent is not supported.");
          var b = l.$action || "merge", C = b === "merge", w = b === "replace";
          if (C) {
            var _ = !c, x = c;
            _ ? x = yM(u, f, l.type, i) : (x && (ba(x).isNew = !1), _F(x)), x && (O0(x, y, e, {
              isInit: _
            }), bM(x, l, o, s));
          } else if (w) {
            B0(c, l, i, e);
            var I = yM(u, f, l.type, i);
            I && (O0(I, y, e, {
              isInit: !0
            }), bM(I, l, o, s));
          } else b === "remove" && (bF(c, l), B0(c, l, i, e));
          var D = i.get(u);
          if (D && v)
            if (C) {
              var T = D.getTextContent();
              T ? T.attr(v) : D.setTextContent(new _t(v));
            } else w && D.setTextContent(new _t(v));
          if (D) {
            var A = l.clipPath;
            if (A) {
              var M = A.type, R = void 0, _ = !1;
              if (C) {
                var E = D.getClipPath();
                _ = !E || ba(E).type !== M, R = _ ? j9(M) : E;
              } else w && (_ = !0, R = j9(M));
              D.setClipPath(R), O0(R, A, e, {
                isInit: _
              }), Km(R, A.keyframeAnimation, e);
            }
            var k = ba(D);
            D.setTextConfig(g), k.option = l, ede(D, e, l), ah({
              el: D,
              componentModel: e,
              itemName: D.name,
              itemTooltipOption: l.tooltip
            }), Km(D, l.keyframeAnimation, e);
          }
        });
      }
    }, r.prototype._relocate = function(e, n) {
      for (var i = e.option.elements, a = this.group, o = this._elMap, s = n.getWidth(), l = n.getHeight(), u = ["x", "y"], c = 0; c < i.length; c++) {
        var d = i[c], f = vn(d.id, null), h = f != null ? o.get(f) : null;
        if (!(!h || !h.isGroup)) {
          var p = h.parent, v = p === a, g = ba(h), m = ba(p);
          g.width = he(g.option.width, v ? s : m.width) || 0, g.height = he(g.option.height, v ? l : m.height) || 0;
        }
      }
      for (var c = i.length - 1; c >= 0; c--) {
        var d = i[c], f = vn(d.id, null), h = f != null ? o.get(f) : null;
        if (h) {
          var p = h.parent, m = ba(p), y = p === a ? {
            width: s,
            height: l
          } : {
            width: m.width,
            height: m.height
          }, b = {}, C = y2(h, d, y, null, {
            hv: d.hv,
            boundingMode: d.bounding
          }, b);
          if (!ba(h).isNew && C) {
            for (var w = d.transition, _ = {}, x = 0; x < u.length; x++) {
              var I = u[x], D = b[I];
              w && (Tc(w) || nt(w, I) >= 0) ? _[I] = D : h[I] = D;
            }
            kt(h, _, e, 0);
          } else
            h.attr(b);
        }
      }
    }, r.prototype._clear = function() {
      var e = this, n = this._elMap;
      n.each(function(i) {
        B0(i, ba(i).option, n, e._lastGraphicModel);
      }), this._elMap = xe();
    }, r.prototype.dispose = function() {
      this._clear();
    }, r.type = "graphic", r;
  }(yr)
);
function j9(t) {
  process.env.NODE_ENV !== "production" && ke(t, "graphic type MUST be set");
  var r = be(mM, t) ? mM[t] : d2(t);
  process.env.NODE_ENV !== "production" && ke(r, "graphic type " + t + " can not be found");
  var e = new r({});
  return ba(e).type = t, e;
}
function yM(t, r, e, n) {
  var i = j9(e);
  return r.add(i), n.set(t, i), ba(i).id = t, ba(i).isNew = !0, i;
}
function B0(t, r, e, n) {
  var i = t && t.parent;
  i && (t.type === "group" && t.traverse(function(a) {
    B0(a, r, e, n);
  }), N2(t, r, n), e.removeKey(ba(t).id));
}
function bM(t, r, e, n) {
  t.isGroup || L([
    ["cursor", La.prototype.cursor],
    // We should not support configure z and zlevel in the element level.
    // But seems we didn't limit it previously. So here still use it to avoid breaking.
    ["zlevel", n || 0],
    ["z", e || 0],
    // z2 must not be null/undefined, otherwise sort error may occur.
    ["z2", 0]
  ], function(i) {
    var a = i[0];
    be(r, a) ? t[a] = je(r[a], i[1]) : t[a] == null && (t[a] = i[1]);
  }), L(yt(r), function(i) {
    if (i.indexOf("on") === 0) {
      var a = r[i];
      t[i] = Ae(a) ? a : null;
    }
  }), be(r, "draggable") && (t.draggable = r.draggable), r.name != null && (t.name = r.name), r.id != null && (t.id = r.id);
}
function Qce(t) {
  return t = ae({}, t), L(["id", "parentId", "$action", "hv", "bounding", "textContent", "clipPath"].concat(AO), function(r) {
    delete t[r];
  }), t;
}
function ede(t, r, e) {
  var n = Ze(t).eventData;
  !t.silent && !t.ignore && !n && (n = Ze(t).eventData = {
    componentType: "graphic",
    componentIndex: r.componentIndex,
    name: t.name
  }), n && (n.info = e.info);
}
function tde(t) {
  t.registerComponentModel(Kce), t.registerComponentView(qce), t.registerPreprocessor(function(r) {
    var e = r.graphic;
    ue(e) ? !e[0] || !e[0].elements ? r.graphic = [{
      elements: e
    }] : r.graphic = [r.graphic[0]] : e && !e.elements && (r.graphic = [{
      elements: [e]
    }]);
  });
}
var CM = ["x", "y", "radius", "angle", "single"], rde = ["cartesian2d", "polar", "singleAxis"];
function nde(t) {
  var r = t.get("coordinateSystem");
  return nt(rde, r) >= 0;
}
function Ll(t) {
  return process.env.NODE_ENV !== "production" && ke(t), t + "Axis";
}
function ide(t, r) {
  var e = xe(), n = [], i = xe();
  t.eachComponent({
    mainType: "dataZoom",
    query: r
  }, function(c) {
    i.get(c.uid) || s(c);
  });
  var a;
  do
    a = !1, t.eachComponent("dataZoom", o);
  while (a);
  function o(c) {
    !i.get(c.uid) && l(c) && (s(c), a = !0);
  }
  function s(c) {
    i.set(c.uid, !0), n.push(c), u(c);
  }
  function l(c) {
    var d = !1;
    return c.eachTargetAxis(function(f, h) {
      var p = e.get(f);
      p && p[h] && (d = !0);
    }), d;
  }
  function u(c) {
    c.eachTargetAxis(function(d, f) {
      (e.get(d) || e.set(d, []))[f] = !0;
    });
  }
  return n;
}
function GF(t) {
  var r = t.ecModel, e = {
    infoList: [],
    infoMap: xe()
  };
  return t.eachTargetAxis(function(n, i) {
    var a = r.getComponent(Ll(n), i);
    if (a) {
      var o = a.getCoordSysModel();
      if (o) {
        var s = o.uid, l = e.infoMap.get(s);
        l || (l = {
          model: o,
          axisModels: []
        }, e.infoList.push(l), e.infoMap.set(s, l)), l.axisModels.push(a);
      }
    }
  }), e;
}
var L3 = (
  /** @class */
  function() {
    function t() {
      this.indexList = [], this.indexMap = [];
    }
    return t.prototype.add = function(r) {
      this.indexMap[r] || (this.indexList.push(r), this.indexMap[r] = !0);
    }, t;
  }()
), Gv = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e._autoThrottle = !0, e._noTarget = !0, e._rangePropMode = ["percent", "percent"], e;
    }
    return r.prototype.init = function(e, n, i) {
      var a = wM(e);
      this.settledOption = a, this.mergeDefaultAndTheme(e, i), this._doInit(a);
    }, r.prototype.mergeOption = function(e) {
      var n = wM(e);
      Qe(this.option, e, !0), Qe(this.settledOption, n, !0), this._doInit(n);
    }, r.prototype._doInit = function(e) {
      var n = this.option;
      this._setDefaultThrottle(e), this._updateRangeUse(e);
      var i = this.settledOption;
      L([["start", "startValue"], ["end", "endValue"]], function(a, o) {
        this._rangePropMode[o] === "value" && (n[a[0]] = i[a[0]] = null);
      }, this), this._resetTarget();
    }, r.prototype._resetTarget = function() {
      var e = this.get("orient", !0), n = this._targetAxisInfoMap = xe(), i = this._fillSpecifiedTargetAxis(n);
      i ? this._orient = e || this._makeAutoOrientByTargetAxis() : (this._orient = e || "horizontal", this._fillAutoTargetAxisByOrient(n, this._orient)), this._noTarget = !0, n.each(function(a) {
        a.indexList.length && (this._noTarget = !1);
      }, this);
    }, r.prototype._fillSpecifiedTargetAxis = function(e) {
      var n = !1;
      return L(CM, function(i) {
        var a = this.getReferringComponents(Ll(i), N$);
        if (a.specified) {
          n = !0;
          var o = new L3();
          L(a.models, function(s) {
            o.add(s.componentIndex);
          }), e.set(i, o);
        }
      }, this), n;
    }, r.prototype._fillAutoTargetAxisByOrient = function(e, n) {
      var i = this.ecModel, a = !0;
      if (a) {
        var o = n === "vertical" ? "y" : "x", s = i.findComponents({
          mainType: o + "Axis"
        });
        l(s, o);
      }
      if (a) {
        var s = i.findComponents({
          mainType: "singleAxis",
          filter: function(c) {
            return c.get("orient", !0) === n;
          }
        });
        l(s, "single");
      }
      function l(u, c) {
        var d = u[0];
        if (d) {
          var f = new L3();
          if (f.add(d.componentIndex), e.set(c, f), a = !1, c === "x" || c === "y") {
            var h = d.getReferringComponents("grid", on).models[0];
            h && L(u, function(p) {
              d.componentIndex !== p.componentIndex && h === p.getReferringComponents("grid", on).models[0] && f.add(p.componentIndex);
            });
          }
        }
      }
      a && L(CM, function(u) {
        if (a) {
          var c = i.findComponents({
            mainType: Ll(u),
            filter: function(f) {
              return f.get("type", !0) === "category";
            }
          });
          if (c[0]) {
            var d = new L3();
            d.add(c[0].componentIndex), e.set(u, d), a = !1;
          }
        }
      }, this);
    }, r.prototype._makeAutoOrientByTargetAxis = function() {
      var e;
      return this.eachTargetAxis(function(n) {
        !e && (e = n);
      }, this), e === "y" ? "vertical" : "horizontal";
    }, r.prototype._setDefaultThrottle = function(e) {
      if (e.hasOwnProperty("throttle") && (this._autoThrottle = !1), this._autoThrottle) {
        var n = this.ecModel.option;
        this.option.throttle = n.animation && n.animationDurationUpdate > 0 ? 100 : 20;
      }
    }, r.prototype._updateRangeUse = function(e) {
      var n = this._rangePropMode, i = this.get("rangeMode");
      L([["start", "startValue"], ["end", "endValue"]], function(a, o) {
        var s = e[a[0]] != null, l = e[a[1]] != null;
        s && !l ? n[o] = "percent" : !s && l ? n[o] = "value" : i ? n[o] = i[o] : s && (n[o] = "percent");
      });
    }, r.prototype.noTarget = function() {
      return this._noTarget;
    }, r.prototype.getFirstTargetAxisModel = function() {
      var e;
      return this.eachTargetAxis(function(n, i) {
        e == null && (e = this.ecModel.getComponent(Ll(n), i));
      }, this), e;
    }, r.prototype.eachTargetAxis = function(e, n) {
      this._targetAxisInfoMap.each(function(i, a) {
        L(i.indexList, function(o) {
          e.call(n, a, o);
        });
      });
    }, r.prototype.getAxisProxy = function(e, n) {
      var i = this.getAxisModel(e, n);
      if (i)
        return i.__dzAxisProxy;
    }, r.prototype.getAxisModel = function(e, n) {
      process.env.NODE_ENV !== "production" && ke(e && n != null);
      var i = this._targetAxisInfoMap.get(e);
      if (i && i.indexMap[n])
        return this.ecModel.getComponent(Ll(e), n);
    }, r.prototype.setRawRange = function(e) {
      var n = this.option, i = this.settledOption;
      L([["start", "startValue"], ["end", "endValue"]], function(a) {
        (e[a[0]] != null || e[a[1]] != null) && (n[a[0]] = i[a[0]] = e[a[0]], n[a[1]] = i[a[1]] = e[a[1]]);
      }, this), this._updateRangeUse(e);
    }, r.prototype.setCalculatedRange = function(e) {
      var n = this.option;
      L(["start", "startValue", "end", "endValue"], function(i) {
        n[i] = e[i];
      });
    }, r.prototype.getPercentRange = function() {
      var e = this.findRepresentativeAxisProxy();
      if (e)
        return e.getDataPercentWindow();
    }, r.prototype.getValueRange = function(e, n) {
      if (e == null && n == null) {
        var i = this.findRepresentativeAxisProxy();
        if (i)
          return i.getDataValueWindow();
      } else
        return this.getAxisProxy(e, n).getDataValueWindow();
    }, r.prototype.findRepresentativeAxisProxy = function(e) {
      if (e)
        return e.__dzAxisProxy;
      for (var n, i = this._targetAxisInfoMap.keys(), a = 0; a < i.length; a++)
        for (var o = i[a], s = this._targetAxisInfoMap.get(o), l = 0; l < s.indexList.length; l++) {
          var u = this.getAxisProxy(o, s.indexList[l]);
          if (u.hostedBy(this))
            return u;
          n || (n = u);
        }
      return n;
    }, r.prototype.getRangePropMode = function() {
      return this._rangePropMode.slice();
    }, r.prototype.getOrient = function() {
      return process.env.NODE_ENV !== "production" && ke(this._orient), this._orient;
    }, r.type = "dataZoom", r.dependencies = ["xAxis", "yAxis", "radiusAxis", "angleAxis", "singleAxis", "series", "toolbox"], r.defaultOption = {
      // zlevel: 0,
      z: 4,
      filterMode: "filter",
      start: 0,
      end: 100
    }, r;
  }(st)
);
function wM(t) {
  var r = {};
  return L(["start", "end", "startValue", "endValue", "throttle"], function(e) {
    t.hasOwnProperty(e) && (r[e] = t[e]);
  }), r;
}
var ade = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.type = "dataZoom.select", r;
  }(Gv)
), I_ = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.render = function(e, n, i, a) {
      this.dataZoomModel = e, this.ecModel = n, this.api = i;
    }, r.type = "dataZoom", r;
  }(yr)
), ode = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.type = "dataZoom.select", r;
  }(I_)
), jd = L, _M = Ui, sde = (
  /** @class */
  function() {
    function t(r, e, n, i) {
      this._dimName = r, this._axisIndex = e, this.ecModel = i, this._dataZoomModel = n;
    }
    return t.prototype.hostedBy = function(r) {
      return this._dataZoomModel === r;
    }, t.prototype.getDataValueWindow = function() {
      return this._valueWindow.slice();
    }, t.prototype.getDataPercentWindow = function() {
      return this._percentWindow.slice();
    }, t.prototype.getTargetSeriesModels = function() {
      var r = [];
      return this.ecModel.eachSeries(function(e) {
        if (nde(e)) {
          var n = Ll(this._dimName), i = e.getReferringComponents(n, on).models[0];
          i && this._axisIndex === i.componentIndex && r.push(e);
        }
      }, this), r;
    }, t.prototype.getAxisModel = function() {
      return this.ecModel.getComponent(this._dimName + "Axis", this._axisIndex);
    }, t.prototype.getMinMaxSpan = function() {
      return Ge(this._minMaxSpan);
    }, t.prototype.calculateDataWindow = function(r) {
      var e = this._dataExtent, n = this.getAxisModel(), i = n.axis.scale, a = this._dataZoomModel.getRangePropMode(), o = [0, 100], s = [], l = [], u;
      jd(["start", "end"], function(f, h) {
        var p = r[f], v = r[f + "Value"];
        a[h] === "percent" ? (p == null && (p = o[h]), v = i.parse(zt(p, o, e))) : (u = !0, v = v == null ? e[h] : i.parse(v), p = zt(v, e, o)), l[h] = v == null || isNaN(v) ? e[h] : v, s[h] = p == null || isNaN(p) ? o[h] : p;
      }), _M(l), _M(s);
      var c = this._minMaxSpan;
      u ? d(l, s, e, o, !1) : d(s, l, o, e, !0);
      function d(f, h, p, v, g) {
        var m = g ? "Span" : "ValueSpan";
        id(0, f, p, "all", c["min" + m], c["max" + m]);
        for (var y = 0; y < 2; y++)
          h[y] = zt(f[y], p, v, !0), g && (h[y] = i.parse(h[y]));
      }
      return {
        valueWindow: l,
        percentWindow: s
      };
    }, t.prototype.reset = function(r) {
      if (r === this._dataZoomModel) {
        var e = this.getTargetSeriesModels();
        this._dataExtent = lde(this, this._dimName, e), this._updateMinMaxSpan();
        var n = this.calculateDataWindow(r.settledOption);
        this._valueWindow = n.valueWindow, this._percentWindow = n.percentWindow, this._setAxisModel();
      }
    }, t.prototype.filterData = function(r, e) {
      if (r !== this._dataZoomModel)
        return;
      var n = this._dimName, i = this.getTargetSeriesModels(), a = r.get("filterMode"), o = this._valueWindow;
      if (a === "none")
        return;
      jd(i, function(l) {
        var u = l.getData(), c = u.mapDimensionsAll(n);
        if (c.length) {
          if (a === "weakFilter") {
            var d = u.getStore(), f = ce(c, function(h) {
              return u.getDimensionIndex(h);
            }, u);
            u.filterSelf(function(h) {
              for (var p, v, g, m = 0; m < c.length; m++) {
                var y = d.get(f[m], h), b = !isNaN(y), C = y < o[0], w = y > o[1];
                if (b && !C && !w)
                  return !0;
                b && (g = !0), C && (p = !0), w && (v = !0);
              }
              return g && p && v;
            });
          } else
            jd(c, function(h) {
              if (a === "empty")
                l.setData(u = u.map(h, function(v) {
                  return s(v) ? v : NaN;
                }));
              else {
                var p = {};
                p[h] = o, u.selectRange(p);
              }
            });
          jd(c, function(h) {
            u.setApproximateExtent(o, h);
          });
        }
      });
      function s(l) {
        return l >= o[0] && l <= o[1];
      }
    }, t.prototype._updateMinMaxSpan = function() {
      var r = this._minMaxSpan = {}, e = this._dataZoomModel, n = this._dataExtent;
      jd(["min", "max"], function(i) {
        var a = e.get(i + "Span"), o = e.get(i + "ValueSpan");
        o != null && (o = this.getAxisModel().axis.scale.parse(o)), o != null ? a = zt(n[0] + o, n, [0, 100], !0) : a != null && (o = zt(a, [0, 100], n, !0) - n[0]), r[i + "Span"] = a, r[i + "ValueSpan"] = o;
      }, this);
    }, t.prototype._setAxisModel = function() {
      var r = this.getAxisModel(), e = this._percentWindow, n = this._valueWindow;
      if (e) {
        var i = R7(n, [0, 500]);
        i = Math.min(i, 20);
        var a = r.axis.scale.rawExtentInfo;
        e[0] !== 0 && a.setDeterminedMinMax("min", +n[0].toFixed(i)), e[1] !== 100 && a.setDeterminedMinMax("max", +n[1].toFixed(i)), a.freeze();
      }
    }, t;
  }()
);
function lde(t, r, e) {
  var n = [1 / 0, -1 / 0];
  jd(e, function(o) {
    Tee(n, o.getData(), r);
  });
  var i = t.getAxisModel(), a = tG(i.axis.scale, i, n).calculate();
  return [a.min, a.max];
}
var ude = {
  // `dataZoomProcessor` will only be performed in needed series. Consider if
  // there is a line series and a pie series, it is better not to update the
  // line series if only pie series is needed to be updated.
  getTargetSeries: function(t) {
    function r(i) {
      t.eachComponent("dataZoom", function(a) {
        a.eachTargetAxis(function(o, s) {
          var l = t.getComponent(Ll(o), s);
          i(o, s, l, a);
        });
      });
    }
    r(function(i, a, o, s) {
      o.__dzAxisProxy = null;
    });
    var e = [];
    r(function(i, a, o, s) {
      o.__dzAxisProxy || (o.__dzAxisProxy = new sde(i, a, s, t), e.push(o.__dzAxisProxy));
    });
    var n = xe();
    return L(e, function(i) {
      L(i.getTargetSeriesModels(), function(a) {
        n.set(a.uid, a);
      });
    }), n;
  },
  // Consider appendData, where filter should be performed. Because data process is
  // in block mode currently, it is not need to worry about that the overallProgress
  // execute every frame.
  overallReset: function(t, r) {
    t.eachComponent("dataZoom", function(e) {
      e.eachTargetAxis(function(n, i) {
        e.getAxisProxy(n, i).reset(e);
      }), e.eachTargetAxis(function(n, i) {
        e.getAxisProxy(n, i).filterData(e, r);
      });
    }), t.eachComponent("dataZoom", function(e) {
      var n = e.findRepresentativeAxisProxy();
      if (n) {
        var i = n.getDataPercentWindow(), a = n.getDataValueWindow();
        e.setCalculatedRange({
          start: i[0],
          end: i[1],
          startValue: a[0],
          endValue: a[1]
        });
      }
    });
  }
};
function cde(t) {
  t.registerAction("dataZoom", function(r, e) {
    var n = ide(e, r);
    L(n, function(i) {
      i.setRawRange({
        start: r.start,
        end: r.end,
        startValue: r.startValue,
        endValue: r.endValue
      });
    });
  });
}
var xM = !1;
function A_(t) {
  xM || (xM = !0, t.registerProcessor(t.PRIORITY.PROCESSOR.FILTER, ude), cde(t), t.registerSubTypeDefaulter("dataZoom", function() {
    return "slider";
  }));
}
function dde(t) {
  t.registerComponentModel(ade), t.registerComponentView(ode), A_(t);
}
var _a = (
  /** @class */
  /* @__PURE__ */ function() {
    function t() {
    }
    return t;
  }()
), BF = {};
function Yd(t, r) {
  BF[t] = r;
}
function FF(t) {
  return BF[t];
}
var fde = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.optionUpdated = function() {
      t.prototype.optionUpdated.apply(this, arguments);
      var e = this.ecModel;
      L(this.option.feature, function(n, i) {
        var a = FF(i);
        a && (a.getDefaultOption && (a.defaultOption = a.getDefaultOption(e)), Qe(n, a.defaultOption));
      });
    }, r.type = "toolbox", r.layoutMode = {
      type: "box",
      ignoreSize: !0
    }, r.defaultOption = {
      show: !0,
      z: 6,
      // zlevel: 0,
      orient: "horizontal",
      left: "right",
      top: "top",
      // right
      // bottom
      backgroundColor: "transparent",
      borderColor: "#ccc",
      borderRadius: 0,
      borderWidth: 0,
      padding: 5,
      itemSize: 15,
      itemGap: 8,
      showTitle: !0,
      iconStyle: {
        borderColor: "#666",
        color: "none"
      },
      emphasis: {
        iconStyle: {
          borderColor: "#3E98C5"
        }
      },
      // textStyle: {},
      // feature
      tooltip: {
        show: !1,
        position: "bottom"
      }
    }, r;
  }(st)
);
function hde(t, r, e) {
  var n = r.getBoxLayoutParams(), i = r.get("padding"), a = {
    width: e.getWidth(),
    height: e.getHeight()
  }, o = cn(n, a, i);
  Ic(r.get("orient"), t, r.get("itemGap"), o.width, o.height), y2(t, n, a, i);
}
function HF(t, r) {
  var e = Qc(r.get("padding")), n = r.getItemStyle(["color", "opacity"]);
  return n.fill = r.get("backgroundColor"), t = new xt({
    shape: {
      x: t.x - e[3],
      y: t.y - e[0],
      width: t.width + e[1] + e[3],
      height: t.height + e[0] + e[2],
      r: r.get("borderRadius")
    },
    style: n,
    silent: !0,
    z2: -1
  }), t;
}
var pde = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return r.prototype.render = function(e, n, i, a) {
      var o = this.group;
      if (o.removeAll(), !e.get("show"))
        return;
      var s = +e.get("itemSize"), l = e.get("orient") === "vertical", u = e.get("feature") || {}, c = this._features || (this._features = {}), d = [];
      L(u, function(p, v) {
        d.push(v);
      }), new Us(this._featureNames || [], d).add(f).update(f).remove(Ye(f, null)).execute(), this._featureNames = d;
      function f(p, v) {
        var g = d[p], m = d[v], y = u[g], b = new Pt(y, e, e.ecModel), C;
        if (a && a.newTitle != null && a.featureName === g && (y.title = a.newTitle), g && !m) {
          if (vde(g))
            C = {
              onclick: b.option.onclick,
              featureName: g
            };
          else {
            var w = FF(g);
            if (!w)
              return;
            C = new w();
          }
          c[g] = C;
        } else if (C = c[m], !C)
          return;
        C.uid = sh("toolbox-feature"), C.model = b, C.ecModel = n, C.api = i;
        var _ = C instanceof _a;
        if (!g && m) {
          _ && C.dispose && C.dispose(n, i);
          return;
        }
        if (!b.get("show") || _ && C.unusable) {
          _ && C.remove && C.remove(n, i);
          return;
        }
        h(b, C, g), b.setIconStatus = function(x, I) {
          var D = this.option, T = this.iconPaths;
          D.iconStatus = D.iconStatus || {}, D.iconStatus[x] = I, T[x] && (I === "emphasis" ? Xs : $s)(T[x]);
        }, C instanceof _a && C.render && C.render(b, n, i, a);
      }
      function h(p, v, g) {
        var m = p.getModel("iconStyle"), y = p.getModel(["emphasis", "iconStyle"]), b = v instanceof _a && v.getIcons ? v.getIcons() : p.get("icon"), C = p.get("title") || {}, w, _;
        pe(b) ? (w = {}, w[g] = b) : w = b, pe(C) ? (_ = {}, _[g] = C) : _ = C;
        var x = p.iconPaths = {};
        L(w, function(I, D) {
          var T = ih(I, {}, {
            x: -s / 2,
            y: -s / 2,
            width: s,
            height: s
          });
          T.setStyle(m.getItemStyle());
          var A = T.ensureState("emphasis");
          A.style = y.getItemStyle();
          var M = new _t({
            style: {
              text: _[D],
              align: y.get("textAlign"),
              borderRadius: y.get("textBorderRadius"),
              padding: y.get("textPadding"),
              fill: null,
              font: U7({
                fontStyle: y.get("textFontStyle"),
                fontFamily: y.get("textFontFamily"),
                fontSize: y.get("textFontSize"),
                fontWeight: y.get("textFontWeight")
              }, n)
            },
            ignore: !0
          });
          T.setTextContent(M), ah({
            el: T,
            componentModel: e,
            itemName: D,
            formatterParamsExtra: {
              title: _[D]
            }
          }), T.__title = _[D], T.on("mouseover", function() {
            var R = y.getItemStyle(), E = l ? e.get("right") == null && e.get("left") !== "right" ? "right" : "left" : e.get("bottom") == null && e.get("top") !== "bottom" ? "bottom" : "top";
            M.setStyle({
              fill: y.get("textFill") || R.fill || R.stroke || "#000",
              backgroundColor: y.get("textBackgroundColor")
            }), T.setTextConfig({
              position: y.get("textPosition") || E
            }), M.ignore = !e.get("showTitle"), i.enterEmphasis(this);
          }).on("mouseout", function() {
            p.get(["iconStatus", D]) !== "emphasis" && i.leaveEmphasis(this), M.hide();
          }), (p.get(["iconStatus", D]) === "emphasis" ? Xs : $s)(T), o.add(T), T.on("click", ye(v.onclick, v, n, i, D)), x[D] = T;
        });
      }
      hde(o, e, i), o.add(HF(o.getBoundingRect(), e)), l || o.eachChild(function(p) {
        var v = p.__title, g = p.ensureState("emphasis"), m = g.textConfig || (g.textConfig = {}), y = p.getTextContent(), b = y && y.ensureState("emphasis");
        if (b && !Ae(b) && v) {
          var C = b.style || (b.style = {}), w = cg(v, _t.makeFont(C)), _ = p.x + o.x, x = p.y + o.y + s, I = !1;
          x + w.height > i.getHeight() && (m.position = "top", I = !0);
          var D = I ? -5 - w.height : s + 10;
          _ + w.width / 2 > i.getWidth() ? (m.position = ["100%", D], C.align = "right") : _ - w.width / 2 < 0 && (m.position = [0, D], C.align = "left");
        }
      });
    }, r.prototype.updateView = function(e, n, i, a) {
      L(this._features, function(o) {
        o instanceof _a && o.updateView && o.updateView(o.model, n, i, a);
      });
    }, r.prototype.remove = function(e, n) {
      L(this._features, function(i) {
        i instanceof _a && i.remove && i.remove(e, n);
      }), this.group.removeAll();
    }, r.prototype.dispose = function(e, n) {
      L(this._features, function(i) {
        i instanceof _a && i.dispose && i.dispose(e, n);
      });
    }, r.type = "toolbox", r;
  }(yr)
);
function vde(t) {
  return t.indexOf("my") === 0;
}
var gde = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return r.prototype.onclick = function(e, n) {
      var i = this.model, a = i.get("name") || e.get("title.0.text") || "echarts", o = n.getZr().painter.getType() === "svg", s = o ? "svg" : i.get("type", !0) || "png", l = n.getConnectedDataURL({
        type: s,
        backgroundColor: i.get("backgroundColor", !0) || e.get("backgroundColor") || "#fff",
        connectedBackgroundColor: i.get("connectedBackgroundColor"),
        excludeComponents: i.get("excludeComponents"),
        pixelRatio: i.get("pixelRatio")
      }), u = vt.browser;
      if (typeof MouseEvent == "function" && (u.newEdge || !u.ie && !u.edge)) {
        var c = document.createElement("a");
        c.download = a + "." + s, c.target = "_blank", c.href = l;
        var d = new MouseEvent("click", {
          // some micro front-end framework， window maybe is a Proxy
          view: document.defaultView,
          bubbles: !0,
          cancelable: !1
        });
        c.dispatchEvent(d);
      } else if (window.navigator.msSaveOrOpenBlob || o) {
        var f = l.split(","), h = f[0].indexOf("base64") > -1, p = o ? decodeURIComponent(f[1]) : f[1];
        h && (p = window.atob(p));
        var v = a + "." + s;
        if (window.navigator.msSaveOrOpenBlob) {
          for (var g = p.length, m = new Uint8Array(g); g--; )
            m[g] = p.charCodeAt(g);
          var y = new Blob([m]);
          window.navigator.msSaveOrOpenBlob(y, v);
        } else {
          var b = document.createElement("iframe");
          document.body.appendChild(b);
          var C = b.contentWindow, w = C.document;
          w.open("image/svg+xml", "replace"), w.write(p), w.close(), C.focus(), w.execCommand("SaveAs", !0, v), document.body.removeChild(b);
        }
      } else {
        var _ = i.get("lang"), x = '<body style="margin:0;"><img src="' + l + '" style="max-width:100%;" title="' + (_ && _[0] || "") + '" /></body>', I = window.open();
        I.document.write(x), I.document.title = a;
      }
    }, r.getDefaultOption = function(e) {
      var n = {
        show: !0,
        icon: "M4.7,22.9L29.3,45.5L54.7,23.4M4.6,43.6L4.6,58L53.8,58L53.8,43.6M29.2,45.1L29.2,0",
        title: e.getLocaleModel().get(["toolbox", "saveAsImage", "title"]),
        type: "png",
        // Default use option.backgroundColor
        // backgroundColor: '#fff',
        connectedBackgroundColor: "#fff",
        name: "",
        excludeComponents: ["toolbox"],
        // use current pixel ratio of device by default
        // pixelRatio: 1,
        lang: e.getLocaleModel().get(["toolbox", "saveAsImage", "lang"])
      };
      return n;
    }, r;
  }(_a)
), SM = "__ec_magicType_stack__", mde = [["line", "bar"], ["stack"]], yde = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return r.prototype.getIcons = function() {
      var e = this.model, n = e.get("icon"), i = {};
      return L(e.get("type"), function(a) {
        n[a] && (i[a] = n[a]);
      }), i;
    }, r.getDefaultOption = function(e) {
      var n = {
        show: !0,
        type: [],
        // Icon group
        icon: {
          line: "M4.1,28.9h7.1l9.3-22l7.4,38l9.7-19.7l3,12.8h14.9M4.1,58h51.4",
          bar: "M6.7,22.9h10V48h-10V22.9zM24.9,13h10v35h-10V13zM43.2,2h10v46h-10V2zM3.1,58h53.7",
          // eslint-disable-next-line
          stack: "M8.2,38.4l-8.4,4.1l30.6,15.3L60,42.5l-8.1-4.1l-21.5,11L8.2,38.4z M51.9,30l-8.1,4.2l-13.4,6.9l-13.9-6.9L8.2,30l-8.4,4.2l8.4,4.2l22.2,11l21.5-11l8.1-4.2L51.9,30z M51.9,21.7l-8.1,4.2L35.7,30l-5.3,2.8L24.9,30l-8.4-4.1l-8.3-4.2l-8.4,4.2L8.2,30l8.3,4.2l13.9,6.9l13.4-6.9l8.1-4.2l8.1-4.1L51.9,21.7zM30.4,2.2L-0.2,17.5l8.4,4.1l8.3,4.2l8.4,4.2l5.5,2.7l5.3-2.7l8.1-4.2l8.1-4.2l8.1-4.1L30.4,2.2z"
          // jshint ignore:line
        },
        // `line`, `bar`, `stack`, `tiled`
        title: e.getLocaleModel().get(["toolbox", "magicType", "title"]),
        option: {},
        seriesIndex: {}
      };
      return n;
    }, r.prototype.onclick = function(e, n, i) {
      var a = this.model, o = a.get(["seriesIndex", i]);
      if (IM[i]) {
        var s = {
          series: []
        }, l = function(d) {
          var f = d.subType, h = d.id, p = IM[i](f, h, d, a);
          p && (Ee(p, d.option), s.series.push(p));
          var v = d.coordinateSystem;
          if (v && v.type === "cartesian2d" && (i === "line" || i === "bar")) {
            var g = v.getAxesByScale("ordinal")[0];
            if (g) {
              var m = g.dim, y = m + "Axis", b = d.getReferringComponents(y, on).models[0], C = b.componentIndex;
              s[y] = s[y] || [];
              for (var w = 0; w <= C; w++)
                s[y][C] = s[y][C] || {};
              s[y][C].boundaryGap = i === "bar";
            }
          }
        };
        L(mde, function(d) {
          nt(d, i) >= 0 && L(d, function(f) {
            a.setIconStatus(f, "normal");
          });
        }), a.setIconStatus(i, "emphasis"), e.eachComponent({
          mainType: "series",
          query: o == null ? null : {
            seriesIndex: o
          }
        }, l);
        var u, c = i;
        i === "stack" && (u = Qe({
          stack: a.option.title.tiled,
          tiled: a.option.title.stack
        }, a.option.title), a.get(["iconStatus", i]) !== "emphasis" && (c = "tiled")), n.dispatchAction({
          type: "changeMagicType",
          currentType: c,
          newOption: s,
          newTitle: u,
          featureName: "magicType"
        });
      }
    }, r;
  }(_a)
), IM = {
  line: function(t, r, e, n) {
    if (t === "bar")
      return Qe({
        id: r,
        type: "line",
        // Preserve data related option
        data: e.get("data"),
        stack: e.get("stack"),
        markPoint: e.get("markPoint"),
        markLine: e.get("markLine")
      }, n.get(["option", "line"]) || {}, !0);
  },
  bar: function(t, r, e, n) {
    if (t === "line")
      return Qe({
        id: r,
        type: "bar",
        // Preserve data related option
        data: e.get("data"),
        stack: e.get("stack"),
        markPoint: e.get("markPoint"),
        markLine: e.get("markLine")
      }, n.get(["option", "bar"]) || {}, !0);
  },
  stack: function(t, r, e, n) {
    var i = e.get("stack") === SM;
    if (t === "line" || t === "bar")
      return n.setIconStatus("stack", i ? "normal" : "emphasis"), Qe({
        id: r,
        stack: i ? "" : SM
      }, n.get(["option", "stack"]) || {}, !0);
  }
};
co({
  type: "changeMagicType",
  event: "magicTypeChanged",
  update: "prepareAndUpdate"
}, function(t, r) {
  r.mergeOption(t.newOption);
});
var O2 = new Array(60).join("-"), Of = "	";
function bde(t) {
  var r = {}, e = [], n = [];
  return t.eachRawSeries(function(i) {
    var a = i.coordinateSystem;
    if (a && (a.type === "cartesian2d" || a.type === "polar")) {
      var o = a.getBaseAxis();
      if (o.type === "category") {
        var s = o.dim + "_" + o.index;
        r[s] || (r[s] = {
          categoryAxis: o,
          valueAxis: a.getOtherAxis(o),
          series: []
        }, n.push({
          axisDim: o.dim,
          axisIndex: o.index
        })), r[s].series.push(i);
      } else
        e.push(i);
    } else
      e.push(i);
  }), {
    seriesGroupByCategoryAxis: r,
    other: e,
    meta: n
  };
}
function Cde(t) {
  var r = [];
  return L(t, function(e, n) {
    var i = e.categoryAxis, a = e.valueAxis, o = a.dim, s = [" "].concat(ce(e.series, function(h) {
      return h.name;
    })), l = [i.model.getCategories()];
    L(e.series, function(h) {
      var p = h.getRawData();
      l.push(h.getRawData().mapArray(p.mapDimension(o), function(v) {
        return v;
      }));
    });
    for (var u = [s.join(Of)], c = 0; c < l[0].length; c++) {
      for (var d = [], f = 0; f < l.length; f++)
        d.push(l[f][c]);
      u.push(d.join(Of));
    }
    r.push(u.join(`
`));
  }), r.join(`

` + O2 + `

`);
}
function wde(t) {
  return ce(t, function(r) {
    var e = r.getRawData(), n = [r.name], i = [];
    return e.each(e.dimensions, function() {
      for (var a = arguments.length, o = arguments[a - 1], s = e.getName(o), l = 0; l < a - 1; l++)
        i[l] = arguments[l];
      n.push((s ? s + Of : "") + i.join(Of));
    }), n.join(`
`);
  }).join(`

` + O2 + `

`);
}
function _de(t) {
  var r = bde(t);
  return {
    value: Wt([Cde(r.seriesGroupByCategoryAxis), wde(r.other)], function(e) {
      return !!e.replace(/[\n\t\s]/g, "");
    }).join(`

` + O2 + `

`),
    meta: r.meta
  };
}
function ty(t) {
  return t.replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function xde(t) {
  var r = t.slice(0, t.indexOf(`
`));
  if (r.indexOf(Of) >= 0)
    return !0;
}
var Y9 = new RegExp("[" + Of + "]+", "g");
function Sde(t) {
  for (var r = t.split(/\n+/g), e = ty(r.shift()).split(Y9), n = [], i = ce(e, function(l) {
    return {
      name: l,
      data: []
    };
  }), a = 0; a < r.length; a++) {
    var o = ty(r[a]).split(Y9);
    n.push(o.shift());
    for (var s = 0; s < o.length; s++)
      i[s] && (i[s].data[a] = o[s]);
  }
  return {
    series: i,
    categories: n
  };
}
function Ide(t) {
  for (var r = t.split(/\n+/g), e = ty(r.shift()), n = [], i = 0; i < r.length; i++) {
    var a = ty(r[i]);
    if (a) {
      var o = a.split(Y9), s = "", l = void 0, u = !1;
      isNaN(o[0]) ? (u = !0, s = o[0], o = o.slice(1), n[i] = {
        name: s,
        value: []
      }, l = n[i].value) : l = n[i] = [];
      for (var c = 0; c < o.length; c++)
        l.push(+o[c]);
      l.length === 1 && (u ? n[i].value = l[0] : n[i] = l[0]);
    }
  }
  return {
    name: e,
    data: n
  };
}
function Ade(t, r) {
  var e = t.split(new RegExp(`
*` + O2 + `
*`, "g")), n = {
    series: []
  };
  return L(e, function(i, a) {
    if (xde(i)) {
      var o = Sde(i), s = r[a], l = s.axisDim + "Axis";
      s && (n[l] = n[l] || [], n[l][s.axisIndex] = {
        data: o.categories
      }, n.series = n.series.concat(o.series));
    } else {
      var o = Ide(i);
      n.series.push(o);
    }
  }), n;
}
var Dde = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return r.prototype.onclick = function(e, n) {
      setTimeout(function() {
        n.dispatchAction({
          type: "hideTip"
        });
      });
      var i = n.getDom(), a = this.model;
      this._dom && i.removeChild(this._dom);
      var o = document.createElement("div");
      o.style.cssText = "position:absolute;top:0;bottom:0;left:0;right:0;padding:5px", o.style.backgroundColor = a.get("backgroundColor") || "#fff";
      var s = document.createElement("h4"), l = a.get("lang") || [];
      s.innerHTML = l[0] || a.get("title"), s.style.cssText = "margin:10px 20px", s.style.color = a.get("textColor");
      var u = document.createElement("div"), c = document.createElement("textarea");
      u.style.cssText = "overflow:auto";
      var d = a.get("optionToContent"), f = a.get("contentToOption"), h = _de(e);
      if (Ae(d)) {
        var p = d(n.getOption());
        pe(p) ? u.innerHTML = p : Kl(p) && u.appendChild(p);
      } else {
        c.readOnly = a.get("readOnly");
        var v = c.style;
        v.cssText = "display:block;width:100%;height:100%;font-family:monospace;font-size:14px;line-height:1.6rem;resize:none;box-sizing:border-box;outline:none", v.color = a.get("textColor"), v.borderColor = a.get("textareaBorderColor"), v.backgroundColor = a.get("textareaColor"), c.value = h.value, u.appendChild(c);
      }
      var g = h.meta, m = document.createElement("div");
      m.style.cssText = "position:absolute;bottom:5px;left:0;right:0";
      var y = "float:right;margin-right:20px;border:none;cursor:pointer;padding:2px 5px;font-size:12px;border-radius:3px", b = document.createElement("div"), C = document.createElement("div");
      y += ";background-color:" + a.get("buttonColor"), y += ";color:" + a.get("buttonTextColor");
      var w = this;
      function _() {
        i.removeChild(o), w._dom = null;
      }
      _C(b, "click", _), _C(C, "click", function() {
        if (f == null && d != null || f != null && d == null) {
          process.env.NODE_ENV !== "production" && Mr("It seems you have just provided one of `contentToOption` and `optionToContent` functions but missed the other one. Data change is ignored."), _();
          return;
        }
        var x;
        try {
          Ae(f) ? x = f(u, n.getOption()) : x = Ade(c.value, g);
        } catch (I) {
          throw _(), new Error("Data view format error " + I);
        }
        x && n.dispatchAction({
          type: "changeDataView",
          newOption: x
        }), _();
      }), b.innerHTML = l[1], C.innerHTML = l[2], C.style.cssText = b.style.cssText = y, !a.get("readOnly") && m.appendChild(C), m.appendChild(b), o.appendChild(s), o.appendChild(u), o.appendChild(m), u.style.height = i.clientHeight - 80 + "px", i.appendChild(o), this._dom = o;
    }, r.prototype.remove = function(e, n) {
      this._dom && n.getDom().removeChild(this._dom);
    }, r.prototype.dispose = function(e, n) {
      this.remove(e, n);
    }, r.getDefaultOption = function(e) {
      var n = {
        show: !0,
        readOnly: !1,
        optionToContent: null,
        contentToOption: null,
        // eslint-disable-next-line
        icon: "M17.5,17.3H33 M17.5,17.3H33 M45.4,29.5h-28 M11.5,2v56H51V14.8L38.4,2H11.5z M38.4,2.2v12.7H51 M45.4,41.7h-28",
        title: e.getLocaleModel().get(["toolbox", "dataView", "title"]),
        lang: e.getLocaleModel().get(["toolbox", "dataView", "lang"]),
        backgroundColor: "#fff",
        textColor: "#000",
        textareaColor: "#fff",
        textareaBorderColor: "#333",
        buttonColor: "#c23531",
        buttonTextColor: "#fff"
      };
      return n;
    }, r;
  }(_a)
);
function Tde(t, r) {
  return ce(t, function(e, n) {
    var i = r && r[n];
    if (Me(i) && !ue(i)) {
      var a = Me(e) && !ue(e);
      a || (e = {
        value: e
      });
      var o = i.name != null && e.name == null;
      return e = Ee(e, i), o && delete e.name, e;
    } else
      return e;
  });
}
co({
  type: "changeDataView",
  event: "dataViewChanged",
  update: "prepareAndUpdate"
}, function(t, r) {
  var e = [];
  L(t.newOption.series, function(n) {
    var i = r.getSeriesByName(n.name)[0];
    if (!i)
      e.push(ae({
        // Default is scatter
        type: "scatter"
      }, n));
    else {
      var a = i.get("data");
      e.push({
        name: n.name,
        data: Tde(n.data, a)
      });
    }
  }), r.mergeOption(Ee({
    series: e
  }, t.newOption));
});
var zF = L, WF = It();
function Mde(t, r) {
  var e = D_(t);
  zF(r, function(n, i) {
    for (var a = e.length - 1; a >= 0; a--) {
      var o = e[a];
      if (o[i])
        break;
    }
    if (a < 0) {
      var s = t.queryComponents({
        mainType: "dataZoom",
        subType: "select",
        id: i
      })[0];
      if (s) {
        var l = s.getPercentRange();
        e[0][i] = {
          dataZoomId: i,
          start: l[0],
          end: l[1]
        };
      }
    }
  }), e.push(r);
}
function Rde(t) {
  var r = D_(t), e = r[r.length - 1];
  r.length > 1 && r.pop();
  var n = {};
  return zF(e, function(i, a) {
    for (var o = r.length - 1; o >= 0; o--)
      if (i = r[o][a], i) {
        n[a] = i;
        break;
      }
  }), n;
}
function Lde(t) {
  WF(t).snapshots = null;
}
function Ede(t) {
  return D_(t).length;
}
function D_(t) {
  var r = WF(t);
  return r.snapshots || (r.snapshots = [{}]), r.snapshots;
}
var kde = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return r.prototype.onclick = function(e, n) {
      Lde(e), n.dispatchAction({
        type: "restore",
        from: this.uid
      });
    }, r.getDefaultOption = function(e) {
      var n = {
        show: !0,
        // eslint-disable-next-line
        icon: "M3.8,33.4 M47,18.9h9.8V8.7 M56.3,20.1 C52.1,9,40.5,0.6,26.8,2.1C12.6,3.7,1.6,16.2,2.1,30.6 M13,41.1H3.1v10.2 M3.7,39.9c4.2,11.1,15.8,19.5,29.5,18 c14.2-1.6,25.2-14.1,24.7-28.5",
        title: e.getLocaleModel().get(["toolbox", "restore", "title"])
      };
      return n;
    }, r;
  }(_a)
);
co({
  type: "restore",
  event: "restore",
  update: "prepareAndUpdate"
}, function(t, r) {
  r.resetOption("recreate");
});
var Pde = ["grid", "xAxis", "yAxis", "geo", "graph", "polar", "radiusAxis", "angleAxis", "bmap"], T_ = (
  /** @class */
  function() {
    function t(r, e, n) {
      var i = this;
      this._targetInfoList = [];
      var a = AM(e, r);
      L(Nde, function(o, s) {
        (!n || !n.include || nt(n.include, s) >= 0) && o(a, i._targetInfoList);
      });
    }
    return t.prototype.setOutputRanges = function(r, e) {
      return this.matchOutputRanges(r, e, function(n, i, a) {
        if ((n.coordRanges || (n.coordRanges = [])).push(i), !n.coordRange) {
          n.coordRange = i;
          var o = E3[n.brushType](0, a, i);
          n.__rangeOffset = {
            offset: RM[n.brushType](o.values, n.range, [1, 1]),
            xyMinMax: o.xyMinMax
          };
        }
      }), r;
    }, t.prototype.matchOutputRanges = function(r, e, n) {
      L(r, function(i) {
        var a = this.findTargetInfo(i, e);
        a && a !== !0 && L(a.coordSyses, function(o) {
          var s = E3[i.brushType](1, o, i.range, !0);
          n(i, s.values, o, e);
        });
      }, this);
    }, t.prototype.setInputRanges = function(r, e) {
      L(r, function(n) {
        var i = this.findTargetInfo(n, e);
        if (process.env.NODE_ENV !== "production" && (ke(!i || i === !0 || n.coordRange, "coordRange must be specified when coord index specified."), ke(!i || i !== !0 || n.range, "range must be specified in global brush.")), n.range = n.range || [], i && i !== !0) {
          n.panelId = i.panelId;
          var a = E3[n.brushType](0, i.coordSys, n.coordRange), o = n.__rangeOffset;
          n.range = o ? RM[n.brushType](a.values, o.offset, Ode(a.xyMinMax, o.xyMinMax)) : a.values;
        }
      }, this);
    }, t.prototype.makePanelOpts = function(r, e) {
      return ce(this._targetInfoList, function(n) {
        var i = n.getPanelRect();
        return {
          panelId: n.panelId,
          defaultBrushType: e ? e(n) : null,
          clipPath: JB(i),
          isTargetByCursor: qB(i, r, n.coordSysModel),
          getLinearBrushOtherExtent: KB(i)
        };
      });
    }, t.prototype.controlSeries = function(r, e, n) {
      var i = this.findTargetInfo(r, n);
      return i === !0 || i && nt(i.coordSyses, e.coordinateSystem) >= 0;
    }, t.prototype.findTargetInfo = function(r, e) {
      for (var n = this._targetInfoList, i = AM(e, r), a = 0; a < n.length; a++) {
        var o = n[a], s = r.panelId;
        if (s) {
          if (o.panelId === s)
            return o;
        } else
          for (var l = 0; l < DM.length; l++)
            if (DM[l](i, o))
              return o;
      }
      return !0;
    }, t;
  }()
);
function X9(t) {
  return t[0] > t[1] && t.reverse(), t;
}
function AM(t, r) {
  return Up(t, r, {
    includeMainTypes: Pde
  });
}
var Nde = {
  grid: function(t, r) {
    var e = t.xAxisModels, n = t.yAxisModels, i = t.gridModels, a = xe(), o = {}, s = {};
    !e && !n && !i || (L(e, function(l) {
      var u = l.axis.grid.model;
      a.set(u.id, u), o[u.id] = !0;
    }), L(n, function(l) {
      var u = l.axis.grid.model;
      a.set(u.id, u), s[u.id] = !0;
    }), L(i, function(l) {
      a.set(l.id, l), o[l.id] = !0, s[l.id] = !0;
    }), a.each(function(l) {
      var u = l.coordinateSystem, c = [];
      L(u.getCartesians(), function(d, f) {
        (nt(e, d.getAxis("x").model) >= 0 || nt(n, d.getAxis("y").model) >= 0) && c.push(d);
      }), r.push({
        panelId: "grid--" + l.id,
        gridModel: l,
        coordSysModel: l,
        // Use the first one as the representitive coordSys.
        coordSys: c[0],
        coordSyses: c,
        getPanelRect: TM.grid,
        xAxisDeclared: o[l.id],
        yAxisDeclared: s[l.id]
      });
    }));
  },
  geo: function(t, r) {
    L(t.geoModels, function(e) {
      var n = e.coordinateSystem;
      r.push({
        panelId: "geo--" + e.id,
        geoModel: e,
        coordSysModel: e,
        coordSys: n,
        coordSyses: [n],
        getPanelRect: TM.geo
      });
    });
  }
}, DM = [
  // grid
  function(t, r) {
    var e = t.xAxisModel, n = t.yAxisModel, i = t.gridModel;
    return !i && e && (i = e.axis.grid.model), !i && n && (i = n.axis.grid.model), i && i === r.gridModel;
  },
  // geo
  function(t, r) {
    var e = t.geoModel;
    return e && e === r.geoModel;
  }
], TM = {
  grid: function() {
    return this.coordSys.master.getRect().clone();
  },
  geo: function() {
    var t = this.coordSys, r = t.getBoundingRect().clone();
    return r.applyTransform(Hl(t)), r;
  }
}, E3 = {
  lineX: Ye(MM, 0),
  lineY: Ye(MM, 1),
  rect: function(t, r, e, n) {
    var i = t ? r.pointToData([e[0][0], e[1][0]], n) : r.dataToPoint([e[0][0], e[1][0]], n), a = t ? r.pointToData([e[0][1], e[1][1]], n) : r.dataToPoint([e[0][1], e[1][1]], n), o = [X9([i[0], a[0]]), X9([i[1], a[1]])];
    return {
      values: o,
      xyMinMax: o
    };
  },
  polygon: function(t, r, e, n) {
    var i = [[1 / 0, -1 / 0], [1 / 0, -1 / 0]], a = ce(e, function(o) {
      var s = t ? r.pointToData(o, n) : r.dataToPoint(o, n);
      return i[0][0] = Math.min(i[0][0], s[0]), i[1][0] = Math.min(i[1][0], s[1]), i[0][1] = Math.max(i[0][1], s[0]), i[1][1] = Math.max(i[1][1], s[1]), s;
    });
    return {
      values: a,
      xyMinMax: i
    };
  }
};
function MM(t, r, e, n) {
  process.env.NODE_ENV !== "production" && ke(e.type === "cartesian2d", "lineX/lineY brush is available only in cartesian2d.");
  var i = e.getAxis(["x", "y"][t]), a = X9(ce([0, 1], function(s) {
    return r ? i.coordToData(i.toLocalCoord(n[s]), !0) : i.toGlobalCoord(i.dataToCoord(n[s]));
  })), o = [];
  return o[t] = a, o[1 - t] = [NaN, NaN], {
    values: a,
    xyMinMax: o
  };
}
var RM = {
  lineX: Ye(LM, 0),
  lineY: Ye(LM, 1),
  rect: function(t, r, e) {
    return [[t[0][0] - e[0] * r[0][0], t[0][1] - e[0] * r[0][1]], [t[1][0] - e[1] * r[1][0], t[1][1] - e[1] * r[1][1]]];
  },
  polygon: function(t, r, e) {
    return ce(t, function(n, i) {
      return [n[0] - e[0] * r[i][0], n[1] - e[1] * r[i][1]];
    });
  }
};
function LM(t, r, e, n) {
  return [r[0] - n[t] * e[0], r[1] - n[t] * e[1]];
}
function Ode(t, r) {
  var e = EM(t), n = EM(r), i = [e[0] / n[0], e[1] / n[1]];
  return isNaN(i[0]) && (i[0] = 1), isNaN(i[1]) && (i[1] = 1), i;
}
function EM(t) {
  return t ? [t[0][1] - t[0][0], t[1][1] - t[1][0]] : [NaN, NaN];
}
var $9 = L, Vde = R$("toolbox-dataZoom_"), Gde = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return r.prototype.render = function(e, n, i, a) {
      this._brushController || (this._brushController = new n_(i.getZr()), this._brushController.on("brush", ye(this._onBrush, this)).mount()), Hde(e, n, this, a, i), Fde(e, n);
    }, r.prototype.onclick = function(e, n, i) {
      Bde[i].call(this);
    }, r.prototype.remove = function(e, n) {
      this._brushController && this._brushController.unmount();
    }, r.prototype.dispose = function(e, n) {
      this._brushController && this._brushController.dispose();
    }, r.prototype._onBrush = function(e) {
      var n = e.areas;
      if (!e.isEnd || !n.length)
        return;
      var i = {}, a = this.ecModel;
      this._brushController.updateCovers([]);
      var o = new T_(M_(this.model), a, {
        include: ["grid"]
      });
      o.matchOutputRanges(n, a, function(u, c, d) {
        if (d.type === "cartesian2d") {
          var f = u.brushType;
          f === "rect" ? (s("x", d, c[0]), s("y", d, c[1])) : s({
            lineX: "x",
            lineY: "y"
          }[f], d, c);
        }
      }), Mde(a, i), this._dispatchZoomAction(i);
      function s(u, c, d) {
        var f = c.getAxis(u), h = f.model, p = l(u, h, a), v = p.findRepresentativeAxisProxy(h).getMinMaxSpan();
        (v.minValueSpan != null || v.maxValueSpan != null) && (d = id(0, d.slice(), f.scale.getExtent(), 0, v.minValueSpan, v.maxValueSpan)), p && (i[p.id] = {
          dataZoomId: p.id,
          startValue: d[0],
          endValue: d[1]
        });
      }
      function l(u, c, d) {
        var f;
        return d.eachComponent({
          mainType: "dataZoom",
          subType: "select"
        }, function(h) {
          var p = h.getAxisModel(u, c.componentIndex);
          p && (f = h);
        }), f;
      }
    }, r.prototype._dispatchZoomAction = function(e) {
      var n = [];
      $9(e, function(i, a) {
        n.push(Ge(i));
      }), n.length && this.api.dispatchAction({
        type: "dataZoom",
        from: this.uid,
        batch: n
      });
    }, r.getDefaultOption = function(e) {
      var n = {
        show: !0,
        filterMode: "filter",
        // Icon group
        icon: {
          zoom: "M0,13.5h26.9 M13.5,26.9V0 M32.1,13.5H58V58H13.5 V32.1",
          back: "M22,1.4L9.9,13.5l12.3,12.3 M10.3,13.5H54.9v44.6 H10.3v-26"
        },
        // `zoom`, `back`
        title: e.getLocaleModel().get(["toolbox", "dataZoom", "title"]),
        brushStyle: {
          borderWidth: 0,
          color: "rgba(210,219,238,0.2)"
        }
      };
      return n;
    }, r;
  }(_a)
), Bde = {
  zoom: function() {
    var t = !this._isZoomActive;
    this.api.dispatchAction({
      type: "takeGlobalCursor",
      key: "dataZoomSelect",
      dataZoomSelectActive: t
    });
  },
  back: function() {
    this._dispatchZoomAction(Rde(this.ecModel));
  }
};
function M_(t) {
  var r = {
    xAxisIndex: t.get("xAxisIndex", !0),
    yAxisIndex: t.get("yAxisIndex", !0),
    xAxisId: t.get("xAxisId", !0),
    yAxisId: t.get("yAxisId", !0)
  };
  return r.xAxisIndex == null && r.xAxisId == null && (r.xAxisIndex = "all"), r.yAxisIndex == null && r.yAxisId == null && (r.yAxisIndex = "all"), r;
}
function Fde(t, r) {
  t.setIconStatus("back", Ede(r) > 1 ? "emphasis" : "normal");
}
function Hde(t, r, e, n, i) {
  var a = e._isZoomActive;
  n && n.type === "takeGlobalCursor" && (a = n.key === "dataZoomSelect" ? n.dataZoomSelectActive : !1), e._isZoomActive = a, t.setIconStatus("zoom", a ? "emphasis" : "normal");
  var o = new T_(M_(t), r, {
    include: ["grid"]
  }), s = o.makePanelOpts(i, function(l) {
    return l.xAxisDeclared && !l.yAxisDeclared ? "lineX" : !l.xAxisDeclared && l.yAxisDeclared ? "lineY" : "rect";
  });
  e._brushController.setPanels(s).enableBrush(a && s.length ? {
    brushType: "auto",
    brushStyle: t.getModel("brushStyle").getItemStyle()
  } : !1);
}
qJ("dataZoom", function(t) {
  var r = t.getComponent("toolbox", 0), e = ["feature", "dataZoom"];
  if (!r || r.get(e) == null)
    return;
  var n = r.getModel(e), i = [], a = M_(n), o = Up(t, a);
  $9(o.xAxisModels, function(l) {
    return s(l, "xAxis", "xAxisIndex");
  }), $9(o.yAxisModels, function(l) {
    return s(l, "yAxis", "yAxisIndex");
  });
  function s(l, u, c) {
    var d = l.componentIndex, f = {
      type: "select",
      $fromToolbox: !0,
      // Default to be filter
      filterMode: n.get("filterMode", !0) || "filter",
      // Id for merge mapping.
      id: Vde + u + d
    };
    f[c] = d, i.push(f);
  }
  return i;
});
function zde(t) {
  t.registerComponentModel(fde), t.registerComponentView(pde), Yd("saveAsImage", gde), Yd("magicType", yde), Yd("dataView", Dde), Yd("dataZoom", Gde), Yd("restore", kde), lt(dde);
}
var Wde = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.type = "tooltip", r.dependencies = ["axisPointer"], r.defaultOption = {
      // zlevel: 0,
      z: 60,
      show: !0,
      // tooltip main content
      showContent: !0,
      // 'trigger' only works on coordinate system.
      // 'item' | 'axis' | 'none'
      trigger: "item",
      // 'click' | 'mousemove' | 'none'
      triggerOn: "mousemove|click",
      alwaysShowContent: !1,
      displayMode: "single",
      renderMode: "auto",
      // whether restraint content inside viewRect.
      // If renderMode: 'richText', default true.
      // If renderMode: 'html', defaut false (for backward compat).
      confine: null,
      showDelay: 0,
      hideDelay: 100,
      // Animation transition time, unit is second
      transitionDuration: 0.4,
      enterable: !1,
      backgroundColor: "#fff",
      // box shadow
      shadowBlur: 10,
      shadowColor: "rgba(0, 0, 0, .2)",
      shadowOffsetX: 1,
      shadowOffsetY: 2,
      // tooltip border radius, unit is px, default is 4
      borderRadius: 4,
      // tooltip border width, unit is px, default is 0 (no border)
      borderWidth: 1,
      // Tooltip inside padding, default is 5 for all direction
      // Array is allowed to set up, right, bottom, left, same with css
      // The default value: See `tooltip/tooltipMarkup.ts#getPaddingFromTooltipModel`.
      padding: null,
      // Extra css text
      extraCssText: "",
      // axis indicator, trigger by axis
      axisPointer: {
        // default is line
        // legal values: 'line' | 'shadow' | 'cross'
        type: "line",
        // Valid when type is line, appoint tooltip line locate on which line. Optional
        // legal values: 'x' | 'y' | 'angle' | 'radius' | 'auto'
        // default is 'auto', chose the axis which type is category.
        // for multiply y axis, cartesian coord chose x axis, polar chose angle axis
        axis: "auto",
        animation: "auto",
        animationDurationUpdate: 200,
        animationEasingUpdate: "exponentialOut",
        crossStyle: {
          color: "#999",
          width: 1,
          type: "dashed",
          // TODO formatter
          textStyle: {}
        }
        // lineStyle and shadowStyle should not be specified here,
        // otherwise it will always override those styles on option.axisPointer.
      },
      textStyle: {
        color: "#666",
        fontSize: 14
      }
    }, r;
  }(st)
);
function ZF(t) {
  var r = t.get("confine");
  return r != null ? !!r : t.get("renderMode") === "richText";
}
function jF(t) {
  if (vt.domSupported) {
    for (var r = document.documentElement.style, e = 0, n = t.length; e < n; e++)
      if (t[e] in r)
        return t[e];
  }
}
var YF = jF(["transform", "webkitTransform", "OTransform", "MozTransform", "msTransform"]), Zde = jF(["webkitTransition", "transition", "OTransition", "MozTransition", "msTransition"]);
function XF(t, r) {
  if (!t)
    return r;
  r = nw(r, !0);
  var e = t.indexOf(r);
  return t = e === -1 ? r : "-" + t.slice(0, e) + "-" + r, t.toLowerCase();
}
function jde(t, r) {
  var e = t.currentStyle || document.defaultView && document.defaultView.getComputedStyle(t);
  return e ? e[r] : null;
}
var Yde = XF(Zde, "transition"), R_ = XF(YF, "transform"), Xde = "position:absolute;display:block;border-style:solid;white-space:nowrap;z-index:9999999;" + (vt.transform3dSupported ? "will-change:transform;" : "");
function $de(t) {
  return t = t === "left" ? "right" : t === "right" ? "left" : t === "top" ? "bottom" : "top", t;
}
function Ude(t, r, e) {
  if (!pe(e) || e === "inside")
    return "";
  var n = t.get("backgroundColor"), i = t.get("borderWidth");
  r = Hc(r);
  var a = $de(e), o = Math.max(Math.round(i) * 1.5, 6), s = "", l = R_ + ":", u;
  nt(["left", "right"], a) > -1 ? (s += "top:50%", l += "translateY(-50%) rotate(" + (u = a === "left" ? -225 : -45) + "deg)") : (s += "left:50%", l += "translateX(-50%) rotate(" + (u = a === "top" ? 225 : 45) + "deg)");
  var c = u * Math.PI / 180, d = o + i, f = d * Math.abs(Math.cos(c)) + d * Math.abs(Math.sin(c)), h = Math.round(((f - Math.SQRT2 * i) / 2 + Math.SQRT2 * i - (f - d) / 2) * 100) / 100;
  s += ";" + a + ":-" + h + "px";
  var p = r + " solid " + i + "px;", v = ["position:absolute;width:" + o + "px;height:" + o + "px;z-index:-1;", s + ";" + l + ";", "border-bottom:" + p, "border-right:" + p, "background-color:" + n + ";"];
  return '<div style="' + v.join("") + '"></div>';
}
function Jde(t, r) {
  var e = "cubic-bezier(0.23,1,0.32,1)", n = " " + t / 2 + "s " + e, i = "opacity" + n + ",visibility" + n;
  return r || (n = " " + t + "s " + e, i += vt.transformSupported ? "," + R_ + n : ",left" + n + ",top" + n), Yde + ":" + i;
}
function kM(t, r, e) {
  var n = t.toFixed(0) + "px", i = r.toFixed(0) + "px";
  if (!vt.transformSupported)
    return e ? "top:" + i + ";left:" + n + ";" : [["top", i], ["left", n]];
  var a = vt.transform3dSupported, o = "translate" + (a ? "3d" : "") + "(" + n + "," + i + (a ? ",0" : "") + ")";
  return e ? "top:0;left:0;" + R_ + ":" + o + ";" : [["top", 0], ["left", 0], [YF, o]];
}
function Kde(t) {
  var r = [], e = t.get("fontSize"), n = t.getTextColor();
  n && r.push("color:" + n), r.push("font:" + t.getFont()), e && r.push("line-height:" + Math.round(e * 3 / 2) + "px");
  var i = t.get("textShadowColor"), a = t.get("textShadowBlur") || 0, o = t.get("textShadowOffsetX") || 0, s = t.get("textShadowOffsetY") || 0;
  return i && a && r.push("text-shadow:" + o + "px " + s + "px " + a + "px " + i), L(["decoration", "align"], function(l) {
    var u = t.get(l);
    u && r.push("text-" + l + ":" + u);
  }), r.join(";");
}
function qde(t, r, e) {
  var n = [], i = t.get("transitionDuration"), a = t.get("backgroundColor"), o = t.get("shadowBlur"), s = t.get("shadowColor"), l = t.get("shadowOffsetX"), u = t.get("shadowOffsetY"), c = t.getModel("textStyle"), d = nV(t, "html"), f = l + "px " + u + "px " + o + "px " + s;
  return n.push("box-shadow:" + f), r && i && n.push(Jde(i, e)), a && n.push("background-color:" + a), L(["width", "color", "radius"], function(h) {
    var p = "border-" + h, v = nw(p), g = t.get(v);
    g != null && n.push(p + ":" + g + (h === "color" ? "" : "px"));
  }), n.push(Kde(c)), d != null && n.push("padding:" + Qc(d).join("px ") + "px"), n.join(";") + ";";
}
function PM(t, r, e, n, i) {
  var a = r && r.painter;
  if (e) {
    var o = a && a.getViewportRoot();
    o && tX(t, o, e, n, i);
  } else {
    t[0] = n, t[1] = i;
    var s = a && a.getViewportRootOffset();
    s && (t[0] += s.offsetLeft, t[1] += s.offsetTop);
  }
  t[2] = t[0] / r.getWidth(), t[3] = t[1] / r.getHeight();
}
var Qde = (
  /** @class */
  function() {
    function t(r, e) {
      if (this._show = !1, this._styleCoord = [0, 0, 0, 0], this._enterable = !0, this._alwaysShowContent = !1, this._firstShow = !0, this._longHide = !0, vt.wxa)
        return null;
      var n = document.createElement("div");
      n.domBelongToZr = !0, this.el = n;
      var i = this._zr = r.getZr(), a = e.appendTo, o = a && (pe(a) ? document.querySelector(a) : Kl(a) ? a : Ae(a) && a(r.getDom()));
      PM(this._styleCoord, i, o, r.getWidth() / 2, r.getHeight() / 2), (o || r.getDom()).appendChild(n), this._api = r, this._container = o;
      var s = this;
      n.onmouseenter = function() {
        s._enterable && (clearTimeout(s._hideTimeout), s._show = !0), s._inContent = !0;
      }, n.onmousemove = function(l) {
        if (l = l || window.event, !s._enterable) {
          var u = i.handler, c = i.painter.getViewportRoot();
          ga(c, l, !0), u.dispatch("mousemove", l);
        }
      }, n.onmouseleave = function() {
        s._inContent = !1, s._enterable && s._show && s.hideLater(s._hideDelay);
      };
    }
    return t.prototype.update = function(r) {
      if (!this._container) {
        var e = this._api.getDom(), n = jde(e, "position"), i = e.style;
        i.position !== "absolute" && n !== "absolute" && (i.position = "relative");
      }
      var a = r.get("alwaysShowContent");
      a && this._moveIfResized(), this._alwaysShowContent = a, this.el.className = r.get("className") || "";
    }, t.prototype.show = function(r, e) {
      clearTimeout(this._hideTimeout), clearTimeout(this._longHideTimeout);
      var n = this.el, i = n.style, a = this._styleCoord;
      n.innerHTML ? i.cssText = Xde + qde(r, !this._firstShow, this._longHide) + kM(a[0], a[1], !0) + ("border-color:" + Hc(e) + ";") + (r.get("extraCssText") || "") + (";pointer-events:" + (this._enterable ? "auto" : "none")) : i.display = "none", this._show = !0, this._firstShow = !1, this._longHide = !1;
    }, t.prototype.setContent = function(r, e, n, i, a) {
      var o = this.el;
      if (r == null) {
        o.innerHTML = "";
        return;
      }
      var s = "";
      if (pe(a) && n.get("trigger") === "item" && !ZF(n) && (s = Ude(n, i, a)), pe(r))
        o.innerHTML = r + s;
      else if (r) {
        o.innerHTML = "", ue(r) || (r = [r]);
        for (var l = 0; l < r.length; l++)
          Kl(r[l]) && r[l].parentNode !== o && o.appendChild(r[l]);
        if (s && o.childNodes.length) {
          var u = document.createElement("div");
          u.innerHTML = s, o.appendChild(u);
        }
      }
    }, t.prototype.setEnterable = function(r) {
      this._enterable = r;
    }, t.prototype.getSize = function() {
      var r = this.el;
      return [r.offsetWidth, r.offsetHeight];
    }, t.prototype.moveTo = function(r, e) {
      var n = this._styleCoord;
      if (PM(n, this._zr, this._container, r, e), n[0] != null && n[1] != null) {
        var i = this.el.style, a = kM(n[0], n[1]);
        L(a, function(o) {
          i[o[0]] = o[1];
        });
      }
    }, t.prototype._moveIfResized = function() {
      var r = this._styleCoord[2], e = this._styleCoord[3];
      this.moveTo(r * this._zr.getWidth(), e * this._zr.getHeight());
    }, t.prototype.hide = function() {
      var r = this, e = this.el.style;
      e.visibility = "hidden", e.opacity = "0", vt.transform3dSupported && (e.willChange = ""), this._show = !1, this._longHideTimeout = setTimeout(function() {
        return r._longHide = !0;
      }, 500);
    }, t.prototype.hideLater = function(r) {
      this._show && !(this._inContent && this._enterable) && !this._alwaysShowContent && (r ? (this._hideDelay = r, this._show = !1, this._hideTimeout = setTimeout(ye(this.hide, this), r)) : this.hide());
    }, t.prototype.isShow = function() {
      return this._show;
    }, t.prototype.dispose = function() {
      clearTimeout(this._hideTimeout), clearTimeout(this._longHideTimeout);
      var r = this.el.parentNode;
      r && r.removeChild(this.el), this.el = this._container = null;
    }, t;
  }()
), efe = (
  /** @class */
  function() {
    function t(r) {
      this._show = !1, this._styleCoord = [0, 0, 0, 0], this._alwaysShowContent = !1, this._enterable = !0, this._zr = r.getZr(), OM(this._styleCoord, this._zr, r.getWidth() / 2, r.getHeight() / 2);
    }
    return t.prototype.update = function(r) {
      var e = r.get("alwaysShowContent");
      e && this._moveIfResized(), this._alwaysShowContent = e;
    }, t.prototype.show = function() {
      this._hideTimeout && clearTimeout(this._hideTimeout), this.el.show(), this._show = !0;
    }, t.prototype.setContent = function(r, e, n, i, a) {
      var o = this;
      Me(r) && Gt(process.env.NODE_ENV !== "production" ? "Passing DOM nodes as content is not supported in richText tooltip!" : ""), this.el && this._zr.remove(this.el);
      var s = n.getModel("textStyle");
      this.el = new _t({
        style: {
          rich: e.richTextStyles,
          text: r,
          lineHeight: 22,
          borderWidth: 1,
          borderColor: i,
          textShadowColor: s.get("textShadowColor"),
          fill: n.get(["textStyle", "color"]),
          padding: nV(n, "richText"),
          verticalAlign: "top",
          align: "left"
        },
        z: n.get("z")
      }), L(["backgroundColor", "borderRadius", "shadowColor", "shadowBlur", "shadowOffsetX", "shadowOffsetY"], function(u) {
        o.el.style[u] = n.get(u);
      }), L(["textShadowBlur", "textShadowOffsetX", "textShadowOffsetY"], function(u) {
        o.el.style[u] = s.get(u) || 0;
      }), this._zr.add(this.el);
      var l = this;
      this.el.on("mouseover", function() {
        l._enterable && (clearTimeout(l._hideTimeout), l._show = !0), l._inContent = !0;
      }), this.el.on("mouseout", function() {
        l._enterable && l._show && l.hideLater(l._hideDelay), l._inContent = !1;
      });
    }, t.prototype.setEnterable = function(r) {
      this._enterable = r;
    }, t.prototype.getSize = function() {
      var r = this.el, e = this.el.getBoundingRect(), n = NM(r.style);
      return [e.width + n.left + n.right, e.height + n.top + n.bottom];
    }, t.prototype.moveTo = function(r, e) {
      var n = this.el;
      if (n) {
        var i = this._styleCoord;
        OM(i, this._zr, r, e), r = i[0], e = i[1];
        var a = n.style, o = Cl(a.borderWidth || 0), s = NM(a);
        n.x = r + o + s.left, n.y = e + o + s.top, n.markRedraw();
      }
    }, t.prototype._moveIfResized = function() {
      var r = this._styleCoord[2], e = this._styleCoord[3];
      this.moveTo(r * this._zr.getWidth(), e * this._zr.getHeight());
    }, t.prototype.hide = function() {
      this.el && this.el.hide(), this._show = !1;
    }, t.prototype.hideLater = function(r) {
      this._show && !(this._inContent && this._enterable) && !this._alwaysShowContent && (r ? (this._hideDelay = r, this._show = !1, this._hideTimeout = setTimeout(ye(this.hide, this), r)) : this.hide());
    }, t.prototype.isShow = function() {
      return this._show;
    }, t.prototype.dispose = function() {
      this._zr.remove(this.el);
    }, t;
  }()
);
function Cl(t) {
  return Math.max(0, t);
}
function NM(t) {
  var r = Cl(t.shadowBlur || 0), e = Cl(t.shadowOffsetX || 0), n = Cl(t.shadowOffsetY || 0);
  return {
    left: Cl(r - e),
    right: Cl(r + e),
    top: Cl(r - n),
    bottom: Cl(r + n)
  };
}
function OM(t, r, e, n) {
  t[0] = e, t[1] = n, t[2] = t[0] / r.getWidth(), t[3] = t[1] / r.getHeight();
}
var tfe = new xt({
  shape: {
    x: -1,
    y: -1,
    width: 2,
    height: 2
  }
}), rfe = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.init = function(e, n) {
      if (!(vt.node || !n.getDom())) {
        var i = e.getComponent("tooltip"), a = this._renderMode = V$(i.get("renderMode"));
        this._tooltipContent = a === "richText" ? new efe(n) : new Qde(n, {
          appendTo: i.get("appendToBody", !0) ? "body" : i.get("appendTo", !0)
        });
      }
    }, r.prototype.render = function(e, n, i) {
      if (!(vt.node || !i.getDom())) {
        this.group.removeAll(), this._tooltipModel = e, this._ecModel = n, this._api = i;
        var a = this._tooltipContent;
        a.update(e), a.setEnterable(e.get("enterable")), this._initGlobalListener(), this._keepShow(), this._renderMode !== "richText" && e.get("transitionDuration") ? dh(this, "_updatePosition", 50, "fixRate") : Iv(this, "_updatePosition");
      }
    }, r.prototype._initGlobalListener = function() {
      var e = this._tooltipModel, n = e.get("triggerOn");
      LF("itemTooltip", this._api, ye(function(i, a, o) {
        n !== "none" && (n.indexOf(i) >= 0 ? this._tryShow(a, o) : i === "leave" && this._hide(o));
      }, this));
    }, r.prototype._keepShow = function() {
      var e = this._tooltipModel, n = this._ecModel, i = this._api, a = e.get("triggerOn");
      if (this._lastX != null && this._lastY != null && a !== "none" && a !== "click") {
        var o = this;
        clearTimeout(this._refreshUpdateTimeout), this._refreshUpdateTimeout = setTimeout(function() {
          !i.isDisposed() && o.manuallyShowTip(e, n, i, {
            x: o._lastX,
            y: o._lastY,
            dataByCoordSys: o._lastDataByCoordSys
          });
        });
      }
    }, r.prototype.manuallyShowTip = function(e, n, i, a) {
      if (!(a.from === this.uid || vt.node || !i.getDom())) {
        var o = VM(a, i);
        this._ticket = "";
        var s = a.dataByCoordSys, l = ofe(a, n, i);
        if (l) {
          var u = l.el.getBoundingRect().clone();
          u.applyTransform(l.el.transform), this._tryShow({
            offsetX: u.x + u.width / 2,
            offsetY: u.y + u.height / 2,
            target: l.el,
            position: a.position,
            // When manully trigger, the mouse is not on the el, so we'd better to
            // position tooltip on the bottom of the el and display arrow is possible.
            positionDefault: "bottom"
          }, o);
        } else if (a.tooltip && a.x != null && a.y != null) {
          var c = tfe;
          c.x = a.x, c.y = a.y, c.update(), Ze(c).tooltipConfig = {
            name: null,
            option: a.tooltip
          }, this._tryShow({
            offsetX: a.x,
            offsetY: a.y,
            target: c
          }, o);
        } else if (s)
          this._tryShow({
            offsetX: a.x,
            offsetY: a.y,
            position: a.position,
            dataByCoordSys: s,
            tooltipOption: a.tooltipOption
          }, o);
        else if (a.seriesIndex != null) {
          if (this._manuallyAxisShowTip(e, n, i, a))
            return;
          var d = EF(a, n), f = d.point[0], h = d.point[1];
          f != null && h != null && this._tryShow({
            offsetX: f,
            offsetY: h,
            target: d.el,
            position: a.position,
            // When manully trigger, the mouse is not on the el, so we'd better to
            // position tooltip on the bottom of the el and display arrow is possible.
            positionDefault: "bottom"
          }, o);
        } else a.x != null && a.y != null && (i.dispatchAction({
          type: "updateAxisPointer",
          x: a.x,
          y: a.y
        }), this._tryShow({
          offsetX: a.x,
          offsetY: a.y,
          position: a.position,
          target: i.getZr().findHover(a.x, a.y).target
        }, o));
      }
    }, r.prototype.manuallyHideTip = function(e, n, i, a) {
      var o = this._tooltipContent;
      this._tooltipModel && o.hideLater(this._tooltipModel.get("hideDelay")), this._lastX = this._lastY = this._lastDataByCoordSys = null, a.from !== this.uid && this._hide(VM(a, i));
    }, r.prototype._manuallyAxisShowTip = function(e, n, i, a) {
      var o = a.seriesIndex, s = a.dataIndex, l = n.getComponent("axisPointer").coordSysAxesInfo;
      if (!(o == null || s == null || l == null)) {
        var u = n.getSeriesByIndex(o);
        if (u) {
          var c = u.getData(), d = np([c.getItemModel(s), u, (u.coordinateSystem || {}).model], this._tooltipModel);
          if (d.get("trigger") === "axis")
            return i.dispatchAction({
              type: "updateAxisPointer",
              seriesIndex: o,
              dataIndex: s,
              position: a.position
            }), !0;
        }
      }
    }, r.prototype._tryShow = function(e, n) {
      var i = e.target, a = this._tooltipModel;
      if (a) {
        this._lastX = e.offsetX, this._lastY = e.offsetY;
        var o = e.dataByCoordSys;
        if (o && o.length)
          this._showAxisTooltip(o, e);
        else if (i) {
          var s = Ze(i);
          if (s.ssrType === "legend")
            return;
          this._lastDataByCoordSys = null;
          var l, u;
          hc(i, function(c) {
            if (Ze(c).dataIndex != null)
              return l = c, !0;
            if (Ze(c).tooltipConfig != null)
              return u = c, !0;
          }, !0), l ? this._showSeriesItemTooltip(e, l, n) : u ? this._showComponentItemTooltip(e, u, n) : this._hide(n);
        } else
          this._lastDataByCoordSys = null, this._hide(n);
      }
    }, r.prototype._showOrMove = function(e, n) {
      var i = e.get("showDelay");
      n = ye(n, this), clearTimeout(this._showTimout), i > 0 ? this._showTimout = setTimeout(n, i) : n();
    }, r.prototype._showAxisTooltip = function(e, n) {
      var i = this._ecModel, a = this._tooltipModel, o = [n.offsetX, n.offsetY], s = np([n.tooltipOption], a), l = this._renderMode, u = [], c = Sn("section", {
        blocks: [],
        noHeader: !0
      }), d = [], f = new gb();
      L(e, function(y) {
        L(y.dataByAxis, function(b) {
          var C = i.getComponent(b.axisDim + "Axis", b.axisIndex), w = b.value;
          if (!(!C || w == null)) {
            var _ = TF(w, C.axis, i, b.seriesDataIndices, b.valueLabelOpt), x = Sn("section", {
              header: _,
              noHeader: !Aa(_),
              sortBlocks: !0,
              blocks: []
            });
            c.blocks.push(x), L(b.seriesDataIndices, function(I) {
              var D = i.getSeriesByIndex(I.seriesIndex), T = I.dataIndexInside, A = D.getDataParams(T);
              if (!(A.dataIndex < 0)) {
                A.axisDim = b.axisDim, A.axisIndex = b.axisIndex, A.axisType = b.axisType, A.axisId = b.axisId, A.axisValue = Lw(C.axis, {
                  value: w
                }), A.axisValueLabel = _, A.marker = f.makeTooltipMarker("item", Hc(A.color), l);
                var M = wI(D.formatTooltip(T, !0, null)), R = M.frag;
                if (R) {
                  var E = np([D], a).get("valueFormatter");
                  x.blocks.push(E ? ae({
                    valueFormatter: E
                  }, R) : R);
                }
                M.text && d.push(M.text), u.push(A);
              }
            });
          }
        });
      }), c.blocks.reverse(), d.reverse();
      var h = n.position, p = s.get("order"), v = DI(c, f, l, p, i.get("useUTC"), s.get("textStyle"));
      v && d.unshift(v);
      var g = l === "richText" ? `

` : "<br/>", m = d.join(g);
      this._showOrMove(s, function() {
        this._updateContentNotChangedOnAxis(e, u) ? this._updatePosition(s, h, o[0], o[1], this._tooltipContent, u) : this._showTooltipContent(s, m, u, Math.random() + "", o[0], o[1], h, null, f);
      });
    }, r.prototype._showSeriesItemTooltip = function(e, n, i) {
      var a = this._ecModel, o = Ze(n), s = o.seriesIndex, l = a.getSeriesByIndex(s), u = o.dataModel || l, c = o.dataIndex, d = o.dataType, f = u.getData(d), h = this._renderMode, p = e.positionDefault, v = np([f.getItemModel(c), u, l && (l.coordinateSystem || {}).model], this._tooltipModel, p ? {
        position: p
      } : null), g = v.get("trigger");
      if (!(g != null && g !== "item")) {
        var m = u.getDataParams(c, d), y = new gb();
        m.marker = y.makeTooltipMarker("item", Hc(m.color), h);
        var b = wI(u.formatTooltip(c, !1, d)), C = v.get("order"), w = v.get("valueFormatter"), _ = b.frag, x = _ ? DI(w ? ae({
          valueFormatter: w
        }, _) : _, y, h, C, a.get("useUTC"), v.get("textStyle")) : b.text, I = "item_" + u.name + "_" + c;
        this._showOrMove(v, function() {
          this._showTooltipContent(v, x, m, I, e.offsetX, e.offsetY, e.position, e.target, y);
        }), i({
          type: "showTip",
          dataIndexInside: c,
          dataIndex: f.getRawIndex(c),
          seriesIndex: s,
          from: this.uid
        });
      }
    }, r.prototype._showComponentItemTooltip = function(e, n, i) {
      var a = this._renderMode === "html", o = Ze(n), s = o.tooltipConfig, l = s.option || {}, u = l.encodeHTMLContent;
      if (pe(l)) {
        var c = l;
        l = {
          content: c,
          // Fixed formatter
          formatter: c
        }, u = !0;
      }
      u && a && l.content && (l = Ge(l), l.content = bi(l.content));
      var d = [l], f = this._ecModel.getComponent(o.componentMainType, o.componentIndex);
      f && d.push(f), d.push({
        formatter: l.content
      });
      var h = e.positionDefault, p = np(d, this._tooltipModel, h ? {
        position: h
      } : null), v = p.get("content"), g = Math.random() + "", m = new gb();
      this._showOrMove(p, function() {
        var y = Ge(p.get("formatterParams") || {});
        this._showTooltipContent(p, v, y, g, e.offsetX, e.offsetY, e.position, n, m);
      }), i({
        type: "showTip",
        from: this.uid
      });
    }, r.prototype._showTooltipContent = function(e, n, i, a, o, s, l, u, c) {
      if (this._ticket = "", !(!e.get("showContent") || !e.get("show"))) {
        var d = this._tooltipContent;
        d.setEnterable(e.get("enterable"));
        var f = e.get("formatter");
        l = l || e.get("position");
        var h = n, p = this._getNearestPoint([o, s], i, e.get("trigger"), e.get("borderColor")), v = p.color;
        if (f)
          if (pe(f)) {
            var g = e.ecModel.get("useUTC"), m = ue(i) ? i[0] : i, y = m && m.axisType && m.axisType.indexOf("time") >= 0;
            h = f, y && (h = yg(m.axisValue, h, g)), h = iw(h, i, !0);
          } else if (Ae(f)) {
            var b = ye(function(C, w) {
              C === this._ticket && (d.setContent(w, c, e, v, l), this._updatePosition(e, l, o, s, d, i, u));
            }, this);
            this._ticket = a, h = f(i, a, b);
          } else
            h = f;
        d.setContent(h, c, e, v, l), d.show(e, v), this._updatePosition(e, l, o, s, d, i, u);
      }
    }, r.prototype._getNearestPoint = function(e, n, i, a) {
      if (i === "axis" || ue(n))
        return {
          color: a || (this._renderMode === "html" ? "#fff" : "none")
        };
      if (!ue(n))
        return {
          color: a || n.color || n.borderColor
        };
    }, r.prototype._updatePosition = function(e, n, i, a, o, s, l) {
      var u = this._api.getWidth(), c = this._api.getHeight();
      n = n || e.get("position");
      var d = o.getSize(), f = e.get("align"), h = e.get("verticalAlign"), p = l && l.getBoundingRect().clone();
      if (l && p.applyTransform(l.transform), Ae(n) && (n = n([i, a], s, o.el, p, {
        viewSize: [u, c],
        contentSize: d.slice()
      })), ue(n))
        i = he(n[0], u), a = he(n[1], c);
      else if (Me(n)) {
        var v = n;
        v.width = d[0], v.height = d[1];
        var g = cn(v, {
          width: u,
          height: c
        });
        i = g.x, a = g.y, f = null, h = null;
      } else if (pe(n) && l) {
        var m = afe(n, p, d, e.get("borderWidth"));
        i = m[0], a = m[1];
      } else {
        var m = nfe(i, a, o, u, c, f ? null : 20, h ? null : 20);
        i = m[0], a = m[1];
      }
      if (f && (i -= GM(f) ? d[0] / 2 : f === "right" ? d[0] : 0), h && (a -= GM(h) ? d[1] / 2 : h === "bottom" ? d[1] : 0), ZF(e)) {
        var m = ife(i, a, o, u, c);
        i = m[0], a = m[1];
      }
      o.moveTo(i, a);
    }, r.prototype._updateContentNotChangedOnAxis = function(e, n) {
      var i = this._lastDataByCoordSys, a = this._cbParamsList, o = !!i && i.length === e.length;
      return o && L(i, function(s, l) {
        var u = s.dataByAxis || [], c = e[l] || {}, d = c.dataByAxis || [];
        o = o && u.length === d.length, o && L(u, function(f, h) {
          var p = d[h] || {}, v = f.seriesDataIndices || [], g = p.seriesDataIndices || [];
          o = o && f.value === p.value && f.axisType === p.axisType && f.axisId === p.axisId && v.length === g.length, o && L(v, function(m, y) {
            var b = g[y];
            o = o && m.seriesIndex === b.seriesIndex && m.dataIndex === b.dataIndex;
          }), a && L(f.seriesDataIndices, function(m) {
            var y = m.seriesIndex, b = n[y], C = a[y];
            b && C && C.data !== b.data && (o = !1);
          });
        });
      }), this._lastDataByCoordSys = e, this._cbParamsList = n, !!o;
    }, r.prototype._hide = function(e) {
      this._lastDataByCoordSys = null, e({
        type: "hideTip",
        from: this.uid
      });
    }, r.prototype.dispose = function(e, n) {
      vt.node || !n.getDom() || (Iv(this, "_updatePosition"), this._tooltipContent.dispose(), W9("itemTooltip", n));
    }, r.type = "tooltip", r;
  }(yr)
);
function np(t, r, e) {
  var n = r.ecModel, i;
  e ? (i = new Pt(e, n, n), i = new Pt(r.option, i, n)) : i = r;
  for (var a = t.length - 1; a >= 0; a--) {
    var o = t[a];
    o && (o instanceof Pt && (o = o.get("tooltip", !0)), pe(o) && (o = {
      formatter: o
    }), o && (i = new Pt(o, i, n)));
  }
  return i;
}
function VM(t, r) {
  return t.dispatchAction || ye(r.dispatchAction, r);
}
function nfe(t, r, e, n, i, a, o) {
  var s = e.getSize(), l = s[0], u = s[1];
  return a != null && (t + l + a + 2 > n ? t -= l + a : t += a), o != null && (r + u + o > i ? r -= u + o : r += o), [t, r];
}
function ife(t, r, e, n, i) {
  var a = e.getSize(), o = a[0], s = a[1];
  return t = Math.min(t + o, n) - o, r = Math.min(r + s, i) - s, t = Math.max(t, 0), r = Math.max(r, 0), [t, r];
}
function afe(t, r, e, n) {
  var i = e[0], a = e[1], o = Math.ceil(Math.SQRT2 * n) + 8, s = 0, l = 0, u = r.width, c = r.height;
  switch (t) {
    case "inside":
      s = r.x + u / 2 - i / 2, l = r.y + c / 2 - a / 2;
      break;
    case "top":
      s = r.x + u / 2 - i / 2, l = r.y - a - o;
      break;
    case "bottom":
      s = r.x + u / 2 - i / 2, l = r.y + c + o;
      break;
    case "left":
      s = r.x - i - o, l = r.y + c / 2 - a / 2;
      break;
    case "right":
      s = r.x + u + o, l = r.y + c / 2 - a / 2;
  }
  return [s, l];
}
function GM(t) {
  return t === "center" || t === "middle";
}
function ofe(t, r, e) {
  var n = P7(t).queryOptionMap, i = n.keys()[0];
  if (!(!i || i === "series")) {
    var a = fg(r, i, n.get(i), {
      useDefault: !1,
      enableAll: !1,
      enableNone: !1
    }), o = a.models[0];
    if (o) {
      var s = e.getViewOfComponentModel(o), l;
      if (s.group.traverse(function(u) {
        var c = Ze(u).tooltipConfig;
        if (c && c.name === t.name)
          return l = u, !0;
      }), l)
        return {
          componentMainType: i,
          componentIndex: o.componentIndex,
          el: l
        };
    }
  }
}
function sfe(t) {
  lt(Mg), t.registerComponentModel(Wde), t.registerComponentView(rfe), t.registerAction({
    type: "showTip",
    event: "showTip",
    update: "tooltip:manuallyShowTip"
  }, Yr), t.registerAction({
    type: "hideTip",
    event: "hideTip",
    update: "tooltip:manuallyHideTip"
  }, Yr);
}
var lfe = ["rect", "polygon", "keep", "clear"];
function ufe(t, r) {
  var e = Qt(t ? t.brush : []);
  if (e.length) {
    var n = [];
    L(e, function(l) {
      var u = l.hasOwnProperty("toolbox") ? l.toolbox : [];
      u instanceof Array && (n = n.concat(u));
    });
    var i = t && t.toolbox;
    ue(i) && (i = i[0]), i || (i = {
      feature: {}
    }, t.toolbox = [i]);
    var a = i.feature || (i.feature = {}), o = a.brush || (a.brush = {}), s = o.type || (o.type = []);
    s.push.apply(s, n), cfe(s), r && !s.length && s.push.apply(s, lfe);
  }
}
function cfe(t) {
  var r = {};
  L(t, function(e) {
    r[e] = 1;
  }), t.length = 0, L(r, function(e, n) {
    t.push(n);
  });
}
var BM = L;
function FM(t) {
  if (t) {
    for (var r in t)
      if (t.hasOwnProperty(r))
        return !0;
  }
}
function U9(t, r, e) {
  var n = {};
  return BM(r, function(a) {
    var o = n[a] = i();
    BM(t[a], function(s, l) {
      if (_n.isValidType(l)) {
        var u = {
          type: l,
          visual: s
        };
        e && e(u, a), o[l] = new _n(u), l === "opacity" && (u = Ge(u), u.type = "colorAlpha", o.__hidden.__alphaForOpacity = new _n(u));
      }
    });
  }), n;
  function i() {
    var a = function() {
    };
    a.prototype.__hidden = a.prototype;
    var o = new a();
    return o;
  }
}
function $F(t, r, e) {
  var n;
  L(e, function(i) {
    r.hasOwnProperty(i) && FM(r[i]) && (n = !0);
  }), n && L(e, function(i) {
    r.hasOwnProperty(i) && FM(r[i]) ? t[i] = Ge(r[i]) : delete t[i];
  });
}
function dfe(t, r, e, n, i, a) {
  var o = {};
  L(t, function(d) {
    var f = _n.prepareVisualTypes(r[d]);
    o[d] = f;
  });
  var s;
  function l(d) {
    return pw(e, s, d);
  }
  function u(d, f) {
    hV(e, s, d, f);
  }
  e.each(c);
  function c(d, f) {
    s = d;
    var h = e.getRawDataItem(s);
    if (!(h && h.visualMap === !1))
      for (var p = n.call(i, d), v = r[p], g = o[p], m = 0, y = g.length; m < y; m++) {
        var b = g[m];
        v[b] && v[b].applyVisual(d, l, u);
      }
  }
}
function ffe(t, r, e, n) {
  var i = {};
  return L(t, function(a) {
    var o = _n.prepareVisualTypes(r[a]);
    i[a] = o;
  }), {
    progress: function(o, s) {
      var l;
      n != null && (l = s.getDimensionIndex(n));
      function u(w) {
        return pw(s, d, w);
      }
      function c(w, _) {
        hV(s, d, w, _);
      }
      for (var d, f = s.getStore(); (d = o.next()) != null; ) {
        var h = s.getRawDataItem(d);
        if (!(h && h.visualMap === !1))
          for (var p = n != null ? f.get(l, d) : d, v = e(p), g = r[v], m = i[v], y = 0, b = m.length; y < b; y++) {
            var C = m[y];
            g[C] && g[C].applyVisual(p, u, c);
          }
      }
    }
  };
}
function hfe(t) {
  var r = t.brushType, e = {
    point: function(n) {
      return HM[r].point(n, e, t);
    },
    rect: function(n) {
      return HM[r].rect(n, e, t);
    }
  };
  return e;
}
var HM = {
  lineX: zM(0),
  lineY: zM(1),
  rect: {
    point: function(t, r, e) {
      return t && e.boundingRect.contain(t[0], t[1]);
    },
    rect: function(t, r, e) {
      return t && e.boundingRect.intersect(t);
    }
  },
  polygon: {
    point: function(t, r, e) {
      return t && e.boundingRect.contain(t[0], t[1]) && ic(e.range, t[0], t[1]);
    },
    rect: function(t, r, e) {
      var n = e.range;
      if (!t || n.length <= 1)
        return !1;
      var i = t.x, a = t.y, o = t.width, s = t.height, l = n[0];
      if (ic(n, i, a) || ic(n, i + o, a) || ic(n, i, a + s) || ic(n, i + o, a + s) || rt.create(t).contain(l[0], l[1]) || Mp(i, a, i + o, a, n) || Mp(i, a, i, a + s, n) || Mp(i + o, a, i + o, a + s, n) || Mp(i, a + s, i + o, a + s, n))
        return !0;
    }
  }
};
function zM(t) {
  var r = ["x", "y"], e = ["width", "height"];
  return {
    point: function(n, i, a) {
      if (n) {
        var o = a.range, s = n[t];
        return ip(s, o);
      }
    },
    rect: function(n, i, a) {
      if (n) {
        var o = a.range, s = [n[r[t]], n[r[t]] + n[e[t]]];
        return s[1] < s[0] && s.reverse(), ip(s[0], o) || ip(s[1], o) || ip(o[0], s) || ip(o[1], s);
      }
    }
  };
}
function ip(t, r) {
  return r[0] <= t && t <= r[1];
}
var WM = ["inBrush", "outOfBrush"], k3 = "__ecBrushSelect", J9 = "__ecInBrushSelectEvent";
function UF(t) {
  t.eachComponent({
    mainType: "brush"
  }, function(r) {
    var e = r.brushTargetManager = new T_(r.option, t);
    e.setInputRanges(r.areas, t);
  });
}
function pfe(t, r, e) {
  var n = [], i, a;
  t.eachComponent({
    mainType: "brush"
  }, function(o) {
    e && e.type === "takeGlobalCursor" && o.setBrushOption(e.key === "brush" ? e.brushOption : {
      brushType: !1
    });
  }), UF(t), t.eachComponent({
    mainType: "brush"
  }, function(o, s) {
    var l = {
      brushId: o.id,
      brushIndex: s,
      brushName: o.name,
      areas: Ge(o.areas),
      selected: []
    };
    n.push(l);
    var u = o.option, c = u.brushLink, d = [], f = [], h = [], p = !1;
    s || (i = u.throttleType, a = u.throttleDelay);
    var v = ce(o.areas, function(w) {
      var _ = yfe[w.brushType], x = Ee({
        boundingRect: _ ? _(w) : void 0
      }, w);
      return x.selectors = hfe(x), x;
    }), g = U9(o.option, WM, function(w) {
      w.mappingMethod = "fixed";
    });
    ue(c) && L(c, function(w) {
      d[w] = 1;
    });
    function m(w) {
      return c === "all" || !!d[w];
    }
    function y(w) {
      return !!w.length;
    }
    t.eachSeries(function(w, _) {
      var x = h[_] = [];
      w.subType === "parallel" ? b(w, _) : C(w, _, x);
    });
    function b(w, _) {
      var x = w.coordinateSystem;
      p = p || x.hasAxisBrushed(), m(_) && x.eachActiveState(w.getData(), function(I, D) {
        I === "active" && (f[D] = 1);
      });
    }
    function C(w, _, x) {
      if (!(!w.brushSelector || mfe(o, _)) && (L(v, function(D) {
        o.brushTargetManager.controlSeries(D, w, t) && x.push(D), p = p || y(x);
      }), m(_) && y(x))) {
        var I = w.getData();
        I.each(function(D) {
          ZM(w, x, I, D) && (f[D] = 1);
        });
      }
    }
    t.eachSeries(function(w, _) {
      var x = {
        seriesId: w.id,
        seriesIndex: _,
        seriesName: w.name,
        dataIndex: []
      };
      l.selected.push(x);
      var I = h[_], D = w.getData(), T = m(_) ? function(A) {
        return f[A] ? (x.dataIndex.push(D.getRawIndex(A)), "inBrush") : "outOfBrush";
      } : function(A) {
        return ZM(w, I, D, A) ? (x.dataIndex.push(D.getRawIndex(A)), "inBrush") : "outOfBrush";
      };
      (m(_) ? p : y(I)) && dfe(WM, g, D, T);
    });
  }), vfe(r, i, a, n, e);
}
function vfe(t, r, e, n, i) {
  if (i) {
    var a = t.getZr();
    if (!a[J9]) {
      a[k3] || (a[k3] = gfe);
      var o = dh(a, k3, e, r);
      o(t, n);
    }
  }
}
function gfe(t, r) {
  if (!t.isDisposed()) {
    var e = t.getZr();
    e[J9] = !0, t.dispatchAction({
      type: "brushSelect",
      batch: r
    }), e[J9] = !1;
  }
}
function ZM(t, r, e, n) {
  for (var i = 0, a = r.length; i < a; i++) {
    var o = r[i];
    if (t.brushSelector(n, e, o.selectors, o))
      return !0;
  }
}
function mfe(t, r) {
  var e = t.option.seriesIndex;
  return e != null && e !== "all" && (ue(e) ? nt(e, r) < 0 : r !== e);
}
var yfe = {
  rect: function(t) {
    return jM(t.range);
  },
  polygon: function(t) {
    for (var r, e = t.range, n = 0, i = e.length; n < i; n++) {
      r = r || [[1 / 0, -1 / 0], [1 / 0, -1 / 0]];
      var a = e[n];
      a[0] < r[0][0] && (r[0][0] = a[0]), a[0] > r[0][1] && (r[0][1] = a[0]), a[1] < r[1][0] && (r[1][0] = a[1]), a[1] > r[1][1] && (r[1][1] = a[1]);
    }
    return r && jM(r);
  }
};
function jM(t) {
  return new rt(t[0][0], t[1][0], t[0][1] - t[0][0], t[1][1] - t[1][0]);
}
var bfe = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.init = function(e, n) {
      this.ecModel = e, this.api = n, this.model, (this._brushController = new n_(n.getZr())).on("brush", ye(this._onBrush, this)).mount();
    }, r.prototype.render = function(e, n, i, a) {
      this.model = e, this._updateController(e, n, i, a);
    }, r.prototype.updateTransform = function(e, n, i, a) {
      UF(n), this._updateController(e, n, i, a);
    }, r.prototype.updateVisual = function(e, n, i, a) {
      this.updateTransform(e, n, i, a);
    }, r.prototype.updateView = function(e, n, i, a) {
      this._updateController(e, n, i, a);
    }, r.prototype._updateController = function(e, n, i, a) {
      (!a || a.$from !== e.id) && this._brushController.setPanels(e.brushTargetManager.makePanelOpts(i)).enableBrush(e.brushOption).updateCovers(e.areas.slice());
    }, r.prototype.dispose = function() {
      this._brushController.dispose();
    }, r.prototype._onBrush = function(e) {
      var n = this.model.id, i = this.model.brushTargetManager.setOutputRanges(e.areas, this.ecModel);
      (!e.isEnd || e.removeOnClick) && this.api.dispatchAction({
        type: "brush",
        brushId: n,
        areas: Ge(i),
        $from: n
      }), e.isEnd && this.api.dispatchAction({
        type: "brushEnd",
        brushId: n,
        areas: Ge(i),
        $from: n
      });
    }, r.type = "brush", r;
  }(yr)
), Cfe = "#ddd", wfe = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e.areas = [], e.brushOption = {}, e;
    }
    return r.prototype.optionUpdated = function(e, n) {
      var i = this.option;
      !n && $F(i, e, ["inBrush", "outOfBrush"]);
      var a = i.inBrush = i.inBrush || {};
      i.outOfBrush = i.outOfBrush || {
        color: Cfe
      }, a.hasOwnProperty("liftZ") || (a.liftZ = 5);
    }, r.prototype.setAreas = function(e) {
      process.env.NODE_ENV !== "production" && (ke(ue(e)), L(e, function(n) {
        ke(n.brushType, "Illegal areas");
      })), e && (this.areas = ce(e, function(n) {
        return YM(this.option, n);
      }, this));
    }, r.prototype.setBrushOption = function(e) {
      this.brushOption = YM(this.option, e), this.brushType = this.brushOption.brushType;
    }, r.type = "brush", r.dependencies = ["geo", "grid", "xAxis", "yAxis", "parallel", "series"], r.defaultOption = {
      seriesIndex: "all",
      brushType: "rect",
      brushMode: "single",
      transformable: !0,
      brushStyle: {
        borderWidth: 1,
        color: "rgba(210,219,238,0.3)",
        borderColor: "#D2DBEE"
      },
      throttleType: "fixRate",
      throttleDelay: 0,
      removeOnClick: !0,
      z: 1e4
    }, r;
  }(st)
);
function YM(t, r) {
  return Qe({
    brushType: t.brushType,
    brushMode: t.brushMode,
    transformable: t.transformable,
    brushStyle: new Pt(t.brushStyle).getItemStyle(),
    removeOnClick: t.removeOnClick,
    z: t.z
  }, r, !0);
}
var _fe = ["rect", "polygon", "lineX", "lineY", "keep", "clear"], xfe = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return r.prototype.render = function(e, n, i) {
      var a, o, s;
      n.eachComponent({
        mainType: "brush"
      }, function(l) {
        a = l.brushType, o = l.brushOption.brushMode || "single", s = s || !!l.areas.length;
      }), this._brushType = a, this._brushMode = o, L(e.get("type", !0), function(l) {
        e.setIconStatus(l, (l === "keep" ? o === "multiple" : l === "clear" ? s : l === a) ? "emphasis" : "normal");
      });
    }, r.prototype.updateView = function(e, n, i) {
      this.render(e, n, i);
    }, r.prototype.getIcons = function() {
      var e = this.model, n = e.get("icon", !0), i = {};
      return L(e.get("type", !0), function(a) {
        n[a] && (i[a] = n[a]);
      }), i;
    }, r.prototype.onclick = function(e, n, i) {
      var a = this._brushType, o = this._brushMode;
      i === "clear" ? (n.dispatchAction({
        type: "axisAreaSelect",
        intervals: []
      }), n.dispatchAction({
        type: "brush",
        command: "clear",
        // Clear all areas of all brush components.
        areas: []
      })) : n.dispatchAction({
        type: "takeGlobalCursor",
        key: "brush",
        brushOption: {
          brushType: i === "keep" ? a : a === i ? !1 : i,
          brushMode: i === "keep" ? o === "multiple" ? "single" : "multiple" : o
        }
      });
    }, r.getDefaultOption = function(e) {
      var n = {
        show: !0,
        type: _fe.slice(),
        icon: {
          /* eslint-disable */
          rect: "M7.3,34.7 M0.4,10V-0.2h9.8 M89.6,10V-0.2h-9.8 M0.4,60v10.2h9.8 M89.6,60v10.2h-9.8 M12.3,22.4V10.5h13.1 M33.6,10.5h7.8 M49.1,10.5h7.8 M77.5,22.4V10.5h-13 M12.3,31.1v8.2 M77.7,31.1v8.2 M12.3,47.6v11.9h13.1 M33.6,59.5h7.6 M49.1,59.5 h7.7 M77.5,47.6v11.9h-13",
          polygon: "M55.2,34.9c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1 s-3.1-1.4-3.1-3.1S53.5,34.9,55.2,34.9z M50.4,51c1.7,0,3.1,1.4,3.1,3.1c0,1.7-1.4,3.1-3.1,3.1c-1.7,0-3.1-1.4-3.1-3.1 C47.3,52.4,48.7,51,50.4,51z M55.6,37.1l1.5-7.8 M60.1,13.5l1.6-8.7l-7.8,4 M59,19l-1,5.3 M24,16.1l6.4,4.9l6.4-3.3 M48.5,11.6 l-5.9,3.1 M19.1,12.8L9.7,5.1l1.1,7.7 M13.4,29.8l1,7.3l6.6,1.6 M11.6,18.4l1,6.1 M32.8,41.9 M26.6,40.4 M27.3,40.2l6.1,1.6 M49.9,52.1l-5.6-7.6l-4.9-1.2",
          lineX: "M15.2,30 M19.7,15.6V1.9H29 M34.8,1.9H40.4 M55.3,15.6V1.9H45.9 M19.7,44.4V58.1H29 M34.8,58.1H40.4 M55.3,44.4 V58.1H45.9 M12.5,20.3l-9.4,9.6l9.6,9.8 M3.1,29.9h16.5 M62.5,20.3l9.4,9.6L62.3,39.7 M71.9,29.9H55.4",
          lineY: "M38.8,7.7 M52.7,12h13.2v9 M65.9,26.6V32 M52.7,46.3h13.2v-9 M24.9,12H11.8v9 M11.8,26.6V32 M24.9,46.3H11.8v-9 M48.2,5.1l-9.3-9l-9.4,9.2 M38.9-3.9V12 M48.2,53.3l-9.3,9l-9.4-9.2 M38.9,62.3V46.4",
          keep: "M4,10.5V1h10.3 M20.7,1h6.1 M33,1h6.1 M55.4,10.5V1H45.2 M4,17.3v6.6 M55.6,17.3v6.6 M4,30.5V40h10.3 M20.7,40 h6.1 M33,40h6.1 M55.4,30.5V40H45.2 M21,18.9h62.9v48.6H21V18.9z",
          clear: "M22,14.7l30.9,31 M52.9,14.7L22,45.7 M4.7,16.8V4.2h13.1 M26,4.2h7.8 M41.6,4.2h7.8 M70.3,16.8V4.2H57.2 M4.7,25.9v8.6 M70.3,25.9v8.6 M4.7,43.2v12.6h13.1 M26,55.8h7.8 M41.6,55.8h7.8 M70.3,43.2v12.6H57.2"
          // jshint ignore:line
          /* eslint-enable */
        },
        // `rect`, `polygon`, `lineX`, `lineY`, `keep`, `clear`
        title: e.getLocaleModel().get(["toolbox", "brush", "title"])
      };
      return n;
    }, r;
  }(_a)
);
function Sfe(t) {
  t.registerComponentView(bfe), t.registerComponentModel(wfe), t.registerPreprocessor(ufe), t.registerVisual(t.PRIORITY.VISUAL.BRUSH, pfe), t.registerAction({
    type: "brush",
    event: "brush",
    update: "updateVisual"
  }, function(r, e) {
    e.eachComponent({
      mainType: "brush",
      query: r
    }, function(n) {
      n.setAreas(r.areas);
    });
  }), t.registerAction({
    type: "brushSelect",
    event: "brushSelected",
    update: "none"
  }, Yr), t.registerAction({
    type: "brushEnd",
    event: "brushEnd",
    update: "none"
  }, Yr), Yd("brush", xfe);
}
var Ife = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e.layoutMode = {
        type: "box",
        ignoreSize: !0
      }, e;
    }
    return r.type = "title", r.defaultOption = {
      // zlevel: 0,
      z: 6,
      show: !0,
      text: "",
      target: "blank",
      subtext: "",
      subtarget: "blank",
      left: 0,
      top: 0,
      backgroundColor: "rgba(0,0,0,0)",
      borderColor: "#ccc",
      borderWidth: 0,
      padding: 5,
      itemGap: 10,
      textStyle: {
        fontSize: 18,
        fontWeight: "bold",
        color: "#464646"
      },
      subtextStyle: {
        fontSize: 12,
        color: "#6E7079"
      }
    }, r;
  }(st)
), Afe = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.render = function(e, n, i) {
      if (this.group.removeAll(), !!e.get("show")) {
        var a = this.group, o = e.getModel("textStyle"), s = e.getModel("subtextStyle"), l = e.get("textAlign"), u = je(e.get("textBaseline"), e.get("textVerticalAlign")), c = new _t({
          style: fr(o, {
            text: e.get("text"),
            fill: o.getTextColor()
          }, {
            disableBox: !0
          }),
          z2: 10
        }), d = c.getBoundingRect(), f = e.get("subtext"), h = new _t({
          style: fr(s, {
            text: f,
            fill: s.getTextColor(),
            y: d.height + e.get("itemGap"),
            verticalAlign: "top"
          }, {
            disableBox: !0
          }),
          z2: 10
        }), p = e.get("link"), v = e.get("sublink"), g = e.get("triggerEvent", !0);
        c.silent = !p && !g, h.silent = !v && !g, p && c.on("click", function() {
          Im(p, "_" + e.get("target"));
        }), v && h.on("click", function() {
          Im(v, "_" + e.get("subtarget"));
        }), Ze(c).eventData = Ze(h).eventData = g ? {
          componentType: "title",
          componentIndex: e.componentIndex
        } : null, a.add(c), f && a.add(h);
        var m = a.getBoundingRect(), y = e.getBoxLayoutParams();
        y.width = m.width, y.height = m.height;
        var b = cn(y, {
          width: i.getWidth(),
          height: i.getHeight()
        }, e.get("padding"));
        l || (l = e.get("left") || e.get("right"), l === "middle" && (l = "center"), l === "right" ? b.x += b.width : l === "center" && (b.x += b.width / 2)), u || (u = e.get("top") || e.get("bottom"), u === "center" && (u = "middle"), u === "bottom" ? b.y += b.height : u === "middle" && (b.y += b.height / 2), u = u || "top"), a.x = b.x, a.y = b.y, a.markRedraw();
        var C = {
          align: l,
          verticalAlign: u
        };
        c.setStyle(C), h.setStyle(C), m = a.getBoundingRect();
        var w = b.margin, _ = e.getItemStyle(["color", "opacity"]);
        _.fill = e.get("backgroundColor");
        var x = new xt({
          shape: {
            x: m.x - w[3],
            y: m.y - w[0],
            width: m.width + w[1] + w[3],
            height: m.height + w[0] + w[2],
            r: e.get("borderRadius")
          },
          style: _,
          subPixelOptimize: !0,
          silent: !0
        });
        a.add(x);
      }
    }, r.type = "title", r;
  }(yr)
);
function Dfe(t) {
  t.registerComponentModel(Ife), t.registerComponentView(Afe);
}
var XM = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e.layoutMode = "box", e;
    }
    return r.prototype.init = function(e, n, i) {
      this.mergeDefaultAndTheme(e, i), this._initData();
    }, r.prototype.mergeOption = function(e) {
      t.prototype.mergeOption.apply(this, arguments), this._initData();
    }, r.prototype.setCurrentIndex = function(e) {
      e == null && (e = this.option.currentIndex);
      var n = this._data.count();
      this.option.loop ? e = (e % n + n) % n : (e >= n && (e = n - 1), e < 0 && (e = 0)), this.option.currentIndex = e;
    }, r.prototype.getCurrentIndex = function() {
      return this.option.currentIndex;
    }, r.prototype.isIndexMax = function() {
      return this.getCurrentIndex() >= this._data.count() - 1;
    }, r.prototype.setPlayState = function(e) {
      this.option.autoPlay = !!e;
    }, r.prototype.getPlayState = function() {
      return !!this.option.autoPlay;
    }, r.prototype._initData = function() {
      var e = this.option, n = e.data || [], i = e.axisType, a = this._names = [], o;
      i === "category" ? (o = [], L(n, function(u, c) {
        var d = vn(qf(u), ""), f;
        Me(u) ? (f = Ge(u), f.value = c) : f = c, o.push(f), a.push(d);
      })) : o = n;
      var s = {
        category: "ordinal",
        time: "time",
        value: "number"
      }[i] || "number", l = this._data = new ni([{
        name: "value",
        type: s
      }], this);
      l.initData(o, a);
    }, r.prototype.getData = function() {
      return this._data;
    }, r.prototype.getCategories = function() {
      if (this.get("axisType") === "category")
        return this._names.slice();
    }, r.type = "timeline", r.defaultOption = {
      // zlevel: 0,                  // 一级层叠
      z: 4,
      show: !0,
      axisType: "time",
      realtime: !0,
      left: "20%",
      top: null,
      right: "20%",
      bottom: 0,
      width: null,
      height: 40,
      padding: 5,
      controlPosition: "left",
      autoPlay: !1,
      rewind: !1,
      loop: !0,
      playInterval: 2e3,
      currentIndex: 0,
      itemStyle: {},
      label: {
        color: "#000"
      },
      data: []
    }, r;
  }(st)
), JF = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.type = "timeline.slider", r.defaultOption = vu(XM.defaultOption, {
      backgroundColor: "rgba(0,0,0,0)",
      borderColor: "#ccc",
      borderWidth: 0,
      orient: "horizontal",
      inverse: !1,
      tooltip: {
        trigger: "item"
        // data item may also have tootip attr.
      },
      symbol: "circle",
      symbolSize: 12,
      lineStyle: {
        show: !0,
        width: 2,
        color: "#DAE1F5"
      },
      label: {
        position: "auto",
        // When using number, label position is not
        // restricted by viewRect.
        // positive: right/bottom, negative: left/top
        show: !0,
        interval: "auto",
        rotate: 0,
        // formatter: null,
        // 其余属性默认使用全局文本样式，详见TEXTSTYLE
        color: "#A4B1D7"
      },
      itemStyle: {
        color: "#A4B1D7",
        borderWidth: 1
      },
      checkpointStyle: {
        symbol: "circle",
        symbolSize: 15,
        color: "#316bf3",
        borderColor: "#fff",
        borderWidth: 2,
        shadowBlur: 2,
        shadowOffsetX: 1,
        shadowOffsetY: 1,
        shadowColor: "rgba(0, 0, 0, 0.3)",
        // borderColor: 'rgba(194,53,49, 0.5)',
        animation: !0,
        animationDuration: 300,
        animationEasing: "quinticInOut"
      },
      controlStyle: {
        show: !0,
        showPlayBtn: !0,
        showPrevBtn: !0,
        showNextBtn: !0,
        itemSize: 24,
        itemGap: 12,
        position: "left",
        playIcon: "path://M31.6,53C17.5,53,6,41.5,6,27.4S17.5,1.8,31.6,1.8C45.7,1.8,57.2,13.3,57.2,27.4S45.7,53,31.6,53z M31.6,3.3 C18.4,3.3,7.5,14.1,7.5,27.4c0,13.3,10.8,24.1,24.1,24.1C44.9,51.5,55.7,40.7,55.7,27.4C55.7,14.1,44.9,3.3,31.6,3.3z M24.9,21.3 c0-2.2,1.6-3.1,3.5-2l10.5,6.1c1.899,1.1,1.899,2.9,0,4l-10.5,6.1c-1.9,1.1-3.5,0.2-3.5-2V21.3z",
        stopIcon: "path://M30.9,53.2C16.8,53.2,5.3,41.7,5.3,27.6S16.8,2,30.9,2C45,2,56.4,13.5,56.4,27.6S45,53.2,30.9,53.2z M30.9,3.5C17.6,3.5,6.8,14.4,6.8,27.6c0,13.3,10.8,24.1,24.101,24.1C44.2,51.7,55,40.9,55,27.6C54.9,14.4,44.1,3.5,30.9,3.5z M36.9,35.8c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H36c0.5,0,0.9,0.4,0.9,1V35.8z M27.8,35.8 c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H27c0.5,0,0.9,0.4,0.9,1L27.8,35.8L27.8,35.8z",
        // eslint-disable-next-line max-len
        nextIcon: "M2,18.5A1.52,1.52,0,0,1,.92,18a1.49,1.49,0,0,1,0-2.12L7.81,9.36,1,3.11A1.5,1.5,0,1,1,3,.89l8,7.34a1.48,1.48,0,0,1,.49,1.09,1.51,1.51,0,0,1-.46,1.1L3,18.08A1.5,1.5,0,0,1,2,18.5Z",
        // eslint-disable-next-line max-len
        prevIcon: "M10,.5A1.52,1.52,0,0,1,11.08,1a1.49,1.49,0,0,1,0,2.12L4.19,9.64,11,15.89a1.5,1.5,0,1,1-2,2.22L1,10.77A1.48,1.48,0,0,1,.5,9.68,1.51,1.51,0,0,1,1,8.58L9,.92A1.5,1.5,0,0,1,10,.5Z",
        prevBtnSize: 18,
        nextBtnSize: 18,
        color: "#A4B1D7",
        borderColor: "#A4B1D7",
        borderWidth: 1
      },
      emphasis: {
        label: {
          show: !0,
          // 其余属性默认使用全局文本样式，详见TEXTSTYLE
          color: "#6f778d"
        },
        itemStyle: {
          color: "#316BF3"
        },
        controlStyle: {
          color: "#316BF3",
          borderColor: "#316BF3",
          borderWidth: 2
        }
      },
      progress: {
        lineStyle: {
          color: "#316BF3"
        },
        itemStyle: {
          color: "#316BF3"
        },
        label: {
          color: "#6f778d"
        }
      },
      data: []
    }), r;
  }(XM)
);
Xr(JF, C2.prototype);
var Tfe = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.type = "timeline", r;
  }(yr)
), Mfe = (
  /** @class */
  function(t) {
    ee(r, t);
    function r(e, n, i, a) {
      var o = t.call(this, e, n, i) || this;
      return o.type = a || "value", o;
    }
    return r.prototype.getLabelModel = function() {
      return this.model.getModel("label");
    }, r.prototype.isHorizontal = function() {
      return this.model.get("orient") === "horizontal";
    }, r;
  }(Va)
), P3 = Math.PI, $M = It(), Rfe = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.init = function(e, n) {
      this.api = n;
    }, r.prototype.render = function(e, n, i) {
      if (this.model = e, this.api = i, this.ecModel = n, this.group.removeAll(), e.get("show", !0)) {
        var a = this._layout(e, i), o = this._createGroup("_mainGroup"), s = this._createGroup("_labelGroup"), l = this._axis = this._createAxis(a, e);
        e.formatTooltip = function(u) {
          var c = l.scale.getLabel({
            value: u
          });
          return Sn("nameValue", {
            noName: !0,
            value: c
          });
        }, L(["AxisLine", "AxisTick", "Control", "CurrentPointer"], function(u) {
          this["_render" + u](a, o, l, e);
        }, this), this._renderAxisLabel(a, s, l, e), this._position(a, e);
      }
      this._doPlayStop(), this._updateTicksStatus();
    }, r.prototype.remove = function() {
      this._clearTimer(), this.group.removeAll();
    }, r.prototype.dispose = function() {
      this._clearTimer();
    }, r.prototype._layout = function(e, n) {
      var i = e.get(["label", "position"]), a = e.get("orient"), o = Efe(e, n), s;
      i == null || i === "auto" ? s = a === "horizontal" ? o.y + o.height / 2 < n.getHeight() / 2 ? "-" : "+" : o.x + o.width / 2 < n.getWidth() / 2 ? "+" : "-" : pe(i) ? s = {
        horizontal: {
          top: "-",
          bottom: "+"
        },
        vertical: {
          left: "-",
          right: "+"
        }
      }[a][i] : s = i;
      var l = {
        horizontal: "center",
        vertical: s >= 0 || s === "+" ? "left" : "right"
      }, u = {
        horizontal: s >= 0 || s === "+" ? "top" : "bottom",
        vertical: "middle"
      }, c = {
        horizontal: 0,
        vertical: P3 / 2
      }, d = a === "vertical" ? o.height : o.width, f = e.getModel("controlStyle"), h = f.get("show", !0), p = h ? f.get("itemSize") : 0, v = h ? f.get("itemGap") : 0, g = p + v, m = e.get(["label", "rotate"]) || 0;
      m = m * P3 / 180;
      var y, b, C, w = f.get("position", !0), _ = h && f.get("showPlayBtn", !0), x = h && f.get("showPrevBtn", !0), I = h && f.get("showNextBtn", !0), D = 0, T = d;
      w === "left" || w === "bottom" ? (_ && (y = [0, 0], D += g), x && (b = [D, 0], D += g), I && (C = [T - p, 0], T -= g)) : (_ && (y = [T - p, 0], T -= g), x && (b = [0, 0], D += g), I && (C = [T - p, 0], T -= g));
      var A = [D, T];
      return e.get("inverse") && A.reverse(), {
        viewRect: o,
        mainLength: d,
        orient: a,
        rotation: c[a],
        labelRotation: m,
        labelPosOpt: s,
        labelAlign: e.get(["label", "align"]) || l[a],
        labelBaseline: e.get(["label", "verticalAlign"]) || e.get(["label", "baseline"]) || u[a],
        // Based on mainGroup.
        playPosition: y,
        prevBtnPosition: b,
        nextBtnPosition: C,
        axisExtent: A,
        controlSize: p,
        controlGap: v
      };
    }, r.prototype._position = function(e, n) {
      var i = this._mainGroup, a = this._labelGroup, o = e.viewRect;
      if (e.orient === "vertical") {
        var s = Oi(), l = o.x, u = o.y + o.height;
        eo(s, s, [-l, -u]), hu(s, s, -P3 / 2), eo(s, s, [l, u]), o = o.clone(), o.applyTransform(s);
      }
      var c = y(o), d = y(i.getBoundingRect()), f = y(a.getBoundingRect()), h = [i.x, i.y], p = [a.x, a.y];
      p[0] = h[0] = c[0][0];
      var v = e.labelPosOpt;
      if (v == null || pe(v)) {
        var g = v === "+" ? 0 : 1;
        b(h, d, c, 1, g), b(p, f, c, 1, 1 - g);
      } else {
        var g = v >= 0 ? 0 : 1;
        b(h, d, c, 1, g), p[1] = h[1] + v;
      }
      i.setPosition(h), a.setPosition(p), i.rotation = a.rotation = e.rotation, m(i), m(a);
      function m(C) {
        C.originX = c[0][0] - C.x, C.originY = c[1][0] - C.y;
      }
      function y(C) {
        return [[C.x, C.x + C.width], [C.y, C.y + C.height]];
      }
      function b(C, w, _, x, I) {
        C[x] += _[x][I] - w[x][I];
      }
    }, r.prototype._createAxis = function(e, n) {
      var i = n.getData(), a = n.get("axisType"), o = Lfe(n, a);
      o.getTicks = function() {
        return i.mapArray(["value"], function(u) {
          return {
            value: u
          };
        });
      };
      var s = i.getDataExtent("value");
      o.setExtent(s[0], s[1]), o.calcNiceTicks();
      var l = new Mfe("value", o, e.axisExtent, a);
      return l.model = n, l;
    }, r.prototype._createGroup = function(e) {
      var n = this[e] = new ze();
      return this.group.add(n), n;
    }, r.prototype._renderAxisLine = function(e, n, i, a) {
      var o = i.getExtent();
      if (a.get(["lineStyle", "show"])) {
        var s = new gn({
          shape: {
            x1: o[0],
            y1: 0,
            x2: o[1],
            y2: 0
          },
          style: ae({
            lineCap: "round"
          }, a.getModel("lineStyle").getLineStyle()),
          silent: !0,
          z2: 1
        });
        n.add(s);
        var l = this._progressLine = new gn({
          shape: {
            x1: o[0],
            x2: this._currentPointer ? this._currentPointer.x : o[0],
            y1: 0,
            y2: 0
          },
          style: Ee({
            lineCap: "round",
            lineWidth: s.style.lineWidth
          }, a.getModel(["progress", "lineStyle"]).getLineStyle()),
          silent: !0,
          z2: 1
        });
        n.add(l);
      }
    }, r.prototype._renderAxisTick = function(e, n, i, a) {
      var o = this, s = a.getData(), l = i.scale.getTicks();
      this._tickSymbols = [], L(l, function(u) {
        var c = i.dataToCoord(u.value), d = s.getItemModel(u.value), f = d.getModel("itemStyle"), h = d.getModel(["emphasis", "itemStyle"]), p = d.getModel(["progress", "itemStyle"]), v = {
          x: c,
          y: 0,
          onclick: ye(o._changeTimeline, o, u.value)
        }, g = UM(d, f, n, v);
        g.ensureState("emphasis").style = h.getItemStyle(), g.ensureState("progress").style = p.getItemStyle(), Fl(g);
        var m = Ze(g);
        d.get("tooltip") ? (m.dataIndex = u.value, m.dataModel = a) : m.dataIndex = m.dataModel = null, o._tickSymbols.push(g);
      });
    }, r.prototype._renderAxisLabel = function(e, n, i, a) {
      var o = this, s = i.getLabelModel();
      if (s.get("show")) {
        var l = a.getData(), u = i.getViewLabels();
        this._tickLabels = [], L(u, function(c) {
          var d = c.tickValue, f = l.getItemModel(d), h = f.getModel("label"), p = f.getModel(["emphasis", "label"]), v = f.getModel(["progress", "label"]), g = i.dataToCoord(c.tickValue), m = new _t({
            x: g,
            y: 0,
            rotation: e.labelRotation - e.rotation,
            onclick: ye(o._changeTimeline, o, d),
            silent: !1,
            style: fr(h, {
              text: c.formattedLabel,
              align: e.labelAlign,
              verticalAlign: e.labelBaseline
            })
          });
          m.ensureState("emphasis").style = fr(p), m.ensureState("progress").style = fr(v), n.add(m), Fl(m), $M(m).dataIndex = d, o._tickLabels.push(m);
        });
      }
    }, r.prototype._renderControl = function(e, n, i, a) {
      var o = e.controlSize, s = e.rotation, l = a.getModel("controlStyle").getItemStyle(), u = a.getModel(["emphasis", "controlStyle"]).getItemStyle(), c = a.getPlayState(), d = a.get("inverse", !0);
      f(e.nextBtnPosition, "next", ye(this._changeTimeline, this, d ? "-" : "+")), f(e.prevBtnPosition, "prev", ye(this._changeTimeline, this, d ? "+" : "-")), f(e.playPosition, c ? "stop" : "play", ye(this._handlePlayClick, this, !c), !0);
      function f(h, p, v, g) {
        if (h) {
          var m = to(je(a.get(["controlStyle", p + "BtnSize"]), o), o), y = [0, -m / 2, m, m], b = kfe(a, p + "Icon", y, {
            x: h[0],
            y: h[1],
            originX: o / 2,
            originY: 0,
            rotation: g ? -s : 0,
            rectHover: !0,
            style: l,
            onclick: v
          });
          b.ensureState("emphasis").style = u, n.add(b), Fl(b);
        }
      }
    }, r.prototype._renderCurrentPointer = function(e, n, i, a) {
      var o = a.getData(), s = a.getCurrentIndex(), l = o.getItemModel(s).getModel("checkpointStyle"), u = this, c = {
        onCreate: function(d) {
          d.draggable = !0, d.drift = ye(u._handlePointerDrag, u), d.ondragend = ye(u._handlePointerDragend, u), JM(d, u._progressLine, s, i, a, !0);
        },
        onUpdate: function(d) {
          JM(d, u._progressLine, s, i, a);
        }
      };
      this._currentPointer = UM(l, l, this._mainGroup, {}, this._currentPointer, c);
    }, r.prototype._handlePlayClick = function(e) {
      this._clearTimer(), this.api.dispatchAction({
        type: "timelinePlayChange",
        playState: e,
        from: this.uid
      });
    }, r.prototype._handlePointerDrag = function(e, n, i) {
      this._clearTimer(), this._pointerChangeTimeline([i.offsetX, i.offsetY]);
    }, r.prototype._handlePointerDragend = function(e) {
      this._pointerChangeTimeline([e.offsetX, e.offsetY], !0);
    }, r.prototype._pointerChangeTimeline = function(e, n) {
      var i = this._toAxisCoord(e)[0], a = this._axis, o = Ui(a.getExtent().slice());
      i > o[1] && (i = o[1]), i < o[0] && (i = o[0]), this._currentPointer.x = i, this._currentPointer.markRedraw();
      var s = this._progressLine;
      s && (s.shape.x2 = i, s.dirty());
      var l = this._findNearestTick(i), u = this.model;
      (n || l !== u.getCurrentIndex() && u.get("realtime")) && this._changeTimeline(l);
    }, r.prototype._doPlayStop = function() {
      var e = this;
      this._clearTimer(), this.model.getPlayState() && (this._timer = setTimeout(function() {
        var n = e.model;
        e._changeTimeline(n.getCurrentIndex() + (n.get("rewind", !0) ? -1 : 1));
      }, this.model.get("playInterval")));
    }, r.prototype._toAxisCoord = function(e) {
      var n = this._mainGroup.getLocalTransform();
      return Ka(e, n, !0);
    }, r.prototype._findNearestTick = function(e) {
      var n = this.model.getData(), i = 1 / 0, a, o = this._axis;
      return n.each(["value"], function(s, l) {
        var u = o.dataToCoord(s), c = Math.abs(u - e);
        c < i && (i = c, a = l);
      }), a;
    }, r.prototype._clearTimer = function() {
      this._timer && (clearTimeout(this._timer), this._timer = null);
    }, r.prototype._changeTimeline = function(e) {
      var n = this.model.getCurrentIndex();
      e === "+" ? e = n + 1 : e === "-" && (e = n - 1), this.api.dispatchAction({
        type: "timelineChange",
        currentIndex: e,
        from: this.uid
      });
    }, r.prototype._updateTicksStatus = function() {
      var e = this.model.getCurrentIndex(), n = this._tickSymbols, i = this._tickLabels;
      if (n)
        for (var a = 0; a < n.length; a++)
          n && n[a] && n[a].toggleState("progress", a < e);
      if (i)
        for (var a = 0; a < i.length; a++)
          i && i[a] && i[a].toggleState("progress", $M(i[a]).dataIndex <= e);
    }, r.type = "timeline.slider", r;
  }(Tfe)
);
function Lfe(t, r) {
  if (r = r || t.get("type"), r)
    switch (r) {
      // Buildin scale
      case "category":
        return new T2({
          ordinalMeta: t.getCategories(),
          extent: [1 / 0, -1 / 0]
        });
      case "time":
        return new Mw({
          locale: t.ecModel.getLocaleModel(),
          useUTC: t.ecModel.get("useUTC")
        });
      default:
        return new Ks();
    }
}
function Efe(t, r) {
  return cn(t.getBoxLayoutParams(), {
    width: r.getWidth(),
    height: r.getHeight()
  }, t.get("padding"));
}
function kfe(t, r, e, n) {
  var i = n.style, a = ih(t.get(["controlStyle", r]), n || {}, new rt(e[0], e[1], e[2], e[3]));
  return i && a.setStyle(i), a;
}
function UM(t, r, e, n, i, a) {
  var o = r.get("color");
  if (i)
    i.setColor(o), e.add(i), a && a.onUpdate(i);
  else {
    var s = t.get("symbol");
    i = en(s, -1, -1, 2, 2, o), i.setStyle("strokeNoScale", !0), e.add(i), a && a.onCreate(i);
  }
  var l = r.getItemStyle(["color"]);
  i.setStyle(l), n = Qe({
    rectHover: !0,
    z2: 100
  }, n, !0);
  var u = fh(t.get("symbolSize"));
  n.scaleX = u[0] / 2, n.scaleY = u[1] / 2;
  var c = td(t.get("symbolOffset"), u);
  c && (n.x = (n.x || 0) + c[0], n.y = (n.y || 0) + c[1]);
  var d = t.get("symbolRotate");
  return n.rotation = (d || 0) * Math.PI / 180 || 0, i.attr(n), i.updateTransform(), i;
}
function JM(t, r, e, n, i, a) {
  if (!t.dragging) {
    var o = i.getModel("checkpointStyle"), s = n.dataToCoord(i.getData().get("value", e));
    if (a || !o.get("animation", !0))
      t.attr({
        x: s,
        y: 0
      }), r && r.attr({
        shape: {
          x2: s
        }
      });
    else {
      var l = {
        duration: o.get("animationDuration", !0),
        easing: o.get("animationEasing", !0)
      };
      t.stopAnimation(null, !0), t.animateTo({
        x: s,
        y: 0
      }, l), r && r.animateTo({
        shape: {
          x2: s
        }
      }, l);
    }
  }
}
function Pfe(t) {
  t.registerAction({
    type: "timelineChange",
    event: "timelineChanged",
    update: "prepareAndUpdate"
  }, function(r, e, n) {
    var i = e.getComponent("timeline");
    return i && r.currentIndex != null && (i.setCurrentIndex(r.currentIndex), !i.get("loop", !0) && i.isIndexMax() && i.getPlayState() && (i.setPlayState(!1), n.dispatchAction({
      type: "timelinePlayChange",
      playState: !1,
      from: r.from
    }))), e.resetOption("timeline", {
      replaceMerge: i.get("replaceMerge", !0)
    }), Ee({
      currentIndex: i.option.currentIndex
    }, r);
  }), t.registerAction({
    type: "timelinePlayChange",
    event: "timelinePlayChanged",
    update: "update"
  }, function(r, e) {
    var n = e.getComponent("timeline");
    n && r.playState != null && n.setPlayState(r.playState);
  });
}
function Nfe(t) {
  var r = t && t.timeline;
  ue(r) || (r = r ? [r] : []), L(r, function(e) {
    e && Ofe(e);
  });
}
function Ofe(t) {
  var r = t.type, e = {
    number: "value",
    time: "time"
  };
  if (e[r] && (t.axisType = e[r], delete t.type), KM(t), sc(t, "controlPosition")) {
    var n = t.controlStyle || (t.controlStyle = {});
    sc(n, "position") || (n.position = t.controlPosition), n.position === "none" && !sc(n, "show") && (n.show = !1, delete n.position), delete t.controlPosition;
  }
  L(t.data || [], function(i) {
    Me(i) && !ue(i) && (!sc(i, "value") && sc(i, "name") && (i.value = i.name), KM(i));
  });
}
function KM(t) {
  var r = t.itemStyle || (t.itemStyle = {}), e = r.emphasis || (r.emphasis = {}), n = t.label || t.label || {}, i = n.normal || (n.normal = {}), a = {
    normal: 1,
    emphasis: 1
  };
  L(n, function(o, s) {
    !a[s] && !sc(i, s) && (i[s] = o);
  }), e.label && !sc(n, "emphasis") && (n.emphasis = e.label, delete e.label);
}
function sc(t, r) {
  return t.hasOwnProperty(r);
}
function Vfe(t) {
  t.registerComponentModel(JF), t.registerComponentView(Rfe), t.registerSubTypeDefaulter("timeline", function() {
    return "slider";
  }), Pfe(t), t.registerPreprocessor(Nfe);
}
function L_(t, r) {
  if (!t)
    return !1;
  for (var e = ue(t) ? t : [t], n = 0; n < e.length; n++)
    if (e[n] && e[n][r])
      return !0;
  return !1;
}
function X1(t) {
  Vc(t, "label", ["show"]);
}
var $1 = It(), Qs = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e.createdBySelf = !1, e;
    }
    return r.prototype.init = function(e, n, i) {
      if (process.env.NODE_ENV !== "production" && this.type === "marker")
        throw new Error("Marker component is abstract component. Use markLine, markPoint, markArea instead.");
      this.mergeDefaultAndTheme(e, i), this._mergeOption(e, i, !1, !0);
    }, r.prototype.isAnimationEnabled = function() {
      if (vt.node)
        return !1;
      var e = this.__hostSeries;
      return this.getShallow("animation") && e && e.isAnimationEnabled();
    }, r.prototype.mergeOption = function(e, n) {
      this._mergeOption(e, n, !1, !1);
    }, r.prototype._mergeOption = function(e, n, i, a) {
      var o = this.mainType;
      i || n.eachSeries(function(s) {
        var l = s.get(this.mainType, !0), u = $1(s)[o];
        if (!l || !l.data) {
          $1(s)[o] = null;
          return;
        }
        u ? u._mergeOption(l, n, !0) : (a && X1(l), L(l.data, function(c) {
          c instanceof Array ? (X1(c[0]), X1(c[1])) : X1(c);
        }), u = this.createMarkerModelFromSeries(l, this, n), ae(u, {
          mainType: this.mainType,
          // Use the same series index and name
          seriesIndex: s.seriesIndex,
          name: s.name,
          createdBySelf: !0
        }), u.__hostSeries = s), $1(s)[o] = u;
      }, this);
    }, r.prototype.formatTooltip = function(e, n, i) {
      var a = this.getData(), o = this.getRawValue(e), s = a.getName(e);
      return Sn("section", {
        header: this.name,
        blocks: [Sn("nameValue", {
          name: s,
          value: o,
          noName: !s,
          noValue: o == null
        })]
      });
    }, r.prototype.getData = function() {
      return this._data;
    }, r.prototype.setData = function(e) {
      this._data = e;
    }, r.prototype.getDataParams = function(e, n) {
      var i = C2.prototype.getDataParams.call(this, e, n), a = this.__hostSeries;
      return a && (i.seriesId = a.id, i.seriesName = a.name, i.seriesType = a.subType), i;
    }, r.getMarkerModelFromSeries = function(e, n) {
      return $1(e)[n];
    }, r.type = "marker", r.dependencies = ["series", "grid", "polar", "geo"], r;
  }(st)
);
Xr(Qs, C2.prototype);
var Gfe = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.createMarkerModelFromSeries = function(e, n, i) {
      return new r(e, n, i);
    }, r.type = "markPoint", r.defaultOption = {
      // zlevel: 0,
      z: 5,
      symbol: "pin",
      symbolSize: 50,
      // symbolRotate: 0,
      // symbolOffset: [0, 0]
      tooltip: {
        trigger: "item"
      },
      label: {
        show: !0,
        position: "inside"
      },
      itemStyle: {
        borderWidth: 2
      },
      emphasis: {
        label: {
          show: !0
        }
      }
    }, r;
  }(Qs)
);
function K9(t) {
  return !(isNaN(parseFloat(t.x)) && isNaN(parseFloat(t.y)));
}
function Bfe(t) {
  return !isNaN(parseFloat(t.x)) && !isNaN(parseFloat(t.y));
}
function U1(t, r, e, n, i, a) {
  var o = [], s = Js(
    r,
    n
    /* , otherDataDim */
  ), l = s ? r.getCalculationInfo("stackResultDimension") : n, u = E_(r, l, t), c = r.indicesOfNearest(l, u)[0];
  o[i] = r.get(e, c), o[a] = r.get(l, c);
  var d = r.get(n, c), f = Ya(r.get(n, c));
  return f = Math.min(f, 20), f >= 0 && (o[a] = +o[a].toFixed(f)), [o, d];
}
var N3 = {
  min: Ye(U1, "min"),
  max: Ye(U1, "max"),
  average: Ye(U1, "average"),
  median: Ye(U1, "median")
};
function Bv(t, r) {
  if (r) {
    var e = t.getData(), n = t.coordinateSystem, i = n && n.dimensions;
    if (!Bfe(r) && !ue(r.coord) && ue(i)) {
      var a = KF(r, e, n, t);
      if (r = Ge(r), r.type && N3[r.type] && a.baseAxis && a.valueAxis) {
        var o = nt(i, a.baseAxis.dim), s = nt(i, a.valueAxis.dim), l = N3[r.type](e, a.baseDataDim, a.valueDataDim, o, s);
        r.coord = l[0], r.value = l[1];
      } else
        r.coord = [r.xAxis != null ? r.xAxis : r.radiusAxis, r.yAxis != null ? r.yAxis : r.angleAxis];
    }
    if (r.coord == null || !ue(i))
      r.coord = [];
    else
      for (var u = r.coord, c = 0; c < 2; c++)
        N3[u[c]] && (u[c] = E_(e, e.mapDimension(i[c]), u[c]));
    return r;
  }
}
function KF(t, r, e, n) {
  var i = {};
  return t.valueIndex != null || t.valueDim != null ? (i.valueDataDim = t.valueIndex != null ? r.getDimension(t.valueIndex) : t.valueDim, i.valueAxis = e.getAxis(Ffe(n, i.valueDataDim)), i.baseAxis = e.getOtherAxis(i.valueAxis), i.baseDataDim = r.mapDimension(i.baseAxis.dim)) : (i.baseAxis = n.getBaseAxis(), i.valueAxis = e.getOtherAxis(i.baseAxis), i.baseDataDim = r.mapDimension(i.baseAxis.dim), i.valueDataDim = r.mapDimension(i.valueAxis.dim)), i;
}
function Ffe(t, r) {
  var e = t.getData().getDimensionInfo(r);
  return e && e.coordDim;
}
function Fv(t, r) {
  return t && t.containData && r.coord && !K9(r) ? t.containData(r.coord) : !0;
}
function Hfe(t, r, e) {
  return t && t.containZone && r.coord && e.coord && !K9(r) && !K9(e) ? t.containZone(r.coord, e.coord) : !0;
}
function qF(t, r) {
  return t ? function(e, n, i, a) {
    var o = a < 2 ? e.coord && e.coord[a] : e.value;
    return zl(o, r[a]);
  } : function(e, n, i, a) {
    return zl(e.value, r[a]);
  };
}
function E_(t, r, e) {
  if (e === "average") {
    var n = 0, i = 0;
    return t.each(r, function(a, o) {
      isNaN(a) || (n += a, i++);
    }), n / i;
  } else return e === "median" ? t.getMedian(r) : t.getDataExtent(r)[e === "max" ? 1 : 0];
}
var O3 = It(), k_ = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.init = function() {
      this.markerGroupMap = xe();
    }, r.prototype.render = function(e, n, i) {
      var a = this, o = this.markerGroupMap;
      o.each(function(s) {
        O3(s).keep = !1;
      }), n.eachSeries(function(s) {
        var l = Qs.getMarkerModelFromSeries(s, a.type);
        l && a.renderSeries(s, l, n, i);
      }), o.each(function(s) {
        !O3(s).keep && a.group.remove(s.group);
      });
    }, r.prototype.markKeep = function(e) {
      O3(e).keep = !0;
    }, r.prototype.toggleBlurSeries = function(e, n) {
      var i = this;
      L(e, function(a) {
        var o = Qs.getMarkerModelFromSeries(a, i.type);
        if (o) {
          var s = o.getData();
          s.eachItemGraphicEl(function(l) {
            l && (n ? jN(l) : H7(l));
          });
        }
      });
    }, r.type = "marker", r;
  }(yr)
);
function qM(t, r, e) {
  var n = r.coordinateSystem;
  t.each(function(i) {
    var a = t.getItemModel(i), o, s = he(a.get("x"), e.getWidth()), l = he(a.get("y"), e.getHeight());
    if (!isNaN(s) && !isNaN(l))
      o = [s, l];
    else if (r.getMarkerPosition)
      o = r.getMarkerPosition(t.getValues(t.dimensions, i));
    else if (n) {
      var u = t.get(n.dimensions[0], i), c = t.get(n.dimensions[1], i);
      o = n.dataToPoint([u, c]);
    }
    isNaN(s) || (o[0] = s), isNaN(l) || (o[1] = l), t.setItemLayout(i, o);
  });
}
var zfe = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.updateTransform = function(e, n, i) {
      n.eachSeries(function(a) {
        var o = Qs.getMarkerModelFromSeries(a, "markPoint");
        o && (qM(o.getData(), a, i), this.markerGroupMap.get(a.id).updateLayout());
      }, this);
    }, r.prototype.renderSeries = function(e, n, i, a) {
      var o = e.coordinateSystem, s = e.id, l = e.getData(), u = this.markerGroupMap, c = u.get(s) || u.set(s, new _g()), d = Wfe(o, e, n);
      n.setData(d), qM(n.getData(), e, a), d.each(function(f) {
        var h = d.getItemModel(f), p = h.getShallow("symbol"), v = h.getShallow("symbolSize"), g = h.getShallow("symbolRotate"), m = h.getShallow("symbolOffset"), y = h.getShallow("symbolKeepAspect");
        if (Ae(p) || Ae(v) || Ae(g) || Ae(m)) {
          var b = n.getRawValue(f), C = n.getDataParams(f);
          Ae(p) && (p = p(b, C)), Ae(v) && (v = v(b, C)), Ae(g) && (g = g(b, C)), Ae(m) && (m = m(b, C));
        }
        var w = h.getModel("itemStyle").getItemStyle(), _ = bg(l, "color");
        w.fill || (w.fill = _), d.setItemVisual(f, {
          symbol: p,
          symbolSize: v,
          symbolRotate: g,
          symbolOffset: m,
          symbolKeepAspect: y,
          style: w
        });
      }), c.updateData(d), this.group.add(c.group), d.eachItemGraphicEl(function(f) {
        f.traverse(function(h) {
          Ze(h).dataModel = n;
        });
      }), this.markKeep(c), c.group.silent = n.get("silent") || e.get("silent");
    }, r.type = "markPoint", r;
  }(k_)
);
function Wfe(t, r, e) {
  var n;
  t ? n = ce(t && t.dimensions, function(s) {
    var l = r.getData().getDimensionInfo(r.getData().mapDimension(s)) || {};
    return ae(ae({}, l), {
      name: s,
      // DON'T use ordinalMeta to parse and collect ordinal.
      ordinalMeta: null
    });
  }) : n = [{
    name: "value",
    type: "float"
  }];
  var i = new ni(n, e), a = ce(e.get("data"), Ye(Bv, r));
  t && (a = Wt(a, Ye(Fv, t)));
  var o = qF(!!t, n);
  return i.initData(a, null, o), i;
}
function Zfe(t) {
  t.registerComponentModel(Gfe), t.registerComponentView(zfe), t.registerPreprocessor(function(r) {
    L_(r.series, "markPoint") && (r.markPoint = r.markPoint || {});
  });
}
var jfe = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.createMarkerModelFromSeries = function(e, n, i) {
      return new r(e, n, i);
    }, r.type = "markLine", r.defaultOption = {
      // zlevel: 0,
      z: 5,
      symbol: ["circle", "arrow"],
      symbolSize: [8, 16],
      // symbolRotate: 0,
      symbolOffset: 0,
      precision: 2,
      tooltip: {
        trigger: "item"
      },
      label: {
        show: !0,
        position: "end",
        distance: 5
      },
      lineStyle: {
        type: "dashed"
      },
      emphasis: {
        label: {
          show: !0
        },
        lineStyle: {
          width: 3
        }
      },
      animationEasing: "linear"
    }, r;
  }(Qs)
), J1 = It(), Yfe = function(t, r, e, n) {
  var i = t.getData(), a;
  if (ue(n))
    a = n;
  else {
    var o = n.type;
    if (o === "min" || o === "max" || o === "average" || o === "median" || n.xAxis != null || n.yAxis != null) {
      var s = void 0, l = void 0;
      if (n.yAxis != null || n.xAxis != null)
        s = r.getAxis(n.yAxis != null ? "y" : "x"), l = Qr(n.yAxis, n.xAxis);
      else {
        var u = KF(n, i, r, t);
        s = u.valueAxis;
        var c = Aw(i, u.valueDataDim);
        l = E_(i, c, o);
      }
      var d = s.dim === "x" ? 0 : 1, f = 1 - d, h = Ge(n), p = {
        coord: []
      };
      h.type = null, h.coord = [], h.coord[f] = -1 / 0, p.coord[f] = 1 / 0;
      var v = e.get("precision");
      v >= 0 && Mt(l) && (l = +l.toFixed(Math.min(v, 20))), h.coord[d] = p.coord[d] = l, a = [h, p, {
        type: o,
        valueIndex: n.valueIndex,
        // Force to use the value of calculated value.
        value: l
      }];
    } else
      process.env.NODE_ENV !== "production" && Da("Invalid markLine data."), a = [];
  }
  var g = [Bv(t, a[0]), Bv(t, a[1]), ae({}, a[2])];
  return g[2].type = g[2].type || null, Qe(g[2], g[0]), Qe(g[2], g[1]), g;
};
function ry(t) {
  return !isNaN(t) && !isFinite(t);
}
function QM(t, r, e, n) {
  var i = 1 - t, a = n.dimensions[t];
  return ry(r[i]) && ry(e[i]) && r[t] === e[t] && n.getAxis(a).containData(r[t]);
}
function Xfe(t, r) {
  if (t.type === "cartesian2d") {
    var e = r[0].coord, n = r[1].coord;
    if (e && n && (QM(1, e, n, t) || QM(0, e, n, t)))
      return !0;
  }
  return Fv(t, r[0]) && Fv(t, r[1]);
}
function V3(t, r, e, n, i) {
  var a = n.coordinateSystem, o = t.getItemModel(r), s, l = he(o.get("x"), i.getWidth()), u = he(o.get("y"), i.getHeight());
  if (!isNaN(l) && !isNaN(u))
    s = [l, u];
  else {
    if (n.getMarkerPosition)
      s = n.getMarkerPosition(t.getValues(t.dimensions, r));
    else {
      var c = a.dimensions, d = t.get(c[0], r), f = t.get(c[1], r);
      s = a.dataToPoint([d, f]);
    }
    if (rd(a, "cartesian2d")) {
      var h = a.getAxis("x"), p = a.getAxis("y"), c = a.dimensions;
      ry(t.get(c[0], r)) ? s[0] = h.toGlobalCoord(h.getExtent()[e ? 0 : 1]) : ry(t.get(c[1], r)) && (s[1] = p.toGlobalCoord(p.getExtent()[e ? 0 : 1]));
    }
    isNaN(l) || (s[0] = l), isNaN(u) || (s[1] = u);
  }
  t.setItemLayout(r, s);
}
var $fe = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.updateTransform = function(e, n, i) {
      n.eachSeries(function(a) {
        var o = Qs.getMarkerModelFromSeries(a, "markLine");
        if (o) {
          var s = o.getData(), l = J1(o).from, u = J1(o).to;
          l.each(function(c) {
            V3(l, c, !0, a, i), V3(u, c, !1, a, i);
          }), s.each(function(c) {
            s.setItemLayout(c, [l.getItemLayout(c), u.getItemLayout(c)]);
          }), this.markerGroupMap.get(a.id).updateLayout();
        }
      }, this);
    }, r.prototype.renderSeries = function(e, n, i, a) {
      var o = e.coordinateSystem, s = e.id, l = e.getData(), u = this.markerGroupMap, c = u.get(s) || u.set(s, new r_());
      this.group.add(c.group);
      var d = Ufe(o, e, n), f = d.from, h = d.to, p = d.line;
      J1(n).from = f, J1(n).to = h, n.setData(p);
      var v = n.get("symbol"), g = n.get("symbolSize"), m = n.get("symbolRotate"), y = n.get("symbolOffset");
      ue(v) || (v = [v, v]), ue(g) || (g = [g, g]), ue(m) || (m = [m, m]), ue(y) || (y = [y, y]), d.from.each(function(C) {
        b(f, C, !0), b(h, C, !1);
      }), p.each(function(C) {
        var w = p.getItemModel(C).getModel("lineStyle").getLineStyle();
        p.setItemLayout(C, [f.getItemLayout(C), h.getItemLayout(C)]), w.stroke == null && (w.stroke = f.getItemVisual(C, "style").fill), p.setItemVisual(C, {
          fromSymbolKeepAspect: f.getItemVisual(C, "symbolKeepAspect"),
          fromSymbolOffset: f.getItemVisual(C, "symbolOffset"),
          fromSymbolRotate: f.getItemVisual(C, "symbolRotate"),
          fromSymbolSize: f.getItemVisual(C, "symbolSize"),
          fromSymbol: f.getItemVisual(C, "symbol"),
          toSymbolKeepAspect: h.getItemVisual(C, "symbolKeepAspect"),
          toSymbolOffset: h.getItemVisual(C, "symbolOffset"),
          toSymbolRotate: h.getItemVisual(C, "symbolRotate"),
          toSymbolSize: h.getItemVisual(C, "symbolSize"),
          toSymbol: h.getItemVisual(C, "symbol"),
          style: w
        });
      }), c.updateData(p), d.line.eachItemGraphicEl(function(C) {
        Ze(C).dataModel = n, C.traverse(function(w) {
          Ze(w).dataModel = n;
        });
      });
      function b(C, w, _) {
        var x = C.getItemModel(w);
        V3(C, w, _, e, a);
        var I = x.getModel("itemStyle").getItemStyle();
        I.fill == null && (I.fill = bg(l, "color")), C.setItemVisual(w, {
          symbolKeepAspect: x.get("symbolKeepAspect"),
          // `0` should be considered as a valid value, so use `retrieve2` instead of `||`
          symbolOffset: je(x.get("symbolOffset", !0), y[_ ? 0 : 1]),
          symbolRotate: je(x.get("symbolRotate", !0), m[_ ? 0 : 1]),
          // TODO: when 2d array is supported, it should ignore parent
          symbolSize: je(x.get("symbolSize"), g[_ ? 0 : 1]),
          symbol: je(x.get("symbol", !0), v[_ ? 0 : 1]),
          style: I
        });
      }
      this.markKeep(c), c.group.silent = n.get("silent") || e.get("silent");
    }, r.type = "markLine", r;
  }(k_)
);
function Ufe(t, r, e) {
  var n;
  t ? n = ce(t && t.dimensions, function(u) {
    var c = r.getData().getDimensionInfo(r.getData().mapDimension(u)) || {};
    return ae(ae({}, c), {
      name: u,
      // DON'T use ordinalMeta to parse and collect ordinal.
      ordinalMeta: null
    });
  }) : n = [{
    name: "value",
    type: "float"
  }];
  var i = new ni(n, e), a = new ni(n, e), o = new ni([], e), s = ce(e.get("data"), Ye(Yfe, r, t, e));
  t && (s = Wt(s, Ye(Xfe, t)));
  var l = qF(!!t, n);
  return i.initData(ce(s, function(u) {
    return u[0];
  }), null, l), a.initData(ce(s, function(u) {
    return u[1];
  }), null, l), o.initData(ce(s, function(u) {
    return u[2];
  })), o.hasItemOption = !0, {
    from: i,
    to: a,
    line: o
  };
}
function Jfe(t) {
  t.registerComponentModel(jfe), t.registerComponentView($fe), t.registerPreprocessor(function(r) {
    L_(r.series, "markLine") && (r.markLine = r.markLine || {});
  });
}
var Kfe = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.createMarkerModelFromSeries = function(e, n, i) {
      return new r(e, n, i);
    }, r.type = "markArea", r.defaultOption = {
      // zlevel: 0,
      // PENDING
      z: 1,
      tooltip: {
        trigger: "item"
      },
      // markArea should fixed on the coordinate system
      animation: !1,
      label: {
        show: !0,
        position: "top"
      },
      itemStyle: {
        // color and borderColor default to use color from series
        // color: 'auto'
        // borderColor: 'auto'
        borderWidth: 0
      },
      emphasis: {
        label: {
          show: !0,
          position: "top"
        }
      }
    }, r;
  }(Qs)
), K1 = It(), qfe = function(t, r, e, n) {
  var i = n[0], a = n[1];
  if (!(!i || !a)) {
    var o = Bv(t, i), s = Bv(t, a), l = o.coord, u = s.coord;
    l[0] = Qr(l[0], -1 / 0), l[1] = Qr(l[1], -1 / 0), u[0] = Qr(u[0], 1 / 0), u[1] = Qr(u[1], 1 / 0);
    var c = $y([{}, o, s]);
    return c.coord = [o.coord, s.coord], c.x0 = o.x, c.y0 = o.y, c.x1 = s.x, c.y1 = s.y, c;
  }
};
function ny(t) {
  return !isNaN(t) && !isFinite(t);
}
function eR(t, r, e, n) {
  var i = 1 - t;
  return ny(r[i]) && ny(e[i]);
}
function Qfe(t, r) {
  var e = r.coord[0], n = r.coord[1], i = {
    coord: e,
    x: r.x0,
    y: r.y0
  }, a = {
    coord: n,
    x: r.x1,
    y: r.y1
  };
  return rd(t, "cartesian2d") ? e && n && (eR(1, e, n) || eR(0, e, n)) ? !0 : Hfe(t, i, a) : Fv(t, i) || Fv(t, a);
}
function tR(t, r, e, n, i) {
  var a = n.coordinateSystem, o = t.getItemModel(r), s, l = he(o.get(e[0]), i.getWidth()), u = he(o.get(e[1]), i.getHeight());
  if (!isNaN(l) && !isNaN(u))
    s = [l, u];
  else {
    if (n.getMarkerPosition) {
      var c = t.getValues(["x0", "y0"], r), d = t.getValues(["x1", "y1"], r), f = a.clampData(c), h = a.clampData(d), p = [];
      e[0] === "x0" ? p[0] = f[0] > h[0] ? d[0] : c[0] : p[0] = f[0] > h[0] ? c[0] : d[0], e[1] === "y0" ? p[1] = f[1] > h[1] ? d[1] : c[1] : p[1] = f[1] > h[1] ? c[1] : d[1], s = n.getMarkerPosition(p, e, !0);
    } else {
      var v = t.get(e[0], r), g = t.get(e[1], r), m = [v, g];
      a.clampData && a.clampData(m, m), s = a.dataToPoint(m, !0);
    }
    if (rd(a, "cartesian2d")) {
      var y = a.getAxis("x"), b = a.getAxis("y"), v = t.get(e[0], r), g = t.get(e[1], r);
      ny(v) ? s[0] = y.toGlobalCoord(y.getExtent()[e[0] === "x0" ? 0 : 1]) : ny(g) && (s[1] = b.toGlobalCoord(b.getExtent()[e[1] === "y0" ? 0 : 1]));
    }
    isNaN(l) || (s[0] = l), isNaN(u) || (s[1] = u);
  }
  return s;
}
var rR = [["x0", "y0"], ["x1", "y0"], ["x1", "y1"], ["x0", "y1"]], ehe = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.updateTransform = function(e, n, i) {
      n.eachSeries(function(a) {
        var o = Qs.getMarkerModelFromSeries(a, "markArea");
        if (o) {
          var s = o.getData();
          s.each(function(l) {
            var u = ce(rR, function(d) {
              return tR(s, l, d, a, i);
            });
            s.setItemLayout(l, u);
            var c = s.getItemGraphicEl(l);
            c.setShape("points", u);
          });
        }
      }, this);
    }, r.prototype.renderSeries = function(e, n, i, a) {
      var o = e.coordinateSystem, s = e.id, l = e.getData(), u = this.markerGroupMap, c = u.get(s) || u.set(s, {
        group: new ze()
      });
      this.group.add(c.group), this.markKeep(c);
      var d = the(o, e, n);
      n.setData(d), d.each(function(f) {
        var h = ce(rR, function(I) {
          return tR(d, f, I, e, a);
        }), p = o.getAxis("x").scale, v = o.getAxis("y").scale, g = p.getExtent(), m = v.getExtent(), y = [p.parse(d.get("x0", f)), p.parse(d.get("x1", f))], b = [v.parse(d.get("y0", f)), v.parse(d.get("y1", f))];
        Ui(y), Ui(b);
        var C = !(g[0] > y[1] || g[1] < y[0] || m[0] > b[1] || m[1] < b[0]), w = !C;
        d.setItemLayout(f, {
          points: h,
          allClipped: w
        });
        var _ = d.getItemModel(f).getModel("itemStyle").getItemStyle(), x = bg(l, "color");
        _.fill || (_.fill = x, pe(_.fill) && (_.fill = mv(_.fill, 0.4))), _.stroke || (_.stroke = x), d.setItemVisual(f, "style", _);
      }), d.diff(K1(c).data).add(function(f) {
        var h = d.getItemLayout(f);
        if (!h.allClipped) {
          var p = new si({
            shape: {
              points: h.points
            }
          });
          d.setItemGraphicEl(f, p), c.group.add(p);
        }
      }).update(function(f, h) {
        var p = K1(c).data.getItemGraphicEl(h), v = d.getItemLayout(f);
        v.allClipped ? p && c.group.remove(p) : (p ? kt(p, {
          shape: {
            points: v.points
          }
        }, n, f) : p = new si({
          shape: {
            points: v.points
          }
        }), d.setItemGraphicEl(f, p), c.group.add(p));
      }).remove(function(f) {
        var h = K1(c).data.getItemGraphicEl(f);
        c.group.remove(h);
      }).execute(), d.eachItemGraphicEl(function(f, h) {
        var p = d.getItemModel(h), v = d.getItemVisual(h, "style");
        f.useStyle(d.getItemVisual(h, "style")), Xn(f, xn(p), {
          labelFetcher: n,
          labelDataIndex: h,
          defaultText: d.getName(h) || "",
          inheritColor: pe(v.fill) ? mv(v.fill, 1) : "#000"
        }), Yn(f, p), Vr(f, null, null, p.get(["emphasis", "disabled"])), Ze(f).dataModel = n;
      }), K1(c).data = d, c.group.silent = n.get("silent") || e.get("silent");
    }, r.type = "markArea", r;
  }(k_)
);
function the(t, r, e) {
  var n, i, a = ["x0", "y0", "x1", "y1"];
  if (t) {
    var o = ce(t && t.dimensions, function(u) {
      var c = r.getData(), d = c.getDimensionInfo(c.mapDimension(u)) || {};
      return ae(ae({}, d), {
        name: u,
        // DON'T use ordinalMeta to parse and collect ordinal.
        ordinalMeta: null
      });
    });
    i = ce(a, function(u, c) {
      return {
        name: u,
        type: o[c % 2].type
      };
    }), n = new ni(i, e);
  } else
    i = [{
      name: "value",
      type: "float"
    }], n = new ni(i, e);
  var s = ce(e.get("data"), Ye(qfe, r, t, e));
  t && (s = Wt(s, Ye(Qfe, t)));
  var l = t ? function(u, c, d, f) {
    var h = u.coord[Math.floor(f / 2)][f % 2];
    return zl(h, i[f]);
  } : function(u, c, d, f) {
    return zl(u.value, i[f]);
  };
  return n.initData(s, null, l), n.hasItemOption = !0, n;
}
function rhe(t) {
  t.registerComponentModel(Kfe), t.registerComponentView(ehe), t.registerPreprocessor(function(r) {
    L_(r.series, "markArea") && (r.markArea = r.markArea || {});
  });
}
var nhe = function(t, r) {
  if (r === "all")
    return {
      type: "all",
      title: t.getLocaleModel().get(["legend", "selector", "all"])
    };
  if (r === "inverse")
    return {
      type: "inverse",
      title: t.getLocaleModel().get(["legend", "selector", "inverse"])
    };
}, q9 = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e.layoutMode = {
        type: "box",
        // legend.width/height are maxWidth/maxHeight actually,
        // whereas real width/height is calculated by its content.
        // (Setting {left: 10, right: 10} does not make sense).
        // So consider the case:
        // `setOption({legend: {left: 10});`
        // then `setOption({legend: {right: 10});`
        // The previous `left` should be cleared by setting `ignoreSize`.
        ignoreSize: !0
      }, e;
    }
    return r.prototype.init = function(e, n, i) {
      this.mergeDefaultAndTheme(e, i), e.selected = e.selected || {}, this._updateSelector(e);
    }, r.prototype.mergeOption = function(e, n) {
      t.prototype.mergeOption.call(this, e, n), this._updateSelector(e);
    }, r.prototype._updateSelector = function(e) {
      var n = e.selector, i = this.ecModel;
      n === !0 && (n = e.selector = ["all", "inverse"]), ue(n) && L(n, function(a, o) {
        pe(a) && (a = {
          type: a
        }), n[o] = Qe(a, nhe(i, a.type));
      });
    }, r.prototype.optionUpdated = function() {
      this._updateData(this.ecModel);
      var e = this._data;
      if (e[0] && this.get("selectedMode") === "single") {
        for (var n = !1, i = 0; i < e.length; i++) {
          var a = e[i].get("name");
          if (this.isSelected(a)) {
            this.select(a), n = !0;
            break;
          }
        }
        !n && this.select(e[0].get("name"));
      }
    }, r.prototype._updateData = function(e) {
      var n = [], i = [];
      e.eachRawSeries(function(l) {
        var u = l.name;
        i.push(u);
        var c;
        if (l.legendVisualProvider) {
          var d = l.legendVisualProvider, f = d.getAllNames();
          e.isSeriesFiltered(l) || (i = i.concat(f)), f.length ? n = n.concat(f) : c = !0;
        } else
          c = !0;
        c && k7(l) && n.push(l.name);
      }), this._availableNames = i;
      var a = this.get("data") || n, o = xe(), s = ce(a, function(l) {
        return (pe(l) || Mt(l)) && (l = {
          name: l
        }), o.get(l.name) ? null : (o.set(l.name, !0), new Pt(l, this, this.ecModel));
      }, this);
      this._data = Wt(s, function(l) {
        return !!l;
      });
    }, r.prototype.getData = function() {
      return this._data;
    }, r.prototype.select = function(e) {
      var n = this.option.selected, i = this.get("selectedMode");
      if (i === "single") {
        var a = this._data;
        L(a, function(o) {
          n[o.get("name")] = !1;
        });
      }
      n[e] = !0;
    }, r.prototype.unSelect = function(e) {
      this.get("selectedMode") !== "single" && (this.option.selected[e] = !1);
    }, r.prototype.toggleSelected = function(e) {
      var n = this.option.selected;
      n.hasOwnProperty(e) || (n[e] = !0), this[n[e] ? "unSelect" : "select"](e);
    }, r.prototype.allSelect = function() {
      var e = this._data, n = this.option.selected;
      L(e, function(i) {
        n[i.get("name", !0)] = !0;
      });
    }, r.prototype.inverseSelect = function() {
      var e = this._data, n = this.option.selected;
      L(e, function(i) {
        var a = i.get("name", !0);
        n.hasOwnProperty(a) || (n[a] = !0), n[a] = !n[a];
      });
    }, r.prototype.isSelected = function(e) {
      var n = this.option.selected;
      return !(n.hasOwnProperty(e) && !n[e]) && nt(this._availableNames, e) >= 0;
    }, r.prototype.getOrient = function() {
      return this.get("orient") === "vertical" ? {
        index: 1,
        name: "vertical"
      } : {
        index: 0,
        name: "horizontal"
      };
    }, r.type = "legend.plain", r.dependencies = ["series"], r.defaultOption = {
      // zlevel: 0,
      z: 4,
      show: !0,
      orient: "horizontal",
      left: "center",
      // right: 'center',
      top: 0,
      // bottom: null,
      align: "auto",
      backgroundColor: "rgba(0,0,0,0)",
      borderColor: "#ccc",
      borderRadius: 0,
      borderWidth: 0,
      padding: 5,
      itemGap: 10,
      itemWidth: 25,
      itemHeight: 14,
      symbolRotate: "inherit",
      symbolKeepAspect: !0,
      inactiveColor: "#ccc",
      inactiveBorderColor: "#ccc",
      inactiveBorderWidth: "auto",
      itemStyle: {
        color: "inherit",
        opacity: "inherit",
        borderColor: "inherit",
        borderWidth: "auto",
        borderCap: "inherit",
        borderJoin: "inherit",
        borderDashOffset: "inherit",
        borderMiterLimit: "inherit"
      },
      lineStyle: {
        width: "auto",
        color: "inherit",
        inactiveColor: "#ccc",
        inactiveWidth: 2,
        opacity: "inherit",
        type: "inherit",
        cap: "inherit",
        join: "inherit",
        dashOffset: "inherit",
        miterLimit: "inherit"
      },
      textStyle: {
        color: "#333"
      },
      selectedMode: !0,
      selector: !1,
      selectorLabel: {
        show: !0,
        borderRadius: 10,
        padding: [3, 5, 3, 5],
        fontSize: 12,
        fontFamily: "sans-serif",
        color: "#666",
        borderWidth: 1,
        borderColor: "#666"
      },
      emphasis: {
        selectorLabel: {
          show: !0,
          color: "#eee",
          backgroundColor: "#666"
        }
      },
      selectorPosition: "auto",
      selectorItemGap: 7,
      selectorButtonGap: 10,
      tooltip: {
        show: !1
      }
    }, r;
  }(st)
), Ld = Ye, Q9 = L, q1 = ze, QF = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e.newlineDisabled = !1, e;
    }
    return r.prototype.init = function() {
      this.group.add(this._contentGroup = new q1()), this.group.add(this._selectorGroup = new q1()), this._isFirstRender = !0;
    }, r.prototype.getContentGroup = function() {
      return this._contentGroup;
    }, r.prototype.getSelectorGroup = function() {
      return this._selectorGroup;
    }, r.prototype.render = function(e, n, i) {
      var a = this._isFirstRender;
      if (this._isFirstRender = !1, this.resetInner(), !!e.get("show", !0)) {
        var o = e.get("align"), s = e.get("orient");
        (!o || o === "auto") && (o = e.get("left") === "right" && s === "vertical" ? "right" : "left");
        var l = e.get("selector", !0), u = e.get("selectorPosition", !0);
        l && (!u || u === "auto") && (u = s === "horizontal" ? "end" : "start"), this.renderInner(o, e, n, i, l, s, u);
        var c = e.getBoxLayoutParams(), d = {
          width: i.getWidth(),
          height: i.getHeight()
        }, f = e.get("padding"), h = cn(c, d, f), p = this.layoutInner(e, o, h, a, l, u), v = cn(Ee({
          width: p.width,
          height: p.height
        }, c), d, f);
        this.group.x = v.x - p.x, this.group.y = v.y - p.y, this.group.markRedraw(), this.group.add(this._backgroundEl = HF(p, e));
      }
    }, r.prototype.resetInner = function() {
      this.getContentGroup().removeAll(), this._backgroundEl && this.group.remove(this._backgroundEl), this.getSelectorGroup().removeAll();
    }, r.prototype.renderInner = function(e, n, i, a, o, s, l) {
      var u = this.getContentGroup(), c = xe(), d = n.get("selectedMode"), f = [];
      i.eachRawSeries(function(h) {
        !h.get("legendHoverLink") && f.push(h.id);
      }), Q9(n.getData(), function(h, p) {
        var v = h.get("name");
        if (!this.newlineDisabled && (v === "" || v === `
`)) {
          var g = new q1();
          g.newline = !0, u.add(g);
          return;
        }
        var m = i.getSeriesByName(v)[0];
        if (!c.get(v)) {
          if (m) {
            var y = m.getData(), b = y.getVisual("legendLineStyle") || {}, C = y.getVisual("legendIcon"), w = y.getVisual("style"), _ = this._createItem(m, v, p, h, n, e, b, w, C, d, a);
            _.on("click", Ld(nR, v, null, a, f)).on("mouseover", Ld(e6, m.name, null, a, f)).on("mouseout", Ld(t6, m.name, null, a, f)), i.ssr && _.eachChild(function(x) {
              var I = Ze(x);
              I.seriesIndex = m.seriesIndex, I.dataIndex = p, I.ssrType = "legend";
            }), c.set(v, !0);
          } else
            i.eachRawSeries(function(x) {
              if (!c.get(v) && x.legendVisualProvider) {
                var I = x.legendVisualProvider;
                if (!I.containName(v))
                  return;
                var D = I.indexOfName(v), T = I.getItemVisual(D, "style"), A = I.getItemVisual(D, "legendIcon"), M = Ci(T.fill);
                M && M[3] === 0 && (M[3] = 0.2, T = ae(ae({}, T), {
                  fill: Ja(M, "rgba")
                }));
                var R = this._createItem(x, v, p, h, n, e, {}, T, A, d, a);
                R.on("click", Ld(nR, null, v, a, f)).on("mouseover", Ld(e6, null, v, a, f)).on("mouseout", Ld(t6, null, v, a, f)), i.ssr && R.eachChild(function(E) {
                  var k = Ze(E);
                  k.seriesIndex = x.seriesIndex, k.dataIndex = p, k.ssrType = "legend";
                }), c.set(v, !0);
              }
            }, this);
          process.env.NODE_ENV !== "production" && (c.get(v) || console.warn(v + " series not exists. Legend data should be same with series name or data name."));
        }
      }, this), o && this._createSelector(o, n, a, s, l);
    }, r.prototype._createSelector = function(e, n, i, a, o) {
      var s = this.getSelectorGroup();
      Q9(e, function(u) {
        var c = u.type, d = new _t({
          style: {
            x: 0,
            y: 0,
            align: "center",
            verticalAlign: "middle"
          },
          onclick: function() {
            i.dispatchAction({
              type: c === "all" ? "legendAllSelect" : "legendInverseSelect"
            });
          }
        });
        s.add(d);
        var f = n.getModel("selectorLabel"), h = n.getModel(["emphasis", "selectorLabel"]);
        Xn(d, {
          normal: f,
          emphasis: h
        }, {
          defaultText: u.title
        }), Fl(d);
      });
    }, r.prototype._createItem = function(e, n, i, a, o, s, l, u, c, d, f) {
      var h = e.visualDrawType, p = o.get("itemWidth"), v = o.get("itemHeight"), g = o.isSelected(n), m = a.get("symbolRotate"), y = a.get("symbolKeepAspect"), b = a.get("icon");
      c = b || c || "roundRect";
      var C = ihe(c, a, l, u, h, g, f), w = new q1(), _ = a.getModel("textStyle");
      if (Ae(e.getLegendIcon) && (!b || b === "inherit"))
        w.add(e.getLegendIcon({
          itemWidth: p,
          itemHeight: v,
          icon: c,
          iconRotate: m,
          itemStyle: C.itemStyle,
          lineStyle: C.lineStyle,
          symbolKeepAspect: y
        }));
      else {
        var x = b === "inherit" && e.getData().getVisual("symbol") ? m === "inherit" ? e.getData().getVisual("symbolRotate") : m : 0;
        w.add(ahe({
          itemWidth: p,
          itemHeight: v,
          icon: c,
          iconRotate: x,
          itemStyle: C.itemStyle,
          lineStyle: C.lineStyle,
          symbolKeepAspect: y
        }));
      }
      var I = s === "left" ? p + 5 : -5, D = s, T = o.get("formatter"), A = n;
      pe(T) && T ? A = T.replace("{name}", n ?? "") : Ae(T) && (A = T(n));
      var M = g ? _.getTextColor() : a.get("inactiveColor");
      w.add(new _t({
        style: fr(_, {
          text: A,
          x: I,
          y: v / 2,
          fill: M,
          align: D,
          verticalAlign: "middle"
        }, {
          inheritColor: M
        })
      }));
      var R = new xt({
        shape: w.getBoundingRect(),
        style: {
          // Cannot use 'invisible' because SVG SSR will miss the node
          fill: "transparent"
        }
      }), E = a.getModel("tooltip");
      return E.get("show") && ah({
        el: R,
        componentModel: o,
        itemName: n,
        itemTooltipOption: E.option
      }), w.add(R), w.eachChild(function(k) {
        k.silent = !0;
      }), R.silent = !d, this.getContentGroup().add(w), Fl(w), w.__legendDataIndex = i, w;
    }, r.prototype.layoutInner = function(e, n, i, a, o, s) {
      var l = this.getContentGroup(), u = this.getSelectorGroup();
      Ic(e.get("orient"), l, e.get("itemGap"), i.width, i.height);
      var c = l.getBoundingRect(), d = [-c.x, -c.y];
      if (u.markRedraw(), l.markRedraw(), o) {
        Ic(
          // Buttons in selectorGroup always layout horizontally
          "horizontal",
          u,
          e.get("selectorItemGap", !0)
        );
        var f = u.getBoundingRect(), h = [-f.x, -f.y], p = e.get("selectorButtonGap", !0), v = e.getOrient().index, g = v === 0 ? "width" : "height", m = v === 0 ? "height" : "width", y = v === 0 ? "y" : "x";
        s === "end" ? h[v] += c[g] + p : d[v] += f[g] + p, h[1 - v] += c[m] / 2 - f[m] / 2, u.x = h[0], u.y = h[1], l.x = d[0], l.y = d[1];
        var b = {
          x: 0,
          y: 0
        };
        return b[g] = c[g] + p + f[g], b[m] = Math.max(c[m], f[m]), b[y] = Math.min(0, f[y] + h[1 - v]), b;
      } else
        return l.x = d[0], l.y = d[1], this.group.getBoundingRect();
    }, r.prototype.remove = function() {
      this.getContentGroup().removeAll(), this._isFirstRender = !0;
    }, r.type = "legend.plain", r;
  }(yr)
);
function ihe(t, r, e, n, i, a, o) {
  function s(g, m) {
    g.lineWidth === "auto" && (g.lineWidth = m.lineWidth > 0 ? 2 : 0), Q9(g, function(y, b) {
      g[b] === "inherit" && (g[b] = m[b]);
    });
  }
  var l = r.getModel("itemStyle"), u = l.getItemStyle(), c = t.lastIndexOf("empty", 0) === 0 ? "fill" : "stroke", d = l.getShallow("decal");
  u.decal = !d || d === "inherit" ? n.decal : Lf(d, o), u.fill === "inherit" && (u.fill = n[i]), u.stroke === "inherit" && (u.stroke = n[c]), u.opacity === "inherit" && (u.opacity = (i === "fill" ? n : e).opacity), s(u, n);
  var f = r.getModel("lineStyle"), h = f.getLineStyle();
  if (s(h, e), u.fill === "auto" && (u.fill = n.fill), u.stroke === "auto" && (u.stroke = n.fill), h.stroke === "auto" && (h.stroke = n.fill), !a) {
    var p = r.get("inactiveBorderWidth"), v = u[c];
    u.lineWidth = p === "auto" ? n.lineWidth > 0 && v ? 2 : 0 : u.lineWidth, u.fill = r.get("inactiveColor"), u.stroke = r.get("inactiveBorderColor"), h.stroke = f.get("inactiveColor"), h.lineWidth = f.get("inactiveWidth");
  }
  return {
    itemStyle: u,
    lineStyle: h
  };
}
function ahe(t) {
  var r = t.icon || "roundRect", e = en(r, 0, 0, t.itemWidth, t.itemHeight, t.itemStyle.fill, t.symbolKeepAspect);
  return e.setStyle(t.itemStyle), e.rotation = (t.iconRotate || 0) * Math.PI / 180, e.setOrigin([t.itemWidth / 2, t.itemHeight / 2]), r.indexOf("empty") > -1 && (e.style.stroke = e.style.fill, e.style.fill = "#fff", e.style.lineWidth = 2), e;
}
function nR(t, r, e, n) {
  t6(t, r, e, n), e.dispatchAction({
    type: "legendToggleSelect",
    name: t ?? r
  }), e6(t, r, e, n);
}
function eH(t) {
  for (var r = t.getZr().storage.getDisplayList(), e, n = 0, i = r.length; n < i && !(e = r[n].states.emphasis); )
    n++;
  return e && e.hoverLayer;
}
function e6(t, r, e, n) {
  eH(e) || e.dispatchAction({
    type: "highlight",
    seriesName: t,
    name: r,
    excludeSeriesId: n
  });
}
function t6(t, r, e, n) {
  eH(e) || e.dispatchAction({
    type: "downplay",
    seriesName: t,
    name: r,
    excludeSeriesId: n
  });
}
function ohe(t) {
  var r = t.findComponents({
    mainType: "legend"
  });
  r && r.length && t.filterSeries(function(e) {
    for (var n = 0; n < r.length; n++)
      if (!r[n].isSelected(e.name))
        return !1;
    return !0;
  });
}
function ap(t, r, e) {
  var n = {}, i = t === "toggleSelected", a;
  return e.eachComponent("legend", function(o) {
    i && a != null ? o[a ? "select" : "unSelect"](r.name) : t === "allSelect" || t === "inverseSelect" ? o[t]() : (o[t](r.name), a = o.isSelected(r.name));
    var s = o.getData();
    L(s, function(l) {
      var u = l.get("name");
      if (!(u === `
` || u === "")) {
        var c = o.isSelected(u);
        n.hasOwnProperty(u) ? n[u] = n[u] && c : n[u] = c;
      }
    });
  }), t === "allSelect" || t === "inverseSelect" ? {
    selected: n
  } : {
    name: r.name,
    selected: n
  };
}
function she(t) {
  t.registerAction("legendToggleSelect", "legendselectchanged", Ye(ap, "toggleSelected")), t.registerAction("legendAllSelect", "legendselectall", Ye(ap, "allSelect")), t.registerAction("legendInverseSelect", "legendinverseselect", Ye(ap, "inverseSelect")), t.registerAction("legendSelect", "legendselected", Ye(ap, "select")), t.registerAction("legendUnSelect", "legendunselected", Ye(ap, "unSelect"));
}
function tH(t) {
  t.registerComponentModel(q9), t.registerComponentView(QF), t.registerProcessor(t.PRIORITY.PROCESSOR.SERIES_FILTER, ohe), t.registerSubTypeDefaulter("legend", function() {
    return "plain";
  }), she(t);
}
var lhe = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.setScrollDataIndex = function(e) {
      this.option.scrollDataIndex = e;
    }, r.prototype.init = function(e, n, i) {
      var a = lh(e);
      t.prototype.init.call(this, e, n, i), iR(this, e, a);
    }, r.prototype.mergeOption = function(e, n) {
      t.prototype.mergeOption.call(this, e, n), iR(this, this.option, e);
    }, r.type = "legend.scroll", r.defaultOption = vu(q9.defaultOption, {
      scrollDataIndex: 0,
      pageButtonItemGap: 5,
      pageButtonGap: null,
      pageButtonPosition: "end",
      pageFormatter: "{current}/{total}",
      pageIcons: {
        horizontal: ["M0,0L12,-10L12,10z", "M0,0L-12,-10L-12,10z"],
        vertical: ["M0,0L20,0L10,-20z", "M0,0L20,0L10,20z"]
      },
      pageIconColor: "#2f4554",
      pageIconInactiveColor: "#aaa",
      pageIconSize: 15,
      pageTextStyle: {
        color: "#333"
      },
      animationDurationUpdate: 800
    }), r;
  }(q9)
);
function iR(t, r, e) {
  var n = t.getOrient(), i = [1, 1];
  i[n.index] = 0, ru(r, e, {
    type: "box",
    ignoreSize: !!i
  });
}
var aR = ze, G3 = ["width", "height"], B3 = ["x", "y"], uhe = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e.newlineDisabled = !0, e._currentIndex = 0, e;
    }
    return r.prototype.init = function() {
      t.prototype.init.call(this), this.group.add(this._containerGroup = new aR()), this._containerGroup.add(this.getContentGroup()), this.group.add(this._controllerGroup = new aR());
    }, r.prototype.resetInner = function() {
      t.prototype.resetInner.call(this), this._controllerGroup.removeAll(), this._containerGroup.removeClipPath(), this._containerGroup.__rectSize = null;
    }, r.prototype.renderInner = function(e, n, i, a, o, s, l) {
      var u = this;
      t.prototype.renderInner.call(this, e, n, i, a, o, s, l);
      var c = this._controllerGroup, d = n.get("pageIconSize", !0), f = ue(d) ? d : [d, d];
      p("pagePrev", 0);
      var h = n.getModel("pageTextStyle");
      c.add(new _t({
        name: "pageText",
        style: {
          // Placeholder to calculate a proper layout.
          text: "xx/xx",
          fill: h.getTextColor(),
          font: h.getFont(),
          verticalAlign: "middle",
          align: "center"
        },
        silent: !0
      })), p("pageNext", 1);
      function p(v, g) {
        var m = v + "DataIndex", y = ih(n.get("pageIcons", !0)[n.getOrient().name][g], {
          // Buttons will be created in each render, so we do not need
          // to worry about avoiding using legendModel kept in scope.
          onclick: ye(u._pageGo, u, m, n, a)
        }, {
          x: -f[0] / 2,
          y: -f[1] / 2,
          width: f[0],
          height: f[1]
        });
        y.name = v, c.add(y);
      }
    }, r.prototype.layoutInner = function(e, n, i, a, o, s) {
      var l = this.getSelectorGroup(), u = e.getOrient().index, c = G3[u], d = B3[u], f = G3[1 - u], h = B3[1 - u];
      o && Ic(
        // Buttons in selectorGroup always layout horizontally
        "horizontal",
        l,
        e.get("selectorItemGap", !0)
      );
      var p = e.get("selectorButtonGap", !0), v = l.getBoundingRect(), g = [-v.x, -v.y], m = Ge(i);
      o && (m[c] = i[c] - v[c] - p);
      var y = this._layoutContentAndController(e, a, m, u, c, f, h, d);
      if (o) {
        if (s === "end")
          g[u] += y[c] + p;
        else {
          var b = v[c] + p;
          g[u] -= b, y[d] -= b;
        }
        y[c] += v[c] + p, g[1 - u] += y[h] + y[f] / 2 - v[f] / 2, y[f] = Math.max(y[f], v[f]), y[h] = Math.min(y[h], v[h] + g[1 - u]), l.x = g[0], l.y = g[1], l.markRedraw();
      }
      return y;
    }, r.prototype._layoutContentAndController = function(e, n, i, a, o, s, l, u) {
      var c = this.getContentGroup(), d = this._containerGroup, f = this._controllerGroup;
      Ic(e.get("orient"), c, e.get("itemGap"), a ? i.width : null, a ? null : i.height), Ic(
        // Buttons in controller are layout always horizontally.
        "horizontal",
        f,
        e.get("pageButtonItemGap", !0)
      );
      var h = c.getBoundingRect(), p = f.getBoundingRect(), v = this._showController = h[o] > i[o], g = [-h.x, -h.y];
      n || (g[a] = c[u]);
      var m = [0, 0], y = [-p.x, -p.y], b = je(e.get("pageButtonGap", !0), e.get("itemGap", !0));
      if (v) {
        var C = e.get("pageButtonPosition", !0);
        C === "end" ? y[a] += i[o] - p[o] : m[a] += p[o] + b;
      }
      y[1 - a] += h[s] / 2 - p[s] / 2, c.setPosition(g), d.setPosition(m), f.setPosition(y);
      var w = {
        x: 0,
        y: 0
      };
      if (w[o] = v ? i[o] : h[o], w[s] = Math.max(h[s], p[s]), w[l] = Math.min(0, p[l] + y[1 - a]), d.__rectSize = i[o], v) {
        var _ = {
          x: 0,
          y: 0
        };
        _[o] = Math.max(i[o] - p[o] - b, 0), _[s] = w[s], d.setClipPath(new xt({
          shape: _
        })), d.__rectSize = _[o];
      } else
        f.eachChild(function(I) {
          I.attr({
            invisible: !0,
            silent: !0
          });
        });
      var x = this._getPageInfo(e);
      return x.pageIndex != null && kt(
        c,
        {
          x: x.contentPosition[0],
          y: x.contentPosition[1]
        },
        // When switch from "show controller" to "not show controller", view should be
        // updated immediately without animation, otherwise causes weird effect.
        v ? e : null
      ), this._updatePageInfoView(e, x), w;
    }, r.prototype._pageGo = function(e, n, i) {
      var a = this._getPageInfo(n)[e];
      a != null && i.dispatchAction({
        type: "legendScroll",
        scrollDataIndex: a,
        legendId: n.id
      });
    }, r.prototype._updatePageInfoView = function(e, n) {
      var i = this._controllerGroup;
      L(["pagePrev", "pageNext"], function(c) {
        var d = c + "DataIndex", f = n[d] != null, h = i.childOfName(c);
        h && (h.setStyle("fill", f ? e.get("pageIconColor", !0) : e.get("pageIconInactiveColor", !0)), h.cursor = f ? "pointer" : "default");
      });
      var a = i.childOfName("pageText"), o = e.get("pageFormatter"), s = n.pageIndex, l = s != null ? s + 1 : 0, u = n.pageCount;
      a && o && a.setStyle("text", pe(o) ? o.replace("{current}", l == null ? "" : l + "").replace("{total}", u == null ? "" : u + "") : o({
        current: l,
        total: u
      }));
    }, r.prototype._getPageInfo = function(e) {
      var n = e.get("scrollDataIndex", !0), i = this.getContentGroup(), a = this._containerGroup.__rectSize, o = e.getOrient().index, s = G3[o], l = B3[o], u = this._findTargetItemIndex(n), c = i.children(), d = c[u], f = c.length, h = f ? 1 : 0, p = {
        contentPosition: [i.x, i.y],
        pageCount: h,
        pageIndex: h - 1,
        pagePrevDataIndex: null,
        pageNextDataIndex: null
      };
      if (!d)
        return p;
      var v = C(d);
      p.contentPosition[o] = -v.s;
      for (var g = u + 1, m = v, y = v, b = null; g <= f; ++g)
        b = C(c[g]), // Half of the last item is out of the window.
        (!b && y.e > m.s + a || b && !w(b, m.s)) && (y.i > m.i ? m = y : m = b, m && (p.pageNextDataIndex == null && (p.pageNextDataIndex = m.i), ++p.pageCount)), y = b;
      for (var g = u - 1, m = v, y = v, b = null; g >= -1; --g)
        b = C(c[g]), // If the the end item does not intersect with the window started
        // from the current item, a page can be settled.
        (!b || !w(y, b.s)) && m.i < y.i && (y = m, p.pagePrevDataIndex == null && (p.pagePrevDataIndex = m.i), ++p.pageCount, ++p.pageIndex), m = b;
      return p;
      function C(_) {
        if (_) {
          var x = _.getBoundingRect(), I = x[l] + _[l];
          return {
            s: I,
            e: I + x[s],
            i: _.__legendDataIndex
          };
        }
      }
      function w(_, x) {
        return _.e >= x && _.s <= x + a;
      }
    }, r.prototype._findTargetItemIndex = function(e) {
      if (!this._showController)
        return 0;
      var n, i = this.getContentGroup(), a;
      return i.eachChild(function(o, s) {
        var l = o.__legendDataIndex;
        a == null && l != null && (a = s), l === e && (n = s);
      }), n ?? a;
    }, r.type = "legend.scroll", r;
  }(QF)
);
function che(t) {
  t.registerAction("legendScroll", "legendscroll", function(r, e) {
    var n = r.scrollDataIndex;
    n != null && e.eachComponent({
      mainType: "legend",
      subType: "scroll",
      query: r
    }, function(i) {
      i.setScrollDataIndex(n);
    });
  });
}
function dhe(t) {
  lt(tH), t.registerComponentModel(lhe), t.registerComponentView(uhe), che(t);
}
function fhe(t) {
  lt(tH), lt(dhe);
}
var hhe = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.type = "dataZoom.inside", r.defaultOption = vu(Gv.defaultOption, {
      disabled: !1,
      zoomLock: !1,
      zoomOnMouseWheel: !0,
      moveOnMouseMove: !0,
      moveOnMouseWheel: !1,
      preventDefaultMouseMove: !0
    }), r;
  }(Gv)
), P_ = It();
function phe(t, r, e) {
  P_(t).coordSysRecordMap.each(function(n) {
    var i = n.dataZoomInfoMap.get(r.uid);
    i && (i.getRange = e);
  });
}
function vhe(t, r) {
  for (var e = P_(t).coordSysRecordMap, n = e.keys(), i = 0; i < n.length; i++) {
    var a = n[i], o = e.get(a), s = o.dataZoomInfoMap;
    if (s) {
      var l = r.uid, u = s.get(l);
      u && (s.removeKey(l), s.keys().length || rH(e, o));
    }
  }
}
function rH(t, r) {
  if (r) {
    t.removeKey(r.model.uid);
    var e = r.controller;
    e && e.dispose();
  }
}
function ghe(t, r) {
  var e = {
    model: r,
    containsPoint: Ye(yhe, r),
    dispatchAction: Ye(mhe, t),
    dataZoomInfoMap: null,
    controller: null
  }, n = e.controller = new Dg(t.getZr());
  return L(["pan", "zoom", "scrollMove"], function(i) {
    n.on(i, function(a) {
      var o = [];
      e.dataZoomInfoMap.each(function(s) {
        if (a.isAvailableBehavior(s.model.option)) {
          var l = (s.getRange || {})[i], u = l && l(s.dzReferCoordSysInfo, e.model.mainType, e.controller, a);
          !s.model.get("disabled", !0) && u && o.push({
            dataZoomId: s.model.id,
            start: u[0],
            end: u[1]
          });
        }
      }), o.length && e.dispatchAction(o);
    });
  }), e;
}
function mhe(t, r) {
  t.isDisposed() || t.dispatchAction({
    type: "dataZoom",
    animation: {
      easing: "cubicOut",
      duration: 100
    },
    batch: r
  });
}
function yhe(t, r, e, n) {
  return t.coordinateSystem.containPoint([e, n]);
}
function bhe(t) {
  var r, e = "type_", n = {
    type_true: 2,
    type_move: 1,
    type_false: 0,
    type_undefined: -1
  }, i = !0;
  return t.each(function(a) {
    var o = a.model, s = o.get("disabled", !0) ? !1 : o.get("zoomLock", !0) ? "move" : !0;
    n[e + s] > n[e + r] && (r = s), i = i && o.get("preventDefaultMouseMove", !0);
  }), {
    controlType: r,
    opt: {
      // RoamController will enable all of these functionalities,
      // and the final behavior is determined by its event listener
      // provided by each inside zoom.
      zoomOnMouseWheel: !0,
      moveOnMouseMove: !0,
      moveOnMouseWheel: !0,
      preventDefaultMouseMove: !!i
    }
  };
}
function Che(t) {
  t.registerProcessor(t.PRIORITY.PROCESSOR.FILTER, function(r, e) {
    var n = P_(e), i = n.coordSysRecordMap || (n.coordSysRecordMap = xe());
    i.each(function(a) {
      a.dataZoomInfoMap = null;
    }), r.eachComponent({
      mainType: "dataZoom",
      subType: "inside"
    }, function(a) {
      var o = GF(a);
      L(o.infoList, function(s) {
        var l = s.model.uid, u = i.get(l) || i.set(l, ghe(e, s.model)), c = u.dataZoomInfoMap || (u.dataZoomInfoMap = xe());
        c.set(a.uid, {
          dzReferCoordSysInfo: s,
          model: a,
          getRange: null
        });
      });
    }), i.each(function(a) {
      var o = a.controller, s, l = a.dataZoomInfoMap;
      if (l) {
        var u = l.keys()[0];
        u != null && (s = l.get(u));
      }
      if (!s) {
        rH(i, a);
        return;
      }
      var c = bhe(l);
      o.enable(c.controlType, c.opt), o.setPointerChecker(a.containsPoint), dh(a, "dispatchAction", s.model.get("throttle", !0), "fixRate");
    });
  });
}
var whe = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = "dataZoom.inside", e;
    }
    return r.prototype.render = function(e, n, i) {
      if (t.prototype.render.apply(this, arguments), e.noTarget()) {
        this._clear();
        return;
      }
      this.range = e.getPercentRange(), phe(i, e, {
        pan: ye(F3.pan, this),
        zoom: ye(F3.zoom, this),
        scrollMove: ye(F3.scrollMove, this)
      });
    }, r.prototype.dispose = function() {
      this._clear(), t.prototype.dispose.apply(this, arguments);
    }, r.prototype._clear = function() {
      vhe(this.api, this.dataZoomModel), this.range = null;
    }, r.type = "dataZoom.inside", r;
  }(I_)
), F3 = {
  zoom: function(t, r, e, n) {
    var i = this.range, a = i.slice(), o = t.axisModels[0];
    if (o) {
      var s = H3[r](null, [n.originX, n.originY], o, e, t), l = (s.signal > 0 ? s.pixelStart + s.pixelLength - s.pixel : s.pixel - s.pixelStart) / s.pixelLength * (a[1] - a[0]) + a[0], u = Math.max(1 / n.scale, 0);
      a[0] = (a[0] - l) * u + l, a[1] = (a[1] - l) * u + l;
      var c = this.dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();
      if (id(0, a, [0, 100], 0, c.minSpan, c.maxSpan), this.range = a, i[0] !== a[0] || i[1] !== a[1])
        return a;
    }
  },
  pan: oR(function(t, r, e, n, i, a) {
    var o = H3[n]([a.oldX, a.oldY], [a.newX, a.newY], r, i, e);
    return o.signal * (t[1] - t[0]) * o.pixel / o.pixelLength;
  }),
  scrollMove: oR(function(t, r, e, n, i, a) {
    var o = H3[n]([0, 0], [a.scrollDelta, a.scrollDelta], r, i, e);
    return o.signal * (t[1] - t[0]) * a.scrollDelta;
  })
};
function oR(t) {
  return function(r, e, n, i) {
    var a = this.range, o = a.slice(), s = r.axisModels[0];
    if (s) {
      var l = t(o, s, r, e, n, i);
      if (id(l, o, [0, 100], "all"), this.range = o, a[0] !== o[0] || a[1] !== o[1])
        return o;
    }
  };
}
var H3 = {
  grid: function(t, r, e, n, i) {
    var a = e.axis, o = {}, s = i.model.coordinateSystem.getRect();
    return t = t || [0, 0], a.dim === "x" ? (o.pixel = r[0] - t[0], o.pixelLength = s.width, o.pixelStart = s.x, o.signal = a.inverse ? 1 : -1) : (o.pixel = r[1] - t[1], o.pixelLength = s.height, o.pixelStart = s.y, o.signal = a.inverse ? -1 : 1), o;
  },
  polar: function(t, r, e, n, i) {
    var a = e.axis, o = {}, s = i.model.coordinateSystem, l = s.getRadiusAxis().getExtent(), u = s.getAngleAxis().getExtent();
    return t = t ? s.pointToCoord(t) : [0, 0], r = s.pointToCoord(r), e.mainType === "radiusAxis" ? (o.pixel = r[0] - t[0], o.pixelLength = l[1] - l[0], o.pixelStart = l[0], o.signal = a.inverse ? 1 : -1) : (o.pixel = r[1] - t[1], o.pixelLength = u[1] - u[0], o.pixelStart = u[0], o.signal = a.inverse ? -1 : 1), o;
  },
  singleAxis: function(t, r, e, n, i) {
    var a = e.axis, o = i.model.coordinateSystem.getRect(), s = {};
    return t = t || [0, 0], a.orient === "horizontal" ? (s.pixel = r[0] - t[0], s.pixelLength = o.width, s.pixelStart = o.x, s.signal = a.inverse ? 1 : -1) : (s.pixel = r[1] - t[1], s.pixelLength = o.height, s.pixelStart = o.y, s.signal = a.inverse ? -1 : 1), s;
  }
};
function nH(t) {
  A_(t), t.registerComponentModel(hhe), t.registerComponentView(whe), Che(t);
}
var _he = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.type = "dataZoom.slider", r.layoutMode = "box", r.defaultOption = vu(Gv.defaultOption, {
      show: !0,
      // deault value can only be drived in view stage.
      right: "ph",
      top: "ph",
      width: "ph",
      height: "ph",
      left: null,
      bottom: null,
      borderColor: "#d2dbee",
      borderRadius: 3,
      backgroundColor: "rgba(47,69,84,0)",
      // dataBackgroundColor: '#ddd',
      dataBackground: {
        lineStyle: {
          color: "#d2dbee",
          width: 0.5
        },
        areaStyle: {
          color: "#d2dbee",
          opacity: 0.2
        }
      },
      selectedDataBackground: {
        lineStyle: {
          color: "#8fb0f7",
          width: 0.5
        },
        areaStyle: {
          color: "#8fb0f7",
          opacity: 0.2
        }
      },
      // Color of selected window.
      fillerColor: "rgba(135,175,274,0.2)",
      handleIcon: "path://M-9.35,34.56V42m0-40V9.5m-2,0h4a2,2,0,0,1,2,2v21a2,2,0,0,1-2,2h-4a2,2,0,0,1-2-2v-21A2,2,0,0,1-11.35,9.5Z",
      // Percent of the slider height
      handleSize: "100%",
      handleStyle: {
        color: "#fff",
        borderColor: "#ACB8D1"
      },
      moveHandleSize: 7,
      moveHandleIcon: "path://M-320.9-50L-320.9-50c18.1,0,27.1,9,27.1,27.1V85.7c0,18.1-9,27.1-27.1,27.1l0,0c-18.1,0-27.1-9-27.1-27.1V-22.9C-348-41-339-50-320.9-50z M-212.3-50L-212.3-50c18.1,0,27.1,9,27.1,27.1V85.7c0,18.1-9,27.1-27.1,27.1l0,0c-18.1,0-27.1-9-27.1-27.1V-22.9C-239.4-41-230.4-50-212.3-50z M-103.7-50L-103.7-50c18.1,0,27.1,9,27.1,27.1V85.7c0,18.1-9,27.1-27.1,27.1l0,0c-18.1,0-27.1-9-27.1-27.1V-22.9C-130.9-41-121.8-50-103.7-50z",
      moveHandleStyle: {
        color: "#D2DBEE",
        opacity: 0.7
      },
      showDetail: !0,
      showDataShadow: "auto",
      realtime: !0,
      zoomLock: !1,
      textStyle: {
        color: "#6E7079"
      },
      brushSelect: !0,
      brushStyle: {
        color: "rgba(135,175,274,0.15)"
      },
      emphasis: {
        handleStyle: {
          borderColor: "#8FB0F7"
        },
        moveHandleStyle: {
          color: "#8FB0F7"
        }
      }
    }), r;
  }(Gv)
), op = xt, sR = 7, xhe = 1, z3 = 30, She = 7, sp = "horizontal", lR = "vertical", Ihe = 5, Ahe = ["line", "bar", "candlestick", "scatter"], Dhe = {
  easing: "cubicOut",
  duration: 100,
  delay: 0
}, The = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e._displayables = {}, e;
    }
    return r.prototype.init = function(e, n) {
      this.api = n, this._onBrush = ye(this._onBrush, this), this._onBrushEnd = ye(this._onBrushEnd, this);
    }, r.prototype.render = function(e, n, i, a) {
      if (t.prototype.render.apply(this, arguments), dh(this, "_dispatchZoomAction", e.get("throttle"), "fixRate"), this._orient = e.getOrient(), e.get("show") === !1) {
        this.group.removeAll();
        return;
      }
      if (e.noTarget()) {
        this._clear(), this.group.removeAll();
        return;
      }
      (!a || a.type !== "dataZoom" || a.from !== this.uid) && this._buildView(), this._updateView();
    }, r.prototype.dispose = function() {
      this._clear(), t.prototype.dispose.apply(this, arguments);
    }, r.prototype._clear = function() {
      Iv(this, "_dispatchZoomAction");
      var e = this.api.getZr();
      e.off("mousemove", this._onBrush), e.off("mouseup", this._onBrushEnd);
    }, r.prototype._buildView = function() {
      var e = this.group;
      e.removeAll(), this._brushing = !1, this._displayables.brushRect = null, this._resetLocation(), this._resetInterval();
      var n = this._displayables.sliderGroup = new ze();
      this._renderBackground(), this._renderHandle(), this._renderDataShadow(), e.add(n), this._positionGroup();
    }, r.prototype._resetLocation = function() {
      var e = this.dataZoomModel, n = this.api, i = e.get("brushSelect"), a = i ? She : 0, o = this._findCoordRect(), s = {
        width: n.getWidth(),
        height: n.getHeight()
      }, l = this._orient === sp ? {
        // Why using 'right', because right should be used in vertical,
        // and it is better to be consistent for dealing with position param merge.
        right: s.width - o.x - o.width,
        top: s.height - z3 - sR - a,
        width: o.width,
        height: z3
      } : {
        right: sR,
        top: o.y,
        width: z3,
        height: o.height
      }, u = lh(e.option);
      L(["right", "top", "width", "height"], function(d) {
        u[d] === "ph" && (u[d] = l[d]);
      });
      var c = cn(u, s);
      this._location = {
        x: c.x,
        y: c.y
      }, this._size = [c.width, c.height], this._orient === lR && this._size.reverse();
    }, r.prototype._positionGroup = function() {
      var e = this.group, n = this._location, i = this._orient, a = this.dataZoomModel.getFirstTargetAxisModel(), o = a && a.get("inverse"), s = this._displayables.sliderGroup, l = (this._dataShadowInfo || {}).otherAxisInverse;
      s.attr(i === sp && !o ? {
        scaleY: l ? 1 : -1,
        scaleX: 1
      } : i === sp && o ? {
        scaleY: l ? 1 : -1,
        scaleX: -1
      } : i === lR && !o ? {
        scaleY: l ? -1 : 1,
        scaleX: 1,
        rotation: Math.PI / 2
      } : {
        scaleY: l ? -1 : 1,
        scaleX: -1,
        rotation: Math.PI / 2
      });
      var u = e.getBoundingRect([s]);
      e.x = n.x - u.x, e.y = n.y - u.y, e.markRedraw();
    }, r.prototype._getViewExtent = function() {
      return [0, this._size[0]];
    }, r.prototype._renderBackground = function() {
      var e = this.dataZoomModel, n = this._size, i = this._displayables.sliderGroup, a = e.get("brushSelect");
      i.add(new op({
        silent: !0,
        shape: {
          x: 0,
          y: 0,
          width: n[0],
          height: n[1]
        },
        style: {
          fill: e.get("backgroundColor")
        },
        z2: -40
      }));
      var o = new op({
        shape: {
          x: 0,
          y: 0,
          width: n[0],
          height: n[1]
        },
        style: {
          fill: "transparent"
        },
        z2: 0,
        onclick: ye(this._onClickPanel, this)
      }), s = this.api.getZr();
      a ? (o.on("mousedown", this._onBrushStart, this), o.cursor = "crosshair", s.on("mousemove", this._onBrush), s.on("mouseup", this._onBrushEnd)) : (s.off("mousemove", this._onBrush), s.off("mouseup", this._onBrushEnd)), i.add(o);
    }, r.prototype._renderDataShadow = function() {
      var e = this._dataShadowInfo = this._prepareDataShadowInfo();
      if (this._displayables.dataShadowSegs = [], !e)
        return;
      var n = this._size, i = this._shadowSize || [], a = e.series, o = a.getRawData(), s = a.getShadowDim && a.getShadowDim(), l = s && o.getDimensionInfo(s) ? a.getShadowDim() : e.otherDim;
      if (l == null)
        return;
      var u = this._shadowPolygonPts, c = this._shadowPolylinePts;
      if (o !== this._shadowData || l !== this._shadowDim || n[0] !== i[0] || n[1] !== i[1]) {
        var d = o.getDataExtent(l), f = (d[1] - d[0]) * 0.3;
        d = [d[0] - f, d[1] + f];
        var h = [0, n[1]], p = [0, n[0]], v = [[n[0], 0], [0, 0]], g = [], m = p[1] / (o.count() - 1), y = 0, b = Math.round(o.count() / n[0]), C;
        o.each([l], function(D, T) {
          if (b > 0 && T % b) {
            y += m;
            return;
          }
          var A = D == null || isNaN(D) || D === "", M = A ? 0 : zt(D, d, h, !0);
          A && !C && T ? (v.push([v[v.length - 1][0], 0]), g.push([g[g.length - 1][0], 0])) : !A && C && (v.push([y, 0]), g.push([y, 0])), v.push([y, M]), g.push([y, M]), y += m, C = A;
        }), u = this._shadowPolygonPts = v, c = this._shadowPolylinePts = g;
      }
      this._shadowData = o, this._shadowDim = l, this._shadowSize = [n[0], n[1]];
      var w = this.dataZoomModel;
      function _(D) {
        var T = w.getModel(D ? "selectedDataBackground" : "dataBackground"), A = new ze(), M = new si({
          shape: {
            points: u
          },
          segmentIgnoreThreshold: 1,
          style: T.getModel("areaStyle").getAreaStyle(),
          silent: !0,
          z2: -20
        }), R = new ci({
          shape: {
            points: c
          },
          segmentIgnoreThreshold: 1,
          style: T.getModel("lineStyle").getLineStyle(),
          silent: !0,
          z2: -19
        });
        return A.add(M), A.add(R), A;
      }
      for (var x = 0; x < 3; x++) {
        var I = _(x === 1);
        this._displayables.sliderGroup.add(I), this._displayables.dataShadowSegs.push(I);
      }
    }, r.prototype._prepareDataShadowInfo = function() {
      var e = this.dataZoomModel, n = e.get("showDataShadow");
      if (n !== !1) {
        var i, a = this.ecModel;
        return e.eachTargetAxis(function(o, s) {
          var l = e.getAxisProxy(o, s).getTargetSeriesModels();
          L(l, function(u) {
            if (!i && !(n !== !0 && nt(Ahe, u.get("type")) < 0)) {
              var c = a.getComponent(Ll(o), s).axis, d = Mhe(o), f, h = u.coordinateSystem;
              d != null && h.getOtherAxis && (f = h.getOtherAxis(c).inverse), d = u.getData().mapDimension(d), i = {
                thisAxis: c,
                series: u,
                thisDim: o,
                otherDim: d,
                otherAxisInverse: f
              };
            }
          }, this);
        }, this), i;
      }
    }, r.prototype._renderHandle = function() {
      var e = this.group, n = this._displayables, i = n.handles = [null, null], a = n.handleLabels = [null, null], o = this._displayables.sliderGroup, s = this._size, l = this.dataZoomModel, u = this.api, c = l.get("borderRadius") || 0, d = l.get("brushSelect"), f = n.filler = new op({
        silent: d,
        style: {
          fill: l.get("fillerColor")
        },
        textConfig: {
          position: "inside"
        }
      });
      o.add(f), o.add(new op({
        silent: !0,
        subPixelOptimize: !0,
        shape: {
          x: 0,
          y: 0,
          width: s[0],
          height: s[1],
          r: c
        },
        style: {
          // deprecated option
          stroke: l.get("dataBackgroundColor") || l.get("borderColor"),
          lineWidth: xhe,
          fill: "rgba(0,0,0,0)"
        }
      })), L([0, 1], function(b) {
        var C = l.get("handleIcon");
        !Mm[C] && C.indexOf("path://") < 0 && C.indexOf("image://") < 0 && (C = "path://" + C, process.env.NODE_ENV !== "production" && Ra("handleIcon now needs 'path://' prefix when using a path string"));
        var w = en(C, -1, 0, 2, 2, null, !0);
        w.attr({
          cursor: uR(this._orient),
          draggable: !0,
          drift: ye(this._onDragMove, this, b),
          ondragend: ye(this._onDragEnd, this),
          onmouseover: ye(this._showDataInfo, this, !0),
          onmouseout: ye(this._showDataInfo, this, !1),
          z2: 5
        });
        var _ = w.getBoundingRect(), x = l.get("handleSize");
        this._handleHeight = he(x, this._size[1]), this._handleWidth = _.width / _.height * this._handleHeight, w.setStyle(l.getModel("handleStyle").getItemStyle()), w.style.strokeNoScale = !0, w.rectHover = !0, w.ensureState("emphasis").style = l.getModel(["emphasis", "handleStyle"]).getItemStyle(), Fl(w);
        var I = l.get("handleColor");
        I != null && (w.style.fill = I), o.add(i[b] = w);
        var D = l.getModel("textStyle");
        e.add(a[b] = new _t({
          silent: !0,
          invisible: !0,
          style: fr(D, {
            x: 0,
            y: 0,
            text: "",
            verticalAlign: "middle",
            align: "center",
            fill: D.getTextColor(),
            font: D.getFont()
          }),
          z2: 10
        }));
      }, this);
      var h = f;
      if (d) {
        var p = he(l.get("moveHandleSize"), s[1]), v = n.moveHandle = new xt({
          style: l.getModel("moveHandleStyle").getItemStyle(),
          silent: !0,
          shape: {
            r: [0, 0, 2, 2],
            y: s[1] - 0.5,
            height: p
          }
        }), g = p * 0.8, m = n.moveHandleIcon = en(l.get("moveHandleIcon"), -g / 2, -g / 2, g, g, "#fff", !0);
        m.silent = !0, m.y = s[1] + p / 2 - 0.5, v.ensureState("emphasis").style = l.getModel(["emphasis", "moveHandleStyle"]).getItemStyle();
        var y = Math.min(s[1] / 2, Math.max(p, 10));
        h = n.moveZone = new xt({
          invisible: !0,
          shape: {
            y: s[1] - y,
            height: p + y
          }
        }), h.on("mouseover", function() {
          u.enterEmphasis(v);
        }).on("mouseout", function() {
          u.leaveEmphasis(v);
        }), o.add(v), o.add(m), o.add(h);
      }
      h.attr({
        draggable: !0,
        cursor: uR(this._orient),
        drift: ye(this._onDragMove, this, "all"),
        ondragstart: ye(this._showDataInfo, this, !0),
        ondragend: ye(this._onDragEnd, this),
        onmouseover: ye(this._showDataInfo, this, !0),
        onmouseout: ye(this._showDataInfo, this, !1)
      });
    }, r.prototype._resetInterval = function() {
      var e = this._range = this.dataZoomModel.getPercentRange(), n = this._getViewExtent();
      this._handleEnds = [zt(e[0], [0, 100], n, !0), zt(e[1], [0, 100], n, !0)];
    }, r.prototype._updateInterval = function(e, n) {
      var i = this.dataZoomModel, a = this._handleEnds, o = this._getViewExtent(), s = i.findRepresentativeAxisProxy().getMinMaxSpan(), l = [0, 100];
      id(n, a, o, i.get("zoomLock") ? "all" : e, s.minSpan != null ? zt(s.minSpan, l, o, !0) : null, s.maxSpan != null ? zt(s.maxSpan, l, o, !0) : null);
      var u = this._range, c = this._range = Ui([zt(a[0], o, l, !0), zt(a[1], o, l, !0)]);
      return !u || u[0] !== c[0] || u[1] !== c[1];
    }, r.prototype._updateView = function(e) {
      var n = this._displayables, i = this._handleEnds, a = Ui(i.slice()), o = this._size;
      L([0, 1], function(h) {
        var p = n.handles[h], v = this._handleHeight;
        p.attr({
          scaleX: v / 2,
          scaleY: v / 2,
          // This is a trick, by adding an extra tiny offset to let the default handle's end point align to the drag window.
          // NOTE: It may affect some custom shapes a bit. But we prefer to have better result by default.
          x: i[h] + (h ? -1 : 1),
          y: o[1] / 2 - v / 2
        });
      }, this), n.filler.setShape({
        x: a[0],
        y: 0,
        width: a[1] - a[0],
        height: o[1]
      });
      var s = {
        x: a[0],
        width: a[1] - a[0]
      };
      n.moveHandle && (n.moveHandle.setShape(s), n.moveZone.setShape(s), n.moveZone.getBoundingRect(), n.moveHandleIcon && n.moveHandleIcon.attr("x", s.x + s.width / 2));
      for (var l = n.dataShadowSegs, u = [0, a[0], a[1], o[0]], c = 0; c < l.length; c++) {
        var d = l[c], f = d.getClipPath();
        f || (f = new xt(), d.setClipPath(f)), f.setShape({
          x: u[c],
          y: 0,
          width: u[c + 1] - u[c],
          height: o[1]
        });
      }
      this._updateDataInfo(e);
    }, r.prototype._updateDataInfo = function(e) {
      var n = this.dataZoomModel, i = this._displayables, a = i.handleLabels, o = this._orient, s = ["", ""];
      if (n.get("showDetail")) {
        var l = n.findRepresentativeAxisProxy();
        if (l) {
          var u = l.getAxisModel().axis, c = this._range, d = e ? l.calculateDataWindow({
            start: c[0],
            end: c[1]
          }).valueWindow : l.getDataValueWindow();
          s = [this._formatLabel(d[0], u), this._formatLabel(d[1], u)];
        }
      }
      var f = Ui(this._handleEnds.slice());
      h.call(this, 0), h.call(this, 1);
      function h(p) {
        var v = Hl(i.handles[p].parent, this.group), g = f2(p === 0 ? "right" : "left", v), m = this._handleWidth / 2 + Ihe, y = Ka([f[p] + (p === 0 ? -m : m), this._size[1] / 2], v);
        a[p].setStyle({
          x: y[0],
          y: y[1],
          verticalAlign: o === sp ? "middle" : g,
          align: o === sp ? g : "center",
          text: s[p]
        });
      }
    }, r.prototype._formatLabel = function(e, n) {
      var i = this.dataZoomModel, a = i.get("labelFormatter"), o = i.get("labelPrecision");
      (o == null || o === "auto") && (o = n.getPixelPrecision());
      var s = e == null || isNaN(e) ? "" : n.type === "category" || n.type === "time" ? n.scale.getLabel({
        value: Math.round(e)
      }) : e.toFixed(Math.min(o, 20));
      return Ae(a) ? a(e, s) : pe(a) ? a.replace("{value}", s) : s;
    }, r.prototype._showDataInfo = function(e) {
      e = this._dragging || e;
      var n = this._displayables, i = n.handleLabels;
      i[0].attr("invisible", !e), i[1].attr("invisible", !e), n.moveHandle && this.api[e ? "enterEmphasis" : "leaveEmphasis"](n.moveHandle, 1);
    }, r.prototype._onDragMove = function(e, n, i, a) {
      this._dragging = !0, Ys(a.event);
      var o = this._displayables.sliderGroup.getLocalTransform(), s = Ka([n, i], o, !0), l = this._updateInterval(e, s[0]), u = this.dataZoomModel.get("realtime");
      this._updateView(!u), l && u && this._dispatchZoomAction(!0);
    }, r.prototype._onDragEnd = function() {
      this._dragging = !1, this._showDataInfo(!1);
      var e = this.dataZoomModel.get("realtime");
      !e && this._dispatchZoomAction(!1);
    }, r.prototype._onClickPanel = function(e) {
      var n = this._size, i = this._displayables.sliderGroup.transformCoordToLocal(e.offsetX, e.offsetY);
      if (!(i[0] < 0 || i[0] > n[0] || i[1] < 0 || i[1] > n[1])) {
        var a = this._handleEnds, o = (a[0] + a[1]) / 2, s = this._updateInterval("all", i[0] - o);
        this._updateView(), s && this._dispatchZoomAction(!1);
      }
    }, r.prototype._onBrushStart = function(e) {
      var n = e.offsetX, i = e.offsetY;
      this._brushStart = new tt(n, i), this._brushing = !0, this._brushStartTime = +/* @__PURE__ */ new Date();
    }, r.prototype._onBrushEnd = function(e) {
      if (this._brushing) {
        var n = this._displayables.brushRect;
        if (this._brushing = !1, !!n) {
          n.attr("ignore", !0);
          var i = n.shape, a = +/* @__PURE__ */ new Date();
          if (!(a - this._brushStartTime < 200 && Math.abs(i.width) < 5)) {
            var o = this._getViewExtent(), s = [0, 100];
            this._range = Ui([zt(i.x, o, s, !0), zt(i.x + i.width, o, s, !0)]), this._handleEnds = [i.x, i.x + i.width], this._updateView(), this._dispatchZoomAction(!1);
          }
        }
      }
    }, r.prototype._onBrush = function(e) {
      this._brushing && (Ys(e.event), this._updateBrushRect(e.offsetX, e.offsetY));
    }, r.prototype._updateBrushRect = function(e, n) {
      var i = this._displayables, a = this.dataZoomModel, o = i.brushRect;
      o || (o = i.brushRect = new op({
        silent: !0,
        style: a.getModel("brushStyle").getItemStyle()
      }), i.sliderGroup.add(o)), o.attr("ignore", !1);
      var s = this._brushStart, l = this._displayables.sliderGroup, u = l.transformCoordToLocal(e, n), c = l.transformCoordToLocal(s.x, s.y), d = this._size;
      u[0] = Math.max(Math.min(d[0], u[0]), 0), o.setShape({
        x: c[0],
        y: 0,
        width: u[0] - c[0],
        height: d[1]
      });
    }, r.prototype._dispatchZoomAction = function(e) {
      var n = this._range;
      this.api.dispatchAction({
        type: "dataZoom",
        from: this.uid,
        dataZoomId: this.dataZoomModel.id,
        animation: e ? Dhe : null,
        start: n[0],
        end: n[1]
      });
    }, r.prototype._findCoordRect = function() {
      var e, n = GF(this.dataZoomModel).infoList;
      if (!e && n.length) {
        var i = n[0].model.coordinateSystem;
        e = i.getRect && i.getRect();
      }
      if (!e) {
        var a = this.api.getWidth(), o = this.api.getHeight();
        e = {
          x: a * 0.2,
          y: o * 0.2,
          width: a * 0.6,
          height: o * 0.6
        };
      }
      return e;
    }, r.type = "dataZoom.slider", r;
  }(I_)
);
function Mhe(t) {
  var r = {
    x: "y",
    y: "x",
    radius: "angle",
    angle: "radius"
  };
  return r[t];
}
function uR(t) {
  return t === "vertical" ? "ns-resize" : "ew-resize";
}
function iH(t) {
  t.registerComponentModel(_he), t.registerComponentView(The), A_(t);
}
function Rhe(t) {
  lt(nH), lt(iH);
}
var aH = {
  /**
   * @public
   */
  get: function(t, r, e) {
    var n = Ge((Lhe[t] || {})[r]);
    return e && ue(n) ? n[n.length - 1] : n;
  }
}, Lhe = {
  color: {
    active: ["#006edd", "#e0ffff"],
    inactive: ["rgba(0,0,0,0)"]
  },
  colorHue: {
    active: [0, 360],
    inactive: [0, 0]
  },
  colorSaturation: {
    active: [0.3, 1],
    inactive: [0, 0]
  },
  colorLightness: {
    active: [0.9, 0.5],
    inactive: [0, 0]
  },
  colorAlpha: {
    active: [0.3, 1],
    inactive: [0, 0]
  },
  opacity: {
    active: [0.3, 1],
    inactive: [0, 0]
  },
  symbol: {
    active: ["circle", "roundRect", "diamond"],
    inactive: ["none"]
  },
  symbolSize: {
    active: [10, 50],
    inactive: [0, 0]
  }
}, cR = _n.mapVisual, Ehe = _n.eachVisual, khe = ue, dR = L, Phe = Ui, Nhe = zt, iy = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e.stateList = ["inRange", "outOfRange"], e.replacableOptionKeys = ["inRange", "outOfRange", "target", "controller", "color"], e.layoutMode = {
        type: "box",
        ignoreSize: !0
      }, e.dataBound = [-1 / 0, 1 / 0], e.targetVisuals = {}, e.controllerVisuals = {}, e;
    }
    return r.prototype.init = function(e, n, i) {
      this.mergeDefaultAndTheme(e, i);
    }, r.prototype.optionUpdated = function(e, n) {
      var i = this.option;
      !n && $F(i, e, this.replacableOptionKeys), this.textStyleModel = this.getModel("textStyle"), this.resetItemSize(), this.completeVisualOption();
    }, r.prototype.resetVisual = function(e) {
      var n = this.stateList;
      e = ye(e, this), this.controllerVisuals = U9(this.option.controller, n, e), this.targetVisuals = U9(this.option.target, n, e);
    }, r.prototype.getItemSymbol = function() {
      return null;
    }, r.prototype.getTargetSeriesIndices = function() {
      var e = this.option.seriesIndex, n = [];
      return e == null || e === "all" ? this.ecModel.eachSeries(function(i, a) {
        n.push(a);
      }) : n = Qt(e), n;
    }, r.prototype.eachTargetSeries = function(e, n) {
      L(this.getTargetSeriesIndices(), function(i) {
        var a = this.ecModel.getSeriesByIndex(i);
        a && e.call(n, a);
      }, this);
    }, r.prototype.isTargetSeries = function(e) {
      var n = !1;
      return this.eachTargetSeries(function(i) {
        i === e && (n = !0);
      }), n;
    }, r.prototype.formatValueText = function(e, n, i) {
      var a = this.option, o = a.precision, s = this.dataBound, l = a.formatter, u;
      i = i || ["<", ">"], ue(e) && (e = e.slice(), u = !0);
      var c = n ? e : u ? [d(e[0]), d(e[1])] : d(e);
      if (pe(l))
        return l.replace("{value}", u ? c[0] : c).replace("{value2}", u ? c[1] : c);
      if (Ae(l))
        return u ? l(e[0], e[1]) : l(e);
      if (u)
        return e[0] === s[0] ? i[0] + " " + c[1] : e[1] === s[1] ? i[1] + " " + c[0] : c[0] + " - " + c[1];
      return c;
      function d(f) {
        return f === s[0] ? "min" : f === s[1] ? "max" : (+f).toFixed(Math.min(o, 20));
      }
    }, r.prototype.resetExtent = function() {
      var e = this.option, n = Phe([e.min, e.max]);
      this._dataExtent = n;
    }, r.prototype.getDataDimensionIndex = function(e) {
      var n = this.option.dimension;
      if (n != null)
        return e.getDimensionIndex(n);
      for (var i = e.dimensions, a = i.length - 1; a >= 0; a--) {
        var o = i[a], s = e.getDimensionInfo(o);
        if (!s.isCalculationCoord)
          return s.storeDimIndex;
      }
    }, r.prototype.getExtent = function() {
      return this._dataExtent.slice();
    }, r.prototype.completeVisualOption = function() {
      var e = this.ecModel, n = this.option, i = {
        inRange: n.inRange,
        outOfRange: n.outOfRange
      }, a = n.target || (n.target = {}), o = n.controller || (n.controller = {});
      Qe(a, i), Qe(o, i);
      var s = this.isCategory();
      l.call(this, a), l.call(this, o), u.call(this, a, "inRange", "outOfRange"), c.call(this, o);
      function l(d) {
        khe(n.color) && !d.inRange && (d.inRange = {
          color: n.color.slice().reverse()
        }), d.inRange = d.inRange || {
          color: e.get("gradientColor")
        };
      }
      function u(d, f, h) {
        var p = d[f], v = d[h];
        p && !v && (v = d[h] = {}, dR(p, function(g, m) {
          if (_n.isValidType(m)) {
            var y = aH.get(m, "inactive", s);
            y != null && (v[m] = y, m === "color" && !v.hasOwnProperty("opacity") && !v.hasOwnProperty("colorAlpha") && (v.opacity = [0, 0]));
          }
        }));
      }
      function c(d) {
        var f = (d.inRange || {}).symbol || (d.outOfRange || {}).symbol, h = (d.inRange || {}).symbolSize || (d.outOfRange || {}).symbolSize, p = this.get("inactiveColor"), v = this.getItemSymbol(), g = v || "roundRect";
        dR(this.stateList, function(m) {
          var y = this.itemSize, b = d[m];
          b || (b = d[m] = {
            color: s ? p : [p]
          }), b.symbol == null && (b.symbol = f && Ge(f) || (s ? g : [g])), b.symbolSize == null && (b.symbolSize = h && Ge(h) || (s ? y[0] : [y[0], y[0]])), b.symbol = cR(b.symbol, function(_) {
            return _ === "none" ? g : _;
          });
          var C = b.symbolSize;
          if (C != null) {
            var w = -1 / 0;
            Ehe(C, function(_) {
              _ > w && (w = _);
            }), b.symbolSize = cR(C, function(_) {
              return Nhe(_, [0, w], [0, y[0]], !0);
            });
          }
        }, this);
      }
    }, r.prototype.resetItemSize = function() {
      this.itemSize = [parseFloat(this.get("itemWidth")), parseFloat(this.get("itemHeight"))];
    }, r.prototype.isCategory = function() {
      return !!this.option.categories;
    }, r.prototype.setSelected = function(e) {
    }, r.prototype.getSelected = function() {
      return null;
    }, r.prototype.getValueState = function(e) {
      return null;
    }, r.prototype.getVisualMeta = function(e) {
      return null;
    }, r.type = "visualMap", r.dependencies = ["series"], r.defaultOption = {
      show: !0,
      // zlevel: 0,
      z: 4,
      seriesIndex: "all",
      min: 0,
      max: 200,
      left: 0,
      right: null,
      top: null,
      bottom: 0,
      itemWidth: null,
      itemHeight: null,
      inverse: !1,
      orient: "vertical",
      backgroundColor: "rgba(0,0,0,0)",
      borderColor: "#ccc",
      contentColor: "#5793f3",
      inactiveColor: "#aaa",
      borderWidth: 0,
      padding: 5,
      // 接受数组分别设定上右下左边距，同css
      textGap: 10,
      precision: 0,
      textStyle: {
        color: "#333"
        // 值域文字颜色
      }
    }, r;
  }(st)
), fR = [20, 140], Ohe = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.optionUpdated = function(e, n) {
      t.prototype.optionUpdated.apply(this, arguments), this.resetExtent(), this.resetVisual(function(i) {
        i.mappingMethod = "linear", i.dataExtent = this.getExtent();
      }), this._resetRange();
    }, r.prototype.resetItemSize = function() {
      t.prototype.resetItemSize.apply(this, arguments);
      var e = this.itemSize;
      (e[0] == null || isNaN(e[0])) && (e[0] = fR[0]), (e[1] == null || isNaN(e[1])) && (e[1] = fR[1]);
    }, r.prototype._resetRange = function() {
      var e = this.getExtent(), n = this.option.range;
      !n || n.auto ? (e.auto = 1, this.option.range = e) : ue(n) && (n[0] > n[1] && n.reverse(), n[0] = Math.max(n[0], e[0]), n[1] = Math.min(n[1], e[1]));
    }, r.prototype.completeVisualOption = function() {
      t.prototype.completeVisualOption.apply(this, arguments), L(this.stateList, function(e) {
        var n = this.option.controller[e].symbolSize;
        n && n[0] !== n[1] && (n[0] = n[1] / 3);
      }, this);
    }, r.prototype.setSelected = function(e) {
      this.option.range = e.slice(), this._resetRange();
    }, r.prototype.getSelected = function() {
      var e = this.getExtent(), n = Ui((this.get("range") || []).slice());
      return n[0] > e[1] && (n[0] = e[1]), n[1] > e[1] && (n[1] = e[1]), n[0] < e[0] && (n[0] = e[0]), n[1] < e[0] && (n[1] = e[0]), n;
    }, r.prototype.getValueState = function(e) {
      var n = this.option.range, i = this.getExtent();
      return (n[0] <= i[0] || n[0] <= e) && (n[1] >= i[1] || e <= n[1]) ? "inRange" : "outOfRange";
    }, r.prototype.findTargetDataIndices = function(e) {
      var n = [];
      return this.eachTargetSeries(function(i) {
        var a = [], o = i.getData();
        o.each(this.getDataDimensionIndex(o), function(s, l) {
          e[0] <= s && s <= e[1] && a.push(l);
        }, this), n.push({
          seriesId: i.id,
          dataIndex: a
        });
      }, this), n;
    }, r.prototype.getVisualMeta = function(e) {
      var n = hR(this, "outOfRange", this.getExtent()), i = hR(this, "inRange", this.option.range.slice()), a = [];
      function o(h, p) {
        a.push({
          value: h,
          color: e(h, p)
        });
      }
      for (var s = 0, l = 0, u = i.length, c = n.length; l < c && (!i.length || n[l] <= i[0]); l++)
        n[l] < i[s] && o(n[l], "outOfRange");
      for (var d = 1; s < u; s++, d = 0)
        d && a.length && o(i[s], "outOfRange"), o(i[s], "inRange");
      for (var d = 1; l < c; l++)
        (!i.length || i[i.length - 1] < n[l]) && (d && (a.length && o(a[a.length - 1].value, "outOfRange"), d = 0), o(n[l], "outOfRange"));
      var f = a.length;
      return {
        stops: a,
        outerColors: [f ? a[0].color : "transparent", f ? a[f - 1].color : "transparent"]
      };
    }, r.type = "visualMap.continuous", r.defaultOption = vu(iy.defaultOption, {
      align: "auto",
      calculable: !1,
      hoverLink: !0,
      realtime: !0,
      handleIcon: "path://M-11.39,9.77h0a3.5,3.5,0,0,1-3.5,3.5h-22a3.5,3.5,0,0,1-3.5-3.5h0a3.5,3.5,0,0,1,3.5-3.5h22A3.5,3.5,0,0,1-11.39,9.77Z",
      handleSize: "120%",
      handleStyle: {
        borderColor: "#fff",
        borderWidth: 1
      },
      indicatorIcon: "circle",
      indicatorSize: "50%",
      indicatorStyle: {
        borderColor: "#fff",
        borderWidth: 2,
        shadowBlur: 2,
        shadowOffsetX: 1,
        shadowOffsetY: 1,
        shadowColor: "rgba(0,0,0,0.2)"
      }
      // emphasis: {
      //     handleStyle: {
      //         shadowBlur: 3,
      //         shadowOffsetX: 1,
      //         shadowOffsetY: 1,
      //         shadowColor: 'rgba(0,0,0,0.2)'
      //     }
      // }
    }), r;
  }(iy)
);
function hR(t, r, e) {
  if (e[0] === e[1])
    return e.slice();
  for (var n = 200, i = (e[1] - e[0]) / n, a = e[0], o = [], s = 0; s <= n && a < e[1]; s++)
    o.push(a), a += i;
  return o.push(e[1]), o;
}
var oH = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e.autoPositionValues = {
        left: 1,
        right: 1,
        top: 1,
        bottom: 1
      }, e;
    }
    return r.prototype.init = function(e, n) {
      this.ecModel = e, this.api = n;
    }, r.prototype.render = function(e, n, i, a) {
      if (this.visualMapModel = e, e.get("show") === !1) {
        this.group.removeAll();
        return;
      }
      this.doRender(e, n, i, a);
    }, r.prototype.renderBackground = function(e) {
      var n = this.visualMapModel, i = Qc(n.get("padding") || 0), a = e.getBoundingRect();
      e.add(new xt({
        z2: -1,
        silent: !0,
        shape: {
          x: a.x - i[3],
          y: a.y - i[0],
          width: a.width + i[3] + i[1],
          height: a.height + i[0] + i[2]
        },
        style: {
          fill: n.get("backgroundColor"),
          stroke: n.get("borderColor"),
          lineWidth: n.get("borderWidth")
        }
      }));
    }, r.prototype.getControllerVisual = function(e, n, i) {
      i = i || {};
      var a = i.forceState, o = this.visualMapModel, s = {};
      if (n === "color") {
        var l = o.get("contentColor");
        s.color = l;
      }
      function u(h) {
        return s[h];
      }
      function c(h, p) {
        s[h] = p;
      }
      var d = o.controllerVisuals[a || o.getValueState(e)], f = _n.prepareVisualTypes(d);
      return L(f, function(h) {
        var p = d[h];
        i.convertOpacityToAlpha && h === "opacity" && (h = "colorAlpha", p = d.__alphaForOpacity), _n.dependsOn(h, n) && p && p.applyVisual(e, u, c);
      }), s[n];
    }, r.prototype.positionGroup = function(e) {
      var n = this.visualMapModel, i = this.api;
      y2(e, n.getBoxLayoutParams(), {
        width: i.getWidth(),
        height: i.getHeight()
      });
    }, r.prototype.doRender = function(e, n, i, a) {
    }, r.type = "visualMap", r;
  }(yr)
), pR = [["left", "right", "width"], ["top", "bottom", "height"]];
function sH(t, r, e) {
  var n = t.option, i = n.align;
  if (i != null && i !== "auto")
    return i;
  for (var a = {
    width: r.getWidth(),
    height: r.getHeight()
  }, o = n.orient === "horizontal" ? 1 : 0, s = pR[o], l = [0, null, 10], u = {}, c = 0; c < 3; c++)
    u[pR[1 - o][c]] = l[c], u[s[c]] = c === 2 ? e[0] : n[s[c]];
  var d = [["x", "width", 3], ["y", "height", 0]][o], f = cn(u, a, n.padding);
  return s[(f.margin[d[2]] || 0) + f[d[0]] + f[d[1]] * 0.5 < a[d[1]] * 0.5 ? 0 : 1];
}
function F0(t, r) {
  return L(t || [], function(e) {
    e.dataIndex != null && (e.dataIndexInside = e.dataIndex, e.dataIndex = null), e.highlightKey = "visualMap" + (r ? r.componentIndex : "");
  }), t;
}
var xo = zt, Vhe = L, vR = Math.min, W3 = Math.max, Ghe = 12, Bhe = 6, Fhe = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e._shapes = {}, e._dataInterval = [], e._handleEnds = [], e._hoverLinkDataIndices = [], e;
    }
    return r.prototype.init = function(e, n) {
      t.prototype.init.call(this, e, n), this._hoverLinkFromSeriesMouseOver = ye(this._hoverLinkFromSeriesMouseOver, this), this._hideIndicator = ye(this._hideIndicator, this);
    }, r.prototype.doRender = function(e, n, i, a) {
      (!a || a.type !== "selectDataRange" || a.from !== this.uid) && this._buildView();
    }, r.prototype._buildView = function() {
      this.group.removeAll();
      var e = this.visualMapModel, n = this.group;
      this._orient = e.get("orient"), this._useHandle = e.get("calculable"), this._resetInterval(), this._renderBar(n);
      var i = e.get("text");
      this._renderEndsText(n, i, 0), this._renderEndsText(n, i, 1), this._updateView(!0), this.renderBackground(n), this._updateView(), this._enableHoverLinkToSeries(), this._enableHoverLinkFromSeries(), this.positionGroup(n);
    }, r.prototype._renderEndsText = function(e, n, i) {
      if (n) {
        var a = n[1 - i];
        a = a != null ? a + "" : "";
        var o = this.visualMapModel, s = o.get("textGap"), l = o.itemSize, u = this._shapes.mainGroup, c = this._applyTransform([l[0] / 2, i === 0 ? -s : l[1] + s], u), d = this._applyTransform(i === 0 ? "bottom" : "top", u), f = this._orient, h = this.visualMapModel.textStyleModel;
        this.group.add(new _t({
          style: fr(h, {
            x: c[0],
            y: c[1],
            verticalAlign: f === "horizontal" ? "middle" : d,
            align: f === "horizontal" ? d : "center",
            text: a
          })
        }));
      }
    }, r.prototype._renderBar = function(e) {
      var n = this.visualMapModel, i = this._shapes, a = n.itemSize, o = this._orient, s = this._useHandle, l = sH(n, this.api, a), u = i.mainGroup = this._createBarGroup(l), c = new ze();
      u.add(c), c.add(i.outOfRange = gR()), c.add(i.inRange = gR(null, s ? yR(this._orient) : null, ye(this._dragHandle, this, "all", !1), ye(this._dragHandle, this, "all", !0))), c.setClipPath(new xt({
        shape: {
          x: 0,
          y: 0,
          width: a[0],
          height: a[1],
          r: 3
        }
      }));
      var d = n.textStyleModel.getTextRect("国"), f = W3(d.width, d.height);
      s && (i.handleThumbs = [], i.handleLabels = [], i.handleLabelPoints = [], this._createHandle(n, u, 0, a, f, o), this._createHandle(n, u, 1, a, f, o)), this._createIndicator(n, u, a, f, o), e.add(u);
    }, r.prototype._createHandle = function(e, n, i, a, o, s) {
      var l = ye(this._dragHandle, this, i, !1), u = ye(this._dragHandle, this, i, !0), c = to(e.get("handleSize"), a[0]), d = en(e.get("handleIcon"), -c / 2, -c / 2, c, c, null, !0), f = yR(this._orient);
      d.attr({
        cursor: f,
        draggable: !0,
        drift: l,
        ondragend: u,
        onmousemove: function(m) {
          Ys(m.event);
        }
      }), d.x = a[0] / 2, d.useStyle(e.getModel("handleStyle").getItemStyle()), d.setStyle({
        strokeNoScale: !0,
        strokeFirst: !0
      }), d.style.lineWidth *= 2, d.ensureState("emphasis").style = e.getModel(["emphasis", "handleStyle"]).getItemStyle(), dc(d, !0), n.add(d);
      var h = this.visualMapModel.textStyleModel, p = new _t({
        cursor: f,
        draggable: !0,
        drift: l,
        onmousemove: function(m) {
          Ys(m.event);
        },
        ondragend: u,
        style: fr(h, {
          x: 0,
          y: 0,
          text: ""
        })
      });
      p.ensureState("blur").style = {
        opacity: 0.1
      }, p.stateTransition = {
        duration: 200
      }, this.group.add(p);
      var v = [c, 0], g = this._shapes;
      g.handleThumbs[i] = d, g.handleLabelPoints[i] = v, g.handleLabels[i] = p;
    }, r.prototype._createIndicator = function(e, n, i, a, o) {
      var s = to(e.get("indicatorSize"), i[0]), l = en(e.get("indicatorIcon"), -s / 2, -s / 2, s, s, null, !0);
      l.attr({
        cursor: "move",
        invisible: !0,
        silent: !0,
        x: i[0] / 2
      });
      var u = e.getModel("indicatorStyle").getItemStyle();
      if (l instanceof An) {
        var c = l.style;
        l.useStyle(ae({
          // TODO other properties like x, y ?
          image: c.image,
          x: c.x,
          y: c.y,
          width: c.width,
          height: c.height
        }, u));
      } else
        l.useStyle(u);
      n.add(l);
      var d = this.visualMapModel.textStyleModel, f = new _t({
        silent: !0,
        invisible: !0,
        style: fr(d, {
          x: 0,
          y: 0,
          text: ""
        })
      });
      this.group.add(f);
      var h = [(o === "horizontal" ? a / 2 : Bhe) + i[0] / 2, 0], p = this._shapes;
      p.indicator = l, p.indicatorLabel = f, p.indicatorLabelPoint = h, this._firstShowIndicator = !0;
    }, r.prototype._dragHandle = function(e, n, i, a) {
      if (this._useHandle) {
        if (this._dragging = !n, !n) {
          var o = this._applyTransform([i, a], this._shapes.mainGroup, !0);
          this._updateInterval(e, o[1]), this._hideIndicator(), this._updateView();
        }
        n === !this.visualMapModel.get("realtime") && this.api.dispatchAction({
          type: "selectDataRange",
          from: this.uid,
          visualMapId: this.visualMapModel.id,
          selected: this._dataInterval.slice()
        }), n ? !this._hovering && this._clearHoverLinkToSeries() : mR(this.visualMapModel) && this._doHoverLinkToSeries(this._handleEnds[e], !1);
      }
    }, r.prototype._resetInterval = function() {
      var e = this.visualMapModel, n = this._dataInterval = e.getSelected(), i = e.getExtent(), a = [0, e.itemSize[1]];
      this._handleEnds = [xo(n[0], i, a, !0), xo(n[1], i, a, !0)];
    }, r.prototype._updateInterval = function(e, n) {
      n = n || 0;
      var i = this.visualMapModel, a = this._handleEnds, o = [0, i.itemSize[1]];
      id(
        n,
        a,
        o,
        e,
        // cross is forbidden
        0
      );
      var s = i.getExtent();
      this._dataInterval = [xo(a[0], o, s, !0), xo(a[1], o, s, !0)];
    }, r.prototype._updateView = function(e) {
      var n = this.visualMapModel, i = n.getExtent(), a = this._shapes, o = [0, n.itemSize[1]], s = e ? o : this._handleEnds, l = this._createBarVisual(this._dataInterval, i, s, "inRange"), u = this._createBarVisual(i, i, o, "outOfRange");
      a.inRange.setStyle({
        fill: l.barColor
        // opacity: visualInRange.opacity
      }).setShape("points", l.barPoints), a.outOfRange.setStyle({
        fill: u.barColor
        // opacity: visualOutOfRange.opacity
      }).setShape("points", u.barPoints), this._updateHandle(s, l);
    }, r.prototype._createBarVisual = function(e, n, i, a) {
      var o = {
        forceState: a,
        convertOpacityToAlpha: !0
      }, s = this._makeColorGradient(e, o), l = [this.getControllerVisual(e[0], "symbolSize", o), this.getControllerVisual(e[1], "symbolSize", o)], u = this._createBarPoints(i, l);
      return {
        barColor: new rh(0, 0, 0, 1, s),
        barPoints: u,
        handlesColor: [s[0].color, s[s.length - 1].color]
      };
    }, r.prototype._makeColorGradient = function(e, n) {
      var i = 100, a = [], o = (e[1] - e[0]) / i;
      a.push({
        color: this.getControllerVisual(e[0], "color", n),
        offset: 0
      });
      for (var s = 1; s < i; s++) {
        var l = e[0] + o * s;
        if (l > e[1])
          break;
        a.push({
          color: this.getControllerVisual(l, "color", n),
          offset: s / i
        });
      }
      return a.push({
        color: this.getControllerVisual(e[1], "color", n),
        offset: 1
      }), a;
    }, r.prototype._createBarPoints = function(e, n) {
      var i = this.visualMapModel.itemSize;
      return [[i[0] - n[0], e[0]], [i[0], e[0]], [i[0], e[1]], [i[0] - n[1], e[1]]];
    }, r.prototype._createBarGroup = function(e) {
      var n = this._orient, i = this.visualMapModel.get("inverse");
      return new ze(n === "horizontal" && !i ? {
        scaleX: e === "bottom" ? 1 : -1,
        rotation: Math.PI / 2
      } : n === "horizontal" && i ? {
        scaleX: e === "bottom" ? -1 : 1,
        rotation: -Math.PI / 2
      } : n === "vertical" && !i ? {
        scaleX: e === "left" ? 1 : -1,
        scaleY: -1
      } : {
        scaleX: e === "left" ? 1 : -1
      });
    }, r.prototype._updateHandle = function(e, n) {
      if (this._useHandle) {
        var i = this._shapes, a = this.visualMapModel, o = i.handleThumbs, s = i.handleLabels, l = a.itemSize, u = a.getExtent();
        Vhe([0, 1], function(c) {
          var d = o[c];
          d.setStyle("fill", n.handlesColor[c]), d.y = e[c];
          var f = xo(e[c], [0, l[1]], u, !0), h = this.getControllerVisual(f, "symbolSize");
          d.scaleX = d.scaleY = h / l[0], d.x = l[0] - h / 2;
          var p = Ka(i.handleLabelPoints[c], Hl(d, this.group));
          s[c].setStyle({
            x: p[0],
            y: p[1],
            text: a.formatValueText(this._dataInterval[c]),
            verticalAlign: "middle",
            align: this._orient === "vertical" ? this._applyTransform("left", i.mainGroup) : "center"
          });
        }, this);
      }
    }, r.prototype._showIndicator = function(e, n, i, a) {
      var o = this.visualMapModel, s = o.getExtent(), l = o.itemSize, u = [0, l[1]], c = this._shapes, d = c.indicator;
      if (d) {
        d.attr("invisible", !1);
        var f = {
          convertOpacityToAlpha: !0
        }, h = this.getControllerVisual(e, "color", f), p = this.getControllerVisual(e, "symbolSize"), v = xo(e, s, u, !0), g = l[0] - p / 2, m = {
          x: d.x,
          y: d.y
        };
        d.y = v, d.x = g;
        var y = Ka(c.indicatorLabelPoint, Hl(d, this.group)), b = c.indicatorLabel;
        b.attr("invisible", !1);
        var C = this._applyTransform("left", c.mainGroup), w = this._orient, _ = w === "horizontal";
        b.setStyle({
          text: (i || "") + o.formatValueText(n),
          verticalAlign: _ ? C : "middle",
          align: _ ? "center" : C
        });
        var x = {
          x: g,
          y: v,
          style: {
            fill: h
          }
        }, I = {
          style: {
            x: y[0],
            y: y[1]
          }
        };
        if (o.ecModel.isAnimationEnabled() && !this._firstShowIndicator) {
          var D = {
            duration: 100,
            easing: "cubicInOut",
            additive: !0
          };
          d.x = m.x, d.y = m.y, d.animateTo(x, D), b.animateTo(I, D);
        } else
          d.attr(x), b.attr(I);
        this._firstShowIndicator = !1;
        var T = this._shapes.handleLabels;
        if (T)
          for (var A = 0; A < T.length; A++)
            this.api.enterBlur(T[A]);
      }
    }, r.prototype._enableHoverLinkToSeries = function() {
      var e = this;
      this._shapes.mainGroup.on("mousemove", function(n) {
        if (e._hovering = !0, !e._dragging) {
          var i = e.visualMapModel.itemSize, a = e._applyTransform([n.offsetX, n.offsetY], e._shapes.mainGroup, !0, !0);
          a[1] = vR(W3(0, a[1]), i[1]), e._doHoverLinkToSeries(a[1], 0 <= a[0] && a[0] <= i[0]);
        }
      }).on("mouseout", function() {
        e._hovering = !1, !e._dragging && e._clearHoverLinkToSeries();
      });
    }, r.prototype._enableHoverLinkFromSeries = function() {
      var e = this.api.getZr();
      this.visualMapModel.option.hoverLink ? (e.on("mouseover", this._hoverLinkFromSeriesMouseOver, this), e.on("mouseout", this._hideIndicator, this)) : this._clearHoverLinkFromSeries();
    }, r.prototype._doHoverLinkToSeries = function(e, n) {
      var i = this.visualMapModel, a = i.itemSize;
      if (i.option.hoverLink) {
        var o = [0, a[1]], s = i.getExtent();
        e = vR(W3(o[0], e), o[1]);
        var l = Hhe(i, s, o), u = [e - l, e + l], c = xo(e, o, s, !0), d = [xo(u[0], o, s, !0), xo(u[1], o, s, !0)];
        u[0] < o[0] && (d[0] = -1 / 0), u[1] > o[1] && (d[1] = 1 / 0), n && (d[0] === -1 / 0 ? this._showIndicator(c, d[1], "< ", l) : d[1] === 1 / 0 ? this._showIndicator(c, d[0], "> ", l) : this._showIndicator(c, c, "≈ ", l));
        var f = this._hoverLinkDataIndices, h = [];
        (n || mR(i)) && (h = this._hoverLinkDataIndices = i.findTargetDataIndices(d));
        var p = k$(f, h);
        this._dispatchHighDown("downplay", F0(p[0], i)), this._dispatchHighDown("highlight", F0(p[1], i));
      }
    }, r.prototype._hoverLinkFromSeriesMouseOver = function(e) {
      var n;
      if (hc(e.target, function(l) {
        var u = Ze(l);
        if (u.dataIndex != null)
          return n = u, !0;
      }, !0), !!n) {
        var i = this.ecModel.getSeriesByIndex(n.seriesIndex), a = this.visualMapModel;
        if (a.isTargetSeries(i)) {
          var o = i.getData(n.dataType), s = o.getStore().get(a.getDataDimensionIndex(o), n.dataIndex);
          isNaN(s) || this._showIndicator(s, s);
        }
      }
    }, r.prototype._hideIndicator = function() {
      var e = this._shapes;
      e.indicator && e.indicator.attr("invisible", !0), e.indicatorLabel && e.indicatorLabel.attr("invisible", !0);
      var n = this._shapes.handleLabels;
      if (n)
        for (var i = 0; i < n.length; i++)
          this.api.leaveBlur(n[i]);
    }, r.prototype._clearHoverLinkToSeries = function() {
      this._hideIndicator();
      var e = this._hoverLinkDataIndices;
      this._dispatchHighDown("downplay", F0(e, this.visualMapModel)), e.length = 0;
    }, r.prototype._clearHoverLinkFromSeries = function() {
      this._hideIndicator();
      var e = this.api.getZr();
      e.off("mouseover", this._hoverLinkFromSeriesMouseOver), e.off("mouseout", this._hideIndicator);
    }, r.prototype._applyTransform = function(e, n, i, a) {
      var o = Hl(n, a ? null : this.group);
      return ue(e) ? Ka(e, o, i) : f2(e, o, i);
    }, r.prototype._dispatchHighDown = function(e, n) {
      n && n.length && this.api.dispatchAction({
        type: e,
        batch: n
      });
    }, r.prototype.dispose = function() {
      this._clearHoverLinkFromSeries(), this._clearHoverLinkToSeries();
    }, r.type = "visualMap.continuous", r;
  }(oH)
);
function gR(t, r, e, n) {
  return new si({
    shape: {
      points: t
    },
    draggable: !!e,
    cursor: r,
    drift: e,
    onmousemove: function(i) {
      Ys(i.event);
    },
    ondragend: n
  });
}
function Hhe(t, r, e) {
  var n = Ghe / 2, i = t.get("hoverLinkDataSize");
  return i && (n = xo(i, r, e, !0) / 2), n;
}
function mR(t) {
  var r = t.get("hoverLinkOnHandle");
  return !!(r ?? t.get("realtime"));
}
function yR(t) {
  return t === "vertical" ? "ns-resize" : "ew-resize";
}
var zhe = {
  type: "selectDataRange",
  event: "dataRangeSelected",
  // FIXME use updateView appears wrong
  update: "update"
}, Whe = function(t, r) {
  r.eachComponent({
    mainType: "visualMap",
    query: t
  }, function(e) {
    e.setSelected(t.selected);
  });
}, Zhe = [
  {
    createOnAllSeries: !0,
    reset: function(t, r) {
      var e = [];
      return r.eachComponent("visualMap", function(n) {
        var i = t.pipelineContext;
        !n.isTargetSeries(t) || i && i.large || e.push(ffe(n.stateList, n.targetVisuals, ye(n.getValueState, n), n.getDataDimensionIndex(t.getData())));
      }), e;
    }
  },
  // Only support color.
  {
    createOnAllSeries: !0,
    reset: function(t, r) {
      var e = t.getData(), n = [];
      r.eachComponent("visualMap", function(i) {
        if (i.isTargetSeries(t)) {
          var a = i.getVisualMeta(ye(jhe, null, t, i)) || {
            stops: [],
            outerColors: []
          }, o = i.getDataDimensionIndex(e);
          o >= 0 && (a.dimension = o, n.push(a));
        }
      }), t.getData().setVisual("visualMeta", n);
    }
  }
];
function jhe(t, r, e, n) {
  for (var i = r.targetVisuals[n], a = _n.prepareVisualTypes(i), o = {
    color: bg(t.getData(), "color")
    // default color.
  }, s = 0, l = a.length; s < l; s++) {
    var u = a[s], c = i[u === "opacity" ? "__alphaForOpacity" : u];
    c && c.applyVisual(e, d, f);
  }
  return o.color;
  function d(h) {
    return o[h];
  }
  function f(h, p) {
    o[h] = p;
  }
}
var bR = L;
function Yhe(t) {
  var r = t && t.visualMap;
  ue(r) || (r = r ? [r] : []), bR(r, function(e) {
    if (e) {
      Ed(e, "splitList") && !Ed(e, "pieces") && (e.pieces = e.splitList, delete e.splitList);
      var n = e.pieces;
      n && ue(n) && bR(n, function(i) {
        Me(i) && (Ed(i, "start") && !Ed(i, "min") && (i.min = i.start), Ed(i, "end") && !Ed(i, "max") && (i.max = i.end));
      });
    }
  });
}
function Ed(t, r) {
  return t && t.hasOwnProperty && t.hasOwnProperty(r);
}
var CR = !1;
function lH(t) {
  CR || (CR = !0, t.registerSubTypeDefaulter("visualMap", function(r) {
    return !r.categories && (!(r.pieces ? r.pieces.length > 0 : r.splitNumber > 0) || r.calculable) ? "continuous" : "piecewise";
  }), t.registerAction(zhe, Whe), L(Zhe, function(r) {
    t.registerVisual(t.PRIORITY.VISUAL.COMPONENT, r);
  }), t.registerPreprocessor(Yhe));
}
function uH(t) {
  t.registerComponentModel(Ohe), t.registerComponentView(Fhe), lH(t);
}
var Xhe = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e._pieceList = [], e;
    }
    return r.prototype.optionUpdated = function(e, n) {
      t.prototype.optionUpdated.apply(this, arguments), this.resetExtent();
      var i = this._mode = this._determineMode();
      this._pieceList = [], $he[this._mode].call(this, this._pieceList), this._resetSelected(e, n);
      var a = this.option.categories;
      this.resetVisual(function(o, s) {
        i === "categories" ? (o.mappingMethod = "category", o.categories = Ge(a)) : (o.dataExtent = this.getExtent(), o.mappingMethod = "piecewise", o.pieceList = ce(this._pieceList, function(l) {
          return l = Ge(l), s !== "inRange" && (l.visual = null), l;
        }));
      });
    }, r.prototype.completeVisualOption = function() {
      var e = this.option, n = {}, i = _n.listVisualTypes(), a = this.isCategory();
      L(e.pieces, function(s) {
        L(i, function(l) {
          s.hasOwnProperty(l) && (n[l] = 1);
        });
      }), L(n, function(s, l) {
        var u = !1;
        L(this.stateList, function(c) {
          u = u || o(e, c, l) || o(e.target, c, l);
        }, this), !u && L(this.stateList, function(c) {
          (e[c] || (e[c] = {}))[l] = aH.get(l, c === "inRange" ? "active" : "inactive", a);
        });
      }, this);
      function o(s, l, u) {
        return s && s[l] && s[l].hasOwnProperty(u);
      }
      t.prototype.completeVisualOption.apply(this, arguments);
    }, r.prototype._resetSelected = function(e, n) {
      var i = this.option, a = this._pieceList, o = (n ? i : e).selected || {};
      if (i.selected = o, L(a, function(l, u) {
        var c = this.getSelectedMapKey(l);
        o.hasOwnProperty(c) || (o[c] = !0);
      }, this), i.selectedMode === "single") {
        var s = !1;
        L(a, function(l, u) {
          var c = this.getSelectedMapKey(l);
          o[c] && (s ? o[c] = !1 : s = !0);
        }, this);
      }
    }, r.prototype.getItemSymbol = function() {
      return this.get("itemSymbol");
    }, r.prototype.getSelectedMapKey = function(e) {
      return this._mode === "categories" ? e.value + "" : e.index + "";
    }, r.prototype.getPieceList = function() {
      return this._pieceList;
    }, r.prototype._determineMode = function() {
      var e = this.option;
      return e.pieces && e.pieces.length > 0 ? "pieces" : this.option.categories ? "categories" : "splitNumber";
    }, r.prototype.setSelected = function(e) {
      this.option.selected = Ge(e);
    }, r.prototype.getValueState = function(e) {
      var n = _n.findPieceIndex(e, this._pieceList);
      return n != null && this.option.selected[this.getSelectedMapKey(this._pieceList[n])] ? "inRange" : "outOfRange";
    }, r.prototype.findTargetDataIndices = function(e) {
      var n = [], i = this._pieceList;
      return this.eachTargetSeries(function(a) {
        var o = [], s = a.getData();
        s.each(this.getDataDimensionIndex(s), function(l, u) {
          var c = _n.findPieceIndex(l, i);
          c === e && o.push(u);
        }, this), n.push({
          seriesId: a.id,
          dataIndex: o
        });
      }, this), n;
    }, r.prototype.getRepresentValue = function(e) {
      var n;
      if (this.isCategory())
        n = e.value;
      else if (e.value != null)
        n = e.value;
      else {
        var i = e.interval || [];
        n = i[0] === -1 / 0 && i[1] === 1 / 0 ? 0 : (i[0] + i[1]) / 2;
      }
      return n;
    }, r.prototype.getVisualMeta = function(e) {
      if (this.isCategory())
        return;
      var n = [], i = ["", ""], a = this;
      function o(c, d) {
        var f = a.getRepresentValue({
          interval: c
        });
        d || (d = a.getValueState(f));
        var h = e(f, d);
        c[0] === -1 / 0 ? i[0] = h : c[1] === 1 / 0 ? i[1] = h : n.push({
          value: c[0],
          color: h
        }, {
          value: c[1],
          color: h
        });
      }
      var s = this._pieceList.slice();
      if (!s.length)
        s.push({
          interval: [-1 / 0, 1 / 0]
        });
      else {
        var l = s[0].interval[0];
        l !== -1 / 0 && s.unshift({
          interval: [-1 / 0, l]
        }), l = s[s.length - 1].interval[1], l !== 1 / 0 && s.push({
          interval: [l, 1 / 0]
        });
      }
      var u = -1 / 0;
      return L(s, function(c) {
        var d = c.interval;
        d && (d[0] > u && o([u, d[0]], "outOfRange"), o(d.slice()), u = d[1]);
      }, this), {
        stops: n,
        outerColors: i
      };
    }, r.type = "visualMap.piecewise", r.defaultOption = vu(iy.defaultOption, {
      selected: null,
      minOpen: !1,
      maxOpen: !1,
      align: "auto",
      itemWidth: 20,
      itemHeight: 14,
      itemSymbol: "roundRect",
      pieces: null,
      categories: null,
      splitNumber: 5,
      selectedMode: "multiple",
      itemGap: 10,
      hoverLink: !0
      // Enable hover highlight.
    }), r;
  }(iy)
), $he = {
  splitNumber: function(t) {
    var r = this.option, e = Math.min(r.precision, 20), n = this.getExtent(), i = r.splitNumber;
    i = Math.max(parseInt(i, 10), 1), r.splitNumber = i;
    for (var a = (n[1] - n[0]) / i; +a.toFixed(e) !== a && e < 5; )
      e++;
    r.precision = e, a = +a.toFixed(e), r.minOpen && t.push({
      interval: [-1 / 0, n[0]],
      close: [0, 0]
    });
    for (var o = 0, s = n[0]; o < i; s += a, o++) {
      var l = o === i - 1 ? n[1] : s + a;
      t.push({
        interval: [s, l],
        close: [1, 1]
      });
    }
    r.maxOpen && t.push({
      interval: [n[1], 1 / 0],
      close: [0, 0]
    }), GC(t), L(t, function(u, c) {
      u.index = c, u.text = this.formatValueText(u.interval);
    }, this);
  },
  categories: function(t) {
    var r = this.option;
    L(r.categories, function(e) {
      t.push({
        text: this.formatValueText(e, !0),
        value: e
      });
    }, this), wR(r, t);
  },
  pieces: function(t) {
    var r = this.option;
    L(r.pieces, function(e, n) {
      Me(e) || (e = {
        value: e
      });
      var i = {
        text: "",
        index: n
      };
      if (e.label != null && (i.text = e.label), e.hasOwnProperty("value")) {
        var a = i.value = e.value;
        i.interval = [a, a], i.close = [1, 1];
      } else {
        for (var o = i.interval = [], s = i.close = [0, 0], l = [1, 0, 1], u = [-1 / 0, 1 / 0], c = [], d = 0; d < 2; d++) {
          for (var f = [["gte", "gt", "min"], ["lte", "lt", "max"]][d], h = 0; h < 3 && o[d] == null; h++)
            o[d] = e[f[h]], s[d] = l[h], c[d] = h === 2;
          o[d] == null && (o[d] = u[d]);
        }
        c[0] && o[1] === 1 / 0 && (s[0] = 0), c[1] && o[0] === -1 / 0 && (s[1] = 0), process.env.NODE_ENV !== "production" && o[0] > o[1] && console.warn("Piece " + n + "is illegal: " + o + " lower bound should not greater then uppper bound."), o[0] === o[1] && s[0] && s[1] && (i.value = o[0]);
      }
      i.visual = _n.retrieveVisuals(e), t.push(i);
    }, this), wR(r, t), GC(t), L(t, function(e) {
      var n = e.close, i = [["<", "≤"][n[1]], [">", "≥"][n[0]]];
      e.text = e.text || this.formatValueText(e.value != null ? e.value : e.interval, !1, i);
    }, this);
  }
};
function wR(t, r) {
  var e = t.inverse;
  (t.orient === "vertical" ? !e : e) && r.reverse();
}
var Uhe = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = r.type, e;
    }
    return r.prototype.doRender = function() {
      var e = this.group;
      e.removeAll();
      var n = this.visualMapModel, i = n.get("textGap"), a = n.textStyleModel, o = a.getFont(), s = a.getTextColor(), l = this._getItemAlign(), u = n.itemSize, c = this._getViewData(), d = c.endsText, f = Qr(n.get("showLabel", !0), !d);
      d && this._renderEndsText(e, d[0], u, f, l), L(c.viewPieceList, function(h) {
        var p = h.piece, v = new ze();
        v.onclick = ye(this._onItemClick, this, p), this._enableHoverLink(v, h.indexInModelPieceList);
        var g = n.getRepresentValue(p);
        if (this._createItemSymbol(v, g, [0, 0, u[0], u[1]]), f) {
          var m = this.visualMapModel.getValueState(g);
          v.add(new _t({
            style: {
              x: l === "right" ? -i : u[0] + i,
              y: u[1] / 2,
              text: p.text,
              verticalAlign: "middle",
              align: l,
              font: o,
              fill: s,
              opacity: m === "outOfRange" ? 0.5 : 1
            }
          }));
        }
        e.add(v);
      }, this), d && this._renderEndsText(e, d[1], u, f, l), Ic(n.get("orient"), e, n.get("itemGap")), this.renderBackground(e), this.positionGroup(e);
    }, r.prototype._enableHoverLink = function(e, n) {
      var i = this;
      e.on("mouseover", function() {
        return a("highlight");
      }).on("mouseout", function() {
        return a("downplay");
      });
      var a = function(o) {
        var s = i.visualMapModel;
        s.option.hoverLink && i.api.dispatchAction({
          type: o,
          batch: F0(s.findTargetDataIndices(n), s)
        });
      };
    }, r.prototype._getItemAlign = function() {
      var e = this.visualMapModel, n = e.option;
      if (n.orient === "vertical")
        return sH(e, this.api, e.itemSize);
      var i = n.align;
      return (!i || i === "auto") && (i = "left"), i;
    }, r.prototype._renderEndsText = function(e, n, i, a, o) {
      if (n) {
        var s = new ze(), l = this.visualMapModel.textStyleModel;
        s.add(new _t({
          style: fr(l, {
            x: a ? o === "right" ? i[0] : 0 : i[0] / 2,
            y: i[1] / 2,
            verticalAlign: "middle",
            align: a ? o : "center",
            text: n
          })
        })), e.add(s);
      }
    }, r.prototype._getViewData = function() {
      var e = this.visualMapModel, n = ce(e.getPieceList(), function(s, l) {
        return {
          piece: s,
          indexInModelPieceList: l
        };
      }), i = e.get("text"), a = e.get("orient"), o = e.get("inverse");
      return (a === "horizontal" ? o : !o) ? n.reverse() : i && (i = i.slice().reverse()), {
        viewPieceList: n,
        endsText: i
      };
    }, r.prototype._createItemSymbol = function(e, n, i) {
      e.add(en(
        // symbol will be string
        this.getControllerVisual(n, "symbol"),
        i[0],
        i[1],
        i[2],
        i[3],
        // color will be string
        this.getControllerVisual(n, "color")
      ));
    }, r.prototype._onItemClick = function(e) {
      var n = this.visualMapModel, i = n.option, a = i.selectedMode;
      if (a) {
        var o = Ge(i.selected), s = n.getSelectedMapKey(e);
        a === "single" || a === !0 ? (o[s] = !0, L(o, function(l, u) {
          o[u] = u === s;
        })) : o[s] = !o[s], this.api.dispatchAction({
          type: "selectDataRange",
          from: this.uid,
          visualMapId: this.visualMapModel.id,
          selected: o
        });
      }
    }, r.type = "visualMap.piecewise", r;
  }(oH)
);
function cH(t) {
  t.registerComponentModel(Xhe), t.registerComponentView(Uhe), lH(t);
}
function Jhe(t) {
  lt(uH), lt(cH);
}
var Khe = {
  label: {
    enabled: !0
  },
  decal: {
    show: !1
  }
}, _R = It(), qhe = {};
function Qhe(t, r) {
  var e = t.getModel("aria");
  if (!e.get("enabled"))
    return;
  var n = Ge(Khe);
  Qe(n.label, t.getLocaleModel().get("aria"), !1), Qe(e.option, n, !1), i(), a();
  function i() {
    var u = e.getModel("decal"), c = u.get("show");
    if (c) {
      var d = xe();
      t.eachSeries(function(f) {
        if (!f.isColorBySeries()) {
          var h = d.get(f.type);
          h || (h = {}, d.set(f.type, h)), _R(f).scope = h;
        }
      }), t.eachRawSeries(function(f) {
        if (t.isSeriesFiltered(f))
          return;
        if (Ae(f.enableAriaDecal)) {
          f.enableAriaDecal();
          return;
        }
        var h = f.getData();
        if (f.isColorBySeries()) {
          var y = t9(f.ecModel, f.name, qhe, t.getSeriesCount()), b = h.getVisual("decal");
          h.setVisual("decal", C(b, y));
        } else {
          var p = f.getRawData(), v = {}, g = _R(f).scope;
          h.each(function(w) {
            var _ = h.getRawIndex(w);
            v[_] = w;
          });
          var m = p.count();
          p.each(function(w) {
            var _ = v[w], x = p.getName(w) || w + "", I = t9(f.ecModel, x, g, m), D = h.getItemVisual(_, "decal");
            h.setItemVisual(_, "decal", C(D, I));
          });
        }
        function C(w, _) {
          var x = w ? ae(ae({}, _), w) : _;
          return x.dirty = !0, x;
        }
      });
    }
  }
  function a() {
    var u = r.getZr().dom;
    if (u) {
      var c = t.getLocaleModel().get("aria"), d = e.getModel("label");
      if (d.option = Ee(d.option, c), !!d.get("enabled")) {
        if (d.get("description")) {
          u.setAttribute("aria-label", d.get("description"));
          return;
        }
        var f = t.getSeriesCount(), h = d.get(["data", "maxCount"]) || 10, p = d.get(["series", "maxCount"]) || 10, v = Math.min(f, p), g;
        if (!(f < 1)) {
          var m = s();
          if (m) {
            var y = d.get(["general", "withTitle"]);
            g = o(y, {
              title: m
            });
          } else
            g = d.get(["general", "withoutTitle"]);
          var b = [], C = f > 1 ? d.get(["series", "multiple", "prefix"]) : d.get(["series", "single", "prefix"]);
          g += o(C, {
            seriesCount: f
          }), t.eachSeries(function(I, D) {
            if (D < v) {
              var T = void 0, A = I.get("name"), M = A ? "withName" : "withoutName";
              T = f > 1 ? d.get(["series", "multiple", M]) : d.get(["series", "single", M]), T = o(T, {
                seriesId: I.seriesIndex,
                seriesName: I.get("name"),
                seriesType: l(I.subType)
              });
              var R = I.getData();
              if (R.count() > h) {
                var E = d.get(["data", "partialData"]);
                T += o(E, {
                  displayCnt: h
                });
              } else
                T += d.get(["data", "allData"]);
              for (var k = d.get(["data", "separator", "middle"]), P = d.get(["data", "separator", "end"]), N = [], O = 0; O < R.count(); O++)
                if (O < h) {
                  var W = R.getName(O), V = R.getValues(O), B = d.get(["data", W ? "withName" : "withoutName"]);
                  N.push(o(B, {
                    name: W,
                    value: V.join(k)
                  }));
                }
              T += N.join(k) + P, b.push(T);
            }
          });
          var w = d.getModel(["series", "multiple", "separator"]), _ = w.get("middle"), x = w.get("end");
          g += b.join(_) + x, u.setAttribute("aria-label", g);
        }
      }
    }
  }
  function o(u, c) {
    if (!pe(u))
      return u;
    var d = u;
    return L(c, function(f, h) {
      d = d.replace(new RegExp("\\{\\s*" + h + "\\s*\\}", "g"), f);
    }), d;
  }
  function s() {
    var u = t.get("title");
    return u && u.length && (u = u[0]), u && u.text;
  }
  function l(u) {
    var c = t.getLocaleModel().get(["series", "typeNames"]);
    return c[u] || c.chart;
  }
}
function epe(t) {
  if (!(!t || !t.aria)) {
    var r = t.aria;
    r.show != null && (r.enabled = r.show), r.label = r.label || {}, L(["description", "general", "series", "data"], function(e) {
      r[e] != null && (r.label[e] = r[e]);
    });
  }
}
function tpe(t) {
  t.registerPreprocessor(epe), t.registerVisual(t.PRIORITY.VISUAL.ARIA, Qhe);
}
var xR = {
  value: "eq",
  // PENDING: not good for literal semantic?
  "<": "lt",
  "<=": "lte",
  ">": "gt",
  ">=": "gte",
  "=": "eq",
  "!=": "ne",
  "<>": "ne"
  // Might be misleading for sake of the difference between '==' and '===',
  // so don't support them.
  // '==': 'eq',
  // '===': 'seq',
  // '!==': 'sne'
  // PENDING: Whether support some common alias "ge", "le", "neq"?
  // ge: 'gte',
  // le: 'lte',
  // neq: 'ne',
}, rpe = (
  /** @class */
  function() {
    function t(r) {
      var e = this._condVal = pe(r) ? new RegExp(r) : _7(r) ? r : null;
      if (e == null) {
        var n = "";
        process.env.NODE_ENV !== "production" && (n = _i("Illegal regexp", r, "in")), Gt(n);
      }
    }
    return t.prototype.evaluate = function(r) {
      var e = typeof r;
      return pe(e) ? this._condVal.test(r) : Mt(e) ? this._condVal.test(r + "") : !1;
    }, t;
  }()
), npe = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.evaluate = function() {
      return this.value;
    }, t;
  }()
), ipe = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.evaluate = function() {
      for (var r = this.children, e = 0; e < r.length; e++)
        if (!r[e].evaluate())
          return !1;
      return !0;
    }, t;
  }()
), ape = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.evaluate = function() {
      for (var r = this.children, e = 0; e < r.length; e++)
        if (r[e].evaluate())
          return !0;
      return !1;
    }, t;
  }()
), ope = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.evaluate = function() {
      return !this.child.evaluate();
    }, t;
  }()
), spe = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.evaluate = function() {
      for (var r = !!this.valueParser, e = this.getValue, n = e(this.valueGetterParam), i = r ? this.valueParser(n) : null, a = 0; a < this.subCondList.length; a++)
        if (!this.subCondList[a].evaluate(r ? i : n))
          return !1;
      return !0;
    }, t;
  }()
);
function N_(t, r) {
  if (t === !0 || t === !1) {
    var e = new npe();
    return e.value = t, e;
  }
  var n = "";
  return dH(t) || (process.env.NODE_ENV !== "production" && (n = _i("Illegal config. Expect a plain object but actually", t)), Gt(n)), t.and ? SR("and", t, r) : t.or ? SR("or", t, r) : t.not ? lpe(t, r) : upe(t, r);
}
function SR(t, r, e) {
  var n = r[t], i = "";
  process.env.NODE_ENV !== "production" && (i = _i('"and"/"or" condition should only be `' + t + ": [...]` and must not be empty array.", "Illegal condition:", r)), ue(n) || Gt(i), n.length || Gt(i);
  var a = t === "and" ? new ipe() : new ape();
  return a.children = ce(n, function(o) {
    return N_(o, e);
  }), a.children.length || Gt(i), a;
}
function lpe(t, r) {
  var e = t.not, n = "";
  process.env.NODE_ENV !== "production" && (n = _i('"not" condition should only be `not: {}`.', "Illegal condition:", t)), dH(e) || Gt(n);
  var i = new ope();
  return i.child = N_(e, r), i.child || Gt(n), i;
}
function upe(t, r) {
  for (var e = "", n = r.prepareGetValue(t), i = [], a = yt(t), o = t.parser, s = o ? ZO(o) : null, l = 0; l < a.length; l++) {
    var u = a[l];
    if (!(u === "parser" || r.valueGetterAttrMap.get(u))) {
      var c = be(xR, u) ? xR[u] : u, d = t[u], f = s ? s(d) : d, h = NK(c, f) || c === "reg" && new rpe(f);
      h || (process.env.NODE_ENV !== "production" && (e = _i('Illegal relational operation: "' + u + '" in condition:', t)), Gt(e)), i.push(h);
    }
  }
  i.length || (process.env.NODE_ENV !== "production" && (e = _i("Relational condition must have at least one operator.", "Illegal condition:", t)), Gt(e));
  var p = new spe();
  return p.valueGetterParam = n, p.valueParser = s, p.getValue = r.getValue, p.subCondList = i, p;
}
function dH(t) {
  return Me(t) && !Zn(t);
}
var cpe = (
  /** @class */
  function() {
    function t(r, e) {
      this._cond = N_(r, e);
    }
    return t.prototype.evaluate = function() {
      return this._cond.evaluate();
    }, t;
  }()
);
function dpe(t, r) {
  return new cpe(t, r);
}
var fpe = {
  type: "echarts:filter",
  // PENDING: enhance to filter by index rather than create new data
  transform: function(t) {
    for (var r = t.upstream, e, n = dpe(t.config, {
      valueGetterAttrMap: xe({
        dimension: !0
      }),
      prepareGetValue: function(s) {
        var l = "", u = s.dimension;
        be(s, "dimension") || (process.env.NODE_ENV !== "production" && (l = _i('Relation condition must has prop "dimension" specified.', "Illegal condition:", s)), Gt(l));
        var c = r.getDimensionInfo(u);
        return c || (process.env.NODE_ENV !== "production" && (l = _i("Can not find dimension info via: " + u + `.
`, "Existing dimensions: ", r.cloneAllDimensionInfo(), `.
`, "Illegal condition:", s, `.
`)), Gt(l)), {
          dimIdx: c.index
        };
      },
      getValue: function(s) {
        return r.retrieveValueFromItem(e, s.dimIdx);
      }
    }), i = [], a = 0, o = r.count(); a < o; a++)
      e = r.getRawDataItem(a), n.evaluate() && i.push(e);
    return {
      data: i
    };
  }
}, r6 = "";
process.env.NODE_ENV !== "production" && (r6 = ["Valid config is like:", '{ dimension: "age", order: "asc" }', 'or [{ dimension: "age", order: "asc"], { dimension: "date", order: "desc" }]'].join(" "));
var hpe = {
  type: "echarts:sort",
  transform: function(t) {
    var r = t.upstream, e = t.config, n = "", i = Qt(e);
    i.length || (process.env.NODE_ENV !== "production" && (n = "Empty `config` in sort transform."), Gt(n));
    var a = [];
    L(i, function(c) {
      var d = c.dimension, f = c.order, h = c.parser, p = c.incomparable;
      if (d == null && (process.env.NODE_ENV !== "production" && (n = 'Sort transform config must has "dimension" specified.' + r6), Gt(n)), f !== "asc" && f !== "desc" && (process.env.NODE_ENV !== "production" && (n = 'Sort transform config must has "order" specified.' + r6), Gt(n)), p && p !== "min" && p !== "max") {
        var v = "";
        process.env.NODE_ENV !== "production" && (v = 'incomparable must be "min" or "max" rather than "' + p + '".'), Gt(v);
      }
      if (f !== "asc" && f !== "desc") {
        var g = "";
        process.env.NODE_ENV !== "production" && (g = 'order must be "asc" or "desc" rather than "' + f + '".'), Gt(g);
      }
      var m = r.getDimensionInfo(d);
      m || (process.env.NODE_ENV !== "production" && (n = _i("Can not find dimension info via: " + d + `.
`, "Existing dimensions: ", r.cloneAllDimensionInfo(), `.
`, "Illegal config:", c, `.
`)), Gt(n));
      var y = h ? ZO(h) : null;
      h && !y && (process.env.NODE_ENV !== "production" && (n = _i("Invalid parser name " + h + `.
`, "Illegal config:", c, `.
`)), Gt(n)), a.push({
        dimIdx: m.index,
        parser: y,
        comparator: new YO(f, p)
      });
    });
    var o = r.sourceFormat;
    o !== li && o !== Oa && (process.env.NODE_ENV !== "production" && (n = 'sourceFormat "' + o + '" is not supported yet'), Gt(n));
    for (var s = [], l = 0, u = r.count(); l < u; l++)
      s.push(r.getRawDataItem(l));
    return s.sort(function(c, d) {
      for (var f = 0; f < a.length; f++) {
        var h = a[f], p = r.retrieveValueFromItem(c, h.dimIdx), v = r.retrieveValueFromItem(d, h.dimIdx);
        h.parser && (p = h.parser(p), v = h.parser(v));
        var g = h.comparator.evaluate(p, v);
        if (g !== 0)
          return g;
      }
      return 0;
    }), {
      data: s
    };
  }
};
function ppe(t) {
  t.registerTransform(fpe), t.registerTransform(hpe);
}
var vpe = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = "dataset", e;
    }
    return r.prototype.init = function(e, n, i) {
      t.prototype.init.call(this, e, n, i), this._sourceManager = new JO(this), II(this);
    }, r.prototype.mergeOption = function(e, n) {
      t.prototype.mergeOption.call(this, e, n), II(this);
    }, r.prototype.optionUpdated = function() {
      this._sourceManager.dirty();
    }, r.prototype.getSourceManager = function() {
      return this._sourceManager;
    }, r.type = "dataset", r.defaultOption = {
      seriesLayoutBy: Wo
    }, r;
  }(st)
), gpe = (
  /** @class */
  function(t) {
    ee(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.type = "dataset", e;
    }
    return r.type = "dataset", r;
  }(yr)
);
function mpe(t) {
  t.registerComponentModel(vpe), t.registerComponentView(gpe);
}
var wo = Qo.CMD;
function qd(t, r) {
  return Math.abs(t - r) < 1e-5;
}
function n6(t) {
  var r = t.data, e = t.len(), n = [], i, a = 0, o = 0, s = 0, l = 0;
  function u(R, E) {
    i && i.length > 2 && n.push(i), i = [R, E];
  }
  function c(R, E, k, P) {
    qd(R, k) && qd(E, P) || i.push(R, E, k, P, k, P);
  }
  function d(R, E, k, P, N, O) {
    var W = Math.abs(E - R), V = Math.tan(W / 4) * 4 / 3, B = E < R ? -1 : 1, Z = Math.cos(R), q = Math.sin(R), z = Math.cos(E), U = Math.sin(E), J = Z * N + k, K = q * O + P, j = z * N + k, oe = U * O + P, ie = N * V * B, le = O * V * B;
    i.push(J - ie * q, K + le * Z, j + ie * U, oe - le * z, j, oe);
  }
  for (var f, h, p, v, g = 0; g < e; ) {
    var m = r[g++], y = g === 1;
    switch (y && (a = r[g], o = r[g + 1], s = a, l = o, (m === wo.L || m === wo.C || m === wo.Q) && (i = [s, l])), m) {
      case wo.M:
        a = s = r[g++], o = l = r[g++], u(s, l);
        break;
      case wo.L:
        f = r[g++], h = r[g++], c(a, o, f, h), a = f, o = h;
        break;
      case wo.C:
        i.push(r[g++], r[g++], r[g++], r[g++], a = r[g++], o = r[g++]);
        break;
      case wo.Q:
        f = r[g++], h = r[g++], p = r[g++], v = r[g++], i.push(a + 2 / 3 * (f - a), o + 2 / 3 * (h - o), p + 2 / 3 * (f - p), v + 2 / 3 * (h - v), p, v), a = p, o = v;
        break;
      case wo.A:
        var b = r[g++], C = r[g++], w = r[g++], _ = r[g++], x = r[g++], I = r[g++] + x;
        g += 1;
        var D = !r[g++];
        f = Math.cos(x) * w + b, h = Math.sin(x) * _ + C, y ? (s = f, l = h, u(s, l)) : c(a, o, f, h), a = Math.cos(I) * w + b, o = Math.sin(I) * _ + C;
        for (var T = (D ? -1 : 1) * Math.PI / 2, A = x; D ? A > I : A < I; A += T) {
          var M = D ? Math.max(A + T, I) : Math.min(A + T, I);
          d(A, M, b, C, w, _);
        }
        break;
      case wo.R:
        s = a = r[g++], l = o = r[g++], f = s + r[g++], h = l + r[g++], u(f, l), c(f, l, f, h), c(f, h, s, h), c(s, h, s, l), c(s, l, f, l);
        break;
      case wo.Z:
        i && c(a, o, s, l), a = s, o = l;
        break;
    }
  }
  return i && i.length > 2 && n.push(i), n;
}
function i6(t, r, e, n, i, a, o, s, l, u) {
  if (qd(t, e) && qd(r, n) && qd(i, o) && qd(a, s)) {
    l.push(o, s);
    return;
  }
  var c = 2 / u, d = c * c, f = o - t, h = s - r, p = Math.sqrt(f * f + h * h);
  f /= p, h /= p;
  var v = e - t, g = n - r, m = i - o, y = a - s, b = v * v + g * g, C = m * m + y * y;
  if (b < d && C < d) {
    l.push(o, s);
    return;
  }
  var w = f * v + h * g, _ = -f * m - h * y, x = b - w * w, I = C - _ * _;
  if (x < d && w >= 0 && I < d && _ >= 0) {
    l.push(o, s);
    return;
  }
  var D = [], T = [];
  Ql(t, e, i, o, 0.5, D), Ql(r, n, a, s, 0.5, T), i6(D[0], T[0], D[1], T[1], D[2], T[2], D[3], T[3], l, u), i6(D[4], T[4], D[5], T[5], D[6], T[6], D[7], T[7], l, u);
}
function ype(t, r) {
  var e = n6(t), n = [];
  r = r || 1;
  for (var i = 0; i < e.length; i++) {
    var a = e[i], o = [], s = a[0], l = a[1];
    o.push(s, l);
    for (var u = 2; u < a.length; ) {
      var c = a[u++], d = a[u++], f = a[u++], h = a[u++], p = a[u++], v = a[u++];
      i6(s, l, c, d, f, h, p, v, o, r), s = p, l = v;
    }
    n.push(o);
  }
  return n;
}
function fH(t, r, e) {
  var n = t[r], i = t[1 - r], a = Math.abs(n / i), o = Math.ceil(Math.sqrt(a * e)), s = Math.floor(e / o);
  s === 0 && (s = 1, o = e);
  for (var l = [], u = 0; u < o; u++)
    l.push(s);
  var c = o * s, d = e - c;
  if (d > 0)
    for (var u = 0; u < d; u++)
      l[u % o] += 1;
  return l;
}
function IR(t, r, e) {
  for (var n = t.r0, i = t.r, a = t.startAngle, o = t.endAngle, s = Math.abs(o - a), l = s * i, u = i - n, c = l > Math.abs(u), d = fH([l, u], c ? 0 : 1, r), f = (c ? s : u) / d.length, h = 0; h < d.length; h++)
    for (var p = (c ? u : s) / d[h], v = 0; v < d[h]; v++) {
      var g = {};
      c ? (g.startAngle = a + f * h, g.endAngle = a + f * (h + 1), g.r0 = n + p * v, g.r = n + p * (v + 1)) : (g.startAngle = a + p * v, g.endAngle = a + p * (v + 1), g.r0 = n + f * h, g.r = n + f * (h + 1)), g.clockwise = t.clockwise, g.cx = t.cx, g.cy = t.cy, e.push(g);
    }
}
function bpe(t, r, e) {
  for (var n = t.width, i = t.height, a = n > i, o = fH([n, i], a ? 0 : 1, r), s = a ? "width" : "height", l = a ? "height" : "width", u = a ? "x" : "y", c = a ? "y" : "x", d = t[s] / o.length, f = 0; f < o.length; f++)
    for (var h = t[l] / o[f], p = 0; p < o[f]; p++) {
      var v = {};
      v[u] = f * d, v[c] = p * h, v[s] = d, v[l] = h, v.x += t.x, v.y += t.y, e.push(v);
    }
}
function AR(t, r, e, n) {
  return t * n - e * r;
}
function Cpe(t, r, e, n, i, a, o, s) {
  var l = e - t, u = n - r, c = o - i, d = s - a, f = AR(c, d, l, u);
  if (Math.abs(f) < 1e-6)
    return null;
  var h = t - i, p = r - a, v = AR(h, p, c, d) / f;
  return v < 0 || v > 1 ? null : new tt(v * l + t, v * u + r);
}
function wpe(t, r, e) {
  var n = new tt();
  tt.sub(n, e, r), n.normalize();
  var i = new tt();
  tt.sub(i, t, r);
  var a = i.dot(n);
  return a;
}
function kd(t, r) {
  var e = t[t.length - 1];
  e && e[0] === r[0] && e[1] === r[1] || t.push(r);
}
function _pe(t, r, e) {
  for (var n = t.length, i = [], a = 0; a < n; a++) {
    var o = t[a], s = t[(a + 1) % n], l = Cpe(o[0], o[1], s[0], s[1], r.x, r.y, e.x, e.y);
    l && i.push({
      projPt: wpe(l, r, e),
      pt: l,
      idx: a
    });
  }
  if (i.length < 2)
    return [{ points: t }, { points: t }];
  i.sort(function(g, m) {
    return g.projPt - m.projPt;
  });
  var u = i[0], c = i[i.length - 1];
  if (c.idx < u.idx) {
    var d = u;
    u = c, c = d;
  }
  for (var f = [u.pt.x, u.pt.y], h = [c.pt.x, c.pt.y], p = [f], v = [h], a = u.idx + 1; a <= c.idx; a++)
    kd(p, t[a].slice());
  kd(p, h), kd(p, f);
  for (var a = c.idx + 1; a <= u.idx + n; a++)
    kd(v, t[a % n].slice());
  return kd(v, f), kd(v, h), [{
    points: p
  }, {
    points: v
  }];
}
function DR(t) {
  var r = t.points, e = [], n = [];
  s2(r, e, n);
  var i = new rt(e[0], e[1], n[0] - e[0], n[1] - e[1]), a = i.width, o = i.height, s = i.x, l = i.y, u = new tt(), c = new tt();
  return a > o ? (u.x = c.x = s + a / 2, u.y = l, c.y = l + o) : (u.y = c.y = l + o / 2, u.x = s, c.x = s + a), _pe(r, u, c);
}
function ay(t, r, e, n) {
  if (e === 1)
    n.push(r);
  else {
    var i = Math.floor(e / 2), a = t(r);
    ay(t, a[0], i, n), ay(t, a[1], e - i, n);
  }
  return n;
}
function xpe(t, r) {
  for (var e = [], n = 0; n < r; n++)
    e.push(W7(t));
  return e;
}
function Spe(t, r) {
  r.setStyle(t.style), r.z = t.z, r.z2 = t.z2, r.zlevel = t.zlevel;
}
function Ipe(t) {
  for (var r = [], e = 0; e < t.length; )
    r.push([t[e++], t[e++]]);
  return r;
}
function Ape(t, r) {
  var e = [], n = t.shape, i;
  switch (t.type) {
    case "rect":
      bpe(n, r, e), i = xt;
      break;
    case "sector":
      IR(n, r, e), i = oi;
      break;
    case "circle":
      IR({
        r0: 0,
        r: n.r,
        startAngle: 0,
        endAngle: Math.PI * 2,
        cx: n.cx,
        cy: n.cy
      }, r, e), i = oi;
      break;
    default:
      var a = t.getComputedTransform(), o = a ? Math.sqrt(Math.max(a[0] * a[0] + a[1] * a[1], a[2] * a[2] + a[3] * a[3])) : 1, s = ce(ype(t.getUpdatedPathProxy(), o), function(m) {
        return Ipe(m);
      }), l = s.length;
      if (l === 0)
        ay(DR, {
          points: s[0]
        }, r, e);
      else if (l === r)
        for (var u = 0; u < l; u++)
          e.push({
            points: s[u]
          });
      else {
        var c = 0, d = ce(s, function(m) {
          var y = [], b = [];
          s2(m, y, b);
          var C = (b[1] - y[1]) * (b[0] - y[0]);
          return c += C, { poly: m, area: C };
        });
        d.sort(function(m, y) {
          return y.area - m.area;
        });
        for (var f = r, u = 0; u < l; u++) {
          var h = d[u];
          if (f <= 0)
            break;
          var p = u === l - 1 ? f : Math.ceil(h.area / c * r);
          p < 0 || (ay(DR, {
            points: h.poly
          }, p, e), f -= p);
        }
      }
      i = si;
      break;
  }
  if (!i)
    return xpe(t, r);
  for (var v = [], u = 0; u < e.length; u++) {
    var g = new i();
    g.setShape(e[u]), Spe(t, g), v.push(g);
  }
  return v;
}
function Dpe(t, r) {
  var e = t.length, n = r.length;
  if (e === n)
    return [t, r];
  for (var i = [], a = [], o = e < n ? t : r, s = Math.min(e, n), l = Math.abs(n - e) / 6, u = (s - 2) / 6, c = Math.ceil(l / u) + 1, d = [o[0], o[1]], f = l, h = 2; h < s; ) {
    var p = o[h - 2], v = o[h - 1], g = o[h++], m = o[h++], y = o[h++], b = o[h++], C = o[h++], w = o[h++];
    if (f <= 0) {
      d.push(g, m, y, b, C, w);
      continue;
    }
    for (var _ = Math.min(f, c - 1) + 1, x = 1; x <= _; x++) {
      var I = x / _;
      Ql(p, g, y, C, I, i), Ql(v, m, b, w, I, a), p = i[3], v = a[3], d.push(i[1], a[1], i[2], a[2], p, v), g = i[5], m = a[5], y = i[6], b = a[6];
    }
    f -= _ - 1;
  }
  return o === t ? [d, r] : [t, d];
}
function TR(t, r) {
  for (var e = t.length, n = t[e - 2], i = t[e - 1], a = [], o = 0; o < r.length; )
    a[o++] = n, a[o++] = i;
  return a;
}
function Tpe(t, r) {
  for (var e, n, i, a = [], o = [], s = 0; s < Math.max(t.length, r.length); s++) {
    var l = t[s], u = r[s], c = void 0, d = void 0;
    l ? u ? (e = Dpe(l, u), c = e[0], d = e[1], n = c, i = d) : (d = TR(i || l, l), c = l) : (c = TR(n || u, u), d = u), a.push(c), o.push(d);
  }
  return [a, o];
}
function MR(t) {
  for (var r = 0, e = 0, n = 0, i = t.length, a = 0, o = i - 2; a < i; o = a, a += 2) {
    var s = t[o], l = t[o + 1], u = t[a], c = t[a + 1], d = s * c - u * l;
    r += d, e += (s + u) * d, n += (l + c) * d;
  }
  return r === 0 ? [t[0] || 0, t[1] || 0] : [e / r / 3, n / r / 3, r];
}
function Mpe(t, r, e, n) {
  for (var i = (t.length - 2) / 6, a = 1 / 0, o = 0, s = t.length, l = s - 2, u = 0; u < i; u++) {
    for (var c = u * 6, d = 0, f = 0; f < s; f += 2) {
      var h = f === 0 ? c : (c + f - 2) % l + 2, p = t[h] - e[0], v = t[h + 1] - e[1], g = r[f] - n[0], m = r[f + 1] - n[1], y = g - p, b = m - v;
      d += y * y + b * b;
    }
    d < a && (a = d, o = u);
  }
  return o;
}
function Rpe(t) {
  for (var r = [], e = t.length, n = 0; n < e; n += 2)
    r[n] = t[e - n - 2], r[n + 1] = t[e - n - 1];
  return r;
}
function Lpe(t, r, e, n) {
  for (var i = [], a, o = 0; o < t.length; o++) {
    var s = t[o], l = r[o], u = MR(s), c = MR(l);
    a == null && (a = u[2] < 0 != c[2] < 0);
    var d = [], f = [], h = 0, p = 1 / 0, v = [], g = s.length;
    a && (s = Rpe(s));
    for (var m = Mpe(s, l, u, c) * 6, y = g - 2, b = 0; b < y; b += 2) {
      var C = (m + b) % y + 2;
      d[b + 2] = s[C] - u[0], d[b + 3] = s[C + 1] - u[1];
    }
    d[0] = s[m] - u[0], d[1] = s[m + 1] - u[1];
    for (var w = n / e, _ = -n / 2; _ <= n / 2; _ += w) {
      for (var x = Math.sin(_), I = Math.cos(_), D = 0, b = 0; b < s.length; b += 2) {
        var T = d[b], A = d[b + 1], M = l[b] - c[0], R = l[b + 1] - c[1], E = M * I - R * x, k = M * x + R * I;
        v[b] = E, v[b + 1] = k;
        var P = E - T, N = k - A;
        D += P * P + N * N;
      }
      if (D < p) {
        p = D, h = _;
        for (var O = 0; O < v.length; O++)
          f[O] = v[O];
      }
    }
    i.push({
      from: d,
      to: f,
      fromCp: u,
      toCp: c,
      rotation: -h
    });
  }
  return i;
}
function oy(t) {
  return t.__isCombineMorphing;
}
var hH = "__mOriginal_";
function sy(t, r, e) {
  var n = hH + r, i = t[n] || t[r];
  t[n] || (t[n] = t[r]);
  var a = e.replace, o = e.after, s = e.before;
  t[r] = function() {
    var l = arguments, u;
    return s && s.apply(this, l), a ? u = a.apply(this, l) : u = i.apply(this, l), o && o.apply(this, l), u;
  };
}
function iv(t, r) {
  var e = hH + r;
  t[e] && (t[r] = t[e], t[e] = null);
}
function RR(t, r) {
  for (var e = 0; e < t.length; e++)
    for (var n = t[e], i = 0; i < n.length; ) {
      var a = n[i], o = n[i + 1];
      n[i++] = r[0] * a + r[2] * o + r[4], n[i++] = r[1] * a + r[3] * o + r[5];
    }
}
function pH(t, r) {
  var e = t.getUpdatedPathProxy(), n = r.getUpdatedPathProxy(), i = Tpe(n6(e), n6(n)), a = i[0], o = i[1], s = t.getComputedTransform(), l = r.getComputedTransform();
  function u() {
    this.transform = null;
  }
  s && RR(a, s), l && RR(o, l), sy(r, "updateTransform", { replace: u }), r.transform = null;
  var c = Lpe(a, o, 10, Math.PI), d = [];
  sy(r, "buildPath", { replace: function(f) {
    for (var h = r.__morphT, p = 1 - h, v = [], g = 0; g < c.length; g++) {
      var m = c[g], y = m.from, b = m.to, C = m.rotation * h, w = m.fromCp, _ = m.toCp, x = Math.sin(C), I = Math.cos(C);
      Zp(v, w, _, h);
      for (var D = 0; D < y.length; D += 2) {
        var T = y[D], A = y[D + 1], M = b[D], R = b[D + 1], E = T * p + M * h, k = A * p + R * h;
        d[D] = E * I - k * x + v[0], d[D + 1] = E * x + k * I + v[1];
      }
      var P = d[0], N = d[1];
      f.moveTo(P, N);
      for (var D = 2; D < y.length; ) {
        var M = d[D++], R = d[D++], O = d[D++], W = d[D++], V = d[D++], B = d[D++];
        P === M && N === R && O === V && W === B ? f.lineTo(V, B) : f.bezierCurveTo(M, R, O, W, V, B), P = V, N = B;
      }
    }
  } });
}
function O_(t, r, e) {
  if (!t || !r)
    return r;
  var n = e.done, i = e.during;
  pH(t, r), r.__morphT = 0;
  function a() {
    iv(r, "buildPath"), iv(r, "updateTransform"), r.__morphT = -1, r.createPathProxy(), r.dirtyShape();
  }
  return r.animateTo({
    __morphT: 1
  }, Ee({
    during: function(o) {
      r.dirtyShape(), i && i(o);
    },
    done: function() {
      a(), n && n();
    }
  }, e)), r;
}
function Epe(t, r, e, n, i, a) {
  var o = 16;
  t = i === e ? 0 : Math.round(32767 * (t - e) / (i - e)), r = a === n ? 0 : Math.round(32767 * (r - n) / (a - n));
  for (var s = 0, l, u = (1 << o) / 2; u > 0; u /= 2) {
    var c = 0, d = 0;
    (t & u) > 0 && (c = 1), (r & u) > 0 && (d = 1), s += u * u * (3 * c ^ d), d === 0 && (c === 1 && (t = u - 1 - t, r = u - 1 - r), l = t, t = r, r = l);
  }
  return s;
}
function ly(t) {
  var r = 1 / 0, e = 1 / 0, n = -1 / 0, i = -1 / 0, a = ce(t, function(s) {
    var l = s.getBoundingRect(), u = s.getComputedTransform(), c = l.x + l.width / 2 + (u ? u[4] : 0), d = l.y + l.height / 2 + (u ? u[5] : 0);
    return r = Math.min(c, r), e = Math.min(d, e), n = Math.max(c, n), i = Math.max(d, i), [c, d];
  }), o = ce(a, function(s, l) {
    return {
      cp: s,
      z: Epe(s[0], s[1], r, e, n, i),
      path: t[l]
    };
  });
  return o.sort(function(s, l) {
    return s.z - l.z;
  }).map(function(s) {
    return s.path;
  });
}
function vH(t) {
  return Ape(t.path, t.count);
}
function a6() {
  return {
    fromIndividuals: [],
    toIndividuals: [],
    count: 0
  };
}
function kpe(t, r, e) {
  var n = [];
  function i(w) {
    for (var _ = 0; _ < w.length; _++) {
      var x = w[_];
      oy(x) ? i(x.childrenRef()) : x instanceof gt && n.push(x);
    }
  }
  i(t);
  var a = n.length;
  if (!a)
    return a6();
  var o = e.dividePath || vH, s = o({
    path: r,
    count: a
  });
  if (s.length !== a)
    return console.error("Invalid morphing: unmatched splitted path"), a6();
  n = ly(n), s = ly(s);
  for (var l = e.done, u = e.during, c = e.individualDelay, d = new Ls(), f = 0; f < a; f++) {
    var h = n[f], p = s[f];
    p.parent = r, p.copyTransform(d), c || pH(h, p);
  }
  r.__isCombineMorphing = !0, r.childrenRef = function() {
    return s;
  };
  function v(w) {
    for (var _ = 0; _ < s.length; _++)
      s[_].addSelfToZr(w);
  }
  sy(r, "addSelfToZr", {
    after: function(w) {
      v(w);
    }
  }), sy(r, "removeSelfFromZr", {
    after: function(w) {
      for (var _ = 0; _ < s.length; _++)
        s[_].removeSelfFromZr(w);
    }
  });
  function g() {
    r.__isCombineMorphing = !1, r.__morphT = -1, r.childrenRef = null, iv(r, "addSelfToZr"), iv(r, "removeSelfFromZr");
  }
  var m = s.length;
  if (c)
    for (var y = m, b = function() {
      y--, y === 0 && (g(), l && l());
    }, f = 0; f < m; f++) {
      var C = c ? Ee({
        delay: (e.delay || 0) + c(f, m, n[f], s[f]),
        done: b
      }, e) : e;
      O_(n[f], s[f], C);
    }
  else
    r.__morphT = 0, r.animateTo({
      __morphT: 1
    }, Ee({
      during: function(w) {
        for (var _ = 0; _ < m; _++) {
          var x = s[_];
          x.__morphT = r.__morphT, x.dirtyShape();
        }
        u && u(w);
      },
      done: function() {
        g();
        for (var w = 0; w < t.length; w++)
          iv(t[w], "updateTransform");
        l && l();
      }
    }, e));
  return r.__zr && v(r.__zr), {
    fromIndividuals: n,
    toIndividuals: s,
    count: m
  };
}
function Ppe(t, r, e) {
  var n = r.length, i = [], a = e.dividePath || vH;
  function o(h) {
    for (var p = 0; p < h.length; p++) {
      var v = h[p];
      oy(v) ? o(v.childrenRef()) : v instanceof gt && i.push(v);
    }
  }
  if (oy(t)) {
    o(t.childrenRef());
    var s = i.length;
    if (s < n)
      for (var l = 0, u = s; u < n; u++)
        i.push(W7(i[l++ % s]));
    i.length = n;
  } else {
    i = a({ path: t, count: n });
    for (var c = t.getComputedTransform(), u = 0; u < i.length; u++)
      i[u].setLocalTransform(c);
    if (i.length !== n)
      return console.error("Invalid morphing: unmatched splitted path"), a6();
  }
  i = ly(i), r = ly(r);
  for (var d = e.individualDelay, u = 0; u < n; u++) {
    var f = d ? Ee({
      delay: (e.delay || 0) + d(u, n, i[u], r[u])
    }, e) : e;
    O_(i[u], r[u], f);
  }
  return {
    fromIndividuals: i,
    toIndividuals: r,
    count: r.length
  };
}
function LR(t) {
  return ue(t[0]);
}
function ER(t, r) {
  for (var e = [], n = t.length, i = 0; i < n; i++)
    e.push({
      one: t[i],
      many: []
    });
  for (var i = 0; i < r.length; i++) {
    var a = r[i].length, o = void 0;
    for (o = 0; o < a; o++)
      e[o % n].many.push(r[i][o]);
  }
  for (var s = 0, i = n - 1; i >= 0; i--)
    if (!e[i].many.length) {
      var l = e[s].many;
      if (l.length <= 1)
        if (s)
          s = 0;
        else
          return e;
      var a = l.length, u = Math.ceil(a / 2);
      e[i].many = l.slice(u, a), e[s].many = l.slice(0, u), s++;
    }
  return e;
}
var Npe = {
  clone: function(t) {
    for (var r = [], e = 1 - Math.pow(1 - t.path.style.opacity, 1 / t.count), n = 0; n < t.count; n++) {
      var i = W7(t.path);
      i.setStyle("opacity", e), r.push(i);
    }
    return r;
  },
  // Use the default divider
  split: null
};
function Z3(t, r, e, n, i, a) {
  if (!t.length || !r.length)
    return;
  var o = nh("update", n, i);
  if (!(o && o.duration > 0))
    return;
  var s = n.getModel("universalTransition").get("delay"), l = Object.assign({
    // Need to setToFinal so the further calculation based on the style can be correct.
    // Like emphasis color.
    setToFinal: !0
  }, o), u, c;
  LR(t) && (u = t, c = r), LR(r) && (u = r, c = t);
  function d(m, y, b, C, w) {
    var _ = m.many, x = m.one;
    if (_.length === 1 && !w) {
      var I = y ? _[0] : x, D = y ? x : _[0];
      if (oy(I))
        d({
          many: [I],
          one: D
        }, !0, b, C, !0);
      else {
        var T = s ? Ee({
          delay: s(b, C)
        }, l) : l;
        O_(I, D, T), a(I, D, I, D, T);
      }
    } else
      for (var A = Ee({
        dividePath: Npe[e],
        individualDelay: s && function(N, O, W, V) {
          return s(N + b, C);
        }
      }, l), M = y ? kpe(_, x, A) : Ppe(x, _, A), R = M.fromIndividuals, E = M.toIndividuals, k = R.length, P = 0; P < k; P++) {
        var T = s ? Ee({
          delay: s(P, k)
        }, l) : l;
        a(R[P], E[P], y ? _[P] : m.one, y ? m.one : _[P], T);
      }
  }
  for (var f = u ? u === t : t.length > r.length, h = u ? ER(c, u) : ER(f ? r : t, [f ? t : r]), p = 0, v = 0; v < h.length; v++)
    p += h[v].many.length;
  for (var g = 0, v = 0; v < h.length; v++)
    d(h[v], f, g, p), g += h[v].many.length;
}
function Qu(t) {
  if (!t)
    return [];
  if (ue(t)) {
    for (var r = [], e = 0; e < t.length; e++)
      r.push(Qu(t[e]));
    return r;
  }
  var n = [];
  return t.traverse(function(i) {
    i instanceof gt && !i.disableMorphing && !i.invisible && !i.ignore && n.push(i);
  }), n;
}
var gH = 1e4, Ope = 0, kR = 1, PR = 2, Vpe = It();
function Gpe(t, r) {
  for (var e = t.dimensions, n = 0; n < e.length; n++) {
    var i = t.getDimensionInfo(e[n]);
    if (i && i.otherDims[r] === 0)
      return e[n];
  }
}
function Bpe(t, r, e) {
  var n = t.getDimensionInfo(e), i = n && n.ordinalMeta;
  if (n) {
    var a = t.get(n.name, r);
    return i && i.categories[a] || a + "";
  }
}
function NR(t, r, e, n) {
  var i = n ? "itemChildGroupId" : "itemGroupId", a = Gpe(t, i);
  if (a) {
    var o = Bpe(t, r, a);
    return o;
  }
  var s = t.getRawDataItem(r), l = n ? "childGroupId" : "groupId";
  if (s && s[l])
    return s[l] + "";
  if (!n)
    return e || t.getId(r);
}
function OR(t) {
  var r = [];
  return L(t, function(e) {
    var n = e.data, i = e.dataGroupId;
    if (n.count() > gH) {
      process.env.NODE_ENV !== "production" && Mr("Universal transition is disabled on large data > 10k.");
      return;
    }
    for (var a = n.getIndices(), o = 0; o < a.length; o++)
      r.push({
        data: n,
        groupId: NR(n, o, i, !1),
        childGroupId: NR(n, o, i, !0),
        divide: e.divide,
        dataIndex: o
      });
  }), r;
}
function j3(t, r, e) {
  t.traverse(function(n) {
    n instanceof gt && Cr(n, {
      style: {
        opacity: 0
      }
    }, r, {
      dataIndex: e,
      isFrom: !0
    });
  });
}
function Y3(t) {
  if (t.parent) {
    var r = t.getComputedTransform();
    t.setLocalTransform(r), t.parent.remove(t);
  }
}
function Pd(t) {
  t.stopAnimation(), t.isGroup && t.traverse(function(r) {
    r.stopAnimation();
  });
}
function Fpe(t, r, e) {
  var n = nh("update", e, r);
  n && t.traverse(function(i) {
    if (i instanceof La) {
      var a = mJ(i);
      a && i.animateFrom({
        style: a
      }, n);
    }
  });
}
function Hpe(t, r) {
  var e = t.length;
  if (e !== r.length)
    return !1;
  for (var n = 0; n < e; n++) {
    var i = t[n], a = r[n];
    if (i.data.getId(i.dataIndex) !== a.data.getId(a.dataIndex))
      return !1;
  }
  return !0;
}
function mH(t, r, e) {
  var n = OR(t), i = OR(r);
  function a(b, C, w, _, x) {
    (w || b) && C.animateFrom({
      style: w && w !== b ? ae(ae({}, w.style), b.style) : b.style
    }, x);
  }
  var o = !1, s = Ope, l = xe(), u = xe();
  n.forEach(function(b) {
    b.groupId && l.set(b.groupId, !0), b.childGroupId && u.set(b.childGroupId, !0);
  });
  for (var c = 0; c < i.length; c++) {
    var d = i[c].groupId;
    if (u.get(d)) {
      s = kR;
      break;
    }
    var f = i[c].childGroupId;
    if (f && l.get(f)) {
      s = PR;
      break;
    }
  }
  function h(b, C) {
    return function(w) {
      var _ = w.data, x = w.dataIndex;
      return C ? _.getId(x) : b ? s === kR ? w.childGroupId : w.groupId : s === PR ? w.childGroupId : w.groupId;
    };
  }
  var p = Hpe(n, i), v = {};
  if (!p)
    for (var c = 0; c < i.length; c++) {
      var g = i[c], m = g.data.getItemGraphicEl(g.dataIndex);
      m && (v[m.id] = !0);
    }
  function y(b, C) {
    var w = n[C], _ = i[b], x = _.data.hostModel, I = w.data.getItemGraphicEl(w.dataIndex), D = _.data.getItemGraphicEl(_.dataIndex);
    if (I === D) {
      D && Fpe(D, _.dataIndex, x);
      return;
    }
    // We can't use the elements that already being morphed
    I && v[I.id] || D && (Pd(D), I ? (Pd(I), Y3(I), o = !0, Z3(Qu(I), Qu(D), _.divide, x, b, a)) : j3(D, x, b));
  }
  new Us(n, i, h(!0, p), h(!1, p), null, "multiple").update(y).updateManyToOne(function(b, C) {
    var w = i[b], _ = w.data, x = _.hostModel, I = _.getItemGraphicEl(w.dataIndex), D = Wt(ce(C, function(T) {
      return n[T].data.getItemGraphicEl(n[T].dataIndex);
    }), function(T) {
      return T && T !== I && !v[T.id];
    });
    I && (Pd(I), D.length ? (L(D, function(T) {
      Pd(T), Y3(T);
    }), o = !0, Z3(Qu(D), Qu(I), w.divide, x, b, a)) : j3(I, x, w.dataIndex));
  }).updateOneToMany(function(b, C) {
    var w = n[C], _ = w.data.getItemGraphicEl(w.dataIndex);
    if (!(_ && v[_.id])) {
      var x = Wt(ce(b, function(D) {
        return i[D].data.getItemGraphicEl(i[D].dataIndex);
      }), function(D) {
        return D && D !== _;
      }), I = i[b[0]].data.hostModel;
      x.length && (L(x, function(D) {
        return Pd(D);
      }), _ ? (Pd(_), Y3(_), o = !0, Z3(
        Qu(_),
        Qu(x),
        w.divide,
        // Use divide on old.
        I,
        b[0],
        a
      )) : L(x, function(D) {
        return j3(D, I, b[0]);
      }));
    }
  }).updateManyToMany(function(b, C) {
    new Us(C, b, function(w) {
      return n[w].data.getId(n[w].dataIndex);
    }, function(w) {
      return i[w].data.getId(i[w].dataIndex);
    }).update(function(w, _) {
      y(b[w], C[_]);
    }).execute();
  }).execute(), o && L(r, function(b) {
    var C = b.data, w = C.hostModel, _ = w && e.getViewOfSeriesModel(w), x = nh("update", w, 0);
    _ && w.isAnimationEnabled() && x && x.duration > 0 && _.group.traverse(function(I) {
      I instanceof gt && !I.animators.length && I.animateFrom({
        style: {
          opacity: 0
        }
      }, x);
    });
  });
}
function VR(t) {
  var r = t.getModel("universalTransition").get("seriesKey");
  return r || t.id;
}
function GR(t) {
  return ue(t) ? t.sort().join(",") : t;
}
function xl(t) {
  if (t.hostModel)
    return t.hostModel.getModel("universalTransition").get("divideShape");
}
function zpe(t, r) {
  var e = xe(), n = xe(), i = xe();
  L(t.oldSeries, function(o, s) {
    var l = t.oldDataGroupIds[s], u = t.oldData[s], c = VR(o), d = GR(c);
    n.set(d, {
      dataGroupId: l,
      data: u
    }), ue(c) && L(c, function(f) {
      i.set(f, {
        key: d,
        dataGroupId: l,
        data: u
      });
    });
  });
  function a(o) {
    e.get(o) && Mr("Duplicated seriesKey in universalTransition " + o);
  }
  return L(r.updatedSeries, function(o) {
    if (o.isUniversalTransitionEnabled() && o.isAnimationEnabled()) {
      var s = o.get("dataGroupId"), l = o.getData(), u = VR(o), c = GR(u), d = n.get(c);
      if (d)
        process.env.NODE_ENV !== "production" && a(c), e.set(c, {
          oldSeries: [{
            dataGroupId: d.dataGroupId,
            divide: xl(d.data),
            data: d.data
          }],
          newSeries: [{
            dataGroupId: s,
            divide: xl(l),
            data: l
          }]
        });
      else if (ue(u)) {
        process.env.NODE_ENV !== "production" && a(c);
        var f = [];
        L(u, function(v) {
          var g = n.get(v);
          g.data && f.push({
            dataGroupId: g.dataGroupId,
            divide: xl(g.data),
            data: g.data
          });
        }), f.length && e.set(c, {
          oldSeries: f,
          newSeries: [{
            dataGroupId: s,
            data: l,
            divide: xl(l)
          }]
        });
      } else {
        var h = i.get(u);
        if (h) {
          var p = e.get(h.key);
          p || (p = {
            oldSeries: [{
              dataGroupId: h.dataGroupId,
              data: h.data,
              divide: xl(h.data)
            }],
            newSeries: []
          }, e.set(h.key, p)), p.newSeries.push({
            dataGroupId: s,
            data: l,
            divide: xl(l)
          });
        }
      }
    }
  }), e;
}
function BR(t, r) {
  for (var e = 0; e < t.length; e++) {
    var n = r.seriesIndex != null && r.seriesIndex === t[e].seriesIndex || r.seriesId != null && r.seriesId === t[e].id;
    if (n)
      return e;
  }
}
function Wpe(t, r, e, n) {
  var i = [], a = [];
  L(Qt(t.from), function(o) {
    var s = BR(r.oldSeries, o);
    s >= 0 && i.push({
      dataGroupId: r.oldDataGroupIds[s],
      data: r.oldData[s],
      // TODO can specify divideShape in transition.
      divide: xl(r.oldData[s]),
      groupIdDim: o.dimension
    });
  }), L(Qt(t.to), function(o) {
    var s = BR(e.updatedSeries, o);
    if (s >= 0) {
      var l = e.updatedSeries[s].getData();
      a.push({
        dataGroupId: r.oldDataGroupIds[s],
        data: l,
        divide: xl(l),
        groupIdDim: o.dimension
      });
    }
  }), i.length > 0 && a.length > 0 && mH(i, a, n);
}
function Zpe(t) {
  t.registerUpdateLifecycle("series:beforeupdate", function(r, e, n) {
    L(Qt(n.seriesTransition), function(i) {
      L(Qt(i.to), function(a) {
        for (var o = n.updatedSeries, s = 0; s < o.length; s++)
          (a.seriesIndex != null && a.seriesIndex === o[s].seriesIndex || a.seriesId != null && a.seriesId === o[s].id) && (o[s][k0] = !0);
      });
    });
  }), t.registerUpdateLifecycle("series:transition", function(r, e, n) {
    var i = Vpe(e);
    if (i.oldSeries && n.updatedSeries && n.optionChanged) {
      var a = n.seriesTransition;
      if (a)
        L(Qt(a), function(h) {
          Wpe(h, i, n, e);
        });
      else {
        var o = zpe(i, n);
        L(o.keys(), function(h) {
          var p = o.get(h);
          mH(p.oldSeries, p.newSeries, e);
        });
      }
      L(n.updatedSeries, function(h) {
        h[k0] && (h[k0] = !1);
      });
    }
    for (var s = r.getSeries(), l = i.oldSeries = [], u = i.oldDataGroupIds = [], c = i.oldData = [], d = 0; d < s.length; d++) {
      var f = s[d].getData();
      f.count() < gH && (l.push(s[d]), u.push(s[d].get("dataGroupId")), c.push(f));
    }
  });
}
lt([tre]);
lt([Jte]);
lt([wre, Ore, Yre, Ine, One, _ie, Jie, kae, toe, soe, goe, cse, Nse, Yse, lle, fle, _le, Mle, Fle, Yle, rue, Gue]);
lt(nce);
lt(Mce);
lt(pB);
lt(zce);
lt(QB);
lt(Yce);
lt(tde);
lt(zde);
lt(sfe);
lt(Mg);
lt(Sfe);
lt(Dfe);
lt(Vfe);
lt(Zfe);
lt(Jfe);
lt(rhe);
lt(fhe);
lt(Rhe);
lt(nH);
lt(iH);
lt(Jhe);
lt(uH);
lt(cH);
lt(tpe);
lt(ppe);
lt(mpe);
lt(Zpe);
lt(gte);
const jpe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Axis: Va,
  ChartView: Yt,
  ComponentModel: st,
  ComponentView: yr,
  List: ni,
  Model: Pt,
  PRIORITY: SV,
  SeriesModel: tr,
  color: PX,
  connect: SQ,
  dataTool: LQ,
  dependencies: oQ,
  disConnect: IQ,
  disconnect: EV,
  dispose: AQ,
  env: vt,
  extendChartView: nte,
  extendComponentModel: ete,
  extendComponentView: tte,
  extendSeriesModel: rte,
  format: Wee,
  getCoordinateSystemDimensions: TQ,
  getInstanceByDom: Cw,
  getInstanceById: DQ,
  getMap: RQ,
  graphic: zee,
  helper: Pee,
  init: xQ,
  innerDrawElementOnCanvas: gw,
  matrix: fX,
  number: Fee,
  parseGeoJSON: g9,
  parseGeoJson: g9,
  registerAction: co,
  registerCoordinateSystem: NV,
  registerLayout: OV,
  registerLoading: Iw,
  registerLocale: q7,
  registerMap: VV,
  registerPostInit: kV,
  registerPostUpdate: PV,
  registerPreprocessor: _w,
  registerProcessor: xw,
  registerTheme: ww,
  registerTransform: GV,
  registerUpdateLifecycle: S2,
  registerVisual: gu,
  setCanvasCreator: MQ,
  setPlatformAPI: PP,
  throttle: _2,
  time: Hee,
  use: lt,
  util: Zee,
  vector: qY,
  version: aQ,
  zrUtil: jY,
  zrender: v$
}, Symbol.toStringTag, { value: "Module" }));
var vs = {}, gs = {}, X3 = {}, FR;
function Ype() {
  return FR || (FR = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = 1, e = function() {
      return "".concat(r++);
    };
    t.default = e;
  }(X3)), X3;
}
var lp = {}, up = {}, $3 = {}, HR;
function yH() {
  return HR || (HR = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = function(n) {
      var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 60, a = null;
      return function() {
        for (var o = this, s = arguments.length, l = new Array(s), u = 0; u < s; u++)
          l[u] = arguments[u];
        clearTimeout(a), a = setTimeout(function() {
          n.apply(o, l);
        }, i);
      };
    };
    t.default = r;
  }($3)), $3;
}
var ms = {}, zR;
function V_() {
  if (zR) return ms;
  zR = 1, Object.defineProperty(ms, "__esModule", {
    value: !0
  }), ms.SizeSensorId = ms.SensorTabIndex = ms.SensorClassName = void 0;
  var t = "size-sensor-id";
  ms.SizeSensorId = t;
  var r = "size-sensor-object";
  ms.SensorClassName = r;
  var e = "-1";
  return ms.SensorTabIndex = e, ms;
}
var WR;
function Xpe() {
  if (WR) return up;
  WR = 1, Object.defineProperty(up, "__esModule", {
    value: !0
  }), up.createSensor = void 0;
  var t = e(yH()), r = V_();
  function e(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var n = function(a, o) {
    var s = void 0, l = [], u = function() {
      getComputedStyle(a).position === "static" && (a.style.position = "relative");
      var v = document.createElement("object");
      return v.onload = function() {
        v.contentDocument.defaultView.addEventListener("resize", c), c();
      }, v.style.display = "block", v.style.position = "absolute", v.style.top = "0", v.style.left = "0", v.style.height = "100%", v.style.width = "100%", v.style.overflow = "hidden", v.style.pointerEvents = "none", v.style.zIndex = "-1", v.style.opacity = "0", v.setAttribute("class", r.SensorClassName), v.setAttribute("tabindex", r.SensorTabIndex), v.type = "text/html", a.appendChild(v), v.data = "about:blank", v;
    }, c = (0, t.default)(function() {
      l.forEach(function(p) {
        p(a);
      });
    }), d = function(v) {
      s || (s = u()), l.indexOf(v) === -1 && l.push(v);
    }, f = function() {
      s && s.parentNode && (s.contentDocument && s.contentDocument.defaultView.removeEventListener("resize", c), s.parentNode.removeChild(s), a.removeAttribute(r.SizeSensorId), s = void 0, l = [], o && o());
    }, h = function(v) {
      var g = l.indexOf(v);
      g !== -1 && l.splice(g, 1), l.length === 0 && s && f();
    };
    return {
      element: a,
      bind: d,
      destroy: f,
      unbind: h
    };
  };
  return up.createSensor = n, up;
}
var cp = {}, ZR;
function $pe() {
  if (ZR) return cp;
  ZR = 1, Object.defineProperty(cp, "__esModule", {
    value: !0
  }), cp.createSensor = void 0;
  var t = V_(), r = e(yH());
  function e(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var n = function(a, o) {
    var s = void 0, l = [], u = (0, r.default)(function() {
      l.forEach(function(p) {
        p(a);
      });
    }), c = function() {
      var v = new ResizeObserver(u);
      return v.observe(a), u(), v;
    }, d = function(v) {
      s || (s = c()), l.indexOf(v) === -1 && l.push(v);
    }, f = function() {
      s.disconnect(), l = [], s = void 0, a.removeAttribute(t.SizeSensorId), o && o();
    }, h = function(v) {
      var g = l.indexOf(v);
      g !== -1 && l.splice(g, 1), l.length === 0 && s && f();
    };
    return {
      element: a,
      bind: d,
      destroy: f,
      unbind: h
    };
  };
  return cp.createSensor = n, cp;
}
var jR;
function Upe() {
  if (jR) return lp;
  jR = 1, Object.defineProperty(lp, "__esModule", {
    value: !0
  }), lp.createSensor = void 0;
  var t = Xpe(), r = $pe(), e = typeof ResizeObserver < "u" ? r.createSensor : t.createSensor;
  return lp.createSensor = e, lp;
}
var YR;
function Jpe() {
  if (YR) return gs;
  YR = 1, Object.defineProperty(gs, "__esModule", {
    value: !0
  }), gs.removeSensor = gs.getSensor = gs.Sensors = void 0;
  var t = n(Ype()), r = Upe(), e = V_();
  function n(l) {
    return l && l.__esModule ? l : { default: l };
  }
  var i = {};
  gs.Sensors = i;
  function a(l) {
    l && i[l] && delete i[l];
  }
  var o = function(u) {
    var c = u.getAttribute(e.SizeSensorId);
    if (c && i[c])
      return i[c];
    var d = (0, t.default)();
    u.setAttribute(e.SizeSensorId, d);
    var f = (0, r.createSensor)(u, function() {
      return a(d);
    });
    return i[d] = f, f;
  };
  gs.getSensor = o;
  var s = function(u) {
    var c = u.element.getAttribute(e.SizeSensorId);
    u.destroy(), a(c);
  };
  return gs.removeSensor = s, gs;
}
var XR;
function Kpe() {
  if (XR) return vs;
  XR = 1, Object.defineProperty(vs, "__esModule", {
    value: !0
  }), vs.ver = vs.clear = vs.bind = void 0;
  var t = Jpe(), r = function(a, o) {
    var s = (0, t.getSensor)(a);
    return s.bind(o), function() {
      s.unbind(o);
    };
  };
  vs.bind = r;
  var e = function(a) {
    var o = (0, t.getSensor)(a);
    (0, t.removeSensor)(o);
  };
  vs.clear = e;
  var n = "1.0.2";
  return vs.ver = n, vs;
}
var $R = Kpe();
function UR(t, r) {
  var e = {};
  return r.forEach(function(n) {
    e[n] = t[n];
  }), e;
}
function U3(t) {
  return typeof t == "function";
}
function qpe(t) {
  return typeof t == "string";
}
var J3, JR;
function Qpe() {
  return JR || (JR = 1, J3 = function t(r, e) {
    if (r === e) return !0;
    if (r && e && typeof r == "object" && typeof e == "object") {
      if (r.constructor !== e.constructor) return !1;
      var n, i, a;
      if (Array.isArray(r)) {
        if (n = r.length, n != e.length) return !1;
        for (i = n; i-- !== 0; )
          if (!t(r[i], e[i])) return !1;
        return !0;
      }
      if (r.constructor === RegExp) return r.source === e.source && r.flags === e.flags;
      if (r.valueOf !== Object.prototype.valueOf) return r.valueOf() === e.valueOf();
      if (r.toString !== Object.prototype.toString) return r.toString() === e.toString();
      if (a = Object.keys(r), n = a.length, n !== Object.keys(e).length) return !1;
      for (i = n; i-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(e, a[i])) return !1;
      for (i = n; i-- !== 0; ) {
        var o = a[i];
        if (!t(r[o], e[o])) return !1;
      }
      return !0;
    }
    return r !== r && e !== e;
  }), J3;
}
var eve = Qpe();
const Nd = /* @__PURE__ */ Yy(eve);
var tve = (
  /** @class */
  function(t) {
    EP(r, t);
    function r(e) {
      var n = t.call(this, e) || this;
      return n.echarts = e.echarts, n.ele = null, n.isInitialResize = !0, n;
    }
    return r.prototype.componentDidMount = function() {
      this.renderNewEcharts();
    }, r.prototype.componentDidUpdate = function(e) {
      var n = this.props.shouldSetOption;
      if (!(U3(n) && !n(e, this.props))) {
        if (!Nd(e.theme, this.props.theme) || !Nd(e.opts, this.props.opts) || !Nd(e.onEvents, this.props.onEvents)) {
          this.dispose(), this.renderNewEcharts();
          return;
        }
        var i = ["option", "notMerge", "lazyUpdate", "showLoading", "loadingOption"];
        Nd(UR(this.props, i), UR(e, i)) || this.updateEChartsOption(), (!Nd(e.style, this.props.style) || !Nd(e.className, this.props.className)) && this.resize();
      }
    }, r.prototype.componentWillUnmount = function() {
      this.dispose();
    }, r.prototype.getEchartsInstance = function() {
      return this.echarts.getInstanceByDom(this.ele) || this.echarts.init(this.ele, this.props.theme, this.props.opts);
    }, r.prototype.dispose = function() {
      if (this.ele) {
        try {
          $R.clear(this.ele);
        } catch (e) {
          console.warn(e);
        }
        this.echarts.dispose(this.ele);
      }
    }, r.prototype.renderNewEcharts = function() {
      var e = this, n = this.props, i = n.onEvents, a = n.onChartReady, o = this.updateEChartsOption();
      this.bindEvents(o, i || {}), U3(a) && a(o), this.ele && $R.bind(this.ele, function() {
        e.resize();
      });
    }, r.prototype.bindEvents = function(e, n) {
      function i(o, s) {
        qpe(o) && U3(s) && e.on(o, function(l) {
          s(l, e);
        });
      }
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && i(a, n[a]);
    }, r.prototype.updateEChartsOption = function() {
      var e = this.props, n = e.option, i = e.notMerge, a = i === void 0 ? !1 : i, o = e.lazyUpdate, s = o === void 0 ? !1 : o, l = e.showLoading, u = e.loadingOption, c = u === void 0 ? null : u, d = this.getEchartsInstance();
      return d.setOption(n, a, s), l ? d.showLoading(c) : d.hideLoading(), d;
    }, r.prototype.resize = function() {
      var e = this.getEchartsInstance();
      if (!this.isInitialResize)
        try {
          e.resize();
        } catch (n) {
          console.warn(n);
        }
      this.isInitialResize = !1;
    }, r.prototype.render = function() {
      var e = this, n = this.props, i = n.style, a = n.className, o = a === void 0 ? "" : a, s = pC({ height: 300 }, i);
      return te.createElement("div", { ref: function(l) {
        e.ele = l;
      }, style: s, className: "echarts-for-react " + o });
    }, r;
  }(hY)
), Rg = (
  /** @class */
  function(t) {
    EP(r, t);
    function r(e) {
      var n = t.call(this, e) || this;
      return n.echarts = jpe, n;
    }
    return r;
  }(tve)
);
const Exe = (t) => {
  const {
    data: r,
    xAxis: e,
    yAxis: n = [
      {
        type: "value"
      }
    ],
    height: i = 194,
    chartOptions: a = {},
    className: o = ""
  } = t, s = r.map((u) => ({
    ...u,
    type: "bar",
    barCategoryGap: 0.5,
    barWidth: u.barWidth ? u.barWidth : "18.5px"
  })), l = {
    grid: {
      right: 0,
      left: 0,
      containLabel: !0
    },
    height: i,
    overflow: "auto",
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow"
      }
    },
    textStyle: {
      fontFamily: "Inter"
    },
    xAxis: e,
    yAxis: n,
    series: s,
    ...a
  };
  return /* @__PURE__ */ S.jsx("div", { style: { width: "100%", height: `${i + 150}px` }, children: /* @__PURE__ */ S.jsx(Rg, { className: o, option: l }) });
}, kxe = (t) => {
  const {
    data: r,
    title: e,
    width: n = 250,
    height: i = 250,
    customLabel: a = null,
    chartOptions: o = {},
    className: s = ""
  } = t, l = {
    tooltip: {
      trigger: "item"
    },
    grid: { top: 0, right: 0, bottom: 0, left: 0 },
    height: i,
    width: n,
    textStyle: {
      fontFamily: "Inter"
    },
    series: [
      {
        name: e,
        type: "pie",
        radius: ["60%", "100%"],
        avoidLabelOverlap: !1,
        label: a,
        data: r
      }
    ],
    ...o
  };
  return /* @__PURE__ */ S.jsx(Rg, { className: s, option: l });
}, Pxe = (t) => {
  const {
    data: r,
    xAxis: e,
    yAxis: n = { type: "value" },
    withLegend: i = !0,
    height: a = 300,
    chartOptions: o = {},
    className: s = ""
  } = t, l = r.map((c) => ({
    ...c,
    type: "line"
  })), u = {
    grid: {
      left: 25,
      right: 0,
      containLabel: !0
    },
    tooltip: {
      trigger: "axis"
    },
    height: a,
    legend: i ? {
      bottom: 0,
      left: 0,
      orient: "vertical"
    } : null,
    xAxis: e,
    yAxis: n,
    series: l,
    textStyle: {
      fontFamily: "Inter"
    },
    ...o
  };
  return /* @__PURE__ */ S.jsx("div", { style: { width: "100%", height: `${a + 150}px` }, children: /* @__PURE__ */ S.jsx(
    Rg,
    {
      className: s,
      option: u,
      style: {
        height: "100%",
        width: "100%"
      }
    }
  ) });
}, Nxe = (t) => {
  const {
    data: r,
    title: e = "",
    width: n = 250,
    height: i = 250,
    customLabel: a = null,
    chartOptions: o = {},
    className: s = ""
  } = t, l = {
    tooltip: {
      trigger: "item"
    },
    grid: { top: 0, right: 0, bottom: 0, left: 0 },
    height: i,
    width: n,
    textStyle: {
      fontFamily: "Inter"
    },
    series: [
      {
        name: e,
        type: "pie",
        avoidLabelOverlap: !1,
        label: a,
        data: r
      }
    ],
    ...o
  };
  return /* @__PURE__ */ S.jsx(Rg, { className: s, option: l });
}, Oxe = (t) => {
  const {
    labels: r,
    links: e,
    width: n = 1024,
    height: i = 250,
    chartOptions: a = {},
    seriesOptions: o = {},
    className: s = ""
  } = t, l = Math.max(...r.map((d) => d.depth)), u = Array.from({ length: l + 1 }, (d, f) => ({
    depth: f,
    lineStyle: {
      color: "source",
      opacity: 0.3
    }
  })), c = {
    grid: { top: 0, right: 0, bottom: 0, left: 0 },
    containLabel: !0,
    height: i,
    width: n,
    textStyle: {
      fontFamily: "Inter"
    },
    tooltip: {
      trigger: "item",
      triggerOn: "mousemove"
    },
    animation: !1,
    series: [
      {
        type: "sankey",
        emphasis: {
          focus: "adjacency"
        },
        left: 0,
        right: 0,
        data: r,
        links: e,
        label: {
          textStyle: {
            fontSize: 10,
            fontWeight: "bold",
            color: "#253858"
          },
          formatter: "{b} {c}"
        },
        lineStyle: {
          color: "source",
          curveness: 0.5
        },
        levels: u,
        ...o
      }
    ],
    ...a
  };
  return /* @__PURE__ */ S.jsx(Rg, { className: s, option: c });
}, Vxe = (t) => {
  const { label: r, variant: e = "green", className: n } = t;
  return /* @__PURE__ */ S.jsx(
    "span",
    {
      className: `theme-chip theme-chip-color-${e} ${n && n}`,
      children: r
    }
  );
};
function bH(t) {
  var r, e, n = "";
  if (typeof t == "string" || typeof t == "number") n += t;
  else if (typeof t == "object") if (Array.isArray(t)) {
    var i = t.length;
    for (r = 0; r < i; r++) t[r] && (e = bH(t[r])) && (n && (n += " "), n += e);
  } else for (e in t) t[e] && (n && (n += " "), n += e);
  return n;
}
function Ln() {
  for (var t, r, e = 0, n = "", i = arguments.length; e < i; e++) (t = arguments[e]) && (r = bH(t)) && (n && (n += " "), n += r);
  return n;
}
function Ne(t) {
  const r = Object.prototype.toString.call(t);
  return t instanceof Date || typeof t == "object" && r === "[object Date]" ? new t.constructor(+t) : typeof t == "number" || r === "[object Number]" || typeof t == "string" || r === "[object String]" ? new Date(t) : /* @__PURE__ */ new Date(NaN);
}
function gr(t, r) {
  return t instanceof Date ? new t.constructor(r) : new Date(r);
}
function el(t, r) {
  const e = Ne(t);
  return isNaN(r) ? gr(t, NaN) : (r && e.setDate(e.getDate() + r), e);
}
function no(t, r) {
  const e = Ne(t);
  if (isNaN(r)) return gr(t, NaN);
  if (!r)
    return e;
  const n = e.getDate(), i = gr(t, e.getTime());
  i.setMonth(e.getMonth() + r + 1, 0);
  const a = i.getDate();
  return n >= a ? i : (e.setFullYear(
    i.getFullYear(),
    i.getMonth(),
    n
  ), e);
}
function G_(t, r) {
  const e = +Ne(t);
  return gr(t, e + r);
}
const CH = 6048e5, rve = 864e5, V2 = 6e4, G2 = 36e5, nve = 1e3;
function ive(t, r) {
  return G_(t, r * G2);
}
let ave = {};
function ad() {
  return ave;
}
function tl(t, r) {
  var s, l, u, c;
  const e = ad(), n = (r == null ? void 0 : r.weekStartsOn) ?? ((l = (s = r == null ? void 0 : r.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? e.weekStartsOn ?? ((c = (u = e.locale) == null ? void 0 : u.options) == null ? void 0 : c.weekStartsOn) ?? 0, i = Ne(t), a = i.getDay(), o = (a < n ? 7 : 0) + a - n;
  return i.setDate(i.getDate() - o), i.setHours(0, 0, 0, 0), i;
}
function Vf(t) {
  return tl(t, { weekStartsOn: 1 });
}
function wH(t) {
  const r = Ne(t), e = r.getFullYear(), n = gr(t, 0);
  n.setFullYear(e + 1, 0, 4), n.setHours(0, 0, 0, 0);
  const i = Vf(n), a = gr(t, 0);
  a.setFullYear(e, 0, 4), a.setHours(0, 0, 0, 0);
  const o = Vf(a);
  return r.getTime() >= i.getTime() ? e + 1 : r.getTime() >= o.getTime() ? e : e - 1;
}
function jc(t) {
  const r = Ne(t);
  return r.setHours(0, 0, 0, 0), r;
}
function uy(t) {
  const r = Ne(t), e = new Date(
    Date.UTC(
      r.getFullYear(),
      r.getMonth(),
      r.getDate(),
      r.getHours(),
      r.getMinutes(),
      r.getSeconds(),
      r.getMilliseconds()
    )
  );
  return e.setUTCFullYear(r.getFullYear()), +t - +e;
}
function Gf(t, r) {
  const e = jc(t), n = jc(r), i = +e - uy(e), a = +n - uy(n);
  return Math.round((i - a) / rve);
}
function ove(t) {
  const r = wH(t), e = gr(t, 0);
  return e.setFullYear(r, 0, 4), e.setHours(0, 0, 0, 0), Vf(e);
}
function o6(t, r) {
  return G_(t, r * V2);
}
function B_(t, r) {
  const e = r * 3;
  return no(t, e);
}
function sve(t, r) {
  return G_(t, r * 1e3);
}
function cy(t, r) {
  const e = r * 7;
  return el(t, e);
}
function Bs(t, r) {
  return no(t, r * 12);
}
function KR(t) {
  let r;
  return t.forEach(function(e) {
    const n = Ne(e);
    (r === void 0 || r < n || isNaN(Number(n))) && (r = n);
  }), r || /* @__PURE__ */ new Date(NaN);
}
function qR(t) {
  let r;
  return t.forEach((e) => {
    const n = Ne(e);
    (!r || r > n || isNaN(+n)) && (r = n);
  }), r || /* @__PURE__ */ new Date(NaN);
}
function lve(t, r) {
  const e = jc(t), n = jc(r);
  return +e == +n;
}
function Fs(t) {
  return t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function dy(t) {
  if (!Fs(t) && typeof t != "number")
    return !1;
  const r = Ne(t);
  return !isNaN(Number(r));
}
function fy(t, r) {
  const e = Ne(t), n = Ne(r), i = e.getFullYear() - n.getFullYear(), a = e.getMonth() - n.getMonth();
  return i * 12 + a;
}
function Mc(t) {
  const r = Ne(t);
  return Math.trunc(r.getMonth() / 3) + 1;
}
function hy(t, r) {
  const e = Ne(t), n = Ne(r), i = e.getFullYear() - n.getFullYear(), a = Mc(e) - Mc(n);
  return i * 4 + a;
}
function py(t, r) {
  const e = Ne(t), n = Ne(r);
  return e.getFullYear() - n.getFullYear();
}
function uve(t, r) {
  const e = Ne(t), n = Ne(r), i = QR(e, n), a = Math.abs(Gf(e, n));
  e.setDate(e.getDate() - i * a);
  const o = +(QR(e, n) === -i), s = i * (a - o);
  return s === 0 ? 0 : s;
}
function QR(t, r) {
  const e = t.getFullYear() - r.getFullYear() || t.getMonth() - r.getMonth() || t.getDate() - r.getDate() || t.getHours() - r.getHours() || t.getMinutes() - r.getMinutes() || t.getSeconds() - r.getSeconds() || t.getMilliseconds() - r.getMilliseconds();
  return e < 0 ? -1 : e > 0 ? 1 : e;
}
function _H(t) {
  const r = Ne(t);
  return r.setHours(23, 59, 59, 999), r;
}
function xH(t) {
  const r = Ne(t), e = r.getMonth();
  return r.setFullYear(r.getFullYear(), e + 1, 0), r.setHours(23, 59, 59, 999), r;
}
function s6(t) {
  const r = Ne(t), e = r.getMonth(), n = e - e % 3;
  return r.setMonth(n, 1), r.setHours(0, 0, 0, 0), r;
}
function SH(t) {
  const r = Ne(t);
  return r.setDate(1), r.setHours(0, 0, 0, 0), r;
}
function IH(t) {
  const r = Ne(t), e = r.getFullYear();
  return r.setFullYear(e + 1, 0, 0), r.setHours(23, 59, 59, 999), r;
}
function B2(t) {
  const r = Ne(t), e = gr(t, 0);
  return e.setFullYear(r.getFullYear(), 0, 1), e.setHours(0, 0, 0, 0), e;
}
function cve(t, r) {
  var s, l;
  const e = ad(), n = e.weekStartsOn ?? ((l = (s = e.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? 0, i = Ne(t), a = i.getDay(), o = (a < n ? -7 : 0) + 6 - (a - n);
  return i.setDate(i.getDate() + o), i.setHours(23, 59, 59, 999), i;
}
const dve = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, fve = (t, r, e) => {
  let n;
  const i = dve[t];
  return typeof i == "string" ? n = i : r === 1 ? n = i.one : n = i.other.replace("{{count}}", r.toString()), e != null && e.addSuffix ? e.comparison && e.comparison > 0 ? "in " + n : n + " ago" : n;
};
function K3(t) {
  return (r = {}) => {
    const e = r.width ? String(r.width) : t.defaultWidth;
    return t.formats[e] || t.formats[t.defaultWidth];
  };
}
const hve = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, pve = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, vve = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, gve = {
  date: K3({
    formats: hve,
    defaultWidth: "full"
  }),
  time: K3({
    formats: pve,
    defaultWidth: "full"
  }),
  dateTime: K3({
    formats: vve,
    defaultWidth: "full"
  })
}, mve = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, yve = (t, r, e, n) => mve[t];
function dp(t) {
  return (r, e) => {
    const n = e != null && e.context ? String(e.context) : "standalone";
    let i;
    if (n === "formatting" && t.formattingValues) {
      const o = t.defaultFormattingWidth || t.defaultWidth, s = e != null && e.width ? String(e.width) : o;
      i = t.formattingValues[s] || t.formattingValues[o];
    } else {
      const o = t.defaultWidth, s = e != null && e.width ? String(e.width) : t.defaultWidth;
      i = t.values[s] || t.values[o];
    }
    const a = t.argumentCallback ? t.argumentCallback(r) : r;
    return i[a];
  };
}
const bve = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Cve = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, wve = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, _ve = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, xve = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Sve = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Ive = (t, r) => {
  const e = Number(t), n = e % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return e + "st";
      case 2:
        return e + "nd";
      case 3:
        return e + "rd";
    }
  return e + "th";
}, Ave = {
  ordinalNumber: Ive,
  era: dp({
    values: bve,
    defaultWidth: "wide"
  }),
  quarter: dp({
    values: Cve,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: dp({
    values: wve,
    defaultWidth: "wide"
  }),
  day: dp({
    values: _ve,
    defaultWidth: "wide"
  }),
  dayPeriod: dp({
    values: xve,
    defaultWidth: "wide",
    formattingValues: Sve,
    defaultFormattingWidth: "wide"
  })
};
function fp(t) {
  return (r, e = {}) => {
    const n = e.width, i = n && t.matchPatterns[n] || t.matchPatterns[t.defaultMatchWidth], a = r.match(i);
    if (!a)
      return null;
    const o = a[0], s = n && t.parsePatterns[n] || t.parsePatterns[t.defaultParseWidth], l = Array.isArray(s) ? Tve(s, (d) => d.test(o)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      Dve(s, (d) => d.test(o))
    );
    let u;
    u = t.valueCallback ? t.valueCallback(l) : l, u = e.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      e.valueCallback(u)
    ) : u;
    const c = r.slice(o.length);
    return { value: u, rest: c };
  };
}
function Dve(t, r) {
  for (const e in t)
    if (Object.prototype.hasOwnProperty.call(t, e) && r(t[e]))
      return e;
}
function Tve(t, r) {
  for (let e = 0; e < t.length; e++)
    if (r(t[e]))
      return e;
}
function Mve(t) {
  return (r, e = {}) => {
    const n = r.match(t.matchPattern);
    if (!n) return null;
    const i = n[0], a = r.match(t.parsePattern);
    if (!a) return null;
    let o = t.valueCallback ? t.valueCallback(a[0]) : a[0];
    o = e.valueCallback ? e.valueCallback(o) : o;
    const s = r.slice(i.length);
    return { value: o, rest: s };
  };
}
const Rve = /^(\d+)(th|st|nd|rd)?/i, Lve = /\d+/i, Eve = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, kve = {
  any: [/^b/i, /^(a|c)/i]
}, Pve = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Nve = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Ove = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Vve = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Gve = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Bve = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Fve = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Hve = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, zve = {
  ordinalNumber: Mve({
    matchPattern: Rve,
    parsePattern: Lve,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: fp({
    matchPatterns: Eve,
    defaultMatchWidth: "wide",
    parsePatterns: kve,
    defaultParseWidth: "any"
  }),
  quarter: fp({
    matchPatterns: Pve,
    defaultMatchWidth: "wide",
    parsePatterns: Nve,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: fp({
    matchPatterns: Ove,
    defaultMatchWidth: "wide",
    parsePatterns: Vve,
    defaultParseWidth: "any"
  }),
  day: fp({
    matchPatterns: Gve,
    defaultMatchWidth: "wide",
    parsePatterns: Bve,
    defaultParseWidth: "any"
  }),
  dayPeriod: fp({
    matchPatterns: Fve,
    defaultMatchWidth: "any",
    parsePatterns: Hve,
    defaultParseWidth: "any"
  })
}, AH = {
  code: "en-US",
  formatDistance: fve,
  formatLong: gve,
  formatRelative: yve,
  localize: Ave,
  match: zve,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function Wve(t) {
  const r = Ne(t);
  return Gf(r, B2(r)) + 1;
}
function F_(t) {
  const r = Ne(t), e = +Vf(r) - +ove(r);
  return Math.round(e / CH) + 1;
}
function H_(t, r) {
  var c, d, f, h;
  const e = Ne(t), n = e.getFullYear(), i = ad(), a = (r == null ? void 0 : r.firstWeekContainsDate) ?? ((d = (c = r == null ? void 0 : r.locale) == null ? void 0 : c.options) == null ? void 0 : d.firstWeekContainsDate) ?? i.firstWeekContainsDate ?? ((h = (f = i.locale) == null ? void 0 : f.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, o = gr(t, 0);
  o.setFullYear(n + 1, 0, a), o.setHours(0, 0, 0, 0);
  const s = tl(o, r), l = gr(t, 0);
  l.setFullYear(n, 0, a), l.setHours(0, 0, 0, 0);
  const u = tl(l, r);
  return e.getTime() >= s.getTime() ? n + 1 : e.getTime() >= u.getTime() ? n : n - 1;
}
function Zve(t, r) {
  var s, l, u, c;
  const e = ad(), n = (r == null ? void 0 : r.firstWeekContainsDate) ?? ((l = (s = r == null ? void 0 : r.locale) == null ? void 0 : s.options) == null ? void 0 : l.firstWeekContainsDate) ?? e.firstWeekContainsDate ?? ((c = (u = e.locale) == null ? void 0 : u.options) == null ? void 0 : c.firstWeekContainsDate) ?? 1, i = H_(t, r), a = gr(t, 0);
  return a.setFullYear(i, 0, n), a.setHours(0, 0, 0, 0), tl(a, r);
}
function DH(t, r) {
  const e = Ne(t), n = +tl(e, r) - +Zve(e, r);
  return Math.round(n / CH) + 1;
}
function pr(t, r) {
  const e = t < 0 ? "-" : "", n = Math.abs(t).toString().padStart(r, "0");
  return e + n;
}
const yl = {
  // Year
  y(t, r) {
    const e = t.getFullYear(), n = e > 0 ? e : 1 - e;
    return pr(r === "yy" ? n % 100 : n, r.length);
  },
  // Month
  M(t, r) {
    const e = t.getMonth();
    return r === "M" ? String(e + 1) : pr(e + 1, 2);
  },
  // Day of the month
  d(t, r) {
    return pr(t.getDate(), r.length);
  },
  // AM or PM
  a(t, r) {
    const e = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return e.toUpperCase();
      case "aaa":
        return e;
      case "aaaaa":
        return e[0];
      case "aaaa":
      default:
        return e === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(t, r) {
    return pr(t.getHours() % 12 || 12, r.length);
  },
  // Hour [0-23]
  H(t, r) {
    return pr(t.getHours(), r.length);
  },
  // Minute
  m(t, r) {
    return pr(t.getMinutes(), r.length);
  },
  // Second
  s(t, r) {
    return pr(t.getSeconds(), r.length);
  },
  // Fraction of second
  S(t, r) {
    const e = r.length, n = t.getMilliseconds(), i = Math.trunc(
      n * Math.pow(10, e - 3)
    );
    return pr(i, r.length);
  }
}, Od = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, eL = {
  // Era
  G: function(t, r, e) {
    const n = t.getFullYear() > 0 ? 1 : 0;
    switch (r) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return e.era(n, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return e.era(n, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return e.era(n, { width: "wide" });
    }
  },
  // Year
  y: function(t, r, e) {
    if (r === "yo") {
      const n = t.getFullYear(), i = n > 0 ? n : 1 - n;
      return e.ordinalNumber(i, { unit: "year" });
    }
    return yl.y(t, r);
  },
  // Local week-numbering year
  Y: function(t, r, e, n) {
    const i = H_(t, n), a = i > 0 ? i : 1 - i;
    if (r === "YY") {
      const o = a % 100;
      return pr(o, 2);
    }
    return r === "Yo" ? e.ordinalNumber(a, { unit: "year" }) : pr(a, r.length);
  },
  // ISO week-numbering year
  R: function(t, r) {
    const e = wH(t);
    return pr(e, r.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, r) {
    const e = t.getFullYear();
    return pr(e, r.length);
  },
  // Quarter
  Q: function(t, r, e) {
    const n = Math.ceil((t.getMonth() + 1) / 3);
    switch (r) {
      // 1, 2, 3, 4
      case "Q":
        return String(n);
      // 01, 02, 03, 04
      case "QQ":
        return pr(n, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return e.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return e.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return e.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return e.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, r, e) {
    const n = Math.ceil((t.getMonth() + 1) / 3);
    switch (r) {
      // 1, 2, 3, 4
      case "q":
        return String(n);
      // 01, 02, 03, 04
      case "qq":
        return pr(n, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return e.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return e.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return e.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return e.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, r, e) {
    const n = t.getMonth();
    switch (r) {
      case "M":
      case "MM":
        return yl.M(t, r);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return e.ordinalNumber(n + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return e.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return e.month(n, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return e.month(n, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(t, r, e) {
    const n = t.getMonth();
    switch (r) {
      // 1, 2, ..., 12
      case "L":
        return String(n + 1);
      // 01, 02, ..., 12
      case "LL":
        return pr(n + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return e.ordinalNumber(n + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return e.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return e.month(n, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return e.month(n, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(t, r, e, n) {
    const i = DH(t, n);
    return r === "wo" ? e.ordinalNumber(i, { unit: "week" }) : pr(i, r.length);
  },
  // ISO week of year
  I: function(t, r, e) {
    const n = F_(t);
    return r === "Io" ? e.ordinalNumber(n, { unit: "week" }) : pr(n, r.length);
  },
  // Day of the month
  d: function(t, r, e) {
    return r === "do" ? e.ordinalNumber(t.getDate(), { unit: "date" }) : yl.d(t, r);
  },
  // Day of year
  D: function(t, r, e) {
    const n = Wve(t);
    return r === "Do" ? e.ordinalNumber(n, { unit: "dayOfYear" }) : pr(n, r.length);
  },
  // Day of week
  E: function(t, r, e) {
    const n = t.getDay();
    switch (r) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return e.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return e.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return e.day(n, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return e.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, r, e, n) {
    const i = t.getDay(), a = (i - n.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(a);
      // Padded numerical value
      case "ee":
        return pr(a, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return e.ordinalNumber(a, { unit: "day" });
      case "eee":
        return e.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return e.day(i, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return e.day(i, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return e.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, r, e, n) {
    const i = t.getDay(), a = (i - n.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      // Numerical value (same as in `e`)
      case "c":
        return String(a);
      // Padded numerical value
      case "cc":
        return pr(a, r.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return e.ordinalNumber(a, { unit: "day" });
      case "ccc":
        return e.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return e.day(i, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return e.day(i, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return e.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, r, e) {
    const n = t.getDay(), i = n === 0 ? 7 : n;
    switch (r) {
      // 2
      case "i":
        return String(i);
      // 02
      case "ii":
        return pr(i, r.length);
      // 2nd
      case "io":
        return e.ordinalNumber(i, { unit: "day" });
      // Tue
      case "iii":
        return e.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return e.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return e.day(n, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return e.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, r, e) {
    const i = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return e.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return e.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return e.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return e.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, r, e) {
    const n = t.getHours();
    let i;
    switch (n === 12 ? i = Od.noon : n === 0 ? i = Od.midnight : i = n / 12 >= 1 ? "pm" : "am", r) {
      case "b":
      case "bb":
        return e.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return e.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return e.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return e.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, r, e) {
    const n = t.getHours();
    let i;
    switch (n >= 17 ? i = Od.evening : n >= 12 ? i = Od.afternoon : n >= 4 ? i = Od.morning : i = Od.night, r) {
      case "B":
      case "BB":
      case "BBB":
        return e.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return e.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return e.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, r, e) {
    if (r === "ho") {
      let n = t.getHours() % 12;
      return n === 0 && (n = 12), e.ordinalNumber(n, { unit: "hour" });
    }
    return yl.h(t, r);
  },
  // Hour [0-23]
  H: function(t, r, e) {
    return r === "Ho" ? e.ordinalNumber(t.getHours(), { unit: "hour" }) : yl.H(t, r);
  },
  // Hour [0-11]
  K: function(t, r, e) {
    const n = t.getHours() % 12;
    return r === "Ko" ? e.ordinalNumber(n, { unit: "hour" }) : pr(n, r.length);
  },
  // Hour [1-24]
  k: function(t, r, e) {
    let n = t.getHours();
    return n === 0 && (n = 24), r === "ko" ? e.ordinalNumber(n, { unit: "hour" }) : pr(n, r.length);
  },
  // Minute
  m: function(t, r, e) {
    return r === "mo" ? e.ordinalNumber(t.getMinutes(), { unit: "minute" }) : yl.m(t, r);
  },
  // Second
  s: function(t, r, e) {
    return r === "so" ? e.ordinalNumber(t.getSeconds(), { unit: "second" }) : yl.s(t, r);
  },
  // Fraction of second
  S: function(t, r) {
    return yl.S(t, r);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, r, e) {
    const n = t.getTimezoneOffset();
    if (n === 0)
      return "Z";
    switch (r) {
      // Hours and optional minutes
      case "X":
        return rL(n);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return ec(n);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return ec(n, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, r, e) {
    const n = t.getTimezoneOffset();
    switch (r) {
      // Hours and optional minutes
      case "x":
        return rL(n);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return ec(n);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return ec(n, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, r, e) {
    const n = t.getTimezoneOffset();
    switch (r) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + tL(n, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + ec(n, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, r, e) {
    const n = t.getTimezoneOffset();
    switch (r) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + tL(n, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + ec(n, ":");
    }
  },
  // Seconds timestamp
  t: function(t, r, e) {
    const n = Math.trunc(t.getTime() / 1e3);
    return pr(n, r.length);
  },
  // Milliseconds timestamp
  T: function(t, r, e) {
    const n = t.getTime();
    return pr(n, r.length);
  }
};
function tL(t, r = "") {
  const e = t > 0 ? "-" : "+", n = Math.abs(t), i = Math.trunc(n / 60), a = n % 60;
  return a === 0 ? e + String(i) : e + String(i) + r + pr(a, 2);
}
function rL(t, r) {
  return t % 60 === 0 ? (t > 0 ? "-" : "+") + pr(Math.abs(t) / 60, 2) : ec(t, r);
}
function ec(t, r = "") {
  const e = t > 0 ? "-" : "+", n = Math.abs(t), i = pr(Math.trunc(n / 60), 2), a = pr(n % 60, 2);
  return e + i + r + a;
}
const nL = (t, r) => {
  switch (t) {
    case "P":
      return r.date({ width: "short" });
    case "PP":
      return r.date({ width: "medium" });
    case "PPP":
      return r.date({ width: "long" });
    case "PPPP":
    default:
      return r.date({ width: "full" });
  }
}, TH = (t, r) => {
  switch (t) {
    case "p":
      return r.time({ width: "short" });
    case "pp":
      return r.time({ width: "medium" });
    case "ppp":
      return r.time({ width: "long" });
    case "pppp":
    default:
      return r.time({ width: "full" });
  }
}, jve = (t, r) => {
  const e = t.match(/(P+)(p+)?/) || [], n = e[1], i = e[2];
  if (!i)
    return nL(t, r);
  let a;
  switch (n) {
    case "P":
      a = r.dateTime({ width: "short" });
      break;
    case "PP":
      a = r.dateTime({ width: "medium" });
      break;
    case "PPP":
      a = r.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      a = r.dateTime({ width: "full" });
      break;
  }
  return a.replace("{{date}}", nL(n, r)).replace("{{time}}", TH(i, r));
}, vy = {
  p: TH,
  P: jve
}, Yve = /^D+$/, Xve = /^Y+$/, $ve = ["D", "DD", "YY", "YYYY"];
function MH(t) {
  return Yve.test(t);
}
function RH(t) {
  return Xve.test(t);
}
function l6(t, r, e) {
  const n = Uve(t, r, e);
  if (console.warn(n), $ve.includes(t)) throw new RangeError(n);
}
function Uve(t, r, e) {
  const n = t[0] === "Y" ? "years" : "days of the month";
  return `Use \`${t.toLowerCase()}\` instead of \`${t}\` (in \`${r}\`) for formatting ${n} to the input \`${e}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const Jve = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Kve = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, qve = /^'([^]*?)'?$/, Qve = /''/g, ege = /[a-zA-Z]/;
function iL(t, r, e) {
  var c, d, f, h, p, v, g, m;
  const n = ad(), i = (e == null ? void 0 : e.locale) ?? n.locale ?? AH, a = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((d = (c = e == null ? void 0 : e.locale) == null ? void 0 : c.options) == null ? void 0 : d.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((h = (f = n.locale) == null ? void 0 : f.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, o = (e == null ? void 0 : e.weekStartsOn) ?? ((v = (p = e == null ? void 0 : e.locale) == null ? void 0 : p.options) == null ? void 0 : v.weekStartsOn) ?? n.weekStartsOn ?? ((m = (g = n.locale) == null ? void 0 : g.options) == null ? void 0 : m.weekStartsOn) ?? 0, s = Ne(t);
  if (!dy(s))
    throw new RangeError("Invalid time value");
  let l = r.match(Kve).map((y) => {
    const b = y[0];
    if (b === "p" || b === "P") {
      const C = vy[b];
      return C(y, i.formatLong);
    }
    return y;
  }).join("").match(Jve).map((y) => {
    if (y === "''")
      return { isToken: !1, value: "'" };
    const b = y[0];
    if (b === "'")
      return { isToken: !1, value: tge(y) };
    if (eL[b])
      return { isToken: !0, value: y };
    if (b.match(ege))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + b + "`"
      );
    return { isToken: !1, value: y };
  });
  i.localize.preprocessor && (l = i.localize.preprocessor(s, l));
  const u = {
    firstWeekContainsDate: a,
    weekStartsOn: o,
    locale: i
  };
  return l.map((y) => {
    if (!y.isToken) return y.value;
    const b = y.value;
    (!(e != null && e.useAdditionalWeekYearTokens) && RH(b) || !(e != null && e.useAdditionalDayOfYearTokens) && MH(b)) && l6(b, r, String(t));
    const C = eL[b[0]];
    return C(s, b, i.localize, u);
  }).join("");
}
function tge(t) {
  const r = t.match(qve);
  return r ? r[1].replace(Qve, "'") : t;
}
function aL(t) {
  return Ne(t).getDate();
}
function rge(t) {
  return Ne(t).getDay();
}
function nge(t) {
  const r = Ne(t), e = r.getFullYear(), n = r.getMonth(), i = gr(t, 0);
  return i.setFullYear(e, n + 1, 0), i.setHours(0, 0, 0, 0), i.getDate();
}
function ige() {
  return Object.assign({}, ad());
}
function Zo(t) {
  return Ne(t).getHours();
}
function age(t) {
  let e = Ne(t).getDay();
  return e === 0 && (e = 7), e;
}
function jo(t) {
  return Ne(t).getMinutes();
}
function sn(t) {
  return Ne(t).getMonth();
}
function Hs(t) {
  return Ne(t).getSeconds();
}
function u6(t) {
  return Ne(t).getTime();
}
function ht(t) {
  return Ne(t).getFullYear();
}
function au(t, r) {
  const e = Ne(t), n = Ne(r);
  return e.getTime() > n.getTime();
}
function Yc(t, r) {
  const e = Ne(t), n = Ne(r);
  return +e < +n;
}
function oge(t, r) {
  const e = Ne(t), n = Ne(r);
  return +e == +n;
}
function sge(t, r) {
  const e = r instanceof Date ? gr(r, 0) : new r(0);
  return e.setFullYear(
    t.getFullYear(),
    t.getMonth(),
    t.getDate()
  ), e.setHours(
    t.getHours(),
    t.getMinutes(),
    t.getSeconds(),
    t.getMilliseconds()
  ), e;
}
const lge = 10;
class LH {
  constructor() {
    Ve(this, "subPriority", 0);
  }
  validate(r, e) {
    return !0;
  }
}
class uge extends LH {
  constructor(r, e, n, i, a) {
    super(), this.value = r, this.validateValue = e, this.setValue = n, this.priority = i, a && (this.subPriority = a);
  }
  validate(r, e) {
    return this.validateValue(r, this.value, e);
  }
  set(r, e, n) {
    return this.setValue(r, e, this.value, n);
  }
}
class cge extends LH {
  constructor() {
    super(...arguments);
    Ve(this, "priority", lge);
    Ve(this, "subPriority", -1);
  }
  set(e, n) {
    return n.timestampIsSet ? e : gr(e, sge(e, Date));
  }
}
class ar {
  run(r, e, n, i) {
    const a = this.parse(r, e, n, i);
    return a ? {
      setter: new uge(
        a.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: a.rest
    } : null;
  }
  validate(r, e, n) {
    return !0;
  }
}
class dge extends ar {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 140);
    Ve(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(e, n, i) {
    switch (n) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return i.era(e, { width: "abbreviated" }) || i.era(e, { width: "narrow" });
      // A, B
      case "GGGGG":
        return i.era(e, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return i.era(e, { width: "wide" }) || i.era(e, { width: "abbreviated" }) || i.era(e, { width: "narrow" });
    }
  }
  set(e, n, i) {
    return n.era = i, e.setFullYear(i, 0, 1), e.setHours(0, 0, 0, 0), e;
  }
}
const ln = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, Eo = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function un(t, r) {
  return t && {
    value: r(t.value),
    rest: t.rest
  };
}
function Wr(t, r) {
  const e = r.match(t);
  return e ? {
    value: parseInt(e[0], 10),
    rest: r.slice(e[0].length)
  } : null;
}
function ko(t, r) {
  const e = r.match(t);
  if (!e)
    return null;
  if (e[0] === "Z")
    return {
      value: 0,
      rest: r.slice(1)
    };
  const n = e[1] === "+" ? 1 : -1, i = e[2] ? parseInt(e[2], 10) : 0, a = e[3] ? parseInt(e[3], 10) : 0, o = e[5] ? parseInt(e[5], 10) : 0;
  return {
    value: n * (i * G2 + a * V2 + o * nve),
    rest: r.slice(e[0].length)
  };
}
function EH(t) {
  return Wr(ln.anyDigitsSigned, t);
}
function tn(t, r) {
  switch (t) {
    case 1:
      return Wr(ln.singleDigit, r);
    case 2:
      return Wr(ln.twoDigits, r);
    case 3:
      return Wr(ln.threeDigits, r);
    case 4:
      return Wr(ln.fourDigits, r);
    default:
      return Wr(new RegExp("^\\d{1," + t + "}"), r);
  }
}
function gy(t, r) {
  switch (t) {
    case 1:
      return Wr(ln.singleDigitSigned, r);
    case 2:
      return Wr(ln.twoDigitsSigned, r);
    case 3:
      return Wr(ln.threeDigitsSigned, r);
    case 4:
      return Wr(ln.fourDigitsSigned, r);
    default:
      return Wr(new RegExp("^-?\\d{1," + t + "}"), r);
  }
}
function z_(t) {
  switch (t) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function kH(t, r) {
  const e = r > 0, n = e ? r : 1 - r;
  let i;
  if (n <= 50)
    i = t || 100;
  else {
    const a = n + 50, o = Math.trunc(a / 100) * 100, s = t >= a % 100;
    i = t + o - (s ? 100 : 0);
  }
  return e ? i : 1 - i;
}
function PH(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
class fge extends ar {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 130);
    Ve(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(e, n, i) {
    const a = (o) => ({
      year: o,
      isTwoDigitYear: n === "yy"
    });
    switch (n) {
      case "y":
        return un(tn(4, e), a);
      case "yo":
        return un(
          i.ordinalNumber(e, {
            unit: "year"
          }),
          a
        );
      default:
        return un(tn(n.length, e), a);
    }
  }
  validate(e, n) {
    return n.isTwoDigitYear || n.year > 0;
  }
  set(e, n, i) {
    const a = e.getFullYear();
    if (i.isTwoDigitYear) {
      const s = kH(
        i.year,
        a
      );
      return e.setFullYear(s, 0, 1), e.setHours(0, 0, 0, 0), e;
    }
    const o = !("era" in n) || n.era === 1 ? i.year : 1 - i.year;
    return e.setFullYear(o, 0, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class hge extends ar {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 130);
    Ve(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(e, n, i) {
    const a = (o) => ({
      year: o,
      isTwoDigitYear: n === "YY"
    });
    switch (n) {
      case "Y":
        return un(tn(4, e), a);
      case "Yo":
        return un(
          i.ordinalNumber(e, {
            unit: "year"
          }),
          a
        );
      default:
        return un(tn(n.length, e), a);
    }
  }
  validate(e, n) {
    return n.isTwoDigitYear || n.year > 0;
  }
  set(e, n, i, a) {
    const o = H_(e, a);
    if (i.isTwoDigitYear) {
      const l = kH(
        i.year,
        o
      );
      return e.setFullYear(
        l,
        0,
        a.firstWeekContainsDate
      ), e.setHours(0, 0, 0, 0), tl(e, a);
    }
    const s = !("era" in n) || n.era === 1 ? i.year : 1 - i.year;
    return e.setFullYear(s, 0, a.firstWeekContainsDate), e.setHours(0, 0, 0, 0), tl(e, a);
  }
}
class pge extends ar {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 130);
    Ve(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, n) {
    return gy(n === "R" ? 4 : n.length, e);
  }
  set(e, n, i) {
    const a = gr(e, 0);
    return a.setFullYear(i, 0, 4), a.setHours(0, 0, 0, 0), Vf(a);
  }
}
class vge extends ar {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 130);
    Ve(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(e, n) {
    return gy(n === "u" ? 4 : n.length, e);
  }
  set(e, n, i) {
    return e.setFullYear(i, 0, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class gge extends ar {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 120);
    Ve(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, n, i) {
    switch (n) {
      // 1, 2, 3, 4
      case "Q":
      case "QQ":
        return tn(n.length, e);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return i.ordinalNumber(e, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return i.quarter(e, {
          width: "abbreviated",
          context: "formatting"
        }) || i.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return i.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return i.quarter(e, {
          width: "wide",
          context: "formatting"
        }) || i.quarter(e, {
          width: "abbreviated",
          context: "formatting"
        }) || i.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(e, n) {
    return n >= 1 && n <= 4;
  }
  set(e, n, i) {
    return e.setMonth((i - 1) * 3, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class mge extends ar {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 120);
    Ve(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, n, i) {
    switch (n) {
      // 1, 2, 3, 4
      case "q":
      case "qq":
        return tn(n.length, e);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return i.ordinalNumber(e, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return i.quarter(e, {
          width: "abbreviated",
          context: "standalone"
        }) || i.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return i.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return i.quarter(e, {
          width: "wide",
          context: "standalone"
        }) || i.quarter(e, {
          width: "abbreviated",
          context: "standalone"
        }) || i.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(e, n) {
    return n >= 1 && n <= 4;
  }
  set(e, n, i) {
    return e.setMonth((i - 1) * 3, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class yge extends ar {
  constructor() {
    super(...arguments);
    Ve(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    Ve(this, "priority", 110);
  }
  parse(e, n, i) {
    const a = (o) => o - 1;
    switch (n) {
      // 1, 2, ..., 12
      case "M":
        return un(
          Wr(ln.month, e),
          a
        );
      // 01, 02, ..., 12
      case "MM":
        return un(tn(2, e), a);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return un(
          i.ordinalNumber(e, {
            unit: "month"
          }),
          a
        );
      // Jan, Feb, ..., Dec
      case "MMM":
        return i.month(e, {
          width: "abbreviated",
          context: "formatting"
        }) || i.month(e, { width: "narrow", context: "formatting" });
      // J, F, ..., D
      case "MMMMM":
        return i.month(e, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return i.month(e, { width: "wide", context: "formatting" }) || i.month(e, {
          width: "abbreviated",
          context: "formatting"
        }) || i.month(e, { width: "narrow", context: "formatting" });
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 11;
  }
  set(e, n, i) {
    return e.setMonth(i, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class bge extends ar {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 110);
    Ve(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, n, i) {
    const a = (o) => o - 1;
    switch (n) {
      // 1, 2, ..., 12
      case "L":
        return un(
          Wr(ln.month, e),
          a
        );
      // 01, 02, ..., 12
      case "LL":
        return un(tn(2, e), a);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return un(
          i.ordinalNumber(e, {
            unit: "month"
          }),
          a
        );
      // Jan, Feb, ..., Dec
      case "LLL":
        return i.month(e, {
          width: "abbreviated",
          context: "standalone"
        }) || i.month(e, { width: "narrow", context: "standalone" });
      // J, F, ..., D
      case "LLLLL":
        return i.month(e, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return i.month(e, { width: "wide", context: "standalone" }) || i.month(e, {
          width: "abbreviated",
          context: "standalone"
        }) || i.month(e, { width: "narrow", context: "standalone" });
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 11;
  }
  set(e, n, i) {
    return e.setMonth(i, 1), e.setHours(0, 0, 0, 0), e;
  }
}
function Cge(t, r, e) {
  const n = Ne(t), i = DH(n, e) - r;
  return n.setDate(n.getDate() - i * 7), n;
}
class wge extends ar {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 100);
    Ve(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(e, n, i) {
    switch (n) {
      case "w":
        return Wr(ln.week, e);
      case "wo":
        return i.ordinalNumber(e, { unit: "week" });
      default:
        return tn(n.length, e);
    }
  }
  validate(e, n) {
    return n >= 1 && n <= 53;
  }
  set(e, n, i, a) {
    return tl(Cge(e, i, a), a);
  }
}
function _ge(t, r) {
  const e = Ne(t), n = F_(e) - r;
  return e.setDate(e.getDate() - n * 7), e;
}
class xge extends ar {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 100);
    Ve(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, n, i) {
    switch (n) {
      case "I":
        return Wr(ln.week, e);
      case "Io":
        return i.ordinalNumber(e, { unit: "week" });
      default:
        return tn(n.length, e);
    }
  }
  validate(e, n) {
    return n >= 1 && n <= 53;
  }
  set(e, n, i) {
    return Vf(_ge(e, i));
  }
}
const Sge = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Ige = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class Age extends ar {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 90);
    Ve(this, "subPriority", 1);
    Ve(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, n, i) {
    switch (n) {
      case "d":
        return Wr(ln.date, e);
      case "do":
        return i.ordinalNumber(e, { unit: "date" });
      default:
        return tn(n.length, e);
    }
  }
  validate(e, n) {
    const i = e.getFullYear(), a = PH(i), o = e.getMonth();
    return a ? n >= 1 && n <= Ige[o] : n >= 1 && n <= Sge[o];
  }
  set(e, n, i) {
    return e.setDate(i), e.setHours(0, 0, 0, 0), e;
  }
}
class Dge extends ar {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 90);
    Ve(this, "subpriority", 1);
    Ve(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, n, i) {
    switch (n) {
      case "D":
      case "DD":
        return Wr(ln.dayOfYear, e);
      case "Do":
        return i.ordinalNumber(e, { unit: "date" });
      default:
        return tn(n.length, e);
    }
  }
  validate(e, n) {
    const i = e.getFullYear();
    return PH(i) ? n >= 1 && n <= 366 : n >= 1 && n <= 365;
  }
  set(e, n, i) {
    return e.setMonth(0, i), e.setHours(0, 0, 0, 0), e;
  }
}
function W_(t, r, e) {
  var d, f, h, p;
  const n = ad(), i = (e == null ? void 0 : e.weekStartsOn) ?? ((f = (d = e == null ? void 0 : e.locale) == null ? void 0 : d.options) == null ? void 0 : f.weekStartsOn) ?? n.weekStartsOn ?? ((p = (h = n.locale) == null ? void 0 : h.options) == null ? void 0 : p.weekStartsOn) ?? 0, a = Ne(t), o = a.getDay(), l = (r % 7 + 7) % 7, u = 7 - i, c = r < 0 || r > 6 ? r - (o + u) % 7 : (l + u) % 7 - (o + u) % 7;
  return el(a, c);
}
class Tge extends ar {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 90);
    Ve(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(e, n, i) {
    switch (n) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return i.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || i.day(e, { width: "short", context: "formatting" }) || i.day(e, { width: "narrow", context: "formatting" });
      // T
      case "EEEEE":
        return i.day(e, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return i.day(e, { width: "short", context: "formatting" }) || i.day(e, { width: "narrow", context: "formatting" });
      // Tuesday
      case "EEEE":
      default:
        return i.day(e, { width: "wide", context: "formatting" }) || i.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || i.day(e, { width: "short", context: "formatting" }) || i.day(e, { width: "narrow", context: "formatting" });
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 6;
  }
  set(e, n, i, a) {
    return e = W_(e, i, a), e.setHours(0, 0, 0, 0), e;
  }
}
class Mge extends ar {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 90);
    Ve(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, n, i, a) {
    const o = (s) => {
      const l = Math.floor((s - 1) / 7) * 7;
      return (s + a.weekStartsOn + 6) % 7 + l;
    };
    switch (n) {
      // 3
      case "e":
      case "ee":
        return un(tn(n.length, e), o);
      // 3rd
      case "eo":
        return un(
          i.ordinalNumber(e, {
            unit: "day"
          }),
          o
        );
      // Tue
      case "eee":
        return i.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || i.day(e, { width: "short", context: "formatting" }) || i.day(e, { width: "narrow", context: "formatting" });
      // T
      case "eeeee":
        return i.day(e, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return i.day(e, { width: "short", context: "formatting" }) || i.day(e, { width: "narrow", context: "formatting" });
      // Tuesday
      case "eeee":
      default:
        return i.day(e, { width: "wide", context: "formatting" }) || i.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || i.day(e, { width: "short", context: "formatting" }) || i.day(e, { width: "narrow", context: "formatting" });
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 6;
  }
  set(e, n, i, a) {
    return e = W_(e, i, a), e.setHours(0, 0, 0, 0), e;
  }
}
class Rge extends ar {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 90);
    Ve(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(e, n, i, a) {
    const o = (s) => {
      const l = Math.floor((s - 1) / 7) * 7;
      return (s + a.weekStartsOn + 6) % 7 + l;
    };
    switch (n) {
      // 3
      case "c":
      case "cc":
        return un(tn(n.length, e), o);
      // 3rd
      case "co":
        return un(
          i.ordinalNumber(e, {
            unit: "day"
          }),
          o
        );
      // Tue
      case "ccc":
        return i.day(e, {
          width: "abbreviated",
          context: "standalone"
        }) || i.day(e, { width: "short", context: "standalone" }) || i.day(e, { width: "narrow", context: "standalone" });
      // T
      case "ccccc":
        return i.day(e, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return i.day(e, { width: "short", context: "standalone" }) || i.day(e, { width: "narrow", context: "standalone" });
      // Tuesday
      case "cccc":
      default:
        return i.day(e, { width: "wide", context: "standalone" }) || i.day(e, {
          width: "abbreviated",
          context: "standalone"
        }) || i.day(e, { width: "short", context: "standalone" }) || i.day(e, { width: "narrow", context: "standalone" });
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 6;
  }
  set(e, n, i, a) {
    return e = W_(e, i, a), e.setHours(0, 0, 0, 0), e;
  }
}
function Lge(t, r) {
  const e = Ne(t), n = age(e), i = r - n;
  return el(e, i);
}
class Ege extends ar {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 90);
    Ve(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, n, i) {
    const a = (o) => o === 0 ? 7 : o;
    switch (n) {
      // 2
      case "i":
      case "ii":
        return tn(n.length, e);
      // 2nd
      case "io":
        return i.ordinalNumber(e, { unit: "day" });
      // Tue
      case "iii":
        return un(
          i.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(e, {
            width: "short",
            context: "formatting"
          }) || i.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
      // T
      case "iiiii":
        return un(
          i.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
      // Tu
      case "iiiiii":
        return un(
          i.day(e, {
            width: "short",
            context: "formatting"
          }) || i.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
      // Tuesday
      case "iiii":
      default:
        return un(
          i.day(e, {
            width: "wide",
            context: "formatting"
          }) || i.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(e, {
            width: "short",
            context: "formatting"
          }) || i.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
    }
  }
  validate(e, n) {
    return n >= 1 && n <= 7;
  }
  set(e, n, i) {
    return e = Lge(e, i), e.setHours(0, 0, 0, 0), e;
  }
}
class kge extends ar {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 80);
    Ve(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(e, n, i) {
    switch (n) {
      case "a":
      case "aa":
      case "aaa":
        return i.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return i.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return i.dayPeriod(e, {
          width: "wide",
          context: "formatting"
        }) || i.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(e, n, i) {
    return e.setHours(z_(i), 0, 0, 0), e;
  }
}
class Pge extends ar {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 80);
    Ve(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(e, n, i) {
    switch (n) {
      case "b":
      case "bb":
      case "bbb":
        return i.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return i.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return i.dayPeriod(e, {
          width: "wide",
          context: "formatting"
        }) || i.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(e, n, i) {
    return e.setHours(z_(i), 0, 0, 0), e;
  }
}
class Nge extends ar {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 80);
    Ve(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(e, n, i) {
    switch (n) {
      case "B":
      case "BB":
      case "BBB":
        return i.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return i.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return i.dayPeriod(e, {
          width: "wide",
          context: "formatting"
        }) || i.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(e, n, i) {
    return e.setHours(z_(i), 0, 0, 0), e;
  }
}
class Oge extends ar {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 70);
    Ve(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(e, n, i) {
    switch (n) {
      case "h":
        return Wr(ln.hour12h, e);
      case "ho":
        return i.ordinalNumber(e, { unit: "hour" });
      default:
        return tn(n.length, e);
    }
  }
  validate(e, n) {
    return n >= 1 && n <= 12;
  }
  set(e, n, i) {
    const a = e.getHours() >= 12;
    return a && i < 12 ? e.setHours(i + 12, 0, 0, 0) : !a && i === 12 ? e.setHours(0, 0, 0, 0) : e.setHours(i, 0, 0, 0), e;
  }
}
class Vge extends ar {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 70);
    Ve(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(e, n, i) {
    switch (n) {
      case "H":
        return Wr(ln.hour23h, e);
      case "Ho":
        return i.ordinalNumber(e, { unit: "hour" });
      default:
        return tn(n.length, e);
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 23;
  }
  set(e, n, i) {
    return e.setHours(i, 0, 0, 0), e;
  }
}
class Gge extends ar {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 70);
    Ve(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(e, n, i) {
    switch (n) {
      case "K":
        return Wr(ln.hour11h, e);
      case "Ko":
        return i.ordinalNumber(e, { unit: "hour" });
      default:
        return tn(n.length, e);
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 11;
  }
  set(e, n, i) {
    return e.getHours() >= 12 && i < 12 ? e.setHours(i + 12, 0, 0, 0) : e.setHours(i, 0, 0, 0), e;
  }
}
class Bge extends ar {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 70);
    Ve(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(e, n, i) {
    switch (n) {
      case "k":
        return Wr(ln.hour24h, e);
      case "ko":
        return i.ordinalNumber(e, { unit: "hour" });
      default:
        return tn(n.length, e);
    }
  }
  validate(e, n) {
    return n >= 1 && n <= 24;
  }
  set(e, n, i) {
    const a = i <= 24 ? i % 24 : i;
    return e.setHours(a, 0, 0, 0), e;
  }
}
class Fge extends ar {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 60);
    Ve(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(e, n, i) {
    switch (n) {
      case "m":
        return Wr(ln.minute, e);
      case "mo":
        return i.ordinalNumber(e, { unit: "minute" });
      default:
        return tn(n.length, e);
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 59;
  }
  set(e, n, i) {
    return e.setMinutes(i, 0, 0), e;
  }
}
class Hge extends ar {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 50);
    Ve(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(e, n, i) {
    switch (n) {
      case "s":
        return Wr(ln.second, e);
      case "so":
        return i.ordinalNumber(e, { unit: "second" });
      default:
        return tn(n.length, e);
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 59;
  }
  set(e, n, i) {
    return e.setSeconds(i, 0), e;
  }
}
class zge extends ar {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 30);
    Ve(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(e, n) {
    const i = (a) => Math.trunc(a * Math.pow(10, -n.length + 3));
    return un(tn(n.length, e), i);
  }
  set(e, n, i) {
    return e.setMilliseconds(i), e;
  }
}
class Wge extends ar {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 10);
    Ve(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(e, n) {
    switch (n) {
      case "X":
        return ko(
          Eo.basicOptionalMinutes,
          e
        );
      case "XX":
        return ko(Eo.basic, e);
      case "XXXX":
        return ko(
          Eo.basicOptionalSeconds,
          e
        );
      case "XXXXX":
        return ko(
          Eo.extendedOptionalSeconds,
          e
        );
      case "XXX":
      default:
        return ko(Eo.extended, e);
    }
  }
  set(e, n, i) {
    return n.timestampIsSet ? e : gr(
      e,
      e.getTime() - uy(e) - i
    );
  }
}
class Zge extends ar {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 10);
    Ve(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(e, n) {
    switch (n) {
      case "x":
        return ko(
          Eo.basicOptionalMinutes,
          e
        );
      case "xx":
        return ko(Eo.basic, e);
      case "xxxx":
        return ko(
          Eo.basicOptionalSeconds,
          e
        );
      case "xxxxx":
        return ko(
          Eo.extendedOptionalSeconds,
          e
        );
      case "xxx":
      default:
        return ko(Eo.extended, e);
    }
  }
  set(e, n, i) {
    return n.timestampIsSet ? e : gr(
      e,
      e.getTime() - uy(e) - i
    );
  }
}
class jge extends ar {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 40);
    Ve(this, "incompatibleTokens", "*");
  }
  parse(e) {
    return EH(e);
  }
  set(e, n, i) {
    return [gr(e, i * 1e3), { timestampIsSet: !0 }];
  }
}
class Yge extends ar {
  constructor() {
    super(...arguments);
    Ve(this, "priority", 20);
    Ve(this, "incompatibleTokens", "*");
  }
  parse(e) {
    return EH(e);
  }
  set(e, n, i) {
    return [gr(e, i), { timestampIsSet: !0 }];
  }
}
const Xge = {
  G: new dge(),
  y: new fge(),
  Y: new hge(),
  R: new pge(),
  u: new vge(),
  Q: new gge(),
  q: new mge(),
  M: new yge(),
  L: new bge(),
  w: new wge(),
  I: new xge(),
  d: new Age(),
  D: new Dge(),
  E: new Tge(),
  e: new Mge(),
  c: new Rge(),
  i: new Ege(),
  a: new kge(),
  b: new Pge(),
  B: new Nge(),
  h: new Oge(),
  H: new Vge(),
  K: new Gge(),
  k: new Bge(),
  m: new Fge(),
  s: new Hge(),
  S: new zge(),
  X: new Wge(),
  x: new Zge(),
  t: new jge(),
  T: new Yge()
}, $ge = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Uge = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Jge = /^'([^]*?)'?$/, Kge = /''/g, qge = /\S/, Qge = /[a-zA-Z]/;
function q3(t, r, e, n) {
  var v, g, m, y, b, C, w, _;
  const i = ige(), a = (n == null ? void 0 : n.locale) ?? i.locale ?? AH, o = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((g = (v = n == null ? void 0 : n.locale) == null ? void 0 : v.options) == null ? void 0 : g.firstWeekContainsDate) ?? i.firstWeekContainsDate ?? ((y = (m = i.locale) == null ? void 0 : m.options) == null ? void 0 : y.firstWeekContainsDate) ?? 1, s = (n == null ? void 0 : n.weekStartsOn) ?? ((C = (b = n == null ? void 0 : n.locale) == null ? void 0 : b.options) == null ? void 0 : C.weekStartsOn) ?? i.weekStartsOn ?? ((_ = (w = i.locale) == null ? void 0 : w.options) == null ? void 0 : _.weekStartsOn) ?? 0;
  if (r === "")
    return t === "" ? Ne(e) : gr(e, NaN);
  const l = {
    firstWeekContainsDate: o,
    weekStartsOn: s,
    locale: a
  }, u = [new cge()], c = r.match(Uge).map((x) => {
    const I = x[0];
    if (I in vy) {
      const D = vy[I];
      return D(x, a.formatLong);
    }
    return x;
  }).join("").match($ge), d = [];
  for (let x of c) {
    !(n != null && n.useAdditionalWeekYearTokens) && RH(x) && l6(x, r, t), !(n != null && n.useAdditionalDayOfYearTokens) && MH(x) && l6(x, r, t);
    const I = x[0], D = Xge[I];
    if (D) {
      const { incompatibleTokens: T } = D;
      if (Array.isArray(T)) {
        const M = d.find(
          (R) => T.includes(R.token) || R.token === I
        );
        if (M)
          throw new RangeError(
            `The format string mustn't contain \`${M.fullToken}\` and \`${x}\` at the same time`
          );
      } else if (D.incompatibleTokens === "*" && d.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${x}\` and any other token at the same time`
        );
      d.push({ token: I, fullToken: x });
      const A = D.run(
        t,
        x,
        a.match,
        l
      );
      if (!A)
        return gr(e, NaN);
      u.push(A.setter), t = A.rest;
    } else {
      if (I.match(Qge))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + I + "`"
        );
      if (x === "''" ? x = "'" : I === "'" && (x = e1e(x)), t.indexOf(x) === 0)
        t = t.slice(x.length);
      else
        return gr(e, NaN);
    }
  }
  if (t.length > 0 && qge.test(t))
    return gr(e, NaN);
  const f = u.map((x) => x.priority).sort((x, I) => I - x).filter((x, I, D) => D.indexOf(x) === I).map(
    (x) => u.filter((I) => I.priority === x).sort((I, D) => D.subPriority - I.subPriority)
  ).map((x) => x[0]);
  let h = Ne(e);
  if (isNaN(h.getTime()))
    return gr(e, NaN);
  const p = {};
  for (const x of f) {
    if (!x.validate(h, l))
      return gr(e, NaN);
    const I = x.set(h, p, l);
    Array.isArray(I) ? (h = I[0], Object.assign(p, I[1])) : h = I;
  }
  return gr(e, h);
}
function e1e(t) {
  return t.match(Jge)[1].replace(Kge, "'");
}
function t1e(t, r) {
  const e = Ne(t), n = Ne(r);
  return e.getFullYear() === n.getFullYear() && e.getMonth() === n.getMonth();
}
function r1e(t, r) {
  const e = s6(t), n = s6(r);
  return +e == +n;
}
function n1e(t, r) {
  const e = Ne(t), n = Ne(r);
  return e.getFullYear() === n.getFullYear();
}
function Hv(t, r) {
  const e = +Ne(t), [n, i] = [
    +Ne(r.start),
    +Ne(r.end)
  ].sort((a, o) => a - o);
  return e >= n && e <= i;
}
function i1e(t, r) {
  return el(t, -r);
}
function a1e(t, r) {
  const n = u1e(t);
  let i;
  if (n.date) {
    const l = c1e(n.date, 2);
    i = d1e(l.restDateString, l.year);
  }
  if (!i || isNaN(i.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  const a = i.getTime();
  let o = 0, s;
  if (n.time && (o = f1e(n.time), isNaN(o)))
    return /* @__PURE__ */ new Date(NaN);
  if (n.timezone) {
    if (s = h1e(n.timezone), isNaN(s))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    const l = new Date(a + o), u = /* @__PURE__ */ new Date(0);
    return u.setFullYear(
      l.getUTCFullYear(),
      l.getUTCMonth(),
      l.getUTCDate()
    ), u.setHours(
      l.getUTCHours(),
      l.getUTCMinutes(),
      l.getUTCSeconds(),
      l.getUTCMilliseconds()
    ), u;
  }
  return new Date(a + o + s);
}
const Q1 = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, o1e = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, s1e = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, l1e = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function u1e(t) {
  const r = {}, e = t.split(Q1.dateTimeDelimiter);
  let n;
  if (e.length > 2)
    return r;
  if (/:/.test(e[0]) ? n = e[0] : (r.date = e[0], n = e[1], Q1.timeZoneDelimiter.test(r.date) && (r.date = t.split(Q1.timeZoneDelimiter)[0], n = t.substr(
    r.date.length,
    t.length
  ))), n) {
    const i = Q1.timezone.exec(n);
    i ? (r.time = n.replace(i[1], ""), r.timezone = i[1]) : r.time = n;
  }
  return r;
}
function c1e(t, r) {
  const e = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + r) + "})|(\\d{2}|[+-]\\d{" + (2 + r) + "})$)"
  ), n = t.match(e);
  if (!n) return { year: NaN, restDateString: "" };
  const i = n[1] ? parseInt(n[1]) : null, a = n[2] ? parseInt(n[2]) : null;
  return {
    year: a === null ? i : a * 100,
    restDateString: t.slice((n[1] || n[2]).length)
  };
}
function d1e(t, r) {
  if (r === null) return /* @__PURE__ */ new Date(NaN);
  const e = t.match(o1e);
  if (!e) return /* @__PURE__ */ new Date(NaN);
  const n = !!e[4], i = hp(e[1]), a = hp(e[2]) - 1, o = hp(e[3]), s = hp(e[4]), l = hp(e[5]) - 1;
  if (n)
    return y1e(r, s, l) ? p1e(r, s, l) : /* @__PURE__ */ new Date(NaN);
  {
    const u = /* @__PURE__ */ new Date(0);
    return !g1e(r, a, o) || !m1e(r, i) ? /* @__PURE__ */ new Date(NaN) : (u.setUTCFullYear(r, a, Math.max(i, o)), u);
  }
}
function hp(t) {
  return t ? parseInt(t) : 1;
}
function f1e(t) {
  const r = t.match(s1e);
  if (!r) return NaN;
  const e = Q3(r[1]), n = Q3(r[2]), i = Q3(r[3]);
  return b1e(e, n, i) ? e * G2 + n * V2 + i * 1e3 : NaN;
}
function Q3(t) {
  return t && parseFloat(t.replace(",", ".")) || 0;
}
function h1e(t) {
  if (t === "Z") return 0;
  const r = t.match(l1e);
  if (!r) return 0;
  const e = r[1] === "+" ? -1 : 1, n = parseInt(r[2]), i = r[3] && parseInt(r[3]) || 0;
  return C1e(n, i) ? e * (n * G2 + i * V2) : NaN;
}
function p1e(t, r, e) {
  const n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(t, 0, 4);
  const i = n.getUTCDay() || 7, a = (r - 1) * 7 + e + 1 - i;
  return n.setUTCDate(n.getUTCDate() + a), n;
}
const v1e = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function NH(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
function g1e(t, r, e) {
  return r >= 0 && r <= 11 && e >= 1 && e <= (v1e[r] || (NH(t) ? 29 : 28));
}
function m1e(t, r) {
  return r >= 1 && r <= (NH(t) ? 366 : 365);
}
function y1e(t, r, e) {
  return r >= 1 && r <= 53 && e >= 0 && e <= 6;
}
function b1e(t, r, e) {
  return t === 24 ? r === 0 && e === 0 : e >= 0 && e < 60 && r >= 0 && r < 60 && t >= 0 && t < 25;
}
function C1e(t, r) {
  return r >= 0 && r <= 59;
}
function Zi(t, r) {
  const e = Ne(t), n = e.getFullYear(), i = e.getDate(), a = gr(t, 0);
  a.setFullYear(n, r, 15), a.setHours(0, 0, 0, 0);
  const o = nge(a);
  return e.setMonth(r, Math.min(i, o)), e;
}
function w1e(t, r) {
  let e = Ne(t);
  return isNaN(+e) ? gr(t, NaN) : (r.year != null && e.setFullYear(r.year), r.month != null && (e = Zi(e, r.month)), r.date != null && e.setDate(r.date), r.hours != null && e.setHours(r.hours), r.minutes != null && e.setMinutes(r.minutes), r.seconds != null && e.setSeconds(r.seconds), r.milliseconds != null && e.setMilliseconds(r.milliseconds), e);
}
function H0(t, r) {
  const e = Ne(t);
  return e.setHours(r), e;
}
function z0(t, r) {
  const e = Ne(t);
  return e.setMinutes(r), e;
}
function Xd(t, r) {
  const e = Ne(t), n = Math.trunc(e.getMonth() / 3) + 1, i = r - n;
  return Zi(e, e.getMonth() + i * 3);
}
function W0(t, r) {
  const e = Ne(t);
  return e.setSeconds(r), e;
}
function Ao(t, r) {
  const e = Ne(t);
  return isNaN(+e) ? gr(t, NaN) : (e.setFullYear(r), e);
}
function Bf(t, r) {
  return no(t, -r);
}
function OH(t, r) {
  return B_(t, -r);
}
function oL(t, r) {
  return cy(t, -r);
}
function Ff(t, r) {
  return Bs(t, -r);
}
function _1e() {
  return typeof window < "u";
}
function VH(t) {
  var r;
  return (t == null || (r = t.ownerDocument) == null ? void 0 : r.defaultView) || window;
}
function Vp(t) {
  return _1e() ? t instanceof Element || t instanceof VH(t).Element : !1;
}
function x1e(t) {
  return VH(t).getComputedStyle(t);
}
const Hf = Math.min, Rc = Math.max, my = Math.round, e0 = Math.floor, ou = (t) => ({
  x: t,
  y: t
}), S1e = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, I1e = {
  start: "end",
  end: "start"
};
function c6(t, r, e) {
  return Rc(t, Hf(r, e));
}
function Lg(t, r) {
  return typeof t == "function" ? t(r) : t;
}
function Xc(t) {
  return t.split("-")[0];
}
function Eg(t) {
  return t.split("-")[1];
}
function GH(t) {
  return t === "x" ? "y" : "x";
}
function Z_(t) {
  return t === "y" ? "height" : "width";
}
function zf(t) {
  return ["top", "bottom"].includes(Xc(t)) ? "y" : "x";
}
function j_(t) {
  return GH(zf(t));
}
function A1e(t, r, e) {
  e === void 0 && (e = !1);
  const n = Eg(t), i = j_(t), a = Z_(i);
  let o = i === "x" ? n === (e ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return r.reference[a] > r.floating[a] && (o = yy(o)), [o, yy(o)];
}
function D1e(t) {
  const r = yy(t);
  return [d6(t), r, d6(r)];
}
function d6(t) {
  return t.replace(/start|end/g, (r) => I1e[r]);
}
function T1e(t, r, e) {
  const n = ["left", "right"], i = ["right", "left"], a = ["top", "bottom"], o = ["bottom", "top"];
  switch (t) {
    case "top":
    case "bottom":
      return e ? r ? i : n : r ? n : i;
    case "left":
    case "right":
      return r ? a : o;
    default:
      return [];
  }
}
function M1e(t, r, e, n) {
  const i = Eg(t);
  let a = T1e(Xc(t), e === "start", n);
  return i && (a = a.map((o) => o + "-" + i), r && (a = a.concat(a.map(d6)))), a;
}
function yy(t) {
  return t.replace(/left|right|bottom|top/g, (r) => S1e[r]);
}
function R1e(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function BH(t) {
  return typeof t != "number" ? R1e(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function by(t) {
  const {
    x: r,
    y: e,
    width: n,
    height: i
  } = t;
  return {
    width: n,
    height: i,
    top: e,
    left: r,
    right: r + n,
    bottom: e + i,
    x: r,
    y: e
  };
}
function sL(t, r, e) {
  let {
    reference: n,
    floating: i
  } = t;
  const a = zf(r), o = j_(r), s = Z_(o), l = Xc(r), u = a === "y", c = n.x + n.width / 2 - i.width / 2, d = n.y + n.height / 2 - i.height / 2, f = n[s] / 2 - i[s] / 2;
  let h;
  switch (l) {
    case "top":
      h = {
        x: c,
        y: n.y - i.height
      };
      break;
    case "bottom":
      h = {
        x: c,
        y: n.y + n.height
      };
      break;
    case "right":
      h = {
        x: n.x + n.width,
        y: d
      };
      break;
    case "left":
      h = {
        x: n.x - i.width,
        y: d
      };
      break;
    default:
      h = {
        x: n.x,
        y: n.y
      };
  }
  switch (Eg(r)) {
    case "start":
      h[o] -= f * (e && u ? -1 : 1);
      break;
    case "end":
      h[o] += f * (e && u ? -1 : 1);
      break;
  }
  return h;
}
const L1e = async (t, r, e) => {
  const {
    placement: n = "bottom",
    strategy: i = "absolute",
    middleware: a = [],
    platform: o
  } = e, s = a.filter(Boolean), l = await (o.isRTL == null ? void 0 : o.isRTL(r));
  let u = await o.getElementRects({
    reference: t,
    floating: r,
    strategy: i
  }), {
    x: c,
    y: d
  } = sL(u, n, l), f = n, h = {}, p = 0;
  for (let v = 0; v < s.length; v++) {
    const {
      name: g,
      fn: m
    } = s[v], {
      x: y,
      y: b,
      data: C,
      reset: w
    } = await m({
      x: c,
      y: d,
      initialPlacement: n,
      placement: f,
      strategy: i,
      middlewareData: h,
      rects: u,
      platform: o,
      elements: {
        reference: t,
        floating: r
      }
    });
    c = y ?? c, d = b ?? d, h = {
      ...h,
      [g]: {
        ...h[g],
        ...C
      }
    }, w && p <= 50 && (p++, typeof w == "object" && (w.placement && (f = w.placement), w.rects && (u = w.rects === !0 ? await o.getElementRects({
      reference: t,
      floating: r,
      strategy: i
    }) : w.rects), {
      x: c,
      y: d
    } = sL(u, f, l)), v = -1);
  }
  return {
    x: c,
    y: d,
    placement: f,
    strategy: i,
    middlewareData: h
  };
};
async function FH(t, r) {
  var e;
  r === void 0 && (r = {});
  const {
    x: n,
    y: i,
    platform: a,
    rects: o,
    elements: s,
    strategy: l
  } = t, {
    boundary: u = "clippingAncestors",
    rootBoundary: c = "viewport",
    elementContext: d = "floating",
    altBoundary: f = !1,
    padding: h = 0
  } = Lg(r, t), p = BH(h), g = s[f ? d === "floating" ? "reference" : "floating" : d], m = by(await a.getClippingRect({
    element: (e = await (a.isElement == null ? void 0 : a.isElement(g))) == null || e ? g : g.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(s.floating)),
    boundary: u,
    rootBoundary: c,
    strategy: l
  })), y = d === "floating" ? {
    x: n,
    y: i,
    width: o.floating.width,
    height: o.floating.height
  } : o.reference, b = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(s.floating)), C = await (a.isElement == null ? void 0 : a.isElement(b)) ? await (a.getScale == null ? void 0 : a.getScale(b)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, w = by(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: y,
    offsetParent: b,
    strategy: l
  }) : y);
  return {
    top: (m.top - w.top + p.top) / C.y,
    bottom: (w.bottom - m.bottom + p.bottom) / C.y,
    left: (m.left - w.left + p.left) / C.x,
    right: (w.right - m.right + p.right) / C.x
  };
}
const E1e = (t) => ({
  name: "arrow",
  options: t,
  async fn(r) {
    const {
      x: e,
      y: n,
      placement: i,
      rects: a,
      platform: o,
      elements: s,
      middlewareData: l
    } = r, {
      element: u,
      padding: c = 0
    } = Lg(t, r) || {};
    if (u == null)
      return {};
    const d = BH(c), f = {
      x: e,
      y: n
    }, h = j_(i), p = Z_(h), v = await o.getDimensions(u), g = h === "y", m = g ? "top" : "left", y = g ? "bottom" : "right", b = g ? "clientHeight" : "clientWidth", C = a.reference[p] + a.reference[h] - f[h] - a.floating[p], w = f[h] - a.reference[h], _ = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(u));
    let x = _ ? _[b] : 0;
    (!x || !await (o.isElement == null ? void 0 : o.isElement(_))) && (x = s.floating[b] || a.floating[p]);
    const I = C / 2 - w / 2, D = x / 2 - v[p] / 2 - 1, T = Hf(d[m], D), A = Hf(d[y], D), M = T, R = x - v[p] - A, E = x / 2 - v[p] / 2 + I, k = c6(M, E, R), P = !l.arrow && Eg(i) != null && E !== k && a.reference[p] / 2 - (E < M ? T : A) - v[p] / 2 < 0, N = P ? E < M ? E - M : E - R : 0;
    return {
      [h]: f[h] + N,
      data: {
        [h]: k,
        centerOffset: E - k - N,
        ...P && {
          alignmentOffset: N
        }
      },
      reset: P
    };
  }
}), k1e = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(r) {
      var e, n;
      const {
        placement: i,
        middlewareData: a,
        rects: o,
        initialPlacement: s,
        platform: l,
        elements: u
      } = r, {
        mainAxis: c = !0,
        crossAxis: d = !0,
        fallbackPlacements: f,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: p = "none",
        flipAlignment: v = !0,
        ...g
      } = Lg(t, r);
      if ((e = a.arrow) != null && e.alignmentOffset)
        return {};
      const m = Xc(i), y = zf(s), b = Xc(s) === s, C = await (l.isRTL == null ? void 0 : l.isRTL(u.floating)), w = f || (b || !v ? [yy(s)] : D1e(s)), _ = p !== "none";
      !f && _ && w.push(...M1e(s, v, p, C));
      const x = [s, ...w], I = await FH(r, g), D = [];
      let T = ((n = a.flip) == null ? void 0 : n.overflows) || [];
      if (c && D.push(I[m]), d) {
        const E = A1e(i, o, C);
        D.push(I[E[0]], I[E[1]]);
      }
      if (T = [...T, {
        placement: i,
        overflows: D
      }], !D.every((E) => E <= 0)) {
        var A, M;
        const E = (((A = a.flip) == null ? void 0 : A.index) || 0) + 1, k = x[E];
        if (k)
          return {
            data: {
              index: E,
              overflows: T
            },
            reset: {
              placement: k
            }
          };
        let P = (M = T.filter((N) => N.overflows[0] <= 0).sort((N, O) => N.overflows[1] - O.overflows[1])[0]) == null ? void 0 : M.placement;
        if (!P)
          switch (h) {
            case "bestFit": {
              var R;
              const N = (R = T.filter((O) => {
                if (_) {
                  const W = zf(O.placement);
                  return W === y || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  W === "y";
                }
                return !0;
              }).map((O) => [O.placement, O.overflows.filter((W) => W > 0).reduce((W, V) => W + V, 0)]).sort((O, W) => O[1] - W[1])[0]) == null ? void 0 : R[0];
              N && (P = N);
              break;
            }
            case "initialPlacement":
              P = s;
              break;
          }
        if (i !== P)
          return {
            reset: {
              placement: P
            }
          };
      }
      return {};
    }
  };
};
async function P1e(t, r) {
  const {
    placement: e,
    platform: n,
    elements: i
  } = t, a = await (n.isRTL == null ? void 0 : n.isRTL(i.floating)), o = Xc(e), s = Eg(e), l = zf(e) === "y", u = ["left", "top"].includes(o) ? -1 : 1, c = a && l ? -1 : 1, d = Lg(r, t);
  let {
    mainAxis: f,
    crossAxis: h,
    alignmentAxis: p
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...d
  };
  return s && typeof p == "number" && (h = s === "end" ? p * -1 : p), l ? {
    x: h * c,
    y: f * u
  } : {
    x: f * u,
    y: h * c
  };
}
const N1e = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(r) {
      var e, n;
      const {
        x: i,
        y: a,
        placement: o,
        middlewareData: s
      } = r, l = await P1e(r, t);
      return o === ((e = s.offset) == null ? void 0 : e.placement) && (n = s.arrow) != null && n.alignmentOffset ? {} : {
        x: i + l.x,
        y: a + l.y,
        data: {
          ...l,
          placement: o
        }
      };
    }
  };
}, O1e = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(r) {
      const {
        x: e,
        y: n,
        placement: i
      } = r, {
        mainAxis: a = !0,
        crossAxis: o = !1,
        limiter: s = {
          fn: (g) => {
            let {
              x: m,
              y
            } = g;
            return {
              x: m,
              y
            };
          }
        },
        ...l
      } = Lg(t, r), u = {
        x: e,
        y: n
      }, c = await FH(r, l), d = zf(Xc(i)), f = GH(d);
      let h = u[f], p = u[d];
      if (a) {
        const g = f === "y" ? "top" : "left", m = f === "y" ? "bottom" : "right", y = h + c[g], b = h - c[m];
        h = c6(y, h, b);
      }
      if (o) {
        const g = d === "y" ? "top" : "left", m = d === "y" ? "bottom" : "right", y = p + c[g], b = p - c[m];
        p = c6(y, p, b);
      }
      const v = s.fn({
        ...r,
        [f]: h,
        [d]: p
      });
      return {
        ...v,
        data: {
          x: v.x - e,
          y: v.y - n
        }
      };
    }
  };
};
function mh(t) {
  return HH(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function Qi(t) {
  var r;
  return (t == null || (r = t.ownerDocument) == null ? void 0 : r.defaultView) || window;
}
function ol(t) {
  var r;
  return (r = (HH(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : r.documentElement;
}
function HH(t) {
  return t instanceof Node || t instanceof Qi(t).Node;
}
function io(t) {
  return t instanceof Element || t instanceof Qi(t).Element;
}
function es(t) {
  return t instanceof HTMLElement || t instanceof Qi(t).HTMLElement;
}
function lL(t) {
  return typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof Qi(t).ShadowRoot;
}
function kg(t) {
  const {
    overflow: r,
    overflowX: e,
    overflowY: n,
    display: i
  } = ao(t);
  return /auto|scroll|overlay|hidden|clip/.test(r + n + e) && !["inline", "contents"].includes(i);
}
function V1e(t) {
  return ["table", "td", "th"].includes(mh(t));
}
function F2(t) {
  return [":popover-open", ":modal"].some((r) => {
    try {
      return t.matches(r);
    } catch {
      return !1;
    }
  });
}
function Y_(t) {
  const r = X_(), e = io(t) ? ao(t) : t;
  return e.transform !== "none" || e.perspective !== "none" || (e.containerType ? e.containerType !== "normal" : !1) || !r && (e.backdropFilter ? e.backdropFilter !== "none" : !1) || !r && (e.filter ? e.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((n) => (e.willChange || "").includes(n)) || ["paint", "layout", "strict", "content"].some((n) => (e.contain || "").includes(n));
}
function G1e(t) {
  let r = su(t);
  for (; es(r) && !Wf(r); ) {
    if (Y_(r))
      return r;
    if (F2(r))
      return null;
    r = su(r);
  }
  return null;
}
function X_() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Wf(t) {
  return ["html", "body", "#document"].includes(mh(t));
}
function ao(t) {
  return Qi(t).getComputedStyle(t);
}
function H2(t) {
  return io(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function su(t) {
  if (mh(t) === "html")
    return t;
  const r = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    lL(t) && t.host || // Fallback.
    ol(t)
  );
  return lL(r) ? r.host : r;
}
function zH(t) {
  const r = su(t);
  return Wf(r) ? t.ownerDocument ? t.ownerDocument.body : t.body : es(r) && kg(r) ? r : zH(r);
}
function zv(t, r, e) {
  var n;
  r === void 0 && (r = []), e === void 0 && (e = !0);
  const i = zH(t), a = i === ((n = t.ownerDocument) == null ? void 0 : n.body), o = Qi(i);
  if (a) {
    const s = f6(o);
    return r.concat(o, o.visualViewport || [], kg(i) ? i : [], s && e ? zv(s) : []);
  }
  return r.concat(i, zv(i, [], e));
}
function f6(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
function WH(t) {
  const r = ao(t);
  let e = parseFloat(r.width) || 0, n = parseFloat(r.height) || 0;
  const i = es(t), a = i ? t.offsetWidth : e, o = i ? t.offsetHeight : n, s = my(e) !== a || my(n) !== o;
  return s && (e = a, n = o), {
    width: e,
    height: n,
    $: s
  };
}
function $_(t) {
  return io(t) ? t : t.contextElement;
}
function yf(t) {
  const r = $_(t);
  if (!es(r))
    return ou(1);
  const e = r.getBoundingClientRect(), {
    width: n,
    height: i,
    $: a
  } = WH(r);
  let o = (a ? my(e.width) : e.width) / n, s = (a ? my(e.height) : e.height) / i;
  return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: o,
    y: s
  };
}
const B1e = /* @__PURE__ */ ou(0);
function ZH(t) {
  const r = Qi(t);
  return !X_() || !r.visualViewport ? B1e : {
    x: r.visualViewport.offsetLeft,
    y: r.visualViewport.offsetTop
  };
}
function F1e(t, r, e) {
  return r === void 0 && (r = !1), !e || r && e !== Qi(t) ? !1 : r;
}
function $c(t, r, e, n) {
  r === void 0 && (r = !1), e === void 0 && (e = !1);
  const i = t.getBoundingClientRect(), a = $_(t);
  let o = ou(1);
  r && (n ? io(n) && (o = yf(n)) : o = yf(t));
  const s = F1e(a, e, n) ? ZH(a) : ou(0);
  let l = (i.left + s.x) / o.x, u = (i.top + s.y) / o.y, c = i.width / o.x, d = i.height / o.y;
  if (a) {
    const f = Qi(a), h = n && io(n) ? Qi(n) : n;
    let p = f, v = f6(p);
    for (; v && n && h !== p; ) {
      const g = yf(v), m = v.getBoundingClientRect(), y = ao(v), b = m.left + (v.clientLeft + parseFloat(y.paddingLeft)) * g.x, C = m.top + (v.clientTop + parseFloat(y.paddingTop)) * g.y;
      l *= g.x, u *= g.y, c *= g.x, d *= g.y, l += b, u += C, p = Qi(v), v = f6(p);
    }
  }
  return by({
    width: c,
    height: d,
    x: l,
    y: u
  });
}
function H1e(t) {
  let {
    elements: r,
    rect: e,
    offsetParent: n,
    strategy: i
  } = t;
  const a = i === "fixed", o = ol(n), s = r ? F2(r.floating) : !1;
  if (n === o || s && a)
    return e;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = ou(1);
  const c = ou(0), d = es(n);
  if ((d || !d && !a) && ((mh(n) !== "body" || kg(o)) && (l = H2(n)), es(n))) {
    const f = $c(n);
    u = yf(n), c.x = f.x + n.clientLeft, c.y = f.y + n.clientTop;
  }
  return {
    width: e.width * u.x,
    height: e.height * u.y,
    x: e.x * u.x - l.scrollLeft * u.x + c.x,
    y: e.y * u.y - l.scrollTop * u.y + c.y
  };
}
function z1e(t) {
  return Array.from(t.getClientRects());
}
function jH(t) {
  return $c(ol(t)).left + H2(t).scrollLeft;
}
function W1e(t) {
  const r = ol(t), e = H2(t), n = t.ownerDocument.body, i = Rc(r.scrollWidth, r.clientWidth, n.scrollWidth, n.clientWidth), a = Rc(r.scrollHeight, r.clientHeight, n.scrollHeight, n.clientHeight);
  let o = -e.scrollLeft + jH(t);
  const s = -e.scrollTop;
  return ao(n).direction === "rtl" && (o += Rc(r.clientWidth, n.clientWidth) - i), {
    width: i,
    height: a,
    x: o,
    y: s
  };
}
function Z1e(t, r) {
  const e = Qi(t), n = ol(t), i = e.visualViewport;
  let a = n.clientWidth, o = n.clientHeight, s = 0, l = 0;
  if (i) {
    a = i.width, o = i.height;
    const u = X_();
    (!u || u && r === "fixed") && (s = i.offsetLeft, l = i.offsetTop);
  }
  return {
    width: a,
    height: o,
    x: s,
    y: l
  };
}
function j1e(t, r) {
  const e = $c(t, !0, r === "fixed"), n = e.top + t.clientTop, i = e.left + t.clientLeft, a = es(t) ? yf(t) : ou(1), o = t.clientWidth * a.x, s = t.clientHeight * a.y, l = i * a.x, u = n * a.y;
  return {
    width: o,
    height: s,
    x: l,
    y: u
  };
}
function uL(t, r, e) {
  let n;
  if (r === "viewport")
    n = Z1e(t, e);
  else if (r === "document")
    n = W1e(ol(t));
  else if (io(r))
    n = j1e(r, e);
  else {
    const i = ZH(t);
    n = {
      ...r,
      x: r.x - i.x,
      y: r.y - i.y
    };
  }
  return by(n);
}
function YH(t, r) {
  const e = su(t);
  return e === r || !io(e) || Wf(e) ? !1 : ao(e).position === "fixed" || YH(e, r);
}
function Y1e(t, r) {
  const e = r.get(t);
  if (e)
    return e;
  let n = zv(t, [], !1).filter((s) => io(s) && mh(s) !== "body"), i = null;
  const a = ao(t).position === "fixed";
  let o = a ? su(t) : t;
  for (; io(o) && !Wf(o); ) {
    const s = ao(o), l = Y_(o);
    !l && s.position === "fixed" && (i = null), (a ? !l && !i : !l && s.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || kg(o) && !l && YH(t, o)) ? n = n.filter((c) => c !== o) : i = s, o = su(o);
  }
  return r.set(t, n), n;
}
function X1e(t) {
  let {
    element: r,
    boundary: e,
    rootBoundary: n,
    strategy: i
  } = t;
  const o = [...e === "clippingAncestors" ? F2(r) ? [] : Y1e(r, this._c) : [].concat(e), n], s = o[0], l = o.reduce((u, c) => {
    const d = uL(r, c, i);
    return u.top = Rc(d.top, u.top), u.right = Hf(d.right, u.right), u.bottom = Hf(d.bottom, u.bottom), u.left = Rc(d.left, u.left), u;
  }, uL(r, s, i));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function $1e(t) {
  const {
    width: r,
    height: e
  } = WH(t);
  return {
    width: r,
    height: e
  };
}
function U1e(t, r, e) {
  const n = es(r), i = ol(r), a = e === "fixed", o = $c(t, !0, a, r);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = ou(0);
  if (n || !n && !a)
    if ((mh(r) !== "body" || kg(i)) && (s = H2(r)), n) {
      const d = $c(r, !0, a, r);
      l.x = d.x + r.clientLeft, l.y = d.y + r.clientTop;
    } else i && (l.x = jH(i));
  const u = o.left + s.scrollLeft - l.x, c = o.top + s.scrollTop - l.y;
  return {
    x: u,
    y: c,
    width: o.width,
    height: o.height
  };
}
function e4(t) {
  return ao(t).position === "static";
}
function cL(t, r) {
  return !es(t) || ao(t).position === "fixed" ? null : r ? r(t) : t.offsetParent;
}
function XH(t, r) {
  const e = Qi(t);
  if (F2(t))
    return e;
  if (!es(t)) {
    let i = su(t);
    for (; i && !Wf(i); ) {
      if (io(i) && !e4(i))
        return i;
      i = su(i);
    }
    return e;
  }
  let n = cL(t, r);
  for (; n && V1e(n) && e4(n); )
    n = cL(n, r);
  return n && Wf(n) && e4(n) && !Y_(n) ? e : n || G1e(t) || e;
}
const J1e = async function(t) {
  const r = this.getOffsetParent || XH, e = this.getDimensions, n = await e(t.floating);
  return {
    reference: U1e(t.reference, await r(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: n.width,
      height: n.height
    }
  };
};
function K1e(t) {
  return ao(t).direction === "rtl";
}
const q1e = {
  convertOffsetParentRelativeRectToViewportRelativeRect: H1e,
  getDocumentElement: ol,
  getClippingRect: X1e,
  getOffsetParent: XH,
  getElementRects: J1e,
  getClientRects: z1e,
  getDimensions: $1e,
  getScale: yf,
  isElement: io,
  isRTL: K1e
};
function Q1e(t, r) {
  let e = null, n;
  const i = ol(t);
  function a() {
    var s;
    clearTimeout(n), (s = e) == null || s.disconnect(), e = null;
  }
  function o(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), a();
    const {
      left: u,
      top: c,
      width: d,
      height: f
    } = t.getBoundingClientRect();
    if (s || r(), !d || !f)
      return;
    const h = e0(c), p = e0(i.clientWidth - (u + d)), v = e0(i.clientHeight - (c + f)), g = e0(u), y = {
      rootMargin: -h + "px " + -p + "px " + -v + "px " + -g + "px",
      threshold: Rc(0, Hf(1, l)) || 1
    };
    let b = !0;
    function C(w) {
      const _ = w[0].intersectionRatio;
      if (_ !== l) {
        if (!b)
          return o();
        _ ? o(!1, _) : n = setTimeout(() => {
          o(!1, 1e-7);
        }, 1e3);
      }
      b = !1;
    }
    try {
      e = new IntersectionObserver(C, {
        ...y,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      e = new IntersectionObserver(C, y);
    }
    e.observe(t);
  }
  return o(!0), a;
}
function $H(t, r, e, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: a = !0,
    elementResize: o = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = n, u = $_(t), c = i || a ? [...u ? zv(u) : [], ...zv(r)] : [];
  c.forEach((m) => {
    i && m.addEventListener("scroll", e, {
      passive: !0
    }), a && m.addEventListener("resize", e);
  });
  const d = u && s ? Q1e(u, e) : null;
  let f = -1, h = null;
  o && (h = new ResizeObserver((m) => {
    let [y] = m;
    y && y.target === u && h && (h.unobserve(r), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var b;
      (b = h) == null || b.observe(r);
    })), e();
  }), u && !l && h.observe(u), h.observe(r));
  let p, v = l ? $c(t) : null;
  l && g();
  function g() {
    const m = $c(t);
    v && (m.x !== v.x || m.y !== v.y || m.width !== v.width || m.height !== v.height) && e(), v = m, p = requestAnimationFrame(g);
  }
  return e(), () => {
    var m;
    c.forEach((y) => {
      i && y.removeEventListener("scroll", e), a && y.removeEventListener("resize", e);
    }), d == null || d(), (m = h) == null || m.disconnect(), h = null, l && cancelAnimationFrame(p);
  };
}
const UH = N1e, e0e = O1e, JH = k1e, h6 = E1e, p6 = (t, r, e) => {
  const n = /* @__PURE__ */ new Map(), i = {
    platform: q1e,
    ...e
  }, a = {
    ...i.platform,
    _c: n
  };
  return L1e(t, r, {
    ...i,
    platform: a
  });
};
var Z0 = typeof document < "u" ? ag : Ue;
function Cy(t, r) {
  if (t === r)
    return !0;
  if (typeof t != typeof r)
    return !1;
  if (typeof t == "function" && t.toString() === r.toString())
    return !0;
  let e, n, i;
  if (t && r && typeof t == "object") {
    if (Array.isArray(t)) {
      if (e = t.length, e !== r.length) return !1;
      for (n = e; n-- !== 0; )
        if (!Cy(t[n], r[n]))
          return !1;
      return !0;
    }
    if (i = Object.keys(t), e = i.length, e !== Object.keys(r).length)
      return !1;
    for (n = e; n-- !== 0; )
      if (!{}.hasOwnProperty.call(r, i[n]))
        return !1;
    for (n = e; n-- !== 0; ) {
      const a = i[n];
      if (!(a === "_owner" && t.$$typeof) && !Cy(t[a], r[a]))
        return !1;
    }
    return !0;
  }
  return t !== t && r !== r;
}
function KH(t) {
  return typeof window > "u" ? 1 : (t.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function dL(t, r) {
  const e = KH(t);
  return Math.round(r * e) / e;
}
function t4(t) {
  const r = $.useRef(t);
  return Z0(() => {
    r.current = t;
  }), r;
}
function t0e(t) {
  t === void 0 && (t = {});
  const {
    placement: r = "bottom",
    strategy: e = "absolute",
    middleware: n = [],
    platform: i,
    elements: {
      reference: a,
      floating: o
    } = {},
    transform: s = !0,
    whileElementsMounted: l,
    open: u
  } = t, [c, d] = $.useState({
    x: 0,
    y: 0,
    strategy: e,
    placement: r,
    middlewareData: {},
    isPositioned: !1
  }), [f, h] = $.useState(n);
  Cy(f, n) || h(n);
  const [p, v] = $.useState(null), [g, m] = $.useState(null), y = $.useCallback((O) => {
    O !== _.current && (_.current = O, v(O));
  }, []), b = $.useCallback((O) => {
    O !== x.current && (x.current = O, m(O));
  }, []), C = a || p, w = o || g, _ = $.useRef(null), x = $.useRef(null), I = $.useRef(c), D = l != null, T = t4(l), A = t4(i), M = t4(u), R = $.useCallback(() => {
    if (!_.current || !x.current)
      return;
    const O = {
      placement: r,
      strategy: e,
      middleware: f
    };
    A.current && (O.platform = A.current), p6(_.current, x.current, O).then((W) => {
      const V = {
        ...W,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: M.current !== !1
      };
      E.current && !Cy(I.current, V) && (I.current = V, vY.flushSync(() => {
        d(V);
      }));
    });
  }, [f, r, e, A, M]);
  Z0(() => {
    u === !1 && I.current.isPositioned && (I.current.isPositioned = !1, d((O) => ({
      ...O,
      isPositioned: !1
    })));
  }, [u]);
  const E = $.useRef(!1);
  Z0(() => (E.current = !0, () => {
    E.current = !1;
  }), []), Z0(() => {
    if (C && (_.current = C), w && (x.current = w), C && w) {
      if (T.current)
        return T.current(C, w, R);
      R();
    }
  }, [C, w, R, T, D]);
  const k = $.useMemo(() => ({
    reference: _,
    floating: x,
    setReference: y,
    setFloating: b
  }), [y, b]), P = $.useMemo(() => ({
    reference: C,
    floating: w
  }), [C, w]), N = $.useMemo(() => {
    const O = {
      position: e,
      left: 0,
      top: 0
    };
    if (!P.floating)
      return O;
    const W = dL(P.floating, c.x), V = dL(P.floating, c.y);
    return s ? {
      ...O,
      transform: "translate(" + W + "px, " + V + "px)",
      ...KH(P.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: e,
      left: W,
      top: V
    };
  }, [e, s, P.floating, c.x, c.y]);
  return $.useMemo(() => ({
    ...c,
    update: R,
    refs: k,
    elements: P,
    floatingStyles: N
  }), [c, R, k, P, N]);
}
const r0e = (t) => {
  function r(e) {
    return {}.hasOwnProperty.call(e, "current");
  }
  return {
    name: "arrow",
    options: t,
    fn(e) {
      const {
        element: n,
        padding: i
      } = typeof t == "function" ? t(e) : t;
      return n && r(n) ? n.current != null ? h6({
        element: n.current,
        padding: i
      }).fn(e) : {} : n ? h6({
        element: n,
        padding: i
      }).fn(e) : {};
    }
  };
}, n0e = (t, r) => ({
  ...UH(t),
  options: [t, r]
}), i0e = (t, r) => ({
  ...JH(t),
  options: [t, r]
}), a0e = (t, r) => ({
  ...r0e(t),
  options: [t, r]
}), qH = {
  ...$
}, o0e = qH.useInsertionEffect, s0e = o0e || ((t) => t());
function l0e(t) {
  const r = $.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return s0e(() => {
    r.current = t;
  }), $.useCallback(function() {
    for (var e = arguments.length, n = new Array(e), i = 0; i < e; i++)
      n[i] = arguments[i];
    return r.current == null ? void 0 : r.current(...n);
  }, []);
}
var wy = typeof document < "u" ? ag : Ue;
function v6() {
  return v6 = Object.assign ? Object.assign.bind() : function(t) {
    for (var r = 1; r < arguments.length; r++) {
      var e = arguments[r];
      for (var n in e)
        Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    }
    return t;
  }, v6.apply(this, arguments);
}
let fL = !1, u0e = 0;
const hL = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + u0e++
);
function c0e() {
  const [t, r] = $.useState(() => fL ? hL() : void 0);
  return wy(() => {
    t == null && r(hL());
  }, []), $.useEffect(() => {
    fL = !0;
  }, []), t;
}
const d0e = qH.useId, QH = d0e || c0e;
let Wv;
process.env.NODE_ENV !== "production" && (Wv = /* @__PURE__ */ new Set());
function f0e() {
  for (var t, r = arguments.length, e = new Array(r), n = 0; n < r; n++)
    e[n] = arguments[n];
  const i = "Floating UI: " + e.join(" ");
  if (!((t = Wv) != null && t.has(i))) {
    var a;
    (a = Wv) == null || a.add(i), console.warn(i);
  }
}
function h0e() {
  for (var t, r = arguments.length, e = new Array(r), n = 0; n < r; n++)
    e[n] = arguments[n];
  const i = "Floating UI: " + e.join(" ");
  if (!((t = Wv) != null && t.has(i))) {
    var a;
    (a = Wv) == null || a.add(i), console.error(i);
  }
}
const p0e = /* @__PURE__ */ $.forwardRef(function(r, e) {
  const {
    context: {
      placement: n,
      elements: {
        floating: i
      },
      middlewareData: {
        arrow: a,
        shift: o
      }
    },
    width: s = 14,
    height: l = 7,
    tipRadius: u = 0,
    strokeWidth: c = 0,
    staticOffset: d,
    stroke: f,
    d: h,
    style: {
      transform: p,
      ...v
    } = {},
    ...g
  } = r;
  process.env.NODE_ENV !== "production" && (e || f0e("The `ref` prop is required for `FloatingArrow`."));
  const m = QH(), [y, b] = $.useState(!1);
  if (wy(() => {
    if (!i) return;
    x1e(i).direction === "rtl" && b(!0);
  }, [i]), !i)
    return null;
  const [C, w] = n.split("-"), _ = C === "top" || C === "bottom";
  let x = d;
  (_ && o != null && o.x || !_ && o != null && o.y) && (x = null);
  const I = c * 2, D = I / 2, T = s / 2 * (u / -8 + 1), A = l / 2 * u / 4, M = !!h, R = x && w === "end" ? "bottom" : "top";
  let E = x && w === "end" ? "right" : "left";
  x && y && (E = w === "end" ? "left" : "right");
  const k = (a == null ? void 0 : a.x) != null ? x || a.x : "", P = (a == null ? void 0 : a.y) != null ? x || a.y : "", N = h || "M0,0" + (" H" + s) + (" L" + (s - T) + "," + (l - A)) + (" Q" + s / 2 + "," + l + " " + T + "," + (l - A)) + " Z", O = {
    top: M ? "rotate(180deg)" : "",
    left: M ? "rotate(90deg)" : "rotate(-90deg)",
    bottom: M ? "" : "rotate(180deg)",
    right: M ? "rotate(-90deg)" : "rotate(90deg)"
  }[C];
  return /* @__PURE__ */ $.createElement("svg", v6({}, g, {
    "aria-hidden": !0,
    ref: e,
    width: M ? s : s + I,
    height: s,
    viewBox: "0 0 " + s + " " + (l > s ? l : s),
    style: {
      position: "absolute",
      pointerEvents: "none",
      [E]: k,
      [R]: P,
      [C]: _ || M ? "100%" : "calc(100% - " + I / 2 + "px)",
      transform: [O, p].filter((W) => !!W).join(" "),
      ...v
    }
  }), I > 0 && /* @__PURE__ */ $.createElement("path", {
    clipPath: "url(#" + m + ")",
    fill: "none",
    stroke: f,
    strokeWidth: I + (h ? 0 : 1),
    d: N
  }), /* @__PURE__ */ $.createElement("path", {
    stroke: I && !h ? g.fill : "none",
    d: N
  }), /* @__PURE__ */ $.createElement("clipPath", {
    id: m
  }, /* @__PURE__ */ $.createElement("rect", {
    x: -D,
    y: D * (M ? -1 : 1),
    width: s + I,
    height: s
  })));
});
function v0e() {
  const t = /* @__PURE__ */ new Map();
  return {
    emit(r, e) {
      var n;
      (n = t.get(r)) == null || n.forEach((i) => i(e));
    },
    on(r, e) {
      t.set(r, [...t.get(r) || [], e]);
    },
    off(r, e) {
      var n;
      t.set(r, ((n = t.get(r)) == null ? void 0 : n.filter((i) => i !== e)) || []);
    }
  };
}
const g0e = /* @__PURE__ */ $.createContext(null), m0e = /* @__PURE__ */ $.createContext(null), y0e = () => {
  var t;
  return ((t = $.useContext(g0e)) == null ? void 0 : t.id) || null;
}, b0e = () => $.useContext(m0e);
function C0e(t) {
  const {
    open: r = !1,
    onOpenChange: e,
    elements: n
  } = t, i = QH(), a = $.useRef({}), [o] = $.useState(() => v0e()), s = y0e() != null;
  if (process.env.NODE_ENV !== "production") {
    const h = n.reference;
    h && !Vp(h) && h0e("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  const [l, u] = $.useState(n.reference), c = l0e((h, p, v) => {
    a.current.openEvent = h ? p : void 0, o.emit("openchange", {
      open: h,
      event: p,
      reason: v,
      nested: s
    }), e == null || e(h, p, v);
  }), d = $.useMemo(() => ({
    setPositionReference: u
  }), []), f = $.useMemo(() => ({
    reference: l || n.reference || null,
    floating: n.floating || null,
    domReference: n.reference
  }), [l, n.reference, n.floating]);
  return $.useMemo(() => ({
    dataRef: a,
    open: r,
    onOpenChange: c,
    elements: f,
    events: o,
    floatingId: i,
    refs: d
  }), [r, c, f, o, i, d]);
}
function w0e(t) {
  t === void 0 && (t = {});
  const {
    nodeId: r
  } = t, e = C0e({
    ...t,
    elements: {
      reference: null,
      floating: null,
      ...t.elements
    }
  }), n = t.rootContext || e, i = n.elements, [a, o] = $.useState(null), [s, l] = $.useState(null), c = (i == null ? void 0 : i.reference) || a, d = $.useRef(null), f = b0e();
  wy(() => {
    c && (d.current = c);
  }, [c]);
  const h = t0e({
    ...t,
    elements: {
      ...i,
      ...s && {
        reference: s
      }
    }
  }), p = $.useCallback((b) => {
    const C = Vp(b) ? {
      getBoundingClientRect: () => b.getBoundingClientRect(),
      contextElement: b
    } : b;
    l(C), h.refs.setReference(C);
  }, [h.refs]), v = $.useCallback((b) => {
    (Vp(b) || b === null) && (d.current = b, o(b)), (Vp(h.refs.reference.current) || h.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    b !== null && !Vp(b)) && h.refs.setReference(b);
  }, [h.refs]), g = $.useMemo(() => ({
    ...h.refs,
    setReference: v,
    setPositionReference: p,
    domReference: d
  }), [h.refs, v, p]), m = $.useMemo(() => ({
    ...h.elements,
    domReference: c
  }), [h.elements, c]), y = $.useMemo(() => ({
    ...h,
    ...n,
    refs: g,
    elements: m,
    nodeId: r
  }), [h, g, m, r, n]);
  return wy(() => {
    n.dataRef.current.floatingContext = y;
    const b = f == null ? void 0 : f.nodesRef.current.find((C) => C.id === r);
    b && (b.context = y);
  }), $.useMemo(() => ({
    ...h,
    context: y,
    refs: g,
    elements: m
  }), [h, g, m, y]);
}
/*!
  react-datepicker v7.5.0
  https://github.com/Hacker0x01/react-datepicker
  Released under the MIT License.
*/
var g6 = function(r, e) {
  return g6 = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function(n, i) {
    n.__proto__ = i;
  } || function(n, i) {
    for (var a in i) Object.prototype.hasOwnProperty.call(i, a) && (n[a] = i[a]);
  }, g6(r, e);
};
function kn(t, r) {
  if (typeof r != "function" && r !== null) throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
  g6(t, r);
  function e() {
    this.constructor = t;
  }
  t.prototype = r === null ? Object.create(r) : (e.prototype = r.prototype, new e());
}
var Jt = function() {
  return Jt = Object.assign || function(e) {
    for (var n, i = 1, a = arguments.length; i < a; i++) {
      n = arguments[i];
      for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, Jt.apply(this, arguments);
};
function Go(t, r, e) {
  if (e || arguments.length === 2) for (var n = 0, i = r.length, a; n < i; n++)
    (a || !(n in r)) && (a || (a = Array.prototype.slice.call(r, 0, n)), a[n] = r[n]);
  return t.concat(a || Array.prototype.slice.call(r));
}
var _0e = function(t) {
  var r = t.showTimeSelectOnly, e = r === void 0 ? !1 : r, n = t.showTime, i = n === void 0 ? !1 : n, a = t.className, o = t.children, s = e ? "Choose Time" : "Choose Date".concat(i ? " and Time" : "");
  return te.createElement("div", { className: a, role: "dialog", "aria-label": s, "aria-modal": "true" }, o);
}, x0e = function(t, r) {
  var e = Vt(null), n = Vt(t);
  n.current = t;
  var i = ns(function(a) {
    var o;
    e.current && !e.current.contains(a.target) && (r && a.target instanceof HTMLElement && a.target.classList.contains(r) || (o = n.current) === null || o === void 0 || o.call(n, a));
  }, [r]);
  return Ue(function() {
    return document.addEventListener("mousedown", i), function() {
      document.removeEventListener("mousedown", i);
    };
  }, [i]), e;
}, z2 = function(t) {
  var r = t.children, e = t.onClickOutside, n = t.className, i = t.containerRef, a = t.style, o = t.ignoreClass, s = x0e(e, o);
  return te.createElement("div", { className: n, style: a, ref: function(l) {
    s.current = l, i && (i.current = l);
  } }, r);
}, Te;
(function(t) {
  t.ArrowUp = "ArrowUp", t.ArrowDown = "ArrowDown", t.ArrowLeft = "ArrowLeft", t.ArrowRight = "ArrowRight", t.PageUp = "PageUp", t.PageDown = "PageDown", t.Home = "Home", t.End = "End", t.Enter = "Enter", t.Space = " ", t.Tab = "Tab", t.Escape = "Escape", t.Backspace = "Backspace", t.X = "x";
})(Te || (Te = {}));
function ez() {
  var t = typeof window < "u" ? window : globalThis;
  return t;
}
var Pg = 12, S0e = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
function mr(t) {
  if (t == null)
    return /* @__PURE__ */ new Date();
  var r = typeof t == "string" ? a1e(t) : Ne(t);
  return Ds(r) ? r : /* @__PURE__ */ new Date();
}
function r4(t, r, e, n, i) {
  var a, o = null, s = Lc(e) || Lc(av()), l = !0;
  if (Array.isArray(r))
    return r.forEach(function(c) {
      var d = q3(t, c, /* @__PURE__ */ new Date(), {
        locale: s,
        useAdditionalWeekYearTokens: !0,
        useAdditionalDayOfYearTokens: !0
      });
      n && (l = Ds(d, i) && t === Rr(d, c, e)), Ds(d, i) && l && (o = d);
    }), o;
  if (o = q3(t, r, /* @__PURE__ */ new Date(), {
    locale: s,
    useAdditionalWeekYearTokens: !0,
    useAdditionalDayOfYearTokens: !0
  }), n)
    l = Ds(o) && t === Rr(o, r, e);
  else if (!Ds(o)) {
    var u = ((a = r.match(S0e)) !== null && a !== void 0 ? a : []).map(function(c) {
      var d = c[0];
      if (d === "p" || d === "P") {
        var f = vy[d];
        return s ? f(c, s.formatLong) : d;
      }
      return c;
    }).join("");
    t.length > 0 && (o = q3(t, u.slice(0, t.length), /* @__PURE__ */ new Date(), {
      useAdditionalWeekYearTokens: !0,
      useAdditionalDayOfYearTokens: !0
    })), Ds(o) || (o = new Date(t));
  }
  return Ds(o) && l ? o : null;
}
function Ds(t, r) {
  return dy(t) && !Yc(t, r ?? /* @__PURE__ */ new Date("1/1/1800"));
}
function Rr(t, r, e) {
  if (e === "en")
    return iL(t, r, {
      useAdditionalWeekYearTokens: !0,
      useAdditionalDayOfYearTokens: !0
    });
  var n = e ? Lc(e) : void 0;
  return e && !n && console.warn('A locale object was not found for the provided string ["'.concat(e, '"].')), !n && av() && Lc(av()) && (n = Lc(av())), iL(t, r, {
    locale: n,
    useAdditionalWeekYearTokens: !0,
    useAdditionalDayOfYearTokens: !0
  });
}
function Ca(t, r) {
  var e = r.dateFormat, n = r.locale, i = Array.isArray(e) && e.length > 0 ? e[0] : e;
  return t && Rr(t, i, n) || "";
}
function I0e(t, r, e) {
  if (!t)
    return "";
  var n = Ca(t, e), i = r ? Ca(r, e) : "";
  return "".concat(n, " - ").concat(i);
}
function A0e(t, r) {
  if (!(t != null && t.length))
    return "";
  var e = t[0] ? Ca(t[0], r) : "";
  if (t.length === 1)
    return e;
  if (t.length === 2 && t[1]) {
    var n = Ca(t[1], r);
    return "".concat(e, ", ").concat(n);
  }
  var i = t.length - 1;
  return "".concat(e, " (+").concat(i, ")");
}
function n4(t, r) {
  var e = r.hour, n = e === void 0 ? 0 : e, i = r.minute, a = i === void 0 ? 0 : i, o = r.second, s = o === void 0 ? 0 : o;
  return H0(z0(W0(t, s), a), n);
}
function D0e(t) {
  return F_(t);
}
function T0e(t, r) {
  return Rr(t, "ddd", r);
}
function j0(t) {
  return jc(t);
}
function Zl(t, r, e) {
  var n = Lc(r || av());
  return tl(t, {
    locale: n,
    weekStartsOn: e
  });
}
function zs(t) {
  return SH(t);
}
function Gp(t) {
  return B2(t);
}
function pL(t) {
  return s6(t);
}
function vL() {
  return jc(mr());
}
function gL(t) {
  return _H(t);
}
function M0e(t) {
  return cve(t);
}
function R0e(t) {
  return xH(t);
}
function Do(t, r) {
  return t && r ? n1e(t, r) : !t && !r;
}
function yi(t, r) {
  return t && r ? t1e(t, r) : !t && !r;
}
function _y(t, r) {
  return t && r ? r1e(t, r) : !t && !r;
}
function jt(t, r) {
  return t && r ? lve(t, r) : !t && !r;
}
function mc(t, r) {
  return t && r ? oge(t, r) : !t && !r;
}
function Bp(t, r, e) {
  var n, i = jc(r), a = _H(e);
  try {
    n = Hv(t, { start: i, end: a });
  } catch {
    n = !1;
  }
  return n;
}
function av() {
  var t = ez();
  return t.__localeId__;
}
function Lc(t) {
  if (typeof t == "string") {
    var r = ez();
    return r.__localeData__ ? r.__localeData__[t] : void 0;
  } else
    return t;
}
function L0e(t, r, e) {
  return r(Rr(t, "EEEE", e));
}
function E0e(t, r) {
  return Rr(t, "EEEEEE", r);
}
function k0e(t, r) {
  return Rr(t, "EEE", r);
}
function U_(t, r) {
  return Rr(Zi(mr(), t), "LLLL", r);
}
function tz(t, r) {
  return Rr(Zi(mr(), t), "LLL", r);
}
function P0e(t, r) {
  return Rr(Xd(mr(), t), "QQQ", r);
}
function xa(t, r) {
  var e = r === void 0 ? {} : r, n = e.minDate, i = e.maxDate, a = e.excludeDates, o = e.excludeDateIntervals, s = e.includeDates, l = e.includeDateIntervals, u = e.filterDate;
  return Ng(t, { minDate: n, maxDate: i }) || a && a.some(function(c) {
    return c instanceof Date ? jt(t, c) : jt(t, c.date);
  }) || o && o.some(function(c) {
    var d = c.start, f = c.end;
    return Hv(t, { start: d, end: f });
  }) || s && !s.some(function(c) {
    return jt(t, c);
  }) || l && !l.some(function(c) {
    var d = c.start, f = c.end;
    return Hv(t, { start: d, end: f });
  }) || u && !u(mr(t)) || !1;
}
function J_(t, r) {
  var e = r === void 0 ? {} : r, n = e.excludeDates, i = e.excludeDateIntervals;
  return i && i.length > 0 ? i.some(function(a) {
    var o = a.start, s = a.end;
    return Hv(t, { start: o, end: s });
  }) : n && n.some(function(a) {
    var o;
    return a instanceof Date ? jt(t, a) : jt(t, (o = a.date) !== null && o !== void 0 ? o : /* @__PURE__ */ new Date());
  }) || !1;
}
function rz(t, r) {
  var e = r === void 0 ? {} : r, n = e.minDate, i = e.maxDate, a = e.excludeDates, o = e.includeDates, s = e.filterDate;
  return Ng(t, {
    minDate: n ? SH(n) : void 0,
    maxDate: i ? xH(i) : void 0
  }) || (a == null ? void 0 : a.some(function(l) {
    return yi(t, l instanceof Date ? l : l.date);
  })) || o && !o.some(function(l) {
    return yi(t, l);
  }) || s && !s(mr(t)) || !1;
}
function t0(t, r, e, n) {
  var i = ht(t), a = sn(t), o = ht(r), s = sn(r), l = ht(n);
  return i === o && i === l ? a <= e && e <= s : i < o ? l === i && a <= e || l === o && s >= e || l < o && l > i : !1;
}
function N0e(t, r) {
  var e = r === void 0 ? {} : r, n = e.minDate, i = e.maxDate, a = e.excludeDates, o = e.includeDates;
  return Ng(t, { minDate: n, maxDate: i }) || a && a.some(function(s) {
    return yi(s instanceof Date ? s : s.date, t);
  }) || o && !o.some(function(s) {
    return yi(s, t);
  }) || !1;
}
function r0(t, r) {
  var e = r === void 0 ? {} : r, n = e.minDate, i = e.maxDate, a = e.excludeDates, o = e.includeDates, s = e.filterDate;
  return Ng(t, { minDate: n, maxDate: i }) || (a == null ? void 0 : a.some(function(l) {
    return _y(t, l instanceof Date ? l : l.date);
  })) || o && !o.some(function(l) {
    return _y(t, l);
  }) || s && !s(mr(t)) || !1;
}
function n0(t, r, e) {
  if (!r || !e || !dy(r) || !dy(e))
    return !1;
  var n = ht(r), i = ht(e);
  return n <= t && i >= t;
}
function Y0(t, r) {
  var e = r === void 0 ? {} : r, n = e.minDate, i = e.maxDate, a = e.excludeDates, o = e.includeDates, s = e.filterDate, l = new Date(t, 0, 1);
  return Ng(l, {
    minDate: n ? B2(n) : void 0,
    maxDate: i ? IH(i) : void 0
  }) || (a == null ? void 0 : a.some(function(u) {
    return Do(l, u instanceof Date ? u : u.date);
  })) || o && !o.some(function(u) {
    return Do(l, u);
  }) || s && !s(mr(l)) || !1;
}
function i0(t, r, e, n) {
  var i = ht(t), a = Mc(t), o = ht(r), s = Mc(r), l = ht(n);
  return i === o && i === l ? a <= e && e <= s : i < o ? l === i && a <= e || l === o && s >= e || l < o && l > i : !1;
}
function Ng(t, r) {
  var e, n = r === void 0 ? {} : r, i = n.minDate, a = n.maxDate;
  return (e = i && Gf(t, i) < 0 || a && Gf(t, a) > 0) !== null && e !== void 0 ? e : !1;
}
function mL(t, r) {
  return r.some(function(e) {
    return Zo(e) === Zo(t) && jo(e) === jo(t) && Hs(e) === Hs(t);
  });
}
function yL(t, r) {
  var e = r === void 0 ? {} : r, n = e.excludeTimes, i = e.includeTimes, a = e.filterTime;
  return n && mL(t, n) || i && !mL(t, i) || a && !a(t) || !1;
}
function bL(t, r) {
  var e = r.minTime, n = r.maxTime;
  if (!e || !n)
    throw new Error("Both minTime and maxTime props required");
  var i = mr();
  i = H0(i, Zo(t)), i = z0(i, jo(t)), i = W0(i, Hs(t));
  var a = mr();
  a = H0(a, Zo(e)), a = z0(a, jo(e)), a = W0(a, Hs(e));
  var o = mr();
  o = H0(o, Zo(n)), o = z0(o, jo(n)), o = W0(o, Hs(n));
  var s;
  try {
    s = !Hv(i, { start: a, end: o });
  } catch {
    s = !1;
  }
  return s;
}
function CL(t, r) {
  var e = r === void 0 ? {} : r, n = e.minDate, i = e.includeDates, a = Bf(t, 1);
  return n && fy(n, a) > 0 || i && i.every(function(o) {
    return fy(o, a) > 0;
  }) || !1;
}
function wL(t, r) {
  var e = r === void 0 ? {} : r, n = e.maxDate, i = e.includeDates, a = no(t, 1);
  return n && fy(a, n) > 0 || i && i.every(function(o) {
    return fy(a, o) > 0;
  }) || !1;
}
function O0e(t, r) {
  var e = r === void 0 ? {} : r, n = e.minDate, i = e.includeDates, a = B2(t), o = OH(a, 1);
  return n && hy(n, o) > 0 || i && i.every(function(s) {
    return hy(s, o) > 0;
  }) || !1;
}
function V0e(t, r) {
  var e = r === void 0 ? {} : r, n = e.maxDate, i = e.includeDates, a = IH(t), o = B_(a, 1);
  return n && hy(o, n) > 0 || i && i.every(function(s) {
    return hy(o, s) > 0;
  }) || !1;
}
function _L(t, r) {
  var e = r === void 0 ? {} : r, n = e.minDate, i = e.includeDates, a = Ff(t, 1);
  return n && py(n, a) > 0 || i && i.every(function(o) {
    return py(o, a) > 0;
  }) || !1;
}
function G0e(t, r) {
  var e = r === void 0 ? {} : r, n = e.minDate, i = e.yearItemNumber, a = i === void 0 ? Pg : i, o = Gp(Ff(t, a)), s = El(o, a).endPeriod, l = n && ht(n);
  return l && l > s || !1;
}
function xL(t, r) {
  var e = r === void 0 ? {} : r, n = e.maxDate, i = e.includeDates, a = Bs(t, 1);
  return n && py(a, n) > 0 || i && i.every(function(o) {
    return py(a, o) > 0;
  }) || !1;
}
function B0e(t, r) {
  var e = r === void 0 ? {} : r, n = e.maxDate, i = e.yearItemNumber, a = i === void 0 ? Pg : i, o = Bs(t, a), s = El(o, a).startPeriod, l = n && ht(n);
  return l && l < s || !1;
}
function nz(t) {
  var r = t.minDate, e = t.includeDates;
  if (e && r) {
    var n = e.filter(function(i) {
      return Gf(i, r) >= 0;
    });
    return qR(n);
  } else return e ? qR(e) : r;
}
function iz(t) {
  var r = t.maxDate, e = t.includeDates;
  if (e && r) {
    var n = e.filter(function(i) {
      return Gf(i, r) <= 0;
    });
    return KR(n);
  } else return e ? KR(e) : r;
}
function SL(t, r) {
  var e;
  t === void 0 && (t = []), r === void 0 && (r = "react-datepicker__day--highlighted");
  for (var n = /* @__PURE__ */ new Map(), i = 0, a = t.length; i < a; i++) {
    var o = t[i];
    if (Fs(o)) {
      var s = Rr(o, "MM.dd.yyyy"), l = n.get(s) || [];
      l.includes(r) || (l.push(r), n.set(s, l));
    } else if (typeof o == "object") {
      var u = Object.keys(o), c = (e = u[0]) !== null && e !== void 0 ? e : "", d = o[c];
      if (typeof c == "string" && Array.isArray(d))
        for (var f = 0, h = d.length; f < h; f++) {
          var p = d[f];
          if (p) {
            var s = Rr(p, "MM.dd.yyyy"), l = n.get(s) || [];
            l.includes(c) || (l.push(c), n.set(s, l));
          }
        }
    }
  }
  return n;
}
function F0e(t, r) {
  return t.length !== r.length ? !1 : t.every(function(e, n) {
    return e === r[n];
  });
}
function H0e(t, r) {
  t === void 0 && (t = []), r === void 0 && (r = "react-datepicker__day--holidays");
  var e = /* @__PURE__ */ new Map();
  return t.forEach(function(n) {
    var i = n.date, a = n.holidayName;
    if (Fs(i)) {
      var o = Rr(i, "MM.dd.yyyy"), s = e.get(o) || {
        className: "",
        holidayNames: []
      };
      if (!("className" in s && s.className === r && F0e(s.holidayNames, [a]))) {
        s.className = r;
        var l = s.holidayNames;
        s.holidayNames = l ? Go(Go([], l, !0), [a], !1) : [a], e.set(o, s);
      }
    }
  }), e;
}
function z0e(t, r, e, n, i) {
  for (var a = i.length, o = [], s = 0; s < a; s++) {
    var l = t, u = i[s];
    u && (l = ive(l, Zo(u)), l = o6(l, jo(u)), l = sve(l, Hs(u)));
    var c = o6(t, (e + 1) * n);
    au(l, r) && Yc(l, c) && u != null && o.push(u);
  }
  return o;
}
function IL(t) {
  return t < 10 ? "0".concat(t) : "".concat(t);
}
function El(t, r) {
  r === void 0 && (r = Pg);
  var e = Math.ceil(ht(t) / r) * r, n = e - (r - 1);
  return { startPeriod: n, endPeriod: e };
}
function W0e(t) {
  var r = new Date(t.getFullYear(), t.getMonth(), t.getDate()), e = new Date(t.getFullYear(), t.getMonth(), t.getDate(), 24);
  return Math.round((+e - +r) / 36e5);
}
function AL(t) {
  var r = t.getSeconds(), e = t.getMilliseconds();
  return Ne(t.getTime() - r * 1e3 - e);
}
function Z0e(t, r) {
  return AL(t).getTime() === AL(r).getTime();
}
function DL(t) {
  if (!Fs(t))
    throw new Error("Invalid date");
  var r = new Date(t);
  return r.setHours(0, 0, 0, 0), r;
}
function TL(t, r) {
  if (!Fs(t) || !Fs(r))
    throw new Error("Invalid date received");
  var e = DL(t), n = DL(r);
  return Yc(e, n);
}
function az(t) {
  return t.key === Te.Space;
}
var j0e = (
  /** @class */
  function(t) {
    kn(r, t);
    function r(e) {
      var n = t.call(this, e) || this;
      return n.inputRef = te.createRef(), n.onTimeChange = function(i) {
        var a, o;
        n.setState({ time: i });
        var s = n.props.date, l = s instanceof Date && !isNaN(+s), u = l ? s : /* @__PURE__ */ new Date();
        if (i != null && i.includes(":")) {
          var c = i.split(":"), d = c[0], f = c[1];
          u.setHours(Number(d)), u.setMinutes(Number(f));
        }
        (o = (a = n.props).onChange) === null || o === void 0 || o.call(a, u);
      }, n.renderTimeInput = function() {
        var i = n.state.time, a = n.props, o = a.date, s = a.timeString, l = a.customTimeInput;
        return l ? v7(l, {
          date: o,
          value: i,
          onChange: n.onTimeChange
        }) : te.createElement("input", { type: "time", className: "react-datepicker-time__input", placeholder: "Time", name: "time-input", ref: n.inputRef, onClick: function() {
          var u;
          (u = n.inputRef.current) === null || u === void 0 || u.focus();
        }, required: !0, value: i, onChange: function(u) {
          n.onTimeChange(u.target.value || s);
        } });
      }, n.state = {
        time: n.props.timeString
      }, n;
    }
    return r.getDerivedStateFromProps = function(e, n) {
      return e.timeString !== n.time ? {
        time: e.timeString
      } : null;
    }, r.prototype.render = function() {
      return te.createElement(
        "div",
        { className: "react-datepicker__input-time-container" },
        te.createElement("div", { className: "react-datepicker-time__caption" }, this.props.timeInputLabel),
        te.createElement(
          "div",
          { className: "react-datepicker-time__input-container" },
          te.createElement("div", { className: "react-datepicker-time__input" }, this.renderTimeInput())
        )
      );
    }, r;
  }(In)
), Y0e = (
  /** @class */
  function(t) {
    kn(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.dayEl = Ul(), e.handleClick = function(n) {
        !e.isDisabled() && e.props.onClick && e.props.onClick(n);
      }, e.handleMouseEnter = function(n) {
        !e.isDisabled() && e.props.onMouseEnter && e.props.onMouseEnter(n);
      }, e.handleOnKeyDown = function(n) {
        var i, a, o = n.key;
        o === Te.Space && (n.preventDefault(), n.key = Te.Enter), (a = (i = e.props).handleOnKeyDown) === null || a === void 0 || a.call(i, n);
      }, e.isSameDay = function(n) {
        return jt(e.props.day, n);
      }, e.isKeyboardSelected = function() {
        var n;
        if (e.props.disabledKeyboardNavigation)
          return !1;
        var i = e.props.selectsMultiple ? (n = e.props.selectedDates) === null || n === void 0 ? void 0 : n.some(function(o) {
          return e.isSameDayOrWeek(o);
        }) : e.isSameDayOrWeek(e.props.selected), a = e.props.preSelection && e.isDisabled(e.props.preSelection);
        return !i && e.isSameDayOrWeek(e.props.preSelection) && !a;
      }, e.isDisabled = function(n) {
        return n === void 0 && (n = e.props.day), xa(n, {
          minDate: e.props.minDate,
          maxDate: e.props.maxDate,
          excludeDates: e.props.excludeDates,
          excludeDateIntervals: e.props.excludeDateIntervals,
          includeDateIntervals: e.props.includeDateIntervals,
          includeDates: e.props.includeDates,
          filterDate: e.props.filterDate
        });
      }, e.isExcluded = function() {
        return J_(e.props.day, {
          excludeDates: e.props.excludeDates,
          excludeDateIntervals: e.props.excludeDateIntervals
        });
      }, e.isStartOfWeek = function() {
        return jt(e.props.day, Zl(e.props.day, e.props.locale, e.props.calendarStartDay));
      }, e.isSameWeek = function(n) {
        return e.props.showWeekPicker && jt(n, Zl(e.props.day, e.props.locale, e.props.calendarStartDay));
      }, e.isSameDayOrWeek = function(n) {
        return e.isSameDay(n) || e.isSameWeek(n);
      }, e.getHighLightedClass = function() {
        var n = e.props, i = n.day, a = n.highlightDates;
        if (!a)
          return !1;
        var o = Rr(i, "MM.dd.yyyy");
        return a.get(o);
      }, e.getHolidaysClass = function() {
        var n, i = e.props, a = i.day, o = i.holidays;
        if (!o)
          return [void 0];
        var s = Rr(a, "MM.dd.yyyy");
        return o.has(s) ? [(n = o.get(s)) === null || n === void 0 ? void 0 : n.className] : [void 0];
      }, e.isInRange = function() {
        var n = e.props, i = n.day, a = n.startDate, o = n.endDate;
        return !a || !o ? !1 : Bp(i, a, o);
      }, e.isInSelectingRange = function() {
        var n, i = e.props, a = i.day, o = i.selectsStart, s = i.selectsEnd, l = i.selectsRange, u = i.selectsDisabledDaysInRange, c = i.startDate, d = i.endDate, f = (n = e.props.selectingDate) !== null && n !== void 0 ? n : e.props.preSelection;
        return !(o || s || l) || !f || !u && e.isDisabled() ? !1 : o && d && (Yc(f, d) || mc(f, d)) ? Bp(a, f, d) : s && c && (au(f, c) || mc(f, c)) || l && c && !d && (au(f, c) || mc(f, c)) ? Bp(a, c, f) : !1;
      }, e.isSelectingRangeStart = function() {
        var n;
        if (!e.isInSelectingRange())
          return !1;
        var i = e.props, a = i.day, o = i.startDate, s = i.selectsStart, l = (n = e.props.selectingDate) !== null && n !== void 0 ? n : e.props.preSelection;
        return s ? jt(a, l) : jt(a, o);
      }, e.isSelectingRangeEnd = function() {
        var n;
        if (!e.isInSelectingRange())
          return !1;
        var i = e.props, a = i.day, o = i.endDate, s = i.selectsEnd, l = i.selectsRange, u = (n = e.props.selectingDate) !== null && n !== void 0 ? n : e.props.preSelection;
        return s || l ? jt(a, u) : jt(a, o);
      }, e.isRangeStart = function() {
        var n = e.props, i = n.day, a = n.startDate, o = n.endDate;
        return !a || !o ? !1 : jt(a, i);
      }, e.isRangeEnd = function() {
        var n = e.props, i = n.day, a = n.startDate, o = n.endDate;
        return !a || !o ? !1 : jt(o, i);
      }, e.isWeekend = function() {
        var n = rge(e.props.day);
        return n === 0 || n === 6;
      }, e.isAfterMonth = function() {
        return e.props.month !== void 0 && (e.props.month + 1) % 12 === sn(e.props.day);
      }, e.isBeforeMonth = function() {
        return e.props.month !== void 0 && (sn(e.props.day) + 1) % 12 === e.props.month;
      }, e.isCurrentDay = function() {
        return e.isSameDay(mr());
      }, e.isSelected = function() {
        var n;
        return e.props.selectsMultiple ? (n = e.props.selectedDates) === null || n === void 0 ? void 0 : n.some(function(i) {
          return e.isSameDayOrWeek(i);
        }) : e.isSameDayOrWeek(e.props.selected);
      }, e.getClassNames = function(n) {
        var i = e.props.dayClassName ? e.props.dayClassName(n) : void 0;
        return Ln("react-datepicker__day", i, "react-datepicker__day--" + T0e(e.props.day), {
          "react-datepicker__day--disabled": e.isDisabled(),
          "react-datepicker__day--excluded": e.isExcluded(),
          "react-datepicker__day--selected": e.isSelected(),
          "react-datepicker__day--keyboard-selected": e.isKeyboardSelected(),
          "react-datepicker__day--range-start": e.isRangeStart(),
          "react-datepicker__day--range-end": e.isRangeEnd(),
          "react-datepicker__day--in-range": e.isInRange(),
          "react-datepicker__day--in-selecting-range": e.isInSelectingRange(),
          "react-datepicker__day--selecting-range-start": e.isSelectingRangeStart(),
          "react-datepicker__day--selecting-range-end": e.isSelectingRangeEnd(),
          "react-datepicker__day--today": e.isCurrentDay(),
          "react-datepicker__day--weekend": e.isWeekend(),
          "react-datepicker__day--outside-month": e.isAfterMonth() || e.isBeforeMonth()
        }, e.getHighLightedClass(), e.getHolidaysClass());
      }, e.getAriaLabel = function() {
        var n = e.props, i = n.day, a = n.ariaLabelPrefixWhenEnabled, o = a === void 0 ? "Choose" : a, s = n.ariaLabelPrefixWhenDisabled, l = s === void 0 ? "Not available" : s, u = e.isDisabled() || e.isExcluded() ? l : o;
        return "".concat(u, " ").concat(Rr(i, "PPPP", e.props.locale));
      }, e.getTitle = function() {
        var n = e.props, i = n.day, a = n.holidays, o = a === void 0 ? /* @__PURE__ */ new Map() : a, s = n.excludeDates, l = Rr(i, "MM.dd.yyyy"), u = [];
        return o.has(l) && u.push.apply(u, o.get(l).holidayNames), e.isExcluded() && u.push(s == null ? void 0 : s.filter(function(c) {
          return c instanceof Date ? jt(c, i) : jt(c == null ? void 0 : c.date, i);
        }).map(function(c) {
          if (!(c instanceof Date))
            return c == null ? void 0 : c.message;
        })), u.join(", ");
      }, e.getTabIndex = function() {
        var n = e.props.selected, i = e.props.preSelection, a = !(e.props.showWeekPicker && (e.props.showWeekNumber || !e.isStartOfWeek())) && (e.isKeyboardSelected() || e.isSameDay(n) && jt(i, n)) ? 0 : -1;
        return a;
      }, e.handleFocusDay = function() {
        var n;
        e.shouldFocusDay() && ((n = e.dayEl.current) === null || n === void 0 || n.focus({ preventScroll: !0 }));
      }, e.renderDayContents = function() {
        return e.props.monthShowsDuplicateDaysEnd && e.isAfterMonth() || e.props.monthShowsDuplicateDaysStart && e.isBeforeMonth() ? null : e.props.renderDayContents ? e.props.renderDayContents(aL(e.props.day), e.props.day) : aL(e.props.day);
      }, e.render = function() {
        return (
          // TODO: Use <option> instead of the "option" role to ensure accessibility across all devices.
          te.createElement(
            "div",
            { ref: e.dayEl, className: e.getClassNames(e.props.day), onKeyDown: e.handleOnKeyDown, onClick: e.handleClick, onMouseEnter: e.props.usePointerEvent ? void 0 : e.handleMouseEnter, onPointerEnter: e.props.usePointerEvent ? e.handleMouseEnter : void 0, tabIndex: e.getTabIndex(), "aria-label": e.getAriaLabel(), role: "option", title: e.getTitle(), "aria-disabled": e.isDisabled(), "aria-current": e.isCurrentDay() ? "date" : void 0, "aria-selected": e.isSelected() || e.isInRange() },
            e.renderDayContents(),
            e.getTitle() !== "" && te.createElement("span", { className: "overlay" }, e.getTitle())
          )
        );
      }, e;
    }
    return r.prototype.componentDidMount = function() {
      this.handleFocusDay();
    }, r.prototype.componentDidUpdate = function() {
      this.handleFocusDay();
    }, r.prototype.shouldFocusDay = function() {
      var e = !1;
      return this.getTabIndex() === 0 && this.isSameDay(this.props.preSelection) && ((!document.activeElement || document.activeElement === document.body) && (e = !0), this.props.inline && !this.props.shouldFocusDayInline && (e = !1), this.isDayActiveElement() && (e = !0), this.isDuplicateDay() && (e = !1)), e;
    }, r.prototype.isDayActiveElement = function() {
      var e, n, i;
      return ((n = (e = this.props.containerRef) === null || e === void 0 ? void 0 : e.current) === null || n === void 0 ? void 0 : n.contains(document.activeElement)) && ((i = document.activeElement) === null || i === void 0 ? void 0 : i.classList.contains("react-datepicker__day"));
    }, r.prototype.isDuplicateDay = function() {
      return (
        //day is one of the non rendered duplicate days
        this.props.monthShowsDuplicateDaysEnd && this.isAfterMonth() || this.props.monthShowsDuplicateDaysStart && this.isBeforeMonth()
      );
    }, r;
  }(In)
), X0e = (
  /** @class */
  function(t) {
    kn(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.weekNumberEl = Ul(), e.handleClick = function(n) {
        e.props.onClick && e.props.onClick(n);
      }, e.handleOnKeyDown = function(n) {
        var i, a, o = n.key;
        o === Te.Space && (n.preventDefault(), n.key = Te.Enter), (a = (i = e.props).handleOnKeyDown) === null || a === void 0 || a.call(i, n);
      }, e.isKeyboardSelected = function() {
        return !e.props.disabledKeyboardNavigation && !jt(e.props.date, e.props.selected) && jt(e.props.date, e.props.preSelection);
      }, e.getTabIndex = function() {
        return e.props.showWeekPicker && e.props.showWeekNumber && (e.isKeyboardSelected() || jt(e.props.date, e.props.selected) && jt(e.props.preSelection, e.props.selected)) ? 0 : -1;
      }, e.handleFocusWeekNumber = function(n) {
        var i = !1;
        e.getTabIndex() === 0 && !(n != null && n.isInputFocused) && jt(e.props.date, e.props.preSelection) && ((!document.activeElement || document.activeElement === document.body) && (i = !0), e.props.inline && !e.props.shouldFocusDayInline && (i = !1), e.props.containerRef && e.props.containerRef.current && e.props.containerRef.current.contains(document.activeElement) && document.activeElement && document.activeElement.classList.contains("react-datepicker__week-number") && (i = !0)), i && e.weekNumberEl.current && e.weekNumberEl.current.focus({ preventScroll: !0 });
      }, e;
    }
    return Object.defineProperty(r, "defaultProps", {
      get: function() {
        return {
          ariaLabelPrefix: "week "
        };
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.componentDidMount = function() {
      this.handleFocusWeekNumber();
    }, r.prototype.componentDidUpdate = function(e) {
      this.handleFocusWeekNumber(e);
    }, r.prototype.render = function() {
      var e = this.props, n = e.weekNumber, i = e.ariaLabelPrefix, a = i === void 0 ? r.defaultProps.ariaLabelPrefix : i, o = e.onClick, s = {
        "react-datepicker__week-number": !0,
        "react-datepicker__week-number--clickable": !!o,
        "react-datepicker__week-number--selected": !!o && jt(this.props.date, this.props.selected),
        "react-datepicker__week-number--keyboard-selected": this.isKeyboardSelected()
      };
      return te.createElement("div", { ref: this.weekNumberEl, className: Ln(s), "aria-label": "".concat(a, " ").concat(this.props.weekNumber), onClick: this.handleClick, onKeyDown: this.handleOnKeyDown, tabIndex: this.getTabIndex() }, n);
    }, r;
  }(In)
), $0e = (
  /** @class */
  function(t) {
    kn(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.isDisabled = function(n) {
        return xa(n, {
          minDate: e.props.minDate,
          maxDate: e.props.maxDate,
          excludeDates: e.props.excludeDates,
          excludeDateIntervals: e.props.excludeDateIntervals,
          includeDateIntervals: e.props.includeDateIntervals,
          includeDates: e.props.includeDates,
          filterDate: e.props.filterDate
        });
      }, e.handleDayClick = function(n, i) {
        e.props.onDayClick && e.props.onDayClick(n, i);
      }, e.handleDayMouseEnter = function(n) {
        e.props.onDayMouseEnter && e.props.onDayMouseEnter(n);
      }, e.handleWeekClick = function(n, i, a) {
        for (var o, s, l, u = new Date(n), c = 0; c < 7; c++) {
          var d = new Date(n);
          d.setDate(d.getDate() + c);
          var f = !e.isDisabled(d);
          if (f) {
            u = d;
            break;
          }
        }
        typeof e.props.onWeekSelect == "function" && e.props.onWeekSelect(u, i, a), e.props.showWeekPicker && e.handleDayClick(u, a), ((o = e.props.shouldCloseOnSelect) !== null && o !== void 0 ? o : r.defaultProps.shouldCloseOnSelect) && ((l = (s = e.props).setOpen) === null || l === void 0 || l.call(s, !1));
      }, e.formatWeekNumber = function(n) {
        return e.props.formatWeekNumber ? e.props.formatWeekNumber(n) : D0e(n);
      }, e.renderDays = function() {
        var n = e.startOfWeek(), i = [], a = e.formatWeekNumber(n);
        if (e.props.showWeekNumber) {
          var o = e.props.onWeekSelect || e.props.showWeekPicker ? e.handleWeekClick.bind(e, n, a) : void 0;
          i.push(te.createElement(X0e, Jt({ key: "W" }, r.defaultProps, e.props, { weekNumber: a, date: n, onClick: o })));
        }
        return i.concat([0, 1, 2, 3, 4, 5, 6].map(function(s) {
          var l = el(n, s);
          return te.createElement(Y0e, Jt({}, r.defaultProps, e.props, { ariaLabelPrefixWhenEnabled: e.props.chooseDayAriaLabelPrefix, ariaLabelPrefixWhenDisabled: e.props.disabledDayAriaLabelPrefix, key: l.valueOf(), day: l, onClick: e.handleDayClick.bind(e, l), onMouseEnter: e.handleDayMouseEnter.bind(e, l) }));
        }));
      }, e.startOfWeek = function() {
        return Zl(e.props.day, e.props.locale, e.props.calendarStartDay);
      }, e.isKeyboardSelected = function() {
        return !e.props.disabledKeyboardNavigation && !jt(e.startOfWeek(), e.props.selected) && jt(e.startOfWeek(), e.props.preSelection);
      }, e;
    }
    return Object.defineProperty(r, "defaultProps", {
      get: function() {
        return {
          shouldCloseOnSelect: !0
        };
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.render = function() {
      var e = {
        "react-datepicker__week": !0,
        "react-datepicker__week--selected": jt(this.startOfWeek(), this.props.selected),
        "react-datepicker__week--keyboard-selected": this.isKeyboardSelected()
      };
      return te.createElement("div", { className: Ln(e) }, this.renderDays());
    }, r;
  }(In)
), pp, U0e = 6, bf = {
  TWO_COLUMNS: "two_columns",
  THREE_COLUMNS: "three_columns",
  FOUR_COLUMNS: "four_columns"
}, i4 = (pp = {}, pp[bf.TWO_COLUMNS] = {
  grid: [
    [0, 1],
    [2, 3],
    [4, 5],
    [6, 7],
    [8, 9],
    [10, 11]
  ],
  verticalNavigationOffset: 2
}, pp[bf.THREE_COLUMNS] = {
  grid: [
    [0, 1, 2],
    [3, 4, 5],
    [6, 7, 8],
    [9, 10, 11]
  ],
  verticalNavigationOffset: 3
}, pp[bf.FOUR_COLUMNS] = {
  grid: [
    [0, 1, 2, 3],
    [4, 5, 6, 7],
    [8, 9, 10, 11]
  ],
  verticalNavigationOffset: 4
}, pp), a0 = 1;
function ML(t, r) {
  return t ? bf.FOUR_COLUMNS : r ? bf.TWO_COLUMNS : bf.THREE_COLUMNS;
}
var J0e = (
  /** @class */
  function(t) {
    kn(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.MONTH_REFS = Go([], Array(12), !0).map(function() {
        return Ul();
      }), e.QUARTER_REFS = Go([], Array(4), !0).map(function() {
        return Ul();
      }), e.isDisabled = function(n) {
        return xa(n, {
          minDate: e.props.minDate,
          maxDate: e.props.maxDate,
          excludeDates: e.props.excludeDates,
          excludeDateIntervals: e.props.excludeDateIntervals,
          includeDateIntervals: e.props.includeDateIntervals,
          includeDates: e.props.includeDates,
          filterDate: e.props.filterDate
        });
      }, e.isExcluded = function(n) {
        return J_(n, {
          excludeDates: e.props.excludeDates,
          excludeDateIntervals: e.props.excludeDateIntervals
        });
      }, e.handleDayClick = function(n, i) {
        var a, o;
        (o = (a = e.props).onDayClick) === null || o === void 0 || o.call(a, n, i, e.props.orderInDisplay);
      }, e.handleDayMouseEnter = function(n) {
        var i, a;
        (a = (i = e.props).onDayMouseEnter) === null || a === void 0 || a.call(i, n);
      }, e.handleMouseLeave = function() {
        var n, i;
        (i = (n = e.props).onMouseLeave) === null || i === void 0 || i.call(n);
      }, e.isRangeStartMonth = function(n) {
        var i = e.props, a = i.day, o = i.startDate, s = i.endDate;
        return !o || !s ? !1 : yi(Zi(a, n), o);
      }, e.isRangeStartQuarter = function(n) {
        var i = e.props, a = i.day, o = i.startDate, s = i.endDate;
        return !o || !s ? !1 : _y(Xd(a, n), o);
      }, e.isRangeEndMonth = function(n) {
        var i = e.props, a = i.day, o = i.startDate, s = i.endDate;
        return !o || !s ? !1 : yi(Zi(a, n), s);
      }, e.isRangeEndQuarter = function(n) {
        var i = e.props, a = i.day, o = i.startDate, s = i.endDate;
        return !o || !s ? !1 : _y(Xd(a, n), s);
      }, e.isInSelectingRangeMonth = function(n) {
        var i, a = e.props, o = a.day, s = a.selectsStart, l = a.selectsEnd, u = a.selectsRange, c = a.startDate, d = a.endDate, f = (i = e.props.selectingDate) !== null && i !== void 0 ? i : e.props.preSelection;
        return !(s || l || u) || !f ? !1 : s && d ? t0(f, d, n, o) : l && c || u && c && !d ? t0(c, f, n, o) : !1;
      }, e.isSelectingMonthRangeStart = function(n) {
        var i;
        if (!e.isInSelectingRangeMonth(n))
          return !1;
        var a = e.props, o = a.day, s = a.startDate, l = a.selectsStart, u = Zi(o, n), c = (i = e.props.selectingDate) !== null && i !== void 0 ? i : e.props.preSelection;
        return l ? yi(u, c) : yi(u, s);
      }, e.isSelectingMonthRangeEnd = function(n) {
        var i;
        if (!e.isInSelectingRangeMonth(n))
          return !1;
        var a = e.props, o = a.day, s = a.endDate, l = a.selectsEnd, u = a.selectsRange, c = Zi(o, n), d = (i = e.props.selectingDate) !== null && i !== void 0 ? i : e.props.preSelection;
        return l || u ? yi(c, d) : yi(c, s);
      }, e.isInSelectingRangeQuarter = function(n) {
        var i, a = e.props, o = a.day, s = a.selectsStart, l = a.selectsEnd, u = a.selectsRange, c = a.startDate, d = a.endDate, f = (i = e.props.selectingDate) !== null && i !== void 0 ? i : e.props.preSelection;
        return !(s || l || u) || !f ? !1 : s && d ? i0(f, d, n, o) : l && c || u && c && !d ? i0(c, f, n, o) : !1;
      }, e.isWeekInMonth = function(n) {
        var i = e.props.day, a = el(n, 6);
        return yi(n, i) || yi(a, i);
      }, e.isCurrentMonth = function(n, i) {
        return ht(n) === ht(mr()) && i === sn(mr());
      }, e.isCurrentQuarter = function(n, i) {
        return ht(n) === ht(mr()) && i === Mc(mr());
      }, e.isSelectedMonth = function(n, i, a) {
        return sn(a) === i && ht(n) === ht(a);
      }, e.isSelectMonthInList = function(n, i, a) {
        return a.some(function(o) {
          return e.isSelectedMonth(n, i, o);
        });
      }, e.isSelectedQuarter = function(n, i, a) {
        return Mc(n) === i && ht(n) === ht(a);
      }, e.renderWeeks = function() {
        for (var n = [], i = e.props.fixedHeight, a = 0, o = !1, s = Zl(zs(e.props.day), e.props.locale, e.props.calendarStartDay), l = function(p) {
          return e.props.showWeekPicker ? Zl(p, e.props.locale, e.props.calendarStartDay) : e.props.preSelection;
        }, u = function(p) {
          return e.props.showWeekPicker ? Zl(p, e.props.locale, e.props.calendarStartDay) : e.props.selected;
        }, c = e.props.selected ? u(e.props.selected) : void 0, d = e.props.preSelection ? l(e.props.preSelection) : void 0; n.push(te.createElement($0e, Jt({}, e.props, { ariaLabelPrefix: e.props.weekAriaLabelPrefix, key: a, day: s, month: sn(e.props.day), onDayClick: e.handleDayClick, onDayMouseEnter: e.handleDayMouseEnter, selected: c, preSelection: d, showWeekNumber: e.props.showWeekNumbers }))), !o; ) {
          a++, s = cy(s, 1);
          var f = i && a >= U0e, h = !i && !e.isWeekInMonth(s);
          if (f || h)
            if (e.props.peekNextMonth)
              o = !0;
            else
              break;
        }
        return n;
      }, e.onMonthClick = function(n, i) {
        var a = e.isMonthDisabledForLabelDate(i), o = a.isDisabled, s = a.labelDate;
        o || e.handleDayClick(zs(s), n);
      }, e.onMonthMouseEnter = function(n) {
        var i = e.isMonthDisabledForLabelDate(n), a = i.isDisabled, o = i.labelDate;
        a || e.handleDayMouseEnter(zs(o));
      }, e.handleMonthNavigation = function(n, i) {
        var a, o, s, l;
        (o = (a = e.props).setPreSelection) === null || o === void 0 || o.call(a, i), (l = (s = e.MONTH_REFS[n]) === null || s === void 0 ? void 0 : s.current) === null || l === void 0 || l.focus();
      }, e.handleKeyboardNavigation = function(n, i, a) {
        var o, s = e.props, l = s.selected, u = s.preSelection, c = s.setPreSelection, d = s.minDate, f = s.maxDate, h = s.showFourColumnMonthYearPicker, p = s.showTwoColumnMonthYearPicker;
        if (u) {
          var v = ML(h, p), g = e.getVerticalOffset(v), m = (o = i4[v]) === null || o === void 0 ? void 0 : o.grid, y = function(x, I, D) {
            var T, A, M = I, R = D;
            switch (x) {
              case Te.ArrowRight:
                M = no(I, a0), R = D === 11 ? 0 : D + a0;
                break;
              case Te.ArrowLeft:
                M = Bf(I, a0), R = D === 0 ? 11 : D - a0;
                break;
              case Te.ArrowUp:
                M = Bf(I, g), R = !((T = m == null ? void 0 : m[0]) === null || T === void 0) && T.includes(D) ? D + 12 - g : D - g;
                break;
              case Te.ArrowDown:
                M = no(I, g), R = !((A = m == null ? void 0 : m[m.length - 1]) === null || A === void 0) && A.includes(D) ? D - 12 + g : D + g;
                break;
            }
            return { newCalculatedDate: M, newCalculatedMonth: R };
          }, b = function(x, I, D) {
            for (var T = 40, A = x, M = !1, R = 0, E = y(A, I, D), k = E.newCalculatedDate, P = E.newCalculatedMonth; !M; ) {
              if (R >= T) {
                k = I, P = D;
                break;
              }
              if (d && k < d) {
                A = Te.ArrowRight;
                var N = y(A, k, P);
                k = N.newCalculatedDate, P = N.newCalculatedMonth;
              }
              if (f && k > f) {
                A = Te.ArrowLeft;
                var N = y(A, k, P);
                k = N.newCalculatedDate, P = N.newCalculatedMonth;
              }
              if (N0e(k, e.props)) {
                var N = y(A, k, P);
                k = N.newCalculatedDate, P = N.newCalculatedMonth;
              } else
                M = !0;
              R++;
            }
            return { newCalculatedDate: k, newCalculatedMonth: P };
          };
          if (i === Te.Enter) {
            e.isMonthDisabled(a) || (e.onMonthClick(n, a), c == null || c(l));
            return;
          }
          var C = b(i, u, a), w = C.newCalculatedDate, _ = C.newCalculatedMonth;
          switch (i) {
            case Te.ArrowRight:
            case Te.ArrowLeft:
            case Te.ArrowUp:
            case Te.ArrowDown:
              e.handleMonthNavigation(_, w);
              break;
          }
        }
      }, e.getVerticalOffset = function(n) {
        var i, a;
        return (a = (i = i4[n]) === null || i === void 0 ? void 0 : i.verticalNavigationOffset) !== null && a !== void 0 ? a : 0;
      }, e.onMonthKeyDown = function(n, i) {
        var a = e.props, o = a.disabledKeyboardNavigation, s = a.handleOnMonthKeyDown, l = n.key;
        l !== Te.Tab && n.preventDefault(), o || e.handleKeyboardNavigation(n, l, i), s && s(n);
      }, e.onQuarterClick = function(n, i) {
        var a = Xd(e.props.day, i);
        r0(a, e.props) || e.handleDayClick(pL(a), n);
      }, e.onQuarterMouseEnter = function(n) {
        var i = Xd(e.props.day, n);
        r0(i, e.props) || e.handleDayMouseEnter(pL(i));
      }, e.handleQuarterNavigation = function(n, i) {
        var a, o, s, l;
        e.isDisabled(i) || e.isExcluded(i) || ((o = (a = e.props).setPreSelection) === null || o === void 0 || o.call(a, i), (l = (s = e.QUARTER_REFS[n - 1]) === null || s === void 0 ? void 0 : s.current) === null || l === void 0 || l.focus());
      }, e.onQuarterKeyDown = function(n, i) {
        var a, o, s = n.key;
        if (!e.props.disabledKeyboardNavigation)
          switch (s) {
            case Te.Enter:
              e.onQuarterClick(n, i), (o = (a = e.props).setPreSelection) === null || o === void 0 || o.call(a, e.props.selected);
              break;
            case Te.ArrowRight:
              if (!e.props.preSelection)
                break;
              e.handleQuarterNavigation(i === 4 ? 1 : i + 1, B_(e.props.preSelection, 1));
              break;
            case Te.ArrowLeft:
              if (!e.props.preSelection)
                break;
              e.handleQuarterNavigation(i === 1 ? 4 : i - 1, OH(e.props.preSelection, 1));
              break;
          }
      }, e.isMonthDisabledForLabelDate = function(n) {
        var i, a = e.props, o = a.day, s = a.minDate, l = a.maxDate, u = a.excludeDates, c = a.includeDates, d = Zi(o, n);
        return {
          isDisabled: (i = (s || l || u || c) && rz(d, e.props)) !== null && i !== void 0 ? i : !1,
          labelDate: d
        };
      }, e.isMonthDisabled = function(n) {
        var i = e.isMonthDisabledForLabelDate(n).isDisabled;
        return i;
      }, e.getMonthClassNames = function(n) {
        var i = e.props, a = i.day, o = i.startDate, s = i.endDate, l = i.preSelection, u = i.monthClassName, c = u ? u(Zi(a, n)) : void 0, d = e.getSelection();
        return Ln("react-datepicker__month-text", "react-datepicker__month-".concat(n), c, {
          "react-datepicker__month-text--disabled": e.isMonthDisabled(n),
          "react-datepicker__month-text--selected": d ? e.isSelectMonthInList(a, n, d) : void 0,
          "react-datepicker__month-text--keyboard-selected": !e.props.disabledKeyboardNavigation && l && e.isSelectedMonth(a, n, l) && !e.isMonthDisabled(n),
          "react-datepicker__month-text--in-selecting-range": e.isInSelectingRangeMonth(n),
          "react-datepicker__month-text--in-range": o && s ? t0(o, s, n, a) : void 0,
          "react-datepicker__month-text--range-start": e.isRangeStartMonth(n),
          "react-datepicker__month-text--range-end": e.isRangeEndMonth(n),
          "react-datepicker__month-text--selecting-range-start": e.isSelectingMonthRangeStart(n),
          "react-datepicker__month-text--selecting-range-end": e.isSelectingMonthRangeEnd(n),
          "react-datepicker__month-text--today": e.isCurrentMonth(a, n)
        });
      }, e.getTabIndex = function(n) {
        if (e.props.preSelection == null)
          return "-1";
        var i = sn(e.props.preSelection), a = e.isMonthDisabledForLabelDate(i).isDisabled, o = n === i && !(a || e.props.disabledKeyboardNavigation) ? "0" : "-1";
        return o;
      }, e.getQuarterTabIndex = function(n) {
        if (e.props.preSelection == null)
          return "-1";
        var i = Mc(e.props.preSelection), a = r0(e.props.day, e.props), o = n === i && !(a || e.props.disabledKeyboardNavigation) ? "0" : "-1";
        return o;
      }, e.getAriaLabel = function(n) {
        var i = e.props, a = i.chooseDayAriaLabelPrefix, o = a === void 0 ? "Choose" : a, s = i.disabledDayAriaLabelPrefix, l = s === void 0 ? "Not available" : s, u = i.day, c = i.locale, d = Zi(u, n), f = e.isDisabled(d) || e.isExcluded(d) ? l : o;
        return "".concat(f, " ").concat(Rr(d, "MMMM yyyy", c));
      }, e.getQuarterClassNames = function(n) {
        var i = e.props, a = i.day, o = i.startDate, s = i.endDate, l = i.selected, u = i.minDate, c = i.maxDate, d = i.excludeDates, f = i.includeDates, h = i.filterDate, p = i.preSelection, v = i.disabledKeyboardNavigation, g = (u || c || d || f || h) && r0(Xd(a, n), e.props);
        return Ln("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(n), {
          "react-datepicker__quarter-text--disabled": g,
          "react-datepicker__quarter-text--selected": l ? e.isSelectedQuarter(a, n, l) : void 0,
          "react-datepicker__quarter-text--keyboard-selected": !v && p && e.isSelectedQuarter(a, n, p) && !g,
          "react-datepicker__quarter-text--in-selecting-range": e.isInSelectingRangeQuarter(n),
          "react-datepicker__quarter-text--in-range": o && s ? i0(o, s, n, a) : void 0,
          "react-datepicker__quarter-text--range-start": e.isRangeStartQuarter(n),
          "react-datepicker__quarter-text--range-end": e.isRangeEndQuarter(n)
        });
      }, e.getMonthContent = function(n) {
        var i = e.props, a = i.showFullMonthYearPicker, o = i.renderMonthContent, s = i.locale, l = i.day, u = tz(n, s), c = U_(n, s);
        return o ? o(n, u, c, l) : a ? c : u;
      }, e.getQuarterContent = function(n) {
        var i, a = e.props, o = a.renderQuarterContent, s = a.locale, l = P0e(n, s);
        return (i = o == null ? void 0 : o(n, l)) !== null && i !== void 0 ? i : l;
      }, e.renderMonths = function() {
        var n, i = e.props, a = i.showTwoColumnMonthYearPicker, o = i.showFourColumnMonthYearPicker, s = i.day, l = i.selected, u = (n = i4[ML(o, a)]) === null || n === void 0 ? void 0 : n.grid;
        return u == null ? void 0 : u.map(function(c, d) {
          return te.createElement("div", { className: "react-datepicker__month-wrapper", key: d }, c.map(function(f, h) {
            return te.createElement("div", { ref: e.MONTH_REFS[f], key: h, onClick: function(p) {
              e.onMonthClick(p, f);
            }, onKeyDown: function(p) {
              az(p) && (p.preventDefault(), p.key = Te.Enter), e.onMonthKeyDown(p, f);
            }, onMouseEnter: e.props.usePointerEvent ? void 0 : function() {
              return e.onMonthMouseEnter(f);
            }, onPointerEnter: e.props.usePointerEvent ? function() {
              return e.onMonthMouseEnter(f);
            } : void 0, tabIndex: Number(e.getTabIndex(f)), className: e.getMonthClassNames(f), "aria-disabled": e.isMonthDisabled(f), role: "option", "aria-label": e.getAriaLabel(f), "aria-current": e.isCurrentMonth(s, f) ? "date" : void 0, "aria-selected": l ? e.isSelectedMonth(s, f, l) : void 0 }, e.getMonthContent(f));
          }));
        });
      }, e.renderQuarters = function() {
        var n = e.props, i = n.day, a = n.selected, o = [1, 2, 3, 4];
        return te.createElement("div", { className: "react-datepicker__quarter-wrapper" }, o.map(function(s, l) {
          return te.createElement("div", { key: l, ref: e.QUARTER_REFS[l], role: "option", onClick: function(u) {
            e.onQuarterClick(u, s);
          }, onKeyDown: function(u) {
            e.onQuarterKeyDown(u, s);
          }, onMouseEnter: e.props.usePointerEvent ? void 0 : function() {
            return e.onQuarterMouseEnter(s);
          }, onPointerEnter: e.props.usePointerEvent ? function() {
            return e.onQuarterMouseEnter(s);
          } : void 0, className: e.getQuarterClassNames(s), "aria-selected": a ? e.isSelectedQuarter(i, s, a) : void 0, tabIndex: Number(e.getQuarterTabIndex(s)), "aria-current": e.isCurrentQuarter(i, s) ? "date" : void 0 }, e.getQuarterContent(s));
        }));
      }, e.getClassNames = function() {
        var n = e.props, i = n.selectingDate, a = n.selectsStart, o = n.selectsEnd, s = n.showMonthYearPicker, l = n.showQuarterYearPicker, u = n.showWeekPicker;
        return Ln("react-datepicker__month", {
          "react-datepicker__month--selecting-range": i && (a || o)
        }, { "react-datepicker__monthPicker": s }, { "react-datepicker__quarterPicker": l }, { "react-datepicker__weekPicker": u });
      }, e;
    }
    return r.prototype.getSelection = function() {
      var e = this.props, n = e.selected, i = e.selectedDates, a = e.selectsMultiple;
      if (a)
        return i;
      if (n)
        return [n];
    }, r.prototype.render = function() {
      var e = this.props, n = e.showMonthYearPicker, i = e.showQuarterYearPicker, a = e.day, o = e.ariaLabelPrefix, s = o === void 0 ? "Month " : o, l = s ? s.trim() + " " : "";
      return te.createElement("div", { className: this.getClassNames(), onMouseLeave: this.props.usePointerEvent ? void 0 : this.handleMouseLeave, onPointerLeave: this.props.usePointerEvent ? this.handleMouseLeave : void 0, "aria-label": "".concat(l).concat(Rr(a, "MMMM, yyyy", this.props.locale)), role: "listbox" }, n ? this.renderMonths() : i ? this.renderQuarters() : this.renderWeeks());
    }, r;
  }(In)
), K0e = (
  /** @class */
  function(t) {
    kn(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.isSelectedMonth = function(n) {
        return e.props.month === n;
      }, e.renderOptions = function() {
        return e.props.monthNames.map(function(n, i) {
          return te.createElement(
            "div",
            { className: e.isSelectedMonth(i) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option", key: n, onClick: e.onChange.bind(e, i), "aria-selected": e.isSelectedMonth(i) ? "true" : void 0 },
            e.isSelectedMonth(i) ? te.createElement("span", { className: "react-datepicker__month-option--selected" }, "✓") : "",
            n
          );
        });
      }, e.onChange = function(n) {
        return e.props.onChange(n);
      }, e.handleClickOutside = function() {
        return e.props.onCancel();
      }, e;
    }
    return r.prototype.render = function() {
      return te.createElement(z2, { className: "react-datepicker__month-dropdown", onClickOutside: this.handleClickOutside }, this.renderOptions());
    }, r;
  }(In)
), q0e = (
  /** @class */
  function(t) {
    kn(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.state = {
        dropdownVisible: !1
      }, e.renderSelectOptions = function(n) {
        return n.map(function(i, a) {
          return te.createElement("option", { key: i, value: a }, i);
        });
      }, e.renderSelectMode = function(n) {
        return te.createElement("select", { value: e.props.month, className: "react-datepicker__month-select", onChange: function(i) {
          return e.onChange(parseInt(i.target.value));
        } }, e.renderSelectOptions(n));
      }, e.renderReadView = function(n, i) {
        return te.createElement(
          "div",
          { key: "read", style: { visibility: n ? "visible" : "hidden" }, className: "react-datepicker__month-read-view", onClick: e.toggleDropdown },
          te.createElement("span", { className: "react-datepicker__month-read-view--down-arrow" }),
          te.createElement("span", { className: "react-datepicker__month-read-view--selected-month" }, i[e.props.month])
        );
      }, e.renderDropdown = function(n) {
        return te.createElement(K0e, Jt({ key: "dropdown" }, e.props, { monthNames: n, onChange: e.onChange, onCancel: e.toggleDropdown }));
      }, e.renderScrollMode = function(n) {
        var i = e.state.dropdownVisible, a = [e.renderReadView(!i, n)];
        return i && a.unshift(e.renderDropdown(n)), a;
      }, e.onChange = function(n) {
        e.toggleDropdown(), n !== e.props.month && e.props.onChange(n);
      }, e.toggleDropdown = function() {
        return e.setState({
          dropdownVisible: !e.state.dropdownVisible
        });
      }, e;
    }
    return r.prototype.render = function() {
      var e = this, n = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function(a) {
        return tz(a, e.props.locale);
      } : function(a) {
        return U_(a, e.props.locale);
      }), i;
      switch (this.props.dropdownMode) {
        case "scroll":
          i = this.renderScrollMode(n);
          break;
        case "select":
          i = this.renderSelectMode(n);
          break;
      }
      return te.createElement("div", { className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode) }, i);
    }, r;
  }(In)
);
function Q0e(t, r) {
  for (var e = [], n = zs(t), i = zs(r); !au(n, i); )
    e.push(mr(n)), n = no(n, 1);
  return e;
}
var eme = (
  /** @class */
  function(t) {
    kn(r, t);
    function r(e) {
      var n = t.call(this, e) || this;
      return n.renderOptions = function() {
        return n.state.monthYearsList.map(function(i) {
          var a = u6(i), o = Do(n.props.date, i) && yi(n.props.date, i);
          return te.createElement(
            "div",
            { className: o ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option", key: a, onClick: n.onChange.bind(n, a), "aria-selected": o ? "true" : void 0 },
            o ? te.createElement("span", { className: "react-datepicker__month-year-option--selected" }, "✓") : "",
            Rr(i, n.props.dateFormat, n.props.locale)
          );
        });
      }, n.onChange = function(i) {
        return n.props.onChange(i);
      }, n.handleClickOutside = function() {
        n.props.onCancel();
      }, n.state = {
        monthYearsList: Q0e(n.props.minDate, n.props.maxDate)
      }, n;
    }
    return r.prototype.render = function() {
      var e = Ln({
        "react-datepicker__month-year-dropdown": !0,
        "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
      });
      return te.createElement(z2, { className: e, onClickOutside: this.handleClickOutside }, this.renderOptions());
    }, r;
  }(In)
), tme = (
  /** @class */
  function(t) {
    kn(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.state = {
        dropdownVisible: !1
      }, e.renderSelectOptions = function() {
        for (var n = zs(e.props.minDate), i = zs(e.props.maxDate), a = []; !au(n, i); ) {
          var o = u6(n);
          a.push(te.createElement("option", { key: o, value: o }, Rr(n, e.props.dateFormat, e.props.locale))), n = no(n, 1);
        }
        return a;
      }, e.onSelectChange = function(n) {
        e.onChange(parseInt(n.target.value));
      }, e.renderSelectMode = function() {
        return te.createElement("select", { value: u6(zs(e.props.date)), className: "react-datepicker__month-year-select", onChange: e.onSelectChange }, e.renderSelectOptions());
      }, e.renderReadView = function(n) {
        var i = Rr(e.props.date, e.props.dateFormat, e.props.locale);
        return te.createElement(
          "div",
          { key: "read", style: { visibility: n ? "visible" : "hidden" }, className: "react-datepicker__month-year-read-view", onClick: e.toggleDropdown },
          te.createElement("span", { className: "react-datepicker__month-year-read-view--down-arrow" }),
          te.createElement("span", { className: "react-datepicker__month-year-read-view--selected-month-year" }, i)
        );
      }, e.renderDropdown = function() {
        return te.createElement(eme, Jt({ key: "dropdown" }, e.props, { onChange: e.onChange, onCancel: e.toggleDropdown }));
      }, e.renderScrollMode = function() {
        var n = e.state.dropdownVisible, i = [e.renderReadView(!n)];
        return n && i.unshift(e.renderDropdown()), i;
      }, e.onChange = function(n) {
        e.toggleDropdown();
        var i = mr(n);
        Do(e.props.date, i) && yi(e.props.date, i) || e.props.onChange(i);
      }, e.toggleDropdown = function() {
        return e.setState({
          dropdownVisible: !e.state.dropdownVisible
        });
      }, e;
    }
    return r.prototype.render = function() {
      var e;
      switch (this.props.dropdownMode) {
        case "scroll":
          e = this.renderScrollMode();
          break;
        case "select":
          e = this.renderSelectMode();
          break;
      }
      return te.createElement("div", { className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode) }, e);
    }, r;
  }(In)
), rme = (
  /** @class */
  function(t) {
    kn(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.state = {
        height: null
      }, e.scrollToTheSelectedTime = function() {
        requestAnimationFrame(function() {
          var n, i, a;
          e.list && (e.list.scrollTop = (a = e.centerLi && r.calcCenterPosition(e.props.monthRef ? e.props.monthRef.clientHeight - ((i = (n = e.header) === null || n === void 0 ? void 0 : n.clientHeight) !== null && i !== void 0 ? i : 0) : e.list.clientHeight, e.centerLi)) !== null && a !== void 0 ? a : 0);
        });
      }, e.handleClick = function(n) {
        var i, a;
        (e.props.minTime || e.props.maxTime) && bL(n, e.props) || (e.props.excludeTimes || e.props.includeTimes || e.props.filterTime) && yL(n, e.props) || (a = (i = e.props).onChange) === null || a === void 0 || a.call(i, n);
      }, e.isSelectedTime = function(n) {
        return e.props.selected && Z0e(e.props.selected, n);
      }, e.isDisabledTime = function(n) {
        return (e.props.minTime || e.props.maxTime) && bL(n, e.props) || (e.props.excludeTimes || e.props.includeTimes || e.props.filterTime) && yL(n, e.props);
      }, e.liClasses = function(n) {
        var i, a = [
          "react-datepicker__time-list-item",
          e.props.timeClassName ? e.props.timeClassName(n) : void 0
        ];
        return e.isSelectedTime(n) && a.push("react-datepicker__time-list-item--selected"), e.isDisabledTime(n) && a.push("react-datepicker__time-list-item--disabled"), e.props.injectTimes && (Zo(n) * 3600 + jo(n) * 60 + Hs(n)) % (((i = e.props.intervals) !== null && i !== void 0 ? i : r.defaultProps.intervals) * 60) !== 0 && a.push("react-datepicker__time-list-item--injected"), a.join(" ");
      }, e.handleOnKeyDown = function(n, i) {
        var a, o;
        n.key === Te.Space && (n.preventDefault(), n.key = Te.Enter), (n.key === Te.ArrowUp || n.key === Te.ArrowLeft) && n.target instanceof HTMLElement && n.target.previousSibling && (n.preventDefault(), n.target.previousSibling instanceof HTMLElement && n.target.previousSibling.focus()), (n.key === Te.ArrowDown || n.key === Te.ArrowRight) && n.target instanceof HTMLElement && n.target.nextSibling && (n.preventDefault(), n.target.nextSibling instanceof HTMLElement && n.target.nextSibling.focus()), n.key === Te.Enter && e.handleClick(i), (o = (a = e.props).handleOnKeyDown) === null || o === void 0 || o.call(a, n);
      }, e.renderTimes = function() {
        for (var n, i = [], a = typeof e.props.format == "string" ? e.props.format : "p", o = (n = e.props.intervals) !== null && n !== void 0 ? n : r.defaultProps.intervals, s = e.props.selected || e.props.openToDate || mr(), l = j0(s), u = e.props.injectTimes && e.props.injectTimes.sort(function(g, m) {
          return g.getTime() - m.getTime();
        }), c = 60 * W0e(s), d = c / o, f = 0; f < d; f++) {
          var h = o6(l, f * o);
          if (i.push(h), u) {
            var p = z0e(l, h, f, o, u);
            i = i.concat(p);
          }
        }
        var v = i.reduce(function(g, m) {
          return m.getTime() <= s.getTime() ? m : g;
        }, i[0]);
        return i.map(function(g) {
          return te.createElement("li", { key: g.valueOf(), onClick: e.handleClick.bind(e, g), className: e.liClasses(g), ref: function(m) {
            g === v && (e.centerLi = m);
          }, onKeyDown: function(m) {
            e.handleOnKeyDown(m, g);
          }, tabIndex: g === v ? 0 : -1, role: "option", "aria-selected": e.isSelectedTime(g) ? "true" : void 0, "aria-disabled": e.isDisabledTime(g) ? "true" : void 0 }, Rr(g, a, e.props.locale));
        });
      }, e.renderTimeCaption = function() {
        return e.props.showTimeCaption === !1 ? te.createElement(te.Fragment, null) : te.createElement(
          "div",
          { className: "react-datepicker__header react-datepicker__header--time ".concat(e.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""), ref: function(n) {
            e.header = n;
          } },
          te.createElement("div", { className: "react-datepicker-time__header" }, e.props.timeCaption)
        );
      }, e;
    }
    return Object.defineProperty(r, "defaultProps", {
      get: function() {
        return {
          intervals: 30,
          todayButton: null,
          timeCaption: "Time",
          showTimeCaption: !0
        };
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.componentDidMount = function() {
      this.scrollToTheSelectedTime(), this.props.monthRef && this.header && this.setState({
        height: this.props.monthRef.clientHeight - this.header.clientHeight
      });
    }, r.prototype.render = function() {
      var e = this, n, i = this.state.height;
      return te.createElement(
        "div",
        { className: "react-datepicker__time-container ".concat(((n = this.props.todayButton) !== null && n !== void 0 ? n : r.defaultProps.todayButton) ? "react-datepicker__time-container--with-today-button" : "") },
        this.renderTimeCaption(),
        te.createElement(
          "div",
          { className: "react-datepicker__time" },
          te.createElement(
            "div",
            { className: "react-datepicker__time-box" },
            te.createElement("ul", { className: "react-datepicker__time-list", ref: function(a) {
              e.list = a;
            }, style: i ? { height: i } : {}, role: "listbox", "aria-label": this.props.timeCaption }, this.renderTimes())
          )
        )
      );
    }, r.calcCenterPosition = function(e, n) {
      return n.offsetTop - (e / 2 - n.clientHeight / 2);
    }, r;
  }(In)
), RL = 3, nme = (
  /** @class */
  function(t) {
    kn(r, t);
    function r(e) {
      var n = t.call(this, e) || this;
      return n.YEAR_REFS = Go([], Array(n.props.yearItemNumber), !0).map(function() {
        return Ul();
      }), n.isDisabled = function(i) {
        return xa(i, {
          minDate: n.props.minDate,
          maxDate: n.props.maxDate,
          excludeDates: n.props.excludeDates,
          includeDates: n.props.includeDates,
          filterDate: n.props.filterDate
        });
      }, n.isExcluded = function(i) {
        return J_(i, {
          excludeDates: n.props.excludeDates
        });
      }, n.selectingDate = function() {
        var i;
        return (i = n.props.selectingDate) !== null && i !== void 0 ? i : n.props.preSelection;
      }, n.updateFocusOnPaginate = function(i) {
        var a = function() {
          var o, s;
          (s = (o = n.YEAR_REFS[i]) === null || o === void 0 ? void 0 : o.current) === null || s === void 0 || s.focus();
        };
        window.requestAnimationFrame(a);
      }, n.handleYearClick = function(i, a) {
        n.props.onDayClick && n.props.onDayClick(i, a);
      }, n.handleYearNavigation = function(i, a) {
        var o, s, l, u, c = n.props, d = c.date, f = c.yearItemNumber;
        if (!(d === void 0 || f === void 0)) {
          var h = El(d, f).startPeriod;
          n.isDisabled(a) || n.isExcluded(a) || ((s = (o = n.props).setPreSelection) === null || s === void 0 || s.call(o, a), i - h < 0 ? n.updateFocusOnPaginate(f - (h - i)) : i - h >= f ? n.updateFocusOnPaginate(Math.abs(f - (i - h))) : (u = (l = n.YEAR_REFS[i - h]) === null || l === void 0 ? void 0 : l.current) === null || u === void 0 || u.focus());
        }
      }, n.isSameDay = function(i, a) {
        return jt(i, a);
      }, n.isCurrentYear = function(i) {
        return i === ht(mr());
      }, n.isRangeStart = function(i) {
        return n.props.startDate && n.props.endDate && Do(Ao(mr(), i), n.props.startDate);
      }, n.isRangeEnd = function(i) {
        return n.props.startDate && n.props.endDate && Do(Ao(mr(), i), n.props.endDate);
      }, n.isInRange = function(i) {
        return n0(i, n.props.startDate, n.props.endDate);
      }, n.isInSelectingRange = function(i) {
        var a = n.props, o = a.selectsStart, s = a.selectsEnd, l = a.selectsRange, u = a.startDate, c = a.endDate;
        return !(o || s || l) || !n.selectingDate() ? !1 : o && c ? n0(i, n.selectingDate(), c) : s && u || l && u && !c ? n0(i, u, n.selectingDate()) : !1;
      }, n.isSelectingRangeStart = function(i) {
        var a;
        if (!n.isInSelectingRange(i))
          return !1;
        var o = n.props, s = o.startDate, l = o.selectsStart, u = Ao(mr(), i);
        return l ? Do(u, (a = n.selectingDate()) !== null && a !== void 0 ? a : null) : Do(u, s ?? null);
      }, n.isSelectingRangeEnd = function(i) {
        var a;
        if (!n.isInSelectingRange(i))
          return !1;
        var o = n.props, s = o.endDate, l = o.selectsEnd, u = o.selectsRange, c = Ao(mr(), i);
        return l || u ? Do(c, (a = n.selectingDate()) !== null && a !== void 0 ? a : null) : Do(c, s ?? null);
      }, n.isKeyboardSelected = function(i) {
        if (!(n.props.date === void 0 || n.props.selected == null || n.props.preSelection == null)) {
          var a = n.props, o = a.minDate, s = a.maxDate, l = a.excludeDates, u = a.includeDates, c = a.filterDate, d = Gp(Ao(n.props.date, i)), f = (o || s || l || u || c) && Y0(i, n.props);
          return !n.props.disabledKeyboardNavigation && !n.props.inline && !jt(d, Gp(n.props.selected)) && jt(d, Gp(n.props.preSelection)) && !f;
        }
      }, n.onYearClick = function(i, a) {
        var o = n.props.date;
        o !== void 0 && n.handleYearClick(Gp(Ao(o, a)), i);
      }, n.onYearKeyDown = function(i, a) {
        var o, s, l = i.key, u = n.props, c = u.date, d = u.yearItemNumber, f = u.handleOnKeyDown;
        if (l !== Te.Tab && i.preventDefault(), !n.props.disabledKeyboardNavigation)
          switch (l) {
            case Te.Enter:
              if (n.props.selected == null)
                break;
              n.onYearClick(i, a), (s = (o = n.props).setPreSelection) === null || s === void 0 || s.call(o, n.props.selected);
              break;
            case Te.ArrowRight:
              if (n.props.preSelection == null)
                break;
              n.handleYearNavigation(a + 1, Bs(n.props.preSelection, 1));
              break;
            case Te.ArrowLeft:
              if (n.props.preSelection == null)
                break;
              n.handleYearNavigation(a - 1, Ff(n.props.preSelection, 1));
              break;
            case Te.ArrowUp: {
              if (c === void 0 || d === void 0 || n.props.preSelection == null)
                break;
              var h = El(c, d).startPeriod, p = RL, v = a - p;
              if (v < h) {
                var g = d % p;
                a >= h && a < h + g ? p = g : p += g, v = a - p;
              }
              n.handleYearNavigation(v, Ff(n.props.preSelection, p));
              break;
            }
            case Te.ArrowDown: {
              if (c === void 0 || d === void 0 || n.props.preSelection == null)
                break;
              var m = El(c, d).endPeriod, p = RL, v = a + p;
              if (v > m) {
                var g = d % p;
                a <= m && a > m - g ? p = g : p += g, v = a + p;
              }
              n.handleYearNavigation(v, Bs(n.props.preSelection, p));
              break;
            }
          }
        f && f(i);
      }, n.getYearClassNames = function(i) {
        var a = n.props, o = a.date, s = a.minDate, l = a.maxDate, u = a.selected, c = a.excludeDates, d = a.includeDates, f = a.filterDate, h = a.yearClassName;
        return Ln("react-datepicker__year-text", "react-datepicker__year-".concat(i), o ? h == null ? void 0 : h(Ao(o, i)) : void 0, {
          "react-datepicker__year-text--selected": u ? i === ht(u) : void 0,
          "react-datepicker__year-text--disabled": (s || l || c || d || f) && Y0(i, n.props),
          "react-datepicker__year-text--keyboard-selected": n.isKeyboardSelected(i),
          "react-datepicker__year-text--range-start": n.isRangeStart(i),
          "react-datepicker__year-text--range-end": n.isRangeEnd(i),
          "react-datepicker__year-text--in-range": n.isInRange(i),
          "react-datepicker__year-text--in-selecting-range": n.isInSelectingRange(i),
          "react-datepicker__year-text--selecting-range-start": n.isSelectingRangeStart(i),
          "react-datepicker__year-text--selecting-range-end": n.isSelectingRangeEnd(i),
          "react-datepicker__year-text--today": n.isCurrentYear(i)
        });
      }, n.getYearTabIndex = function(i) {
        if (n.props.disabledKeyboardNavigation || n.props.preSelection == null)
          return "-1";
        var a = ht(n.props.preSelection), o = Y0(i, n.props);
        return i === a && !o ? "0" : "-1";
      }, n.getYearContainerClassNames = function() {
        var i = n.props, a = i.selectingDate, o = i.selectsStart, s = i.selectsEnd, l = i.selectsRange;
        return Ln("react-datepicker__year", {
          "react-datepicker__year--selecting-range": a && (o || s || l)
        });
      }, n.getYearContent = function(i) {
        return n.props.renderYearContent ? n.props.renderYearContent(i) : i;
      }, n;
    }
    return r.prototype.render = function() {
      var e = this, n = [], i = this.props, a = i.date, o = i.yearItemNumber, s = i.onYearMouseEnter, l = i.onYearMouseLeave;
      if (a === void 0)
        return null;
      for (var u = El(a, o), c = u.startPeriod, d = u.endPeriod, f = function(v) {
        n.push(te.createElement("div", { ref: h.YEAR_REFS[v - c], onClick: function(g) {
          e.onYearClick(g, v);
        }, onKeyDown: function(g) {
          az(g) && (g.preventDefault(), g.key = Te.Enter), e.onYearKeyDown(g, v);
        }, tabIndex: Number(h.getYearTabIndex(v)), className: h.getYearClassNames(v), onMouseEnter: h.props.usePointerEvent ? void 0 : function(g) {
          return s(g, v);
        }, onPointerEnter: h.props.usePointerEvent ? function(g) {
          return s(g, v);
        } : void 0, onMouseLeave: h.props.usePointerEvent ? void 0 : function(g) {
          return l(g, v);
        }, onPointerLeave: h.props.usePointerEvent ? function(g) {
          return l(g, v);
        } : void 0, key: v, "aria-current": h.isCurrentYear(v) ? "date" : void 0 }, h.getYearContent(v)));
      }, h = this, p = c; p <= d; p++)
        f(p);
      return te.createElement(
        "div",
        { className: this.getYearContainerClassNames() },
        te.createElement("div", { className: "react-datepicker__year-wrapper", onMouseLeave: this.props.usePointerEvent ? void 0 : this.props.clearSelectingDate, onPointerLeave: this.props.usePointerEvent ? this.props.clearSelectingDate : void 0 }, n)
      );
    }, r;
  }(In)
);
function ime(t, r, e, n) {
  for (var i = [], a = 0; a < 2 * r + 1; a++) {
    var o = t + r - a, s = !0;
    e && (s = ht(e) <= o), n && s && (s = ht(n) >= o), s && i.push(o);
  }
  return i;
}
var ame = (
  /** @class */
  function(t) {
    kn(r, t);
    function r(e) {
      var n = t.call(this, e) || this;
      n.renderOptions = function() {
        var s = n.props.year, l = n.state.yearsList.map(function(d) {
          return te.createElement(
            "div",
            { className: s === d ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option", key: d, onClick: n.onChange.bind(n, d), "aria-selected": s === d ? "true" : void 0 },
            s === d ? te.createElement("span", { className: "react-datepicker__year-option--selected" }, "✓") : "",
            d
          );
        }), u = n.props.minDate ? ht(n.props.minDate) : null, c = n.props.maxDate ? ht(n.props.maxDate) : null;
        return (!c || !n.state.yearsList.find(function(d) {
          return d === c;
        })) && l.unshift(te.createElement(
          "div",
          { className: "react-datepicker__year-option", key: "upcoming", onClick: n.incrementYears },
          te.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming" })
        )), (!u || !n.state.yearsList.find(function(d) {
          return d === u;
        })) && l.push(te.createElement(
          "div",
          { className: "react-datepicker__year-option", key: "previous", onClick: n.decrementYears },
          te.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous" })
        )), l;
      }, n.onChange = function(s) {
        n.props.onChange(s);
      }, n.handleClickOutside = function() {
        n.props.onCancel();
      }, n.shiftYears = function(s) {
        var l = n.state.yearsList.map(function(u) {
          return u + s;
        });
        n.setState({
          yearsList: l
        });
      }, n.incrementYears = function() {
        return n.shiftYears(1);
      }, n.decrementYears = function() {
        return n.shiftYears(-1);
      };
      var i = e.yearDropdownItemNumber, a = e.scrollableYearDropdown, o = i || (a ? 10 : 5);
      return n.state = {
        yearsList: ime(n.props.year, o, n.props.minDate, n.props.maxDate)
      }, n.dropdownRef = Ul(), n;
    }
    return r.prototype.componentDidMount = function() {
      var e = this.dropdownRef.current;
      if (e) {
        var n = e.children ? Array.from(e.children) : null, i = n ? n.find(function(a) {
          return a.ariaSelected;
        }) : null;
        e.scrollTop = i && i instanceof HTMLElement ? i.offsetTop + (i.clientHeight - e.clientHeight) / 2 : (e.scrollHeight - e.clientHeight) / 2;
      }
    }, r.prototype.render = function() {
      var e = Ln({
        "react-datepicker__year-dropdown": !0,
        "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
      });
      return te.createElement(z2, { className: e, containerRef: this.dropdownRef, onClickOutside: this.handleClickOutside }, this.renderOptions());
    }, r;
  }(In)
), ome = (
  /** @class */
  function(t) {
    kn(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.state = {
        dropdownVisible: !1
      }, e.renderSelectOptions = function() {
        for (var n = e.props.minDate ? ht(e.props.minDate) : 1900, i = e.props.maxDate ? ht(e.props.maxDate) : 2100, a = [], o = n; o <= i; o++)
          a.push(te.createElement("option", { key: o, value: o }, o));
        return a;
      }, e.onSelectChange = function(n) {
        e.onChange(parseInt(n.target.value));
      }, e.renderSelectMode = function() {
        return te.createElement("select", { value: e.props.year, className: "react-datepicker__year-select", onChange: e.onSelectChange }, e.renderSelectOptions());
      }, e.renderReadView = function(n) {
        return te.createElement(
          "div",
          { key: "read", style: { visibility: n ? "visible" : "hidden" }, className: "react-datepicker__year-read-view", onClick: function(i) {
            return e.toggleDropdown(i);
          } },
          te.createElement("span", { className: "react-datepicker__year-read-view--down-arrow" }),
          te.createElement("span", { className: "react-datepicker__year-read-view--selected-year" }, e.props.year)
        );
      }, e.renderDropdown = function() {
        return te.createElement(ame, Jt({ key: "dropdown" }, e.props, { onChange: e.onChange, onCancel: e.toggleDropdown }));
      }, e.renderScrollMode = function() {
        var n = e.state.dropdownVisible, i = [e.renderReadView(!n)];
        return n && i.unshift(e.renderDropdown()), i;
      }, e.onChange = function(n) {
        e.toggleDropdown(), n !== e.props.year && e.props.onChange(n);
      }, e.toggleDropdown = function(n) {
        e.setState({
          dropdownVisible: !e.state.dropdownVisible
        }, function() {
          e.props.adjustDateOnChange && e.handleYearChange(e.props.date, n);
        });
      }, e.handleYearChange = function(n, i) {
        var a;
        (a = e.onSelect) === null || a === void 0 || a.call(e, n, i), e.setOpen();
      }, e.onSelect = function(n, i) {
        var a, o;
        (o = (a = e.props).onSelect) === null || o === void 0 || o.call(a, n, i);
      }, e.setOpen = function() {
        var n, i;
        (i = (n = e.props).setOpen) === null || i === void 0 || i.call(n, !0);
      }, e;
    }
    return r.prototype.render = function() {
      var e;
      switch (this.props.dropdownMode) {
        case "scroll":
          e = this.renderScrollMode();
          break;
        case "select":
          e = this.renderSelectMode();
          break;
      }
      return te.createElement("div", { className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode) }, e);
    }, r;
  }(In)
), sme = [
  "react-datepicker__year-select",
  "react-datepicker__month-select",
  "react-datepicker__month-year-select"
], lme = function(t) {
  var r = (t.className || "").split(/\s+/);
  return sme.some(function(e) {
    return r.indexOf(e) >= 0;
  });
}, ume = (
  /** @class */
  function(t) {
    kn(r, t);
    function r(e) {
      var n = t.call(this, e) || this;
      return n.monthContainer = void 0, n.handleClickOutside = function(i) {
        n.props.onClickOutside(i);
      }, n.setClickOutsideRef = function() {
        return n.containerRef.current;
      }, n.handleDropdownFocus = function(i) {
        var a, o;
        lme(i.target) && ((o = (a = n.props).onDropdownFocus) === null || o === void 0 || o.call(a, i));
      }, n.getDateInView = function() {
        var i = n.props, a = i.preSelection, o = i.selected, s = i.openToDate, l = nz(n.props), u = iz(n.props), c = mr(), d = s || o || a;
        return d || (l && Yc(c, l) ? l : u && au(c, u) ? u : c);
      }, n.increaseMonth = function() {
        n.setState(function(i) {
          var a = i.date;
          return {
            date: no(a, 1)
          };
        }, function() {
          return n.handleMonthChange(n.state.date);
        });
      }, n.decreaseMonth = function() {
        n.setState(function(i) {
          var a = i.date;
          return {
            date: Bf(a, 1)
          };
        }, function() {
          return n.handleMonthChange(n.state.date);
        });
      }, n.handleDayClick = function(i, a, o) {
        n.props.onSelect(i, a, o), n.props.setPreSelection && n.props.setPreSelection(i);
      }, n.handleDayMouseEnter = function(i) {
        n.setState({ selectingDate: i }), n.props.onDayMouseEnter && n.props.onDayMouseEnter(i);
      }, n.handleMonthMouseLeave = function() {
        n.setState({ selectingDate: void 0 }), n.props.onMonthMouseLeave && n.props.onMonthMouseLeave();
      }, n.handleYearMouseEnter = function(i, a) {
        n.setState({ selectingDate: Ao(mr(), a) }), n.props.onYearMouseEnter && n.props.onYearMouseEnter(i, a);
      }, n.handleYearMouseLeave = function(i, a) {
        n.props.onYearMouseLeave && n.props.onYearMouseLeave(i, a);
      }, n.handleYearChange = function(i) {
        var a, o, s, l;
        (o = (a = n.props).onYearChange) === null || o === void 0 || o.call(a, i), n.setState({ isRenderAriaLiveMessage: !0 }), n.props.adjustDateOnChange && (n.props.onSelect(i), (l = (s = n.props).setOpen) === null || l === void 0 || l.call(s, !0)), n.props.setPreSelection && n.props.setPreSelection(i);
      }, n.getEnabledPreSelectionDateForMonth = function(i) {
        if (!xa(i, n.props))
          return i;
        for (var a = zs(i), o = R0e(i), s = uve(o, a), l = null, u = 0; u <= s; u++) {
          var c = el(a, u);
          if (!xa(c, n.props)) {
            l = c;
            break;
          }
        }
        return l;
      }, n.handleMonthChange = function(i) {
        var a, o, s, l = (a = n.getEnabledPreSelectionDateForMonth(i)) !== null && a !== void 0 ? a : i;
        n.handleCustomMonthChange(l), n.props.adjustDateOnChange && (n.props.onSelect(l), (s = (o = n.props).setOpen) === null || s === void 0 || s.call(o, !0)), n.props.setPreSelection && n.props.setPreSelection(l);
      }, n.handleCustomMonthChange = function(i) {
        var a, o;
        (o = (a = n.props).onMonthChange) === null || o === void 0 || o.call(a, i), n.setState({ isRenderAriaLiveMessage: !0 });
      }, n.handleMonthYearChange = function(i) {
        n.handleYearChange(i), n.handleMonthChange(i);
      }, n.changeYear = function(i) {
        n.setState(function(a) {
          var o = a.date;
          return {
            date: Ao(o, Number(i))
          };
        }, function() {
          return n.handleYearChange(n.state.date);
        });
      }, n.changeMonth = function(i) {
        n.setState(function(a) {
          var o = a.date;
          return {
            date: Zi(o, Number(i))
          };
        }, function() {
          return n.handleMonthChange(n.state.date);
        });
      }, n.changeMonthYear = function(i) {
        n.setState(function(a) {
          var o = a.date;
          return {
            date: Ao(Zi(o, sn(i)), ht(i))
          };
        }, function() {
          return n.handleMonthYearChange(n.state.date);
        });
      }, n.header = function(i) {
        i === void 0 && (i = n.state.date);
        var a = Zl(i, n.props.locale, n.props.calendarStartDay), o = [];
        return n.props.showWeekNumbers && o.push(te.createElement("div", { key: "W", className: "react-datepicker__day-name" }, n.props.weekLabel || "#")), o.concat([0, 1, 2, 3, 4, 5, 6].map(function(s) {
          var l = el(a, s), u = n.formatWeekday(l, n.props.locale), c = n.props.weekDayClassName ? n.props.weekDayClassName(l) : void 0;
          return te.createElement("div", { key: s, "aria-label": Rr(l, "EEEE", n.props.locale), className: Ln("react-datepicker__day-name", c) }, u);
        }));
      }, n.formatWeekday = function(i, a) {
        return n.props.formatWeekDay ? L0e(i, n.props.formatWeekDay, a) : n.props.useWeekdaysShort ? k0e(i, a) : E0e(i, a);
      }, n.decreaseYear = function() {
        n.setState(function(i) {
          var a, o = i.date;
          return {
            date: Ff(o, n.props.showYearPicker ? (a = n.props.yearItemNumber) !== null && a !== void 0 ? a : r.defaultProps.yearItemNumber : 1)
          };
        }, function() {
          return n.handleYearChange(n.state.date);
        });
      }, n.clearSelectingDate = function() {
        n.setState({ selectingDate: void 0 });
      }, n.renderPreviousButton = function() {
        var i;
        if (!n.props.renderCustomHeader) {
          var a;
          switch (!0) {
            case n.props.showMonthYearPicker:
              a = _L(n.state.date, n.props);
              break;
            case n.props.showYearPicker:
              a = G0e(n.state.date, n.props);
              break;
            case n.props.showQuarterYearPicker:
              a = O0e(n.state.date, n.props);
              break;
            default:
              a = CL(n.state.date, n.props);
              break;
          }
          if (!(!((i = n.props.forceShowMonthNavigation) !== null && i !== void 0 ? i : r.defaultProps.forceShowMonthNavigation) && !n.props.showDisabledMonthNavigation && a || n.props.showTimeSelectOnly)) {
            var o = [
              "react-datepicker__navigation-icon",
              "react-datepicker__navigation-icon--previous"
            ], s = [
              "react-datepicker__navigation",
              "react-datepicker__navigation--previous"
            ], l = n.decreaseMonth;
            (n.props.showMonthYearPicker || n.props.showQuarterYearPicker || n.props.showYearPicker) && (l = n.decreaseYear), a && n.props.showDisabledMonthNavigation && (s.push("react-datepicker__navigation--previous--disabled"), l = void 0);
            var u = n.props.showMonthYearPicker || n.props.showQuarterYearPicker || n.props.showYearPicker, c = n.props, d = c.previousMonthButtonLabel, f = d === void 0 ? r.defaultProps.previousMonthButtonLabel : d, h = c.previousYearButtonLabel, p = h === void 0 ? r.defaultProps.previousYearButtonLabel : h, v = n.props, g = v.previousMonthAriaLabel, m = g === void 0 ? typeof f == "string" ? f : "Previous Month" : g, y = v.previousYearAriaLabel, b = y === void 0 ? typeof p == "string" ? p : "Previous Year" : y;
            return te.createElement(
              "button",
              { type: "button", className: s.join(" "), onClick: l, onKeyDown: n.props.handleOnKeyDown, "aria-label": u ? b : m },
              te.createElement("span", { className: o.join(" ") }, u ? p : f)
            );
          }
        }
      }, n.increaseYear = function() {
        n.setState(function(i) {
          var a, o = i.date;
          return {
            date: Bs(o, n.props.showYearPicker ? (a = n.props.yearItemNumber) !== null && a !== void 0 ? a : r.defaultProps.yearItemNumber : 1)
          };
        }, function() {
          return n.handleYearChange(n.state.date);
        });
      }, n.renderNextButton = function() {
        var i;
        if (!n.props.renderCustomHeader) {
          var a;
          switch (!0) {
            case n.props.showMonthYearPicker:
              a = xL(n.state.date, n.props);
              break;
            case n.props.showYearPicker:
              a = B0e(n.state.date, n.props);
              break;
            case n.props.showQuarterYearPicker:
              a = V0e(n.state.date, n.props);
              break;
            default:
              a = wL(n.state.date, n.props);
              break;
          }
          if (!(!((i = n.props.forceShowMonthNavigation) !== null && i !== void 0 ? i : r.defaultProps.forceShowMonthNavigation) && !n.props.showDisabledMonthNavigation && a || n.props.showTimeSelectOnly)) {
            var o = [
              "react-datepicker__navigation",
              "react-datepicker__navigation--next"
            ], s = [
              "react-datepicker__navigation-icon",
              "react-datepicker__navigation-icon--next"
            ];
            n.props.showTimeSelect && o.push("react-datepicker__navigation--next--with-time"), n.props.todayButton && o.push("react-datepicker__navigation--next--with-today-button");
            var l = n.increaseMonth;
            (n.props.showMonthYearPicker || n.props.showQuarterYearPicker || n.props.showYearPicker) && (l = n.increaseYear), a && n.props.showDisabledMonthNavigation && (o.push("react-datepicker__navigation--next--disabled"), l = void 0);
            var u = n.props.showMonthYearPicker || n.props.showQuarterYearPicker || n.props.showYearPicker, c = n.props, d = c.nextMonthButtonLabel, f = d === void 0 ? r.defaultProps.nextMonthButtonLabel : d, h = c.nextYearButtonLabel, p = h === void 0 ? r.defaultProps.nextYearButtonLabel : h, v = n.props, g = v.nextMonthAriaLabel, m = g === void 0 ? typeof f == "string" ? f : "Next Month" : g, y = v.nextYearAriaLabel, b = y === void 0 ? typeof p == "string" ? p : "Next Year" : y;
            return te.createElement(
              "button",
              { type: "button", className: o.join(" "), onClick: l, onKeyDown: n.props.handleOnKeyDown, "aria-label": u ? b : m },
              te.createElement("span", { className: s.join(" ") }, u ? p : f)
            );
          }
        }
      }, n.renderCurrentMonth = function(i) {
        i === void 0 && (i = n.state.date);
        var a = ["react-datepicker__current-month"];
        return n.props.showYearDropdown && a.push("react-datepicker__current-month--hasYearDropdown"), n.props.showMonthDropdown && a.push("react-datepicker__current-month--hasMonthDropdown"), n.props.showMonthYearDropdown && a.push("react-datepicker__current-month--hasMonthYearDropdown"), te.createElement("h2", { className: a.join(" ") }, Rr(i, n.props.dateFormat, n.props.locale));
      }, n.renderYearDropdown = function(i) {
        if (i === void 0 && (i = !1), !(!n.props.showYearDropdown || i))
          return te.createElement(ome, Jt({}, r.defaultProps, n.props, { date: n.state.date, onChange: n.changeYear, year: ht(n.state.date) }));
      }, n.renderMonthDropdown = function(i) {
        if (i === void 0 && (i = !1), !(!n.props.showMonthDropdown || i))
          return te.createElement(q0e, Jt({}, r.defaultProps, n.props, { month: sn(n.state.date), onChange: n.changeMonth }));
      }, n.renderMonthYearDropdown = function(i) {
        if (i === void 0 && (i = !1), !(!n.props.showMonthYearDropdown || i))
          return te.createElement(tme, Jt({}, r.defaultProps, n.props, { date: n.state.date, onChange: n.changeMonthYear }));
      }, n.handleTodayButtonClick = function(i) {
        n.props.onSelect(vL(), i), n.props.setPreSelection && n.props.setPreSelection(vL());
      }, n.renderTodayButton = function() {
        if (!(!n.props.todayButton || n.props.showTimeSelectOnly))
          return te.createElement("div", { className: "react-datepicker__today-button", onClick: n.handleTodayButtonClick }, n.props.todayButton);
      }, n.renderDefaultHeader = function(i) {
        var a = i.monthDate, o = i.i;
        return te.createElement(
          "div",
          { className: "react-datepicker__header ".concat(n.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "") },
          n.renderCurrentMonth(a),
          te.createElement(
            "div",
            { className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(n.props.dropdownMode), onFocus: n.handleDropdownFocus },
            n.renderMonthDropdown(o !== 0),
            n.renderMonthYearDropdown(o !== 0),
            n.renderYearDropdown(o !== 0)
          ),
          te.createElement("div", { className: "react-datepicker__day-names" }, n.header(a))
        );
      }, n.renderCustomHeader = function(i) {
        var a, o, s = i.monthDate, l = i.i;
        if (n.props.showTimeSelect && !n.state.monthContainer || n.props.showTimeSelectOnly)
          return null;
        var u = CL(n.state.date, n.props), c = wL(n.state.date, n.props), d = _L(n.state.date, n.props), f = xL(n.state.date, n.props), h = !n.props.showMonthYearPicker && !n.props.showQuarterYearPicker && !n.props.showYearPicker;
        return te.createElement(
          "div",
          { className: "react-datepicker__header react-datepicker__header--custom", onFocus: n.props.onDropdownFocus },
          (o = (a = n.props).renderCustomHeader) === null || o === void 0 ? void 0 : o.call(a, Jt(Jt({}, n.state), { customHeaderCount: l, monthDate: s, changeMonth: n.changeMonth, changeYear: n.changeYear, decreaseMonth: n.decreaseMonth, increaseMonth: n.increaseMonth, decreaseYear: n.decreaseYear, increaseYear: n.increaseYear, prevMonthButtonDisabled: u, nextMonthButtonDisabled: c, prevYearButtonDisabled: d, nextYearButtonDisabled: f })),
          h && te.createElement("div", { className: "react-datepicker__day-names" }, n.header(s))
        );
      }, n.renderYearHeader = function(i) {
        var a = i.monthDate, o = n.props, s = o.showYearPicker, l = o.yearItemNumber, u = l === void 0 ? r.defaultProps.yearItemNumber : l, c = El(a, u), d = c.startPeriod, f = c.endPeriod;
        return te.createElement("div", { className: "react-datepicker__header react-datepicker-year-header" }, s ? "".concat(d, " - ").concat(f) : ht(a));
      }, n.renderHeader = function(i) {
        var a = i.monthDate, o = i.i, s = o === void 0 ? 0 : o, l = { monthDate: a, i: s };
        switch (!0) {
          case n.props.renderCustomHeader !== void 0:
            return n.renderCustomHeader(l);
          case (n.props.showMonthYearPicker || n.props.showQuarterYearPicker || n.props.showYearPicker):
            return n.renderYearHeader(l);
          default:
            return n.renderDefaultHeader(l);
        }
      }, n.renderMonths = function() {
        var i, a;
        if (!(n.props.showTimeSelectOnly || n.props.showYearPicker)) {
          for (var o = [], s = (i = n.props.monthsShown) !== null && i !== void 0 ? i : r.defaultProps.monthsShown, l = n.props.showPreviousMonths ? s - 1 : 0, u = n.props.showMonthYearPicker || n.props.showQuarterYearPicker ? Bs(n.state.date, l) : Bf(n.state.date, l), c = (a = n.props.monthSelectedIn) !== null && a !== void 0 ? a : l, d = 0; d < s; ++d) {
            var f = d - c + l, h = n.props.showMonthYearPicker || n.props.showQuarterYearPicker ? Bs(u, f) : no(u, f), p = "month-".concat(d), v = d < s - 1, g = d > 0;
            o.push(te.createElement(
              "div",
              { key: p, ref: function(m) {
                n.monthContainer = m ?? void 0;
              }, className: "react-datepicker__month-container" },
              n.renderHeader({ monthDate: h, i: d }),
              te.createElement(J0e, Jt({}, r.defaultProps, n.props, { ariaLabelPrefix: n.props.monthAriaLabelPrefix, day: h, onDayClick: n.handleDayClick, handleOnKeyDown: n.props.handleOnDayKeyDown, handleOnMonthKeyDown: n.props.handleOnKeyDown, onDayMouseEnter: n.handleDayMouseEnter, onMouseLeave: n.handleMonthMouseLeave, orderInDisplay: d, selectingDate: n.state.selectingDate, monthShowsDuplicateDaysEnd: v, monthShowsDuplicateDaysStart: g }))
            ));
          }
          return o;
        }
      }, n.renderYears = function() {
        if (!n.props.showTimeSelectOnly && n.props.showYearPicker)
          return te.createElement(
            "div",
            { className: "react-datepicker__year--container" },
            n.renderHeader({ monthDate: n.state.date }),
            te.createElement(nme, Jt({}, r.defaultProps, n.props, { selectingDate: n.state.selectingDate, date: n.state.date, onDayClick: n.handleDayClick, clearSelectingDate: n.clearSelectingDate, onYearMouseEnter: n.handleYearMouseEnter, onYearMouseLeave: n.handleYearMouseLeave }))
          );
      }, n.renderTimeSection = function() {
        if (n.props.showTimeSelect && (n.state.monthContainer || n.props.showTimeSelectOnly))
          return te.createElement(rme, Jt({}, r.defaultProps, n.props, { onChange: n.props.onTimeChange, format: n.props.timeFormat, intervals: n.props.timeIntervals, monthRef: n.state.monthContainer }));
      }, n.renderInputTimeSection = function() {
        var i = n.props.selected ? new Date(n.props.selected) : void 0, a = i && Ds(i) && !!n.props.selected, o = a ? "".concat(IL(i.getHours()), ":").concat(IL(i.getMinutes())) : "";
        if (n.props.showTimeInput)
          return te.createElement(j0e, Jt({}, r.defaultProps, n.props, { date: i, timeString: o, onChange: n.props.onTimeChange }));
      }, n.renderAriaLiveRegion = function() {
        var i, a = El(n.state.date, (i = n.props.yearItemNumber) !== null && i !== void 0 ? i : r.defaultProps.yearItemNumber), o = a.startPeriod, s = a.endPeriod, l;
        return n.props.showYearPicker ? l = "".concat(o, " - ").concat(s) : n.props.showMonthYearPicker || n.props.showQuarterYearPicker ? l = ht(n.state.date) : l = "".concat(U_(sn(n.state.date), n.props.locale), " ").concat(ht(n.state.date)), te.createElement("span", { role: "alert", "aria-live": "polite", className: "react-datepicker__aria-live" }, n.state.isRenderAriaLiveMessage && l);
      }, n.renderChildren = function() {
        if (n.props.children)
          return te.createElement("div", { className: "react-datepicker__children-container" }, n.props.children);
      }, n.containerRef = Ul(), n.state = {
        date: n.getDateInView(),
        selectingDate: void 0,
        monthContainer: void 0,
        isRenderAriaLiveMessage: !1
      }, n;
    }
    return Object.defineProperty(r, "defaultProps", {
      get: function() {
        return {
          monthsShown: 1,
          forceShowMonthNavigation: !1,
          timeCaption: "Time",
          previousYearButtonLabel: "Previous Year",
          nextYearButtonLabel: "Next Year",
          previousMonthButtonLabel: "Previous Month",
          nextMonthButtonLabel: "Next Month",
          yearItemNumber: Pg
        };
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.componentDidMount = function() {
      var e = this;
      this.props.showTimeSelect && (this.assignMonthContainer = function() {
        e.setState({ monthContainer: e.monthContainer });
      }());
    }, r.prototype.componentDidUpdate = function(e) {
      var n = this;
      if (this.props.preSelection && (!jt(this.props.preSelection, e.preSelection) || this.props.monthSelectedIn !== e.monthSelectedIn)) {
        var i = !yi(this.state.date, this.props.preSelection);
        this.setState({
          date: this.props.preSelection
        }, function() {
          return i && n.handleCustomMonthChange(n.state.date);
        });
      } else this.props.openToDate && !jt(this.props.openToDate, e.openToDate) && this.setState({
        date: this.props.openToDate
      });
    }, r.prototype.render = function() {
      var e = this.props.container || _0e;
      return te.createElement(
        z2,
        { onClickOutside: this.handleClickOutside, style: { display: "contents" }, containerRef: this.containerRef, ignoreClass: this.props.outsideClickIgnoreClass },
        te.createElement(
          e,
          { className: Ln("react-datepicker", this.props.className, {
            "react-datepicker--time-only": this.props.showTimeSelectOnly
          }), showTime: this.props.showTimeSelect || this.props.showTimeInput, showTimeSelectOnly: this.props.showTimeSelectOnly },
          this.renderAriaLiveRegion(),
          this.renderPreviousButton(),
          this.renderNextButton(),
          this.renderMonths(),
          this.renderYears(),
          this.renderTodayButton(),
          this.renderTimeSection(),
          this.renderInputTimeSection(),
          this.renderChildren()
        )
      );
    }, r;
  }(In)
), cme = function(t) {
  var r = t.icon, e = t.className, n = e === void 0 ? "" : e, i = t.onClick, a = "react-datepicker__calendar-icon";
  return typeof r == "string" ? te.createElement("i", { className: "".concat(a, " ").concat(r, " ").concat(n), "aria-hidden": "true", onClick: i }) : te.isValidElement(r) ? te.cloneElement(r, {
    className: "".concat(r.props.className || "", " ").concat(a, " ").concat(n),
    onClick: function(o) {
      typeof r.props.onClick == "function" && r.props.onClick(o), typeof i == "function" && i(o);
    }
  }) : te.createElement(
    "svg",
    { className: "".concat(a, " ").concat(n), xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 448 512", onClick: i },
    te.createElement("path", { d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z" })
  );
}, oz = (
  /** @class */
  function(t) {
    kn(r, t);
    function r(e) {
      var n = t.call(this, e) || this;
      return n.portalRoot = null, n.el = document.createElement("div"), n;
    }
    return r.prototype.componentDidMount = function() {
      this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
    }, r.prototype.componentWillUnmount = function() {
      this.portalRoot && this.portalRoot.removeChild(this.el);
    }, r.prototype.render = function() {
      return RP.createPortal(this.props.children, this.el);
    }, r;
  }(In)
), dme = "[tabindex], a, button, input, select, textarea", fme = function(t) {
  return (t instanceof HTMLAnchorElement || !t.disabled) && t.tabIndex !== -1;
}, sz = (
  /** @class */
  function(t) {
    kn(r, t);
    function r(e) {
      var n = t.call(this, e) || this;
      return n.getTabChildren = function() {
        var i;
        return Array.prototype.slice.call((i = n.tabLoopRef.current) === null || i === void 0 ? void 0 : i.querySelectorAll(dme), 1, -1).filter(fme);
      }, n.handleFocusStart = function() {
        var i = n.getTabChildren();
        i && i.length > 1 && i[i.length - 1].focus();
      }, n.handleFocusEnd = function() {
        var i = n.getTabChildren();
        i && i.length > 1 && i[0].focus();
      }, n.tabLoopRef = Ul(), n;
    }
    return r.prototype.render = function() {
      var e;
      return ((e = this.props.enableTabLoop) !== null && e !== void 0 ? e : r.defaultProps.enableTabLoop) ? te.createElement(
        "div",
        { className: "react-datepicker__tab-loop", ref: this.tabLoopRef },
        te.createElement("div", { className: "react-datepicker__tab-loop__start", tabIndex: 0, onFocus: this.handleFocusStart }),
        this.props.children,
        te.createElement("div", { className: "react-datepicker__tab-loop__end", tabIndex: 0, onFocus: this.handleFocusEnd })
      ) : this.props.children;
    }, r.defaultProps = {
      enableTabLoop: !0
    }, r;
  }(In)
);
function hme(t) {
  var r = function(e) {
    var n, i = typeof e.hidePopper == "boolean" ? e.hidePopper : !0, a = Vt(null), o = w0e(Jt({ open: !i, whileElementsMounted: $H, placement: e.popperPlacement, middleware: Go([
      i0e({ padding: 15 }),
      n0e(10),
      a0e({ element: a })
    ], (n = e.popperModifiers) !== null && n !== void 0 ? n : [], !0) }, e.popperProps)), s = Jt(Jt({}, e), { hidePopper: i, popperProps: Jt(Jt({}, o), { arrowRef: a }) });
    return te.createElement(t, Jt({}, s));
  };
  return r;
}
var pme = (
  /** @class */
  function(t) {
    kn(r, t);
    function r() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(r, "defaultProps", {
      get: function() {
        return {
          hidePopper: !0
        };
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.render = function() {
      var e = this.props, n = e.className, i = e.wrapperClassName, a = e.hidePopper, o = a === void 0 ? r.defaultProps.hidePopper : a, s = e.popperComponent, l = e.targetComponent, u = e.enableTabLoop, c = e.popperOnKeyDown, d = e.portalId, f = e.portalHost, h = e.popperProps, p = e.showArrow, v = void 0;
      if (!o) {
        var g = Ln("react-datepicker-popper", n);
        v = te.createElement(
          sz,
          { enableTabLoop: u },
          te.createElement(
            "div",
            { ref: h.refs.setFloating, style: h.floatingStyles, className: g, "data-placement": h.placement, onKeyDown: c },
            s,
            p && te.createElement(p0e, { ref: h.arrowRef, context: h.context, fill: "currentColor", strokeWidth: 1, height: 8, width: 16, style: { transform: "translateY(-1px)" }, className: "react-datepicker__triangle" })
          )
        );
      }
      this.props.popperContainer && (v = wc(this.props.popperContainer, {}, v)), d && !o && (v = te.createElement(oz, { portalId: d, portalHost: f }, v));
      var m = Ln("react-datepicker-wrapper", i);
      return te.createElement(
        te.Fragment,
        null,
        te.createElement("div", { ref: h.refs.setReference, className: m }, l),
        v
      );
    }, r;
  }(In)
), vme = hme(pme), LL = "react-datepicker-ignore-onclickoutside";
function gme(t, r) {
  return t && r ? sn(t) !== sn(r) || ht(t) !== ht(r) : t !== r;
}
var a4 = "Date input not valid.", K_ = (
  /** @class */
  function(t) {
    kn(r, t);
    function r(e) {
      var n = t.call(this, e) || this;
      return n.calendar = null, n.input = null, n.getPreSelection = function() {
        return n.props.openToDate ? n.props.openToDate : n.props.selectsEnd && n.props.startDate ? n.props.startDate : n.props.selectsStart && n.props.endDate ? n.props.endDate : mr();
      }, n.modifyHolidays = function() {
        var i;
        return (i = n.props.holidays) === null || i === void 0 ? void 0 : i.reduce(function(a, o) {
          var s = new Date(o.date);
          return Ds(s) ? Go(Go([], a, !0), [Jt(Jt({}, o), { date: s })], !1) : a;
        }, []);
      }, n.calcInitialState = function() {
        var i, a = n.getPreSelection(), o = nz(n.props), s = iz(n.props), l = o && Yc(a, j0(o)) ? o : s && au(a, gL(s)) ? s : a;
        return {
          open: n.props.startOpen || !1,
          preventFocus: !1,
          inputValue: null,
          preSelection: (i = n.props.selectsRange ? n.props.startDate : n.props.selected) !== null && i !== void 0 ? i : l,
          // transforming highlighted days (perhaps nested array)
          // to flat Map for faster access in day.jsx
          highlightDates: SL(n.props.highlightDates),
          focused: !1,
          // used to focus day in inline version after month has changed, but not on
          // initial render
          shouldFocusDayInline: !1,
          isRenderAriaLiveMessage: !1,
          wasHidden: !1
        };
      }, n.resetHiddenStatus = function() {
        n.setState(Jt(Jt({}, n.state), { wasHidden: !1 }));
      }, n.setHiddenStatus = function() {
        n.setState(Jt(Jt({}, n.state), { wasHidden: !0 }));
      }, n.setHiddenStateOnVisibilityHidden = function() {
        document.visibilityState === "hidden" && n.setHiddenStatus();
      }, n.clearPreventFocusTimeout = function() {
        n.preventFocusTimeout && clearTimeout(n.preventFocusTimeout);
      }, n.setFocus = function() {
        n.input && n.input.focus && n.input.focus({ preventScroll: !0 });
      }, n.setBlur = function() {
        n.input && n.input.blur && n.input.blur(), n.cancelFocusInput();
      }, n.setOpen = function(i, a) {
        a === void 0 && (a = !1), n.setState({
          open: i,
          preSelection: i && n.state.open ? n.state.preSelection : n.calcInitialState().preSelection,
          lastPreSelectChange: o4
        }, function() {
          i || n.setState(function(o) {
            return {
              focused: a ? o.focused : !1
            };
          }, function() {
            !a && n.setBlur(), n.setState({ inputValue: null });
          });
        });
      }, n.inputOk = function() {
        return Fs(n.state.preSelection);
      }, n.isCalendarOpen = function() {
        return n.props.open === void 0 ? n.state.open && !n.props.disabled && !n.props.readOnly : n.props.open;
      }, n.handleFocus = function(i) {
        var a, o, s = n.state.wasHidden, l = s ? n.state.open : !0;
        s && n.resetHiddenStatus(), !n.state.preventFocus && l && ((o = (a = n.props).onFocus) === null || o === void 0 || o.call(a, i), !n.props.preventOpenOnFocus && !n.props.readOnly && n.setOpen(!0)), n.setState({ focused: !0 });
      }, n.sendFocusBackToInput = function() {
        n.preventFocusTimeout && n.clearPreventFocusTimeout(), n.setState({ preventFocus: !0 }, function() {
          n.preventFocusTimeout = setTimeout(function() {
            n.setFocus(), n.setState({ preventFocus: !1 });
          });
        });
      }, n.cancelFocusInput = function() {
        clearTimeout(n.inputFocusTimeout), n.inputFocusTimeout = void 0;
      }, n.deferFocusInput = function() {
        n.cancelFocusInput(), n.inputFocusTimeout = setTimeout(function() {
          return n.setFocus();
        }, 1);
      }, n.handleDropdownFocus = function() {
        n.cancelFocusInput();
      }, n.handleBlur = function(i) {
        var a, o;
        (!n.state.open || n.props.withPortal || n.props.showTimeInput) && ((o = (a = n.props).onBlur) === null || o === void 0 || o.call(a, i)), n.setState({ focused: !1 });
      }, n.handleCalendarClickOutside = function(i) {
        var a, o;
        n.props.inline || n.setOpen(!1), (o = (a = n.props).onClickOutside) === null || o === void 0 || o.call(a, i), n.props.withPortal && i.preventDefault();
      }, n.handleChange = function() {
        for (var i, a, o = [], s = 0; s < arguments.length; s++)
          o[s] = arguments[s];
        var l = o[0];
        if (!(n.props.onChangeRaw && (n.props.onChangeRaw.apply(n, o), !l || typeof l.isDefaultPrevented != "function" || l.isDefaultPrevented()))) {
          n.setState({
            inputValue: (l == null ? void 0 : l.target) instanceof HTMLInputElement ? l.target.value : null,
            lastPreSelectChange: mme
          });
          var u = n.props, c = u.dateFormat, d = c === void 0 ? r.defaultProps.dateFormat : c, f = u.strictParsing, h = f === void 0 ? r.defaultProps.strictParsing : f, p = u.selectsRange, v = u.startDate, g = u.endDate, m = (l == null ? void 0 : l.target) instanceof HTMLInputElement ? l.target.value : "";
          if (p) {
            var y = m.split("-", 2).map(function(T) {
              return T.trim();
            }), b = y[0], C = y[1], w = r4(b ?? "", d, n.props.locale, h), _ = r4(C ?? "", d, n.props.locale, h), x = (v == null ? void 0 : v.getTime()) !== (w == null ? void 0 : w.getTime()), I = (g == null ? void 0 : g.getTime()) !== (_ == null ? void 0 : _.getTime());
            if (!x && !I || w && xa(w, n.props) || _ && xa(_, n.props))
              return;
            (a = (i = n.props).onChange) === null || a === void 0 || a.call(i, [w, _], l);
          } else {
            var D = r4(m, d, n.props.locale, h, n.props.minDate);
            n.props.showTimeSelectOnly && n.props.selected && D && !jt(D, n.props.selected) && (D = w1e(n.props.selected, {
              hours: Zo(D),
              minutes: jo(D),
              seconds: Hs(D)
            })), (D || !m) && n.setSelected(D, l, !0);
          }
        }
      }, n.handleSelect = function(i, a, o) {
        if (n.props.shouldCloseOnSelect && !n.props.showTimeSelect && n.sendFocusBackToInput(), n.props.onChangeRaw && n.props.onChangeRaw(a), n.setSelected(i, a, !1, o), n.props.showDateSelect && n.setState({ isRenderAriaLiveMessage: !0 }), !n.props.shouldCloseOnSelect || n.props.showTimeSelect)
          n.setPreSelection(i);
        else if (!n.props.inline) {
          n.props.selectsRange || n.setOpen(!1);
          var s = n.props, l = s.startDate, u = s.endDate;
          l && !u && (n.props.swapRange || !TL(i, l)) && n.setOpen(!1);
        }
      }, n.setSelected = function(i, a, o, s) {
        var l, u, c = i;
        if (n.props.showYearPicker) {
          if (c !== null && Y0(ht(c), n.props))
            return;
        } else if (n.props.showMonthYearPicker) {
          if (c !== null && rz(c, n.props))
            return;
        } else if (c !== null && xa(c, n.props))
          return;
        var d = n.props, f = d.onChange, h = d.selectsRange, p = d.startDate, v = d.endDate, g = d.selectsMultiple, m = d.selectedDates, y = d.minTime, b = d.swapRange;
        if (!mc(n.props.selected, c) || n.props.allowSameDay || h || g)
          if (c !== null && (n.props.selected && (!o || !n.props.showTimeSelect && !n.props.showTimeSelectOnly && !n.props.showTimeInput) && (c = n4(c, {
            hour: Zo(n.props.selected),
            minute: jo(n.props.selected),
            second: Hs(n.props.selected)
          })), !o && (n.props.showTimeSelect || n.props.showTimeSelectOnly) && y && (c = n4(c, {
            hour: y.getHours(),
            minute: y.getMinutes(),
            second: y.getSeconds()
          })), n.props.inline || n.setState({
            preSelection: c
          }), n.props.focusSelectedMonth || n.setState({ monthSelectedIn: s })), h) {
            var C = !p && !v, w = p && !v, _ = p && v;
            C ? f == null || f([c, null], a) : w && (c === null ? f == null || f([null, null], a) : TL(c, p) ? b ? f == null || f([c, p], a) : f == null || f([c, null], a) : f == null || f([p, c], a)), _ && (f == null || f([c, null], a));
          } else if (g) {
            if (c !== null)
              if (!(m != null && m.length))
                f == null || f([c], a);
              else {
                var x = m.some(function(D) {
                  return jt(D, c);
                });
                if (x) {
                  var I = m.filter(function(D) {
                    return !jt(D, c);
                  });
                  f == null || f(I, a);
                } else
                  f == null || f(Go(Go([], m, !0), [c], !1), a);
              }
          } else
            f == null || f(c, a);
        o || ((u = (l = n.props).onSelect) === null || u === void 0 || u.call(l, c, a), n.setState({ inputValue: null }));
      }, n.setPreSelection = function(i) {
        var a = Fs(n.props.minDate), o = Fs(n.props.maxDate), s = !0;
        if (i) {
          var l = j0(i);
          if (a && o)
            s = Bp(i, n.props.minDate, n.props.maxDate);
          else if (a) {
            var u = j0(n.props.minDate);
            s = au(i, u) || mc(l, u);
          } else if (o) {
            var c = gL(n.props.maxDate);
            s = Yc(i, c) || mc(l, c);
          }
        }
        s && n.setState({
          preSelection: i
        });
      }, n.toggleCalendar = function() {
        n.setOpen(!n.state.open);
      }, n.handleTimeChange = function(i) {
        var a, o;
        if (!(n.props.selectsRange || n.props.selectsMultiple)) {
          var s = n.props.selected ? n.props.selected : n.getPreSelection(), l = n.props.selected ? i : n4(s, {
            hour: Zo(i),
            minute: jo(i)
          });
          n.setState({
            preSelection: l
          }), (o = (a = n.props).onChange) === null || o === void 0 || o.call(a, l), n.props.shouldCloseOnSelect && !n.props.showTimeInput && (n.sendFocusBackToInput(), n.setOpen(!1)), n.props.showTimeInput && n.setOpen(!0), (n.props.showTimeSelectOnly || n.props.showTimeSelect) && n.setState({ isRenderAriaLiveMessage: !0 }), n.setState({ inputValue: null });
        }
      }, n.onInputClick = function() {
        var i, a;
        !n.props.disabled && !n.props.readOnly && n.setOpen(!0), (a = (i = n.props).onInputClick) === null || a === void 0 || a.call(i);
      }, n.onInputKeyDown = function(i) {
        var a, o, s, l, u, c;
        (o = (a = n.props).onKeyDown) === null || o === void 0 || o.call(a, i);
        var d = i.key;
        if (!n.state.open && !n.props.inline && !n.props.preventOpenOnFocus) {
          (d === Te.ArrowDown || d === Te.ArrowUp || d === Te.Enter) && ((s = n.onInputClick) === null || s === void 0 || s.call(n));
          return;
        }
        if (n.state.open) {
          if (d === Te.ArrowDown || d === Te.ArrowUp) {
            i.preventDefault();
            var f = n.props.showTimeSelectOnly ? ".react-datepicker__time-list-item[tabindex='0']" : n.props.showWeekPicker && n.props.showWeekNumbers ? '.react-datepicker__week-number[tabindex="0"]' : n.props.showFullMonthYearPicker || n.props.showMonthYearPicker ? '.react-datepicker__month-text[tabindex="0"]' : '.react-datepicker__day[tabindex="0"]', h = ((l = n.calendar) === null || l === void 0 ? void 0 : l.containerRef.current) instanceof Element && n.calendar.containerRef.current.querySelector(f);
            h instanceof HTMLElement && h.focus({ preventScroll: !0 });
            return;
          }
          var p = mr(n.state.preSelection);
          d === Te.Enter ? (i.preventDefault(), n.inputOk() && n.state.lastPreSelectChange === o4 ? (n.handleSelect(p, i), !n.props.shouldCloseOnSelect && n.setPreSelection(p)) : n.setOpen(!1)) : d === Te.Escape ? (i.preventDefault(), n.sendFocusBackToInput(), n.setOpen(!1)) : d === Te.Tab && n.setOpen(!1), n.inputOk() || (c = (u = n.props).onInputError) === null || c === void 0 || c.call(u, { code: 1, msg: a4 });
        }
      }, n.onPortalKeyDown = function(i) {
        var a = i.key;
        a === Te.Escape && (i.preventDefault(), n.setState({
          preventFocus: !0
        }, function() {
          n.setOpen(!1), setTimeout(function() {
            n.setFocus(), n.setState({ preventFocus: !1 });
          });
        }));
      }, n.onDayKeyDown = function(i) {
        var a, o, s, l, u, c, d = n.props, f = d.minDate, h = d.maxDate, p = d.disabledKeyboardNavigation, v = d.showWeekPicker, g = d.shouldCloseOnSelect, m = d.locale, y = d.calendarStartDay, b = d.adjustDateOnChange, C = d.inline;
        if ((o = (a = n.props).onKeyDown) === null || o === void 0 || o.call(a, i), !p) {
          var w = i.key, _ = i.shiftKey, x = mr(n.state.preSelection), I = function(k, P) {
            var N = P;
            switch (k) {
              case Te.ArrowRight:
                N = v ? cy(P, 1) : el(P, 1);
                break;
              case Te.ArrowLeft:
                N = v ? oL(P, 1) : i1e(P, 1);
                break;
              case Te.ArrowUp:
                N = oL(P, 1);
                break;
              case Te.ArrowDown:
                N = cy(P, 1);
                break;
              case Te.PageUp:
                N = _ ? Ff(P, 1) : Bf(P, 1);
                break;
              case Te.PageDown:
                N = _ ? Bs(P, 1) : no(P, 1);
                break;
              case Te.Home:
                N = Zl(P, m, y);
                break;
              case Te.End:
                N = M0e(P);
                break;
            }
            return N;
          }, D = function(k, P) {
            for (var N = 40, O = k, W = !1, V = 0, B = I(k, P); !W; ) {
              if (V >= N) {
                B = P;
                break;
              }
              f && B < f && (O = Te.ArrowRight, B = xa(f, n.props) ? I(O, B) : f), h && B > h && (O = Te.ArrowLeft, B = xa(h, n.props) ? I(O, B) : h), xa(B, n.props) ? ((O === Te.PageUp || O === Te.Home) && (O = Te.ArrowRight), (O === Te.PageDown || O === Te.End) && (O = Te.ArrowLeft), B = I(O, B)) : W = !0, V++;
            }
            return B;
          };
          if (w === Te.Enter) {
            i.preventDefault(), n.handleSelect(x, i), !g && n.setPreSelection(x);
            return;
          } else if (w === Te.Escape) {
            i.preventDefault(), n.setOpen(!1), n.inputOk() || (l = (s = n.props).onInputError) === null || l === void 0 || l.call(s, { code: 1, msg: a4 });
            return;
          }
          var T = null;
          switch (w) {
            case Te.ArrowLeft:
            case Te.ArrowRight:
            case Te.ArrowUp:
            case Te.ArrowDown:
            case Te.PageUp:
            case Te.PageDown:
            case Te.Home:
            case Te.End:
              T = D(w, x);
              break;
          }
          if (!T) {
            (c = (u = n.props).onInputError) === null || c === void 0 || c.call(u, { code: 1, msg: a4 });
            return;
          }
          if (i.preventDefault(), n.setState({ lastPreSelectChange: o4 }), b && n.setSelected(T), n.setPreSelection(T), C) {
            var A = sn(x), M = sn(T), R = ht(x), E = ht(T);
            A !== M || R !== E ? n.setState({ shouldFocusDayInline: !0 }) : n.setState({ shouldFocusDayInline: !1 });
          }
        }
      }, n.onPopperKeyDown = function(i) {
        var a = i.key;
        a === Te.Escape && (i.preventDefault(), n.sendFocusBackToInput());
      }, n.onClearClick = function(i) {
        i && i.preventDefault && i.preventDefault(), n.sendFocusBackToInput();
        var a = n.props, o = a.selectsRange, s = a.onChange;
        o ? s == null || s([null, null], i) : s == null || s(null, i), n.setState({ inputValue: null });
      }, n.clear = function() {
        n.onClearClick();
      }, n.onScroll = function(i) {
        typeof n.props.closeOnScroll == "boolean" && n.props.closeOnScroll ? (i.target === document || i.target === document.documentElement || i.target === document.body) && n.setOpen(!1) : typeof n.props.closeOnScroll == "function" && n.props.closeOnScroll(i) && n.setOpen(!1);
      }, n.renderCalendar = function() {
        var i, a;
        return !n.props.inline && !n.isCalendarOpen() ? null : te.createElement(ume, Jt({ showMonthYearDropdown: void 0, ref: function(o) {
          n.calendar = o;
        } }, n.props, n.state, { setOpen: n.setOpen, dateFormat: (i = n.props.dateFormatCalendar) !== null && i !== void 0 ? i : r.defaultProps.dateFormatCalendar, onSelect: n.handleSelect, onClickOutside: n.handleCalendarClickOutside, holidays: H0e(n.modifyHolidays()), outsideClickIgnoreClass: LL, onDropdownFocus: n.handleDropdownFocus, onTimeChange: n.handleTimeChange, className: n.props.calendarClassName, container: n.props.calendarContainer, handleOnKeyDown: n.props.onKeyDown, handleOnDayKeyDown: n.onDayKeyDown, setPreSelection: n.setPreSelection, dropdownMode: (a = n.props.dropdownMode) !== null && a !== void 0 ? a : r.defaultProps.dropdownMode }), n.props.children);
      }, n.renderAriaLiveRegion = function() {
        var i = n.props, a = i.dateFormat, o = a === void 0 ? r.defaultProps.dateFormat : a, s = i.locale, l = n.props.showTimeInput || n.props.showTimeSelect, u = l ? "PPPPp" : "PPPP", c;
        return n.props.selectsRange ? c = "Selected start date: ".concat(Ca(n.props.startDate, {
          dateFormat: u,
          locale: s
        }), ". ").concat(n.props.endDate ? "End date: " + Ca(n.props.endDate, {
          dateFormat: u,
          locale: s
        }) : "") : n.props.showTimeSelectOnly ? c = "Selected time: ".concat(Ca(n.props.selected, { dateFormat: o, locale: s })) : n.props.showYearPicker ? c = "Selected year: ".concat(Ca(n.props.selected, { dateFormat: "yyyy", locale: s })) : n.props.showMonthYearPicker ? c = "Selected month: ".concat(Ca(n.props.selected, { dateFormat: "MMMM yyyy", locale: s })) : n.props.showQuarterYearPicker ? c = "Selected quarter: ".concat(Ca(n.props.selected, {
          dateFormat: "yyyy, QQQ",
          locale: s
        })) : c = "Selected date: ".concat(Ca(n.props.selected, {
          dateFormat: u,
          locale: s
        })), te.createElement("span", { role: "alert", "aria-live": "polite", className: "react-datepicker__aria-live" }, c);
      }, n.renderDateInput = function() {
        var i, a, o, s = Ln(n.props.className, (i = {}, i[LL] = n.state.open, i)), l = n.props.customInput || te.createElement("input", { type: "text" }), u = n.props.customInputRef || "ref", c = n.props, d = c.dateFormat, f = d === void 0 ? r.defaultProps.dateFormat : d, h = c.locale, p = typeof n.props.value == "string" ? n.props.value : typeof n.state.inputValue == "string" ? n.state.inputValue : n.props.selectsRange ? I0e(n.props.startDate, n.props.endDate, {
          dateFormat: f,
          locale: h
        }) : n.props.selectsMultiple ? A0e((o = n.props.selectedDates) !== null && o !== void 0 ? o : [], {
          dateFormat: f,
          locale: h
        }) : Ca(n.props.selected, {
          dateFormat: f,
          locale: h
        });
        return v7(l, (a = {}, a[u] = function(v) {
          n.input = v;
        }, a.value = p, a.onBlur = n.handleBlur, a.onChange = n.handleChange, a.onClick = n.onInputClick, a.onFocus = n.handleFocus, a.onKeyDown = n.onInputKeyDown, a.id = n.props.id, a.name = n.props.name, a.form = n.props.form, a.autoFocus = n.props.autoFocus, a.placeholder = n.props.placeholderText, a.disabled = n.props.disabled, a.autoComplete = n.props.autoComplete, a.className = Ln(l.props.className, s), a.title = n.props.title, a.readOnly = n.props.readOnly, a.required = n.props.required, a.tabIndex = n.props.tabIndex, a["aria-describedby"] = n.props.ariaDescribedBy, a["aria-invalid"] = n.props.ariaInvalid, a["aria-labelledby"] = n.props.ariaLabelledBy, a["aria-required"] = n.props.ariaRequired, a));
      }, n.renderClearButton = function() {
        var i = n.props, a = i.isClearable, o = i.disabled, s = i.selected, l = i.startDate, u = i.endDate, c = i.clearButtonTitle, d = i.clearButtonClassName, f = d === void 0 ? "" : d, h = i.ariaLabelClose, p = h === void 0 ? "Close" : h, v = i.selectedDates;
        return a && (s != null || l != null || u != null || v != null && v.length) ? te.createElement("button", { type: "button", className: Ln("react-datepicker__close-icon", f, { "react-datepicker__close-icon--disabled": o }), disabled: o, "aria-label": p, onClick: n.onClearClick, title: c, tabIndex: -1 }) : null;
      }, n.state = n.calcInitialState(), n.preventFocusTimeout = void 0, n;
    }
    return Object.defineProperty(r, "defaultProps", {
      get: function() {
        return {
          allowSameDay: !1,
          dateFormat: "MM/dd/yyyy",
          dateFormatCalendar: "LLLL yyyy",
          disabled: !1,
          disabledKeyboardNavigation: !1,
          dropdownMode: "scroll",
          preventOpenOnFocus: !1,
          monthsShown: 1,
          readOnly: !1,
          withPortal: !1,
          selectsDisabledDaysInRange: !1,
          shouldCloseOnSelect: !0,
          showTimeSelect: !1,
          showTimeInput: !1,
          showPreviousMonths: !1,
          showMonthYearPicker: !1,
          showFullMonthYearPicker: !1,
          showTwoColumnMonthYearPicker: !1,
          showFourColumnMonthYearPicker: !1,
          showYearPicker: !1,
          showQuarterYearPicker: !1,
          showWeekPicker: !1,
          strictParsing: !1,
          swapRange: !1,
          timeIntervals: 30,
          timeCaption: "Time",
          previousMonthAriaLabel: "Previous Month",
          previousMonthButtonLabel: "Previous Month",
          nextMonthAriaLabel: "Next Month",
          nextMonthButtonLabel: "Next Month",
          previousYearAriaLabel: "Previous Year",
          previousYearButtonLabel: "Previous Year",
          nextYearAriaLabel: "Next Year",
          nextYearButtonLabel: "Next Year",
          timeInputLabel: "Time",
          enableTabLoop: !0,
          yearItemNumber: Pg,
          focusSelectedMonth: !1,
          showPopperArrow: !0,
          excludeScrollbar: !0,
          customTimeInput: null,
          calendarStartDay: void 0,
          toggleCalendarOnIconClick: !1,
          usePointerEvent: !1
        };
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.componentDidMount = function() {
      window.addEventListener("scroll", this.onScroll, !0), document.addEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
    }, r.prototype.componentDidUpdate = function(e, n) {
      var i, a, o, s;
      e.inline && gme(e.selected, this.props.selected) && this.setPreSelection(this.props.selected), this.state.monthSelectedIn !== void 0 && e.monthsShown !== this.props.monthsShown && this.setState({ monthSelectedIn: 0 }), e.highlightDates !== this.props.highlightDates && this.setState({
        highlightDates: SL(this.props.highlightDates)
      }), !n.focused && !mc(e.selected, this.props.selected) && this.setState({ inputValue: null }), n.open !== this.state.open && (n.open === !1 && this.state.open === !0 && ((a = (i = this.props).onCalendarOpen) === null || a === void 0 || a.call(i)), n.open === !0 && this.state.open === !1 && ((s = (o = this.props).onCalendarClose) === null || s === void 0 || s.call(o)));
    }, r.prototype.componentWillUnmount = function() {
      this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0), document.removeEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
    }, r.prototype.renderInputContainer = function() {
      var e = this.props, n = e.showIcon, i = e.icon, a = e.calendarIconClassname, o = e.calendarIconClassName, s = e.toggleCalendarOnIconClick, l = this.state.open;
      return a && console.warn("calendarIconClassname props is deprecated. should use calendarIconClassName props."), te.createElement(
        "div",
        { className: "react-datepicker__input-container".concat(n ? " react-datepicker__view-calendar-icon" : "") },
        n && te.createElement(cme, Jt({ icon: i, className: Ln(o, !o && a, l && "react-datepicker-ignore-onclickoutside") }, s ? {
          onClick: this.toggleCalendar
        } : null)),
        this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(),
        this.renderDateInput(),
        this.renderClearButton()
      );
    }, r.prototype.render = function() {
      var e = this.renderCalendar();
      if (this.props.inline)
        return e;
      if (this.props.withPortal) {
        var n = this.state.open ? te.createElement(
          sz,
          { enableTabLoop: this.props.enableTabLoop },
          te.createElement("div", { className: "react-datepicker__portal", tabIndex: -1, onKeyDown: this.onPortalKeyDown }, e)
        ) : null;
        return this.state.open && this.props.portalId && (n = te.createElement(oz, Jt({ portalId: this.props.portalId }, this.props), n)), te.createElement(
          "div",
          null,
          this.renderInputContainer(),
          n
        );
      }
      return te.createElement(vme, Jt({}, this.props, { className: this.props.popperClassName, hidePopper: !this.isCalendarOpen(), targetComponent: this.renderInputContainer(), popperComponent: e, popperOnKeyDown: this.onPopperKeyDown, showArrow: this.props.showPopperArrow }));
    }, r;
  }(In)
), mme = "input", o4 = "navigate";
const Qd = (t) => /* @__PURE__ */ $.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ $.createElement("path", { d: "M10 12.6004C9.73253 12.6004 9.50873 12.5021 9.28493 12.2783L5.24563 8.14625C5.08188 7.97704 5 7.78053 5 7.54581C5 7.06001 5.38755 6.66699 5.8679 6.66699C6.10808 6.66699 6.33188 6.76525 6.51201 6.94538L10.0055 10.548L13.4935 6.94538C13.6736 6.76525 13.8974 6.66699 14.1321 6.66699C14.6124 6.66699 15 7.06001 15 7.54581C15 7.78599 14.9181 7.98249 14.7544 8.14625L10.7151 12.2783C10.5022 12.4967 10.2729 12.6004 10 12.6004Z", fill: "#395278" })), lz = (t) => {
  const [r, e] = We(!1), [n, i] = We(!1), o = ((g, m, y = 1) => {
    const b = [];
    for (let C = g; C <= m; C += y)
      b.push(C);
    return b;
  })(
    ht(/* @__PURE__ */ new Date()) - 100,
    ht(/* @__PURE__ */ new Date()),
    1
  ), s = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ], {
    date: l,
    changeYear: u,
    changeMonth: c,
    decreaseMonth: d,
    increaseMonth: f,
    isMonthYearPicker: h = !1
  } = t, p = sn(/* @__PURE__ */ new Date()), v = ht(/* @__PURE__ */ new Date());
  return /* @__PURE__ */ S.jsxs("div", { className: "theme-datepicker-header-selector", children: [
    !h && /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
      /* @__PURE__ */ S.jsx(
        "div",
        {
          className: "month-arrow-icon left",
          onClick: () => d(),
          children: /* @__PURE__ */ S.jsx(Qd, { className: "arrow-icon" })
        }
      ),
      /* @__PURE__ */ S.jsxs(
        "div",
        {
          className: "theme-datepicker-header-month-selector",
          onClick: () => {
            e(!r), i(!1);
          },
          children: [
            /* @__PURE__ */ S.jsx("span", { children: s[sn(l)] }),
            /* @__PURE__ */ S.jsx(
              Qd,
              {
                className: `arrow-icon ${r && "is-active"}`
              }
            )
          ]
        }
      ),
      r && /* @__PURE__ */ S.jsx("div", { className: "theme-datepicker-dropdown month-selector", children: s.map((g, m) => /* @__PURE__ */ S.jsx(
        "span",
        {
          className: `theme-datepicker-dropdown-item ${s[sn(l)] === g && "is-selected"} ${p === m && "is-current"}`,
          onClick: () => {
            c(s.indexOf(g)), e(!1);
          },
          children: g
        },
        `month-${m}`
      )) })
    ] }),
    /* @__PURE__ */ S.jsxs(
      "div",
      {
        className: `theme-datepicker-header-year-selector ${h && "month-year-picker"}`,
        onClick: () => {
          i(!n), e(!1);
        },
        children: [
          /* @__PURE__ */ S.jsx("span", { children: ht(l) }),
          /* @__PURE__ */ S.jsx(
            Qd,
            {
              className: `arrow-icon ${n && "is-active"}`
            }
          )
        ]
      }
    ),
    n && /* @__PURE__ */ S.jsx("div", { className: "theme-datepicker-dropdown year-selector", children: o.map((g, m) => /* @__PURE__ */ S.jsx(
      "span",
      {
        className: `theme-datepicker-dropdown-item ${ht(l) === g && "is-selected"} ${v === g && "is-current"}`,
        onClick: () => {
          u(g), i(!1);
        },
        children: g
      },
      `year-${m}`
    )) }),
    !h && /* @__PURE__ */ S.jsx("div", { className: "month-arrow-icon right", onClick: () => f(), children: /* @__PURE__ */ S.jsx(Qd, { className: "arrow-icon" }) })
  ] });
}, q_ = (t) => /* @__PURE__ */ $.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ $.createElement("g", { id: "icon-x" }, /* @__PURE__ */ $.createElement("path", { id: "ô", d: "M4.31188 15.6827C3.89121 15.2692 3.90571 14.5367 4.29737 14.145L8.44604 9.99637L4.29737 5.86221C3.90571 5.4633 3.89121 4.73801 4.31188 4.31734C4.73254 3.88942 5.46509 3.90392 5.85675 4.30283L9.99816 8.44425L14.1396 4.30283C14.5457 3.89667 15.2565 3.89667 15.6772 4.31734C16.1051 4.73801 16.1051 5.44879 15.6917 5.86221L11.5575 9.99637L15.6917 14.1378C16.1051 14.5512 16.0979 15.2547 15.6772 15.6827C15.2638 16.1033 14.5457 16.1033 14.1396 15.6972L9.99816 11.5558L5.85675 15.6972C5.46509 16.0961 4.7398 16.1033 4.31188 15.6827Z", fill: "#99A6B9" }))), Q_ = (t) => /* @__PURE__ */ $.createElement("svg", { width: 25, height: 24, viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ $.createElement("path", { d: "M7.08268 19.7008C5.38189 19.7008 4.5 18.8268 4.5 17.1417V7.55906C4.5 5.87402 5.38189 5 7.08268 5H17.9173C19.6181 5 20.5 5.87402 20.5 7.55906V17.1417C20.5 18.8189 19.6181 19.7008 17.9173 19.7008H7.08268ZM7.05906 18.1575H17.9252C18.5866 18.1575 18.9567 17.811 18.9567 17.126V9.85039C18.9567 9.15748 18.5866 8.8189 17.9252 8.8189H7.05906C6.40551 8.8189 6.04331 9.15748 6.04331 9.85039V17.126C6.04331 17.811 6.40551 18.1575 7.05906 18.1575ZM10.9803 11.5512C10.7047 11.5512 10.6102 11.4646 10.6102 11.1811V10.7244C10.6102 10.4409 10.7047 10.3543 10.9803 10.3543H11.4449C11.7283 10.3543 11.8228 10.4409 11.8228 10.7244V11.1811C11.8228 11.4646 11.7283 11.5512 11.4449 11.5512H10.9803ZM13.563 11.5512C13.2795 11.5512 13.185 11.4646 13.185 11.1811V10.7244C13.185 10.4409 13.2795 10.3543 13.563 10.3543H14.0197C14.3032 10.3543 14.3976 10.4409 14.3976 10.7244V11.1811C14.3976 11.4646 14.3032 11.5512 14.0197 11.5512H13.563ZM16.1378 11.5512C15.8543 11.5512 15.7598 11.4646 15.7598 11.1811V10.7244C15.7598 10.4409 15.8543 10.3543 16.1378 10.3543H16.5945C16.878 10.3543 16.9724 10.4409 16.9724 10.7244V11.1811C16.9724 11.4646 16.878 11.5512 16.5945 11.5512H16.1378ZM8.40551 14.0866C8.12992 14.0866 8.03543 14 8.03543 13.7165V13.2598C8.03543 12.9764 8.12992 12.8898 8.40551 12.8898H8.87008C9.15354 12.8898 9.24803 12.9764 9.24803 13.2598V13.7165C9.24803 14 9.15354 14.0866 8.87008 14.0866H8.40551ZM10.9803 14.0866C10.7047 14.0866 10.6102 14 10.6102 13.7165V13.2598C10.6102 12.9764 10.7047 12.8898 10.9803 12.8898H11.4449C11.7283 12.8898 11.8228 12.9764 11.8228 13.2598V13.7165C11.8228 14 11.7283 14.0866 11.4449 14.0866H10.9803ZM13.563 14.0866C13.2795 14.0866 13.185 14 13.185 13.7165V13.2598C13.185 12.9764 13.2795 12.8898 13.563 12.8898H14.0197C14.3032 12.8898 14.3976 12.9764 14.3976 13.2598V13.7165C14.3976 14 14.3032 14.0866 14.0197 14.0866H13.563ZM16.1378 14.0866C15.8543 14.0866 15.7598 14 15.7598 13.7165V13.2598C15.7598 12.9764 15.8543 12.8898 16.1378 12.8898H16.5945C16.878 12.8898 16.9724 12.9764 16.9724 13.2598V13.7165C16.9724 14 16.878 14.0866 16.5945 14.0866H16.1378ZM8.40551 16.622C8.12992 16.622 8.03543 16.5354 8.03543 16.252V15.7953C8.03543 15.5118 8.12992 15.4252 8.40551 15.4252H8.87008C9.15354 15.4252 9.24803 15.5118 9.24803 15.7953V16.252C9.24803 16.5354 9.15354 16.622 8.87008 16.622H8.40551ZM10.9803 16.622C10.7047 16.622 10.6102 16.5354 10.6102 16.252V15.7953C10.6102 15.5118 10.7047 15.4252 10.9803 15.4252H11.4449C11.7283 15.4252 11.8228 15.5118 11.8228 15.7953V16.252C11.8228 16.5354 11.7283 16.622 11.4449 16.622H10.9803ZM13.563 16.622C13.2795 16.622 13.185 16.5354 13.185 16.252V15.7953C13.185 15.5118 13.2795 15.4252 13.563 15.4252H14.0197C14.3032 15.4252 14.3976 15.5118 14.3976 15.7953V16.252C14.3976 16.5354 14.3032 16.622 14.0197 16.622H13.563Z", fill: "#395278" })), Gxe = (t) => {
  const {
    value: r,
    className: e = "",
    containerClassName: n,
    formLabel: i,
    formSubLabel: a,
    inputHelpBlock: o,
    isRequired: s = !1,
    hasError: l = !1,
    errorMessage: u = "",
    onInputChange: c,
    onResetDate: d,
    showTimeSelect: f = !1,
    showMonthYearPicker: h = !1,
    minDate: p,
    format: v = "dd MMMM yyyy",
    disabled: g = !1,
    placeholder: m = ""
  } = t, [y, b] = We(!1);
  return /* @__PURE__ */ S.jsxs(
    "div",
    {
      className: `theme-form-input-container ${n !== void 0 ? n : ""}`,
      children: [
        i && /* @__PURE__ */ S.jsxs("label", { className: "theme-form-input-label", htmlFor: `field-${name}`, children: [
          i,
          " ",
          s && /* @__PURE__ */ S.jsx("span", { children: "*" })
        ] }),
        a && /* @__PURE__ */ S.jsx("label", { className: "theme-form-sublabel", children: a }),
        /* @__PURE__ */ S.jsx(
          K_,
          {
            selected: r,
            disabled: g,
            dateFormat: v,
            showTimeSelect: f,
            minDate: p,
            showIcon: !0,
            icon: !y && !r ? /* @__PURE__ */ S.jsx(Q_, {}) : /* @__PURE__ */ S.jsx(q_, { onClick: () => d && d() }),
            useWeekdaysShort: !0,
            showMonthYearPicker: h,
            placeholderText: m,
            wrapperClassName: "theme-custom-datepicker-wrapper",
            calendarClassName: "theme-custom-datepicker",
            className: `theme-form-control ${e} ${l && "theme-form-control-has-error"}`,
            renderCustomHeader: (C) => /* @__PURE__ */ S.jsx(
              lz,
              {
                ...C,
                isMonthYearPicker: h
              }
            ),
            onChange: (C) => c(C),
            onCalendarOpen: () => b(!0),
            onCalendarClose: () => {
              b(!1);
            },
            toggleCalendarOnIconClick: !0
          }
        ),
        o && /* @__PURE__ */ S.jsx("span", { className: "theme-form-helpblock", children: o }),
        l && /* @__PURE__ */ S.jsx("div", { className: "theme-font-sm color-theme-red-500 theme-form-error-message", children: u })
      ]
    }
  );
};
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var uz;
function De() {
  return uz.apply(null, arguments);
}
function yme(t) {
  uz = t;
}
function oo(t) {
  return t instanceof Array || Object.prototype.toString.call(t) === "[object Array]";
}
function Ec(t) {
  return t != null && Object.prototype.toString.call(t) === "[object Object]";
}
function er(t, r) {
  return Object.prototype.hasOwnProperty.call(t, r);
}
function ex(t) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(t).length === 0;
  var r;
  for (r in t)
    if (er(t, r))
      return !1;
  return !0;
}
function Li(t) {
  return t === void 0;
}
function rl(t) {
  return typeof t == "number" || Object.prototype.toString.call(t) === "[object Number]";
}
function Og(t) {
  return t instanceof Date || Object.prototype.toString.call(t) === "[object Date]";
}
function cz(t, r) {
  var e = [], n, i = t.length;
  for (n = 0; n < i; ++n)
    e.push(r(t[n], n));
  return e;
}
function kl(t, r) {
  for (var e in r)
    er(r, e) && (t[e] = r[e]);
  return er(r, "toString") && (t.toString = r.toString), er(r, "valueOf") && (t.valueOf = r.valueOf), t;
}
function ls(t, r, e, n) {
  return kz(t, r, e, n, !0).utc();
}
function bme() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function Tt(t) {
  return t._pf == null && (t._pf = bme()), t._pf;
}
var m6;
Array.prototype.some ? m6 = Array.prototype.some : m6 = function(t) {
  var r = Object(this), e = r.length >>> 0, n;
  for (n = 0; n < e; n++)
    if (n in r && t.call(this, r[n], n, r))
      return !0;
  return !1;
};
function tx(t) {
  var r = null, e = !1, n = t._d && !isNaN(t._d.getTime());
  if (n && (r = Tt(t), e = m6.call(r.parsedDateParts, function(i) {
    return i != null;
  }), n = r.overflow < 0 && !r.empty && !r.invalidEra && !r.invalidMonth && !r.invalidWeekday && !r.weekdayMismatch && !r.nullInput && !r.invalidFormat && !r.userInvalidated && (!r.meridiem || r.meridiem && e), t._strict && (n = n && r.charsLeftOver === 0 && r.unusedTokens.length === 0 && r.bigHour === void 0)), Object.isFrozen == null || !Object.isFrozen(t))
    t._isValid = n;
  else
    return n;
  return t._isValid;
}
function W2(t) {
  var r = ls(NaN);
  return t != null ? kl(Tt(r), t) : Tt(r).userInvalidated = !0, r;
}
var EL = De.momentProperties = [], s4 = !1;
function rx(t, r) {
  var e, n, i, a = EL.length;
  if (Li(r._isAMomentObject) || (t._isAMomentObject = r._isAMomentObject), Li(r._i) || (t._i = r._i), Li(r._f) || (t._f = r._f), Li(r._l) || (t._l = r._l), Li(r._strict) || (t._strict = r._strict), Li(r._tzm) || (t._tzm = r._tzm), Li(r._isUTC) || (t._isUTC = r._isUTC), Li(r._offset) || (t._offset = r._offset), Li(r._pf) || (t._pf = Tt(r)), Li(r._locale) || (t._locale = r._locale), a > 0)
    for (e = 0; e < a; e++)
      n = EL[e], i = r[n], Li(i) || (t[n] = i);
  return t;
}
function Vg(t) {
  rx(this, t), this._d = new Date(t._d != null ? t._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), s4 === !1 && (s4 = !0, De.updateOffset(this), s4 = !1);
}
function so(t) {
  return t instanceof Vg || t != null && t._isAMomentObject != null;
}
function dz(t) {
  De.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + t);
}
function Ga(t, r) {
  var e = !0;
  return kl(function() {
    if (De.deprecationHandler != null && De.deprecationHandler(null, t), e) {
      var n = [], i, a, o, s = arguments.length;
      for (a = 0; a < s; a++) {
        if (i = "", typeof arguments[a] == "object") {
          i += `
[` + a + "] ";
          for (o in arguments[0])
            er(arguments[0], o) && (i += o + ": " + arguments[0][o] + ", ");
          i = i.slice(0, -2);
        } else
          i = arguments[a];
        n.push(i);
      }
      dz(
        t + `
Arguments: ` + Array.prototype.slice.call(n).join("") + `
` + new Error().stack
      ), e = !1;
    }
    return r.apply(this, arguments);
  }, r);
}
var kL = {};
function fz(t, r) {
  De.deprecationHandler != null && De.deprecationHandler(t, r), kL[t] || (dz(r), kL[t] = !0);
}
De.suppressDeprecationWarnings = !1;
De.deprecationHandler = null;
function us(t) {
  return typeof Function < "u" && t instanceof Function || Object.prototype.toString.call(t) === "[object Function]";
}
function Cme(t) {
  var r, e;
  for (e in t)
    er(t, e) && (r = t[e], us(r) ? this[e] = r : this["_" + e] = r);
  this._config = t, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function y6(t, r) {
  var e = kl({}, t), n;
  for (n in r)
    er(r, n) && (Ec(t[n]) && Ec(r[n]) ? (e[n] = {}, kl(e[n], t[n]), kl(e[n], r[n])) : r[n] != null ? e[n] = r[n] : delete e[n]);
  for (n in t)
    er(t, n) && !er(r, n) && Ec(t[n]) && (e[n] = kl({}, e[n]));
  return e;
}
function nx(t) {
  t != null && this.set(t);
}
var b6;
Object.keys ? b6 = Object.keys : b6 = function(t) {
  var r, e = [];
  for (r in t)
    er(t, r) && e.push(r);
  return e;
};
var wme = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function _me(t, r, e) {
  var n = this._calendar[t] || this._calendar.sameElse;
  return us(n) ? n.call(r, e) : n;
}
function ts(t, r, e) {
  var n = "" + Math.abs(t), i = r - n.length, a = t >= 0;
  return (a ? e ? "+" : "" : "-") + Math.pow(10, Math.max(0, i)).toString().substr(1) + n;
}
var ix = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, o0 = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, l4 = {}, Cf = {};
function et(t, r, e, n) {
  var i = n;
  typeof n == "string" && (i = function() {
    return this[n]();
  }), t && (Cf[t] = i), r && (Cf[r[0]] = function() {
    return ts(i.apply(this, arguments), r[1], r[2]);
  }), e && (Cf[e] = function() {
    return this.localeData().ordinal(
      i.apply(this, arguments),
      t
    );
  });
}
function xme(t) {
  return t.match(/\[[\s\S]/) ? t.replace(/^\[|\]$/g, "") : t.replace(/\\/g, "");
}
function Sme(t) {
  var r = t.match(ix), e, n;
  for (e = 0, n = r.length; e < n; e++)
    Cf[r[e]] ? r[e] = Cf[r[e]] : r[e] = xme(r[e]);
  return function(i) {
    var a = "", o;
    for (o = 0; o < n; o++)
      a += us(r[o]) ? r[o].call(i, t) : r[o];
    return a;
  };
}
function X0(t, r) {
  return t.isValid() ? (r = hz(r, t.localeData()), l4[r] = l4[r] || Sme(r), l4[r](t)) : t.localeData().invalidDate();
}
function hz(t, r) {
  var e = 5;
  function n(i) {
    return r.longDateFormat(i) || i;
  }
  for (o0.lastIndex = 0; e >= 0 && o0.test(t); )
    t = t.replace(
      o0,
      n
    ), o0.lastIndex = 0, e -= 1;
  return t;
}
var Ime = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function Ame(t) {
  var r = this._longDateFormat[t], e = this._longDateFormat[t.toUpperCase()];
  return r || !e ? r : (this._longDateFormat[t] = e.match(ix).map(function(n) {
    return n === "MMMM" || n === "MM" || n === "DD" || n === "dddd" ? n.slice(1) : n;
  }).join(""), this._longDateFormat[t]);
}
var Dme = "Invalid date";
function Tme() {
  return this._invalidDate;
}
var Mme = "%d", Rme = /\d{1,2}/;
function Lme(t) {
  return this._ordinal.replace("%d", t);
}
var Eme = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function kme(t, r, e, n) {
  var i = this._relativeTime[e];
  return us(i) ? i(t, r, e, n) : i.replace(/%d/i, t);
}
function Pme(t, r) {
  var e = this._relativeTime[t > 0 ? "future" : "past"];
  return us(e) ? e(r) : e.replace(/%s/i, r);
}
var PL = {
  D: "date",
  dates: "date",
  date: "date",
  d: "day",
  days: "day",
  day: "day",
  e: "weekday",
  weekdays: "weekday",
  weekday: "weekday",
  E: "isoWeekday",
  isoweekdays: "isoWeekday",
  isoweekday: "isoWeekday",
  DDD: "dayOfYear",
  dayofyears: "dayOfYear",
  dayofyear: "dayOfYear",
  h: "hour",
  hours: "hour",
  hour: "hour",
  ms: "millisecond",
  milliseconds: "millisecond",
  millisecond: "millisecond",
  m: "minute",
  minutes: "minute",
  minute: "minute",
  M: "month",
  months: "month",
  month: "month",
  Q: "quarter",
  quarters: "quarter",
  quarter: "quarter",
  s: "second",
  seconds: "second",
  second: "second",
  gg: "weekYear",
  weekyears: "weekYear",
  weekyear: "weekYear",
  GG: "isoWeekYear",
  isoweekyears: "isoWeekYear",
  isoweekyear: "isoWeekYear",
  w: "week",
  weeks: "week",
  week: "week",
  W: "isoWeek",
  isoweeks: "isoWeek",
  isoweek: "isoWeek",
  y: "year",
  years: "year",
  year: "year"
};
function Ba(t) {
  return typeof t == "string" ? PL[t] || PL[t.toLowerCase()] : void 0;
}
function ax(t) {
  var r = {}, e, n;
  for (n in t)
    er(t, n) && (e = Ba(n), e && (r[e] = t[n]));
  return r;
}
var Nme = {
  date: 9,
  day: 11,
  weekday: 11,
  isoWeekday: 11,
  dayOfYear: 4,
  hour: 13,
  millisecond: 16,
  minute: 14,
  month: 8,
  quarter: 7,
  second: 15,
  weekYear: 1,
  isoWeekYear: 1,
  week: 5,
  isoWeek: 5,
  year: 1
};
function Ome(t) {
  var r = [], e;
  for (e in t)
    er(t, e) && r.push({ unit: e, priority: Nme[e] });
  return r.sort(function(n, i) {
    return n.priority - i.priority;
  }), r;
}
var pz = /\d/, aa = /\d\d/, vz = /\d{3}/, ox = /\d{4}/, Z2 = /[+-]?\d{6}/, Er = /\d\d?/, gz = /\d\d\d\d?/, mz = /\d\d\d\d\d\d?/, j2 = /\d{1,3}/, sx = /\d{1,4}/, Y2 = /[+-]?\d{1,6}/, yh = /\d+/, X2 = /[+-]?\d+/, Vme = /Z|[+-]\d\d:?\d\d/gi, $2 = /Z|[+-]\d\d(?::?\d\d)?/gi, Gme = /[+-]?\d+(\.\d{1,3})?/, Gg = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, bh = /^[1-9]\d?/, lx = /^([1-9]\d|\d)/, xy;
xy = {};
function Fe(t, r, e) {
  xy[t] = us(r) ? r : function(n, i) {
    return n && e ? e : r;
  };
}
function Bme(t, r) {
  return er(xy, t) ? xy[t](r._strict, r._locale) : new RegExp(Fme(t));
}
function Fme(t) {
  return Ws(
    t.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(r, e, n, i, a) {
        return e || n || i || a;
      }
    )
  );
}
function Ws(t) {
  return t.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
function Sa(t) {
  return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
}
function Bt(t) {
  var r = +t, e = 0;
  return r !== 0 && isFinite(r) && (e = Sa(r)), e;
}
var C6 = {};
function xr(t, r) {
  var e, n = r, i;
  for (typeof t == "string" && (t = [t]), rl(r) && (n = function(a, o) {
    o[r] = Bt(a);
  }), i = t.length, e = 0; e < i; e++)
    C6[t[e]] = n;
}
function Bg(t, r) {
  xr(t, function(e, n, i, a) {
    i._w = i._w || {}, r(e, i._w, i, a);
  });
}
function Hme(t, r, e) {
  r != null && er(C6, t) && C6[t](r, e._a, e, t);
}
function U2(t) {
  return t % 4 === 0 && t % 100 !== 0 || t % 400 === 0;
}
var ii = 0, ks = 1, Po = 2, wn = 3, $a = 4, Ps = 5, yc = 6, zme = 7, Wme = 8;
et("Y", 0, 0, function() {
  var t = this.year();
  return t <= 9999 ? ts(t, 4) : "+" + t;
});
et(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
et(0, ["YYYY", 4], 0, "year");
et(0, ["YYYYY", 5], 0, "year");
et(0, ["YYYYYY", 6, !0], 0, "year");
Fe("Y", X2);
Fe("YY", Er, aa);
Fe("YYYY", sx, ox);
Fe("YYYYY", Y2, Z2);
Fe("YYYYYY", Y2, Z2);
xr(["YYYYY", "YYYYYY"], ii);
xr("YYYY", function(t, r) {
  r[ii] = t.length === 2 ? De.parseTwoDigitYear(t) : Bt(t);
});
xr("YY", function(t, r) {
  r[ii] = De.parseTwoDigitYear(t);
});
xr("Y", function(t, r) {
  r[ii] = parseInt(t, 10);
});
function ov(t) {
  return U2(t) ? 366 : 365;
}
De.parseTwoDigitYear = function(t) {
  return Bt(t) + (Bt(t) > 68 ? 1900 : 2e3);
};
var yz = Ch("FullYear", !0);
function Zme() {
  return U2(this.year());
}
function Ch(t, r) {
  return function(e) {
    return e != null ? (bz(this, t, e), De.updateOffset(this, r), this) : Zv(this, t);
  };
}
function Zv(t, r) {
  if (!t.isValid())
    return NaN;
  var e = t._d, n = t._isUTC;
  switch (r) {
    case "Milliseconds":
      return n ? e.getUTCMilliseconds() : e.getMilliseconds();
    case "Seconds":
      return n ? e.getUTCSeconds() : e.getSeconds();
    case "Minutes":
      return n ? e.getUTCMinutes() : e.getMinutes();
    case "Hours":
      return n ? e.getUTCHours() : e.getHours();
    case "Date":
      return n ? e.getUTCDate() : e.getDate();
    case "Day":
      return n ? e.getUTCDay() : e.getDay();
    case "Month":
      return n ? e.getUTCMonth() : e.getMonth();
    case "FullYear":
      return n ? e.getUTCFullYear() : e.getFullYear();
    default:
      return NaN;
  }
}
function bz(t, r, e) {
  var n, i, a, o, s;
  if (!(!t.isValid() || isNaN(e))) {
    switch (n = t._d, i = t._isUTC, r) {
      case "Milliseconds":
        return void (i ? n.setUTCMilliseconds(e) : n.setMilliseconds(e));
      case "Seconds":
        return void (i ? n.setUTCSeconds(e) : n.setSeconds(e));
      case "Minutes":
        return void (i ? n.setUTCMinutes(e) : n.setMinutes(e));
      case "Hours":
        return void (i ? n.setUTCHours(e) : n.setHours(e));
      case "Date":
        return void (i ? n.setUTCDate(e) : n.setDate(e));
      // case 'Day': // Not real
      //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
      // case 'Month': // Not used because we need to pass two variables
      //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
      case "FullYear":
        break;
      // See below ...
      default:
        return;
    }
    a = e, o = t.month(), s = t.date(), s = s === 29 && o === 1 && !U2(a) ? 28 : s, i ? n.setUTCFullYear(a, o, s) : n.setFullYear(a, o, s);
  }
}
function jme(t) {
  return t = Ba(t), us(this[t]) ? this[t]() : this;
}
function Yme(t, r) {
  if (typeof t == "object") {
    t = ax(t);
    var e = Ome(t), n, i = e.length;
    for (n = 0; n < i; n++)
      this[e[n].unit](t[e[n].unit]);
  } else if (t = Ba(t), us(this[t]))
    return this[t](r);
  return this;
}
function Xme(t, r) {
  return (t % r + r) % r;
}
var nn;
Array.prototype.indexOf ? nn = Array.prototype.indexOf : nn = function(t) {
  var r;
  for (r = 0; r < this.length; ++r)
    if (this[r] === t)
      return r;
  return -1;
};
function ux(t, r) {
  if (isNaN(t) || isNaN(r))
    return NaN;
  var e = Xme(r, 12);
  return t += (r - e) / 12, e === 1 ? U2(t) ? 29 : 28 : 31 - e % 7 % 2;
}
et("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
et("MMM", 0, 0, function(t) {
  return this.localeData().monthsShort(this, t);
});
et("MMMM", 0, 0, function(t) {
  return this.localeData().months(this, t);
});
Fe("M", Er, bh);
Fe("MM", Er, aa);
Fe("MMM", function(t, r) {
  return r.monthsShortRegex(t);
});
Fe("MMMM", function(t, r) {
  return r.monthsRegex(t);
});
xr(["M", "MM"], function(t, r) {
  r[ks] = Bt(t) - 1;
});
xr(["MMM", "MMMM"], function(t, r, e, n) {
  var i = e._locale.monthsParse(t, n, e._strict);
  i != null ? r[ks] = i : Tt(e).invalidMonth = t;
});
var $me = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), Cz = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), wz = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, Ume = Gg, Jme = Gg;
function Kme(t, r) {
  return t ? oo(this._months) ? this._months[t.month()] : this._months[(this._months.isFormat || wz).test(r) ? "format" : "standalone"][t.month()] : oo(this._months) ? this._months : this._months.standalone;
}
function qme(t, r) {
  return t ? oo(this._monthsShort) ? this._monthsShort[t.month()] : this._monthsShort[wz.test(r) ? "format" : "standalone"][t.month()] : oo(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function Qme(t, r, e) {
  var n, i, a, o = t.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], n = 0; n < 12; ++n)
      a = ls([2e3, n]), this._shortMonthsParse[n] = this.monthsShort(
        a,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[n] = this.months(a, "").toLocaleLowerCase();
  return e ? r === "MMM" ? (i = nn.call(this._shortMonthsParse, o), i !== -1 ? i : null) : (i = nn.call(this._longMonthsParse, o), i !== -1 ? i : null) : r === "MMM" ? (i = nn.call(this._shortMonthsParse, o), i !== -1 ? i : (i = nn.call(this._longMonthsParse, o), i !== -1 ? i : null)) : (i = nn.call(this._longMonthsParse, o), i !== -1 ? i : (i = nn.call(this._shortMonthsParse, o), i !== -1 ? i : null));
}
function eye(t, r, e) {
  var n, i, a;
  if (this._monthsParseExact)
    return Qme.call(this, t, r, e);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), n = 0; n < 12; n++) {
    if (i = ls([2e3, n]), e && !this._longMonthsParse[n] && (this._longMonthsParse[n] = new RegExp(
      "^" + this.months(i, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[n] = new RegExp(
      "^" + this.monthsShort(i, "").replace(".", "") + "$",
      "i"
    )), !e && !this._monthsParse[n] && (a = "^" + this.months(i, "") + "|^" + this.monthsShort(i, ""), this._monthsParse[n] = new RegExp(a.replace(".", ""), "i")), e && r === "MMMM" && this._longMonthsParse[n].test(t))
      return n;
    if (e && r === "MMM" && this._shortMonthsParse[n].test(t))
      return n;
    if (!e && this._monthsParse[n].test(t))
      return n;
  }
}
function _z(t, r) {
  if (!t.isValid())
    return t;
  if (typeof r == "string") {
    if (/^\d+$/.test(r))
      r = Bt(r);
    else if (r = t.localeData().monthsParse(r), !rl(r))
      return t;
  }
  var e = r, n = t.date();
  return n = n < 29 ? n : Math.min(n, ux(t.year(), e)), t._isUTC ? t._d.setUTCMonth(e, n) : t._d.setMonth(e, n), t;
}
function xz(t) {
  return t != null ? (_z(this, t), De.updateOffset(this, !0), this) : Zv(this, "Month");
}
function tye() {
  return ux(this.year(), this.month());
}
function rye(t) {
  return this._monthsParseExact ? (er(this, "_monthsRegex") || Sz.call(this), t ? this._monthsShortStrictRegex : this._monthsShortRegex) : (er(this, "_monthsShortRegex") || (this._monthsShortRegex = Ume), this._monthsShortStrictRegex && t ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function nye(t) {
  return this._monthsParseExact ? (er(this, "_monthsRegex") || Sz.call(this), t ? this._monthsStrictRegex : this._monthsRegex) : (er(this, "_monthsRegex") || (this._monthsRegex = Jme), this._monthsStrictRegex && t ? this._monthsStrictRegex : this._monthsRegex);
}
function Sz() {
  function t(l, u) {
    return u.length - l.length;
  }
  var r = [], e = [], n = [], i, a, o, s;
  for (i = 0; i < 12; i++)
    a = ls([2e3, i]), o = Ws(this.monthsShort(a, "")), s = Ws(this.months(a, "")), r.push(o), e.push(s), n.push(s), n.push(o);
  r.sort(t), e.sort(t), n.sort(t), this._monthsRegex = new RegExp("^(" + n.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + e.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  );
}
function iye(t, r, e, n, i, a, o) {
  var s;
  return t < 100 && t >= 0 ? (s = new Date(t + 400, r, e, n, i, a, o), isFinite(s.getFullYear()) && s.setFullYear(t)) : s = new Date(t, r, e, n, i, a, o), s;
}
function jv(t) {
  var r, e;
  return t < 100 && t >= 0 ? (e = Array.prototype.slice.call(arguments), e[0] = t + 400, r = new Date(Date.UTC.apply(null, e)), isFinite(r.getUTCFullYear()) && r.setUTCFullYear(t)) : r = new Date(Date.UTC.apply(null, arguments)), r;
}
function Sy(t, r, e) {
  var n = 7 + r - e, i = (7 + jv(t, 0, n).getUTCDay() - r) % 7;
  return -i + n - 1;
}
function Iz(t, r, e, n, i) {
  var a = (7 + e - n) % 7, o = Sy(t, n, i), s = 1 + 7 * (r - 1) + a + o, l, u;
  return s <= 0 ? (l = t - 1, u = ov(l) + s) : s > ov(t) ? (l = t + 1, u = s - ov(t)) : (l = t, u = s), {
    year: l,
    dayOfYear: u
  };
}
function Yv(t, r, e) {
  var n = Sy(t.year(), r, e), i = Math.floor((t.dayOfYear() - n - 1) / 7) + 1, a, o;
  return i < 1 ? (o = t.year() - 1, a = i + Zs(o, r, e)) : i > Zs(t.year(), r, e) ? (a = i - Zs(t.year(), r, e), o = t.year() + 1) : (o = t.year(), a = i), {
    week: a,
    year: o
  };
}
function Zs(t, r, e) {
  var n = Sy(t, r, e), i = Sy(t + 1, r, e);
  return (ov(t) - n + i) / 7;
}
et("w", ["ww", 2], "wo", "week");
et("W", ["WW", 2], "Wo", "isoWeek");
Fe("w", Er, bh);
Fe("ww", Er, aa);
Fe("W", Er, bh);
Fe("WW", Er, aa);
Bg(
  ["w", "ww", "W", "WW"],
  function(t, r, e, n) {
    r[n.substr(0, 1)] = Bt(t);
  }
);
function aye(t) {
  return Yv(t, this._week.dow, this._week.doy).week;
}
var oye = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function sye() {
  return this._week.dow;
}
function lye() {
  return this._week.doy;
}
function uye(t) {
  var r = this.localeData().week(this);
  return t == null ? r : this.add((t - r) * 7, "d");
}
function cye(t) {
  var r = Yv(this, 1, 4).week;
  return t == null ? r : this.add((t - r) * 7, "d");
}
et("d", 0, "do", "day");
et("dd", 0, 0, function(t) {
  return this.localeData().weekdaysMin(this, t);
});
et("ddd", 0, 0, function(t) {
  return this.localeData().weekdaysShort(this, t);
});
et("dddd", 0, 0, function(t) {
  return this.localeData().weekdays(this, t);
});
et("e", 0, 0, "weekday");
et("E", 0, 0, "isoWeekday");
Fe("d", Er);
Fe("e", Er);
Fe("E", Er);
Fe("dd", function(t, r) {
  return r.weekdaysMinRegex(t);
});
Fe("ddd", function(t, r) {
  return r.weekdaysShortRegex(t);
});
Fe("dddd", function(t, r) {
  return r.weekdaysRegex(t);
});
Bg(["dd", "ddd", "dddd"], function(t, r, e, n) {
  var i = e._locale.weekdaysParse(t, n, e._strict);
  i != null ? r.d = i : Tt(e).invalidWeekday = t;
});
Bg(["d", "e", "E"], function(t, r, e, n) {
  r[n] = Bt(t);
});
function dye(t, r) {
  return typeof t != "string" ? t : isNaN(t) ? (t = r.weekdaysParse(t), typeof t == "number" ? t : null) : parseInt(t, 10);
}
function fye(t, r) {
  return typeof t == "string" ? r.weekdaysParse(t) % 7 || 7 : isNaN(t) ? null : t;
}
function cx(t, r) {
  return t.slice(r, 7).concat(t.slice(0, r));
}
var hye = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), Az = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), pye = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), vye = Gg, gye = Gg, mye = Gg;
function yye(t, r) {
  var e = oo(this._weekdays) ? this._weekdays : this._weekdays[t && t !== !0 && this._weekdays.isFormat.test(r) ? "format" : "standalone"];
  return t === !0 ? cx(e, this._week.dow) : t ? e[t.day()] : e;
}
function bye(t) {
  return t === !0 ? cx(this._weekdaysShort, this._week.dow) : t ? this._weekdaysShort[t.day()] : this._weekdaysShort;
}
function Cye(t) {
  return t === !0 ? cx(this._weekdaysMin, this._week.dow) : t ? this._weekdaysMin[t.day()] : this._weekdaysMin;
}
function wye(t, r, e) {
  var n, i, a, o = t.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], n = 0; n < 7; ++n)
      a = ls([2e3, 1]).day(n), this._minWeekdaysParse[n] = this.weekdaysMin(
        a,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[n] = this.weekdaysShort(
        a,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[n] = this.weekdays(a, "").toLocaleLowerCase();
  return e ? r === "dddd" ? (i = nn.call(this._weekdaysParse, o), i !== -1 ? i : null) : r === "ddd" ? (i = nn.call(this._shortWeekdaysParse, o), i !== -1 ? i : null) : (i = nn.call(this._minWeekdaysParse, o), i !== -1 ? i : null) : r === "dddd" ? (i = nn.call(this._weekdaysParse, o), i !== -1 || (i = nn.call(this._shortWeekdaysParse, o), i !== -1) ? i : (i = nn.call(this._minWeekdaysParse, o), i !== -1 ? i : null)) : r === "ddd" ? (i = nn.call(this._shortWeekdaysParse, o), i !== -1 || (i = nn.call(this._weekdaysParse, o), i !== -1) ? i : (i = nn.call(this._minWeekdaysParse, o), i !== -1 ? i : null)) : (i = nn.call(this._minWeekdaysParse, o), i !== -1 || (i = nn.call(this._weekdaysParse, o), i !== -1) ? i : (i = nn.call(this._shortWeekdaysParse, o), i !== -1 ? i : null));
}
function _ye(t, r, e) {
  var n, i, a;
  if (this._weekdaysParseExact)
    return wye.call(this, t, r, e);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), n = 0; n < 7; n++) {
    if (i = ls([2e3, 1]).day(n), e && !this._fullWeekdaysParse[n] && (this._fullWeekdaysParse[n] = new RegExp(
      "^" + this.weekdays(i, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[n] = new RegExp(
      "^" + this.weekdaysShort(i, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[n] = new RegExp(
      "^" + this.weekdaysMin(i, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[n] || (a = "^" + this.weekdays(i, "") + "|^" + this.weekdaysShort(i, "") + "|^" + this.weekdaysMin(i, ""), this._weekdaysParse[n] = new RegExp(a.replace(".", ""), "i")), e && r === "dddd" && this._fullWeekdaysParse[n].test(t))
      return n;
    if (e && r === "ddd" && this._shortWeekdaysParse[n].test(t))
      return n;
    if (e && r === "dd" && this._minWeekdaysParse[n].test(t))
      return n;
    if (!e && this._weekdaysParse[n].test(t))
      return n;
  }
}
function xye(t) {
  if (!this.isValid())
    return t != null ? this : NaN;
  var r = Zv(this, "Day");
  return t != null ? (t = dye(t, this.localeData()), this.add(t - r, "d")) : r;
}
function Sye(t) {
  if (!this.isValid())
    return t != null ? this : NaN;
  var r = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return t == null ? r : this.add(t - r, "d");
}
function Iye(t) {
  if (!this.isValid())
    return t != null ? this : NaN;
  if (t != null) {
    var r = fye(t, this.localeData());
    return this.day(this.day() % 7 ? r : r - 7);
  } else
    return this.day() || 7;
}
function Aye(t) {
  return this._weekdaysParseExact ? (er(this, "_weekdaysRegex") || dx.call(this), t ? this._weekdaysStrictRegex : this._weekdaysRegex) : (er(this, "_weekdaysRegex") || (this._weekdaysRegex = vye), this._weekdaysStrictRegex && t ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function Dye(t) {
  return this._weekdaysParseExact ? (er(this, "_weekdaysRegex") || dx.call(this), t ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (er(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = gye), this._weekdaysShortStrictRegex && t ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function Tye(t) {
  return this._weekdaysParseExact ? (er(this, "_weekdaysRegex") || dx.call(this), t ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (er(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = mye), this._weekdaysMinStrictRegex && t ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function dx() {
  function t(c, d) {
    return d.length - c.length;
  }
  var r = [], e = [], n = [], i = [], a, o, s, l, u;
  for (a = 0; a < 7; a++)
    o = ls([2e3, 1]).day(a), s = Ws(this.weekdaysMin(o, "")), l = Ws(this.weekdaysShort(o, "")), u = Ws(this.weekdays(o, "")), r.push(s), e.push(l), n.push(u), i.push(s), i.push(l), i.push(u);
  r.sort(t), e.sort(t), n.sort(t), i.sort(t), this._weekdaysRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + e.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  );
}
function fx() {
  return this.hours() % 12 || 12;
}
function Mye() {
  return this.hours() || 24;
}
et("H", ["HH", 2], 0, "hour");
et("h", ["hh", 2], 0, fx);
et("k", ["kk", 2], 0, Mye);
et("hmm", 0, 0, function() {
  return "" + fx.apply(this) + ts(this.minutes(), 2);
});
et("hmmss", 0, 0, function() {
  return "" + fx.apply(this) + ts(this.minutes(), 2) + ts(this.seconds(), 2);
});
et("Hmm", 0, 0, function() {
  return "" + this.hours() + ts(this.minutes(), 2);
});
et("Hmmss", 0, 0, function() {
  return "" + this.hours() + ts(this.minutes(), 2) + ts(this.seconds(), 2);
});
function Dz(t, r) {
  et(t, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      r
    );
  });
}
Dz("a", !0);
Dz("A", !1);
function Tz(t, r) {
  return r._meridiemParse;
}
Fe("a", Tz);
Fe("A", Tz);
Fe("H", Er, lx);
Fe("h", Er, bh);
Fe("k", Er, bh);
Fe("HH", Er, aa);
Fe("hh", Er, aa);
Fe("kk", Er, aa);
Fe("hmm", gz);
Fe("hmmss", mz);
Fe("Hmm", gz);
Fe("Hmmss", mz);
xr(["H", "HH"], wn);
xr(["k", "kk"], function(t, r, e) {
  var n = Bt(t);
  r[wn] = n === 24 ? 0 : n;
});
xr(["a", "A"], function(t, r, e) {
  e._isPm = e._locale.isPM(t), e._meridiem = t;
});
xr(["h", "hh"], function(t, r, e) {
  r[wn] = Bt(t), Tt(e).bigHour = !0;
});
xr("hmm", function(t, r, e) {
  var n = t.length - 2;
  r[wn] = Bt(t.substr(0, n)), r[$a] = Bt(t.substr(n)), Tt(e).bigHour = !0;
});
xr("hmmss", function(t, r, e) {
  var n = t.length - 4, i = t.length - 2;
  r[wn] = Bt(t.substr(0, n)), r[$a] = Bt(t.substr(n, 2)), r[Ps] = Bt(t.substr(i)), Tt(e).bigHour = !0;
});
xr("Hmm", function(t, r, e) {
  var n = t.length - 2;
  r[wn] = Bt(t.substr(0, n)), r[$a] = Bt(t.substr(n));
});
xr("Hmmss", function(t, r, e) {
  var n = t.length - 4, i = t.length - 2;
  r[wn] = Bt(t.substr(0, n)), r[$a] = Bt(t.substr(n, 2)), r[Ps] = Bt(t.substr(i));
});
function Rye(t) {
  return (t + "").toLowerCase().charAt(0) === "p";
}
var Lye = /[ap]\.?m?\.?/i, Eye = Ch("Hours", !0);
function kye(t, r, e) {
  return t > 11 ? e ? "pm" : "PM" : e ? "am" : "AM";
}
var Mz = {
  calendar: wme,
  longDateFormat: Ime,
  invalidDate: Dme,
  ordinal: Mme,
  dayOfMonthOrdinalParse: Rme,
  relativeTime: Eme,
  months: $me,
  monthsShort: Cz,
  week: oye,
  weekdays: hye,
  weekdaysMin: pye,
  weekdaysShort: Az,
  meridiemParse: Lye
}, Pr = {}, vp = {}, Xv;
function Pye(t, r) {
  var e, n = Math.min(t.length, r.length);
  for (e = 0; e < n; e += 1)
    if (t[e] !== r[e])
      return e;
  return n;
}
function NL(t) {
  return t && t.toLowerCase().replace("_", "-");
}
function Nye(t) {
  for (var r = 0, e, n, i, a; r < t.length; ) {
    for (a = NL(t[r]).split("-"), e = a.length, n = NL(t[r + 1]), n = n ? n.split("-") : null; e > 0; ) {
      if (i = J2(a.slice(0, e).join("-")), i)
        return i;
      if (n && n.length >= e && Pye(a, n) >= e - 1)
        break;
      e--;
    }
    r++;
  }
  return Xv;
}
function Oye(t) {
  return !!(t && t.match("^[^/\\\\]*$"));
}
function J2(t) {
  var r = null, e;
  if (Pr[t] === void 0 && typeof module < "u" && module && module.exports && Oye(t))
    try {
      r = Xv._abbr, e = require, e("./locale/" + t), jl(r);
    } catch {
      Pr[t] = null;
    }
  return Pr[t];
}
function jl(t, r) {
  var e;
  return t && (Li(r) ? e = sl(t) : e = hx(t, r), e ? Xv = e : typeof console < "u" && console.warn && console.warn(
    "Locale " + t + " not found. Did you forget to load it?"
  )), Xv._abbr;
}
function hx(t, r) {
  if (r !== null) {
    var e, n = Mz;
    if (r.abbr = t, Pr[t] != null)
      fz(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), n = Pr[t]._config;
    else if (r.parentLocale != null)
      if (Pr[r.parentLocale] != null)
        n = Pr[r.parentLocale]._config;
      else if (e = J2(r.parentLocale), e != null)
        n = e._config;
      else
        return vp[r.parentLocale] || (vp[r.parentLocale] = []), vp[r.parentLocale].push({
          name: t,
          config: r
        }), null;
    return Pr[t] = new nx(y6(n, r)), vp[t] && vp[t].forEach(function(i) {
      hx(i.name, i.config);
    }), jl(t), Pr[t];
  } else
    return delete Pr[t], null;
}
function Vye(t, r) {
  if (r != null) {
    var e, n, i = Mz;
    Pr[t] != null && Pr[t].parentLocale != null ? Pr[t].set(y6(Pr[t]._config, r)) : (n = J2(t), n != null && (i = n._config), r = y6(i, r), n == null && (r.abbr = t), e = new nx(r), e.parentLocale = Pr[t], Pr[t] = e), jl(t);
  } else
    Pr[t] != null && (Pr[t].parentLocale != null ? (Pr[t] = Pr[t].parentLocale, t === jl() && jl(t)) : Pr[t] != null && delete Pr[t]);
  return Pr[t];
}
function sl(t) {
  var r;
  if (t && t._locale && t._locale._abbr && (t = t._locale._abbr), !t)
    return Xv;
  if (!oo(t)) {
    if (r = J2(t), r)
      return r;
    t = [t];
  }
  return Nye(t);
}
function Gye() {
  return b6(Pr);
}
function px(t) {
  var r, e = t._a;
  return e && Tt(t).overflow === -2 && (r = e[ks] < 0 || e[ks] > 11 ? ks : e[Po] < 1 || e[Po] > ux(e[ii], e[ks]) ? Po : e[wn] < 0 || e[wn] > 24 || e[wn] === 24 && (e[$a] !== 0 || e[Ps] !== 0 || e[yc] !== 0) ? wn : e[$a] < 0 || e[$a] > 59 ? $a : e[Ps] < 0 || e[Ps] > 59 ? Ps : e[yc] < 0 || e[yc] > 999 ? yc : -1, Tt(t)._overflowDayOfYear && (r < ii || r > Po) && (r = Po), Tt(t)._overflowWeeks && r === -1 && (r = zme), Tt(t)._overflowWeekday && r === -1 && (r = Wme), Tt(t).overflow = r), t;
}
var Bye = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, Fye = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, Hye = /Z|[+-]\d\d(?::?\d\d)?/, s0 = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], u4 = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], zye = /^\/?Date\((-?\d+)/i, Wye = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, Zye = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function Rz(t) {
  var r, e, n = t._i, i = Bye.exec(n) || Fye.exec(n), a, o, s, l, u = s0.length, c = u4.length;
  if (i) {
    for (Tt(t).iso = !0, r = 0, e = u; r < e; r++)
      if (s0[r][1].exec(i[1])) {
        o = s0[r][0], a = s0[r][2] !== !1;
        break;
      }
    if (o == null) {
      t._isValid = !1;
      return;
    }
    if (i[3]) {
      for (r = 0, e = c; r < e; r++)
        if (u4[r][1].exec(i[3])) {
          s = (i[2] || " ") + u4[r][0];
          break;
        }
      if (s == null) {
        t._isValid = !1;
        return;
      }
    }
    if (!a && s != null) {
      t._isValid = !1;
      return;
    }
    if (i[4])
      if (Hye.exec(i[4]))
        l = "Z";
      else {
        t._isValid = !1;
        return;
      }
    t._f = o + (s || "") + (l || ""), gx(t);
  } else
    t._isValid = !1;
}
function jye(t, r, e, n, i, a) {
  var o = [
    Yye(t),
    Cz.indexOf(r),
    parseInt(e, 10),
    parseInt(n, 10),
    parseInt(i, 10)
  ];
  return a && o.push(parseInt(a, 10)), o;
}
function Yye(t) {
  var r = parseInt(t, 10);
  return r <= 49 ? 2e3 + r : r <= 999 ? 1900 + r : r;
}
function Xye(t) {
  return t.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function $ye(t, r, e) {
  if (t) {
    var n = Az.indexOf(t), i = new Date(
      r[0],
      r[1],
      r[2]
    ).getDay();
    if (n !== i)
      return Tt(e).weekdayMismatch = !0, e._isValid = !1, !1;
  }
  return !0;
}
function Uye(t, r, e) {
  if (t)
    return Zye[t];
  if (r)
    return 0;
  var n = parseInt(e, 10), i = n % 100, a = (n - i) / 100;
  return a * 60 + i;
}
function Lz(t) {
  var r = Wye.exec(Xye(t._i)), e;
  if (r) {
    if (e = jye(
      r[4],
      r[3],
      r[2],
      r[5],
      r[6],
      r[7]
    ), !$ye(r[1], e, t))
      return;
    t._a = e, t._tzm = Uye(r[8], r[9], r[10]), t._d = jv.apply(null, t._a), t._d.setUTCMinutes(t._d.getUTCMinutes() - t._tzm), Tt(t).rfc2822 = !0;
  } else
    t._isValid = !1;
}
function Jye(t) {
  var r = zye.exec(t._i);
  if (r !== null) {
    t._d = /* @__PURE__ */ new Date(+r[1]);
    return;
  }
  if (Rz(t), t._isValid === !1)
    delete t._isValid;
  else
    return;
  if (Lz(t), t._isValid === !1)
    delete t._isValid;
  else
    return;
  t._strict ? t._isValid = !1 : De.createFromInputFallback(t);
}
De.createFromInputFallback = Ga(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(t) {
    t._d = /* @__PURE__ */ new Date(t._i + (t._useUTC ? " UTC" : ""));
  }
);
function $d(t, r, e) {
  return t ?? r ?? e;
}
function Kye(t) {
  var r = new Date(De.now());
  return t._useUTC ? [
    r.getUTCFullYear(),
    r.getUTCMonth(),
    r.getUTCDate()
  ] : [r.getFullYear(), r.getMonth(), r.getDate()];
}
function vx(t) {
  var r, e, n = [], i, a, o;
  if (!t._d) {
    for (i = Kye(t), t._w && t._a[Po] == null && t._a[ks] == null && qye(t), t._dayOfYear != null && (o = $d(t._a[ii], i[ii]), (t._dayOfYear > ov(o) || t._dayOfYear === 0) && (Tt(t)._overflowDayOfYear = !0), e = jv(o, 0, t._dayOfYear), t._a[ks] = e.getUTCMonth(), t._a[Po] = e.getUTCDate()), r = 0; r < 3 && t._a[r] == null; ++r)
      t._a[r] = n[r] = i[r];
    for (; r < 7; r++)
      t._a[r] = n[r] = t._a[r] == null ? r === 2 ? 1 : 0 : t._a[r];
    t._a[wn] === 24 && t._a[$a] === 0 && t._a[Ps] === 0 && t._a[yc] === 0 && (t._nextDay = !0, t._a[wn] = 0), t._d = (t._useUTC ? jv : iye).apply(
      null,
      n
    ), a = t._useUTC ? t._d.getUTCDay() : t._d.getDay(), t._tzm != null && t._d.setUTCMinutes(t._d.getUTCMinutes() - t._tzm), t._nextDay && (t._a[wn] = 24), t._w && typeof t._w.d < "u" && t._w.d !== a && (Tt(t).weekdayMismatch = !0);
  }
}
function qye(t) {
  var r, e, n, i, a, o, s, l, u;
  r = t._w, r.GG != null || r.W != null || r.E != null ? (a = 1, o = 4, e = $d(
    r.GG,
    t._a[ii],
    Yv(Lr(), 1, 4).year
  ), n = $d(r.W, 1), i = $d(r.E, 1), (i < 1 || i > 7) && (l = !0)) : (a = t._locale._week.dow, o = t._locale._week.doy, u = Yv(Lr(), a, o), e = $d(r.gg, t._a[ii], u.year), n = $d(r.w, u.week), r.d != null ? (i = r.d, (i < 0 || i > 6) && (l = !0)) : r.e != null ? (i = r.e + a, (r.e < 0 || r.e > 6) && (l = !0)) : i = a), n < 1 || n > Zs(e, a, o) ? Tt(t)._overflowWeeks = !0 : l != null ? Tt(t)._overflowWeekday = !0 : (s = Iz(e, n, i, a, o), t._a[ii] = s.year, t._dayOfYear = s.dayOfYear);
}
De.ISO_8601 = function() {
};
De.RFC_2822 = function() {
};
function gx(t) {
  if (t._f === De.ISO_8601) {
    Rz(t);
    return;
  }
  if (t._f === De.RFC_2822) {
    Lz(t);
    return;
  }
  t._a = [], Tt(t).empty = !0;
  var r = "" + t._i, e, n, i, a, o, s = r.length, l = 0, u, c;
  for (i = hz(t._f, t._locale).match(ix) || [], c = i.length, e = 0; e < c; e++)
    a = i[e], n = (r.match(Bme(a, t)) || [])[0], n && (o = r.substr(0, r.indexOf(n)), o.length > 0 && Tt(t).unusedInput.push(o), r = r.slice(
      r.indexOf(n) + n.length
    ), l += n.length), Cf[a] ? (n ? Tt(t).empty = !1 : Tt(t).unusedTokens.push(a), Hme(a, n, t)) : t._strict && !n && Tt(t).unusedTokens.push(a);
  Tt(t).charsLeftOver = s - l, r.length > 0 && Tt(t).unusedInput.push(r), t._a[wn] <= 12 && Tt(t).bigHour === !0 && t._a[wn] > 0 && (Tt(t).bigHour = void 0), Tt(t).parsedDateParts = t._a.slice(0), Tt(t).meridiem = t._meridiem, t._a[wn] = Qye(
    t._locale,
    t._a[wn],
    t._meridiem
  ), u = Tt(t).era, u !== null && (t._a[ii] = t._locale.erasConvertYear(u, t._a[ii])), vx(t), px(t);
}
function Qye(t, r, e) {
  var n;
  return e == null ? r : t.meridiemHour != null ? t.meridiemHour(r, e) : (t.isPM != null && (n = t.isPM(e), n && r < 12 && (r += 12), !n && r === 12 && (r = 0)), r);
}
function e2e(t) {
  var r, e, n, i, a, o, s = !1, l = t._f.length;
  if (l === 0) {
    Tt(t).invalidFormat = !0, t._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (i = 0; i < l; i++)
    a = 0, o = !1, r = rx({}, t), t._useUTC != null && (r._useUTC = t._useUTC), r._f = t._f[i], gx(r), tx(r) && (o = !0), a += Tt(r).charsLeftOver, a += Tt(r).unusedTokens.length * 10, Tt(r).score = a, s ? a < n && (n = a, e = r) : (n == null || a < n || o) && (n = a, e = r, o && (s = !0));
  kl(t, e || r);
}
function t2e(t) {
  if (!t._d) {
    var r = ax(t._i), e = r.day === void 0 ? r.date : r.day;
    t._a = cz(
      [r.year, r.month, e, r.hour, r.minute, r.second, r.millisecond],
      function(n) {
        return n && parseInt(n, 10);
      }
    ), vx(t);
  }
}
function r2e(t) {
  var r = new Vg(px(Ez(t)));
  return r._nextDay && (r.add(1, "d"), r._nextDay = void 0), r;
}
function Ez(t) {
  var r = t._i, e = t._f;
  return t._locale = t._locale || sl(t._l), r === null || e === void 0 && r === "" ? W2({ nullInput: !0 }) : (typeof r == "string" && (t._i = r = t._locale.preparse(r)), so(r) ? new Vg(px(r)) : (Og(r) ? t._d = r : oo(e) ? e2e(t) : e ? gx(t) : n2e(t), tx(t) || (t._d = null), t));
}
function n2e(t) {
  var r = t._i;
  Li(r) ? t._d = new Date(De.now()) : Og(r) ? t._d = new Date(r.valueOf()) : typeof r == "string" ? Jye(t) : oo(r) ? (t._a = cz(r.slice(0), function(e) {
    return parseInt(e, 10);
  }), vx(t)) : Ec(r) ? t2e(t) : rl(r) ? t._d = new Date(r) : De.createFromInputFallback(t);
}
function kz(t, r, e, n, i) {
  var a = {};
  return (r === !0 || r === !1) && (n = r, r = void 0), (e === !0 || e === !1) && (n = e, e = void 0), (Ec(t) && ex(t) || oo(t) && t.length === 0) && (t = void 0), a._isAMomentObject = !0, a._useUTC = a._isUTC = i, a._l = e, a._i = t, a._f = r, a._strict = n, r2e(a);
}
function Lr(t, r, e, n) {
  return kz(t, r, e, n, !1);
}
var i2e = Ga(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var t = Lr.apply(null, arguments);
    return this.isValid() && t.isValid() ? t < this ? this : t : W2();
  }
), a2e = Ga(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var t = Lr.apply(null, arguments);
    return this.isValid() && t.isValid() ? t > this ? this : t : W2();
  }
);
function Pz(t, r) {
  var e, n;
  if (r.length === 1 && oo(r[0]) && (r = r[0]), !r.length)
    return Lr();
  for (e = r[0], n = 1; n < r.length; ++n)
    (!r[n].isValid() || r[n][t](e)) && (e = r[n]);
  return e;
}
function o2e() {
  var t = [].slice.call(arguments, 0);
  return Pz("isBefore", t);
}
function s2e() {
  var t = [].slice.call(arguments, 0);
  return Pz("isAfter", t);
}
var l2e = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, gp = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function u2e(t) {
  var r, e = !1, n, i = gp.length;
  for (r in t)
    if (er(t, r) && !(nn.call(gp, r) !== -1 && (t[r] == null || !isNaN(t[r]))))
      return !1;
  for (n = 0; n < i; ++n)
    if (t[gp[n]]) {
      if (e)
        return !1;
      parseFloat(t[gp[n]]) !== Bt(t[gp[n]]) && (e = !0);
    }
  return !0;
}
function c2e() {
  return this._isValid;
}
function d2e() {
  return fo(NaN);
}
function K2(t) {
  var r = ax(t), e = r.year || 0, n = r.quarter || 0, i = r.month || 0, a = r.week || r.isoWeek || 0, o = r.day || 0, s = r.hour || 0, l = r.minute || 0, u = r.second || 0, c = r.millisecond || 0;
  this._isValid = u2e(r), this._milliseconds = +c + u * 1e3 + // 1000
  l * 6e4 + // 1000 * 60
  s * 1e3 * 60 * 60, this._days = +o + a * 7, this._months = +i + n * 3 + e * 12, this._data = {}, this._locale = sl(), this._bubble();
}
function $0(t) {
  return t instanceof K2;
}
function w6(t) {
  return t < 0 ? Math.round(-1 * t) * -1 : Math.round(t);
}
function f2e(t, r, e) {
  var n = Math.min(t.length, r.length), i = Math.abs(t.length - r.length), a = 0, o;
  for (o = 0; o < n; o++)
    Bt(t[o]) !== Bt(r[o]) && a++;
  return a + i;
}
function Nz(t, r) {
  et(t, 0, 0, function() {
    var e = this.utcOffset(), n = "+";
    return e < 0 && (e = -e, n = "-"), n + ts(~~(e / 60), 2) + r + ts(~~e % 60, 2);
  });
}
Nz("Z", ":");
Nz("ZZ", "");
Fe("Z", $2);
Fe("ZZ", $2);
xr(["Z", "ZZ"], function(t, r, e) {
  e._useUTC = !0, e._tzm = mx($2, t);
});
var h2e = /([\+\-]|\d\d)/gi;
function mx(t, r) {
  var e = (r || "").match(t), n, i, a;
  return e === null ? null : (n = e[e.length - 1] || [], i = (n + "").match(h2e) || ["-", 0, 0], a = +(i[1] * 60) + Bt(i[2]), a === 0 ? 0 : i[0] === "+" ? a : -a);
}
function yx(t, r) {
  var e, n;
  return r._isUTC ? (e = r.clone(), n = (so(t) || Og(t) ? t.valueOf() : Lr(t).valueOf()) - e.valueOf(), e._d.setTime(e._d.valueOf() + n), De.updateOffset(e, !1), e) : Lr(t).local();
}
function _6(t) {
  return -Math.round(t._d.getTimezoneOffset());
}
De.updateOffset = function() {
};
function p2e(t, r, e) {
  var n = this._offset || 0, i;
  if (!this.isValid())
    return t != null ? this : NaN;
  if (t != null) {
    if (typeof t == "string") {
      if (t = mx($2, t), t === null)
        return this;
    } else Math.abs(t) < 16 && !e && (t = t * 60);
    return !this._isUTC && r && (i = _6(this)), this._offset = t, this._isUTC = !0, i != null && this.add(i, "m"), n !== t && (!r || this._changeInProgress ? Gz(
      this,
      fo(t - n, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, De.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? n : _6(this);
}
function v2e(t, r) {
  return t != null ? (typeof t != "string" && (t = -t), this.utcOffset(t, r), this) : -this.utcOffset();
}
function g2e(t) {
  return this.utcOffset(0, t);
}
function m2e(t) {
  return this._isUTC && (this.utcOffset(0, t), this._isUTC = !1, t && this.subtract(_6(this), "m")), this;
}
function y2e() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var t = mx(Vme, this._i);
    t != null ? this.utcOffset(t) : this.utcOffset(0, !0);
  }
  return this;
}
function b2e(t) {
  return this.isValid() ? (t = t ? Lr(t).utcOffset() : 0, (this.utcOffset() - t) % 60 === 0) : !1;
}
function C2e() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function w2e() {
  if (!Li(this._isDSTShifted))
    return this._isDSTShifted;
  var t = {}, r;
  return rx(t, this), t = Ez(t), t._a ? (r = t._isUTC ? ls(t._a) : Lr(t._a), this._isDSTShifted = this.isValid() && f2e(t._a, r.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function _2e() {
  return this.isValid() ? !this._isUTC : !1;
}
function x2e() {
  return this.isValid() ? this._isUTC : !1;
}
function Oz() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var S2e = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, I2e = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function fo(t, r) {
  var e = t, n = null, i, a, o;
  return $0(t) ? e = {
    ms: t._milliseconds,
    d: t._days,
    M: t._months
  } : rl(t) || !isNaN(+t) ? (e = {}, r ? e[r] = +t : e.milliseconds = +t) : (n = S2e.exec(t)) ? (i = n[1] === "-" ? -1 : 1, e = {
    y: 0,
    d: Bt(n[Po]) * i,
    h: Bt(n[wn]) * i,
    m: Bt(n[$a]) * i,
    s: Bt(n[Ps]) * i,
    ms: Bt(w6(n[yc] * 1e3)) * i
    // the millisecond decimal point is included in the match
  }) : (n = I2e.exec(t)) ? (i = n[1] === "-" ? -1 : 1, e = {
    y: Yu(n[2], i),
    M: Yu(n[3], i),
    w: Yu(n[4], i),
    d: Yu(n[5], i),
    h: Yu(n[6], i),
    m: Yu(n[7], i),
    s: Yu(n[8], i)
  }) : e == null ? e = {} : typeof e == "object" && ("from" in e || "to" in e) && (o = A2e(
    Lr(e.from),
    Lr(e.to)
  ), e = {}, e.ms = o.milliseconds, e.M = o.months), a = new K2(e), $0(t) && er(t, "_locale") && (a._locale = t._locale), $0(t) && er(t, "_isValid") && (a._isValid = t._isValid), a;
}
fo.fn = K2.prototype;
fo.invalid = d2e;
function Yu(t, r) {
  var e = t && parseFloat(t.replace(",", "."));
  return (isNaN(e) ? 0 : e) * r;
}
function OL(t, r) {
  var e = {};
  return e.months = r.month() - t.month() + (r.year() - t.year()) * 12, t.clone().add(e.months, "M").isAfter(r) && --e.months, e.milliseconds = +r - +t.clone().add(e.months, "M"), e;
}
function A2e(t, r) {
  var e;
  return t.isValid() && r.isValid() ? (r = yx(r, t), t.isBefore(r) ? e = OL(t, r) : (e = OL(r, t), e.milliseconds = -e.milliseconds, e.months = -e.months), e) : { milliseconds: 0, months: 0 };
}
function Vz(t, r) {
  return function(e, n) {
    var i, a;
    return n !== null && !isNaN(+n) && (fz(
      r,
      "moment()." + r + "(period, number) is deprecated. Please use moment()." + r + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), a = e, e = n, n = a), i = fo(e, n), Gz(this, i, t), this;
  };
}
function Gz(t, r, e, n) {
  var i = r._milliseconds, a = w6(r._days), o = w6(r._months);
  t.isValid() && (n = n ?? !0, o && _z(t, Zv(t, "Month") + o * e), a && bz(t, "Date", Zv(t, "Date") + a * e), i && t._d.setTime(t._d.valueOf() + i * e), n && De.updateOffset(t, a || o));
}
var D2e = Vz(1, "add"), T2e = Vz(-1, "subtract");
function Bz(t) {
  return typeof t == "string" || t instanceof String;
}
function M2e(t) {
  return so(t) || Og(t) || Bz(t) || rl(t) || L2e(t) || R2e(t) || t === null || t === void 0;
}
function R2e(t) {
  var r = Ec(t) && !ex(t), e = !1, n = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], i, a, o = n.length;
  for (i = 0; i < o; i += 1)
    a = n[i], e = e || er(t, a);
  return r && e;
}
function L2e(t) {
  var r = oo(t), e = !1;
  return r && (e = t.filter(function(n) {
    return !rl(n) && Bz(t);
  }).length === 0), r && e;
}
function E2e(t) {
  var r = Ec(t) && !ex(t), e = !1, n = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], i, a;
  for (i = 0; i < n.length; i += 1)
    a = n[i], e = e || er(t, a);
  return r && e;
}
function k2e(t, r) {
  var e = t.diff(r, "days", !0);
  return e < -6 ? "sameElse" : e < -1 ? "lastWeek" : e < 0 ? "lastDay" : e < 1 ? "sameDay" : e < 2 ? "nextDay" : e < 7 ? "nextWeek" : "sameElse";
}
function P2e(t, r) {
  arguments.length === 1 && (arguments[0] ? M2e(arguments[0]) ? (t = arguments[0], r = void 0) : E2e(arguments[0]) && (r = arguments[0], t = void 0) : (t = void 0, r = void 0));
  var e = t || Lr(), n = yx(e, this).startOf("day"), i = De.calendarFormat(this, n) || "sameElse", a = r && (us(r[i]) ? r[i].call(this, e) : r[i]);
  return this.format(
    a || this.localeData().calendar(i, this, Lr(e))
  );
}
function N2e() {
  return new Vg(this);
}
function O2e(t, r) {
  var e = so(t) ? t : Lr(t);
  return this.isValid() && e.isValid() ? (r = Ba(r) || "millisecond", r === "millisecond" ? this.valueOf() > e.valueOf() : e.valueOf() < this.clone().startOf(r).valueOf()) : !1;
}
function V2e(t, r) {
  var e = so(t) ? t : Lr(t);
  return this.isValid() && e.isValid() ? (r = Ba(r) || "millisecond", r === "millisecond" ? this.valueOf() < e.valueOf() : this.clone().endOf(r).valueOf() < e.valueOf()) : !1;
}
function G2e(t, r, e, n) {
  var i = so(t) ? t : Lr(t), a = so(r) ? r : Lr(r);
  return this.isValid() && i.isValid() && a.isValid() ? (n = n || "()", (n[0] === "(" ? this.isAfter(i, e) : !this.isBefore(i, e)) && (n[1] === ")" ? this.isBefore(a, e) : !this.isAfter(a, e))) : !1;
}
function B2e(t, r) {
  var e = so(t) ? t : Lr(t), n;
  return this.isValid() && e.isValid() ? (r = Ba(r) || "millisecond", r === "millisecond" ? this.valueOf() === e.valueOf() : (n = e.valueOf(), this.clone().startOf(r).valueOf() <= n && n <= this.clone().endOf(r).valueOf())) : !1;
}
function F2e(t, r) {
  return this.isSame(t, r) || this.isAfter(t, r);
}
function H2e(t, r) {
  return this.isSame(t, r) || this.isBefore(t, r);
}
function z2e(t, r, e) {
  var n, i, a;
  if (!this.isValid())
    return NaN;
  if (n = yx(t, this), !n.isValid())
    return NaN;
  switch (i = (n.utcOffset() - this.utcOffset()) * 6e4, r = Ba(r), r) {
    case "year":
      a = U0(this, n) / 12;
      break;
    case "month":
      a = U0(this, n);
      break;
    case "quarter":
      a = U0(this, n) / 3;
      break;
    case "second":
      a = (this - n) / 1e3;
      break;
    // 1000
    case "minute":
      a = (this - n) / 6e4;
      break;
    // 1000 * 60
    case "hour":
      a = (this - n) / 36e5;
      break;
    // 1000 * 60 * 60
    case "day":
      a = (this - n - i) / 864e5;
      break;
    // 1000 * 60 * 60 * 24, negate dst
    case "week":
      a = (this - n - i) / 6048e5;
      break;
    // 1000 * 60 * 60 * 24 * 7, negate dst
    default:
      a = this - n;
  }
  return e ? a : Sa(a);
}
function U0(t, r) {
  if (t.date() < r.date())
    return -U0(r, t);
  var e = (r.year() - t.year()) * 12 + (r.month() - t.month()), n = t.clone().add(e, "months"), i, a;
  return r - n < 0 ? (i = t.clone().add(e - 1, "months"), a = (r - n) / (n - i)) : (i = t.clone().add(e + 1, "months"), a = (r - n) / (i - n)), -(e + a) || 0;
}
De.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
De.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function W2e() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function Z2e(t) {
  if (!this.isValid())
    return null;
  var r = t !== !0, e = r ? this.clone().utc() : this;
  return e.year() < 0 || e.year() > 9999 ? X0(
    e,
    r ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : us(Date.prototype.toISOString) ? r ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", X0(e, "Z")) : X0(
    e,
    r ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function j2e() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var t = "moment", r = "", e, n, i, a;
  return this.isLocal() || (t = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", r = "Z"), e = "[" + t + '("]', n = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", i = "-MM-DD[T]HH:mm:ss.SSS", a = r + '[")]', this.format(e + n + i + a);
}
function Y2e(t) {
  t || (t = this.isUtc() ? De.defaultFormatUtc : De.defaultFormat);
  var r = X0(this, t);
  return this.localeData().postformat(r);
}
function X2e(t, r) {
  return this.isValid() && (so(t) && t.isValid() || Lr(t).isValid()) ? fo({ to: this, from: t }).locale(this.locale()).humanize(!r) : this.localeData().invalidDate();
}
function $2e(t) {
  return this.from(Lr(), t);
}
function U2e(t, r) {
  return this.isValid() && (so(t) && t.isValid() || Lr(t).isValid()) ? fo({ from: this, to: t }).locale(this.locale()).humanize(!r) : this.localeData().invalidDate();
}
function J2e(t) {
  return this.to(Lr(), t);
}
function Fz(t) {
  var r;
  return t === void 0 ? this._locale._abbr : (r = sl(t), r != null && (this._locale = r), this);
}
var Hz = Ga(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(t) {
    return t === void 0 ? this.localeData() : this.locale(t);
  }
);
function zz() {
  return this._locale;
}
var Iy = 1e3, wf = 60 * Iy, Ay = 60 * wf, Wz = (365 * 400 + 97) * 24 * Ay;
function _f(t, r) {
  return (t % r + r) % r;
}
function Zz(t, r, e) {
  return t < 100 && t >= 0 ? new Date(t + 400, r, e) - Wz : new Date(t, r, e).valueOf();
}
function jz(t, r, e) {
  return t < 100 && t >= 0 ? Date.UTC(t + 400, r, e) - Wz : Date.UTC(t, r, e);
}
function K2e(t) {
  var r, e;
  if (t = Ba(t), t === void 0 || t === "millisecond" || !this.isValid())
    return this;
  switch (e = this._isUTC ? jz : Zz, t) {
    case "year":
      r = e(this.year(), 0, 1);
      break;
    case "quarter":
      r = e(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      r = e(this.year(), this.month(), 1);
      break;
    case "week":
      r = e(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      r = e(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      r = e(this.year(), this.month(), this.date());
      break;
    case "hour":
      r = this._d.valueOf(), r -= _f(
        r + (this._isUTC ? 0 : this.utcOffset() * wf),
        Ay
      );
      break;
    case "minute":
      r = this._d.valueOf(), r -= _f(r, wf);
      break;
    case "second":
      r = this._d.valueOf(), r -= _f(r, Iy);
      break;
  }
  return this._d.setTime(r), De.updateOffset(this, !0), this;
}
function q2e(t) {
  var r, e;
  if (t = Ba(t), t === void 0 || t === "millisecond" || !this.isValid())
    return this;
  switch (e = this._isUTC ? jz : Zz, t) {
    case "year":
      r = e(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      r = e(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      r = e(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      r = e(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      r = e(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      r = e(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      r = this._d.valueOf(), r += Ay - _f(
        r + (this._isUTC ? 0 : this.utcOffset() * wf),
        Ay
      ) - 1;
      break;
    case "minute":
      r = this._d.valueOf(), r += wf - _f(r, wf) - 1;
      break;
    case "second":
      r = this._d.valueOf(), r += Iy - _f(r, Iy) - 1;
      break;
  }
  return this._d.setTime(r), De.updateOffset(this, !0), this;
}
function Q2e() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function e5e() {
  return Math.floor(this.valueOf() / 1e3);
}
function t5e() {
  return new Date(this.valueOf());
}
function r5e() {
  var t = this;
  return [
    t.year(),
    t.month(),
    t.date(),
    t.hour(),
    t.minute(),
    t.second(),
    t.millisecond()
  ];
}
function n5e() {
  var t = this;
  return {
    years: t.year(),
    months: t.month(),
    date: t.date(),
    hours: t.hours(),
    minutes: t.minutes(),
    seconds: t.seconds(),
    milliseconds: t.milliseconds()
  };
}
function i5e() {
  return this.isValid() ? this.toISOString() : null;
}
function a5e() {
  return tx(this);
}
function o5e() {
  return kl({}, Tt(this));
}
function s5e() {
  return Tt(this).overflow;
}
function l5e() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
et("N", 0, 0, "eraAbbr");
et("NN", 0, 0, "eraAbbr");
et("NNN", 0, 0, "eraAbbr");
et("NNNN", 0, 0, "eraName");
et("NNNNN", 0, 0, "eraNarrow");
et("y", ["y", 1], "yo", "eraYear");
et("y", ["yy", 2], 0, "eraYear");
et("y", ["yyy", 3], 0, "eraYear");
et("y", ["yyyy", 4], 0, "eraYear");
Fe("N", bx);
Fe("NN", bx);
Fe("NNN", bx);
Fe("NNNN", b5e);
Fe("NNNNN", C5e);
xr(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(t, r, e, n) {
    var i = e._locale.erasParse(t, n, e._strict);
    i ? Tt(e).era = i : Tt(e).invalidEra = t;
  }
);
Fe("y", yh);
Fe("yy", yh);
Fe("yyy", yh);
Fe("yyyy", yh);
Fe("yo", w5e);
xr(["y", "yy", "yyy", "yyyy"], ii);
xr(["yo"], function(t, r, e, n) {
  var i;
  e._locale._eraYearOrdinalRegex && (i = t.match(e._locale._eraYearOrdinalRegex)), e._locale.eraYearOrdinalParse ? r[ii] = e._locale.eraYearOrdinalParse(t, i) : r[ii] = parseInt(t, 10);
});
function u5e(t, r) {
  var e, n, i, a = this._eras || sl("en")._eras;
  for (e = 0, n = a.length; e < n; ++e) {
    switch (typeof a[e].since) {
      case "string":
        i = De(a[e].since).startOf("day"), a[e].since = i.valueOf();
        break;
    }
    switch (typeof a[e].until) {
      case "undefined":
        a[e].until = 1 / 0;
        break;
      case "string":
        i = De(a[e].until).startOf("day").valueOf(), a[e].until = i.valueOf();
        break;
    }
  }
  return a;
}
function c5e(t, r, e) {
  var n, i, a = this.eras(), o, s, l;
  for (t = t.toUpperCase(), n = 0, i = a.length; n < i; ++n)
    if (o = a[n].name.toUpperCase(), s = a[n].abbr.toUpperCase(), l = a[n].narrow.toUpperCase(), e)
      switch (r) {
        case "N":
        case "NN":
        case "NNN":
          if (s === t)
            return a[n];
          break;
        case "NNNN":
          if (o === t)
            return a[n];
          break;
        case "NNNNN":
          if (l === t)
            return a[n];
          break;
      }
    else if ([o, s, l].indexOf(t) >= 0)
      return a[n];
}
function d5e(t, r) {
  var e = t.since <= t.until ? 1 : -1;
  return r === void 0 ? De(t.since).year() : De(t.since).year() + (r - t.offset) * e;
}
function f5e() {
  var t, r, e, n = this.localeData().eras();
  for (t = 0, r = n.length; t < r; ++t)
    if (e = this.clone().startOf("day").valueOf(), n[t].since <= e && e <= n[t].until || n[t].until <= e && e <= n[t].since)
      return n[t].name;
  return "";
}
function h5e() {
  var t, r, e, n = this.localeData().eras();
  for (t = 0, r = n.length; t < r; ++t)
    if (e = this.clone().startOf("day").valueOf(), n[t].since <= e && e <= n[t].until || n[t].until <= e && e <= n[t].since)
      return n[t].narrow;
  return "";
}
function p5e() {
  var t, r, e, n = this.localeData().eras();
  for (t = 0, r = n.length; t < r; ++t)
    if (e = this.clone().startOf("day").valueOf(), n[t].since <= e && e <= n[t].until || n[t].until <= e && e <= n[t].since)
      return n[t].abbr;
  return "";
}
function v5e() {
  var t, r, e, n, i = this.localeData().eras();
  for (t = 0, r = i.length; t < r; ++t)
    if (e = i[t].since <= i[t].until ? 1 : -1, n = this.clone().startOf("day").valueOf(), i[t].since <= n && n <= i[t].until || i[t].until <= n && n <= i[t].since)
      return (this.year() - De(i[t].since).year()) * e + i[t].offset;
  return this.year();
}
function g5e(t) {
  return er(this, "_erasNameRegex") || Cx.call(this), t ? this._erasNameRegex : this._erasRegex;
}
function m5e(t) {
  return er(this, "_erasAbbrRegex") || Cx.call(this), t ? this._erasAbbrRegex : this._erasRegex;
}
function y5e(t) {
  return er(this, "_erasNarrowRegex") || Cx.call(this), t ? this._erasNarrowRegex : this._erasRegex;
}
function bx(t, r) {
  return r.erasAbbrRegex(t);
}
function b5e(t, r) {
  return r.erasNameRegex(t);
}
function C5e(t, r) {
  return r.erasNarrowRegex(t);
}
function w5e(t, r) {
  return r._eraYearOrdinalRegex || yh;
}
function Cx() {
  var t = [], r = [], e = [], n = [], i, a, o, s, l, u = this.eras();
  for (i = 0, a = u.length; i < a; ++i)
    o = Ws(u[i].name), s = Ws(u[i].abbr), l = Ws(u[i].narrow), r.push(o), t.push(s), e.push(l), n.push(o), n.push(s), n.push(l);
  this._erasRegex = new RegExp("^(" + n.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + t.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + e.join("|") + ")",
    "i"
  );
}
et(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
et(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function q2(t, r) {
  et(0, [t, t.length], 0, r);
}
q2("gggg", "weekYear");
q2("ggggg", "weekYear");
q2("GGGG", "isoWeekYear");
q2("GGGGG", "isoWeekYear");
Fe("G", X2);
Fe("g", X2);
Fe("GG", Er, aa);
Fe("gg", Er, aa);
Fe("GGGG", sx, ox);
Fe("gggg", sx, ox);
Fe("GGGGG", Y2, Z2);
Fe("ggggg", Y2, Z2);
Bg(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(t, r, e, n) {
    r[n.substr(0, 2)] = Bt(t);
  }
);
Bg(["gg", "GG"], function(t, r, e, n) {
  r[n] = De.parseTwoDigitYear(t);
});
function _5e(t) {
  return Yz.call(
    this,
    t,
    this.week(),
    this.weekday() + this.localeData()._week.dow,
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function x5e(t) {
  return Yz.call(
    this,
    t,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function S5e() {
  return Zs(this.year(), 1, 4);
}
function I5e() {
  return Zs(this.isoWeekYear(), 1, 4);
}
function A5e() {
  var t = this.localeData()._week;
  return Zs(this.year(), t.dow, t.doy);
}
function D5e() {
  var t = this.localeData()._week;
  return Zs(this.weekYear(), t.dow, t.doy);
}
function Yz(t, r, e, n, i) {
  var a;
  return t == null ? Yv(this, n, i).year : (a = Zs(t, n, i), r > a && (r = a), T5e.call(this, t, r, e, n, i));
}
function T5e(t, r, e, n, i) {
  var a = Iz(t, r, e, n, i), o = jv(a.year, 0, a.dayOfYear);
  return this.year(o.getUTCFullYear()), this.month(o.getUTCMonth()), this.date(o.getUTCDate()), this;
}
et("Q", 0, "Qo", "quarter");
Fe("Q", pz);
xr("Q", function(t, r) {
  r[ks] = (Bt(t) - 1) * 3;
});
function M5e(t) {
  return t == null ? Math.ceil((this.month() + 1) / 3) : this.month((t - 1) * 3 + this.month() % 3);
}
et("D", ["DD", 2], "Do", "date");
Fe("D", Er, bh);
Fe("DD", Er, aa);
Fe("Do", function(t, r) {
  return t ? r._dayOfMonthOrdinalParse || r._ordinalParse : r._dayOfMonthOrdinalParseLenient;
});
xr(["D", "DD"], Po);
xr("Do", function(t, r) {
  r[Po] = Bt(t.match(Er)[0]);
});
var Xz = Ch("Date", !0);
et("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
Fe("DDD", j2);
Fe("DDDD", vz);
xr(["DDD", "DDDD"], function(t, r, e) {
  e._dayOfYear = Bt(t);
});
function R5e(t) {
  var r = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return t == null ? r : this.add(t - r, "d");
}
et("m", ["mm", 2], 0, "minute");
Fe("m", Er, lx);
Fe("mm", Er, aa);
xr(["m", "mm"], $a);
var L5e = Ch("Minutes", !1);
et("s", ["ss", 2], 0, "second");
Fe("s", Er, lx);
Fe("ss", Er, aa);
xr(["s", "ss"], Ps);
var E5e = Ch("Seconds", !1);
et("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
et(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
et(0, ["SSS", 3], 0, "millisecond");
et(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
et(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
et(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
et(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
et(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
et(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
Fe("S", j2, pz);
Fe("SS", j2, aa);
Fe("SSS", j2, vz);
var Pl, $z;
for (Pl = "SSSS"; Pl.length <= 9; Pl += "S")
  Fe(Pl, yh);
function k5e(t, r) {
  r[yc] = Bt(("0." + t) * 1e3);
}
for (Pl = "S"; Pl.length <= 9; Pl += "S")
  xr(Pl, k5e);
$z = Ch("Milliseconds", !1);
et("z", 0, 0, "zoneAbbr");
et("zz", 0, 0, "zoneName");
function P5e() {
  return this._isUTC ? "UTC" : "";
}
function N5e() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var me = Vg.prototype;
me.add = D2e;
me.calendar = P2e;
me.clone = N2e;
me.diff = z2e;
me.endOf = q2e;
me.format = Y2e;
me.from = X2e;
me.fromNow = $2e;
me.to = U2e;
me.toNow = J2e;
me.get = jme;
me.invalidAt = s5e;
me.isAfter = O2e;
me.isBefore = V2e;
me.isBetween = G2e;
me.isSame = B2e;
me.isSameOrAfter = F2e;
me.isSameOrBefore = H2e;
me.isValid = a5e;
me.lang = Hz;
me.locale = Fz;
me.localeData = zz;
me.max = a2e;
me.min = i2e;
me.parsingFlags = o5e;
me.set = Yme;
me.startOf = K2e;
me.subtract = T2e;
me.toArray = r5e;
me.toObject = n5e;
me.toDate = t5e;
me.toISOString = Z2e;
me.inspect = j2e;
typeof Symbol < "u" && Symbol.for != null && (me[Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
me.toJSON = i5e;
me.toString = W2e;
me.unix = e5e;
me.valueOf = Q2e;
me.creationData = l5e;
me.eraName = f5e;
me.eraNarrow = h5e;
me.eraAbbr = p5e;
me.eraYear = v5e;
me.year = yz;
me.isLeapYear = Zme;
me.weekYear = _5e;
me.isoWeekYear = x5e;
me.quarter = me.quarters = M5e;
me.month = xz;
me.daysInMonth = tye;
me.week = me.weeks = uye;
me.isoWeek = me.isoWeeks = cye;
me.weeksInYear = A5e;
me.weeksInWeekYear = D5e;
me.isoWeeksInYear = S5e;
me.isoWeeksInISOWeekYear = I5e;
me.date = Xz;
me.day = me.days = xye;
me.weekday = Sye;
me.isoWeekday = Iye;
me.dayOfYear = R5e;
me.hour = me.hours = Eye;
me.minute = me.minutes = L5e;
me.second = me.seconds = E5e;
me.millisecond = me.milliseconds = $z;
me.utcOffset = p2e;
me.utc = g2e;
me.local = m2e;
me.parseZone = y2e;
me.hasAlignedHourOffset = b2e;
me.isDST = C2e;
me.isLocal = _2e;
me.isUtcOffset = x2e;
me.isUtc = Oz;
me.isUTC = Oz;
me.zoneAbbr = P5e;
me.zoneName = N5e;
me.dates = Ga(
  "dates accessor is deprecated. Use date instead.",
  Xz
);
me.months = Ga(
  "months accessor is deprecated. Use month instead",
  xz
);
me.years = Ga(
  "years accessor is deprecated. Use year instead",
  yz
);
me.zone = Ga(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  v2e
);
me.isDSTShifted = Ga(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  w2e
);
function O5e(t) {
  return Lr(t * 1e3);
}
function V5e() {
  return Lr.apply(null, arguments).parseZone();
}
function Uz(t) {
  return t;
}
var rr = nx.prototype;
rr.calendar = _me;
rr.longDateFormat = Ame;
rr.invalidDate = Tme;
rr.ordinal = Lme;
rr.preparse = Uz;
rr.postformat = Uz;
rr.relativeTime = kme;
rr.pastFuture = Pme;
rr.set = Cme;
rr.eras = u5e;
rr.erasParse = c5e;
rr.erasConvertYear = d5e;
rr.erasAbbrRegex = m5e;
rr.erasNameRegex = g5e;
rr.erasNarrowRegex = y5e;
rr.months = Kme;
rr.monthsShort = qme;
rr.monthsParse = eye;
rr.monthsRegex = nye;
rr.monthsShortRegex = rye;
rr.week = aye;
rr.firstDayOfYear = lye;
rr.firstDayOfWeek = sye;
rr.weekdays = yye;
rr.weekdaysMin = Cye;
rr.weekdaysShort = bye;
rr.weekdaysParse = _ye;
rr.weekdaysRegex = Aye;
rr.weekdaysShortRegex = Dye;
rr.weekdaysMinRegex = Tye;
rr.isPM = Rye;
rr.meridiem = kye;
function Dy(t, r, e, n) {
  var i = sl(), a = ls().set(n, r);
  return i[e](a, t);
}
function Jz(t, r, e) {
  if (rl(t) && (r = t, t = void 0), t = t || "", r != null)
    return Dy(t, r, e, "month");
  var n, i = [];
  for (n = 0; n < 12; n++)
    i[n] = Dy(t, n, e, "month");
  return i;
}
function _x(t, r, e, n) {
  typeof t == "boolean" ? (rl(r) && (e = r, r = void 0), r = r || "") : (r = t, e = r, t = !1, rl(r) && (e = r, r = void 0), r = r || "");
  var i = sl(), a = t ? i._week.dow : 0, o, s = [];
  if (e != null)
    return Dy(r, (e + a) % 7, n, "day");
  for (o = 0; o < 7; o++)
    s[o] = Dy(r, (o + a) % 7, n, "day");
  return s;
}
function G5e(t, r) {
  return Jz(t, r, "months");
}
function B5e(t, r) {
  return Jz(t, r, "monthsShort");
}
function F5e(t, r, e) {
  return _x(t, r, e, "weekdays");
}
function H5e(t, r, e) {
  return _x(t, r, e, "weekdaysShort");
}
function z5e(t, r, e) {
  return _x(t, r, e, "weekdaysMin");
}
jl("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(t) {
    var r = t % 10, e = Bt(t % 100 / 10) === 1 ? "th" : r === 1 ? "st" : r === 2 ? "nd" : r === 3 ? "rd" : "th";
    return t + e;
  }
});
De.lang = Ga(
  "moment.lang is deprecated. Use moment.locale instead.",
  jl
);
De.langData = Ga(
  "moment.langData is deprecated. Use moment.localeData instead.",
  sl
);
var ys = Math.abs;
function W5e() {
  var t = this._data;
  return this._milliseconds = ys(this._milliseconds), this._days = ys(this._days), this._months = ys(this._months), t.milliseconds = ys(t.milliseconds), t.seconds = ys(t.seconds), t.minutes = ys(t.minutes), t.hours = ys(t.hours), t.months = ys(t.months), t.years = ys(t.years), this;
}
function Kz(t, r, e, n) {
  var i = fo(r, e);
  return t._milliseconds += n * i._milliseconds, t._days += n * i._days, t._months += n * i._months, t._bubble();
}
function Z5e(t, r) {
  return Kz(this, t, r, 1);
}
function j5e(t, r) {
  return Kz(this, t, r, -1);
}
function VL(t) {
  return t < 0 ? Math.floor(t) : Math.ceil(t);
}
function Y5e() {
  var t = this._milliseconds, r = this._days, e = this._months, n = this._data, i, a, o, s, l;
  return t >= 0 && r >= 0 && e >= 0 || t <= 0 && r <= 0 && e <= 0 || (t += VL(x6(e) + r) * 864e5, r = 0, e = 0), n.milliseconds = t % 1e3, i = Sa(t / 1e3), n.seconds = i % 60, a = Sa(i / 60), n.minutes = a % 60, o = Sa(a / 60), n.hours = o % 24, r += Sa(o / 24), l = Sa(qz(r)), e += l, r -= VL(x6(l)), s = Sa(e / 12), e %= 12, n.days = r, n.months = e, n.years = s, this;
}
function qz(t) {
  return t * 4800 / 146097;
}
function x6(t) {
  return t * 146097 / 4800;
}
function X5e(t) {
  if (!this.isValid())
    return NaN;
  var r, e, n = this._milliseconds;
  if (t = Ba(t), t === "month" || t === "quarter" || t === "year")
    switch (r = this._days + n / 864e5, e = this._months + qz(r), t) {
      case "month":
        return e;
      case "quarter":
        return e / 3;
      case "year":
        return e / 12;
    }
  else
    switch (r = this._days + Math.round(x6(this._months)), t) {
      case "week":
        return r / 7 + n / 6048e5;
      case "day":
        return r + n / 864e5;
      case "hour":
        return r * 24 + n / 36e5;
      case "minute":
        return r * 1440 + n / 6e4;
      case "second":
        return r * 86400 + n / 1e3;
      // Math.floor prevents floating point math errors here
      case "millisecond":
        return Math.floor(r * 864e5) + n;
      default:
        throw new Error("Unknown unit " + t);
    }
}
function ll(t) {
  return function() {
    return this.as(t);
  };
}
var Qz = ll("ms"), $5e = ll("s"), U5e = ll("m"), J5e = ll("h"), K5e = ll("d"), q5e = ll("w"), Q5e = ll("M"), ebe = ll("Q"), tbe = ll("y"), rbe = Qz;
function nbe() {
  return fo(this);
}
function ibe(t) {
  return t = Ba(t), this.isValid() ? this[t + "s"]() : NaN;
}
function od(t) {
  return function() {
    return this.isValid() ? this._data[t] : NaN;
  };
}
var abe = od("milliseconds"), obe = od("seconds"), sbe = od("minutes"), lbe = od("hours"), ube = od("days"), cbe = od("months"), dbe = od("years");
function fbe() {
  return Sa(this.days() / 7);
}
var xs = Math.round, ef = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function hbe(t, r, e, n, i) {
  return i.relativeTime(r || 1, !!e, t, n);
}
function pbe(t, r, e, n) {
  var i = fo(t).abs(), a = xs(i.as("s")), o = xs(i.as("m")), s = xs(i.as("h")), l = xs(i.as("d")), u = xs(i.as("M")), c = xs(i.as("w")), d = xs(i.as("y")), f = a <= e.ss && ["s", a] || a < e.s && ["ss", a] || o <= 1 && ["m"] || o < e.m && ["mm", o] || s <= 1 && ["h"] || s < e.h && ["hh", s] || l <= 1 && ["d"] || l < e.d && ["dd", l];
  return e.w != null && (f = f || c <= 1 && ["w"] || c < e.w && ["ww", c]), f = f || u <= 1 && ["M"] || u < e.M && ["MM", u] || d <= 1 && ["y"] || ["yy", d], f[2] = r, f[3] = +t > 0, f[4] = n, hbe.apply(null, f);
}
function vbe(t) {
  return t === void 0 ? xs : typeof t == "function" ? (xs = t, !0) : !1;
}
function gbe(t, r) {
  return ef[t] === void 0 ? !1 : r === void 0 ? ef[t] : (ef[t] = r, t === "s" && (ef.ss = r - 1), !0);
}
function mbe(t, r) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var e = !1, n = ef, i, a;
  return typeof t == "object" && (r = t, t = !1), typeof t == "boolean" && (e = t), typeof r == "object" && (n = Object.assign({}, ef, r), r.s != null && r.ss == null && (n.ss = r.s - 1)), i = this.localeData(), a = pbe(this, !e, n, i), e && (a = i.pastFuture(+this, a)), i.postformat(a);
}
var c4 = Math.abs;
function Vd(t) {
  return (t > 0) - (t < 0) || +t;
}
function Q2() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var t = c4(this._milliseconds) / 1e3, r = c4(this._days), e = c4(this._months), n, i, a, o, s = this.asSeconds(), l, u, c, d;
  return s ? (n = Sa(t / 60), i = Sa(n / 60), t %= 60, n %= 60, a = Sa(e / 12), e %= 12, o = t ? t.toFixed(3).replace(/\.?0+$/, "") : "", l = s < 0 ? "-" : "", u = Vd(this._months) !== Vd(s) ? "-" : "", c = Vd(this._days) !== Vd(s) ? "-" : "", d = Vd(this._milliseconds) !== Vd(s) ? "-" : "", l + "P" + (a ? u + a + "Y" : "") + (e ? u + e + "M" : "") + (r ? c + r + "D" : "") + (i || n || t ? "T" : "") + (i ? d + i + "H" : "") + (n ? d + n + "M" : "") + (t ? d + o + "S" : "")) : "P0D";
}
var Xt = K2.prototype;
Xt.isValid = c2e;
Xt.abs = W5e;
Xt.add = Z5e;
Xt.subtract = j5e;
Xt.as = X5e;
Xt.asMilliseconds = Qz;
Xt.asSeconds = $5e;
Xt.asMinutes = U5e;
Xt.asHours = J5e;
Xt.asDays = K5e;
Xt.asWeeks = q5e;
Xt.asMonths = Q5e;
Xt.asQuarters = ebe;
Xt.asYears = tbe;
Xt.valueOf = rbe;
Xt._bubble = Y5e;
Xt.clone = nbe;
Xt.get = ibe;
Xt.milliseconds = abe;
Xt.seconds = obe;
Xt.minutes = sbe;
Xt.hours = lbe;
Xt.days = ube;
Xt.weeks = fbe;
Xt.months = cbe;
Xt.years = dbe;
Xt.humanize = mbe;
Xt.toISOString = Q2;
Xt.toString = Q2;
Xt.toJSON = Q2;
Xt.locale = Fz;
Xt.localeData = zz;
Xt.toIsoString = Ga(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  Q2
);
Xt.lang = Hz;
et("X", 0, 0, "unix");
et("x", 0, 0, "valueOf");
Fe("x", X2);
Fe("X", Gme);
xr("X", function(t, r, e) {
  e._d = new Date(parseFloat(t) * 1e3);
});
xr("x", function(t, r, e) {
  e._d = new Date(Bt(t));
});
//! moment.js
De.version = "2.30.1";
yme(Lr);
De.fn = me;
De.min = o2e;
De.max = s2e;
De.now = l2e;
De.utc = ls;
De.unix = O5e;
De.months = G5e;
De.isDate = Og;
De.locale = jl;
De.invalid = W2;
De.duration = fo;
De.isMoment = so;
De.weekdays = F5e;
De.parseZone = V5e;
De.localeData = sl;
De.isDuration = $0;
De.monthsShort = B5e;
De.weekdaysMin = z5e;
De.defineLocale = hx;
De.updateLocale = Vye;
De.locales = Gye;
De.weekdaysShort = H5e;
De.normalizeUnits = Ba;
De.relativeTimeRounding = vbe;
De.relativeTimeThreshold = gbe;
De.calendarFormat = k2e;
De.prototype = me;
De.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
const ybe = (t) => {
  const [r, e] = We(!1), [n, i] = We(!1), o = ((g, m, y = 1) => {
    const b = [];
    for (let C = g; C <= m; C += y)
      b.push(C);
    return b;
  })(
    ht(/* @__PURE__ */ new Date()) - 100,
    ht(/* @__PURE__ */ new Date()),
    1
  ), s = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ], {
    date: l,
    changeYear: u,
    changeMonth: c,
    isMonthYearPicker: d = !1,
    startDate: f,
    endDate: h
  } = t, p = sn(/* @__PURE__ */ new Date()), v = ht(/* @__PURE__ */ new Date());
  return /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
    /* @__PURE__ */ S.jsxs("div", { className: "theme-datepicker-header-selector", children: [
      !d && /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
        /* @__PURE__ */ S.jsxs(
          "div",
          {
            className: "theme-datepicker-header-month-selector",
            onClick: () => {
              e(!r), i(!1);
            },
            children: [
              /* @__PURE__ */ S.jsx("span", { children: s[sn(l)] }),
              /* @__PURE__ */ S.jsx(
                Qd,
                {
                  className: `arrow-icon ${r && "is-active"}`
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ S.jsx("div", { className: "theme-datepicker-dropdown month-selector", children: s.map((g, m) => /* @__PURE__ */ S.jsx(
          "span",
          {
            className: `theme-datepicker-dropdown-item ${s[sn(l)] === g && "is-selected"} ${p === m && "is-current"}`,
            onClick: () => {
              c(s.indexOf(g)), e(!1);
            },
            children: g
          },
          `month-${m}`
        )) })
      ] }),
      /* @__PURE__ */ S.jsxs(
        "div",
        {
          className: `theme-datepicker-header-year-selector ${d && "month-year-picker"}`,
          onClick: () => {
            i(!n), e(!1);
          },
          children: [
            /* @__PURE__ */ S.jsx("span", { children: ht(l) }),
            /* @__PURE__ */ S.jsx(
              Qd,
              {
                className: `arrow-icon ${n && "is-active"}`
              }
            )
          ]
        }
      ),
      n && /* @__PURE__ */ S.jsx("div", { className: "theme-datepicker-dropdown year-selector", children: o.map((g, m) => /* @__PURE__ */ S.jsx(
        "span",
        {
          className: `theme-datepicker-dropdown-item ${ht(l) === g && "is-selected"} ${v === g && "is-current"}`,
          onClick: () => {
            u(g), i(!1);
          },
          children: g
        },
        `year-${m}`
      )) })
    ] }),
    /* @__PURE__ */ S.jsxs("div", { className: "theme-datepicker-range-header-dates", children: [
      /* @__PURE__ */ S.jsx(
        "span",
        {
          className: h == null ? "is-active" : "",
          children: f && Object.prototype.toString.call(f) === "[object Date]" ? De(f).format("DD MMM YYYY") : "Start Date"
        }
      ),
      /* @__PURE__ */ S.jsx(
        "span",
        {
          className: h && h !== null && Object.prototype.toString.call(h) === "[object Date]" ? "is-active" : "",
          children: h && Object.prototype.toString.call(h) === "[object Date]" ? De(h).format("DD MMM YYYY") : "End Date"
        }
      )
    ] })
  ] });
}, Bxe = (t) => {
  const {
    startDate: r,
    endDate: e,
    onInputChange: n,
    onResetDate: i,
    className: a = "",
    containerClassName: o,
    formLabel: s,
    formSubLabel: l,
    inputHelpBlock: u,
    isRequired: c = !1,
    showTimeSelect: d = !1,
    showMonthYearPicker: f = !1,
    minDate: h,
    format: p = "dd MMM yyyy",
    disabled: v = !1,
    shouldCloseOnSelect: g = !1,
    placeholder: m = "",
    onCloseIconClick: y
  } = t, [b, C] = We(!1);
  return /* @__PURE__ */ S.jsxs(
    "div",
    {
      className: `theme-form-input-container ${o !== void 0 ? o : ""}`,
      children: [
        s && /* @__PURE__ */ S.jsxs("label", { className: "theme-form-input-label", htmlFor: `field-${name}`, children: [
          s,
          " ",
          c && /* @__PURE__ */ S.jsx("span", { children: "*" })
        ] }),
        l && /* @__PURE__ */ S.jsx("label", { className: "theme-form-sublabel", children: l }),
        /* @__PURE__ */ S.jsx(
          K_,
          {
            selected: r,
            disabled: v,
            dateFormat: p,
            showTimeSelect: d,
            minDate: h,
            showIcon: !0,
            icon: b ? /* @__PURE__ */ S.jsx(q_, { onClick: () => i && i() }) : /* @__PURE__ */ S.jsx(Q_, {}),
            useWeekdaysShort: !0,
            showMonthYearPicker: f,
            placeholderText: m,
            wrapperClassName: "theme-custom-datepicker-wrapper",
            calendarClassName: "theme-custom-datepicker theme-datepicker-range",
            className: `theme-form-control ${a}`,
            shouldCloseOnSelect: g,
            renderCustomHeader: (w) => /* @__PURE__ */ S.jsx(
              ybe,
              {
                ...w,
                isMonthYearPicker: f,
                startDate: r,
                endDate: e
              }
            ),
            onChange: (w) => n(w),
            startDate: r,
            endDate: e,
            onCalendarOpen: () => C(!0),
            onCalendarClose: () => {
              C(!1), y && y();
            },
            selectsRange: !0,
            toggleCalendarOnIconClick: !0
          }
        ),
        u && /* @__PURE__ */ S.jsx("span", { className: "theme-form-helpblock", children: u })
      ]
    }
  );
};
var bbe = (t) => t.type === "checkbox", Cbe = (t) => t instanceof Date, eW = (t) => t == null;
const wbe = (t) => typeof t == "object";
var wh = (t) => !eW(t) && !Array.isArray(t) && wbe(t) && !Cbe(t), _be = (t) => wh(t) && t.target ? bbe(t.target) ? t.target.checked : t.target.value : t, xbe = (t) => t.substring(0, t.search(/\.\d+(\.|$)/)) || t, Sbe = (t, r) => t.has(xbe(r)), Ibe = (t) => {
  const r = t.constructor && t.constructor.prototype;
  return wh(r) && r.hasOwnProperty("isPrototypeOf");
}, Abe = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function xx(t) {
  let r;
  const e = Array.isArray(t);
  if (t instanceof Date)
    r = new Date(t);
  else if (t instanceof Set)
    r = new Set(t);
  else if (!(Abe && (t instanceof Blob || t instanceof FileList)) && (e || wh(t)))
    if (r = e ? [] : {}, !e && !Ibe(t))
      r = t;
    else
      for (const n in t)
        t.hasOwnProperty(n) && (r[n] = xx(t[n]));
  else
    return t;
  return r;
}
var tW = (t) => Array.isArray(t) ? t.filter(Boolean) : [], S6 = (t) => t === void 0, Gn = (t, r, e) => {
  if (!r || !wh(t))
    return e;
  const n = tW(r.split(/[,[\].]+?/)).reduce((i, a) => eW(i) ? i : i[a], t);
  return S6(n) || n === t ? S6(t[r]) ? e : t[r] : n;
}, GL = (t) => typeof t == "boolean", Dbe = (t) => /^\w*$/.test(t), Tbe = (t) => tW(t.replace(/["|']|\]/g, "").split(/\.|\[/)), BL = (t, r, e) => {
  let n = -1;
  const i = Dbe(r) ? [r] : Tbe(r), a = i.length, o = a - 1;
  for (; ++n < a; ) {
    const s = i[n];
    let l = e;
    if (n !== o) {
      const u = t[s];
      l = wh(u) || Array.isArray(u) ? u : isNaN(+i[n + 1]) ? {} : [];
    }
    if (s === "__proto__")
      return;
    t[s] = l, t = t[s];
  }
  return t;
};
const FL = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, HL = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Mbe = te.createContext(null), e5 = () => te.useContext(Mbe);
var Rbe = (t, r, e, n = !0) => {
  const i = {
    defaultValues: r._defaultValues
  };
  for (const a in t)
    Object.defineProperty(i, a, {
      get: () => {
        const o = a;
        return r._proxyFormState[o] !== HL.all && (r._proxyFormState[o] = !n || HL.all), e && (e[o] = !0), t[o];
      }
    });
  return i;
}, Lbe = (t) => wh(t) && !Object.keys(t).length, Ebe = (t, r, e, n) => {
  e(t);
  const { name: i, ...a } = t;
  return Lbe(a) || Object.keys(a).length >= Object.keys(r).length || Object.keys(a).find((o) => r[o] === !n);
}, kbe = (t) => Array.isArray(t) ? t : [t], rW = (t, r, e) => !t || !r || t === r || kbe(t).some((n) => n && (e ? n === r : n.startsWith(r) || r.startsWith(n)));
function nW(t) {
  const r = te.useRef(t);
  r.current = t, te.useEffect(() => {
    const e = !t.disabled && r.current.subject && r.current.subject.subscribe({
      next: r.current.next
    });
    return () => {
      e && e.unsubscribe();
    };
  }, [t.disabled]);
}
function Pbe(t) {
  const r = e5(), { control: e = r.control, disabled: n, name: i, exact: a } = t || {}, [o, s] = te.useState(e._formState), l = te.useRef(!0), u = te.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), c = te.useRef(i);
  return c.current = i, nW({
    disabled: n,
    next: (d) => l.current && rW(c.current, d.name, a) && Ebe(d, u.current, e._updateFormState) && s({
      ...e._formState,
      ...d
    }),
    subject: e._subjects.state
  }), te.useEffect(() => (l.current = !0, u.current.isValid && e._updateValid(!0), () => {
    l.current = !1;
  }), [e]), Rbe(o, e, u.current, !1);
}
var Nbe = (t) => typeof t == "string", Obe = (t, r, e, n, i) => Nbe(t) ? Gn(e, t, i) : Array.isArray(t) ? t.map((a) => Gn(e, a)) : e;
function Vbe(t) {
  const r = e5(), { control: e = r.control, name: n, defaultValue: i, disabled: a, exact: o } = t || {}, s = te.useRef(n);
  s.current = n, nW({
    disabled: a,
    subject: e._subjects.values,
    next: (c) => {
      rW(s.current, c.name, o) && u(xx(Obe(s.current, e._names, c.values || e._formValues, !1, i)));
    }
  });
  const [l, u] = te.useState(e._getWatch(n, i));
  return te.useEffect(() => e._removeUnmounted()), l;
}
function Gbe(t) {
  const r = e5(), { name: e, disabled: n, control: i = r.control, shouldUnregister: a } = t, o = Sbe(i._names.array, e), s = Vbe({
    control: i,
    name: e,
    defaultValue: Gn(i._formValues, e, Gn(i._defaultValues, e, t.defaultValue)),
    exact: !0
  }), l = Pbe({
    control: i,
    name: e,
    exact: !0
  }), u = te.useRef(i.register(e, {
    ...t.rules,
    value: s,
    ...GL(t.disabled) ? { disabled: t.disabled } : {}
  }));
  return te.useEffect(() => {
    const c = i._options.shouldUnregister || a, d = (f, h) => {
      const p = Gn(i._fields, f);
      p && p._f && (p._f.mount = h);
    };
    if (d(e, !0), c) {
      const f = xx(Gn(i._options.defaultValues, e));
      BL(i._defaultValues, e, f), S6(Gn(i._formValues, e)) && BL(i._formValues, e, f);
    }
    return () => {
      (o ? c && !i._state.action : c) ? i.unregister(e) : d(e, !1);
    };
  }, [e, i, o, a]), te.useEffect(() => {
    Gn(i._fields, e) && i._updateDisabledField({
      disabled: n,
      fields: i._fields,
      name: e,
      value: Gn(i._fields, e)._f.value
    });
  }, [n, e, i]), {
    field: {
      name: e,
      value: s,
      ...GL(n) || l.disabled ? { disabled: l.disabled || n } : {},
      onChange: te.useCallback((c) => u.current.onChange({
        target: {
          value: _be(c),
          name: e
        },
        type: FL.CHANGE
      }), [e]),
      onBlur: te.useCallback(() => u.current.onBlur({
        target: {
          value: Gn(i._formValues, e),
          name: e
        },
        type: FL.BLUR
      }), [e, i]),
      ref: te.useCallback((c) => {
        const d = Gn(i._fields, e);
        d && c && (d._f.ref = {
          focus: () => c.focus(),
          select: () => c.select(),
          setCustomValidity: (f) => c.setCustomValidity(f),
          reportValidity: () => c.reportValidity()
        });
      }, [i._fields, e])
    },
    formState: l,
    fieldState: Object.defineProperties({}, {
      invalid: {
        enumerable: !0,
        get: () => !!Gn(l.errors, e)
      },
      isDirty: {
        enumerable: !0,
        get: () => !!Gn(l.dirtyFields, e)
      },
      isTouched: {
        enumerable: !0,
        get: () => !!Gn(l.touchedFields, e)
      },
      isValidating: {
        enumerable: !0,
        get: () => !!Gn(l.validatingFields, e)
      },
      error: {
        enumerable: !0,
        get: () => Gn(l.errors, e)
      }
    })
  };
}
const mu = (t) => t.render(Gbe(t));
var yu = function(t) {
  var r = t.as, e = t.errors, n = t.name, i = t.message, a = t.render, o = function(f, h) {
    if (f == null) return {};
    var p, v, g = {}, m = Object.keys(f);
    for (v = 0; v < m.length; v++) h.indexOf(p = m[v]) >= 0 || (g[p] = f[p]);
    return g;
  }(t, ["as", "errors", "name", "message", "render"]), s = e5(), l = Gn(e || s.formState.errors, n);
  if (!l) return null;
  var u = l.message, c = l.types, d = Object.assign({}, o, { children: u || i });
  return $.isValidElement(r) ? $.cloneElement(r, d) : a ? a({ message: u || i, messages: c }) : $.createElement(r || $.Fragment, d);
};
const Fxe = (t) => {
  const {
    name: r,
    defaultValue: e,
    className: n = "",
    containerClassName: i,
    formLabel: a,
    formSubLabel: o,
    inputHelpBlock: s,
    isRequired: l = !1,
    onInputChange: u,
    onResetDate: c,
    showTimeSelect: d = !1,
    showMonthYearPicker: f = !1,
    minDate: h,
    format: p = "dd MMMM yyyy",
    disabled: v = !1,
    rules: g,
    control: m,
    errors: y,
    placeholder: b = ""
  } = t, [C, w] = We(!1);
  return /* @__PURE__ */ S.jsxs(
    "div",
    {
      className: `theme-form-input-container ${i !== void 0 ? i : ""}`,
      children: [
        a && /* @__PURE__ */ S.jsxs("label", { className: "theme-form-input-label", htmlFor: `field-${r}`, children: [
          a,
          " ",
          l && /* @__PURE__ */ S.jsx("span", { children: "*" })
        ] }),
        o && /* @__PURE__ */ S.jsx("label", { className: "theme-form-sublabel", children: o }),
        /* @__PURE__ */ S.jsx(
          mu,
          {
            name: r,
            control: m,
            defaultValue: e,
            rules: g || {},
            render: ({ field: { onChange: _, value: x } }) => /* @__PURE__ */ S.jsx(
              K_,
              {
                selected: x,
                disabled: v,
                dateFormat: p,
                showTimeSelect: d,
                minDate: h,
                showIcon: !0,
                icon: !C && !x ? /* @__PURE__ */ S.jsx(Q_, {}) : /* @__PURE__ */ S.jsx(q_, { onClick: () => c && c() }),
                useWeekdaysShort: !0,
                showMonthYearPicker: f,
                placeholderText: b,
                wrapperClassName: "theme-custom-datepicker-wrapper",
                calendarClassName: "theme-custom-datepicker",
                className: `theme-form-control ${n}`,
                renderCustomHeader: (I) => /* @__PURE__ */ S.jsx(lz, { ...I }),
                onChange: (I) => {
                  _(I), u && u(I);
                },
                onCalendarOpen: () => w(!0),
                onCalendarClose: () => {
                  w(!1);
                },
                toggleCalendarOnIconClick: !0
              }
            )
          }
        ),
        /* @__PURE__ */ S.jsx(
          yu,
          {
            errors: y,
            name: r,
            render: ({ message: _ }) => /* @__PURE__ */ S.jsx("div", { className: "theme-form-text form-error", children: _ })
          }
        ),
        s && /* @__PURE__ */ S.jsx("span", { className: "theme-form-helpblock", children: s })
      ]
    }
  );
}, zL = /* @__PURE__ */ new Set();
function t5(t, r, e) {
  t || zL.has(r) || (console.warn(r), zL.add(r));
}
function Bbe(t) {
  if (typeof Proxy > "u")
    return t;
  const r = /* @__PURE__ */ new Map(), e = (...n) => (process.env.NODE_ENV !== "production" && t5(!1, "motion() is deprecated. Use motion.create() instead."), t(...n));
  return new Proxy(e, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (n, i) => i === "create" ? t : (r.has(i) || r.set(i, t(i)), r.get(i))
  });
}
function r5(t) {
  return t !== null && typeof t == "object" && typeof t.start == "function";
}
const I6 = (t) => Array.isArray(t);
function iW(t, r) {
  if (!Array.isArray(r))
    return !1;
  const e = r.length;
  if (e !== t.length)
    return !1;
  for (let n = 0; n < e; n++)
    if (r[n] !== t[n])
      return !1;
  return !0;
}
function $v(t) {
  return typeof t == "string" || Array.isArray(t);
}
function WL(t) {
  const r = [{}, {}];
  return t == null || t.values.forEach((e, n) => {
    r[0][n] = e.get(), r[1][n] = e.getVelocity();
  }), r;
}
function Sx(t, r, e, n) {
  if (typeof r == "function") {
    const [i, a] = WL(n);
    r = r(e !== void 0 ? e : t.custom, i, a);
  }
  if (typeof r == "string" && (r = t.variants && t.variants[r]), typeof r == "function") {
    const [i, a] = WL(n);
    r = r(e !== void 0 ? e : t.custom, i, a);
  }
  return r;
}
function n5(t, r, e) {
  const n = t.getProps();
  return Sx(n, r, e !== void 0 ? e : n.custom, t);
}
const Ix = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], Ax = ["initial", ...Ix], Fg = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], sd = new Set(Fg), Yo = (t) => t * 1e3, js = (t) => t / 1e3, Fbe = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, Hbe = (t) => ({
  type: "spring",
  stiffness: 550,
  damping: t === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), zbe = {
  type: "keyframes",
  duration: 0.8
}, Wbe = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, Zbe = (t, { keyframes: r }) => r.length > 2 ? zbe : sd.has(t) ? t.startsWith("scale") ? Hbe(r[1]) : Fbe : Wbe;
function Dx(t, r) {
  return t ? t[r] || t.default || t : void 0;
}
const jbe = {
  skipAnimations: !1,
  useManualTiming: !1
}, Ybe = (t) => t !== null;
function i5(t, { repeat: r, repeatType: e = "loop" }, n) {
  const i = t.filter(Ybe), a = r && e !== "loop" && r % 2 === 1 ? 0 : i.length - 1;
  return !a || n === void 0 ? i[a] : n;
}
const Wn = (t) => t;
let _h = Wn, lu = Wn;
process.env.NODE_ENV !== "production" && (_h = (t, r) => {
  !t && typeof console < "u" && console.warn(r);
}, lu = (t, r) => {
  if (!t)
    throw new Error(r);
});
function Xbe(t) {
  let r = /* @__PURE__ */ new Set(), e = /* @__PURE__ */ new Set(), n = !1, i = !1;
  const a = /* @__PURE__ */ new WeakSet();
  let o = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function s(u) {
    a.has(u) && (l.schedule(u), t()), u(o);
  }
  const l = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (u, c = !1, d = !1) => {
      const h = d && n ? r : e;
      return c && a.add(u), h.has(u) || h.add(u), u;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (u) => {
      e.delete(u), a.delete(u);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (u) => {
      if (o = u, n) {
        i = !0;
        return;
      }
      n = !0, [r, e] = [e, r], e.clear(), r.forEach(s), n = !1, i && (i = !1, l.process(u));
    }
  };
  return l;
}
const l0 = [
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
], $be = 40;
function aW(t, r) {
  let e = !1, n = !0;
  const i = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, a = () => e = !0, o = l0.reduce((m, y) => (m[y] = Xbe(a), m), {}), { read: s, resolveKeyframes: l, update: u, preRender: c, render: d, postRender: f } = o, h = () => {
    const m = performance.now();
    e = !1, i.delta = n ? 1e3 / 60 : Math.max(Math.min(m - i.timestamp, $be), 1), i.timestamp = m, i.isProcessing = !0, s.process(i), l.process(i), u.process(i), c.process(i), d.process(i), f.process(i), i.isProcessing = !1, e && r && (n = !1, t(h));
  }, p = () => {
    e = !0, n = !0, i.isProcessing || t(h);
  };
  return { schedule: l0.reduce((m, y) => {
    const b = o[y];
    return m[y] = (C, w = !1, _ = !1) => (e || p(), b.schedule(C, w, _)), m;
  }, {}), cancel: (m) => {
    for (let y = 0; y < l0.length; y++)
      o[l0[y]].cancel(m);
  }, state: i, steps: o };
}
const { schedule: br, cancel: uu, state: Fn, steps: d4 } = aW(typeof requestAnimationFrame < "u" ? requestAnimationFrame : Wn, !0), oW = (t, r, e) => (((1 - 3 * e + 3 * r) * t + (3 * e - 6 * r)) * t + 3 * r) * t, Ube = 1e-7, Jbe = 12;
function Kbe(t, r, e, n, i) {
  let a, o, s = 0;
  do
    o = r + (e - r) / 2, a = oW(o, n, i) - t, a > 0 ? e = o : r = o;
  while (Math.abs(a) > Ube && ++s < Jbe);
  return o;
}
function Hg(t, r, e, n) {
  if (t === r && e === n)
    return Wn;
  const i = (a) => Kbe(a, 0, 1, t, e);
  return (a) => a === 0 || a === 1 ? a : oW(i(a), r, n);
}
const sW = (t) => (r) => r <= 0.5 ? t(2 * r) / 2 : (2 - t(2 * (1 - r))) / 2, lW = (t) => (r) => 1 - t(1 - r), uW = /* @__PURE__ */ Hg(0.33, 1.53, 0.69, 0.99), Tx = /* @__PURE__ */ lW(uW), cW = /* @__PURE__ */ sW(Tx), dW = (t) => (t *= 2) < 1 ? 0.5 * Tx(t) : 0.5 * (2 - Math.pow(2, -10 * (t - 1))), Mx = (t) => 1 - Math.sin(Math.acos(t)), fW = lW(Mx), hW = sW(Mx), pW = (t) => /^0[^.\s]+$/u.test(t);
function qbe(t) {
  return typeof t == "number" ? t === 0 : t !== null ? t === "none" || t === "0" || pW(t) : !0;
}
const vW = (t) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(t), gW = (t) => (r) => typeof r == "string" && r.startsWith(t), mW = /* @__PURE__ */ gW("--"), Qbe = /* @__PURE__ */ gW("var(--"), Rx = (t) => Qbe(t) ? e3e.test(t.split("/*")[0].trim()) : !1, e3e = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu, t3e = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function r3e(t) {
  const r = t3e.exec(t);
  if (!r)
    return [,];
  const [, e, n, i] = r;
  return [`--${e ?? n}`, i];
}
const n3e = 4;
function yW(t, r, e = 1) {
  lu(e <= n3e, `Max CSS variable fallback depth detected in property "${t}". This may indicate a circular fallback dependency.`);
  const [n, i] = r3e(t);
  if (!n)
    return;
  const a = window.getComputedStyle(r).getPropertyValue(n);
  if (a) {
    const o = a.trim();
    return vW(o) ? parseFloat(o) : o;
  }
  return Rx(i) ? yW(i, r, e + 1) : i;
}
const nl = (t, r, e) => e > r ? r : e < t ? t : e, xh = {
  test: (t) => typeof t == "number",
  parse: parseFloat,
  transform: (t) => t
}, Uv = {
  ...xh,
  transform: (t) => nl(0, 1, t)
}, u0 = {
  ...xh,
  default: 1
}, zg = (t) => ({
  test: (r) => typeof r == "string" && r.endsWith(t) && r.split(" ").length === 1,
  parse: parseFloat,
  transform: (r) => `${r}${t}`
}), wl = /* @__PURE__ */ zg("deg"), Xo = /* @__PURE__ */ zg("%"), ot = /* @__PURE__ */ zg("px"), i3e = /* @__PURE__ */ zg("vh"), a3e = /* @__PURE__ */ zg("vw"), ZL = {
  ...Xo,
  parse: (t) => Xo.parse(t) / 100,
  transform: (t) => Xo.transform(t * 100)
}, o3e = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y",
  "translateX",
  "translateY"
]), jL = (t) => t === xh || t === ot, YL = (t, r) => parseFloat(t.split(", ")[r]), XL = (t, r) => (e, { transform: n }) => {
  if (n === "none" || !n)
    return 0;
  const i = n.match(/^matrix3d\((.+)\)$/u);
  if (i)
    return YL(i[1], r);
  {
    const a = n.match(/^matrix\((.+)\)$/u);
    return a ? YL(a[1], t) : 0;
  }
}, s3e = /* @__PURE__ */ new Set(["x", "y", "z"]), l3e = Fg.filter((t) => !s3e.has(t));
function u3e(t) {
  const r = [];
  return l3e.forEach((e) => {
    const n = t.getValue(e);
    n !== void 0 && (r.push([e, n.get()]), n.set(e.startsWith("scale") ? 1 : 0));
  }), r;
}
const Zf = {
  // Dimensions
  width: ({ x: t }, { paddingLeft: r = "0", paddingRight: e = "0" }) => t.max - t.min - parseFloat(r) - parseFloat(e),
  height: ({ y: t }, { paddingTop: r = "0", paddingBottom: e = "0" }) => t.max - t.min - parseFloat(r) - parseFloat(e),
  top: (t, { top: r }) => parseFloat(r),
  left: (t, { left: r }) => parseFloat(r),
  bottom: ({ y: t }, { top: r }) => parseFloat(r) + (t.max - t.min),
  right: ({ x: t }, { left: r }) => parseFloat(r) + (t.max - t.min),
  // Transform
  x: XL(4, 13),
  y: XL(5, 14)
};
Zf.translateX = Zf.x;
Zf.translateY = Zf.y;
const bW = (t) => (r) => r.test(t), c3e = {
  test: (t) => t === "auto",
  parse: (t) => t
}, CW = [xh, ot, Xo, wl, a3e, i3e, c3e], $L = (t) => CW.find(bW(t)), kc = /* @__PURE__ */ new Set();
let A6 = !1, D6 = !1;
function wW() {
  if (D6) {
    const t = Array.from(kc).filter((n) => n.needsMeasurement), r = new Set(t.map((n) => n.element)), e = /* @__PURE__ */ new Map();
    r.forEach((n) => {
      const i = u3e(n);
      i.length && (e.set(n, i), n.render());
    }), t.forEach((n) => n.measureInitialState()), r.forEach((n) => {
      n.render();
      const i = e.get(n);
      i && i.forEach(([a, o]) => {
        var s;
        (s = n.getValue(a)) === null || s === void 0 || s.set(o);
      });
    }), t.forEach((n) => n.measureEndState()), t.forEach((n) => {
      n.suspendedScrollY !== void 0 && window.scrollTo(0, n.suspendedScrollY);
    });
  }
  D6 = !1, A6 = !1, kc.forEach((t) => t.complete()), kc.clear();
}
function _W() {
  kc.forEach((t) => {
    t.readKeyframes(), t.needsMeasurement && (D6 = !0);
  });
}
function d3e() {
  _W(), wW();
}
class Lx {
  constructor(r, e, n, i, a, o = !1) {
    this.isComplete = !1, this.isAsync = !1, this.needsMeasurement = !1, this.isScheduled = !1, this.unresolvedKeyframes = [...r], this.onComplete = e, this.name = n, this.motionValue = i, this.element = a, this.isAsync = o;
  }
  scheduleResolve() {
    this.isScheduled = !0, this.isAsync ? (kc.add(this), A6 || (A6 = !0, br.read(_W), br.resolveKeyframes(wW))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: r, name: e, element: n, motionValue: i } = this;
    for (let a = 0; a < r.length; a++)
      if (r[a] === null)
        if (a === 0) {
          const o = i == null ? void 0 : i.get(), s = r[r.length - 1];
          if (o !== void 0)
            r[0] = o;
          else if (n && e) {
            const l = n.readValue(e, s);
            l != null && (r[0] = l);
          }
          r[0] === void 0 && (r[0] = s), i && o === void 0 && i.set(r[0]);
        } else
          r[a] = r[a - 1];
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete() {
    this.isComplete = !0, this.onComplete(this.unresolvedKeyframes, this.finalKeyframe), kc.delete(this);
  }
  cancel() {
    this.isComplete || (this.isScheduled = !1, kc.delete(this));
  }
  resume() {
    this.isComplete || this.scheduleResolve();
  }
}
const sv = (t) => Math.round(t * 1e5) / 1e5, Ex = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function f3e(t) {
  return t == null;
}
const h3e = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, kx = (t, r) => (e) => !!(typeof e == "string" && h3e.test(e) && e.startsWith(t) || r && !f3e(e) && Object.prototype.hasOwnProperty.call(e, r)), xW = (t, r, e) => (n) => {
  if (typeof n != "string")
    return n;
  const [i, a, o, s] = n.match(Ex);
  return {
    [t]: parseFloat(i),
    [r]: parseFloat(a),
    [e]: parseFloat(o),
    alpha: s !== void 0 ? parseFloat(s) : 1
  };
}, p3e = (t) => nl(0, 255, t), f4 = {
  ...xh,
  transform: (t) => Math.round(p3e(t))
}, bc = {
  test: /* @__PURE__ */ kx("rgb", "red"),
  parse: /* @__PURE__ */ xW("red", "green", "blue"),
  transform: ({ red: t, green: r, blue: e, alpha: n = 1 }) => "rgba(" + f4.transform(t) + ", " + f4.transform(r) + ", " + f4.transform(e) + ", " + sv(Uv.transform(n)) + ")"
};
function v3e(t) {
  let r = "", e = "", n = "", i = "";
  return t.length > 5 ? (r = t.substring(1, 3), e = t.substring(3, 5), n = t.substring(5, 7), i = t.substring(7, 9)) : (r = t.substring(1, 2), e = t.substring(2, 3), n = t.substring(3, 4), i = t.substring(4, 5), r += r, e += e, n += n, i += i), {
    red: parseInt(r, 16),
    green: parseInt(e, 16),
    blue: parseInt(n, 16),
    alpha: i ? parseInt(i, 16) / 255 : 1
  };
}
const T6 = {
  test: /* @__PURE__ */ kx("#"),
  parse: v3e,
  transform: bc.transform
}, tf = {
  test: /* @__PURE__ */ kx("hsl", "hue"),
  parse: /* @__PURE__ */ xW("hue", "saturation", "lightness"),
  transform: ({ hue: t, saturation: r, lightness: e, alpha: n = 1 }) => "hsla(" + Math.round(t) + ", " + Xo.transform(sv(r)) + ", " + Xo.transform(sv(e)) + ", " + sv(Uv.transform(n)) + ")"
}, ei = {
  test: (t) => bc.test(t) || T6.test(t) || tf.test(t),
  parse: (t) => bc.test(t) ? bc.parse(t) : tf.test(t) ? tf.parse(t) : T6.parse(t),
  transform: (t) => typeof t == "string" ? t : t.hasOwnProperty("red") ? bc.transform(t) : tf.transform(t)
}, g3e = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function m3e(t) {
  var r, e;
  return isNaN(t) && typeof t == "string" && (((r = t.match(Ex)) === null || r === void 0 ? void 0 : r.length) || 0) + (((e = t.match(g3e)) === null || e === void 0 ? void 0 : e.length) || 0) > 0;
}
const SW = "number", IW = "color", y3e = "var", b3e = "var(", UL = "${}", C3e = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function Jv(t) {
  const r = t.toString(), e = [], n = {
    color: [],
    number: [],
    var: []
  }, i = [];
  let a = 0;
  const s = r.replace(C3e, (l) => (ei.test(l) ? (n.color.push(a), i.push(IW), e.push(ei.parse(l))) : l.startsWith(b3e) ? (n.var.push(a), i.push(y3e), e.push(l)) : (n.number.push(a), i.push(SW), e.push(parseFloat(l))), ++a, UL)).split(UL);
  return { values: e, split: s, indexes: n, types: i };
}
function AW(t) {
  return Jv(t).values;
}
function DW(t) {
  const { split: r, types: e } = Jv(t), n = r.length;
  return (i) => {
    let a = "";
    for (let o = 0; o < n; o++)
      if (a += r[o], i[o] !== void 0) {
        const s = e[o];
        s === SW ? a += sv(i[o]) : s === IW ? a += ei.transform(i[o]) : a += i[o];
      }
    return a;
  };
}
const w3e = (t) => typeof t == "number" ? 0 : t;
function _3e(t) {
  const r = AW(t);
  return DW(t)(r.map(w3e));
}
const cu = {
  test: m3e,
  parse: AW,
  createTransformer: DW,
  getAnimatableNone: _3e
}, x3e = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function S3e(t) {
  const [r, e] = t.slice(0, -1).split("(");
  if (r === "drop-shadow")
    return t;
  const [n] = e.match(Ex) || [];
  if (!n)
    return t;
  const i = e.replace(n, "");
  let a = x3e.has(r) ? 1 : 0;
  return n !== e && (a *= 100), r + "(" + a + i + ")";
}
const I3e = /\b([a-z-]*)\(.*?\)/gu, M6 = {
  ...cu,
  getAnimatableNone: (t) => {
    const r = t.match(I3e);
    return r ? r.map(S3e).join(" ") : t;
  }
}, A3e = {
  // Border props
  borderWidth: ot,
  borderTopWidth: ot,
  borderRightWidth: ot,
  borderBottomWidth: ot,
  borderLeftWidth: ot,
  borderRadius: ot,
  radius: ot,
  borderTopLeftRadius: ot,
  borderTopRightRadius: ot,
  borderBottomRightRadius: ot,
  borderBottomLeftRadius: ot,
  // Positioning props
  width: ot,
  maxWidth: ot,
  height: ot,
  maxHeight: ot,
  top: ot,
  right: ot,
  bottom: ot,
  left: ot,
  // Spacing props
  padding: ot,
  paddingTop: ot,
  paddingRight: ot,
  paddingBottom: ot,
  paddingLeft: ot,
  margin: ot,
  marginTop: ot,
  marginRight: ot,
  marginBottom: ot,
  marginLeft: ot,
  // Misc
  backgroundPositionX: ot,
  backgroundPositionY: ot
}, D3e = {
  rotate: wl,
  rotateX: wl,
  rotateY: wl,
  rotateZ: wl,
  scale: u0,
  scaleX: u0,
  scaleY: u0,
  scaleZ: u0,
  skew: wl,
  skewX: wl,
  skewY: wl,
  distance: ot,
  translateX: ot,
  translateY: ot,
  translateZ: ot,
  x: ot,
  y: ot,
  z: ot,
  perspective: ot,
  transformPerspective: ot,
  opacity: Uv,
  originX: ZL,
  originY: ZL,
  originZ: ot
}, JL = {
  ...xh,
  transform: Math.round
}, Px = {
  ...A3e,
  ...D3e,
  zIndex: JL,
  size: ot,
  // SVG
  fillOpacity: Uv,
  strokeOpacity: Uv,
  numOctaves: JL
}, T3e = {
  ...Px,
  // Color props
  color: ei,
  backgroundColor: ei,
  outlineColor: ei,
  fill: ei,
  stroke: ei,
  // Border props
  borderColor: ei,
  borderTopColor: ei,
  borderRightColor: ei,
  borderBottomColor: ei,
  borderLeftColor: ei,
  filter: M6,
  WebkitFilter: M6
}, Nx = (t) => T3e[t];
function TW(t, r) {
  let e = Nx(t);
  return e !== M6 && (e = cu), e.getAnimatableNone ? e.getAnimatableNone(r) : void 0;
}
const M3e = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function R3e(t, r, e) {
  let n = 0, i;
  for (; n < t.length && !i; ) {
    const a = t[n];
    typeof a == "string" && !M3e.has(a) && Jv(a).values.length && (i = t[n]), n++;
  }
  if (i && e)
    for (const a of r)
      t[a] = TW(e, i);
}
class MW extends Lx {
  constructor(r, e, n, i, a) {
    super(r, e, n, i, a, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: r, element: e, name: n } = this;
    if (!e || !e.current)
      return;
    super.readKeyframes();
    for (let l = 0; l < r.length; l++) {
      let u = r[l];
      if (typeof u == "string" && (u = u.trim(), Rx(u))) {
        const c = yW(u, e.current);
        c !== void 0 && (r[l] = c), l === r.length - 1 && (this.finalKeyframe = u);
      }
    }
    if (this.resolveNoneKeyframes(), !o3e.has(n) || r.length !== 2)
      return;
    const [i, a] = r, o = $L(i), s = $L(a);
    if (o !== s)
      if (jL(o) && jL(s))
        for (let l = 0; l < r.length; l++) {
          const u = r[l];
          typeof u == "string" && (r[l] = parseFloat(u));
        }
      else
        this.needsMeasurement = !0;
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: r, name: e } = this, n = [];
    for (let i = 0; i < r.length; i++)
      qbe(r[i]) && n.push(i);
    n.length && R3e(r, n, e);
  }
  measureInitialState() {
    const { element: r, unresolvedKeyframes: e, name: n } = this;
    if (!r || !r.current)
      return;
    n === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = Zf[n](r.measureViewportBox(), window.getComputedStyle(r.current)), e[0] = this.measuredOrigin;
    const i = e[e.length - 1];
    i !== void 0 && r.getValue(n, i).jump(i, !1);
  }
  measureEndState() {
    var r;
    const { element: e, name: n, unresolvedKeyframes: i } = this;
    if (!e || !e.current)
      return;
    const a = e.getValue(n);
    a && a.jump(this.measuredOrigin, !1);
    const o = i.length - 1, s = i[o];
    i[o] = Zf[n](e.measureViewportBox(), window.getComputedStyle(e.current)), s !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = s), !((r = this.removedTransforms) === null || r === void 0) && r.length && this.removedTransforms.forEach(([l, u]) => {
      e.getValue(l).set(u);
    }), this.resolveNoneKeyframes();
  }
}
function Ox(t) {
  return typeof t == "function";
}
let J0;
function L3e() {
  J0 = void 0;
}
const $o = {
  now: () => (J0 === void 0 && $o.set(Fn.isProcessing || jbe.useManualTiming ? Fn.timestamp : performance.now()), J0),
  set: (t) => {
    J0 = t, queueMicrotask(L3e);
  }
}, KL = (t, r) => r === "zIndex" ? !1 : !!(typeof t == "number" || Array.isArray(t) || typeof t == "string" && // It's animatable if we have a string
(cu.test(t) || t === "0") && // And it contains numbers and/or colors
!t.startsWith("url("));
function E3e(t) {
  const r = t[0];
  if (t.length === 1)
    return !0;
  for (let e = 0; e < t.length; e++)
    if (t[e] !== r)
      return !0;
}
function k3e(t, r, e, n) {
  const i = t[0];
  if (i === null)
    return !1;
  if (r === "display" || r === "visibility")
    return !0;
  const a = t[t.length - 1], o = KL(i, r), s = KL(a, r);
  return _h(o === s, `You are trying to animate ${r} from "${i}" to "${a}". ${i} is not an animatable value - to enable this animation set ${i} to a value animatable to ${a} via the \`style\` property.`), !o || !s ? !1 : E3e(t) || (e === "spring" || Ox(e)) && n;
}
const P3e = 40;
class RW {
  constructor({ autoplay: r = !0, delay: e = 0, type: n = "keyframes", repeat: i = 0, repeatDelay: a = 0, repeatType: o = "loop", ...s }) {
    this.isStopped = !1, this.hasAttemptedResolve = !1, this.createdAt = $o.now(), this.options = {
      autoplay: r,
      delay: e,
      type: n,
      repeat: i,
      repeatDelay: a,
      repeatType: o,
      ...s
    }, this.updateFinishedPromise();
  }
  /**
   * This method uses the createdAt and resolvedAt to calculate the
   * animation startTime. *Ideally*, we would use the createdAt time as t=0
   * as the following frame would then be the first frame of the animation in
   * progress, which would feel snappier.
   *
   * However, if there's a delay (main thread work) between the creation of
   * the animation and the first commited frame, we prefer to use resolvedAt
   * to avoid a sudden jump into the animation.
   */
  calcStartTime() {
    return this.resolvedAt ? this.resolvedAt - this.createdAt > P3e ? this.resolvedAt : this.createdAt : this.createdAt;
  }
  /**
   * A getter for resolved data. If keyframes are not yet resolved, accessing
   * this.resolved will synchronously flush all pending keyframe resolvers.
   * This is a deoptimisation, but at its worst still batches read/writes.
   */
  get resolved() {
    return !this._resolved && !this.hasAttemptedResolve && d3e(), this._resolved;
  }
  /**
   * A method to be called when the keyframes resolver completes. This method
   * will check if its possible to run the animation and, if not, skip it.
   * Otherwise, it will call initPlayback on the implementing class.
   */
  onKeyframesResolved(r, e) {
    this.resolvedAt = $o.now(), this.hasAttemptedResolve = !0;
    const { name: n, type: i, velocity: a, delay: o, onComplete: s, onUpdate: l, isGenerator: u } = this.options;
    if (!u && !k3e(r, n, i, a))
      if (o)
        this.options.duration = 0;
      else {
        l == null || l(i5(r, this.options, e)), s == null || s(), this.resolveFinishedPromise();
        return;
      }
    const c = this.initPlayback(r, e);
    c !== !1 && (this._resolved = {
      keyframes: r,
      finalKeyframe: e,
      ...c
    }, this.onPostResolved());
  }
  onPostResolved() {
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(r, e) {
    return this.currentFinishedPromise.then(r, e);
  }
  flatten() {
    this.options.type = "keyframes", this.options.ease = "linear";
  }
  updateFinishedPromise() {
    this.currentFinishedPromise = new Promise((r) => {
      this.resolveFinishedPromise = r;
    });
  }
}
const jf = (t, r, e) => {
  const n = r - t;
  return n === 0 ? 1 : (e - t) / n;
}, LW = (t, r, e = 10) => {
  let n = "";
  const i = Math.max(Math.round(r / e), 2);
  for (let a = 0; a < i; a++)
    n += t(jf(0, i - 1, a)) + ", ";
  return `linear(${n.substring(0, n.length - 2)})`;
};
function EW(t, r) {
  return r ? t * (1e3 / r) : 0;
}
const N3e = 5;
function kW(t, r, e) {
  const n = Math.max(r - N3e, 0);
  return EW(e - t(n), r - n);
}
const zr = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 5e-3,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
}, h4 = 1e-3;
function O3e({ duration: t = zr.duration, bounce: r = zr.bounce, velocity: e = zr.velocity, mass: n = zr.mass }) {
  let i, a;
  _h(t <= Yo(zr.maxDuration), "Spring duration must be 10 seconds or less");
  let o = 1 - r;
  o = nl(zr.minDamping, zr.maxDamping, o), t = nl(zr.minDuration, zr.maxDuration, js(t)), o < 1 ? (i = (u) => {
    const c = u * o, d = c * t, f = c - e, h = R6(u, o), p = Math.exp(-d);
    return h4 - f / h * p;
  }, a = (u) => {
    const d = u * o * t, f = d * e + e, h = Math.pow(o, 2) * Math.pow(u, 2) * t, p = Math.exp(-d), v = R6(Math.pow(u, 2), o);
    return (-i(u) + h4 > 0 ? -1 : 1) * ((f - h) * p) / v;
  }) : (i = (u) => {
    const c = Math.exp(-u * t), d = (u - e) * t + 1;
    return -h4 + c * d;
  }, a = (u) => {
    const c = Math.exp(-u * t), d = (e - u) * (t * t);
    return c * d;
  });
  const s = 5 / t, l = G3e(i, a, s);
  if (t = Yo(t), isNaN(l))
    return {
      stiffness: zr.stiffness,
      damping: zr.damping,
      duration: t
    };
  {
    const u = Math.pow(l, 2) * n;
    return {
      stiffness: u,
      damping: o * 2 * Math.sqrt(n * u),
      duration: t
    };
  }
}
const V3e = 12;
function G3e(t, r, e) {
  let n = e;
  for (let i = 1; i < V3e; i++)
    n = n - t(n) / r(n);
  return n;
}
function R6(t, r) {
  return t * Math.sqrt(1 - r * r);
}
const L6 = 2e4;
function PW(t) {
  let r = 0;
  const e = 50;
  let n = t.next(r);
  for (; !n.done && r < L6; )
    r += e, n = t.next(r);
  return r >= L6 ? 1 / 0 : r;
}
const B3e = ["duration", "bounce"], F3e = ["stiffness", "damping", "mass"];
function qL(t, r) {
  return r.some((e) => t[e] !== void 0);
}
function H3e(t) {
  let r = {
    velocity: zr.velocity,
    stiffness: zr.stiffness,
    damping: zr.damping,
    mass: zr.mass,
    isResolvedFromDuration: !1,
    ...t
  };
  if (!qL(t, F3e) && qL(t, B3e))
    if (t.visualDuration) {
      const e = t.visualDuration, n = 2 * Math.PI / (e * 1.2), i = n * n, a = 2 * nl(0.05, 1, 1 - t.bounce) * Math.sqrt(i);
      r = {
        ...r,
        mass: zr.mass,
        stiffness: i,
        damping: a
      };
    } else {
      const e = O3e(t);
      r = {
        ...r,
        ...e,
        mass: zr.mass
      }, r.isResolvedFromDuration = !0;
    }
  return r;
}
function NW(t = zr.visualDuration, r = zr.bounce) {
  const e = typeof t != "object" ? {
    visualDuration: t,
    keyframes: [0, 1],
    bounce: r
  } : t;
  let { restSpeed: n, restDelta: i } = e;
  const a = e.keyframes[0], o = e.keyframes[e.keyframes.length - 1], s = { done: !1, value: a }, { stiffness: l, damping: u, mass: c, duration: d, velocity: f, isResolvedFromDuration: h } = H3e({
    ...e,
    velocity: -js(e.velocity || 0)
  }), p = f || 0, v = u / (2 * Math.sqrt(l * c)), g = o - a, m = js(Math.sqrt(l / c)), y = Math.abs(g) < 5;
  n || (n = y ? zr.restSpeed.granular : zr.restSpeed.default), i || (i = y ? zr.restDelta.granular : zr.restDelta.default);
  let b;
  if (v < 1) {
    const w = R6(m, v);
    b = (_) => {
      const x = Math.exp(-v * m * _);
      return o - x * ((p + v * m * g) / w * Math.sin(w * _) + g * Math.cos(w * _));
    };
  } else if (v === 1)
    b = (w) => o - Math.exp(-m * w) * (g + (p + m * g) * w);
  else {
    const w = m * Math.sqrt(v * v - 1);
    b = (_) => {
      const x = Math.exp(-v * m * _), I = Math.min(w * _, 300);
      return o - x * ((p + v * m * g) * Math.sinh(I) + w * g * Math.cosh(I)) / w;
    };
  }
  const C = {
    calculatedDuration: h && d || null,
    next: (w) => {
      const _ = b(w);
      if (h)
        s.done = w >= d;
      else {
        let x = 0;
        v < 1 && (x = w === 0 ? Yo(p) : kW(b, w, _));
        const I = Math.abs(x) <= n, D = Math.abs(o - _) <= i;
        s.done = I && D;
      }
      return s.value = s.done ? o : _, s;
    },
    toString: () => {
      const w = Math.min(PW(C), L6), _ = LW((x) => C.next(w * x).value, w, 30);
      return w + "ms " + _;
    }
  };
  return C;
}
function QL({ keyframes: t, velocity: r = 0, power: e = 0.8, timeConstant: n = 325, bounceDamping: i = 10, bounceStiffness: a = 500, modifyTarget: o, min: s, max: l, restDelta: u = 0.5, restSpeed: c }) {
  const d = t[0], f = {
    done: !1,
    value: d
  }, h = (I) => s !== void 0 && I < s || l !== void 0 && I > l, p = (I) => s === void 0 ? l : l === void 0 || Math.abs(s - I) < Math.abs(l - I) ? s : l;
  let v = e * r;
  const g = d + v, m = o === void 0 ? g : o(g);
  m !== g && (v = m - d);
  const y = (I) => -v * Math.exp(-I / n), b = (I) => m + y(I), C = (I) => {
    const D = y(I), T = b(I);
    f.done = Math.abs(D) <= u, f.value = f.done ? m : T;
  };
  let w, _;
  const x = (I) => {
    h(f.value) && (w = I, _ = NW({
      keyframes: [f.value, p(f.value)],
      velocity: kW(b, I, f.value),
      // TODO: This should be passing * 1000
      damping: i,
      stiffness: a,
      restDelta: u,
      restSpeed: c
    }));
  };
  return x(0), {
    calculatedDuration: null,
    next: (I) => {
      let D = !1;
      return !_ && w === void 0 && (D = !0, C(I), x(I)), w !== void 0 && I >= w ? _.next(I - w) : (!D && C(I), f);
    }
  };
}
const z3e = /* @__PURE__ */ Hg(0.42, 0, 1, 1), W3e = /* @__PURE__ */ Hg(0, 0, 0.58, 1), OW = /* @__PURE__ */ Hg(0.42, 0, 0.58, 1), Z3e = (t) => Array.isArray(t) && typeof t[0] != "number", Vx = (t) => Array.isArray(t) && typeof t[0] == "number", eE = {
  linear: Wn,
  easeIn: z3e,
  easeInOut: OW,
  easeOut: W3e,
  circIn: Mx,
  circInOut: hW,
  circOut: fW,
  backIn: Tx,
  backInOut: cW,
  backOut: uW,
  anticipate: dW
}, tE = (t) => {
  if (Vx(t)) {
    lu(t.length === 4, "Cubic bezier arrays must contain four numerical values.");
    const [r, e, n, i] = t;
    return Hg(r, e, n, i);
  } else if (typeof t == "string")
    return lu(eE[t] !== void 0, `Invalid easing type '${t}'`), eE[t];
  return t;
}, j3e = (t, r) => (e) => r(t(e)), Yl = (...t) => t.reduce(j3e), Zr = (t, r, e) => t + (r - t) * e;
function p4(t, r, e) {
  return e < 0 && (e += 1), e > 1 && (e -= 1), e < 1 / 6 ? t + (r - t) * 6 * e : e < 1 / 2 ? r : e < 2 / 3 ? t + (r - t) * (2 / 3 - e) * 6 : t;
}
function Y3e({ hue: t, saturation: r, lightness: e, alpha: n }) {
  t /= 360, r /= 100, e /= 100;
  let i = 0, a = 0, o = 0;
  if (!r)
    i = a = o = e;
  else {
    const s = e < 0.5 ? e * (1 + r) : e + r - e * r, l = 2 * e - s;
    i = p4(l, s, t + 1 / 3), a = p4(l, s, t), o = p4(l, s, t - 1 / 3);
  }
  return {
    red: Math.round(i * 255),
    green: Math.round(a * 255),
    blue: Math.round(o * 255),
    alpha: n
  };
}
function Ty(t, r) {
  return (e) => e > 0 ? r : t;
}
const v4 = (t, r, e) => {
  const n = t * t, i = e * (r * r - n) + n;
  return i < 0 ? 0 : Math.sqrt(i);
}, X3e = [T6, bc, tf], $3e = (t) => X3e.find((r) => r.test(t));
function rE(t) {
  const r = $3e(t);
  if (_h(!!r, `'${t}' is not an animatable color. Use the equivalent color code instead.`), !r)
    return !1;
  let e = r.parse(t);
  return r === tf && (e = Y3e(e)), e;
}
const nE = (t, r) => {
  const e = rE(t), n = rE(r);
  if (!e || !n)
    return Ty(t, r);
  const i = { ...e };
  return (a) => (i.red = v4(e.red, n.red, a), i.green = v4(e.green, n.green, a), i.blue = v4(e.blue, n.blue, a), i.alpha = Zr(e.alpha, n.alpha, a), bc.transform(i));
}, E6 = /* @__PURE__ */ new Set(["none", "hidden"]);
function U3e(t, r) {
  return E6.has(t) ? (e) => e <= 0 ? t : r : (e) => e >= 1 ? r : t;
}
function J3e(t, r) {
  return (e) => Zr(t, r, e);
}
function Gx(t) {
  return typeof t == "number" ? J3e : typeof t == "string" ? Rx(t) ? Ty : ei.test(t) ? nE : Q3e : Array.isArray(t) ? VW : typeof t == "object" ? ei.test(t) ? nE : K3e : Ty;
}
function VW(t, r) {
  const e = [...t], n = e.length, i = t.map((a, o) => Gx(a)(a, r[o]));
  return (a) => {
    for (let o = 0; o < n; o++)
      e[o] = i[o](a);
    return e;
  };
}
function K3e(t, r) {
  const e = { ...t, ...r }, n = {};
  for (const i in e)
    t[i] !== void 0 && r[i] !== void 0 && (n[i] = Gx(t[i])(t[i], r[i]));
  return (i) => {
    for (const a in n)
      e[a] = n[a](i);
    return e;
  };
}
function q3e(t, r) {
  var e;
  const n = [], i = { color: 0, var: 0, number: 0 };
  for (let a = 0; a < r.values.length; a++) {
    const o = r.types[a], s = t.indexes[o][i[o]], l = (e = t.values[s]) !== null && e !== void 0 ? e : 0;
    n[a] = l, i[o]++;
  }
  return n;
}
const Q3e = (t, r) => {
  const e = cu.createTransformer(r), n = Jv(t), i = Jv(r);
  return n.indexes.var.length === i.indexes.var.length && n.indexes.color.length === i.indexes.color.length && n.indexes.number.length >= i.indexes.number.length ? E6.has(t) && !i.values.length || E6.has(r) && !n.values.length ? U3e(t, r) : Yl(VW(q3e(n, i), i.values), e) : (_h(!0, `Complex values '${t}' and '${r}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), Ty(t, r));
};
function GW(t, r, e) {
  return typeof t == "number" && typeof r == "number" && typeof e == "number" ? Zr(t, r, e) : Gx(t)(t, r);
}
function e4e(t, r, e) {
  const n = [], i = e || GW, a = t.length - 1;
  for (let o = 0; o < a; o++) {
    let s = i(t[o], t[o + 1]);
    if (r) {
      const l = Array.isArray(r) ? r[o] || Wn : r;
      s = Yl(l, s);
    }
    n.push(s);
  }
  return n;
}
function t4e(t, r, { clamp: e = !0, ease: n, mixer: i } = {}) {
  const a = t.length;
  if (lu(a === r.length, "Both input and output ranges must be the same length"), a === 1)
    return () => r[0];
  if (a === 2 && t[0] === t[1])
    return () => r[1];
  t[0] > t[a - 1] && (t = [...t].reverse(), r = [...r].reverse());
  const o = e4e(r, n, i), s = o.length, l = (u) => {
    let c = 0;
    if (s > 1)
      for (; c < t.length - 2 && !(u < t[c + 1]); c++)
        ;
    const d = jf(t[c], t[c + 1], u);
    return o[c](d);
  };
  return e ? (u) => l(nl(t[0], t[a - 1], u)) : l;
}
function r4e(t, r) {
  const e = t[t.length - 1];
  for (let n = 1; n <= r; n++) {
    const i = jf(0, r, n);
    t.push(Zr(e, 1, i));
  }
}
function n4e(t) {
  const r = [0];
  return r4e(r, t.length - 1), r;
}
function i4e(t, r) {
  return t.map((e) => e * r);
}
function a4e(t, r) {
  return t.map(() => r || OW).splice(0, t.length - 1);
}
function My({ duration: t = 300, keyframes: r, times: e, ease: n = "easeInOut" }) {
  const i = Z3e(n) ? n.map(tE) : tE(n), a = {
    done: !1,
    value: r[0]
  }, o = i4e(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    e && e.length === r.length ? e : n4e(r),
    t
  ), s = t4e(o, r, {
    ease: Array.isArray(i) ? i : a4e(r, i)
  });
  return {
    calculatedDuration: t,
    next: (l) => (a.value = s(l), a.done = l >= t, a)
  };
}
const o4e = (t) => {
  const r = ({ timestamp: e }) => t(e);
  return {
    start: () => br.update(r, !0),
    stop: () => uu(r),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => Fn.isProcessing ? Fn.timestamp : $o.now()
  };
}, s4e = {
  decay: QL,
  inertia: QL,
  tween: My,
  keyframes: My,
  spring: NW
}, l4e = (t) => t / 100;
class Bx extends RW {
  constructor(r) {
    super(r), this.holdTime = null, this.cancelTime = null, this.currentTime = 0, this.playbackSpeed = 1, this.pendingPlayState = "running", this.startTime = null, this.state = "idle", this.stop = () => {
      if (this.resolver.cancel(), this.isStopped = !0, this.state === "idle")
        return;
      this.teardown();
      const { onStop: l } = this.options;
      l && l();
    };
    const { name: e, motionValue: n, element: i, keyframes: a } = this.options, o = (i == null ? void 0 : i.KeyframeResolver) || Lx, s = (l, u) => this.onKeyframesResolved(l, u);
    this.resolver = new o(a, s, e, n, i), this.resolver.scheduleResolve();
  }
  flatten() {
    super.flatten(), this._resolved && Object.assign(this._resolved, this.initPlayback(this._resolved.keyframes));
  }
  initPlayback(r) {
    const { type: e = "keyframes", repeat: n = 0, repeatDelay: i = 0, repeatType: a, velocity: o = 0 } = this.options, s = Ox(e) ? e : s4e[e] || My;
    let l, u;
    s !== My && typeof r[0] != "number" && (process.env.NODE_ENV !== "production" && lu(r.length === 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${r}`), l = Yl(l4e, GW(r[0], r[1])), r = [0, 100]);
    const c = s({ ...this.options, keyframes: r });
    a === "mirror" && (u = s({
      ...this.options,
      keyframes: [...r].reverse(),
      velocity: -o
    })), c.calculatedDuration === null && (c.calculatedDuration = PW(c));
    const { calculatedDuration: d } = c, f = d + i, h = f * (n + 1) - i;
    return {
      generator: c,
      mirroredGenerator: u,
      mapPercentToKeyframes: l,
      calculatedDuration: d,
      resolvedDuration: f,
      totalDuration: h
    };
  }
  onPostResolved() {
    const { autoplay: r = !0 } = this.options;
    this.play(), this.pendingPlayState === "paused" || !r ? this.pause() : this.state = this.pendingPlayState;
  }
  tick(r, e = !1) {
    const { resolved: n } = this;
    if (!n) {
      const { keyframes: I } = this.options;
      return { done: !0, value: I[I.length - 1] };
    }
    const { finalKeyframe: i, generator: a, mirroredGenerator: o, mapPercentToKeyframes: s, keyframes: l, calculatedDuration: u, totalDuration: c, resolvedDuration: d } = n;
    if (this.startTime === null)
      return a.next(0);
    const { delay: f, repeat: h, repeatType: p, repeatDelay: v, onUpdate: g } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, r) : this.speed < 0 && (this.startTime = Math.min(r - c / this.speed, this.startTime)), e ? this.currentTime = r : this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = Math.round(r - this.startTime) * this.speed;
    const m = this.currentTime - f * (this.speed >= 0 ? 1 : -1), y = this.speed >= 0 ? m < 0 : m > c;
    this.currentTime = Math.max(m, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = c);
    let b = this.currentTime, C = a;
    if (h) {
      const I = Math.min(this.currentTime, c) / d;
      let D = Math.floor(I), T = I % 1;
      !T && I >= 1 && (T = 1), T === 1 && D--, D = Math.min(D, h + 1), !!(D % 2) && (p === "reverse" ? (T = 1 - T, v && (T -= v / d)) : p === "mirror" && (C = o)), b = nl(0, 1, T) * d;
    }
    const w = y ? { done: !1, value: l[0] } : C.next(b);
    s && (w.value = s(w.value));
    let { done: _ } = w;
    !y && u !== null && (_ = this.speed >= 0 ? this.currentTime >= c : this.currentTime <= 0);
    const x = this.holdTime === null && (this.state === "finished" || this.state === "running" && _);
    return x && i !== void 0 && (w.value = i5(l, this.options, i)), g && g(w.value), x && this.finish(), w;
  }
  get duration() {
    const { resolved: r } = this;
    return r ? js(r.calculatedDuration) : 0;
  }
  get time() {
    return js(this.currentTime);
  }
  set time(r) {
    r = Yo(r), this.currentTime = r, this.holdTime !== null || this.speed === 0 ? this.holdTime = r : this.driver && (this.startTime = this.driver.now() - r / this.speed);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(r) {
    const e = this.playbackSpeed !== r;
    this.playbackSpeed = r, e && (this.time = js(this.currentTime));
  }
  play() {
    if (this.resolver.isScheduled || this.resolver.resume(), !this._resolved) {
      this.pendingPlayState = "running";
      return;
    }
    if (this.isStopped)
      return;
    const { driver: r = o4e, onPlay: e, startTime: n } = this.options;
    this.driver || (this.driver = r((a) => this.tick(a))), e && e();
    const i = this.driver.now();
    this.holdTime !== null ? this.startTime = i - this.holdTime : this.startTime ? this.state === "finished" && (this.startTime = i) : this.startTime = n ?? this.calcStartTime(), this.state === "finished" && this.updateFinishedPromise(), this.cancelTime = this.startTime, this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    var r;
    if (!this._resolved) {
      this.pendingPlayState = "paused";
      return;
    }
    this.state = "paused", this.holdTime = (r = this.currentTime) !== null && r !== void 0 ? r : 0;
  }
  complete() {
    this.state !== "running" && this.play(), this.pendingPlayState = this.state = "finished", this.holdTime = null;
  }
  finish() {
    this.teardown(), this.state = "finished";
    const { onComplete: r } = this.options;
    r && r();
  }
  cancel() {
    this.cancelTime !== null && this.tick(this.cancelTime), this.teardown(), this.updateFinishedPromise();
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.resolveFinishedPromise(), this.updateFinishedPromise(), this.startTime = this.cancelTime = null, this.resolver.cancel();
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(r) {
    return this.startTime = 0, this.tick(r, !0);
  }
}
const u4e = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Can be accelerated but currently disabled until https://issues.chromium.org/issues/41491098 is resolved
  // or until we implement support for linear() easing.
  // "background-color"
]);
function Fx(t) {
  let r;
  return () => (r === void 0 && (r = t()), r);
}
const c4e = {
  linearEasing: void 0
};
function d4e(t, r) {
  const e = Fx(t);
  return () => {
    var n;
    return (n = c4e[r]) !== null && n !== void 0 ? n : e();
  };
}
const Ry = /* @__PURE__ */ d4e(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing");
function BW(t) {
  return !!(typeof t == "function" && Ry() || !t || typeof t == "string" && (t in k6 || Ry()) || Vx(t) || Array.isArray(t) && t.every(BW));
}
const Fp = ([t, r, e, n]) => `cubic-bezier(${t}, ${r}, ${e}, ${n})`, k6 = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ Fp([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ Fp([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ Fp([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ Fp([0.33, 1.53, 0.69, 0.99])
};
function FW(t, r) {
  if (t)
    return typeof t == "function" && Ry() ? LW(t, r) : Vx(t) ? Fp(t) : Array.isArray(t) ? t.map((e) => FW(e, r) || k6.easeOut) : k6[t];
}
function f4e(t, r, e, { delay: n = 0, duration: i = 300, repeat: a = 0, repeatType: o = "loop", ease: s = "easeInOut", times: l } = {}) {
  const u = { [r]: e };
  l && (u.offset = l);
  const c = FW(s, i);
  return Array.isArray(c) && (u.easing = c), t.animate(u, {
    delay: n,
    duration: i,
    easing: Array.isArray(c) ? "linear" : c,
    fill: "both",
    iterations: a + 1,
    direction: o === "reverse" ? "alternate" : "normal"
  });
}
function iE(t, r) {
  t.timeline = r, t.onfinish = null;
}
const h4e = /* @__PURE__ */ Fx(() => Object.hasOwnProperty.call(Element.prototype, "animate")), Ly = 10, p4e = 2e4;
function v4e(t) {
  return Ox(t.type) || t.type === "spring" || !BW(t.ease);
}
function g4e(t, r) {
  const e = new Bx({
    ...r,
    keyframes: t,
    repeat: 0,
    delay: 0,
    isGenerator: !0
  });
  let n = { done: !1, value: t[0] };
  const i = [];
  let a = 0;
  for (; !n.done && a < p4e; )
    n = e.sample(a), i.push(n.value), a += Ly;
  return {
    times: void 0,
    keyframes: i,
    duration: a - Ly,
    ease: "linear"
  };
}
const HW = {
  anticipate: dW,
  backInOut: cW,
  circInOut: hW
};
function m4e(t) {
  return t in HW;
}
class aE extends RW {
  constructor(r) {
    super(r);
    const { name: e, motionValue: n, element: i, keyframes: a } = this.options;
    this.resolver = new MW(a, (o, s) => this.onKeyframesResolved(o, s), e, n, i), this.resolver.scheduleResolve();
  }
  initPlayback(r, e) {
    var n;
    let { duration: i = 300, times: a, ease: o, type: s, motionValue: l, name: u, startTime: c } = this.options;
    if (!(!((n = l.owner) === null || n === void 0) && n.current))
      return !1;
    if (typeof o == "string" && Ry() && m4e(o) && (o = HW[o]), v4e(this.options)) {
      const { onComplete: f, onUpdate: h, motionValue: p, element: v, ...g } = this.options, m = g4e(r, g);
      r = m.keyframes, r.length === 1 && (r[1] = r[0]), i = m.duration, a = m.times, o = m.ease, s = "keyframes";
    }
    const d = f4e(l.owner.current, u, r, { ...this.options, duration: i, times: a, ease: o });
    return d.startTime = c ?? this.calcStartTime(), this.pendingTimeline ? (iE(d, this.pendingTimeline), this.pendingTimeline = void 0) : d.onfinish = () => {
      const { onComplete: f } = this.options;
      l.set(i5(r, this.options, e)), f && f(), this.cancel(), this.resolveFinishedPromise();
    }, {
      animation: d,
      duration: i,
      times: a,
      type: s,
      ease: o,
      keyframes: r
    };
  }
  get duration() {
    const { resolved: r } = this;
    if (!r)
      return 0;
    const { duration: e } = r;
    return js(e);
  }
  get time() {
    const { resolved: r } = this;
    if (!r)
      return 0;
    const { animation: e } = r;
    return js(e.currentTime || 0);
  }
  set time(r) {
    const { resolved: e } = this;
    if (!e)
      return;
    const { animation: n } = e;
    n.currentTime = Yo(r);
  }
  get speed() {
    const { resolved: r } = this;
    if (!r)
      return 1;
    const { animation: e } = r;
    return e.playbackRate;
  }
  set speed(r) {
    const { resolved: e } = this;
    if (!e)
      return;
    const { animation: n } = e;
    n.playbackRate = r;
  }
  get state() {
    const { resolved: r } = this;
    if (!r)
      return "idle";
    const { animation: e } = r;
    return e.playState;
  }
  get startTime() {
    const { resolved: r } = this;
    if (!r)
      return null;
    const { animation: e } = r;
    return e.startTime;
  }
  /**
   * Replace the default DocumentTimeline with another AnimationTimeline.
   * Currently used for scroll animations.
   */
  attachTimeline(r) {
    if (!this._resolved)
      this.pendingTimeline = r;
    else {
      const { resolved: e } = this;
      if (!e)
        return Wn;
      const { animation: n } = e;
      iE(n, r);
    }
    return Wn;
  }
  play() {
    if (this.isStopped)
      return;
    const { resolved: r } = this;
    if (!r)
      return;
    const { animation: e } = r;
    e.playState === "finished" && this.updateFinishedPromise(), e.play();
  }
  pause() {
    const { resolved: r } = this;
    if (!r)
      return;
    const { animation: e } = r;
    e.pause();
  }
  stop() {
    if (this.resolver.cancel(), this.isStopped = !0, this.state === "idle")
      return;
    this.resolveFinishedPromise(), this.updateFinishedPromise();
    const { resolved: r } = this;
    if (!r)
      return;
    const { animation: e, keyframes: n, duration: i, type: a, ease: o, times: s } = r;
    if (e.playState === "idle" || e.playState === "finished")
      return;
    if (this.time) {
      const { motionValue: u, onUpdate: c, onComplete: d, element: f, ...h } = this.options, p = new Bx({
        ...h,
        keyframes: n,
        duration: i,
        type: a,
        ease: o,
        times: s,
        isGenerator: !0
      }), v = Yo(this.time);
      u.setWithVelocity(p.sample(v - Ly).value, p.sample(v).value, Ly);
    }
    const { onStop: l } = this.options;
    l && l(), this.cancel();
  }
  complete() {
    const { resolved: r } = this;
    r && r.animation.finish();
  }
  cancel() {
    const { resolved: r } = this;
    r && r.animation.cancel();
  }
  static supports(r) {
    const { motionValue: e, name: n, repeatDelay: i, repeatType: a, damping: o, type: s } = r;
    return h4e() && n && u4e.has(n) && e && e.owner && e.owner.current instanceof HTMLElement && /**
     * If we're outputting values to onUpdate then we can't use WAAPI as there's
     * no way to read the value from WAAPI every frame.
     */
    !e.owner.getProps().onUpdate && !i && a !== "mirror" && o !== 0 && s !== "inertia";
  }
}
const y4e = Fx(() => window.ScrollTimeline !== void 0);
class b4e {
  constructor(r) {
    this.stop = () => this.runAll("stop"), this.animations = r.filter(Boolean);
  }
  then(r, e) {
    return Promise.all(this.animations).then(r).catch(e);
  }
  /**
   * TODO: Filter out cancelled or stopped animations before returning
   */
  getAll(r) {
    return this.animations[0][r];
  }
  setAll(r, e) {
    for (let n = 0; n < this.animations.length; n++)
      this.animations[n][r] = e;
  }
  attachTimeline(r, e) {
    const n = this.animations.map((i) => y4e() && i.attachTimeline ? i.attachTimeline(r) : e(i));
    return () => {
      n.forEach((i, a) => {
        i && i(), this.animations[a].stop();
      });
    };
  }
  get time() {
    return this.getAll("time");
  }
  set time(r) {
    this.setAll("time", r);
  }
  get speed() {
    return this.getAll("speed");
  }
  set speed(r) {
    this.setAll("speed", r);
  }
  get startTime() {
    return this.getAll("startTime");
  }
  get duration() {
    let r = 0;
    for (let e = 0; e < this.animations.length; e++)
      r = Math.max(r, this.animations[e].duration);
    return r;
  }
  runAll(r) {
    this.animations.forEach((e) => e[r]());
  }
  flatten() {
    this.runAll("flatten");
  }
  play() {
    this.runAll("play");
  }
  pause() {
    this.runAll("pause");
  }
  cancel() {
    this.runAll("cancel");
  }
  complete() {
    this.runAll("complete");
  }
}
function C4e({ when: t, delay: r, delayChildren: e, staggerChildren: n, staggerDirection: i, repeat: a, repeatType: o, repeatDelay: s, from: l, elapsed: u, ...c }) {
  return !!Object.keys(c).length;
}
const Hx = (t, r, e, n = {}, i, a) => (o) => {
  const s = Dx(n, t) || {}, l = s.delay || n.delay || 0;
  let { elapsed: u = 0 } = n;
  u = u - Yo(l);
  let c = {
    keyframes: Array.isArray(e) ? e : [null, e],
    ease: "easeOut",
    velocity: r.getVelocity(),
    ...s,
    delay: -u,
    onUpdate: (f) => {
      r.set(f), s.onUpdate && s.onUpdate(f);
    },
    onComplete: () => {
      o(), s.onComplete && s.onComplete();
    },
    name: t,
    motionValue: r,
    element: a ? void 0 : i
  };
  C4e(s) || (c = {
    ...c,
    ...Zbe(t, c)
  }), c.duration && (c.duration = Yo(c.duration)), c.repeatDelay && (c.repeatDelay = Yo(c.repeatDelay)), c.from !== void 0 && (c.keyframes[0] = c.from);
  let d = !1;
  if ((c.type === !1 || c.duration === 0 && !c.repeatDelay) && (c.duration = 0, c.delay === 0 && (d = !0)), d && !a && r.get() !== void 0) {
    const f = i5(c.keyframes, s);
    if (f !== void 0)
      return br.update(() => {
        c.onUpdate(f), c.onComplete();
      }), new b4e([]);
  }
  return !a && aE.supports(c) ? new aE(c) : new Bx(c);
}, w4e = (t) => !!(t && typeof t == "object" && t.mix && t.toValue), _4e = (t) => I6(t) ? t[t.length - 1] || 0 : t;
function zx(t, r) {
  t.indexOf(r) === -1 && t.push(r);
}
function Wx(t, r) {
  const e = t.indexOf(r);
  e > -1 && t.splice(e, 1);
}
class Zx {
  constructor() {
    this.subscriptions = [];
  }
  add(r) {
    return zx(this.subscriptions, r), () => Wx(this.subscriptions, r);
  }
  notify(r, e, n) {
    const i = this.subscriptions.length;
    if (i)
      if (i === 1)
        this.subscriptions[0](r, e, n);
      else
        for (let a = 0; a < i; a++) {
          const o = this.subscriptions[a];
          o && o(r, e, n);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const oE = 30, x4e = (t) => !isNaN(parseFloat(t));
class S4e {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  constructor(r, e = {}) {
    this.version = "11.13.1", this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (n, i = !0) => {
      const a = $o.now();
      this.updatedAt !== a && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(n), this.current !== this.prev && this.events.change && this.events.change.notify(this.current), i && this.events.renderRequest && this.events.renderRequest.notify(this.current);
    }, this.hasAnimated = !1, this.setCurrent(r), this.owner = e.owner;
  }
  setCurrent(r) {
    this.current = r, this.updatedAt = $o.now(), this.canTrackVelocity === null && r !== void 0 && (this.canTrackVelocity = x4e(this.current));
  }
  setPrevFrameValue(r = this.current) {
    this.prevFrameValue = r, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(r) {
    return process.env.NODE_ENV !== "production" && t5(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", r);
  }
  on(r, e) {
    this.events[r] || (this.events[r] = new Zx());
    const n = this.events[r].add(e);
    return r === "change" ? () => {
      n(), br.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : n;
  }
  clearListeners() {
    for (const r in this.events)
      this.events[r].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   *
   * @internal
   */
  attach(r, e) {
    this.passiveEffect = r, this.stopPassiveEffect = e;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(r, e = !0) {
    !e || !this.passiveEffect ? this.updateAndNotify(r, e) : this.passiveEffect(r, this.updateAndNotify);
  }
  setWithVelocity(r, e, n) {
    this.set(e), this.prev = void 0, this.prevFrameValue = r, this.prevUpdatedAt = this.updatedAt - n;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(r, e = !0) {
    this.updateAndNotify(r), this.prev = r, this.prevUpdatedAt = this.prevFrameValue = void 0, e && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const r = $o.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || r - this.updatedAt > oE)
      return 0;
    const e = Math.min(this.updatedAt - this.prevUpdatedAt, oE);
    return EW(parseFloat(this.current) - parseFloat(this.prevFrameValue), e);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   *
   * @internal
   */
  start(r) {
    return this.stop(), new Promise((e) => {
      this.hasAnimated = !0, this.animation = r(e), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function Kv(t, r) {
  return new S4e(t, r);
}
function I4e(t, r, e) {
  t.hasValue(r) ? t.getValue(r).set(e) : t.addValue(r, Kv(e));
}
function A4e(t, r) {
  const e = n5(t, r);
  let { transitionEnd: n = {}, transition: i = {}, ...a } = e || {};
  a = { ...a, ...n };
  for (const o in a) {
    const s = _4e(a[o]);
    I4e(t, o, s);
  }
}
const jx = (t) => t.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(), D4e = "framerAppearId", zW = "data-" + jx(D4e);
function WW(t) {
  return t.props[zW];
}
const ri = (t) => !!(t && t.getVelocity);
function T4e(t) {
  return !!(ri(t) && t.add);
}
function P6(t, r) {
  const e = t.getValue("willChange");
  if (T4e(e))
    return e.add(r);
}
function M4e({ protectedKeys: t, needsAnimating: r }, e) {
  const n = t.hasOwnProperty(e) && r[e] !== !0;
  return r[e] = !1, n;
}
function ZW(t, r, { delay: e = 0, transitionOverride: n, type: i } = {}) {
  var a;
  let { transition: o = t.getDefaultTransition(), transitionEnd: s, ...l } = r;
  n && (o = n);
  const u = [], c = i && t.animationState && t.animationState.getState()[i];
  for (const d in l) {
    const f = t.getValue(d, (a = t.latestValues[d]) !== null && a !== void 0 ? a : null), h = l[d];
    if (h === void 0 || c && M4e(c, d))
      continue;
    const p = {
      delay: e,
      ...Dx(o || {}, d)
    };
    let v = !1;
    if (window.MotionHandoffAnimation) {
      const m = WW(t);
      if (m) {
        const y = window.MotionHandoffAnimation(m, d, br);
        y !== null && (p.startTime = y, v = !0);
      }
    }
    P6(t, d), f.start(Hx(d, f, h, t.shouldReduceMotion && sd.has(d) ? { type: !1 } : p, t, v));
    const g = f.animation;
    g && u.push(g);
  }
  return s && Promise.all(u).then(() => {
    br.update(() => {
      s && A4e(t, s);
    });
  }), u;
}
function N6(t, r, e = {}) {
  var n;
  const i = n5(t, r, e.type === "exit" ? (n = t.presenceContext) === null || n === void 0 ? void 0 : n.custom : void 0);
  let { transition: a = t.getDefaultTransition() || {} } = i || {};
  e.transitionOverride && (a = e.transitionOverride);
  const o = i ? () => Promise.all(ZW(t, i, e)) : () => Promise.resolve(), s = t.variantChildren && t.variantChildren.size ? (u = 0) => {
    const { delayChildren: c = 0, staggerChildren: d, staggerDirection: f } = a;
    return R4e(t, r, c + u, d, f, e);
  } : () => Promise.resolve(), { when: l } = a;
  if (l) {
    const [u, c] = l === "beforeChildren" ? [o, s] : [s, o];
    return u().then(() => c());
  } else
    return Promise.all([o(), s(e.delay)]);
}
function R4e(t, r, e = 0, n = 0, i = 1, a) {
  const o = [], s = (t.variantChildren.size - 1) * n, l = i === 1 ? (u = 0) => u * n : (u = 0) => s - u * n;
  return Array.from(t.variantChildren).sort(L4e).forEach((u, c) => {
    u.notify("AnimationStart", r), o.push(N6(u, r, {
      ...a,
      delay: e + l(c)
    }).then(() => u.notify("AnimationComplete", r)));
  }), Promise.all(o);
}
function L4e(t, r) {
  return t.sortNodePosition(r);
}
function E4e(t, r, e = {}) {
  t.notify("AnimationStart", r);
  let n;
  if (Array.isArray(r)) {
    const i = r.map((a) => N6(t, a, e));
    n = Promise.all(i);
  } else if (typeof r == "string")
    n = N6(t, r, e);
  else {
    const i = typeof r == "function" ? n5(t, r, e.custom) : r;
    n = Promise.all(ZW(t, i, e));
  }
  return n.then(() => {
    t.notify("AnimationComplete", r);
  });
}
const k4e = Ax.length;
function jW(t) {
  if (!t)
    return;
  if (!t.isControllingVariants) {
    const e = t.parent ? jW(t.parent) || {} : {};
    return t.props.initial !== void 0 && (e.initial = t.props.initial), e;
  }
  const r = {};
  for (let e = 0; e < k4e; e++) {
    const n = Ax[e], i = t.props[n];
    ($v(i) || i === !1) && (r[n] = i);
  }
  return r;
}
const P4e = [...Ix].reverse(), N4e = Ix.length;
function O4e(t) {
  return (r) => Promise.all(r.map(({ animation: e, options: n }) => E4e(t, e, n)));
}
function V4e(t) {
  let r = O4e(t), e = sE(), n = !0;
  const i = (l) => (u, c) => {
    var d;
    const f = n5(t, c, l === "exit" ? (d = t.presenceContext) === null || d === void 0 ? void 0 : d.custom : void 0);
    if (f) {
      const { transition: h, transitionEnd: p, ...v } = f;
      u = { ...u, ...v, ...p };
    }
    return u;
  };
  function a(l) {
    r = l(t);
  }
  function o(l) {
    const { props: u } = t, c = jW(t.parent) || {}, d = [], f = /* @__PURE__ */ new Set();
    let h = {}, p = 1 / 0;
    for (let g = 0; g < N4e; g++) {
      const m = P4e[g], y = e[m], b = u[m] !== void 0 ? u[m] : c[m], C = $v(b), w = m === l ? y.isActive : null;
      w === !1 && (p = g);
      let _ = b === c[m] && b !== u[m] && C;
      if (_ && n && t.manuallyAnimateOnMount && (_ = !1), y.protectedKeys = { ...h }, // If it isn't active and hasn't *just* been set as inactive
      !y.isActive && w === null || // If we didn't and don't have any defined prop for this animation type
      !b && !y.prevProp || // Or if the prop doesn't define an animation
      r5(b) || typeof b == "boolean")
        continue;
      const x = G4e(y.prevProp, b);
      let I = x || // If we're making this variant active, we want to always make it active
      m === l && y.isActive && !_ && C || // If we removed a higher-priority variant (i is in reverse order)
      g > p && C, D = !1;
      const T = Array.isArray(b) ? b : [b];
      let A = T.reduce(i(m), {});
      w === !1 && (A = {});
      const { prevResolvedValues: M = {} } = y, R = {
        ...M,
        ...A
      }, E = (N) => {
        I = !0, f.has(N) && (D = !0, f.delete(N)), y.needsAnimating[N] = !0;
        const O = t.getValue(N);
        O && (O.liveStyle = !1);
      };
      for (const N in R) {
        const O = A[N], W = M[N];
        if (h.hasOwnProperty(N))
          continue;
        let V = !1;
        I6(O) && I6(W) ? V = !iW(O, W) : V = O !== W, V ? O != null ? E(N) : f.add(N) : O !== void 0 && f.has(N) ? E(N) : y.protectedKeys[N] = !0;
      }
      y.prevProp = b, y.prevResolvedValues = A, y.isActive && (h = { ...h, ...A }), n && t.blockInitialAnimation && (I = !1), I && (!(_ && x) || D) && d.push(...T.map((N) => ({
        animation: N,
        options: { type: m }
      })));
    }
    if (f.size) {
      const g = {};
      f.forEach((m) => {
        const y = t.getBaseTarget(m), b = t.getValue(m);
        b && (b.liveStyle = !0), g[m] = y ?? null;
      }), d.push({ animation: g });
    }
    let v = !!d.length;
    return n && (u.initial === !1 || u.initial === u.animate) && !t.manuallyAnimateOnMount && (v = !1), n = !1, v ? r(d) : Promise.resolve();
  }
  function s(l, u) {
    var c;
    if (e[l].isActive === u)
      return Promise.resolve();
    (c = t.variantChildren) === null || c === void 0 || c.forEach((f) => {
      var h;
      return (h = f.animationState) === null || h === void 0 ? void 0 : h.setActive(l, u);
    }), e[l].isActive = u;
    const d = o(l);
    for (const f in e)
      e[f].protectedKeys = {};
    return d;
  }
  return {
    animateChanges: o,
    setActive: s,
    setAnimateFunction: a,
    getState: () => e,
    reset: () => {
      e = sE(), n = !0;
    }
  };
}
function G4e(t, r) {
  return typeof r == "string" ? r !== t : Array.isArray(r) ? !iW(r, t) : !1;
}
function Xu(t = !1) {
  return {
    isActive: t,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function sE() {
  return {
    animate: Xu(!0),
    whileInView: Xu(),
    whileHover: Xu(),
    whileTap: Xu(),
    whileDrag: Xu(),
    whileFocus: Xu(),
    exit: Xu()
  };
}
class bu {
  constructor(r) {
    this.isMounted = !1, this.node = r;
  }
  update() {
  }
}
class B4e extends bu {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(r) {
    super(r), r.animationState || (r.animationState = V4e(r));
  }
  updateAnimationControlsSubscription() {
    const { animate: r } = this.node.getProps();
    r5(r) && (this.unmountControls = r.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: r } = this.node.getProps(), { animate: e } = this.node.prevProps || {};
    r !== e && this.updateAnimationControlsSubscription();
  }
  unmount() {
    var r;
    this.node.animationState.reset(), (r = this.unmountControls) === null || r === void 0 || r.call(this);
  }
}
let F4e = 0;
class H4e extends bu {
  constructor() {
    super(...arguments), this.id = F4e++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: r, onExitComplete: e } = this.node.presenceContext, { isPresent: n } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || r === n)
      return;
    const i = this.node.animationState.setActive("exit", !r);
    e && !r && i.then(() => e(this.id));
  }
  mount() {
    const { register: r } = this.node.presenceContext || {};
    r && (this.unmount = r(this.id));
  }
  unmount() {
  }
}
const z4e = {
  animation: {
    Feature: B4e
  },
  exit: {
    Feature: H4e
  }
};
function W4e(t, r, e) {
  var n;
  if (t instanceof Element)
    return [t];
  if (typeof t == "string") {
    let i = document;
    const a = (n = void 0) !== null && n !== void 0 ? n : i.querySelectorAll(t);
    return a ? Array.from(a) : [];
  }
  return Array.from(t);
}
const Za = {
  x: !1,
  y: !1
};
function YW() {
  return Za.x || Za.y;
}
function lE(t) {
  return (r) => {
    r.pointerType === "touch" || YW() || t(r);
  };
}
function Z4e(t, r, e = {}) {
  const n = new AbortController(), i = {
    passive: !0,
    ...e,
    signal: n.signal
  }, a = lE((o) => {
    const { target: s } = o, l = r(o);
    if (!l || !s)
      return;
    const u = lE((c) => {
      l(c), s.removeEventListener("pointerleave", u);
    });
    s.addEventListener("pointerleave", u, i);
  });
  return W4e(t).forEach((o) => {
    o.addEventListener("pointerenter", a, i);
  }), () => n.abort();
}
function j4e(t) {
  return t === "x" || t === "y" ? Za[t] ? null : (Za[t] = !0, () => {
    Za[t] = !1;
  }) : Za.x || Za.y ? null : (Za.x = Za.y = !0, () => {
    Za.x = Za.y = !1;
  });
}
const XW = (t) => t.pointerType === "mouse" ? typeof t.button != "number" || t.button <= 0 : t.isPrimary !== !1;
function Wg(t) {
  return {
    point: {
      x: t.pageX,
      y: t.pageY
    }
  };
}
const Y4e = (t) => (r) => XW(r) && t(r, Wg(r));
function Ns(t, r, e, n = { passive: !0 }) {
  return t.addEventListener(r, e, n), () => t.removeEventListener(r, e);
}
function Xl(t, r, e, n) {
  return Ns(t, r, Y4e(e), n);
}
const uE = (t, r) => Math.abs(t - r);
function X4e(t, r) {
  const e = uE(t.x, r.x), n = uE(t.y, r.y);
  return Math.sqrt(e ** 2 + n ** 2);
}
class $W {
  constructor(r, e, { transformPagePoint: n, contextWindow: i, dragSnapToOrigin: a = !1 } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const d = m4(this.lastMoveEventInfo, this.history), f = this.startEvent !== null, h = X4e(d.offset, { x: 0, y: 0 }) >= 3;
      if (!f && !h)
        return;
      const { point: p } = d, { timestamp: v } = Fn;
      this.history.push({ ...p, timestamp: v });
      const { onStart: g, onMove: m } = this.handlers;
      f || (g && g(this.lastMoveEvent, d), this.startEvent = this.lastMoveEvent), m && m(this.lastMoveEvent, d);
    }, this.handlePointerMove = (d, f) => {
      this.lastMoveEvent = d, this.lastMoveEventInfo = g4(f, this.transformPagePoint), br.update(this.updatePoint, !0);
    }, this.handlePointerUp = (d, f) => {
      this.end();
      const { onEnd: h, onSessionEnd: p, resumeAnimation: v } = this.handlers;
      if (this.dragSnapToOrigin && v && v(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const g = m4(d.type === "pointercancel" ? this.lastMoveEventInfo : g4(f, this.transformPagePoint), this.history);
      this.startEvent && h && h(d, g), p && p(d, g);
    }, !XW(r))
      return;
    this.dragSnapToOrigin = a, this.handlers = e, this.transformPagePoint = n, this.contextWindow = i || window;
    const o = Wg(r), s = g4(o, this.transformPagePoint), { point: l } = s, { timestamp: u } = Fn;
    this.history = [{ ...l, timestamp: u }];
    const { onSessionStart: c } = e;
    c && c(r, m4(s, this.history)), this.removeListeners = Yl(Xl(this.contextWindow, "pointermove", this.handlePointerMove), Xl(this.contextWindow, "pointerup", this.handlePointerUp), Xl(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(r) {
    this.handlers = r;
  }
  end() {
    this.removeListeners && this.removeListeners(), uu(this.updatePoint);
  }
}
function g4(t, r) {
  return r ? { point: r(t.point) } : t;
}
function cE(t, r) {
  return { x: t.x - r.x, y: t.y - r.y };
}
function m4({ point: t }, r) {
  return {
    point: t,
    delta: cE(t, UW(r)),
    offset: cE(t, $4e(r)),
    velocity: U4e(r, 0.1)
  };
}
function $4e(t) {
  return t[0];
}
function UW(t) {
  return t[t.length - 1];
}
function U4e(t, r) {
  if (t.length < 2)
    return { x: 0, y: 0 };
  let e = t.length - 1, n = null;
  const i = UW(t);
  for (; e >= 0 && (n = t[e], !(i.timestamp - n.timestamp > Yo(r))); )
    e--;
  if (!n)
    return { x: 0, y: 0 };
  const a = js(i.timestamp - n.timestamp);
  if (a === 0)
    return { x: 0, y: 0 };
  const o = {
    x: (i.x - n.x) / a,
    y: (i.y - n.y) / a
  };
  return o.x === 1 / 0 && (o.x = 0), o.y === 1 / 0 && (o.y = 0), o;
}
function rf(t) {
  return t && typeof t == "object" && Object.prototype.hasOwnProperty.call(t, "current");
}
const JW = 1e-4, J4e = 1 - JW, K4e = 1 + JW, KW = 0.01, q4e = 0 - KW, Q4e = 0 + KW;
function na(t) {
  return t.max - t.min;
}
function eCe(t, r, e) {
  return Math.abs(t - r) <= e;
}
function dE(t, r, e, n = 0.5) {
  t.origin = n, t.originPoint = Zr(r.min, r.max, t.origin), t.scale = na(e) / na(r), t.translate = Zr(e.min, e.max, t.origin) - t.originPoint, (t.scale >= J4e && t.scale <= K4e || isNaN(t.scale)) && (t.scale = 1), (t.translate >= q4e && t.translate <= Q4e || isNaN(t.translate)) && (t.translate = 0);
}
function lv(t, r, e, n) {
  dE(t.x, r.x, e.x, n ? n.originX : void 0), dE(t.y, r.y, e.y, n ? n.originY : void 0);
}
function fE(t, r, e) {
  t.min = e.min + r.min, t.max = t.min + na(r);
}
function tCe(t, r, e) {
  fE(t.x, r.x, e.x), fE(t.y, r.y, e.y);
}
function hE(t, r, e) {
  t.min = r.min - e.min, t.max = t.min + na(r);
}
function uv(t, r, e) {
  hE(t.x, r.x, e.x), hE(t.y, r.y, e.y);
}
function rCe(t, { min: r, max: e }, n) {
  return r !== void 0 && t < r ? t = n ? Zr(r, t, n.min) : Math.max(t, r) : e !== void 0 && t > e && (t = n ? Zr(e, t, n.max) : Math.min(t, e)), t;
}
function pE(t, r, e) {
  return {
    min: r !== void 0 ? t.min + r : void 0,
    max: e !== void 0 ? t.max + e - (t.max - t.min) : void 0
  };
}
function nCe(t, { top: r, left: e, bottom: n, right: i }) {
  return {
    x: pE(t.x, e, i),
    y: pE(t.y, r, n)
  };
}
function vE(t, r) {
  let e = r.min - t.min, n = r.max - t.max;
  return r.max - r.min < t.max - t.min && ([e, n] = [n, e]), { min: e, max: n };
}
function iCe(t, r) {
  return {
    x: vE(t.x, r.x),
    y: vE(t.y, r.y)
  };
}
function aCe(t, r) {
  let e = 0.5;
  const n = na(t), i = na(r);
  return i > n ? e = jf(r.min, r.max - n, t.min) : n > i && (e = jf(t.min, t.max - i, r.min)), nl(0, 1, e);
}
function oCe(t, r) {
  const e = {};
  return r.min !== void 0 && (e.min = r.min - t.min), r.max !== void 0 && (e.max = r.max - t.min), e;
}
const O6 = 0.35;
function sCe(t = O6) {
  return t === !1 ? t = 0 : t === !0 && (t = O6), {
    x: gE(t, "left", "right"),
    y: gE(t, "top", "bottom")
  };
}
function gE(t, r, e) {
  return {
    min: mE(t, r),
    max: mE(t, e)
  };
}
function mE(t, r) {
  return typeof t == "number" ? t : t[r] || 0;
}
const yE = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), nf = () => ({
  x: yE(),
  y: yE()
}), bE = () => ({ min: 0, max: 0 }), rn = () => ({
  x: bE(),
  y: bE()
});
function va(t) {
  return [t("x"), t("y")];
}
function qW({ top: t, left: r, right: e, bottom: n }) {
  return {
    x: { min: r, max: e },
    y: { min: t, max: n }
  };
}
function lCe({ x: t, y: r }) {
  return { top: r.min, right: t.max, bottom: r.max, left: t.min };
}
function uCe(t, r) {
  if (!r)
    return t;
  const e = r({ x: t.left, y: t.top }), n = r({ x: t.right, y: t.bottom });
  return {
    top: e.y,
    left: e.x,
    bottom: n.y,
    right: n.x
  };
}
function y4(t) {
  return t === void 0 || t === 1;
}
function V6({ scale: t, scaleX: r, scaleY: e }) {
  return !y4(t) || !y4(r) || !y4(e);
}
function tc(t) {
  return V6(t) || QW(t) || t.z || t.rotate || t.rotateX || t.rotateY || t.skewX || t.skewY;
}
function QW(t) {
  return CE(t.x) || CE(t.y);
}
function CE(t) {
  return t && t !== "0%";
}
function Ey(t, r, e) {
  const n = t - e, i = r * n;
  return e + i;
}
function wE(t, r, e, n, i) {
  return i !== void 0 && (t = Ey(t, i, n)), Ey(t, e, n) + r;
}
function G6(t, r = 0, e = 1, n, i) {
  t.min = wE(t.min, r, e, n, i), t.max = wE(t.max, r, e, n, i);
}
function eZ(t, { x: r, y: e }) {
  G6(t.x, r.translate, r.scale, r.originPoint), G6(t.y, e.translate, e.scale, e.originPoint);
}
const _E = 0.999999999999, xE = 1.0000000000001;
function cCe(t, r, e, n = !1) {
  const i = e.length;
  if (!i)
    return;
  r.x = r.y = 1;
  let a, o;
  for (let s = 0; s < i; s++) {
    a = e[s], o = a.projectionDelta;
    const { visualElement: l } = a.options;
    l && l.props.style && l.props.style.display === "contents" || (n && a.options.layoutScroll && a.scroll && a !== a.root && of(t, {
      x: -a.scroll.offset.x,
      y: -a.scroll.offset.y
    }), o && (r.x *= o.x.scale, r.y *= o.y.scale, eZ(t, o)), n && tc(a.latestValues) && of(t, a.latestValues));
  }
  r.x < xE && r.x > _E && (r.x = 1), r.y < xE && r.y > _E && (r.y = 1);
}
function af(t, r) {
  t.min = t.min + r, t.max = t.max + r;
}
function SE(t, r, e, n, i = 0.5) {
  const a = Zr(t.min, t.max, i);
  G6(t, r, e, a, n);
}
function of(t, r) {
  SE(t.x, r.x, r.scaleX, r.scale, r.originX), SE(t.y, r.y, r.scaleY, r.scale, r.originY);
}
function tZ(t, r) {
  return qW(uCe(t.getBoundingClientRect(), r));
}
function dCe(t, r, e) {
  const n = tZ(t, e), { scroll: i } = r;
  return i && (af(n.x, i.offset.x), af(n.y, i.offset.y)), n;
}
const rZ = ({ current: t }) => t ? t.ownerDocument.defaultView : null, fCe = /* @__PURE__ */ new WeakMap();
class hCe {
  constructor(r) {
    this.openDragLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = rn(), this.visualElement = r;
  }
  start(r, { snapToCursor: e = !1 } = {}) {
    const { presenceContext: n } = this.visualElement;
    if (n && n.isPresent === !1)
      return;
    const i = (c) => {
      const { dragSnapToOrigin: d } = this.getProps();
      d ? this.pauseAnimation() : this.stopAnimation(), e && this.snapToCursor(Wg(c).point);
    }, a = (c, d) => {
      const { drag: f, dragPropagation: h, onDragStart: p } = this.getProps();
      if (f && !h && (this.openDragLock && this.openDragLock(), this.openDragLock = j4e(f), !this.openDragLock))
        return;
      this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), va((g) => {
        let m = this.getAxisMotionValue(g).get() || 0;
        if (Xo.test(m)) {
          const { projection: y } = this.visualElement;
          if (y && y.layout) {
            const b = y.layout.layoutBox[g];
            b && (m = na(b) * (parseFloat(m) / 100));
          }
        }
        this.originPoint[g] = m;
      }), p && br.postRender(() => p(c, d)), P6(this.visualElement, "transform");
      const { animationState: v } = this.visualElement;
      v && v.setActive("whileDrag", !0);
    }, o = (c, d) => {
      const { dragPropagation: f, dragDirectionLock: h, onDirectionLock: p, onDrag: v } = this.getProps();
      if (!f && !this.openDragLock)
        return;
      const { offset: g } = d;
      if (h && this.currentDirection === null) {
        this.currentDirection = pCe(g), this.currentDirection !== null && p && p(this.currentDirection);
        return;
      }
      this.updateAxis("x", d.point, g), this.updateAxis("y", d.point, g), this.visualElement.render(), v && v(c, d);
    }, s = (c, d) => this.stop(c, d), l = () => va((c) => {
      var d;
      return this.getAnimationState(c) === "paused" && ((d = this.getAxisMotionValue(c).animation) === null || d === void 0 ? void 0 : d.play());
    }), { dragSnapToOrigin: u } = this.getProps();
    this.panSession = new $W(r, {
      onSessionStart: i,
      onStart: a,
      onMove: o,
      onSessionEnd: s,
      resumeAnimation: l
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: u,
      contextWindow: rZ(this.visualElement)
    });
  }
  stop(r, e) {
    const n = this.isDragging;
    if (this.cancel(), !n)
      return;
    const { velocity: i } = e;
    this.startAnimation(i);
    const { onDragEnd: a } = this.getProps();
    a && br.postRender(() => a(r, e));
  }
  cancel() {
    this.isDragging = !1;
    const { projection: r, animationState: e } = this.visualElement;
    r && (r.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation: n } = this.getProps();
    !n && this.openDragLock && (this.openDragLock(), this.openDragLock = null), e && e.setActive("whileDrag", !1);
  }
  updateAxis(r, e, n) {
    const { drag: i } = this.getProps();
    if (!n || !c0(r, i, this.currentDirection))
      return;
    const a = this.getAxisMotionValue(r);
    let o = this.originPoint[r] + n[r];
    this.constraints && this.constraints[r] && (o = rCe(o, this.constraints[r], this.elastic[r])), a.set(o);
  }
  resolveConstraints() {
    var r;
    const { dragConstraints: e, dragElastic: n } = this.getProps(), i = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (r = this.visualElement.projection) === null || r === void 0 ? void 0 : r.layout, a = this.constraints;
    e && rf(e) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : e && i ? this.constraints = nCe(i.layoutBox, e) : this.constraints = !1, this.elastic = sCe(n), a !== this.constraints && i && this.constraints && !this.hasMutatedConstraints && va((o) => {
      this.constraints !== !1 && this.getAxisMotionValue(o) && (this.constraints[o] = oCe(i.layoutBox[o], this.constraints[o]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: r, onMeasureDragConstraints: e } = this.getProps();
    if (!r || !rf(r))
      return !1;
    const n = r.current;
    lu(n !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
    const { projection: i } = this.visualElement;
    if (!i || !i.layout)
      return !1;
    const a = dCe(n, i.root, this.visualElement.getTransformPagePoint());
    let o = iCe(i.layout.layoutBox, a);
    if (e) {
      const s = e(lCe(o));
      this.hasMutatedConstraints = !!s, s && (o = qW(s));
    }
    return o;
  }
  startAnimation(r) {
    const { drag: e, dragMomentum: n, dragElastic: i, dragTransition: a, dragSnapToOrigin: o, onDragTransitionEnd: s } = this.getProps(), l = this.constraints || {}, u = va((c) => {
      if (!c0(c, e, this.currentDirection))
        return;
      let d = l && l[c] || {};
      o && (d = { min: 0, max: 0 });
      const f = i ? 200 : 1e6, h = i ? 40 : 1e7, p = {
        type: "inertia",
        velocity: n ? r[c] : 0,
        bounceStiffness: f,
        bounceDamping: h,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...a,
        ...d
      };
      return this.startAxisValueAnimation(c, p);
    });
    return Promise.all(u).then(s);
  }
  startAxisValueAnimation(r, e) {
    const n = this.getAxisMotionValue(r);
    return P6(this.visualElement, r), n.start(Hx(r, n, 0, e, this.visualElement, !1));
  }
  stopAnimation() {
    va((r) => this.getAxisMotionValue(r).stop());
  }
  pauseAnimation() {
    va((r) => {
      var e;
      return (e = this.getAxisMotionValue(r).animation) === null || e === void 0 ? void 0 : e.pause();
    });
  }
  getAnimationState(r) {
    var e;
    return (e = this.getAxisMotionValue(r).animation) === null || e === void 0 ? void 0 : e.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(r) {
    const e = `_drag${r.toUpperCase()}`, n = this.visualElement.getProps(), i = n[e];
    return i || this.visualElement.getValue(r, (n.initial ? n.initial[r] : void 0) || 0);
  }
  snapToCursor(r) {
    va((e) => {
      const { drag: n } = this.getProps();
      if (!c0(e, n, this.currentDirection))
        return;
      const { projection: i } = this.visualElement, a = this.getAxisMotionValue(e);
      if (i && i.layout) {
        const { min: o, max: s } = i.layout.layoutBox[e];
        a.set(r[e] - Zr(o, s, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: r, dragConstraints: e } = this.getProps(), { projection: n } = this.visualElement;
    if (!rf(e) || !n || !this.constraints)
      return;
    this.stopAnimation();
    const i = { x: 0, y: 0 };
    va((o) => {
      const s = this.getAxisMotionValue(o);
      if (s && this.constraints !== !1) {
        const l = s.get();
        i[o] = aCe({ min: l, max: l }, this.constraints[o]);
      }
    });
    const { transformTemplate: a } = this.visualElement.getProps();
    this.visualElement.current.style.transform = a ? a({}, "") : "none", n.root && n.root.updateScroll(), n.updateLayout(), this.resolveConstraints(), va((o) => {
      if (!c0(o, r, null))
        return;
      const s = this.getAxisMotionValue(o), { min: l, max: u } = this.constraints[o];
      s.set(Zr(l, u, i[o]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    fCe.set(this.visualElement, this);
    const r = this.visualElement.current, e = Xl(r, "pointerdown", (l) => {
      const { drag: u, dragListener: c = !0 } = this.getProps();
      u && c && this.start(l);
    }), n = () => {
      const { dragConstraints: l } = this.getProps();
      rf(l) && l.current && (this.constraints = this.resolveRefConstraints());
    }, { projection: i } = this.visualElement, a = i.addEventListener("measure", n);
    i && !i.layout && (i.root && i.root.updateScroll(), i.updateLayout()), br.read(n);
    const o = Ns(window, "resize", () => this.scalePositionWithinConstraints()), s = i.addEventListener("didUpdate", ({ delta: l, hasLayoutChanged: u }) => {
      this.isDragging && u && (va((c) => {
        const d = this.getAxisMotionValue(c);
        d && (this.originPoint[c] += l[c].translate, d.set(d.get() + l[c].translate));
      }), this.visualElement.render());
    });
    return () => {
      o(), e(), a(), s && s();
    };
  }
  getProps() {
    const r = this.visualElement.getProps(), { drag: e = !1, dragDirectionLock: n = !1, dragPropagation: i = !1, dragConstraints: a = !1, dragElastic: o = O6, dragMomentum: s = !0 } = r;
    return {
      ...r,
      drag: e,
      dragDirectionLock: n,
      dragPropagation: i,
      dragConstraints: a,
      dragElastic: o,
      dragMomentum: s
    };
  }
}
function c0(t, r, e) {
  return (r === !0 || r === t) && (e === null || e === t);
}
function pCe(t, r = 10) {
  let e = null;
  return Math.abs(t.y) > r ? e = "y" : Math.abs(t.x) > r && (e = "x"), e;
}
class vCe extends bu {
  constructor(r) {
    super(r), this.removeGroupControls = Wn, this.removeListeners = Wn, this.controls = new hCe(r);
  }
  mount() {
    const { dragControls: r } = this.node.getProps();
    r && (this.removeGroupControls = r.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || Wn;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const IE = (t) => (r, e) => {
  t && br.postRender(() => t(r, e));
};
class gCe extends bu {
  constructor() {
    super(...arguments), this.removePointerDownListener = Wn;
  }
  onPointerDown(r) {
    this.session = new $W(r, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: rZ(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: r, onPanStart: e, onPan: n, onPanEnd: i } = this.node.getProps();
    return {
      onSessionStart: IE(r),
      onStart: IE(e),
      onMove: n,
      onEnd: (a, o) => {
        delete this.session, i && br.postRender(() => i(a, o));
      }
    };
  }
  mount() {
    this.removePointerDownListener = Xl(this.node.current, "pointerdown", (r) => this.onPointerDown(r));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
const Yx = Uc(null);
function mCe() {
  const t = zn(Yx);
  if (t === null)
    return [!0, null];
  const { isPresent: r, onExitComplete: e, register: n } = t, i = ui();
  Ue(() => n(i), []);
  const a = ns(() => e && e(i), [i, e]);
  return !r && e ? [!1, a] : [!0];
}
const nZ = Uc({}), iZ = Uc({}), K0 = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
function AE(t, r) {
  return r.max === r.min ? 0 : t / (r.max - r.min) * 100;
}
const mp = {
  correct: (t, r) => {
    if (!r.target)
      return t;
    if (typeof t == "string")
      if (ot.test(t))
        t = parseFloat(t);
      else
        return t;
    const e = AE(t, r.target.x), n = AE(t, r.target.y);
    return `${e}% ${n}%`;
  }
}, yCe = {
  correct: (t, { treeScale: r, projectionDelta: e }) => {
    const n = t, i = cu.parse(t);
    if (i.length > 5)
      return n;
    const a = cu.createTransformer(t), o = typeof i[0] != "number" ? 1 : 0, s = e.x.scale * r.x, l = e.y.scale * r.y;
    i[0 + o] /= s, i[1 + o] /= l;
    const u = Zr(s, l, 0.5);
    return typeof i[2 + o] == "number" && (i[2 + o] /= u), typeof i[3 + o] == "number" && (i[3 + o] /= u), a(i);
  }
}, ky = {};
function bCe(t) {
  Object.assign(ky, t);
}
const { schedule: Xx, cancel: Hxe } = aW(queueMicrotask, !1);
class CCe extends In {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: r, layoutGroup: e, switchLayoutGroup: n, layoutId: i } = this.props, { projection: a } = r;
    bCe(wCe), a && (e.group && e.group.add(a), n && n.register && i && n.register(a), a.root.didUpdate(), a.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), a.setOptions({
      ...a.options,
      onExitComplete: () => this.safeToRemove()
    })), K0.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(r) {
    const { layoutDependency: e, visualElement: n, drag: i, isPresent: a } = this.props, o = n.projection;
    return o && (o.isPresent = a, i || r.layoutDependency !== e || e === void 0 ? o.willUpdate() : this.safeToRemove(), r.isPresent !== a && (a ? o.promote() : o.relegate() || br.postRender(() => {
      const s = o.getStack();
      (!s || !s.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: r } = this.props.visualElement;
    r && (r.root.didUpdate(), Xx.postRender(() => {
      !r.currentAnimation && r.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: r, layoutGroup: e, switchLayoutGroup: n } = this.props, { projection: i } = r;
    i && (i.scheduleCheckAfterUnmount(), e && e.group && e.group.remove(i), n && n.deregister && n.deregister(i));
  }
  safeToRemove() {
    const { safeToRemove: r } = this.props;
    r && r();
  }
  render() {
    return null;
  }
}
function aZ(t) {
  const [r, e] = mCe(), n = zn(nZ);
  return S.jsx(CCe, { ...t, layoutGroup: n, switchLayoutGroup: zn(iZ), isPresent: r, safeToRemove: e });
}
const wCe = {
  borderRadius: {
    ...mp,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: mp,
  borderTopRightRadius: mp,
  borderBottomLeftRadius: mp,
  borderBottomRightRadius: mp,
  boxShadow: yCe
}, oZ = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], _Ce = oZ.length, DE = (t) => typeof t == "string" ? parseFloat(t) : t, TE = (t) => typeof t == "number" || ot.test(t);
function xCe(t, r, e, n, i, a) {
  i ? (t.opacity = Zr(
    0,
    // TODO Reinstate this if only child
    e.opacity !== void 0 ? e.opacity : 1,
    SCe(n)
  ), t.opacityExit = Zr(r.opacity !== void 0 ? r.opacity : 1, 0, ICe(n))) : a && (t.opacity = Zr(r.opacity !== void 0 ? r.opacity : 1, e.opacity !== void 0 ? e.opacity : 1, n));
  for (let o = 0; o < _Ce; o++) {
    const s = `border${oZ[o]}Radius`;
    let l = ME(r, s), u = ME(e, s);
    if (l === void 0 && u === void 0)
      continue;
    l || (l = 0), u || (u = 0), l === 0 || u === 0 || TE(l) === TE(u) ? (t[s] = Math.max(Zr(DE(l), DE(u), n), 0), (Xo.test(u) || Xo.test(l)) && (t[s] += "%")) : t[s] = u;
  }
  (r.rotate || e.rotate) && (t.rotate = Zr(r.rotate || 0, e.rotate || 0, n));
}
function ME(t, r) {
  return t[r] !== void 0 ? t[r] : t.borderRadius;
}
const SCe = /* @__PURE__ */ sZ(0, 0.5, fW), ICe = /* @__PURE__ */ sZ(0.5, 0.95, Wn);
function sZ(t, r, e) {
  return (n) => n < t ? 0 : n > r ? 1 : e(jf(t, r, n));
}
function RE(t, r) {
  t.min = r.min, t.max = r.max;
}
function fa(t, r) {
  RE(t.x, r.x), RE(t.y, r.y);
}
function LE(t, r) {
  t.translate = r.translate, t.scale = r.scale, t.originPoint = r.originPoint, t.origin = r.origin;
}
function EE(t, r, e, n, i) {
  return t -= r, t = Ey(t, 1 / e, n), i !== void 0 && (t = Ey(t, 1 / i, n)), t;
}
function ACe(t, r = 0, e = 1, n = 0.5, i, a = t, o = t) {
  if (Xo.test(r) && (r = parseFloat(r), r = Zr(o.min, o.max, r / 100) - o.min), typeof r != "number")
    return;
  let s = Zr(a.min, a.max, n);
  t === a && (s -= r), t.min = EE(t.min, r, e, s, i), t.max = EE(t.max, r, e, s, i);
}
function kE(t, r, [e, n, i], a, o) {
  ACe(t, r[e], r[n], r[i], r.scale, a, o);
}
const DCe = ["x", "scaleX", "originX"], TCe = ["y", "scaleY", "originY"];
function PE(t, r, e, n) {
  kE(t.x, r, DCe, e ? e.x : void 0, n ? n.x : void 0), kE(t.y, r, TCe, e ? e.y : void 0, n ? n.y : void 0);
}
function NE(t) {
  return t.translate === 0 && t.scale === 1;
}
function lZ(t) {
  return NE(t.x) && NE(t.y);
}
function OE(t, r) {
  return t.min === r.min && t.max === r.max;
}
function MCe(t, r) {
  return OE(t.x, r.x) && OE(t.y, r.y);
}
function VE(t, r) {
  return Math.round(t.min) === Math.round(r.min) && Math.round(t.max) === Math.round(r.max);
}
function uZ(t, r) {
  return VE(t.x, r.x) && VE(t.y, r.y);
}
function GE(t) {
  return na(t.x) / na(t.y);
}
function BE(t, r) {
  return t.translate === r.translate && t.scale === r.scale && t.originPoint === r.originPoint;
}
class RCe {
  constructor() {
    this.members = [];
  }
  add(r) {
    zx(this.members, r), r.scheduleRender();
  }
  remove(r) {
    if (Wx(this.members, r), r === this.prevLead && (this.prevLead = void 0), r === this.lead) {
      const e = this.members[this.members.length - 1];
      e && this.promote(e);
    }
  }
  relegate(r) {
    const e = this.members.findIndex((i) => r === i);
    if (e === 0)
      return !1;
    let n;
    for (let i = e; i >= 0; i--) {
      const a = this.members[i];
      if (a.isPresent !== !1) {
        n = a;
        break;
      }
    }
    return n ? (this.promote(n), !0) : !1;
  }
  promote(r, e) {
    const n = this.lead;
    if (r !== n && (this.prevLead = n, this.lead = r, r.show(), n)) {
      n.instance && n.scheduleRender(), r.scheduleRender(), r.resumeFrom = n, e && (r.resumeFrom.preserveOpacity = !0), n.snapshot && (r.snapshot = n.snapshot, r.snapshot.latestValues = n.animationValues || n.latestValues), r.root && r.root.isUpdating && (r.isLayoutDirty = !0);
      const { crossfade: i } = r.options;
      i === !1 && n.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((r) => {
      const { options: e, resumingFrom: n } = r;
      e.onExitComplete && e.onExitComplete(), n && n.options.onExitComplete && n.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((r) => {
      r.instance && r.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function LCe(t, r, e) {
  let n = "";
  const i = t.x.translate / r.x, a = t.y.translate / r.y, o = (e == null ? void 0 : e.z) || 0;
  if ((i || a || o) && (n = `translate3d(${i}px, ${a}px, ${o}px) `), (r.x !== 1 || r.y !== 1) && (n += `scale(${1 / r.x}, ${1 / r.y}) `), e) {
    const { transformPerspective: u, rotate: c, rotateX: d, rotateY: f, skewX: h, skewY: p } = e;
    u && (n = `perspective(${u}px) ${n}`), c && (n += `rotate(${c}deg) `), d && (n += `rotateX(${d}deg) `), f && (n += `rotateY(${f}deg) `), h && (n += `skewX(${h}deg) `), p && (n += `skewY(${p}deg) `);
  }
  const s = t.x.scale * r.x, l = t.y.scale * r.y;
  return (s !== 1 || l !== 1) && (n += `scale(${s}, ${l})`), n || "none";
}
const ECe = (t, r) => t.depth - r.depth;
class kCe {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(r) {
    zx(this.children, r), this.isDirty = !0;
  }
  remove(r) {
    Wx(this.children, r), this.isDirty = !0;
  }
  forEach(r) {
    this.isDirty && this.children.sort(ECe), this.isDirty = !1, this.children.forEach(r);
  }
}
function q0(t) {
  const r = ri(t) ? t.get() : t;
  return w4e(r) ? r.toValue() : r;
}
function PCe(t, r) {
  const e = $o.now(), n = ({ timestamp: i }) => {
    const a = i - e;
    a >= r && (uu(n), t(a - r));
  };
  return br.read(n, !0), () => uu(n);
}
function NCe(t) {
  return t instanceof SVGElement && t.tagName !== "svg";
}
function OCe(t, r, e) {
  const n = ri(t) ? t : Kv(t);
  return n.start(Hx("", n, r, e)), n.animation;
}
const rc = {
  type: "projectionFrame",
  totalNodes: 0,
  resolvedTargetDeltas: 0,
  recalculatedProjection: 0
}, Hp = typeof window < "u" && window.MotionDebug !== void 0, b4 = ["", "X", "Y", "Z"], VCe = { visibility: "hidden" }, FE = 1e3;
let GCe = 0;
function C4(t, r, e, n) {
  const { latestValues: i } = r;
  i[t] && (e[t] = i[t], r.setStaticValue(t, 0), n && (n[t] = 0));
}
function cZ(t) {
  if (t.hasCheckedOptimisedAppear = !0, t.root === t)
    return;
  const { visualElement: r } = t.options;
  if (!r)
    return;
  const e = WW(r);
  if (window.MotionHasOptimisedAnimation(e, "transform")) {
    const { layout: i, layoutId: a } = t.options;
    window.MotionCancelOptimisedAnimation(e, "transform", br, !(i || a));
  }
  const { parent: n } = t;
  n && !n.hasCheckedOptimisedAppear && cZ(n);
}
function dZ({ attachResizeListener: t, defaultParent: r, measureScroll: e, checkIsScrollRoot: n, resetTransform: i }) {
  return class {
    constructor(o = {}, s = r == null ? void 0 : r()) {
      this.id = GCe++, this.animationId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, Hp && (rc.totalNodes = rc.resolvedTargetDeltas = rc.recalculatedProjection = 0), this.nodes.forEach(HCe), this.nodes.forEach(YCe), this.nodes.forEach(XCe), this.nodes.forEach(zCe), Hp && window.MotionDebug.record(rc);
      }, this.resolvedRelativeTargetAt = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = o, this.root = s ? s.root || s : this, this.path = s ? [...s.path, s] : [], this.parent = s, this.depth = s ? s.depth + 1 : 0;
      for (let l = 0; l < this.path.length; l++)
        this.path[l].shouldResetTransform = !0;
      this.root === this && (this.nodes = new kCe());
    }
    addEventListener(o, s) {
      return this.eventHandlers.has(o) || this.eventHandlers.set(o, new Zx()), this.eventHandlers.get(o).add(s);
    }
    notifyListeners(o, ...s) {
      const l = this.eventHandlers.get(o);
      l && l.notify(...s);
    }
    hasListeners(o) {
      return this.eventHandlers.has(o);
    }
    /**
     * Lifecycles
     */
    mount(o, s = this.root.hasTreeAnimated) {
      if (this.instance)
        return;
      this.isSVG = NCe(o), this.instance = o;
      const { layoutId: l, layout: u, visualElement: c } = this.options;
      if (c && !c.current && c.mount(o), this.root.nodes.add(this), this.parent && this.parent.children.add(this), s && (u || l) && (this.isLayoutDirty = !0), t) {
        let d;
        const f = () => this.root.updateBlockedByResize = !1;
        t(o, () => {
          this.root.updateBlockedByResize = !0, d && d(), d = PCe(f, 250), K0.hasAnimatedSinceResize && (K0.hasAnimatedSinceResize = !1, this.nodes.forEach(zE));
        });
      }
      l && this.root.registerSharedNode(l, this), this.options.animate !== !1 && c && (l || u) && this.addEventListener("didUpdate", ({ delta: d, hasLayoutChanged: f, hasRelativeTargetChanged: h, layout: p }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const v = this.options.transition || c.getDefaultTransition() || qCe, { onLayoutAnimationStart: g, onLayoutAnimationComplete: m } = c.getProps(), y = !this.targetLayout || !uZ(this.targetLayout, p) || h, b = !f && h;
        if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || b || f && (y || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0), this.setAnimationOrigin(d, b);
          const C = {
            ...Dx(v, "layout"),
            onPlay: g,
            onComplete: m
          };
          (c.shouldReduceMotion || this.options.layoutRoot) && (C.delay = 0, C.type = !1), this.startAnimation(C);
        } else
          f || zE(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = p;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const o = this.getStack();
      o && o.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, uu(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach($Ce), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: o } = this.options;
      return o && o.getProps().transformTemplate;
    }
    willUpdate(o = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && cZ(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let c = 0; c < this.path.length; c++) {
        const d = this.path[c];
        d.shouldResetTransform = !0, d.updateScroll("snapshot"), d.options.layoutRoot && d.willUpdate(!1);
      }
      const { layoutId: s, layout: l } = this.options;
      if (s === void 0 && !l)
        return;
      const u = this.getTransformTemplate();
      this.prevTransformTemplateValue = u ? u(this.latestValues, "") : void 0, this.updateSnapshot(), o && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(HE);
        return;
      }
      this.isUpdating || this.nodes.forEach(ZCe), this.isUpdating = !1, this.nodes.forEach(jCe), this.nodes.forEach(BCe), this.nodes.forEach(FCe), this.clearAllSnapshots();
      const s = $o.now();
      Fn.delta = nl(0, 1e3 / 60, s - Fn.timestamp), Fn.timestamp = s, Fn.isProcessing = !0, d4.update.process(Fn), d4.preRender.process(Fn), d4.render.process(Fn), Fn.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, Xx.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach(WCe), this.sharedNodes.forEach(UCe);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, br.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      br.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure());
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let l = 0; l < this.path.length; l++)
          this.path[l].updateScroll();
      const o = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = rn(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: s } = this.options;
      s && s.notify("LayoutMeasure", this.layout.layoutBox, o ? o.layoutBox : void 0);
    }
    updateScroll(o = "measure") {
      let s = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === o && (s = !1), s) {
        const l = n(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: o,
          isRoot: l,
          offset: e(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : l
        };
      }
    }
    resetTransform() {
      if (!i)
        return;
      const o = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, s = this.projectionDelta && !lZ(this.projectionDelta), l = this.getTransformTemplate(), u = l ? l(this.latestValues, "") : void 0, c = u !== this.prevTransformTemplateValue;
      o && (s || tc(this.latestValues) || c) && (i(this.instance, u), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(o = !0) {
      const s = this.measurePageBox();
      let l = this.removeElementScroll(s);
      return o && (l = this.removeTransform(l)), QCe(l), {
        animationId: this.root.animationId,
        measuredBox: s,
        layoutBox: l,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      var o;
      const { visualElement: s } = this.options;
      if (!s)
        return rn();
      const l = s.measureViewportBox();
      if (!(((o = this.scroll) === null || o === void 0 ? void 0 : o.wasRoot) || this.path.some(e9e))) {
        const { scroll: c } = this.root;
        c && (af(l.x, c.offset.x), af(l.y, c.offset.y));
      }
      return l;
    }
    removeElementScroll(o) {
      var s;
      const l = rn();
      if (fa(l, o), !((s = this.scroll) === null || s === void 0) && s.wasRoot)
        return l;
      for (let u = 0; u < this.path.length; u++) {
        const c = this.path[u], { scroll: d, options: f } = c;
        c !== this.root && d && f.layoutScroll && (d.wasRoot && fa(l, o), af(l.x, d.offset.x), af(l.y, d.offset.y));
      }
      return l;
    }
    applyTransform(o, s = !1) {
      const l = rn();
      fa(l, o);
      for (let u = 0; u < this.path.length; u++) {
        const c = this.path[u];
        !s && c.options.layoutScroll && c.scroll && c !== c.root && of(l, {
          x: -c.scroll.offset.x,
          y: -c.scroll.offset.y
        }), tc(c.latestValues) && of(l, c.latestValues);
      }
      return tc(this.latestValues) && of(l, this.latestValues), l;
    }
    removeTransform(o) {
      const s = rn();
      fa(s, o);
      for (let l = 0; l < this.path.length; l++) {
        const u = this.path[l];
        if (!u.instance || !tc(u.latestValues))
          continue;
        V6(u.latestValues) && u.updateSnapshot();
        const c = rn(), d = u.measurePageBox();
        fa(c, d), PE(s, u.latestValues, u.snapshot ? u.snapshot.layoutBox : void 0, c);
      }
      return tc(this.latestValues) && PE(s, this.latestValues), s;
    }
    setTargetDelta(o) {
      this.targetDelta = o, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(o) {
      this.options = {
        ...this.options,
        ...o,
        crossfade: o.crossfade !== void 0 ? o.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== Fn.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(o = !1) {
      var s;
      const l = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = l.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = l.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = l.isSharedProjectionDirty);
      const u = !!this.resumingFrom || this !== l;
      if (!(o || u && this.isSharedProjectionDirty || this.isProjectionDirty || !((s = this.parent) === null || s === void 0) && s.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize))
        return;
      const { layout: d, layoutId: f } = this.options;
      if (!(!this.layout || !(d || f))) {
        if (this.resolvedRelativeTargetAt = Fn.timestamp, !this.targetDelta && !this.relativeTarget) {
          const h = this.getClosestProjectingParent();
          h && h.layout && this.animationProgress !== 1 ? (this.relativeParent = h, this.forceRelativeParentToResolveTarget(), this.relativeTarget = rn(), this.relativeTargetOrigin = rn(), uv(this.relativeTargetOrigin, this.layout.layoutBox, h.layout.layoutBox), fa(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta)) {
          if (this.target || (this.target = rn(), this.targetWithTransforms = rn()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), tCe(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : fa(this.target, this.layout.layoutBox), eZ(this.target, this.targetDelta)) : fa(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget) {
            this.attemptToResolveRelativeTarget = !1;
            const h = this.getClosestProjectingParent();
            h && !!h.resumingFrom == !!this.resumingFrom && !h.options.layoutScroll && h.target && this.animationProgress !== 1 ? (this.relativeParent = h, this.forceRelativeParentToResolveTarget(), this.relativeTarget = rn(), this.relativeTargetOrigin = rn(), uv(this.relativeTargetOrigin, this.target, h.target), fa(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
          }
          Hp && rc.resolvedTargetDeltas++;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || V6(this.parent.latestValues) || QW(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var o;
      const s = this.getLead(), l = !!this.resumingFrom || this !== s;
      let u = !0;
      if ((this.isProjectionDirty || !((o = this.parent) === null || o === void 0) && o.isProjectionDirty) && (u = !1), l && (this.isSharedProjectionDirty || this.isTransformDirty) && (u = !1), this.resolvedRelativeTargetAt === Fn.timestamp && (u = !1), u)
        return;
      const { layout: c, layoutId: d } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(c || d))
        return;
      fa(this.layoutCorrected, this.layout.layoutBox);
      const f = this.treeScale.x, h = this.treeScale.y;
      cCe(this.layoutCorrected, this.treeScale, this.path, l), s.layout && !s.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (s.target = s.layout.layoutBox, s.targetWithTransforms = rn());
      const { target: p } = s;
      if (!p) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (LE(this.prevProjectionDelta.x, this.projectionDelta.x), LE(this.prevProjectionDelta.y, this.projectionDelta.y)), lv(this.projectionDelta, this.layoutCorrected, p, this.latestValues), (this.treeScale.x !== f || this.treeScale.y !== h || !BE(this.projectionDelta.x, this.prevProjectionDelta.x) || !BE(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", p)), Hp && rc.recalculatedProjection++;
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(o = !0) {
      var s;
      if ((s = this.options.visualElement) === null || s === void 0 || s.scheduleRender(), o) {
        const l = this.getStack();
        l && l.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = nf(), this.projectionDelta = nf(), this.projectionDeltaWithTransform = nf();
    }
    setAnimationOrigin(o, s = !1) {
      const l = this.snapshot, u = l ? l.latestValues : {}, c = { ...this.latestValues }, d = nf();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !s;
      const f = rn(), h = l ? l.source : void 0, p = this.layout ? this.layout.source : void 0, v = h !== p, g = this.getStack(), m = !g || g.members.length <= 1, y = !!(v && !m && this.options.crossfade === !0 && !this.path.some(KCe));
      this.animationProgress = 0;
      let b;
      this.mixTargetDelta = (C) => {
        const w = C / 1e3;
        WE(d.x, o.x, w), WE(d.y, o.y, w), this.setTargetDelta(d), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (uv(f, this.layout.layoutBox, this.relativeParent.layout.layoutBox), JCe(this.relativeTarget, this.relativeTargetOrigin, f, w), b && MCe(this.relativeTarget, b) && (this.isProjectionDirty = !1), b || (b = rn()), fa(b, this.relativeTarget)), v && (this.animationValues = c, xCe(c, u, this.latestValues, w, y, m)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = w;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(o) {
      this.notifyListeners("animationStart"), this.currentAnimation && this.currentAnimation.stop(), this.resumingFrom && this.resumingFrom.currentAnimation && this.resumingFrom.currentAnimation.stop(), this.pendingAnimation && (uu(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = br.update(() => {
        K0.hasAnimatedSinceResize = !0, this.currentAnimation = OCe(0, FE, {
          ...o,
          onUpdate: (s) => {
            this.mixTargetDelta(s), o.onUpdate && o.onUpdate(s);
          },
          onComplete: () => {
            o.onComplete && o.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const o = this.getStack();
      o && o.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(FE), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const o = this.getLead();
      let { targetWithTransforms: s, target: l, layout: u, latestValues: c } = o;
      if (!(!s || !l || !u)) {
        if (this !== o && this.layout && u && fZ(this.options.animationType, this.layout.layoutBox, u.layoutBox)) {
          l = this.target || rn();
          const d = na(this.layout.layoutBox.x);
          l.x.min = o.target.x.min, l.x.max = l.x.min + d;
          const f = na(this.layout.layoutBox.y);
          l.y.min = o.target.y.min, l.y.max = l.y.min + f;
        }
        fa(s, l), of(s, c), lv(this.projectionDeltaWithTransform, this.layoutCorrected, s, c);
      }
    }
    registerSharedNode(o, s) {
      this.sharedNodes.has(o) || this.sharedNodes.set(o, new RCe()), this.sharedNodes.get(o).add(s);
      const u = s.options.initialPromotionConfig;
      s.promote({
        transition: u ? u.transition : void 0,
        preserveFollowOpacity: u && u.shouldPreserveFollowOpacity ? u.shouldPreserveFollowOpacity(s) : void 0
      });
    }
    isLead() {
      const o = this.getStack();
      return o ? o.lead === this : !0;
    }
    getLead() {
      var o;
      const { layoutId: s } = this.options;
      return s ? ((o = this.getStack()) === null || o === void 0 ? void 0 : o.lead) || this : this;
    }
    getPrevLead() {
      var o;
      const { layoutId: s } = this.options;
      return s ? (o = this.getStack()) === null || o === void 0 ? void 0 : o.prevLead : void 0;
    }
    getStack() {
      const { layoutId: o } = this.options;
      if (o)
        return this.root.sharedNodes.get(o);
    }
    promote({ needsReset: o, transition: s, preserveFollowOpacity: l } = {}) {
      const u = this.getStack();
      u && u.promote(this, l), o && (this.projectionDelta = void 0, this.needsReset = !0), s && this.setOptions({ transition: s });
    }
    relegate() {
      const o = this.getStack();
      return o ? o.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: o } = this.options;
      if (!o)
        return;
      let s = !1;
      const { latestValues: l } = o;
      if ((l.z || l.rotate || l.rotateX || l.rotateY || l.rotateZ || l.skewX || l.skewY) && (s = !0), !s)
        return;
      const u = {};
      l.z && C4("z", o, u, this.animationValues);
      for (let c = 0; c < b4.length; c++)
        C4(`rotate${b4[c]}`, o, u, this.animationValues), C4(`skew${b4[c]}`, o, u, this.animationValues);
      o.render();
      for (const c in u)
        o.setStaticValue(c, u[c]), this.animationValues && (this.animationValues[c] = u[c]);
      o.scheduleRender();
    }
    getProjectionStyles(o) {
      var s, l;
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible)
        return VCe;
      const u = {
        visibility: ""
      }, c = this.getTransformTemplate();
      if (this.needsReset)
        return this.needsReset = !1, u.opacity = "", u.pointerEvents = q0(o == null ? void 0 : o.pointerEvents) || "", u.transform = c ? c(this.latestValues, "") : "none", u;
      const d = this.getLead();
      if (!this.projectionDelta || !this.layout || !d.target) {
        const v = {};
        return this.options.layoutId && (v.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, v.pointerEvents = q0(o == null ? void 0 : o.pointerEvents) || ""), this.hasProjected && !tc(this.latestValues) && (v.transform = c ? c({}, "") : "none", this.hasProjected = !1), v;
      }
      const f = d.animationValues || d.latestValues;
      this.applyTransformsToTarget(), u.transform = LCe(this.projectionDeltaWithTransform, this.treeScale, f), c && (u.transform = c(f, u.transform));
      const { x: h, y: p } = this.projectionDelta;
      u.transformOrigin = `${h.origin * 100}% ${p.origin * 100}% 0`, d.animationValues ? u.opacity = d === this ? (l = (s = f.opacity) !== null && s !== void 0 ? s : this.latestValues.opacity) !== null && l !== void 0 ? l : 1 : this.preserveOpacity ? this.latestValues.opacity : f.opacityExit : u.opacity = d === this ? f.opacity !== void 0 ? f.opacity : "" : f.opacityExit !== void 0 ? f.opacityExit : 0;
      for (const v in ky) {
        if (f[v] === void 0)
          continue;
        const { correct: g, applyTo: m } = ky[v], y = u.transform === "none" ? f[v] : g(f[v], d);
        if (m) {
          const b = m.length;
          for (let C = 0; C < b; C++)
            u[m[C]] = y;
        } else
          u[v] = y;
      }
      return this.options.layoutId && (u.pointerEvents = d === this ? q0(o == null ? void 0 : o.pointerEvents) || "" : "none"), u;
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((o) => {
        var s;
        return (s = o.currentAnimation) === null || s === void 0 ? void 0 : s.stop();
      }), this.root.nodes.forEach(HE), this.root.sharedNodes.clear();
    }
  };
}
function BCe(t) {
  t.updateLayout();
}
function FCe(t) {
  var r;
  const e = ((r = t.resumeFrom) === null || r === void 0 ? void 0 : r.snapshot) || t.snapshot;
  if (t.isLead() && t.layout && e && t.hasListeners("didUpdate")) {
    const { layoutBox: n, measuredBox: i } = t.layout, { animationType: a } = t.options, o = e.source !== t.layout.source;
    a === "size" ? va((d) => {
      const f = o ? e.measuredBox[d] : e.layoutBox[d], h = na(f);
      f.min = n[d].min, f.max = f.min + h;
    }) : fZ(a, e.layoutBox, n) && va((d) => {
      const f = o ? e.measuredBox[d] : e.layoutBox[d], h = na(n[d]);
      f.max = f.min + h, t.relativeTarget && !t.currentAnimation && (t.isProjectionDirty = !0, t.relativeTarget[d].max = t.relativeTarget[d].min + h);
    });
    const s = nf();
    lv(s, n, e.layoutBox);
    const l = nf();
    o ? lv(l, t.applyTransform(i, !0), e.measuredBox) : lv(l, n, e.layoutBox);
    const u = !lZ(s);
    let c = !1;
    if (!t.resumeFrom) {
      const d = t.getClosestProjectingParent();
      if (d && !d.resumeFrom) {
        const { snapshot: f, layout: h } = d;
        if (f && h) {
          const p = rn();
          uv(p, e.layoutBox, f.layoutBox);
          const v = rn();
          uv(v, n, h.layoutBox), uZ(p, v) || (c = !0), d.options.layoutRoot && (t.relativeTarget = v, t.relativeTargetOrigin = p, t.relativeParent = d);
        }
      }
    }
    t.notifyListeners("didUpdate", {
      layout: n,
      snapshot: e,
      delta: l,
      layoutDelta: s,
      hasLayoutChanged: u,
      hasRelativeTargetChanged: c
    });
  } else if (t.isLead()) {
    const { onExitComplete: n } = t.options;
    n && n();
  }
  t.options.transition = void 0;
}
function HCe(t) {
  Hp && rc.totalNodes++, t.parent && (t.isProjecting() || (t.isProjectionDirty = t.parent.isProjectionDirty), t.isSharedProjectionDirty || (t.isSharedProjectionDirty = !!(t.isProjectionDirty || t.parent.isProjectionDirty || t.parent.isSharedProjectionDirty)), t.isTransformDirty || (t.isTransformDirty = t.parent.isTransformDirty));
}
function zCe(t) {
  t.isProjectionDirty = t.isSharedProjectionDirty = t.isTransformDirty = !1;
}
function WCe(t) {
  t.clearSnapshot();
}
function HE(t) {
  t.clearMeasurements();
}
function ZCe(t) {
  t.isLayoutDirty = !1;
}
function jCe(t) {
  const { visualElement: r } = t.options;
  r && r.getProps().onBeforeLayoutMeasure && r.notify("BeforeLayoutMeasure"), t.resetTransform();
}
function zE(t) {
  t.finishAnimation(), t.targetDelta = t.relativeTarget = t.target = void 0, t.isProjectionDirty = !0;
}
function YCe(t) {
  t.resolveTargetDelta();
}
function XCe(t) {
  t.calcProjection();
}
function $Ce(t) {
  t.resetSkewAndRotation();
}
function UCe(t) {
  t.removeLeadSnapshot();
}
function WE(t, r, e) {
  t.translate = Zr(r.translate, 0, e), t.scale = Zr(r.scale, 1, e), t.origin = r.origin, t.originPoint = r.originPoint;
}
function ZE(t, r, e, n) {
  t.min = Zr(r.min, e.min, n), t.max = Zr(r.max, e.max, n);
}
function JCe(t, r, e, n) {
  ZE(t.x, r.x, e.x, n), ZE(t.y, r.y, e.y, n);
}
function KCe(t) {
  return t.animationValues && t.animationValues.opacityExit !== void 0;
}
const qCe = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, jE = (t) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(t), YE = jE("applewebkit/") && !jE("chrome/") ? Math.round : Wn;
function XE(t) {
  t.min = YE(t.min), t.max = YE(t.max);
}
function QCe(t) {
  XE(t.x), XE(t.y);
}
function fZ(t, r, e) {
  return t === "position" || t === "preserve-aspect" && !eCe(GE(r), GE(e), 0.2);
}
function e9e(t) {
  var r;
  return t !== t.root && ((r = t.scroll) === null || r === void 0 ? void 0 : r.wasRoot);
}
const t9e = dZ({
  attachResizeListener: (t, r) => Ns(t, "resize", r),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), w4 = {
  current: void 0
}, hZ = dZ({
  measureScroll: (t) => ({
    x: t.scrollLeft,
    y: t.scrollTop
  }),
  defaultParent: () => {
    if (!w4.current) {
      const t = new t9e({});
      t.mount(window), t.setOptions({ layoutScroll: !0 }), w4.current = t;
    }
    return w4.current;
  },
  resetTransform: (t, r) => {
    t.style.transform = r !== void 0 ? r : "none";
  },
  checkIsScrollRoot: (t) => window.getComputedStyle(t).position === "fixed"
}), r9e = {
  pan: {
    Feature: gCe
  },
  drag: {
    Feature: vCe,
    ProjectionNode: hZ,
    MeasureLayout: aZ
  }
};
function $E(t, r, e) {
  const { props: n } = t;
  t.animationState && n.whileHover && t.animationState.setActive("whileHover", e);
  const i = n[e ? "onHoverStart" : "onHoverEnd"];
  i && br.postRender(() => i(r, Wg(r)));
}
class n9e extends bu {
  mount() {
    const { current: r, props: e } = this.node;
    r && (this.unmount = Z4e(r, (n) => ($E(this.node, n, !0), (i) => $E(this.node, i, !1)), { passive: !e.onHoverStart && !e.onHoverEnd }));
  }
  unmount() {
  }
}
class i9e extends bu {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let r = !1;
    try {
      r = this.node.current.matches(":focus-visible");
    } catch {
      r = !0;
    }
    !r || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = Yl(Ns(this.node.current, "focus", () => this.onFocus()), Ns(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
const pZ = (t, r) => r ? t === r ? !0 : pZ(t, r.parentElement) : !1;
function _4(t, r) {
  if (!r)
    return;
  const e = new PointerEvent("pointer" + t);
  r(e, Wg(e));
}
class a9e extends bu {
  constructor() {
    super(...arguments), this.removeStartListeners = Wn, this.removeEndListeners = Wn, this.removeAccessibleListeners = Wn, this.startPointerPress = (r, e) => {
      if (this.isPressing)
        return;
      this.removeEndListeners();
      const n = this.node.getProps(), a = Xl(window, "pointerup", (s, l) => {
        if (!this.checkPressEnd())
          return;
        const { onTap: u, onTapCancel: c, globalTapTarget: d } = this.node.getProps(), f = !d && !pZ(this.node.current, s.target) ? c : u;
        f && br.update(() => f(s, l));
      }, {
        passive: !(n.onTap || n.onPointerUp)
      }), o = Xl(window, "pointercancel", (s, l) => this.cancelPress(s, l), {
        passive: !(n.onTapCancel || n.onPointerCancel)
      });
      this.removeEndListeners = Yl(a, o), this.startPress(r, e);
    }, this.startAccessiblePress = () => {
      const r = (a) => {
        if (a.key !== "Enter" || this.isPressing)
          return;
        const o = (s) => {
          s.key !== "Enter" || !this.checkPressEnd() || _4("up", (l, u) => {
            const { onTap: c } = this.node.getProps();
            c && br.postRender(() => c(l, u));
          });
        };
        this.removeEndListeners(), this.removeEndListeners = Ns(this.node.current, "keyup", o), _4("down", (s, l) => {
          this.startPress(s, l);
        });
      }, e = Ns(this.node.current, "keydown", r), n = () => {
        this.isPressing && _4("cancel", (a, o) => this.cancelPress(a, o));
      }, i = Ns(this.node.current, "blur", n);
      this.removeAccessibleListeners = Yl(e, i);
    };
  }
  startPress(r, e) {
    this.isPressing = !0;
    const { onTapStart: n, whileTap: i } = this.node.getProps();
    i && this.node.animationState && this.node.animationState.setActive("whileTap", !0), n && br.postRender(() => n(r, e));
  }
  checkPressEnd() {
    return this.removeEndListeners(), this.isPressing = !1, this.node.getProps().whileTap && this.node.animationState && this.node.animationState.setActive("whileTap", !1), !YW();
  }
  cancelPress(r, e) {
    if (!this.checkPressEnd())
      return;
    const { onTapCancel: n } = this.node.getProps();
    n && br.postRender(() => n(r, e));
  }
  mount() {
    const r = this.node.getProps(), e = Xl(r.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, {
      passive: !(r.onTapStart || r.onPointerStart)
    }), n = Ns(this.node.current, "focus", this.startAccessiblePress);
    this.removeStartListeners = Yl(e, n);
  }
  unmount() {
    this.removeStartListeners(), this.removeEndListeners(), this.removeAccessibleListeners();
  }
}
const B6 = /* @__PURE__ */ new WeakMap(), x4 = /* @__PURE__ */ new WeakMap(), o9e = (t) => {
  const r = B6.get(t.target);
  r && r(t);
}, s9e = (t) => {
  t.forEach(o9e);
};
function l9e({ root: t, ...r }) {
  const e = t || document;
  x4.has(e) || x4.set(e, {});
  const n = x4.get(e), i = JSON.stringify(r);
  return n[i] || (n[i] = new IntersectionObserver(s9e, { root: t, ...r })), n[i];
}
function u9e(t, r, e) {
  const n = l9e(r);
  return B6.set(t, e), n.observe(t), () => {
    B6.delete(t), n.unobserve(t);
  };
}
const c9e = {
  some: 0,
  all: 1
};
class d9e extends bu {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: r = {} } = this.node.getProps(), { root: e, margin: n, amount: i = "some", once: a } = r, o = {
      root: e ? e.current : void 0,
      rootMargin: n,
      threshold: typeof i == "number" ? i : c9e[i]
    }, s = (l) => {
      const { isIntersecting: u } = l;
      if (this.isInView === u || (this.isInView = u, a && !u && this.hasEnteredView))
        return;
      u && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", u);
      const { onViewportEnter: c, onViewportLeave: d } = this.node.getProps(), f = u ? c : d;
      f && f(l);
    };
    return u9e(this.node.current, o, s);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: r, prevProps: e } = this.node;
    ["amount", "margin", "root"].some(f9e(r, e)) && this.startObserver();
  }
  unmount() {
  }
}
function f9e({ viewport: t = {} }, { viewport: r = {} } = {}) {
  return (e) => t[e] !== r[e];
}
const h9e = {
  inView: {
    Feature: d9e
  },
  tap: {
    Feature: a9e
  },
  focus: {
    Feature: i9e
  },
  hover: {
    Feature: n9e
  }
}, p9e = {
  layout: {
    ProjectionNode: hZ,
    MeasureLayout: aZ
  }
}, vZ = Uc({
  transformPagePoint: (t) => t,
  isStatic: !1,
  reducedMotion: "never"
}), a5 = Uc({}), $x = typeof window < "u", v9e = $x ? ag : Ue, gZ = Uc({ strict: !1 });
function g9e(t, r, e, n, i) {
  var a, o;
  const { visualElement: s } = zn(a5), l = zn(gZ), u = zn(Yx), c = zn(vZ).reducedMotion, d = Vt();
  n = n || l.renderer, !d.current && n && (d.current = n(t, {
    visualState: r,
    parent: s,
    props: e,
    presenceContext: u,
    blockInitialAnimation: u ? u.initial === !1 : !1,
    reducedMotionConfig: c
  }));
  const f = d.current, h = zn(iZ);
  f && !f.projection && i && (f.type === "html" || f.type === "svg") && m9e(d.current, e, i, h);
  const p = Vt(!1);
  pY(() => {
    f && p.current && f.update(e, u);
  });
  const v = e[zW], g = Vt(!!v && !(!((a = window.MotionHandoffIsComplete) === null || a === void 0) && a.call(window, v)) && ((o = window.MotionHasOptimisedAnimation) === null || o === void 0 ? void 0 : o.call(window, v)));
  return v9e(() => {
    f && (p.current = !0, window.MotionIsMounted = !0, f.updateFeatures(), Xx.render(f.render), g.current && f.animationState && f.animationState.animateChanges());
  }), Ue(() => {
    f && (!g.current && f.animationState && f.animationState.animateChanges(), g.current && (queueMicrotask(() => {
      var m;
      (m = window.MotionHandoffMarkAsComplete) === null || m === void 0 || m.call(window, v);
    }), g.current = !1));
  }), f;
}
function m9e(t, r, e, n) {
  const { layoutId: i, layout: a, drag: o, dragConstraints: s, layoutScroll: l, layoutRoot: u } = r;
  t.projection = new e(t.latestValues, r["data-framer-portal-id"] ? void 0 : mZ(t.parent)), t.projection.setOptions({
    layoutId: i,
    layout: a,
    alwaysMeasureLayout: !!o || s && rf(s),
    visualElement: t,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof a == "string" ? a : "both",
    initialPromotionConfig: n,
    layoutScroll: l,
    layoutRoot: u
  });
}
function mZ(t) {
  if (t)
    return t.options.allowProjection !== !1 ? t.projection : mZ(t.parent);
}
function y9e(t, r, e) {
  return ns(
    (n) => {
      n && t.mount && t.mount(n), r && (n ? r.mount(n) : r.unmount()), e && (typeof e == "function" ? e(n) : rf(e) && (e.current = n));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [r]
  );
}
function o5(t) {
  return r5(t.animate) || Ax.some((r) => $v(t[r]));
}
function yZ(t) {
  return !!(o5(t) || t.variants);
}
function b9e(t, r) {
  if (o5(t)) {
    const { initial: e, animate: n } = t;
    return {
      initial: e === !1 || $v(e) ? e : void 0,
      animate: $v(n) ? n : void 0
    };
  }
  return t.inherit !== !1 ? r : {};
}
function C9e(t) {
  const { initial: r, animate: e } = b9e(t, zn(a5));
  return Oc(() => ({ initial: r, animate: e }), [UE(r), UE(e)]);
}
function UE(t) {
  return Array.isArray(t) ? t.join(" ") : t;
}
const JE = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, Yf = {};
for (const t in JE)
  Yf[t] = {
    isEnabled: (r) => JE[t].some((e) => !!r[e])
  };
function w9e(t) {
  for (const r in t)
    Yf[r] = {
      ...Yf[r],
      ...t[r]
    };
}
const _9e = Symbol.for("motionComponentSymbol");
function x9e({ preloadedFeatures: t, createVisualElement: r, useRender: e, useVisualState: n, Component: i }) {
  t && w9e(t);
  function a(s, l) {
    let u;
    const c = {
      ...zn(vZ),
      ...s,
      layoutId: S9e(s)
    }, { isStatic: d } = c, f = C9e(s), h = n(s, d);
    if (!d && $x) {
      I9e(c, t);
      const p = A9e(c);
      u = p.MeasureLayout, f.visualElement = g9e(i, h, c, r, p.ProjectionNode);
    }
    return S.jsxs(a5.Provider, { value: f, children: [u && f.visualElement ? S.jsx(u, { visualElement: f.visualElement, ...c }) : null, e(i, s, y9e(h, f.visualElement, l), h, d, f.visualElement)] });
  }
  const o = uo(a);
  return o[_9e] = i, o;
}
function S9e({ layoutId: t }) {
  const r = zn(nZ).id;
  return r && t !== void 0 ? r + "-" + t : t;
}
function I9e(t, r) {
  const e = zn(gZ).strict;
  if (process.env.NODE_ENV !== "production" && r && e) {
    const n = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    t.ignoreStrict ? _h(!1, n) : lu(!1, n);
  }
}
function A9e(t) {
  const { drag: r, layout: e } = Yf;
  if (!r && !e)
    return {};
  const n = { ...r, ...e };
  return {
    MeasureLayout: r != null && r.isEnabled(t) || e != null && e.isEnabled(t) ? n.MeasureLayout : void 0,
    ProjectionNode: n.ProjectionNode
  };
}
const D9e = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function Ux(t) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof t != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    t.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(D9e.indexOf(t) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(t))
    )
  );
}
function bZ(t, { style: r, vars: e }, n, i) {
  Object.assign(t.style, r, i && i.getProjectionStyles(n));
  for (const a in e)
    t.style.setProperty(a, e[a]);
}
const CZ = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function wZ(t, r, e, n) {
  bZ(t, r, void 0, n);
  for (const i in r.attrs)
    t.setAttribute(CZ.has(i) ? i : jx(i), r.attrs[i]);
}
function _Z(t, { layout: r, layoutId: e }) {
  return sd.has(t) || t.startsWith("origin") || (r || e !== void 0) && (!!ky[t] || t === "opacity");
}
function Jx(t, r, e) {
  var n;
  const { style: i } = t, a = {};
  for (const o in i)
    (ri(i[o]) || r.style && ri(r.style[o]) || _Z(o, t) || ((n = e == null ? void 0 : e.getValue(o)) === null || n === void 0 ? void 0 : n.liveStyle) !== void 0) && (a[o] = i[o]);
  return a;
}
function xZ(t, r, e) {
  const n = Jx(t, r, e);
  for (const i in t)
    if (ri(t[i]) || ri(r[i])) {
      const a = Fg.indexOf(i) !== -1 ? "attr" + i.charAt(0).toUpperCase() + i.substring(1) : i;
      n[a] = t[i];
    }
  return n;
}
function T9e(t) {
  const r = Vt(null);
  return r.current === null && (r.current = t()), r.current;
}
function M9e({ scrapeMotionValuesFromProps: t, createRenderState: r, onMount: e }, n, i, a) {
  const o = {
    latestValues: R9e(n, i, a, t),
    renderState: r()
  };
  return e && (o.mount = (s) => e(n, s, o)), o;
}
const SZ = (t) => (r, e) => {
  const n = zn(a5), i = zn(Yx), a = () => M9e(t, r, n, i);
  return e ? a() : T9e(a);
};
function R9e(t, r, e, n) {
  const i = {}, a = n(t, {});
  for (const f in a)
    i[f] = q0(a[f]);
  let { initial: o, animate: s } = t;
  const l = o5(t), u = yZ(t);
  r && u && !l && t.inherit !== !1 && (o === void 0 && (o = r.initial), s === void 0 && (s = r.animate));
  let c = e ? e.initial === !1 : !1;
  c = c || o === !1;
  const d = c ? s : o;
  if (d && typeof d != "boolean" && !r5(d)) {
    const f = Array.isArray(d) ? d : [d];
    for (let h = 0; h < f.length; h++) {
      const p = Sx(t, f[h]);
      if (p) {
        const { transitionEnd: v, transition: g, ...m } = p;
        for (const y in m) {
          let b = m[y];
          if (Array.isArray(b)) {
            const C = c ? b.length - 1 : 0;
            b = b[C];
          }
          b !== null && (i[y] = b);
        }
        for (const y in v)
          i[y] = v[y];
      }
    }
  }
  return i;
}
const Kx = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
}), IZ = () => ({
  ...Kx(),
  attrs: {}
}), AZ = (t, r) => r && typeof t == "number" ? r.transform(t) : t, L9e = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, E9e = Fg.length;
function k9e(t, r, e) {
  let n = "", i = !0;
  for (let a = 0; a < E9e; a++) {
    const o = Fg[a], s = t[o];
    if (s === void 0)
      continue;
    let l = !0;
    if (typeof s == "number" ? l = s === (o.startsWith("scale") ? 1 : 0) : l = parseFloat(s) === 0, !l || e) {
      const u = AZ(s, Px[o]);
      if (!l) {
        i = !1;
        const c = L9e[o] || o;
        n += `${c}(${u}) `;
      }
      e && (r[o] = u);
    }
  }
  return n = n.trim(), e ? n = e(r, i ? "" : n) : i && (n = "none"), n;
}
function qx(t, r, e) {
  const { style: n, vars: i, transformOrigin: a } = t;
  let o = !1, s = !1;
  for (const l in r) {
    const u = r[l];
    if (sd.has(l)) {
      o = !0;
      continue;
    } else if (mW(l)) {
      i[l] = u;
      continue;
    } else {
      const c = AZ(u, Px[l]);
      l.startsWith("origin") ? (s = !0, a[l] = c) : n[l] = c;
    }
  }
  if (r.transform || (o || e ? n.transform = k9e(r, t.transform, e) : n.transform && (n.transform = "none")), s) {
    const { originX: l = "50%", originY: u = "50%", originZ: c = 0 } = a;
    n.transformOrigin = `${l} ${u} ${c}`;
  }
}
function KE(t, r, e) {
  return typeof t == "string" ? t : ot.transform(r + e * t);
}
function P9e(t, r, e) {
  const n = KE(r, t.x, t.width), i = KE(e, t.y, t.height);
  return `${n} ${i}`;
}
const N9e = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, O9e = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function V9e(t, r, e = 1, n = 0, i = !0) {
  t.pathLength = 1;
  const a = i ? N9e : O9e;
  t[a.offset] = ot.transform(-n);
  const o = ot.transform(r), s = ot.transform(e);
  t[a.array] = `${o} ${s}`;
}
function Qx(t, {
  attrX: r,
  attrY: e,
  attrScale: n,
  originX: i,
  originY: a,
  pathLength: o,
  pathSpacing: s = 1,
  pathOffset: l = 0,
  // This is object creation, which we try to avoid per-frame.
  ...u
}, c, d) {
  if (qx(t, u, d), c) {
    t.style.viewBox && (t.attrs.viewBox = t.style.viewBox);
    return;
  }
  t.attrs = t.style, t.style = {};
  const { attrs: f, style: h, dimensions: p } = t;
  f.transform && (p && (h.transform = f.transform), delete f.transform), p && (i !== void 0 || a !== void 0 || h.transform) && (h.transformOrigin = P9e(p, i !== void 0 ? i : 0.5, a !== void 0 ? a : 0.5)), r !== void 0 && (f.x = r), e !== void 0 && (f.y = e), n !== void 0 && (f.scale = n), o !== void 0 && V9e(f, o, s, l, !1);
}
const e8 = (t) => typeof t == "string" && t.toLowerCase() === "svg", G9e = {
  useVisualState: SZ({
    scrapeMotionValuesFromProps: xZ,
    createRenderState: IZ,
    onMount: (t, r, { renderState: e, latestValues: n }) => {
      br.read(() => {
        try {
          e.dimensions = typeof r.getBBox == "function" ? r.getBBox() : r.getBoundingClientRect();
        } catch {
          e.dimensions = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
          };
        }
      }), br.render(() => {
        Qx(e, n, e8(r.tagName), t.transformTemplate), wZ(r, e);
      });
    }
  })
}, B9e = {
  useVisualState: SZ({
    scrapeMotionValuesFromProps: Jx,
    createRenderState: Kx
  })
};
function DZ(t, r, e) {
  for (const n in r)
    !ri(r[n]) && !_Z(n, e) && (t[n] = r[n]);
}
function F9e({ transformTemplate: t }, r) {
  return Oc(() => {
    const e = Kx();
    return qx(e, r, t), Object.assign({}, e.vars, e.style);
  }, [r]);
}
function H9e(t, r) {
  const e = t.style || {}, n = {};
  return DZ(n, e, t), Object.assign(n, F9e(t, r)), n;
}
function z9e(t, r) {
  const e = {}, n = H9e(t, r);
  return t.drag && t.dragListener !== !1 && (e.draggable = !1, n.userSelect = n.WebkitUserSelect = n.WebkitTouchCallout = "none", n.touchAction = t.drag === !0 ? "none" : `pan-${t.drag === "x" ? "y" : "x"}`), t.tabIndex === void 0 && (t.onTap || t.onTapStart || t.whileTap) && (e.tabIndex = 0), e.style = n, e;
}
const W9e = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function Py(t) {
  return t.startsWith("while") || t.startsWith("drag") && t !== "draggable" || t.startsWith("layout") || t.startsWith("onTap") || t.startsWith("onPan") || t.startsWith("onLayout") || W9e.has(t);
}
let TZ = (t) => !Py(t);
function Z9e(t) {
  t && (TZ = (r) => r.startsWith("on") ? !Py(r) : t(r));
}
try {
  Z9e(require("@emotion/is-prop-valid").default);
} catch {
}
function j9e(t, r, e) {
  const n = {};
  for (const i in t)
    i === "values" && typeof t.values == "object" || (TZ(i) || e === !0 && Py(i) || !r && !Py(i) || // If trying to use native HTML drag events, forward drag listeners
    t.draggable && i.startsWith("onDrag")) && (n[i] = t[i]);
  return n;
}
function Y9e(t, r, e, n) {
  const i = Oc(() => {
    const a = IZ();
    return Qx(a, r, e8(n), t.transformTemplate), {
      ...a.attrs,
      style: { ...a.style }
    };
  }, [r]);
  if (t.style) {
    const a = {};
    DZ(a, t.style, t), i.style = { ...a, ...i.style };
  }
  return i;
}
function X9e(t = !1) {
  return (e, n, i, { latestValues: a }, o) => {
    const l = (Ux(e) ? Y9e : z9e)(n, a, o, e), u = j9e(n, typeof e == "string", t), c = e !== g7 ? { ...u, ...l, ref: i } : {}, { children: d } = n, f = Oc(() => ri(d) ? d.get() : d, [d]);
    return wc(e, {
      ...c,
      children: f
    });
  };
}
function $9e(t, r) {
  return function(n, { forwardMotionProps: i } = { forwardMotionProps: !1 }) {
    const o = {
      ...Ux(n) ? G9e : B9e,
      preloadedFeatures: t,
      useRender: X9e(i),
      createVisualElement: r,
      Component: n
    };
    return x9e(o);
  };
}
const F6 = { current: null }, MZ = { current: !1 };
function U9e() {
  if (MZ.current = !0, !!$x)
    if (window.matchMedia) {
      const t = window.matchMedia("(prefers-reduced-motion)"), r = () => F6.current = t.matches;
      t.addListener(r), r();
    } else
      F6.current = !1;
}
function J9e(t, r, e) {
  for (const n in r) {
    const i = r[n], a = e[n];
    if (ri(i))
      t.addValue(n, i), process.env.NODE_ENV === "development" && t5(i.version === "11.13.1", `Attempting to mix Motion versions ${i.version} with 11.13.1 may not work as expected.`);
    else if (ri(a))
      t.addValue(n, Kv(i, { owner: t }));
    else if (a !== i)
      if (t.hasValue(n)) {
        const o = t.getValue(n);
        o.liveStyle === !0 ? o.jump(i) : o.hasAnimated || o.set(i);
      } else {
        const o = t.getStaticValue(n);
        t.addValue(n, Kv(o !== void 0 ? o : i, { owner: t }));
      }
  }
  for (const n in e)
    r[n] === void 0 && t.removeValue(n);
  return r;
}
const qE = /* @__PURE__ */ new WeakMap(), K9e = [...CW, ei, cu], q9e = (t) => K9e.find(bW(t)), QE = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
class Q9e {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(r, e, n) {
    return {};
  }
  constructor({ parent: r, props: e, presenceContext: n, reducedMotionConfig: i, blockInitialAnimation: a, visualState: o }, s = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = Lx, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const f = $o.now();
      this.renderScheduledAt < f && (this.renderScheduledAt = f, br.render(this.render, !1, !0));
    };
    const { latestValues: l, renderState: u } = o;
    this.latestValues = l, this.baseTarget = { ...l }, this.initialValues = e.initial ? { ...l } : {}, this.renderState = u, this.parent = r, this.props = e, this.presenceContext = n, this.depth = r ? r.depth + 1 : 0, this.reducedMotionConfig = i, this.options = s, this.blockInitialAnimation = !!a, this.isControllingVariants = o5(e), this.isVariantNode = yZ(e), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(r && r.current);
    const { willChange: c, ...d } = this.scrapeMotionValuesFromProps(e, {}, this);
    for (const f in d) {
      const h = d[f];
      l[f] !== void 0 && ri(h) && h.set(l[f], !1);
    }
  }
  mount(r) {
    this.current = r, qE.set(r, this), this.projection && !this.projection.instance && this.projection.mount(r), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((e, n) => this.bindToMotionValue(n, e)), MZ.current || U9e(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : F6.current, process.env.NODE_ENV !== "production" && t5(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    qE.delete(this.current), this.projection && this.projection.unmount(), uu(this.notifyUpdate), uu(this.render), this.valueSubscriptions.forEach((r) => r()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const r in this.events)
      this.events[r].clear();
    for (const r in this.features) {
      const e = this.features[r];
      e && (e.unmount(), e.isMounted = !1);
    }
    this.current = null;
  }
  bindToMotionValue(r, e) {
    this.valueSubscriptions.has(r) && this.valueSubscriptions.get(r)();
    const n = sd.has(r), i = e.on("change", (s) => {
      this.latestValues[r] = s, this.props.onUpdate && br.preRender(this.notifyUpdate), n && this.projection && (this.projection.isTransformDirty = !0);
    }), a = e.on("renderRequest", this.scheduleRender);
    let o;
    window.MotionCheckAppearSync && (o = window.MotionCheckAppearSync(this, r, e)), this.valueSubscriptions.set(r, () => {
      i(), a(), o && o(), e.owner && e.stop();
    });
  }
  sortNodePosition(r) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== r.type ? 0 : this.sortInstanceNodePosition(this.current, r.current);
  }
  updateFeatures() {
    let r = "animation";
    for (r in Yf) {
      const e = Yf[r];
      if (!e)
        continue;
      const { isEnabled: n, Feature: i } = e;
      if (!this.features[r] && i && n(this.props) && (this.features[r] = new i(this)), this.features[r]) {
        const a = this.features[r];
        a.isMounted ? a.update() : (a.mount(), a.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : rn();
  }
  getStaticValue(r) {
    return this.latestValues[r];
  }
  setStaticValue(r, e) {
    this.latestValues[r] = e;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(r, e) {
    (r.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = r, this.prevPresenceContext = this.presenceContext, this.presenceContext = e;
    for (let n = 0; n < QE.length; n++) {
      const i = QE[n];
      this.propEventSubscriptions[i] && (this.propEventSubscriptions[i](), delete this.propEventSubscriptions[i]);
      const a = "on" + i, o = r[a];
      o && (this.propEventSubscriptions[i] = this.on(i, o));
    }
    this.prevMotionValues = J9e(this, this.scrapeMotionValuesFromProps(r, this.prevProps, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(r) {
    return this.props.variants ? this.props.variants[r] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(r) {
    const e = this.getClosestVariantNode();
    if (e)
      return e.variantChildren && e.variantChildren.add(r), () => e.variantChildren.delete(r);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(r, e) {
    const n = this.values.get(r);
    e !== n && (n && this.removeValue(r), this.bindToMotionValue(r, e), this.values.set(r, e), this.latestValues[r] = e.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(r) {
    this.values.delete(r);
    const e = this.valueSubscriptions.get(r);
    e && (e(), this.valueSubscriptions.delete(r)), delete this.latestValues[r], this.removeValueFromRenderState(r, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(r) {
    return this.values.has(r);
  }
  getValue(r, e) {
    if (this.props.values && this.props.values[r])
      return this.props.values[r];
    let n = this.values.get(r);
    return n === void 0 && e !== void 0 && (n = Kv(e === null ? void 0 : e, { owner: this }), this.addValue(r, n)), n;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(r, e) {
    var n;
    let i = this.latestValues[r] !== void 0 || !this.current ? this.latestValues[r] : (n = this.getBaseTargetFromProps(this.props, r)) !== null && n !== void 0 ? n : this.readValueFromInstance(this.current, r, this.options);
    return i != null && (typeof i == "string" && (vW(i) || pW(i)) ? i = parseFloat(i) : !q9e(i) && cu.test(e) && (i = TW(r, e)), this.setBaseTarget(r, ri(i) ? i.get() : i)), ri(i) ? i.get() : i;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(r, e) {
    this.baseTarget[r] = e;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(r) {
    var e;
    const { initial: n } = this.props;
    let i;
    if (typeof n == "string" || typeof n == "object") {
      const o = Sx(this.props, n, (e = this.presenceContext) === null || e === void 0 ? void 0 : e.custom);
      o && (i = o[r]);
    }
    if (n && i !== void 0)
      return i;
    const a = this.getBaseTargetFromProps(this.props, r);
    return a !== void 0 && !ri(a) ? a : this.initialValues[r] !== void 0 && i === void 0 ? void 0 : this.baseTarget[r];
  }
  on(r, e) {
    return this.events[r] || (this.events[r] = new Zx()), this.events[r].add(e);
  }
  notify(r, ...e) {
    this.events[r] && this.events[r].notify(...e);
  }
}
class RZ extends Q9e {
  constructor() {
    super(...arguments), this.KeyframeResolver = MW;
  }
  sortInstanceNodePosition(r, e) {
    return r.compareDocumentPosition(e) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(r, e) {
    return r.style ? r.style[e] : void 0;
  }
  removeValueFromRenderState(r, { vars: e, style: n }) {
    delete e[r], delete n[r];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: r } = this.props;
    ri(r) && (this.childSubscription = r.on("change", (e) => {
      this.current && (this.current.textContent = `${e}`);
    }));
  }
}
function e6e(t) {
  return window.getComputedStyle(t);
}
class t6e extends RZ {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = bZ;
  }
  readValueFromInstance(r, e) {
    if (sd.has(e)) {
      const n = Nx(e);
      return n && n.default || 0;
    } else {
      const n = e6e(r), i = (mW(e) ? n.getPropertyValue(e) : n[e]) || 0;
      return typeof i == "string" ? i.trim() : i;
    }
  }
  measureInstanceViewportBox(r, { transformPagePoint: e }) {
    return tZ(r, e);
  }
  build(r, e, n) {
    qx(r, e, n.transformTemplate);
  }
  scrapeMotionValuesFromProps(r, e, n) {
    return Jx(r, e, n);
  }
}
class r6e extends RZ {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = rn;
  }
  getBaseTargetFromProps(r, e) {
    return r[e];
  }
  readValueFromInstance(r, e) {
    if (sd.has(e)) {
      const n = Nx(e);
      return n && n.default || 0;
    }
    return e = CZ.has(e) ? e : jx(e), r.getAttribute(e);
  }
  scrapeMotionValuesFromProps(r, e, n) {
    return xZ(r, e, n);
  }
  build(r, e, n) {
    Qx(r, e, this.isSVGTag, n.transformTemplate);
  }
  renderInstance(r, e, n, i) {
    wZ(r, e, n, i);
  }
  mount(r) {
    this.isSVGTag = e8(r.tagName), super.mount(r);
  }
}
const n6e = (t, r) => Ux(t) ? new r6e(r) : new t6e(r, {
  allowProjection: t !== g7
}), i6e = /* @__PURE__ */ $9e({
  ...z4e,
  ...h9e,
  ...r9e,
  ...p9e
}, n6e), a6e = /* @__PURE__ */ Bbe(i6e), o6e = (t) => /* @__PURE__ */ $.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ $.createElement("path", { d: "M22 11.05L20.95 10L16 14.95L11.05 10L10 11.05L14.95 16L10 20.95L11.05 22L16 17.05L20.95 22L22 20.95L17.05 16L22 11.05Z", fill: "#253858" })), Wxe = (t) => {
  const {
    className: r = "",
    title: e,
    size: n = "md",
    onBackdropClick: i,
    closeButton: a = !1,
    onCloseButtonClick: o,
    footerButtons: s
  } = t;
  return Ue(() => (document.body.style.overflow = "hidden", () => {
    document.body.style.overflow = "auto";
  }), []), /* @__PURE__ */ S.jsx("div", { className: "theme-dialog-wrapper", children: /* @__PURE__ */ S.jsx(
    a6e.div,
    {
      className: "theme-dialog-backdrop",
      onClick: () => i && i(),
      initial: { opacity: 0 },
      animate: { opacity: 1 },
      exit: { opacity: 0 },
      children: /* @__PURE__ */ S.jsxs(
        "div",
        {
          onClick: (l) => l.stopPropagation(),
          className: `theme-dialog theme-dialog-${n} ${r}`,
          children: [
            a && /* @__PURE__ */ S.jsx(
              o6e,
              {
                className: "theme-dialog-close",
                onClick: () => o && o()
              }
            ),
            e && /* @__PURE__ */ S.jsx("div", { className: "theme-dialog-header", children: /* @__PURE__ */ S.jsx("h4", { children: e }) }),
            /* @__PURE__ */ S.jsx("div", { className: "theme-dialog-body", children: t.children }),
            s && /* @__PURE__ */ S.jsx("div", { className: "theme-dialog-footer", children: s })
          ]
        }
      )
    }
  ) });
};
var LZ = /* @__PURE__ */ ((t) => (t.IDLE = "idle", t.UPLOAD = "uploading", t.SUCCESS = "upload-success", t))(LZ || {});
const Zxe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DropzoneStateEnums: LZ
}, Symbol.toStringTag, { value: "Module" }));
var S4 = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var ek;
function s6e() {
  return ek || (ek = 1, function(t) {
    (function() {
      var r = {}.hasOwnProperty;
      function e() {
        for (var a = "", o = 0; o < arguments.length; o++) {
          var s = arguments[o];
          s && (a = i(a, n(s)));
        }
        return a;
      }
      function n(a) {
        if (typeof a == "string" || typeof a == "number")
          return a;
        if (typeof a != "object")
          return "";
        if (Array.isArray(a))
          return e.apply(null, a);
        if (a.toString !== Object.prototype.toString && !a.toString.toString().includes("[native code]"))
          return a.toString();
        var o = "";
        for (var s in a)
          r.call(a, s) && a[s] && (o = i(o, s));
        return o;
      }
      function i(a, o) {
        return o ? a ? a + " " + o : a + o : a;
      }
      t.exports ? (e.default = e, t.exports = e) : window.classNames = e;
    })();
  }(S4)), S4.exports;
}
var l6e = s6e();
const H6 = /* @__PURE__ */ Yy(l6e);
/*
* React Tooltip
* {@link https://github.com/ReactTooltip/react-tooltip}
* @copyright ReactTooltip Team
* @license MIT
*/
const u6e = "react-tooltip-core-styles", c6e = "react-tooltip-base-styles", tk = { core: !1, base: !1 };
function rk({ css: t, id: r = c6e, type: e = "base", ref: n }) {
  var i, a;
  if (!t || typeof document > "u" || tk[e] || e === "core" && typeof process < "u" && (!((i = process == null ? void 0 : process.env) === null || i === void 0) && i.REACT_TOOLTIP_DISABLE_CORE_STYLES) || e !== "base" && typeof process < "u" && (!((a = process == null ? void 0 : process.env) === null || a === void 0) && a.REACT_TOOLTIP_DISABLE_BASE_STYLES)) return;
  e === "core" && (r = u6e), n || (n = {});
  const { insertAt: o } = n;
  if (document.getElementById(r)) return;
  const s = document.head || document.getElementsByTagName("head")[0], l = document.createElement("style");
  l.id = r, l.type = "text/css", o === "top" && s.firstChild ? s.insertBefore(l, s.firstChild) : s.appendChild(l), l.styleSheet ? l.styleSheet.cssText = t : l.appendChild(document.createTextNode(t)), tk[e] = !0;
}
const nk = async ({ elementReference: t = null, tooltipReference: r = null, tooltipArrowReference: e = null, place: n = "top", offset: i = 10, strategy: a = "absolute", middlewares: o = [UH(Number(i)), JH({ fallbackAxisSideDirection: "start" }), e0e({ padding: 5 })], border: s }) => {
  if (!t) return { tooltipStyles: {}, tooltipArrowStyles: {}, place: n };
  if (r === null) return { tooltipStyles: {}, tooltipArrowStyles: {}, place: n };
  const l = o;
  return e ? (l.push(h6({ element: e, padding: 5 })), p6(t, r, { placement: n, strategy: a, middleware: l }).then(({ x: u, y: c, placement: d, middlewareData: f }) => {
    var h, p;
    const v = { left: `${u}px`, top: `${c}px`, border: s }, { x: g, y: m } = (h = f.arrow) !== null && h !== void 0 ? h : { x: 0, y: 0 }, y = (p = { top: "bottom", right: "left", bottom: "top", left: "right" }[d.split("-")[0]]) !== null && p !== void 0 ? p : "bottom", b = s && { borderBottom: s, borderRight: s };
    let C = 0;
    if (s) {
      const w = `${s}`.match(/(\d+)px/);
      C = w != null && w[1] ? Number(w[1]) : 1;
    }
    return { tooltipStyles: v, tooltipArrowStyles: { left: g != null ? `${g}px` : "", top: m != null ? `${m}px` : "", right: "", bottom: "", ...b, [y]: `-${4 + C}px` }, place: d };
  })) : p6(t, r, { placement: "bottom", strategy: a, middleware: l }).then(({ x: u, y: c, placement: d }) => ({ tooltipStyles: { left: `${u}px`, top: `${c}px` }, tooltipArrowStyles: {}, place: d }));
}, ik = (t, r) => !("CSS" in window && "supports" in window.CSS) || window.CSS.supports(t, r), ak = (t, r, e) => {
  let n = null;
  const i = function(...a) {
    const o = () => {
      n = null;
    };
    !n && (t.apply(this, a), n = setTimeout(o, r));
  };
  return i.cancel = () => {
    n && (clearTimeout(n), n = null);
  }, i;
}, ok = (t) => t !== null && !Array.isArray(t) && typeof t == "object", z6 = (t, r) => {
  if (t === r) return !0;
  if (Array.isArray(t) && Array.isArray(r)) return t.length === r.length && t.every((i, a) => z6(i, r[a]));
  if (Array.isArray(t) !== Array.isArray(r)) return !1;
  if (!ok(t) || !ok(r)) return t === r;
  const e = Object.keys(t), n = Object.keys(r);
  return e.length === n.length && e.every((i) => z6(t[i], r[i]));
}, d6e = (t) => {
  if (!(t instanceof HTMLElement || t instanceof SVGElement)) return !1;
  const r = getComputedStyle(t);
  return ["overflow", "overflow-x", "overflow-y"].some((e) => {
    const n = r.getPropertyValue(e);
    return n === "auto" || n === "scroll";
  });
}, sk = (t) => {
  if (!t) return null;
  let r = t.parentElement;
  for (; r; ) {
    if (d6e(r)) return r;
    r = r.parentElement;
  }
  return document.scrollingElement || document.documentElement;
}, f6e = typeof window < "u" ? ag : Ue, ha = (t) => {
  t.current && (clearTimeout(t.current), t.current = null);
}, h6e = "DEFAULT_TOOLTIP_ID", p6e = { anchorRefs: /* @__PURE__ */ new Set(), activeAnchor: { current: null }, attach: () => {
}, detach: () => {
}, setActiveAnchor: () => {
} }, v6e = Uc({ getTooltipData: () => p6e });
function EZ(t = h6e) {
  return zn(v6e).getTooltipData(t);
}
var Gd = { tooltip: "core-styles-module_tooltip__3vRRp", fixed: "core-styles-module_fixed__pcSol", arrow: "core-styles-module_arrow__cvMwQ", noArrow: "core-styles-module_noArrow__xock6", clickable: "core-styles-module_clickable__ZuTTB", show: "core-styles-module_show__Nt9eE", closing: "core-styles-module_closing__sGnxF" }, I4 = { tooltip: "styles-module_tooltip__mnnfp", arrow: "styles-module_arrow__K0L3T", dark: "styles-module_dark__xNqje", light: "styles-module_light__Z6W-X", success: "styles-module_success__A2AKt", warning: "styles-module_warning__SCK0X", error: "styles-module_error__JvumD", info: "styles-module_info__BWdHW" };
const g6e = ({ forwardRef: t, id: r, className: e, classNameArrow: n, variant: i = "dark", anchorId: a, anchorSelect: o, place: s = "top", offset: l = 10, events: u = ["hover"], openOnClick: c = !1, positionStrategy: d = "absolute", middlewares: f, wrapper: h, delayShow: p = 0, delayHide: v = 0, float: g = !1, hidden: m = !1, noArrow: y = !1, clickable: b = !1, closeOnEsc: C = !1, closeOnScroll: w = !1, closeOnResize: _ = !1, openEvents: x, closeEvents: I, globalCloseEvents: D, imperativeModeOnly: T, style: A, position: M, afterShow: R, afterHide: E, disableTooltip: k, content: P, contentWrapperRef: N, isOpen: O, defaultIsOpen: W = !1, setIsOpen: V, activeAnchor: B, setActiveAnchor: Z, border: q, opacity: z, arrowColor: U, role: J = "tooltip" }) => {
  var K;
  const j = Vt(null), oe = Vt(null), ie = Vt(null), le = Vt(null), re = Vt(null), [Re, ve] = We({ tooltipStyles: {}, tooltipArrowStyles: {}, place: s }), [Oe, qe] = We(!1), [dt, At] = We(!1), [Be, Nt] = We(null), wt = Vt(!1), Dt = Vt(null), { anchorRefs: Ot, setActiveAnchor: or } = EZ(r), $r = Vt(!1), [kr, Gr] = We([]), Dn = Vt(!1), dn = c || u.includes("click"), Pn = dn || (x == null ? void 0 : x.click) || (x == null ? void 0 : x.dblclick) || (x == null ? void 0 : x.mousedown), Tn = x ? { ...x } : { mouseover: !0, focus: !0, mouseenter: !1, click: !1, dblclick: !1, mousedown: !1 };
  !x && dn && Object.assign(Tn, { mouseenter: !1, focus: !1, mouseover: !1, click: !0 });
  const Gi = I ? { ...I } : { mouseout: !0, blur: !0, mouseleave: !1, click: !1, dblclick: !1, mouseup: !1 };
  !I && dn && Object.assign(Gi, { mouseleave: !1, blur: !1, mouseout: !1 });
  const de = D ? { ...D } : { escape: C || !1, scroll: w || !1, resize: _ || !1, clickOutsideAnchor: Pn || !1 };
  T && (Object.assign(Tn, { mouseenter: !1, focus: !1, click: !1, dblclick: !1, mousedown: !1 }), Object.assign(Gi, { mouseleave: !1, blur: !1, click: !1, dblclick: !1, mouseup: !1 }), Object.assign(de, { escape: !1, scroll: !1, resize: !1, clickOutsideAnchor: !1 })), f6e(() => (Dn.current = !0, () => {
    Dn.current = !1;
  }), []);
  const Kt = (Ie) => {
    Dn.current && (Ie && At(!0), setTimeout(() => {
      Dn.current && (V == null || V(Ie), O === void 0 && qe(Ie));
    }, 10));
  };
  Ue(() => {
    if (O === void 0) return () => null;
    O && At(!0);
    const Ie = setTimeout(() => {
      qe(O);
    }, 10);
    return () => {
      clearTimeout(Ie);
    };
  }, [O]), Ue(() => {
    if (Oe !== wt.current) if (ha(re), wt.current = Oe, Oe) R == null || R();
    else {
      const Ie = ((Xe) => {
        const it = Xe.match(/^([\d.]+)(ms|s)$/);
        if (!it) return 0;
        const [, hr, hn] = it;
        return Number(hr) * (hn === "ms" ? 1 : 1e3);
      })(getComputedStyle(document.body).getPropertyValue("--rt-transition-show-delay"));
      re.current = setTimeout(() => {
        At(!1), Nt(null), E == null || E();
      }, Ie + 25);
    }
  }, [Oe]);
  const fn = (Ie) => {
    ve((Xe) => z6(Xe, Ie) ? Xe : Ie);
  }, Ii = (Ie = p) => {
    ha(ie), dt ? Kt(!0) : ie.current = setTimeout(() => {
      Kt(!0);
    }, Ie);
  }, di = (Ie = v) => {
    ha(le), le.current = setTimeout(() => {
      $r.current || Kt(!1);
    }, Ie);
  }, Ai = (Ie) => {
    var Xe;
    if (!Ie) return;
    const it = (Xe = Ie.currentTarget) !== null && Xe !== void 0 ? Xe : Ie.target;
    if (!(it != null && it.isConnected)) return Z(null), void or({ current: null });
    p ? Ii() : Kt(!0), Z(it), or({ current: it }), ha(le);
  }, Br = () => {
    b ? di(v || 100) : v ? di() : Kt(!1), ha(ie);
  }, Nn = ({ x: Ie, y: Xe }) => {
    var it;
    const hr = { getBoundingClientRect: () => ({ x: Ie, y: Xe, width: 0, height: 0, top: Xe, left: Ie, right: Ie, bottom: Xe }) };
    nk({ place: (it = Be == null ? void 0 : Be.place) !== null && it !== void 0 ? it : s, offset: l, elementReference: hr, tooltipReference: j.current, tooltipArrowReference: oe.current, strategy: d, middlewares: f, border: q }).then((hn) => {
      fn(hn);
    });
  }, Tr = (Ie) => {
    if (!Ie) return;
    const Xe = Ie, it = { x: Xe.clientX, y: Xe.clientY };
    Nn(it), Dt.current = it;
  }, On = (Ie) => {
    var Xe;
    if (!Oe) return;
    const it = Ie.target;
    it.isConnected && (!((Xe = j.current) === null || Xe === void 0) && Xe.contains(it) || [document.querySelector(`[id='${a}']`), ...kr].some((hr) => hr == null ? void 0 : hr.contains(it)) || (Kt(!1), ha(ie)));
  }, Bi = ak(Ai, 50), Sr = ak(Br, 50), Mn = (Ie) => {
    Sr.cancel(), Bi(Ie);
  }, Ke = () => {
    Bi.cancel(), Sr();
  }, St = ns(() => {
    var Ie, Xe;
    const it = (Ie = Be == null ? void 0 : Be.position) !== null && Ie !== void 0 ? Ie : M;
    it ? Nn(it) : g ? Dt.current && Nn(Dt.current) : B != null && B.isConnected && nk({ place: (Xe = Be == null ? void 0 : Be.place) !== null && Xe !== void 0 ? Xe : s, offset: l, elementReference: B, tooltipReference: j.current, tooltipArrowReference: oe.current, strategy: d, middlewares: f, border: q }).then((hr) => {
      Dn.current && fn(hr);
    });
  }, [Oe, B, P, A, s, Be == null ? void 0 : Be.place, l, d, M, Be == null ? void 0 : Be.position, g]);
  Ue(() => {
    var Ie, Xe;
    const it = new Set(Ot);
    kr.forEach((Ct) => {
      k != null && k(Ct) || it.add({ current: Ct });
    });
    const hr = document.querySelector(`[id='${a}']`);
    hr && !(k != null && k(hr)) && it.add({ current: hr });
    const hn = () => {
      Kt(!1);
    }, $n = sk(B), Di = sk(j.current);
    de.scroll && (window.addEventListener("scroll", hn), $n == null || $n.addEventListener("scroll", hn), Di == null || Di.addEventListener("scroll", hn));
    let Fr = null;
    de.resize ? window.addEventListener("resize", hn) : B && j.current && (Fr = $H(B, j.current, St, { ancestorResize: !0, elementResize: !0, layoutShift: !0 }));
    const X = (Ct) => {
      Ct.key === "Escape" && Kt(!1);
    };
    de.escape && window.addEventListener("keydown", X), de.clickOutsideAnchor && window.addEventListener("click", On);
    const fe = [], Se = (Ct) => {
      Oe && (Ct == null ? void 0 : Ct.target) === B || Ai(Ct);
    }, at = (Ct) => {
      Oe && (Ct == null ? void 0 : Ct.target) === B && Br();
    }, Ft = ["mouseover", "mouseout", "mouseenter", "mouseleave", "focus", "blur"], $t = ["click", "dblclick", "mousedown", "mouseup"];
    Object.entries(Tn).forEach(([Ct, Zt]) => {
      Zt && (Ft.includes(Ct) ? fe.push({ event: Ct, listener: Mn }) : $t.includes(Ct) && fe.push({ event: Ct, listener: Se }));
    }), Object.entries(Gi).forEach(([Ct, Zt]) => {
      Zt && (Ft.includes(Ct) ? fe.push({ event: Ct, listener: Ke }) : $t.includes(Ct) && fe.push({ event: Ct, listener: at }));
    }), g && fe.push({ event: "pointermove", listener: Tr });
    const Rt = () => {
      $r.current = !0;
    }, bt = () => {
      $r.current = !1, Br();
    };
    return b && !Pn && ((Ie = j.current) === null || Ie === void 0 || Ie.addEventListener("mouseenter", Rt), (Xe = j.current) === null || Xe === void 0 || Xe.addEventListener("mouseleave", bt)), fe.forEach(({ event: Ct, listener: Zt }) => {
      it.forEach((Ar) => {
        var Ur;
        (Ur = Ar.current) === null || Ur === void 0 || Ur.addEventListener(Ct, Zt);
      });
    }), () => {
      var Ct, Zt;
      de.scroll && (window.removeEventListener("scroll", hn), $n == null || $n.removeEventListener("scroll", hn), Di == null || Di.removeEventListener("scroll", hn)), de.resize ? window.removeEventListener("resize", hn) : Fr == null || Fr(), de.clickOutsideAnchor && window.removeEventListener("click", On), de.escape && window.removeEventListener("keydown", X), b && !Pn && ((Ct = j.current) === null || Ct === void 0 || Ct.removeEventListener("mouseenter", Rt), (Zt = j.current) === null || Zt === void 0 || Zt.removeEventListener("mouseleave", bt)), fe.forEach(({ event: Ar, listener: Ur }) => {
        it.forEach((vo) => {
          var Ut;
          (Ut = vo.current) === null || Ut === void 0 || Ut.removeEventListener(Ar, Ur);
        });
      });
    };
  }, [B, St, dt, Ot, kr, x, I, D, dn, p, v]), Ue(() => {
    var Ie, Xe;
    let it = (Xe = (Ie = Be == null ? void 0 : Be.anchorSelect) !== null && Ie !== void 0 ? Ie : o) !== null && Xe !== void 0 ? Xe : "";
    !it && r && (it = `[data-tooltip-id='${r.replace(/'/g, "\\'")}']`);
    const hr = new MutationObserver((hn) => {
      const $n = [], Di = [];
      hn.forEach((Fr) => {
        if (Fr.type === "attributes" && Fr.attributeName === "data-tooltip-id" && (Fr.target.getAttribute("data-tooltip-id") === r ? $n.push(Fr.target) : Fr.oldValue === r && Di.push(Fr.target)), Fr.type === "childList") {
          if (B) {
            const X = [...Fr.removedNodes].filter((fe) => fe.nodeType === 1);
            if (it) try {
              Di.push(...X.filter((fe) => fe.matches(it))), Di.push(...X.flatMap((fe) => [...fe.querySelectorAll(it)]));
            } catch {
            }
            X.some((fe) => {
              var Se;
              return !!(!((Se = fe == null ? void 0 : fe.contains) === null || Se === void 0) && Se.call(fe, B)) && (At(!1), Kt(!1), Z(null), ha(ie), ha(le), !0);
            });
          }
          if (it) try {
            const X = [...Fr.addedNodes].filter((fe) => fe.nodeType === 1);
            $n.push(...X.filter((fe) => fe.matches(it))), $n.push(...X.flatMap((fe) => [...fe.querySelectorAll(it)]));
          } catch {
          }
        }
      }), ($n.length || Di.length) && Gr((Fr) => [...Fr.filter((X) => !Di.includes(X)), ...$n]);
    });
    return hr.observe(document.body, { childList: !0, subtree: !0, attributes: !0, attributeFilter: ["data-tooltip-id"], attributeOldValue: !0 }), () => {
      hr.disconnect();
    };
  }, [r, o, Be == null ? void 0 : Be.anchorSelect, B]), Ue(() => {
    St();
  }, [St]), Ue(() => {
    if (!(N != null && N.current)) return () => null;
    const Ie = new ResizeObserver(() => {
      setTimeout(() => St());
    });
    return Ie.observe(N.current), () => {
      Ie.disconnect();
    };
  }, [P, N == null ? void 0 : N.current]), Ue(() => {
    var Ie;
    const Xe = document.querySelector(`[id='${a}']`), it = [...kr, Xe];
    B && it.includes(B) || Z((Ie = kr[0]) !== null && Ie !== void 0 ? Ie : Xe);
  }, [a, kr, B]), Ue(() => (W && Kt(!0), () => {
    ha(ie), ha(le);
  }), []), Ue(() => {
    var Ie;
    let Xe = (Ie = Be == null ? void 0 : Be.anchorSelect) !== null && Ie !== void 0 ? Ie : o;
    if (!Xe && r && (Xe = `[data-tooltip-id='${r.replace(/'/g, "\\'")}']`), Xe) try {
      const it = Array.from(document.querySelectorAll(Xe));
      Gr(it);
    } catch {
      Gr([]);
    }
  }, [r, o, Be == null ? void 0 : Be.anchorSelect]), Ue(() => {
    ie.current && (ha(ie), Ii(p));
  }, [p]);
  const Ir = (K = Be == null ? void 0 : Be.content) !== null && K !== void 0 ? K : P, mn = Oe && Object.keys(Re.tooltipStyles).length > 0;
  return MP(t, () => ({ open: (Ie) => {
    if (Ie != null && Ie.anchorSelect) try {
      document.querySelector(Ie.anchorSelect);
    } catch {
      return void console.warn(`[react-tooltip] "${Ie.anchorSelect}" is not a valid CSS selector`);
    }
    Nt(Ie ?? null), Ie != null && Ie.delay ? Ii(Ie.delay) : Kt(!0);
  }, close: (Ie) => {
    Ie != null && Ie.delay ? di(Ie.delay) : Kt(!1);
  }, activeAnchor: B, place: Re.place, isOpen: !!(dt && !m && Ir && mn) })), dt && !m && Ir ? te.createElement(h, { id: r, role: J, className: H6("react-tooltip", Gd.tooltip, I4.tooltip, I4[i], e, `react-tooltip__place-${Re.place}`, Gd[mn ? "show" : "closing"], mn ? "react-tooltip__show" : "react-tooltip__closing", d === "fixed" && Gd.fixed, b && Gd.clickable), onTransitionEnd: (Ie) => {
    ha(re), Oe || Ie.propertyName !== "opacity" || (At(!1), Nt(null), E == null || E());
  }, style: { ...A, ...Re.tooltipStyles, opacity: z !== void 0 && mn ? z : void 0 }, ref: j }, Ir, te.createElement(h, { className: H6("react-tooltip-arrow", Gd.arrow, I4.arrow, n, y && Gd.noArrow), style: { ...Re.tooltipArrowStyles, background: U ? `linear-gradient(to right bottom, transparent 50%, ${U} 50%)` : void 0 }, ref: oe })) : null;
}, m6e = ({ content: t }) => te.createElement("span", { dangerouslySetInnerHTML: { __html: t } }), Si = te.forwardRef(({ id: t, anchorId: r, anchorSelect: e, content: n, html: i, render: a, className: o, classNameArrow: s, variant: l = "dark", place: u = "top", offset: c = 10, wrapper: d = "div", children: f = null, events: h = ["hover"], openOnClick: p = !1, positionStrategy: v = "absolute", middlewares: g, delayShow: m = 0, delayHide: y = 0, float: b = !1, hidden: C = !1, noArrow: w = !1, clickable: _ = !1, closeOnEsc: x = !1, closeOnScroll: I = !1, closeOnResize: D = !1, openEvents: T, closeEvents: A, globalCloseEvents: M, imperativeModeOnly: R = !1, style: E, position: k, isOpen: P, defaultIsOpen: N = !1, disableStyleInjection: O = !1, border: W, opacity: V, arrowColor: B, setIsOpen: Z, afterShow: q, afterHide: z, disableTooltip: U, role: J = "tooltip" }, K) => {
  const [j, oe] = We(n), [ie, le] = We(i), [re, Re] = We(u), [ve, Oe] = We(l), [qe, dt] = We(c), [At, Be] = We(m), [Nt, wt] = We(y), [Dt, Ot] = We(b), [or, $r] = We(C), [kr, Gr] = We(d), [Dn, dn] = We(h), [Pn, Tn] = We(v), [Gi, de] = We(null), [Kt, fn] = We(null), Ii = Vt(O), { anchorRefs: di, activeAnchor: Ai } = EZ(t), Br = (Sr) => Sr == null ? void 0 : Sr.getAttributeNames().reduce((Mn, Ke) => {
    var St;
    return Ke.startsWith("data-tooltip-") && (Mn[Ke.replace(/^data-tooltip-/, "")] = (St = Sr == null ? void 0 : Sr.getAttribute(Ke)) !== null && St !== void 0 ? St : null), Mn;
  }, {}), Nn = (Sr) => {
    const Mn = { place: (Ke) => {
      var St;
      Re((St = Ke) !== null && St !== void 0 ? St : u);
    }, content: (Ke) => {
      oe(Ke ?? n);
    }, html: (Ke) => {
      le(Ke ?? i);
    }, variant: (Ke) => {
      var St;
      Oe((St = Ke) !== null && St !== void 0 ? St : l);
    }, offset: (Ke) => {
      dt(Ke === null ? c : Number(Ke));
    }, wrapper: (Ke) => {
      var St;
      Gr((St = Ke) !== null && St !== void 0 ? St : d);
    }, events: (Ke) => {
      const St = Ke == null ? void 0 : Ke.split(" ");
      dn(St ?? h);
    }, "position-strategy": (Ke) => {
      var St;
      Tn((St = Ke) !== null && St !== void 0 ? St : v);
    }, "delay-show": (Ke) => {
      Be(Ke === null ? m : Number(Ke));
    }, "delay-hide": (Ke) => {
      wt(Ke === null ? y : Number(Ke));
    }, float: (Ke) => {
      Ot(Ke === null ? b : Ke === "true");
    }, hidden: (Ke) => {
      $r(Ke === null ? C : Ke === "true");
    }, "class-name": (Ke) => {
      de(Ke);
    } };
    Object.values(Mn).forEach((Ke) => Ke(null)), Object.entries(Sr).forEach(([Ke, St]) => {
      var Ir;
      (Ir = Mn[Ke]) === null || Ir === void 0 || Ir.call(Mn, St);
    });
  };
  Ue(() => {
    oe(n);
  }, [n]), Ue(() => {
    le(i);
  }, [i]), Ue(() => {
    Re(u);
  }, [u]), Ue(() => {
    Oe(l);
  }, [l]), Ue(() => {
    dt(c);
  }, [c]), Ue(() => {
    Be(m);
  }, [m]), Ue(() => {
    wt(y);
  }, [y]), Ue(() => {
    Ot(b);
  }, [b]), Ue(() => {
    $r(C);
  }, [C]), Ue(() => {
    Tn(v);
  }, [v]), Ue(() => {
    Ii.current !== O && console.warn("[react-tooltip] Do not change `disableStyleInjection` dynamically.");
  }, [O]), Ue(() => {
    typeof window < "u" && window.dispatchEvent(new CustomEvent("react-tooltip-inject-styles", { detail: { disableCore: O === "core", disableBase: O } }));
  }, []), Ue(() => {
    var Sr;
    const Mn = new Set(di);
    let Ke = e;
    if (!Ke && t && (Ke = `[data-tooltip-id='${t.replace(/'/g, "\\'")}']`), Ke) try {
      document.querySelectorAll(Ke).forEach((Xe) => {
        Mn.add({ current: Xe });
      });
    } catch {
      console.warn(`[react-tooltip] "${Ke}" is not a valid CSS selector`);
    }
    const St = document.querySelector(`[id='${r}']`);
    if (St && Mn.add({ current: St }), !Mn.size) return () => null;
    const Ir = (Sr = Kt ?? St) !== null && Sr !== void 0 ? Sr : Ai.current, mn = new MutationObserver((Xe) => {
      Xe.forEach((it) => {
        var hr;
        if (!Ir || it.type !== "attributes" || !(!((hr = it.attributeName) === null || hr === void 0) && hr.startsWith("data-tooltip-"))) return;
        const hn = Br(Ir);
        Nn(hn);
      });
    }), Ie = { attributes: !0, childList: !1, subtree: !1 };
    if (Ir) {
      const Xe = Br(Ir);
      Nn(Xe), mn.observe(Ir, Ie);
    }
    return () => {
      mn.disconnect();
    };
  }, [di, Ai, Kt, r, e]), Ue(() => {
    E != null && E.border && console.warn("[react-tooltip] Do not set `style.border`. Use `border` prop instead."), W && !ik("border", `${W}`) && console.warn(`[react-tooltip] "${W}" is not a valid \`border\`.`), E != null && E.opacity && console.warn("[react-tooltip] Do not set `style.opacity`. Use `opacity` prop instead."), V && !ik("opacity", `${V}`) && console.warn(`[react-tooltip] "${V}" is not a valid \`opacity\`.`);
  }, []);
  let Tr = f;
  const On = Vt(null);
  if (a) {
    const Sr = a({ content: (Kt == null ? void 0 : Kt.getAttribute("data-tooltip-content")) || j || null, activeAnchor: Kt });
    Tr = Sr ? te.createElement("div", { ref: On, className: "react-tooltip-content-wrapper" }, Sr) : null;
  } else j && (Tr = j);
  ie && (Tr = te.createElement(m6e, { content: ie }));
  const Bi = { forwardRef: K, id: t, anchorId: r, anchorSelect: e, className: H6(o, Gi), classNameArrow: s, content: Tr, contentWrapperRef: On, place: re, variant: ve, offset: qe, wrapper: kr, events: Dn, openOnClick: p, positionStrategy: Pn, middlewares: g, delayShow: At, delayHide: Nt, float: Dt, hidden: or, noArrow: w, clickable: _, closeOnEsc: x, closeOnScroll: I, closeOnResize: D, openEvents: T, closeEvents: A, globalCloseEvents: M, imperativeModeOnly: R, style: E, position: k, isOpen: P, defaultIsOpen: N, border: W, opacity: V, arrowColor: B, setIsOpen: Z, afterShow: q, afterHide: z, disableTooltip: U, activeAnchor: Kt, setActiveAnchor: (Sr) => fn(Sr), role: J };
  return te.createElement(g6e, { ...Bi });
});
typeof window < "u" && window.addEventListener("react-tooltip-inject-styles", (t) => {
  t.detail.disableCore || rk({ css: ":root{--rt-color-white:#fff;--rt-color-dark:#222;--rt-color-success:#8dc572;--rt-color-error:#be6464;--rt-color-warning:#f0ad4e;--rt-color-info:#337ab7;--rt-opacity:0.9;--rt-transition-show-delay:0.15s;--rt-transition-closing-delay:0.15s}.core-styles-module_tooltip__3vRRp{position:absolute;top:0;left:0;pointer-events:none;opacity:0;will-change:opacity}.core-styles-module_fixed__pcSol{position:fixed}.core-styles-module_arrow__cvMwQ{position:absolute;background:inherit}.core-styles-module_noArrow__xock6{display:none}.core-styles-module_clickable__ZuTTB{pointer-events:auto}.core-styles-module_show__Nt9eE{opacity:var(--rt-opacity);transition:opacity var(--rt-transition-show-delay)ease-out}.core-styles-module_closing__sGnxF{opacity:0;transition:opacity var(--rt-transition-closing-delay)ease-in}", type: "core" }), t.detail.disableBase || rk({ css: `
.styles-module_tooltip__mnnfp{padding:8px 16px;border-radius:3px;font-size:90%;width:max-content}.styles-module_arrow__K0L3T{width:8px;height:8px}[class*='react-tooltip__place-top']>.styles-module_arrow__K0L3T{transform:rotate(45deg)}[class*='react-tooltip__place-right']>.styles-module_arrow__K0L3T{transform:rotate(135deg)}[class*='react-tooltip__place-bottom']>.styles-module_arrow__K0L3T{transform:rotate(225deg)}[class*='react-tooltip__place-left']>.styles-module_arrow__K0L3T{transform:rotate(315deg)}.styles-module_dark__xNqje{background:var(--rt-color-dark);color:var(--rt-color-white)}.styles-module_light__Z6W-X{background-color:var(--rt-color-white);color:var(--rt-color-dark)}.styles-module_success__A2AKt{background-color:var(--rt-color-success);color:var(--rt-color-white)}.styles-module_warning__SCK0X{background-color:var(--rt-color-warning);color:var(--rt-color-white)}.styles-module_error__JvumD{background-color:var(--rt-color-error);color:var(--rt-color-white)}.styles-module_info__BWdHW{background-color:var(--rt-color-info);color:var(--rt-color-white)}`, type: "base" });
});
const kZ = (t) => {
  if (!t)
    return "";
  try {
    const e = new URL(t).pathname.split("/");
    return e[e.length - 1];
  } catch (r) {
    return console.log({ err: r }), t;
  }
}, Dr = (t) => /* @__PURE__ */ $.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ $.createElement("g", { id: "icon-info-outline" }, /* @__PURE__ */ $.createElement("path", { id: "ô´", d: "M8.9971 14.9942C8.17658 14.9942 7.40445 14.8374 6.6807 14.5239C5.95694 14.2143 5.31834 13.7828 4.76488 13.2293C4.21529 12.6759 3.78374 12.0373 3.47025 11.3135C3.15675 10.5897 3 9.81761 3 8.9971C3 8.17658 3.15675 7.40445 3.47025 6.6807C3.78374 5.95694 4.21529 5.32027 4.76488 4.77068C5.31834 4.21722 5.95501 3.78374 6.67489 3.47025C7.39865 3.15675 8.17078 3 8.99129 3C9.81568 3 10.5897 3.15675 11.3135 3.47025C12.0373 3.78374 12.6759 4.21722 13.2293 4.77068C13.7828 5.32027 14.2163 5.95694 14.5298 6.6807C14.8433 7.40445 15 8.17658 15 8.9971C15 9.81761 14.8433 10.5897 14.5298 11.3135C14.2163 12.0373 13.7828 12.6759 13.2293 13.2293C12.6759 13.7828 12.0373 14.2143 11.3135 14.5239C10.5897 14.8374 9.81761 14.9942 8.9971 14.9942ZM8.9971 13.8099C9.66667 13.8099 10.2917 13.686 10.8723 13.4383C11.4528 13.1906 11.9637 12.8462 12.4049 12.4049C12.8462 11.9637 13.1906 11.4528 13.4383 10.8723C13.686 10.2917 13.8099 9.66667 13.8099 8.9971C13.8099 8.3314 13.686 7.70827 13.4383 7.12772C13.1906 6.5433 12.8462 6.03048 12.4049 5.58926C11.9637 5.14804 11.4509 4.80358 10.8665 4.55588C10.2859 4.30818 9.66086 4.18433 8.99129 4.18433C8.32559 4.18433 7.70053 4.30818 7.11611 4.55588C6.53556 4.80358 6.02661 5.14804 5.58926 5.58926C5.15191 6.03048 4.80939 6.5433 4.56168 7.12772C4.31398 7.70827 4.19013 8.3314 4.19013 8.9971C4.19013 9.66667 4.31398 10.2917 4.56168 10.8723C4.80939 11.4528 5.15191 11.9637 5.58926 12.4049C6.03048 12.8462 6.54136 13.1906 7.12192 13.4383C7.70634 13.686 8.3314 13.8099 8.9971 13.8099ZM7.98113 12.1843C7.84954 12.1843 7.73924 12.1437 7.65022 12.0624C7.56507 11.9773 7.5225 11.8708 7.5225 11.7431C7.5225 11.6154 7.56507 11.5109 7.65022 11.4296C7.73924 11.3445 7.84954 11.3019 7.98113 11.3019H8.67199V8.87518H8.08563C7.95404 8.87518 7.84374 8.83454 7.75472 8.75327C7.6657 8.66812 7.62119 8.56168 7.62119 8.43396C7.62119 8.31011 7.6657 8.20561 7.75472 8.12046C7.84374 8.03532 7.95404 7.99274 8.08563 7.99274H9.17707C9.33962 7.99274 9.46154 8.04499 9.54282 8.14949C9.62796 8.25012 9.67054 8.38752 9.67054 8.56168V11.3019H10.3149C10.4465 11.3019 10.5549 11.3445 10.6401 11.4296C10.7291 11.5109 10.7736 11.6154 10.7736 11.7431C10.7736 11.8708 10.7291 11.9773 10.6401 12.0624C10.5549 12.1437 10.4465 12.1843 10.3149 12.1843H7.98113ZM8.96226 7.09289C8.74552 7.09289 8.55975 7.01742 8.40493 6.86647C8.25399 6.71166 8.17852 6.52588 8.17852 6.30914C8.17852 6.08853 8.25399 5.90276 8.40493 5.75181C8.55975 5.597 8.74552 5.51959 8.96226 5.51959C9.179 5.51959 9.36284 5.597 9.51379 5.75181C9.6686 5.90276 9.74601 6.08853 9.74601 6.30914C9.74601 6.52588 9.6686 6.71166 9.51379 6.86647C9.36284 7.01742 9.179 7.09289 8.96226 7.09289Z", fill: "#3548C9" }))), y6e = (t) => /* @__PURE__ */ $.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ $.createElement("g", { id: "icon-image-add" }, /* @__PURE__ */ $.createElement("path", { id: "ô", d: "M5.83984 16.7871C4.61523 16.7871 4 16.1836 4 14.9766V7.81641C4 6.60938 4.61523 6 5.83984 6H15.9766C17.207 6 17.8164 6.60938 17.8164 7.81641V11.1738C17.6641 11.1562 17.5059 11.1445 17.3477 11.1445C17.1895 11.1445 17.0312 11.1562 16.873 11.1738V7.86914C16.873 7.25977 16.5449 6.94336 15.9648 6.94336H5.85156C5.26562 6.94336 4.94336 7.25977 4.94336 7.86914V14.3438L6.68945 12.7617C6.92969 12.5391 7.18164 12.4336 7.44531 12.4336C7.7207 12.4336 7.99023 12.5449 8.23633 12.7676L9.32031 13.7461L11.9688 11.3789C12.2383 11.1387 12.5254 11.0273 12.8477 11.0273C13.1641 11.0273 13.4746 11.1504 13.7324 11.3906L14.6758 12.2754C13.9902 12.9492 13.5684 13.8867 13.5684 14.9238C13.5684 15.5977 13.7559 16.2363 14.0781 16.7871H5.83984ZM8.36523 11.4492C7.60352 11.4492 6.98242 10.8281 6.98242 10.0664C6.98242 9.31055 7.60352 8.68359 8.36523 8.68359C9.12109 8.68359 9.74219 9.31055 9.74219 10.0664C9.74219 10.8281 9.12109 11.4492 8.36523 11.4492ZM17.3535 17.9004C15.7188 17.9004 14.377 16.5586 14.377 14.9238C14.377 13.2891 15.7188 11.9473 17.3535 11.9473C18.9824 11.9473 20.3301 13.2891 20.3301 14.9238C20.3301 16.5469 18.9648 17.9004 17.3535 17.9004ZM17.3535 16.7871C17.5703 16.7871 17.7109 16.6406 17.7109 16.4238V15.2812H18.8535C19.0703 15.2812 19.2168 15.1406 19.2168 14.9238C19.2168 14.7012 19.0703 14.5605 18.8535 14.5605H17.7109V13.418C17.7109 13.207 17.5703 13.0605 17.3535 13.0605C17.1309 13.0605 16.9902 13.207 16.9902 13.418V14.5605H15.8477C15.6309 14.5605 15.4902 14.7012 15.4902 14.9238C15.4902 15.1406 15.6309 15.2812 15.8477 15.2812H16.9902V16.4238C16.9902 16.6406 17.1309 16.7871 17.3535 16.7871Z", fill: "#395278" }))), lk = (t) => /* @__PURE__ */ $.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ $.createElement("g", { id: "icon-close-circle-with shadow", clipPath: "url(#clip0_14267_59046)", filter: "url(#filter0_d_14267_59046)" }, /* @__PURE__ */ $.createElement("g", { id: "ô¡", filter: "url(#filter1_d_14267_59046)" }, /* @__PURE__ */ $.createElement("path", { d: "M16 20C11.6244 20 8 16.3833 8 12C8 7.62439 11.6167 4 15.9923 4C20.3756 4 24 7.62439 24 12C24 16.3833 20.3756 20 16 20ZM13.4598 15.2836C13.6689 15.2836 13.847 15.2062 13.9942 15.0668L16 13.0455L18.0213 15.0668C18.153 15.2062 18.3388 15.2836 18.5479 15.2836C18.9584 15.2836 19.2836 14.9584 19.2836 14.5402C19.2836 14.3466 19.2062 14.1684 19.0668 14.029L17.0455 12.0077L19.0745 9.9787C19.2217 9.83156 19.2836 9.66118 19.2836 9.46757C19.2836 9.05712 18.9661 8.73959 18.5634 8.73959C18.3543 8.73959 18.1917 8.80929 18.0445 8.95644L16 10.9855L13.971 8.96418C13.8316 8.82478 13.6689 8.75508 13.4598 8.75508C13.0494 8.75508 12.7318 9.06486 12.7318 9.47531C12.7318 9.66893 12.8093 9.84705 12.9487 9.98645L14.97 12.0077L12.9487 14.0368C12.8093 14.1762 12.7318 14.3543 12.7318 14.5402C12.7318 14.9584 13.0494 15.2836 13.4598 15.2836Z", fill: "white" }))), /* @__PURE__ */ $.createElement("defs", null, /* @__PURE__ */ $.createElement("filter", { id: "filter0_d_14267_59046", x: -4, y: -4, width: 40, height: 40, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ $.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ $.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ $.createElement("feOffset", { dy: 4 }), /* @__PURE__ */ $.createElement("feGaussianBlur", { stdDeviation: 4 }), /* @__PURE__ */ $.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ $.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" }), /* @__PURE__ */ $.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_14267_59046" }), /* @__PURE__ */ $.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_14267_59046", result: "shape" })), /* @__PURE__ */ $.createElement("filter", { id: "filter1_d_14267_59046", x: 0, y: -4, width: 32, height: 32, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ $.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ $.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ $.createElement("feOffset", null), /* @__PURE__ */ $.createElement("feGaussianBlur", { stdDeviation: 4 }), /* @__PURE__ */ $.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ $.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" }), /* @__PURE__ */ $.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_14267_59046" }), /* @__PURE__ */ $.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_14267_59046", result: "shape" })), /* @__PURE__ */ $.createElement("clipPath", { id: "clip0_14267_59046" }, /* @__PURE__ */ $.createElement("rect", { width: 24, height: 24, fill: "white", transform: "translate(4)" })))), b6e = (t) => /* @__PURE__ */ $.createElement("svg", { width: 30, height: 30, viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ $.createElement("g", { id: "icon-upload" }, /* @__PURE__ */ $.createElement("path", { id: "ô", d: "M18.063 18.4759H22.4943C24.3051 18.4759 25.1786 17.5842 25.1786 16.3012C25.1786 14.818 24.1504 13.8899 22.4761 13.5987C22.3487 13.5805 22.2941 13.5077 22.3123 13.3803C22.3578 12.9254 22.3942 12.3703 22.3669 11.8517C22.2304 9.23112 20.2286 7.02912 17.4352 7.02912C15.2241 7.02912 13.8774 8.20291 13.013 9.79527C12.9584 9.90446 12.8765 9.92266 12.7582 9.89536C10.7473 9.31301 8.85464 10.2411 8.94563 12.8981C8.95473 13.0346 8.89104 13.1074 8.76365 13.1074C6.94381 13.1074 5.80642 14.2357 5.80642 15.9281C5.80642 17.3294 6.85282 18.4759 8.72725 18.4759H12.831V20.505H8.72725C5.66993 20.505 3.75 18.485 3.75 15.9827C3.75 13.7534 5.04208 11.9973 7.14399 11.606C7.25319 9.03094 9.80096 7.36579 12.0303 7.89354C13.2041 6.21019 15.0512 5 17.4534 5C21.3205 5 24.3141 7.99363 24.3141 12.1429C26.134 12.8617 27.2441 14.454 27.2441 16.4377C27.2441 18.8035 25.4424 20.505 22.558 20.505H18.063V18.4759ZM15.4515 25C14.9329 25 14.5143 24.5723 14.5143 24.081V15.7916L14.6326 14.2084L14.0685 14.8908L12.8674 16.1101C12.7036 16.2739 12.4761 16.374 12.2486 16.374C11.8028 16.374 11.4297 16.0464 11.4297 15.5823C11.4297 15.3458 11.5116 15.1638 11.6845 15L14.7236 12.1429C14.9784 11.9154 15.1968 11.8244 15.4515 11.8244C15.6972 11.8244 15.9247 11.9154 16.1704 12.1429L19.2095 15C19.3824 15.1638 19.4643 15.3458 19.4643 15.5823C19.4643 16.0464 19.0821 16.374 18.6454 16.374C18.4179 16.374 18.1904 16.2739 18.0266 16.1101L16.8255 14.8908L16.2705 14.2084L16.3797 15.7916V24.081C16.3797 24.5723 15.9611 25 15.4515 25Z", fill: "#C0C9D5" }))), C6e = (t) => /* @__PURE__ */ $.createElement("svg", { width: 30, height: 30, viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ $.createElement("g", { id: "icon-upload" }, /* @__PURE__ */ $.createElement("path", { id: "ô", d: "M18.063 18.4759H22.4943C24.3051 18.4759 25.1786 17.5842 25.1786 16.3012C25.1786 14.818 24.1504 13.8899 22.4761 13.5987C22.3487 13.5805 22.2941 13.5077 22.3123 13.3803C22.3578 12.9254 22.3942 12.3703 22.3669 11.8517C22.2304 9.23112 20.2286 7.02912 17.4352 7.02912C15.2241 7.02912 13.8774 8.20291 13.013 9.79527C12.9584 9.90446 12.8765 9.92266 12.7582 9.89536C10.7473 9.31301 8.85464 10.2411 8.94563 12.8981C8.95473 13.0346 8.89104 13.1074 8.76365 13.1074C6.94381 13.1074 5.80642 14.2357 5.80642 15.9281C5.80642 17.3294 6.85282 18.4759 8.72725 18.4759H12.831V20.505H8.72725C5.66993 20.505 3.75 18.485 3.75 15.9827C3.75 13.7534 5.04208 11.9973 7.14399 11.606C7.25319 9.03094 9.80096 7.36579 12.0303 7.89354C13.2041 6.21019 15.0512 5 17.4534 5C21.3205 5 24.3141 7.99363 24.3141 12.1429C26.134 12.8617 27.2441 14.454 27.2441 16.4377C27.2441 18.8035 25.4424 20.505 22.558 20.505H18.063V18.4759ZM15.4515 25C14.9329 25 14.5143 24.5723 14.5143 24.081V15.7916L14.6326 14.2084L14.0685 14.8908L12.8674 16.1101C12.7036 16.2739 12.4761 16.374 12.2486 16.374C11.8028 16.374 11.4297 16.0464 11.4297 15.5823C11.4297 15.3458 11.5116 15.1638 11.6845 15L14.7236 12.1429C14.9784 11.9154 15.1968 11.8244 15.4515 11.8244C15.6972 11.8244 15.9247 11.9154 16.1704 12.1429L19.2095 15C19.3824 15.1638 19.4643 15.3458 19.4643 15.5823C19.4643 16.0464 19.0821 16.374 18.6454 16.374C18.4179 16.374 18.1904 16.2739 18.0266 16.1101L16.8255 14.8908L16.2705 14.2084L16.3797 15.7916V24.081C16.3797 24.5723 15.9611 25 15.4515 25Z", fill: "#E59CA5" }))), jxe = ({
  title: t,
  titleId: r,
  ...e
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    "aria-labelledby": r,
    ...e,
    children: [
      t ? /* @__PURE__ */ S.jsx("title", { id: r, children: t }) : null,
      /* @__PURE__ */ S.jsx("path", { d: "M5 12C5 11.4898 5.42652 11.0633 5.93668 11.0633H11.0633V5.93668C11.0633 5.42652 11.4898 5 12 5C12.5102 5 12.9367 5.42652 12.9367 5.93668V11.0633H18.0633C18.5735 11.0633 19 11.4898 19 12C19 12.5185 18.5735 12.9367 18.0633 12.9367H12.9367V18.0633C12.9367 18.5735 12.5102 19 12 19C11.4898 19 11.0633 18.5735 11.0633 18.0633V12.9367H5.93668C5.42652 12.9367 5 12.5185 5 12Z" })
    ]
  }
), Yxe = ({
  title: t,
  titleId: r,
  ...e
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 14 16",
    width: "14",
    height: "16",
    "aria-labelledby": r,
    ...e,
    children: [
      t ? /* @__PURE__ */ S.jsx("title", { id: r, children: t }) : null,
      /* @__PURE__ */ S.jsx("path", { d: "M6.99965 -2.19376e-06C7.25361 -2.20486e-06 7.49912 0.110051 7.68536 0.30476L13.2642 5.89206C13.4589 6.09524 13.552 6.31534 13.552 6.55238C13.552 7.07725 13.1711 7.4582 12.6631 7.4582C12.4007 7.4582 12.1721 7.35661 12.0113 7.1873L10.0896 5.291L7.80388 2.79365L7.9224 4.76613L7.9224 15.0603C7.9224 15.619 7.54145 16 6.99965 16C6.44938 16 6.0769 15.619 6.0769 15.0603L6.07689 4.76613L6.19541 2.80211L3.9097 5.291L1.98801 7.1873C1.81869 7.35661 1.59012 7.4582 1.32769 7.4582C0.819752 7.4582 0.447265 7.07725 0.447265 6.55238C0.447265 6.31534 0.531921 6.08677 0.743561 5.87513L6.31393 0.30476C6.49171 0.110051 6.74568 -2.18266e-06 6.99965 -2.19376e-06Z" })
    ]
  }
), Xxe = ({
  title: t,
  titleId: r,
  ...e
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    "aria-labelledby": r,
    ...e,
    children: [
      t ? /* @__PURE__ */ S.jsx("title", { id: r, children: t }) : null,
      /* @__PURE__ */ S.jsx("path", { d: "M6.14774 16.952C5.42565 16.952 5 16.5872 5 16.0323C5 15.2722 5.7677 14.5881 6.42898 13.9116C6.93064 13.3872 7.06746 12.3078 7.12827 11.4337C7.18147 8.51496 7.95677 6.50831 9.97862 5.77862C10.2599 4.7829 11.0504 4 12.1677 4C13.2926 4 14.0755 4.7829 14.3644 5.77862C16.3862 6.50831 17.1615 8.51496 17.2147 11.4337C17.2755 12.3078 17.4124 13.3872 17.914 13.9116C18.5677 14.5881 19.343 15.2722 19.343 16.0323C19.343 16.5872 18.9097 16.952 18.1952 16.952H6.14774ZM12.1677 20C10.8831 20 9.94062 19.0575 9.8418 17.9933H14.5012C14.4024 19.0575 13.4599 20 12.1677 20Z" })
    ]
  }
), $xe = ({
  title: t,
  titleId: r,
  ...e
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 40 40",
    width: "40",
    height: "40",
    "aria-labelledby": r,
    ...e,
    children: [
      t ? /* @__PURE__ */ S.jsx("title", { id: r, children: t }) : null,
      /* @__PURE__ */ S.jsx(
        "path",
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M9 25.7999C9 26.7356 9.69892 27.3668 10.86 27.3668H28.8628C30.0127 27.3668 30.7229 26.7356 30.7229 25.7999C30.7229 24.6458 29.6834 23.6418 28.6911 22.6833C28.6656 22.6587 28.6402 22.6342 28.6148 22.6097C27.8934 21.8995 27.6792 20.434 27.5777 19.1714C27.5439 18.4387 27.4876 17.7398 27.3974 17.0634C26.8112 17.3114 26.1574 17.458 25.481 17.458C22.4711 17.458 20.0023 14.9892 20.0023 11.9793C20.0023 10.5928 20.5322 9.3302 21.3889 8.37201C20.938 8.124 20.4194 8 19.8558 8C18.1874 8 16.9699 9.13856 16.5077 10.6266C13.5768 11.6862 12.3706 14.6059 12.2128 18.7543C12.0775 20.2311 11.8859 21.8431 11.0968 22.6097C11.08 22.6259 11.0631 22.6422 11.0463 22.6584C10.0466 23.6244 9 24.6359 9 25.7999ZM16.271 28.9338C16.4176 30.5796 17.8718 32 19.8671 32C21.8511 32 23.3053 30.5796 23.4519 28.9338H16.271Z"
        }
      ),
      /* @__PURE__ */ S.jsx("circle", { cx: "26", cy: "12", r: "4", fill: "#EB4553" })
    ]
  }
), Uxe = ({
  title: t,
  titleId: r,
  ...e
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    "aria-labelledby": r,
    ...e,
    children: [
      t ? /* @__PURE__ */ S.jsx("title", { id: r, children: t }) : null,
      /* @__PURE__ */ S.jsx("path", { d: "M6.58268 19.7008C4.88189 19.7008 4 18.8268 4 17.1417V7.55906C4 5.87402 4.88189 5 6.58268 5H17.4173C19.1181 5 20 5.87402 20 7.55906V17.1417C20 18.8189 19.1181 19.7008 17.4173 19.7008H6.58268ZM6.55906 18.1575H17.4252C18.0866 18.1575 18.4567 17.811 18.4567 17.126V9.85039C18.4567 9.15748 18.0866 8.8189 17.4252 8.8189H6.55906C5.90551 8.8189 5.54331 9.15748 5.54331 9.85039V17.126C5.54331 17.811 5.90551 18.1575 6.55906 18.1575ZM10.4803 11.5512C10.2047 11.5512 10.1102 11.4646 10.1102 11.1811V10.7244C10.1102 10.4409 10.2047 10.3543 10.4803 10.3543H10.9449C11.2283 10.3543 11.3228 10.4409 11.3228 10.7244V11.1811C11.3228 11.4646 11.2283 11.5512 10.9449 11.5512H10.4803ZM13.063 11.5512C12.7795 11.5512 12.685 11.4646 12.685 11.1811V10.7244C12.685 10.4409 12.7795 10.3543 13.063 10.3543H13.5197C13.8032 10.3543 13.8976 10.4409 13.8976 10.7244V11.1811C13.8976 11.4646 13.8032 11.5512 13.5197 11.5512H13.063ZM15.6378 11.5512C15.3543 11.5512 15.2598 11.4646 15.2598 11.1811V10.7244C15.2598 10.4409 15.3543 10.3543 15.6378 10.3543H16.0945C16.378 10.3543 16.4724 10.4409 16.4724 10.7244V11.1811C16.4724 11.4646 16.378 11.5512 16.0945 11.5512H15.6378ZM7.90551 14.0866C7.62992 14.0866 7.53543 14 7.53543 13.7165V13.2598C7.53543 12.9764 7.62992 12.8898 7.90551 12.8898H8.37008C8.65354 12.8898 8.74803 12.9764 8.74803 13.2598V13.7165C8.74803 14 8.65354 14.0866 8.37008 14.0866H7.90551ZM10.4803 14.0866C10.2047 14.0866 10.1102 14 10.1102 13.7165V13.2598C10.1102 12.9764 10.2047 12.8898 10.4803 12.8898H10.9449C11.2283 12.8898 11.3228 12.9764 11.3228 13.2598V13.7165C11.3228 14 11.2283 14.0866 10.9449 14.0866H10.4803ZM13.063 14.0866C12.7795 14.0866 12.685 14 12.685 13.7165V13.2598C12.685 12.9764 12.7795 12.8898 13.063 12.8898H13.5197C13.8032 12.8898 13.8976 12.9764 13.8976 13.2598V13.7165C13.8976 14 13.8032 14.0866 13.5197 14.0866H13.063ZM15.6378 14.0866C15.3543 14.0866 15.2598 14 15.2598 13.7165V13.2598C15.2598 12.9764 15.3543 12.8898 15.6378 12.8898H16.0945C16.378 12.8898 16.4724 12.9764 16.4724 13.2598V13.7165C16.4724 14 16.378 14.0866 16.0945 14.0866H15.6378ZM7.90551 16.622C7.62992 16.622 7.53543 16.5354 7.53543 16.252V15.7953C7.53543 15.5118 7.62992 15.4252 7.90551 15.4252H8.37008C8.65354 15.4252 8.74803 15.5118 8.74803 15.7953V16.252C8.74803 16.5354 8.65354 16.622 8.37008 16.622H7.90551ZM10.4803 16.622C10.2047 16.622 10.1102 16.5354 10.1102 16.252V15.7953C10.1102 15.5118 10.2047 15.4252 10.4803 15.4252H10.9449C11.2283 15.4252 11.3228 15.5118 11.3228 15.7953V16.252C11.3228 16.5354 11.2283 16.622 10.9449 16.622H10.4803ZM13.063 16.622C12.7795 16.622 12.685 16.5354 12.685 16.252V15.7953C12.685 15.5118 12.7795 15.4252 13.063 15.4252H13.5197C13.8032 15.4252 13.8976 15.5118 13.8976 15.7953V16.252C13.8976 16.5354 13.8032 16.622 13.5197 16.622H13.063Z" })
    ]
  }
), Jxe = ({
  title: t,
  titleId: r,
  ...e
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    "aria-labelledby": r,
    ...e,
    children: [
      t ? /* @__PURE__ */ S.jsx("title", { id: r, children: t }) : null,
      /* @__PURE__ */ S.jsx("path", { d: "M12 20C7.61266 20 4 16.3873 4 12C4 7.62033 7.61266 4 11.9923 4C16.3797 4 20 7.62033 20 12C20 16.3873 16.3873 20 12 20ZM11.1486 15.8121C11.4554 15.8121 11.7239 15.6587 11.908 15.3826L15.4899 9.85235C15.605 9.67594 15.697 9.46884 15.697 9.28476C15.697 8.85523 15.3135 8.55609 14.8993 8.55609C14.6309 8.55609 14.4008 8.70949 14.2167 8.99329L11.1256 13.9329L9.70662 12.1534C9.50719 11.908 9.30777 11.8082 9.05465 11.8082C8.62512 11.8082 8.28763 12.1534 8.28763 12.5829C8.28763 12.79 8.35666 12.9741 8.51007 13.1659L10.3586 15.3902C10.5887 15.674 10.8341 15.8121 11.1486 15.8121Z" })
    ]
  }
), Kxe = ({
  title: t,
  titleId: r,
  ...e
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    "aria-labelledby": r,
    ...e,
    children: [
      t ? /* @__PURE__ */ S.jsx("title", { id: r, children: t }) : null,
      /* @__PURE__ */ S.jsx("path", { d: "M10.9219 18.168C10.4844 18.168 10.1562 18.0107 9.8623 17.6621L6.33496 13.3896C6.08887 13.1094 6 12.8564 6 12.5693C6 11.9268 6.47852 11.4551 7.1416 11.4551C7.52441 11.4551 7.79785 11.5918 8.05078 11.8926L10.8877 15.4131L16.4795 6.59473C16.7529 6.16406 17.0332 6 17.4844 6C18.1406 6 18.6191 6.46484 18.6191 7.10742C18.6191 7.34668 18.5439 7.59961 18.3662 7.87305L11.9951 17.6143C11.749 17.9902 11.3867 18.168 10.9219 18.168Z" })
    ]
  }
), qxe = ({
  title: t,
  titleId: r,
  ...e
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    "aria-labelledby": r,
    ...e,
    children: [
      t ? /* @__PURE__ */ S.jsx("title", { id: r, children: t }) : null,
      /* @__PURE__ */ S.jsx("path", { d: "M6.29476 13.345L11.1419 8.38646C11.4105 8.1179 11.679 8 12 8C12.3275 8 12.6026 8.12445 12.8581 8.38646L17.7052 13.345C17.9017 13.5415 18 13.7773 18 14.0655C18 14.6485 17.5349 15.1201 16.9585 15.1201C16.6769 15.1201 16.4017 15.0087 16.1921 14.786L12.0066 10.4694L7.81441 14.786C7.59825 15.0022 7.32969 15.1201 7.04148 15.1201C6.46507 15.1201 6 14.6485 6 14.0655C6 13.7838 6.09825 13.5415 6.29476 13.345Z" })
    ]
  }
), Qxe = ({
  title: t,
  titleId: r,
  ...e
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    "aria-labelledby": r,
    ...e,
    children: [
      t ? /* @__PURE__ */ S.jsx("title", { id: r, children: t }) : null,
      /* @__PURE__ */ S.jsx("path", { d: "M4.74297 17.2508C4.28023 16.7961 4.29619 15.9903 4.72701 15.5594L9.29054 10.9959L4.72701 6.44833C4.29619 6.00953 4.28023 5.21171 4.74297 4.74898C5.2057 4.27826 6.0115 4.29422 6.44232 4.73302L10.9979 9.28858L15.5534 4.73302C16.0002 4.28624 16.7821 4.28624 17.2448 4.74898C17.7155 5.21171 17.7155 5.99358 17.2608 6.44833L12.7132 10.9959L17.2608 15.5515C17.7155 16.0062 17.7076 16.7801 17.2448 17.2508C16.7901 17.7136 16.0002 17.7136 15.5534 17.2668L10.9979 12.7112L6.44232 17.2668C6.0115 17.7056 5.21368 17.7136 4.74297 17.2508Z" })
    ]
  }
), e8e = ({
  title: t,
  titleId: r,
  ...e
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    "aria-labelledby": r,
    ...e,
    children: [
      t ? /* @__PURE__ */ S.jsx("title", { id: r, children: t }) : null,
      /* @__PURE__ */ S.jsx("path", { d: "M8.73593 20C7.63713 20 6.9424 19.3478 6.89278 18.2561L6.41072 8.03367H5.62384C5.28356 8.03367 5 7.76429 5 7.40984C5 7.06247 5.28356 6.79309 5.62384 6.79309H8.77138V5.72973C8.77138 4.6451 9.46611 4 10.6358 4H13.3296C14.5064 4 15.1941 4.6451 15.1941 5.72973V6.79309H18.3487C18.7031 6.79309 18.9796 7.06247 18.9796 7.40984C18.9796 7.76429 18.7031 8.03367 18.3487 8.03367H17.5689L17.0868 18.249C17.0372 19.3407 16.3354 20 15.2508 20H8.73593ZM10.0758 5.79353V6.79309H13.8897V5.79353C13.8897 5.4249 13.6345 5.19096 13.2375 5.19096H10.728C10.331 5.19096 10.0758 5.4249 10.0758 5.79353ZM9.81347 17.8024C10.1254 17.8024 10.331 17.6039 10.3168 17.3132L10.097 9.60744C10.0899 9.30261 9.87727 9.1183 9.58662 9.1183C9.2747 9.1183 9.07621 9.3097 9.0833 9.60744L9.29597 17.3203C9.31015 17.6181 9.50864 17.8024 9.81347 17.8024ZM11.9898 17.8024C12.2946 17.8024 12.5073 17.611 12.5073 17.3203V9.60744C12.5073 9.3097 12.2946 9.1183 11.9898 9.1183C11.685 9.1183 11.4723 9.3097 11.4723 9.60744V17.3203C11.4723 17.611 11.685 17.8024 11.9898 17.8024ZM14.1662 17.8024C14.4639 17.8024 14.6624 17.6181 14.6766 17.3203L14.8963 9.60744C14.9034 9.3097 14.7049 9.1183 14.393 9.1183C14.0953 9.1183 13.8897 9.3097 13.8826 9.60744L13.6557 17.3132C13.6486 17.611 13.8542 17.8024 14.1662 17.8024Z" })
    ]
  }
), t8e = ({
  title: t,
  titleId: r,
  ...e
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    "aria-labelledby": r,
    ...e,
    children: [
      t ? /* @__PURE__ */ S.jsx("title", { id: r, children: t }) : null,
      /* @__PURE__ */ S.jsx("path", { d: "M13.8203 14.1874H17.1702C18.5391 14.1874 19.1995 13.5133 19.1995 12.5434C19.1995 11.4222 18.4222 10.7206 17.1565 10.5004C17.0602 10.4867 17.0189 10.4316 17.0327 10.3353C17.0671 9.9914 17.0946 9.5718 17.0739 9.17971C16.9708 7.19862 15.4574 5.53396 13.3457 5.53396C11.6741 5.53396 10.6561 6.42132 10.0026 7.62511C9.96131 7.70765 9.8994 7.72141 9.80997 7.70077C8.28977 7.26053 6.85898 7.96217 6.92777 9.97077C6.93465 10.0739 6.8865 10.129 6.7902 10.129C5.41445 10.129 4.5546 10.9819 4.5546 12.2614C4.5546 13.3207 5.34566 14.1874 6.76268 14.1874H9.865V15.7214H6.76268C4.45142 15.7214 3 14.1943 3 12.3027C3 10.6174 3.97678 9.28977 5.56578 8.99398C5.64832 7.04729 7.57438 5.78848 9.25967 6.18745C10.147 4.91488 11.5434 4 13.3594 4C16.2829 4 18.546 6.26311 18.546 9.39983C19.9218 9.94325 20.761 11.147 20.761 12.6466C20.761 14.4351 19.399 15.7214 17.2184 15.7214H13.8203V14.1874ZM11.8461 20C11.6535 20 11.4884 19.9381 11.2958 19.7592L8.99828 17.5993C8.86758 17.4755 8.80567 17.3379 8.80567 17.1591C8.80567 16.8083 9.0877 16.5606 9.42476 16.5606C9.59673 16.5606 9.7687 16.6363 9.89252 16.767L10.8005 17.6819L11.227 18.1978L11.1376 17.1797V11.2915C11.1376 10.92 11.454 10.6036 11.8461 10.6036C12.2313 10.6036 12.5477 10.92 12.5477 11.2915V17.1797L12.4652 18.1978L12.8848 17.6819L13.7928 16.767C13.9166 16.6363 14.0886 16.5606 14.2605 16.5606C14.5907 16.5606 14.8796 16.8083 14.8796 17.1591C14.8796 17.3379 14.8177 17.4755 14.687 17.5993L12.3895 19.7592C12.2038 19.9381 12.0318 20 11.8461 20Z" })
    ]
  }
), r8e = ({
  title: t,
  titleId: r,
  ...e
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    "aria-labelledby": r,
    ...e,
    children: [
      t ? /* @__PURE__ */ S.jsx("title", { id: r, children: t }) : null,
      /* @__PURE__ */ S.jsx("path", { d: "M19.3679 6.70346L17.2673 4.61369L18.4475 3.45511C19.0214 2.89206 19.671 2.83793 20.2016 3.36849L20.6239 3.79077C21.1545 4.33216 21.122 4.97101 20.5373 5.55571L19.3679 6.70346ZM6.15793 19.8917L3.54843 20.8879C3.23442 21.007 2.89876 20.6605 3.02869 20.3465L4.07899 17.802L16.2495 5.64233L18.3284 7.72127L6.15793 19.8917Z" })
    ]
  }
), n8e = ({
  title: t,
  titleId: r,
  ...e
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    "aria-labelledby": r,
    ...e,
    children: [
      t ? /* @__PURE__ */ S.jsx("title", { id: r, children: t }) : null,
      /* @__PURE__ */ S.jsx("path", { d: "M18.9534 5.04665C19.837 5.93029 20 7.13995 20 8.70134V15.2815C20 16.8515 19.837 18.0611 18.9534 18.9448C18.0697 19.8198 16.8515 19.9914 15.2901 19.9914H8.70992C7.14853 19.9914 5.93029 19.8198 5.03807 18.9448C4.163 18.0611 4 16.8515 4 15.2815V8.68418C4 7.13995 4.163 5.93029 5.04665 5.04665C5.92172 4.17158 7.14853 4 8.68418 4H15.2901C16.8515 4 18.0697 4.163 18.9534 5.04665ZM18.3185 8.46971C18.3185 7.57748 18.207 6.75389 17.7265 6.28204C17.2461 5.80161 16.4139 5.67292 15.5303 5.67292H8.48686C7.58606 5.67292 6.74531 5.79303 6.26488 6.27346C5.79303 6.75389 5.6815 7.57748 5.6815 8.48686V15.5217C5.6815 16.4139 5.79303 17.229 6.27346 17.7094C6.75389 18.1898 7.58606 18.3099 8.46971 18.3099H15.5303C16.4139 18.3099 17.2461 18.1898 17.7265 17.7094C18.1984 17.229 18.3185 16.4139 18.3185 15.5217V8.46971ZM14.681 14.2263C14.252 14.2263 13.9689 13.9346 13.9689 13.4627V12.0901L14.0976 10.8547L12.9394 12.1158L9.94531 15.1099C9.78231 15.2643 9.60214 15.3501 9.36193 15.3501C8.93298 15.3501 8.61555 15.0499 8.61555 14.6038C8.61555 14.3979 8.70992 14.2005 8.85576 14.0547L11.867 11.0434L13.1367 9.87668L11.9614 10.0139H10.5115C10.0483 10.0139 9.74799 9.73941 9.74799 9.31046C9.74799 8.8815 10.0483 8.60697 10.5029 8.60697H14.518C15.0499 8.60697 15.3844 8.87292 15.3844 9.46488V13.4542C15.3844 13.9088 15.1013 14.2263 14.681 14.2263Z" })
    ]
  }
), i8e = ({
  title: t,
  titleId: r,
  ...e
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    "aria-labelledby": r,
    ...e,
    children: [
      t ? /* @__PURE__ */ S.jsx("title", { id: r, children: t }) : null,
      /* @__PURE__ */ S.jsx("path", { d: "M12.3447 17.7168C6.88965 17.7168 3 13.2529 3 11.8584C3 10.457 6.89648 6 12.3447 6C17.8613 6 21.6826 10.457 21.6826 11.8584C21.6826 13.2529 17.8682 17.7168 12.3447 17.7168ZM12.3447 16.6367C16.8291 16.6367 20.4863 12.8223 20.4863 11.8584C20.4863 11.0449 16.8291 7.08008 12.3447 7.08008C7.83984 7.08008 4.19629 11.0449 4.19629 11.8584C4.19629 12.8223 7.83984 16.6367 12.3447 16.6367ZM12.3447 15.6865C10.2051 15.6865 8.49609 13.9434 8.49609 11.8584C8.49609 9.71875 10.2051 8.03027 12.3447 8.03027C14.4707 8.03027 16.1797 9.71875 16.1797 11.8584C16.1797 13.9434 14.4707 15.6865 12.3447 15.6865ZM12.3447 13.1299C13.0488 13.1299 13.623 12.5557 13.623 11.8584C13.623 11.1543 13.0488 10.5869 12.3447 10.5869C11.6338 10.5869 11.0596 11.1543 11.0596 11.8584C11.0596 12.5557 11.6338 13.1299 12.3447 13.1299Z" })
    ]
  }
), a8e = ({
  title: t,
  titleId: r,
  ...e
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    "aria-labelledby": r,
    ...e,
    children: [
      t ? /* @__PURE__ */ S.jsx("title", { id: r, children: t }) : null,
      /* @__PURE__ */ S.jsx("path", { d: "M17.6631 18.3218L6.22656 6.89893C6.02832 6.70068 6.02832 6.35205 6.22656 6.15381C6.43848 5.94873 6.77344 5.94873 6.97852 6.15381L18.4082 17.5767C18.6133 17.7886 18.6338 18.0962 18.4082 18.3218C18.1963 18.5474 17.8682 18.5337 17.6631 18.3218ZM12.3447 6.54346C17.8682 6.54346 21.6826 11.0005 21.6826 12.4019C21.6826 13.2085 20.3975 15.0474 18.2373 16.4487L17.3965 15.6079C19.29 14.4458 20.4863 12.9556 20.4863 12.4019C20.4863 11.5884 16.8428 7.62354 12.3447 7.62354C11.4971 7.62354 10.7246 7.75342 9.97266 7.979L9.07031 7.0835C10.0752 6.74854 11.1553 6.54346 12.3447 6.54346ZM12.3447 18.2603C6.88965 18.2603 3 13.7964 3 12.4019C3 11.5747 4.35352 9.68115 6.62988 8.27295L7.47754 9.12061C5.46094 10.3306 4.19629 11.9233 4.19629 12.4019C4.19629 13.3657 7.83984 17.1802 12.3447 17.1802C13.2676 17.1802 14.1289 17.0298 14.9424 16.7769L15.8379 17.6724C14.7783 18.0347 13.6162 18.2603 12.3447 18.2603ZM15.8516 13.8989L10.8408 8.88818C11.2988 8.68994 11.8047 8.57373 12.3447 8.57373C14.4707 8.57373 16.1797 10.2622 16.1797 12.4019C16.1797 12.9282 16.0635 13.4409 15.8516 13.8989ZM12.3447 16.23C10.2051 16.23 8.50293 14.4868 8.49609 12.4019C8.49609 11.7866 8.63965 11.2124 8.89258 10.7065L14.0195 15.8335C13.5137 16.0796 12.9463 16.23 12.3447 16.23Z" })
    ]
  }
), o8e = ({
  title: t,
  titleId: r,
  ...e
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    "aria-labelledby": r,
    ...e,
    children: [
      t ? /* @__PURE__ */ S.jsx("title", { id: r, children: t }) : null,
      /* @__PURE__ */ S.jsx("path", { d: "M11.8536 11.5395C11.411 11.5395 11.1896 11.3372 11.1896 10.9326C11.1896 10.9183 11.1896 10.9064 11.1896 10.8969C11.1896 10.8826 11.1896 10.8684 11.1896 10.8541C11.1896 10.5304 11.2706 10.2663 11.4324 10.0616C11.5942 9.85691 11.8013 9.6689 12.0535 9.49755C12.3534 9.28812 12.5771 9.112 12.7247 8.96921C12.877 8.82642 12.9531 8.64079 12.9531 8.41232C12.9531 8.17433 12.8651 7.97918 12.689 7.82686C12.5129 7.67455 12.2796 7.59839 11.9893 7.59839C11.8465 7.59839 11.7132 7.62219 11.5895 7.66979C11.4705 7.71263 11.361 7.77927 11.261 7.8697C11.1611 7.95538 11.0707 8.06247 10.9897 8.19099L10.8755 8.33378C10.8089 8.42898 10.7279 8.50275 10.6328 8.55511C10.5423 8.60747 10.4352 8.63365 10.3115 8.63365C10.1687 8.63365 10.0402 8.58605 9.92593 8.49085C9.81645 8.3909 9.76171 8.25524 9.76171 8.08389C9.76171 8.01725 9.76647 7.95538 9.77599 7.89826C9.79027 7.83638 9.80693 7.77689 9.82597 7.71977C9.93545 7.38658 10.1853 7.101 10.5756 6.86301C10.9707 6.62502 11.4705 6.50602 12.075 6.50602C12.4891 6.50602 12.8699 6.57742 13.2173 6.72021C13.5695 6.86301 13.8504 7.07244 14.0598 7.34851C14.274 7.61981 14.3811 7.95062 14.3811 8.34092C14.3811 8.75502 14.2764 9.08345 14.0669 9.32619C13.8575 9.56418 13.5791 9.79741 13.2316 10.0259C12.9984 10.1782 12.8199 10.3234 12.6961 10.4614C12.5771 10.5947 12.5129 10.7541 12.5033 10.9398C12.5033 10.954 12.501 10.9683 12.4962 10.9826C12.4962 10.9969 12.4962 11.0112 12.4962 11.0254C12.4867 11.1682 12.4248 11.2896 12.3106 11.3896C12.1963 11.4895 12.044 11.5395 11.8536 11.5395ZM11.8322 13.6885C11.6133 13.6885 11.4229 13.6148 11.261 13.4672C11.0992 13.3196 11.0183 13.1364 11.0183 12.9174C11.0183 12.6985 11.0968 12.5176 11.2539 12.3748C11.4157 12.2273 11.6085 12.1535 11.8322 12.1535C12.0607 12.1535 12.2558 12.2273 12.4177 12.3748C12.5795 12.5176 12.6604 12.6985 12.6604 12.9174C12.6604 13.1412 12.5795 13.3268 12.4177 13.4743C12.2558 13.6171 12.0607 13.6885 11.8322 13.6885ZM8.59795 19.0433C8.31236 19.0433 8.08865 18.9505 7.92682 18.7648C7.76975 18.5792 7.69121 18.3269 7.69121 18.008V16.2517H7.30567C6.6155 16.2517 6.02291 16.1184 5.52789 15.8519C5.03763 15.5853 4.65923 15.2045 4.39268 14.7095C4.13089 14.2097 4 13.6052 4 12.896V7.35564C4 6.64644 4.13089 6.04433 4.39268 5.54931C4.65447 5.04953 5.03287 4.66637 5.52789 4.39982C6.02767 4.13327 6.63692 4 7.35564 4H16.6444C17.3583 4 17.9652 4.13327 18.465 4.39982C18.9647 4.66637 19.3455 5.04953 19.6073 5.54931C19.8691 6.04433 20 6.64644 20 7.35564V12.896C20 13.6052 19.8691 14.2097 19.6073 14.7095C19.3455 15.2045 18.9647 15.5853 18.465 15.8519C17.9652 16.1184 17.3583 16.2517 16.6444 16.2517H12.232L9.79027 18.415C9.54752 18.6292 9.33809 18.7863 9.16198 18.8862C8.98587 18.9909 8.79786 19.0433 8.59795 19.0433ZM8.94779 17.4654L11.2111 15.2236C11.3634 15.0712 11.5038 14.9713 11.6323 14.9237C11.7656 14.8713 11.9417 14.8452 12.1606 14.8452H16.6015C17.2774 14.8452 17.7772 14.6786 18.1008 14.3454C18.4293 14.0074 18.5935 13.5077 18.5935 12.8461V7.39848C18.5935 6.74163 18.4293 6.24662 18.1008 5.91343C17.7772 5.57549 17.2774 5.40651 16.6015 5.40651H7.39134C6.72021 5.40651 6.22044 5.57549 5.89201 5.91343C5.56835 6.24662 5.40651 6.74163 5.40651 7.39848V12.8461C5.40651 13.5077 5.56835 14.0074 5.89201 14.3454C6.22044 14.6786 6.72021 14.8452 7.39134 14.8452H8.36948C8.56939 14.8452 8.71456 14.8904 8.805 14.9808C8.90019 15.0665 8.94779 15.2164 8.94779 15.4306V17.4654Z" })
    ]
  }
), s8e = ({
  title: t,
  titleId: r,
  ...e
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    "aria-labelledby": r,
    ...e,
    children: [
      t ? /* @__PURE__ */ S.jsx("title", { id: r, children: t }) : null,
      /* @__PURE__ */ S.jsx("path", { d: "M4.54588 10.8678H5.54269C6.2143 7.53798 9.1906 5 12.6971 5C16.6985 5 20 8.30857 20 12.3029C20 16.3043 16.6985 19.6058 12.6971 19.6058C10.4066 19.6058 8.26448 18.4534 6.95661 16.7426C6.64554 16.3679 6.70917 15.9154 7.03437 15.6821C7.38078 15.4347 7.79082 15.5408 8.0736 15.873C9.14111 17.2728 10.8025 18.1636 12.6971 18.1706C15.9562 18.1777 18.5649 15.5549 18.5649 12.3029C18.5649 9.05087 15.9562 6.4422 12.6971 6.4422C9.93997 6.4422 7.64236 8.31564 7.01316 10.8678H8.03118C8.57554 10.8678 8.71693 11.2849 8.42001 11.6878L6.70917 14.0703C6.47587 14.3955 6.10826 14.4026 5.86789 14.0703L4.15705 11.6949C3.85306 11.2778 3.99445 10.8678 4.54588 10.8678ZM12.4285 8.08234C12.7961 8.08234 13.1001 8.37926 13.1001 8.74688V12.4938L14.7685 14.756C15.0159 15.1024 14.9947 15.5054 14.6766 15.7246C14.3302 15.9579 13.9484 15.8942 13.6656 15.5266L11.9548 13.2643C11.8134 13.0876 11.7639 12.925 11.7639 12.7553V8.74688C11.7639 8.37926 12.0609 8.08234 12.4285 8.08234Z" })
    ]
  }
), l8e = ({
  title: t,
  titleId: r,
  ...e
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    "aria-labelledby": r,
    ...e,
    children: [
      t ? /* @__PURE__ */ S.jsx("title", { id: r, children: t }) : null,
      /* @__PURE__ */ S.jsx(
        "path",
        {
          id: "ô",
          d: "M5.83984 16.7871C4.61523 16.7871 4 16.1836 4 14.9766V7.81641C4 6.60938 4.61523 6 5.83984 6H15.9766C17.207 6 17.8164 6.60938 17.8164 7.81641V11.1738C17.6641 11.1562 17.5059 11.1445 17.3477 11.1445C17.1895 11.1445 17.0312 11.1562 16.873 11.1738V7.86914C16.873 7.25977 16.5449 6.94336 15.9648 6.94336H5.85156C5.26562 6.94336 4.94336 7.25977 4.94336 7.86914V14.3438L6.68945 12.7617C6.92969 12.5391 7.18164 12.4336 7.44531 12.4336C7.7207 12.4336 7.99023 12.5449 8.23633 12.7676L9.32031 13.7461L11.9688 11.3789C12.2383 11.1387 12.5254 11.0273 12.8477 11.0273C13.1641 11.0273 13.4746 11.1504 13.7324 11.3906L14.6758 12.2754C13.9902 12.9492 13.5684 13.8867 13.5684 14.9238C13.5684 15.5977 13.7559 16.2363 14.0781 16.7871H5.83984ZM8.36523 11.4492C7.60352 11.4492 6.98242 10.8281 6.98242 10.0664C6.98242 9.31055 7.60352 8.68359 8.36523 8.68359C9.12109 8.68359 9.74219 9.31055 9.74219 10.0664C9.74219 10.8281 9.12109 11.4492 8.36523 11.4492ZM17.3535 17.9004C15.7188 17.9004 14.377 16.5586 14.377 14.9238C14.377 13.2891 15.7188 11.9473 17.3535 11.9473C18.9824 11.9473 20.3301 13.2891 20.3301 14.9238C20.3301 16.5469 18.9648 17.9004 17.3535 17.9004ZM17.3535 16.7871C17.5703 16.7871 17.7109 16.6406 17.7109 16.4238V15.2812H18.8535C19.0703 15.2812 19.2168 15.1406 19.2168 14.9238C19.2168 14.7012 19.0703 14.5605 18.8535 14.5605H17.7109V13.418C17.7109 13.207 17.5703 13.0605 17.3535 13.0605C17.1309 13.0605 16.9902 13.207 16.9902 13.418V14.5605H15.8477C15.6309 14.5605 15.4902 14.7012 15.4902 14.9238C15.4902 15.1406 15.6309 15.2812 15.8477 15.2812H16.9902V16.4238C16.9902 16.6406 17.1309 16.7871 17.3535 16.7871Z"
        }
      )
    ]
  }
), u8e = ({
  title: t,
  titleId: r,
  ...e
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    "aria-labelledby": r,
    ...e,
    children: [
      t ? /* @__PURE__ */ S.jsx("title", { id: r, children: t }) : null,
      /* @__PURE__ */ S.jsx("path", { d: "M11.9961 19.9923C10.9021 19.9923 9.8726 19.7833 8.9076 19.3653C7.94259 18.9524 7.09111 18.377 6.35317 17.6391C5.62038 16.9011 5.04499 16.0497 4.627 15.0847C4.209 14.1197 4 13.0901 4 11.9961C4 10.9021 4.209 9.8726 4.627 8.9076C5.04499 7.94259 5.62038 7.09369 6.35317 6.36091C7.09111 5.62296 7.94001 5.04499 8.89985 4.627C9.86486 4.209 10.8944 4 11.9884 4C13.0876 4 14.1197 4.209 15.0847 4.627C16.0497 5.04499 16.9011 5.62296 17.6391 6.36091C18.377 7.09369 18.955 7.94259 19.373 8.9076C19.791 9.8726 20 10.9021 20 11.9961C20 13.0901 19.791 14.1197 19.373 15.0847C18.955 16.0497 18.377 16.9011 17.6391 17.6391C16.9011 18.377 16.0497 18.9524 15.0847 19.3653C14.1197 19.7833 13.0901 19.9923 11.9961 19.9923ZM11.9961 18.4132C12.8889 18.4132 13.7223 18.248 14.4964 17.9178C15.2704 17.5875 15.9516 17.1282 16.5399 16.5399C17.1282 15.9516 17.5875 15.2704 17.9178 14.4964C18.248 13.7223 18.4132 12.8889 18.4132 11.9961C18.4132 11.1085 18.248 10.2777 17.9178 9.50363C17.5875 8.7244 17.1282 8.04064 16.5399 7.45235C15.9516 6.86405 15.2679 6.40477 14.4886 6.0745C13.7146 5.74423 12.8811 5.5791 11.9884 5.5791C11.1008 5.5791 10.2674 5.74423 9.48815 6.0745C8.71408 6.40477 8.03548 6.86405 7.45235 7.45235C6.86921 8.04064 6.41251 8.7244 6.08224 9.50363C5.75198 10.2777 5.58684 11.1085 5.58684 11.9961C5.58684 12.8889 5.75198 13.7223 6.08224 14.4964C6.41251 15.2704 6.86921 15.9516 7.45235 16.5399C8.04064 17.1282 8.72182 17.5875 9.49589 17.9178C10.2751 18.248 11.1085 18.4132 11.9961 18.4132ZM10.6415 16.2458C10.4661 16.2458 10.319 16.1916 10.2003 16.0832C10.0868 15.9697 10.03 15.8278 10.03 15.6575C10.03 15.4872 10.0868 15.3478 10.2003 15.2395C10.319 15.1259 10.4661 15.0692 10.6415 15.0692H11.5627V11.8336H10.7808C10.6054 11.8336 10.4583 11.7794 10.3396 11.671C10.2209 11.5575 10.1616 11.4156 10.1616 11.2453C10.1616 11.0801 10.2209 10.9408 10.3396 10.8273C10.4583 10.7138 10.6054 10.657 10.7808 10.657H12.2361C12.4528 10.657 12.6154 10.7267 12.7238 10.866C12.8373 11.0002 12.894 11.1834 12.894 11.4156V15.0692H13.7533C13.9287 15.0692 14.0732 15.1259 14.1867 15.2395C14.3054 15.3478 14.3648 15.4872 14.3648 15.6575C14.3648 15.8278 14.3054 15.9697 14.1867 16.0832C14.0732 16.1916 13.9287 16.2458 13.7533 16.2458H10.6415ZM11.9497 9.45718C11.6607 9.45718 11.413 9.35655 11.2066 9.1553C11.0053 8.94888 10.9047 8.70118 10.9047 8.41219C10.9047 8.11805 11.0053 7.87034 11.2066 7.66909C11.413 7.46267 11.6607 7.35946 11.9497 7.35946C12.2387 7.35946 12.4838 7.46267 12.6851 7.66909C12.8915 7.87034 12.9947 8.11805 12.9947 8.41219C12.9947 8.70118 12.8915 8.94888 12.6851 9.1553C12.4838 9.35655 12.2387 9.45718 11.9497 9.45718Z" })
    ]
  }
), c8e = ({
  title: t,
  titleId: r,
  ...e
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    "aria-labelledby": r,
    ...e,
    children: [
      t ? /* @__PURE__ */ S.jsx("title", { id: r, children: t }) : null,
      /* @__PURE__ */ S.jsx("path", { d: "M13.0256 20V12.4284L19.9309 8.53272C19.9602 8.66453 19.9748 8.82807 19.9748 9.02334V14.8668C19.9748 15.3892 19.8845 15.7822 19.7039 16.0458C19.5281 16.3045 19.2621 16.5339 18.9057 16.7341L13.238 19.9195C13.1989 19.939 13.1623 19.9561 13.1281 19.9707C13.094 19.9854 13.0598 19.9951 13.0256 20ZM11.9492 20C11.915 19.9951 11.8809 19.9854 11.8467 19.9707C11.8174 19.9561 11.7832 19.939 11.7442 19.9195L6.06911 16.7341C5.71762 16.5339 5.45156 16.3045 5.27094 16.0458C5.09031 15.7822 5 15.3892 5 14.8668V9.02334C5 8.82807 5.01709 8.66453 5.05126 8.53272L11.9492 12.4284V20ZM12.4911 11.4764L5.53455 7.5881C5.65172 7.4807 5.80061 7.37818 5.98124 7.28055L8.61739 5.79405L15.6032 9.73364L12.4911 11.4764ZM16.7236 9.11121L9.70114 5.17895L11.1071 4.39542C11.5709 4.13181 12.0322 4 12.4911 4C12.95 4 13.4088 4.13181 13.8677 4.39542L19.0082 7.28055C19.184 7.37818 19.328 7.4807 19.4403 7.5881L16.7236 9.11121Z" })
    ]
  }
), d8e = ({
  title: t,
  titleId: r,
  ...e
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    "aria-labelledby": r,
    ...e,
    children: [
      t ? /* @__PURE__ */ S.jsx("title", { id: r, children: t }) : null,
      /* @__PURE__ */ S.jsx("path", { d: "M6.04918 16.612C5.70431 16.4177 5.44202 16.1919 5.2623 15.9344C5.08743 15.677 5 15.2933 5 14.7832V8.88889C5 8.5003 5.07529 8.17729 5.22587 7.91985C5.37644 7.65756 5.61445 7.43655 5.93989 7.25683L11.0619 4.38616C11.5137 4.12872 11.9678 4 12.4244 4C12.881 4 13.3327 4.12872 13.7796 4.38616L18.9016 7.25683C19.2271 7.43655 19.4651 7.65756 19.6157 7.91985C19.7662 8.17729 19.8415 8.5003 19.8415 8.88889V14.7832C19.8415 15.2933 19.7541 15.677 19.5792 15.9344C19.4044 16.1919 19.1421 16.4177 18.7923 16.612L13.0291 19.8324C12.8251 19.9441 12.6211 20 12.4171 20C12.218 20 12.0188 19.9441 11.8197 19.8324L6.04918 16.612ZM6.83607 15.49L11.7468 18.2587V12.4153L6.2969 9.34062V14.6521C6.2969 14.8415 6.33576 15.0018 6.41348 15.133C6.49605 15.2593 6.63692 15.3783 6.83607 15.49ZM18.0055 15.49C18.2046 15.3783 18.343 15.2593 18.4208 15.133C18.5033 15.0018 18.5446 14.8415 18.5446 14.6521V9.34062L13.0947 12.4153V18.2587L18.0055 15.49ZM12.4244 11.2204L14.4572 10.0765L9.06557 7.05282L7.04007 8.20401L12.4244 11.2204ZM15.8415 9.31148L17.8087 8.20401L13.204 5.6102C12.6891 5.3139 12.167 5.3139 11.6375 5.6102L10.4353 6.2878L15.8415 9.31148Z" })
    ]
  }
), w6e = ({
  title: t,
  titleId: r,
  ...e
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25",
    ...e,
    children: [
      t ? /* @__PURE__ */ S.jsx("title", { id: r, children: t }) : null,
      /* @__PURE__ */ S.jsx("path", { d: "M12.3969 4.5C9.30088 4.5 6.79688 7.004 6.79688 10.1C6.79688 14.3 12.3969 20.5 12.3969 20.5C12.3969 20.5 17.9969 14.3 17.9969 10.1C17.9969 7.004 15.4929 4.5 12.3969 4.5Z" }),
      /* @__PURE__ */ S.jsx(
        "path",
        {
          d: "M12.3984 12.1016C13.503 12.1016 14.3984 11.2061 14.3984 10.1016C14.3984 8.99699 13.503 8.10156 12.3984 8.10156C11.2939 8.10156 10.3984 8.99699 10.3984 10.1016C10.3984 11.2061 11.2939 12.1016 12.3984 12.1016Z",
          fill: "white"
        }
      )
    ]
  }
), f8e = ({
  title: t,
  titleId: r,
  ...e
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 40 40",
    width: "40",
    height: "40",
    "aria-labelledby": r,
    ...e,
    children: [
      t ? /* @__PURE__ */ S.jsx("title", { id: r, children: t }) : null,
      /* @__PURE__ */ S.jsx("path", { d: "M10.1796 15.1049C8.81887 15.1049 8 14.286 8 12.865V10.2398C8 8.83091 8.81887 8 10.1796 8H12.9132C14.286 8 15.0928 8.83091 15.0928 10.2398V12.865C15.0928 14.286 14.286 15.1049 12.9132 15.1049H10.1796ZM18.8741 15.1049C17.5013 15.1049 16.6944 14.286 16.6944 12.865V10.2398C16.6944 8.83091 17.5013 8 18.8741 8H21.6076C22.9804 8 23.7873 8.83091 23.7873 10.2398V12.865C23.7873 14.286 22.9804 15.1049 21.6076 15.1049H18.8741ZM27.5805 15.1049C26.2077 15.1049 25.3889 14.286 25.3889 12.865V10.2398C25.3889 8.83091 26.2077 8 27.5805 8H30.3141C31.6749 8 32.4937 8.83091 32.4937 10.2398V12.865C32.4937 14.286 31.6749 15.1049 30.3141 15.1049H27.5805ZM10.1796 23.5464C8.81887 23.5464 8 22.7396 8 21.3307V18.6814C8 17.2725 8.81887 16.4656 10.1796 16.4656H12.9132C14.286 16.4656 15.0928 17.2725 15.0928 18.6814V21.3307C15.0928 22.7396 14.286 23.5464 12.9132 23.5464H10.1796ZM18.8741 23.5464C17.5013 23.5464 16.6944 22.7396 16.6944 21.3307V18.6814C16.6944 17.2725 17.5013 16.4656 18.8741 16.4656H21.6076C22.9804 16.4656 23.7873 17.2725 23.7873 18.6814V21.3307C23.7873 22.7396 22.9804 23.5464 21.6076 23.5464H18.8741ZM27.5805 23.5464C26.2077 23.5464 25.3889 22.7396 25.3889 21.3307V18.6814C25.3889 17.2725 26.2077 16.4656 27.5805 16.4656H30.3141C31.6749 16.4656 32.4937 17.2725 32.4937 18.6814V21.3307C32.4937 22.7396 31.6749 23.5464 30.3141 23.5464H27.5805ZM10.1796 32C8.81887 32 8 31.1811 8 29.7722V27.135C8 25.726 8.81887 24.9072 10.1796 24.9072H12.9132C14.286 24.9072 15.0928 25.726 15.0928 27.135V29.7722C15.0928 31.1811 14.286 32 12.9132 32H10.1796ZM18.8741 32C17.5013 32 16.6944 31.1811 16.6944 29.7722V27.135C16.6944 25.726 17.5013 24.9072 18.8741 24.9072H21.6076C22.9804 24.9072 23.7873 25.726 23.7873 27.135V29.7722C23.7873 31.1811 22.9804 32 21.6076 32H18.8741ZM27.5805 32C26.2077 32 25.3889 31.1811 25.3889 29.7722V27.135C25.3889 25.726 26.2077 24.9072 27.5805 24.9072H30.3141C31.6749 24.9072 32.4937 25.726 32.4937 27.135V29.7722C32.4937 31.1811 31.6749 32 30.3141 32H27.5805Z" })
    ]
  }
), h8e = ({
  title: t,
  titleId: r,
  ...e
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    "aria-labelledby": r,
    ...e,
    children: [
      t ? /* @__PURE__ */ S.jsx("title", { id: r, children: t }) : null,
      /* @__PURE__ */ S.jsx("path", { d: "M13.4105 18.2905C13.4105 18.6105 13.3347 18.8996 13.1832 19.1579C13.026 19.4161 12.8182 19.6211 12.56 19.7726C12.3018 19.9242 12.0182 20 11.7095 20C11.3951 20 11.1088 19.9242 10.8505 19.7726C10.5923 19.6211 10.3874 19.4161 10.2358 19.1579C10.0786 18.8996 10 18.6105 10 18.2905C10 17.9818 10.0786 17.6982 10.2358 17.44C10.3874 17.1818 10.5923 16.9768 10.8505 16.8253C11.1088 16.6737 11.3951 16.5979 11.7095 16.5979C12.0182 16.5979 12.3018 16.6737 12.56 16.8253C12.8182 16.9768 13.026 17.1818 13.1832 17.44C13.3347 17.6982 13.4105 17.9818 13.4105 18.2905ZM13.4105 12C13.4105 12.3144 13.3347 12.6007 13.1832 12.8589C13.026 13.1172 12.8182 13.3249 12.56 13.4821C12.3018 13.6337 12.0182 13.7095 11.7095 13.7095C11.3951 13.7095 11.1088 13.6337 10.8505 13.4821C10.5923 13.3249 10.3874 13.1172 10.2358 12.8589C10.0786 12.6007 10 12.3144 10 12C10 11.6856 10.0786 11.4021 10.2358 11.1495C10.3874 10.8912 10.5923 10.6863 10.8505 10.5347C11.1088 10.3775 11.3951 10.2989 11.7095 10.2989C12.0182 10.2989 12.3018 10.3775 12.56 10.5347C12.8182 10.6863 13.026 10.8912 13.1832 11.1495C13.3347 11.4021 13.4105 11.6856 13.4105 12ZM13.4105 5.70947C13.4105 6.02386 13.3347 6.31018 13.1832 6.56842C13.026 6.82667 12.8182 7.03158 12.56 7.18316C12.3018 7.33474 12.0182 7.41053 11.7095 7.41053C11.3951 7.41053 11.1088 7.33474 10.8505 7.18316C10.5923 7.03158 10.3874 6.82667 10.2358 6.56842C10.0786 6.31018 10 6.02386 10 5.70947C10 5.39509 10.0786 5.10877 10.2358 4.85053C10.3874 4.59228 10.5923 4.38737 10.8505 4.23579C11.1088 4.0786 11.3951 4 11.7095 4C12.0182 4 12.3018 4.0786 12.56 4.23579C12.8182 4.38737 13.026 4.59228 13.1832 4.85053C13.3347 5.10877 13.4105 5.39509 13.4105 5.70947Z" })
    ]
  }
), p8e = ({
  title: t,
  titleId: r,
  ...e
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "14",
    viewBox: "0 0 16 14",
    ...e,
    children: [
      t ? /* @__PURE__ */ S.jsx("title", { id: r, children: t }) : null,
      /* @__PURE__ */ S.jsxs("g", { "clip-path": "url(#clip0_20809_85770)", children: [
        /* @__PURE__ */ S.jsx("path", { d: "M0 7.94302C0.366667 7.06728 0.99 6.41401 1.76958 5.86594C1.65417 5.86594 1.53875 5.86594 1.42333 5.86594C0.790417 5.86594 0.52875 5.58669 0.5625 4.94803C0.599583 4.24426 1.1375 3.7851 1.81958 3.87777C1.96375 3.89739 2.10583 3.93245 2.25042 3.95082C2.80208 4.02178 3.35292 4.10568 3.90708 4.15285C4.46292 4.20002 5.00458 4.10276 5.53375 3.92034C6.02 3.75254 6.51875 3.65653 7.03708 3.74711C7.76167 3.87359 8.24417 4.5686 8.09542 5.27988C8.03875 5.55121 7.90208 5.75992 7.62 5.84799C7.57875 5.86093 7.53917 5.90894 7.51792 5.95068C7.11917 6.74879 6.97625 7.60366 7.00917 8.48442C7.03583 9.20781 7.69917 9.76381 8.42 9.7133C9.57667 9.63232 10.4929 8.90476 10.7625 7.85328C10.8725 7.42375 10.8571 6.99548 10.7392 6.57013C10.3367 5.11458 9.93167 3.65946 9.53084 2.20308C9.50542 2.11041 9.46792 2.05489 9.36583 2.05781C9.33583 2.05865 9.30208 2.0503 9.27583 2.03569C9.08167 1.92633 8.88333 1.85704 8.65083 1.85912C8.50917 1.86037 8.41917 1.73056 8.40042 1.57987C8.38 1.41582 8.44417 1.28267 8.59375 1.22339C8.72458 1.17163 8.79 1.08606 8.86167 0.970852C8.9375 0.848548 9.05875 0.742523 9.18208 0.664883C9.44542 0.49875 9.73792 0.376446 9.99167 0.197372C10.4738 -0.142408 11.0213 0.00953308 11.3508 0.283778C11.7379 0.605609 11.8913 1.0343 11.8367 1.5256C11.7983 1.86872 11.5842 2.06408 11.1896 2.08203C11.2679 2.15257 11.3196 2.19849 11.3704 2.24524C12.1517 2.96236 12.8383 3.75379 13.2904 4.72638C13.4808 5.13587 13.6083 5.56289 13.6354 6.01746C13.6383 6.0663 13.6825 6.13726 13.7254 6.15521C14.7013 6.56512 15.4525 7.22631 15.9758 8.14839C15.98 8.15591 15.9921 8.15883 16.0008 8.16342V8.35126C15.8275 8.55621 15.7154 8.57166 15.5158 8.41847C13.655 6.99005 10.9996 8.05197 10.6308 10.372C10.5442 10.9171 10.2463 11.173 9.69708 11.173C8.60375 11.173 7.51042 11.173 6.4175 11.173C6.14583 11.173 6.12917 11.1522 6.12958 10.8775C6.13167 9.77216 5.67792 8.89683 4.76708 8.28072C3.59167 7.48511 2.02792 7.62453 1.00042 8.61173C0.679583 8.91979 0.332083 8.8075 0.1325 8.50696C0.0758333 8.42181 0.0441667 8.32037 0.00125 8.22604C0.00125 8.13212 0.00125 8.0382 0.00125 7.94428L0 7.94302Z" }),
        /* @__PURE__ */ S.jsx("path", { d: "M0.779542 10.8102C0.780375 9.52993 1.81579 8.50141 3.10121 8.50391C4.36996 8.50642 5.40329 9.54496 5.40329 10.8177C5.40329 12.0937 4.35787 13.1398 3.08579 13.136C1.80787 13.1323 0.778708 12.0941 0.779542 10.8102Z" }),
        /* @__PURE__ */ S.jsx("path", { d: "M11.3301 10.8164C11.3309 9.53327 12.3659 8.50016 13.6459 8.50392C14.9213 8.50767 15.9476 9.53536 15.9505 10.8118C15.9534 12.0987 14.9113 13.141 13.6267 13.136C12.3597 13.131 11.3288 12.09 11.3301 10.8164Z" })
      ] }),
      /* @__PURE__ */ S.jsx("defs", { children: /* @__PURE__ */ S.jsx("clipPath", { id: "clip0_20809_85770", children: /* @__PURE__ */ S.jsx("rect", { width: "16", height: "13.1358", fill: "white" }) }) })
    ]
  }
), v8e = ({
  title: t,
  titleId: r,
  ...e
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    "aria-labelledby": r,
    ...e,
    children: [
      t ? /* @__PURE__ */ S.jsx("title", { id: r, children: t }) : null,
      /* @__PURE__ */ S.jsx("path", { d: "M19.9996 13.2943C19.8422 13.5497 19.6932 13.8111 19.5228 14.0574C19.4598 14.1488 19.502 14.1981 19.5375 14.2632C20.3323 15.723 19.5809 17.5273 17.9849 17.9907C16.7321 18.3543 15.4096 17.7268 14.894 16.5175C14.8473 16.4081 14.7947 16.3743 14.6782 16.3743C12.96 16.378 11.2413 16.378 9.52301 16.3743C9.41363 16.3743 9.36103 16.4064 9.31678 16.5104C8.85674 17.5832 7.77302 18.2078 6.62375 18.0704C5.48826 17.9347 4.57319 17.0568 4.38575 15.9059C4.28222 15.2701 4.41205 14.6748 4.75019 14.1258C4.78275 14.0728 4.8174 14.0215 4.86207 13.9522C4.73015 13.8916 4.6045 13.834 4.47884 13.776C4.02757 13.5681 3.87519 13.1252 4.10814 12.6848C4.4755 11.9897 4.98814 11.4249 5.64063 10.9865C5.6878 10.9548 5.73456 10.9218 5.7809 10.8889C5.78341 10.8868 5.78298 10.8805 5.78758 10.8567C5.62602 10.8567 5.4678 10.8567 5.30959 10.8567C4.87167 10.8567 4.63121 10.6563 4.57235 10.2188C4.52267 9.8523 4.60825 9.51249 4.84495 9.22361C5.09 8.92429 5.41479 8.81909 5.79384 8.87127C6.45301 8.96269 7.11093 9.06664 7.77176 9.14304C8.3537 9.21025 8.92354 9.12258 9.47834 8.93473C9.96009 8.7715 10.4494 8.66505 10.9641 8.72933C11.7335 8.82535 12.2699 9.55507 12.1 10.2852C12.0386 10.549 11.9067 10.754 11.6291 10.8367C11.594 10.8471 11.5544 10.8793 11.5385 10.9118C11.2617 11.4842 11.0526 12.0757 11.0981 12.7244C11.1085 12.8714 11.1507 13.0225 11.2091 13.159C11.3181 13.4141 11.5322 13.5422 11.8015 13.5873C12.9433 13.7781 13.8078 12.9428 13.9439 12.1968C14.0145 11.8098 13.9973 11.3965 13.9564 11.0016C13.8266 9.73875 13.6671 8.47886 13.5185 7.21771C13.5131 7.17179 13.5027 7.12629 13.5018 7.1217C13.3198 7.03153 13.1666 6.94929 13.0075 6.88082C12.9554 6.85828 12.8873 6.86329 12.8276 6.86913C12.6193 6.88917 12.4594 6.79691 12.4122 6.62283C12.3626 6.43957 12.4607 6.27801 12.6527 6.18742C12.7233 6.15403 12.775 6.07846 12.833 6.02002C12.9512 5.90063 13.0518 5.75493 13.1887 5.66434C13.4346 5.50112 13.7231 5.39801 13.9573 5.22142C14.6214 4.72089 15.4989 5.13417 15.7482 5.81129C15.81 5.97953 15.8446 6.16321 15.8571 6.3423C15.8826 6.71133 15.6776 6.96765 15.3169 7.0549C15.2873 7.062 15.2581 7.07035 15.2289 7.07786C15.2506 7.05866 15.2727 7.03904 15.2944 7.01984C15.4918 7.25487 15.6789 7.4995 15.888 7.72326C16.4453 8.31981 16.9488 8.95226 17.2957 9.69784C17.4881 10.112 17.6125 10.5436 17.6522 11.0003C17.6568 11.0529 17.7027 11.1285 17.7482 11.1477C18.7067 11.5526 19.4494 12.2005 19.9699 13.1018C19.9775 13.1147 19.99 13.1252 20 13.1365V13.2926L19.9996 13.2943ZM14.8669 8.43294C14.8715 8.49347 14.874 8.554 14.8807 8.61453C14.9775 9.47826 15.0832 10.3407 15.1687 11.2057C15.2326 11.8498 15.2184 12.4973 14.8949 13.0788C14.219 14.2949 13.1599 14.9023 11.7952 14.7846C10.9804 14.7145 10.3897 14.3033 10.0749 13.5343C9.89288 13.0897 9.85864 12.6213 9.92544 12.1521C10.0407 11.3431 10.2753 10.5753 10.7988 9.90365C10.7019 9.90365 10.608 9.88946 10.5195 9.90657C10.3003 9.94832 10.0782 9.98672 9.86783 10.0573C9.17735 10.2885 8.47226 10.3867 7.7463 10.3328C7.46201 10.3119 7.17772 10.2877 6.87798 10.2635C7.00071 10.5119 7.06208 10.7619 7.0195 11.0275C6.95688 11.4174 6.74439 11.7033 6.40876 11.907C6.00006 12.155 5.65859 12.4748 5.38473 12.8747C5.52208 12.944 5.65274 12.9983 5.77046 13.073C5.8598 13.1298 5.93077 13.1281 6.02762 13.0914C7.33301 12.5954 8.79413 13.2296 9.32388 14.5245C9.40946 14.7341 9.45872 14.9587 9.52593 15.1803H14.702C14.859 14.2649 15.3274 13.5777 16.1635 13.1782C16.9926 12.782 17.8188 12.8505 18.6311 13.2776C18.604 13.2145 18.571 13.1703 18.5343 13.1289C18.174 12.7257 17.7386 12.433 17.2381 12.2289C16.753 12.031 16.4954 11.6641 16.4649 11.1381C16.4583 11.0191 16.4453 10.8985 16.4165 10.7832C16.1761 9.82725 15.5628 9.11089 14.8669 8.43336V8.43294ZM6.94645 14.1091C6.17707 14.1041 5.54086 14.7337 5.53794 15.5026C5.53501 16.2657 6.15494 16.8953 6.92056 16.9065C7.69286 16.9178 8.33534 16.282 8.33742 15.5047C8.33951 14.7466 7.70914 14.1141 6.94645 14.1091ZM18.6683 15.5185C18.6808 14.7587 18.0588 14.1204 17.2949 14.1096C16.5305 14.0987 15.888 14.7157 15.8751 15.4738C15.8621 16.2574 16.48 16.8986 17.2573 16.907C18.0275 16.9153 18.6554 16.2975 18.6683 15.5185Z" })
    ]
  }
), g8e = ({
  title: t,
  titleId: r,
  ...e
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    "aria-labelledby": r,
    ...e,
    children: [
      t ? /* @__PURE__ */ S.jsx("title", { id: r, children: t }) : null,
      /* @__PURE__ */ S.jsx("path", { d: "M12.55 19.9152L19.9328 12.5248C20.5204 11.9297 20.5807 11.5832 20.5807 10.7243V7.86914C20.5807 7.03293 20.3848 6.74666 19.7746 6.13644L18.0494 4.41128C17.4317 3.80106 17.1454 3.60519 16.3167 3.60519H13.454C12.6027 3.60519 12.2562 3.66546 11.6686 4.26061L4.27068 11.6434C3.14066 12.7734 3.1256 13.9713 4.27822 15.1088L9.08458 19.9152C10.2297 21.0527 11.42 21.0452 12.55 19.9152ZM14.9908 9.88812C14.3731 9.88812 13.906 9.41351 13.906 8.8033C13.906 8.20062 14.3731 7.71847 14.9908 7.71847C15.6086 7.71847 16.0757 8.20062 16.0757 8.8033C16.0757 9.41351 15.6086 9.88812 14.9908 9.88812Z" })
    ]
  }
), m8e = ({
  title: t,
  titleId: r,
  ...e
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    "aria-labelledby": r,
    ...e,
    children: [
      t ? /* @__PURE__ */ S.jsx("title", { id: r, children: t }) : null,
      /* @__PURE__ */ S.jsx("path", { d: "M12.55 19.9155L19.9328 12.5251C20.5204 11.93 20.5807 11.5834 20.5807 10.7246V7.86942C20.5807 7.0332 20.3848 6.74693 19.7746 6.13672L18.0494 4.41155C17.4317 3.80134 17.1454 3.60547 16.3167 3.60547H13.454C12.6027 3.60547 12.2562 3.66574 11.6686 4.26088L4.27068 11.6437C3.14066 12.7737 3.1256 13.9715 4.27822 15.1091L9.08458 19.9155C10.2297 21.053 11.42 21.0455 12.55 19.9155ZM11.5782 18.7628C11.081 19.26 10.5611 19.2676 10.0489 18.7553L5.43084 14.1448C4.91856 13.6325 4.93363 13.1052 5.42331 12.6155L12.7383 5.31557C12.889 5.1649 13.0321 5.0745 13.2732 5.0745H16.3017C16.5277 5.0745 16.6859 5.15737 16.8365 5.30804L18.8781 7.34961C19.0212 7.50028 19.1041 7.65095 19.1041 7.88449V10.9129C19.1041 11.1616 19.0288 11.3047 18.8781 11.4554L11.5782 18.7628ZM15.375 9.88839C15.9928 9.88839 16.4599 9.41378 16.4599 8.80357C16.4599 8.20089 15.9928 7.71875 15.375 7.71875C14.7648 7.71875 14.2977 8.20089 14.2977 8.80357C14.2977 9.41378 14.7648 9.88839 15.375 9.88839Z" })
    ]
  }
), y8e = ({
  title: t,
  titleId: r,
  ...e
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    "aria-labelledby": r,
    ...e,
    children: [
      t ? /* @__PURE__ */ S.jsx("title", { id: r, children: t }) : null,
      /* @__PURE__ */ S.jsx("path", { d: "M11.6391 20C11.5054 20 11.293 19.9449 11.0885 19.8348C6.57325 17.3648 5 16.2399 5 13.3766V7.42183C5 6.49361 5.36185 6.15536 6.14061 5.83284C7.01377 5.47099 9.96362 4.37758 10.821 4.14159C11.0806 4.0708 11.3795 4 11.6391 4C11.9066 4 12.2055 4.05506 12.4572 4.14159C13.3225 4.42478 16.2724 5.46313 17.1455 5.83284C17.9243 6.16323 18.2861 6.49361 18.2861 7.42183V13.3766C18.2861 16.2399 16.7129 17.3727 12.1976 19.8348C11.9931 19.9449 11.7807 20 11.6391 20ZM11.6391 18.3481C11.7571 18.3481 11.8673 18.3088 12.0954 18.1672C15.6509 16.0275 16.8073 15.3982 16.8073 13.0777V7.67355C16.8073 7.39823 16.7522 7.28024 16.532 7.20157C15.352 6.77679 13.1101 5.9823 12.0482 5.56539C11.8751 5.50246 11.7571 5.47886 11.6391 5.47886C11.529 5.47886 11.4031 5.50246 11.2301 5.56539C10.176 5.9823 7.91052 6.7296 6.74631 7.20157C6.53392 7.2881 6.47099 7.39823 6.47099 7.67355V13.0777C6.47099 15.3825 7.588 15.9803 11.1908 18.1672C11.411 18.3088 11.529 18.3481 11.6391 18.3481ZM10.7974 15.3196C10.5064 15.3196 10.2861 15.2016 10.0659 14.9341L8.20944 12.6608C8.07571 12.4956 8.00492 12.3225 8.00492 12.1337C8.00492 11.7483 8.3117 11.4336 8.69715 11.4336C8.92527 11.4336 9.11406 11.5202 9.30285 11.764L10.7738 13.6283L13.881 8.6411C14.0383 8.38151 14.2507 8.24779 14.4867 8.24779C14.8564 8.24779 15.2026 8.50737 15.2026 8.90069C15.2026 9.07375 15.116 9.26254 15.0138 9.42773L11.4897 14.9263C11.3245 15.1858 11.0806 15.3196 10.7974 15.3196Z" })
    ]
  }
), b8e = ({
  title: t,
  titleId: r,
  ...e
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    "aria-labelledby": r,
    ...e,
    children: [
      t ? /* @__PURE__ */ S.jsx("title", { id: r, children: t }) : null,
      /* @__PURE__ */ S.jsx("path", { d: "M4 10.4714C4 6.90319 6.90319 4 10.4714 4C14.0395 4 16.9427 6.90319 16.9427 10.4714C16.9427 11.9473 16.448 13.3016 15.6128 14.3882L19.5783 18.3781C19.7486 18.5484 19.8459 18.7836 19.8459 19.0431C19.8459 19.5864 19.4648 20 18.9133 20C18.6538 20 18.4105 19.9108 18.224 19.7243L14.2342 15.7263C13.1718 16.4886 11.8824 16.9427 10.4714 16.9427C6.90319 16.9427 4 14.0395 4 10.4714ZM5.38672 10.4714C5.38672 13.2772 7.66548 15.556 10.4714 15.556C13.2772 15.556 15.556 13.2772 15.556 10.4714C15.556 7.66548 13.2772 5.38672 10.4714 5.38672C7.66548 5.38672 5.38672 7.66548 5.38672 10.4714Z" })
    ]
  }
), C8e = ({
  title: t,
  titleId: r,
  ...e
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    "aria-labelledby": r,
    ...e,
    children: [
      t ? /* @__PURE__ */ S.jsx("title", { id: r, children: t }) : null,
      /* @__PURE__ */ S.jsx("path", { d: "M11.3111 19.9925C10.8593 19.9925 10.528 19.7289 10.4301 19.2922L10.0536 17.6885C9.79012 17.5981 9.54165 17.5002 9.31576 17.3948L7.92282 18.2532C7.55388 18.4866 7.11718 18.4489 6.80847 18.1402L5.84471 17.1765C5.536 16.8678 5.49082 16.416 5.73929 16.0471L6.59012 14.6616C6.48471 14.4282 6.38682 14.1873 6.31153 13.9539L4.70024 13.5699C4.26353 13.472 4 13.1407 4 12.6965V11.3412C4 10.8969 4.26353 10.5656 4.70024 10.4678L6.29647 10.0838C6.37929 9.81271 6.48471 9.57176 6.57506 9.36847L5.72424 7.95294C5.48329 7.57647 5.51341 7.15482 5.82965 6.83859L6.80847 5.87482C7.12471 5.58118 7.51624 5.536 7.89271 5.74682L9.30824 6.61271C9.53412 6.49976 9.79012 6.40188 10.0536 6.31153L10.4301 4.70776C10.528 4.26353 10.8593 4 11.3111 4H12.6889C13.1332 4 13.472 4.26353 13.5624 4.70024L13.9464 6.32659C14.2174 6.41694 14.4584 6.51482 14.6767 6.62024L16.0998 5.74682C16.4762 5.536 16.8678 5.58871 17.184 5.87482L18.1628 6.83859C18.4791 7.15482 18.5092 7.57647 18.2682 7.95294L17.4174 9.36847C17.5078 9.57176 17.6132 9.81271 17.7035 10.0838L19.2998 10.4678C19.7365 10.5656 20 10.8969 20 11.3412V12.6965C20 13.1407 19.7365 13.472 19.2998 13.5699L17.6885 13.9539C17.6132 14.1873 17.5078 14.4282 17.4024 14.6616L18.2532 16.0471C18.5016 16.416 18.4565 16.8678 18.1478 17.1765L17.184 18.1402C16.8753 18.4489 16.4461 18.4866 16.0772 18.2532L14.6767 17.3948C14.4508 17.5002 14.2024 17.5981 13.9464 17.6885L13.5624 19.2922C13.472 19.7289 13.1332 19.9925 12.6889 19.9925H11.3111ZM12.0038 14.6315C13.4494 14.6315 14.6315 13.4419 14.6315 11.9887C14.6315 10.5506 13.4494 9.36094 12.0038 9.36094C10.5506 9.36094 9.36094 10.5506 9.36094 11.9887C9.36094 13.4419 10.5506 14.6315 12.0038 14.6315Z" })
    ]
  }
), w8e = ({
  title: t,
  titleId: r,
  ...e
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    "aria-labelledby": r,
    ...e,
    children: [
      t ? /* @__PURE__ */ S.jsx("title", { id: r, children: t }) : null,
      /* @__PURE__ */ S.jsx("path", { d: "M11.256 19.9853C10.9515 19.9853 10.6863 19.8993 10.4604 19.7274C10.2394 19.5556 10.0945 19.3223 10.0258 19.0276L9.72376 17.7238L9.52486 17.6575L8.39779 18.3499C8.14242 18.512 7.87231 18.5734 7.58748 18.5341C7.30755 18.4997 7.05955 18.3745 6.84346 18.1584L5.81215 17.1344C5.59116 16.9134 5.46347 16.663 5.4291 16.3831C5.39472 16.1031 5.45856 15.8355 5.62063 15.5801L6.32781 14.453L6.26151 14.2689L4.95764 13.9669C4.66789 13.8981 4.43462 13.7508 4.25783 13.5249C4.08594 13.299 4 13.0362 4 12.7366V11.2855C4 10.9859 4.08594 10.7256 4.25783 10.5046C4.42971 10.2787 4.66298 10.1289 4.95764 10.0552L6.24678 9.74586L6.32044 9.54696L5.61326 8.41989C5.4512 8.16943 5.38735 7.90424 5.42173 7.62431C5.45611 7.34438 5.58379 7.09392 5.80479 6.87293L6.8361 5.84162C7.05218 5.62554 7.30018 5.50031 7.58011 5.46593C7.86004 5.42664 8.12769 5.48557 8.38306 5.64273L9.5175 6.34254L9.72376 6.26151L10.0258 4.95764C10.0945 4.66789 10.2394 4.43708 10.4604 4.26519C10.6863 4.0884 10.9515 4 11.256 4H12.7514C13.0559 4 13.3186 4.0884 13.5396 4.26519C13.7606 4.43708 13.9055 4.66789 13.9742 4.95764L14.2762 6.26151L14.4825 6.34254L15.6169 5.64273C15.8723 5.48557 16.14 5.42664 16.4199 5.46593C16.7047 5.50031 16.9527 5.62554 17.1639 5.84162L18.1952 6.87293C18.4113 7.09392 18.5365 7.34438 18.5709 7.62431C18.6102 7.90424 18.5488 8.16943 18.3867 8.41989L17.6796 9.54696L17.7606 9.74586L19.0424 10.0552C19.3321 10.124 19.5629 10.2713 19.7348 10.4972C19.9116 10.7231 20 10.9859 20 11.2855V12.7366C20 13.0362 19.9116 13.299 19.7348 13.5249C19.5629 13.7459 19.3321 13.8932 19.0424 13.9669L17.7459 14.2689L17.6722 14.453L18.3794 15.5801C18.5414 15.8355 18.6028 16.1031 18.5635 16.3831C18.5292 16.663 18.4039 16.9134 18.1878 17.1344L17.1565 18.1584C16.9405 18.3745 16.69 18.4997 16.4052 18.5341C16.1252 18.5734 15.8576 18.512 15.6022 18.3499L14.4678 17.6575L14.2762 17.7238L13.9742 19.0276C13.9055 19.3223 13.7606 19.5556 13.5396 19.7274C13.3186 19.8993 13.0559 19.9853 12.7514 19.9853H11.256ZM11.4401 18.6519H12.5672C12.6851 18.6519 12.7514 18.5955 12.7661 18.4825L13.2081 16.6703C13.4537 16.6163 13.682 16.5451 13.8932 16.4567C14.1044 16.3634 14.3008 16.2603 14.4825 16.1473L16.0663 17.1197C16.1596 17.1835 16.2505 17.1737 16.3389 17.0902L17.1197 16.302C17.1983 16.2333 17.2056 16.1449 17.1418 16.0368L16.1694 14.4604C16.2726 14.2836 16.3683 14.0872 16.4567 13.8711C16.55 13.655 16.6237 13.4316 16.6777 13.2007L18.4972 12.7661C18.6102 12.7465 18.6667 12.6777 18.6667 12.5599V11.4549C18.6667 11.3419 18.6102 11.2732 18.4972 11.2486L16.6851 10.814C16.6262 10.5684 16.5476 10.3352 16.4494 10.1142C16.356 9.89319 16.2652 9.70411 16.1768 9.54696L17.1492 7.96317C17.2179 7.86004 17.2106 7.76673 17.1271 7.68324L16.3462 6.91713C16.2627 6.83855 16.1694 6.82627 16.0663 6.88029L14.4825 7.8453C14.3008 7.74217 14.1019 7.64641 13.8858 7.55801C13.6746 7.4647 13.4487 7.38858 13.2081 7.32965L12.7661 5.50276C12.7514 5.38981 12.6851 5.33333 12.5672 5.33333H11.4401C11.3174 5.33333 11.2462 5.38981 11.2265 5.50276L10.7993 7.31492C10.5635 7.37385 10.3303 7.45242 10.0994 7.55064C9.87354 7.64395 9.6771 7.73972 9.51013 7.83794L7.92634 6.88029C7.82812 6.82627 7.73726 6.8361 7.65378 6.90976L6.86556 7.68324C6.78699 7.76673 6.77962 7.86004 6.84346 7.96317L7.81584 9.54696C7.73235 9.70411 7.6415 9.89319 7.54328 10.1142C7.44506 10.3352 7.36894 10.5684 7.31492 10.814L5.50276 11.2486C5.38981 11.2732 5.33333 11.3419 5.33333 11.4549V12.5599C5.33333 12.6777 5.38981 12.7465 5.50276 12.7661L7.31492 13.1934C7.37385 13.4291 7.44997 13.655 7.54328 13.8711C7.63659 14.0823 7.73235 14.2787 7.83057 14.4604L6.85083 16.0442C6.7919 16.1473 6.79926 16.2357 6.87293 16.3094L7.66114 17.0902C7.74954 17.1737 7.83794 17.186 7.92634 17.1271L9.5175 16.1473C9.6992 16.2603 9.8981 16.3634 10.1142 16.4567C10.3352 16.5451 10.5611 16.6163 10.7919 16.6703L11.2265 18.4825C11.2462 18.5955 11.3174 18.6519 11.4401 18.6519ZM12 14.7919C11.4893 14.7919 11.0203 14.6667 10.593 14.4162C10.1707 14.1608 9.8318 13.822 9.57643 13.3996C9.32597 12.9773 9.20074 12.5083 9.20074 11.9926C9.20074 11.4819 9.32597 11.0153 9.57643 10.593C9.8318 10.1707 10.1707 9.83425 10.593 9.58379C11.0203 9.33333 11.4893 9.2081 12 9.2081C12.5157 9.2081 12.9847 9.33333 13.407 9.58379C13.8293 9.83425 14.1657 10.1707 14.4162 10.593C14.6667 11.0153 14.7919 11.4819 14.7919 11.9926C14.7919 12.5034 14.6667 12.9724 14.4162 13.3996C14.1657 13.8269 13.8293 14.1657 13.407 14.4162C12.9847 14.6667 12.5157 14.7919 12 14.7919ZM12 13.5249C12.275 13.5249 12.5279 13.4561 12.7587 13.3186C12.9896 13.1762 13.1713 12.9896 13.3039 12.7587C13.4414 12.5279 13.5101 12.2726 13.5101 11.9926C13.5101 11.7127 13.4414 11.4598 13.3039 11.2339C13.1713 11.0031 12.9896 10.8189 12.7587 10.6814C12.5279 10.5439 12.275 10.4751 12 10.4751C11.7201 10.4751 11.4647 10.5439 11.2339 10.6814C11.0031 10.8189 10.8189 11.0031 10.6814 11.2339C10.5439 11.4598 10.4751 11.7127 10.4751 11.9926C10.4751 12.2775 10.5439 12.5353 10.6814 12.7661C10.8189 12.9969 11.0031 13.1811 11.2339 13.3186C11.4647 13.4561 11.7201 13.5249 12 13.5249Z" })
    ]
  }
), _8e = ({
  title: t,
  titleId: r,
  ...e
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    "aria-labelledby": r,
    ...e,
    children: [
      t ? /* @__PURE__ */ S.jsx("title", { id: r, children: t }) : null,
      /* @__PURE__ */ S.jsx("path", { d: "M11.6269 4C12 4 12.306 4.14925 12.6119 4.44776L16.8284 8.49254C17.0821 8.73881 17.2537 9.03731 17.2537 9.37313C17.2537 10.0746 16.6791 10.5672 16.0672 10.5672C15.7687 10.5672 15.4552 10.4701 15.194 10.2239L11.6269 6.73134L8.0597 10.2239C7.80597 10.4776 7.48507 10.5672 7.18657 10.5672C6.58209 10.5672 6 10.0746 6 9.37313C6 9.03731 6.1791 8.73881 6.43284 8.49254L10.6493 4.44776C10.9478 4.14925 11.2612 4 11.6269 4ZM11.6269 20C11.2612 20 10.9478 19.8507 10.6493 19.5522L6.43284 15.5075C6.1791 15.2612 6 14.9627 6 14.6269C6 13.9254 6.58209 13.4328 7.18657 13.4328C7.48507 13.4328 7.80597 13.5224 8.0597 13.7761L11.6269 17.2687L15.194 13.7761C15.4552 13.5299 15.7687 13.4328 16.0672 13.4328C16.6791 13.4328 17.2537 13.9254 17.2537 14.6269C17.2537 14.9627 17.0821 15.2612 16.8284 15.5075L12.6119 19.5522C12.306 19.8507 12 20 11.6269 20Z" })
    ]
  }
), x8e = ({
  title: t,
  titleId: r,
  ...e
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    "aria-labelledby": r,
    ...e,
    children: [
      t ? /* @__PURE__ */ S.jsx("title", { id: r, children: t }) : null,
      /* @__PURE__ */ S.jsx("path", { d: "M11.6269 4C12 4 12.306 4.14925 12.6119 4.44776L16.8284 8.49254C17.0821 8.73881 17.2537 9.03731 17.2537 9.37313C17.2537 10.0746 16.6791 10.5672 16.0672 10.5672C15.7687 10.5672 15.4552 10.4701 15.194 10.2239L11.6269 6.73134L8.0597 10.2239C7.80597 10.4776 7.48507 10.5672 7.18657 10.5672C6.58209 10.5672 6 10.0746 6 9.37313C6 9.03731 6.1791 8.73881 6.43284 8.49254L10.6493 4.44776C10.9478 4.14925 11.2612 4 11.6269 4Z" })
    ]
  }
), S8e = ({
  title: t,
  titleId: r,
  ...e
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    "aria-labelledby": r,
    ...e,
    children: [
      t ? /* @__PURE__ */ S.jsx("title", { id: r, children: t }) : null,
      /* @__PURE__ */ S.jsx("path", { d: "M6.81735 6.47476V6.34959C6.81735 5.50471 7.35557 4.979 8.21922 4.979H16.2925C17.1562 4.979 17.6944 5.50471 17.6944 6.34959V6.47476H6.81735ZM5.35289 9.57266C5.37792 9.52885 5.40295 9.47878 5.42799 9.42871L6.66089 7.15066H17.8509L19.0838 9.42871C19.1088 9.47878 19.1338 9.52885 19.1589 9.57266H5.35289ZM7.34931 12.1699C6.17899 12.1699 5.24023 11.3438 5.24023 10.4551V10.2486H19.2778V10.3487C19.2778 11.2374 18.339 12.1699 17.1687 12.1699C16.4928 12.1699 15.9045 11.857 15.5353 11.3751C15.1598 11.857 14.5715 12.1699 13.8956 12.1699C13.2197 12.1699 12.6314 11.857 12.2621 11.3751C11.8866 11.857 11.2983 12.1699 10.6224 12.1699C9.94654 12.1699 9.35825 11.857 8.98275 11.3751C8.6135 11.857 8.02521 12.1699 7.34931 12.1699ZM7.56835 18.979C6.61708 18.979 6.06634 18.4345 6.06634 17.5145V12.5516C6.45436 12.7394 6.89871 12.8458 7.37434 12.8458C7.99392 12.8458 8.56344 12.6455 9.01404 12.3076C9.46464 12.6455 10.0342 12.8458 10.6537 12.8458C11.2733 12.8458 11.8366 12.6455 12.2872 12.3138C12.7378 12.6455 13.301 12.8458 13.9206 12.8458C14.5402 12.8458 15.1034 12.6455 15.5603 12.3076C16.0109 12.6455 16.5742 12.8458 17.1937 12.8458C17.6756 12.8458 18.12 12.7206 18.508 12.5204V17.5145C18.508 18.4345 17.951 18.979 16.9997 18.979H7.56835ZM13.6077 16.4944H16.1423C16.4365 16.4944 16.6242 16.3067 16.6242 16.0125V14.2915C16.6242 13.9973 16.4365 13.8096 16.1423 13.8096H13.6077C13.3135 13.8096 13.1195 13.9973 13.1195 14.2915V16.0125C13.1195 16.3067 13.3135 16.4944 13.6077 16.4944ZM8.30684 17.8588H11.7427V14.6294C11.7427 14.3415 11.5549 14.1538 11.2608 14.1538H8.795C8.50085 14.1538 8.30684 14.3415 8.30684 14.6294V17.8588Z" })
    ]
  }
), I8e = ({
  title: t,
  titleId: r,
  ...e
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    "aria-labelledby": r,
    ...e,
    children: [
      t ? /* @__PURE__ */ S.jsx("title", { id: r, children: t }) : null,
      /* @__PURE__ */ S.jsx("path", { d: "M7.58471 19C6.63344 19 6.0827 18.4555 6.0827 17.5355V12.4537C5.43183 12.0782 5 11.371 5 10.5637V10.4385C5 10.1694 5.06884 9.9316 5.20653 9.7063L6.85248 6.91506V6.37684C6.85248 5.5257 7.3907 5 8.25436 5H16.3527C17.2164 5 17.7546 5.5257 17.7546 6.37684V6.91506L19.4005 9.7063C19.532 9.9316 19.6008 10.1694 19.6008 10.4385V10.5637C19.6008 11.371 19.1752 12.0782 18.5244 12.4537V17.5355C18.5244 18.4555 17.9674 19 17.0161 19H7.58471ZM7.98525 6.69602H16.6156V6.54582C16.6156 6.25793 16.4466 6.0827 16.165 6.0827H8.43585C8.15422 6.0827 7.98525 6.25793 7.98525 6.54582V6.69602ZM6.31426 10.038H18.2803L16.9785 7.80376H7.58471L6.31426 10.038ZM6.03889 11.0143C6.18283 11.4774 6.58337 11.7841 7.19043 11.7841C7.7975 11.7841 8.20429 11.4774 8.34823 11.0143H6.03889ZM9.44345 11.0143C9.58739 11.4774 9.99419 11.7841 10.6013 11.7841C11.2083 11.7841 11.6089 11.4774 11.7528 11.0143H9.44345ZM12.8543 11.0143C12.992 11.4774 13.3987 11.7841 14.0058 11.7841C14.6129 11.7841 15.0197 11.4774 15.1636 11.0143H12.8543ZM16.2588 11.0143C16.3965 11.4774 16.8033 11.7841 17.4104 11.7841C18.0174 11.7841 18.4242 11.4774 18.5682 11.0143H16.2588ZM11.8404 14.3876V17.7734H16.6969C17.0849 17.7734 17.2977 17.5606 17.2977 17.16V12.7479C16.6468 12.7166 16.0773 12.4037 15.7081 11.928C15.3201 12.435 14.7067 12.7479 14.0058 12.7479C13.3049 12.7479 12.6916 12.4287 12.3035 11.9218C11.9155 12.4287 11.3022 12.7479 10.6013 12.7479C9.90031 12.7479 9.28699 12.435 8.89897 11.928C8.52973 12.4037 7.96021 12.7166 7.30934 12.7479V17.16C7.30934 17.5606 7.52213 17.7734 7.91015 17.7734H8.24184V14.3876C8.24184 14.0934 8.43585 13.9057 8.73 13.9057H11.3585C11.6527 13.9057 11.8404 14.0934 11.8404 14.3876ZM12.9356 14.0559C12.9356 13.7617 13.1296 13.574 13.4238 13.574H15.9522C16.2463 13.574 16.4341 13.7617 16.4341 14.0559V15.8333C16.4341 16.1211 16.2463 16.3152 15.9522 16.3152H13.4238C13.1296 16.3152 12.9356 16.1211 12.9356 15.8333V14.0559Z" })
    ]
  }
), A8e = ({
  title: t,
  titleId: r,
  ...e
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    "aria-labelledby": r,
    ...e,
    children: [
      t ? /* @__PURE__ */ S.jsx("title", { id: r, children: t }) : null,
      /* @__PURE__ */ S.jsx("path", { d: "M5.22035 7.59662L8.68903 4.20613C8.82645 4.06871 8.98756 4 9.17237 4C9.36665 4 9.52303 4.0616 9.64149 4.18481C9.75996 4.30327 9.81919 4.45965 9.81919 4.65393C9.81919 4.834 9.75759 4.98564 9.63438 5.10884L8.19858 6.502L7.04709 7.49L8.54687 7.43314H17.4034C17.5882 7.43314 17.7422 7.49474 17.8654 7.61795C17.9933 7.74115 18.0573 7.8999 18.0573 8.09418C18.0573 8.28373 17.9933 8.4401 17.8654 8.5633C17.7422 8.68651 17.5882 8.74811 17.4034 8.74811H8.54687L7.04709 8.68414L8.19858 9.67215L9.63438 11.0653C9.75759 11.1932 9.81919 11.3449 9.81919 11.5202C9.81919 11.7145 9.75996 11.8732 9.64149 11.9964C9.52303 12.1149 9.36665 12.1741 9.17237 12.1741C8.98756 12.1741 8.82645 12.1054 8.68903 11.968L5.22035 8.57752C5.07819 8.44484 5.00474 8.28373 5 8.09418C5 7.8999 5.07345 7.73404 5.22035 7.59662ZM17.8441 16.4034L14.3754 19.7939C14.238 19.9313 14.0769 20 13.892 20C13.6978 20 13.5414 19.9408 13.4229 19.8223C13.3045 19.7038 13.2452 19.5475 13.2452 19.3532C13.2452 19.1731 13.3068 19.0215 13.43 18.8983L14.8658 17.5051L16.0173 16.5171L14.5175 16.574H5.66104C5.47149 16.574 5.31275 16.5124 5.18481 16.3892C5.0616 16.266 5 16.1096 5 15.92C5 15.7258 5.0616 15.567 5.18481 15.4438C5.31275 15.3206 5.47149 15.259 5.66104 15.259H14.5175L16.0173 15.3159L14.8658 14.3279L13.43 12.9347C13.3068 12.8115 13.2452 12.6599 13.2452 12.4798C13.2452 12.2902 13.3045 12.1362 13.4229 12.0178C13.5414 11.8946 13.6978 11.833 13.892 11.833C14.0769 11.833 14.238 11.9017 14.3754 12.0391L17.8441 15.4296C17.9862 15.5623 18.0573 15.7234 18.0573 15.9129C18.062 16.1025 17.991 16.266 17.8441 16.4034Z" })
    ]
  }
), D8e = ({
  title: t,
  titleId: r,
  ...e
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    "aria-labelledby": r,
    ...e,
    children: [
      t ? /* @__PURE__ */ S.jsx("title", { id: r, children: t }) : null,
      /* @__PURE__ */ S.jsx("path", { d: "M5.57762 16.1959C5.06596 16.1959 4.67511 16.0608 4.40506 15.7908C4.13502 15.5208 4 15.1317 4 14.6236V7.57762C4 7.06596 4.13502 6.67511 4.40506 6.40506C4.67511 6.13502 5.06596 6 5.57762 6H13.4923C14.004 6 14.3948 6.1368 14.6649 6.41039C14.9349 6.68044 15.07 7.06951 15.07 7.57762V14.9167L14.0253 15.4284V7.63091C14.0253 7.43193 13.9756 7.28448 13.8761 7.18854C13.7766 7.0926 13.6309 7.04464 13.439 7.04464H5.62558C5.43371 7.04464 5.28803 7.0926 5.18854 7.18854C5.0926 7.28448 5.04464 7.43193 5.04464 7.63091V14.5703C5.04464 14.7657 5.0926 14.9114 5.18854 15.0073C5.28803 15.1033 5.43371 15.1512 5.62558 15.1512H6.69154V16.1959H5.57762ZM14.505 9.99201V8.94737H16.4877C16.7684 8.94737 17.0082 8.98645 17.2072 9.06462C17.4062 9.13924 17.5909 9.26893 17.7615 9.4537L19.6003 11.5323C19.7566 11.71 19.8614 11.8805 19.9147 12.044C19.9716 12.2039 20 12.4242 20 12.7049V14.6236C20 15.1317 19.865 15.5208 19.5949 15.7908C19.3284 16.0608 18.9376 16.1959 18.4224 16.1959H17.5536V15.1512H18.3744C18.5663 15.1512 18.7102 15.1033 18.8061 15.0073C18.9056 14.9114 18.9554 14.7657 18.9554 14.5703V12.7368C18.9554 12.6302 18.9358 12.5254 18.8967 12.4224C18.8612 12.3158 18.8061 12.2199 18.7315 12.1346L17.0793 10.2798C16.9762 10.1626 16.8714 10.0862 16.7648 10.0506C16.6582 10.0115 16.5356 9.99201 16.3971 9.99201H14.505ZM16.0773 12.7582C15.9316 12.7582 15.8143 12.7155 15.7255 12.6302C15.6402 12.5414 15.5976 12.4242 15.5976 12.2785V10.5356H16.2425C16.3278 10.5356 16.4042 10.5552 16.4717 10.5943C16.5427 10.6298 16.6085 10.6795 16.6689 10.7435L18.2039 12.4757C18.2429 12.5183 18.2732 12.561 18.2945 12.6036C18.3193 12.6427 18.3318 12.6942 18.3318 12.7582H16.0773ZM8.0986 17.6989C7.73973 17.6989 7.41461 17.6118 7.12325 17.4377C6.83189 17.2672 6.59916 17.0362 6.42505 16.7448C6.25094 16.4535 6.16389 16.1301 6.16389 15.7748C6.16389 15.4195 6.25094 15.0962 6.42505 14.8048C6.59916 14.5134 6.83189 14.2825 7.12325 14.1119C7.41461 13.9378 7.73973 13.8508 8.0986 13.8508C8.45037 13.8508 8.77193 13.9378 9.06329 14.1119C9.35465 14.2825 9.58561 14.5134 9.75616 14.8048C9.93027 15.0962 10.0173 15.4195 10.0173 15.7748C10.0173 16.1301 9.93027 16.4535 9.75616 16.7448C9.58561 17.0362 9.35465 17.2672 9.06329 17.4377C8.77193 17.6118 8.45037 17.6989 8.0986 17.6989ZM8.0986 16.8301C8.28692 16.8301 8.46103 16.7821 8.62092 16.6862C8.78437 16.5903 8.91228 16.4624 9.00466 16.3025C9.09705 16.1426 9.14324 15.9667 9.14324 15.7748C9.14324 15.5794 9.09705 15.4017 9.00466 15.2418C8.91228 15.0819 8.78437 14.9558 8.62092 14.8634C8.46103 14.7675 8.28692 14.7195 8.0986 14.7195C7.90318 14.7195 7.72552 14.7675 7.56562 14.8634C7.40573 14.9558 7.27781 15.0819 7.18188 15.2418C7.08594 15.4017 7.03797 15.5794 7.03797 15.7748C7.03797 15.9667 7.08594 16.1426 7.18188 16.3025C7.27781 16.4624 7.40573 16.5903 7.56562 16.6862C7.72552 16.7821 7.90318 16.8301 8.0986 16.8301ZM15.9334 17.6989C15.5816 17.6989 15.2583 17.6118 14.9634 17.4377C14.672 17.2672 14.4393 17.0362 14.2652 16.7448C14.0911 16.4535 14.004 16.1301 14.004 15.7748C14.004 15.4195 14.0911 15.0962 14.2652 14.8048C14.4393 14.5134 14.672 14.2825 14.9634 14.1119C15.2583 13.9378 15.5816 13.8508 15.9334 13.8508C16.2887 13.8508 16.6103 13.9378 16.8981 14.1119C17.1894 14.2825 17.4222 14.5134 17.5963 14.8048C17.7704 15.0962 17.8574 15.4195 17.8574 15.7748C17.8574 16.1301 17.7704 16.4535 17.5963 16.7448C17.4222 17.0362 17.1894 17.2672 16.8981 17.4377C16.6103 17.6118 16.2887 17.6989 15.9334 17.6989ZM15.9334 16.8301C16.1288 16.8301 16.3047 16.7821 16.461 16.6862C16.6209 16.5903 16.7471 16.4624 16.8394 16.3025C16.9354 16.1426 16.9833 15.9667 16.9833 15.7748C16.9833 15.5794 16.9354 15.4017 16.8394 15.2418C16.7435 15.0819 16.6156 14.9558 16.4557 14.8634C16.2994 14.7675 16.1252 14.7195 15.9334 14.7195C15.738 14.7195 15.5603 14.7675 15.4004 14.8634C15.2441 14.9558 15.1179 15.0819 15.022 15.2418C14.926 15.4017 14.8781 15.5794 14.8781 15.7748C14.8781 15.9667 14.926 16.1426 15.022 16.3025C15.1179 16.4624 15.2441 16.5903 15.4004 16.6862C15.5603 16.7821 15.738 16.8301 15.9334 16.8301ZM9.56962 16.1959V15.1512H14.4624V16.1959H9.56962Z" })
    ]
  }
), T8e = ({
  title: t,
  titleId: r,
  ...e
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    "aria-labelledby": r,
    ...e,
    children: [
      t ? /* @__PURE__ */ S.jsx("title", { id: r, children: t }) : null,
      /* @__PURE__ */ S.jsx("path", { d: "M14.4504 14.7807H17.9955C19.444 14.7807 20.1429 14.0673 20.1429 13.0409C20.1429 11.8544 19.3203 11.1119 17.9809 10.879C17.879 10.8644 17.8353 10.8062 17.8499 10.7043C17.8863 10.3403 17.9154 9.89627 17.8935 9.48135C17.7844 7.3849 16.1829 5.62329 13.9481 5.62329C12.1793 5.62329 11.1019 6.56233 10.4104 7.83621C10.3667 7.92357 10.3012 7.93813 10.2066 7.91629C8.59782 7.45041 7.08371 8.1929 7.15651 10.3185C7.16379 10.4277 7.11283 10.4859 7.01092 10.4859C5.55505 10.4859 4.64513 11.3885 4.64513 12.7425C4.64513 13.8635 5.48226 14.7807 6.9818 14.7807H10.2648V16.404H6.9818C4.53594 16.404 3 14.788 3 12.7862C3 11.0027 4.03367 9.59782 5.7152 9.2848C5.80255 7.22475 7.84076 5.89263 9.6242 6.31483C10.5632 4.96815 12.0409 4 13.9627 4C17.0564 4 19.4513 6.3949 19.4513 9.71429C20.9072 10.2894 21.7953 11.5632 21.7953 13.1501C21.7953 15.0428 20.354 16.404 18.0464 16.404H14.4504V14.7807ZM12.3612 20C11.9463 20 11.6115 19.6579 11.6115 19.2648V12.6333L11.7061 11.3667L11.2548 11.9126L10.2939 12.8881C10.1629 13.0191 9.98089 13.0992 9.79891 13.0992C9.44222 13.0992 9.14377 12.8371 9.14377 12.4659C9.14377 12.2766 9.20928 12.131 9.34759 12L11.7789 9.71429C11.9827 9.5323 12.1574 9.45951 12.3612 9.45951C12.5578 9.45951 12.7398 9.5323 12.9363 9.71429L15.3676 12C15.5059 12.131 15.5714 12.2766 15.5714 12.4659C15.5714 12.8371 15.2657 13.0992 14.9163 13.0992C14.7343 13.0992 14.5523 13.0191 14.4213 12.8881L13.4604 11.9126L13.0164 11.3667L13.1037 12.6333V19.2648C13.1037 19.6579 12.7689 20 12.3612 20Z" })
    ]
  }
), _6e = ({
  title: t,
  titleId: r,
  ...e
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    "aria-labelledby": r,
    ...e,
    children: [
      t ? /* @__PURE__ */ S.jsx("title", { id: r, children: t }) : null,
      /* @__PURE__ */ S.jsx("path", { d: "M6.90909 3.09082C5.86246 3.09082 5 3.95328 5 4.99991V18.9999C5 20.0465 5.86246 20.909 6.90909 20.909H17.0909C18.1375 20.909 19 20.0465 19 18.9999V6.909C19 6.74024 18.9329 6.5784 18.8136 6.45907L15.6317 3.27726C15.5124 3.15791 15.3506 3.09085 15.1818 3.09082H6.90909ZM6.90909 4.36355H13.9091V6.27264C13.9091 7.31927 14.7716 8.18173 15.8182 8.18173H17.7273V18.9999C17.7273 19.3635 17.4545 19.6363 17.0909 19.6363H6.90909C6.54554 19.6363 6.27273 19.3635 6.27273 18.9999V4.99991C6.27273 4.63636 6.54554 4.36355 6.90909 4.36355ZM15.1818 4.62704L17.4638 6.909H15.8182C15.4546 6.909 15.1818 6.63619 15.1818 6.27264V4.62704Z" }),
      /* @__PURE__ */ S.jsx("path", { d: "M11.55 9.64091L9.00451 12.1864C8.75606 12.4349 8.75606 12.8377 9.00451 13.0862C9.25302 13.3347 9.65586 13.3347 9.90437 13.0862L11.3635 11.6271V17.0908C11.3635 17.4423 11.6484 17.7272 11.9999 17.7272C12.3513 17.7272 12.6363 17.4423 12.6363 17.0908V11.6271L14.0954 13.0862C14.3439 13.3347 14.7468 13.3347 14.9953 13.0862C15.2437 12.8377 15.2437 12.4349 14.9953 12.1864L12.4498 9.64091C12.1628 9.37445 11.8185 9.37602 11.55 9.64091Z" })
    ]
  }
), M8e = ({
  title: t,
  titleId: r,
  ...e
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    "aria-labelledby": r,
    ...e,
    children: [
      t ? /* @__PURE__ */ S.jsx("title", { id: r, children: t }) : null,
      /* @__PURE__ */ S.jsx("path", { d: "M12 20C7.62439 20 4 16.3833 4 12C4 7.62439 7.61665 4 11.9923 4C16.3756 4 20 7.62439 20 12C20 16.3833 16.3756 20 12 20ZM12 11.7367C13.1307 11.7444 14.0445 10.7764 14.0445 9.49855C14.0445 8.31365 13.1307 7.32236 12 7.32236C10.8693 7.32236 9.95547 8.31365 9.95547 9.49855C9.95547 10.7764 10.8693 11.7289 12 11.7367ZM8.4453 16.0349H15.5547C15.9109 16.0349 16.0813 15.7948 16.0813 15.4773C16.0813 14.6099 14.7957 12.3717 12 12.3717C9.20426 12.3717 7.91868 14.6099 7.91868 15.4773C7.91868 15.7948 8.08906 16.0349 8.4453 16.0349Z" })
    ]
  }
), R8e = ({
  title: t,
  titleId: r,
  ...e
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    "aria-labelledby": r,
    ...e,
    children: [
      t ? /* @__PURE__ */ S.jsx("title", { id: r, children: t }) : null,
      /* @__PURE__ */ S.jsx("path", { d: "M12 20C7.62439 20 4 16.3833 4 12C4 7.62439 7.61665 4 11.9923 4C16.3756 4 20 7.62439 20 12C20 16.3833 16.3756 20 12 20ZM12 18.4279C15.5624 18.4279 18.4279 15.5624 18.4279 12C18.4279 8.43756 15.5547 5.57986 11.9923 5.57986C8.42982 5.57986 5.57986 8.43756 5.57986 12C5.57986 15.5624 8.43756 18.4279 12 18.4279ZM11.9923 11.7289C10.908 11.7289 10.0252 10.8151 10.0252 9.58374C10.0252 8.43756 10.908 7.485 11.9923 7.485C13.0842 7.485 13.9593 8.43756 13.9593 9.58374C13.9593 10.8151 13.0842 11.7367 11.9923 11.7289ZM8.56922 15.8722C8.22846 15.8722 8.06583 15.6399 8.06583 15.3379C8.06583 14.5015 9.30494 12.3408 11.9923 12.3408C14.6796 12.3408 15.9264 14.5015 15.9264 15.3379C15.9264 15.6399 15.7561 15.8722 15.423 15.8722H8.56922Z" })
    ]
  }
), L8e = ({
  title: t,
  titleId: r,
  ...e
}) => /* @__PURE__ */ S.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    "aria-labelledby": r,
    ...e,
    children: [
      t ? /* @__PURE__ */ S.jsx("title", { id: r, children: t }) : null,
      /* @__PURE__ */ S.jsx("path", { d: "M11.9961 19.9923C10.9021 19.9923 9.8726 19.7833 8.9076 19.3653C7.94259 18.9524 7.09111 18.377 6.35317 17.6391C5.62038 16.9011 5.04499 16.0497 4.627 15.0847C4.209 14.1197 4 13.0901 4 11.9961C4 10.9021 4.209 9.8726 4.627 8.9076C5.04499 7.94259 5.62038 7.09369 6.35317 6.36091C7.09111 5.62296 7.94001 5.04499 8.89985 4.627C9.86486 4.209 10.8944 4 11.9884 4C13.0876 4 14.1197 4.209 15.0847 4.627C16.0497 5.04499 16.9011 5.62296 17.6391 6.36091C18.377 7.09369 18.955 7.94259 19.373 8.9076C19.791 9.8726 20 10.9021 20 11.9961C20 13.0901 19.791 14.1197 19.373 15.0847C18.955 16.0497 18.377 16.9011 17.6391 17.6391C16.9011 18.377 16.0497 18.9524 15.0847 19.3653C14.1197 19.7833 13.0901 19.9923 11.9961 19.9923ZM9.65844 15.6884C9.81842 15.6884 9.94743 15.6549 10.0455 15.5878C10.1435 15.5207 10.2545 15.3995 10.3783 15.224L11.9574 12.956H11.9961L13.5597 15.224C13.6784 15.3995 13.7894 15.5207 13.8926 15.5878C13.9958 15.6549 14.1222 15.6884 14.2719 15.6884C14.4886 15.6884 14.6641 15.6265 14.7983 15.5027C14.9376 15.3736 15.0073 15.2059 15.0073 14.9995C15.0073 14.8241 14.9428 14.6538 14.8137 14.4886L12.9405 11.9342L14.8292 9.37978C14.9582 9.20948 15.0227 9.03661 15.0227 8.86115C15.0227 8.66505 14.9557 8.50508 14.8215 8.38123C14.6873 8.25222 14.517 8.18771 14.3106 8.18771C14.1609 8.18771 14.0319 8.22125 13.9236 8.28834C13.8152 8.35543 13.712 8.47412 13.6139 8.64441L12.089 10.9124H12.0426L10.4867 8.63667C10.3732 8.47154 10.2622 8.35543 10.1538 8.28834C10.0506 8.22125 9.91904 8.18771 9.75907 8.18771C9.55781 8.18771 9.38494 8.2548 9.24044 8.38897C9.10111 8.52314 9.03145 8.68828 9.03145 8.88437C9.03145 9.06499 9.10111 9.24819 9.24044 9.43396L11.044 11.9032L9.13982 14.5119C9.02113 14.6821 8.96178 14.8524 8.96178 15.0227C8.96178 15.2137 9.02629 15.3736 9.1553 15.5027C9.28947 15.6265 9.45718 15.6884 9.65844 15.6884Z" })
    ]
  }
), E8e = (t) => {
  const {
    file: r,
    variant: e,
    onFileChange: n,
    onRemoveFile: i,
    accept: a,
    acceptText: o,
    additionalAcceptText: s,
    className: l,
    formLabel: u,
    formSubLabel: c,
    isRequired: d = !1,
    isError: f = !1,
    tooltip: h,
    onClickImage: p,
    disabled: v = !1,
    timeLabel: g,
    locationInfo: m,
    uploaderInfo: y
  } = t, b = ui(), C = Vt(null), w = () => {
    C.current && (C.current.value = ""), i();
  }, _ = () => /* @__PURE__ */ S.jsx(
    "div",
    {
      className: `theme-file-input-small ${r !== void 0 ? "theme-file-input-hasfile" : ""}`,
      onClick: () => {
        r === void 0 && C.current !== null && C.current.click();
      },
      children: r === void 0 || r.uri === void 0 ? /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
        /* @__PURE__ */ S.jsx(y6e, {}),
        /* @__PURE__ */ S.jsx("span", { className: "theme-file-input-small-text", children: "Upload" })
      ] }) : /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
        !v && /* @__PURE__ */ S.jsx(
          lk,
          {
            className: "theme-file-input-close",
            onClick: () => w()
          }
        ),
        r.uri && r.type && typeof r.uri == "string" && r.type === "image" && /* @__PURE__ */ S.jsx(
          "img",
          {
            src: r.uri,
            alt: "",
            onClick: () => p && p(r)
          }
        ),
        r.uri && r.type && typeof r.uri == "string" && r.type === "document" && /* @__PURE__ */ S.jsx("span", { className: "theme-file-input-small-filename", children: kZ(r.uri) })
      ] })
    }
  ), x = (T) => {
    T.preventDefault(), T.dataTransfer.dropEffect = "copy";
  }, I = (T) => {
    T.preventDefault();
    const A = T.dataTransfer.files[0];
    if (A) {
      if (a) {
        const M = a.split(",");
        if (M.includes("image/*") && !A.type.includes("image/*"))
          return !1;
        if (!M.includes(A.type))
          return !1;
      }
      n(A);
    }
  }, D = () => /* @__PURE__ */ S.jsx(
    "div",
    {
      className: `theme-file-input-large ${r !== void 0 ? "theme-file-input-hasfile" : ""}`,
      onDragOver: x,
      onDrop: I,
      onClick: () => {
        r === void 0 && C !== null && C.current !== null && C.current.click();
      },
      children: r === void 0 || r.uri === void 0 ? /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
        f ? /* @__PURE__ */ S.jsx(C6e, {}) : /* @__PURE__ */ S.jsx(b6e, {}),
        /* @__PURE__ */ S.jsx("span", { className: "theme-file-input-large-text1", children: "Drag and drop" }),
        /* @__PURE__ */ S.jsx("span", { className: "theme-file-input-large-text2", children: o }),
        /* @__PURE__ */ S.jsx("span", { className: "theme-file-input-large-text2", children: s }),
        /* @__PURE__ */ S.jsx("span", { className: "theme-file-input-large-button", children: "Browse" })
      ] }) : /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
        !v && /* @__PURE__ */ S.jsx(
          lk,
          {
            className: "theme-file-input-close",
            onClick: () => w()
          }
        ),
        r !== void 0 && r.type === "image" && typeof r.uri == "string" && /* @__PURE__ */ S.jsx(
          "img",
          {
            src: r.uri,
            alt: "",
            onClick: () => p && p(r)
          }
        ),
        r !== void 0 && r.type === "document" && /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
          /* @__PURE__ */ S.jsx("span", { className: "theme-file-input-filename", children: typeof r.uri == "string" && r.uri }),
          /* @__PURE__ */ S.jsx("span", { className: "theme-file-input-message", children: "Successfully uploaded" })
        ] }),
        g && /* @__PURE__ */ S.jsx("span", { className: "theme-file-input-time", children: g })
      ] })
    }
  );
  return /* @__PURE__ */ S.jsxs(
    "div",
    {
      className: `${f ? "theme-file-input-error" : ""} ${l !== void 0 ? l : ""}`,
      children: [
        /* @__PURE__ */ S.jsx(
          "input",
          {
            type: "file",
            ref: C,
            accept: a ?? "*",
            onChange: (T) => {
              var A;
              n((A = T.target.files) == null ? void 0 : A[0]);
            },
            className: "theme-file-input",
            disabled: v
          }
        ),
        u && /* @__PURE__ */ S.jsxs("label", { className: "theme-form-input-label", children: [
          u,
          " ",
          d && /* @__PURE__ */ S.jsx("span", { children: "*" }),
          " ",
          h && /* @__PURE__ */ S.jsx(S.Fragment, { children: h.onClick !== void 0 ? /* @__PURE__ */ S.jsx(
            Dr,
            {
              onClick: () => h.onClick && h.onClick()
            }
          ) : /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
            /* @__PURE__ */ S.jsx(
              Dr,
              {
                "data-tooltip-id": `${b}-tooltip`,
                "data-tooltip-html": h.content !== void 0 ? h.content : ""
              }
            ),
            /* @__PURE__ */ S.jsx(
              Si,
              {
                id: `${b}-tooltip`,
                className: "theme-tooltip"
              }
            )
          ] }) })
        ] }),
        c && /* @__PURE__ */ S.jsx("label", { className: "theme-form-sublabel", children: c }),
        e === "small" && _(),
        e === "large" && D(),
        m && /* @__PURE__ */ S.jsxs("div", { className: "theme-file-input-location-info", children: [
          /* @__PURE__ */ S.jsxs(
            "div",
            {
              className: "theme-file-input-location-latlng",
              onClick: () => {
                m.onMapLabelClick && m.onMapLabelClick();
              },
              children: [
                /* @__PURE__ */ S.jsx(w6e, { className: "fill-color-purple-500" }),
                /* @__PURE__ */ S.jsx("span", { children: m.mapLabel })
              ]
            }
          ),
          /* @__PURE__ */ S.jsx("p", { className: "theme-file-input-location-address", children: m.addressLabel })
        ] }),
        " ",
        y && /* @__PURE__ */ S.jsxs("div", { className: "theme-file-input-uploader-info", children: [
          /* @__PURE__ */ S.jsxs("div", { className: "theme-file-input-uploader-title", children: [
            /* @__PURE__ */ S.jsx(_6e, { className: "fill-color-grey-300" }),
            /* @__PURE__ */ S.jsx("span", { children: y.title })
          ] }),
          y.description && /* @__PURE__ */ S.jsx("p", { children: y.description })
        ] })
      ]
    }
  );
}, uk = (t) => {
  const [r, e] = We(0), {
    value: n,
    max: i,
    variant: a = "purple",
    withTimer: o = !1,
    uploadLabel: s = "",
    className: l = ""
  } = t;
  return Ue(() => {
    e(n / i * 100);
  }, [n]), Ue(() => {
    if (o) {
      const u = setInterval(() => {
        const c = Math.random() * 2;
        e((d) => d >= i ? (clearInterval(u), i) : d + c);
      }, 100);
      return () => clearInterval(u);
    }
  }, []), /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
    /* @__PURE__ */ S.jsx(
      "div",
      {
        className: `theme-progress-bar theme-progress-bar-color-${a} ${l}`,
        children: /* @__PURE__ */ S.jsx(
          "div",
          {
            className: "theme-progress-bar-fill",
            style: { width: `${r}%` }
          }
        )
      }
    ),
    s !== "" && /* @__PURE__ */ S.jsxs("span", { className: "theme-progress-bar-label", children: [
      s,
      " ",
      Math.round(r).toLocaleString(),
      "%"
    ] })
  ] });
}, x6e = (t) => /* @__PURE__ */ $.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ $.createElement("g", { id: "icon-upload" }, /* @__PURE__ */ $.createElement("path", { id: "ô", d: "M14.4504 14.7807H17.9955C19.444 14.7807 20.1429 14.0673 20.1429 13.0409C20.1429 11.8544 19.3203 11.1119 17.9809 10.879C17.879 10.8644 17.8353 10.8062 17.8499 10.7043C17.8863 10.3403 17.9154 9.89627 17.8935 9.48135C17.7844 7.3849 16.1829 5.62329 13.9481 5.62329C12.1793 5.62329 11.1019 6.56233 10.4104 7.83621C10.3667 7.92357 10.3012 7.93813 10.2066 7.91629C8.59782 7.45041 7.08371 8.1929 7.15651 10.3185C7.16379 10.4277 7.11283 10.4859 7.01092 10.4859C5.55505 10.4859 4.64513 11.3885 4.64513 12.7425C4.64513 13.8635 5.48226 14.7807 6.9818 14.7807H10.2648V16.404H6.9818C4.53594 16.404 3 14.788 3 12.7862C3 11.0027 4.03367 9.59782 5.7152 9.2848C5.80255 7.22475 7.84076 5.89263 9.6242 6.31483C10.5632 4.96815 12.0409 4 13.9627 4C17.0564 4 19.4513 6.3949 19.4513 9.71429C20.9072 10.2894 21.7953 11.5632 21.7953 13.1501C21.7953 15.0428 20.354 16.404 18.0464 16.404H14.4504V14.7807ZM12.3612 20C11.9463 20 11.6115 19.6579 11.6115 19.2648V12.6333L11.7061 11.3667L11.2548 11.9126L10.2939 12.8881C10.1629 13.0191 9.98089 13.0992 9.79891 13.0992C9.44222 13.0992 9.14377 12.8371 9.14377 12.4659C9.14377 12.2766 9.20928 12.131 9.34759 12L11.7789 9.71429C11.9827 9.5323 12.1574 9.45951 12.3612 9.45951C12.5578 9.45951 12.7398 9.5323 12.9363 9.71429L15.3676 12C15.5059 12.131 15.5714 12.2766 15.5714 12.4659C15.5714 12.8371 15.2657 13.0992 14.9163 13.0992C14.7343 13.0992 14.5523 13.0191 14.4213 12.8881L13.4604 11.9126L13.0164 11.3667L13.1037 12.6333V19.2648C13.1037 19.6579 12.7689 20 12.3612 20Z", fill: "white" }))), ck = (t) => /* @__PURE__ */ $.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ $.createElement("g", { id: "icon-x" }, /* @__PURE__ */ $.createElement("path", { id: "ô", d: "M3.4497 12.5453C3.11316 12.2146 3.12476 11.6286 3.43809 11.3153L6.75703 7.99632L3.43809 4.68899C3.12476 4.36986 3.11316 3.78963 3.4497 3.45309C3.78623 3.11075 4.37227 3.12236 4.68559 3.44149L7.99873 6.75462L11.3119 3.44149C11.6368 3.11655 12.2054 3.11655 12.542 3.45309C12.8843 3.78963 12.8843 4.35825 12.5536 4.68899L9.24623 7.99632L12.5536 11.3095C12.8843 11.6402 12.8785 12.203 12.542 12.5453C12.2112 12.8819 11.6368 12.8819 11.3119 12.557L7.99873 9.24382L4.68559 12.557C4.37227 12.8761 3.79203 12.8819 3.4497 12.5453Z", fill: "#395278" }))), k8e = (t) => {
  const [r, e] = We(!1), {
    files: n,
    uploadingFiles: i,
    state: a,
    onFilesUpload: o,
    onRemoveFile: s,
    className: l = "",
    accept: u,
    acceptText: c = "",
    withTimer: d = !1
  } = t, f = ui(), h = Vt(null), p = () => /* @__PURE__ */ S.jsxs("span", { className: "theme-file-dropzone-title", children: [
    a === "idle" && "Drag and drop the file here",
    a === "uploading" && "Uploading...",
    a === "upload-success" && "All File(s) Uploaded!"
  ] }), v = () => /* @__PURE__ */ S.jsxs("span", { className: "theme-file-dropzone-subtitle", children: [
    a === "idle" && c !== "" && c,
    a === "uploading" && "This won’t take too long!",
    a === "upload-success" && "Your file(s) has been successfully uploaded"
  ] }), g = (y) => {
    y.preventDefault(), e(!0), y.dataTransfer.dropEffect = "copy";
  }, m = (y) => {
    y.preventDefault(), e(!1);
    const b = y.dataTransfer.files;
    if (b) {
      for (let C of b)
        if (u) {
          const w = u.split(",");
          if (w.includes("image/*") && !C.type.includes("image/*"))
            return !1;
          if (!w.includes(C.type))
            return !1;
        }
    }
    o(b);
  };
  return /* @__PURE__ */ S.jsxs(
    TY,
    {
      className: `theme-file-dropzone ${r ? "theme-file-dropzone-dragged" : ""} ${l}`,
      onDragOver: g,
      onDragLeave: () => e(!1),
      onDrop: m,
      children: [
        /* @__PURE__ */ S.jsx(
          "input",
          {
            type: "file",
            ref: h,
            accept: u ?? "*",
            multiple: !0,
            onChange: (y) => {
              o(y.target.files);
            },
            className: "theme-file-input"
          }
        ),
        p(),
        v(),
        a === "idle" && /* @__PURE__ */ S.jsx(
          DY,
          {
            className: "theme-file-dropzone-button",
            label: "Browse",
            icon: /* @__PURE__ */ S.jsx(x6e, {}),
            iconPosition: "left",
            onClick: () => {
              h !== null && h.current !== null && h.current.click();
            }
          }
        ),
        a !== "idle" && /* @__PURE__ */ S.jsxs("div", { className: "theme-file-dropzone-files", children: [
          a === "uploading" && i && i.map((y, b) => /* @__PURE__ */ S.jsxs(
            "div",
            {
              className: "theme-file-dropzone-file",
              children: [
                /* @__PURE__ */ S.jsx(
                  ck,
                  {
                    className: "file-remove",
                    onClick: () => s(b, "uploadingFiles")
                  }
                ),
                /* @__PURE__ */ S.jsx("p", { className: "file-name", children: y.file.name }),
                /* @__PURE__ */ S.jsx(
                  uk,
                  {
                    value: y.uploadPercent,
                    max: 100,
                    uploadLabel: "Uploading",
                    withTimer: d
                  }
                )
              ]
            },
            `dz-${f}-uploading-${b}`
          )),
          a === "upload-success" && n && n.map((y, b) => (console.log({ file: y }), /* @__PURE__ */ S.jsxs(
            "div",
            {
              className: "theme-file-dropzone-file",
              children: [
                /* @__PURE__ */ S.jsx(
                  ck,
                  {
                    className: "file-remove",
                    onClick: () => s(b, "uploadedFiles")
                  }
                ),
                /* @__PURE__ */ S.jsx("p", { className: "file-name", children: typeof y.uri == "string" && kZ(y.uri) }),
                /* @__PURE__ */ S.jsx(uk, { value: 100, max: 100 }),
                /* @__PURE__ */ S.jsx("p", { className: "file-upload-message", children: "Successfully uploaded" })
              ]
            },
            `dz-${f}-uploading-${b}`
          )))
        ] })
      ]
    }
  );
}, P8e = (t) => {
  const { fileLabel: r, linkLabel: e, fileDescription: n, onLinkClick: i } = t;
  return /* @__PURE__ */ S.jsxs("div", { className: "theme-file-input-large theme-file-viewer", children: [
    /* @__PURE__ */ S.jsx("span", { className: "theme-file-viewer-title", children: r }),
    n && /* @__PURE__ */ S.jsx("span", { className: "theme-file-viewer-description", children: n }),
    e && i && /* @__PURE__ */ S.jsx("span", { className: "theme-file-viewer-link", onClick: i, children: e })
  ] });
}, N8e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), PZ = (t) => /* @__PURE__ */ $.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ $.createElement("path", { d: "M12.3447 17.7168C6.88965 17.7168 3 13.2529 3 11.8584C3 10.457 6.89648 6 12.3447 6C17.8613 6 21.6826 10.457 21.6826 11.8584C21.6826 13.2529 17.8682 17.7168 12.3447 17.7168ZM12.3447 16.6367C16.8291 16.6367 20.4863 12.8223 20.4863 11.8584C20.4863 11.0449 16.8291 7.08008 12.3447 7.08008C7.83984 7.08008 4.19629 11.0449 4.19629 11.8584C4.19629 12.8223 7.83984 16.6367 12.3447 16.6367ZM12.3447 15.6865C10.2051 15.6865 8.49609 13.9434 8.49609 11.8584C8.49609 9.71875 10.2051 8.03027 12.3447 8.03027C14.4707 8.03027 16.1797 9.71875 16.1797 11.8584C16.1797 13.9434 14.4707 15.6865 12.3447 15.6865ZM12.3447 13.1299C13.0488 13.1299 13.623 12.5557 13.623 11.8584C13.623 11.1543 13.0488 10.5869 12.3447 10.5869C11.6338 10.5869 11.0596 11.1543 11.0596 11.8584C11.0596 12.5557 11.6338 13.1299 12.3447 13.1299Z", fill: "#395278" })), NZ = (t) => /* @__PURE__ */ $.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ $.createElement("path", { d: "M17.6631 18.3218L6.22656 6.89893C6.02832 6.70068 6.02832 6.35205 6.22656 6.15381C6.43848 5.94873 6.77344 5.94873 6.97852 6.15381L18.4082 17.5767C18.6133 17.7886 18.6338 18.0962 18.4082 18.3218C18.1963 18.5474 17.8682 18.5337 17.6631 18.3218ZM12.3447 6.54346C17.8682 6.54346 21.6826 11.0005 21.6826 12.4019C21.6826 13.2085 20.3975 15.0474 18.2373 16.4487L17.3965 15.6079C19.29 14.4458 20.4863 12.9556 20.4863 12.4019C20.4863 11.5884 16.8428 7.62354 12.3447 7.62354C11.4971 7.62354 10.7246 7.75342 9.97266 7.979L9.07031 7.0835C10.0752 6.74854 11.1553 6.54346 12.3447 6.54346ZM12.3447 18.2603C6.88965 18.2603 3 13.7964 3 12.4019C3 11.5747 4.35352 9.68115 6.62988 8.27295L7.47754 9.12061C5.46094 10.3306 4.19629 11.9233 4.19629 12.4019C4.19629 13.3657 7.83984 17.1802 12.3447 17.1802C13.2676 17.1802 14.1289 17.0298 14.9424 16.7769L15.8379 17.6724C14.7783 18.0347 13.6162 18.2603 12.3447 18.2603ZM15.8516 13.8989L10.8408 8.88818C11.2988 8.68994 11.8047 8.57373 12.3447 8.57373C14.4707 8.57373 16.1797 10.2622 16.1797 12.4019C16.1797 12.9282 16.0635 13.4409 15.8516 13.8989ZM12.3447 16.23C10.2051 16.23 8.50293 14.4868 8.49609 12.4019C8.49609 11.7866 8.63965 11.2124 8.89258 10.7065L14.0195 15.8335C13.5137 16.0796 12.9463 16.23 12.3447 16.23Z", fill: "#395278" })), O8e = (t) => {
  const [r, e] = We(!1), {
    name: n,
    value: i = "",
    placeholder: a,
    autoComplete: o,
    containerClassName: s,
    className: l,
    formLabel: u,
    formSubLabel: c,
    inputHelpBlock: d,
    disabled: f = !1,
    isRequired: h = !1,
    hasError: p = !1,
    errorMessage: v = "",
    onInputChange: g,
    icon: m = null,
    maxLength: y = null,
    type: b,
    tooltip: C
  } = t;
  let w = b;
  w === "password" && (w = r ? "text" : "password");
  const _ = ui();
  return /* @__PURE__ */ S.jsxs(
    "div",
    {
      className: `theme-form-input-container ${s !== void 0 ? s : ""}`,
      children: [
        u && /* @__PURE__ */ S.jsxs("label", { className: "theme-form-input-label", htmlFor: `field-${n}`, children: [
          u,
          " ",
          h && /* @__PURE__ */ S.jsx("span", { children: "*" }),
          " ",
          C && /* @__PURE__ */ S.jsx(S.Fragment, { children: C.onClick !== void 0 ? /* @__PURE__ */ S.jsx(
            Dr,
            {
              onClick: () => C.onClick && C.onClick()
            }
          ) : /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
            /* @__PURE__ */ S.jsx(
              Dr,
              {
                "data-tooltip-id": `${_}-tooltip`,
                "data-tooltip-html": C.content !== void 0 ? C.content : ""
              }
            ),
            /* @__PURE__ */ S.jsx(
              Si,
              {
                id: `${_}-tooltip`,
                className: "theme-tooltip"
              }
            )
          ] }) })
        ] }),
        c && /* @__PURE__ */ S.jsx("label", { className: "theme-form-sublabel", children: c }),
        /* @__PURE__ */ S.jsxs("div", { className: "theme-form-input-field-wrapper", children: [
          /* @__PURE__ */ S.jsx(
            "input",
            {
              disabled: f,
              placeholder: a,
              type: w !== void 0 ? w : "text",
              name: n,
              value: y !== null && i.length > y ? i.substring(0, y) : i,
              className: `theme-form-control ${m !== null && "has-left"} ${l !== void 0 ? l : ""} ${p && "theme-form-control-has-error"}`,
              autoComplete: o !== void 0 ? o : "",
              onChange: (x) => {
                g && g(x);
              }
            }
          ),
          y === null && m !== null && /* @__PURE__ */ S.jsx("div", { className: "theme-form-input-icon", children: m }),
          y !== null && m === null && /* @__PURE__ */ S.jsxs("span", { className: "theme-form-input-count", children: [
            i.length,
            "/",
            y
          ] })
        ] }),
        b === "password" && /* @__PURE__ */ S.jsx(
          "div",
          {
            className: "theme-form-icon-adornment",
            onClick: () => e((x) => !x),
            children: r ? /* @__PURE__ */ S.jsx(PZ, {}) : /* @__PURE__ */ S.jsx(NZ, {})
          }
        ),
        p && /* @__PURE__ */ S.jsx("div", { className: "theme-font-sm color-theme-red-500 theme-form-error-message", children: v }),
        d && /* @__PURE__ */ S.jsx("span", { className: "theme-form-helpblock", children: d })
      ]
    }
  );
}, V8e = (t) => {
  const [r, e] = We(!1), {
    name: n,
    defaultValue: i,
    placeholder: a,
    autoComplete: o,
    containerClassName: s,
    className: l,
    formLabel: u,
    formSubLabel: c,
    inputHelpBlock: d,
    isRequired: f = !1,
    disabled: h = !1,
    onInputChange: p,
    type: v,
    icon: g = null,
    maxLength: m = null,
    tooltip: y,
    rules: b,
    control: C,
    errors: w
  } = t;
  let _ = v;
  return _ === "password" && (_ = r ? "text" : "password"), /* @__PURE__ */ S.jsxs(
    "div",
    {
      className: `theme-form-input-container ${s !== void 0 ? s : ""}`,
      children: [
        /* @__PURE__ */ S.jsx(
          mu,
          {
            name: n,
            control: C,
            defaultValue: i,
            rules: b || {},
            render: ({ field: { onChange: x, value: I } }) => /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
              u && /* @__PURE__ */ S.jsxs(
                "label",
                {
                  className: "theme-form-input-label",
                  htmlFor: `field-${n}`,
                  children: [
                    u,
                    " ",
                    f && /* @__PURE__ */ S.jsx("span", { children: "*" }),
                    " ",
                    y && /* @__PURE__ */ S.jsx(S.Fragment, { children: y.onClick !== void 0 ? /* @__PURE__ */ S.jsx(
                      Dr,
                      {
                        onClick: () => y.onClick && y.onClick()
                      }
                    ) : /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
                      /* @__PURE__ */ S.jsx(
                        Dr,
                        {
                          "data-tooltip-id": `${n}-tooltip`,
                          "data-tooltip-html": y.content !== void 0 ? y.content : ""
                        }
                      ),
                      /* @__PURE__ */ S.jsx(
                        Si,
                        {
                          id: `${n}-tooltip`,
                          className: "theme-tooltip"
                        }
                      )
                    ] }) })
                  ]
                }
              ),
              c && /* @__PURE__ */ S.jsx("label", { className: "theme-form-sublabel", children: c }),
              /* @__PURE__ */ S.jsxs("div", { className: "theme-form-input-field-wrapper", children: [
                /* @__PURE__ */ S.jsx(
                  "input",
                  {
                    id: `field-${n}`,
                    disabled: h,
                    placeholder: a,
                    type: _ !== void 0 ? _ : "text",
                    name: n,
                    value: m !== null && I.length > m ? I.substring(0, m) : I,
                    className: `theme-form-control ${l !== void 0 ? l : ""} ${n in w && "theme-form-control-has-error"}`,
                    autoComplete: o !== void 0 ? o : "on",
                    onChange: (D) => {
                      x(D), p && p(D);
                    }
                  }
                ),
                m === null && g !== null && /* @__PURE__ */ S.jsx("div", { className: "theme-form-input-icon", children: g }),
                m !== null && g === null && /* @__PURE__ */ S.jsxs("span", { className: "theme-form-input-count", children: [
                  I.length,
                  "/",
                  m
                ] })
              ] })
            ] })
          }
        ),
        v === "password" && /* @__PURE__ */ S.jsx(
          "div",
          {
            className: "theme-form-icon-adornment",
            onClick: () => e((x) => !x),
            children: r ? /* @__PURE__ */ S.jsx(PZ, {}) : /* @__PURE__ */ S.jsx(NZ, {})
          }
        ),
        /* @__PURE__ */ S.jsx(
          yu,
          {
            errors: w,
            name: n,
            render: ({ message: x }) => /* @__PURE__ */ S.jsx("div", { className: "theme-font-sm color-theme-red-500 theme-form-error-message", children: x })
          }
        ),
        d && /* @__PURE__ */ S.jsx("span", { className: "theme-form-helpblock", children: d })
      ]
    }
  );
}, G8e = (t) => {
  const {
    name: r,
    value: e,
    characterLimit: n,
    placeholder: i,
    containerClassName: a,
    className: o,
    formLabel: s,
    formSubLabel: l,
    inputHelpBlock: u,
    disabled: c = !1,
    isRequired: d = !1,
    hasError: f = !1,
    errorMessage: h = "",
    onInputChange: p,
    tooltip: v
  } = t, g = ui();
  return /* @__PURE__ */ S.jsxs(
    "div",
    {
      className: `theme-form-input-container ${a !== void 0 ? a : ""}`,
      children: [
        s && /* @__PURE__ */ S.jsxs("label", { className: "theme-form-input-label", htmlFor: `field-${r}`, children: [
          s,
          " ",
          d && /* @__PURE__ */ S.jsx("span", { children: "*" }),
          " ",
          v && /* @__PURE__ */ S.jsx(S.Fragment, { children: v.onClick !== void 0 ? /* @__PURE__ */ S.jsx(
            Dr,
            {
              onClick: () => v.onClick && v.onClick()
            }
          ) : /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
            /* @__PURE__ */ S.jsx(
              Dr,
              {
                "data-tooltip-id": `${g}-tooltip`,
                "data-tooltip-html": v.content !== void 0 ? v.content : ""
              }
            ),
            /* @__PURE__ */ S.jsx(
              Si,
              {
                id: `${g}-tooltip`,
                className: "theme-tooltip"
              }
            )
          ] }) })
        ] }),
        l && /* @__PURE__ */ S.jsx("label", { className: "theme-form-sublabel", children: l }),
        /* @__PURE__ */ S.jsx(
          "textarea",
          {
            disabled: c,
            placeholder: i,
            name: r,
            value: e !== null ? e : "",
            className: `theme-form-control theme-form-textarea ${o !== void 0 ? o : ""} ${f && "theme-form-control-has-error"}`,
            onChange: (m) => {
              n && m.target.value.length > n || p && p(m);
            }
          }
        ),
        n && /* @__PURE__ */ S.jsxs("span", { className: "theme-textarea-count", children: [
          e.length,
          "/",
          n.toString()
        ] }),
        f && /* @__PURE__ */ S.jsx("div", { className: "theme-font-sm color-theme-red-500 theme-form-error-message", children: h }),
        u && /* @__PURE__ */ S.jsx("span", { className: "theme-form-helpblock", children: u })
      ]
    }
  );
}, B8e = (t) => {
  const {
    name: r,
    defaultValue: e,
    characterLimit: n,
    placeholder: i,
    containerClassName: a,
    className: o,
    formLabel: s,
    formSubLabel: l,
    inputHelpBlock: u,
    disabled: c = !1,
    isRequired: d = !1,
    hasError: f = !1,
    onInputChange: h,
    tooltip: p,
    rules: v,
    control: g,
    errors: m
  } = t, y = ui();
  return /* @__PURE__ */ S.jsx(
    "div",
    {
      className: `theme-form-input-container ${a !== void 0 ? a : ""}`,
      children: /* @__PURE__ */ S.jsx(
        mu,
        {
          name: r,
          control: g,
          defaultValue: e,
          rules: v || {},
          render: ({ field: { onChange: b, value: C } }) => /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
            s && /* @__PURE__ */ S.jsxs(
              "label",
              {
                className: "theme-form-input-label",
                htmlFor: `field-${r}`,
                children: [
                  s,
                  " ",
                  d && /* @__PURE__ */ S.jsx("span", { children: "*" }),
                  " ",
                  p && /* @__PURE__ */ S.jsx(S.Fragment, { children: p.onClick !== void 0 ? /* @__PURE__ */ S.jsx(
                    Dr,
                    {
                      onClick: () => p.onClick && p.onClick()
                    }
                  ) : /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
                    /* @__PURE__ */ S.jsx(
                      Dr,
                      {
                        "data-tooltip-id": `${y}-tooltip`,
                        "data-tooltip-html": p.content !== void 0 ? p.content : ""
                      }
                    ),
                    /* @__PURE__ */ S.jsx(
                      Si,
                      {
                        id: `${y}-tooltip`,
                        className: "theme-tooltip"
                      }
                    )
                  ] }) })
                ]
              }
            ),
            l && /* @__PURE__ */ S.jsx("label", { className: "theme-form-sublabel", children: l }),
            /* @__PURE__ */ S.jsx(
              "textarea",
              {
                disabled: c,
                placeholder: i,
                name: r,
                value: C !== null ? C : "",
                className: `theme-form-control theme-form-textarea ${o !== void 0 ? o : ""} ${f && "theme-form-control-has-error"}`,
                onChange: (w) => {
                  n && w.target.value !== void 0 && w.target.value.length > n || (b(w), h && h(w));
                }
              }
            ),
            n && /* @__PURE__ */ S.jsxs("span", { className: "theme-textarea-count", children: [
              C.length,
              "/",
              n.toString()
            ] }),
            /* @__PURE__ */ S.jsx(
              yu,
              {
                errors: m,
                name: r,
                render: ({ message: w }) => /* @__PURE__ */ S.jsx("div", { className: "theme-font-sm color-theme-red-500 theme-form-error-message", children: w })
              }
            ),
            u && /* @__PURE__ */ S.jsx("span", { className: "theme-form-helpblock", children: u })
          ] })
        }
      )
    }
  );
}, OZ = (t) => /* @__PURE__ */ $.createElement("svg", { width: 13, height: 13, viewBox: "0 0 13 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ $.createElement("path", { d: "M4.92188 12.168C4.48438 12.168 4.15625 12.0107 3.8623 11.6621L0.334961 7.38965C0.0888672 7.10938 0 6.85645 0 6.56934C0 5.92676 0.478516 5.45508 1.1416 5.45508C1.52441 5.45508 1.79785 5.5918 2.05078 5.89258L4.8877 9.41309L10.4795 0.594727C10.7529 0.164062 11.0332 0 11.4844 0C12.1406 0 12.6191 0.464844 12.6191 1.10742C12.6191 1.34668 12.5439 1.59961 12.3662 1.87305L5.99512 11.6143C5.74902 11.9902 5.38672 12.168 4.92188 12.168Z", fill: "#ffffff" })), VZ = (t) => /* @__PURE__ */ $.createElement("svg", { width: 13, height: 13, viewBox: "0 0 13 13", ...t }, /* @__PURE__ */ $.createElement("line", { x1: 0, y1: 7, x2: 13, y2: 7, stroke: "white", strokeWidth: 3 })), s5 = (t) => {
  const {
    name: r,
    value: e,
    theme: n = "purple",
    onInputChange: i,
    checkboxValues: a,
    variant: o = "checkbox",
    className: s = "",
    alignment: l = "vertical",
    containerClassName: u,
    formLabel: c,
    formSubLabel: d,
    inputHelpBlock: f,
    isRequired: h = !1,
    hasError: p = !1,
    errorMessage: v = "",
    disabled: g = !1,
    useSecondaryCheckmark: m = !1,
    tooltip: y
  } = t, b = ui();
  return /* @__PURE__ */ S.jsxs(
    "div",
    {
      className: `${u !== void 0 ? u : ""}`,
      children: [
        c && /* @__PURE__ */ S.jsxs("label", { className: "theme-form-input-label", htmlFor: `field-${r}`, children: [
          c,
          " ",
          h && /* @__PURE__ */ S.jsx("span", { children: "*" }),
          " ",
          y && /* @__PURE__ */ S.jsx(S.Fragment, { children: y.onClick !== void 0 ? /* @__PURE__ */ S.jsx(
            Dr,
            {
              onClick: () => y.onClick && y.onClick()
            }
          ) : /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
            /* @__PURE__ */ S.jsx(
              Dr,
              {
                "data-tooltip-id": `${b}-tooltip`,
                "data-tooltip-html": y.content !== void 0 ? y.content : ""
              }
            ),
            /* @__PURE__ */ S.jsx(
              Si,
              {
                id: `${b}-tooltip`,
                className: "theme-tooltip"
              }
            )
          ] }) })
        ] }),
        d && /* @__PURE__ */ S.jsx("label", { className: "theme-form-sublabel", children: d }),
        /* @__PURE__ */ S.jsx(
          "div",
          {
            className: `theme-checkbox-container theme-checkbox-variant-${o} theme-checkbox-align-${l}`,
            children: a.map(
              (C, w) => o === "switch" ? /* @__PURE__ */ S.jsxs(
                "label",
                {
                  className: `theme-checkbox-switch ${g && "theme-checkbox-disabled"} theme-checkbox-color-${n} ${s}`,
                  children: [
                    /* @__PURE__ */ S.jsx(
                      "input",
                      {
                        id: `input-checkbox-${r}-${w}`,
                        type: "checkbox",
                        value: C.value,
                        checked: Array.isArray(e) ? e.includes(C.value) : C.value === e,
                        name: r,
                        disabled: g,
                        onChange: (_) => {
                          i && i(_, C.value);
                        }
                      }
                    ),
                    /* @__PURE__ */ S.jsx("span", { className: "theme-checkbox-switch-slider" })
                  ]
                },
                `input-checkbox-${r}-${w}`
              ) : /* @__PURE__ */ S.jsxs(
                "div",
                {
                  className: `theme-checkbox ${g && "theme-checkbox-disabled"} theme-checkbox-color-${n} ${s}`,
                  children: [
                    /* @__PURE__ */ S.jsx(
                      "input",
                      {
                        id: `input-checkbox-${r}-${w}`,
                        type: "checkbox",
                        value: C.value,
                        checked: Array.isArray(e) ? e.includes(C.value) : C.value === e,
                        name: r,
                        disabled: g,
                        onChange: (_) => {
                          i && i(_, C.value);
                        }
                      }
                    ),
                    /* @__PURE__ */ S.jsxs(
                      "label",
                      {
                        htmlFor: `input-checkbox-${r}-${w}`,
                        className: "theme-checkbox-label",
                        children: [
                          C.label,
                          m ? /* @__PURE__ */ S.jsx(VZ, {}) : /* @__PURE__ */ S.jsx(OZ, {})
                        ]
                      }
                    )
                  ]
                },
                `input-checkbox-${r}-${w}`
              )
            )
          }
        ),
        f && /* @__PURE__ */ S.jsx("span", { className: "theme-form-helpblock", children: f }),
        p && /* @__PURE__ */ S.jsx("div", { className: "theme-font-sm color-theme-red-500 theme-form-error-message", children: v })
      ]
    }
  );
}, F8e = (t) => {
  const {
    name: r,
    theme: e = "purple",
    onInputChange: n,
    checkboxValues: i,
    className: a = "",
    containerClassName: o,
    formLabel: s,
    formSubLabel: l,
    inputHelpBlock: u,
    isRequired: c = !1,
    disabled: d = !1,
    useSecondaryCheckmark: f = !1,
    tooltip: h,
    rules: p,
    control: v,
    errors: g
  } = t;
  return /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
    /* @__PURE__ */ S.jsx(
      mu,
      {
        name: r,
        control: v,
        rules: p || {},
        render: ({ field: { onChange: m, value: y } }) => /* @__PURE__ */ S.jsxs(
          "div",
          {
            className: `${o !== void 0 ? o : ""}`,
            children: [
              s && /* @__PURE__ */ S.jsxs(
                "label",
                {
                  className: "theme-form-input-label",
                  htmlFor: `field-${r}`,
                  children: [
                    s,
                    " ",
                    c && /* @__PURE__ */ S.jsx("span", { children: "*" }),
                    " ",
                    h && /* @__PURE__ */ S.jsx(S.Fragment, { children: h.onClick !== void 0 ? /* @__PURE__ */ S.jsx(
                      Dr,
                      {
                        onClick: () => h.onClick && h.onClick()
                      }
                    ) : /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
                      /* @__PURE__ */ S.jsx(
                        Dr,
                        {
                          "data-tooltip-id": `${r}-tooltip`,
                          "data-tooltip-html": h.content !== void 0 ? h.content : ""
                        }
                      ),
                      /* @__PURE__ */ S.jsx(
                        Si,
                        {
                          id: `${r}-tooltip`,
                          className: "theme-tooltip"
                        }
                      )
                    ] }) })
                  ]
                }
              ),
              l && /* @__PURE__ */ S.jsx("label", { className: "theme-form-sublabel", children: l }),
              /* @__PURE__ */ S.jsx("div", { className: "theme-checkbox-container", children: i.map((b, C) => /* @__PURE__ */ S.jsxs(
                "div",
                {
                  className: `theme-checkbox theme-checkbox-color-${e} ${a}`,
                  children: [
                    /* @__PURE__ */ S.jsx(
                      "input",
                      {
                        id: `input-checkbox-${r}-${C}`,
                        type: "checkbox",
                        value: b.value,
                        checked: y && Array.isArray(y) && y.includes(b.value),
                        name: r,
                        disabled: d,
                        onChange: (w) => {
                          if (y && w.target.checked)
                            m(y.concat([b.value]));
                          else {
                            const _ = [...y].filter(
                              (x) => x !== b.value
                            );
                            m(_);
                          }
                          n && n(w, b.value);
                        }
                      }
                    ),
                    /* @__PURE__ */ S.jsx(
                      "label",
                      {
                        htmlFor: `input-checkbox-${r}-${C}`,
                        className: "theme-checkbox-label",
                        children: b.label
                      }
                    ),
                    f ? /* @__PURE__ */ S.jsx(VZ, {}) : /* @__PURE__ */ S.jsx(OZ, {})
                  ]
                },
                `input-checkbox-${r}-${C}`
              )) })
            ]
          }
        )
      }
    ),
    /* @__PURE__ */ S.jsx(
      yu,
      {
        errors: g,
        name: r,
        render: ({ message: m }) => /* @__PURE__ */ S.jsx("div", { className: "theme-font-sm color-theme-red-500 theme-form-error-message", children: m })
      }
    ),
    u && /* @__PURE__ */ S.jsx("span", { className: "theme-form-helpblock", children: u })
  ] });
}, H8e = (t) => {
  const {
    name: r,
    value: e,
    theme: n = "purple",
    onInputChange: i,
    radioValues: a,
    variant: o = "inline",
    className: s = "",
    containerClassName: l,
    formLabel: u,
    formSubLabel: c,
    inputHelpBlock: d,
    isRequired: f = !1,
    hasError: h = !1,
    errorMessage: p = "",
    alignment: v = "horizontal",
    disabled: g = !1,
    tooltip: m
  } = t, y = ui();
  return /* @__PURE__ */ S.jsxs(
    "div",
    {
      className: `${l !== void 0 ? l : ""}`,
      children: [
        u && /* @__PURE__ */ S.jsxs("label", { className: "theme-form-input-label", htmlFor: `field-${r}`, children: [
          u,
          " ",
          f && /* @__PURE__ */ S.jsx("span", { children: "*" }),
          " ",
          m && /* @__PURE__ */ S.jsx(S.Fragment, { children: m.onClick !== void 0 ? /* @__PURE__ */ S.jsx(
            Dr,
            {
              onClick: () => m.onClick && m.onClick()
            }
          ) : /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
            /* @__PURE__ */ S.jsx(
              Dr,
              {
                "data-tooltip-id": `${y}-tooltip`,
                "data-tooltip-html": m.content !== void 0 ? m.content : ""
              }
            ),
            /* @__PURE__ */ S.jsx(
              Si,
              {
                id: `${y}-tooltip`,
                className: "theme-tooltip"
              }
            )
          ] }) })
        ] }),
        c && /* @__PURE__ */ S.jsx("label", { className: "theme-form-sublabel", children: c }),
        /* @__PURE__ */ S.jsx(
          "div",
          {
            className: `theme-radio-container theme-radio-variant-${o} theme-radio-align-${v}`,
            children: a.map((b, C) => /* @__PURE__ */ S.jsx(
              "div",
              {
                className: `theme-radio ${g ? "theme-radio-disabled" : `theme-radio-color-${n}`} ${s}`,
                children: /* @__PURE__ */ S.jsxs("label", { htmlFor: `input-radio-${r}-${C}`, children: [
                  /* @__PURE__ */ S.jsx(
                    "input",
                    {
                      id: `input-radio-${r}-${C}`,
                      type: "radio",
                      value: b.value,
                      checked: b.value === e,
                      name: r,
                      disabled: g,
                      onChange: () => {
                        i && i(b.value);
                      }
                    }
                  ),
                  b.label
                ] })
              },
              `input-radio-${r}-${C}`
            ))
          }
        ),
        d && /* @__PURE__ */ S.jsx("span", { className: "theme-form-helpblock", children: d }),
        h && /* @__PURE__ */ S.jsx("div", { className: "theme-font-sm color-theme-red-500 theme-form-error-message", children: p })
      ]
    }
  );
}, z8e = (t) => {
  const {
    name: r,
    defaultValue: e,
    theme: n = "purple",
    onInputChange: i,
    radioValues: a,
    variant: o = "inline",
    className: s = "",
    containerClassName: l,
    formLabel: u,
    formSubLabel: c,
    inputHelpBlock: d,
    isRequired: f = !1,
    alignment: h = "horizontal",
    disabled: p = !1,
    tooltip: v,
    rules: g,
    control: m,
    errors: y
  } = t;
  return /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
    /* @__PURE__ */ S.jsx(
      mu,
      {
        name: r,
        control: m,
        defaultValue: e,
        rules: g || {},
        render: ({ field: { onChange: b, value: C } }) => /* @__PURE__ */ S.jsxs(
          "div",
          {
            className: `${l !== void 0 ? l : ""}`,
            children: [
              u && /* @__PURE__ */ S.jsxs(
                "label",
                {
                  className: "theme-form-input-label",
                  htmlFor: `field-${r}`,
                  children: [
                    u,
                    " ",
                    f && /* @__PURE__ */ S.jsx("span", { children: "*" }),
                    " ",
                    v && /* @__PURE__ */ S.jsx(S.Fragment, { children: v.onClick !== void 0 ? /* @__PURE__ */ S.jsx(
                      Dr,
                      {
                        onClick: () => v.onClick && v.onClick()
                      }
                    ) : /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
                      /* @__PURE__ */ S.jsx(
                        Dr,
                        {
                          "data-tooltip-id": `${r}-tooltip`,
                          "data-tooltip-html": v.content !== void 0 ? v.content : ""
                        }
                      ),
                      /* @__PURE__ */ S.jsx(
                        Si,
                        {
                          id: `${r}-tooltip`,
                          className: "theme-tooltip"
                        }
                      )
                    ] }) })
                  ]
                }
              ),
              c && /* @__PURE__ */ S.jsx("label", { className: "theme-form-sublabel", children: c }),
              /* @__PURE__ */ S.jsx(
                "div",
                {
                  className: `theme-radio-container theme-radio-variant-${o} theme-radio-align-${h}`,
                  children: a.map(
                    (w, _) => /* @__PURE__ */ S.jsx(
                      "div",
                      {
                        className: `theme-radio ${p ? "theme-radio-disabled" : `theme-radio-color-${n}`} ${s}`,
                        children: /* @__PURE__ */ S.jsxs("label", { htmlFor: `input-radio-${r}-${_}`, children: [
                          /* @__PURE__ */ S.jsx(
                            "input",
                            {
                              id: `input-radio-${r}-${_}`,
                              type: "radio",
                              value: w.value,
                              checked: w.value === C,
                              name: r,
                              disabled: p,
                              onChange: () => {
                                b(w.value), i && i(w.value);
                              }
                            }
                          ),
                          w.label
                        ] })
                      },
                      `input-radio-${r}-${_}`
                    )
                  )
                }
              )
            ]
          }
        )
      }
    ),
    /* @__PURE__ */ S.jsx(
      yu,
      {
        errors: y,
        name: r,
        render: ({ message: b }) => /* @__PURE__ */ S.jsx("div", { className: "theme-font-sm color-theme-red-500 theme-form-error-message", children: b })
      }
    ),
    d && /* @__PURE__ */ S.jsx("span", { className: "theme-form-helpblock", children: d })
  ] });
};
var A4 = {};
function W6() {
  return W6 = Object.assign ? Object.assign.bind() : function(t) {
    for (var r = 1; r < arguments.length; r++) {
      var e = arguments[r];
      for (var n in e) ({}).hasOwnProperty.call(e, n) && (t[n] = e[n]);
    }
    return t;
  }, W6.apply(null, arguments);
}
function GZ(t) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(e) {
    return r[e] === void 0 && (r[e] = t(e)), r[e];
  };
}
var S6e = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, I6e = /* @__PURE__ */ GZ(
  function(t) {
    return S6e.test(t) || t.charCodeAt(0) === 111 && t.charCodeAt(1) === 110 && t.charCodeAt(2) < 91;
  }
  /* Z+1 */
), A6e = !1;
function D6e(t) {
  if (t.sheet)
    return t.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === t)
      return document.styleSheets[r];
}
function T6e(t) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", t.key), t.nonce !== void 0 && r.setAttribute("nonce", t.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var M6e = /* @__PURE__ */ function() {
  function t(e) {
    var n = this;
    this._insertTag = function(i) {
      var a;
      n.tags.length === 0 ? n.insertionPoint ? a = n.insertionPoint.nextSibling : n.prepend ? a = n.container.firstChild : a = n.before : a = n.tags[n.tags.length - 1].nextSibling, n.container.insertBefore(i, a), n.tags.push(i);
    }, this.isSpeedy = e.speedy === void 0 ? !A6e : e.speedy, this.tags = [], this.ctr = 0, this.nonce = e.nonce, this.key = e.key, this.container = e.container, this.prepend = e.prepend, this.insertionPoint = e.insertionPoint, this.before = null;
  }
  var r = t.prototype;
  return r.hydrate = function(n) {
    n.forEach(this._insertTag);
  }, r.insert = function(n) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(T6e(this));
    var i = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var a = D6e(i);
      try {
        a.insertRule(n, a.cssRules.length);
      } catch {
      }
    } else
      i.appendChild(document.createTextNode(n));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(n) {
      var i;
      return (i = n.parentNode) == null ? void 0 : i.removeChild(n);
    }), this.tags = [], this.ctr = 0;
  }, t;
}(), qn = "-ms-", Ny = "-moz-", nr = "-webkit-", BZ = "comm", t8 = "rule", r8 = "decl", R6e = "@import", FZ = "@keyframes", L6e = "@layer", E6e = Math.abs, l5 = String.fromCharCode, k6e = Object.assign;
function P6e(t, r) {
  return Hn(t, 0) ^ 45 ? (((r << 2 ^ Hn(t, 0)) << 2 ^ Hn(t, 1)) << 2 ^ Hn(t, 2)) << 2 ^ Hn(t, 3) : 0;
}
function HZ(t) {
  return t.trim();
}
function N6e(t, r) {
  return (t = r.exec(t)) ? t[0] : t;
}
function ir(t, r, e) {
  return t.replace(r, e);
}
function Z6(t, r) {
  return t.indexOf(r);
}
function Hn(t, r) {
  return t.charCodeAt(r) | 0;
}
function qv(t, r, e) {
  return t.slice(r, e);
}
function To(t) {
  return t.length;
}
function n8(t) {
  return t.length;
}
function d0(t, r) {
  return r.push(t), t;
}
function O6e(t, r) {
  return t.map(r).join("");
}
var u5 = 1, Xf = 1, zZ = 0, Vi = 0, pn = 0, Sh = "";
function c5(t, r, e, n, i, a, o) {
  return { value: t, root: r, parent: e, type: n, props: i, children: a, line: u5, column: Xf, length: o, return: "" };
}
function yp(t, r) {
  return k6e(c5("", null, null, "", null, null, 0), t, { length: -t.length }, r);
}
function V6e() {
  return pn;
}
function G6e() {
  return pn = Vi > 0 ? Hn(Sh, --Vi) : 0, Xf--, pn === 10 && (Xf = 1, u5--), pn;
}
function ea() {
  return pn = Vi < zZ ? Hn(Sh, Vi++) : 0, Xf++, pn === 10 && (Xf = 1, u5++), pn;
}
function Uo() {
  return Hn(Sh, Vi);
}
function Q0() {
  return Vi;
}
function Zg(t, r) {
  return qv(Sh, t, r);
}
function Qv(t) {
  switch (t) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function WZ(t) {
  return u5 = Xf = 1, zZ = To(Sh = t), Vi = 0, [];
}
function ZZ(t) {
  return Sh = "", t;
}
function em(t) {
  return HZ(Zg(Vi - 1, j6(t === 91 ? t + 2 : t === 40 ? t + 1 : t)));
}
function B6e(t) {
  for (; (pn = Uo()) && pn < 33; )
    ea();
  return Qv(t) > 2 || Qv(pn) > 3 ? "" : " ";
}
function F6e(t, r) {
  for (; --r && ea() && !(pn < 48 || pn > 102 || pn > 57 && pn < 65 || pn > 70 && pn < 97); )
    ;
  return Zg(t, Q0() + (r < 6 && Uo() == 32 && ea() == 32));
}
function j6(t) {
  for (; ea(); )
    switch (pn) {
      // ] ) " '
      case t:
        return Vi;
      // " '
      case 34:
      case 39:
        t !== 34 && t !== 39 && j6(pn);
        break;
      // (
      case 40:
        t === 41 && j6(t);
        break;
      // \
      case 92:
        ea();
        break;
    }
  return Vi;
}
function H6e(t, r) {
  for (; ea() && t + pn !== 57; )
    if (t + pn === 84 && Uo() === 47)
      break;
  return "/*" + Zg(r, Vi - 1) + "*" + l5(t === 47 ? t : ea());
}
function z6e(t) {
  for (; !Qv(Uo()); )
    ea();
  return Zg(t, Vi);
}
function W6e(t) {
  return ZZ(tm("", null, null, null, [""], t = WZ(t), 0, [0], t));
}
function tm(t, r, e, n, i, a, o, s, l) {
  for (var u = 0, c = 0, d = o, f = 0, h = 0, p = 0, v = 1, g = 1, m = 1, y = 0, b = "", C = i, w = a, _ = n, x = b; g; )
    switch (p = y, y = ea()) {
      // (
      case 40:
        if (p != 108 && Hn(x, d - 1) == 58) {
          Z6(x += ir(em(y), "&", "&\f"), "&\f") != -1 && (m = -1);
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        x += em(y);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        x += B6e(p);
        break;
      // \
      case 92:
        x += F6e(Q0() - 1, 7);
        continue;
      // /
      case 47:
        switch (Uo()) {
          case 42:
          case 47:
            d0(Z6e(H6e(ea(), Q0()), r, e), l);
            break;
          default:
            x += "/";
        }
        break;
      // {
      case 123 * v:
        s[u++] = To(x) * m;
      // } ; \0
      case 125 * v:
      case 59:
      case 0:
        switch (y) {
          // \0 }
          case 0:
          case 125:
            g = 0;
          // ;
          case 59 + c:
            m == -1 && (x = ir(x, /\f/g, "")), h > 0 && To(x) - d && d0(h > 32 ? fk(x + ";", n, e, d - 1) : fk(ir(x, " ", "") + ";", n, e, d - 2), l);
            break;
          // @ ;
          case 59:
            x += ";";
          // { rule/at-rule
          default:
            if (d0(_ = dk(x, r, e, u, c, i, s, b, C = [], w = [], d), a), y === 123)
              if (c === 0)
                tm(x, r, _, _, C, a, d, s, w);
              else
                switch (f === 99 && Hn(x, 3) === 110 ? 100 : f) {
                  // d l m s
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    tm(t, _, _, n && d0(dk(t, _, _, 0, 0, i, s, b, i, C = [], d), w), i, w, d, s, n ? C : w);
                    break;
                  default:
                    tm(x, _, _, _, [""], w, 0, s, w);
                }
        }
        u = c = h = 0, v = m = 1, b = x = "", d = o;
        break;
      // :
      case 58:
        d = 1 + To(x), h = p;
      default:
        if (v < 1) {
          if (y == 123)
            --v;
          else if (y == 125 && v++ == 0 && G6e() == 125)
            continue;
        }
        switch (x += l5(y), y * v) {
          // &
          case 38:
            m = c > 0 ? 1 : (x += "\f", -1);
            break;
          // ,
          case 44:
            s[u++] = (To(x) - 1) * m, m = 1;
            break;
          // @
          case 64:
            Uo() === 45 && (x += em(ea())), f = Uo(), c = d = To(b = x += z6e(Q0())), y++;
            break;
          // -
          case 45:
            p === 45 && To(x) == 2 && (v = 0);
        }
    }
  return a;
}
function dk(t, r, e, n, i, a, o, s, l, u, c) {
  for (var d = i - 1, f = i === 0 ? a : [""], h = n8(f), p = 0, v = 0, g = 0; p < n; ++p)
    for (var m = 0, y = qv(t, d + 1, d = E6e(v = o[p])), b = t; m < h; ++m)
      (b = HZ(v > 0 ? f[m] + " " + y : ir(y, /&\f/g, f[m]))) && (l[g++] = b);
  return c5(t, r, e, i === 0 ? t8 : s, l, u, c);
}
function Z6e(t, r, e) {
  return c5(t, r, e, BZ, l5(V6e()), qv(t, 2, -2), 0);
}
function fk(t, r, e, n) {
  return c5(t, r, e, r8, qv(t, 0, n), qv(t, n + 1, -1), n);
}
function xf(t, r) {
  for (var e = "", n = n8(t), i = 0; i < n; i++)
    e += r(t[i], i, t, r) || "";
  return e;
}
function j6e(t, r, e, n) {
  switch (t.type) {
    case L6e:
      if (t.children.length) break;
    case R6e:
    case r8:
      return t.return = t.return || t.value;
    case BZ:
      return "";
    case FZ:
      return t.return = t.value + "{" + xf(t.children, n) + "}";
    case t8:
      t.value = t.props.join(",");
  }
  return To(e = xf(t.children, n)) ? t.return = t.value + "{" + e + "}" : "";
}
function Y6e(t) {
  var r = n8(t);
  return function(e, n, i, a) {
    for (var o = "", s = 0; s < r; s++)
      o += t[s](e, n, i, a) || "";
    return o;
  };
}
function X6e(t) {
  return function(r) {
    r.root || (r = r.return) && t(r);
  };
}
var $6e = function(r, e, n) {
  for (var i = 0, a = 0; i = a, a = Uo(), i === 38 && a === 12 && (e[n] = 1), !Qv(a); )
    ea();
  return Zg(r, Vi);
}, U6e = function(r, e) {
  var n = -1, i = 44;
  do
    switch (Qv(i)) {
      case 0:
        i === 38 && Uo() === 12 && (e[n] = 1), r[n] += $6e(Vi - 1, e, n);
        break;
      case 2:
        r[n] += em(i);
        break;
      case 4:
        if (i === 44) {
          r[++n] = Uo() === 58 ? "&\f" : "", e[n] = r[n].length;
          break;
        }
      // fallthrough
      default:
        r[n] += l5(i);
    }
  while (i = ea());
  return r;
}, J6e = function(r, e) {
  return ZZ(U6e(WZ(r), e));
}, hk = /* @__PURE__ */ new WeakMap(), K6e = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var e = r.value, n = r.parent, i = r.column === n.column && r.line === n.line; n.type !== "rule"; )
      if (n = n.parent, !n) return;
    if (!(r.props.length === 1 && e.charCodeAt(0) !== 58 && !hk.get(n)) && !i) {
      hk.set(r, !0);
      for (var a = [], o = J6e(e, a), s = n.props, l = 0, u = 0; l < o.length; l++)
        for (var c = 0; c < s.length; c++, u++)
          r.props[u] = a[l] ? o[l].replace(/&\f/g, s[c]) : s[c] + " " + o[l];
    }
  }
}, q6e = function(r) {
  if (r.type === "decl") {
    var e = r.value;
    // charcode for l
    e.charCodeAt(0) === 108 && // charcode for b
    e.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
};
function jZ(t, r) {
  switch (P6e(t, r)) {
    // color-adjust
    case 5103:
      return nr + "print-" + t + t;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return nr + t + t;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return nr + t + Ny + t + qn + t + t;
    // flex, flex-direction
    case 6828:
    case 4268:
      return nr + t + qn + t + t;
    // order
    case 6165:
      return nr + t + qn + "flex-" + t + t;
    // align-items
    case 5187:
      return nr + t + ir(t, /(\w+).+(:[^]+)/, nr + "box-$1$2" + qn + "flex-$1$2") + t;
    // align-self
    case 5443:
      return nr + t + qn + "flex-item-" + ir(t, /flex-|-self/, "") + t;
    // align-content
    case 4675:
      return nr + t + qn + "flex-line-pack" + ir(t, /align-content|flex-|-self/, "") + t;
    // flex-shrink
    case 5548:
      return nr + t + qn + ir(t, "shrink", "negative") + t;
    // flex-basis
    case 5292:
      return nr + t + qn + ir(t, "basis", "preferred-size") + t;
    // flex-grow
    case 6060:
      return nr + "box-" + ir(t, "-grow", "") + nr + t + qn + ir(t, "grow", "positive") + t;
    // transition
    case 4554:
      return nr + ir(t, /([^-])(transform)/g, "$1" + nr + "$2") + t;
    // cursor
    case 6187:
      return ir(ir(ir(t, /(zoom-|grab)/, nr + "$1"), /(image-set)/, nr + "$1"), t, "") + t;
    // background, background-image
    case 5495:
    case 3959:
      return ir(t, /(image-set\([^]*)/, nr + "$1$`$1");
    // justify-content
    case 4968:
      return ir(ir(t, /(.+:)(flex-)?(.*)/, nr + "box-pack:$3" + qn + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + nr + t + t;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return ir(t, /(.+)-inline(.+)/, nr + "$1$2") + t;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (To(t) - 1 - r > 6) switch (Hn(t, r + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          if (Hn(t, r + 4) !== 45) break;
        // (f)ill-available, (f)it-content
        case 102:
          return ir(t, /(.+:)(.+)-([^]+)/, "$1" + nr + "$2-$3$1" + Ny + (Hn(t, r + 3) == 108 ? "$3" : "$2-$3")) + t;
        // (s)tretch
        case 115:
          return ~Z6(t, "stretch") ? jZ(ir(t, "stretch", "fill-available"), r) + t : t;
      }
      break;
    // position: sticky
    case 4949:
      if (Hn(t, r + 1) !== 115) break;
    // display: (flex|inline-flex)
    case 6444:
      switch (Hn(t, To(t) - 3 - (~Z6(t, "!important") && 10))) {
        // stic(k)y
        case 107:
          return ir(t, ":", ":" + nr) + t;
        // (inline-)?fl(e)x
        case 101:
          return ir(t, /(.+:)([^;!]+)(;|!.+)?/, "$1" + nr + (Hn(t, 14) === 45 ? "inline-" : "") + "box$3$1" + nr + "$2$3$1" + qn + "$2box$3") + t;
      }
      break;
    // writing-mode
    case 5936:
      switch (Hn(t, r + 11)) {
        // vertical-l(r)
        case 114:
          return nr + t + qn + ir(t, /[svh]\w+-[tblr]{2}/, "tb") + t;
        // vertical-r(l)
        case 108:
          return nr + t + qn + ir(t, /[svh]\w+-[tblr]{2}/, "tb-rl") + t;
        // horizontal(-)tb
        case 45:
          return nr + t + qn + ir(t, /[svh]\w+-[tblr]{2}/, "lr") + t;
      }
      return nr + t + qn + t + t;
  }
  return t;
}
var Q6e = function(r, e, n, i) {
  if (r.length > -1 && !r.return) switch (r.type) {
    case r8:
      r.return = jZ(r.value, r.length);
      break;
    case FZ:
      return xf([yp(r, {
        value: ir(r.value, "@", "@" + nr)
      })], i);
    case t8:
      if (r.length) return O6e(r.props, function(a) {
        switch (N6e(a, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ":read-only":
          case ":read-write":
            return xf([yp(r, {
              props: [ir(a, /:(read-\w+)/, ":" + Ny + "$1")]
            })], i);
          // :placeholder
          case "::placeholder":
            return xf([yp(r, {
              props: [ir(a, /:(plac\w+)/, ":" + nr + "input-$1")]
            }), yp(r, {
              props: [ir(a, /:(plac\w+)/, ":" + Ny + "$1")]
            }), yp(r, {
              props: [ir(a, /:(plac\w+)/, qn + "input-$1")]
            })], i);
        }
        return "";
      });
  }
}, e7e = [Q6e], t7e = function(r) {
  var e = r.key;
  if (e === "css") {
    var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(n, function(v) {
      var g = v.getAttribute("data-emotion");
      g.indexOf(" ") !== -1 && (document.head.appendChild(v), v.setAttribute("data-s", ""));
    });
  }
  var i = r.stylisPlugins || e7e, a = {}, o, s = [];
  o = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + e + ' "]'),
    function(v) {
      for (var g = v.getAttribute("data-emotion").split(" "), m = 1; m < g.length; m++)
        a[g[m]] = !0;
      s.push(v);
    }
  );
  var l, u = [K6e, q6e];
  {
    var c, d = [j6e, X6e(function(v) {
      c.insert(v);
    })], f = Y6e(u.concat(i, d)), h = function(g) {
      return xf(W6e(g), f);
    };
    l = function(g, m, y, b) {
      c = y, h(g ? g + "{" + m.styles + "}" : m.styles), b && (p.inserted[m.name] = !0);
    };
  }
  var p = {
    key: e,
    sheet: new M6e({
      key: e,
      container: o,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: a,
    registered: {},
    insert: l
  };
  return p.sheet.hydrate(s), p;
}, f0 = { exports: {} }, cr = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var pk;
function r7e() {
  if (pk) return cr;
  pk = 1;
  var t = typeof Symbol == "function" && Symbol.for, r = t ? Symbol.for("react.element") : 60103, e = t ? Symbol.for("react.portal") : 60106, n = t ? Symbol.for("react.fragment") : 60107, i = t ? Symbol.for("react.strict_mode") : 60108, a = t ? Symbol.for("react.profiler") : 60114, o = t ? Symbol.for("react.provider") : 60109, s = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, u = t ? Symbol.for("react.concurrent_mode") : 60111, c = t ? Symbol.for("react.forward_ref") : 60112, d = t ? Symbol.for("react.suspense") : 60113, f = t ? Symbol.for("react.suspense_list") : 60120, h = t ? Symbol.for("react.memo") : 60115, p = t ? Symbol.for("react.lazy") : 60116, v = t ? Symbol.for("react.block") : 60121, g = t ? Symbol.for("react.fundamental") : 60117, m = t ? Symbol.for("react.responder") : 60118, y = t ? Symbol.for("react.scope") : 60119;
  function b(w) {
    if (typeof w == "object" && w !== null) {
      var _ = w.$$typeof;
      switch (_) {
        case r:
          switch (w = w.type, w) {
            case l:
            case u:
            case n:
            case a:
            case i:
            case d:
              return w;
            default:
              switch (w = w && w.$$typeof, w) {
                case s:
                case c:
                case p:
                case h:
                case o:
                  return w;
                default:
                  return _;
              }
          }
        case e:
          return _;
      }
    }
  }
  function C(w) {
    return b(w) === u;
  }
  return cr.AsyncMode = l, cr.ConcurrentMode = u, cr.ContextConsumer = s, cr.ContextProvider = o, cr.Element = r, cr.ForwardRef = c, cr.Fragment = n, cr.Lazy = p, cr.Memo = h, cr.Portal = e, cr.Profiler = a, cr.StrictMode = i, cr.Suspense = d, cr.isAsyncMode = function(w) {
    return C(w) || b(w) === l;
  }, cr.isConcurrentMode = C, cr.isContextConsumer = function(w) {
    return b(w) === s;
  }, cr.isContextProvider = function(w) {
    return b(w) === o;
  }, cr.isElement = function(w) {
    return typeof w == "object" && w !== null && w.$$typeof === r;
  }, cr.isForwardRef = function(w) {
    return b(w) === c;
  }, cr.isFragment = function(w) {
    return b(w) === n;
  }, cr.isLazy = function(w) {
    return b(w) === p;
  }, cr.isMemo = function(w) {
    return b(w) === h;
  }, cr.isPortal = function(w) {
    return b(w) === e;
  }, cr.isProfiler = function(w) {
    return b(w) === a;
  }, cr.isStrictMode = function(w) {
    return b(w) === i;
  }, cr.isSuspense = function(w) {
    return b(w) === d;
  }, cr.isValidElementType = function(w) {
    return typeof w == "string" || typeof w == "function" || w === n || w === u || w === a || w === i || w === d || w === f || typeof w == "object" && w !== null && (w.$$typeof === p || w.$$typeof === h || w.$$typeof === o || w.$$typeof === s || w.$$typeof === c || w.$$typeof === g || w.$$typeof === m || w.$$typeof === y || w.$$typeof === v);
  }, cr.typeOf = b, cr;
}
var dr = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var vk;
function n7e() {
  return vk || (vk = 1, process.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, r = t ? Symbol.for("react.element") : 60103, e = t ? Symbol.for("react.portal") : 60106, n = t ? Symbol.for("react.fragment") : 60107, i = t ? Symbol.for("react.strict_mode") : 60108, a = t ? Symbol.for("react.profiler") : 60114, o = t ? Symbol.for("react.provider") : 60109, s = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, u = t ? Symbol.for("react.concurrent_mode") : 60111, c = t ? Symbol.for("react.forward_ref") : 60112, d = t ? Symbol.for("react.suspense") : 60113, f = t ? Symbol.for("react.suspense_list") : 60120, h = t ? Symbol.for("react.memo") : 60115, p = t ? Symbol.for("react.lazy") : 60116, v = t ? Symbol.for("react.block") : 60121, g = t ? Symbol.for("react.fundamental") : 60117, m = t ? Symbol.for("react.responder") : 60118, y = t ? Symbol.for("react.scope") : 60119;
    function b(re) {
      return typeof re == "string" || typeof re == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      re === n || re === u || re === a || re === i || re === d || re === f || typeof re == "object" && re !== null && (re.$$typeof === p || re.$$typeof === h || re.$$typeof === o || re.$$typeof === s || re.$$typeof === c || re.$$typeof === g || re.$$typeof === m || re.$$typeof === y || re.$$typeof === v);
    }
    function C(re) {
      if (typeof re == "object" && re !== null) {
        var Re = re.$$typeof;
        switch (Re) {
          case r:
            var ve = re.type;
            switch (ve) {
              case l:
              case u:
              case n:
              case a:
              case i:
              case d:
                return ve;
              default:
                var Oe = ve && ve.$$typeof;
                switch (Oe) {
                  case s:
                  case c:
                  case p:
                  case h:
                  case o:
                    return Oe;
                  default:
                    return Re;
                }
            }
          case e:
            return Re;
        }
      }
    }
    var w = l, _ = u, x = s, I = o, D = r, T = c, A = n, M = p, R = h, E = e, k = a, P = i, N = d, O = !1;
    function W(re) {
      return O || (O = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), V(re) || C(re) === l;
    }
    function V(re) {
      return C(re) === u;
    }
    function B(re) {
      return C(re) === s;
    }
    function Z(re) {
      return C(re) === o;
    }
    function q(re) {
      return typeof re == "object" && re !== null && re.$$typeof === r;
    }
    function z(re) {
      return C(re) === c;
    }
    function U(re) {
      return C(re) === n;
    }
    function J(re) {
      return C(re) === p;
    }
    function K(re) {
      return C(re) === h;
    }
    function j(re) {
      return C(re) === e;
    }
    function oe(re) {
      return C(re) === a;
    }
    function ie(re) {
      return C(re) === i;
    }
    function le(re) {
      return C(re) === d;
    }
    dr.AsyncMode = w, dr.ConcurrentMode = _, dr.ContextConsumer = x, dr.ContextProvider = I, dr.Element = D, dr.ForwardRef = T, dr.Fragment = A, dr.Lazy = M, dr.Memo = R, dr.Portal = E, dr.Profiler = k, dr.StrictMode = P, dr.Suspense = N, dr.isAsyncMode = W, dr.isConcurrentMode = V, dr.isContextConsumer = B, dr.isContextProvider = Z, dr.isElement = q, dr.isForwardRef = z, dr.isFragment = U, dr.isLazy = J, dr.isMemo = K, dr.isPortal = j, dr.isProfiler = oe, dr.isStrictMode = ie, dr.isSuspense = le, dr.isValidElementType = b, dr.typeOf = C;
  }()), dr;
}
var gk;
function YZ() {
  return gk || (gk = 1, process.env.NODE_ENV === "production" ? f0.exports = r7e() : f0.exports = n7e()), f0.exports;
}
var i7e = !0;
function XZ(t, r, e) {
  var n = "";
  return e.split(" ").forEach(function(i) {
    t[i] !== void 0 ? r.push(t[i] + ";") : n += i + " ";
  }), n;
}
var i8 = function(r, e, n) {
  var i = r.key + "-" + e.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (n === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  i7e === !1) && r.registered[i] === void 0 && (r.registered[i] = e.styles);
}, $Z = function(r, e, n) {
  i8(r, e, n);
  var i = r.key + "-" + e.name;
  if (r.inserted[e.name] === void 0) {
    var a = e;
    do
      r.insert(e === a ? "." + i : "", a, r.sheet, !0), a = a.next;
    while (a !== void 0);
  }
};
function a7e(t) {
  for (var r = 0, e, n = 0, i = t.length; i >= 4; ++n, i -= 4)
    e = t.charCodeAt(n) & 255 | (t.charCodeAt(++n) & 255) << 8 | (t.charCodeAt(++n) & 255) << 16 | (t.charCodeAt(++n) & 255) << 24, e = /* Math.imul(k, m): */
    (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16), e ^= /* k >>> r: */
    e >>> 24, r = /* Math.imul(k, m): */
    (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (i) {
    case 3:
      r ^= (t.charCodeAt(n + 2) & 255) << 16;
    case 2:
      r ^= (t.charCodeAt(n + 1) & 255) << 8;
    case 1:
      r ^= t.charCodeAt(n) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var o7e = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, s7e = !1, l7e = /[A-Z]|^ms/g, u7e = /_EMO_([^_]+?)_([^]*?)_EMO_/g, UZ = function(r) {
  return r.charCodeAt(1) === 45;
}, mk = function(r) {
  return r != null && typeof r != "boolean";
}, D4 = /* @__PURE__ */ GZ(function(t) {
  return UZ(t) ? t : t.replace(l7e, "-$&").toLowerCase();
}), yk = function(r, e) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof e == "string")
        return e.replace(u7e, function(n, i, a) {
          return Mo = {
            name: i,
            styles: a,
            next: Mo
          }, i;
        });
  }
  return o7e[r] !== 1 && !UZ(r) && typeof e == "number" && e !== 0 ? e + "px" : e;
}, c7e = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function eg(t, r, e) {
  if (e == null)
    return "";
  var n = e;
  if (n.__emotion_styles !== void 0)
    return n;
  switch (typeof e) {
    case "boolean":
      return "";
    case "object": {
      var i = e;
      if (i.anim === 1)
        return Mo = {
          name: i.name,
          styles: i.styles,
          next: Mo
        }, i.name;
      var a = e;
      if (a.styles !== void 0) {
        var o = a.next;
        if (o !== void 0)
          for (; o !== void 0; )
            Mo = {
              name: o.name,
              styles: o.styles,
              next: Mo
            }, o = o.next;
        var s = a.styles + ";";
        return s;
      }
      return d7e(t, r, e);
    }
    case "function": {
      if (t !== void 0) {
        var l = Mo, u = e(t);
        return Mo = l, eg(t, r, u);
      }
      break;
    }
  }
  var c = e;
  if (r == null)
    return c;
  var d = r[c];
  return d !== void 0 ? d : c;
}
function d7e(t, r, e) {
  var n = "";
  if (Array.isArray(e))
    for (var i = 0; i < e.length; i++)
      n += eg(t, r, e[i]) + ";";
  else
    for (var a in e) {
      var o = e[a];
      if (typeof o != "object") {
        var s = o;
        r != null && r[s] !== void 0 ? n += a + "{" + r[s] + "}" : mk(s) && (n += D4(a) + ":" + yk(a, s) + ";");
      } else {
        if (a === "NO_COMPONENT_SELECTOR" && s7e)
          throw new Error(c7e);
        if (Array.isArray(o) && typeof o[0] == "string" && (r == null || r[o[0]] === void 0))
          for (var l = 0; l < o.length; l++)
            mk(o[l]) && (n += D4(a) + ":" + yk(a, o[l]) + ";");
        else {
          var u = eg(t, r, o);
          switch (a) {
            case "animation":
            case "animationName": {
              n += D4(a) + ":" + u + ";";
              break;
            }
            default:
              n += a + "{" + u + "}";
          }
        }
      }
    }
  return n;
}
var bk = /label:\s*([^\s;\n{]+)\s*(;|$)/g, Mo;
function Y6(t, r, e) {
  if (t.length === 1 && typeof t[0] == "object" && t[0] !== null && t[0].styles !== void 0)
    return t[0];
  var n = !0, i = "";
  Mo = void 0;
  var a = t[0];
  if (a == null || a.raw === void 0)
    n = !1, i += eg(e, r, a);
  else {
    var o = a;
    i += o[0];
  }
  for (var s = 1; s < t.length; s++)
    if (i += eg(e, r, t[s]), n) {
      var l = a;
      i += l[s];
    }
  bk.lastIndex = 0;
  for (var u = "", c; (c = bk.exec(i)) !== null; )
    u += "-" + c[1];
  var d = a7e(i) + u;
  return {
    name: d,
    styles: i,
    next: Mo
  };
}
var f7e = function(r) {
  return r();
}, h7e = $.useInsertionEffect ? $.useInsertionEffect : !1, JZ = h7e || f7e, p7e = {}.hasOwnProperty, a8 = /* @__PURE__ */ $.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ t7e({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (a8.displayName = "EmotionCacheContext");
a8.Provider;
var KZ = function(r) {
  return /* @__PURE__ */ uo(function(e, n) {
    var i = zn(a8);
    return r(e, i, n);
  });
}, o8 = /* @__PURE__ */ $.createContext({});
process.env.NODE_ENV !== "production" && (o8.displayName = "EmotionThemeContext");
var Ck = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", wk = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", v7e = function(r) {
  var e = r.cache, n = r.serialized, i = r.isStringTag;
  return i8(e, n, i), JZ(function() {
    return $Z(e, n, i);
  }), null;
}, g7e = /* @__PURE__ */ KZ(function(t, r, e) {
  var n = t.css;
  typeof n == "string" && r.registered[n] !== void 0 && (n = r.registered[n]);
  var i = t[Ck], a = [n], o = "";
  typeof t.className == "string" ? o = XZ(r.registered, a, t.className) : t.className != null && (o = t.className + " ");
  var s = Y6(a, void 0, $.useContext(o8));
  if (process.env.NODE_ENV !== "production" && s.name.indexOf("-") === -1) {
    var l = t[wk];
    l && (s = Y6([s, "label:" + l + ";"]));
  }
  o += r.key + "-" + s.name;
  var u = {};
  for (var c in t)
    p7e.call(t, c) && c !== "css" && c !== Ck && (process.env.NODE_ENV === "production" || c !== wk) && (u[c] = t[c]);
  return u.ref = e, u.className = o, /* @__PURE__ */ $.createElement($.Fragment, null, /* @__PURE__ */ $.createElement(v7e, {
    cache: r,
    serialized: s,
    isStringTag: typeof i == "string"
  }), /* @__PURE__ */ $.createElement(i, u));
});
process.env.NODE_ENV !== "production" && (g7e.displayName = "EmotionCssPropInternal");
var m7e = I6e, y7e = function(r) {
  return r !== "theme";
}, _k = function(r) {
  return typeof r == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  r.charCodeAt(0) > 96 ? m7e : y7e;
}, xk = function(r, e, n) {
  var i;
  if (e) {
    var a = e.shouldForwardProp;
    i = r.__emotion_forwardProp && a ? function(o) {
      return r.__emotion_forwardProp(o) && a(o);
    } : a;
  }
  return typeof i != "function" && n && (i = r.__emotion_forwardProp), i;
}, Sk = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, b7e = function(r) {
  var e = r.cache, n = r.serialized, i = r.isStringTag;
  return i8(e, n, i), JZ(function() {
    return $Z(e, n, i);
  }), null;
}, C7e = function t(r, e) {
  if (process.env.NODE_ENV !== "production" && r === void 0)
    throw new Error(`You are trying to create a styled element with an undefined component.
You may have forgotten to import it.`);
  var n = r.__emotion_real === r, i = n && r.__emotion_base || r, a, o;
  e !== void 0 && (a = e.label, o = e.target);
  var s = xk(r, e, n), l = s || _k(i), u = !l("as");
  return function() {
    var c = arguments, d = n && r.__emotion_styles !== void 0 ? r.__emotion_styles.slice(0) : [];
    if (a !== void 0 && d.push("label:" + a + ";"), c[0] == null || c[0].raw === void 0)
      d.push.apply(d, c);
    else {
      process.env.NODE_ENV !== "production" && c[0][0] === void 0 && console.error(Sk), d.push(c[0][0]);
      for (var f = c.length, h = 1; h < f; h++)
        process.env.NODE_ENV !== "production" && c[0][h] === void 0 && console.error(Sk), d.push(c[h], c[0][h]);
    }
    var p = KZ(function(v, g, m) {
      var y = u && v.as || i, b = "", C = [], w = v;
      if (v.theme == null) {
        w = {};
        for (var _ in v)
          w[_] = v[_];
        w.theme = $.useContext(o8);
      }
      typeof v.className == "string" ? b = XZ(g.registered, C, v.className) : v.className != null && (b = v.className + " ");
      var x = Y6(d.concat(C), g.registered, w);
      b += g.key + "-" + x.name, o !== void 0 && (b += " " + o);
      var I = u && s === void 0 ? _k(y) : l, D = {};
      for (var T in v)
        u && T === "as" || // $FlowFixMe
        I(T) && (D[T] = v[T]);
      return D.className = b, D.ref = m, /* @__PURE__ */ $.createElement($.Fragment, null, /* @__PURE__ */ $.createElement(b7e, {
        cache: g,
        serialized: x,
        isStringTag: typeof y == "string"
      }), /* @__PURE__ */ $.createElement(y, D));
    });
    return p.displayName = a !== void 0 ? a : "Styled(" + (typeof i == "string" ? i : i.displayName || i.name || "Component") + ")", p.defaultProps = r.defaultProps, p.__emotion_real = p, p.__emotion_base = i, p.__emotion_styles = d, p.__emotion_forwardProp = s, Object.defineProperty(p, "toString", {
      value: function() {
        return o === void 0 && process.env.NODE_ENV !== "production" ? "NO_COMPONENT_SELECTOR" : "." + o;
      }
    }), p.withComponent = function(v, g) {
      return t(v, W6({}, e, g, {
        shouldForwardProp: xk(p, g, !0)
      })).apply(void 0, d);
    }, p;
  };
};
const w7e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: C7e
}, Symbol.toStringTag, { value: "Module" })), ho = /* @__PURE__ */ gY(w7e);
var T4 = {}, h0 = { exports: {} };
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var M4, Ik;
function _7e() {
  if (Ik) return M4;
  Ik = 1;
  var t = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, e = Object.prototype.propertyIsEnumerable;
  function n(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var o = {}, s = 0; s < 10; s++)
        o["_" + String.fromCharCode(s)] = s;
      var l = Object.getOwnPropertyNames(o).map(function(c) {
        return o[c];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(c) {
        u[c] = c;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return M4 = i() ? Object.assign : function(a, o) {
    for (var s, l = n(a), u, c = 1; c < arguments.length; c++) {
      s = Object(arguments[c]);
      for (var d in s)
        r.call(s, d) && (l[d] = s[d]);
      if (t) {
        u = t(s);
        for (var f = 0; f < u.length; f++)
          e.call(s, u[f]) && (l[u[f]] = s[u[f]]);
      }
    }
    return l;
  }, M4;
}
var R4, Ak;
function s8() {
  if (Ak) return R4;
  Ak = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return R4 = t, R4;
}
var L4, Dk;
function qZ() {
  return Dk || (Dk = 1, L4 = Function.call.bind(Object.prototype.hasOwnProperty)), L4;
}
var E4, Tk;
function x7e() {
  if (Tk) return E4;
  Tk = 1;
  var t = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var r = /* @__PURE__ */ s8(), e = {}, n = /* @__PURE__ */ qZ();
    t = function(a) {
      var o = "Warning: " + a;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function i(a, o, s, l, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var c in a)
        if (n(a, c)) {
          var d;
          try {
            if (typeof a[c] != "function") {
              var f = Error(
                (l || "React class") + ": " + s + " type `" + c + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[c] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw f.name = "Invariant Violation", f;
            }
            d = a[c](o, c, l, s, null, r);
          } catch (p) {
            d = p;
          }
          if (d && !(d instanceof Error) && t(
            (l || "React class") + ": type specification of " + s + " `" + c + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in e)) {
            e[d.message] = !0;
            var h = u ? u() : "";
            t(
              "Failed " + s + " type: " + d.message + (h ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (e = {});
  }, E4 = i, E4;
}
var k4, Mk;
function S7e() {
  if (Mk) return k4;
  Mk = 1;
  var t = YZ(), r = _7e(), e = /* @__PURE__ */ s8(), n = /* @__PURE__ */ qZ(), i = /* @__PURE__ */ x7e(), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(s) {
    var l = "Warning: " + s;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return k4 = function(s, l) {
    var u = typeof Symbol == "function" && Symbol.iterator, c = "@@iterator";
    function d(V) {
      var B = V && (u && V[u] || V[c]);
      if (typeof B == "function")
        return B;
    }
    var f = "<<anonymous>>", h = {
      array: m("array"),
      bigint: m("bigint"),
      bool: m("boolean"),
      func: m("function"),
      number: m("number"),
      object: m("object"),
      string: m("string"),
      symbol: m("symbol"),
      any: y(),
      arrayOf: b,
      element: C(),
      elementType: w(),
      instanceOf: _,
      node: T(),
      objectOf: I,
      oneOf: x,
      oneOfType: D,
      shape: M,
      exact: R
    };
    function p(V, B) {
      return V === B ? V !== 0 || 1 / V === 1 / B : V !== V && B !== B;
    }
    function v(V, B) {
      this.message = V, this.data = B && typeof B == "object" ? B : {}, this.stack = "";
    }
    v.prototype = Error.prototype;
    function g(V) {
      if (process.env.NODE_ENV !== "production")
        var B = {}, Z = 0;
      function q(U, J, K, j, oe, ie, le) {
        if (j = j || f, ie = ie || K, le !== e) {
          if (l) {
            var re = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw re.name = "Invariant Violation", re;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Re = j + ":" + K;
            !B[Re] && // Avoid spamming the console because they are often not actionable except for lib authors
            Z < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + ie + "` prop on `" + j + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), B[Re] = !0, Z++);
          }
        }
        return J[K] == null ? U ? J[K] === null ? new v("The " + oe + " `" + ie + "` is marked as required " + ("in `" + j + "`, but its value is `null`.")) : new v("The " + oe + " `" + ie + "` is marked as required in " + ("`" + j + "`, but its value is `undefined`.")) : null : V(J, K, j, oe, ie);
      }
      var z = q.bind(null, !1);
      return z.isRequired = q.bind(null, !0), z;
    }
    function m(V) {
      function B(Z, q, z, U, J, K) {
        var j = Z[q], oe = P(j);
        if (oe !== V) {
          var ie = N(j);
          return new v(
            "Invalid " + U + " `" + J + "` of type " + ("`" + ie + "` supplied to `" + z + "`, expected ") + ("`" + V + "`."),
            { expectedType: V }
          );
        }
        return null;
      }
      return g(B);
    }
    function y() {
      return g(o);
    }
    function b(V) {
      function B(Z, q, z, U, J) {
        if (typeof V != "function")
          return new v("Property `" + J + "` of component `" + z + "` has invalid PropType notation inside arrayOf.");
        var K = Z[q];
        if (!Array.isArray(K)) {
          var j = P(K);
          return new v("Invalid " + U + " `" + J + "` of type " + ("`" + j + "` supplied to `" + z + "`, expected an array."));
        }
        for (var oe = 0; oe < K.length; oe++) {
          var ie = V(K, oe, z, U, J + "[" + oe + "]", e);
          if (ie instanceof Error)
            return ie;
        }
        return null;
      }
      return g(B);
    }
    function C() {
      function V(B, Z, q, z, U) {
        var J = B[Z];
        if (!s(J)) {
          var K = P(J);
          return new v("Invalid " + z + " `" + U + "` of type " + ("`" + K + "` supplied to `" + q + "`, expected a single ReactElement."));
        }
        return null;
      }
      return g(V);
    }
    function w() {
      function V(B, Z, q, z, U) {
        var J = B[Z];
        if (!t.isValidElementType(J)) {
          var K = P(J);
          return new v("Invalid " + z + " `" + U + "` of type " + ("`" + K + "` supplied to `" + q + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return g(V);
    }
    function _(V) {
      function B(Z, q, z, U, J) {
        if (!(Z[q] instanceof V)) {
          var K = V.name || f, j = W(Z[q]);
          return new v("Invalid " + U + " `" + J + "` of type " + ("`" + j + "` supplied to `" + z + "`, expected ") + ("instance of `" + K + "`."));
        }
        return null;
      }
      return g(B);
    }
    function x(V) {
      if (!Array.isArray(V))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), o;
      function B(Z, q, z, U, J) {
        for (var K = Z[q], j = 0; j < V.length; j++)
          if (p(K, V[j]))
            return null;
        var oe = JSON.stringify(V, function(le, re) {
          var Re = N(re);
          return Re === "symbol" ? String(re) : re;
        });
        return new v("Invalid " + U + " `" + J + "` of value `" + String(K) + "` " + ("supplied to `" + z + "`, expected one of " + oe + "."));
      }
      return g(B);
    }
    function I(V) {
      function B(Z, q, z, U, J) {
        if (typeof V != "function")
          return new v("Property `" + J + "` of component `" + z + "` has invalid PropType notation inside objectOf.");
        var K = Z[q], j = P(K);
        if (j !== "object")
          return new v("Invalid " + U + " `" + J + "` of type " + ("`" + j + "` supplied to `" + z + "`, expected an object."));
        for (var oe in K)
          if (n(K, oe)) {
            var ie = V(K, oe, z, U, J + "." + oe, e);
            if (ie instanceof Error)
              return ie;
          }
        return null;
      }
      return g(B);
    }
    function D(V) {
      if (!Array.isArray(V))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var B = 0; B < V.length; B++) {
        var Z = V[B];
        if (typeof Z != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + O(Z) + " at index " + B + "."
          ), o;
      }
      function q(z, U, J, K, j) {
        for (var oe = [], ie = 0; ie < V.length; ie++) {
          var le = V[ie], re = le(z, U, J, K, j, e);
          if (re == null)
            return null;
          re.data && n(re.data, "expectedType") && oe.push(re.data.expectedType);
        }
        var Re = oe.length > 0 ? ", expected one of type [" + oe.join(", ") + "]" : "";
        return new v("Invalid " + K + " `" + j + "` supplied to " + ("`" + J + "`" + Re + "."));
      }
      return g(q);
    }
    function T() {
      function V(B, Z, q, z, U) {
        return E(B[Z]) ? null : new v("Invalid " + z + " `" + U + "` supplied to " + ("`" + q + "`, expected a ReactNode."));
      }
      return g(V);
    }
    function A(V, B, Z, q, z) {
      return new v(
        (V || "React class") + ": " + B + " type `" + Z + "." + q + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + z + "`."
      );
    }
    function M(V) {
      function B(Z, q, z, U, J) {
        var K = Z[q], j = P(K);
        if (j !== "object")
          return new v("Invalid " + U + " `" + J + "` of type `" + j + "` " + ("supplied to `" + z + "`, expected `object`."));
        for (var oe in V) {
          var ie = V[oe];
          if (typeof ie != "function")
            return A(z, U, J, oe, N(ie));
          var le = ie(K, oe, z, U, J + "." + oe, e);
          if (le)
            return le;
        }
        return null;
      }
      return g(B);
    }
    function R(V) {
      function B(Z, q, z, U, J) {
        var K = Z[q], j = P(K);
        if (j !== "object")
          return new v("Invalid " + U + " `" + J + "` of type `" + j + "` " + ("supplied to `" + z + "`, expected `object`."));
        var oe = r({}, Z[q], V);
        for (var ie in oe) {
          var le = V[ie];
          if (n(V, ie) && typeof le != "function")
            return A(z, U, J, ie, N(le));
          if (!le)
            return new v(
              "Invalid " + U + " `" + J + "` key `" + ie + "` supplied to `" + z + "`.\nBad object: " + JSON.stringify(Z[q], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(V), null, "  ")
            );
          var re = le(K, ie, z, U, J + "." + ie, e);
          if (re)
            return re;
        }
        return null;
      }
      return g(B);
    }
    function E(V) {
      switch (typeof V) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !V;
        case "object":
          if (Array.isArray(V))
            return V.every(E);
          if (V === null || s(V))
            return !0;
          var B = d(V);
          if (B) {
            var Z = B.call(V), q;
            if (B !== V.entries) {
              for (; !(q = Z.next()).done; )
                if (!E(q.value))
                  return !1;
            } else
              for (; !(q = Z.next()).done; ) {
                var z = q.value;
                if (z && !E(z[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function k(V, B) {
      return V === "symbol" ? !0 : B ? B["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && B instanceof Symbol : !1;
    }
    function P(V) {
      var B = typeof V;
      return Array.isArray(V) ? "array" : V instanceof RegExp ? "object" : k(B, V) ? "symbol" : B;
    }
    function N(V) {
      if (typeof V > "u" || V === null)
        return "" + V;
      var B = P(V);
      if (B === "object") {
        if (V instanceof Date)
          return "date";
        if (V instanceof RegExp)
          return "regexp";
      }
      return B;
    }
    function O(V) {
      var B = N(V);
      switch (B) {
        case "array":
        case "object":
          return "an " + B;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + B;
        default:
          return B;
      }
    }
    function W(V) {
      return !V.constructor || !V.constructor.name ? f : V.constructor.name;
    }
    return h.checkPropTypes = i, h.resetWarningCache = i.resetWarningCache, h.PropTypes = h, h;
  }, k4;
}
var P4, Rk;
function I7e() {
  if (Rk) return P4;
  Rk = 1;
  var t = /* @__PURE__ */ s8();
  function r() {
  }
  function e() {
  }
  return e.resetWarningCache = r, P4 = function() {
    function n(o, s, l, u, c, d) {
      if (d !== t) {
        var f = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw f.name = "Invariant Violation", f;
      }
    }
    n.isRequired = n;
    function i() {
      return n;
    }
    var a = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: i,
      element: n,
      elementType: n,
      instanceOf: i,
      node: n,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: e,
      resetWarningCache: r
    };
    return a.PropTypes = a, a;
  }, P4;
}
var Lk;
function ld() {
  if (Lk) return h0.exports;
  if (Lk = 1, process.env.NODE_ENV !== "production") {
    var t = YZ(), r = !0;
    h0.exports = /* @__PURE__ */ S7e()(t.isElement, r);
  } else
    h0.exports = /* @__PURE__ */ I7e()();
  return h0.exports;
}
var Ek;
function A7e() {
  return Ek || (Ek = 1, function(t) {
    t.__esModule = !0, t.default = void 0;
    var r = e(te);
    e(/* @__PURE__ */ ld());
    function e(s) {
      return s && s.__esModule ? s : { default: s };
    }
    function n(s, l) {
      s.prototype = Object.create(l.prototype), s.prototype.constructor = s, i(s, l);
    }
    function i(s, l) {
      return i = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(u, c) {
        return u.__proto__ = c, u;
      }, i(s, l);
    }
    var a = /* @__PURE__ */ function(s) {
      function l() {
        for (var c, d = arguments.length, f = Array(d), h = 0; h < d; h++) f[h] = arguments[h];
        return c = s.call.apply(s, [this].concat(f)) || this, c.container = /* @__PURE__ */ r.default.createRef(), c.handleClick = function(p) {
          var v = c.container.current, g = p.target, m = c.props.onClickOutside;
          (v && v === g || v && !v.contains(g)) && m(p);
        }, c;
      }
      n(l, s);
      var u = l.prototype;
      return u.componentDidMount = function() {
        document.addEventListener("click", this.handleClick, !0);
      }, u.componentWillUnmount = function() {
        document.removeEventListener("click", this.handleClick, !0);
      }, u.render = function() {
        var d = this.props, f = d.className, h = d.children;
        return /* @__PURE__ */ r.default.createElement("div", { className: f, ref: this.container }, h);
      }, l;
    }(r.default.Component), o = a;
    t.default = o;
  }(T4)), T4;
}
var N4 = {}, O4 = {}, V4 = {}, kk;
function Ih() {
  return kk || (kk = 1, function(t) {
    t.__esModule = !0, t.valueExistInSelected = t.isomorphicWindow = t.isEqual = t.hexToRGBA = t.getProp = t.getByPath = t.debounce = void 0;
    var r = function(l, u, c) {
      return !!u.find(function(d) {
        return a(d, c.valueField) === l || a(d, c.labelField) === l;
      });
    };
    t.valueExistInSelected = r;
    var e = function(l, u) {
      l.length === 4 && (l = "" + l[1] + l[1] + l[2] + l[2] + l[3] + l[3] + "}");
      var c = parseInt(l.slice(1, 3), 16), d = parseInt(l.slice(3, 5), 16), f = parseInt(l.slice(5, 7), 16);
      return "rgba(" + c + ", " + d + ", " + f + (u && ", " + u) + ")";
    };
    t.hexToRGBA = e;
    var n = function(l, u) {
      u === void 0 && (u = 0);
      var c;
      return function() {
        for (var d = arguments.length, f = Array(d), h = 0; h < d; h++) f[h] = arguments[h];
        c && clearTimeout(c), c = setTimeout(function() {
          l.apply(void 0, f), c = null;
        }, u);
      };
    };
    t.debounce = n;
    var i = function(l, u) {
      return JSON.stringify(l) === JSON.stringify(u);
    };
    t.isEqual = i;
    var a = function(l, u) {
      return u ? u.split(".").reduce(function(c, d) {
        return c[d];
      }, l) : void 0;
    };
    t.getByPath = a;
    var o = function(l, u, c) {
      if (!u) return l;
      var d = Array.isArray(u) ? u : u.split(".").filter(function(f) {
        return f.length;
      });
      return d.length ? o(l[d.shift()], d, c) : l === void 0 ? c : l;
    };
    t.getProp = o;
    var s = function() {
      return typeof window > "u" && (xp.window = {}), window;
    };
    t.isomorphicWindow = s;
  }(V4)), V4;
}
var G4 = {}, Pk;
function po() {
  return Pk || (Pk = 1, function(t) {
    t.__esModule = !0, t.LIB_NAME = void 0, t.LIB_NAME = "react-dropdown-select";
  }(G4)), G4;
}
var Nk;
function D7e() {
  return Nk || (Nk = 1, function(t) {
    t.__esModule = !0, t.default = void 0;
    var r = a(ho), e = a(te), n = /* @__PURE__ */ Ih(), i = /* @__PURE__ */ po();
    function a(u) {
      return u && u.__esModule ? u : { default: u };
    }
    var o = function(u) {
      var c = u.item, d = u.props, f = u.state, h = u.methods;
      return c && d.optionRenderer ? d.optionRenderer({ item: c, props: d, state: f, methods: h }) : /* @__PURE__ */ e.default.createElement(s, { role: "listitem", disabled: d.disabled, direction: d.direction, className: i.LIB_NAME + "-option", color: d.color }, /* @__PURE__ */ e.default.createElement("span", { className: i.LIB_NAME + "-option-label" }, (0, n.getByPath)(c, d.labelField)), /* @__PURE__ */ e.default.createElement("span", { className: i.LIB_NAME + "-option-remove", onClick: function(v) {
        return h.removeItem(v, c, d.closeOnSelect);
      } }, "×"));
    }, s = /* @__PURE__ */ (0, r.default)("span", process.env.NODE_ENV === "production" ? { target: "e1l4eby50" } : { target: "e1l4eby50", label: "OptionComponent" })("padding:0 5px;border-radius:2px;line-height:21px;margin:3px 0 3px 5px;background:", function(u) {
      var c = u.color;
      return c;
    }, ";color:#fff;display:flex;flex-direction:", function(u) {
      var c = u.direction;
      return c === "rtl" ? "row-reverse" : "row";
    }, ";.", i.LIB_NAME, "-option-remove{cursor:pointer;width:22px;height:22px;display:inline-block;text-align:center;margin:0 -5px 0 0px;border-radius:0 3px 3px 0;:hover{color:tomato;}}:hover,:hover>span{opacity:0.9;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")), l = o;
    t.default = l;
  }(O4)), O4;
}
var B4 = {}, Ok;
function T7e() {
  return Ok || (Ok = 1, function(t) {
    t.__esModule = !0, t.default = void 0;
    var r = s(ho), e = o(te), n = /* @__PURE__ */ Ih();
    o(/* @__PURE__ */ ld());
    var i = /* @__PURE__ */ po();
    function a(p) {
      if (typeof WeakMap != "function") return null;
      var v = /* @__PURE__ */ new WeakMap(), g = /* @__PURE__ */ new WeakMap();
      return (a = function(m) {
        return m ? g : v;
      })(p);
    }
    function o(p, v) {
      if (p && p.__esModule) return p;
      if (p === null || typeof p != "object" && typeof p != "function") return { default: p };
      var g = a(v);
      if (g && g.has(p)) return g.get(p);
      var m = {}, y = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var b in p) if (b != "default" && Object.prototype.hasOwnProperty.call(p, b)) {
        var C = y ? Object.getOwnPropertyDescriptor(p, b) : null;
        C && (C.get || C.set) ? Object.defineProperty(m, b, C) : m[b] = p[b];
      }
      return m.default = p, g && g.set(p, m), m;
    }
    function s(p) {
      return p && p.__esModule ? p : { default: p };
    }
    function l(p, v) {
      p.prototype = Object.create(v.prototype), p.prototype.constructor = p, u(p, v);
    }
    function u(p, v) {
      return u = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(g, m) {
        return g.__proto__ = m, g;
      }, u(p, v);
    }
    var c = function(p, v) {
      var g = p.addPlaceholder, m = p.searchable, y = p.placeholder, b = v.values && v.values.length === 0, C = v.values && 0 < v.values.length;
      return C && g && m ? g : b ? y : "";
    }, d = /* @__PURE__ */ function(p) {
      function v() {
        for (var m, y = arguments.length, b = Array(y), C = 0; C < y; C++) b[C] = arguments[C];
        return m = p.call.apply(p, [this].concat(b)) || this, m.input = /* @__PURE__ */ e.default.createRef(), m.onBlur = function(w) {
          return w.stopPropagation(), m.props.state.dropdown ? m.input.current.focus() : m.input.current.blur();
        }, m.handleKeyPress = function(w) {
          var _ = m.props, x = _.props, I = _.state, D = _.methods;
          return x.create && w.key === "Enter" && !(0, n.valueExistInSelected)(I.search, [].concat(I.values, x.options), m.props) && I.search && I.cursor === null && D.createNew(I.search);
        }, m;
      }
      l(v, p);
      var g = v.prototype;
      return g.componentDidUpdate = function(y) {
        (this.props.state.dropdown || y.state.dropdown !== this.props.state.dropdown && this.props.state.dropdown || this.props.props.autoFocus) && this.input.current.focus(), y.state.dropdown === this.props.state.dropdown || this.props.state.dropdown || this.input.current.blur();
      }, g.render = function() {
        var y = this.props, b = y.props, C = y.state, w = y.methods;
        return b.inputRenderer ? b.inputRenderer({ props: b, state: C, methods: w, inputRef: this.input }) : /* @__PURE__ */ e.default.createElement(f, { ref: this.input, tabIndex: "-1", onFocus: function(x) {
          return x.stopPropagation();
        }, className: i.LIB_NAME + "-input", size: w.getInputSize(), value: C.search, readOnly: !b.searchable, onClick: function() {
          return w.dropDown("open");
        }, onKeyPress: this.handleKeyPress, onChange: w.setSearch, onBlur: this.onBlur, placeholder: c(b, C), disabled: b.disabled });
      }, v;
    }(e.Component), f = /* @__PURE__ */ (0, r.default)("input", process.env.NODE_ENV === "production" ? { target: "e11wid6y0" } : { target: "e11wid6y0", label: "InputComponent" })("line-height:inherit;border:none;margin-left:5px;background:transparent;padding:0;width:calc(", function(p) {
      var v = p.size;
      return v + "ch";
    }, " + 5px);font-size:smaller;", function(p) {
      var v = p.readOnly;
      return v && "cursor: pointer;";
    }, " :focus{outline:none;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21wb25lbnRzL0lucHV0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWlHbUMiLCJmaWxlIjoiLi4vLi4vc3JjL2NvbXBvbmVudHMvSW5wdXQuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgQ29tcG9uZW50IH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgdmFsdWVFeGlzdEluU2VsZWN0ZWQgfSBmcm9tICcuLi91dGlsJztcbmltcG9ydCAqIGFzIFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJztcbmltcG9ydCB7IExJQl9OQU1FIH0gZnJvbSAnLi4vY29uc3RhbnRzJztcblxuY29uc3QgaGFuZGxlUGxhY2VIb2xkZXIgPSAocHJvcHMsIHN0YXRlKSA9PiB7XG4gIGNvbnN0IHsgYWRkUGxhY2Vob2xkZXIsIHNlYXJjaGFibGUsIHBsYWNlaG9sZGVyIH0gPSBwcm9wcztcbiAgY29uc3Qgbm9WYWx1ZXMgPSBzdGF0ZS52YWx1ZXMgJiYgc3RhdGUudmFsdWVzLmxlbmd0aCA9PT0gMDtcbiAgY29uc3QgaGFzVmFsdWVzID0gc3RhdGUudmFsdWVzICYmIHN0YXRlLnZhbHVlcy5sZW5ndGggPiAwO1xuXG4gIGlmIChoYXNWYWx1ZXMgJiYgYWRkUGxhY2Vob2xkZXIgJiYgc2VhcmNoYWJsZSkge1xuICAgIHJldHVybiBhZGRQbGFjZWhvbGRlcjtcbiAgfVxuXG4gIGlmIChub1ZhbHVlcykge1xuICAgIHJldHVybiBwbGFjZWhvbGRlcjtcbiAgfVxuXG4gIGlmIChoYXNWYWx1ZXMgJiYgIXNlYXJjaGFibGUpIHtcbiAgICByZXR1cm4gJyc7XG4gIH1cblxuICByZXR1cm4gJyc7XG59O1xuXG5jbGFzcyBJbnB1dCBleHRlbmRzIENvbXBvbmVudCB7XG4gIGlucHV0ID0gUmVhY3QuY3JlYXRlUmVmKCk7XG5cbiAgY29tcG9uZW50RGlkVXBkYXRlKHByZXZQcm9wcykge1xuICAgIGlmIChcbiAgICAgIHRoaXMucHJvcHMuc3RhdGUuZHJvcGRvd24gfHwgKHByZXZQcm9wcy5zdGF0ZS5kcm9wZG93biAhPT0gdGhpcy5wcm9wcy5zdGF0ZS5kcm9wZG93biAmJiB0aGlzLnByb3BzLnN0YXRlLmRyb3Bkb3duKSB8fFxuICAgICAgdGhpcy5wcm9wcy5wcm9wcy5hdXRvRm9jdXNcbiAgICApIHtcbiAgICAgIHRoaXMuaW5wdXQuY3VycmVudC5mb2N1cygpO1xuICAgIH1cblxuICAgIGlmIChwcmV2UHJvcHMuc3RhdGUuZHJvcGRvd24gIT09IHRoaXMucHJvcHMuc3RhdGUuZHJvcGRvd24gJiYgIXRoaXMucHJvcHMuc3RhdGUuZHJvcGRvd24pIHtcbiAgICAgICB0aGlzLmlucHV0LmN1cnJlbnQuYmx1cigpO1xuICAgIH1cbiAgfVxuXG4gIG9uQmx1ciA9IChldmVudCkgPT4ge1xuICAgIGV2ZW50LnN0b3BQcm9wYWdhdGlvbigpO1xuICAgIGlmICghdGhpcy5wcm9wcy5zdGF0ZS5kcm9wZG93bikge1xuICAgICAgcmV0dXJuIHRoaXMuaW5wdXQuY3VycmVudC5ibHVyKCk7XG4gICAgfVxuXG4gICAgcmV0dXJuIHRoaXMuaW5wdXQuY3VycmVudC5mb2N1cygpO1xuICB9O1xuXG4gIGhhbmRsZUtleVByZXNzID0gKGV2ZW50KSA9PiB7XG4gICAgY29uc3QgeyBwcm9wcywgc3RhdGUsIG1ldGhvZHMgfSA9IHRoaXMucHJvcHM7XG5cbiAgICByZXR1cm4gKFxuICAgICAgcHJvcHMuY3JlYXRlICYmXG4gICAgICBldmVudC5rZXkgPT09ICdFbnRlcicgJiZcbiAgICAgICF2YWx1ZUV4aXN0SW5TZWxlY3RlZChzdGF0ZS5zZWFyY2gsIFsuLi5zdGF0ZS52YWx1ZXMsIC4uLnByb3BzLm9wdGlvbnNdLCB0aGlzLnByb3BzKSAmJlxuICAgICAgc3RhdGUuc2VhcmNoICYmXG4gICAgICBzdGF0ZS5jdXJzb3IgPT09IG51bGwgJiZcbiAgICAgIG1ldGhvZHMuY3JlYXRlTmV3KHN0YXRlLnNlYXJjaClcbiAgICApO1xuICB9O1xuXG4gIHJlbmRlcigpIHtcbiAgICBjb25zdCB7IHByb3BzLCBzdGF0ZSwgbWV0aG9kcyB9ID0gdGhpcy5wcm9wcztcblxuICAgIGlmIChwcm9wcy5pbnB1dFJlbmRlcmVyKSB7XG4gICAgICByZXR1cm4gcHJvcHMuaW5wdXRSZW5kZXJlcih7IHByb3BzLCBzdGF0ZSwgbWV0aG9kcywgaW5wdXRSZWY6IHRoaXMuaW5wdXQgfSk7XG4gICAgfVxuXG4gICAgcmV0dXJuIChcbiAgICAgIDxJbnB1dENvbXBvbmVudFxuICAgICAgICByZWY9e3RoaXMuaW5wdXR9XG4gICAgICAgIHRhYkluZGV4PVwiLTFcIlxuICAgICAgICBvbkZvY3VzPXsoZXZlbnQpID0+IGV2ZW50LnN0b3BQcm9wYWdhdGlvbigpfVxuICAgICAgICBjbGFzc05hbWU9e2Ake0xJQl9OQU1FfS1pbnB1dGB9XG4gICAgICAgIHNpemU9e21ldGhvZHMuZ2V0SW5wdXRTaXplKCl9XG4gICAgICAgIHZhbHVlPXtzdGF0ZS5zZWFyY2h9XG4gICAgICAgIHJlYWRPbmx5PXshcHJvcHMuc2VhcmNoYWJsZX1cbiAgICAgICAgb25DbGljaz17KCkgPT4gbWV0aG9kcy5kcm9wRG93bignb3BlbicpfVxuICAgICAgICBvbktleVByZXNzPXt0aGlzLmhhbmRsZUtleVByZXNzfVxuICAgICAgICBvbkNoYW5nZT17bWV0aG9kcy5zZXRTZWFyY2h9XG4gICAgICAgIG9uQmx1cj17dGhpcy5vbkJsdXJ9XG4gICAgICAgIHBsYWNlaG9sZGVyPXtoYW5kbGVQbGFjZUhvbGRlcihwcm9wcywgc3RhdGUpfVxuICAgICAgICBkaXNhYmxlZD17cHJvcHMuZGlzYWJsZWR9XG4gICAgICAvPlxuICAgICk7XG4gIH1cbn1cblxuSW5wdXQucHJvcFR5cGVzID0ge1xuICBwcm9wczogUHJvcFR5cGVzLm9iamVjdCxcbiAgc3RhdGU6IFByb3BUeXBlcy5vYmplY3QsXG4gIG1ldGhvZHM6IFByb3BUeXBlcy5vYmplY3Rcbn07XG5cbmNvbnN0IElucHV0Q29tcG9uZW50ID0gc3R5bGVkLmlucHV0YFxuICBsaW5lLWhlaWdodDogaW5oZXJpdDtcbiAgYm9yZGVyOiBub25lO1xuICBtYXJnaW4tbGVmdDogNXB4O1xuICBiYWNrZ3JvdW5kOiB0cmFuc3BhcmVudDtcbiAgcGFkZGluZzogMDtcbiAgd2lkdGg6IGNhbGMoJHsoeyBzaXplIH0pID0+IGAke3NpemV9Y2hgfSArIDVweCk7XG4gIGZvbnQtc2l6ZTogc21hbGxlcjtcbiAgJHsoeyByZWFkT25seSB9KSA9PiByZWFkT25seSAmJiAnY3Vyc29yOiBwb2ludGVyOyd9XG4gIDpmb2N1cyB7XG4gICAgb3V0bGluZTogbm9uZTtcbiAgfVxuYDtcblxuZXhwb3J0IGRlZmF1bHQgSW5wdXQ7XG4iXX0= */")), h = d;
    t.default = h;
  }(B4)), B4;
}
var F4 = {}, Vk;
function QZ() {
  return Vk || (Vk = 1, function(t) {
    var r = e(/* @__PURE__ */ ld());
    t.__esModule = !0, t.default = void 0;
    function e(a) {
      return a && a.__esModule ? a : { default: a };
    }
    var n = Object.freeze({
      /**
      * Secondary placeholder on search field if any value selected
      */
      addPlaceholder: r.default.string,
      /**
      * Additional props to pass to Select
      */
      additionalProps: r.default.object,
      /**
      * If true, and searchable, dropdown will autofocus
      */
      autoFocus: r.default.bool,
      /**
      * If true, backspace key will delete last value
      */
      backspaceDelete: r.default.bool,
      /**
      * CSS class attribute to pass to select
      */
      className: r.default.string,
      /**
      * Label for "Clear all"
      */
      clearAllLabel: r.default.string,
      /**
      * If true, and searchable, search value will be cleared on blur
      */
      clearOnBlur: r.default.bool,
      /**
      * If true, and searchable, search value will be cleared upon value select/de-select
      */
      clearOnSelect: r.default.bool,
      /**
      * Overrides internal clear button
      */
      clearRenderer: r.default.func,
      /**
      * Clear all indicator
      */
      clearable: r.default.bool,
      /**
      * If true, scrolling the page will close the dropdown
      */
      closeOnScroll: r.default.bool,
      /**
      * If true, selecting option will close the dropdown
      */
      closeOnSelect: r.default.bool,
      /**
      * If true, clicking input will close the dropdown if you are not searching.
      */
      closeOnClickInput: r.default.bool,
      /**
      * Base color (any CSS compatible) to use in component, also can be overwritten via CSS
      */
      color: r.default.string,
      /**
      * Compare values override function
      */
      compareValuesFunc: r.default.func,
      /**
      * Overrides internal content component (the contents of the select component)
      * | <a href="https://sanusart.github.io/react-dropdown-select/prop/content-renderer">example</a>
      */
      contentRenderer: r.default.func,
      /**
      * If true, select will create value from search string and fire onCreateNew callback prop
      */
      create: r.default.bool,
      /**
      * If create set to true, this will be the label of the "add new" component. {search} will be replaced by search value
      */
      createNewLabel: r.default.string,
      /**
      * Debounce Delay for updates upon component interactions
      */
      debounceDelay: r.default.number,
      /**
      * Direction of a dropdown "ltr", "rtl" or "auto"
      */
      direction: r.default.string,
      /**
      * Disable select and all interactions
      */
      disabled: r.default.bool,
      /**
      * Label shown on disabled field (after) the text
      */
      disabledLabel: r.default.string,
      /**
      * Gap between select element and dropdown
      */
      dropdownGap: r.default.number,
      /**
      * Show or hide dropdown handle to open/close dropdown
      */
      dropdownHandle: r.default.bool,
      /**
      * Overrides internal dropdown handle
      */
      dropdownHandleRenderer: r.default.func,
      /**
      * Minimum height of a dropdown
      */
      dropdownHeight: r.default.string,
      /**
      * Available options are "auto", "top" and "bottom" defaults to "bottom". Auto will adjust itself according Select's position on the page
      * | <a href="https://sanusart.github.io/react-dropdown-select/prop/dropdown-position">example</a>
      */
      dropdownPosition: r.default.oneOf(["top", "bottom", "auto"]),
      /**
      * Overrides internal dropdown handle
      */
      dropdownRenderer: r.default.func,
      /**
      * Overrides internal keyDown function
      */
      handleKeyDownFn: r.default.func,
      /**
      * Overrides internal input text
      */
      inputRenderer: r.default.func,
      /**
      * Overrides internal item in a dropdown
      */
      itemRenderer: r.default.func,
      /**
      * If true, dropdown will always stay open (good for debugging)
      */
      keepOpen: r.default.bool,
      /**
      * If false, selected item will not appear in a list
      */
      keepSelectedInList: r.default.bool,
      /**
      * Field in data to use for label
      */
      labelField: r.default.string,
      /**
      * Loading indicator
      */
      loading: r.default.bool,
      /**
      * Overrides internal loading
      */
      loadingRenderer: r.default.func,
      /**
      * If true - will act as multi-select, if false - only one option will be selected at the time
      */
      multi: r.default.bool,
      /**
      * If set, input type hidden would be added in the component with the value of the `name` prop as `name` and select's `values` as `value`
      * Useful for HTML forms
      */
      name: r.default.string,
      /**
      * Label for "No data"
      */
      noDataLabel: r.default.string,
      /**
      * Overrides internal "no data" (shown where search has no results)
      */
      noDataRenderer: r.default.func,
      /**
      * onChange callback handler
      */
      onChange: r.default.func.isRequired,
      /**
      * Fires upon clearing all values (via custom renderers)
      */
      onClearAll: r.default.func,
      /**
      * Fires upon creation of new item if create prop set to true
      */
      onCreateNew: r.default.func,
      /**
      * Fires upon dropdown close
      */
      onDropdownClose: r.default.func,
      /**
      * Fires upon dropdown closing state, stops the closing and provides own method close()
      * @return undefined
      */
      onDropdownCloseRequest: r.default.func,
      /**
      * Fires upon dropdown open
      */
      onDropdownOpen: r.default.func,
      /**
      * Fires upon selecting all values (via custom renderers)
      */
      onSelectAll: r.default.func,
      /**
      * Overrides internal option (the pillow with an "x") on the select content
      */
      optionRenderer: r.default.func,
      /**
      * Available options, (option with key disabled: true will be disabled)
      */
      options: r.default.array.isRequired,
      /**
      * If set, input type hidden would be added in the component with pattern prop as regex
      */
      pattern: r.default.string,
      /**
      * Placeholder shown where there are no selected values
      */
      placeholder: r.default.string,
      /**
      * If valid DOM element specified - dropdown will break out to render inside the specified element
      */
      portal: r.default.element,
      /**
      * If set, input type hidden would be added in the component with required prop as true/false
      */
      required: r.default.bool,
      /**
      * Search by object property in values
      */
      searchBy: r.default.string,
      /**
      * Overrides internal search function
      */
      searchFn: r.default.func,
      /**
      * If true, select will have search input text
      */
      searchable: r.default.bool,
      /**
      * Allow to select all (if select is multi-select)
      */
      selectAll: r.default.bool,
      /**
      * Label for "Select all"
      */
      selectAllLabel: r.default.string,
      /**
      * Separator line between close all and dropdown handle
      */
      separator: r.default.bool,
      /**
      * Overrides internal separator
      */
      separatorRenderer: r.default.func,
      /**
      * Sort by object property in values
      */
      sortBy: r.default.string,
      /**
      * Style object to pass to select
      */
      style: r.default.object,
      /**
      * Field in data to use for value
      */
      valueField: r.default.string,
      /**
      * Selected values
      */
      values: r.default.array,
      /**
      * If true, dropdown will be open by default
      */
      defaultMenuIsOpen: r.default.bool
    }), i = n;
    t.default = i;
  }(F4)), F4;
}
var H4 = {}, Gk;
function M7e() {
  return Gk || (Gk = 1, function(t) {
    var r = e(/* @__PURE__ */ ld());
    t.__esModule = !0, t.default = void 0;
    function e(a) {
      return a && a.__esModule ? a : { default: a };
    }
    var n = Object.freeze({
      activeCursorItem: r.default.func,
      /**
      * Add a new item
      */
      addItem: r.default.func.isRequired,
      /**
      * Check if all items are selected
      */
      areAllSelected: r.default.func.isRequired,
      /**
      * Clear all selected items
      */
      clearAll: r.default.func.isRequired,
      /**
      * Create a new item
      */
      createNew: r.default.func.isRequired,
      /**
      * Close/Toggle/Open
      */
      dropDown: r.default.func.isRequired,
      /**
      * Get the input size
      */
      getInputSize: r.default.func.isRequired,
      /**
      * Get the bounds of the select component
      */
      getSelectBounds: r.default.func.isRequired,
      /**
      * Get the reference to the select component
      */
      getSelectRef: r.default.func.isRequired,
      /**
      * Handle key down event
      */
      handleKeyDown: r.default.func.isRequired,
      /**
      * Check if an item is selected
      */
      isSelected: r.default.func.isRequired,
      /**
      * Remove an item
      */
      removeItem: r.default.func.isRequired,
      /**
      * Make a string safe
      */
      safeString: r.default.func.isRequired,
      /**
      * Get search results
      */
      searchResults: r.default.func.isRequired,
      /**
      * Select all items
      */
      selectAll: r.default.func.isRequired,
      /**
      * Set the search string
      */
      setSearch: r.default.func.isRequired,
      /**
      * Sort items
      */
      sortBy: r.default.func.isRequired,
      /**
      * Toggle select all
      */
      toggleSelectAll: r.default.func.isRequired
    }), i = n;
    t.default = i;
  }(H4)), H4;
}
var z4 = {}, Bk;
function R7e() {
  return Bk || (Bk = 1, function(t) {
    var r = e(/* @__PURE__ */ ld());
    t.__esModule = !0, t.default = void 0;
    function e(a) {
      return a && a.__esModule ? a : { default: a };
    }
    var n = Object.freeze({
      /**
      * Flag indicating whether the dropdown is open or closed
      */
      dropdown: r.default.bool.isRequired,
      /**
      * Array of selected values
      */
      values: r.default.arrayOf(r.default.shape({})),
      /**
      * Search string
      */
      search: r.default.string.isRequired,
      /**
      * Array of bounds for the select component
      */
      selectBounds: r.default.shape({}),
      /**
      * Cursor position
      */
      cursor: r.default.number,
      /**
      * Array of search results
      */
      searchResults: r.default.arrayOf(r.default.shape({}))
    }), i = n;
    t.default = i;
  }(z4)), z4;
}
var Fk;
function L7e() {
  return Fk || (Fk = 1, function(t) {
    t.__esModule = !0, t.default = void 0;
    var r = s(ho), e = s(te);
    s(/* @__PURE__ */ ld());
    var n = s(/* @__PURE__ */ D7e()), i = s(/* @__PURE__ */ T7e()), a = /* @__PURE__ */ po(), o = /* @__PURE__ */ Ih();
    s(/* @__PURE__ */ QZ()), s(/* @__PURE__ */ M7e()), s(/* @__PURE__ */ R7e());
    function s(f) {
      return f && f.__esModule ? f : { default: f };
    }
    function l() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    var u = function(f) {
      var h = f.props, p = f.state, v = f.methods;
      return /* @__PURE__ */ e.default.createElement(c, { className: a.LIB_NAME + "-content " + (h.multi ? a.LIB_NAME + "-type-multi" : a.LIB_NAME + "-type-single"), onClick: function(m) {
        return m.stopPropagation(), p.dropdown === !0 && h.closeOnClickInput && !p.search ? v.dropDown("close") : v.dropDown("open");
      } }, h.contentRenderer ? h.contentRenderer({ props: h, state: p, methods: v }) : /* @__PURE__ */ e.default.createElement(e.default.Fragment, null, h.multi ? p.values && p.values.map(function(g) {
        return /* @__PURE__ */ e.default.createElement(n.default, { key: "" + (0, o.getByPath)(g, h.valueField) + (0, o.getByPath)(g, h.labelField), item: g, state: p, props: h, methods: v });
      }) : p.values && 0 < p.values.length && /* @__PURE__ */ e.default.createElement("span", null, (0, o.getByPath)(p.values[0], h.labelField)), /* @__PURE__ */ e.default.createElement(i.default, { props: h, methods: v, state: p })));
    }, c = /* @__PURE__ */ (0, r.default)("div", process.env.NODE_ENV === "production" ? { target: "e1gn6jc30" } : { target: "e1gn6jc30", label: "ContentComponent" })(process.env.NODE_ENV === "production" ? { name: "1m5113o", styles: "display:flex;flex:1;flex-wrap:wrap" } : { name: "1m5113o", styles: "display:flex;flex:1;flex-wrap:wrap", map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */", toString: l }), d = u;
    t.default = d;
  }(N4)), N4;
}
var W4 = {}, Z4 = {}, Hk;
function E7e() {
  return Hk || (Hk = 1, function(t) {
    t.__esModule = !0, t.default = void 0;
    var r = i(ho), e = i(te), n = /* @__PURE__ */ po();
    function i(l) {
      return l && l.__esModule ? l : { default: l };
    }
    var a = function(l) {
      var u = l.props, c = l.state, d = l.methods;
      return u.noDataRenderer ? u.noDataRenderer({ props: u, state: c, methods: d }) : /* @__PURE__ */ e.default.createElement(o, { className: n.LIB_NAME + "-no-data", color: u.color }, u.noDataLabel);
    }, o = /* @__PURE__ */ (0, r.default)("div", process.env.NODE_ENV === "production" ? { target: "e1l5ho1t0" } : { target: "e1l5ho1t0", label: "NoDataComponent" })("padding:10px;text-align:center;color:", function(l) {
      var u = l.color;
      return u;
    }, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21wb25lbnRzL05vRGF0YS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFha0MiLCJmaWxlIjoiLi4vLi4vc3JjL2NvbXBvbmVudHMvTm9EYXRhLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IExJQl9OQU1FIH0gZnJvbSAnLi4vY29uc3RhbnRzJztcblxuY29uc3QgTm9EYXRhID0gKHsgcHJvcHMsIHN0YXRlLCBtZXRob2RzIH0pID0+XG4gIHByb3BzLm5vRGF0YVJlbmRlcmVyID8gKFxuICAgIHByb3BzLm5vRGF0YVJlbmRlcmVyKHsgcHJvcHMsIHN0YXRlLCBtZXRob2RzIH0pXG4gICkgOiAoXG4gICAgPE5vRGF0YUNvbXBvbmVudCBjbGFzc05hbWU9e2Ake0xJQl9OQU1FfS1uby1kYXRhYH0gY29sb3I9e3Byb3BzLmNvbG9yfT5cbiAgICAgIHtwcm9wcy5ub0RhdGFMYWJlbH1cbiAgICA8L05vRGF0YUNvbXBvbmVudD5cbiAgKTtcblxuY29uc3QgTm9EYXRhQ29tcG9uZW50ID0gc3R5bGVkLmRpdmBcbiAgcGFkZGluZzogMTBweDtcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xuICBjb2xvcjogJHsoeyBjb2xvciB9KSA9PiBjb2xvcn07XG5gO1xuXG5leHBvcnQgZGVmYXVsdCBOb0RhdGE7XG4iXX0= */")), s = a;
    t.default = s;
  }(Z4)), Z4;
}
var j4 = {}, zk;
function k7e() {
  return zk || (zk = 1, function(t) {
    t.__esModule = !0, t.default = void 0;
    var r = s(ho), e = o(te), n = /* @__PURE__ */ Ih();
    o(/* @__PURE__ */ ld());
    var i = /* @__PURE__ */ po();
    function a(h) {
      if (typeof WeakMap != "function") return null;
      var p = /* @__PURE__ */ new WeakMap(), v = /* @__PURE__ */ new WeakMap();
      return (a = function(g) {
        return g ? v : p;
      })(h);
    }
    function o(h, p) {
      if (h && h.__esModule) return h;
      if (h === null || typeof h != "object" && typeof h != "function") return { default: h };
      var v = a(p);
      if (v && v.has(h)) return v.get(h);
      var g = {}, m = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var y in h) if (y != "default" && Object.prototype.hasOwnProperty.call(h, y)) {
        var b = m ? Object.getOwnPropertyDescriptor(h, y) : null;
        b && (b.get || b.set) ? Object.defineProperty(g, y, b) : g[y] = h[y];
      }
      return g.default = h, v && v.set(h, g), g;
    }
    function s(h) {
      return h && h.__esModule ? h : { default: h };
    }
    function l(h, p) {
      h.prototype = Object.create(p.prototype), h.prototype.constructor = h, u(h, p);
    }
    function u(h, p) {
      return u = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(v, g) {
        return v.__proto__ = g, v;
      }, u(h, p);
    }
    var c = /* @__PURE__ */ function(h) {
      function p() {
        for (var g, m = arguments.length, y = Array(m), b = 0; b < m; b++) y[b] = arguments[b];
        return g = h.call.apply(h, [this].concat(y)) || this, g.item = /* @__PURE__ */ e.default.createRef(), g;
      }
      l(p, h);
      var v = p.prototype;
      return v.componentDidMount = function() {
        var m = this.props, y = m.props, b = m.methods;
        this.item.current && !y.multi && y.keepSelectedInList && b.isSelected(this.props.item) && this.item.current.scrollIntoView({ block: "nearest", inline: "start" });
      }, v.componentDidUpdate = function() {
        this.props.state.cursor === this.props.itemIndex && this.item.current && this.item.current.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" });
      }, v.render = function() {
        var m = this.props, y = m.props, b = m.state, C = m.methods, w = m.item, _ = m.itemIndex;
        return y.itemRenderer ? y.itemRenderer({ item: w, itemIndex: _, props: y, state: b, methods: C }) : !y.keepSelectedInList && C.isSelected(w) ? null : /* @__PURE__ */ e.default.createElement(d, { role: "option", ref: this.item, "aria-selected": C.isSelected(w), "aria-disabled": w.disabled, "aria-label": (0, n.getByPath)(w, y.labelField), disabled: w.disabled, key: "" + (0, n.getByPath)(w, y.valueField) + (0, n.getByPath)(w, y.labelField), tabIndex: "-1", className: i.LIB_NAME + "-item " + (C.isSelected(w) ? i.LIB_NAME + "-item-selected" : "") + " " + (b.cursor === _ ? i.LIB_NAME + "-item-active" : "") + " " + (w.disabled ? i.LIB_NAME + "-item-disabled" : ""), onClick: w.disabled ? void 0 : function() {
          return C.addItem(w);
        }, onKeyPress: w.disabled ? void 0 : function() {
          return C.addItem(w);
        }, color: y.color }, (0, n.getByPath)(w, y.labelField), " ", w.disabled && /* @__PURE__ */ e.default.createElement("ins", null, y.disabledLabel));
      }, p;
    }(e.Component), d = /* @__PURE__ */ (0, r.default)("span", process.env.NODE_ENV === "production" ? { target: "evc32pp0" } : { target: "evc32pp0", label: "ItemComponent" })("padding:5px 10px;cursor:pointer;border-bottom:1px solid #fff;&.", i.LIB_NAME, "-item-active{border-bottom:1px solid #fff;", function(h) {
      var p = h.disabled, v = h.color;
      return !p && v && "background: " + (0, n.hexToRGBA)(v, 0.1) + ";";
    }, ";}:hover,:focus{background:", function(h) {
      var p = h.color;
      return p && (0, n.hexToRGBA)(p, 0.1);
    }, ";outline:none;}&.", i.LIB_NAME, "-item-selected{", function(h) {
      var p = h.disabled, v = h.color;
      return p ? `
    background: #f2f2f2;
    color: #ccc;
    ` : `
    background: ` + v + `;
    color: #fff;
    border-bottom: 1px solid #fff;
    `;
    }, ";}", function(h) {
      var p = h.disabled;
      return p ? `
    background: #f2f2f2;
    color: #ccc;

    ins {
      text-decoration: none;
      border:1px solid #ccc;
      border-radius: 2px;
      padding: 0px 3px;
      font-size: x-small;
      text-transform: uppercase;
    }
    ` : "";
    }, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21wb25lbnRzL0l0ZW0uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBdUVpQyIsImZpbGUiOiIuLi8uLi9zcmMvY29tcG9uZW50cy9JdGVtLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IENvbXBvbmVudCB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IGhleFRvUkdCQSwgZ2V0QnlQYXRoIH0gZnJvbSAnLi4vdXRpbCc7XG5pbXBvcnQgKiBhcyBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgeyBMSUJfTkFNRSB9IGZyb20gJy4uL2NvbnN0YW50cyc7XG5cbmNsYXNzIEl0ZW0gZXh0ZW5kcyBDb21wb25lbnQge1xuICBpdGVtID0gUmVhY3QuY3JlYXRlUmVmKCk7XG5cbiAgY29tcG9uZW50RGlkTW91bnQoKSB7XG4gICAgY29uc3QgeyBwcm9wcywgbWV0aG9kcyB9ID0gdGhpcy5wcm9wcztcblxuICAgIGlmIChcbiAgICAgIHRoaXMuaXRlbS5jdXJyZW50ICYmXG4gICAgICAhcHJvcHMubXVsdGkgJiZcbiAgICAgIHByb3BzLmtlZXBTZWxlY3RlZEluTGlzdCAmJlxuICAgICAgbWV0aG9kcy5pc1NlbGVjdGVkKHRoaXMucHJvcHMuaXRlbSlcbiAgICApXG4gICAgICB0aGlzLml0ZW0uY3VycmVudC5zY3JvbGxJbnRvVmlldyh7IGJsb2NrOiAnbmVhcmVzdCcsIGlubGluZTogJ3N0YXJ0JyB9KTtcbiAgfVxuXG4gIGNvbXBvbmVudERpZFVwZGF0ZSgpIHtcbiAgICBpZiAodGhpcy5wcm9wcy5zdGF0ZS5jdXJzb3IgPT09IHRoaXMucHJvcHMuaXRlbUluZGV4KSB7XG4gICAgICB0aGlzLml0ZW0uY3VycmVudCAmJlxuICAgICAgICB0aGlzLml0ZW0uY3VycmVudC5zY3JvbGxJbnRvVmlldyh7IGJlaGF2aW9yOiAnc21vb3RoJywgYmxvY2s6ICduZWFyZXN0JywgaW5saW5lOiAnc3RhcnQnIH0pO1xuICAgIH1cbiAgfVxuXG4gIHJlbmRlcigpIHtcbiAgICBjb25zdCB7IHByb3BzLCBzdGF0ZSwgbWV0aG9kcywgaXRlbSwgaXRlbUluZGV4IH0gPSB0aGlzLnByb3BzO1xuXG4gICAgaWYgKHByb3BzLml0ZW1SZW5kZXJlcikge1xuICAgICAgcmV0dXJuIHByb3BzLml0ZW1SZW5kZXJlcih7IGl0ZW0sIGl0ZW1JbmRleCwgcHJvcHMsIHN0YXRlLCBtZXRob2RzIH0pO1xuICAgIH1cblxuICAgIGlmICghcHJvcHMua2VlcFNlbGVjdGVkSW5MaXN0ICYmIG1ldGhvZHMuaXNTZWxlY3RlZChpdGVtKSkge1xuICAgICAgcmV0dXJuIG51bGw7XG4gICAgfVxuXG4gICAgcmV0dXJuIChcbiAgICAgIDxJdGVtQ29tcG9uZW50XG4gICAgICAgIHJvbGU9XCJvcHRpb25cIlxuICAgICAgICByZWY9e3RoaXMuaXRlbX1cbiAgICAgICAgYXJpYS1zZWxlY3RlZD17bWV0aG9kcy5pc1NlbGVjdGVkKGl0ZW0pfVxuICAgICAgICBhcmlhLWRpc2FibGVkPXtpdGVtLmRpc2FibGVkfVxuICAgICAgICBhcmlhLWxhYmVsPXtnZXRCeVBhdGgoaXRlbSwgcHJvcHMubGFiZWxGaWVsZCl9XG4gICAgICAgIGRpc2FibGVkPXtpdGVtLmRpc2FibGVkfVxuICAgICAgICBrZXk9e2Ake2dldEJ5UGF0aChpdGVtLCBwcm9wcy52YWx1ZUZpZWxkKX0ke2dldEJ5UGF0aChpdGVtLCBwcm9wcy5sYWJlbEZpZWxkKX1gfVxuICAgICAgICB0YWJJbmRleD1cIi0xXCJcbiAgICAgICAgY2xhc3NOYW1lPXtgJHtMSUJfTkFNRX0taXRlbSAke1xuICAgICAgICAgIG1ldGhvZHMuaXNTZWxlY3RlZChpdGVtKSA/IGAke0xJQl9OQU1FfS1pdGVtLXNlbGVjdGVkYCA6ICcnXG4gICAgICAgIH0gJHtzdGF0ZS5jdXJzb3IgPT09IGl0ZW1JbmRleCA/IGAke0xJQl9OQU1FfS1pdGVtLWFjdGl2ZWAgOiAnJ30gJHtcbiAgICAgICAgICBpdGVtLmRpc2FibGVkID8gYCR7TElCX05BTUV9LWl0ZW0tZGlzYWJsZWRgIDogJydcbiAgICAgICAgfWB9XG4gICAgICAgIG9uQ2xpY2s9e2l0ZW0uZGlzYWJsZWQgPyB1bmRlZmluZWQgOiAoKSA9PiBtZXRob2RzLmFkZEl0ZW0oaXRlbSl9XG4gICAgICAgIG9uS2V5UHJlc3M9e2l0ZW0uZGlzYWJsZWQgPyB1bmRlZmluZWQgOiAoKSA9PiBtZXRob2RzLmFkZEl0ZW0oaXRlbSl9XG4gICAgICAgIGNvbG9yPXtwcm9wcy5jb2xvcn0+XG4gICAgICAgIHtnZXRCeVBhdGgoaXRlbSwgcHJvcHMubGFiZWxGaWVsZCl9IHtpdGVtLmRpc2FibGVkICYmIDxpbnM+e3Byb3BzLmRpc2FibGVkTGFiZWx9PC9pbnM+fVxuICAgICAgPC9JdGVtQ29tcG9uZW50PlxuICAgICk7XG4gIH1cbn1cblxuSXRlbS5wcm9wVHlwZXMgPSB7XG4gIHByb3BzOiBQcm9wVHlwZXMuYW55LFxuICBzdGF0ZTogUHJvcFR5cGVzLmFueSxcbiAgbWV0aG9kczogUHJvcFR5cGVzLmFueSxcbiAgaXRlbTogUHJvcFR5cGVzLmFueSxcbiAgaXRlbUluZGV4OiBQcm9wVHlwZXMuYW55XG59O1xuXG5jb25zdCBJdGVtQ29tcG9uZW50ID0gc3R5bGVkLnNwYW5gXG4gIHBhZGRpbmc6IDVweCAxMHB4O1xuICBjdXJzb3I6IHBvaW50ZXI7XG4gIGJvcmRlci1ib3R0b206IDFweCBzb2xpZCAjZmZmO1xuXG4gICYuJHtMSUJfTkFNRX0taXRlbS1hY3RpdmUge1xuICAgIGJvcmRlci1ib3R0b206IDFweCBzb2xpZCAjZmZmO1xuICAgICR7KHsgZGlzYWJsZWQsIGNvbG9yIH0pID0+ICFkaXNhYmxlZCAmJiBjb2xvciAmJiBgYmFja2dyb3VuZDogJHtoZXhUb1JHQkEoY29sb3IsIDAuMSl9O2B9XG4gIH1cblxuICA6aG92ZXIsXG4gIDpmb2N1cyB7XG4gICAgYmFja2dyb3VuZDogJHsoeyBjb2xvciB9KSA9PiBjb2xvciAmJiBoZXhUb1JHQkEoY29sb3IsIDAuMSl9O1xuICAgIG91dGxpbmU6IG5vbmU7XG4gIH1cblxuICAmLiR7TElCX05BTUV9LWl0ZW0tc2VsZWN0ZWQge1xuICAgICR7KHsgZGlzYWJsZWQsIGNvbG9yIH0pID0+XG4gICAgICBkaXNhYmxlZFxuICAgICAgICA/IGBcbiAgICBiYWNrZ3JvdW5kOiAjZjJmMmYyO1xuICAgIGNvbG9yOiAjY2NjO1xuICAgIGBcbiAgICAgICAgOiBgXG4gICAgYmFja2dyb3VuZDogJHtjb2xvcn07XG4gICAgY29sb3I6ICNmZmY7XG4gICAgYm9yZGVyLWJvdHRvbTogMXB4IHNvbGlkICNmZmY7XG4gICAgYH1cbiAgfVxuXG4gICR7KHsgZGlzYWJsZWQgfSkgPT5cbiAgICBkaXNhYmxlZFxuICAgICAgPyBgXG4gICAgYmFja2dyb3VuZDogI2YyZjJmMjtcbiAgICBjb2xvcjogI2NjYztcblxuICAgIGlucyB7XG4gICAgICB0ZXh0LWRlY29yYXRpb246IG5vbmU7XG4gICAgICBib3JkZXI6MXB4IHNvbGlkICNjY2M7XG4gICAgICBib3JkZXItcmFkaXVzOiAycHg7XG4gICAgICBwYWRkaW5nOiAwcHggM3B4O1xuICAgICAgZm9udC1zaXplOiB4LXNtYWxsO1xuICAgICAgdGV4dC10cmFuc2Zvcm06IHVwcGVyY2FzZTtcbiAgICB9XG4gICAgYFxuICAgICAgOiAnJ31cbmA7XG5cbmV4cG9ydCBkZWZhdWx0IEl0ZW07XG4iXX0= */")), f = c;
    t.default = f;
  }(j4)), j4;
}
var Wk;
function P7e() {
  return Wk || (Wk = 1, function(t) {
    t.__esModule = !0, t.default = void 0;
    var r = s(ho), e = s(te), n = /* @__PURE__ */ po(), i = s(/* @__PURE__ */ E7e()), a = s(/* @__PURE__ */ k7e()), o = /* @__PURE__ */ Ih();
    function s(p) {
      return p && p.__esModule ? p : { default: p };
    }
    var l = function(p, v) {
      var g = v.getSelectRef().getBoundingClientRect(), m = g.bottom + parseInt(p.dropdownHeight, 10) + parseInt(p.dropdownGap, 10);
      return p.dropdownPosition === "auto" ? m > (0, o.isomorphicWindow)().innerHeight && m > g.top ? "top" : "bottom" : p.dropdownPosition;
    }, u = function(p) {
      var v = p.props, g = p.state, m = p.methods;
      return /* @__PURE__ */ e.default.createElement(c, { tabIndex: "-1", "aria-expanded": "true", role: "list", dropdownPosition: l(v, m), selectBounds: g.selectBounds, portal: v.portal, dropdownGap: v.dropdownGap, dropdownHeight: v.dropdownHeight, className: n.LIB_NAME + "-dropdown " + n.LIB_NAME + "-dropdown-position-" + l(v, m) }, v.dropdownRenderer ? v.dropdownRenderer({ props: v, state: g, methods: m }) : /* @__PURE__ */ e.default.createElement(e.default.Fragment, null, v.create && g.search && !(0, o.valueExistInSelected)(g.search, [].concat(g.values, v.options), v) && /* @__PURE__ */ e.default.createElement(d, { role: "button", className: n.LIB_NAME + "-dropdown-add-new", color: v.color, onClick: function() {
        return m.createNew(g.search);
      } }, v.createNewLabel.replace("{search}", '"' + g.search + '"')), g.searchResults.length === 0 ? /* @__PURE__ */ e.default.createElement(i.default, { className: n.LIB_NAME + "-no-data", state: g, props: v, methods: m }) : g.searchResults.map(function(y, b) {
        return /* @__PURE__ */ e.default.createElement(a.default, { key: y[v.valueField].toString(), item: y, itemIndex: b, state: g, props: v, methods: m });
      }), v.selectAll && v.options && v.multi && /* @__PURE__ */ e.default.createElement(f, { role: "button", className: n.LIB_NAME + "-dropdown-select-all", color: v.color, onClick: function() {
        return m.areAllSelected() ? m.clearAll() : m.selectAll();
      } }, m.areAllSelected() ? v.clearAllLabel : v.selectAllLabel)));
    }, c = /* @__PURE__ */ (0, r.default)("div", process.env.NODE_ENV === "production" ? { target: "e1qjn9k92" } : { target: "e1qjn9k92", label: "DropDown" })("position:absolute;", function(p) {
      var v = p.selectBounds, g = p.dropdownGap, m = p.dropdownPosition;
      return m === "top" ? "bottom: " + (v.height + 2 + g) + "px" : "top: " + (v.height + 2 + g) + "px";
    }, ";", function(p) {
      var v = p.selectBounds, g = p.dropdownGap, m = p.dropdownPosition, y = p.portal;
      return y ? `
      position: fixed;
      ` + (m === "bottom" ? "top: " + (v.bottom + g) + "px;" : "bottom: " + ((0, o.isomorphicWindow)().innerHeight - v.top + g) + "px;") + `
      left: ` + (v.left - 1) + "px;" : "left: -1px;";
    }, ";border:1px solid #ccc;width:", function(p) {
      var v = p.selectBounds;
      return v.width;
    }, "px;padding:0;display:flex;flex-direction:column;background:#fff;border-radius:2px;box-shadow:0 0 10px 0 ", function() {
      return (0, o.hexToRGBA)("#000000", 0.2);
    }, ";max-height:", function(p) {
      var v = p.dropdownHeight;
      return v;
    }, ";overflow:auto;z-index:9;:focus{outline:none;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")), d = /* @__PURE__ */ (0, r.default)("div", process.env.NODE_ENV === "production" ? { target: "e1qjn9k91" } : { target: "e1qjn9k91", label: "AddNew" })("color:", function(p) {
      var v = p.color;
      return v;
    }, ";padding:5px 10px;:hover{background:", function(p) {
      var v = p.color;
      return v && (0, o.hexToRGBA)(v, 0.1);
    }, ";outline:none;cursor:pointer;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")), f = /* @__PURE__ */ (0, r.default)("div", process.env.NODE_ENV === "production" ? { target: "e1qjn9k90" } : { target: "e1qjn9k90", label: "SelectAll" })("color:", function(p) {
      var v = p.color;
      return v;
    }, ";padding:5px 10px;position:sticky;bottom:0;margin:0;opacity:1;background:#fff;box-shadow:0 0 10px 0 ", function() {
      return (0, o.hexToRGBA)("#000000", 0.2);
    }, ";:hover{outline:none;cursor:pointer;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21wb25lbnRzL0Ryb3Bkb3duLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXVJNEIiLCJmaWxlIjoiLi4vLi4vc3JjL2NvbXBvbmVudHMvRHJvcGRvd24uanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuXG5pbXBvcnQgeyBMSUJfTkFNRSB9IGZyb20gJy4uL2NvbnN0YW50cyc7XG5pbXBvcnQgTm9EYXRhIGZyb20gJy4uL2NvbXBvbmVudHMvTm9EYXRhJztcbmltcG9ydCBJdGVtIGZyb20gJy4uL2NvbXBvbmVudHMvSXRlbSc7XG5cbmltcG9ydCB7IHZhbHVlRXhpc3RJblNlbGVjdGVkLCBoZXhUb1JHQkEsIGlzb21vcnBoaWNXaW5kb3cgfSBmcm9tICcuLi91dGlsJztcblxuY29uc3QgZHJvcGRvd25Qb3NpdGlvbiA9IChwcm9wcywgbWV0aG9kcykgPT4ge1xuICBjb25zdCBEcm9wZG93bkJvdW5kaW5nQ2xpZW50UmVjdCA9IG1ldGhvZHMuZ2V0U2VsZWN0UmVmKCkuZ2V0Qm91bmRpbmdDbGllbnRSZWN0KCk7XG4gIGNvbnN0IGRyb3Bkb3duSGVpZ2h0ID1cbiAgICBEcm9wZG93bkJvdW5kaW5nQ2xpZW50UmVjdC5ib3R0b20gK1xuICAgIHBhcnNlSW50KHByb3BzLmRyb3Bkb3duSGVpZ2h0LCAxMCkgK1xuICAgIHBhcnNlSW50KHByb3BzLmRyb3Bkb3duR2FwLCAxMCk7XG5cbiAgaWYgKHByb3BzLmRyb3Bkb3duUG9zaXRpb24gIT09ICdhdXRvJykge1xuICAgIHJldHVybiBwcm9wcy5kcm9wZG93blBvc2l0aW9uO1xuICB9XG5cbiAgaWYgKFxuICAgIGRyb3Bkb3duSGVpZ2h0ID4gaXNvbW9ycGhpY1dpbmRvdygpLmlubmVySGVpZ2h0ICYmXG4gICAgZHJvcGRvd25IZWlnaHQgPiBEcm9wZG93bkJvdW5kaW5nQ2xpZW50UmVjdC50b3BcbiAgKSB7XG4gICAgcmV0dXJuICd0b3AnO1xuICB9XG5cbiAgcmV0dXJuICdib3R0b20nO1xufTtcblxuY29uc3QgRHJvcGRvd24gPSAoeyBwcm9wcywgc3RhdGUsIG1ldGhvZHMgfSkgPT4gKFxuICA8RHJvcERvd25cbiAgICB0YWJJbmRleD1cIi0xXCJcbiAgICBhcmlhLWV4cGFuZGVkPVwidHJ1ZVwiXG4gICAgcm9sZT1cImxpc3RcIlxuICAgIGRyb3Bkb3duUG9zaXRpb249e2Ryb3Bkb3duUG9zaXRpb24ocHJvcHMsIG1ldGhvZHMpfVxuICAgIHNlbGVjdEJvdW5kcz17c3RhdGUuc2VsZWN0Qm91bmRzfVxuICAgIHBvcnRhbD17cHJvcHMucG9ydGFsfVxuICAgIGRyb3Bkb3duR2FwPXtwcm9wcy5kcm9wZG93bkdhcH1cbiAgICBkcm9wZG93bkhlaWdodD17cHJvcHMuZHJvcGRvd25IZWlnaHR9XG4gICAgY2xhc3NOYW1lPXtgJHtMSUJfTkFNRX0tZHJvcGRvd24gJHtMSUJfTkFNRX0tZHJvcGRvd24tcG9zaXRpb24tJHtkcm9wZG93blBvc2l0aW9uKFxuICAgICAgcHJvcHMsXG4gICAgICBtZXRob2RzXG4gICAgKX1gfT5cbiAgICB7cHJvcHMuZHJvcGRvd25SZW5kZXJlciA/IChcbiAgICAgIHByb3BzLmRyb3Bkb3duUmVuZGVyZXIoeyBwcm9wcywgc3RhdGUsIG1ldGhvZHMgfSlcbiAgICApIDogKFxuICAgICAgPFJlYWN0LkZyYWdtZW50PlxuICAgICAgICB7cHJvcHMuY3JlYXRlICYmXG4gICAgICAgICAgc3RhdGUuc2VhcmNoICYmXG4gICAgICAgICAgIXZhbHVlRXhpc3RJblNlbGVjdGVkKHN0YXRlLnNlYXJjaCwgWy4uLnN0YXRlLnZhbHVlcywgLi4ucHJvcHMub3B0aW9uc10sIHByb3BzKSAmJiAoXG4gICAgICAgICAgICA8QWRkTmV3XG4gICAgICAgICAgICAgIHJvbGU9XCJidXR0b25cIlxuICAgICAgICAgICAgICBjbGFzc05hbWU9e2Ake0xJQl9OQU1FfS1kcm9wZG93bi1hZGQtbmV3YH1cbiAgICAgICAgICAgICAgY29sb3I9e3Byb3BzLmNvbG9yfVxuICAgICAgICAgICAgICBvbkNsaWNrPXsoKSA9PiBtZXRob2RzLmNyZWF0ZU5ldyhzdGF0ZS5zZWFyY2gpfT5cbiAgICAgICAgICAgICAge3Byb3BzLmNyZWF0ZU5ld0xhYmVsLnJlcGxhY2UoJ3tzZWFyY2h9JywgYFwiJHtzdGF0ZS5zZWFyY2h9XCJgKX1cbiAgICAgICAgICAgIDwvQWRkTmV3PlxuICAgICAgICAgICl9XG4gICAgICAgIHtzdGF0ZS5zZWFyY2hSZXN1bHRzLmxlbmd0aCA9PT0gMCA/IChcbiAgICAgICAgICA8Tm9EYXRhIGNsYXNzTmFtZT17YCR7TElCX05BTUV9LW5vLWRhdGFgfSBzdGF0ZT17c3RhdGV9IHByb3BzPXtwcm9wc30gbWV0aG9kcz17bWV0aG9kc30gLz5cbiAgICAgICAgKSA6IChcbiAgICAgICAgICBzdGF0ZS5zZWFyY2hSZXN1bHRzLm1hcCgoaXRlbSwgaXRlbUluZGV4KSA9PiAoXG4gICAgICAgICAgICA8SXRlbVxuICAgICAgICAgICAgICBrZXk9e2l0ZW1bcHJvcHMudmFsdWVGaWVsZF0udG9TdHJpbmcoKX1cbiAgICAgICAgICAgICAgaXRlbT17aXRlbX1cbiAgICAgICAgICAgICAgaXRlbUluZGV4PXtpdGVtSW5kZXh9XG4gICAgICAgICAgICAgIHN0YXRlPXtzdGF0ZX1cbiAgICAgICAgICAgICAgcHJvcHM9e3Byb3BzfVxuICAgICAgICAgICAgICBtZXRob2RzPXttZXRob2RzfVxuICAgICAgICAgICAgLz5cbiAgICAgICAgICApKVxuICAgICAgICApfVxuXG4gICAgICAgIHtwcm9wcy5zZWxlY3RBbGwgJiYgcHJvcHMub3B0aW9ucyAmJiBwcm9wcy5tdWx0aSAmJiAoXG4gICAgICAgICAgPFNlbGVjdEFsbFxuICAgICAgICAgICAgcm9sZT1cImJ1dHRvblwiXG4gICAgICAgICAgICBjbGFzc05hbWU9e2Ake0xJQl9OQU1FfS1kcm9wZG93bi1zZWxlY3QtYWxsYH1cbiAgICAgICAgICAgIGNvbG9yPXtwcm9wcy5jb2xvcn1cbiAgICAgICAgICAgIG9uQ2xpY2s9eygpID0+IChtZXRob2RzLmFyZUFsbFNlbGVjdGVkKCkgPyBtZXRob2RzLmNsZWFyQWxsKCkgOiBtZXRob2RzLnNlbGVjdEFsbCgpKX0+XG4gICAgICAgICAgICB7bWV0aG9kcy5hcmVBbGxTZWxlY3RlZCgpID8gcHJvcHMuY2xlYXJBbGxMYWJlbCA6IHByb3BzLnNlbGVjdEFsbExhYmVsfVxuICAgICAgICAgIDwvU2VsZWN0QWxsPlxuICAgICAgICApfVxuICAgICAgPC9SZWFjdC5GcmFnbWVudD5cbiAgICApfVxuICA8L0Ryb3BEb3duPlxuKTtcblxuY29uc3QgRHJvcERvd24gPSBzdHlsZWQuZGl2YFxuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICR7KHsgc2VsZWN0Qm91bmRzLCBkcm9wZG93bkdhcCwgZHJvcGRvd25Qb3NpdGlvbiB9KSA9PlxuICAgIGRyb3Bkb3duUG9zaXRpb24gPT09ICd0b3AnXG4gICAgICA/IGBib3R0b206ICR7c2VsZWN0Qm91bmRzLmhlaWdodCArIDIgKyBkcm9wZG93bkdhcH1weGBcbiAgICAgIDogYHRvcDogJHtzZWxlY3RCb3VuZHMuaGVpZ2h0ICsgMiArIGRyb3Bkb3duR2FwfXB4YH07XG5cbiAgJHsoeyBzZWxlY3RCb3VuZHMsIGRyb3Bkb3duR2FwLCBkcm9wZG93blBvc2l0aW9uLCBwb3J0YWwgfSkgPT5cbiAgICBwb3J0YWxcbiAgICAgID8gYFxuICAgICAgcG9zaXRpb246IGZpeGVkO1xuICAgICAgJHtcbiAgICAgICAgZHJvcGRvd25Qb3NpdGlvbiA9PT0gJ2JvdHRvbSdcbiAgICAgICAgICA/IGB0b3A6ICR7c2VsZWN0Qm91bmRzLmJvdHRvbSArIGRyb3Bkb3duR2FwfXB4O2BcbiAgICAgICAgICA6IGBib3R0b206ICR7aXNvbW9ycGhpY1dpbmRvdygpLmlubmVySGVpZ2h0IC0gc2VsZWN0Qm91bmRzLnRvcCArIGRyb3Bkb3duR2FwfXB4O2BcbiAgICAgIH1cbiAgICAgIGxlZnQ6ICR7c2VsZWN0Qm91bmRzLmxlZnQgLSAxfXB4O2BcbiAgICAgIDogJ2xlZnQ6IC0xcHg7J307XG4gIGJvcmRlcjogMXB4IHNvbGlkICNjY2M7XG4gIHdpZHRoOiAkeyh7IHNlbGVjdEJvdW5kcyB9KSA9PiBzZWxlY3RCb3VuZHMud2lkdGh9cHg7XG4gIHBhZGRpbmc6IDA7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIGJhY2tncm91bmQ6ICNmZmY7XG4gIGJvcmRlci1yYWRpdXM6IDJweDtcbiAgYm94LXNoYWRvdzogMCAwIDEwcHggMCAkeygpID0+IGhleFRvUkdCQSgnIzAwMDAwMCcsIDAuMil9O1xuICBtYXgtaGVpZ2h0OiAkeyh7IGRyb3Bkb3duSGVpZ2h0IH0pID0+IGRyb3Bkb3duSGVpZ2h0fTtcbiAgb3ZlcmZsb3c6IGF1dG87XG4gIHotaW5kZXg6IDk7XG5cbiAgOmZvY3VzIHtcbiAgICBvdXRsaW5lOiBub25lO1xuICB9XG59XG5gO1xuXG5jb25zdCBBZGROZXcgPSBzdHlsZWQuZGl2YFxuICBjb2xvcjogJHsoeyBjb2xvciB9KSA9PiBjb2xvcn07XG4gIHBhZGRpbmc6IDVweCAxMHB4O1xuXG4gIDpob3ZlciB7XG4gICAgYmFja2dyb3VuZDogJHsoeyBjb2xvciB9KSA9PiBjb2xvciAmJiBoZXhUb1JHQkEoY29sb3IsIDAuMSl9O1xuICAgIG91dGxpbmU6IG5vbmU7XG4gICAgY3Vyc29yOiBwb2ludGVyO1xuICB9XG5gO1xuXG5jb25zdCBTZWxlY3RBbGwgPSBzdHlsZWQuZGl2YFxuICBjb2xvcjogJHsoeyBjb2xvciB9KSA9PiBjb2xvcn07XG4gIHBhZGRpbmc6IDVweCAxMHB4O1xuICBwb3NpdGlvbjogc3RpY2t5O1xuICBib3R0b206IDA7XG4gIG1hcmdpbjogMDtcbiAgb3BhY2l0eTogMTtcbiAgYmFja2dyb3VuZDogI2ZmZjtcbiAgYm94LXNoYWRvdzogMCAwIDEwcHggMCAkeygpID0+IGhleFRvUkdCQSgnIzAwMDAwMCcsIDAuMil9O1xuXG4gIDpob3ZlciB7XG4gICAgb3V0bGluZTogbm9uZTtcbiAgICBjdXJzb3I6IHBvaW50ZXI7XG4gIH1cbmA7XG5cbmV4cG9ydCBkZWZhdWx0IERyb3Bkb3duO1xuIl19 */")), h = u;
    t.default = h;
  }(W4)), W4;
}
var Y4 = {}, Zk;
function N7e() {
  return Zk || (Zk = 1, function(t) {
    t.__esModule = !0, t.default = void 0;
    var r = i(ho), e = i(te), n = /* @__PURE__ */ po();
    function i(l) {
      return l && l.__esModule ? l : { default: l };
    }
    var a = function(l) {
      var u = l.props;
      return u.loadingRenderer ? u.loadingRenderer({ props: u }) : /* @__PURE__ */ e.default.createElement(o, { className: n.LIB_NAME + "-loading", color: u.color });
    }, o = /* @__PURE__ */ (0, r.default)("div", process.env.NODE_ENV === "production" ? { target: "e1l5cpc30" } : { target: "e1l5cpc30", label: "LoadingComponent" })("@keyframes dual-ring-spin{0%{transform:rotate(0deg);}100%{transform:rotate(180deg);}}padding:0 5px;display:block;width:auto;height:auto;:after{content:' ';display:block;width:16px;height:16px;border-radius:50%;border-width:1px;border-style:solid;border-color:", function(l) {
      var u = l.color;
      return u;
    }, " transparent;animation:dual-ring-spin 0.7s ease-in-out infinite;margin:0 0 0 -10px;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21wb25lbnRzL0xvYWRpbmcuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBV21DIiwiZmlsZSI6Ii4uLy4uL3NyYy9jb21wb25lbnRzL0xvYWRpbmcuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgTElCX05BTUUgfSBmcm9tICcuLi9jb25zdGFudHMnO1xuXG5jb25zdCBMb2FkaW5nID0gKHsgcHJvcHMgfSkgPT5cbiAgcHJvcHMubG9hZGluZ1JlbmRlcmVyID8gKFxuICAgIHByb3BzLmxvYWRpbmdSZW5kZXJlcih7IHByb3BzIH0pXG4gICkgOiAoXG4gICAgPExvYWRpbmdDb21wb25lbnQgY2xhc3NOYW1lPXtgJHtMSUJfTkFNRX0tbG9hZGluZ2B9IGNvbG9yPXtwcm9wcy5jb2xvcn0gLz5cbiAgKTtcblxuY29uc3QgTG9hZGluZ0NvbXBvbmVudCA9IHN0eWxlZC5kaXZgXG4gIEBrZXlmcmFtZXMgZHVhbC1yaW5nLXNwaW4ge1xuICAgIDAlIHtcbiAgICAgIHRyYW5zZm9ybTogcm90YXRlKDBkZWcpO1xuICAgIH1cbiAgICAxMDAlIHtcbiAgICAgIHRyYW5zZm9ybTogcm90YXRlKDE4MGRlZyk7XG4gICAgfVxuICB9XG5cbiAgcGFkZGluZzogMCA1cHg7XG4gIGRpc3BsYXk6IGJsb2NrO1xuICB3aWR0aDogYXV0bztcbiAgaGVpZ2h0OiBhdXRvO1xuXG4gIDphZnRlciB7XG4gICAgY29udGVudDogJyAnO1xuICAgIGRpc3BsYXk6IGJsb2NrO1xuICAgIHdpZHRoOiAxNnB4O1xuICAgIGhlaWdodDogMTZweDtcbiAgICBib3JkZXItcmFkaXVzOiA1MCU7XG4gICAgYm9yZGVyLXdpZHRoOiAxcHg7XG4gICAgYm9yZGVyLXN0eWxlOiBzb2xpZDtcbiAgICBib3JkZXItY29sb3I6ICR7KHsgY29sb3IgfSkgPT4gY29sb3J9IHRyYW5zcGFyZW50O1xuICAgIGFuaW1hdGlvbjogZHVhbC1yaW5nLXNwaW4gMC43cyBlYXNlLWluLW91dCBpbmZpbml0ZTtcbiAgICBtYXJnaW46IDAgMCAwIC0xMHB4O1xuICB9XG5gO1xuXG5leHBvcnQgZGVmYXVsdCBMb2FkaW5nO1xuIl19 */")), s = a;
    t.default = s;
  }(Y4)), Y4;
}
var X4 = {}, jk;
function O7e() {
  return jk || (jk = 1, function(t) {
    t.__esModule = !0, t.default = void 0;
    var r = i(ho), e = i(te), n = /* @__PURE__ */ po();
    function i(u) {
      return u && u.__esModule ? u : { default: u };
    }
    function a() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    var o = function(u) {
      var c = u.props, d = u.state, f = u.methods;
      return c.clearRenderer ? c.clearRenderer({ props: c, state: d, methods: f }) : /* @__PURE__ */ e.default.createElement(s, { className: n.LIB_NAME + "-clear", tabIndex: "-1", onClick: function() {
        return f.clearAll();
      }, onKeyPress: function() {
        return f.clearAll();
      } }, "×");
    }, s = /* @__PURE__ */ (0, r.default)("div", process.env.NODE_ENV === "production" ? { target: "e11qlq5e0" } : { target: "e11qlq5e0", label: "ClearComponent" })(process.env.NODE_ENV === "production" ? { name: "992gsg", styles: "line-height:25px;margin:0 10px;cursor:pointer;:focus{outline:none;}:hover{color:tomato;}" } : { name: "992gsg", styles: "line-height:25px;margin:0 10px;cursor:pointer;:focus{outline:none;}:hover{color:tomato;}", map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21wb25lbnRzL0NsZWFyLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWlCaUMiLCJmaWxlIjoiLi4vLi4vc3JjL2NvbXBvbmVudHMvQ2xlYXIuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgTElCX05BTUUgfSBmcm9tICcuLi9jb25zdGFudHMnO1xuXG5jb25zdCBDbGVhciA9ICh7IHByb3BzLCBzdGF0ZSwgbWV0aG9kcyB9KSA9PlxuICBwcm9wcy5jbGVhclJlbmRlcmVyID8gKFxuICAgIHByb3BzLmNsZWFyUmVuZGVyZXIoeyBwcm9wcywgc3RhdGUsIG1ldGhvZHMgfSlcbiAgKSA6IChcbiAgICA8Q2xlYXJDb21wb25lbnRcbiAgICAgIGNsYXNzTmFtZT17YCR7TElCX05BTUV9LWNsZWFyYH1cbiAgICAgIHRhYkluZGV4PVwiLTFcIlxuICAgICAgb25DbGljaz17KCkgPT4gbWV0aG9kcy5jbGVhckFsbCgpfVxuICAgICAgb25LZXlQcmVzcz17KCkgPT4gbWV0aG9kcy5jbGVhckFsbCgpfT5cbiAgICAgICZ0aW1lcztcbiAgICA8L0NsZWFyQ29tcG9uZW50PlxuICApO1xuXG5jb25zdCBDbGVhckNvbXBvbmVudCA9IHN0eWxlZC5kaXZgXG4gIGxpbmUtaGVpZ2h0OiAyNXB4O1xuICBtYXJnaW46IDAgMTBweDtcbiAgY3Vyc29yOiBwb2ludGVyO1xuXG4gIDpmb2N1cyB7XG4gICAgb3V0bGluZTogbm9uZTtcbiAgfVxuXG4gIDpob3ZlciB7XG4gICAgY29sb3I6IHRvbWF0bztcbiAgfVxuYDtcblxuZXhwb3J0IGRlZmF1bHQgQ2xlYXI7XG4iXX0= */", toString: a }), l = o;
    t.default = l;
  }(X4)), X4;
}
var $4 = {}, Yk;
function V7e() {
  return Yk || (Yk = 1, function(t) {
    t.__esModule = !0, t.default = void 0;
    var r = i(ho), e = i(te), n = /* @__PURE__ */ po();
    function i(u) {
      return u && u.__esModule ? u : { default: u };
    }
    function a() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    var o = function(u) {
      var c = u.props, d = u.state, f = u.methods;
      return c.separatorRenderer ? c.separatorRenderer({ props: c, state: d, methods: f }) : /* @__PURE__ */ e.default.createElement(s, { className: n.LIB_NAME + "-separator" });
    }, s = /* @__PURE__ */ (0, r.default)("div", process.env.NODE_ENV === "production" ? { target: "e19h5j1v0" } : { target: "e19h5j1v0", label: "SeparatorComponent" })(process.env.NODE_ENV === "production" ? { name: "cmi1n0", styles: "border-left:1px solid #ccc;width:1px;height:25px;display:block" } : { name: "cmi1n0", styles: "border-left:1px solid #ccc;width:1px;height:25px;display:block", map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21wb25lbnRzL1NlcGFyYXRvci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFXcUMiLCJmaWxlIjoiLi4vLi4vc3JjL2NvbXBvbmVudHMvU2VwYXJhdG9yLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IExJQl9OQU1FIH0gZnJvbSAnLi4vY29uc3RhbnRzJztcblxuY29uc3QgU2VwYXJhdG9yID0gKHsgcHJvcHMsIHN0YXRlLCBtZXRob2RzIH0pID0+XG4gIHByb3BzLnNlcGFyYXRvclJlbmRlcmVyID8gKFxuICAgIHByb3BzLnNlcGFyYXRvclJlbmRlcmVyKHsgcHJvcHMsIHN0YXRlLCBtZXRob2RzIH0pXG4gICkgOiAoXG4gICAgPFNlcGFyYXRvckNvbXBvbmVudCBjbGFzc05hbWU9e2Ake0xJQl9OQU1FfS1zZXBhcmF0b3JgfSAvPlxuICApO1xuXG5jb25zdCBTZXBhcmF0b3JDb21wb25lbnQgPSBzdHlsZWQuZGl2YFxuICBib3JkZXItbGVmdDogMXB4IHNvbGlkICNjY2M7XG4gIHdpZHRoOiAxcHg7XG4gIGhlaWdodDogMjVweDtcbiAgZGlzcGxheTogYmxvY2s7XG5gO1xuXG5leHBvcnQgZGVmYXVsdCBTZXBhcmF0b3I7XG4iXX0= */", toString: a }), l = o;
    t.default = l;
  }($4)), $4;
}
var U4 = {}, Xk;
function G7e() {
  return Xk || (Xk = 1, function(t) {
    t.__esModule = !0, t.default = void 0;
    var r = i(ho), e = i(te), n = /* @__PURE__ */ po();
    function i(l) {
      return l && l.__esModule ? l : { default: l };
    }
    var a = function(l) {
      var u = l.props, c = l.state, d = l.methods;
      return /* @__PURE__ */ e.default.createElement(o, { tabIndex: "-1", onClick: function(h) {
        return d.dropDown(c.dropdown ? "close" : "open", h);
      }, dropdownOpen: c.dropdown, onKeyPress: function(h) {
        return d.dropDown("toggle", h);
      }, onKeyDown: function(h) {
        return d.dropDown("toggle", h);
      }, className: n.LIB_NAME + "-dropdown-handle", rotate: u.dropdownHandleRenderer ? 0 : 1, color: u.color }, u.dropdownHandleRenderer ? u.dropdownHandleRenderer({ props: u, state: c, methods: d }) : /* @__PURE__ */ e.default.createElement("svg", { fill: "currentColor", viewBox: "0 0 40 40" }, /* @__PURE__ */ e.default.createElement("path", { d: "M31 26.4q0 .3-.2.5l-1.1 1.2q-.3.2-.6.2t-.5-.2l-8.7-8.8-8.8 8.8q-.2.2-.5.2t-.5-.2l-1.2-1.2q-.2-.2-.2-.5t.2-.5l10.4-10.4q.3-.2.6-.2t.5.2l10.4 10.4q.2.2.2.5z" })));
    }, o = /* @__PURE__ */ (0, r.default)("div", process.env.NODE_ENV === "production" ? { target: "e1vudypg0" } : { target: "e1vudypg0", label: "DropdownHandleComponent" })("text-align:center;", function(l) {
      var u = l.dropdownOpen, c = l.rotate;
      return u ? `
      pointer-events: all;
      ` + (c ? "transform: rotate(0deg);margin: 0px 0 -3px 5px;" : "") + `
      ` : `
      pointer-events: none;
      ` + (c ? "margin: 0 0 0 5px;transform: rotate(180deg);" : "") + `
      `;
    }, ";cursor:pointer;svg{width:16px;height:16px;}:hover{path{stroke:", function(l) {
      var u = l.color;
      return u;
    }, ";}}:focus{outline:none;path{stroke:", function(l) {
      var u = l.color;
      return u;
    }, ";}}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")), s = a;
    t.default = s;
  }(U4)), U4;
}
var $k;
function B7e() {
  return $k || ($k = 1, function(t) {
    t.__esModule = !0, t.default = t.Select = void 0;
    var r = v(ho), e = p(te), n = v(RP), i = v(/* @__PURE__ */ A7e()), a = v(/* @__PURE__ */ L7e()), o = v(/* @__PURE__ */ P7e()), s = v(/* @__PURE__ */ N7e()), l = v(/* @__PURE__ */ O7e()), u = v(/* @__PURE__ */ V7e()), c = v(/* @__PURE__ */ G7e()), d = /* @__PURE__ */ Ih(), f = /* @__PURE__ */ po();
    v(/* @__PURE__ */ QZ());
    function h(x) {
      if (typeof WeakMap != "function") return null;
      var I = /* @__PURE__ */ new WeakMap(), D = /* @__PURE__ */ new WeakMap();
      return (h = function(T) {
        return T ? D : I;
      })(x);
    }
    function p(x, I) {
      if (x && x.__esModule) return x;
      if (x === null || typeof x != "object" && typeof x != "function") return { default: x };
      var D = h(I);
      if (D && D.has(x)) return D.get(x);
      var T = {}, A = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var M in x) if (M != "default" && Object.prototype.hasOwnProperty.call(x, M)) {
        var R = A ? Object.getOwnPropertyDescriptor(x, M) : null;
        R && (R.get || R.set) ? Object.defineProperty(T, M, R) : T[M] = x[M];
      }
      return T.default = x, D && D.set(x, T), T;
    }
    function v(x) {
      return x && x.__esModule ? x : { default: x };
    }
    function g() {
      return g = Object.assign ? Object.assign.bind() : function(x) {
        for (var I, D = 1; D < arguments.length; D++) for (var T in I = arguments[D], I) Object.prototype.hasOwnProperty.call(I, T) && (x[T] = I[T]);
        return x;
      }, g.apply(this, arguments);
    }
    function m(x) {
      if (x === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return x;
    }
    function y(x, I) {
      x.prototype = Object.create(I.prototype), x.prototype.constructor = x, b(x, I);
    }
    function b(x, I) {
      return b = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(D, T) {
        return D.__proto__ = T, D;
      }, b(x, I);
    }
    var C = /* @__PURE__ */ function(x) {
      function I(T) {
        var A;
        return A = x.call(this, T) || this, A.onDropdownClose = function() {
          A.setState({ cursor: null }), A.props.onDropdownClose();
        }, A.onScroll = function() {
          A.props.closeOnScroll && A.dropDown("close"), A.updateSelectBounds();
        }, A.updateSelectBounds = function() {
          return A.select.current && A.setState({ selectBounds: A.select.current.getBoundingClientRect() });
        }, A.getSelectBounds = function() {
          return A.state.selectBounds;
        }, A.dropDown = function(M, R, E) {
          M === void 0 && (M = "toggle"), E === void 0 && (E = !1);
          var k = R && R.target || R && R.srcElement;
          return A.props.onDropdownCloseRequest !== void 0 && A.state.dropdown && E === !1 && M === "close" ? A.props.onDropdownCloseRequest({ props: A.props, methods: A.methods, state: A.state, close: function() {
            return A.dropDown("close", null, !0);
          } }) : A.props.portal && !A.props.closeOnScroll && !A.props.closeOnSelect && R && k && k.offsetParent && k.offsetParent.classList.contains("react-dropdown-select-dropdown") ? void 0 : A.props.keepOpen ? A.setState({ dropdown: !0 }) : M === "close" && A.state.dropdown ? (A.select.current.blur(), A.setState({ dropdown: !1, search: A.props.clearOnBlur ? "" : A.state.search, searchResults: A.props.options })) : M !== "open" || A.state.dropdown ? M === "toggle" && (A.select.current.focus(), A.setState({ dropdown: !A.state.dropdown })) : A.setState({ dropdown: !0 });
        }, A.getSelectRef = function() {
          return A.select.current;
        }, A.addItem = function(M) {
          if (A.props.multi) {
            if ((0, d.valueExistInSelected)((0, d.getByPath)(M, A.props.valueField), A.state.values, A.props)) return A.removeItem(null, M, !1);
            A.setState({ values: [].concat(A.state.values, [M]) });
          } else A.setState({ values: [M], dropdown: !1 });
          return A.props.clearOnSelect && A.setState({ search: "" }, function() {
            A.setState({ searchResults: A.searchResults() });
          }), !0;
        }, A.removeItem = function(M, R, E) {
          E === void 0 && (E = !1), M && E && (M.preventDefault(), M.stopPropagation(), A.dropDown("close")), A.setState({ values: A.state.values.filter(function(k) {
            return (0, d.getByPath)(k, A.props.valueField) !== (0, d.getByPath)(R, A.props.valueField);
          }) });
        }, A.setSearch = function(M) {
          A.setState({ cursor: null }), A.setState({ search: M.target.value }, function() {
            A.setState({ searchResults: A.searchResults() });
          });
        }, A.getInputSize = function() {
          return A.state.search ? A.state.search.length : 0 < A.state.values.length ? A.props.addPlaceholder.length : A.props.placeholder.length;
        }, A.toggleSelectAll = function() {
          return A.setState({ values: A.state.values.length === 0 ? A.selectAll() : A.clearAll() });
        }, A.clearAll = function() {
          A.props.onClearAll(), A.setState({ values: [] });
        }, A.selectAll = function(M) {
          M === void 0 && (M = []), A.props.onSelectAll();
          var R = 0 < M.length ? M : A.props.options.filter(function(E) {
            return !E.disabled;
          });
          A.setState({ values: R });
        }, A.isSelected = function(M) {
          return !!A.state.values.find(function(R) {
            return (0, d.getByPath)(R, A.props.valueField) === (0, d.getByPath)(M, A.props.valueField);
          });
        }, A.areAllSelected = function() {
          return A.state.values.length === A.props.options.filter(function(M) {
            return !M.disabled;
          }).length;
        }, A.safeString = function(M) {
          return M.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        }, A.sortBy = function() {
          var M = A.props, R = M.sortBy, E = M.options;
          return R && E.sort(function(k, P) {
            return (0, d.getProp)(k, R) < (0, d.getProp)(P, R) ? -1 : (0, d.getProp)(k, R) > (0, d.getProp)(P, R) ? 1 : 0;
          }), E;
        }, A.searchFn = function(M) {
          var R = M.state, E = M.methods, k = new RegExp(E.safeString(R.search), "i");
          return E.sortBy().filter(function(P) {
            return k.test((0, d.getByPath)(P, A.props.searchBy) || (0, d.getByPath)(P, A.props.valueField));
          });
        }, A.searchResults = function() {
          var M = { state: A.state, props: A.props, methods: A.methods };
          return A.props.searchFn(M) || A.searchFn(M);
        }, A.activeCursorItem = function(M) {
          return A.setState({ activeCursorItem: M });
        }, A.handleKeyDown = function(M) {
          var R = { event: M, state: A.state, props: A.props, methods: A.methods, setState: A.setState.bind(m(A)) };
          return A.props.handleKeyDownFn(R) || A.handleKeyDownFn(R);
        }, A.handleKeyDownFn = function(M) {
          var R = M.event, E = M.state, k = M.props, P = M.methods, N = M.setState, O = E.cursor, W = E.searchResults, V = R.key === "Escape", B = R.key === "Enter", Z = R.key === "ArrowUp", q = R.key === "ArrowDown", z = R.key === "Backspace", U = R.key === "Tab" && !R.shiftKey, J = R.shiftKey && R.key === "Tab";
          if (q && !E.dropdown) return R.preventDefault(), A.dropDown("open"), N({ cursor: 0 });
          if ((q || U && E.dropdown) && O === null) return N({ cursor: 0 });
          if ((Z || q || J && E.dropdown || U && E.dropdown) && R.preventDefault(), V && A.dropDown("close"), B) {
            var K = W[O];
            if (K && !K.disabled) {
              if (k.create && (0, d.valueExistInSelected)(E.search, E.values, k)) return null;
              P.addItem(K);
            }
          }
          return (q || U && E.dropdown) && W.length === O ? N({ cursor: 0 }) : ((q || U && E.dropdown) && N(function(j) {
            return { cursor: j.cursor + 1 };
          }), (Z || J && E.dropdown) && 0 < O && N(function(j) {
            return { cursor: j.cursor - 1 };
          }), (Z || J && E.dropdown) && O === 0 && N({ cursor: W.length }), void (z && k.backspaceDelete && A.getInputSize() === 0 && A.setState({ values: A.state.values.slice(0, -1) })));
        }, A.renderDropdown = function() {
          return A.props.portal ? /* @__PURE__ */ n.default.createPortal(/* @__PURE__ */ e.default.createElement(o.default, { props: A.props, state: A.state, methods: A.methods }), A.dropdownRoot) : /* @__PURE__ */ e.default.createElement(o.default, { props: A.props, state: A.state, methods: A.methods });
        }, A.createNew = function(M) {
          var R, E = (R = {}, R[A.props.labelField] = M, R[A.props.valueField] = M, R);
          A.addItem(E), A.props.onCreateNew(E), A.setState({ search: "" });
        }, A.state = { dropdown: !1, values: T.values, search: "", selectBounds: {}, cursor: null, searchResults: T.options }, A.methods = { activeCursorItem: A.activeCursorItem, addItem: A.addItem, areAllSelected: A.areAllSelected, clearAll: A.clearAll, createNew: A.createNew, dropDown: A.dropDown, getInputSize: A.getInputSize, getSelectBounds: A.getSelectBounds, getSelectRef: A.getSelectRef, handleKeyDown: A.handleKeyDown, isSelected: A.isSelected, removeItem: A.removeItem, safeString: A.safeString, searchResults: A.searchResults, selectAll: A.selectAll, setSearch: A.setSearch, sortBy: A.sortBy, toggleSelectAll: A.toggleSelectAll }, A.select = /* @__PURE__ */ e.default.createRef(), A.dropdownRoot = typeof document < "u" && document.createElement("div"), A;
      }
      y(I, x);
      var D = I.prototype;
      return D.componentDidMount = function() {
        this.props.portal && this.props.portal.appendChild(this.dropdownRoot), (0, d.isomorphicWindow)().addEventListener("resize", (0, d.debounce)(this.updateSelectBounds)), (0, d.isomorphicWindow)().addEventListener("scroll", (0, d.debounce)(this.onScroll)), this.dropDown("close"), this.select && this.updateSelectBounds(), this.props.defaultMenuIsOpen && this.dropDown("open");
      }, D.componentDidUpdate = function(A, M) {
        var R = this;
        !this.props.compareValuesFunc(A.values, this.props.values) && this.props.compareValuesFunc(A.values, M.values) && (this.setState({ values: this.props.values }, function() {
          R.props.onChange(R.state.values);
        }), this.updateSelectBounds()), A.options !== this.props.options && this.setState({ searchResults: this.searchResults() }), M.values !== this.state.values && (this.props.onChange(this.state.values), this.updateSelectBounds()), M.search !== this.state.search && this.updateSelectBounds(), M.values !== this.state.values && this.props.closeOnSelect && this.dropDown("close"), A.multi !== this.props.multi && this.updateSelectBounds(), M.dropdown && M.dropdown !== this.state.dropdown && this.onDropdownClose(), M.dropdown || M.dropdown === this.state.dropdown || this.props.onDropdownOpen();
      }, D.componentWillUnmount = function() {
        this.props.portal && this.props.portal.removeChild(this.dropdownRoot), (0, d.isomorphicWindow)().removeEventListener("resize", (0, d.debounce)(this.updateSelectBounds, this.props.debounceDelay)), (0, d.isomorphicWindow)().removeEventListener("scroll", (0, d.debounce)(this.onScroll, this.props.debounceDelay));
      }, D.render = function() {
        var A = this;
        return /* @__PURE__ */ e.default.createElement(i.default, { onClickOutside: function(R) {
          return A.dropDown("close", R);
        } }, /* @__PURE__ */ e.default.createElement(w, g({ onKeyDown: this.handleKeyDown, "aria-label": "Dropdown select", "aria-expanded": this.state.dropdown, onClick: function(R) {
          return A.dropDown("open", R);
        }, tabIndex: this.props.disabled ? "-1" : "0", direction: this.props.direction, style: this.props.style, ref: this.select, disabled: this.props.disabled, className: f.LIB_NAME + " " + this.props.className, color: this.props.color }, this.props.additionalProps), /* @__PURE__ */ e.default.createElement(a.default, { props: this.props, state: this.state, methods: this.methods }), (this.props.name || this.props.required) && /* @__PURE__ */ e.default.createElement("input", { tabIndex: -1, style: { opacity: 0, width: 0, position: "absolute" }, name: this.props.name, required: this.props.required, pattern: this.props.pattern, defaultValue: this.state.values.map(function(M) {
          return M[A.props.labelField];
        }).toString() || [], disabled: this.props.disabled }), this.props.loading && /* @__PURE__ */ e.default.createElement(s.default, { props: this.props }), this.props.clearable && /* @__PURE__ */ e.default.createElement(l.default, { props: this.props, state: this.state, methods: this.methods }), this.props.separator && /* @__PURE__ */ e.default.createElement(u.default, { props: this.props, state: this.state, methods: this.methods }), this.props.dropdownHandle && /* @__PURE__ */ e.default.createElement(c.default, { onClick: function() {
          return A.select.current.focus();
        }, props: this.props, state: this.state, methods: this.methods }), this.state.dropdown && !this.props.disabled && this.renderDropdown()));
      }, I;
    }(e.Component);
    t.Select = C, C.defaultProps = { addPlaceholder: "", additionalProps: null, autoFocus: !1, backspaceDelete: !0, clearAllLabel: "Clear all", clearOnBlur: !0, clearOnSelect: !0, clearable: !1, closeOnScroll: !1, closeOnSelect: !1, closeOnClickInput: !1, color: "#0074D9", compareValuesFunc: d.isEqual, create: !1, createNewLabel: "add {search}", debounceDelay: 0, direction: "ltr", disabled: !1, disabledLabel: "disabled", dropdownGap: 5, dropdownHandle: !0, dropdownHeight: "300px", dropdownPosition: "bottom", handleKeyDownFn: function() {
    }, keepOpen: !1, keepSelectedInList: !0, labelField: "label", loading: !1, multi: !1, name: null, noDataLabel: "No data", onChange: function() {
    }, onClearAll: function() {
    }, onCreateNew: function() {
    }, onDropdownClose: function() {
    }, onDropdownCloseRequest: void 0, onDropdownOpen: function() {
    }, onSelectAll: function() {
    }, options: [], pattern: void 0, placeholder: "Select...", portal: null, required: !1, searchBy: "label", searchFn: function() {
    }, searchable: !0, selectAll: !1, selectAllLabel: "Select all", separator: !1, sortBy: null, valueField: "value", values: [], defaultMenuIsOpen: !1 };
    var w = /* @__PURE__ */ (0, r.default)("div", process.env.NODE_ENV === "production" ? { target: "e1gzf2xs0" } : { target: "e1gzf2xs0", label: "ReactDropdownSelect" })("box-sizing:border-box;position:relative;display:flex;border:1px solid #ccc;width:100%;border-radius:2px;padding:2px 5px;flex-direction:row;direction:", function(x) {
      var I = x.direction;
      return I;
    }, ";align-items:center;cursor:pointer;min-height:36px;", function(x) {
      var I = x.disabled;
      return I ? "cursor: not-allowed;pointer-events: none;opacity: 0.3;" : "pointer-events: all;";
    }, " :hover,:focus-within{border-color:", function(x) {
      var I = x.color;
      return I;
    }, ";}:focus,:focus-within{outline:0;box-shadow:0 0 0 3px ", function(x) {
      var I = x.color;
      return (0, d.hexToRGBA)(I, 0.2);
    }, ";}*{box-sizing:border-box;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")), _ = C;
    t.default = _;
  }(A4)), A4;
}
var F7e = /* @__PURE__ */ B7e();
const ej = /* @__PURE__ */ Yy(F7e), d5 = (t) => /* @__PURE__ */ $.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ $.createElement("path", { d: "M4 10.4714C4 6.90319 6.90319 4 10.4714 4C14.0395 4 16.9427 6.90319 16.9427 10.4714C16.9427 11.9473 16.448 13.3016 15.6128 14.3882L19.5783 18.3781C19.7486 18.5484 19.8459 18.7836 19.8459 19.0431C19.8459 19.5864 19.4648 20 18.9133 20C18.6538 20 18.4105 19.9108 18.224 19.7243L14.2342 15.7263C13.1718 16.4886 11.8824 16.9427 10.4714 16.9427C6.90319 16.9427 4 14.0395 4 10.4714ZM5.38672 10.4714C5.38672 13.2772 7.66548 15.556 10.4714 15.556C13.2772 15.556 15.556 13.2772 15.556 10.4714C15.556 7.66548 13.2772 5.38672 10.4714 5.38672C7.66548 5.38672 5.38672 7.66548 5.38672 10.4714Z", fill: "#395278" })), W8e = (t) => {
  const {
    value: r,
    onChange: e,
    options: n,
    isMultiple: i = !1,
    loading: a = !1,
    keepOpen: o = !1,
    placeholder: s = "Select...",
    className: l = "",
    containerClassName: u,
    formLabel: c,
    formSubLabel: d,
    inputHelpBlock: f,
    isRequired: h = !1,
    hasError: p = !1,
    errorMessage: v = "",
    withSearch: g = !0,
    withCheckbox: m = !1,
    onSearch: y,
    create: b = !1,
    disabled: C = !1,
    tooltip: w,
    itemRenderer: _,
    additionalItems: x,
    additionalSearchFilterRenderer: I
  } = t, D = ui(), T = ({ props: A, state: M, methods: R }) => {
    const E = new RegExp(M.search, "i");
    return /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
      (g === !0 || I !== void 0) && /* @__PURE__ */ S.jsxs("div", { className: "theme-select-header-filter", children: [
        g && /* @__PURE__ */ S.jsxs("div", { className: "theme-select-search-wrapper", children: [
          /* @__PURE__ */ S.jsx(
            "input",
            {
              type: "text",
              value: M.search,
              onChange: R.setSearch,
              className: "theme-form-control",
              placeholder: "Search",
              autoComplete: "off",
              autoFocus: !0
            }
          ),
          /* @__PURE__ */ S.jsx(d5, { className: "theme-select-search-icon" })
        ] }),
        I && I()
      ] }),
      A.options.filter(
        (k) => E.test(k[A.searchBy] || k.label)
      ).map((k) => {
        var N;
        const P = r.find(
          (O) => O.value === k.value
        );
        return k.value === "all" ? /* @__PURE__ */ S.jsx(
          "span",
          {
            onClick: () => {
              R.selectAll(
                A.options.filter(
                  (O) => O.value !== "all"
                )
              );
            },
            className: `react-dropdown-select-item ${k.disabled ? "react-dropdown-select-item-disabled" : ""} ${M.values.find(
              (O) => O.value === k.value.toString()
            ) ? "react-dropdown-select-item-selected" : ""}`,
            children: (N = k.other) == null ? void 0 : N.label
          },
          k.value
        ) : /* @__PURE__ */ S.jsxs(
          "span",
          {
            onClick: () => {
              (k.disabled === void 0 || !k.disabled) && (P ? R.removeItem(null, k, !1) : R.addItem(k));
            },
            className: `react-dropdown-select-item ${k.disabled ? "react-dropdown-select-item-disabled" : ""} ${M.values.find(
              (O) => O.value === k.value.toString()
            ) ? "react-dropdown-select-item-selected" : ""}`,
            children: [
              m && i && /* @__PURE__ */ S.jsx(
                s5,
                {
                  name: `${D}-cb-${k.value}`,
                  value: P !== void 0 ? k.value : ";",
                  checkboxValues: [
                    {
                      label: "",
                      value: P !== void 0 ? k.value : ""
                    }
                  ]
                }
              ),
              _ === void 0 && k.label,
              _ && _(k)
            ]
          },
          k.value
        );
      }),
      x && x.map(
        (k, P) => /* @__PURE__ */ S.jsx(
          "span",
          {
            className: "react-dropdown-select-item",
            onClick: () => k.onClick && k.onClick(),
            children: k.label()
          },
          `${D}-added-option-${P}`
        )
      )
    ] });
  };
  return /* @__PURE__ */ S.jsxs(
    "div",
    {
      className: `${g ? "theme-select-custom-search" : ""} ${u !== void 0 ? u : ""}`,
      children: [
        c && /* @__PURE__ */ S.jsxs("label", { className: "theme-form-input-label", children: [
          c,
          " ",
          h && /* @__PURE__ */ S.jsx("span", { children: "*" }),
          " ",
          w && /* @__PURE__ */ S.jsx(S.Fragment, { children: w.onClick !== void 0 ? /* @__PURE__ */ S.jsx(
            Dr,
            {
              onClick: () => w.onClick && w.onClick()
            }
          ) : /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
            /* @__PURE__ */ S.jsx(
              Dr,
              {
                "data-tooltip-id": `${D}-tooltip`,
                "data-tooltip-html": w.content !== void 0 ? w.content : ""
              }
            ),
            /* @__PURE__ */ S.jsx(
              Si,
              {
                id: `${D}-tooltip`,
                className: "theme-tooltip"
              }
            )
          ] }) })
        ] }),
        d && /* @__PURE__ */ S.jsx("label", { className: "theme-form-sublabel", children: d }),
        /* @__PURE__ */ S.jsxs("div", { className: "theme-select-input-wrapper", children: [
          s && r.length <= 0 && /* @__PURE__ */ S.jsx("span", { className: "theme-select-placeholder", children: s }),
          /* @__PURE__ */ S.jsx(
            ej,
            {
              options: n,
              className: `theme-select-container ${m ? "theme-select-checkbox" : ""} ${p && "theme-form-control-has-error"} ${l}`,
              values: r,
              onChange: e,
              placeholder: s,
              multi: i,
              loading: a,
              disabled: C,
              create: b,
              keepOpen: o,
              handleKeyDownFn: (A) => {
                y !== void 0 && y(A.event.target.value);
              },
              dropdownRenderer: T,
              color: "#1ea8e7"
            }
          )
        ] }),
        f && /* @__PURE__ */ S.jsx("span", { className: "theme-form-helpblock", children: f }),
        p && /* @__PURE__ */ S.jsx("div", { className: "theme-font-sm color-theme-red-500 theme-form-error-message", children: v })
      ]
    }
  );
}, Z8e = (t) => {
  const {
    name: r,
    defaultValue: e,
    options: n,
    isMultiple: i = !1,
    loading: a = !1,
    keepOpen: o = !1,
    placeholder: s = "Select...",
    className: l = "",
    containerClassName: u,
    formLabel: c,
    formSubLabel: d,
    inputHelpBlock: f,
    isRequired: h = !1,
    withSearch: p = !0,
    withCheckbox: v = !1,
    onSearch: g,
    create: m = !1,
    disabled: y = !1,
    tooltip: b,
    rules: C,
    control: w,
    errors: _,
    itemRenderer: x,
    additionalItems: I,
    additionalSearchFilterRenderer: D
  } = t, T = ui(), A = ({ props: M, state: R, methods: E }, k) => {
    const P = new RegExp(R.search, "i");
    return /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
      (p === !0 || D !== void 0) && /* @__PURE__ */ S.jsxs("div", { className: "theme-select-header-filter", children: [
        p && /* @__PURE__ */ S.jsxs("div", { className: "theme-select-search-wrapper", children: [
          /* @__PURE__ */ S.jsx(
            "input",
            {
              type: "text",
              value: R.search,
              onChange: E.setSearch,
              className: "theme-form-control",
              placeholder: "Search",
              autoComplete: "off",
              autoFocus: !0
            }
          ),
          /* @__PURE__ */ S.jsx(d5, { className: "theme-select-search-icon" })
        ] }),
        D && D()
      ] }),
      M.options.filter(
        (N) => P.test(N[M.searchBy] || N.label)
      ).map((N) => {
        var W;
        const O = k.find(
          (V) => V.value === N.value
        );
        return N.value === "all" ? /* @__PURE__ */ S.jsx(
          "span",
          {
            onClick: () => {
              E.selectAll(
                M.options.filter(
                  (V) => V.value !== "all"
                )
              );
            },
            className: `react-dropdown-select-item ${N.disabled ? "react-dropdown-select-item-disabled" : ""} ${R.values.find(
              (V) => V.value === N.value.toString()
            ) ? "react-dropdown-select-item-selected" : ""}`,
            children: (W = N.other) == null ? void 0 : W.label
          },
          N.value
        ) : /* @__PURE__ */ S.jsxs(
          "span",
          {
            onClick: () => {
              (N.disabled === void 0 || !N.disabled) && (O ? E.removeItem(null, N, !1) : E.addItem(N));
            },
            className: `react-dropdown-select-item ${N.disabled ? "react-dropdown-select-item-disabled" : ""} ${R.values.find(
              (V) => V.value === N.value.toString()
            ) ? "react-dropdown-select-item-selected" : ""}`,
            children: [
              v && i && /* @__PURE__ */ S.jsx(
                s5,
                {
                  name: `${T}-cb-${N.value}`,
                  value: O !== void 0 ? N.value : ";",
                  checkboxValues: [
                    {
                      label: "",
                      value: O !== void 0 ? N.value : ""
                    }
                  ]
                }
              ),
              x === void 0 && N.label,
              x && x(N)
            ]
          },
          N.value
        );
      }),
      I && I.map(
        (N, O) => /* @__PURE__ */ S.jsx(
          "span",
          {
            className: "react-dropdown-select-item",
            onClick: () => N.onClick && N.onClick(),
            children: N.label()
          },
          `${T}-added-option-${O}`
        )
      )
    ] });
  };
  return /* @__PURE__ */ S.jsxs(
    "div",
    {
      className: `${u !== void 0 ? u : ""}`,
      children: [
        c && /* @__PURE__ */ S.jsxs("label", { className: "theme-form-input-label", children: [
          c,
          " ",
          h && /* @__PURE__ */ S.jsx("span", { children: "*" }),
          " ",
          b && /* @__PURE__ */ S.jsx(S.Fragment, { children: b.onClick !== void 0 ? /* @__PURE__ */ S.jsx(
            Dr,
            {
              onClick: () => b.onClick && b.onClick()
            }
          ) : /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
            /* @__PURE__ */ S.jsx(
              Dr,
              {
                "data-tooltip-id": `${r}-tooltip`,
                "data-tooltip-html": b.content !== void 0 ? b.content : ""
              }
            ),
            /* @__PURE__ */ S.jsx(Si, { id: `${r}-tooltip`, className: "theme-tooltip" })
          ] }) })
        ] }),
        d && /* @__PURE__ */ S.jsx("label", { className: "theme-form-sublabel", children: d }),
        /* @__PURE__ */ S.jsx(
          mu,
          {
            name: r,
            control: w,
            defaultValue: e,
            rules: C || {},
            render: ({ field: { onChange: M, value: R } }) => /* @__PURE__ */ S.jsxs("div", { className: "theme-select-input-wrapper", children: [
              s && R.length <= 0 && /* @__PURE__ */ S.jsx("span", { className: "theme-select-placeholder", children: s }),
              /* @__PURE__ */ S.jsx(
                ej,
                {
                  options: n,
                  className: `theme-select-container ${l}`,
                  values: R,
                  onChange: M,
                  placeholder: s,
                  multi: i,
                  loading: a,
                  disabled: y,
                  create: m,
                  keepOpen: o,
                  handleKeyDownFn: (E) => {
                    g !== void 0 && g(E.event.target.value);
                  },
                  dropdownRenderer: (E) => A(E, R),
                  color: "#1ea8e7"
                }
              )
            ] })
          }
        ),
        /* @__PURE__ */ S.jsx(
          yu,
          {
            errors: _,
            name: r,
            render: ({ message: M }) => /* @__PURE__ */ S.jsx("div", { className: "theme-font-sm color-theme-red-500 theme-form-error-message", children: M })
          }
        ),
        f && /* @__PURE__ */ S.jsx("span", { className: "theme-form-helpblock", children: f })
      ]
    }
  );
}, tj = (t) => /* @__PURE__ */ $.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "#395278", viewBox: "0 0 40 40", ...t }, /* @__PURE__ */ $.createElement("path", { d: "M31 26.4q0 .3-.2.5l-1.1 1.2q-.3.2-.6.2t-.5-.2l-8.7-8.8-8.8 8.8q-.2.2-.5.2t-.5-.2l-1.2-1.2q-.2-.2-.2-.5t.2-.5l10.4-10.4q.3-.2.6-.2t.5.2l10.4 10.4q.2.2.2.5z" })), Oy = (t) => /* @__PURE__ */ $.createElement("svg", { width: 25, height: 24, viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ $.createElement("path", { d: "M16.9478 12.0498C16.9478 12.2822 16.8657 12.4805 16.6811 12.6582L11.3462 17.874C11.1957 18.0244 11.011 18.0996 10.7922 18.0996C10.3476 18.0996 9.99194 17.7578 9.99194 17.3066C9.99194 17.0879 10.0877 16.8896 10.2313 16.7393L15.0464 12.0498L10.2313 7.36035C10.0809 7.20312 9.99194 7.00488 9.99194 6.78613C9.99194 6.3418 10.3476 6 10.7922 6C11.011 6 11.1957 6.0752 11.3462 6.22559L16.6811 11.4414C16.8589 11.6191 16.9478 11.8174 16.9478 12.0498Z", fill: "#395278" })), rj = (t) => /* @__PURE__ */ $.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ $.createElement("path", { d: "M3.4497 12.5461C3.11316 12.2154 3.12476 11.6294 3.43809 11.316L6.75703 7.9971L3.43809 4.68977C3.12476 4.37064 3.11316 3.7904 3.4497 3.45387C3.78623 3.11153 4.37227 3.12314 4.68559 3.44226L7.99873 6.7554L11.3119 3.44226C11.6368 3.11733 12.2054 3.11733 12.542 3.45387C12.8843 3.7904 12.8843 4.35903 12.5536 4.68977L9.24623 7.9971L12.5536 11.3102C12.8843 11.641 12.8785 12.2038 12.542 12.5461C12.2112 12.8827 11.6368 12.8827 11.3119 12.5577L7.99873 9.2446L4.68559 12.5577C4.37227 12.8769 3.79203 12.8827 3.4497 12.5461Z", fill: "#395278" })), l8 = (t, r, e = 0, n = null) => {
  for (const i of t)
    if (i.value !== void 0) {
      if (typeof i.value != "string" && (i.value = i.value.toString()), i.value === r)
        return { options: t, depth: e, previousItem: n };
      if (i.children !== void 0) {
        const a = l8(
          i.children,
          r,
          e + 1,
          i
        );
        if (a)
          return a;
      }
    }
  return null;
}, u8 = (t, r) => t.children ? t.children.every(
  (e) => r.includes(e.value) && (e.children ? u8(e, r) : !0)
) : !1, c8 = (t, r) => t.children ? t.children.some(
  (e) => r.includes(e.value) || c8(e, r)
) : !1, d8 = (t) => {
  var n;
  let r = [], e = [];
  return r.push(t.value), e.push(t), t.children && ((n = t.children) == null || n.forEach((i) => {
    const a = d8(i);
    r = [...r, ...a.values], e = [...e, ...a.options];
  })), { values: r, options: e };
}, nj = (t, r = 5) => t.length <= r ? t.join(", ") : t.slice(0, r - 1).join(", ") + "...", ij = (t, r) => {
  const e = [...r];
  for (; e.length; ) {
    const n = e.shift();
    if (n) {
      if (n.value === t)
        return n;
      n.children && e.push(...n.children);
    }
  }
  return null;
}, j8e = (t) => {
  const {
    value: r,
    options: e,
    onSelected: n,
    isMultiple: i = !1,
    defaultValue: a = "",
    placeholder: o = "Select...",
    className: s = "",
    formLabel: l,
    formSubLabel: u,
    inputHelpBlock: c,
    withSearch: d = !0,
    isRequired: f = !1,
    containerClassName: h,
    disabled: p = !1,
    defaultOption: v,
    waitApiSetup: g = !1,
    apiLoaded: m = !1,
    tooltipContent: y,
    tooltip: b
  } = t, [C, w] = We(!1), [_, x] = We(
    []
  ), [I, D] = We(null), [T, A] = We(0), [M, R] = We(!1), [E, k] = We(!1), P = ui(), N = (z) => {
    if (!p)
      if (D(null), i || n([z.value], [z]), z.isParent !== void 0 && z.isParent === !0) {
        R(!0), setTimeout(() => R(!1), 200);
        const U = l8(e, z.value);
        if (U !== null && U.options !== void 0 && Array.isArray(U.options)) {
          let J = {}, K = [...U.options];
          U.previousItem !== void 0 && U.previousItem !== null && (J = {
            ...U.previousItem,
            isParent: !0
          }, K = [J, ...U.options]), x(K), A(T - 1);
        } else
          x(e), A(0);
      } else if (z.children === void 0 || Array.isArray(z.children) && z.children.length <= 0)
        w(!1);
      else {
        k(!0), setTimeout(() => k(!1), 200);
        const U = [
          {
            ...z,
            isParent: !0
          },
          ...z.children
        ];
        A(T + 1), x(U);
      }
  }, O = (z, U) => {
    const J = z.target.checked;
    let K = [...r];
    const j = d8(U);
    J ? (K = [...K, ...j.values], n(K, j.options, "select")) : (K = K.filter((oe) => !j.values.includes(oe)), n(K, j.options, "deselect"));
  }, W = (z, U) => z.reduce((J, K) => {
    K.label.toLowerCase().includes(U.toLowerCase()) && J.push(K);
    const j = W(K.children || [], U);
    return j.length > 0 && j.forEach((oe) => {
      J.push(oe);
    }), J;
  }, []), V = (z) => {
    if (w(!0), z.length <= 0)
      return x(e), !0;
    if (z.length < 3) return !1;
    const U = W(
      e,
      z
    );
    U.sort((J, K) => J.label < K.label ? -1 : 1), x(U);
  }, B = Vt(null), Z = (z) => {
    B.current && !B.current.contains(z.target) && w(!1);
  }, q = () => `<div class="theme-tooltip-content"><ul>${r.map((z) => `<li>${z}</li>`).join("")}</ul></div>`;
  return Ue(() => {
    if (Array.isArray(e) && e.length > 0) {
      if (g && !m)
        return;
      x(e), setTimeout(() => {
        if (Array.isArray(a) && a.length > 0 && !i) {
          const z = ij(a[0], e);
          z && z !== null && N(z);
        }
      }, 300);
    }
  }, [JSON.stringify(e)]), Ue(() => {
    const z = Z;
    return C && document.addEventListener("click", z), () => {
      document.removeEventListener("click", z);
    };
  }, [C]), /* @__PURE__ */ S.jsxs(
    "div",
    {
      className: `theme-multilevel-select-container ${h !== void 0 ? h : ""} ${C && "is-opened"} ${p ? "is-disabled" : ""}`,
      ref: B,
      children: [
        l && /* @__PURE__ */ S.jsxs("label", { className: "theme-form-input-label", htmlFor: `field-${name}`, children: [
          l,
          " ",
          f && /* @__PURE__ */ S.jsx("span", { children: "*" }),
          " ",
          b && /* @__PURE__ */ S.jsx(S.Fragment, { children: b.onClick !== void 0 ? /* @__PURE__ */ S.jsx(
            Dr,
            {
              onClick: () => b.onClick && b.onClick()
            }
          ) : /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
            /* @__PURE__ */ S.jsx(
              Dr,
              {
                "data-tooltip-id": `${P}-tooltip`,
                "data-tooltip-html": b.content !== void 0 ? b.content : ""
              }
            ),
            /* @__PURE__ */ S.jsx(
              Si,
              {
                id: `${P}-tooltip`,
                className: "theme-tooltip"
              }
            )
          ] }) })
        ] }),
        u && /* @__PURE__ */ S.jsx("label", { className: "theme-form-sublabel", children: u }),
        /* @__PURE__ */ S.jsxs(
          "div",
          {
            className: "theme-multilevel-select-wrapper",
            onClick: () => {
              p || w(!C);
            },
            children: [
              /* @__PURE__ */ S.jsx("div", { className: "theme-select-icon-arrow", children: /* @__PURE__ */ S.jsx(tj, {}) }),
              /* @__PURE__ */ S.jsx(
                "input",
                {
                  disabled: p,
                  readOnly: !0,
                  placeholder: o,
                  type: "text",
                  value: nj(r),
                  onClick: () => w(!C),
                  className: `theme-form-control ${s !== void 0 ? s : ""} ${i ? "theme-multilevel-select-multiple-input" : ""}`,
                  autoComplete: "off",
                  onChange: (z) => z.preventDefault()
                }
              ),
              i && Array.isArray(r) && r.length > 2 && /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
                /* @__PURE__ */ S.jsx(
                  "span",
                  {
                    className: "theme-multilevel-select-bubble",
                    "data-tooltip-id": `${P}-bubble-tooltip`,
                    "data-tooltip-delay-hide": 500,
                    "data-tooltip-html": y !== void 0 ? y : q(),
                    children: r.length < 100 ? r.length : "99+"
                  }
                ),
                /* @__PURE__ */ S.jsx(
                  Si,
                  {
                    id: `${P}-bubble-tooltip`,
                    className: "theme-tooltip"
                  }
                )
              ] })
            ]
          }
        ),
        C && /* @__PURE__ */ S.jsxs(
          "div",
          {
            className: `theme-multilevel-select-list ${M ? "animate-slide-left" : ""} ${E ? "animate-slide-right" : ""}`,
            children: [
              d && /* @__PURE__ */ S.jsxs("div", { className: "theme-multilevel-select-option theme-multilevel-select-search", children: [
                /* @__PURE__ */ S.jsx(
                  "input",
                  {
                    type: "text",
                    value: I !== null ? I : "",
                    className: "theme-form-control",
                    placeholder: "Search",
                    autoComplete: "off",
                    onChange: (z) => {
                      D(z.target.value), V(z.target.value);
                    }
                  }
                ),
                I === "" || I === null && /* @__PURE__ */ S.jsx(d5, { className: "theme-multilevel-search-icon" }),
                I !== "" && I !== null && /* @__PURE__ */ S.jsx(
                  rj,
                  {
                    className: "theme-multilevel-search-icon",
                    onClick: (z) => {
                      z.preventDefault(), z.stopPropagation(), D(null), x(e);
                    }
                  }
                )
              ] }),
              _.length <= 0 && /* @__PURE__ */ S.jsx("div", { className: "theme-multilevel-select-option", children: /* @__PURE__ */ S.jsx("span", { children: "No value available" }) }),
              /* @__PURE__ */ S.jsx(
                "div",
                {
                  className: "theme-multilevel-select-option",
                  onClick: (z) => {
                    z.preventDefault(), z.stopPropagation(), A(0), x(e), n(v !== void 0 ? [v] : []);
                  },
                  children: /* @__PURE__ */ S.jsx("span", { className: "color-theme-red-500", children: "Reset Selection" })
                }
              ),
              _.map((z, U) => {
                if (z.value !== "" && z.label !== "") {
                  const J = r.includes(z.value) || c8(z, r);
                  return /* @__PURE__ */ S.jsxs(
                    "div",
                    {
                      className: `theme-multilevel-select-option ${J && !i && "theme-multilevel-select-option-selected"}`,
                      onClick: (K) => {
                        K.stopPropagation(), (!i || z.isParent) && N(z);
                      },
                      children: [
                        z.isParent && /* @__PURE__ */ S.jsx("div", { className: "theme-multilevel-arrow-left", children: /* @__PURE__ */ S.jsx(Oy, {}) }),
                        !z.isParent && i && /* @__PURE__ */ S.jsx(
                          s5,
                          {
                            containerClassName: "theme-multilevel-cb-container",
                            name: `cb-${z.value}`,
                            value: J ? z.value : ";",
                            useSecondaryCheckmark: z.children === void 0 || z.children.length < 0 ? !1 : !u8(z, r),
                            onInputChange: (K) => O(K, z),
                            checkboxValues: [
                              {
                                label: z.label,
                                value: J ? z.value : ""
                              }
                            ]
                          }
                        ),
                        !i || i && z.isParent ? /* @__PURE__ */ S.jsx(
                          "span",
                          {
                            className: (z.isParent === void 0 || !z.isParent) && T > 0 ? "theme-multilevel-select-option-child" : "",
                            children: z.label
                          }
                        ) : /* @__PURE__ */ S.jsx(S.Fragment, {}),
                        z.isParent === void 0 && z.children !== void 0 && Array.isArray(z.children) && z.children.length > 0 && /* @__PURE__ */ S.jsx(
                          "div",
                          {
                            className: "theme-multilevel-arrow-right",
                            onClick: () => {
                              i && N(z);
                            },
                            children: /* @__PURE__ */ S.jsx(Oy, {})
                          }
                        )
                      ]
                    },
                    `option-${z.value}-${U}`
                  );
                }
              })
            ]
          }
        ),
        c && /* @__PURE__ */ S.jsx("span", { className: "theme-form-helpblock", children: c })
      ]
    }
  );
}, Y8e = (t) => {
  const {
    name: r,
    options: e,
    onSelected: n,
    isMultiple: i = !1,
    defaultValue: a,
    placeholder: o = "Select...",
    className: s = "",
    formLabel: l,
    formSubLabel: u,
    inputHelpBlock: c,
    withSearch: d = !0,
    isRequired: f = !1,
    containerClassName: h,
    disabled: p = !1,
    defaultOption: v,
    waitApiSetup: g = !1,
    apiLoaded: m = !1,
    tooltipContent: y,
    tooltip: b,
    rules: C,
    control: w,
    errors: _
  } = t, [x, I] = We(!1), [D, T] = We(
    []
  ), [A, M] = We(0), [R, E] = We(!1), [k, P] = We(!1), [N, O] = We(null), W = (J, K) => {
    if (!p)
      if (O(null), i || (n && n([J.value], [J]), K && K([J.value])), J.isParent !== void 0 && J.isParent === !0) {
        E(!0), setTimeout(() => E(!1), 200);
        const j = l8(e, J.value);
        if (j !== null && j.options !== void 0 && Array.isArray(j.options)) {
          let oe = {}, ie = [...j.options];
          j.previousItem !== void 0 && j.previousItem !== null && (oe = {
            ...j.previousItem,
            isParent: !0
          }, ie = [oe, ...j.options]), T(ie), M(j.depth - 1);
        } else
          T(e), M(0);
      } else if (J.children === void 0 || Array.isArray(J.children) && J.children.length <= 0)
        I(!1);
      else {
        P(!0), setTimeout(() => P(!1), 200);
        const j = [
          {
            ...J,
            isParent: !0
          },
          ...J.children
        ];
        M(A + 1), T(j);
      }
  }, V = (J, K, j, oe) => {
    const ie = J.target.checked;
    let le = [...j];
    const re = d8(K);
    ie ? (le = [...le, ...re.values], n && n(le, re.options, "select")) : (le = le.filter((Re) => !re.values.includes(Re)), n && n(le, re.options, "deselect")), oe(le);
  }, B = (J, K) => J.reduce((j, oe) => {
    oe.label.toLowerCase().includes(K.toLowerCase()) && j.push(oe);
    const ie = B(oe.children || [], K);
    return ie.length > 0 && ie.forEach((le) => {
      j.push(le);
    }), j;
  }, []), Z = (J) => {
    if (I(!0), J.length <= 0)
      return T(e), !0;
    if (J.length < 3) return !1;
    const K = B(
      e,
      J
    );
    K.sort((j, oe) => j.label < oe.label ? -1 : 1), T(K);
  }, q = Vt(null), z = (J) => {
    q.current && !q.current.contains(J.target) && I(!1);
  }, U = (J) => `<div class="theme-tooltip-content"><ul>${J.map((K) => `<li>${K}</li>`).join("")}</ul></div>`;
  return Ue(() => {
    if (Array.isArray(e) && e.length > 0) {
      if (g && !m)
        return;
      T(e), setTimeout(() => {
        if (Array.isArray(a) && a.length > 0 && !i) {
          const J = ij(a[0], e);
          J && J !== null && W(J);
        }
      }, 300);
    }
  }, [JSON.stringify(e)]), Ue(() => {
    const J = z;
    return x && document.addEventListener("click", J), () => {
      document.removeEventListener("click", J);
    };
  }, [x]), /* @__PURE__ */ S.jsxs(
    "div",
    {
      ref: q,
      className: `theme-multilevel-select-container ${h !== void 0 ? h : ""} ${x && "is-opened"}`,
      children: [
        l && /* @__PURE__ */ S.jsxs("label", { className: "theme-form-input-label", htmlFor: `field-${r}`, children: [
          l,
          " ",
          f && /* @__PURE__ */ S.jsx("span", { children: "*" }),
          " ",
          b && /* @__PURE__ */ S.jsx(S.Fragment, { children: b.onClick !== void 0 ? /* @__PURE__ */ S.jsx(
            Dr,
            {
              onClick: () => b.onClick && b.onClick()
            }
          ) : /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
            /* @__PURE__ */ S.jsx(
              Dr,
              {
                "data-tooltip-id": `${r}-tooltip`,
                "data-tooltip-html": b.content !== void 0 ? b.content : ""
              }
            ),
            /* @__PURE__ */ S.jsx(Si, { id: `${r}-tooltip`, className: "theme-tooltip" })
          ] }) })
        ] }),
        u && /* @__PURE__ */ S.jsx("label", { className: "theme-form-sublabel", children: u }),
        /* @__PURE__ */ S.jsx(
          mu,
          {
            name: r,
            control: w,
            defaultValue: a,
            rules: C || {},
            render: ({ field: { onChange: J, value: K } }) => /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
              /* @__PURE__ */ S.jsxs(
                "div",
                {
                  className: "theme-multilevel-select-wrapper",
                  onClick: () => {
                    p || I(!x);
                  },
                  children: [
                    /* @__PURE__ */ S.jsx("div", { className: "theme-select-icon-arrow", children: /* @__PURE__ */ S.jsx(tj, {}) }),
                    /* @__PURE__ */ S.jsx(
                      "input",
                      {
                        disabled: p,
                        placeholder: o,
                        type: "text",
                        value: nj(K),
                        className: `theme-form-control ${s !== void 0 ? s : ""} ${i ? "theme-multilevel-select-multiple-input" : ""}`,
                        autoComplete: "off",
                        onChange: (j) => j.preventDefault()
                      }
                    ),
                    i && Array.isArray(K) && K.length > 2 && /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
                      /* @__PURE__ */ S.jsx(
                        "span",
                        {
                          className: "theme-multilevel-select-bubble",
                          "data-tooltip-id": `${r}-bubble-tooltip`,
                          "data-tooltip-delay-hide": 500,
                          "data-tooltip-html": y !== void 0 ? y : U(K),
                          children: K.length < 100 ? K.length : "99+"
                        }
                      ),
                      /* @__PURE__ */ S.jsx(
                        Si,
                        {
                          id: `${r}-bubble-tooltip`,
                          className: "theme-tooltip"
                        }
                      )
                    ] })
                  ]
                }
              ),
              x && /* @__PURE__ */ S.jsxs(
                "div",
                {
                  className: `theme-multilevel-select-list ${R ? "animate-slide-left" : ""} ${k ? "animate-slide-right" : ""}`,
                  children: [
                    d && /* @__PURE__ */ S.jsxs("div", { className: "theme-multilevel-select-option theme-multilevel-select-search", children: [
                      /* @__PURE__ */ S.jsx(
                        "input",
                        {
                          type: "text",
                          value: N !== null ? N : "",
                          className: "theme-form-control",
                          placeholder: "Search",
                          autoComplete: "off",
                          onChange: (j) => {
                            O(j.target.value), Z(j.target.value);
                          }
                        }
                      ),
                      N === "" || N === null && /* @__PURE__ */ S.jsx(d5, { className: "theme-multilevel-search-icon" }),
                      N !== "" && N !== null && /* @__PURE__ */ S.jsx(
                        rj,
                        {
                          className: "theme-multilevel-search-icon",
                          onClick: (j) => {
                            j.preventDefault(), j.stopPropagation(), O(null), T(e);
                          }
                        }
                      )
                    ] }),
                    D.length <= 0 && /* @__PURE__ */ S.jsx("div", { className: "theme-multilevel-select-option", children: /* @__PURE__ */ S.jsx("span", { children: "No value available" }) }),
                    /* @__PURE__ */ S.jsx(
                      "div",
                      {
                        className: "theme-multilevel-select-option",
                        onClick: (j) => {
                          j.preventDefault(), j.stopPropagation(), M(0), T(e), n && n(
                            v !== void 0 ? [v] : []
                          ), J(
                            v !== void 0 ? [v] : []
                          );
                        },
                        children: /* @__PURE__ */ S.jsx("span", { className: "color-theme-red-500", children: "Reset Selection" })
                      }
                    ),
                    D.map(
                      (j, oe) => {
                        if (j.value !== "" && j.label !== "") {
                          const ie = K.includes(j.value) || c8(j, K);
                          return /* @__PURE__ */ S.jsxs(
                            "div",
                            {
                              className: `theme-multilevel-select-option ${ie && !i && "theme-multilevel-select-option-selected"}`,
                              onClick: (le) => {
                                le.stopPropagation(), (!i || j.isParent) && W(j, J);
                              },
                              children: [
                                j.isParent && /* @__PURE__ */ S.jsx("div", { className: "theme-multilevel-arrow-left", children: /* @__PURE__ */ S.jsx(Oy, {}) }),
                                !j.isParent && i && /* @__PURE__ */ S.jsx(
                                  s5,
                                  {
                                    containerClassName: "theme-multilevel-cb-container",
                                    name: `cb-${j.value}`,
                                    value: ie ? j.value : ";",
                                    useSecondaryCheckmark: j.children === void 0 || j.children.length < 0 ? !1 : !u8(j, K),
                                    onInputChange: (le) => V(le, j, K, J),
                                    checkboxValues: [
                                      {
                                        label: j.label,
                                        value: ie ? j.value : ""
                                      }
                                    ]
                                  }
                                ),
                                !i || i && j.isParent ? /* @__PURE__ */ S.jsx(
                                  "span",
                                  {
                                    className: (j.isParent === void 0 || !j.isParent) && A > 0 ? "theme-multilevel-select-option-child" : "",
                                    children: j.label
                                  }
                                ) : /* @__PURE__ */ S.jsx(S.Fragment, {}),
                                j.isParent === void 0 && j.children !== void 0 && Array.isArray(j.children) && j.children.length > 0 && /* @__PURE__ */ S.jsx(
                                  "div",
                                  {
                                    className: "theme-multilevel-arrow-right",
                                    onClick: () => {
                                      i && W(j, J);
                                    },
                                    children: /* @__PURE__ */ S.jsx(Oy, {})
                                  }
                                )
                              ]
                            },
                            `option-${j.value}-${oe}`
                          );
                        }
                      }
                    )
                  ]
                }
              )
            ] })
          }
        ),
        /* @__PURE__ */ S.jsx(
          yu,
          {
            errors: _,
            name: r,
            render: ({ message: J }) => /* @__PURE__ */ S.jsx("div", { className: "theme-font-sm color-theme-red-500 theme-form-error-message", children: J })
          }
        ),
        c && /* @__PURE__ */ S.jsx("span", { className: "theme-form-helpblock", children: c })
      ]
    }
  );
};
var rm = { exports: {} }, H7e = rm.exports, Uk;
function z7e() {
  return Uk || (Uk = 1, function(t, r) {
    (function(e, n) {
      t.exports = n(te);
    })(H7e, (e) => (() => {
      var n = { 703: (s, l, u) => {
        var c = u(414);
        function d() {
        }
        function f() {
        }
        f.resetWarningCache = d, s.exports = function() {
          function h(g, m, y, b, C, w) {
            if (w !== c) {
              var _ = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
              throw _.name = "Invariant Violation", _;
            }
          }
          function p() {
            return h;
          }
          h.isRequired = h;
          var v = { array: h, bool: h, func: h, number: h, object: h, string: h, symbol: h, any: h, arrayOf: p, element: h, elementType: h, instanceOf: p, node: h, objectOf: p, oneOf: p, oneOfType: p, shape: p, exact: p, checkPropTypes: f, resetWarningCache: d };
          return v.PropTypes = v, v;
        };
      }, 697: (s, l, u) => {
        s.exports = u(703)();
      }, 414: (s) => {
        s.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
      }, 590: (s) => {
        var l = typeof Element < "u", u = typeof Map == "function", c = typeof Set == "function", d = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
        function f(h, p) {
          if (h === p) return !0;
          if (h && p && typeof h == "object" && typeof p == "object") {
            if (h.constructor !== p.constructor) return !1;
            var v, g, m, y;
            if (Array.isArray(h)) {
              if ((v = h.length) != p.length) return !1;
              for (g = v; g-- != 0; ) if (!f(h[g], p[g])) return !1;
              return !0;
            }
            if (u && h instanceof Map && p instanceof Map) {
              if (h.size !== p.size) return !1;
              for (y = h.entries(); !(g = y.next()).done; ) if (!p.has(g.value[0])) return !1;
              for (y = h.entries(); !(g = y.next()).done; ) if (!f(g.value[1], p.get(g.value[0]))) return !1;
              return !0;
            }
            if (c && h instanceof Set && p instanceof Set) {
              if (h.size !== p.size) return !1;
              for (y = h.entries(); !(g = y.next()).done; ) if (!p.has(g.value[0])) return !1;
              return !0;
            }
            if (d && ArrayBuffer.isView(h) && ArrayBuffer.isView(p)) {
              if ((v = h.length) != p.length) return !1;
              for (g = v; g-- != 0; ) if (h[g] !== p[g]) return !1;
              return !0;
            }
            if (h.constructor === RegExp) return h.source === p.source && h.flags === p.flags;
            if (h.valueOf !== Object.prototype.valueOf) return h.valueOf() === p.valueOf();
            if (h.toString !== Object.prototype.toString) return h.toString() === p.toString();
            if ((v = (m = Object.keys(h)).length) !== Object.keys(p).length) return !1;
            for (g = v; g-- != 0; ) if (!Object.prototype.hasOwnProperty.call(p, m[g])) return !1;
            if (l && h instanceof Element) return !1;
            for (g = v; g-- != 0; ) if ((m[g] !== "_owner" && m[g] !== "__v" && m[g] !== "__o" || !h.$$typeof) && !f(h[m[g]], p[m[g]])) return !1;
            return !0;
          }
          return h != h && p != p;
        }
        s.exports = function(h, p) {
          try {
            return f(h, p);
          } catch (v) {
            if ((v.message || "").match(/stack|recursion/i)) return console.warn("react-fast-compare cannot handle circular refs"), !1;
            throw v;
          }
        };
      }, 359: (s) => {
        s.exports = e;
      } }, i = {};
      function a(s) {
        var l = i[s];
        if (l !== void 0) return l.exports;
        var u = i[s] = { exports: {} };
        return n[s](u, u.exports, a), u.exports;
      }
      a.n = (s) => {
        var l = s && s.__esModule ? () => s.default : () => s;
        return a.d(l, { a: l }), l;
      }, a.d = (s, l) => {
        for (var u in l) a.o(l, u) && !a.o(s, u) && Object.defineProperty(s, u, { enumerable: !0, get: l[u] });
      }, a.g = function() {
        if (typeof globalThis == "object") return globalThis;
        try {
          return this || new Function("return this")();
        } catch {
          if (typeof window == "object") return window;
        }
      }(), a.o = (s, l) => Object.prototype.hasOwnProperty.call(s, l), a.r = (s) => {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(s, "__esModule", { value: !0 });
      };
      var o = {};
      return (() => {
        function s(Y) {
          var G, Q, ne = "";
          if (typeof Y == "string" || typeof Y == "number") ne += Y;
          else if (typeof Y == "object") if (Array.isArray(Y)) for (G = 0; G < Y.length; G++) Y[G] && (Q = s(Y[G])) && (ne && (ne += " "), ne += Q);
          else for (G in Y) Y[G] && (ne && (ne += " "), ne += G);
          return ne;
        }
        function l() {
          for (var Y, G, Q = 0, ne = ""; Q < arguments.length; ) (Y = arguments[Q++]) && (G = s(Y)) && (ne && (ne += " "), ne += G);
          return ne;
        }
        a.r(o), a.d(o, { default: () => uY });
        var u = a(359), c = a.n(u);
        const d = function(Y) {
          var G = typeof Y;
          return Y != null && (G == "object" || G == "function");
        }, f = typeof xp == "object" && xp && xp.Object === Object && xp;
        var h = typeof self == "object" && self && self.Object === Object && self;
        const p = f || h || Function("return this")(), v = function() {
          return p.Date.now();
        };
        var g = /\s/, m = /^\s+/;
        const y = function(Y) {
          return Y && Y.slice(0, function(G) {
            for (var Q = G.length; Q-- && g.test(G.charAt(Q)); ) ;
            return Q;
          }(Y) + 1).replace(m, "");
        }, b = p.Symbol;
        var C = Object.prototype, w = C.hasOwnProperty, _ = C.toString, x = b ? b.toStringTag : void 0, I = Object.prototype.toString, D = b ? b.toStringTag : void 0;
        const T = function(Y) {
          return Y == null ? Y === void 0 ? "[object Undefined]" : "[object Null]" : D && D in Object(Y) ? function(G) {
            var Q = w.call(G, x), ne = G[x];
            try {
              G[x] = void 0;
              var we = !0;
            } catch {
            }
            var $e = _.call(G);
            return we && (Q ? G[x] = ne : delete G[x]), $e;
          }(Y) : function(G) {
            return I.call(G);
          }(Y);
        };
        var A = /^[-+]0x[0-9a-f]+$/i, M = /^0b[01]+$/i, R = /^0o[0-7]+$/i, E = parseInt;
        const k = function(Y) {
          if (typeof Y == "number") return Y;
          if (function(ne) {
            return typeof ne == "symbol" || function(we) {
              return we != null && typeof we == "object";
            }(ne) && T(ne) == "[object Symbol]";
          }(Y)) return NaN;
          if (d(Y)) {
            var G = typeof Y.valueOf == "function" ? Y.valueOf() : Y;
            Y = d(G) ? G + "" : G;
          }
          if (typeof Y != "string") return Y === 0 ? Y : +Y;
          Y = y(Y);
          var Q = M.test(Y);
          return Q || R.test(Y) ? E(Y.slice(2), Q ? 2 : 8) : A.test(Y) ? NaN : +Y;
        };
        var P = Math.max, N = Math.min;
        const O = function(Y, G, Q) {
          var ne, we, $e, Ht, H, F, se = 0, ge = !1, _e = !1, Ce = !0;
          if (typeof Y != "function") throw new TypeError("Expected a function");
          function mt(Je) {
            var Et = ne, sr = we;
            return ne = we = void 0, se = Je, Ht = Y.apply(sr, Et);
          }
          function ft(Je) {
            return se = Je, H = setTimeout(Le, G), ge ? mt(Je) : Ht;
          }
          function Lt(Je) {
            var Et = Je - F;
            return F === void 0 || Et >= G || Et < 0 || _e && Je - se >= $e;
          }
          function Le() {
            var Je = v();
            if (Lt(Je)) return Pe(Je);
            H = setTimeout(Le, function(Et) {
              var sr = G - (Et - F);
              return _e ? N(sr, $e - (Et - se)) : sr;
            }(Je));
          }
          function Pe(Je) {
            return H = void 0, Ce && ne ? mt(Je) : (ne = we = void 0, Ht);
          }
          function He() {
            var Je = v(), Et = Lt(Je);
            if (ne = arguments, we = this, F = Je, Et) {
              if (H === void 0) return ft(F);
              if (_e) return clearTimeout(H), H = setTimeout(Le, G), mt(F);
            }
            return H === void 0 && (H = setTimeout(Le, G)), Ht;
          }
          return G = k(G) || 0, d(Q) && (ge = !!Q.leading, $e = (_e = "maxWait" in Q) ? P(k(Q.maxWait) || 0, G) : $e, Ce = "trailing" in Q ? !!Q.trailing : Ce), He.cancel = function() {
            H !== void 0 && clearTimeout(H), se = 0, ne = F = we = H = void 0;
          }, He.flush = function() {
            return H === void 0 ? Ht : Pe(v());
          }, He;
        }, W = function(Y, G, Q) {
          var ne = !0, we = !0;
          if (typeof Y != "function") throw new TypeError("Expected a function");
          return d(Q) && (ne = "leading" in Q ? !!Q.leading : ne, we = "trailing" in Q ? !!Q.trailing : we), O(Y, G, { leading: ne, maxWait: G, trailing: we });
        };
        var V = a(590), B = a.n(V), Z = function() {
          if (typeof Map < "u") return Map;
          function Y(G, Q) {
            var ne = -1;
            return G.some(function(we, $e) {
              return we[0] === Q && (ne = $e, !0);
            }), ne;
          }
          return function() {
            function G() {
              this.__entries__ = [];
            }
            return Object.defineProperty(G.prototype, "size", { get: function() {
              return this.__entries__.length;
            }, enumerable: !0, configurable: !0 }), G.prototype.get = function(Q) {
              var ne = Y(this.__entries__, Q), we = this.__entries__[ne];
              return we && we[1];
            }, G.prototype.set = function(Q, ne) {
              var we = Y(this.__entries__, Q);
              ~we ? this.__entries__[we][1] = ne : this.__entries__.push([Q, ne]);
            }, G.prototype.delete = function(Q) {
              var ne = this.__entries__, we = Y(ne, Q);
              ~we && ne.splice(we, 1);
            }, G.prototype.has = function(Q) {
              return !!~Y(this.__entries__, Q);
            }, G.prototype.clear = function() {
              this.__entries__.splice(0);
            }, G.prototype.forEach = function(Q, ne) {
              ne === void 0 && (ne = null);
              for (var we = 0, $e = this.__entries__; we < $e.length; we++) {
                var Ht = $e[we];
                Q.call(ne, Ht[1], Ht[0]);
              }
            }, G;
          }();
        }(), q = typeof window < "u" && typeof document < "u" && window.document === document, z = a.g !== void 0 && a.g.Math === Math ? a.g : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")(), U = typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(z) : function(Y) {
          return setTimeout(function() {
            return Y(Date.now());
          }, 1e3 / 60);
        }, J = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], K = typeof MutationObserver < "u", j = function() {
          function Y() {
            this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = /* @__PURE__ */ function(G, Q) {
              var ne = !1, we = !1, $e = 0;
              function Ht() {
                ne && (ne = !1, G()), we && F();
              }
              function H() {
                U(Ht);
              }
              function F() {
                var se = Date.now();
                if (ne) {
                  if (se - $e < 2) return;
                  we = !0;
                } else ne = !0, we = !1, setTimeout(H, 20);
                $e = se;
              }
              return F;
            }(this.refresh.bind(this));
          }
          return Y.prototype.addObserver = function(G) {
            ~this.observers_.indexOf(G) || this.observers_.push(G), this.connected_ || this.connect_();
          }, Y.prototype.removeObserver = function(G) {
            var Q = this.observers_, ne = Q.indexOf(G);
            ~ne && Q.splice(ne, 1), !Q.length && this.connected_ && this.disconnect_();
          }, Y.prototype.refresh = function() {
            this.updateObservers_() && this.refresh();
          }, Y.prototype.updateObservers_ = function() {
            var G = this.observers_.filter(function(Q) {
              return Q.gatherActive(), Q.hasActive();
            });
            return G.forEach(function(Q) {
              return Q.broadcastActive();
            }), G.length > 0;
          }, Y.prototype.connect_ = function() {
            q && !this.connected_ && (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), K ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, { attributes: !0, childList: !0, characterData: !0, subtree: !0 })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
          }, Y.prototype.disconnect_ = function() {
            q && this.connected_ && (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
          }, Y.prototype.onTransitionEnd_ = function(G) {
            var Q = G.propertyName, ne = Q === void 0 ? "" : Q;
            J.some(function(we) {
              return !!~ne.indexOf(we);
            }) && this.refresh();
          }, Y.getInstance = function() {
            return this.instance_ || (this.instance_ = new Y()), this.instance_;
          }, Y.instance_ = null, Y;
        }(), oe = function(Y, G) {
          for (var Q = 0, ne = Object.keys(G); Q < ne.length; Q++) {
            var we = ne[Q];
            Object.defineProperty(Y, we, { value: G[we], enumerable: !1, writable: !1, configurable: !0 });
          }
          return Y;
        }, ie = function(Y) {
          return Y && Y.ownerDocument && Y.ownerDocument.defaultView || z;
        }, le = qe(0, 0, 0, 0);
        function re(Y) {
          return parseFloat(Y) || 0;
        }
        function Re(Y) {
          for (var G = [], Q = 1; Q < arguments.length; Q++) G[Q - 1] = arguments[Q];
          return G.reduce(function(ne, we) {
            return ne + re(Y["border-" + we + "-width"]);
          }, 0);
        }
        var ve = typeof SVGGraphicsElement < "u" ? function(Y) {
          return Y instanceof ie(Y).SVGGraphicsElement;
        } : function(Y) {
          return Y instanceof ie(Y).SVGElement && typeof Y.getBBox == "function";
        };
        function Oe(Y) {
          return q ? ve(Y) ? function(G) {
            var Q = G.getBBox();
            return qe(0, 0, Q.width, Q.height);
          }(Y) : function(G) {
            var Q = G.clientWidth, ne = G.clientHeight;
            if (!Q && !ne) return le;
            var we = ie(G).getComputedStyle(G), $e = function(Ce) {
              for (var mt = {}, ft = 0, Lt = ["top", "right", "bottom", "left"]; ft < Lt.length; ft++) {
                var Le = Lt[ft], Pe = Ce["padding-" + Le];
                mt[Le] = re(Pe);
              }
              return mt;
            }(we), Ht = $e.left + $e.right, H = $e.top + $e.bottom, F = re(we.width), se = re(we.height);
            if (we.boxSizing === "border-box" && (Math.round(F + Ht) !== Q && (F -= Re(we, "left", "right") + Ht), Math.round(se + H) !== ne && (se -= Re(we, "top", "bottom") + H)), !function(Ce) {
              return Ce === ie(Ce).document.documentElement;
            }(G)) {
              var ge = Math.round(F + Ht) - Q, _e = Math.round(se + H) - ne;
              Math.abs(ge) !== 1 && (F -= ge), Math.abs(_e) !== 1 && (se -= _e);
            }
            return qe($e.left, $e.top, F, se);
          }(Y) : le;
        }
        function qe(Y, G, Q, ne) {
          return { x: Y, y: G, width: Q, height: ne };
        }
        var dt = function() {
          function Y(G) {
            this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = qe(0, 0, 0, 0), this.target = G;
          }
          return Y.prototype.isActive = function() {
            var G = Oe(this.target);
            return this.contentRect_ = G, G.width !== this.broadcastWidth || G.height !== this.broadcastHeight;
          }, Y.prototype.broadcastRect = function() {
            var G = this.contentRect_;
            return this.broadcastWidth = G.width, this.broadcastHeight = G.height, G;
          }, Y;
        }(), At = function(Y, G) {
          var Q, ne, we, $e, Ht, H, F, se = (ne = (Q = G).x, we = Q.y, $e = Q.width, Ht = Q.height, H = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, F = Object.create(H.prototype), oe(F, { x: ne, y: we, width: $e, height: Ht, top: we, right: ne + $e, bottom: Ht + we, left: ne }), F);
          oe(this, { target: Y, contentRect: se });
        }, Be = function() {
          function Y(G, Q, ne) {
            if (this.activeObservations_ = [], this.observations_ = new Z(), typeof G != "function") throw new TypeError("The callback provided as parameter 1 is not a function.");
            this.callback_ = G, this.controller_ = Q, this.callbackCtx_ = ne;
          }
          return Y.prototype.observe = function(G) {
            if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
            if (typeof Element < "u" && Element instanceof Object) {
              if (!(G instanceof ie(G).Element)) throw new TypeError('parameter 1 is not of type "Element".');
              var Q = this.observations_;
              Q.has(G) || (Q.set(G, new dt(G)), this.controller_.addObserver(this), this.controller_.refresh());
            }
          }, Y.prototype.unobserve = function(G) {
            if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
            if (typeof Element < "u" && Element instanceof Object) {
              if (!(G instanceof ie(G).Element)) throw new TypeError('parameter 1 is not of type "Element".');
              var Q = this.observations_;
              Q.has(G) && (Q.delete(G), Q.size || this.controller_.removeObserver(this));
            }
          }, Y.prototype.disconnect = function() {
            this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
          }, Y.prototype.gatherActive = function() {
            var G = this;
            this.clearActive(), this.observations_.forEach(function(Q) {
              Q.isActive() && G.activeObservations_.push(Q);
            });
          }, Y.prototype.broadcastActive = function() {
            if (this.hasActive()) {
              var G = this.callbackCtx_, Q = this.activeObservations_.map(function(ne) {
                return new At(ne.target, ne.broadcastRect());
              });
              this.callback_.call(G, Q, G), this.clearActive();
            }
          }, Y.prototype.clearActive = function() {
            this.activeObservations_.splice(0);
          }, Y.prototype.hasActive = function() {
            return this.activeObservations_.length > 0;
          }, Y;
        }(), Nt = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new Z(), wt = function Y(G) {
          if (!(this instanceof Y)) throw new TypeError("Cannot call a class as a function.");
          if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
          var Q = j.getInstance(), ne = new Be(G, Q, this);
          Nt.set(this, ne);
        };
        ["observe", "unobserve", "disconnect"].forEach(function(Y) {
          wt.prototype[Y] = function() {
            var G;
            return (G = Nt.get(this))[Y].apply(G, arguments);
          };
        });
        const Dt = z.ResizeObserver !== void 0 ? z.ResizeObserver : wt, Ot = "Left", or = "Right", $r = "Up", kr = "Down", Gr = { delta: 10, preventScrollOnSwipe: !1, rotationAngle: 0, trackMouse: !1, trackTouch: !0, swipeDuration: 1 / 0, touchEventOptions: { passive: !0 } }, Dn = { first: !0, initial: [0, 0], start: 0, swiping: !1, xy: [0, 0] }, dn = "mousemove", Pn = "mouseup";
        function Tn(Y, G) {
          if (G === 0) return Y;
          const Q = Math.PI / 180 * G;
          return [Y[0] * Math.cos(Q) + Y[1] * Math.sin(Q), Y[1] * Math.cos(Q) - Y[0] * Math.sin(Q)];
        }
        function Gi(Y) {
          const { trackMouse: G } = Y, Q = u.useRef(Object.assign({}, Dn)), ne = u.useRef(Object.assign({}, Gr)), we = u.useRef(Object.assign({}, ne.current));
          let $e;
          for ($e in we.current = Object.assign({}, ne.current), ne.current = Object.assign(Object.assign({}, Gr), Y), Gr) ne.current[$e] === void 0 && (ne.current[$e] = Gr[$e]);
          const [Ht, H] = u.useMemo(() => function(F, se) {
            const ge = (Le) => {
              const Pe = "touches" in Le;
              Pe && Le.touches.length > 1 || F((He, Je) => {
                Je.trackMouse && !Pe && (document.addEventListener(dn, _e), document.addEventListener(Pn, mt));
                const { clientX: Et, clientY: sr } = Pe ? Le.touches[0] : Le, Jr = Tn([Et, sr], Je.rotationAngle);
                return Je.onTouchStartOrOnMouseDown && Je.onTouchStartOrOnMouseDown({ event: Le }), Object.assign(Object.assign(Object.assign({}, He), Dn), { initial: Jr.slice(), xy: Jr, start: Le.timeStamp || 0 });
              });
            }, _e = (Le) => {
              F((Pe, He) => {
                const Je = "touches" in Le;
                if (Je && Le.touches.length > 1) return Pe;
                if (Le.timeStamp - Pe.start > He.swipeDuration) return Pe.swiping ? Object.assign(Object.assign({}, Pe), { swiping: !1 }) : Pe;
                const { clientX: Et, clientY: sr } = Je ? Le.touches[0] : Le, [Jr, Ti] = Tn([Et, sr], He.rotationAngle), fi = Jr - Pe.xy[0], Vn = Ti - Pe.xy[1], Hr = Math.abs(fi), lr = Math.abs(Vn), ul = (Le.timeStamp || 0) - Pe.start, Dh = Math.sqrt(Hr * Hr + lr * lr) / (ul || 1), Th = [fi / (ul || 1), Vn / (ul || 1)], ds = function(Mh, dd, Rh, Fi) {
                  return Mh > dd ? Rh > 0 ? or : Ot : Fi > 0 ? kr : $r;
                }(Hr, lr, fi, Vn), wu = typeof He.delta == "number" ? He.delta : He.delta[ds.toLowerCase()] || Gr.delta;
                if (Hr < wu && lr < wu && !Pe.swiping) return Pe;
                const go = { absX: Hr, absY: lr, deltaX: fi, deltaY: Vn, dir: ds, event: Le, first: Pe.first, initial: Pe.initial, velocity: Dh, vxvy: Th };
                go.first && He.onSwipeStart && He.onSwipeStart(go), He.onSwiping && He.onSwiping(go);
                let cd = !1;
                return (He.onSwiping || He.onSwiped || He[`onSwiped${ds}`]) && (cd = !0), cd && He.preventScrollOnSwipe && He.trackTouch && Le.cancelable && Le.preventDefault(), Object.assign(Object.assign({}, Pe), { first: !1, eventData: go, swiping: !0 });
              });
            }, Ce = (Le) => {
              F((Pe, He) => {
                let Je;
                if (Pe.swiping && Pe.eventData) {
                  if (Le.timeStamp - Pe.start < He.swipeDuration) {
                    Je = Object.assign(Object.assign({}, Pe.eventData), { event: Le }), He.onSwiped && He.onSwiped(Je);
                    const Et = He[`onSwiped${Je.dir}`];
                    Et && Et(Je);
                  }
                } else He.onTap && He.onTap({ event: Le });
                return He.onTouchEndOrOnMouseUp && He.onTouchEndOrOnMouseUp({ event: Le }), Object.assign(Object.assign(Object.assign({}, Pe), Dn), { eventData: Je });
              });
            }, mt = (Le) => {
              document.removeEventListener(dn, _e), document.removeEventListener(Pn, mt), Ce(Le);
            }, ft = (Le, Pe) => {
              let He = () => {
              };
              if (Le && Le.addEventListener) {
                const Je = Object.assign(Object.assign({}, Gr.touchEventOptions), Pe.touchEventOptions), Et = [["touchstart", ge, Je], ["touchmove", _e, Object.assign(Object.assign({}, Je), Pe.preventScrollOnSwipe ? { passive: !1 } : {})], ["touchend", Ce, Je]];
                Et.forEach(([sr, Jr, Ti]) => Le.addEventListener(sr, Jr, Ti)), He = () => Et.forEach(([sr, Jr]) => Le.removeEventListener(sr, Jr));
              }
              return He;
            }, Lt = { ref: (Le) => {
              Le !== null && F((Pe, He) => {
                if (Pe.el === Le) return Pe;
                const Je = {};
                return Pe.el && Pe.el !== Le && Pe.cleanUpTouch && (Pe.cleanUpTouch(), Je.cleanUpTouch = void 0), He.trackTouch && Le && (Je.cleanUpTouch = ft(Le, He)), Object.assign(Object.assign(Object.assign({}, Pe), { el: Le }), Je);
              });
            } };
            return se.trackMouse && (Lt.onMouseDown = ge), [Lt, ft];
          }((F) => Q.current = F(Q.current, ne.current), { trackMouse: G }), [G]);
          return Q.current = function(F, se, ge, _e) {
            return se.trackTouch && F.el ? F.cleanUpTouch ? se.preventScrollOnSwipe !== ge.preventScrollOnSwipe || se.touchEventOptions.passive !== ge.touchEventOptions.passive ? (F.cleanUpTouch(), Object.assign(Object.assign({}, F), { cleanUpTouch: _e(F.el, se) })) : F : Object.assign(Object.assign({}, F), { cleanUpTouch: _e(F.el, se) }) : (F.cleanUpTouch && F.cleanUpTouch(), Object.assign(Object.assign({}, F), { cleanUpTouch: void 0 }));
          }(Q.current, ne.current, we.current, H), Ht;
        }
        var de = a(697);
        function Kt(Y) {
          return Kt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(G) {
            return typeof G;
          } : function(G) {
            return G && typeof Symbol == "function" && G.constructor === Symbol && G !== Symbol.prototype ? "symbol" : typeof G;
          }, Kt(Y);
        }
        function fn(Y, G) {
          var Q = Object.keys(Y);
          if (Object.getOwnPropertySymbols) {
            var ne = Object.getOwnPropertySymbols(Y);
            G && (ne = ne.filter(function(we) {
              return Object.getOwnPropertyDescriptor(Y, we).enumerable;
            })), Q.push.apply(Q, ne);
          }
          return Q;
        }
        function Ii(Y) {
          for (var G = 1; G < arguments.length; G++) {
            var Q = arguments[G] != null ? arguments[G] : {};
            G % 2 ? fn(Object(Q), !0).forEach(function(ne) {
              di(Y, ne, Q[ne]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Y, Object.getOwnPropertyDescriptors(Q)) : fn(Object(Q)).forEach(function(ne) {
              Object.defineProperty(Y, ne, Object.getOwnPropertyDescriptor(Q, ne));
            });
          }
          return Y;
        }
        function di(Y, G, Q) {
          return (G = function(ne) {
            var we = function($e, Ht) {
              if (Kt($e) !== "object" || $e === null) return $e;
              var H = $e[Symbol.toPrimitive];
              if (H !== void 0) {
                var F = H.call($e, Ht);
                if (Kt(F) !== "object") return F;
                throw new TypeError("@@toPrimitive must return a primitive value.");
              }
              return String($e);
            }(ne, "string");
            return Kt(we) === "symbol" ? we : String(we);
          }(G)) in Y ? Object.defineProperty(Y, G, { value: Q, enumerable: !0, configurable: !0, writable: !0 }) : Y[G] = Q, Y;
        }
        var Ai = { description: "", fullscreen: "", isFullscreen: !1, originalAlt: "", originalHeight: "", originalWidth: "", originalTitle: "", sizes: "", srcSet: "", loading: "eager" }, Br = c().memo(function(Y) {
          var G = Ii(Ii({}, Ai), Y), Q = G.description, ne = G.fullscreen, we = G.handleImageLoaded, $e = G.isFullscreen, Ht = G.onImageError, H = G.original, F = G.originalAlt, se = G.originalHeight, ge = G.originalWidth, _e = G.originalTitle, Ce = G.sizes, mt = G.srcSet, ft = G.loading, Lt = $e && ne || H;
          return c().createElement(c().Fragment, null, c().createElement("img", { className: "image-gallery-image", src: Lt, alt: F, srcSet: mt, height: se, width: ge, sizes: Ce, title: _e, onLoad: function(Le) {
            return we(Le, H);
          }, onError: Ht, loading: ft }), Q && c().createElement("span", { className: "image-gallery-description" }, Q));
        });
        Br.displayName = "Item", Br.propTypes = { description: de.string, fullscreen: de.string, handleImageLoaded: de.func.isRequired, isFullscreen: de.bool, onImageError: de.func.isRequired, original: de.string.isRequired, originalAlt: de.string, originalHeight: de.string, originalWidth: de.string, originalTitle: de.string, sizes: de.string, srcSet: de.string, loading: de.string };
        const Nn = Br;
        function Tr(Y) {
          return Tr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(G) {
            return typeof G;
          } : function(G) {
            return G && typeof Symbol == "function" && G.constructor === Symbol && G !== Symbol.prototype ? "symbol" : typeof G;
          }, Tr(Y);
        }
        function On(Y, G) {
          var Q = Object.keys(Y);
          if (Object.getOwnPropertySymbols) {
            var ne = Object.getOwnPropertySymbols(Y);
            G && (ne = ne.filter(function(we) {
              return Object.getOwnPropertyDescriptor(Y, we).enumerable;
            })), Q.push.apply(Q, ne);
          }
          return Q;
        }
        function Bi(Y) {
          for (var G = 1; G < arguments.length; G++) {
            var Q = arguments[G] != null ? arguments[G] : {};
            G % 2 ? On(Object(Q), !0).forEach(function(ne) {
              Sr(Y, ne, Q[ne]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Y, Object.getOwnPropertyDescriptors(Q)) : On(Object(Q)).forEach(function(ne) {
              Object.defineProperty(Y, ne, Object.getOwnPropertyDescriptor(Q, ne));
            });
          }
          return Y;
        }
        function Sr(Y, G, Q) {
          return (G = function(ne) {
            var we = function($e, Ht) {
              if (Tr($e) !== "object" || $e === null) return $e;
              var H = $e[Symbol.toPrimitive];
              if (H !== void 0) {
                var F = H.call($e, Ht);
                if (Tr(F) !== "object") return F;
                throw new TypeError("@@toPrimitive must return a primitive value.");
              }
              return String($e);
            }(ne, "string");
            return Tr(we) === "symbol" ? we : String(we);
          }(G)) in Y ? Object.defineProperty(Y, G, { value: Q, enumerable: !0, configurable: !0, writable: !0 }) : Y[G] = Q, Y;
        }
        var Mn = { left: c().createElement("polyline", { points: "15 18 9 12 15 6" }), right: c().createElement("polyline", { points: "9 18 15 12 9 6" }), maximize: c().createElement("path", { d: "M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3" }), minimize: c().createElement("path", { d: "M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3" }), play: c().createElement("polygon", { points: "5 3 19 12 5 21 5 3" }), pause: c().createElement(c().Fragment, null, c().createElement("rect", { x: "6", y: "4", width: "4", height: "16" }), c().createElement("rect", { x: "14", y: "4", width: "4", height: "16" })) }, Ke = { strokeWidth: 1, viewBox: "0 0 24 24" }, St = function(Y) {
          var G = Bi(Bi({}, Ke), Y), Q = G.strokeWidth, ne = G.viewBox, we = G.icon;
          return c().createElement("svg", { className: "image-gallery-svg", xmlns: "http://www.w3.org/2000/svg", viewBox: ne, fill: "none", stroke: "currentColor", strokeWidth: Q, strokeLinecap: "round", strokeLinejoin: "round" }, Mn[we]);
        };
        St.propTypes = { strokeWidth: de.number, viewBox: de.string, icon: (0, de.oneOf)(["left", "right", "maximize", "minimize", "play", "pause"]).isRequired };
        const Ir = St;
        var mn = c().memo(function(Y) {
          var G = Y.isFullscreen, Q = Y.onClick;
          return c().createElement("button", { type: "button", className: "image-gallery-icon image-gallery-fullscreen-button", onClick: Q, "aria-label": "Open Fullscreen" }, c().createElement(Ir, { strokeWidth: 2, icon: G ? "minimize" : "maximize" }));
        });
        mn.displayName = "Fullscreen", mn.propTypes = { isFullscreen: de.bool.isRequired, onClick: de.func.isRequired };
        const Ie = mn;
        var Xe = c().memo(function(Y) {
          var G = Y.disabled, Q = Y.onClick;
          return c().createElement("button", { type: "button", className: "image-gallery-icon image-gallery-left-nav", disabled: G, onClick: Q, "aria-label": "Previous Slide" }, c().createElement(Ir, { icon: "left", viewBox: "6 0 12 24" }));
        });
        Xe.displayName = "LeftNav", Xe.propTypes = { disabled: de.bool.isRequired, onClick: de.func.isRequired };
        const it = Xe;
        var hr = c().memo(function(Y) {
          var G = Y.disabled, Q = Y.onClick;
          return c().createElement("button", { type: "button", className: "image-gallery-icon image-gallery-right-nav", disabled: G, onClick: Q, "aria-label": "Next Slide" }, c().createElement(Ir, { icon: "right", viewBox: "6 0 12 24" }));
        });
        hr.displayName = "RightNav", hr.propTypes = { disabled: de.bool.isRequired, onClick: de.func.isRequired };
        const hn = hr;
        var $n = c().memo(function(Y) {
          var G = Y.isPlaying, Q = Y.onClick;
          return c().createElement("button", { type: "button", className: "image-gallery-icon image-gallery-play-button", onClick: Q, "aria-label": "Play or Pause Slideshow" }, c().createElement(Ir, { strokeWidth: 2, icon: G ? "pause" : "play" }));
        });
        $n.displayName = "PlayPause", $n.propTypes = { isPlaying: de.bool.isRequired, onClick: de.func.isRequired };
        const Di = $n;
        function Fr(Y) {
          return Fr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(G) {
            return typeof G;
          } : function(G) {
            return G && typeof Symbol == "function" && G.constructor === Symbol && G !== Symbol.prototype ? "symbol" : typeof G;
          }, Fr(Y);
        }
        function X() {
          return X = Object.assign ? Object.assign.bind() : function(Y) {
            for (var G = 1; G < arguments.length; G++) {
              var Q = arguments[G];
              for (var ne in Q) Object.prototype.hasOwnProperty.call(Q, ne) && (Y[ne] = Q[ne]);
            }
            return Y;
          }, X.apply(this, arguments);
        }
        function fe(Y, G) {
          var Q = Object.keys(Y);
          if (Object.getOwnPropertySymbols) {
            var ne = Object.getOwnPropertySymbols(Y);
            G && (ne = ne.filter(function(we) {
              return Object.getOwnPropertyDescriptor(Y, we).enumerable;
            })), Q.push.apply(Q, ne);
          }
          return Q;
        }
        function Se(Y) {
          for (var G = 1; G < arguments.length; G++) {
            var Q = arguments[G] != null ? arguments[G] : {};
            G % 2 ? fe(Object(Q), !0).forEach(function(ne) {
              at(Y, ne, Q[ne]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Y, Object.getOwnPropertyDescriptors(Q)) : fe(Object(Q)).forEach(function(ne) {
              Object.defineProperty(Y, ne, Object.getOwnPropertyDescriptor(Q, ne));
            });
          }
          return Y;
        }
        function at(Y, G, Q) {
          return (G = function(ne) {
            var we = function($e, Ht) {
              if (Fr($e) !== "object" || $e === null) return $e;
              var H = $e[Symbol.toPrimitive];
              if (H !== void 0) {
                var F = H.call($e, Ht);
                if (Fr(F) !== "object") return F;
                throw new TypeError("@@toPrimitive must return a primitive value.");
              }
              return String($e);
            }(ne, "string");
            return Fr(we) === "symbol" ? we : String(we);
          }(G)) in Y ? Object.defineProperty(Y, G, { value: Q, enumerable: !0, configurable: !0, writable: !0 }) : Y[G] = Q, Y;
        }
        var Ft = { className: "", delta: 0, onSwiping: function() {
        }, onSwiped: function() {
        } }, $t = function(Y) {
          var G = Se(Se({}, Ft), Y), Q = G.children, ne = G.className, we = Gi({ delta: G.delta, onSwiping: G.onSwiping, onSwiped: G.onSwiped });
          return c().createElement("div", X({}, we, { className: ne }), Q);
        };
        $t.propTypes = { children: de.node.isRequired, className: de.string, delta: de.number, onSwiped: de.func, onSwiping: de.func };
        const Rt = $t;
        function bt(Y) {
          return bt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(G) {
            return typeof G;
          } : function(G) {
            return G && typeof Symbol == "function" && G.constructor === Symbol && G !== Symbol.prototype ? "symbol" : typeof G;
          }, bt(Y);
        }
        function Ct(Y, G) {
          var Q = Object.keys(Y);
          if (Object.getOwnPropertySymbols) {
            var ne = Object.getOwnPropertySymbols(Y);
            G && (ne = ne.filter(function(we) {
              return Object.getOwnPropertyDescriptor(Y, we).enumerable;
            })), Q.push.apply(Q, ne);
          }
          return Q;
        }
        function Zt(Y) {
          for (var G = 1; G < arguments.length; G++) {
            var Q = arguments[G] != null ? arguments[G] : {};
            G % 2 ? Ct(Object(Q), !0).forEach(function(ne) {
              ud(Y, ne, Q[ne]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Y, Object.getOwnPropertyDescriptors(Q)) : Ct(Object(Q)).forEach(function(ne) {
              Object.defineProperty(Y, ne, Object.getOwnPropertyDescriptor(Q, ne));
            });
          }
          return Y;
        }
        function Ar(Y, G) {
          for (var Q = 0; Q < G.length; Q++) {
            var ne = G[Q];
            ne.enumerable = ne.enumerable || !1, ne.configurable = !0, "value" in ne && (ne.writable = !0), Object.defineProperty(Y, $g(ne.key), ne);
          }
        }
        function Ur(Y, G) {
          return Ur = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(Q, ne) {
            return Q.__proto__ = ne, Q;
          }, Ur(Y, G);
        }
        function vo(Y, G) {
          if (G && (bt(G) === "object" || typeof G == "function")) return G;
          if (G !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
          return Ut(Y);
        }
        function Ut(Y) {
          if (Y === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return Y;
        }
        function yn(Y) {
          return yn = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(G) {
            return G.__proto__ || Object.getPrototypeOf(G);
          }, yn(Y);
        }
        function ud(Y, G, Q) {
          return (G = $g(G)) in Y ? Object.defineProperty(Y, G, { value: Q, enumerable: !0, configurable: !0, writable: !0 }) : Y[G] = Q, Y;
        }
        function $g(Y) {
          var G = function(Q, ne) {
            if (bt(Q) !== "object" || Q === null) return Q;
            var we = Q[Symbol.toPrimitive];
            if (we !== void 0) {
              var $e = we.call(Q, ne);
              if (bt($e) !== "object") return $e;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(Q);
          }(Y, "string");
          return bt(G) === "symbol" ? G : String(G);
        }
        var Ug = ["fullscreenchange", "MSFullscreenChange", "mozfullscreenchange", "webkitfullscreenchange"], lY = (0, de.arrayOf)((0, de.shape)({ srcSet: de.string, media: de.string }));
        function P8(Y) {
          var G = parseInt(Y.keyCode || Y.which || 0, 10);
          return G === 66 || G === 62;
        }
        var x5 = function(Y) {
          (function(H, F) {
            if (typeof F != "function" && F !== null) throw new TypeError("Super expression must either be null or a function");
            H.prototype = Object.create(F && F.prototype, { constructor: { value: H, writable: !0, configurable: !0 } }), Object.defineProperty(H, "prototype", { writable: !1 }), F && Ur(H, F);
          })(Ht, Y);
          var G, Q, ne, we, $e = (ne = Ht, we = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }(), function() {
            var H, F = yn(ne);
            if (we) {
              var se = yn(this).constructor;
              H = Reflect.construct(F, arguments, se);
            } else H = F.apply(this, arguments);
            return vo(this, H);
          });
          function Ht(H) {
            var F;
            return function(se, ge) {
              if (!(se instanceof ge)) throw new TypeError("Cannot call a class as a function");
            }(this, Ht), ud(Ut(F = $e.call(this, H)), "onBulletClick", function(se, ge) {
              var _e = F.props, Ce = _e.onBulletClick, mt = _e.items, ft = F.state.currentIndex;
              se.target.blur(), ft !== ge && (mt.length === 2 ? F.slideToIndexWithStyleReset(ge, se) : F.slideToIndex(ge, se)), Ce && Ce(se, ge);
            }), F.state = { currentIndex: H.startIndex, thumbsTranslate: 0, thumbsSwipedTranslate: 0, currentSlideOffset: 0, galleryWidth: 0, thumbnailsWrapperWidth: 0, thumbnailsWrapperHeight: 0, thumbsStyle: { transition: "all ".concat(H.slideDuration, "ms ease-out") }, isFullscreen: !1, isSwipingThumbnail: !1, isPlaying: !1 }, F.loadedImages = {}, F.imageGallery = c().createRef(), F.thumbnailsWrapper = c().createRef(), F.thumbnails = c().createRef(), F.imageGallerySlideWrapper = c().createRef(), F.handleImageLoaded = F.handleImageLoaded.bind(Ut(F)), F.handleKeyDown = F.handleKeyDown.bind(Ut(F)), F.handleMouseDown = F.handleMouseDown.bind(Ut(F)), F.handleResize = F.handleResize.bind(Ut(F)), F.handleTouchMove = F.handleTouchMove.bind(Ut(F)), F.handleOnSwiped = F.handleOnSwiped.bind(Ut(F)), F.handleScreenChange = F.handleScreenChange.bind(Ut(F)), F.handleSwiping = F.handleSwiping.bind(Ut(F)), F.handleThumbnailSwiping = F.handleThumbnailSwiping.bind(Ut(F)), F.handleOnThumbnailSwiped = F.handleOnThumbnailSwiped.bind(Ut(F)), F.onThumbnailMouseLeave = F.onThumbnailMouseLeave.bind(Ut(F)), F.handleImageError = F.handleImageError.bind(Ut(F)), F.pauseOrPlay = F.pauseOrPlay.bind(Ut(F)), F.renderThumbInner = F.renderThumbInner.bind(Ut(F)), F.renderItem = F.renderItem.bind(Ut(F)), F.slideLeft = F.slideLeft.bind(Ut(F)), F.slideRight = F.slideRight.bind(Ut(F)), F.toggleFullScreen = F.toggleFullScreen.bind(Ut(F)), F.togglePlay = F.togglePlay.bind(Ut(F)), F.unthrottledSlideToIndex = F.slideToIndex, F.slideToIndex = W(F.unthrottledSlideToIndex, H.slideDuration, { trailing: !1 }), H.lazyLoad && (F.lazyLoaded = []), F;
          }
          return G = Ht, Q = [{ key: "componentDidMount", value: function() {
            var H = this.props, F = H.autoPlay, se = H.useWindowKeyDown;
            F && this.play(), se ? window.addEventListener("keydown", this.handleKeyDown) : this.imageGallery.current.addEventListener("keydown", this.handleKeyDown), window.addEventListener("mousedown", this.handleMouseDown), window.addEventListener("touchmove", this.handleTouchMove, { passive: !1 }), this.initSlideWrapperResizeObserver(this.imageGallerySlideWrapper), this.initThumbnailWrapperResizeObserver(this.thumbnailsWrapper), this.addScreenChangeEvent();
          } }, { key: "componentDidUpdate", value: function(H, F) {
            var se = this.props, ge = se.items, _e = se.lazyLoad, Ce = se.slideDuration, mt = se.slideInterval, ft = se.startIndex, Lt = se.thumbnailPosition, Le = se.showThumbnails, Pe = se.useWindowKeyDown, He = this.state, Je = He.currentIndex, Et = He.isPlaying, sr = H.items.length !== ge.length, Jr = !B()(H.items, ge), Ti = H.startIndex !== ft, fi = H.thumbnailPosition !== Lt, Vn = H.showThumbnails !== Le;
            mt === H.slideInterval && Ce === H.slideDuration || Et && (this.pause(), this.play()), fi && (this.removeResizeObserver(), this.initSlideWrapperResizeObserver(this.imageGallerySlideWrapper), this.initThumbnailWrapperResizeObserver(this.thumbnailsWrapper)), Vn && Le && this.initThumbnailWrapperResizeObserver(this.thumbnailsWrapper), Vn && !Le && this.removeThumbnailsResizeObserver(), (sr || Vn) && this.handleResize(), F.currentIndex !== Je && this.slideThumbnailBar(), H.slideDuration !== Ce && (this.slideToIndex = W(this.unthrottledSlideToIndex, Ce, { trailing: !1 })), !_e || H.lazyLoad && !Jr || (this.lazyLoaded = []), Pe !== H.useWindowKeyDown && (Pe ? (this.imageGallery.current.removeEventListener("keydown", this.handleKeyDown), window.addEventListener("keydown", this.handleKeyDown)) : (window.removeEventListener("keydown", this.handleKeyDown), this.imageGallery.current.addEventListener("keydown", this.handleKeyDown))), (Ti || Jr) && this.setState({ currentIndex: ft, slideStyle: { transition: "none" } });
          } }, { key: "componentWillUnmount", value: function() {
            var H = this.props.useWindowKeyDown;
            window.removeEventListener("mousedown", this.handleMouseDown), window.removeEventListener("touchmove", this.handleTouchMove), this.removeScreenChangeEvent(), this.removeResizeObserver(), this.playPauseIntervalId && (window.clearInterval(this.playPauseIntervalId), this.playPauseIntervalId = null), this.transitionTimer && window.clearTimeout(this.transitionTimer), H ? window.removeEventListener("keydown", this.handleKeyDown) : this.imageGallery.current.removeEventListener("keydown", this.handleKeyDown);
          } }, { key: "onSliding", value: function() {
            var H = this, F = this.state, se = F.currentIndex, ge = F.isTransitioning, _e = this.props, Ce = _e.onSlide, mt = _e.slideDuration;
            this.transitionTimer = window.setTimeout(function() {
              ge && (H.setState({ isTransitioning: !ge, isSwipingThumbnail: !1 }), Ce && Ce(se));
            }, mt + 50);
          } }, { key: "onThumbnailClick", value: function(H, F) {
            var se = this.props, ge = se.onThumbnailClick, _e = se.items, Ce = this.state.currentIndex;
            H.target.parentNode.parentNode.blur(), Ce !== F && (_e.length === 2 ? this.slideToIndexWithStyleReset(F, H) : this.slideToIndex(F, H)), ge && ge(H, F);
          } }, { key: "onThumbnailMouseOver", value: function(H, F) {
            var se = this;
            this.thumbnailMouseOverTimer && (window.clearTimeout(this.thumbnailMouseOverTimer), this.thumbnailMouseOverTimer = null), this.thumbnailMouseOverTimer = window.setTimeout(function() {
              se.slideToIndex(F), se.pause();
            }, 300);
          } }, { key: "onThumbnailMouseLeave", value: function() {
            if (this.thumbnailMouseOverTimer) {
              var H = this.props.autoPlay;
              window.clearTimeout(this.thumbnailMouseOverTimer), this.thumbnailMouseOverTimer = null, H && this.play();
            }
          } }, { key: "setThumbsTranslate", value: function(H) {
            this.setState({ thumbsTranslate: H });
          } }, { key: "setModalFullscreen", value: function(H) {
            var F = this.props.onScreenChange;
            this.setState({ modalFullscreen: H }), F && F(H);
          } }, { key: "getThumbsTranslate", value: function(H) {
            var F, se = this.props, ge = se.disableThumbnailScroll, _e = se.items, Ce = this.state, mt = Ce.thumbnailsWrapperWidth, ft = Ce.thumbnailsWrapperHeight, Lt = this.thumbnails && this.thumbnails.current;
            if (ge) return 0;
            if (Lt) {
              if (this.isThumbnailVertical()) {
                if (Lt.scrollHeight <= ft) return 0;
                F = Lt.scrollHeight - ft;
              } else {
                if (Lt.scrollWidth <= mt || mt <= 0) return 0;
                F = Lt.scrollWidth - mt;
              }
              return H * (F / (_e.length - 1));
            }
            return 0;
          } }, { key: "getThumbnailPositionClassName", value: function(H) {
            switch (H) {
              case "left":
                H = " ".concat("image-gallery-thumbnails-left");
                break;
              case "right":
                H = " ".concat("image-gallery-thumbnails-right");
                break;
              case "bottom":
                H = " ".concat("image-gallery-thumbnails-bottom");
                break;
              case "top":
                H = " ".concat("image-gallery-thumbnails-top");
            }
            return H;
          } }, { key: "getAlignmentClassName", value: function(H) {
            var F = this.state.currentIndex, se = this.props, ge = se.infinite, _e = se.items, Ce = "", mt = "image-gallery-left", ft = "image-gallery-right";
            switch (H) {
              case F - 1:
                Ce = " ".concat(mt);
                break;
              case F:
                Ce = " ".concat("image-gallery-center");
                break;
              case F + 1:
                Ce = " ".concat(ft);
            }
            return _e.length >= 3 && ge && (H === 0 && F === _e.length - 1 ? Ce = " ".concat(ft) : H === _e.length - 1 && F === 0 && (Ce = " ".concat(mt))), Ce;
          } }, { key: "getTranslateXForTwoSlide", value: function(H) {
            var F = this.state, se = F.currentIndex, ge = F.currentSlideOffset, _e = F.previousIndex, Ce = se !== _e, mt = H === 0 && _e === 0, ft = H === 1 && _e === 1, Lt = H === 0 && se === 1, Le = H === 1 && se === 0, Pe = ge === 0, He = -100 * se + 100 * H + ge;
            return ge > 0 ? this.direction = "left" : ge < 0 && (this.direction = "right"), Le && ge > 0 && (He = -100 + ge), Lt && ge < 0 && (He = 100 + ge), Ce ? mt && Pe && this.direction === "left" ? He = 100 : ft && Pe && this.direction === "right" && (He = -100) : (Le && Pe && this.direction === "left" && (He = -100), Lt && Pe && this.direction === "right" && (He = 100)), He;
          } }, { key: "getThumbnailBarHeight", value: function() {
            return this.isThumbnailVertical() ? { height: this.state.gallerySlideWrapperHeight } : {};
          } }, { key: "getSlideStyle", value: function(H) {
            var F = this.state, se = F.currentIndex, ge = F.currentSlideOffset, _e = F.slideStyle, Ce = this.props, mt = Ce.infinite, ft = Ce.items, Lt = Ce.useTranslate3D, Le = Ce.isRTL, Pe = -100 * se, He = ft.length - 1, Je = (Pe + 100 * H) * (Le ? -1 : 1) + ge;
            mt && ft.length > 2 && (se === 0 && H === He ? Je = -100 * (Le ? -1 : 1) + ge : se === He && H === 0 && (Je = 100 * (Le ? -1 : 1) + ge)), mt && ft.length === 2 && (Je = this.getTranslateXForTwoSlide(H));
            var Et = "translate(".concat(Je, "%, 0)");
            return Lt && (Et = "translate3d(".concat(Je, "%, 0, 0)")), Zt({ display: this.isSlideVisible(H) ? "inherit" : "none", WebkitTransform: Et, MozTransform: Et, msTransform: Et, OTransform: Et, transform: Et }, _e);
          } }, { key: "getCurrentIndex", value: function() {
            return this.state.currentIndex;
          } }, { key: "getThumbnailStyle", value: function() {
            var H, F = this.props, se = F.useTranslate3D, ge = F.isRTL, _e = this.state, Ce = _e.thumbsTranslate, mt = _e.thumbsStyle, ft = ge ? -1 * Ce : Ce;
            return this.isThumbnailVertical() ? (H = "translate(0, ".concat(Ce, "px)"), se && (H = "translate3d(0, ".concat(Ce, "px, 0)"))) : (H = "translate(".concat(ft, "px, 0)"), se && (H = "translate3d(".concat(ft, "px, 0, 0)"))), Zt({ WebkitTransform: H, MozTransform: H, msTransform: H, OTransform: H, transform: H }, mt);
          } }, { key: "getSlideItems", value: function() {
            var H = this, F = this.state.currentIndex, se = this.props, ge = se.items, _e = se.slideOnThumbnailOver, Ce = se.onClick, mt = se.lazyLoad, ft = se.onTouchMove, Lt = se.onTouchEnd, Le = se.onTouchStart, Pe = se.onMouseOver, He = se.onMouseLeave, Je = se.renderItem, Et = se.renderThumbInner, sr = se.showThumbnails, Jr = se.showBullets, Ti = [], fi = [], Vn = [];
            return ge.forEach(function(Hr, lr) {
              var ul = H.getAlignmentClassName(lr), Dh = Hr.originalClass ? " ".concat(Hr.originalClass) : "", Th = Hr.thumbnailClass ? " ".concat(Hr.thumbnailClass) : "", ds = Hr.renderItem || Je || H.renderItem, wu = Hr.renderThumbInner || Et || H.renderThumbInner, go = !mt || ul || H.lazyLoaded[lr];
              go && mt && !H.lazyLoaded[lr] && (H.lazyLoaded[lr] = !0);
              var cd = H.getSlideStyle(lr), Mh = c().createElement("div", { "aria-label": "Go to Slide ".concat(lr + 1), key: "slide-".concat(lr), tabIndex: "-1", className: "image-gallery-slide ".concat(ul, " ").concat(Dh), style: cd, onClick: Ce, onKeyUp: H.handleSlideKeyUp, onTouchMove: ft, onTouchEnd: Lt, onTouchStart: Le, onMouseOver: Pe, onFocus: Pe, onMouseLeave: He, role: "button" }, go ? ds(Hr) : c().createElement("div", { style: { height: "100%" } }));
              if (Ti.push(Mh), sr && Hr.thumbnail) {
                var dd = l("image-gallery-thumbnail", Th, { active: F === lr });
                fi.push(c().createElement("button", { key: "thumbnail-".concat(lr), type: "button", tabIndex: "0", "aria-pressed": F === lr ? "true" : "false", "aria-label": "Go to Slide ".concat(lr + 1), className: dd, onMouseLeave: _e ? H.onThumbnailMouseLeave : null, onMouseOver: function(Fi) {
                  return H.handleThumbnailMouseOver(Fi, lr);
                }, onFocus: function(Fi) {
                  return H.handleThumbnailMouseOver(Fi, lr);
                }, onKeyUp: function(Fi) {
                  return H.handleThumbnailKeyUp(Fi, lr);
                }, onClick: function(Fi) {
                  return H.onThumbnailClick(Fi, lr);
                } }, wu(Hr)));
              }
              if (Jr) {
                var Rh = l("image-gallery-bullet", Hr.bulletClass, { active: F === lr });
                Vn.push(c().createElement("button", { type: "button", key: "bullet-".concat(lr), className: Rh, onClick: function(Fi) {
                  return H.onBulletClick(Fi, lr);
                }, "aria-pressed": F === lr ? "true" : "false", "aria-label": "Go to Slide ".concat(lr + 1) }));
              }
            }), { slides: Ti, thumbnails: fi, bullets: Vn };
          } }, { key: "ignoreIsTransitioning", value: function() {
            var H = this.props.items, F = this.state, se = F.previousIndex, ge = F.currentIndex, _e = H.length - 1;
            return Math.abs(se - ge) > 1 && !(se === 0 && ge === _e) && !(se === _e && ge === 0);
          } }, { key: "isFirstOrLastSlide", value: function(H) {
            return H === this.props.items.length - 1 || H === 0;
          } }, { key: "slideIsTransitioning", value: function(H) {
            var F = this.state, se = F.isTransitioning, ge = F.previousIndex, _e = F.currentIndex;
            return se && !(H === ge || H === _e);
          } }, { key: "isSlideVisible", value: function(H) {
            return !this.slideIsTransitioning(H) || this.ignoreIsTransitioning() && !this.isFirstOrLastSlide(H);
          } }, { key: "slideThumbnailBar", value: function() {
            var H = this.state, F = H.currentIndex, se = H.isSwipingThumbnail, ge = -this.getThumbsTranslate(F);
            se || (F === 0 ? this.setState({ thumbsTranslate: 0, thumbsSwipedTranslate: 0 }) : this.setState({ thumbsTranslate: ge, thumbsSwipedTranslate: ge }));
          } }, { key: "canSlide", value: function() {
            return this.props.items.length >= 2;
          } }, { key: "canSlideLeft", value: function() {
            return this.props.infinite || this.canSlidePrevious();
          } }, { key: "canSlideRight", value: function() {
            return this.props.infinite || this.canSlideNext();
          } }, { key: "canSlidePrevious", value: function() {
            return this.state.currentIndex > 0;
          } }, { key: "canSlideNext", value: function() {
            return this.state.currentIndex < this.props.items.length - 1;
          } }, { key: "handleSwiping", value: function(H) {
            var F = H.event, se = H.absX, ge = H.dir, _e = this.props, Ce = _e.disableSwipe, mt = _e.stopPropagation, ft = this.state, Lt = ft.galleryWidth, Le = ft.isTransitioning, Pe = ft.swipingUpDown, He = ft.swipingLeftRight;
            if (ge !== $r && ge !== kr && !Pe || He) {
              if (ge !== Ot && ge !== or || He || this.setState({ swipingLeftRight: !0 }), !Ce) {
                var Je = this.props.swipingTransitionDuration;
                if (mt && F.preventDefault(), Le) this.setState({ currentSlideOffset: 0 });
                else {
                  var Et = ge === or ? 1 : -1, sr = se / Lt * 100;
                  Math.abs(sr) >= 100 && (sr = 100);
                  var Jr = { transition: "transform ".concat(Je, "ms ease-out") };
                  this.setState({ currentSlideOffset: Et * sr, slideStyle: Jr });
                }
              }
            } else Pe || this.setState({ swipingUpDown: !0 });
          } }, { key: "handleThumbnailSwiping", value: function(H) {
            var F = H.event, se = H.absX, ge = H.absY, _e = H.dir, Ce = this.props, mt = Ce.stopPropagation, ft = Ce.swipingThumbnailTransitionDuration, Lt = this.state, Le = Lt.thumbsSwipedTranslate, Pe = Lt.thumbnailsWrapperHeight, He = Lt.thumbnailsWrapperWidth, Je = Lt.swipingUpDown, Et = Lt.swipingLeftRight;
            if (this.isThumbnailVertical()) {
              if ((_e === Ot || _e === or || Et) && !Je) return void (Et || this.setState({ swipingLeftRight: !0 }));
              _e !== $r && _e !== kr || Je || this.setState({ swipingUpDown: !0 });
            } else {
              if ((_e === $r || _e === kr || Je) && !Et) return void (Je || this.setState({ swipingUpDown: !0 }));
              _e !== Ot && _e !== or || Et || this.setState({ swipingLeftRight: !0 });
            }
            var sr, Jr, Ti, fi, Vn, Hr = this.thumbnails && this.thumbnails.current;
            if (this.isThumbnailVertical() ? (sr = Le + (_e === kr ? ge : -ge), Jr = Hr.scrollHeight - Pe + 20, Ti = Math.abs(sr) > Jr, fi = sr > 20, Vn = Hr.scrollHeight <= Pe) : (sr = Le + (_e === or ? se : -se), Jr = Hr.scrollWidth - He + 20, Ti = Math.abs(sr) > Jr, fi = sr > 20, Vn = Hr.scrollWidth <= He), !Vn && (_e !== Ot && _e !== $r || !Ti) && (_e !== or && _e !== kr || !fi)) {
              mt && F.stopPropagation();
              var lr = { transition: "transform ".concat(ft, "ms ease-out") };
              this.setState({ thumbsTranslate: sr, thumbsStyle: lr });
            }
          } }, { key: "handleOnThumbnailSwiped", value: function() {
            var H = this.state.thumbsTranslate, F = this.props.slideDuration;
            this.resetSwipingDirection(), this.setState({ isSwipingThumbnail: !0, thumbsSwipedTranslate: H, thumbsStyle: { transition: "all ".concat(F, "ms ease-out") } });
          } }, { key: "sufficientSwipe", value: function() {
            var H = this.state.currentSlideOffset, F = this.props.swipeThreshold;
            return Math.abs(H) > F;
          } }, { key: "resetSwipingDirection", value: function() {
            var H = this.state, F = H.swipingUpDown, se = H.swipingLeftRight;
            F && this.setState({ swipingUpDown: !1 }), se && this.setState({ swipingLeftRight: !1 });
          } }, { key: "handleOnSwiped", value: function(H) {
            var F = H.event, se = H.dir, ge = H.velocity, _e = this.props, Ce = _e.disableSwipe, mt = _e.stopPropagation, ft = _e.flickThreshold;
            if (!Ce) {
              var Lt = this.props.isRTL;
              mt && F.stopPropagation(), this.resetSwipingDirection();
              var Le = (se === Ot ? 1 : -1) * (Lt ? -1 : 1), Pe = ge > ft && !(se === $r || se === kr);
              this.handleOnSwipedTo(Le, Pe);
            }
          } }, { key: "handleOnSwipedTo", value: function(H, F) {
            var se = this.state, ge = se.currentIndex, _e = se.isTransitioning, Ce = ge;
            !this.sufficientSwipe() && !F || _e || (Ce += H), (H === -1 && !this.canSlideLeft() || H === 1 && !this.canSlideRight()) && (Ce = ge), this.unthrottledSlideToIndex(Ce);
          } }, { key: "handleTouchMove", value: function(H) {
            this.state.swipingLeftRight && H.preventDefault();
          } }, { key: "handleMouseDown", value: function() {
            this.imageGallery.current.classList.add("image-gallery-using-mouse");
          } }, { key: "handleKeyDown", value: function(H) {
            var F = this.props, se = F.disableKeyDown, ge = F.useBrowserFullscreen, _e = this.state.isFullscreen;
            if (this.imageGallery.current.classList.remove("image-gallery-using-mouse"), !se) switch (parseInt(H.keyCode || H.which || 0, 10)) {
              case 37:
                this.canSlideLeft() && !this.playPauseIntervalId && this.slideLeft(H);
                break;
              case 39:
                this.canSlideRight() && !this.playPauseIntervalId && this.slideRight(H);
                break;
              case 27:
                _e && !ge && this.exitFullScreen();
            }
          } }, { key: "handleImageError", value: function(H) {
            var F = this.props.onErrorImageURL;
            F && H.target.src.indexOf(F) === -1 && (H.target.src = F);
          } }, { key: "removeThumbnailsResizeObserver", value: function() {
            this.resizeThumbnailWrapperObserver && this.thumbnailsWrapper && this.thumbnailsWrapper.current && (this.resizeThumbnailWrapperObserver.unobserve(this.thumbnailsWrapper.current), this.resizeThumbnailWrapperObserver = null);
          } }, { key: "removeResizeObserver", value: function() {
            this.resizeSlideWrapperObserver && this.imageGallerySlideWrapper && this.imageGallerySlideWrapper.current && (this.resizeSlideWrapperObserver.unobserve(this.imageGallerySlideWrapper.current), this.resizeSlideWrapperObserver = null), this.removeThumbnailsResizeObserver();
          } }, { key: "handleResize", value: function() {
            var H = this.state.currentIndex;
            this.imageGallery && (this.imageGallery && this.imageGallery.current && this.setState({ galleryWidth: this.imageGallery.current.offsetWidth }), this.imageGallerySlideWrapper && this.imageGallerySlideWrapper.current && this.setState({ gallerySlideWrapperHeight: this.imageGallerySlideWrapper.current.offsetHeight }), this.setThumbsTranslate(-this.getThumbsTranslate(H)));
          } }, { key: "initSlideWrapperResizeObserver", value: function(H) {
            var F = this;
            H && !H.current || (this.resizeSlideWrapperObserver = new Dt(O(function(se) {
              se && se.forEach(function(ge) {
                F.setState({ thumbnailsWrapperWidth: ge.contentRect.width }, F.handleResize);
              });
            }, 50)), this.resizeSlideWrapperObserver.observe(H.current));
          } }, { key: "initThumbnailWrapperResizeObserver", value: function(H) {
            var F = this;
            H && !H.current || (this.resizeThumbnailWrapperObserver = new Dt(O(function(se) {
              se && se.forEach(function(ge) {
                F.setState({ thumbnailsWrapperHeight: ge.contentRect.height }, F.handleResize);
              });
            }, 50)), this.resizeThumbnailWrapperObserver.observe(H.current));
          } }, { key: "toggleFullScreen", value: function() {
            this.state.isFullscreen ? this.exitFullScreen() : this.fullScreen();
          } }, { key: "togglePlay", value: function() {
            this.playPauseIntervalId ? this.pause() : this.play();
          } }, { key: "handleScreenChange", value: function() {
            var H = this.props, F = H.onScreenChange, se = H.useBrowserFullscreen, ge = document.fullscreenElement || document.msFullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement, _e = this.imageGallery.current === ge;
            F && F(_e), se && this.setState({ isFullscreen: _e });
          } }, { key: "slideToIndex", value: function(H, F) {
            var se = this.state, ge = se.currentIndex, _e = se.isTransitioning, Ce = this.props, mt = Ce.items, ft = Ce.slideDuration, Lt = Ce.onBeforeSlide;
            if (!_e) {
              F && this.playPauseIntervalId && (this.pause(!1), this.play(!1));
              var Le = mt.length - 1, Pe = H;
              H < 0 ? Pe = Le : H > Le && (Pe = 0), Lt && Pe !== ge && Lt(Pe), this.setState({ previousIndex: ge, currentIndex: Pe, isTransitioning: Pe !== ge, currentSlideOffset: 0, slideStyle: { transition: "all ".concat(ft, "ms ease-out") } }, this.onSliding);
            }
          } }, { key: "slideLeft", value: function(H) {
            var F = this.props.isRTL;
            this.slideTo(H, F ? "right" : "left");
          } }, { key: "slideRight", value: function(H) {
            var F = this.props.isRTL;
            this.slideTo(H, F ? "left" : "right");
          } }, { key: "slideTo", value: function(H, F) {
            var se = this.state, ge = se.currentIndex, _e = se.isTransitioning, Ce = this.props.items, mt = ge + (F === "left" ? -1 : 1);
            _e || (Ce.length === 2 ? this.slideToIndexWithStyleReset(mt, H) : this.slideToIndex(mt, H));
          } }, { key: "slideToIndexWithStyleReset", value: function(H, F) {
            var se = this, ge = this.state, _e = ge.currentIndex, Ce = ge.currentSlideOffset;
            this.setState({ currentSlideOffset: Ce + (_e > H ? 1e-3 : -1e-3), slideStyle: { transition: "none" } }, function() {
              window.setTimeout(function() {
                return se.slideToIndex(H, F);
              }, 25);
            });
          } }, { key: "handleThumbnailMouseOver", value: function(H, F) {
            this.props.slideOnThumbnailOver && this.onThumbnailMouseOver(H, F);
          } }, { key: "handleThumbnailKeyUp", value: function(H, F) {
            P8(H) && this.onThumbnailClick(H, F);
          } }, { key: "handleSlideKeyUp", value: function(H) {
            P8(H) && (0, this.props.onClick)(H);
          } }, { key: "isThumbnailVertical", value: function() {
            var H = this.props.thumbnailPosition;
            return H === "left" || H === "right";
          } }, { key: "addScreenChangeEvent", value: function() {
            var H = this;
            Ug.forEach(function(F) {
              document.addEventListener(F, H.handleScreenChange);
            });
          } }, { key: "removeScreenChangeEvent", value: function() {
            var H = this;
            Ug.forEach(function(F) {
              document.removeEventListener(F, H.handleScreenChange);
            });
          } }, { key: "fullScreen", value: function() {
            var H = this.props.useBrowserFullscreen, F = this.imageGallery.current;
            H ? F.requestFullscreen ? F.requestFullscreen() : F.msRequestFullscreen ? F.msRequestFullscreen() : F.mozRequestFullScreen ? F.mozRequestFullScreen() : F.webkitRequestFullscreen ? F.webkitRequestFullscreen() : this.setModalFullscreen(!0) : this.setModalFullscreen(!0), this.setState({ isFullscreen: !0 });
          } }, { key: "exitFullScreen", value: function() {
            var H = this.state.isFullscreen, F = this.props.useBrowserFullscreen;
            H && (F ? document.exitFullscreen ? document.exitFullscreen() : document.webkitExitFullscreen ? document.webkitExitFullscreen() : document.mozCancelFullScreen ? document.mozCancelFullScreen() : document.msExitFullscreen ? document.msExitFullscreen() : this.setModalFullscreen(!1) : this.setModalFullscreen(!1), this.setState({ isFullscreen: !1 }));
          } }, { key: "pauseOrPlay", value: function() {
            var H = this.props.infinite, F = this.state.currentIndex;
            H || this.canSlideRight() ? this.slideToIndex(F + 1) : this.pause();
          } }, { key: "play", value: function() {
            var H = !(arguments.length > 0 && arguments[0] !== void 0) || arguments[0], F = this.props, se = F.onPlay, ge = F.slideInterval, _e = F.slideDuration, Ce = this.state.currentIndex;
            this.playPauseIntervalId || (this.setState({ isPlaying: !0 }), this.playPauseIntervalId = window.setInterval(this.pauseOrPlay, Math.max(ge, _e)), se && H && se(Ce));
          } }, { key: "pause", value: function() {
            var H = !(arguments.length > 0 && arguments[0] !== void 0) || arguments[0], F = this.props.onPause, se = this.state.currentIndex;
            this.playPauseIntervalId && (window.clearInterval(this.playPauseIntervalId), this.playPauseIntervalId = null, this.setState({ isPlaying: !1 }), F && H && F(se));
          } }, { key: "isImageLoaded", value: function(H) {
            return !!this.loadedImages[H.original] || (this.loadedImages[H.original] = !0, !1);
          } }, { key: "handleImageLoaded", value: function(H, F) {
            var se = this.props.onImageLoad;
            !this.loadedImages[F] && se && (this.loadedImages[F] = !0, se(H));
          } }, { key: "renderItem", value: function(H) {
            var F = this.state.isFullscreen, se = this.props.onImageError || this.handleImageError;
            return c().createElement(Nn, { description: H.description, fullscreen: H.fullscreen, handleImageLoaded: this.handleImageLoaded, isFullscreen: F, onImageError: se, original: H.original, originalAlt: H.originalAlt, originalHeight: H.originalHeight, originalWidth: H.originalWidth, originalTitle: H.originalTitle, sizes: H.sizes, loading: H.loading, srcSet: H.srcSet });
          } }, { key: "renderThumbInner", value: function(H) {
            var F = this.props.onThumbnailError || this.handleImageError;
            return c().createElement("span", { className: "image-gallery-thumbnail-inner" }, c().createElement("img", { className: "image-gallery-thumbnail-image", src: H.thumbnail, height: H.thumbnailHeight, width: H.thumbnailWidth, alt: H.thumbnailAlt, title: H.thumbnailTitle, loading: H.thumbnailLoading, onError: F }), H.thumbnailLabel && c().createElement("div", { className: "image-gallery-thumbnail-label" }, H.thumbnailLabel));
          } }, { key: "render", value: function() {
            var H = this.state, F = H.currentIndex, se = H.isFullscreen, ge = H.modalFullscreen, _e = H.isPlaying, Ce = this.props, mt = Ce.additionalClass, ft = Ce.disableThumbnailSwipe, Lt = Ce.indexSeparator, Le = Ce.isRTL, Pe = Ce.items, He = Ce.thumbnailPosition, Je = Ce.renderFullscreenButton, Et = Ce.renderCustomControls, sr = Ce.renderLeftNav, Jr = Ce.renderRightNav, Ti = Ce.showBullets, fi = Ce.showFullscreenButton, Vn = Ce.showIndex, Hr = Ce.showThumbnails, lr = Ce.showNav, ul = Ce.showPlayButton, Dh = Ce.renderPlayPauseButton, Th = this.getThumbnailStyle(), ds = this.getSlideItems(), wu = ds.slides, go = ds.thumbnails, cd = ds.bullets, Mh = l("image-gallery-slide-wrapper", this.getThumbnailPositionClassName(He), { "image-gallery-rtl": Le }), dd = c().createElement("div", { ref: this.imageGallerySlideWrapper, className: Mh }, Et && Et(), this.canSlide() ? c().createElement(c().Fragment, null, lr && c().createElement(c().Fragment, null, sr(this.slideLeft, !this.canSlideLeft()), Jr(this.slideRight, !this.canSlideRight())), c().createElement(Rt, { className: "image-gallery-swipe", delta: 0, onSwiping: this.handleSwiping, onSwiped: this.handleOnSwiped }, c().createElement("div", { className: "image-gallery-slides" }, wu))) : c().createElement("div", { className: "image-gallery-slides" }, wu), ul && Dh(this.togglePlay, _e), Ti && c().createElement("div", { className: "image-gallery-bullets" }, c().createElement("div", { className: "image-gallery-bullets-container", role: "navigation", "aria-label": "Bullet Navigation" }, cd)), fi && Je(this.toggleFullScreen, se), Vn && c().createElement("div", { className: "image-gallery-index" }, c().createElement("span", { className: "image-gallery-index-current" }, F + 1), c().createElement("span", { className: "image-gallery-index-separator" }, Lt), c().createElement("span", { className: "image-gallery-index-total" }, Pe.length))), Rh = l("image-gallery", mt, { "fullscreen-modal": ge }), Fi = l("image-gallery-content", this.getThumbnailPositionClassName(He), { fullscreen: se }), cY = l("image-gallery-thumbnails-wrapper", this.getThumbnailPositionClassName(He), { "thumbnails-wrapper-rtl": !this.isThumbnailVertical() && Le }, { "thumbnails-swipe-horizontal": !this.isThumbnailVertical() && !ft }, { "thumbnails-swipe-vertical": this.isThumbnailVertical() && !ft });
            return c().createElement("div", { ref: this.imageGallery, className: Rh, "aria-live": "polite" }, c().createElement("div", { className: Fi }, (He === "bottom" || He === "right") && dd, Hr && go.length > 0 ? c().createElement(Rt, { className: cY, delta: 0, onSwiping: !ft && this.handleThumbnailSwiping, onSwiped: !ft && this.handleOnThumbnailSwiped }, c().createElement("div", { className: "image-gallery-thumbnails", ref: this.thumbnailsWrapper, style: this.getThumbnailBarHeight() }, c().createElement("nav", { ref: this.thumbnails, className: "image-gallery-thumbnails-container", style: Th, "aria-label": "Thumbnail Navigation" }, go))) : null, (He === "top" || He === "left") && dd));
          } }], Q && Ar(G.prototype, Q), Object.defineProperty(G, "prototype", { writable: !1 }), Ht;
        }(c().Component);
        x5.propTypes = { flickThreshold: de.number, items: (0, de.arrayOf)((0, de.shape)({ bulletClass: de.string, bulletOnClick: de.func, description: de.string, original: de.string, originalHeight: de.number, originalWidth: de.number, loading: de.string, thumbnailHeight: de.number, thumbnailWidth: de.number, thumbnailLoading: de.string, fullscreen: de.string, originalAlt: de.string, originalTitle: de.string, thumbnail: de.string, thumbnailAlt: de.string, thumbnailLabel: de.string, thumbnailTitle: de.string, originalClass: de.string, thumbnailClass: de.string, renderItem: de.func, renderThumbInner: de.func, imageSet: lY, srcSet: de.string, sizes: de.string })).isRequired, showNav: de.bool, autoPlay: de.bool, lazyLoad: de.bool, infinite: de.bool, showIndex: de.bool, showBullets: de.bool, showThumbnails: de.bool, showPlayButton: de.bool, showFullscreenButton: de.bool, disableThumbnailScroll: de.bool, disableKeyDown: de.bool, disableSwipe: de.bool, disableThumbnailSwipe: de.bool, useBrowserFullscreen: de.bool, onErrorImageURL: de.string, indexSeparator: de.string, thumbnailPosition: (0, de.oneOf)(["top", "bottom", "left", "right"]), startIndex: de.number, slideDuration: de.number, slideInterval: de.number, slideOnThumbnailOver: de.bool, swipeThreshold: de.number, swipingTransitionDuration: de.number, swipingThumbnailTransitionDuration: de.number, onSlide: de.func, onBeforeSlide: de.func, onScreenChange: de.func, onPause: de.func, onPlay: de.func, onClick: de.func, onImageLoad: de.func, onImageError: de.func, onTouchMove: de.func, onTouchEnd: de.func, onTouchStart: de.func, onMouseOver: de.func, onMouseLeave: de.func, onBulletClick: de.func, onThumbnailError: de.func, onThumbnailClick: de.func, renderCustomControls: de.func, renderLeftNav: de.func, renderRightNav: de.func, renderPlayPauseButton: de.func, renderFullscreenButton: de.func, renderItem: de.func, renderThumbInner: de.func, stopPropagation: de.bool, additionalClass: de.string, useTranslate3D: de.bool, isRTL: de.bool, useWindowKeyDown: de.bool }, x5.defaultProps = { onErrorImageURL: "", additionalClass: "", showNav: !0, autoPlay: !1, lazyLoad: !1, infinite: !0, showIndex: !1, showBullets: !1, showThumbnails: !0, showPlayButton: !0, showFullscreenButton: !0, disableThumbnailScroll: !1, disableKeyDown: !1, disableSwipe: !1, disableThumbnailSwipe: !1, useTranslate3D: !0, isRTL: !1, useBrowserFullscreen: !0, flickThreshold: 0.4, stopPropagation: !1, indexSeparator: " / ", thumbnailPosition: "bottom", startIndex: 0, slideDuration: 450, swipingTransitionDuration: 0, swipingThumbnailTransitionDuration: 0, onSlide: null, onBeforeSlide: null, onScreenChange: null, onPause: null, onPlay: null, onClick: null, onImageLoad: null, onImageError: null, onTouchMove: null, onTouchEnd: null, onTouchStart: null, onMouseOver: null, onMouseLeave: null, onBulletClick: null, onThumbnailError: null, onThumbnailClick: null, renderCustomControls: null, renderThumbInner: null, renderItem: null, slideInterval: 3e3, slideOnThumbnailOver: !1, swipeThreshold: 30, renderLeftNav: function(Y, G) {
          return c().createElement(it, { onClick: Y, disabled: G });
        }, renderRightNav: function(Y, G) {
          return c().createElement(hn, { onClick: Y, disabled: G });
        }, renderPlayPauseButton: function(Y, G) {
          return c().createElement(Di, { onClick: Y, isPlaying: G });
        }, renderFullscreenButton: function(Y, G) {
          return c().createElement(Ie, { onClick: Y, isFullscreen: G });
        }, useWindowKeyDown: !0 };
        const uY = x5;
      })(), o;
    })());
  }(rm)), rm.exports;
}
var W7e = z7e();
const Z7e = /* @__PURE__ */ Yy(W7e), j7e = (t) => /* @__PURE__ */ $.createElement("svg", { width: 16, height: 14, viewBox: "0 0 16 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ $.createElement("path", { id: "ô°", d: "M0 6.99965C0 6.74568 0.110053 6.49171 0.304762 6.31393L5.86667 0.743562C6.08677 0.531922 6.31534 0.447266 6.54392 0.447266C7.07725 0.447266 7.4582 0.819752 7.4582 1.32769C7.4582 1.59012 7.35661 1.81869 7.1873 1.98801L5.29101 3.9097L2.79365 6.19541L4.76614 6.0769H15.0603C15.6106 6.0769 16 6.44938 16 6.99965C16 7.54145 15.6106 7.9224 15.0603 7.9224H4.76614L2.78519 7.80388L5.29101 10.0896L7.1873 12.0113C7.35661 12.1721 7.4582 12.4007 7.4582 12.6631C7.4582 13.1711 7.07725 13.552 6.54392 13.552C6.31534 13.552 6.08677 13.4589 5.8836 13.2642L0.304762 7.68536C0.110053 7.49912 0 7.25361 0 6.99965Z", fill: "#3548C9" })), Y7e = (t) => /* @__PURE__ */ $.createElement("svg", { width: 16, height: 14, viewBox: "0 0 16 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ $.createElement("path", { id: "ô«", d: "M16 6.99965C16 7.25361 15.8899 7.49912 15.6952 7.68536L10.1079 13.2642C9.90476 13.4589 9.68466 13.552 9.44762 13.552C8.92275 13.552 8.5418 13.1711 8.5418 12.6631C8.5418 12.4007 8.64339 12.1721 8.8127 12.0113L10.709 10.0896L13.2063 7.80388L11.2339 7.9224H0.939683C0.380952 7.9224 0 7.54145 0 6.99965C0 6.44938 0.380952 6.0769 0.939683 6.0769H11.2339L13.1979 6.19541L10.709 3.9097L8.8127 1.98801C8.64339 1.81869 8.5418 1.59012 8.5418 1.32769C8.5418 0.819752 8.92275 0.447266 9.44762 0.447266C9.68466 0.447266 9.91323 0.531922 10.1249 0.743562L15.6952 6.31393C15.8899 6.49171 16 6.74568 16 6.99965Z", fill: "#253858" })), X8e = (t) => {
  const { images: r, className: e = "" } = t;
  return /* @__PURE__ */ S.jsx(
    Z7e,
    {
      items: r,
      additionalClass: `theme-gallery ${e}`,
      showFullscreenButton: !1,
      showPlayButton: !1,
      renderLeftNav: (n, i) => /* @__PURE__ */ S.jsx(S.Fragment, { children: !i && /* @__PURE__ */ S.jsx(
        "div",
        {
          className: "theme-gallery-arrow theme-gallery-arrow-left",
          onClick: n,
          children: /* @__PURE__ */ S.jsx(j7e, {})
        }
      ) }),
      renderRightNav: (n, i) => /* @__PURE__ */ S.jsx(S.Fragment, { children: !i && /* @__PURE__ */ S.jsx(
        "div",
        {
          className: "theme-gallery-arrow theme-gallery-arrow-right",
          onClick: n,
          children: /* @__PURE__ */ S.jsx(Y7e, {})
        }
      ) })
    }
  );
}, $8e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), U8e = (t) => {
  const { items: r, className: e = "" } = t, n = ui();
  return /* @__PURE__ */ S.jsx("div", { className: `theme-list-horizontal-card ${e}`, children: r.map((i, a) => /* @__PURE__ */ S.jsx("div", { children: i }, `${n}-horizontal-card-list-${a}`)) });
}, X7e = (t) => /* @__PURE__ */ $.createElement("svg", { width: 14, height: 17, viewBox: "0 0 14 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ $.createElement("g", { id: "icon-chevron-right" }, /* @__PURE__ */ $.createElement("path", { id: "ô¯»", d: "M10.7424 8.5C10.7424 8.71397 10.6681 8.89301 10.4847 9.06769L7.18341 12.3035C7.0524 12.4345 6.89083 12.5 6.69869 12.5C6.31441 12.5 6 12.19 6 11.8057C6 11.6092 6.0786 11.4345 6.22271 11.2904L9.10044 8.49563L6.22271 5.70524C6.0786 5.5655 6 5.38646 6 5.19432C6 4.81441 6.31441 4.5 6.69869 4.5C6.89083 4.5 7.0524 4.5655 7.18341 4.69651L10.4847 7.93231C10.6638 8.10262 10.7424 8.28166 10.7424 8.5Z", fill: "#3548C9" }))), J8e = (t) => {
  const { items: r, className: e = "" } = t, n = ui();
  return /* @__PURE__ */ S.jsx("div", { className: `theme-list-horizontal-legend ${e}`, children: r.map((i, a) => /* @__PURE__ */ S.jsxs(
    "div",
    {
      className: "theme-list-horizontal-legend-item",
      children: [
        /* @__PURE__ */ S.jsxs(
          "div",
          {
            className: "theme-list-horizontal-legend-heading",
            onClick: () => i.headingOnClick && i.headingOnClick(),
            children: [
              i.headingWithCircle && i.headingCircleColor && /* @__PURE__ */ S.jsx(
                "span",
                {
                  className: "theme-list-horizontal-legend-heading-circle",
                  style: {
                    backgroundColor: i.headingCircleColor
                  }
                }
              ),
              /* @__PURE__ */ S.jsx("span", { className: "theme-list-horizontal-legend-heading-title", children: i.heading }),
              i.headingWithArrow && /* @__PURE__ */ S.jsx(X7e, {})
            ]
          }
        ),
        /* @__PURE__ */ S.jsx("div", { className: "theme-list-horizontal-legend-content", children: i.content })
      ]
    },
    `${n}-horizontal-legend-list-${a}`
  )) });
}, $7e = (t) => /* @__PURE__ */ $.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ $.createElement("path", { d: "M10.86 27.3668C9.69892 27.3668 9 26.7356 9 25.7999C9 24.6163 10.0822 23.5904 11.0968 22.6097C11.8859 21.8431 12.0775 20.2311 12.2128 18.7543C12.3706 14.6059 13.5768 11.6862 16.5077 10.6266C16.9699 9.13856 18.1874 8 19.8558 8C21.5242 8 22.7417 9.13856 23.2039 10.6266C26.1348 11.6862 27.341 14.6059 27.4988 18.7543C27.6454 20.2311 27.8257 21.8431 28.6148 22.6097C29.6294 23.5904 30.7229 24.6163 30.7229 25.7999C30.7229 26.7356 30.0127 27.3668 28.8628 27.3668H10.86ZM19.8558 32C17.8718 32 16.4176 30.5796 16.271 28.9338H23.4519C23.294 30.5796 21.8511 32 19.8558 32Z", fill: "white" })), U7e = (t) => /* @__PURE__ */ $.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ $.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 25.7999C9 26.7356 9.69892 27.3668 10.86 27.3668H28.8628C30.0127 27.3668 30.7229 26.7356 30.7229 25.7999C30.7229 24.6458 29.6834 23.6418 28.6911 22.6833C28.6656 22.6587 28.6402 22.6342 28.6148 22.6097C27.8934 21.8995 27.6792 20.434 27.5777 19.1714C27.5439 18.4387 27.4876 17.7398 27.3974 17.0634C26.8112 17.3114 26.1574 17.458 25.481 17.458C22.4711 17.458 20.0023 14.9892 20.0023 11.9793C20.0023 10.5928 20.5322 9.3302 21.3889 8.37201C20.938 8.124 20.4194 8 19.8558 8C18.1874 8 16.9699 9.13856 16.5077 10.6266C13.5768 11.6862 12.3706 14.6059 12.2128 18.7543C12.0775 20.2311 11.8859 21.8431 11.0968 22.6097C11.08 22.6259 11.0631 22.6422 11.0463 22.6584C10.0466 23.6244 9 24.6359 9 25.7999ZM16.271 28.9338C16.4176 30.5796 17.8718 32 19.8671 32C21.8511 32 23.3053 30.5796 23.4519 28.9338H16.271Z", fill: "white" }), /* @__PURE__ */ $.createElement("circle", { cx: 26, cy: 12, r: 4, fill: "#EB4553" })), J7e = (t) => /* @__PURE__ */ $.createElement("svg", { width: 100, height: 100, viewBox: "0 0 100 100", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ $.createElement("rect", { x: 16.6665, y: 16.6665, width: 66.6667, height: 66.6667, rx: 8, fill: "#E7E9ED" }), /* @__PURE__ */ $.createElement("path", { d: "M32.3665 85.5307C32.2535 85.3272 32.0952 85.0333 32.0274 84.7847C31.9822 84.6716 31.937 84.5134 31.8918 84.3777C31.824 84.1291 31.7561 83.8126 31.7109 83.5865C31.7109 83.5865 31.6431 83.1796 31.6431 82.7049C31.6431 82.1623 31.7109 81.7554 31.7109 81.7554C31.7335 81.5972 31.7561 81.4163 31.8013 81.2581C31.8465 81.0772 31.8918 80.8512 31.9596 80.6703C32.0726 80.3086 32.2534 79.8339 32.4117 79.4722C32.5473 79.1783 32.7508 78.7714 32.909 78.5001C33.1803 78.048 33.5646 77.4376 33.8585 77.0081C34.288 76.4203 34.8758 75.6517 35.3505 75.0865C35.441 74.9961 35.5087 74.9057 35.5765 74.8153C35.5765 74.8831 35.5766 74.9735 35.5992 75.0414C35.2601 75.4709 34.9436 75.8778 34.6723 76.2847C32.4343 79.4722 32.8638 80.919 35.3279 80.6477C36.6391 80.5121 38.5154 79.8791 40.8665 78.7714C42.3811 78.1384 44.1444 77.2341 46.1337 76.0812C54.4302 71.3113 63.7893 63.7834 68.2653 58.4257C69.1696 57.431 69.9381 56.4815 70.5485 55.6225C71.0685 54.8765 71.4528 54.2209 71.7015 53.6558C72.8544 50.943 70.7294 50.5135 66.2307 52.322C66.1629 52.2994 66.0951 52.2542 66.0272 52.2316C66.3663 52.0959 66.6829 51.9603 66.9767 51.8472C67.3158 51.7116 67.7453 51.5534 68.0844 51.4177C68.4009 51.3047 68.8531 51.1465 69.1922 51.056C69.4635 50.9882 69.8025 50.8752 70.0738 50.8074C70.3903 50.7396 70.8424 50.6265 71.1589 50.5813C71.5432 50.5361 72.0631 50.4909 72.4474 50.4683C72.6735 50.4683 72.99 50.4683 73.2161 50.4683C73.397 50.4683 73.623 50.5135 73.8038 50.5361C74.0751 50.5813 74.4368 50.6717 74.6855 50.7396C74.7533 50.7396 75.0924 50.8526 75.5219 51.056C75.7028 51.1465 75.974 51.2595 76.2679 51.4629C76.494 51.6212 76.7201 51.7794 76.9461 51.9603C77.24 52.2316 77.4661 52.4802 77.5113 52.548C77.6469 52.7063 77.8051 52.9324 77.8956 53.0906C77.986 53.2488 78.1669 53.5653 78.3025 53.8818C78.393 54.1079 78.4834 54.3566 78.5738 54.7635C78.6416 55.0348 78.6868 55.419 78.7094 55.6903C78.7094 55.8486 78.7094 56.052 78.7094 56.2103C78.7094 56.3685 78.7094 56.572 78.6868 56.7076C78.6868 56.8885 78.6416 57.1371 78.5964 57.2954C78.5511 57.4988 78.5059 57.7475 78.4607 57.9509C78.3477 58.3353 78.1669 58.8552 78.0086 59.2395C77.873 59.556 77.6695 59.9629 77.5113 60.2568C77.3757 60.5055 77.1722 60.8446 77.0366 61.0706C76.8557 61.3645 76.607 61.7488 76.4035 62.0201C76.2001 62.314 75.9062 62.6983 75.7027 62.9696C75.6801 62.9922 75.0924 63.806 73.8491 65.1624C73.5552 65.4789 73.1709 65.9084 72.8544 66.2249C72.5153 66.5866 72.0632 67.0387 71.7241 67.3778C71.1589 67.9429 70.1868 68.8924 69.3504 69.6384C68.9661 69.9775 68.4687 70.4523 68.0844 70.7914C67.7001 71.1304 67.1576 71.5826 66.7733 71.9217C66.3664 72.2608 65.8238 72.7355 65.3943 73.0746C64.5578 73.7754 63.405 74.6796 62.5459 75.3352C62.1164 75.6743 61.506 76.1264 61.0765 76.4655C60.6243 76.8046 60.0366 77.2342 59.5845 77.5732C59.1324 77.8897 58.522 78.3419 58.0699 78.6583C57.6177 78.9748 57.0074 79.4044 56.5326 79.7208C56.0805 80.0373 55.4476 80.4442 54.9954 80.7381C54.5433 81.032 53.9103 81.4389 53.4581 81.7328C52.8026 82.1397 51.2428 83.1118 50.3837 83.5865C49.5247 84.0613 48.3943 84.7168 47.5127 85.1463C46.7441 85.5533 45.7042 86.0732 44.913 86.4123C44.2122 86.7062 43.3079 87.1131 42.5845 87.3392C42.268 87.4522 41.8385 87.6104 41.522 87.7009C41.0021 87.8365 40.2787 88.04 39.7587 88.1304C39.1484 88.2434 39.0354 88.2434 38.2441 88.3112C37.9729 88.3112 37.6337 88.3112 37.3625 88.3112C37.0234 88.3112 36.5939 88.2434 36.2548 88.1756C35.8026 88.0852 35.5314 87.9948 35.2149 87.8817C35.2149 87.8817 34.808 87.7235 34.3332 87.4748C33.9941 87.2714 33.7229 87.0679 33.5646 86.9323C33.2481 86.661 33.0221 86.4349 32.9316 86.2993C32.8412 86.2089 32.7508 86.0732 32.6604 85.9602C32.57 85.8245 32.4569 85.6437 32.3665 85.5081V85.5307Z", fill: "#EAA800" }), /* @__PURE__ */ $.createElement("path", { d: "M44.3251 72.2155C44.3251 72.2155 44.2799 72.0572 44.2573 71.9668C44.2799 72.0572 44.3025 72.125 44.3251 72.2155Z", fill: "#EAA800" }), /* @__PURE__ */ $.createElement("path", { d: "M43.6701 70.3618C43.8962 70.8818 44.0996 71.4017 44.2352 71.9443C44.2352 71.899 44.2126 71.8538 44.19 71.8086C44.0544 71.3791 43.8283 70.7913 43.6475 70.3618H43.6701Z", fill: "#EAA800" }), /* @__PURE__ */ $.createElement("path", { d: "M51.0619 82.7272C60.2174 77.4599 70.6842 68.8469 74.4368 63.4666C75.8158 61.5225 76.0871 60.2565 75.4767 59.714C74.6403 58.968 72.131 59.5331 68.3331 61.3416C68.1975 61.3416 68.0166 61.3868 67.8584 61.3868C67.6323 61.3868 67.3384 61.4095 67.1124 61.4321C66.9315 61.4321 66.6829 61.4321 66.502 61.4321C66.276 61.4321 65.9595 61.3869 65.7108 61.3642C65.5073 61.3642 44.393 77.5503 44.3478 77.7312C44.3026 77.9347 44.2122 78.2059 44.167 78.4094C44.1218 78.5902 44.0314 78.8163 43.9635 78.9972C43.8957 79.1554 43.8053 79.3815 43.7375 79.5397C43.7375 79.5397 43.7149 79.5849 43.6696 79.6753C42.7202 80.7152 41.9063 81.6873 41.2959 82.569C40.143 84.2192 39.7587 85.3721 40.0526 86.0277C40.7082 87.4745 44.7547 86.3894 51.0619 82.7272ZM67.9714 61.6581C68.1071 61.6581 68.2427 61.6581 68.3557 61.6581C68.2201 61.6581 68.0845 61.6581 67.9714 61.6581Z", fill: "url(#paint0_linear_1921_154521)" }), /* @__PURE__ */ $.createElement("path", { d: "M60.626 59.5786C60.626 59.5786 60.7164 59.6465 60.7616 59.6691C60.739 59.6691 60.7164 59.6464 60.6938 59.6238C60.6938 59.6238 60.6486 59.6012 60.626 59.5786Z", fill: "#E59402" }), /* @__PURE__ */ $.createElement("path", { d: "M59.4263 58.6743C59.6523 58.8552 59.8558 59.036 60.1044 59.2169C60.1044 59.2169 60.0818 59.2169 60.0592 59.1943C59.8558 59.0586 59.6071 58.8552 59.4263 58.6969V58.6743Z", fill: "#EAA800" }), /* @__PURE__ */ $.createElement("path", { d: "M24.6338 48.976C24.5434 48.7273 24.4078 48.4109 24.3399 48.1396C24.2495 47.8683 24.1592 47.5292 24.1139 47.2579C24.0687 47.0093 24.0009 46.6928 23.9557 46.4441C23.9105 46.1728 23.8878 45.8111 23.8652 45.5625C23.8652 45.3138 23.8652 44.9973 23.8652 44.7486C23.8652 44.4774 23.9104 44.1157 23.9331 43.8444C23.9331 43.6183 24.0009 43.3018 24.0687 43.0532C24.1365 42.7593 24.227 42.3976 24.3174 42.1037C24.4078 41.7646 24.5886 41.3351 24.7017 41.0186C24.8599 40.6117 25.1312 40.0691 25.3573 39.6848C25.5381 39.3457 25.832 38.9388 26.0354 38.5997C26.3067 38.238 26.9171 37.3564 28.0248 36.3165C29.1099 35.2766 30.1046 34.621 30.4889 34.3723C30.6697 34.2593 30.9636 34.0784 31.0088 34.0332C31.3931 33.8072 31.4157 33.7846 31.7774 33.6037C32.1618 33.4003 32.6817 33.1516 32.953 33.0386C33.1339 32.9708 33.3825 32.8577 33.586 32.7899C33.7668 32.7221 33.9929 32.6316 34.1737 32.5864C34.3546 32.5412 34.5806 32.4508 34.7615 32.4056C35.0554 32.3378 35.4623 32.2247 35.7562 32.1795C36.1857 32.0891 36.7734 32.0213 37.2029 31.9987C37.4968 31.9761 37.8812 31.9761 38.1751 31.9761C38.4463 31.9761 38.808 31.976 39.0567 32.0213C39.2827 32.0439 39.5992 32.0891 39.8479 32.1343C40.0966 32.1795 40.4357 32.2473 40.707 32.3377C41.1817 32.4734 41.792 32.6995 42.2442 32.9029C42.4928 33.0159 42.8093 33.1742 43.0354 33.3098C43.2615 33.4455 43.578 33.6263 43.804 33.7846C44.2335 34.1011 44.7761 34.5532 45.183 34.9149C45.0021 34.7341 44.6404 34.6888 44.1431 34.7566C43.058 34.9149 41.3173 35.6383 39.034 36.9495C33.8346 39.9561 27.8892 44.8391 25.7416 47.8909C25.4929 48.2526 25.3121 48.5691 25.1764 48.8404C24.973 49.2925 24.9278 49.6316 25.0408 49.8576C24.9052 49.609 24.7469 49.2699 24.6565 48.9986L24.6338 48.976Z", fill: "url(#paint1_linear_1921_154521)" }), /* @__PURE__ */ $.createElement("path", { d: "M35.3964 77.5727C35.6224 77.0979 35.9389 76.5328 36.3911 75.8998C40.1437 70.5421 50.5878 61.9517 59.7208 56.6844C63.3604 54.582 66.2314 53.3387 68.1529 52.9318C68.9893 53.1352 69.8032 53.203 70.5266 53.1126C70.1875 52.7961 69.5771 52.7057 68.6955 52.8188C68.5372 52.8188 68.3111 52.8188 68.1529 52.7735C68.1303 52.7735 68.1077 52.7735 68.0851 52.7735C67.9947 52.7735 67.9042 52.7509 67.7912 52.7283C67.7234 52.7283 67.6782 52.7057 67.6104 52.6831C67.4295 52.6379 67.226 52.5701 67.0226 52.5023C66.8191 52.4345 66.6157 52.3666 66.4349 52.3214C66.367 52.2988 66.3218 52.2762 66.254 52.2536C66.254 52.2536 66.2088 52.2536 66.1862 52.231C66.1183 52.2084 66.0505 52.1632 65.9601 52.1406C65.9149 52.1406 65.8471 52.0954 65.8019 52.0727C65.7567 52.0727 65.7114 52.0275 65.6888 52.0275C65.621 52.0049 65.5532 51.9597 65.4854 51.9371C65.3949 51.8919 65.3045 51.8467 65.2141 51.8014C64.7394 51.5528 64.1742 51.2589 63.6316 50.9424C63.5864 50.9198 63.5187 50.8746 63.4734 50.852C63.4734 50.852 63.4734 50.852 63.4508 50.852C63.1117 50.6485 62.7952 50.4677 62.5013 50.2868C62.4561 50.2642 62.4109 50.2416 62.3657 50.1964C62.3431 50.1964 62.2978 50.1512 62.2752 50.1286C61.8457 49.8573 61.2806 49.4504 60.6024 48.9757C60.5798 48.9757 60.5572 48.9304 60.5119 48.9078C60.4441 48.8626 60.3537 48.7948 60.2633 48.727C60.1955 48.6818 60.1277 48.614 60.0599 48.5688C60.0147 48.5235 59.9694 48.5009 59.9016 48.4557C59.7886 48.3879 59.6982 48.2975 59.5852 48.2071C59.0426 47.8001 58.4096 47.3028 57.8219 46.8055C57.7993 46.8055 57.7766 46.7603 57.754 46.7377C57.7088 46.6924 57.6636 46.6698 57.6183 46.6246C57.2792 46.3533 56.9628 46.0821 56.6915 45.8334C56.6011 45.7656 56.5106 45.6752 56.4202 45.6073C56.1037 45.3361 55.7646 45.0422 55.4482 44.7709C55.3803 44.7031 55.3125 44.6579 55.2447 44.5901C55.1995 44.5675 55.1769 44.5222 55.1317 44.4996C55.1543 44.4996 55.1769 44.5448 55.1995 44.5674C55.1091 44.4996 55.0412 44.4092 54.9508 44.3414C55.0186 44.3866 55.0639 44.4544 55.1317 44.4996C55.0413 44.4092 54.9508 44.3414 54.8604 44.2509C54.5891 44.0023 54.2952 43.7536 54.0239 43.5049C54.0466 43.5275 54.0692 43.5501 54.1144 43.5728C54.024 43.4823 53.9336 43.4145 53.8431 43.3241C53.8883 43.3693 53.9561 43.4371 54.0239 43.4823C53.9335 43.4145 53.8657 43.3467 53.7979 43.2563C53.0971 42.6233 52.2381 41.7869 51.5147 41.1087C51.4017 40.9956 51.266 40.8826 51.153 40.7696C51.153 40.7696 51.1756 40.7922 51.1982 40.8148C51.1756 40.7922 51.153 40.7696 51.1303 40.747C51.1303 40.747 51.1304 40.747 51.153 40.7696C50.9043 40.5209 50.6104 40.2496 50.3166 39.9558C50.4296 40.0688 50.5426 40.1818 50.6783 40.2948C50.5426 40.1592 50.4069 40.0236 50.2713 39.8879C50.2713 39.8879 50.3165 39.9332 50.3391 39.9558C50.2035 39.8201 50.0453 39.6619 49.9097 39.5262C49.9097 39.5262 49.9549 39.5714 49.9775 39.5941C50.0001 39.6167 50.0227 39.6393 50.0453 39.6619C49.7966 39.4132 49.5253 39.1419 49.2541 38.8707C49.4575 39.0741 49.6836 39.3002 49.9097 39.5262C49.2767 38.8933 48.4628 38.102 47.8298 37.4465C47.8298 37.4465 47.8299 37.4464 47.8525 37.4691C47.8299 37.4464 47.7846 37.4013 47.762 37.3786C47.762 37.3786 47.8072 37.4239 47.8298 37.4465C47.2195 36.8361 46.6769 36.2935 46.2022 35.8188C46.2022 35.8188 46.157 35.751 46.1344 35.751C45.7727 35.4119 45.5014 35.1406 45.2301 34.8693C45.0493 34.6885 44.6875 34.6433 44.1902 34.7111C43.1051 34.8693 41.3644 35.5927 39.0812 36.9039C33.8818 39.9105 27.9363 44.7935 25.7887 47.8453C25.54 48.207 25.3592 48.5236 25.2235 48.7948C25.0201 49.247 24.9749 49.5861 25.0879 49.8121C25.2235 50.0834 25.4043 50.4451 25.54 50.6938C25.9017 51.372 26.3765 52.2762 26.7382 52.9544C27.7329 54.8081 28.2528 55.7802 28.9988 57.2722C29.4962 58.2443 30.1517 59.578 30.649 60.5727C30.8977 61.0927 31.2142 61.7708 31.4629 62.2908C31.7116 62.8107 32.028 63.5115 32.2541 64.0315C32.5479 64.7097 33.0905 65.9756 33.6783 67.5129C34.2434 69.0501 34.6052 70.1804 34.786 70.8812C35.0347 71.7854 35.3059 72.9836 35.4642 73.9105C35.532 74.2948 35.5772 74.8147 35.5998 75.199C35.6224 75.5381 35.5998 75.9902 35.5998 76.3293C35.5998 76.3293 35.5546 77.2788 35.419 77.5727H35.3964ZM49.1636 38.848C49.1636 38.848 49.0958 38.7802 49.0506 38.735C49.0958 38.7802 49.1184 38.8028 49.1636 38.848ZM51.0852 40.7244C50.9721 40.6113 50.8365 40.4983 50.7234 40.3853C50.8365 40.4983 50.9495 40.6113 51.0852 40.7244ZM54.8152 44.2057C54.8152 44.2057 54.6344 44.0475 54.5665 43.9797C54.657 44.0475 54.7474 44.1379 54.8152 44.2057ZM54.4083 43.8441C54.4083 43.8441 54.2727 43.731 54.2048 43.6632C54.2727 43.731 54.3405 43.7762 54.4083 43.8441ZM56.5333 45.7204C56.5333 45.7204 56.4654 45.6751 56.4428 45.6299C56.4654 45.6525 56.5107 45.6978 56.5333 45.7204Z", fill: "url(#paint2_linear_1921_154521)" }), /* @__PURE__ */ $.createElement("path", { d: "M32.5695 85.8691C32.7504 86.1404 32.886 86.2986 33.2025 86.6377C33.4737 86.909 33.7902 87.1351 33.8806 87.2029C34.0163 87.2933 34.3102 87.4968 34.6719 87.6776C34.8075 87.7454 34.9884 87.8133 35.124 87.8811C35.2597 87.9263 35.4405 87.9941 35.5987 88.0393C35.757 88.0845 35.9605 88.1524 36.1187 88.175C36.277 88.2202 36.503 88.2428 36.6612 88.2654C36.8647 88.288 37.1134 88.3332 37.3168 88.3332C37.7011 88.3332 38.2437 88.3332 38.628 88.3106C38.9445 88.288 39.374 88.2202 39.6905 88.175C40.233 88.0619 40.9338 87.8811 41.4538 87.7454C41.7703 87.655 42.1998 87.5194 42.5163 87.4063C43.2171 87.1577 44.144 86.7734 44.8222 86.4795C45.2065 86.3212 45.7038 86.0726 46.0881 85.8917C46.9245 85.5074 48.0096 84.9196 48.8234 84.4901C49.2756 84.2641 49.8407 83.925 50.2928 83.6763C50.7676 83.405 51.4006 83.0433 51.8527 82.7494C52.3048 82.4781 52.9152 82.0938 53.3899 81.8C53.8646 81.5061 54.475 81.1218 54.9497 80.8053C55.4019 80.4888 56.0348 80.1045 56.4869 79.788C56.9391 79.4715 57.5721 79.042 58.0242 78.7255C58.4764 78.409 59.0867 77.9795 59.5388 77.6404C60.4431 76.9848 61.6186 76.1032 62.5002 75.425C62.9298 75.0859 63.5176 74.6338 63.9471 74.2947C64.3766 73.9556 64.9417 73.5035 65.3487 73.1644C65.7556 72.8253 66.2981 72.3731 66.705 72.0114C67.112 71.6723 67.6319 71.2202 68.0162 70.8811C68.4005 70.542 68.8978 70.0899 69.2821 69.7508C69.6438 69.4117 70.1412 68.9596 70.5029 68.6205C71.1811 67.9649 72.0628 67.0832 72.7183 66.4277C73.0348 66.1112 73.4417 65.6591 73.7356 65.3426C74.0295 65.0261 74.4138 64.5739 74.7076 64.2348C75.1824 63.6471 75.8154 62.8785 76.2449 62.2681C76.471 61.9742 76.7422 61.5673 76.9457 61.2508C77.2396 60.7761 77.6013 60.1431 77.8273 59.6458C77.9403 59.4197 78.0534 59.1258 78.1438 58.8998C78.2117 58.7189 78.3021 58.4476 78.3699 58.2668C78.4377 58.0407 78.5055 57.7242 78.5507 57.4756C78.6864 56.82 78.6637 56.3226 78.6637 56.3226C78.6637 56.1644 78.6637 55.9383 78.6637 55.7801C78.6637 55.6445 78.6412 55.441 78.6185 55.3054C78.6185 55.1697 78.5733 54.9663 78.5281 54.8306C78.4603 54.582 78.3473 54.2203 78.2795 53.9716C78.2343 53.836 78.1664 53.6777 78.0986 53.5421C77.9403 53.2256 77.8952 53.1578 77.6465 52.7961C77.5335 52.6378 77.3526 52.457 77.2396 52.2987C77.1492 52.2083 77.0361 52.0953 76.9457 52.0049C76.7649 51.8466 76.5162 51.6431 76.3127 51.5075C76.1997 51.4397 76.0641 51.3493 75.951 51.2814C75.838 51.2136 75.7023 51.1458 75.5893 51.1006C75.4763 51.0328 75.2954 50.9649 75.1824 50.9197C75.0468 50.8745 74.8885 50.8067 74.7529 50.7841C74.6173 50.7389 74.4364 50.6937 74.3234 50.6711C74.1877 50.6258 73.9843 50.6033 73.826 50.5806C73.5321 50.5354 73.1026 50.5128 72.8087 50.4902C72.6053 50.4902 72.3114 50.4902 72.1079 50.4902C71.6106 50.5354 71.1359 50.5807 70.3899 50.7389C69.8473 50.8519 69.1239 51.078 68.5813 51.2362C68.1518 51.3719 67.5867 51.5753 67.1798 51.7562C66.4338 52.0501 65.4617 52.4796 64.7383 52.8187C63.9019 53.2256 62.8167 53.7907 62.0029 54.2203C61.4829 54.4915 60.8048 54.8758 60.3074 55.1697C59.358 55.7123 58.1146 56.4583 57.2104 57.0461C56.7356 57.3399 56.1027 57.7468 55.628 58.0633C55.1532 58.3798 54.5203 58.7867 54.0681 59.1032C53.1187 59.7588 52.3048 60.3014 50.971 61.2734C49.4564 62.3585 48.3261 63.2628 47.9418 63.5341C47.2636 64.054 46.2237 64.8678 45.0256 65.8625C44.5961 66.2016 44.0535 66.6763 43.624 67.038C43.217 67.3771 42.6745 67.8519 42.2676 68.2136C41.5216 68.8692 40.753 69.57 39.7583 70.5194C38.5376 71.6724 37.7237 72.5314 37.4977 72.7574C37.0907 73.187 36.3221 74.0008 35.5309 74.9277C34.8753 75.6963 34.4232 76.284 33.9033 77.03C33.112 78.1603 33.1799 79.9462 34.1293 81.3704C35.3953 83.2468 38.4019 84.3771 40.7078 83.0433C44.6187 77.4596 55.5149 68.4849 65.0548 62.9915C74.5946 57.4982 79.1385 57.566 75.2276 63.1498C71.3167 68.7335 60.4205 77.7082 50.8806 83.2015C41.3408 88.6949 36.7969 88.6271 40.7078 83.0433C38.4019 84.3771 35.3953 83.2468 34.1293 81.3704C33.1799 79.9688 33.112 78.183 33.9033 77.03C33.745 77.2787 33.4964 77.5952 33.3607 77.8439C33.1121 78.2734 32.773 78.8159 32.5695 79.2681C32.4113 79.6298 32.2078 80.1045 32.0948 80.4662C32.027 80.6697 31.9592 80.9635 31.8913 81.1896C31.8461 81.3704 31.8009 81.5965 31.7783 81.7774C31.7104 82.2973 31.7104 82.7268 31.7104 82.7268C31.7104 82.9755 31.733 83.3146 31.7556 83.5633C31.7556 83.6989 31.8009 83.8571 31.8235 83.9928C31.8461 84.1284 31.8913 84.2867 31.9365 84.3997C32.0043 84.6258 32.1174 84.9422 32.2078 85.1457C32.2756 85.3039 32.4791 85.6883 32.6147 85.8691H32.5695Z", fill: "url(#paint3_linear_1921_154521)" }), /* @__PURE__ */ $.createElement("path", { d: "M41.2947 82.5684C41.0912 82.7493 40.8652 82.885 40.6617 83.0206C36.7508 88.6044 41.2947 88.6722 50.8346 83.1788C60.3744 77.6855 71.2707 68.7108 75.1816 63.127C79.0925 57.5433 74.5486 57.4754 65.0088 62.9688C55.4689 68.4621 44.5726 77.4368 40.6617 83.0206C40.8878 82.885 41.0912 82.7493 41.2947 82.5684C45.0473 77.2107 55.5141 68.5978 64.6697 63.3079C70.4795 59.9621 74.3678 58.764 75.4755 59.7135C76.1085 60.256 75.8146 61.522 74.4356 63.4661C70.6829 68.8238 60.2162 77.4368 51.0606 82.7267C44.7309 86.3663 40.6844 87.4514 40.0514 86.0272C39.7575 85.3716 40.1418 84.2413 41.2947 82.5684Z", fill: "#E89C02" }), /* @__PURE__ */ $.createElement("path", { d: "M61.1438 65.6821C62.0933 66.2925 62.9297 67.1063 63.5627 68.1236C65.8459 71.7632 64.7609 76.5784 61.1212 78.8616C57.4816 81.1448 52.6665 80.0597 50.3832 76.4201C49.9763 75.7645 49.6825 75.0864 49.479 74.3856C51.1519 72.8709 53.0734 71.3111 55.1531 69.7513C57.2103 68.214 59.2449 66.8351 61.1438 65.6821Z", fill: "url(#paint4_linear_1921_154521)" }), /* @__PURE__ */ $.createElement("path", { d: "M23.9338 34.8695C22.7131 32.7897 23.4139 30.1221 25.4937 28.924C27.483 27.7485 30.1053 28.3815 31.3487 30.3482C31.6652 30.8455 31.8687 31.4107 31.9591 31.9532C32.1399 33.0383 31.6878 34.146 30.8288 34.8468C30.4897 35.1181 30.1506 35.3894 29.8115 35.6381C29.495 35.8641 29.1785 36.0902 28.8394 36.3163C27.9126 36.9266 26.737 37.0397 25.7424 36.5423C25.019 36.1806 24.3859 35.6155 23.9338 34.8695Z", fill: "url(#paint5_linear_1921_154521)" }), /* @__PURE__ */ $.createElement("defs", null, /* @__PURE__ */ $.createElement("linearGradient", { id: "paint0_linear_1921_154521", x1: 60.4409, y1: 76.5683, x2: 54.964, y2: 68.129, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ $.createElement("stop", { stopColor: "#FBC700" }), /* @__PURE__ */ $.createElement("stop", { offset: 0.67, stopColor: "#DF8803" })), /* @__PURE__ */ $.createElement("linearGradient", { id: "paint1_linear_1921_154521", x1: 36.0881, y1: 47.2017, x2: 32.9683, y2: 32.495, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ $.createElement("stop", { offset: 0.03, stopColor: "#D68300" }), /* @__PURE__ */ $.createElement("stop", { offset: 0.58, stopColor: "#F3BA00" }), /* @__PURE__ */ $.createElement("stop", { offset: 0.66, stopColor: "#F3BC08" }), /* @__PURE__ */ $.createElement("stop", { offset: 0.78, stopColor: "#F3C41D" }), /* @__PURE__ */ $.createElement("stop", { offset: 0.93, stopColor: "#F3D041" }), /* @__PURE__ */ $.createElement("stop", { offset: 1, stopColor: "#F3D856" })), /* @__PURE__ */ $.createElement("linearGradient", { id: "paint2_linear_1921_154521", x1: 58.1961, y1: 41.6191, x2: 28.8569, y2: 65.3656, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ $.createElement("stop", { stopColor: "#F3C319" }), /* @__PURE__ */ $.createElement("stop", { offset: 0.37, stopColor: "#F3C216" }), /* @__PURE__ */ $.createElement("stop", { offset: 0.84, stopColor: "#D68300" })), /* @__PURE__ */ $.createElement("linearGradient", { id: "paint3_linear_1921_154521", x1: 60.0725, y1: 78.5285, x2: 50.5091, y2: 59.7854, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ $.createElement("stop", { stopColor: "#D68300" }), /* @__PURE__ */ $.createElement("stop", { offset: 0.86, stopColor: "#FFCF00" })), /* @__PURE__ */ $.createElement("linearGradient", { id: "paint4_linear_1921_154521", x1: 63.8823, y1: 75.7549, x2: 52.2325, y2: 69.3074, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ $.createElement("stop", { offset: 0.04, stopColor: "#FFCF00" }), /* @__PURE__ */ $.createElement("stop", { offset: 0.14, stopColor: "#F8C200" }), /* @__PURE__ */ $.createElement("stop", { offset: 0.51, stopColor: "#DF9400" }), /* @__PURE__ */ $.createElement("stop", { offset: 0.7, stopColor: "#D68300" })), /* @__PURE__ */ $.createElement("linearGradient", { id: "paint5_linear_1921_154521", x1: 24.7817, y1: 35.6206, x2: 29.3709, y2: 28.2703, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ $.createElement("stop", { offset: 0.31, stopColor: "#D68300" }), /* @__PURE__ */ $.createElement("stop", { offset: 0.66, stopColor: "#F3BA00" }), /* @__PURE__ */ $.createElement("stop", { offset: 0.87, stopColor: "#F3CE39" }), /* @__PURE__ */ $.createElement("stop", { offset: 1, stopColor: "#F3D856" })))), K7e = (t) => /* @__PURE__ */ $.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ $.createElement("path", { d: "M6.14774 16.952C5.42565 16.952 5 16.5872 5 16.0323C5 15.2722 5.7677 14.5881 6.42898 13.9116C6.93064 13.3872 7.06746 12.3078 7.12827 11.4337C7.18147 8.51496 7.95677 6.50831 9.97862 5.77862C10.2599 4.7829 11.0504 4 12.1677 4C13.2926 4 14.0755 4.7829 14.3644 5.77862C16.3862 6.50831 17.1615 8.51496 17.2147 11.4337C17.2755 12.3078 17.4124 13.3872 17.914 13.9116C18.5677 14.5881 19.343 15.2722 19.343 16.0323C19.343 16.5872 18.9097 16.952 18.1952 16.952H6.14774ZM12.1677 20C10.8831 20 9.94062 19.0575 9.8418 17.9933H14.5012C14.4024 19.0575 13.4599 20 12.1677 20Z", fill: "#3548C9" })), q7e = (t) => /* @__PURE__ */ $.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ $.createElement("path", { d: "M17.3813 13.1162C16.7823 13.1162 16.4288 12.743 16.4288 12.1047V11.0736C16.4288 10.4354 16.7823 10.0622 17.3813 10.0622H18.2062C18.2848 8.92308 19.2373 8 20.4059 8C21.5745 8 22.527 8.92308 22.5957 10.0622H23.4304C24.0196 10.0622 24.383 10.4354 24.383 11.0736V12.1047C24.383 12.743 24.0196 13.1162 23.4304 13.1162H17.3813ZM20.4059 11.0147C20.8871 11.0147 21.27 10.6121 21.27 10.1408C21.27 9.66939 20.8871 9.2766 20.4059 9.2766C19.9247 9.2766 19.5319 9.66939 19.5319 10.1408C19.5319 10.6121 19.9247 11.0147 20.4059 11.0147ZM15.1915 32C13.1097 32 12 30.8805 12 28.7692V13.9018C12 11.7807 13.1097 10.671 15.1129 10.671H15.3191C15.2897 10.7496 15.27 10.8576 15.27 10.9656V12.1047C15.27 13.3715 16.1244 14.275 17.3813 14.275H23.4304C24.6776 14.275 25.5319 13.3715 25.5319 12.1047V10.9656C25.5319 10.8576 25.5221 10.7496 25.4926 10.671H25.6989C27.7021 10.671 28.802 11.7807 28.802 13.9018V28.7692C28.802 30.8805 27.7021 32 25.6105 32H15.1915ZM16.0655 19.4108H24.7365C25.1293 19.4108 25.4632 19.0867 25.4632 18.6939C25.4632 18.2815 25.1293 17.9574 24.7365 17.9574H16.0655C15.6727 17.9574 15.3486 18.2815 15.3486 18.6939C15.3486 19.0867 15.6727 19.4108 16.0655 19.4108ZM16.0655 23.0246H24.7365C25.1489 23.0246 25.4632 22.7005 25.4632 22.2979C25.4632 21.8953 25.1391 21.5712 24.7365 21.5712H16.0655C15.6628 21.5712 15.3486 21.8953 15.3486 22.2979C15.3486 22.7005 15.6628 23.0246 16.0655 23.0246ZM16.0655 26.8347H20.5139C20.9067 26.8347 21.2406 26.5008 21.2406 26.108C21.2406 25.7054 20.9165 25.3912 20.5139 25.3912H16.0655C15.6628 25.3912 15.3486 25.7054 15.3486 26.108C15.3486 26.5008 15.6727 26.8347 16.0655 26.8347Z", fill: "white" })), Q7e = (t) => /* @__PURE__ */ $.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ $.createElement("path", { d: "M7.57648 18.1131H9.23784C10.3572 12.5635 15.3177 8.3335 21.1619 8.3335C27.8309 8.3335 33.3334 13.8478 33.3334 20.505C33.3334 27.174 27.8309 32.6764 21.1619 32.6764C17.3443 32.6764 13.7742 30.7559 11.5944 27.9045C11.0759 27.28 11.182 26.5259 11.724 26.1371C12.3013 25.7247 12.9847 25.9014 13.456 26.4552C15.2352 28.7882 18.0041 30.2728 21.1619 30.2846C26.5937 30.2964 30.9415 25.925 30.9415 20.505C30.9415 15.085 26.5937 10.7372 21.1619 10.7372C16.5666 10.7372 12.7373 13.8596 11.6886 18.1131H13.3853C14.2926 18.1131 14.5282 18.8083 14.0334 19.4799L11.182 23.4506C10.7931 23.9926 10.1804 24.0044 9.77984 23.4506L6.92844 19.4917C6.42178 18.7965 6.65744 18.1131 7.57648 18.1131ZM20.7141 13.4707C21.3268 13.4707 21.8335 13.9656 21.8335 14.5783V20.8231L24.6142 24.5936C25.0266 25.1709 24.9912 25.8425 24.461 26.2078C23.8837 26.5966 23.2474 26.4906 22.7761 25.8779L19.9247 22.1074C19.689 21.8128 19.6066 21.5418 19.6066 21.2591V14.5783C19.6066 13.9656 20.1014 13.4707 20.7141 13.4707Z", fill: "white" })), ewe = (t) => /* @__PURE__ */ $.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ $.createElement("path", { d: "M10.1796 15.1049C8.81887 15.1049 8 14.286 8 12.865V10.2398C8 8.83091 8.81887 8 10.1796 8H12.9132C14.286 8 15.0928 8.83091 15.0928 10.2398V12.865C15.0928 14.286 14.286 15.1049 12.9132 15.1049H10.1796ZM18.8741 15.1049C17.5013 15.1049 16.6944 14.286 16.6944 12.865V10.2398C16.6944 8.83091 17.5013 8 18.8741 8H21.6076C22.9804 8 23.7873 8.83091 23.7873 10.2398V12.865C23.7873 14.286 22.9804 15.1049 21.6076 15.1049H18.8741ZM27.5805 15.1049C26.2077 15.1049 25.3889 14.286 25.3889 12.865V10.2398C25.3889 8.83091 26.2077 8 27.5805 8H30.3141C31.6749 8 32.4937 8.83091 32.4937 10.2398V12.865C32.4937 14.286 31.6749 15.1049 30.3141 15.1049H27.5805ZM10.1796 23.5464C8.81887 23.5464 8 22.7396 8 21.3307V18.6814C8 17.2725 8.81887 16.4656 10.1796 16.4656H12.9132C14.286 16.4656 15.0928 17.2725 15.0928 18.6814V21.3307C15.0928 22.7396 14.286 23.5464 12.9132 23.5464H10.1796ZM18.8741 23.5464C17.5013 23.5464 16.6944 22.7396 16.6944 21.3307V18.6814C16.6944 17.2725 17.5013 16.4656 18.8741 16.4656H21.6076C22.9804 16.4656 23.7873 17.2725 23.7873 18.6814V21.3307C23.7873 22.7396 22.9804 23.5464 21.6076 23.5464H18.8741ZM27.5805 23.5464C26.2077 23.5464 25.3889 22.7396 25.3889 21.3307V18.6814C25.3889 17.2725 26.2077 16.4656 27.5805 16.4656H30.3141C31.6749 16.4656 32.4937 17.2725 32.4937 18.6814V21.3307C32.4937 22.7396 31.6749 23.5464 30.3141 23.5464H27.5805ZM10.1796 32C8.81887 32 8 31.1811 8 29.7722V27.135C8 25.726 8.81887 24.9072 10.1796 24.9072H12.9132C14.286 24.9072 15.0928 25.726 15.0928 27.135V29.7722C15.0928 31.1811 14.286 32 12.9132 32H10.1796ZM18.8741 32C17.5013 32 16.6944 31.1811 16.6944 29.7722V27.135C16.6944 25.726 17.5013 24.9072 18.8741 24.9072H21.6076C22.9804 24.9072 23.7873 25.726 23.7873 27.135V29.7722C23.7873 31.1811 22.9804 32 21.6076 32H18.8741ZM27.5805 32C26.2077 32 25.3889 31.1811 25.3889 29.7722V27.135C25.3889 25.726 26.2077 24.9072 27.5805 24.9072H30.3141C31.6749 24.9072 32.4937 25.726 32.4937 27.135V29.7722C32.4937 31.1811 31.6749 32 30.3141 32H27.5805Z", fill: "white" })), twe = (t) => /* @__PURE__ */ $.createElement("svg", { "aria-hidden": "true", fill: "currentColor", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ $.createElement("path", { clipRule: "evenodd", fillRule: "evenodd", d: "M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z" })), J4 = (t) => t.split(" ").map((r) => r[0] !== void 0 ? r[0].toUpperCase() : "").join(""), rwe = (t) => {
  const r = De(), e = De.duration(r.diff(t)), n = e.asSeconds(), i = e.asMinutes(), a = e.asHours(), o = e.asDays();
  return n < 60 ? "Just Now" : i < 60 ? `${Math.floor(i)} minute${i === 1 ? "" : "s"} ago` : a < 24 ? `${Math.floor(a)} hour${a === 1 ? "" : "s"} ago` : `${o.toFixed(0)} day${o === 1 ? "" : "s"} ago`;
}, K8e = (t) => {
  const {
    quickLinksComponent: r,
    userMenu: e,
    showNotificationIcon: n = !0,
    hasActiveNotification: i = !1,
    notifications: a = [],
    toggleSidebar: o = null,
    showQuickLinksIcon: s = !0,
    showTaskIcon: l = !0,
    onTaskIconClick: u = null,
    showHistoryIcon: c = !0,
    onHistoryIconClick: d = null
  } = t, [f, h] = We(!1), [p, v] = We(!1), [g, m] = We(!1), y = Vt(null), b = (I) => {
    y.current && !y.current.contains(I.target) && (v(!1), h(!1));
  }, C = () => /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
    n && /* @__PURE__ */ S.jsx(
      "button",
      {
        type: "button",
        onClick: () => {
          m(!g), v(!1), h(!1);
        },
        children: i ? /* @__PURE__ */ S.jsx(U7e, { className: "theme-navbar-icons" }) : /* @__PURE__ */ S.jsx($7e, { className: "theme-navbar-icons" })
      }
    ),
    /* @__PURE__ */ S.jsxs(
      "div",
      {
        className: `theme-navbar-dropdown theme-navbar-notif-dropdown ${g && "dropdown-visible"}`,
        children: [
          i && a.length > 0 && /* @__PURE__ */ S.jsx("ul", { children: a.map(
            (I, D) => w(I, D)
          ) }),
          (!i || a.length <= 0) && /* @__PURE__ */ S.jsxs("div", { className: "theme-navbar-notif-empty-wrapper", children: [
            /* @__PURE__ */ S.jsx(J7e, {}),
            /* @__PURE__ */ S.jsx("p", { className: "title", children: "No notification yet" }),
            /* @__PURE__ */ S.jsx("p", { children: "Any notification you receive will show up here" })
          ] })
        ]
      }
    )
  ] }), w = (I, D) => /* @__PURE__ */ S.jsxs(
    "li",
    {
      className: `${I.hasRead && "theme-navbar-notif-has-read"}`,
      onClick: () => I.onClick && I.onClick(),
      children: [
        (I.sourceNames === void 0 || I.sourceNames.length <= 0) && /* @__PURE__ */ S.jsx("div", { className: "theme-navbar-notif-icon icon-default", children: /* @__PURE__ */ S.jsx(K7e, {}) }),
        I.sourceNames && Array.isArray(I.sourceNames) && I.sourceNames[0] !== void 0 && I.sourceNames.length === 1 && /* @__PURE__ */ S.jsx("div", { className: "theme-navbar-notif-icon icon-user", children: /* @__PURE__ */ S.jsx("span", { className: "icon-name", children: J4(I.sourceNames[0]) }) }),
        I.sourceNames && Array.isArray(I.sourceNames) && I.sourceNames.length > 1 && /* @__PURE__ */ S.jsx("div", { className: "theme-navbar-notif-icon-stack", children: I.sourceNames.map((T, A) => /* @__PURE__ */ S.jsx(
          "div",
          {
            className: "theme-navbar-notif-icon icon-user",
            children: /* @__PURE__ */ S.jsx("span", { className: "icon-name", children: J4(T) })
          },
          `notif-${D}-${A}`
        )) }),
        /* @__PURE__ */ S.jsxs("div", { className: "theme-navbar-notif-content", children: [
          /* @__PURE__ */ S.jsx("p", { children: I.title }),
          /* @__PURE__ */ S.jsx("p", { dangerouslySetInnerHTML: { __html: I.description } }),
          /* @__PURE__ */ S.jsx("small", { children: rwe(I.time) })
        ] }),
        !I.hasRead && /* @__PURE__ */ S.jsx("span", { className: "theme-navbar-notif-readicon" })
      ]
    },
    `notification-${D}`
  ), _ = () => /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
    /* @__PURE__ */ S.jsx(
      "button",
      {
        type: "button",
        onClick: () => {
          v(!p), m(!1), h(!1);
        },
        children: /* @__PURE__ */ S.jsx(ewe, { className: "theme-navbar-icons" })
      }
    ),
    /* @__PURE__ */ S.jsx(
      "div",
      {
        className: `theme-navbar-dropdown theme-navbar-quicklinks-dropdown ${p && "dropdown-visible"}`,
        children: r
      }
    )
  ] }), x = () => /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
    /* @__PURE__ */ S.jsxs(
      "button",
      {
        type: "button",
        onClick: () => {
          h(!f), m(!1), v(!1);
        },
        children: [
          /* @__PURE__ */ S.jsx("span", { className: "theme-navbar-avatar", children: J4(e.fullname) }),
          /* @__PURE__ */ S.jsx("span", { className: "theme-navbar-avatar-name", children: e.fullname })
        ]
      }
    ),
    /* @__PURE__ */ S.jsx(
      "div",
      {
        className: `theme-navbar-dropdown theme-navbar-user-dropdown ${f && "dropdown-visible"}`,
        id: "user-dropdown",
        children: /* @__PURE__ */ S.jsx("ul", { children: e.links.map((I, D) => /* @__PURE__ */ S.jsx("li", { children: I }, `user-dropdown-${D}`)) })
      }
    )
  ] });
  return Ue(() => (document.addEventListener("click", b), () => document.removeEventListener("click", b)), []), /* @__PURE__ */ S.jsx("nav", { className: "theme-navbar", ref: y, children: /* @__PURE__ */ S.jsxs("div", { className: "theme-navbar-wrapper", children: [
    /* @__PURE__ */ S.jsx("div", { className: "theme-navbar-sidebar-wrapper", children: /* @__PURE__ */ S.jsx(
      "button",
      {
        type: "button",
        className: "theme-navbar-sidebar-button",
        onClick: () => {
          o && o(), v(!1), v(!1);
        },
        children: /* @__PURE__ */ S.jsx(twe, {})
      }
    ) }),
    /* @__PURE__ */ S.jsxs("div", { className: "theme-navbar-buttons", children: [
      C(),
      l && /* @__PURE__ */ S.jsx(
        "button",
        {
          type: "button",
          onClick: () => {
            u && u();
          },
          children: /* @__PURE__ */ S.jsx(q7e, { className: "theme-navbar-icons" })
        }
      ),
      c && /* @__PURE__ */ S.jsx(
        "button",
        {
          type: "button",
          onClick: () => {
            d && d();
          },
          children: /* @__PURE__ */ S.jsx(Q7e, { className: "theme-navbar-icons" })
        }
      ),
      s && _(),
      x()
    ] })
  ] }) });
}, q8e = (t) => {
  const { digits: r = 6, onChange: e, className: n = "" } = t, [i, a] = We(new Array(r).fill("")), o = Vt(Array(r).fill(null)), s = async (u, c) => {
    const d = [...i], f = u.target;
    d[c] = f.value, a(d), f.value !== "" && c < r - 1 ? o.current[c + 1].focus() : f.value === "" && c > 0 && o.current[c - 1].focus(), e && e(d.join(""));
  }, l = async (u, c) => {
    const d = u.target, f = await navigator.clipboard.readText();
    if (f && /\d{6}/.test(f)) {
      if (f.length > 6)
        return !1;
      const h = f.split(""), p = h.map(
        (m, y) => y === c ? d.value : m || i[y]
      );
      e && e(p.join("")), a(p);
      const v = p.indexOf(""), g = v > -1 ? v : h - 1;
      o.current[g].focus();
    }
  };
  return Ue(() => {
    o.current[0].focus();
  }, []), /* @__PURE__ */ S.jsx("div", { className: `otp-input ${n}`, children: i.map((u, c) => /* @__PURE__ */ S.jsx("div", { children: /* @__PURE__ */ S.jsx(
    "input",
    {
      type: "text",
      maxLength: 1,
      ref: (d) => o.current[c] = d,
      "data-focus-input-init": !0,
      "data-focus-input-next": `code-${c}`,
      id: `code-${c}`,
      value: u,
      onChange: (d) => s(d, c),
      onPaste: (d) => l(d, c),
      className: "block theme-form-control text-center",
      required: !0
    }
  ) }, `otp-input-${c}`)) });
}, Jk = (t) => /* @__PURE__ */ $.createElement("svg", { width: 17, height: 14, viewBox: "0 0 17 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ $.createElement("path", { d: "M0.5 6.99965C0.5 6.74568 0.610053 6.49171 0.804762 6.31393L6.36667 0.743562C6.58677 0.531922 6.81534 0.447266 7.04392 0.447266C7.57725 0.447266 7.9582 0.819752 7.9582 1.32769C7.9582 1.59012 7.85661 1.81869 7.6873 1.98801L5.79101 3.9097L3.29365 6.19541L5.26614 6.0769H15.5603C16.1106 6.0769 16.5 6.44938 16.5 6.99965C16.5 7.54145 16.1106 7.9224 15.5603 7.9224H5.26614L3.28519 7.80388L5.79101 10.0896L7.6873 12.0113C7.85661 12.1721 7.9582 12.4007 7.9582 12.6631C7.9582 13.1711 7.57725 13.552 7.04392 13.552C6.81534 13.552 6.58677 13.4589 6.3836 13.2642L0.804762 7.68536C0.610053 7.49912 0.5 7.25361 0.5 6.99965Z", fill: "#3548C9" })), nwe = (t) => {
  const { currentPage: r, totalPages: e, onPageChange: n, className: i = "" } = t, a = [];
  if (e <= 5)
    for (let o = 1; o <= e; o++)
      a.push(o.toString());
  else {
    const o = r - 4, s = r + 4 > e ? e : r + 4;
    for (let l = o <= 0 ? 1 : o; l <= s; l++)
      a.push(l.toString());
    r + 4 <= e && a.push("...");
  }
  return /* @__PURE__ */ S.jsxs("div", { className: `theme-pagination ${i}`, children: [
    /* @__PURE__ */ S.jsx(
      "div",
      {
        className: "theme-pagination-page-number theme-pagination-arrow",
        onClick: () => n((r - 1 <= 0 ? 1 : r - 1).toString()),
        children: /* @__PURE__ */ S.jsx("span", { children: /* @__PURE__ */ S.jsx(Jk, { className: "theme-pagination-arrow-left" }) })
      }
    ),
    a.map((o) => /* @__PURE__ */ S.jsx(
      "div",
      {
        className: `theme-pagination-page-number ${parseInt(o) === r && "active"}`,
        onClick: () => {
          n(
            o === "..." ? (r + 3 > e ? e : r + 3).toString() : o
          );
        },
        children: /* @__PURE__ */ S.jsx("span", { children: o })
      },
      `pagination-${o}`
    )),
    /* @__PURE__ */ S.jsx(
      "div",
      {
        className: "theme-pagination-page-number theme-pagination-arrow",
        onClick: () => n(
          (r + 1 > e ? e : r + 1).toString()
        ),
        children: /* @__PURE__ */ S.jsx("span", { children: /* @__PURE__ */ S.jsx(Jk, { className: "theme-pagination-arrow-right" }) })
      }
    )
  ] });
}, aj = (t) => /* @__PURE__ */ $.createElement("svg", { width: 22, height: 24, viewBox: "0 0 22 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ $.createElement("path", { d: "M12.0566 15.9521C11.8242 15.9521 11.6191 15.8633 11.4414 15.6787L6.23242 10.3535C6.08203 10.2031 6 10.0117 6 9.79297C6 9.34863 6.34863 9 6.79297 9C7.01172 9 7.20996 9.08887 7.36719 9.23926L12.0566 14.0449L16.7461 9.23926C16.8965 9.08887 17.1016 9 17.3203 9C17.7578 9 18.1064 9.34863 18.1064 9.79297C18.1064 10.0186 18.0312 10.2031 17.8809 10.3535L12.6719 15.6787C12.501 15.8633 12.2891 15.9521 12.0566 15.9521Z", fill: "#395278" })), Nl = JSON.parse('[{"name":"Afghanistan","dial_code":"+93","emoji":"🇦🇫"},{"name":"Albania","dial_code":"+355","emoji":"🇦🇱"},{"name":"Andorra","dial_code":"+376","emoji":"🇦🇩"},{"name":"Angola","dial_code":"+244","emoji":"🇦🇴"},{"name":"Anguilla","dial_code":"+1264","emoji":"🇦🇮"},{"name":"Antarctica","dial_code":"+672","emoji":"🇦🇶"},{"name":"Antigua & Barbuda","dial_code":"+1268","emoji":"🇦🇬"},{"name":"Argentina","dial_code":"+54","emoji":"🇦🇷"},{"name":"Armenia","dial_code":"+374","emoji":"🇦🇲"},{"name":"Aruba","dial_code":"+297","emoji":"🇦🇼"},{"name":"Australia","dial_code":"+61","emoji":"🇦🇺"},{"name":"Austria","dial_code":"+43","emoji":"🇦🇹"},{"name":"Azerbaijan","dial_code":"+994","emoji":"🇦🇿"},{"name":"Bahamas","dial_code":"+1242","emoji":"🇧🇸"},{"name":"Bahrain","dial_code":"+973","emoji":"🇧🇭"},{"name":"Bangladesh","dial_code":"+880","emoji":"🇧🇩"},{"name":"Barbados","dial_code":"+1246","emoji":"🇧🇧"},{"name":"Belarus","dial_code":"+375","emoji":"🇧🇾"},{"name":"Belgium","dial_code":"+32","emoji":"🇧🇪"},{"name":"Belize","dial_code":"+501","emoji":"🇧🇿"},{"name":"Benin","dial_code":"+229","emoji":"🇧🇯"},{"name":"Bermuda","dial_code":"+1441","emoji":"🇧🇲"},{"name":"Bhutan","dial_code":"+975","emoji":"🇧🇹"},{"name":"Bolivia","dial_code":"+591","emoji":"🇧🇴"},{"name":"Bosnia & Herzegovina","dial_code":"+387","emoji":"🇧🇦"},{"name":"Botswana","dial_code":"+267","emoji":"🇧🇼"},{"name":"Brazil","dial_code":"+55","emoji":"🇧🇷"},{"name":"Brunei","dial_code":"+673","emoji":"🇧🇳"},{"name":"Bulgaria","dial_code":"+359","emoji":"🇧🇬"},{"name":"Burkina Faso","dial_code":"+226","emoji":"🇧🇫"},{"name":"Burundi","dial_code":"+257","emoji":"🇧🇮"},{"name":"Cabo Verde","dial_code":"+238","emoji":"🇨🇻"},{"name":"Cambodia","dial_code":"+855","emoji":"🇰🇭"},{"name":"Cameroon","dial_code":"+237","emoji":"🇨🇲"},{"name":"Canada","dial_code":"+1","emoji":"🇨🇦"},{"name":"Cayman Islands","dial_code":"+1345","emoji":"🇰🇾"},{"name":"Central African Republic","dial_code":"+236","emoji":"🇨🇫"},{"name":"Chad","dial_code":"+235","emoji":"🇹🇩"},{"name":"Chile","dial_code":"+56","emoji":"🇨🇱"},{"name":"China","dial_code":"+86","emoji":"🇨🇳"},{"name":"Colombia","dial_code":"+57","emoji":"🇨🇴"},{"name":"Comoros","dial_code":"+269","emoji":"🇰🇲"},{"name":"Congo - Brazzaville","dial_code":"+242","emoji":"🇨🇬"},{"name":"Congo - Kinshasa","dial_code":"+243","emoji":"🇨🇩"},{"name":"Cook Islands","dial_code":"+682","emoji":"🇨🇰"},{"name":"Costa Rica","dial_code":"+506","emoji":"🇨🇷"},{"name":"Croatia","dial_code":"+385","emoji":"🇭🇷"},{"name":"Cuba","dial_code":"+53","emoji":"🇨🇺"},{"name":"Curaçao","dial_code":"+599","emoji":"🇨🇼"},{"name":"Cyprus","dial_code":"+357","emoji":"🇨🇾"},{"name":"Czechia","dial_code":"+420","emoji":"🇨🇿"},{"name":"Côte d’Ivoire","dial_code":"+225","emoji":"🇨🇮"},{"name":"Denmark","dial_code":"+45","emoji":"🇩🇰"},{"name":"Djibouti","dial_code":"+253","emoji":"🇩🇯"},{"name":"Dominica","dial_code":"+1767","emoji":"🇩🇲"},{"name":"Dominican Republic","dial_code":"+1 809, +1 829, +1 849","emoji":"🇩🇴"},{"name":"Ecuador","dial_code":"+593","emoji":"🇪🇨"},{"name":"Egypt","dial_code":"+20","emoji":"🇪🇬"},{"name":"El Salvador","dial_code":"+503","emoji":"🇸🇻"},{"name":"Equatorial Guinea","dial_code":"+240","emoji":"🇬🇶"},{"name":"Eritrea","dial_code":"+291","emoji":"🇪🇷"},{"name":"Estonia","dial_code":"+372","emoji":"🇪🇪"},{"name":"Eswatini","dial_code":"+268","emoji":"🇸🇿"},{"name":"Ethiopia","dial_code":"+251","emoji":"🇪🇹"},{"name":"Falkland Islands","dial_code":"+500","emoji":"🇫🇰"},{"name":"Faroe Islands","dial_code":"+298","emoji":"🇫🇴"},{"name":"Fiji","dial_code":"+679","emoji":"🇫🇯"},{"name":"Finland","dial_code":"+358","emoji":"🇫🇮"},{"name":"France","dial_code":"+33","emoji":"🇫🇷"},{"name":"French Guiana","dial_code":"+594","emoji":"🇬🇫"},{"name":"French Polynesia","dial_code":"+689","emoji":"🇵🇫"},{"name":"Gabon","dial_code":"+241","emoji":"🇬🇦"},{"name":"Gambia","dial_code":"+220","emoji":"🇬🇲"},{"name":"Georgia","dial_code":"+995","emoji":"🇬🇪"},{"name":"Germany","dial_code":"+49","emoji":"🇩🇪"},{"name":"Ghana","dial_code":"+233","emoji":"🇬🇭"},{"name":"Gibraltar","dial_code":"+350","emoji":"🇬🇮"},{"name":"Greece","dial_code":"+30","emoji":"🇬🇷"},{"name":"Greenland","dial_code":"+299","emoji":"🇬🇱"},{"name":"Grenada","dial_code":"+1473","emoji":"🇬🇩"},{"name":"Guadeloupe","dial_code":"+590","emoji":"🇬🇵"},{"name":"Guam","dial_code":"+1671","emoji":"🇬🇺"},{"name":"Guatemala","dial_code":"+502","emoji":"🇬🇹"},{"name":"Guernsey","dial_code":"+44","emoji":"🇬🇬"},{"name":"Guinea","dial_code":"+224","emoji":"🇬🇳"},{"name":"Guinea-Bissau","dial_code":"+245","emoji":"🇬🇼"},{"name":"Guyana","dial_code":"+592","emoji":"🇬🇾"},{"name":"Haiti","dial_code":"+509","emoji":"🇭🇹"},{"name":"Honduras","dial_code":"+504","emoji":"🇭🇳"},{"name":"Hong Kong SAR China","dial_code":"+852","emoji":"🇭🇰"},{"name":"Hungary","dial_code":"+36","emoji":"🇭🇺"},{"name":"Iceland","dial_code":"+354","emoji":"🇮🇸"},{"name":"India","dial_code":"+91","emoji":"🇮🇳"},{"name":"Indonesia","dial_code":"+62","emoji":"🇮🇩"},{"name":"Iran","dial_code":"+98","emoji":"🇮🇷"},{"name":"Iraq","dial_code":"+964","emoji":"🇮🇶"},{"name":"Ireland","dial_code":"+353","emoji":"🇮🇪"},{"name":"Isle of Man","dial_code":"+44","emoji":"🇮🇲"},{"name":"Israel","dial_code":"+972","emoji":"🇮🇱"},{"name":"Italy","dial_code":"+39","emoji":"🇮🇹"},{"name":"Jamaica","dial_code":"+1 876","emoji":"🇯🇲"},{"name":"Japan","dial_code":"+81","emoji":"🇯🇵"},{"name":"Jersey","dial_code":"+44","emoji":"🇯🇪"},{"name":"Jordan","dial_code":"+962","emoji":"🇯🇴"},{"name":"Kazakhstan","dial_code":"+7","emoji":"🇰🇿"},{"name":"Kenya","dial_code":"+254","emoji":"🇰🇪"},{"name":"Kiribati","dial_code":"+686","emoji":"🇰🇮"},{"name":"Kosovo","dial_code":"+383","emoji":"🇽🇰"},{"name":"Kuwait","dial_code":"+965","emoji":"🇰🇼"},{"name":"Kyrgyzstan","dial_code":"+996","emoji":"🇰🇬"},{"name":"Laos","dial_code":"+856","emoji":"🇱🇦"},{"name":"Latvia","dial_code":"+371","emoji":"🇱🇻"},{"name":"Lebanon","dial_code":"+961","emoji":"🇱🇧"},{"name":"Lesotho","dial_code":"+266","emoji":"🇱🇸"},{"name":"Liberia","dial_code":"+231","emoji":"🇱🇷"},{"name":"Libya","dial_code":"+218","emoji":"🇱🇾"},{"name":"Liechtenstein","dial_code":"+423","emoji":"🇱🇮"},{"name":"Lithuania","dial_code":"+370","emoji":"🇱🇹"},{"name":"Luxembourg","dial_code":"+352","emoji":"🇱🇺"},{"name":"Macao SAR China","dial_code":"+853","emoji":"🇲🇴"},{"name":"Madagascar","dial_code":"+261","emoji":"🇲🇬"},{"name":"Malawi","dial_code":"+265","emoji":"🇲🇼"},{"name":"Malaysia","dial_code":"+60","emoji":"🇲🇾"},{"name":"Maldives","dial_code":"+960","emoji":"🇲🇻"},{"name":"Mali","dial_code":"+223","emoji":"🇲🇱"},{"name":"Malta","dial_code":"+356","emoji":"🇲🇹"},{"name":"Marshall Islands","dial_code":"+692","emoji":"🇲🇭"},{"name":"Martinique","dial_code":"+596","emoji":"🇲🇶"},{"name":"Mauritania","dial_code":"+222","emoji":"🇲🇷"},{"name":"Mauritius","dial_code":"+230","emoji":"🇲🇺"},{"name":"Mayotte","dial_code":"+262","emoji":"🇾🇹"},{"name":"Mexico","dial_code":"+52","emoji":"🇲🇽"},{"name":"Micronesia","dial_code":"+691","emoji":"🇫🇲"},{"name":"Moldova","dial_code":"+373","emoji":"🇲🇩"},{"name":"Monaco","dial_code":"+377","emoji":"🇲🇨"},{"name":"Mongolia","dial_code":"+976","emoji":"🇲🇳"},{"name":"Montenegro","dial_code":"+382","emoji":"🇲🇪"},{"name":"Montserrat","dial_code":"+1 664","emoji":"🇲🇸"},{"name":"Morocco","dial_code":"+212","emoji":"🇲🇦"},{"name":"Mozambique","dial_code":"+258","emoji":"🇲🇿"},{"name":"Myanmar (Burma)","dial_code":"+95","emoji":"🇲🇲"},{"name":"Namibia","dial_code":"+264","emoji":"🇳🇦"},{"name":"Nauru","dial_code":"+674","emoji":"🇳🇷"},{"name":"Nepal","dial_code":"+977","emoji":"🇳🇵"},{"name":"Netherlands","dial_code":"+31","emoji":"🇳🇱"},{"name":"New Caledonia","dial_code":"+687","emoji":"🇳🇨"},{"name":"New Zealand","dial_code":"+64","emoji":"🇳🇿"},{"name":"Nicaragua","dial_code":"+505","emoji":"🇳🇮"},{"name":"Niger","dial_code":"+227","emoji":"🇳🇪"},{"name":"Nigeria","dial_code":"+234","emoji":"🇳🇬"},{"name":"Niue","dial_code":"+683","emoji":"🇳🇺"},{"name":"Norfolk Island","dial_code":"+672","emoji":"🇳🇫"},{"name":"North Korea","dial_code":"+850","emoji":"🇰🇵"},{"name":"Northern Mariana Islands","dial_code":"+1 670","emoji":"🇲🇵"},{"name":"Norway","dial_code":"+47","emoji":"🇳🇴"},{"name":"Oman","dial_code":"+968","emoji":"🇴🇲"},{"name":"Pakistan","dial_code":"+92","emoji":"🇵🇰"},{"name":"Palau","dial_code":"+680","emoji":"🇵🇼"},{"name":"Palestinian Territories","dial_code":"+970","emoji":"🇵🇸"},{"name":"Panama","dial_code":"+507","emoji":"🇵🇦"},{"name":"Papua New Guinea","dial_code":"+675","emoji":"🇵🇬"},{"name":"Paraguay","dial_code":"+595","emoji":"🇵🇾"},{"name":"Peru","dial_code":"+51","emoji":"🇵🇪"},{"name":"Philippines","dial_code":"+63","emoji":"🇵🇭"},{"name":"Pitcairn Islands","dial_code":"+64","emoji":"🇵🇳"},{"name":"Poland","dial_code":"+48","emoji":"🇵🇱"},{"name":"Portugal","dial_code":"+351","emoji":"🇵🇹"},{"name":"Puerto Rico","dial_code":"+1 787","emoji":"🇵🇷"},{"name":"Qatar","dial_code":"+974","emoji":"🇶🇦"},{"name":"Réunion","dial_code":"+262","emoji":"🇷🇪"},{"name":"Romania","dial_code":"+40","emoji":"🇷🇴"},{"name":"Russia","dial_code":"+7","emoji":"🇷🇺"},{"name":"Rwanda","dial_code":"+250","emoji":"🇷🇼"},{"name":"Saint Helena","dial_code":"+290","emoji":"🇸🇭"},{"name":"Saint Kitts & Nevis","dial_code":"+1 869","emoji":"🇰🇳"},{"name":"Saint Lucia","dial_code":"+1 758","emoji":"🇱🇨"},{"name":"Saint Pierre & Miquelon","dial_code":"+508","emoji":"🇵🇲"},{"name":"Samoa","dial_code":"+685","emoji":"🇼🇸"},{"name":"San Marino","dial_code":"+378","emoji":"🇸🇲"},{"name":"Sao Tome & Principe","dial_code":"+239","emoji":"🇸🇹"},{"name":"Saudi Arabia","dial_code":"+966","emoji":"🇸🇦"},{"name":"Senegal","dial_code":"+221","emoji":"🇸🇳"},{"name":"Serbia","dial_code":"+381","emoji":"🇷🇸"},{"name":"Seychelles","dial_code":"+248","emoji":"🇸🇨"},{"name":"Sierra Leone","dial_code":"+232","emoji":"🇸🇱"},{"name":"Singapore","dial_code":"+65","emoji":"🇸🇬"},{"name":"Sint Maarten","dial_code":"+1 721","emoji":"🇸🇽"},{"name":"Slovakia","dial_code":"+421","emoji":"🇸🇰"},{"name":"Slovenia","dial_code":"+386","emoji":"🇸🇮"},{"name":"Solomon Islands","dial_code":"+677","emoji":"🇸🇧"},{"name":"Somalia","dial_code":"+252","emoji":"🇸🇴"},{"name":"South Africa","dial_code":"+27","emoji":"🇿🇦"},{"name":"South Korea","dial_code":"+82","emoji":"🇰🇷"},{"name":"South Sudan","dial_code":"+211","emoji":"🇸🇸"},{"name":"Spain","dial_code":"+34","emoji":"🇪🇸"},{"name":"Sri Lanka","dial_code":"+94","emoji":"🇱🇰"},{"name":"Sudan","dial_code":"+249","emoji":"🇸🇩"},{"name":"Suriname","dial_code":"+597","emoji":"🇸🇷"},{"name":"Sweden","dial_code":"+46","emoji":"🇸🇪"},{"name":"Switzerland","dial_code":"+41","emoji":"🇨🇭"},{"name":"Syria","dial_code":"+963","emoji":"🇸🇾"},{"name":"Taiwan","dial_code":"+886","emoji":"🇹🇼"},{"name":"Tajikistan","dial_code":"+992","emoji":"🇹🇯"},{"name":"Tanzania","dial_code":"+255","emoji":"🇹🇿"},{"name":"Thailand","dial_code":"+66","emoji":"🇹🇭"},{"name":"Timor-Leste","dial_code":"+670","emoji":"🇹🇱"},{"name":"Togo","dial_code":"+228","emoji":"🇹🇬"},{"name":"Tokelau","dial_code":"+690","emoji":"🇹🇰"},{"name":"Tonga","dial_code":"+676","emoji":"🇹🇴"},{"name":"Trinidad & Tobago","dial_code":"+1 868","emoji":"🇹🇹"},{"name":"Tunisia","dial_code":"+216","emoji":"🇹🇳"},{"name":"Turkey","dial_code":"+90","emoji":"🇹🇷"},{"name":"Turkmenistan","dial_code":"+993","emoji":"🇹🇲"},{"name":"Turks & Caicos Islands","dial_code":"+1 649","emoji":"🇹🇨"},{"name":"Tuvalu","dial_code":"+688","emoji":"🇹🇻"},{"name":"Uganda","dial_code":"+256","emoji":"🇺🇬"},{"name":"Ukraine","dial_code":"+380","emoji":"🇺🇦"},{"name":"United Arab Emirates","dial_code":"+971","emoji":"🇦🇪"},{"name":"United Kingdom","dial_code":"+44","emoji":"🇬🇧"},{"name":"United States","dial_code":"+1","emoji":"🇺🇸"},{"name":"Uruguay","dial_code":"+598","emoji":"🇺🇾"},{"name":"Uzbekistan","dial_code":"+998","emoji":"🇺🇿"},{"name":"Vanuatu","dial_code":"+678","emoji":"🇻🇺"},{"name":"Vatican City","dial_code":"+379","emoji":"🇻🇦"},{"name":"Venezuela","dial_code":"+58","emoji":"🇻🇪"},{"name":"Vietnam","dial_code":"+84","emoji":"🇻🇳"},{"name":"Wallis & Futuna","dial_code":"+681","emoji":"🇼🇫"}]'), Q8e = (t) => {
  const [r, e] = We(null), [n, i] = We(null), [a, o] = We(""), [s, l] = We(!1), [u, c] = We([]), {
    name: d,
    value: f,
    placeholder: h,
    containerClassName: p,
    onInputChange: v,
    className: g,
    formLabel: m,
    formSubLabel: y,
    inputHelpBlock: b,
    isRequired: C = !1,
    disabled: w = !1
  } = t, _ = (x) => {
    if (x.length <= 3)
      return c(Nl), !0;
    const I = Nl.filter(
      (D) => {
        var T;
        return (T = D.name) == null ? void 0 : T.toLowerCase().includes(x);
      }
    );
    c(I);
  };
  return Ue(() => {
    if (f && f !== "") {
      const x = f.split("-");
      if (x[0] !== void 0) {
        const I = Nl.filter(
          (D) => D.dial_code === x[0]
        );
        I[0] !== void 0 && (e(x[0]), i(I[0]));
      }
      x[1] && o(x[1]);
    }
  }, [f]), Ue(() => {
    c(Nl);
  }, []), /* @__PURE__ */ S.jsxs(
    "div",
    {
      className: `theme-form-input-container ${p !== void 0 ? p : ""}`,
      children: [
        m && /* @__PURE__ */ S.jsxs("label", { className: "theme-form-input-label", htmlFor: `field-${d}`, children: [
          m,
          " ",
          C && /* @__PURE__ */ S.jsx("span", { children: "*" })
        ] }),
        y && /* @__PURE__ */ S.jsx("label", { className: "theme-form-sublabel", children: y }),
        /* @__PURE__ */ S.jsxs("div", { className: "theme-phone-input", children: [
          /* @__PURE__ */ S.jsxs(
            "button",
            {
              id: `field-phoneDropdown-${d}`,
              className: "theme-phone-dropdown-toggle",
              type: "button",
              onClick: () => l(!s),
              disabled: w,
              children: [
                n === null && "Select Country",
                n !== null && /* @__PURE__ */ S.jsx("div", { className: "button-text", children: /* @__PURE__ */ S.jsx("span", { children: n.dial_code }) }),
                /* @__PURE__ */ S.jsx(
                  aj,
                  {
                    className: `theme-phone-dropdown-toggle-icon ${s && "is-opened"}`
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ S.jsx(
            "div",
            {
              className: `theme-phone-dropdown ${!s && "theme-phone-dropdown-hidden"}`,
              children: /* @__PURE__ */ S.jsxs("ul", { children: [
                /* @__PURE__ */ S.jsx("li", { className: "p-4", children: /* @__PURE__ */ S.jsx(
                  "input",
                  {
                    type: "text",
                    className: "theme-form-control theme-phone-search",
                    placeholder: "Search...",
                    onChange: (x) => _(x.target.value)
                  }
                ) }),
                u.map(
                  (x, I) => /* @__PURE__ */ S.jsx(
                    "li",
                    {
                      onClick: () => {
                        e(x.dial_code), i(x), l(!1), v && v(`${x.dial_code}-${a}`);
                      },
                      children: /* @__PURE__ */ S.jsxs("p", { children: [
                        x.name,
                        " (",
                        x.dial_code,
                        ")"
                      ] })
                    },
                    `field-phoneDropdown-${d}-${I}`
                  )
                )
              ] })
            }
          ),
          /* @__PURE__ */ S.jsx(
            "input",
            {
              id: `field-phoneInput-${d}`,
              disabled: w,
              placeholder: h,
              type: "text",
              name: d,
              value: a !== null ? a : "",
              className: `theme-form-control ${g !== void 0 ? g : ""}`,
              autoComplete: "off",
              onChange: (x) => {
                const I = x.target.value.replace(/[^0-9]/g, "");
                o(I), v && v(`${r}-${I}`);
              }
            }
          ),
          b && /* @__PURE__ */ S.jsx("span", { className: "theme-form-helpblock", children: b })
        ] })
      ]
    }
  );
}, eSe = (t) => {
  const [r, e] = We(null), [n, i] = We(null), [a, o] = We(""), [s, l] = We(!1), [u, c] = We([]), {
    name: d,
    defaultValue: f,
    placeholder: h,
    containerClassName: p,
    onInputChange: v,
    className: g,
    formLabel: m,
    formSubLabel: y,
    inputHelpBlock: b,
    isRequired: C = !1,
    disabled: w = !1,
    rules: _,
    control: x,
    errors: I
  } = t, D = (T) => {
    if (T.length <= 3)
      return c(Nl), !0;
    const A = Nl.filter(
      (M) => {
        var R;
        return (R = M.name) == null ? void 0 : R.toLowerCase().includes(T);
      }
    );
    c(A);
  };
  return Ue(() => {
    if (f && f !== "") {
      const T = f.split("-");
      if (T[0] !== void 0) {
        const A = Nl.filter(
          (M) => M.dial_code === T[0]
        );
        A[0] !== void 0 && (e(T[0]), i(A[0]));
      }
      T[1] && o(T[1]);
    }
  }, [f]), Ue(() => {
    c(Nl);
  }, []), /* @__PURE__ */ S.jsxs(
    "div",
    {
      className: `theme-form-input-container ${p !== void 0 ? p : ""}`,
      children: [
        m && /* @__PURE__ */ S.jsxs("label", { className: "theme-form-input-label", htmlFor: `field-${d}`, children: [
          m,
          " ",
          C && /* @__PURE__ */ S.jsx("span", { children: "*" })
        ] }),
        y && /* @__PURE__ */ S.jsx("label", { className: "theme-form-sublabel", children: y }),
        /* @__PURE__ */ S.jsx(
          mu,
          {
            name: d,
            control: x,
            defaultValue: f,
            rules: _ || {},
            render: ({ field: { onChange: T } }) => /* @__PURE__ */ S.jsxs("div", { className: "theme-phone-input", children: [
              /* @__PURE__ */ S.jsxs(
                "button",
                {
                  id: `field-phoneDropdown-${d}`,
                  className: "theme-phone-dropdown-toggle",
                  type: "button",
                  onClick: () => l(!s),
                  children: [
                    n === null && "Select Country",
                    n !== null && /* @__PURE__ */ S.jsx("div", { className: "button-text", children: /* @__PURE__ */ S.jsx("span", { children: n.dial_code }) }),
                    /* @__PURE__ */ S.jsx(
                      aj,
                      {
                        className: `theme-phone-dropdown-toggle-icon ${s && "is-opened"}`
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ S.jsx(
                "div",
                {
                  className: `theme-phone-dropdown ${!s && "theme-phone-dropdown-hidden"}`,
                  children: /* @__PURE__ */ S.jsxs("ul", { children: [
                    /* @__PURE__ */ S.jsx("li", { className: "p-4", children: /* @__PURE__ */ S.jsx(
                      "input",
                      {
                        type: "text",
                        className: "theme-form-control theme-phone-search",
                        placeholder: "Search...",
                        onChange: (A) => D(A.target.value)
                      }
                    ) }),
                    u.map(
                      (A, M) => /* @__PURE__ */ S.jsx(
                        "li",
                        {
                          onClick: () => {
                            e(A.dial_code), i(A), l(!1), T(`${A.dial_code}-${a}`), v && v(`${A.dial_code}-${a}`);
                          },
                          children: /* @__PURE__ */ S.jsxs("p", { children: [
                            A.name,
                            " (",
                            A.dial_code,
                            ")"
                          ] })
                        },
                        `field-phoneDropdown-${d}-${M}`
                      )
                    )
                  ] })
                }
              ),
              /* @__PURE__ */ S.jsx(
                "input",
                {
                  id: `field-phoneInput-${d}`,
                  disabled: w,
                  placeholder: h,
                  type: "text",
                  name: d,
                  value: a !== null ? a : "",
                  className: `theme-form-control ${g !== void 0 ? g : ""}`,
                  autoComplete: "off",
                  onChange: (A) => {
                    const M = A.target.value.replace(/[^0-9]/g, "");
                    o(M), T(`${r}-${M}`), v && v(`${r}-${M}`);
                  }
                }
              ),
              b && /* @__PURE__ */ S.jsx("span", { className: "theme-form-helpblock", children: b })
            ] })
          }
        ),
        /* @__PURE__ */ S.jsx(
          yu,
          {
            errors: I,
            name: d,
            render: ({ message: T }) => /* @__PURE__ */ S.jsx("div", { className: "theme-font-sm color-theme-red-500 theme-form-error-message", children: T })
          }
        )
      ]
    }
  );
};
/*!
 * OverlayScrollbars
 * Version: 2.10.1
 *
 * Copyright (c) Rene Haas | KingSora.
 * https://github.com/KingSora
 *
 * Released under the MIT license.
 */
const Wi = (t, r) => {
  const { o: e, i: n, u: i } = t;
  let a = e, o;
  const s = (c, d) => {
    const f = a, h = c, p = d || (n ? !n(f, h) : f !== h);
    return (p || i) && (a = h, o = f), [a, p, o];
  };
  return [r ? (c) => s(r(a, o), c) : s, (c) => [a, !!c, o]];
}, iwe = typeof window < "u" && typeof HTMLElement < "u" && !!window.document, Ni = iwe ? window : {}, oj = Math.max, awe = Math.min, X6 = Math.round, Vy = Math.abs, Kk = Math.sign, sj = Ni.cancelAnimationFrame, f8 = Ni.requestAnimationFrame, Gy = Ni.setTimeout, $6 = Ni.clearTimeout, f5 = (t) => typeof Ni[t] < "u" ? Ni[t] : void 0, owe = f5("MutationObserver"), qk = f5("IntersectionObserver"), By = f5("ResizeObserver"), nm = f5("ScrollTimeline"), h8 = (t) => t === void 0, h5 = (t) => t === null, Jo = (t) => typeof t == "number", jg = (t) => typeof t == "string", p8 = (t) => typeof t == "boolean", Ea = (t) => typeof t == "function", rs = (t) => Array.isArray(t), Fy = (t) => typeof t == "object" && !rs(t) && !h5(t), v8 = (t) => {
  const r = !!t && t.length, e = Jo(r) && r > -1 && r % 1 == 0;
  return rs(t) || !Ea(t) && e ? r > 0 && Fy(t) ? r - 1 in t : !0 : !1;
}, Hy = (t) => !!t && t.constructor === Object, zy = (t) => t instanceof HTMLElement, p5 = (t) => t instanceof Element;
function wr(t, r) {
  if (v8(t))
    for (let e = 0; e < t.length && r(t[e], e, t) !== !1; e++)
      ;
  else t && wr(Object.keys(t), (e) => r(t[e], e, t));
  return t;
}
const lj = (t, r) => t.indexOf(r) >= 0, tg = (t, r) => t.concat(r), jr = (t, r, e) => (!jg(r) && v8(r) ? Array.prototype.push.apply(t, r) : t.push(r), t), Cu = (t) => Array.from(t || []), g8 = (t) => rs(t) ? t : !jg(t) && v8(t) ? Cu(t) : [t], U6 = (t) => !!t && !t.length, J6 = (t) => Cu(new Set(t)), ta = (t, r, e) => {
  wr(t, (i) => i ? i.apply(void 0, r || []) : !0), !e && (t.length = 0);
}, uj = "paddingTop", cj = "paddingRight", dj = "paddingLeft", fj = "paddingBottom", hj = "marginLeft", pj = "marginRight", vj = "marginBottom", gj = "overflowX", mj = "overflowY", v5 = "width", g5 = "height", Sl = "visible", Cc = "hidden", $f = "scroll", swe = (t) => {
  const r = String(t || "");
  return r ? r[0].toUpperCase() + r.slice(1) : "";
}, m5 = (t, r, e, n) => {
  if (t && r) {
    let i = !0;
    return wr(e, (a) => {
      const o = t[a], s = r[a];
      o !== s && (i = !1);
    }), i;
  }
  return !1;
}, yj = (t, r) => m5(t, r, ["w", "h"]), im = (t, r) => m5(t, r, ["x", "y"]), lwe = (t, r) => m5(t, r, ["t", "r", "b", "l"]), Pc = () => {
}, pt = (t, ...r) => t.bind(0, ...r), sf = (t) => {
  let r;
  const e = t ? Gy : f8, n = t ? $6 : sj;
  return [(i) => {
    n(r), r = e(() => i(), Ea(t) ? t() : t);
  }, () => n(r)];
}, K6 = (t, r) => {
  const { _: e, p: n, v: i, S: a } = r || {};
  let o, s, l, u, c = Pc;
  const d = function(g) {
    c(), $6(o), u = o = s = void 0, c = Pc, t.apply(this, g);
  }, f = (v) => a && s ? a(s, v) : v, h = () => {
    c !== Pc && d(f(l) || l);
  }, p = function() {
    const g = Cu(arguments), m = Ea(e) ? e() : e;
    if (Jo(m) && m >= 0) {
      const b = Ea(n) ? n() : n, C = Jo(b) && b >= 0, w = m > 0 ? Gy : f8, _ = m > 0 ? $6 : sj, I = f(g) || g, D = d.bind(0, I);
      let T;
      c(), i && !u ? (D(), u = !0, T = w(() => u = void 0, m)) : (T = w(D, m), C && !o && (o = Gy(h, b))), c = () => _(T), s = l = I;
    } else
      d(g);
  };
  return p.m = h, p;
}, bj = (t, r) => Object.prototype.hasOwnProperty.call(t, r), lo = (t) => t ? Object.keys(t) : [], qt = (t, r, e, n, i, a, o) => {
  const s = [r, e, n, i, a, o];
  return (typeof t != "object" || h5(t)) && !Ea(t) && (t = {}), wr(s, (l) => {
    wr(l, (u, c) => {
      const d = l[c];
      if (t === d)
        return !0;
      const f = rs(d);
      if (d && Hy(d)) {
        const h = t[c];
        let p = h;
        f && !rs(h) ? p = [] : !f && !Hy(h) && (p = {}), t[c] = qt(p, d);
      } else
        t[c] = f ? d.slice() : d;
    });
  }), t;
}, Cj = (t, r) => wr(qt({}, t), (e, n, i) => {
  e === void 0 ? delete i[n] : e && Hy(e) && (i[n] = Cj(e));
}), m8 = (t) => !lo(t).length, wj = (t, r, e) => oj(t, awe(r, e)), Nc = (t) => J6((rs(t) ? t : (t || "").split(" ")).filter((r) => r)), y8 = (t, r) => t && t.getAttribute(r), Qk = (t, r) => t && t.hasAttribute(r), Ss = (t, r, e) => {
  wr(Nc(r), (n) => {
    t && t.setAttribute(n, String(e || ""));
  });
}, So = (t, r) => {
  wr(Nc(r), (e) => t && t.removeAttribute(e));
}, y5 = (t, r) => {
  const e = Nc(y8(t, r)), n = pt(Ss, t, r), i = (a, o) => {
    const s = new Set(e);
    return wr(Nc(a), (l) => {
      s[o](l);
    }), Cu(s).join(" ");
  };
  return {
    O: (a) => n(i(a, "delete")),
    $: (a) => n(i(a, "add")),
    C: (a) => {
      const o = Nc(a);
      return o.reduce((s, l) => s && e.includes(l), o.length > 0);
    }
  };
}, _j = (t, r, e) => (y5(t, r).O(e), pt(b8, t, r, e)), b8 = (t, r, e) => (y5(t, r).$(e), pt(_j, t, r, e)), Wy = (t, r, e, n) => (n ? b8 : _j)(t, r, e), C8 = (t, r, e) => y5(t, r).C(e), xj = (t) => y5(t, "class"), Sj = (t, r) => {
  xj(t).O(r);
}, w8 = (t, r) => (xj(t).$(r), pt(Sj, t, r)), Ij = (t, r) => {
  const e = r ? p5(r) && r : document;
  return e ? Cu(e.querySelectorAll(t)) : [];
}, uwe = (t, r) => {
  const e = r ? p5(r) && r : document;
  return e && e.querySelector(t);
}, q6 = (t, r) => p5(t) && t.matches(r), Aj = (t) => q6(t, "body"), Q6 = (t) => t ? Cu(t.childNodes) : [], rg = (t) => t && t.parentElement, lf = (t, r) => p5(t) && t.closest(r), e7 = (t) => document.activeElement, cwe = (t, r, e) => {
  const n = lf(t, r), i = t && uwe(e, n), a = lf(i, r) === n;
  return n && i ? n === t || i === t || a && lf(lf(t, e), r) !== n : !1;
}, Uf = (t) => {
  wr(g8(t), (r) => {
    const e = rg(r);
    r && e && e.removeChild(r);
  });
}, Xi = (t, r) => pt(Uf, t && r && wr(g8(r), (e) => {
  e && t.appendChild(e);
})), Sf = (t) => {
  const r = document.createElement("div");
  return Ss(r, "class", t), r;
}, Dj = (t) => {
  const r = Sf();
  return r.innerHTML = t.trim(), wr(Q6(r), (e) => Uf(e));
}, eP = (t, r) => t.getPropertyValue(r) || t[r] || "", Tj = (t) => {
  const r = t || 0;
  return isFinite(r) ? r : 0;
}, p0 = (t) => Tj(parseFloat(t || "")), t7 = (t) => Math.round(t * 1e4) / 1e4, Mj = (t) => `${t7(Tj(t))}px`;
function ng(t, r) {
  t && r && wr(r, (e, n) => {
    try {
      const i = t.style, a = h5(e) || p8(e) ? "" : Jo(e) ? Mj(e) : e;
      n.indexOf("--") === 0 ? i.setProperty(n, a) : i[n] = a;
    } catch {
    }
  });
}
function il(t, r, e) {
  const n = jg(r);
  let i = n ? "" : {};
  if (t) {
    const a = Ni.getComputedStyle(t, e) || t.style;
    i = n ? eP(a, r) : Cu(r).reduce((o, s) => (o[s] = eP(a, s), o), i);
  }
  return i;
}
const tP = (t, r, e) => {
  const n = r ? `${r}-` : "", i = e ? `-${e}` : "", a = `${n}top${i}`, o = `${n}right${i}`, s = `${n}bottom${i}`, l = `${n}left${i}`, u = il(t, [a, o, s, l]);
  return {
    t: p0(u[a]),
    r: p0(u[o]),
    b: p0(u[s]),
    l: p0(u[l])
  };
}, dwe = (t, r) => `translate${Fy(t) ? `(${t.x},${t.y})` : `Y(${t})`}`, fwe = (t) => !!(t.offsetWidth || t.offsetHeight || t.getClientRects().length), hwe = {
  w: 0,
  h: 0
}, b5 = (t, r) => r ? {
  w: r[`${t}Width`],
  h: r[`${t}Height`]
} : hwe, pwe = (t) => b5("inner", t || Ni), If = pt(b5, "offset"), Rj = pt(b5, "client"), Zy = pt(b5, "scroll"), _8 = (t) => {
  const r = parseFloat(il(t, v5)) || 0, e = parseFloat(il(t, g5)) || 0;
  return {
    w: r - X6(r),
    h: e - X6(e)
  };
}, K4 = (t) => t.getBoundingClientRect(), vwe = (t) => !!t && fwe(t), r7 = (t) => !!(t && (t[g5] || t[v5])), Lj = (t, r) => {
  const e = r7(t);
  return !r7(r) && e;
}, rP = (t, r, e, n) => {
  wr(Nc(r), (i) => {
    t && t.removeEventListener(i, e, n);
  });
}, Nr = (t, r, e, n) => {
  var i;
  const a = (i = n && n.H) != null ? i : !0, o = n && n.I || !1, s = n && n.A || !1, l = {
    passive: a,
    capture: o
  };
  return pt(ta, Nc(r).map((u) => {
    const c = s ? (d) => {
      rP(t, u, c, o), e && e(d);
    } : e;
    return t && t.addEventListener(u, c, l), pt(rP, t, u, c, o);
  }));
}, Ej = (t) => t.stopPropagation(), n7 = (t) => t.preventDefault(), kj = (t) => Ej(t) || n7(t), Bo = (t, r) => {
  const { x: e, y: n } = Jo(r) ? {
    x: r,
    y: r
  } : r || {};
  Jo(e) && (t.scrollLeft = e), Jo(n) && (t.scrollTop = n);
}, $i = (t) => ({
  x: t.scrollLeft,
  y: t.scrollTop
}), Pj = () => ({
  D: {
    x: 0,
    y: 0
  },
  M: {
    x: 0,
    y: 0
  }
}), gwe = (t, r) => {
  const { D: e, M: n } = t, { w: i, h: a } = r, o = (d, f, h) => {
    let p = Kk(d) * h, v = Kk(f) * h;
    if (p === v) {
      const g = Vy(d), m = Vy(f);
      v = g > m ? 0 : v, p = g < m ? 0 : p;
    }
    return p = p === v ? 0 : p, [p + 0, v + 0];
  }, [s, l] = o(e.x, n.x, i), [u, c] = o(e.y, n.y, a);
  return {
    D: {
      x: s,
      y: u
    },
    M: {
      x: l,
      y: c
    }
  };
}, nP = ({ D: t, M: r }) => {
  const e = (n, i) => n === 0 && n <= i;
  return {
    x: e(t.x, r.x),
    y: e(t.y, r.y)
  };
}, iP = ({ D: t, M: r }, e) => {
  const n = (i, a, o) => wj(0, 1, (i - o) / (i - a) || 0);
  return {
    x: n(t.x, r.x, e.x),
    y: n(t.y, r.y, e.y)
  };
}, i7 = (t) => {
  t && t.focus && t.focus({
    preventScroll: !0
  });
}, aP = (t, r) => {
  wr(g8(r), t);
}, a7 = (t) => {
  const r = /* @__PURE__ */ new Map(), e = (a, o) => {
    if (a) {
      const s = r.get(a);
      aP((l) => {
        s && s[l ? "delete" : "clear"](l);
      }, o);
    } else
      r.forEach((s) => {
        s.clear();
      }), r.clear();
  }, n = (a, o) => {
    if (jg(a)) {
      const u = r.get(a) || /* @__PURE__ */ new Set();
      return r.set(a, u), aP((c) => {
        Ea(c) && u.add(c);
      }, o), pt(e, a, o);
    }
    p8(o) && o && e();
    const s = lo(a), l = [];
    return wr(s, (u) => {
      const c = a[u];
      c && jr(l, n(u, c));
    }), pt(ta, l);
  }, i = (a, o) => {
    wr(Cu(r.get(a)), (s) => {
      o && !U6(o) ? s.apply(0, o) : s();
    });
  };
  return n(t || {}), [n, e, i];
}, Nj = {}, Oj = {}, mwe = (t) => {
  wr(t, (r) => wr(r, (e, n) => {
    Nj[n] = r[n];
  }));
}, Vj = (t, r, e) => lo(t).map((n) => {
  const { static: i, instance: a } = t[n], [o, s, l] = e || [], u = e ? a : i;
  if (u) {
    const c = e ? u(o, s, r) : u(r);
    return (l || Oj)[n] = c;
  }
}), Yg = (t) => Oj[t], ywe = "__osOptionsValidationPlugin", Ah = "data-overlayscrollbars", am = "os-environment", v0 = `${am}-scrollbar-hidden`, q4 = `${Ah}-initialize`, om = "noClipping", oP = `${Ah}-body`, $l = Ah, bwe = "host", Is = `${Ah}-viewport`, Cwe = gj, wwe = mj, _we = "arrange", Gj = "measuring", xwe = "scrolling", Bj = "scrollbarHidden", Swe = "noContent", o7 = `${Ah}-padding`, sP = `${Ah}-content`, x8 = "os-size-observer", Iwe = `${x8}-appear`, Awe = `${x8}-listener`, Dwe = "os-trinsic-observer", Twe = "os-theme-none", oa = "os-scrollbar", Mwe = `${oa}-rtl`, Rwe = `${oa}-horizontal`, Lwe = `${oa}-vertical`, Fj = `${oa}-track`, S8 = `${oa}-handle`, Ewe = `${oa}-visible`, kwe = `${oa}-cornerless`, lP = `${oa}-interaction`, uP = `${oa}-unusable`, s7 = `${oa}-auto-hide`, cP = `${s7}-hidden`, dP = `${oa}-wheel`, Pwe = `${Fj}-interactive`, Nwe = `${S8}-interactive`, Owe = "__osSizeObserverPlugin", Vwe = (t, r) => {
  const { T: e } = r, [n, i] = t("showNativeOverlaidScrollbars");
  return [n && e.x && e.y, i];
}, Jf = (t) => t.indexOf(Sl) === 0, Gwe = (t, r) => {
  const e = (i, a, o, s) => {
    const l = i === Sl ? Cc : i.replace(`${Sl}-`, ""), u = Jf(i), c = Jf(o);
    return !a && !s ? Cc : u && c ? Sl : u ? a && s ? l : a ? Sl : Cc : a ? l : c && s ? Sl : Cc;
  }, n = {
    x: e(r.x, t.x, r.y, t.y),
    y: e(r.y, t.y, r.x, t.x)
  };
  return {
    k: n,
    R: {
      x: n.x === $f,
      y: n.y === $f
    }
  };
}, Hj = "__osScrollbarsHidingPlugin", Bwe = "__osClickScrollPlugin", fP = (t) => JSON.stringify(t, (r, e) => {
  if (Ea(e))
    throw 0;
  return e;
}), hP = (t, r) => t ? `${r}`.split(".").reduce((e, n) => e && bj(e, n) ? e[n] : void 0, t) : void 0, Fwe = {
  paddingAbsolute: !1,
  showNativeOverlaidScrollbars: !1,
  update: {
    elementEvents: [["img", "load"]],
    debounce: [0, 33],
    attributes: null,
    ignoreMutation: null
  },
  overflow: {
    x: "scroll",
    y: "scroll"
  },
  scrollbars: {
    theme: "os-theme-dark",
    visibility: "auto",
    autoHide: "never",
    autoHideDelay: 1300,
    autoHideSuspend: !1,
    dragScroll: !0,
    clickScroll: !1,
    pointers: ["mouse", "touch", "pen"]
  }
}, zj = (t, r) => {
  const e = {}, n = tg(lo(r), lo(t));
  return wr(n, (i) => {
    const a = t[i], o = r[i];
    if (Fy(a) && Fy(o))
      qt(e[i] = {}, zj(a, o)), m8(e[i]) && delete e[i];
    else if (bj(r, i) && o !== a) {
      let s = !0;
      if (rs(a) || rs(o))
        try {
          fP(a) === fP(o) && (s = !1);
        } catch {
        }
      s && (e[i] = o);
    }
  }), e;
}, pP = (t, r, e) => (n) => [hP(t, n), e || hP(r, n) !== void 0];
let Wj;
const Hwe = () => Wj, zwe = (t) => {
  Wj = t;
};
let Q4;
const Wwe = () => {
  const t = (C, w, _) => {
    Xi(document.body, C), Xi(document.body, C);
    const x = Rj(C), I = If(C), D = _8(w);
    return _ && Uf(C), {
      x: I.h - x.h + D.h,
      y: I.w - x.w + D.w
    };
  }, r = (C) => {
    let w = !1;
    const _ = w8(C, v0);
    try {
      w = il(C, "scrollbar-width") === "none" || il(C, "display", "::-webkit-scrollbar") === "none";
    } catch {
    }
    return _(), w;
  }, e = `.${am}{scroll-behavior:auto!important;position:fixed;opacity:0;visibility:hidden;overflow:scroll;height:200px;width:200px;z-index:-1}.${am} div{width:200%;height:200%;margin:10px 0}.${v0}{scrollbar-width:none!important}.${v0}::-webkit-scrollbar,.${v0}::-webkit-scrollbar-corner{appearance:none!important;display:none!important;width:0!important;height:0!important}`, i = Dj(`<div class="${am}"><div></div><style>${e}</style></div>`)[0], a = i.firstChild, o = i.lastChild, s = Hwe();
  s && (o.nonce = s);
  const [l, , u] = a7(), [c, d] = Wi({
    o: t(i, a),
    i: im
  }, pt(t, i, a, !0)), [f] = d(), h = r(i), p = {
    x: f.x === 0,
    y: f.y === 0
  }, v = {
    elements: {
      host: null,
      padding: !h,
      viewport: (C) => h && Aj(C) && C,
      content: !1
    },
    scrollbars: {
      slot: !0
    },
    cancel: {
      nativeScrollbarsOverlaid: !1,
      body: null
    }
  }, g = qt({}, Fwe), m = pt(qt, {}, g), y = pt(qt, {}, v), b = {
    N: f,
    T: p,
    P: h,
    G: !!nm,
    K: pt(l, "r"),
    Z: y,
    tt: (C) => qt(v, C) && y(),
    nt: m,
    ot: (C) => qt(g, C) && m(),
    st: qt({}, v),
    et: qt({}, g)
  };
  if (So(i, "style"), Uf(i), Nr(Ni, "resize", () => {
    u("r", []);
  }), Ea(Ni.matchMedia) && !h && (!p.x || !p.y)) {
    const C = (w) => {
      const _ = Ni.matchMedia(`(resolution: ${Ni.devicePixelRatio}dppx)`);
      Nr(_, "change", () => {
        w(), C(w);
      }, {
        A: !0
      });
    };
    C(() => {
      const [w, _] = c();
      qt(b.N, w), u("r", [_]);
    });
  }
  return b;
}, cs = () => (Q4 || (Q4 = Wwe()), Q4), Zwe = (t, r, e) => {
  let n = !1;
  const i = e ? /* @__PURE__ */ new WeakMap() : !1, a = () => {
    n = !0;
  }, o = (s) => {
    if (i && e) {
      const l = e.map((u) => {
        const [c, d] = u || [];
        return [d && c ? (s || Ij)(c, t) : [], d];
      });
      wr(l, (u) => wr(u[0], (c) => {
        const d = u[1], f = i.get(c) || [];
        if (t.contains(c) && d) {
          const p = Nr(c, d, (v) => {
            n ? (p(), i.delete(c)) : r(v);
          });
          i.set(c, jr(f, p));
        } else
          ta(f), i.delete(c);
      }));
    }
  };
  return o(), [a, o];
}, vP = (t, r, e, n) => {
  let i = !1;
  const { ct: a, rt: o, lt: s, it: l, ut: u, _t: c } = n || {}, d = K6(() => i && e(!0), {
    _: 33,
    p: 99
  }), [f, h] = Zwe(t, d, s), p = a || [], v = o || [], g = tg(p, v), m = (b, C) => {
    if (!U6(C)) {
      const w = u || Pc, _ = c || Pc, x = [], I = [];
      let D = !1, T = !1;
      if (wr(C, (A) => {
        const { attributeName: M, target: R, type: E, oldValue: k, addedNodes: P, removedNodes: N } = A, O = E === "attributes", W = E === "childList", V = t === R, B = O && M, Z = B && y8(R, M || ""), q = jg(Z) ? Z : null, z = B && k !== q, U = lj(v, M) && z;
        if (r && (W || !V)) {
          const J = O && z, K = J && l && q6(R, l), oe = (K ? !w(R, M, k, q) : !O || J) && !_(A, !!K, t, n);
          wr(P, (ie) => jr(x, ie)), wr(N, (ie) => jr(x, ie)), T = T || oe;
        }
        !r && V && z && !w(R, M, k, q) && (jr(I, M), D = D || U);
      }), h((A) => J6(x).reduce((M, R) => (jr(M, Ij(A, R)), q6(R, A) ? jr(M, R) : M), [])), r)
        return !b && T && e(!1), [!1];
      if (!U6(I) || D) {
        const A = [J6(I), D];
        return !b && e.apply(0, A), A;
      }
    }
  }, y = new owe(pt(m, !1));
  return [() => (y.observe(t, {
    attributes: !0,
    attributeOldValue: !0,
    attributeFilter: g,
    subtree: r,
    childList: r,
    characterData: r
  }), i = !0, () => {
    i && (f(), y.disconnect(), i = !1);
  }), () => {
    if (i)
      return d.m(), m(!0, y.takeRecords());
  }];
}, Zj = (t, r, e) => {
  const { dt: n } = e || {}, i = Yg(Owe), [a] = Wi({
    o: !1,
    u: !0
  });
  return () => {
    const o = [], l = Dj(`<div class="${x8}"><div class="${Awe}"></div></div>`)[0], u = l.firstChild, c = (d) => {
      const f = d instanceof ResizeObserverEntry;
      let h = !1, p = !1;
      if (f) {
        const [v, , g] = a(d.contentRect), m = r7(v);
        p = Lj(v, g), h = !p && !m;
      } else
        p = d === !0;
      h || r({
        ft: !0,
        dt: p
      });
    };
    if (By) {
      const d = new By((f) => c(f.pop()));
      d.observe(u), jr(o, () => {
        d.disconnect();
      });
    } else if (i) {
      const [d, f] = i(u, c, n);
      jr(o, tg([w8(l, Iwe), Nr(l, "animationstart", d)], f));
    } else
      return Pc;
    return pt(ta, jr(o, Xi(t, l)));
  };
}, jwe = (t, r) => {
  let e;
  const n = (l) => l.h === 0 || l.isIntersecting || l.intersectionRatio > 0, i = Sf(Dwe), [a] = Wi({
    o: !1
  }), o = (l, u) => {
    if (l) {
      const c = a(n(l)), [, d] = c;
      return d && !u && r(c) && [c];
    }
  }, s = (l, u) => o(u.pop(), l);
  return [() => {
    const l = [];
    if (qk)
      e = new qk(pt(s, !1), {
        root: t
      }), e.observe(i), jr(l, () => {
        e.disconnect();
      });
    else {
      const u = () => {
        const c = If(i);
        o(c);
      };
      jr(l, Zj(i, u)()), u();
    }
    return pt(ta, jr(l, Xi(t, i)));
  }, () => e && s(!0, e.takeRecords())];
}, Ywe = (t, r, e, n) => {
  let i, a, o, s, l, u;
  const c = `[${$l}]`, d = `[${Is}]`, f = ["id", "class", "style", "open", "wrap", "cols", "rows"], { vt: h, ht: p, U: v, gt: g, bt: m, L: y, wt: b, yt: C, St: w, Ot: _ } = t, x = (U) => il(U, "direction") === "rtl", I = {
    $t: !1,
    F: x(h)
  }, D = cs(), T = Yg(Hj), [A] = Wi({
    i: yj,
    o: {
      w: 0,
      h: 0
    }
  }, () => {
    const U = T && T.V(t, r, I, D, e).X, K = !(b && y) && C8(p, $l, om), j = !y && C(_we), oe = j && $i(g), ie = oe && _(), le = w(Gj, K), re = j && U && U()[0], Re = Zy(v), ve = _8(v);
    return re && re(), Bo(g, oe), ie && ie(), K && le(), {
      w: Re.w + ve.w,
      h: Re.h + ve.h
    };
  }), M = K6(n, {
    _: () => i,
    p: () => a,
    S(U, J) {
      const [K] = U, [j] = J;
      return [tg(lo(K), lo(j)).reduce((oe, ie) => (oe[ie] = K[ie] || j[ie], oe), {})];
    }
  }), R = (U) => {
    const J = x(h);
    qt(U, {
      Ct: u !== J
    }), qt(I, {
      F: J
    }), u = J;
  }, E = (U, J) => {
    const [K, j] = U, oe = {
      xt: j
    };
    return qt(I, {
      $t: K
    }), !J && n(oe), oe;
  }, k = ({ ft: U, dt: J }) => {
    const j = !(U && !J) && D.P ? M : n, oe = {
      ft: U || J,
      dt: J
    };
    R(oe), j(oe);
  }, P = (U, J) => {
    const [, K] = A(), j = {
      Ht: K
    };
    return R(j), K && !J && (U ? n : M)(j), j;
  }, N = (U, J, K) => {
    const j = {
      Et: J
    };
    return R(j), J && !K && M(j), j;
  }, [O, W] = m ? jwe(p, E) : [], V = !y && Zj(p, k, {
    dt: !0
  }), [B, Z] = vP(p, !1, N, {
    rt: f,
    ct: f
  }), q = y && By && new By((U) => {
    const J = U[U.length - 1].contentRect;
    k({
      ft: !0,
      dt: Lj(J, l)
    }), l = J;
  }), z = K6(() => {
    const [, U] = A();
    n({
      Ht: U
    });
  }, {
    _: 222,
    v: !0
  });
  return [() => {
    q && q.observe(p);
    const U = V && V(), J = O && O(), K = B(), j = D.K((oe) => {
      oe ? M({
        zt: oe
      }) : z();
    });
    return () => {
      q && q.disconnect(), U && U(), J && J(), s && s(), K(), j();
    };
  }, ({ It: U, At: J, Dt: K }) => {
    const j = {}, [oe] = U("update.ignoreMutation"), [ie, le] = U("update.attributes"), [re, Re] = U("update.elementEvents"), [ve, Oe] = U("update.debounce"), qe = Re || le, dt = J || K, At = (Be) => Ea(oe) && oe(Be);
    if (qe) {
      o && o(), s && s();
      const [Be, Nt] = vP(m || v, !0, P, {
        ct: tg(f, ie || []),
        lt: re,
        it: c,
        _t: (wt, Dt) => {
          const { target: Ot, attributeName: or } = wt;
          return (!Dt && or && !y ? cwe(Ot, c, d) : !1) || !!lf(Ot, `.${oa}`) || !!At(wt);
        }
      });
      s = Be(), o = Nt;
    }
    if (Oe)
      if (M.m(), rs(ve)) {
        const Be = ve[0], Nt = ve[1];
        i = Jo(Be) && Be, a = Jo(Nt) && Nt;
      } else Jo(ve) ? (i = ve, a = !1) : (i = !1, a = !1);
    if (dt) {
      const Be = Z(), Nt = W && W(), wt = o && o();
      Be && qt(j, N(Be[0], Be[1], dt)), Nt && qt(j, E(Nt[0], dt)), wt && qt(j, P(wt[0], dt));
    }
    return R(j), j;
  }, I];
}, jj = (t, r) => Ea(r) ? r.apply(0, t) : r, Xwe = (t, r, e, n) => {
  const i = h8(n) ? e : n;
  return jj(t, i) || r.apply(0, t);
}, Yj = (t, r, e, n) => {
  const i = h8(n) ? e : n, a = jj(t, i);
  return !!a && (zy(a) ? a : r.apply(0, t));
}, $we = (t, r) => {
  const { nativeScrollbarsOverlaid: e, body: n } = r || {}, { T: i, P: a, Z: o } = cs(), { nativeScrollbarsOverlaid: s, body: l } = o().cancel, u = e ?? s, c = h8(n) ? l : n, d = (i.x || i.y) && u, f = t && (h5(c) ? !a : c);
  return !!d || !!f;
}, Uwe = (t, r, e, n) => {
  const i = "--os-viewport-percent", a = "--os-scroll-percent", o = "--os-scroll-direction", { Z: s } = cs(), { scrollbars: l } = s(), { slot: u } = l, { vt: c, ht: d, U: f, Mt: h, gt: p, wt: v, L: g } = r, { scrollbars: m } = h ? {} : t, { slot: y } = m || {}, b = [], C = [], w = [], _ = Yj([c, d, f], () => g && v ? c : d, u, y), x = (B) => {
    if (nm) {
      const Z = new nm({
        source: p,
        axis: B
      });
      return {
        kt: (z) => {
          const U = z.Tt.animate({
            clear: ["left"],
            [a]: [0, 1]
          }, {
            timeline: Z
          });
          return () => U.cancel();
        }
      };
    }
  }, I = {
    x: x("x"),
    y: x("y")
  }, D = () => {
    const { Rt: B, Vt: Z } = e, q = (z, U) => wj(0, 1, z / (z + U) || 0);
    return {
      x: q(Z.x, B.x),
      y: q(Z.y, B.y)
    };
  }, T = (B, Z, q) => {
    const z = q ? w8 : Sj;
    wr(B, (U) => {
      z(U.Tt, Z);
    });
  }, A = (B, Z) => {
    wr(B, (q) => {
      const [z, U] = Z(q);
      ng(z, U);
    });
  }, M = (B, Z, q) => {
    const z = p8(q), U = z ? q : !0, J = z ? !q : !0;
    U && T(C, B, Z), J && T(w, B, Z);
  }, R = () => {
    const B = D(), Z = (q) => (z) => [z.Tt, {
      [i]: t7(q) + ""
    }];
    A(C, Z(B.x)), A(w, Z(B.y));
  }, E = () => {
    if (!nm) {
      const { Lt: B } = e, Z = iP(B, $i(p)), q = (z) => (U) => [U.Tt, {
        [a]: t7(z) + ""
      }];
      A(C, q(Z.x)), A(w, q(Z.y));
    }
  }, k = () => {
    const { Lt: B } = e, Z = nP(B), q = (z) => (U) => [U.Tt, {
      [o]: z ? "0" : "1"
    }];
    A(C, q(Z.x)), A(w, q(Z.y));
  }, P = () => {
    if (g && !v) {
      const { Rt: B, Lt: Z } = e, q = nP(Z), z = iP(Z, $i(p)), U = (J) => {
        const { Tt: K } = J, j = rg(K) === f && K, oe = (ie, le, re) => {
          const Re = le * ie;
          return Mj(re ? Re : -Re);
        };
        return [j, j && {
          transform: dwe({
            x: oe(z.x, B.x, q.x),
            y: oe(z.y, B.y, q.y)
          })
        }];
      };
      A(C, U), A(w, U);
    }
  }, N = (B) => {
    const Z = B ? "x" : "y", z = Sf(`${oa} ${B ? Rwe : Lwe}`), U = Sf(Fj), J = Sf(S8), K = {
      Tt: z,
      Ut: U,
      Pt: J
    }, j = I[Z];
    return jr(B ? C : w, K), jr(b, [Xi(z, U), Xi(U, J), pt(Uf, z), j && j.kt(K), n(K, M, B)]), K;
  }, O = pt(N, !0), W = pt(N, !1), V = () => (Xi(_, C[0].Tt), Xi(_, w[0].Tt), pt(ta, b));
  return O(), W(), [{
    Nt: R,
    qt: E,
    Bt: k,
    Ft: P,
    jt: M,
    Yt: {
      Wt: C,
      Xt: O,
      Jt: pt(A, C)
    },
    Gt: {
      Wt: w,
      Xt: W,
      Jt: pt(A, w)
    }
  }, V];
}, Jwe = (t, r, e, n) => (i, a, o) => {
  const { ht: s, U: l, L: u, gt: c, Kt: d, Ot: f } = r, { Tt: h, Ut: p, Pt: v } = i, [g, m] = sf(333), [y, b] = sf(444), C = (x) => {
    Ea(c.scrollBy) && c.scrollBy({
      behavior: "smooth",
      left: x.x,
      top: x.y
    });
  }, w = () => {
    const x = "pointerup pointercancel lostpointercapture", I = `client${o ? "X" : "Y"}`, D = o ? v5 : g5, T = o ? "left" : "top", A = o ? "w" : "h", M = o ? "x" : "y", R = (k, P) => (N) => {
      const { Rt: O } = e, W = If(p)[A] - If(v)[A], B = P * N / W * O[M];
      Bo(c, {
        [M]: k + B
      });
    }, E = [];
    return Nr(p, "pointerdown", (k) => {
      const P = lf(k.target, `.${S8}`) === v, N = P ? v : p, O = t.scrollbars, W = O[P ? "dragScroll" : "clickScroll"], { button: V, isPrimary: B, pointerType: Z } = k, { pointers: q } = O;
      if (V === 0 && B && W && (q || []).includes(Z)) {
        ta(E), b();
        const U = !P && (k.shiftKey || W === "instant"), J = pt(K4, v), K = pt(K4, p), j = (Dt, Ot) => (Dt || J())[T] - (Ot || K())[T], oe = X6(K4(c)[D]) / If(c)[A] || 1, ie = R($i(c)[M], 1 / oe), le = k[I], re = J(), Re = K(), ve = re[D], Oe = j(re, Re) + ve / 2, qe = le - Re[T], dt = P ? 0 : qe - Oe, At = (Dt) => {
          ta(wt), N.releasePointerCapture(Dt.pointerId);
        }, Be = P || U, Nt = f(), wt = [Nr(d, x, At), Nr(d, "selectstart", (Dt) => n7(Dt), {
          H: !1
        }), Nr(p, x, At), Be && Nr(p, "pointermove", (Dt) => ie(dt + (Dt[I] - le))), Be && (() => {
          const Dt = $i(c);
          Nt();
          const Ot = $i(c), or = {
            x: Ot.x - Dt.x,
            y: Ot.y - Dt.y
          };
          (Vy(or.x) > 3 || Vy(or.y) > 3) && (f(), Bo(c, Dt), C(or), y(Nt));
        })];
        if (N.setPointerCapture(k.pointerId), U)
          ie(dt);
        else if (!P) {
          const Dt = Yg(Bwe);
          if (Dt) {
            const Ot = Dt(ie, dt, ve, (or) => {
              or ? Nt() : jr(wt, Nt);
            });
            jr(wt, Ot), jr(E, pt(Ot, !0));
          }
        }
      }
    });
  };
  let _ = !0;
  return pt(ta, [Nr(v, "pointermove pointerleave", n), Nr(h, "pointerenter", () => {
    a(lP, !0);
  }), Nr(h, "pointerleave pointercancel", () => {
    a(lP, !1);
  }), !u && Nr(h, "mousedown", () => {
    const x = e7();
    (Qk(x, Is) || Qk(x, $l) || x === document.body) && Gy(pt(i7, l), 25);
  }), Nr(h, "wheel", (x) => {
    const { deltaX: I, deltaY: D, deltaMode: T } = x;
    _ && T === 0 && rg(h) === s && C({
      x: I,
      y: D
    }), _ = !1, a(dP, !0), g(() => {
      _ = !0, a(dP);
    }), n7(x);
  }, {
    H: !1,
    I: !0
  }), Nr(h, "pointerdown", pt(Nr, d, "click", kj, {
    A: !0,
    I: !0,
    H: !1
  }), {
    I: !0
  }), w(), m, b]);
}, Kwe = (t, r, e, n, i, a) => {
  let o, s, l, u, c, d = Pc, f = 0;
  const h = ["mouse", "pen"], p = (Z) => h.includes(Z.pointerType), [v, g] = sf(), [m, y] = sf(100), [b, C] = sf(100), [w, _] = sf(() => f), [x, I] = Uwe(t, i, n, Jwe(r, i, n, (Z) => p(Z) && O())), { ht: D, Qt: T, wt: A } = i, { jt: M, Nt: R, qt: E, Bt: k, Ft: P } = x, N = (Z, q) => {
    if (_(), Z)
      M(cP);
    else {
      const z = pt(M, cP, !0);
      f > 0 && !q ? w(z) : z();
    }
  }, O = () => {
    (l ? !o : !u) && (N(!0), m(() => {
      N(!1);
    }));
  }, W = (Z) => {
    M(s7, Z, !0), M(s7, Z, !1);
  }, V = (Z) => {
    p(Z) && (o = l, l && N(!0));
  }, B = [_, y, C, g, () => d(), Nr(D, "pointerover", V, {
    A: !0
  }), Nr(D, "pointerenter", V), Nr(D, "pointerleave", (Z) => {
    p(Z) && (o = !1, l && N(!1));
  }), Nr(D, "pointermove", (Z) => {
    p(Z) && s && O();
  }), Nr(T, "scroll", (Z) => {
    v(() => {
      E(), O();
    }), a(Z), P();
  })];
  return [() => pt(ta, jr(B, I())), ({ It: Z, Dt: q, Zt: z, tn: U }) => {
    const { nn: J, sn: K, en: j, cn: oe } = U || {}, { Ct: ie, dt: le } = z || {}, { F: re } = e, { T: Re } = cs(), { k: ve, rn: Oe } = n, [qe, dt] = Z("showNativeOverlaidScrollbars"), [At, Be] = Z("scrollbars.theme"), [Nt, wt] = Z("scrollbars.visibility"), [Dt, Ot] = Z("scrollbars.autoHide"), [or, $r] = Z("scrollbars.autoHideSuspend"), [kr] = Z("scrollbars.autoHideDelay"), [Gr, Dn] = Z("scrollbars.dragScroll"), [dn, Pn] = Z("scrollbars.clickScroll"), [Tn, Gi] = Z("overflow"), de = le && !q, Kt = Oe.x || Oe.y, fn = J || K || oe || ie || q, Ii = j || wt || Gi, di = qe && Re.x && Re.y, Ai = (Br, Nn, Tr) => {
      const On = Br.includes($f) && (Nt === Sl || Nt === "auto" && Nn === $f);
      return M(Ewe, On, Tr), On;
    };
    if (f = kr, de && (or && Kt ? (W(!1), d(), b(() => {
      d = Nr(T, "scroll", pt(W, !0), {
        A: !0
      });
    })) : W(!0)), dt && M(Twe, di), Be && (M(c), M(At, !0), c = At), $r && !or && W(!0), Ot && (s = Dt === "move", l = Dt === "leave", u = Dt === "never", N(u, !0)), Dn && M(Nwe, Gr), Pn && M(Pwe, !!dn), Ii) {
      const Br = Ai(Tn.x, ve.x, !0), Nn = Ai(Tn.y, ve.y, !1);
      M(kwe, !(Br && Nn));
    }
    fn && (E(), R(), P(), oe && k(), M(uP, !Oe.x, !0), M(uP, !Oe.y, !1), M(Mwe, re && !A));
  }, {}, x];
}, qwe = (t) => {
  const r = cs(), { Z: e, P: n } = r, { elements: i } = e(), { padding: a, viewport: o, content: s } = i, l = zy(t), u = l ? {} : t, { elements: c } = u, { padding: d, viewport: f, content: h } = c || {}, p = l ? t : u.target, v = Aj(p), g = p.ownerDocument, m = g.documentElement, y = () => g.defaultView || Ni, b = pt(Xwe, [p]), C = pt(Yj, [p]), w = pt(Sf, ""), _ = pt(b, w, o), x = pt(C, w, s), I = (ve) => {
    const Oe = If(ve), qe = Zy(ve), dt = il(ve, gj), At = il(ve, mj);
    return qe.w - Oe.w > 0 && !Jf(dt) || qe.h - Oe.h > 0 && !Jf(At);
  }, D = _(f), T = D === p, A = T && v, M = !T && x(h), R = !T && D === M, E = A ? m : D, k = A ? E : p, P = !T && C(w, a, d), N = !R && M, O = [N, E, P, k].map((ve) => zy(ve) && !rg(ve) && ve), W = (ve) => ve && lj(O, ve), V = !W(E) && I(E) ? E : p, B = A ? m : E, q = {
    vt: p,
    ht: k,
    U: E,
    ln: P,
    bt: N,
    gt: B,
    Qt: A ? g : E,
    an: v ? m : V,
    Kt: g,
    wt: v,
    Mt: l,
    L: T,
    un: y,
    yt: (ve) => C8(E, Is, ve),
    St: (ve, Oe) => Wy(E, Is, ve, Oe),
    Ot: () => Wy(B, Is, xwe, !0)
  }, { vt: z, ht: U, ln: J, U: K, bt: j } = q, oe = [() => {
    So(U, [$l, q4]), So(z, q4), v && So(m, [q4, $l]);
  }];
  let ie = Q6([j, K, J, U, z].find((ve) => ve && !W(ve)));
  const le = A ? z : j || K, re = pt(ta, oe);
  return [q, () => {
    const ve = y(), Oe = e7(), qe = (wt) => {
      Xi(rg(wt), Q6(wt)), Uf(wt);
    }, dt = (wt) => Nr(wt, "focusin focusout focus blur", kj, {
      I: !0,
      H: !1
    }), At = "tabindex", Be = y8(K, At), Nt = dt(Oe);
    return Ss(U, $l, T ? "" : bwe), Ss(J, o7, ""), Ss(K, Is, ""), Ss(j, sP, ""), T || (Ss(K, At, Be || "-1"), v && Ss(m, oP, "")), Xi(le, ie), Xi(U, J), Xi(J || U, !T && K), Xi(K, j), jr(oe, [Nt, () => {
      const wt = e7(), Dt = W(K), Ot = Dt && wt === K ? z : wt, or = dt(Ot);
      So(J, o7), So(j, sP), So(K, Is), v && So(m, oP), Be ? Ss(K, At, Be) : So(K, At), W(j) && qe(j), Dt && qe(K), W(J) && qe(J), i7(Ot), or();
    }]), n && !T && (b8(K, Is, Bj), jr(oe, pt(So, K, Is))), i7(!T && v && Oe === z && ve.top === ve ? K : Oe), Nt(), ie = 0, re;
  }, re];
}, Qwe = ({ bt: t }) => ({ Zt: r, _n: e, Dt: n }) => {
  const { xt: i } = r || {}, { $t: a } = e;
  t && (i || n) && ng(t, {
    [g5]: a && "100%"
  });
}, e_e = ({ ht: t, ln: r, U: e, L: n }, i) => {
  const [a, o] = Wi({
    i: lwe,
    o: tP()
  }, pt(tP, t, "padding", ""));
  return ({ It: s, Zt: l, _n: u, Dt: c }) => {
    let [d, f] = o(c);
    const { P: h } = cs(), { ft: p, Ht: v, Ct: g } = l || {}, { F: m } = u, [y, b] = s("paddingAbsolute");
    (p || f || (c || v)) && ([d, f] = a(c));
    const w = !n && (b || g || f);
    if (w) {
      const _ = !y || !r && !h, x = d.r + d.l, I = d.t + d.b, D = {
        [pj]: _ && !m ? -x : 0,
        [vj]: _ ? -I : 0,
        [hj]: _ && m ? -x : 0,
        top: _ ? -d.t : 0,
        right: _ ? m ? -d.r : "auto" : 0,
        left: _ ? m ? "auto" : -d.l : 0,
        [v5]: _ && `calc(100% + ${x}px)`
      }, T = {
        [uj]: _ ? d.t : 0,
        [cj]: _ ? d.r : 0,
        [fj]: _ ? d.b : 0,
        [dj]: _ ? d.l : 0
      };
      ng(r || e, D), ng(e, T), qt(i, {
        ln: d,
        dn: !_,
        j: r ? T : qt({}, D, T)
      });
    }
    return {
      fn: w
    };
  };
}, t_e = (t, r) => {
  const e = cs(), { ht: n, ln: i, U: a, L: o, Qt: s, gt: l, wt: u, St: c, un: d } = t, { P: f } = e, h = u && o, p = pt(oj, 0), v = {
    display: () => !1,
    direction: (Z) => Z !== "ltr",
    flexDirection: (Z) => Z.endsWith("-reverse"),
    writingMode: (Z) => Z !== "horizontal-tb"
  }, g = lo(v), m = {
    i: yj,
    o: {
      w: 0,
      h: 0
    }
  }, y = {
    i: im,
    o: {}
  }, b = (Z) => {
    c(Gj, !h && Z);
  }, C = (Z) => {
    if (!g.some((le) => {
      const re = Z[le];
      return re && v[le](re);
    }))
      return {
        D: {
          x: 0,
          y: 0
        },
        M: {
          x: 1,
          y: 1
        }
      };
    b(!0);
    const z = $i(l), U = c(Swe, !0), J = Nr(s, $f, (le) => {
      const re = $i(l);
      le.isTrusted && re.x === z.x && re.y === z.y && Ej(le);
    }, {
      I: !0,
      A: !0
    });
    Bo(l, {
      x: 0,
      y: 0
    }), U();
    const K = $i(l), j = Zy(l);
    Bo(l, {
      x: j.w,
      y: j.h
    });
    const oe = $i(l);
    Bo(l, {
      x: oe.x - K.x < 1 && -j.w,
      y: oe.y - K.y < 1 && -j.h
    });
    const ie = $i(l);
    return Bo(l, z), f8(() => J()), {
      D: K,
      M: ie
    };
  }, w = (Z, q) => {
    const z = Ni.devicePixelRatio % 1 !== 0 ? 1 : 0, U = {
      w: p(Z.w - q.w),
      h: p(Z.h - q.h)
    };
    return {
      w: U.w > z ? U.w : 0,
      h: U.h > z ? U.h : 0
    };
  }, [_, x] = Wi(m, pt(_8, a)), [I, D] = Wi(m, pt(Zy, a)), [T, A] = Wi(m), [M] = Wi(y), [R, E] = Wi(m), [k] = Wi(y), [P] = Wi({
    i: (Z, q) => m5(Z, q, g),
    o: {}
  }, () => vwe(a) ? il(a, g) : {}), [N, O] = Wi({
    i: (Z, q) => im(Z.D, q.D) && im(Z.M, q.M),
    o: Pj()
  }), W = Yg(Hj), V = (Z, q) => `${q ? Cwe : wwe}${swe(Z)}`, B = (Z) => {
    const q = (U) => [Sl, Cc, $f].map((J) => V(J, U)), z = q(!0).concat(q()).join(" ");
    c(z), c(lo(Z).map((U) => V(Z[U], U === "x")).join(" "), !0);
  };
  return ({ It: Z, Zt: q, _n: z, Dt: U }, { fn: J }) => {
    const { ft: K, Ht: j, Ct: oe, dt: ie, zt: le } = q || {}, re = W && W.V(t, r, z, e, Z), { W: Re, X: ve, J: Oe } = re || {}, [qe, dt] = Vwe(Z, e), [At, Be] = Z("overflow"), Nt = Jf(At.x), wt = Jf(At.y), Dt = !0;
    let Ot = x(U), or = D(U), $r = A(U), kr = E(U);
    dt && f && c(Bj, !qe);
    {
      C8(n, $l, om) && b(!0);
      const [St] = ve ? ve() : [], [Ir] = Ot = _(U), [mn] = or = I(U), Ie = Rj(a), Xe = h && pwe(d()), it = {
        w: p(mn.w + Ir.w),
        h: p(mn.h + Ir.h)
      }, hr = {
        w: p((Xe ? Xe.w : Ie.w + p(Ie.w - mn.w)) + Ir.w),
        h: p((Xe ? Xe.h : Ie.h + p(Ie.h - mn.h)) + Ir.h)
      };
      St && St(), kr = R(hr), $r = T(w(it, hr), U);
    }
    const [Gr, Dn] = kr, [dn, Pn] = $r, [Tn, Gi] = or, [de, Kt] = Ot, [fn, Ii] = M({
      x: dn.w > 0,
      y: dn.h > 0
    }), di = Nt && wt && (fn.x || fn.y) || Nt && fn.x && !fn.y || wt && fn.y && !fn.x, Ai = J || oe || le || Kt || Gi || Dn || Pn || Be || dt || Dt, Br = Gwe(fn, At), [Nn, Tr] = k(Br.k), [On, Bi] = P(U), Sr = oe || ie || Bi || Ii || U, [Mn, Ke] = Sr ? N(C(On), U) : O();
    return Ai && (Tr && B(Br.k), Oe && Re && ng(a, Oe(Br, z, Re(Br, Tn, de)))), b(!1), Wy(n, $l, om, di), Wy(i, o7, om, di), qt(r, {
      k: Nn,
      Vt: {
        x: Gr.w,
        y: Gr.h
      },
      Rt: {
        x: dn.w,
        y: dn.h
      },
      rn: fn,
      Lt: gwe(Mn, dn)
    }), {
      en: Tr,
      nn: Dn,
      sn: Pn,
      cn: Ke || Pn,
      pn: Sr
    };
  };
}, r_e = (t) => {
  const [r, e, n] = qwe(t), i = {
    ln: {
      t: 0,
      r: 0,
      b: 0,
      l: 0
    },
    dn: !1,
    j: {
      [pj]: 0,
      [vj]: 0,
      [hj]: 0,
      [uj]: 0,
      [cj]: 0,
      [fj]: 0,
      [dj]: 0
    },
    Vt: {
      x: 0,
      y: 0
    },
    Rt: {
      x: 0,
      y: 0
    },
    k: {
      x: Cc,
      y: Cc
    },
    rn: {
      x: !1,
      y: !1
    },
    Lt: Pj()
  }, { vt: a, gt: o, L: s, Ot: l } = r, { P: u, T: c } = cs(), d = !u && (c.x || c.y), f = [Qwe(r), e_e(r, i), t_e(r, i)];
  return [e, (h) => {
    const p = {}, g = d && $i(o), m = g && l();
    return wr(f, (y) => {
      qt(p, y(h, p) || {});
    }), Bo(o, g), m && m(), !s && Bo(a, 0), p;
  }, i, r, n];
}, n_e = (t, r, e, n, i) => {
  let a = !1;
  const o = pP(r, {}), [s, l, u, c, d] = r_e(t), [f, h, p] = Ywe(c, u, o, (C) => {
    b({}, C);
  }), [v, g, , m] = Kwe(t, r, p, u, c, i), y = (C) => lo(C).some((w) => !!C[w]), b = (C, w) => {
    if (e())
      return !1;
    const { vn: _, Dt: x, At: I, hn: D } = C, T = _ || {}, A = !!x || !a, M = {
      It: pP(r, T, A),
      vn: T,
      Dt: A
    };
    if (D)
      return g(M), !1;
    const R = w || h(qt({}, M, {
      At: I
    })), E = l(qt({}, M, {
      _n: p,
      Zt: R
    }));
    g(qt({}, M, {
      Zt: R,
      tn: E
    }));
    const k = y(R), P = y(E), N = k || P || !m8(T) || A;
    return a = !0, N && n(C, {
      Zt: R,
      tn: E
    }), N;
  };
  return [() => {
    const { an: C, gt: w, Ot: _ } = c, x = $i(C), I = [f(), s(), v()], D = _();
    return Bo(w, x), D(), pt(ta, I);
  }, b, () => ({
    gn: p,
    bn: u
  }), {
    wn: c,
    yn: m
  }, d];
}, I8 = /* @__PURE__ */ new WeakMap(), i_e = (t, r) => {
  I8.set(t, r);
}, a_e = (t) => {
  I8.delete(t);
}, Xj = (t) => I8.get(t), Fo = (t, r, e) => {
  const { nt: n } = cs(), i = zy(t), a = i ? t : t.target, o = Xj(a);
  if (r && !o) {
    let s = !1;
    const l = [], u = {}, c = (T) => {
      const A = Cj(T), M = Yg(ywe);
      return M ? M(A, !0) : A;
    }, d = qt({}, n(), c(r)), [f, h, p] = a7(), [v, g, m] = a7(e), y = (T, A) => {
      m(T, A), p(T, A);
    }, [b, C, w, _, x] = n_e(t, d, () => s, ({ vn: T, Dt: A }, { Zt: M, tn: R }) => {
      const { ft: E, Ct: k, xt: P, Ht: N, Et: O, dt: W } = M, { nn: V, sn: B, en: Z, cn: q } = R;
      y("updated", [D, {
        updateHints: {
          sizeChanged: !!E,
          directionChanged: !!k,
          heightIntrinsicChanged: !!P,
          overflowEdgeChanged: !!V,
          overflowAmountChanged: !!B,
          overflowStyleChanged: !!Z,
          scrollCoordinatesChanged: !!q,
          contentMutation: !!N,
          hostMutation: !!O,
          appear: !!W
        },
        changedOptions: T || {},
        force: !!A
      }]);
    }, (T) => y("scroll", [D, T])), I = (T) => {
      a_e(a), ta(l), s = !0, y("destroyed", [D, T]), h(), g();
    }, D = {
      options(T, A) {
        if (T) {
          const M = A ? n() : {}, R = zj(d, qt(M, c(T)));
          m8(R) || (qt(d, R), C({
            vn: R
          }));
        }
        return qt({}, d);
      },
      on: v,
      off: (T, A) => {
        T && A && g(T, A);
      },
      state() {
        const { gn: T, bn: A } = w(), { F: M } = T, { Vt: R, Rt: E, k, rn: P, ln: N, dn: O, Lt: W } = A;
        return qt({}, {
          overflowEdge: R,
          overflowAmount: E,
          overflowStyle: k,
          hasOverflow: P,
          scrollCoordinates: {
            start: W.D,
            end: W.M
          },
          padding: N,
          paddingAbsolute: O,
          directionRTL: M,
          destroyed: s
        });
      },
      elements() {
        const { vt: T, ht: A, ln: M, U: R, bt: E, gt: k, Qt: P } = _.wn, { Yt: N, Gt: O } = _.yn, W = (B) => {
          const { Pt: Z, Ut: q, Tt: z } = B;
          return {
            scrollbar: z,
            track: q,
            handle: Z
          };
        }, V = (B) => {
          const { Wt: Z, Xt: q } = B, z = W(Z[0]);
          return qt({}, z, {
            clone: () => {
              const U = W(q());
              return C({
                hn: !0
              }), U;
            }
          });
        };
        return qt({}, {
          target: T,
          host: A,
          padding: M || R,
          viewport: R,
          content: E || R,
          scrollOffsetElement: k,
          scrollEventElement: P,
          scrollbarHorizontal: V(N),
          scrollbarVertical: V(O)
        });
      },
      update: (T) => C({
        Dt: T,
        At: !0
      }),
      destroy: pt(I, !1),
      plugin: (T) => u[lo(T)[0]]
    };
    return jr(l, [x]), i_e(a, D), Vj(Nj, Fo, [D, f, u]), $we(_.wn.wt, !i && t.cancel) ? (I(!0), D) : (jr(l, b()), y("initialized", [D]), D.update(), D);
  }
  return o;
};
Fo.plugin = (t) => {
  const r = rs(t), e = r ? t : [t], n = e.map((i) => Vj(i, Fo)[0]);
  return mwe(e), r ? n : n[0];
};
Fo.valid = (t) => {
  const r = t && t.elements, e = Ea(r) && r();
  return Hy(e) && !!Xj(e.target);
};
Fo.env = () => {
  const { N: t, T: r, P: e, G: n, st: i, et: a, Z: o, tt: s, nt: l, ot: u } = cs();
  return qt({}, {
    scrollbarsSize: t,
    scrollbarsOverlaid: r,
    scrollbarsHiding: e,
    scrollTimeline: n,
    staticDefaultInitialization: i,
    staticDefaultOptions: a,
    getDefaultInitialization: o,
    setDefaultInitialization: s,
    getDefaultOptions: l,
    setDefaultOptions: u
  });
};
Fo.nonce = zwe;
const o_e = () => {
  if (typeof window > "u") {
    const u = () => {
    };
    return [u, u];
  }
  let t, r;
  const e = window, n = typeof e.requestIdleCallback == "function", i = e.requestAnimationFrame, a = e.cancelAnimationFrame, o = n ? e.requestIdleCallback : i, s = n ? e.cancelIdleCallback : a, l = () => {
    s(t), a(r);
  };
  return [
    (u, c) => {
      l(), t = o(
        n ? () => {
          l(), r = i(u);
        } : u,
        typeof c == "object" ? c : { timeout: 2233 }
      );
    },
    l
  ];
}, s_e = (t) => {
  const { options: r, events: e, defer: n } = t || {}, [i, a] = Oc(o_e, []), o = Vt(null), s = Vt(n), l = Vt(r), u = Vt(e);
  return Ue(() => {
    s.current = n;
  }, [n]), Ue(() => {
    const { current: c } = o;
    l.current = r, Fo.valid(c) && c.options(r || {}, !0);
  }, [r]), Ue(() => {
    const { current: c } = o;
    u.current = e, Fo.valid(c) && c.on(e || {}, !0);
  }, [e]), Ue(
    () => () => {
      var c;
      a(), (c = o.current) == null || c.destroy();
    },
    []
  ), Oc(
    () => [
      (c) => {
        const d = o.current;
        if (Fo.valid(d))
          return;
        const f = s.current, h = l.current || {}, p = u.current || {}, v = () => o.current = Fo(c, h, p);
        f ? i(v, f) : v();
      },
      () => o.current
    ],
    []
  );
}, l_e = (t, r) => {
  const { element: e = "div", options: n, events: i, defer: a, children: o, ...s } = t, l = e, u = Vt(null), c = Vt(null), [d, f] = s_e({ options: n, events: i, defer: a });
  return Ue(() => {
    const { current: h } = u, { current: p } = c;
    if (!h)
      return;
    const v = h;
    return d(
      e === "body" ? {
        target: v,
        cancel: {
          body: null
        }
      } : {
        target: v,
        elements: {
          viewport: p,
          content: p
        }
      }
    ), () => {
      var g;
      return (g = f()) == null ? void 0 : g.destroy();
    };
  }, [d, e]), MP(
    r,
    () => ({
      osInstance: f,
      getElement: () => u.current
    }),
    []
  ), // @ts-ignore
  /* @__PURE__ */ te.createElement(l, { "data-overlayscrollbars-initialize": "", ref: u, ...s }, e === "body" ? o : /* @__PURE__ */ te.createElement("div", { "data-overlayscrollbars-contents": "", ref: c }, o));
}, u_e = uo(l_e), c_e = (t) => /* @__PURE__ */ $.createElement("svg", { width: 22, height: 24, viewBox: "0 0 22 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ $.createElement("path", { d: "M12.0566 15.9521C11.8242 15.9521 11.6191 15.8633 11.4414 15.6787L6.23242 10.3535C6.08203 10.2031 6 10.0117 6 9.79297C6 9.34863 6.34863 9 6.79297 9C7.01172 9 7.20996 9.08887 7.36719 9.23926L12.0566 14.0449L16.7461 9.23926C16.8965 9.08887 17.1016 9 17.3203 9C17.7578 9 18.1064 9.34863 18.1064 9.79297C18.1064 10.0186 18.0312 10.2031 17.8809 10.3535L12.6719 15.6787C12.501 15.8633 12.2891 15.9521 12.0566 15.9521Z", fill: "#395278" })), d_e = (t) => /* @__PURE__ */ $.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ $.createElement("path", { d: "M11.8536 11.5395C11.411 11.5395 11.1896 11.3372 11.1896 10.9326C11.1896 10.9183 11.1896 10.9064 11.1896 10.8969C11.1896 10.8826 11.1896 10.8684 11.1896 10.8541C11.1896 10.5304 11.2706 10.2663 11.4324 10.0616C11.5942 9.85691 11.8013 9.6689 12.0535 9.49755C12.3534 9.28812 12.5771 9.112 12.7247 8.96921C12.877 8.82642 12.9531 8.64079 12.9531 8.41232C12.9531 8.17433 12.8651 7.97918 12.689 7.82686C12.5129 7.67455 12.2796 7.59839 11.9893 7.59839C11.8465 7.59839 11.7132 7.62219 11.5895 7.66979C11.4705 7.71263 11.361 7.77927 11.261 7.8697C11.1611 7.95538 11.0707 8.06247 10.9897 8.19099L10.8755 8.33378C10.8089 8.42898 10.7279 8.50275 10.6328 8.55511C10.5423 8.60747 10.4352 8.63365 10.3115 8.63365C10.1687 8.63365 10.0402 8.58605 9.92593 8.49085C9.81645 8.3909 9.76171 8.25524 9.76171 8.08389C9.76171 8.01725 9.76647 7.95538 9.77599 7.89826C9.79027 7.83638 9.80693 7.77689 9.82597 7.71977C9.93545 7.38658 10.1853 7.101 10.5756 6.86301C10.9707 6.62502 11.4705 6.50602 12.075 6.50602C12.4891 6.50602 12.8699 6.57742 13.2173 6.72021C13.5695 6.86301 13.8504 7.07244 14.0598 7.34851C14.274 7.61981 14.3811 7.95062 14.3811 8.34092C14.3811 8.75502 14.2764 9.08345 14.0669 9.32619C13.8575 9.56418 13.5791 9.79741 13.2316 10.0259C12.9984 10.1782 12.8199 10.3234 12.6961 10.4614C12.5771 10.5947 12.5129 10.7541 12.5033 10.9398C12.5033 10.954 12.501 10.9683 12.4962 10.9826C12.4962 10.9969 12.4962 11.0112 12.4962 11.0254C12.4867 11.1682 12.4248 11.2896 12.3106 11.3896C12.1963 11.4895 12.044 11.5395 11.8536 11.5395ZM11.8322 13.6885C11.6133 13.6885 11.4229 13.6148 11.261 13.4672C11.0992 13.3196 11.0183 13.1364 11.0183 12.9174C11.0183 12.6985 11.0968 12.5176 11.2539 12.3748C11.4157 12.2273 11.6085 12.1535 11.8322 12.1535C12.0607 12.1535 12.2558 12.2273 12.4177 12.3748C12.5795 12.5176 12.6604 12.6985 12.6604 12.9174C12.6604 13.1412 12.5795 13.3268 12.4177 13.4743C12.2558 13.6171 12.0607 13.6885 11.8322 13.6885ZM8.59795 19.0433C8.31236 19.0433 8.08865 18.9505 7.92682 18.7648C7.76975 18.5792 7.69121 18.3269 7.69121 18.008V16.2517H7.30567C6.6155 16.2517 6.02291 16.1184 5.52789 15.8519C5.03763 15.5853 4.65923 15.2045 4.39268 14.7095C4.13089 14.2097 4 13.6052 4 12.896V7.35564C4 6.64644 4.13089 6.04433 4.39268 5.54931C4.65447 5.04953 5.03287 4.66637 5.52789 4.39982C6.02767 4.13327 6.63692 4 7.35564 4H16.6444C17.3583 4 17.9652 4.13327 18.465 4.39982C18.9647 4.66637 19.3455 5.04953 19.6073 5.54931C19.8691 6.04433 20 6.64644 20 7.35564V12.896C20 13.6052 19.8691 14.2097 19.6073 14.7095C19.3455 15.2045 18.9647 15.5853 18.465 15.8519C17.9652 16.1184 17.3583 16.2517 16.6444 16.2517H12.232L9.79027 18.415C9.54752 18.6292 9.33809 18.7863 9.16198 18.8862C8.98587 18.9909 8.79786 19.0433 8.59795 19.0433ZM8.94779 17.4654L11.2111 15.2236C11.3634 15.0712 11.5038 14.9713 11.6323 14.9237C11.7656 14.8713 11.9417 14.8452 12.1606 14.8452H16.6015C17.2774 14.8452 17.7772 14.6786 18.1008 14.3454C18.4293 14.0074 18.5935 13.5077 18.5935 12.8461V7.39848C18.5935 6.74163 18.4293 6.24662 18.1008 5.91343C17.7772 5.57549 17.2774 5.40651 16.6015 5.40651H7.39134C6.72021 5.40651 6.22044 5.57549 5.89201 5.91343C5.56835 6.24662 5.40651 6.74163 5.40651 7.39848V12.8461C5.40651 13.5077 5.56835 14.0074 5.89201 14.3454C6.22044 14.6786 6.72021 14.8452 7.39134 14.8452H8.36948C8.56939 14.8452 8.71456 14.8904 8.805 14.9808C8.90019 15.0665 8.94779 15.2164 8.94779 15.4306V17.4654Z", fill: "#3548C9" })), tSe = (t) => {
  const {
    title: r,
    items: e,
    location: n,
    logoImage: i,
    openSidebar: a = !0,
    onClickLogo: o = null,
    hasSupportChat: s = !0,
    supportChatLoading: l = !1,
    onSupportChatClick: u
  } = t, [c, d] = We(-1), [f, h] = We(""), [p, v] = We(a), g = (m, y) => /* @__PURE__ */ S.jsx(
    "ul",
    {
      className: `theme-sidebar-children ${c !== y && "theme-sidebar-children-hidden"}`,
      children: m.map((b, C) => {
        const w = b.activeUrl, _ = w !== void 0 ? w.some((x) => f.includes(x)) : !1;
        return /* @__PURE__ */ S.jsx(
          "li",
          {
            className: `${_ && "theme-sidebar-item-active"}`,
            children: /* @__PURE__ */ S.jsx(
              "div",
              {
                className: "theme-sidebar-child-item",
                onClick: () => b.onClick && b.onClick(),
                children: /* @__PURE__ */ S.jsx("span", { children: b.label })
              }
            )
          },
          `sidebar-${y}-${C}`
        );
      })
    }
  );
  return Ue(() => {
    h(window.location.href), v(!1);
  }, [n]), Ue(() => {
    v(a);
  }, [a]), /* @__PURE__ */ S.jsx(
    "aside",
    {
      className: `theme-sidebar ${p && "theme-sidebar-open"}`,
      children: /* @__PURE__ */ S.jsxs("div", { className: "theme-sidebar-wrapper", children: [
        /* @__PURE__ */ S.jsx(
          "a",
          {
            href: "#",
            onClick: () => {
              d(-1), o && o();
            },
            className: "theme-sidebar-logo-wrapper",
            children: /* @__PURE__ */ S.jsx(
              "img",
              {
                src: i,
                alt: "TVS Digital",
                className: "theme-sidebar-logo"
              }
            )
          }
        ),
        /* @__PURE__ */ S.jsx(u_e, { defer: !0, children: /* @__PURE__ */ S.jsxs("ul", { className: "theme-sidebar-menu", children: [
          /* @__PURE__ */ S.jsx("li", { className: "theme-sidebar-title", children: r }),
          e.map((m, y) => {
            var C;
            const b = ((C = m.activeUrl) == null ? void 0 : C.some((w) => f.includes(w))) || m.isIndex !== void 0 && m.isIndex && window.location.href.replace("#", "") === `${window.location.origin}/`;
            return /* @__PURE__ */ S.jsxs("li", { children: [
              /* @__PURE__ */ S.jsxs(
                "button",
                {
                  className: `theme-sidebar-link" ${b ? "theme-sidebar-item-active" : ""}`,
                  onClick: () => {
                    d(c === y ? -1 : y), m.onClick && m.onClick();
                  },
                  children: [
                    m.icon && m.iconActive && /* @__PURE__ */ S.jsx("div", { className: "theme-sidebar-icon", children: b ? m.iconActive : m.icon }),
                    m.label,
                    m.children !== void 0 && Array.isArray(m.children) && m.children.length > 0 && /* @__PURE__ */ S.jsx("span", { className: "theme-sidebar-arrow", children: /* @__PURE__ */ S.jsx(
                      c_e,
                      {
                        className: `theme-sidebar-arrow ${y === c && "is-opened"}`
                      }
                    ) })
                  ]
                }
              ),
              m.children !== void 0 && Array.isArray(m.children) && m.children.length > 0 && g(m.children, y)
            ] }, `sidebar-${y}`);
          })
        ] }) }),
        /* @__PURE__ */ S.jsxs("div", { className: "theme-sidebar-footer", children: [
          /* @__PURE__ */ S.jsx("div", { className: "logo-wrapper", children: /* @__PURE__ */ S.jsx("img", { src: "/images/sidebar/sidebar-logo-bottom.svg" }) }),
          s && /* @__PURE__ */ S.jsxs(
            "div",
            {
              className: "support-chat",
              onClick: () => u && !l && u(),
              children: [
                /* @__PURE__ */ S.jsx(d_e, {}),
                /* @__PURE__ */ S.jsx("span", { children: l ? "Loading Chat..." : "Chat Support" })
              ]
            }
          ),
          /* @__PURE__ */ S.jsxs("div", { className: "content-wrapper", children: [
            /* @__PURE__ */ S.jsx(
              "a",
              {
                href: "https://www.tvsd.ai/en/privacy-policy",
                className: "color-theme-grey-200",
                target: "_blank",
                children: "Privacy Policy"
              }
            ),
            /* @__PURE__ */ S.jsx(
              "a",
              {
                href: "https://www.tvsd.ai/en/terms-of-use",
                className: "color-theme-grey-200",
                target: "_blank",
                children: "Terms Of Use"
              }
            ),
            /* @__PURE__ */ S.jsx(
              "a",
              {
                href: "https://www.tvsd.ai/en/cookie-policy",
                className: "color-theme-grey-200",
                target: "_blank",
                children: "Cookie Policy"
              }
            )
          ] })
        ] })
      ] })
    }
  );
}, rSe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), $j = !0, f_e = ({
  baseColor: t,
  highlightColor: r,
  width: e,
  height: n,
  borderRadius: i,
  circle: a,
  direction: o,
  duration: s,
  enableAnimation: l = $j
}) => {
  const u = {};
  return o === "rtl" && (u["--animation-direction"] = "reverse"), typeof s == "number" && (u["--animation-duration"] = `${s}s`), l || (u["--pseudo-element-display"] = "none"), (typeof e == "string" || typeof e == "number") && (u.width = e), (typeof n == "string" || typeof n == "number") && (u.height = n), (typeof i == "string" || typeof i == "number") && (u.borderRadius = i), a && (u.borderRadius = "50%"), typeof t < "u" && (u["--base-color"] = t), typeof r < "u" && (u["--highlight-color"] = r), u;
}, nSe = (t) => {
  const {
    count: r = 1,
    wrapper: e,
    className: n,
    containerClassName: i,
    containerTestId: a,
    circle: o = !1,
    style: s,
    ...l
  } = t, c = {
    ...{ ...l },
    circle: o
  }, d = {
    ...s,
    ...f_e(c)
  };
  let f = "theme-skeleton-loading";
  n && (f += ` ${n}`);
  const h = c.inline ?? !1, p = [], v = Math.ceil(r);
  for (let g = 0; g < v; g++) {
    let m = d;
    if (v > r && g === v - 1) {
      const b = m.width ?? "100%", C = r % 1, w = typeof b == "number" ? b * C : `calc(${b} * ${C})`;
      m = { ...m, width: w };
    }
    const y = /* @__PURE__ */ S.jsx("span", { className: f, style: m, children: "‌" }, g);
    h ? p.push(y) : p.push(
      /* @__PURE__ */ S.jsxs(g7, { children: [
        y,
        /* @__PURE__ */ S.jsx("br", {})
      ] }, g)
    );
  }
  return /* @__PURE__ */ S.jsx(
    "span",
    {
      className: i,
      "data-testid": a,
      "aria-live": "polite",
      "aria-busy": c.enableAnimation ?? $j,
      children: e ? p.map((g, m) => /* @__PURE__ */ S.jsx(e, { children: g }, m)) : p
    }
  );
};
function Uj(t) {
  var r, e, n = "";
  if (typeof t == "string" || typeof t == "number") n += t;
  else if (typeof t == "object") if (Array.isArray(t)) for (r = 0; r < t.length; r++) t[r] && (e = Uj(t[r])) && (n && (n += " "), n += e);
  else for (r in t) t[r] && (n && (n += " "), n += r);
  return n;
}
function C5() {
  for (var t, r, e = 0, n = ""; e < arguments.length; ) (t = arguments[e++]) && (r = Uj(t)) && (n && (n += " "), n += r);
  return n;
}
let h_e = { data: "" }, p_e = (t) => typeof window == "object" ? ((t ? t.querySelector("#_goober") : window._goober) || Object.assign((t || document.head).appendChild(document.createElement("style")), { innerHTML: " ", id: "_goober" })).firstChild : t || h_e, v_e = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, g_e = /\/\*[^]*?\*\/|  +/g, gP = /\n+/g, lc = (t, r) => {
  let e = "", n = "", i = "";
  for (let a in t) {
    let o = t[a];
    a[0] == "@" ? a[1] == "i" ? e = a + " " + o + ";" : n += a[1] == "f" ? lc(o, a) : a + "{" + lc(o, a[1] == "k" ? "" : r) + "}" : typeof o == "object" ? n += lc(o, r ? r.replace(/([^,])+/g, (s) => a.replace(/(^:.*)|([^,])+/g, (l) => /&/.test(l) ? l.replace(/&/g, s) : s ? s + " " + l : l)) : a) : o != null && (a = /^--/.test(a) ? a : a.replace(/[A-Z]/g, "-$&").toLowerCase(), i += lc.p ? lc.p(a, o) : a + ":" + o + ";");
  }
  return e + (r && i ? r + "{" + i + "}" : i) + n;
}, bs = {}, Jj = (t) => {
  if (typeof t == "object") {
    let r = "";
    for (let e in t) r += e + Jj(t[e]);
    return r;
  }
  return t;
}, m_e = (t, r, e, n, i) => {
  let a = Jj(t), o = bs[a] || (bs[a] = ((l) => {
    let u = 0, c = 11;
    for (; u < l.length; ) c = 101 * c + l.charCodeAt(u++) >>> 0;
    return "go" + c;
  })(a));
  if (!bs[o]) {
    let l = a !== t ? t : ((u) => {
      let c, d, f = [{}];
      for (; c = v_e.exec(u.replace(g_e, "")); ) c[4] ? f.shift() : c[3] ? (d = c[3].replace(gP, " ").trim(), f.unshift(f[0][d] = f[0][d] || {})) : f[0][c[1]] = c[2].replace(gP, " ").trim();
      return f[0];
    })(t);
    bs[o] = lc(i ? { ["@keyframes " + o]: l } : l, e ? "" : "." + o);
  }
  let s = e && bs.g ? bs.g : null;
  return e && (bs.g = bs[o]), ((l, u, c, d) => {
    d ? u.data = u.data.replace(d, l) : u.data.indexOf(l) === -1 && (u.data = c ? l + u.data : u.data + l);
  })(bs[o], r, n, s), o;
}, y_e = (t, r, e) => t.reduce((n, i, a) => {
  let o = r[a];
  if (o && o.call) {
    let s = o(e), l = s && s.props && s.props.className || /^go/.test(s) && s;
    o = l ? "." + l : s && typeof s == "object" ? s.props ? "" : lc(s, "") : s === !1 ? "" : s;
  }
  return n + i + (o ?? "");
}, "");
function A8(t) {
  let r = this || {}, e = t.call ? t(r.p) : t;
  return m_e(e.unshift ? e.raw ? y_e(e, [].slice.call(arguments, 1), r.p) : e.reduce((n, i) => Object.assign(n, i && i.call ? i(r.p) : i), {}) : e, p_e(r.target), r.g, r.o, r.k);
}
A8.bind({ g: 1 });
A8.bind({ k: 1 });
function b_e(t, r) {
  for (var e = 0; e < r.length; e++) {
    var n = r[e];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
  }
}
function C_e(t, r, e) {
  return r && b_e(t.prototype, r), t;
}
function Ol() {
  return Ol = Object.assign || function(t) {
    for (var r = 1; r < arguments.length; r++) {
      var e = arguments[r];
      for (var n in e)
        Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    }
    return t;
  }, Ol.apply(this, arguments);
}
function w_e(t, r) {
  t.prototype = Object.create(r.prototype), t.prototype.constructor = t, t.__proto__ = r;
}
function D8(t, r) {
  if (t == null) return {};
  var e = {}, n = Object.keys(t), i, a;
  for (a = 0; a < n.length; a++)
    i = n[a], !(r.indexOf(i) >= 0) && (e[i] = t[i]);
  return e;
}
var mP = function() {
  return "";
}, __e = /* @__PURE__ */ te.createContext({
  enqueueSnackbar: mP,
  closeSnackbar: mP
}), nc = {
  downXs: "@media (max-width:599.95px)",
  upSm: "@media (min-width:600px)"
}, g0 = "unmounted", Bd = "exited", Fd = "entering", bp = "entered", yP = "exiting", T8 = /* @__PURE__ */ function(t) {
  w_e(r, t);
  function r(n) {
    var i;
    i = t.call(this, n) || this;
    var a = n.appear, o;
    return i.appearStatus = null, n.in ? a ? (o = Bd, i.appearStatus = Fd) : o = bp : n.unmountOnExit || n.mountOnEnter ? o = g0 : o = Bd, i.state = {
      status: o
    }, i.nextCallback = null, i;
  }
  r.getDerivedStateFromProps = function(i, a) {
    var o = i.in;
    return o && a.status === g0 ? {
      status: Bd
    } : null;
  };
  var e = r.prototype;
  return e.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, e.componentDidUpdate = function(i) {
    var a = null;
    if (i !== this.props) {
      var o = this.state.status;
      this.props.in ? o !== Fd && o !== bp && (a = Fd) : (o === Fd || o === bp) && (a = yP);
    }
    this.updateStatus(!1, a);
  }, e.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, e.getTimeouts = function() {
    var i = this.props.timeout, a = i, o = i;
    return i != null && typeof i != "number" && typeof i != "string" && (o = i.exit, a = i.enter), {
      exit: o,
      enter: a
    };
  }, e.updateStatus = function(i, a) {
    i === void 0 && (i = !1), a !== null ? (this.cancelNextCallback(), a === Fd ? this.performEnter(i) : this.performExit()) : this.props.unmountOnExit && this.state.status === Bd && this.setState({
      status: g0
    });
  }, e.performEnter = function(i) {
    var a = this, o = this.props.enter, s = i, l = this.getTimeouts();
    if (!i && !o) {
      this.safeSetState({
        status: bp
      }, function() {
        a.props.onEntered && a.props.onEntered(a.node, s);
      });
      return;
    }
    this.props.onEnter && this.props.onEnter(this.node, s), this.safeSetState({
      status: Fd
    }, function() {
      a.props.onEntering && a.props.onEntering(a.node, s), a.onTransitionEnd(l.enter, function() {
        a.safeSetState({
          status: bp
        }, function() {
          a.props.onEntered && a.props.onEntered(a.node, s);
        });
      });
    });
  }, e.performExit = function() {
    var i = this, a = this.props.exit, o = this.getTimeouts();
    if (!a) {
      this.safeSetState({
        status: Bd
      }, function() {
        i.props.onExited && i.props.onExited(i.node);
      });
      return;
    }
    this.props.onExit && this.props.onExit(this.node), this.safeSetState({
      status: yP
    }, function() {
      i.props.onExiting && i.props.onExiting(i.node), i.onTransitionEnd(o.exit, function() {
        i.safeSetState({
          status: Bd
        }, function() {
          i.props.onExited && i.props.onExited(i.node);
        });
      });
    });
  }, e.cancelNextCallback = function() {
    this.nextCallback !== null && this.nextCallback.cancel && (this.nextCallback.cancel(), this.nextCallback = null);
  }, e.safeSetState = function(i, a) {
    a = this.setNextCallback(a), this.setState(i, a);
  }, e.setNextCallback = function(i) {
    var a = this, o = !0;
    return this.nextCallback = function() {
      o && (o = !1, a.nextCallback = null, i());
    }, this.nextCallback.cancel = function() {
      o = !1;
    }, this.nextCallback;
  }, e.onTransitionEnd = function(i, a) {
    this.setNextCallback(a);
    var o = i == null && !this.props.addEndListener;
    if (!this.node || o) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    this.props.addEndListener && this.props.addEndListener(this.node, this.nextCallback), i != null && setTimeout(this.nextCallback, i);
  }, e.render = function() {
    var i = this.state.status;
    if (i === g0)
      return null;
    var a = this.props, o = a.children, s = D8(a, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return o(i, s);
  }, C_e(r, [{
    key: "node",
    get: function() {
      var i, a = (i = this.props.nodeRef) === null || i === void 0 ? void 0 : i.current;
      if (!a)
        throw new Error("notistack - Custom snackbar is not refForwarding");
      return a;
    }
  }]), r;
}(te.Component);
function Hd() {
}
T8.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: Hd,
  onEntering: Hd,
  onEntered: Hd,
  onExit: Hd,
  onExiting: Hd,
  onExited: Hd
};
function bP(t, r) {
  typeof t == "function" ? t(r) : t && (t.current = r);
}
function l7(t, r) {
  return Oc(function() {
    return t == null && r == null ? null : function(e) {
      bP(t, e), bP(r, e);
    };
  }, [t, r]);
}
function jy(t) {
  var r = t.timeout, e = t.style, n = e === void 0 ? {} : e, i = t.mode;
  return {
    duration: typeof r == "object" ? r[i] || 0 : r,
    easing: n.transitionTimingFunction,
    delay: n.transitionDelay
  };
}
var u7 = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, Kj = function(r) {
  r.scrollTop = r.scrollTop;
}, CP = function(r) {
  return Math.round(r) + "ms";
};
function uf(t, r) {
  t === void 0 && (t = ["all"]);
  var e = r || {}, n = e.duration, i = n === void 0 ? 300 : n, a = e.easing, o = a === void 0 ? u7.easeInOut : a, s = e.delay, l = s === void 0 ? 0 : s, u = Array.isArray(t) ? t : [t];
  return u.map(function(c) {
    var d = typeof i == "string" ? i : CP(i), f = typeof l == "string" ? l : CP(l);
    return c + " " + d + " " + o + " " + f;
  }).join(",");
}
function x_e(t) {
  return t && t.ownerDocument || document;
}
function qj(t) {
  var r = x_e(t);
  return r.defaultView || window;
}
function S_e(t, r) {
  r === void 0 && (r = 166);
  var e;
  function n() {
    for (var i = this, a = arguments.length, o = new Array(a), s = 0; s < a; s++)
      o[s] = arguments[s];
    var l = function() {
      t.apply(i, o);
    };
    clearTimeout(e), e = setTimeout(l, r);
  }
  return n.clear = function() {
    clearTimeout(e);
  }, n;
}
function I_e(t, r) {
  var e = r.getBoundingClientRect(), n = qj(r), i;
  if (r.fakeTransform)
    i = r.fakeTransform;
  else {
    var a = n.getComputedStyle(r);
    i = a.getPropertyValue("-webkit-transform") || a.getPropertyValue("transform");
  }
  var o = 0, s = 0;
  if (i && i !== "none" && typeof i == "string") {
    var l = i.split("(")[1].split(")")[0].split(",");
    o = parseInt(l[4], 10), s = parseInt(l[5], 10);
  }
  switch (t) {
    case "left":
      return "translateX(" + (n.innerWidth + o - e.left) + "px)";
    case "right":
      return "translateX(-" + (e.left + e.width - o) + "px)";
    case "up":
      return "translateY(" + (n.innerHeight + s - e.top) + "px)";
    default:
      return "translateY(-" + (e.top + e.height - s) + "px)";
  }
}
function m0(t, r) {
  if (r) {
    var e = I_e(t, r);
    e && (r.style.webkitTransform = e, r.style.transform = e);
  }
}
var A_e = /* @__PURE__ */ uo(function(t, r) {
  var e = t.children, n = t.direction, i = n === void 0 ? "down" : n, a = t.in, o = t.style, s = t.timeout, l = s === void 0 ? 0 : s, u = t.onEnter, c = t.onEntered, d = t.onExit, f = t.onExited, h = D8(t, ["children", "direction", "in", "style", "timeout", "onEnter", "onEntered", "onExit", "onExited"]), p = Vt(null), v = l7(e.ref, p), g = l7(v, r), m = function(x, I) {
    m0(i, x), Kj(x), u && u(x, I);
  }, y = function(x) {
    var I = (o == null ? void 0 : o.transitionTimingFunction) || u7.easeOut, D = jy({
      timeout: l,
      mode: "enter",
      style: Ol({}, o, {
        transitionTimingFunction: I
      })
    });
    x.style.webkitTransition = uf("-webkit-transform", D), x.style.transition = uf("transform", D), x.style.webkitTransform = "none", x.style.transform = "none";
  }, b = function(x) {
    var I = (o == null ? void 0 : o.transitionTimingFunction) || u7.sharp, D = jy({
      timeout: l,
      mode: "exit",
      style: Ol({}, o, {
        transitionTimingFunction: I
      })
    });
    x.style.webkitTransition = uf("-webkit-transform", D), x.style.transition = uf("transform", D), m0(i, x), d && d(x);
  }, C = function(x) {
    x.style.webkitTransition = "", x.style.transition = "", f && f(x);
  }, w = ns(function() {
    p.current && m0(i, p.current);
  }, [i]);
  return Ue(function() {
    if (!(a || i === "down" || i === "right")) {
      var _ = S_e(function() {
        p.current && m0(i, p.current);
      }), x = qj(p.current);
      return x.addEventListener("resize", _), function() {
        _.clear(), x.removeEventListener("resize", _);
      };
    }
  }, [i, a]), Ue(function() {
    a || w();
  }, [a, w]), wc(T8, Object.assign({
    appear: !0,
    nodeRef: p,
    onEnter: m,
    onEntered: c,
    onEntering: y,
    onExit: b,
    onExited: C,
    in: a,
    timeout: l
  }, h), function(_, x) {
    return v7(e, Ol({
      ref: g,
      style: Ol({
        visibility: _ === "exited" && !a ? "hidden" : void 0
      }, o, {}, e.props.style)
    }, x));
  });
});
A_e.displayName = "Slide";
function w5(t) {
  return Object.entries(t).reduce(function(r, e) {
    var n, i = e[0], a = e[1];
    return Ol({}, r, (n = {}, n[i] = A8(a), n));
  }, {});
}
var ig = {
  SnackbarContainer: "notistack-SnackbarContainer",
  Snackbar: "notistack-Snackbar",
  CollapseWrapper: "notistack-CollapseWrapper",
  MuiContent: "notistack-MuiContent",
  MuiContentVariant: function(r) {
    return "notistack-MuiContent-" + r;
  }
}, wP = /* @__PURE__ */ w5({
  root: {
    height: 0
  },
  entered: {
    height: "auto"
  }
}), eC = "0px", tC = 175, D_e = /* @__PURE__ */ uo(function(t, r) {
  var e = t.children, n = t.in, i = t.onExited, a = Vt(null), o = Vt(null), s = l7(r, o), l = function() {
    return a.current ? a.current.clientHeight : 0;
  }, u = function(v) {
    v.style.height = eC;
  }, c = function(v) {
    var g = l(), m = jy({
      timeout: tC,
      mode: "enter"
    }), y = m.duration, b = m.easing;
    v.style.transitionDuration = typeof y == "string" ? y : y + "ms", v.style.height = g + "px", v.style.transitionTimingFunction = b || "";
  }, d = function(v) {
    v.style.height = "auto";
  }, f = function(v) {
    v.style.height = l() + "px";
  }, h = function(v) {
    Kj(v);
    var g = jy({
      timeout: tC,
      mode: "exit"
    }), m = g.duration, y = g.easing;
    v.style.transitionDuration = typeof m == "string" ? m : m + "ms", v.style.height = eC, v.style.transitionTimingFunction = y || "";
  };
  return wc(T8, {
    in: n,
    unmountOnExit: !0,
    onEnter: u,
    onEntered: d,
    onEntering: c,
    onExit: f,
    onExited: i,
    onExiting: h,
    nodeRef: o,
    timeout: tC
  }, function(p, v) {
    return wc("div", Object.assign({
      ref: s,
      className: C5(wP.root, p === "entered" && wP.entered),
      style: Ol({
        pointerEvents: "all",
        overflow: "hidden",
        minHeight: eC,
        transition: uf("height")
      }, p === "entered" && {
        overflow: "visible"
      }, {}, p === "exited" && !n && {
        visibility: "hidden"
      })
    }, v), wc("div", {
      ref: a,
      className: ig.CollapseWrapper,
      // Hack to get children with a negative margin to not falsify the height computation.
      style: {
        display: "flex",
        width: "100%"
      }
    }, e));
  });
});
D_e.displayName = "Collapse";
var T_e = typeof window < "u" ? ag : Ue;
function _P(t) {
  var r = Vt(t);
  return T_e(function() {
    r.current = t;
  }), ns(function() {
    return (
      // @ts-expect-error hide `this`
      r.current.apply(void 0, arguments)
    );
  }, []);
}
var M_e = /* @__PURE__ */ uo(function(t, r) {
  var e = t.children, n = t.className, i = t.autoHideDuration, a = t.disableWindowBlurListener, o = a === void 0 ? !1 : a, s = t.onClose, l = t.id, u = t.open, c = t.SnackbarProps, d = c === void 0 ? {} : c, f = Vt(), h = _P(function() {
    s && s.apply(void 0, arguments);
  }), p = _P(function(b) {
    !s || b == null || (f.current && clearTimeout(f.current), f.current = setTimeout(function() {
      h(null, "timeout", l);
    }, b));
  });
  Ue(function() {
    return u && p(i), function() {
      f.current && clearTimeout(f.current);
    };
  }, [u, i, p]);
  var v = function() {
    f.current && clearTimeout(f.current);
  }, g = ns(function() {
    i != null && p(i * 0.5);
  }, [i, p]), m = function(C) {
    d.onMouseEnter && d.onMouseEnter(C), v();
  }, y = function(C) {
    d.onMouseLeave && d.onMouseLeave(C), g();
  };
  return Ue(function() {
    if (!o && u)
      return window.addEventListener("focus", g), window.addEventListener("blur", v), function() {
        window.removeEventListener("focus", g), window.removeEventListener("blur", v);
      };
  }, [o, g, u]), wc("div", Object.assign({
    ref: r
  }, d, {
    className: C5(ig.Snackbar, n),
    onMouseEnter: m,
    onMouseLeave: y
  }), e);
});
M_e.displayName = "Snackbar";
var rC, R_e = /* @__PURE__ */ w5({
  root: (rC = {
    display: "flex",
    flexWrap: "wrap",
    flexGrow: 1
  }, rC[nc.upSm] = {
    flexGrow: "initial",
    minWidth: "288px"
  }, rC)
}), Xg = /* @__PURE__ */ uo(function(t, r) {
  var e = t.className, n = D8(t, ["className"]);
  return te.createElement("div", Object.assign({
    ref: r,
    className: C5(R_e.root, e)
  }, n));
});
Xg.displayName = "SnackbarContent";
var Cp = /* @__PURE__ */ w5({
  root: {
    backgroundColor: "#313131",
    fontSize: "0.875rem",
    lineHeight: 1.43,
    letterSpacing: "0.01071em",
    color: "#fff",
    alignItems: "center",
    padding: "6px 16px",
    borderRadius: "4px",
    boxShadow: "0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)"
  },
  lessPadding: {
    paddingLeft: 8 * 2.5 + "px"
  },
  default: {
    backgroundColor: "#313131"
  },
  success: {
    backgroundColor: "#43a047"
  },
  error: {
    backgroundColor: "#d32f2f"
  },
  warning: {
    backgroundColor: "#ff9800"
  },
  info: {
    backgroundColor: "#2196f3"
  },
  message: {
    display: "flex",
    alignItems: "center",
    padding: "8px 0"
  },
  action: {
    display: "flex",
    alignItems: "center",
    marginLeft: "auto",
    paddingLeft: "16px",
    marginRight: "-8px"
  }
}), xP = "notistack-snackbar", L_e = /* @__PURE__ */ uo(function(t, r) {
  var e = t.id, n = t.message, i = t.action, a = t.iconVariant, o = t.variant, s = t.hideIconVariant, l = t.style, u = t.className, c = a[o], d = i;
  return typeof d == "function" && (d = d(e)), te.createElement(Xg, {
    ref: r,
    role: "alert",
    "aria-describedby": xP,
    style: l,
    className: C5(ig.MuiContent, ig.MuiContentVariant(o), Cp.root, Cp[o], u, !s && c && Cp.lessPadding)
  }, te.createElement("div", {
    id: xP,
    className: Cp.message
  }, s ? null : c, n), d && te.createElement("div", {
    className: Cp.action
  }, d));
});
L_e.displayName = "MaterialDesignContent";
var wp, nC, y0, b0, iC, Cs = {
  view: {
    default: 20,
    dense: 4
  },
  snackbar: {
    default: 6,
    dense: 2
  }
}, SP = "." + ig.CollapseWrapper, aC = 16;
wp = {
  boxSizing: "border-box",
  display: "flex",
  maxHeight: "100%",
  position: "fixed",
  zIndex: 1400,
  height: "auto",
  width: "auto",
  transition: /* @__PURE__ */ uf(["top", "right", "bottom", "left", "max-width"], {
    duration: 300,
    easing: "ease"
  }),
  // container itself is invisible and should not block clicks, clicks should be passed to its children
  // a pointerEvents: all is applied in the collapse component
  pointerEvents: "none"
}, wp[SP] = {
  padding: Cs.snackbar.default + "px 0px",
  transition: "padding 300ms ease 0ms"
}, wp.maxWidth = "calc(100% - " + Cs.view.default * 2 + "px)", wp[nc.downXs] = {
  width: "100%",
  maxWidth: "calc(100% - " + aC * 2 + "px)"
}, nC = {}, nC[SP] = {
  padding: Cs.snackbar.dense + "px 0px"
}, Cs.view.default - Cs.snackbar.default + "", Cs.view.default - Cs.snackbar.default + "", y0 = {
  left: Cs.view.default + "px"
}, y0[nc.upSm] = {
  alignItems: "flex-start"
}, y0[nc.downXs] = {
  left: aC + "px"
}, b0 = {
  right: Cs.view.default + "px"
}, b0[nc.upSm] = {
  alignItems: "flex-end"
}, b0[nc.downXs] = {
  right: aC + "px"
}, iC = {
  left: "50%",
  transform: "translateX(-50%)"
}, iC[nc.upSm] = {
  alignItems: "center"
};
process.env.NODE_ENV;
var M8 = function() {
  return zn(__e);
};
const R8 = (t) => /* @__PURE__ */ $.createElement("svg", { width: 22, height: 22, viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ $.createElement("path", { d: "M4.74345 17.2509C4.28072 16.7962 4.29667 15.9904 4.7275 15.5595L9.29103 10.996L4.7275 6.44843C4.29667 6.00962 4.28072 5.2118 4.74345 4.74907C5.20619 4.27835 6.01199 4.29431 6.44281 4.73311L10.9984 9.28867L15.5539 4.73311C16.0007 4.28633 16.7826 4.28633 17.2453 4.74907C17.716 5.2118 17.716 5.99367 17.2613 6.44843L12.7137 10.996L17.2613 15.5516C17.716 16.0063 17.708 16.7802 17.2453 17.2509C16.7905 17.7137 16.0007 17.7137 15.5539 17.2669L10.9984 12.7113L6.44281 17.2669C6.01199 17.7057 5.21417 17.7137 4.74345 17.2509Z", fill: "white" })), iSe = uo(
  (t, r) => {
    const { id: e, message: n } = t, { closeSnackbar: i } = M8(), a = ns(() => {
      i(e);
    }, [e, i]);
    return /* @__PURE__ */ S.jsx(Xg, { ref: r, role: "alert", children: /* @__PURE__ */ S.jsxs("div", { className: "theme-snackbar theme-snackbar-success", children: [
      /* @__PURE__ */ S.jsx("span", { children: n }),
      /* @__PURE__ */ S.jsx(
        R8,
        {
          className: "theme-snackbar-close-button",
          onClick: a
        }
      )
    ] }) });
  }
), aSe = uo(
  (t, r) => {
    const { id: e, message: n } = t, { closeSnackbar: i } = M8(), a = ns(() => {
      i(e);
    }, [e, i]);
    return /* @__PURE__ */ S.jsx(Xg, { ref: r, role: "alert", children: /* @__PURE__ */ S.jsxs("div", { className: "theme-snackbar theme-snackbar-error", children: [
      /* @__PURE__ */ S.jsx("span", { children: n }),
      /* @__PURE__ */ S.jsx(
        R8,
        {
          className: "theme-snackbar-close-button",
          onClick: a
        }
      )
    ] }) });
  }
), oSe = uo(
  (t, r) => {
    const { id: e, message: n } = t, { closeSnackbar: i } = M8(), a = ns(() => {
      i(e);
    }, [e, i]);
    return /* @__PURE__ */ S.jsx(Xg, { ref: r, role: "alert", children: /* @__PURE__ */ S.jsxs("div", { className: "theme-snackbar theme-snackbar-warning", children: [
      /* @__PURE__ */ S.jsx("span", { children: n }),
      /* @__PURE__ */ S.jsx(
        R8,
        {
          className: "theme-snackbar-close-button",
          onClick: a
        }
      )
    ] }) });
  }
), sSe = (t) => {
  const {
    current: r,
    steps: e,
    completedSteps: n,
    onChangeStep: i,
    className: a = ""
  } = t, o = ui();
  return r > e.length ? /* @__PURE__ */ S.jsxs(LP, { variant: "error", children: [
    "Props ERR: ",
    /* @__PURE__ */ S.jsx("code", { children: "current" }),
    " cannot be more than ",
    /* @__PURE__ */ S.jsx("code", { children: "steps" })
  ] }) : /* @__PURE__ */ S.jsx("div", { className: `theme-stepper ${a}`, children: e.map((s, l) => {
    const u = l + 1;
    return /* @__PURE__ */ S.jsx(
      "div",
      {
        className: `theme-step ${u === r ? "theme-step-active" : ""} ${n != null && n.includes(u) || r > u ? "theme-step-filled" : ""}`,
        onClick: () => i(u),
        children: /* @__PURE__ */ S.jsx("div", { className: "theme-step-label", children: s })
      },
      `stepper-${o}-${u}`
    );
  }) });
}, lSe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), uSe = (t) => {
  const { tabs: r, defaultOpenIndex: e = 0, className: n = "" } = t, [i, a] = We(e), o = ui(), s = (l, u) => {
    a(l), u.onTabChange && u.onTabChange();
  };
  return r[e] === void 0 ? /* @__PURE__ */ S.jsxs(LP, { variant: "error", children: [
    /* @__PURE__ */ S.jsx("code", { children: "defaultOpenIndex" }),
    " has to be in range of ",
    /* @__PURE__ */ S.jsx("code", { children: "tabs" }),
    " ",
    "array"
  ] }) : /* @__PURE__ */ S.jsxs("div", { className: `theme-tabs-container ${n}`, children: [
    /* @__PURE__ */ S.jsx("ul", { className: "theme-tabs-list", children: r.map((l, u) => /* @__PURE__ */ S.jsx(
      "li",
      {
        className: `theme-tab-item ${u === i ? "active" : ""}`,
        onClick: () => s(u, l),
        children: l.label
      },
      `${o}-tab-${u}`
    )) }),
    /* @__PURE__ */ S.jsx("div", { className: "theme-tab-content", children: r[i] && r[i].content || "" })
  ] });
}, cSe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function Vl(t, r) {
  return typeof t == "function" ? t(r) : t;
}
function ia(t, r) {
  return (e) => {
    r.setState((n) => ({
      ...n,
      [t]: Vl(e, n[t])
    }));
  };
}
function _5(t) {
  return t instanceof Function;
}
function E_e(t) {
  return Array.isArray(t) && t.every((r) => typeof r == "number");
}
function k_e(t, r) {
  const e = [], n = (i) => {
    i.forEach((a) => {
      e.push(a);
      const o = r(a);
      o != null && o.length && n(o);
    });
  };
  return n(t), e;
}
function ut(t, r, e) {
  let n = [], i;
  return (a) => {
    let o;
    e.key && e.debug && (o = Date.now());
    const s = t(a);
    if (!(s.length !== n.length || s.some((c, d) => n[d] !== c)))
      return i;
    n = s;
    let u;
    if (e.key && e.debug && (u = Date.now()), i = r(...s), e == null || e.onChange == null || e.onChange(i), e.key && e.debug && e != null && e.debug()) {
      const c = Math.round((Date.now() - o) * 100) / 100, d = Math.round((Date.now() - u) * 100) / 100, f = d / 16, h = (p, v) => {
        for (p = String(p); p.length < v; )
          p = " " + p;
        return p;
      };
      console.info(`%c⏱ ${h(d, 5)} /${h(c, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * f, 120))}deg 100% 31%);`, e == null ? void 0 : e.key);
    }
    return i;
  };
}
function ct(t, r, e, n) {
  return {
    debug: () => {
      var i;
      return (i = t == null ? void 0 : t.debugAll) != null ? i : t[r];
    },
    key: process.env.NODE_ENV === "development" && e,
    onChange: n
  };
}
function P_e(t, r, e, n) {
  const i = () => {
    var o;
    return (o = a.getValue()) != null ? o : t.options.renderFallbackValue;
  }, a = {
    id: `${r.id}_${e.id}`,
    row: r,
    column: e,
    getValue: () => r.getValue(n),
    renderValue: i,
    getContext: ut(() => [t, e, r, a], (o, s, l, u) => ({
      table: o,
      column: s,
      row: l,
      cell: u,
      getValue: u.getValue,
      renderValue: u.renderValue
    }), ct(t.options, "debugCells", "cell.getContext"))
  };
  return t._features.forEach((o) => {
    o.createCell == null || o.createCell(a, e, r, t);
  }, {}), a;
}
function N_e(t, r, e, n) {
  var i, a;
  const s = {
    ...t._getDefaultColumnDef(),
    ...r
  }, l = s.accessorKey;
  let u = (i = (a = s.id) != null ? a : l ? typeof String.prototype.replaceAll == "function" ? l.replaceAll(".", "_") : l.replace(/\./g, "_") : void 0) != null ? i : typeof s.header == "string" ? s.header : void 0, c;
  if (s.accessorFn ? c = s.accessorFn : l && (l.includes(".") ? c = (f) => {
    let h = f;
    for (const v of l.split(".")) {
      var p;
      h = (p = h) == null ? void 0 : p[v], process.env.NODE_ENV !== "production" && h === void 0 && console.warn(`"${v}" in deeply nested key "${l}" returned undefined.`);
    }
    return h;
  } : c = (f) => f[s.accessorKey]), !u)
    throw process.env.NODE_ENV !== "production" ? new Error(s.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header") : new Error();
  let d = {
    id: `${String(u)}`,
    accessorFn: c,
    parent: n,
    depth: e,
    columnDef: s,
    columns: [],
    getFlatColumns: ut(() => [!0], () => {
      var f;
      return [d, ...(f = d.columns) == null ? void 0 : f.flatMap((h) => h.getFlatColumns())];
    }, ct(t.options, "debugColumns", "column.getFlatColumns")),
    getLeafColumns: ut(() => [t._getOrderColumnsFn()], (f) => {
      var h;
      if ((h = d.columns) != null && h.length) {
        let p = d.columns.flatMap((v) => v.getLeafColumns());
        return f(p);
      }
      return [d];
    }, ct(t.options, "debugColumns", "column.getLeafColumns"))
  };
  for (const f of t._features)
    f.createColumn == null || f.createColumn(d, t);
  return d;
}
const Kn = "debugHeaders";
function IP(t, r, e) {
  var n;
  let a = {
    id: (n = e.id) != null ? n : r.id,
    column: r,
    index: e.index,
    isPlaceholder: !!e.isPlaceholder,
    placeholderId: e.placeholderId,
    depth: e.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const o = [], s = (l) => {
        l.subHeaders && l.subHeaders.length && l.subHeaders.map(s), o.push(l);
      };
      return s(a), o;
    },
    getContext: () => ({
      table: t,
      header: a,
      column: r
    })
  };
  return t._features.forEach((o) => {
    o.createHeader == null || o.createHeader(a, t);
  }), a;
}
const O_e = {
  createTable: (t) => {
    t.getHeaderGroups = ut(() => [t.getAllColumns(), t.getVisibleLeafColumns(), t.getState().columnPinning.left, t.getState().columnPinning.right], (r, e, n, i) => {
      var a, o;
      const s = (a = n == null ? void 0 : n.map((d) => e.find((f) => f.id === d)).filter(Boolean)) != null ? a : [], l = (o = i == null ? void 0 : i.map((d) => e.find((f) => f.id === d)).filter(Boolean)) != null ? o : [], u = e.filter((d) => !(n != null && n.includes(d.id)) && !(i != null && i.includes(d.id)));
      return C0(r, [...s, ...u, ...l], t);
    }, ct(t.options, Kn, "getHeaderGroups")), t.getCenterHeaderGroups = ut(() => [t.getAllColumns(), t.getVisibleLeafColumns(), t.getState().columnPinning.left, t.getState().columnPinning.right], (r, e, n, i) => (e = e.filter((a) => !(n != null && n.includes(a.id)) && !(i != null && i.includes(a.id))), C0(r, e, t, "center")), ct(t.options, Kn, "getCenterHeaderGroups")), t.getLeftHeaderGroups = ut(() => [t.getAllColumns(), t.getVisibleLeafColumns(), t.getState().columnPinning.left], (r, e, n) => {
      var i;
      const a = (i = n == null ? void 0 : n.map((o) => e.find((s) => s.id === o)).filter(Boolean)) != null ? i : [];
      return C0(r, a, t, "left");
    }, ct(t.options, Kn, "getLeftHeaderGroups")), t.getRightHeaderGroups = ut(() => [t.getAllColumns(), t.getVisibleLeafColumns(), t.getState().columnPinning.right], (r, e, n) => {
      var i;
      const a = (i = n == null ? void 0 : n.map((o) => e.find((s) => s.id === o)).filter(Boolean)) != null ? i : [];
      return C0(r, a, t, "right");
    }, ct(t.options, Kn, "getRightHeaderGroups")), t.getFooterGroups = ut(() => [t.getHeaderGroups()], (r) => [...r].reverse(), ct(t.options, Kn, "getFooterGroups")), t.getLeftFooterGroups = ut(() => [t.getLeftHeaderGroups()], (r) => [...r].reverse(), ct(t.options, Kn, "getLeftFooterGroups")), t.getCenterFooterGroups = ut(() => [t.getCenterHeaderGroups()], (r) => [...r].reverse(), ct(t.options, Kn, "getCenterFooterGroups")), t.getRightFooterGroups = ut(() => [t.getRightHeaderGroups()], (r) => [...r].reverse(), ct(t.options, Kn, "getRightFooterGroups")), t.getFlatHeaders = ut(() => [t.getHeaderGroups()], (r) => r.map((e) => e.headers).flat(), ct(t.options, Kn, "getFlatHeaders")), t.getLeftFlatHeaders = ut(() => [t.getLeftHeaderGroups()], (r) => r.map((e) => e.headers).flat(), ct(t.options, Kn, "getLeftFlatHeaders")), t.getCenterFlatHeaders = ut(() => [t.getCenterHeaderGroups()], (r) => r.map((e) => e.headers).flat(), ct(t.options, Kn, "getCenterFlatHeaders")), t.getRightFlatHeaders = ut(() => [t.getRightHeaderGroups()], (r) => r.map((e) => e.headers).flat(), ct(t.options, Kn, "getRightFlatHeaders")), t.getCenterLeafHeaders = ut(() => [t.getCenterFlatHeaders()], (r) => r.filter((e) => {
      var n;
      return !((n = e.subHeaders) != null && n.length);
    }), ct(t.options, Kn, "getCenterLeafHeaders")), t.getLeftLeafHeaders = ut(() => [t.getLeftFlatHeaders()], (r) => r.filter((e) => {
      var n;
      return !((n = e.subHeaders) != null && n.length);
    }), ct(t.options, Kn, "getLeftLeafHeaders")), t.getRightLeafHeaders = ut(() => [t.getRightFlatHeaders()], (r) => r.filter((e) => {
      var n;
      return !((n = e.subHeaders) != null && n.length);
    }), ct(t.options, Kn, "getRightLeafHeaders")), t.getLeafHeaders = ut(() => [t.getLeftHeaderGroups(), t.getCenterHeaderGroups(), t.getRightHeaderGroups()], (r, e, n) => {
      var i, a, o, s, l, u;
      return [...(i = (a = r[0]) == null ? void 0 : a.headers) != null ? i : [], ...(o = (s = e[0]) == null ? void 0 : s.headers) != null ? o : [], ...(l = (u = n[0]) == null ? void 0 : u.headers) != null ? l : []].map((c) => c.getLeafHeaders()).flat();
    }, ct(t.options, Kn, "getLeafHeaders"));
  }
};
function C0(t, r, e, n) {
  var i, a;
  let o = 0;
  const s = function(f, h) {
    h === void 0 && (h = 1), o = Math.max(o, h), f.filter((p) => p.getIsVisible()).forEach((p) => {
      var v;
      (v = p.columns) != null && v.length && s(p.columns, h + 1);
    }, 0);
  };
  s(t);
  let l = [];
  const u = (f, h) => {
    const p = {
      depth: h,
      id: [n, `${h}`].filter(Boolean).join("_"),
      headers: []
    }, v = [];
    f.forEach((g) => {
      const m = [...v].reverse()[0], y = g.column.depth === p.depth;
      let b, C = !1;
      if (y && g.column.parent ? b = g.column.parent : (b = g.column, C = !0), m && (m == null ? void 0 : m.column) === b)
        m.subHeaders.push(g);
      else {
        const w = IP(e, b, {
          id: [n, h, b.id, g == null ? void 0 : g.id].filter(Boolean).join("_"),
          isPlaceholder: C,
          placeholderId: C ? `${v.filter((_) => _.column === b).length}` : void 0,
          depth: h,
          index: v.length
        });
        w.subHeaders.push(g), v.push(w);
      }
      p.headers.push(g), g.headerGroup = p;
    }), l.push(p), h > 0 && u(v, h - 1);
  }, c = r.map((f, h) => IP(e, f, {
    depth: o,
    index: h
  }));
  u(c, o - 1), l.reverse();
  const d = (f) => f.filter((p) => p.column.getIsVisible()).map((p) => {
    let v = 0, g = 0, m = [0];
    p.subHeaders && p.subHeaders.length ? (m = [], d(p.subHeaders).forEach((b) => {
      let {
        colSpan: C,
        rowSpan: w
      } = b;
      v += C, m.push(w);
    })) : v = 1;
    const y = Math.min(...m);
    return g = g + y, p.colSpan = v, p.rowSpan = g, {
      colSpan: v,
      rowSpan: g
    };
  });
  return d((i = (a = l[0]) == null ? void 0 : a.headers) != null ? i : []), l;
}
const V_e = (t, r, e, n, i, a, o) => {
  let s = {
    id: r,
    index: n,
    original: e,
    depth: i,
    parentId: o,
    _valuesCache: {},
    _uniqueValuesCache: {},
    getValue: (l) => {
      if (s._valuesCache.hasOwnProperty(l))
        return s._valuesCache[l];
      const u = t.getColumn(l);
      if (u != null && u.accessorFn)
        return s._valuesCache[l] = u.accessorFn(s.original, n), s._valuesCache[l];
    },
    getUniqueValues: (l) => {
      if (s._uniqueValuesCache.hasOwnProperty(l))
        return s._uniqueValuesCache[l];
      const u = t.getColumn(l);
      if (u != null && u.accessorFn)
        return u.columnDef.getUniqueValues ? (s._uniqueValuesCache[l] = u.columnDef.getUniqueValues(s.original, n), s._uniqueValuesCache[l]) : (s._uniqueValuesCache[l] = [s.getValue(l)], s._uniqueValuesCache[l]);
    },
    renderValue: (l) => {
      var u;
      return (u = s.getValue(l)) != null ? u : t.options.renderFallbackValue;
    },
    subRows: [],
    getLeafRows: () => k_e(s.subRows, (l) => l.subRows),
    getParentRow: () => s.parentId ? t.getRow(s.parentId, !0) : void 0,
    getParentRows: () => {
      let l = [], u = s;
      for (; ; ) {
        const c = u.getParentRow();
        if (!c) break;
        l.push(c), u = c;
      }
      return l.reverse();
    },
    getAllCells: ut(() => [t.getAllLeafColumns()], (l) => l.map((u) => P_e(t, s, u, u.id)), ct(t.options, "debugRows", "getAllCells")),
    _getAllCellsByColumnId: ut(() => [s.getAllCells()], (l) => l.reduce((u, c) => (u[c.column.id] = c, u), {}), ct(t.options, "debugRows", "getAllCellsByColumnId"))
  };
  for (let l = 0; l < t._features.length; l++) {
    const u = t._features[l];
    u == null || u.createRow == null || u.createRow(s, t);
  }
  return s;
}, G_e = {
  createColumn: (t, r) => {
    t._getFacetedRowModel = r.options.getFacetedRowModel && r.options.getFacetedRowModel(r, t.id), t.getFacetedRowModel = () => t._getFacetedRowModel ? t._getFacetedRowModel() : r.getPreFilteredRowModel(), t._getFacetedUniqueValues = r.options.getFacetedUniqueValues && r.options.getFacetedUniqueValues(r, t.id), t.getFacetedUniqueValues = () => t._getFacetedUniqueValues ? t._getFacetedUniqueValues() : /* @__PURE__ */ new Map(), t._getFacetedMinMaxValues = r.options.getFacetedMinMaxValues && r.options.getFacetedMinMaxValues(r, t.id), t.getFacetedMinMaxValues = () => {
      if (t._getFacetedMinMaxValues)
        return t._getFacetedMinMaxValues();
    };
  }
}, Qj = (t, r, e) => {
  var n, i;
  const a = e == null || (n = e.toString()) == null ? void 0 : n.toLowerCase();
  return !!(!((i = t.getValue(r)) == null || (i = i.toString()) == null || (i = i.toLowerCase()) == null) && i.includes(a));
};
Qj.autoRemove = (t) => qa(t);
const eY = (t, r, e) => {
  var n;
  return !!(!((n = t.getValue(r)) == null || (n = n.toString()) == null) && n.includes(e));
};
eY.autoRemove = (t) => qa(t);
const tY = (t, r, e) => {
  var n;
  return ((n = t.getValue(r)) == null || (n = n.toString()) == null ? void 0 : n.toLowerCase()) === (e == null ? void 0 : e.toLowerCase());
};
tY.autoRemove = (t) => qa(t);
const rY = (t, r, e) => {
  var n;
  return (n = t.getValue(r)) == null ? void 0 : n.includes(e);
};
rY.autoRemove = (t) => qa(t) || !(t != null && t.length);
const nY = (t, r, e) => !e.some((n) => {
  var i;
  return !((i = t.getValue(r)) != null && i.includes(n));
});
nY.autoRemove = (t) => qa(t) || !(t != null && t.length);
const iY = (t, r, e) => e.some((n) => {
  var i;
  return (i = t.getValue(r)) == null ? void 0 : i.includes(n);
});
iY.autoRemove = (t) => qa(t) || !(t != null && t.length);
const aY = (t, r, e) => t.getValue(r) === e;
aY.autoRemove = (t) => qa(t);
const oY = (t, r, e) => t.getValue(r) == e;
oY.autoRemove = (t) => qa(t);
const L8 = (t, r, e) => {
  let [n, i] = e;
  const a = t.getValue(r);
  return a >= n && a <= i;
};
L8.resolveFilterValue = (t) => {
  let [r, e] = t, n = typeof r != "number" ? parseFloat(r) : r, i = typeof e != "number" ? parseFloat(e) : e, a = r === null || Number.isNaN(n) ? -1 / 0 : n, o = e === null || Number.isNaN(i) ? 1 / 0 : i;
  if (a > o) {
    const s = a;
    a = o, o = s;
  }
  return [a, o];
};
L8.autoRemove = (t) => qa(t) || qa(t[0]) && qa(t[1]);
const As = {
  includesString: Qj,
  includesStringSensitive: eY,
  equalsString: tY,
  arrIncludes: rY,
  arrIncludesAll: nY,
  arrIncludesSome: iY,
  equals: aY,
  weakEquals: oY,
  inNumberRange: L8
};
function qa(t) {
  return t == null || t === "";
}
const B_e = {
  getDefaultColumnDef: () => ({
    filterFn: "auto"
  }),
  getInitialState: (t) => ({
    columnFilters: [],
    ...t
  }),
  getDefaultOptions: (t) => ({
    onColumnFiltersChange: ia("columnFilters", t),
    filterFromLeafRows: !1,
    maxLeafRowFilterDepth: 100
  }),
  createColumn: (t, r) => {
    t.getAutoFilterFn = () => {
      const e = r.getCoreRowModel().flatRows[0], n = e == null ? void 0 : e.getValue(t.id);
      return typeof n == "string" ? As.includesString : typeof n == "number" ? As.inNumberRange : typeof n == "boolean" || n !== null && typeof n == "object" ? As.equals : Array.isArray(n) ? As.arrIncludes : As.weakEquals;
    }, t.getFilterFn = () => {
      var e, n;
      return _5(t.columnDef.filterFn) ? t.columnDef.filterFn : t.columnDef.filterFn === "auto" ? t.getAutoFilterFn() : (
        // @ts-ignore
        (e = (n = r.options.filterFns) == null ? void 0 : n[t.columnDef.filterFn]) != null ? e : As[t.columnDef.filterFn]
      );
    }, t.getCanFilter = () => {
      var e, n, i;
      return ((e = t.columnDef.enableColumnFilter) != null ? e : !0) && ((n = r.options.enableColumnFilters) != null ? n : !0) && ((i = r.options.enableFilters) != null ? i : !0) && !!t.accessorFn;
    }, t.getIsFiltered = () => t.getFilterIndex() > -1, t.getFilterValue = () => {
      var e;
      return (e = r.getState().columnFilters) == null || (e = e.find((n) => n.id === t.id)) == null ? void 0 : e.value;
    }, t.getFilterIndex = () => {
      var e, n;
      return (e = (n = r.getState().columnFilters) == null ? void 0 : n.findIndex((i) => i.id === t.id)) != null ? e : -1;
    }, t.setFilterValue = (e) => {
      r.setColumnFilters((n) => {
        const i = t.getFilterFn(), a = n == null ? void 0 : n.find((c) => c.id === t.id), o = Vl(e, a ? a.value : void 0);
        if (AP(i, o, t)) {
          var s;
          return (s = n == null ? void 0 : n.filter((c) => c.id !== t.id)) != null ? s : [];
        }
        const l = {
          id: t.id,
          value: o
        };
        if (a) {
          var u;
          return (u = n == null ? void 0 : n.map((c) => c.id === t.id ? l : c)) != null ? u : [];
        }
        return n != null && n.length ? [...n, l] : [l];
      });
    };
  },
  createRow: (t, r) => {
    t.columnFilters = {}, t.columnFiltersMeta = {};
  },
  createTable: (t) => {
    t.setColumnFilters = (r) => {
      const e = t.getAllLeafColumns(), n = (i) => {
        var a;
        return (a = Vl(r, i)) == null ? void 0 : a.filter((o) => {
          const s = e.find((l) => l.id === o.id);
          if (s) {
            const l = s.getFilterFn();
            if (AP(l, o.value, s))
              return !1;
          }
          return !0;
        });
      };
      t.options.onColumnFiltersChange == null || t.options.onColumnFiltersChange(n);
    }, t.resetColumnFilters = (r) => {
      var e, n;
      t.setColumnFilters(r ? [] : (e = (n = t.initialState) == null ? void 0 : n.columnFilters) != null ? e : []);
    }, t.getPreFilteredRowModel = () => t.getCoreRowModel(), t.getFilteredRowModel = () => (!t._getFilteredRowModel && t.options.getFilteredRowModel && (t._getFilteredRowModel = t.options.getFilteredRowModel(t)), t.options.manualFiltering || !t._getFilteredRowModel ? t.getPreFilteredRowModel() : t._getFilteredRowModel());
  }
};
function AP(t, r, e) {
  return (t && t.autoRemove ? t.autoRemove(r, e) : !1) || typeof r > "u" || typeof r == "string" && !r;
}
const F_e = (t, r, e) => e.reduce((n, i) => {
  const a = i.getValue(t);
  return n + (typeof a == "number" ? a : 0);
}, 0), H_e = (t, r, e) => {
  let n;
  return e.forEach((i) => {
    const a = i.getValue(t);
    a != null && (n > a || n === void 0 && a >= a) && (n = a);
  }), n;
}, z_e = (t, r, e) => {
  let n;
  return e.forEach((i) => {
    const a = i.getValue(t);
    a != null && (n < a || n === void 0 && a >= a) && (n = a);
  }), n;
}, W_e = (t, r, e) => {
  let n, i;
  return e.forEach((a) => {
    const o = a.getValue(t);
    o != null && (n === void 0 ? o >= o && (n = i = o) : (n > o && (n = o), i < o && (i = o)));
  }), [n, i];
}, Z_e = (t, r) => {
  let e = 0, n = 0;
  if (r.forEach((i) => {
    let a = i.getValue(t);
    a != null && (a = +a) >= a && (++e, n += a);
  }), e) return n / e;
}, j_e = (t, r) => {
  if (!r.length)
    return;
  const e = r.map((a) => a.getValue(t));
  if (!E_e(e))
    return;
  if (e.length === 1)
    return e[0];
  const n = Math.floor(e.length / 2), i = e.sort((a, o) => a - o);
  return e.length % 2 !== 0 ? i[n] : (i[n - 1] + i[n]) / 2;
}, Y_e = (t, r) => Array.from(new Set(r.map((e) => e.getValue(t))).values()), X_e = (t, r) => new Set(r.map((e) => e.getValue(t))).size, $_e = (t, r) => r.length, oC = {
  sum: F_e,
  min: H_e,
  max: z_e,
  extent: W_e,
  mean: Z_e,
  median: j_e,
  unique: Y_e,
  uniqueCount: X_e,
  count: $_e
}, U_e = {
  getDefaultColumnDef: () => ({
    aggregatedCell: (t) => {
      var r, e;
      return (r = (e = t.getValue()) == null || e.toString == null ? void 0 : e.toString()) != null ? r : null;
    },
    aggregationFn: "auto"
  }),
  getInitialState: (t) => ({
    grouping: [],
    ...t
  }),
  getDefaultOptions: (t) => ({
    onGroupingChange: ia("grouping", t),
    groupedColumnMode: "reorder"
  }),
  createColumn: (t, r) => {
    t.toggleGrouping = () => {
      r.setGrouping((e) => e != null && e.includes(t.id) ? e.filter((n) => n !== t.id) : [...e ?? [], t.id]);
    }, t.getCanGroup = () => {
      var e, n;
      return ((e = t.columnDef.enableGrouping) != null ? e : !0) && ((n = r.options.enableGrouping) != null ? n : !0) && (!!t.accessorFn || !!t.columnDef.getGroupingValue);
    }, t.getIsGrouped = () => {
      var e;
      return (e = r.getState().grouping) == null ? void 0 : e.includes(t.id);
    }, t.getGroupedIndex = () => {
      var e;
      return (e = r.getState().grouping) == null ? void 0 : e.indexOf(t.id);
    }, t.getToggleGroupingHandler = () => {
      const e = t.getCanGroup();
      return () => {
        e && t.toggleGrouping();
      };
    }, t.getAutoAggregationFn = () => {
      const e = r.getCoreRowModel().flatRows[0], n = e == null ? void 0 : e.getValue(t.id);
      if (typeof n == "number")
        return oC.sum;
      if (Object.prototype.toString.call(n) === "[object Date]")
        return oC.extent;
    }, t.getAggregationFn = () => {
      var e, n;
      if (!t)
        throw new Error();
      return _5(t.columnDef.aggregationFn) ? t.columnDef.aggregationFn : t.columnDef.aggregationFn === "auto" ? t.getAutoAggregationFn() : (e = (n = r.options.aggregationFns) == null ? void 0 : n[t.columnDef.aggregationFn]) != null ? e : oC[t.columnDef.aggregationFn];
    };
  },
  createTable: (t) => {
    t.setGrouping = (r) => t.options.onGroupingChange == null ? void 0 : t.options.onGroupingChange(r), t.resetGrouping = (r) => {
      var e, n;
      t.setGrouping(r ? [] : (e = (n = t.initialState) == null ? void 0 : n.grouping) != null ? e : []);
    }, t.getPreGroupedRowModel = () => t.getFilteredRowModel(), t.getGroupedRowModel = () => (!t._getGroupedRowModel && t.options.getGroupedRowModel && (t._getGroupedRowModel = t.options.getGroupedRowModel(t)), t.options.manualGrouping || !t._getGroupedRowModel ? t.getPreGroupedRowModel() : t._getGroupedRowModel());
  },
  createRow: (t, r) => {
    t.getIsGrouped = () => !!t.groupingColumnId, t.getGroupingValue = (e) => {
      if (t._groupingValuesCache.hasOwnProperty(e))
        return t._groupingValuesCache[e];
      const n = r.getColumn(e);
      return n != null && n.columnDef.getGroupingValue ? (t._groupingValuesCache[e] = n.columnDef.getGroupingValue(t.original), t._groupingValuesCache[e]) : t.getValue(e);
    }, t._groupingValuesCache = {};
  },
  createCell: (t, r, e, n) => {
    t.getIsGrouped = () => r.getIsGrouped() && r.id === e.groupingColumnId, t.getIsPlaceholder = () => !t.getIsGrouped() && r.getIsGrouped(), t.getIsAggregated = () => {
      var i;
      return !t.getIsGrouped() && !t.getIsPlaceholder() && !!((i = e.subRows) != null && i.length);
    };
  }
};
function J_e(t, r, e) {
  if (!(r != null && r.length) || !e)
    return t;
  const n = t.filter((a) => !r.includes(a.id));
  return e === "remove" ? n : [...r.map((a) => t.find((o) => o.id === a)).filter(Boolean), ...n];
}
const K_e = {
  getInitialState: (t) => ({
    columnOrder: [],
    ...t
  }),
  getDefaultOptions: (t) => ({
    onColumnOrderChange: ia("columnOrder", t)
  }),
  createColumn: (t, r) => {
    t.getIndex = ut((e) => [cv(r, e)], (e) => e.findIndex((n) => n.id === t.id), ct(r.options, "debugColumns", "getIndex")), t.getIsFirstColumn = (e) => {
      var n;
      return ((n = cv(r, e)[0]) == null ? void 0 : n.id) === t.id;
    }, t.getIsLastColumn = (e) => {
      var n;
      const i = cv(r, e);
      return ((n = i[i.length - 1]) == null ? void 0 : n.id) === t.id;
    };
  },
  createTable: (t) => {
    t.setColumnOrder = (r) => t.options.onColumnOrderChange == null ? void 0 : t.options.onColumnOrderChange(r), t.resetColumnOrder = (r) => {
      var e;
      t.setColumnOrder(r ? [] : (e = t.initialState.columnOrder) != null ? e : []);
    }, t._getOrderColumnsFn = ut(() => [t.getState().columnOrder, t.getState().grouping, t.options.groupedColumnMode], (r, e, n) => (i) => {
      let a = [];
      if (!(r != null && r.length))
        a = i;
      else {
        const o = [...r], s = [...i];
        for (; s.length && o.length; ) {
          const l = o.shift(), u = s.findIndex((c) => c.id === l);
          u > -1 && a.push(s.splice(u, 1)[0]);
        }
        a = [...a, ...s];
      }
      return J_e(a, e, n);
    }, ct(t.options, "debugTable", "_getOrderColumnsFn"));
  }
}, sC = () => ({
  left: [],
  right: []
}), q_e = {
  getInitialState: (t) => ({
    columnPinning: sC(),
    ...t
  }),
  getDefaultOptions: (t) => ({
    onColumnPinningChange: ia("columnPinning", t)
  }),
  createColumn: (t, r) => {
    t.pin = (e) => {
      const n = t.getLeafColumns().map((i) => i.id).filter(Boolean);
      r.setColumnPinning((i) => {
        var a, o;
        if (e === "right") {
          var s, l;
          return {
            left: ((s = i == null ? void 0 : i.left) != null ? s : []).filter((d) => !(n != null && n.includes(d))),
            right: [...((l = i == null ? void 0 : i.right) != null ? l : []).filter((d) => !(n != null && n.includes(d))), ...n]
          };
        }
        if (e === "left") {
          var u, c;
          return {
            left: [...((u = i == null ? void 0 : i.left) != null ? u : []).filter((d) => !(n != null && n.includes(d))), ...n],
            right: ((c = i == null ? void 0 : i.right) != null ? c : []).filter((d) => !(n != null && n.includes(d)))
          };
        }
        return {
          left: ((a = i == null ? void 0 : i.left) != null ? a : []).filter((d) => !(n != null && n.includes(d))),
          right: ((o = i == null ? void 0 : i.right) != null ? o : []).filter((d) => !(n != null && n.includes(d)))
        };
      });
    }, t.getCanPin = () => t.getLeafColumns().some((n) => {
      var i, a, o;
      return ((i = n.columnDef.enablePinning) != null ? i : !0) && ((a = (o = r.options.enableColumnPinning) != null ? o : r.options.enablePinning) != null ? a : !0);
    }), t.getIsPinned = () => {
      const e = t.getLeafColumns().map((s) => s.id), {
        left: n,
        right: i
      } = r.getState().columnPinning, a = e.some((s) => n == null ? void 0 : n.includes(s)), o = e.some((s) => i == null ? void 0 : i.includes(s));
      return a ? "left" : o ? "right" : !1;
    }, t.getPinnedIndex = () => {
      var e, n;
      const i = t.getIsPinned();
      return i ? (e = (n = r.getState().columnPinning) == null || (n = n[i]) == null ? void 0 : n.indexOf(t.id)) != null ? e : -1 : 0;
    };
  },
  createRow: (t, r) => {
    t.getCenterVisibleCells = ut(() => [t._getAllVisibleCells(), r.getState().columnPinning.left, r.getState().columnPinning.right], (e, n, i) => {
      const a = [...n ?? [], ...i ?? []];
      return e.filter((o) => !a.includes(o.column.id));
    }, ct(r.options, "debugRows", "getCenterVisibleCells")), t.getLeftVisibleCells = ut(() => [t._getAllVisibleCells(), r.getState().columnPinning.left], (e, n) => (n ?? []).map((a) => e.find((o) => o.column.id === a)).filter(Boolean).map((a) => ({
      ...a,
      position: "left"
    })), ct(r.options, "debugRows", "getLeftVisibleCells")), t.getRightVisibleCells = ut(() => [t._getAllVisibleCells(), r.getState().columnPinning.right], (e, n) => (n ?? []).map((a) => e.find((o) => o.column.id === a)).filter(Boolean).map((a) => ({
      ...a,
      position: "right"
    })), ct(r.options, "debugRows", "getRightVisibleCells"));
  },
  createTable: (t) => {
    t.setColumnPinning = (r) => t.options.onColumnPinningChange == null ? void 0 : t.options.onColumnPinningChange(r), t.resetColumnPinning = (r) => {
      var e, n;
      return t.setColumnPinning(r ? sC() : (e = (n = t.initialState) == null ? void 0 : n.columnPinning) != null ? e : sC());
    }, t.getIsSomeColumnsPinned = (r) => {
      var e;
      const n = t.getState().columnPinning;
      if (!r) {
        var i, a;
        return !!((i = n.left) != null && i.length || (a = n.right) != null && a.length);
      }
      return !!((e = n[r]) != null && e.length);
    }, t.getLeftLeafColumns = ut(() => [t.getAllLeafColumns(), t.getState().columnPinning.left], (r, e) => (e ?? []).map((n) => r.find((i) => i.id === n)).filter(Boolean), ct(t.options, "debugColumns", "getLeftLeafColumns")), t.getRightLeafColumns = ut(() => [t.getAllLeafColumns(), t.getState().columnPinning.right], (r, e) => (e ?? []).map((n) => r.find((i) => i.id === n)).filter(Boolean), ct(t.options, "debugColumns", "getRightLeafColumns")), t.getCenterLeafColumns = ut(() => [t.getAllLeafColumns(), t.getState().columnPinning.left, t.getState().columnPinning.right], (r, e, n) => {
      const i = [...e ?? [], ...n ?? []];
      return r.filter((a) => !i.includes(a.id));
    }, ct(t.options, "debugColumns", "getCenterLeafColumns"));
  }
}, w0 = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
}, lC = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: !1,
  columnSizingStart: []
}), Q_e = {
  getDefaultColumnDef: () => w0,
  getInitialState: (t) => ({
    columnSizing: {},
    columnSizingInfo: lC(),
    ...t
  }),
  getDefaultOptions: (t) => ({
    columnResizeMode: "onEnd",
    columnResizeDirection: "ltr",
    onColumnSizingChange: ia("columnSizing", t),
    onColumnSizingInfoChange: ia("columnSizingInfo", t)
  }),
  createColumn: (t, r) => {
    t.getSize = () => {
      var e, n, i;
      const a = r.getState().columnSizing[t.id];
      return Math.min(Math.max((e = t.columnDef.minSize) != null ? e : w0.minSize, (n = a ?? t.columnDef.size) != null ? n : w0.size), (i = t.columnDef.maxSize) != null ? i : w0.maxSize);
    }, t.getStart = ut((e) => [e, cv(r, e), r.getState().columnSizing], (e, n) => n.slice(0, t.getIndex(e)).reduce((i, a) => i + a.getSize(), 0), ct(r.options, "debugColumns", "getStart")), t.getAfter = ut((e) => [e, cv(r, e), r.getState().columnSizing], (e, n) => n.slice(t.getIndex(e) + 1).reduce((i, a) => i + a.getSize(), 0), ct(r.options, "debugColumns", "getAfter")), t.resetSize = () => {
      r.setColumnSizing((e) => {
        let {
          [t.id]: n,
          ...i
        } = e;
        return i;
      });
    }, t.getCanResize = () => {
      var e, n;
      return ((e = t.columnDef.enableResizing) != null ? e : !0) && ((n = r.options.enableColumnResizing) != null ? n : !0);
    }, t.getIsResizing = () => r.getState().columnSizingInfo.isResizingColumn === t.id;
  },
  createHeader: (t, r) => {
    t.getSize = () => {
      let e = 0;
      const n = (i) => {
        if (i.subHeaders.length)
          i.subHeaders.forEach(n);
        else {
          var a;
          e += (a = i.column.getSize()) != null ? a : 0;
        }
      };
      return n(t), e;
    }, t.getStart = () => {
      if (t.index > 0) {
        const e = t.headerGroup.headers[t.index - 1];
        return e.getStart() + e.getSize();
      }
      return 0;
    }, t.getResizeHandler = (e) => {
      const n = r.getColumn(t.column.id), i = n == null ? void 0 : n.getCanResize();
      return (a) => {
        if (!n || !i || (a.persist == null || a.persist(), uC(a) && a.touches && a.touches.length > 1))
          return;
        const o = t.getSize(), s = t ? t.getLeafHeaders().map((m) => [m.column.id, m.column.getSize()]) : [[n.id, n.getSize()]], l = uC(a) ? Math.round(a.touches[0].clientX) : a.clientX, u = {}, c = (m, y) => {
          typeof y == "number" && (r.setColumnSizingInfo((b) => {
            var C, w;
            const _ = r.options.columnResizeDirection === "rtl" ? -1 : 1, x = (y - ((C = b == null ? void 0 : b.startOffset) != null ? C : 0)) * _, I = Math.max(x / ((w = b == null ? void 0 : b.startSize) != null ? w : 0), -0.999999);
            return b.columnSizingStart.forEach((D) => {
              let [T, A] = D;
              u[T] = Math.round(Math.max(A + A * I, 0) * 100) / 100;
            }), {
              ...b,
              deltaOffset: x,
              deltaPercentage: I
            };
          }), (r.options.columnResizeMode === "onChange" || m === "end") && r.setColumnSizing((b) => ({
            ...b,
            ...u
          })));
        }, d = (m) => c("move", m), f = (m) => {
          c("end", m), r.setColumnSizingInfo((y) => ({
            ...y,
            isResizingColumn: !1,
            startOffset: null,
            startSize: null,
            deltaOffset: null,
            deltaPercentage: null,
            columnSizingStart: []
          }));
        }, h = e || typeof document < "u" ? document : null, p = {
          moveHandler: (m) => d(m.clientX),
          upHandler: (m) => {
            h == null || h.removeEventListener("mousemove", p.moveHandler), h == null || h.removeEventListener("mouseup", p.upHandler), f(m.clientX);
          }
        }, v = {
          moveHandler: (m) => (m.cancelable && (m.preventDefault(), m.stopPropagation()), d(m.touches[0].clientX), !1),
          upHandler: (m) => {
            var y;
            h == null || h.removeEventListener("touchmove", v.moveHandler), h == null || h.removeEventListener("touchend", v.upHandler), m.cancelable && (m.preventDefault(), m.stopPropagation()), f((y = m.touches[0]) == null ? void 0 : y.clientX);
          }
        }, g = exe() ? {
          passive: !1
        } : !1;
        uC(a) ? (h == null || h.addEventListener("touchmove", v.moveHandler, g), h == null || h.addEventListener("touchend", v.upHandler, g)) : (h == null || h.addEventListener("mousemove", p.moveHandler, g), h == null || h.addEventListener("mouseup", p.upHandler, g)), r.setColumnSizingInfo((m) => ({
          ...m,
          startOffset: l,
          startSize: o,
          deltaOffset: 0,
          deltaPercentage: 0,
          columnSizingStart: s,
          isResizingColumn: n.id
        }));
      };
    };
  },
  createTable: (t) => {
    t.setColumnSizing = (r) => t.options.onColumnSizingChange == null ? void 0 : t.options.onColumnSizingChange(r), t.setColumnSizingInfo = (r) => t.options.onColumnSizingInfoChange == null ? void 0 : t.options.onColumnSizingInfoChange(r), t.resetColumnSizing = (r) => {
      var e;
      t.setColumnSizing(r ? {} : (e = t.initialState.columnSizing) != null ? e : {});
    }, t.resetHeaderSizeInfo = (r) => {
      var e;
      t.setColumnSizingInfo(r ? lC() : (e = t.initialState.columnSizingInfo) != null ? e : lC());
    }, t.getTotalSize = () => {
      var r, e;
      return (r = (e = t.getHeaderGroups()[0]) == null ? void 0 : e.headers.reduce((n, i) => n + i.getSize(), 0)) != null ? r : 0;
    }, t.getLeftTotalSize = () => {
      var r, e;
      return (r = (e = t.getLeftHeaderGroups()[0]) == null ? void 0 : e.headers.reduce((n, i) => n + i.getSize(), 0)) != null ? r : 0;
    }, t.getCenterTotalSize = () => {
      var r, e;
      return (r = (e = t.getCenterHeaderGroups()[0]) == null ? void 0 : e.headers.reduce((n, i) => n + i.getSize(), 0)) != null ? r : 0;
    }, t.getRightTotalSize = () => {
      var r, e;
      return (r = (e = t.getRightHeaderGroups()[0]) == null ? void 0 : e.headers.reduce((n, i) => n + i.getSize(), 0)) != null ? r : 0;
    };
  }
};
let _0 = null;
function exe() {
  if (typeof _0 == "boolean") return _0;
  let t = !1;
  try {
    const r = {
      get passive() {
        return t = !0, !1;
      }
    }, e = () => {
    };
    window.addEventListener("test", e, r), window.removeEventListener("test", e);
  } catch {
    t = !1;
  }
  return _0 = t, _0;
}
function uC(t) {
  return t.type === "touchstart";
}
const txe = {
  getInitialState: (t) => ({
    columnVisibility: {},
    ...t
  }),
  getDefaultOptions: (t) => ({
    onColumnVisibilityChange: ia("columnVisibility", t)
  }),
  createColumn: (t, r) => {
    t.toggleVisibility = (e) => {
      t.getCanHide() && r.setColumnVisibility((n) => ({
        ...n,
        [t.id]: e ?? !t.getIsVisible()
      }));
    }, t.getIsVisible = () => {
      var e, n;
      const i = t.columns;
      return (e = i.length ? i.some((a) => a.getIsVisible()) : (n = r.getState().columnVisibility) == null ? void 0 : n[t.id]) != null ? e : !0;
    }, t.getCanHide = () => {
      var e, n;
      return ((e = t.columnDef.enableHiding) != null ? e : !0) && ((n = r.options.enableHiding) != null ? n : !0);
    }, t.getToggleVisibilityHandler = () => (e) => {
      t.toggleVisibility == null || t.toggleVisibility(e.target.checked);
    };
  },
  createRow: (t, r) => {
    t._getAllVisibleCells = ut(() => [t.getAllCells(), r.getState().columnVisibility], (e) => e.filter((n) => n.column.getIsVisible()), ct(r.options, "debugRows", "_getAllVisibleCells")), t.getVisibleCells = ut(() => [t.getLeftVisibleCells(), t.getCenterVisibleCells(), t.getRightVisibleCells()], (e, n, i) => [...e, ...n, ...i], ct(r.options, "debugRows", "getVisibleCells"));
  },
  createTable: (t) => {
    const r = (e, n) => ut(() => [n(), n().filter((i) => i.getIsVisible()).map((i) => i.id).join("_")], (i) => i.filter((a) => a.getIsVisible == null ? void 0 : a.getIsVisible()), ct(t.options, "debugColumns", e));
    t.getVisibleFlatColumns = r("getVisibleFlatColumns", () => t.getAllFlatColumns()), t.getVisibleLeafColumns = r("getVisibleLeafColumns", () => t.getAllLeafColumns()), t.getLeftVisibleLeafColumns = r("getLeftVisibleLeafColumns", () => t.getLeftLeafColumns()), t.getRightVisibleLeafColumns = r("getRightVisibleLeafColumns", () => t.getRightLeafColumns()), t.getCenterVisibleLeafColumns = r("getCenterVisibleLeafColumns", () => t.getCenterLeafColumns()), t.setColumnVisibility = (e) => t.options.onColumnVisibilityChange == null ? void 0 : t.options.onColumnVisibilityChange(e), t.resetColumnVisibility = (e) => {
      var n;
      t.setColumnVisibility(e ? {} : (n = t.initialState.columnVisibility) != null ? n : {});
    }, t.toggleAllColumnsVisible = (e) => {
      var n;
      e = (n = e) != null ? n : !t.getIsAllColumnsVisible(), t.setColumnVisibility(t.getAllLeafColumns().reduce((i, a) => ({
        ...i,
        [a.id]: e || !(a.getCanHide != null && a.getCanHide())
      }), {}));
    }, t.getIsAllColumnsVisible = () => !t.getAllLeafColumns().some((e) => !(e.getIsVisible != null && e.getIsVisible())), t.getIsSomeColumnsVisible = () => t.getAllLeafColumns().some((e) => e.getIsVisible == null ? void 0 : e.getIsVisible()), t.getToggleAllColumnsVisibilityHandler = () => (e) => {
      var n;
      t.toggleAllColumnsVisible((n = e.target) == null ? void 0 : n.checked);
    };
  }
};
function cv(t, r) {
  return r ? r === "center" ? t.getCenterVisibleLeafColumns() : r === "left" ? t.getLeftVisibleLeafColumns() : t.getRightVisibleLeafColumns() : t.getVisibleLeafColumns();
}
const rxe = {
  createTable: (t) => {
    t._getGlobalFacetedRowModel = t.options.getFacetedRowModel && t.options.getFacetedRowModel(t, "__global__"), t.getGlobalFacetedRowModel = () => t.options.manualFiltering || !t._getGlobalFacetedRowModel ? t.getPreFilteredRowModel() : t._getGlobalFacetedRowModel(), t._getGlobalFacetedUniqueValues = t.options.getFacetedUniqueValues && t.options.getFacetedUniqueValues(t, "__global__"), t.getGlobalFacetedUniqueValues = () => t._getGlobalFacetedUniqueValues ? t._getGlobalFacetedUniqueValues() : /* @__PURE__ */ new Map(), t._getGlobalFacetedMinMaxValues = t.options.getFacetedMinMaxValues && t.options.getFacetedMinMaxValues(t, "__global__"), t.getGlobalFacetedMinMaxValues = () => {
      if (t._getGlobalFacetedMinMaxValues)
        return t._getGlobalFacetedMinMaxValues();
    };
  }
}, nxe = {
  getInitialState: (t) => ({
    globalFilter: void 0,
    ...t
  }),
  getDefaultOptions: (t) => ({
    onGlobalFilterChange: ia("globalFilter", t),
    globalFilterFn: "auto",
    getColumnCanGlobalFilter: (r) => {
      var e;
      const n = (e = t.getCoreRowModel().flatRows[0]) == null || (e = e._getAllCellsByColumnId()[r.id]) == null ? void 0 : e.getValue();
      return typeof n == "string" || typeof n == "number";
    }
  }),
  createColumn: (t, r) => {
    t.getCanGlobalFilter = () => {
      var e, n, i, a;
      return ((e = t.columnDef.enableGlobalFilter) != null ? e : !0) && ((n = r.options.enableGlobalFilter) != null ? n : !0) && ((i = r.options.enableFilters) != null ? i : !0) && ((a = r.options.getColumnCanGlobalFilter == null ? void 0 : r.options.getColumnCanGlobalFilter(t)) != null ? a : !0) && !!t.accessorFn;
    };
  },
  createTable: (t) => {
    t.getGlobalAutoFilterFn = () => As.includesString, t.getGlobalFilterFn = () => {
      var r, e;
      const {
        globalFilterFn: n
      } = t.options;
      return _5(n) ? n : n === "auto" ? t.getGlobalAutoFilterFn() : (r = (e = t.options.filterFns) == null ? void 0 : e[n]) != null ? r : As[n];
    }, t.setGlobalFilter = (r) => {
      t.options.onGlobalFilterChange == null || t.options.onGlobalFilterChange(r);
    }, t.resetGlobalFilter = (r) => {
      t.setGlobalFilter(r ? void 0 : t.initialState.globalFilter);
    };
  }
}, ixe = {
  getInitialState: (t) => ({
    expanded: {},
    ...t
  }),
  getDefaultOptions: (t) => ({
    onExpandedChange: ia("expanded", t),
    paginateExpandedRows: !0
  }),
  createTable: (t) => {
    let r = !1, e = !1;
    t._autoResetExpanded = () => {
      var n, i;
      if (!r) {
        t._queue(() => {
          r = !0;
        });
        return;
      }
      if ((n = (i = t.options.autoResetAll) != null ? i : t.options.autoResetExpanded) != null ? n : !t.options.manualExpanding) {
        if (e) return;
        e = !0, t._queue(() => {
          t.resetExpanded(), e = !1;
        });
      }
    }, t.setExpanded = (n) => t.options.onExpandedChange == null ? void 0 : t.options.onExpandedChange(n), t.toggleAllRowsExpanded = (n) => {
      n ?? !t.getIsAllRowsExpanded() ? t.setExpanded(!0) : t.setExpanded({});
    }, t.resetExpanded = (n) => {
      var i, a;
      t.setExpanded(n ? {} : (i = (a = t.initialState) == null ? void 0 : a.expanded) != null ? i : {});
    }, t.getCanSomeRowsExpand = () => t.getPrePaginationRowModel().flatRows.some((n) => n.getCanExpand()), t.getToggleAllRowsExpandedHandler = () => (n) => {
      n.persist == null || n.persist(), t.toggleAllRowsExpanded();
    }, t.getIsSomeRowsExpanded = () => {
      const n = t.getState().expanded;
      return n === !0 || Object.values(n).some(Boolean);
    }, t.getIsAllRowsExpanded = () => {
      const n = t.getState().expanded;
      return typeof n == "boolean" ? n === !0 : !(!Object.keys(n).length || t.getRowModel().flatRows.some((i) => !i.getIsExpanded()));
    }, t.getExpandedDepth = () => {
      let n = 0;
      return (t.getState().expanded === !0 ? Object.keys(t.getRowModel().rowsById) : Object.keys(t.getState().expanded)).forEach((a) => {
        const o = a.split(".");
        n = Math.max(n, o.length);
      }), n;
    }, t.getPreExpandedRowModel = () => t.getSortedRowModel(), t.getExpandedRowModel = () => (!t._getExpandedRowModel && t.options.getExpandedRowModel && (t._getExpandedRowModel = t.options.getExpandedRowModel(t)), t.options.manualExpanding || !t._getExpandedRowModel ? t.getPreExpandedRowModel() : t._getExpandedRowModel());
  },
  createRow: (t, r) => {
    t.toggleExpanded = (e) => {
      r.setExpanded((n) => {
        var i;
        const a = n === !0 ? !0 : !!(n != null && n[t.id]);
        let o = {};
        if (n === !0 ? Object.keys(r.getRowModel().rowsById).forEach((s) => {
          o[s] = !0;
        }) : o = n, e = (i = e) != null ? i : !a, !a && e)
          return {
            ...o,
            [t.id]: !0
          };
        if (a && !e) {
          const {
            [t.id]: s,
            ...l
          } = o;
          return l;
        }
        return n;
      });
    }, t.getIsExpanded = () => {
      var e;
      const n = r.getState().expanded;
      return !!((e = r.options.getIsRowExpanded == null ? void 0 : r.options.getIsRowExpanded(t)) != null ? e : n === !0 || n != null && n[t.id]);
    }, t.getCanExpand = () => {
      var e, n, i;
      return (e = r.options.getRowCanExpand == null ? void 0 : r.options.getRowCanExpand(t)) != null ? e : ((n = r.options.enableExpanding) != null ? n : !0) && !!((i = t.subRows) != null && i.length);
    }, t.getIsAllParentsExpanded = () => {
      let e = !0, n = t;
      for (; e && n.parentId; )
        n = r.getRow(n.parentId, !0), e = n.getIsExpanded();
      return e;
    }, t.getToggleExpandedHandler = () => {
      const e = t.getCanExpand();
      return () => {
        e && t.toggleExpanded();
      };
    };
  }
}, c7 = 0, d7 = 10, cC = () => ({
  pageIndex: c7,
  pageSize: d7
}), axe = {
  getInitialState: (t) => ({
    ...t,
    pagination: {
      ...cC(),
      ...t == null ? void 0 : t.pagination
    }
  }),
  getDefaultOptions: (t) => ({
    onPaginationChange: ia("pagination", t)
  }),
  createTable: (t) => {
    let r = !1, e = !1;
    t._autoResetPageIndex = () => {
      var n, i;
      if (!r) {
        t._queue(() => {
          r = !0;
        });
        return;
      }
      if ((n = (i = t.options.autoResetAll) != null ? i : t.options.autoResetPageIndex) != null ? n : !t.options.manualPagination) {
        if (e) return;
        e = !0, t._queue(() => {
          t.resetPageIndex(), e = !1;
        });
      }
    }, t.setPagination = (n) => {
      const i = (a) => Vl(n, a);
      return t.options.onPaginationChange == null ? void 0 : t.options.onPaginationChange(i);
    }, t.resetPagination = (n) => {
      var i;
      t.setPagination(n ? cC() : (i = t.initialState.pagination) != null ? i : cC());
    }, t.setPageIndex = (n) => {
      t.setPagination((i) => {
        let a = Vl(n, i.pageIndex);
        const o = typeof t.options.pageCount > "u" || t.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : t.options.pageCount - 1;
        return a = Math.max(0, Math.min(a, o)), {
          ...i,
          pageIndex: a
        };
      });
    }, t.resetPageIndex = (n) => {
      var i, a;
      t.setPageIndex(n ? c7 : (i = (a = t.initialState) == null || (a = a.pagination) == null ? void 0 : a.pageIndex) != null ? i : c7);
    }, t.resetPageSize = (n) => {
      var i, a;
      t.setPageSize(n ? d7 : (i = (a = t.initialState) == null || (a = a.pagination) == null ? void 0 : a.pageSize) != null ? i : d7);
    }, t.setPageSize = (n) => {
      t.setPagination((i) => {
        const a = Math.max(1, Vl(n, i.pageSize)), o = i.pageSize * i.pageIndex, s = Math.floor(o / a);
        return {
          ...i,
          pageIndex: s,
          pageSize: a
        };
      });
    }, t.setPageCount = (n) => t.setPagination((i) => {
      var a;
      let o = Vl(n, (a = t.options.pageCount) != null ? a : -1);
      return typeof o == "number" && (o = Math.max(-1, o)), {
        ...i,
        pageCount: o
      };
    }), t.getPageOptions = ut(() => [t.getPageCount()], (n) => {
      let i = [];
      return n && n > 0 && (i = [...new Array(n)].fill(null).map((a, o) => o)), i;
    }, ct(t.options, "debugTable", "getPageOptions")), t.getCanPreviousPage = () => t.getState().pagination.pageIndex > 0, t.getCanNextPage = () => {
      const {
        pageIndex: n
      } = t.getState().pagination, i = t.getPageCount();
      return i === -1 ? !0 : i === 0 ? !1 : n < i - 1;
    }, t.previousPage = () => t.setPageIndex((n) => n - 1), t.nextPage = () => t.setPageIndex((n) => n + 1), t.firstPage = () => t.setPageIndex(0), t.lastPage = () => t.setPageIndex(t.getPageCount() - 1), t.getPrePaginationRowModel = () => t.getExpandedRowModel(), t.getPaginationRowModel = () => (!t._getPaginationRowModel && t.options.getPaginationRowModel && (t._getPaginationRowModel = t.options.getPaginationRowModel(t)), t.options.manualPagination || !t._getPaginationRowModel ? t.getPrePaginationRowModel() : t._getPaginationRowModel()), t.getPageCount = () => {
      var n;
      return (n = t.options.pageCount) != null ? n : Math.ceil(t.getRowCount() / t.getState().pagination.pageSize);
    }, t.getRowCount = () => {
      var n;
      return (n = t.options.rowCount) != null ? n : t.getPrePaginationRowModel().rows.length;
    };
  }
}, dC = () => ({
  top: [],
  bottom: []
}), oxe = {
  getInitialState: (t) => ({
    rowPinning: dC(),
    ...t
  }),
  getDefaultOptions: (t) => ({
    onRowPinningChange: ia("rowPinning", t)
  }),
  createRow: (t, r) => {
    t.pin = (e, n, i) => {
      const a = n ? t.getLeafRows().map((l) => {
        let {
          id: u
        } = l;
        return u;
      }) : [], o = i ? t.getParentRows().map((l) => {
        let {
          id: u
        } = l;
        return u;
      }) : [], s = /* @__PURE__ */ new Set([...o, t.id, ...a]);
      r.setRowPinning((l) => {
        var u, c;
        if (e === "bottom") {
          var d, f;
          return {
            top: ((d = l == null ? void 0 : l.top) != null ? d : []).filter((v) => !(s != null && s.has(v))),
            bottom: [...((f = l == null ? void 0 : l.bottom) != null ? f : []).filter((v) => !(s != null && s.has(v))), ...Array.from(s)]
          };
        }
        if (e === "top") {
          var h, p;
          return {
            top: [...((h = l == null ? void 0 : l.top) != null ? h : []).filter((v) => !(s != null && s.has(v))), ...Array.from(s)],
            bottom: ((p = l == null ? void 0 : l.bottom) != null ? p : []).filter((v) => !(s != null && s.has(v)))
          };
        }
        return {
          top: ((u = l == null ? void 0 : l.top) != null ? u : []).filter((v) => !(s != null && s.has(v))),
          bottom: ((c = l == null ? void 0 : l.bottom) != null ? c : []).filter((v) => !(s != null && s.has(v)))
        };
      });
    }, t.getCanPin = () => {
      var e;
      const {
        enableRowPinning: n,
        enablePinning: i
      } = r.options;
      return typeof n == "function" ? n(t) : (e = n ?? i) != null ? e : !0;
    }, t.getIsPinned = () => {
      const e = [t.id], {
        top: n,
        bottom: i
      } = r.getState().rowPinning, a = e.some((s) => n == null ? void 0 : n.includes(s)), o = e.some((s) => i == null ? void 0 : i.includes(s));
      return a ? "top" : o ? "bottom" : !1;
    }, t.getPinnedIndex = () => {
      var e, n;
      const i = t.getIsPinned();
      if (!i) return -1;
      const a = (e = i === "top" ? r.getTopRows() : r.getBottomRows()) == null ? void 0 : e.map((o) => {
        let {
          id: s
        } = o;
        return s;
      });
      return (n = a == null ? void 0 : a.indexOf(t.id)) != null ? n : -1;
    };
  },
  createTable: (t) => {
    t.setRowPinning = (r) => t.options.onRowPinningChange == null ? void 0 : t.options.onRowPinningChange(r), t.resetRowPinning = (r) => {
      var e, n;
      return t.setRowPinning(r ? dC() : (e = (n = t.initialState) == null ? void 0 : n.rowPinning) != null ? e : dC());
    }, t.getIsSomeRowsPinned = (r) => {
      var e;
      const n = t.getState().rowPinning;
      if (!r) {
        var i, a;
        return !!((i = n.top) != null && i.length || (a = n.bottom) != null && a.length);
      }
      return !!((e = n[r]) != null && e.length);
    }, t._getPinnedRows = (r, e, n) => {
      var i;
      return ((i = t.options.keepPinnedRows) == null || i ? (
        //get all rows that are pinned even if they would not be otherwise visible
        //account for expanded parent rows, but not pagination or filtering
        (e ?? []).map((o) => {
          const s = t.getRow(o, !0);
          return s.getIsAllParentsExpanded() ? s : null;
        })
      ) : (
        //else get only visible rows that are pinned
        (e ?? []).map((o) => r.find((s) => s.id === o))
      )).filter(Boolean).map((o) => ({
        ...o,
        position: n
      }));
    }, t.getTopRows = ut(() => [t.getRowModel().rows, t.getState().rowPinning.top], (r, e) => t._getPinnedRows(r, e, "top"), ct(t.options, "debugRows", "getTopRows")), t.getBottomRows = ut(() => [t.getRowModel().rows, t.getState().rowPinning.bottom], (r, e) => t._getPinnedRows(r, e, "bottom"), ct(t.options, "debugRows", "getBottomRows")), t.getCenterRows = ut(() => [t.getRowModel().rows, t.getState().rowPinning.top, t.getState().rowPinning.bottom], (r, e, n) => {
      const i = /* @__PURE__ */ new Set([...e ?? [], ...n ?? []]);
      return r.filter((a) => !i.has(a.id));
    }, ct(t.options, "debugRows", "getCenterRows"));
  }
}, sxe = {
  getInitialState: (t) => ({
    rowSelection: {},
    ...t
  }),
  getDefaultOptions: (t) => ({
    onRowSelectionChange: ia("rowSelection", t),
    enableRowSelection: !0,
    enableMultiRowSelection: !0,
    enableSubRowSelection: !0
    // enableGroupingRowSelection: false,
    // isAdditiveSelectEvent: (e: unknown) => !!e.metaKey,
    // isInclusiveSelectEvent: (e: unknown) => !!e.shiftKey,
  }),
  createTable: (t) => {
    t.setRowSelection = (r) => t.options.onRowSelectionChange == null ? void 0 : t.options.onRowSelectionChange(r), t.resetRowSelection = (r) => {
      var e;
      return t.setRowSelection(r ? {} : (e = t.initialState.rowSelection) != null ? e : {});
    }, t.toggleAllRowsSelected = (r) => {
      t.setRowSelection((e) => {
        r = typeof r < "u" ? r : !t.getIsAllRowsSelected();
        const n = {
          ...e
        }, i = t.getPreGroupedRowModel().flatRows;
        return r ? i.forEach((a) => {
          a.getCanSelect() && (n[a.id] = !0);
        }) : i.forEach((a) => {
          delete n[a.id];
        }), n;
      });
    }, t.toggleAllPageRowsSelected = (r) => t.setRowSelection((e) => {
      const n = typeof r < "u" ? r : !t.getIsAllPageRowsSelected(), i = {
        ...e
      };
      return t.getRowModel().rows.forEach((a) => {
        f7(i, a.id, n, !0, t);
      }), i;
    }), t.getPreSelectedRowModel = () => t.getCoreRowModel(), t.getSelectedRowModel = ut(() => [t.getState().rowSelection, t.getCoreRowModel()], (r, e) => Object.keys(r).length ? fC(t, e) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, ct(t.options, "debugTable", "getSelectedRowModel")), t.getFilteredSelectedRowModel = ut(() => [t.getState().rowSelection, t.getFilteredRowModel()], (r, e) => Object.keys(r).length ? fC(t, e) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, ct(t.options, "debugTable", "getFilteredSelectedRowModel")), t.getGroupedSelectedRowModel = ut(() => [t.getState().rowSelection, t.getSortedRowModel()], (r, e) => Object.keys(r).length ? fC(t, e) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, ct(t.options, "debugTable", "getGroupedSelectedRowModel")), t.getIsAllRowsSelected = () => {
      const r = t.getFilteredRowModel().flatRows, {
        rowSelection: e
      } = t.getState();
      let n = !!(r.length && Object.keys(e).length);
      return n && r.some((i) => i.getCanSelect() && !e[i.id]) && (n = !1), n;
    }, t.getIsAllPageRowsSelected = () => {
      const r = t.getPaginationRowModel().flatRows.filter((i) => i.getCanSelect()), {
        rowSelection: e
      } = t.getState();
      let n = !!r.length;
      return n && r.some((i) => !e[i.id]) && (n = !1), n;
    }, t.getIsSomeRowsSelected = () => {
      var r;
      const e = Object.keys((r = t.getState().rowSelection) != null ? r : {}).length;
      return e > 0 && e < t.getFilteredRowModel().flatRows.length;
    }, t.getIsSomePageRowsSelected = () => {
      const r = t.getPaginationRowModel().flatRows;
      return t.getIsAllPageRowsSelected() ? !1 : r.filter((e) => e.getCanSelect()).some((e) => e.getIsSelected() || e.getIsSomeSelected());
    }, t.getToggleAllRowsSelectedHandler = () => (r) => {
      t.toggleAllRowsSelected(r.target.checked);
    }, t.getToggleAllPageRowsSelectedHandler = () => (r) => {
      t.toggleAllPageRowsSelected(r.target.checked);
    };
  },
  createRow: (t, r) => {
    t.toggleSelected = (e, n) => {
      const i = t.getIsSelected();
      r.setRowSelection((a) => {
        var o;
        if (e = typeof e < "u" ? e : !i, t.getCanSelect() && i === e)
          return a;
        const s = {
          ...a
        };
        return f7(s, t.id, e, (o = n == null ? void 0 : n.selectChildren) != null ? o : !0, r), s;
      });
    }, t.getIsSelected = () => {
      const {
        rowSelection: e
      } = r.getState();
      return E8(t, e);
    }, t.getIsSomeSelected = () => {
      const {
        rowSelection: e
      } = r.getState();
      return h7(t, e) === "some";
    }, t.getIsAllSubRowsSelected = () => {
      const {
        rowSelection: e
      } = r.getState();
      return h7(t, e) === "all";
    }, t.getCanSelect = () => {
      var e;
      return typeof r.options.enableRowSelection == "function" ? r.options.enableRowSelection(t) : (e = r.options.enableRowSelection) != null ? e : !0;
    }, t.getCanSelectSubRows = () => {
      var e;
      return typeof r.options.enableSubRowSelection == "function" ? r.options.enableSubRowSelection(t) : (e = r.options.enableSubRowSelection) != null ? e : !0;
    }, t.getCanMultiSelect = () => {
      var e;
      return typeof r.options.enableMultiRowSelection == "function" ? r.options.enableMultiRowSelection(t) : (e = r.options.enableMultiRowSelection) != null ? e : !0;
    }, t.getToggleSelectedHandler = () => {
      const e = t.getCanSelect();
      return (n) => {
        var i;
        e && t.toggleSelected((i = n.target) == null ? void 0 : i.checked);
      };
    };
  }
}, f7 = (t, r, e, n, i) => {
  var a;
  const o = i.getRow(r, !0);
  e ? (o.getCanMultiSelect() || Object.keys(t).forEach((s) => delete t[s]), o.getCanSelect() && (t[r] = !0)) : delete t[r], n && (a = o.subRows) != null && a.length && o.getCanSelectSubRows() && o.subRows.forEach((s) => f7(t, s.id, e, n, i));
};
function fC(t, r) {
  const e = t.getState().rowSelection, n = [], i = {}, a = function(o, s) {
    return o.map((l) => {
      var u;
      const c = E8(l, e);
      if (c && (n.push(l), i[l.id] = l), (u = l.subRows) != null && u.length && (l = {
        ...l,
        subRows: a(l.subRows)
      }), c)
        return l;
    }).filter(Boolean);
  };
  return {
    rows: a(r.rows),
    flatRows: n,
    rowsById: i
  };
}
function E8(t, r) {
  var e;
  return (e = r[t.id]) != null ? e : !1;
}
function h7(t, r, e) {
  var n;
  if (!((n = t.subRows) != null && n.length)) return !1;
  let i = !0, a = !1;
  return t.subRows.forEach((o) => {
    if (!(a && !i) && (o.getCanSelect() && (E8(o, r) ? a = !0 : i = !1), o.subRows && o.subRows.length)) {
      const s = h7(o, r);
      s === "all" ? a = !0 : (s === "some" && (a = !0), i = !1);
    }
  }), i ? "all" : a ? "some" : !1;
}
const p7 = /([0-9]+)/gm, lxe = (t, r, e) => sY(du(t.getValue(e)).toLowerCase(), du(r.getValue(e)).toLowerCase()), uxe = (t, r, e) => sY(du(t.getValue(e)), du(r.getValue(e))), cxe = (t, r, e) => k8(du(t.getValue(e)).toLowerCase(), du(r.getValue(e)).toLowerCase()), dxe = (t, r, e) => k8(du(t.getValue(e)), du(r.getValue(e))), fxe = (t, r, e) => {
  const n = t.getValue(e), i = r.getValue(e);
  return n > i ? 1 : n < i ? -1 : 0;
}, hxe = (t, r, e) => k8(t.getValue(e), r.getValue(e));
function k8(t, r) {
  return t === r ? 0 : t > r ? 1 : -1;
}
function du(t) {
  return typeof t == "number" ? isNaN(t) || t === 1 / 0 || t === -1 / 0 ? "" : String(t) : typeof t == "string" ? t : "";
}
function sY(t, r) {
  const e = t.split(p7).filter(Boolean), n = r.split(p7).filter(Boolean);
  for (; e.length && n.length; ) {
    const i = e.shift(), a = n.shift(), o = parseInt(i, 10), s = parseInt(a, 10), l = [o, s].sort();
    if (isNaN(l[0])) {
      if (i > a)
        return 1;
      if (a > i)
        return -1;
      continue;
    }
    if (isNaN(l[1]))
      return isNaN(o) ? -1 : 1;
    if (o > s)
      return 1;
    if (s > o)
      return -1;
  }
  return e.length - n.length;
}
const _p = {
  alphanumeric: lxe,
  alphanumericCaseSensitive: uxe,
  text: cxe,
  textCaseSensitive: dxe,
  datetime: fxe,
  basic: hxe
}, pxe = {
  getInitialState: (t) => ({
    sorting: [],
    ...t
  }),
  getDefaultColumnDef: () => ({
    sortingFn: "auto",
    sortUndefined: 1
  }),
  getDefaultOptions: (t) => ({
    onSortingChange: ia("sorting", t),
    isMultiSortEvent: (r) => r.shiftKey
  }),
  createColumn: (t, r) => {
    t.getAutoSortingFn = () => {
      const e = r.getFilteredRowModel().flatRows.slice(10);
      let n = !1;
      for (const i of e) {
        const a = i == null ? void 0 : i.getValue(t.id);
        if (Object.prototype.toString.call(a) === "[object Date]")
          return _p.datetime;
        if (typeof a == "string" && (n = !0, a.split(p7).length > 1))
          return _p.alphanumeric;
      }
      return n ? _p.text : _p.basic;
    }, t.getAutoSortDir = () => {
      const e = r.getFilteredRowModel().flatRows[0];
      return typeof (e == null ? void 0 : e.getValue(t.id)) == "string" ? "asc" : "desc";
    }, t.getSortingFn = () => {
      var e, n;
      if (!t)
        throw new Error();
      return _5(t.columnDef.sortingFn) ? t.columnDef.sortingFn : t.columnDef.sortingFn === "auto" ? t.getAutoSortingFn() : (e = (n = r.options.sortingFns) == null ? void 0 : n[t.columnDef.sortingFn]) != null ? e : _p[t.columnDef.sortingFn];
    }, t.toggleSorting = (e, n) => {
      const i = t.getNextSortingOrder(), a = typeof e < "u" && e !== null;
      r.setSorting((o) => {
        const s = o == null ? void 0 : o.find((h) => h.id === t.id), l = o == null ? void 0 : o.findIndex((h) => h.id === t.id);
        let u = [], c, d = a ? e : i === "desc";
        if (o != null && o.length && t.getCanMultiSort() && n ? s ? c = "toggle" : c = "add" : o != null && o.length && l !== o.length - 1 ? c = "replace" : s ? c = "toggle" : c = "replace", c === "toggle" && (a || i || (c = "remove")), c === "add") {
          var f;
          u = [...o, {
            id: t.id,
            desc: d
          }], u.splice(0, u.length - ((f = r.options.maxMultiSortColCount) != null ? f : Number.MAX_SAFE_INTEGER));
        } else c === "toggle" ? u = o.map((h) => h.id === t.id ? {
          ...h,
          desc: d
        } : h) : c === "remove" ? u = o.filter((h) => h.id !== t.id) : u = [{
          id: t.id,
          desc: d
        }];
        return u;
      });
    }, t.getFirstSortDir = () => {
      var e, n;
      return ((e = (n = t.columnDef.sortDescFirst) != null ? n : r.options.sortDescFirst) != null ? e : t.getAutoSortDir() === "desc") ? "desc" : "asc";
    }, t.getNextSortingOrder = (e) => {
      var n, i;
      const a = t.getFirstSortDir(), o = t.getIsSorted();
      return o ? o !== a && ((n = r.options.enableSortingRemoval) == null || n) && // If enableSortRemove, enable in general
      (!(e && (i = r.options.enableMultiRemove) != null) || i) ? !1 : o === "desc" ? "asc" : "desc" : a;
    }, t.getCanSort = () => {
      var e, n;
      return ((e = t.columnDef.enableSorting) != null ? e : !0) && ((n = r.options.enableSorting) != null ? n : !0) && !!t.accessorFn;
    }, t.getCanMultiSort = () => {
      var e, n;
      return (e = (n = t.columnDef.enableMultiSort) != null ? n : r.options.enableMultiSort) != null ? e : !!t.accessorFn;
    }, t.getIsSorted = () => {
      var e;
      const n = (e = r.getState().sorting) == null ? void 0 : e.find((i) => i.id === t.id);
      return n ? n.desc ? "desc" : "asc" : !1;
    }, t.getSortIndex = () => {
      var e, n;
      return (e = (n = r.getState().sorting) == null ? void 0 : n.findIndex((i) => i.id === t.id)) != null ? e : -1;
    }, t.clearSorting = () => {
      r.setSorting((e) => e != null && e.length ? e.filter((n) => n.id !== t.id) : []);
    }, t.getToggleSortingHandler = () => {
      const e = t.getCanSort();
      return (n) => {
        e && (n.persist == null || n.persist(), t.toggleSorting == null || t.toggleSorting(void 0, t.getCanMultiSort() ? r.options.isMultiSortEvent == null ? void 0 : r.options.isMultiSortEvent(n) : !1));
      };
    };
  },
  createTable: (t) => {
    t.setSorting = (r) => t.options.onSortingChange == null ? void 0 : t.options.onSortingChange(r), t.resetSorting = (r) => {
      var e, n;
      t.setSorting(r ? [] : (e = (n = t.initialState) == null ? void 0 : n.sorting) != null ? e : []);
    }, t.getPreSortedRowModel = () => t.getGroupedRowModel(), t.getSortedRowModel = () => (!t._getSortedRowModel && t.options.getSortedRowModel && (t._getSortedRowModel = t.options.getSortedRowModel(t)), t.options.manualSorting || !t._getSortedRowModel ? t.getPreSortedRowModel() : t._getSortedRowModel());
  }
}, vxe = [
  O_e,
  txe,
  K_e,
  q_e,
  G_e,
  B_e,
  rxe,
  //depends on ColumnFaceting
  nxe,
  //depends on ColumnFiltering
  pxe,
  U_e,
  //depends on RowSorting
  ixe,
  axe,
  oxe,
  sxe,
  Q_e
];
function gxe(t) {
  var r, e;
  process.env.NODE_ENV !== "production" && (t.debugAll || t.debugTable) && console.info("Creating Table Instance...");
  const n = [...vxe, ...(r = t._features) != null ? r : []];
  let i = {
    _features: n
  };
  const a = i._features.reduce((f, h) => Object.assign(f, h.getDefaultOptions == null ? void 0 : h.getDefaultOptions(i)), {}), o = (f) => i.options.mergeOptions ? i.options.mergeOptions(a, f) : {
    ...a,
    ...f
  };
  let l = {
    ...{},
    ...(e = t.initialState) != null ? e : {}
  };
  i._features.forEach((f) => {
    var h;
    l = (h = f.getInitialState == null ? void 0 : f.getInitialState(l)) != null ? h : l;
  });
  const u = [];
  let c = !1;
  const d = {
    _features: n,
    options: {
      ...a,
      ...t
    },
    initialState: l,
    _queue: (f) => {
      u.push(f), c || (c = !0, Promise.resolve().then(() => {
        for (; u.length; )
          u.shift()();
        c = !1;
      }).catch((h) => setTimeout(() => {
        throw h;
      })));
    },
    reset: () => {
      i.setState(i.initialState);
    },
    setOptions: (f) => {
      const h = Vl(f, i.options);
      i.options = o(h);
    },
    getState: () => i.options.state,
    setState: (f) => {
      i.options.onStateChange == null || i.options.onStateChange(f);
    },
    _getRowId: (f, h, p) => {
      var v;
      return (v = i.options.getRowId == null ? void 0 : i.options.getRowId(f, h, p)) != null ? v : `${p ? [p.id, h].join(".") : h}`;
    },
    getCoreRowModel: () => (i._getCoreRowModel || (i._getCoreRowModel = i.options.getCoreRowModel(i)), i._getCoreRowModel()),
    // The final calls start at the bottom of the model,
    // expanded rows, which then work their way up
    getRowModel: () => i.getPaginationRowModel(),
    //in next version, we should just pass in the row model as the optional 2nd arg
    getRow: (f, h) => {
      let p = (h ? i.getPrePaginationRowModel() : i.getRowModel()).rowsById[f];
      if (!p && (p = i.getCoreRowModel().rowsById[f], !p))
        throw process.env.NODE_ENV !== "production" ? new Error(`getRow could not find row with ID: ${f}`) : new Error();
      return p;
    },
    _getDefaultColumnDef: ut(() => [i.options.defaultColumn], (f) => {
      var h;
      return f = (h = f) != null ? h : {}, {
        header: (p) => {
          const v = p.header.column.columnDef;
          return v.accessorKey ? v.accessorKey : v.accessorFn ? v.id : null;
        },
        // footer: props => props.header.column.id,
        cell: (p) => {
          var v, g;
          return (v = (g = p.renderValue()) == null || g.toString == null ? void 0 : g.toString()) != null ? v : null;
        },
        ...i._features.reduce((p, v) => Object.assign(p, v.getDefaultColumnDef == null ? void 0 : v.getDefaultColumnDef()), {}),
        ...f
      };
    }, ct(t, "debugColumns", "_getDefaultColumnDef")),
    _getColumnDefs: () => i.options.columns,
    getAllColumns: ut(() => [i._getColumnDefs()], (f) => {
      const h = function(p, v, g) {
        return g === void 0 && (g = 0), p.map((m) => {
          const y = N_e(i, m, g, v), b = m;
          return y.columns = b.columns ? h(b.columns, y, g + 1) : [], y;
        });
      };
      return h(f);
    }, ct(t, "debugColumns", "getAllColumns")),
    getAllFlatColumns: ut(() => [i.getAllColumns()], (f) => f.flatMap((h) => h.getFlatColumns()), ct(t, "debugColumns", "getAllFlatColumns")),
    _getAllFlatColumnsById: ut(() => [i.getAllFlatColumns()], (f) => f.reduce((h, p) => (h[p.id] = p, h), {}), ct(t, "debugColumns", "getAllFlatColumnsById")),
    getAllLeafColumns: ut(() => [i.getAllColumns(), i._getOrderColumnsFn()], (f, h) => {
      let p = f.flatMap((v) => v.getLeafColumns());
      return h(p);
    }, ct(t, "debugColumns", "getAllLeafColumns")),
    getColumn: (f) => {
      const h = i._getAllFlatColumnsById()[f];
      return process.env.NODE_ENV !== "production" && !h && console.error(`[Table] Column with id '${f}' does not exist.`), h;
    }
  };
  Object.assign(i, d);
  for (let f = 0; f < i._features.length; f++) {
    const h = i._features[f];
    h == null || h.createTable == null || h.createTable(i);
  }
  return i;
}
function mxe() {
  return (t) => ut(() => [t.options.data], (r) => {
    const e = {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, n = function(i, a, o) {
      a === void 0 && (a = 0);
      const s = [];
      for (let u = 0; u < i.length; u++) {
        const c = V_e(t, t._getRowId(i[u], u, o), i[u], u, a, void 0, o == null ? void 0 : o.id);
        if (e.flatRows.push(c), e.rowsById[c.id] = c, s.push(c), t.options.getSubRows) {
          var l;
          c.originalSubRows = t.options.getSubRows(i[u], u), (l = c.originalSubRows) != null && l.length && (c.subRows = n(c.originalSubRows, a + 1, c));
        }
      }
      return s;
    };
    return e.rows = n(r), e;
  }, ct(t.options, "debugTable", "getRowModel", () => t._autoResetPageIndex()));
}
function yxe(t) {
  const r = [], e = (n) => {
    var i;
    r.push(n), (i = n.subRows) != null && i.length && n.getIsExpanded() && n.subRows.forEach(e);
  };
  return t.rows.forEach(e), {
    rows: r,
    flatRows: t.flatRows,
    rowsById: t.rowsById
  };
}
function bxe(t) {
  return (r) => ut(() => [r.getState().pagination, r.getPrePaginationRowModel(), r.options.paginateExpandedRows ? void 0 : r.getState().expanded], (e, n) => {
    if (!n.rows.length)
      return n;
    const {
      pageSize: i,
      pageIndex: a
    } = e;
    let {
      rows: o,
      flatRows: s,
      rowsById: l
    } = n;
    const u = i * a, c = u + i;
    o = o.slice(u, c);
    let d;
    r.options.paginateExpandedRows ? d = {
      rows: o,
      flatRows: s,
      rowsById: l
    } : d = yxe({
      rows: o,
      flatRows: s,
      rowsById: l
    }), d.flatRows = [];
    const f = (h) => {
      d.flatRows.push(h), h.subRows.length && h.subRows.forEach(f);
    };
    return d.rows.forEach(f), d;
  }, ct(r.options, "debugTable", "getPaginationRowModel"));
}
function Cxe() {
  return (t) => ut(() => [t.getState().sorting, t.getPreSortedRowModel()], (r, e) => {
    if (!e.rows.length || !(r != null && r.length))
      return e;
    const n = t.getState().sorting, i = [], a = n.filter((l) => {
      var u;
      return (u = t.getColumn(l.id)) == null ? void 0 : u.getCanSort();
    }), o = {};
    a.forEach((l) => {
      const u = t.getColumn(l.id);
      u && (o[l.id] = {
        sortUndefined: u.columnDef.sortUndefined,
        invertSorting: u.columnDef.invertSorting,
        sortingFn: u.getSortingFn()
      });
    });
    const s = (l) => {
      const u = l.map((c) => ({
        ...c
      }));
      return u.sort((c, d) => {
        for (let h = 0; h < a.length; h += 1) {
          var f;
          const p = a[h], v = o[p.id], g = v.sortUndefined, m = (f = p == null ? void 0 : p.desc) != null ? f : !1;
          let y = 0;
          if (g) {
            const b = c.getValue(p.id), C = d.getValue(p.id), w = b === void 0, _ = C === void 0;
            if (w || _) {
              if (g === "first") return w ? -1 : 1;
              if (g === "last") return w ? 1 : -1;
              y = w && _ ? 0 : w ? g : -g;
            }
          }
          if (y === 0 && (y = v.sortingFn(c, d, p.id)), y !== 0)
            return m && (y *= -1), v.invertSorting && (y *= -1), y;
        }
        return c.index - d.index;
      }), u.forEach((c) => {
        var d;
        i.push(c), (d = c.subRows) != null && d.length && (c.subRows = s(c.subRows));
      }), u;
    };
    return {
      rows: s(e.rows),
      flatRows: i,
      rowsById: e.rowsById
    };
  }, ct(t.options, "debugTable", "getSortedRowModel", () => t._autoResetPageIndex()));
}
/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function DP(t, r) {
  return t ? wxe(t) ? /* @__PURE__ */ $.createElement(t, r) : t : null;
}
function wxe(t) {
  return _xe(t) || typeof t == "function" || xxe(t);
}
function _xe(t) {
  return typeof t == "function" && (() => {
    const r = Object.getPrototypeOf(t);
    return r.prototype && r.prototype.isReactComponent;
  })();
}
function xxe(t) {
  return typeof t == "object" && typeof t.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(t.$$typeof.description);
}
function Sxe(t) {
  const r = {
    state: {},
    // Dummy state
    onStateChange: () => {
    },
    // noop
    renderFallbackValue: null,
    ...t
  }, [e] = $.useState(() => ({
    current: gxe(r)
  })), [n, i] = $.useState(() => e.current.initialState);
  return e.current.setOptions((a) => ({
    ...a,
    ...t,
    state: {
      ...n,
      ...t.state
    },
    // Similarly, we'll maintain both our internal state and any user-provided
    // state.
    onStateChange: (o) => {
      i(o), t.onStateChange == null || t.onStateChange(o);
    }
  })), e.current;
}
const Ixe = (t) => /* @__PURE__ */ $.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ $.createElement("path", { d: "M11.6269 4C12 4 12.306 4.14925 12.6119 4.44776L16.8284 8.49254C17.0821 8.73881 17.2537 9.03731 17.2537 9.37313C17.2537 10.0746 16.6791 10.5672 16.0672 10.5672C15.7687 10.5672 15.4552 10.4701 15.194 10.2239L11.6269 6.73134L8.0597 10.2239C7.80597 10.4776 7.48507 10.5672 7.18657 10.5672C6.58209 10.5672 6 10.0746 6 9.37313C6 9.03731 6.1791 8.73881 6.43284 8.49254L10.6493 4.44776C10.9478 4.14925 11.2612 4 11.6269 4ZM11.6269 20C11.2612 20 10.9478 19.8507 10.6493 19.5522L6.43284 15.5075C6.1791 15.2612 6 14.9627 6 14.6269C6 13.9254 6.58209 13.4328 7.18657 13.4328C7.48507 13.4328 7.80597 13.5224 8.0597 13.7761L11.6269 17.2687L15.194 13.7761C15.4552 13.5299 15.7687 13.4328 16.0672 13.4328C16.6791 13.4328 17.2537 13.9254 17.2537 14.6269C17.2537 14.9627 17.0821 15.2612 16.8284 15.5075L12.6119 19.5522C12.306 19.8507 12 20 11.6269 20Z", fill: "#395278" })), TP = (t) => /* @__PURE__ */ $.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ $.createElement("path", { d: "M11.6269 4C12 4 12.306 4.14925 12.6119 4.44776L16.8284 8.49254C17.0821 8.73881 17.2537 9.03731 17.2537 9.37313C17.2537 10.0746 16.6791 10.5672 16.0672 10.5672C15.7687 10.5672 15.4552 10.4701 15.194 10.2239L11.6269 6.73134L8.0597 10.2239C7.80597 10.4776 7.48507 10.5672 7.18657 10.5672C6.58209 10.5672 6 10.0746 6 9.37313C6 9.03731 6.1791 8.73881 6.43284 8.49254L10.6493 4.44776C10.9478 4.14925 11.2612 4 11.6269 4Z", fill: "#395278" })), dSe = (t) => {
  const {
    columns: r,
    data: e,
    totalRecords: n,
    isLoading: i,
    sorting: a,
    setSorting: o,
    manualSorting: s = !0,
    serverSidePagination: l = !0,
    pagination: u,
    enablePagination: c = !0,
    onPageChange: d = null,
    onRowClick: f
  } = t, [h, p] = We({}), v = Sxe({
    data: e,
    columns: r,
    state: {
      pagination: u,
      sorting: a,
      rowSelection: h
    },
    manualSorting: s,
    enableMultiRowSelection: !1,
    onRowSelectionChange: p,
    manualPagination: !1,
    onSortingChange: o,
    getCoreRowModel: mxe(),
    getSortedRowModel: Cxe(),
    getPaginationRowModel: l ? void 0 : bxe(),
    pageCount: n < u.pageSize ? 1 : Math.ceil(n / u.pageSize)
  }), g = !e || e.length === 0, m = Math.ceil(n / u.pageSize), y = () => {
    const b = u.pageSize * u.pageIndex + 1, C = Math.min(b + u.pageSize - 1, n);
    return `${b}-${C}`;
  };
  return Ue(() => {
    const b = v.getSelectedRowModel().rows;
    Array.isArray(b) && b[0] !== void 0 && b[0].original !== void 0 && f && f(b[0].original);
  }, [h]), /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
    /* @__PURE__ */ S.jsxs("div", { className: "theme-table-container theme-table-max-height", children: [
      i && /* @__PURE__ */ S.jsx("div", { className: "theme-table-loading", children: /* @__PURE__ */ S.jsx("p", { children: "Loading table data.." }) }),
      /* @__PURE__ */ S.jsxs("table", { className: "theme-table", children: [
        /* @__PURE__ */ S.jsx("thead", { children: v.getHeaderGroups().map((b) => /* @__PURE__ */ S.jsx("tr", { children: b.headers.map((C) => /* @__PURE__ */ S.jsx(
          "th",
          {
            colSpan: C.colSpan,
            style: {
              width: C.getSize()
            },
            children: C.isPlaceholder ? null : /* @__PURE__ */ S.jsxs(
              "div",
              {
                className: C.column.getCanSort() ? "theme-table-header-wrapper" : "",
                onClick: C.column.getToggleSortingHandler(),
                children: [
                  DP(
                    C.column.columnDef.header,
                    C.getContext()
                  ),
                  {
                    asc: /* @__PURE__ */ S.jsx(TP, { className: "theme-table-sort-icon" }),
                    desc: /* @__PURE__ */ S.jsx(TP, { className: "theme-table-sort-icon theme-table-sort-icon-desc" })
                  }[C.column.getIsSorted()] ?? (C.column.columnDef.enableSorting === void 0 || C.column.columnDef.enableSorting === !0 ? /* @__PURE__ */ S.jsx(Ixe, { className: "theme-table-sort-icon" }) : null)
                ]
              }
            )
          },
          C.id
        )) }, b.id)) }),
        /* @__PURE__ */ S.jsx("tbody", { children: g ? /* @__PURE__ */ S.jsx("tr", { children: /* @__PURE__ */ S.jsx("td", { colSpan: 100, children: "No data found" }) }) : /* @__PURE__ */ S.jsx(S.Fragment, { children: v.getRowModel().rows.map((b) => /* @__PURE__ */ S.jsx("tr", { onClick: b.getToggleSelectedHandler(), children: b.getVisibleCells().map((C) => /* @__PURE__ */ S.jsx("td", { children: DP(
          C.column.columnDef.cell,
          C.getContext()
        ) }, C.id)) }, b.id)) }) })
      ] })
    ] }),
    c && /* @__PURE__ */ S.jsxs("div", { className: "theme-table-pagination", children: [
      /* @__PURE__ */ S.jsxs("span", { className: "theme-table-pagination-text", children: [
        "Showing item ",
        y(),
        " out of ",
        n,
        " items"
      ] }),
      /* @__PURE__ */ S.jsx(
        nwe,
        {
          className: "theme-table-pagination-paging",
          currentPage: u.pageIndex + 1,
          totalPages: m,
          onPageChange: (b) => d && d(parseInt(b) - 1)
        }
      )
    ] })
  ] });
}, fSe = (t) => {
  const {
    columns: r,
    rows: e,
    className: n = "",
    stickyColumnIndices: i = [],
    stickyPosition: a = "end"
  } = t, o = Vt(null), [s, l] = We([]), u = ui();
  return Ue(() => {
    const c = o.current;
    if (c !== null) {
      const d = r.map((f, h) => {
        const p = c.querySelector(
          `th:nth-child(${h + 1})`
        );
        return p === null ? 0 : p.offsetWidth;
      });
      l(d);
    }
  }, [o, i]), /* @__PURE__ */ S.jsx(
    "div",
    {
      className: `theme-table-container ${n !== "" ? n : ""}`,
      children: /* @__PURE__ */ S.jsxs(
        "table",
        {
          className: `theme-table ${i.length > 0 ? "table-static" : ""}`,
          ref: o,
          children: [
            /* @__PURE__ */ S.jsx("thead", { children: /* @__PURE__ */ S.jsx("tr", { children: r.map((c, d) => {
              let f = 0;
              if (a === "start")
                for (let h = 0; h < d; h++)
                  f += s[h];
              else
                for (let h = r.length - 1; h > d; h--)
                  f += s[h];
              return /* @__PURE__ */ S.jsx(
                "th",
                {
                  className: i.includes(d) ? `sticky-column sticky-${a}` : "",
                  style: i.length > 0 ? {
                    ...a === "start" ? {
                      left: i.includes(d) ? f + "px" : "auto"
                    } : {
                      right: i.includes(d) ? f + "px" : "auto"
                    }
                  } : {},
                  children: c
                },
                `${u}-col-${d}`
              );
            }) }) }),
            /* @__PURE__ */ S.jsx("tbody", { children: e.map((c, d) => /* @__PURE__ */ S.jsx("tr", { children: c.map((f, h) => {
              let p = 0;
              if (a === "start")
                for (let v = 0; v < h; v++)
                  p += s[v];
              else
                for (let v = r.length - 1; v > h; v--)
                  p += s[v];
              return /* @__PURE__ */ S.jsx(
                "td",
                {
                  className: i.includes(h) ? `sticky-column sticky-${a}` : "",
                  style: i.length > 0 ? {
                    ...a === "start" ? {
                      left: i.includes(h) ? p + "px" : "auto"
                    } : {
                      right: i.includes(
                        h
                      ) ? p + "px" : "auto"
                    }
                  } : {},
                  children: f
                },
                `${u}-row-${d}-col-${h}`
              );
            }) }, `${u}-row-${d}`)) })
          ]
        }
      )
    }
  );
};
export {
  Mxe as Accordion,
  LP as Alert,
  Exe as BarChart,
  Lxe as Breadcrumb,
  Rxe as BreadcrumbTypes,
  DY as Button,
  TY as Card,
  s5 as Checkbox,
  F8e as CheckboxRHF,
  Vxe as Chip,
  Gxe as CustomDatepicker,
  Bxe as CustomDatepickerRange,
  Fxe as DatepickerRHF,
  Wxe as Dialog,
  kxe as DoughnutChart,
  E8e as FileUpload,
  k8e as FileUploadDropzone,
  Zxe as FileUploadTypes,
  P8e as FileViewer,
  W8e as FormSelect,
  Z8e as FormSelectRHF,
  N8e as FormTypes,
  X8e as Gallery,
  U8e as HorizontalCardList,
  J8e as HorizontalLegendList,
  jxe as IconAdd,
  Yxe as IconArrow,
  Xxe as IconBell,
  $xe as IconBellActive,
  Uxe as IconCalendar,
  Jxe as IconCheckCircleFilled,
  Kxe as IconCheckmark,
  qxe as IconChevronArrow,
  Qxe as IconClose,
  e8e as IconDelete,
  t8e as IconDownload,
  r8e as IconEdit,
  n8e as IconExternal,
  i8e as IconEye,
  a8e as IconEyeCross,
  o8e as IconHelpChatOutline,
  s8e as IconHistory,
  l8e as IconImageAdd,
  u8e as IconInfo,
  c8e as IconInventoryFilled,
  d8e as IconInventoryOutline,
  w6e as IconMapLocationFilled,
  f8e as IconMenu,
  h8e as IconMoreVertical,
  p8e as IconMotorFilled,
  v8e as IconMotorOutline,
  g8e as IconPriceFilled,
  m8e as IconPriceOutline,
  y8e as IconReleaseOutline,
  b8e as IconSearch,
  C8e as IconSettingsFilled,
  w8e as IconSettingsOutline,
  _8e as IconSort,
  x8e as IconSortArrow,
  S8e as IconStoreFilled,
  I8e as IconStoreOutline,
  A8e as IconTransfer,
  D8e as IconTruckOutline,
  T8e as IconUpload,
  _6e as IconUploadFile,
  M8e as IconUserCircleFilled,
  R8e as IconUserCircleOutline,
  L8e as IconXCircleFilled,
  O8e as Input,
  V8e as InputRHF,
  Pxe as LineChart,
  $8e as ListTypes,
  j8e as MultilevelSelect,
  Y8e as MultilevelSelectRHF,
  K8e as Navbar,
  q8e as OTPInput,
  nwe as Pagination,
  Q8e as PhoneInput,
  eSe as PhoneInputRHF,
  Nxe as PieChart,
  uk as ProgressBar,
  H8e as Radio,
  z8e as RadioRHF,
  Oxe as SankeyChart,
  tSe as Sidebar,
  nSe as SkeletonLoading,
  rSe as SkeletonLoadingTypes,
  aSe as SnackbarError,
  iSe as SnackbarSuccess,
  oSe as SnackbarWarning,
  sSe as Stepper,
  uSe as Tab,
  lSe as TabTypes,
  dSe as Table,
  fSe as TableStatic,
  cSe as TableTypes,
  G8e as Textarea,
  B8e as TextareaRHF
};
//# sourceMappingURL=index.js.map
